// @ts-nocheck
import { TypedDocumentNode as DocumentNode } from "@graphql-typed-document-node/core";
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  /** Built-in java.math.BigDecimal */
  BigDecimal: any;
  /** A type representing a Locale such as en_US or fr_FR */
  Locale: any;
  /** A type representing a full protocol, host and path */
  URL: any;
  /** A type representing a formatted java.util.UUID */
  UUID: any;
};

/** Contract for accessibility data. */
export interface AccessibilityData {
  hint?: Maybe<Scalars["String"]>;
  label?: Maybe<Scalars["String"]>;
}

/** An interface for a11y labels. */
export interface AccessibilityField {
  /** Label where a11y behavior is needed. */
  accessibilityLabel?: Maybe<Scalars["String"]>;
  /**
   * a11y label.
   * @deprecated Use accessibilityLabel, replace with accessibilityLabel
   */
  label?: Maybe<Scalars["String"]>;
}

/** Represents a checkbox wrapper with analytics */
export type ActionCheckBox = {
  __typename?: "ActionCheckBox";
  /** Represents client side analytics */
  analytics: ClientSideAnalytics;
  /** Represents basic check box */
  checkBox: EgdsBasicCheckBox;
};

/** Describes what kind of action being described. Copy for example describes the coupon code copy behavior. Authwindow shows the login/signup dialog. */
export type ActionDetails = AccessibilityField & {
  __typename?: "ActionDetails";
  /** Accessibility label tied to the action being taken, ex: 'Close the dialog' */
  accessibilityLabel?: Maybe<Scalars["String"]>;
  /** The action that would be performed client side such as 'DEFAULT_TO_RECOMMENDED' or 'OPEN' */
  action: Scalars["String"];
  /** The metadata in service of the named action, such as the text to be copied into the client's clipboard, etc. */
  details?: Maybe<Scalars["String"]>;
  /** @deprecated Use accessibilityLabel instead, replace with accessibilityLabel */
  label?: Maybe<Scalars["String"]>;
  /** @deprecated Use action field instead, enums are discouraged. */
  name: ActionDetailsType;
  /** The title to be shown in association with the details data, ex: 'Terms and Conditions' */
  title?: Maybe<Scalars["String"]>;
};

/** Describes what kind of action being described. Copy for example describes the coupon code copy behavior. Authwindow shows the login/signup dialog. */
export type ActionDetailsType =
  /** Action to pop auth window */
  | "AUTHWINDOW"
  /** Action to close a dropdown option */
  | "CLOSE"
  /** Action to copy contents to clipboard */
  | "COPY"
  /** Action to open the date picker */
  | "DATEPICKER"
  /** Action to open an external link off */
  | "EXTERNAL_LINK"
  /** Action to display free lx message */
  | "FREE_LX"
  /** Action to open a link off */
  | "OPEN"
  /** Action to display term and conditions */
  | "TERMS_AND_CONDITIONS";

export type ActionLink = {
  __typename?: "ActionLink";
  action: ActionType;
  analytics: ClientSideAnalytics;
  text: Scalars["String"];
};

export type ActionType = "DownloadDPReport";

/** Indicates the coupon's active state */
export type ActiveState = "ACTIVE" | "INACTIVE" | "UNKNOWN" | "USED";

export type ActivitiesByCategoriesModule = {
  __typename?: "ActivitiesByCategoriesModule";
  /** See all link for carousel */
  action?: Maybe<ActivityGroupAction>;
  /** List of Activities returned for each Category */
  groups: Array<ActivityGroup>;
};

export type Activity = {
  __typename?: "Activity";
  /** Formatted duration of activity */
  activityDuration?: Maybe<EgdsText>;
  /**
   * For tracking onLoad events
   * @deprecated use clientSideAnalytics
   */
  analytics?: Maybe<ActivityAnalytics>;
  /**
   * Deals/discount/likelyToSellOut etc badges to show on activity tile
   * @deprecated Use cardBadges instead
   */
  badges?: Maybe<ActivityTileBadges>;
  /** Deals/discount/likelyToSellOut etc badges to show on activity card */
  cardBadges?: Maybe<ActivityCardBadges>;
  /**  Details of categories with which activity is associated with */
  categoryDetails?: Maybe<Array<Maybe<ActivityCategoryDetails>>>;
  /** Click link, action and onclick analytics for activity */
  clickAction?: Maybe<ActivityAction>;
  /** For client side analytics onLoad events */
  clientSideAnalytics?: Maybe<ClientSideAnalytics>;
  /** Short description of activity, limits to 160 characters including ellipsis */
  description?: Maybe<Scalars["String"]>;
  /** Link to open the details of the Activity in a popup */
  detailsLink?: Maybe<ActivityAnchoredMessage>;
  /**
   * Duration of activity
   * @deprecated Use activityDuration instead
   */
  duration: ActivityDuration;
  /** Enabled field to have the ability to show disabled tiles wherever required. They will have data but cannot be clicked and have less opacity */
  enabled: Scalars["Boolean"];
  /** features include pinned-activity, saved-activity, free cancel, mip/mod etc. */
  features: ActivitySearchFeature;
  /**
   * Flag suggests if an activity is free cancellable before redeeming
   * @deprecated should use features instead
   */
  freeCancel: Scalars["Boolean"];
  /** Activity image gallery */
  gallery?: Maybe<ActivityGallery>;
  /** Activity's unique identifier */
  id: Scalars["String"];
  /**
   * Featured activity image
   * @deprecated Use gallery instead
   */
  image?: Maybe<Image>;
  /**
   * Lead activity ticket
   * @deprecated Use leadTicketPrice instead
   */
  leadTicket: ActivitySearchTicket;
  /** Activity's lead ticket price */
  leadTicketPrice: ActivityPriceDisplay;
  /** Url link */
  link?: Maybe<Scalars["String"]>;
  /** Geo-coordinates of activity location */
  location?: Maybe<Coordinates>;
  /**
   * Localized name of activity
   * @deprecated Use primary instead
   */
  name: Scalars["String"];
  /**
   * Details about applied price discounts
   * @deprecated We send badges instead directly now
   */
  priceMetadata?: Maybe<ActivityPriceMetadata>;
  /** Localized name of activity */
  primary: EgdsText;
  /** Activity redemption details, like redemption-location and redemption-type */
  redemption?: Maybe<ActivityRedemption>;
  /** Customer review summary information */
  reviewSummary?: Maybe<ActivityReviewsSummary>;
  /** Save activity on clicking heart icon */
  saveItem?: Maybe<TripsSaveItem>;
  /** SecondaryMessage for the activity tile. Like for Poi tile, it could be `x things to do starting from y.` */
  secondaryMessage?: Maybe<Scalars["String"]>;
  /** ref id of the overview section for tab navigation */
  sectionRef?: Maybe<Scalars["String"]>;
  /**
   * shortlisted activity message which appears on click of favorite icon
   * @deprecated use TripsSaveItem
   */
  shortlistingMessages?: Maybe<ActivityShortlistingMessages>;
  /** Supplier name of activity, value will always be in english */
  supplierName?: Maybe<Scalars["String"]>;
  /** Third party partner name of activity, value will always be in english if activity is 3P */
  thirdPartyPartnerName?: Maybe<Scalars["String"]>;
  /** Actions involved to add, remove and update activity to trip. */
  tripUpdateButtons?: Maybe<ActivityTripUpdateButtons>;
  /**
   * link of activity info-site
   * @deprecated should use clickAction instead
   */
  url?: Maybe<Scalars["URL"]>;
};

/** Activity search region information */
export type ActivityAboveTheFold = {
  __typename?: "ActivityAboveTheFold";
  /** Above the fold banners */
  banners?: Maybe<Array<ActivityBanner>>;
  /** Above the fold breadcrumbs */
  breadcrumbs: Array<ActivityBreadcrumb>;
  /** Above the fold pills */
  pills?: Maybe<Array<ActivityPill>>;
};

/** Interface for accessibility data. */
export interface ActivityAccessibility {
  /** Accessibility label text. */
  label?: Maybe<Scalars["String"]>;
}

export type ActivityAction = {
  __typename?: "ActivityAction";
  /** accessibilityText for the action link. Eg Open in new tab */
  accessibilityText: Scalars["String"];
  /**
   * The presence of this field indicates that client side interactions such as `click` should be tracked.
   * @deprecated use clickanalytics
   */
  analytics?: Maybe<ActivityAnalytics>;
  /** The presence of this field indicates that client side interactions such as `click` should be tracked. */
  clickAnalytics?: Maybe<ClientSideAnalytics>;
  /** icon to display */
  icon?: Maybe<Icon>;
  /** label to be displayed on the action button */
  label: Scalars["String"];
  /** to decide open link in new tab or same */
  openInNewTab: Scalars["Boolean"];
  /** URI to get the relative and complete url. */
  uri?: Maybe<HttpUri>;
  /** url which will be used for navigating to All results */
  url: Scalars["String"];
};

export type ActivityActionCallbackMessages = {
  __typename?: "ActivityActionCallbackMessages";
  /** Message for failure callback */
  failure: Scalars["String"];
  /** Message for success callback */
  success: Scalars["String"];
};

export type ActivityActionTile = {
  __typename?: "ActivityActionTile";
  /**
   * The presence of this field indicates that client side interactions such as `click` should be tracked.
   * @deprecated use clientSideAnalytics
   */
  analytics?: Maybe<ActivityAnalytics>;
  /** Click Action for tile */
  clickAction?: Maybe<ActivityAction>;
  /** For client side analytics onLoad events */
  clientSideAnalytics?: Maybe<ClientSideAnalytics>;
  /** Enabled field to have the ability to show disabled tiles wherever required. They will have data but cannot be clicked and have less opacity */
  enabled: Scalars["Boolean"];
  /** Featured activity image */
  image?: Maybe<Image>;
  /** Url link */
  link?: Maybe<Scalars["String"]>;
  /** Localized name of activity including ActivityTile action text */
  name: Scalars["String"];
  /** Localized name of activity */
  primary: EgdsText;
  /** Action for Activity tile */
  primaryAction: ActivityAction;
  /** SecondaryMessage for the activity tile. Like for Poi tile, it could be `x things to do starting from y.` */
  secondaryMessage?: Maybe<Scalars["String"]>;
};

/** User interaction on an element to add an offer to the trip */
export type ActivityAddOfferToTripAction = UiAction & {
  __typename?: "ActivityAddOfferToTripAction";
  accessibility?: Maybe<Scalars["String"]>;
  analytics: ClientSideAnalytics;
  /** Messages corresponding to add offer to trip callbacks */
  callbackMessages?: Maybe<ActivityActionCallbackMessages>;
  /** Natural key used to retrieve details about a selected offer in trip */
  offerNaturalKey: ActivityOfferNaturalKey;
};

export type ActivityAnalytics = {
  __typename?: "ActivityAnalytics";
  /** link attached to any event */
  linkName: Scalars["String"];
  /** prime payload to send on click */
  microMessagePayload?: Maybe<Scalars["String"]>;
  /** rfrr to be used with track call for any event */
  referrerId: Scalars["String"];
};

export type ActivityAnchoredMessage = {
  __typename?: "ActivityAnchoredMessage";
  /** Accessibility string for the message. Useful when the link have no text or we have to provide alternate text */
  accessibilityText: Scalars["String"];
  /** Extended message with the text. Eg Link or popup */
  clickAction?: Maybe<ActivityClickAction>;
  /** Icon to be displayed with message. eg: information */
  icon?: Maybe<Icon>;
  /** Text message to be displayed */
  text?: Maybe<Scalars["String"]>;
};

export type ActivityAssortedComponentsTile = {
  __typename?: "ActivityAssortedComponentsTile";
  /** Filter pills to displayed */
  pills?: Maybe<ActivityPills>;
  /** SWP Toggle to be displayed */
  shopWithPoints?: Maybe<ActivityToggle>;
  /**
   * Represents a sort dropdown selection
   * @deprecated Use sortSection for the consistency across all platforms
   */
  sort?: Maybe<ShoppingDropdownField>;
  /** Sort disclaimer message to be displayed with click action */
  sortDisclaimer?: Maybe<ActivityAnchoredMessage>;
  /** Represents a dropdown of sort selection */
  sortSection?: Maybe<ShoppingSortAndFilterSection>;
};

export type ActivityAvailability = {
  __typename?: "ActivityAvailability";
  /** Accessibility string for activity availability */
  accessibility: Scalars["String"];
  /** Analytics when clicking on activity availability date */
  analytics: ClientSideAnalytics;
  date: Date;
  /** Localized text that displays Activity availability Date eg: 'Sat, Oct 26' */
  formattedDate: EgdsPlainText;
  /** Lead/minimum price of an activity displayed on availability calendar */
  formattedPrice?: Maybe<Scalars["String"]>;
  /** To highlight a date. Logic to highlight can be default or specific for use-case eg: highlight the date for which the first offer in trip is available */
  highlighted: Scalars["Boolean"];
  /** Field will be consumed on UI as boolean to power active/inactive dates */
  isAvailable: Scalars["Boolean"];
  /**
   * Field will be consumed to display lead/minimum price of an activity on availability calendar
   * @deprecated Use priceText instead
   */
  price?: Maybe<Money>;
  /** This field describes the theme applied on the price text */
  priceTextTheme?: Maybe<ActivityAvailabilityPriceTextTheme>;
};

export type ActivityAvailabilityPriceTextTheme = "POSITIVE";

export type ActivityBadge = {
  __typename?: "ActivityBadge";
  /** icon to display */
  icon?: Maybe<Icon>;
  /** mark to display if media type is Mark */
  mark?: Maybe<Mark>;
  /** text or label that should be displayed in badge */
  text?: Maybe<Scalars["String"]>;
  /** type of badge */
  type: ActivityBadgeType;
};

export type ActivityBadgeType = "CAMPAIGN_DEAL" | "DEAL_ADD_ON" | "DEAL_GENERIC" | "DEAL_MEMBER";

/** Activity banner view */
export type ActivityBanner = {
  __typename?: "ActivityBanner";
  /** action on banner */
  action?: Maybe<ActivityMessageActionLink>;
  /** impression tracking */
  analytics?: Maybe<ActivityAnalytics>;
  /** icon to be displayed for banner */
  icon?: Maybe<Icon>;
  /** mark to be displayed for banner */
  mark?: Maybe<Mark>;
  /**
   * title or primary-text of banner
   * @deprecated use title instead
   */
  primaryText: Icon;
  /** secondary action on banner */
  secondaryAction?: Maybe<ActivityMessageActionLink>;
  /**
   * supporting or sub-text of banner
   * @deprecated use subtitle instead
   */
  secondaryText: Icon;
  /** subtitle of banner */
  subtitle?: Maybe<Scalars["String"]>;
  /** title of banner */
  title?: Maybe<Scalars["String"]>;
  /** type of banner */
  type: ActivityBannerType;
  /**
   * regular text for shop-with-point and success/failure/warning for alert
   * @deprecated use icon/mark instead as per the use case
   */
  view: Icon;
};

/** Activity banner type */
export type ActivityBannerType = "ALERT" | "INFO" | "SHOP_WITH_POINTS";

export type ActivityBasicTile = {
  __typename?: "ActivityBasicTile";
  /**
   * The presence of this field indicates that client side interactions such as `click` should be tracked.
   * @deprecated use clientSideAnalytics
   */
  analytics?: Maybe<ActivityAnalytics>;
  /** Click Action for tile */
  clickAction?: Maybe<ActivityAction>;
  /** For client side analytics onLoad events */
  clientSideAnalytics?: Maybe<ClientSideAnalytics>;
  /** Enabled field to have the ability to show disabled tiles wherever required. They will have data but cannot be clicked and have less opacity */
  enabled: Scalars["Boolean"];
  /** Featured activity image */
  image?: Maybe<Image>;
  /** Url link */
  link?: Maybe<Scalars["String"]>;
  /**
   * Localized name of activity
   * @deprecated Use primary instead
   */
  name: Scalars["String"];
  /** Localized name of activity */
  primary: EgdsText;
  /** SecondaryMessage for the activity tile. Like for Poi tile, it could be `x things to do starting from y.` */
  secondaryMessage?: Maybe<Scalars["String"]>;
};

export type ActivityBreadcrumb = {
  __typename?: "ActivityBreadcrumb";
  /** used for tracking */
  analytics?: Maybe<ActivityAnalytics>;
  /** localized text of the breadcrumb link to be shown on UI */
  label: Scalars["String"];
  /** value to be removed from selections when link is clicked */
  selectionsToRemove: Array<ActivitySelectedValue>;
};

/** A button that triggers a dialog to open. */
export type ActivityButtonDialogTrigger = ActivityDialogTrigger & {
  __typename?: "ActivityButtonDialogTrigger";
  accessibility: Scalars["String"];
  analytics: ClientSideAnalytics;
  /** UI button element for trigger */
  button: EgdsButton;
};

export type ActivityCancellationType = "FREE_CANCELLATION" | "NO_CANCELLATION";

/** A card contains logical grouping of elements and content. Each card implementation will be unique in how they display content and carry information. */
export interface ActivityCard {
  /** Analytics tracking to capture onLoad events. */
  analytics?: Maybe<ClientSideAnalytics>;
}

/** Badges displayed on cards. For example, primary badge may show deal name and secondary badge may show price discount percentage. */
export type ActivityCardBadges = {
  __typename?: "ActivityCardBadges";
  /** Primary badge to display on activity card */
  primary?: Maybe<EgdsBadge>;
  /** Secondary badge to display on activity card */
  secondary?: Maybe<EgdsBadge>;
};

/** A group of elements to make up the content of an activity card. */
export type ActivityCardContent =
  | ActivityCardHeadingContent
  | ActivityCardHtmlContent
  | ActivityCardSectionContent
  | ActivityCardTextContent
  | ActivityCardTextListContent
  | ActivityPriceDisplay;

/** Title/heading only for an activity card. */
export type ActivityCardHeadingContent = {
  __typename?: "ActivityCardHeadingContent";
  /** Title/heading of activity card. */
  heading?: Maybe<EgdsText>;
};

/** HTML-formatted text in activity cards being injected into inner-html */
export type ActivityCardHtmlContent = {
  __typename?: "ActivityCardHtmlContent";
  /** Controls how an expanded link should appear */
  expando?: Maybe<EgdsExpando>;
  /** Group title/heading. */
  heading?: Maybe<EgdsText>;
  /** Html-formatted text. */
  text: Scalars["String"];
};

/** A list of link items in no particular order in an activity card. */
export type ActivityCardLinkListContent = {
  __typename?: "ActivityCardLinkListContent";
  /** Group title/heading. */
  heading?: Maybe<EgdsHeading>;
  /** Link list. */
  list: EgdsLinkList;
};

/** Reviews and rating information as seen in activity cards being used in carousels or in search results page. */
export type ActivityCardReviewsRatingContent = {
  __typename?: "ActivityCardReviewsRatingContent";
  /** Review disclaimer action and dialog. */
  disclaimer?: Maybe<ActivityDisclaimerDialog>;
  /** Reviews rating text. */
  primary?: Maybe<EgdsText>;
  /** Reviews count text. */
  secondaries?: Maybe<Array<EgdsText>>;
};

/** A content section can contain rows of card content that are grouped together. */
export type ActivityCardSectionContent = {
  __typename?: "ActivityCardSectionContent";
  /** Represents a column to organize content within the section. */
  columns: Array<ActivityCardSectionContentColumn>;
  /**
   * Represents a row to organize content within the section.
   * @deprecated
   *         Please start using the rows within columns in ActivityCardSectionContent instead of using this field directly.
   *         The new pattern allows us query both rows and columns in a more SDUI way.
   *
   */
  rows: Array<ActivityCardSectionContentElement>;
};

/** Represents a row to organize content within the section. */
export type ActivityCardSectionContentColumn = {
  __typename?: "ActivityCardSectionContentColumn";
  /** Represents a row to organize content within the section. */
  rows: Array<ActivityCardSectionContentElement>;
};

export type ActivityCardSectionContentElement =
  | ActivityCardHeadingContent
  | ActivityCardHtmlContent
  | ActivityCardLinkListContent
  | ActivityCardReviewsRatingContent
  | ActivityCardTextContent
  | ActivityCardTextListContent
  | ActivityPriceDisplay;

/**
 * A list of textual items.
 * For example, a textual item can be the duration of an activity which shows a clock icon with the duration time of the activity in simple text.
 */
export type ActivityCardTextContent = {
  __typename?: "ActivityCardTextContent";
  /** Controls how a expanded link should appear */
  expando?: Maybe<EgdsExpando>;
  /** Group title/heading. */
  heading?: Maybe<EgdsText>;
  /** Textual items. */
  items: Array<EgdsText>;
};

/** A list of items in no particular order in an activity card. */
export type ActivityCardTextListContent = {
  __typename?: "ActivityCardTextListContent";
  /** Controls how a expanded link should appear */
  expando?: Maybe<EgdsExpando>;
  /** Group title/heading. */
  heading?: Maybe<EgdsText>;
  /** Icon displayed next to title/heading. */
  icon?: Maybe<Icon>;
  /** Text list. */
  list: EgdsTextList;
};

/** Activity Carousel Accessibility Data when you have next and back buttons. */
export type ActivityCarouselAccessibilityData = ActivityAccessibility & {
  __typename?: "ActivityCarouselAccessibilityData";
  label?: Maybe<Scalars["String"]>;
  /** Accessibility label text for next button. */
  nextButton?: Maybe<Scalars["String"]>;
  /** Accessibility label text for previous button. */
  prevButton?: Maybe<Scalars["String"]>;
};

/** Carousel that aligns a set of cards horizontally with scrolling effect. The recommended card to use is the `ActivityImageHeaderCard` */
export type ActivityCarouselContainer = {
  __typename?: "ActivityCarouselContainer";
  /** Accessibility data. */
  accessibility?: Maybe<ActivityAccessibility>;
  /** List of analytics to capture multiple onLoad events. */
  analytics?: Maybe<Array<ClientSideAnalytics>>;
  /** List of carousel cards. */
  cards: Array<ActivityCard>;
  /** Container heading. */
  heading?: Maybe<EgdsHeading>;
};

export type ActivityCategory =
  | "ADULTS_ONLY_SHOWS"
  | "ADVENTURES"
  | "ADVENTURE_OUTDOOR"
  | "AIRBOAT_TOURS"
  | "AIRPLANE_RIDES"
  | "AIRPLANE_TOURS"
  | "AIRPORT_GROUND_TRANSPORTATION"
  | "AIRPORT_LOUNGES"
  | "AIRPORT_TO_AIRPORT_TRANSFERS"
  | "AIR_BALLOON_HELICOPTER_TOURS"
  | "AIR_HELICOPTER_BALLOON_TOURS"
  | "AMUSEMENT_THEME_PARKS"
  | "ARCHITECTURE_TOURS"
  | "ART_CLASSES"
  | "ART_CULTURE_HISTORY_TOURS"
  | "ART_MUSIC_LITERARYTOURS"
  | "ATTRACTIONS"
  | "ATTRACTION_TICKETS"
  | "BALLOON_RIDES"
  | "BALLOON_TOURS"
  | "BAR_PUB_TOURS"
  | "BEER_BREWERY_TOURS"
  | "BEYOND_THE_CITY"
  | "BIKE_MOUNTAIN_BIKE_TOURS"
  | "BIKE_RENTALS"
  | "BOAT_RENTAL"
  | "BOAT_TOURS"
  | "BOAT_TOURS_CRUISES"
  | "BRUNCHC_RUISES"
  | "BUNGEE_JUMPING_SKYDIVING"
  | "BUS_MINIVAN_TOURS"
  | "CABARET"
  | "CAMPAIGN_DEALS"
  | "CASTLE_PALACE_TOURS"
  | "CHAUFFER_SERVICES"
  | "CHRISTMAS"
  | "CIRQUE"
  | "CIRQUE_DU_SOLEIL"
  | "CIRQUE_DU_SOLEILSHOWS"
  | "CITY_AND_ATTRACTION_TRANSFERS"
  | "CITY_ATTRACTION_TRANSFERS"
  | "CITY_TOURS"
  | "CITY_TOURS_PACKAGES"
  | "CLASSES_WORKSHOPS"
  | "CLUB_AND_PARTY_BUS_TOURS"
  | "CLUB_PARTY_BUS_TOURS"
  | "COFFEE_TEA_TOURS"
  | "COMEDY_SHOWS"
  | "CONCERTS_SPECIAL_EVENTS"
  | "COOKING_CLASSES"
  | "CRUISES_BOAT_TOURS"
  | "CRUISES_WATER_TOURS"
  | "CULTURAL_HERITAGE_EXPERIENCES"
  | "CUSTOM_PRIVATE_TOURS"
  | "DANCE_CLASSES"
  | "DAY_OF_THE_DEAD"
  | "DAY_SPAS"
  | "DAY_TRIPS"
  | "DAY_TRIPS_EXCURSIONS"
  | "DINING_EXPERIENCES"
  | "DINNER_CRUISES"
  | "DINNER_THEATER"
  | "DISNEY"
  | "DISNEY_PARKS"
  | "DOLPHIN_WHALE_WATCHING"
  | "DOSE_OF_CULTURE"
  | "DUCK_TOURS"
  | "EASTER"
  | "FAMILY_FRIENDLY"
  | "FASHION_SHOWS_TOURS"
  | "FISHING_CHARTERS_TOURS"
  | "FISHING_TOURS_AND_CHARTERS"
  | "FOOD_DRINK"
  | "FOOD_DRINK_NIGHTLIFE"
  | "FOOD_TOURS"
  | "FUN_FOR_FOODIES"
  | "FUN_ON_THE_WATER"
  | "GALLERIES_MUSEUMS"
  | "GAMES_SHOWS_SPECIAL_EVENTS"
  | "GETTING_AROUND"
  | "GOLF_TEE_TIMES"
  | "GOLF_TOURS_TEE_TIMES"
  | "HALLOWEEN"
  | "HAMMAMS_TURKISH_BATHS"
  | "HELICOPTER_RIDES"
  | "HELICOPTER_TOURS"
  | "HIGH_SPEED_DRIVING"
  | "HIGH_SPEED_RIDES"
  | "HIKING_CAMPING"
  | "HISTORICAL_TOURS"
  | "HISTORY_CULTURE"
  | "HOLIDAY_SEASONAL_TOURS"
  | "HONEYMOON_PACKAGE"
  | "HONEYMOON_PACKAGES"
  | "HOP_ON_HOP_OFF"
  | "HOP_ON_HOP_OFF_TOURS"
  | "HORSE_CARRIAGE_RIDES"
  | "HOT_SPRINGS_THERMAL_SPAS"
  | "INTERESTS"
  | "KAYAKING_CANOEING"
  | "LATEST_GREATEST"
  | "LIFT_TICKETS"
  | "LIKELY_TO_SELL_OUT"
  | "LITERARY_ART_MUSIC_TOURS"
  | "LOCAL_EXPERT_PICKS"
  | "LUNCH_CRUISES"
  | "MOTORCYCLE_SCOOTER_TOURS"
  | "MOVIE_TV_TOURS"
  | "MULTIDAY_CRUISES"
  | "MULTI_DAY_EXTENDED_TOURS"
  | "MUSEUM_TICKETS"
  | "MUSEUM_TICKETS_PASSES"
  | "MUST_SEE_SIGHTS"
  | "NA"
  | "NATIONAL_HOLIDAYS"
  | "NEW"
  | "NEWY_EARS"
  | "NIGHTLIFE"
  | "NIGHTLIFE_PASSES"
  | "NIGHT_CRUISES"
  | "NIGHT_TOURS"
  | "ONSENS"
  | "OTHER_ANIMALS_ACTIVITIES"
  | "OTHER_ANIMAL_ACTIVITIES"
  | "OTHER_CLASSES"
  | "OTHER_OUTDOOR_ACTIVITIES"
  | "OTHER_SEASONAL_EVENTS"
  | "OTHER_TOURS"
  | "OTHER_TRANSFERS"
  | "OTHER_TRANSPORTATION"
  | "OTHER_WATER_ACTIVITIES"
  | "PHOTOGRAPHY_TOURS"
  | "PORT_TRANSFERS"
  | "PRIVATE_CUSTOM_TOURS"
  | "PRIVATE_DAY_TRIPS"
  | "PRIVATE_TOURS"
  | "PRIVATE_TRANSFERS"
  | "PURE_ROMANCE"
  | "RELIGIOUS_SPIRITUAL_TOURS"
  | "RIVER_HARBOUR_CRUISES"
  | "ROMAN_STAYCATION"
  | "SAFARIS"
  | "SAILING_TRIPS"
  | "SCOOTER_RENTALS"
  | "SEGWAY_TOURS"
  | "SHARED_TRANSFERS"
  | "SHARK_DIVING"
  | "SHOPPING_FASHION"
  | "SHOPPING_PASSES_OFFERS"
  | "SHOPPING_TOURS"
  | "SHORE_EXCURIONS"
  | "SHOWS_CONCERTS"
  | "SHOW_SPORT_TICKETS"
  | "SIGHTSEEING_ATTRACTION_PASSES"
  | "SIGHTSEEING_CITY_PASSES"
  | "SIGHTSEEING_PASSES"
  | "SKIING_RENTALS"
  | "SKIP_THE_LINE_TOURS"
  | "SNORKELING_SCUBA_DIVING"
  | "SNOWBOARDING_RENTALS"
  | "SNOWMOBILE_TOURS"
  | "SNOWSHOEING"
  | "SPA"
  | "SPA_WELLNESS"
  | "SPEED_BOATS_JET_SKIS"
  | "SPORTING_EVENTS_PACKAGES"
  | "SPORTS_PACKAGES"
  | "STAY_ACTIVE"
  | "SUBMARINE_TOURS"
  | "SUNSET_CRUISES"
  | "SUPERNATURAL_TOURS"
  | "SUSTAINABLE_TOURS"
  | "SWIM_WITH_DOLPHINS"
  | "THEATER_SHOWS_MUSICALS"
  | "THEME_PARKS"
  | "THEME_PARK_TICKETS_TOURS"
  | "THE_GREAT_OUTDOORS"
  | "THRILL_SEEKER"
  | "TICKETS"
  | "TOURS_ACTIVITIES"
  | "TOURS_SIGHTSEEING"
  | "TRANSPORTATION_SERVICES"
  | "TREAT_YOURSELF"
  | "TUBING"
  | "UNIVERSAL_THEME_PARKS"
  | "VALENTINES_DAY"
  | "WALKING_BIKE_TOURS"
  | "WALKING_TOURS"
  | "WATERSKIING_WAKEBOARDING"
  | "WATER_ACTIVITIES"
  | "WATER_PARKS"
  | "WEDDING_CEREMONIES"
  | "WEDDING_HONEYMOON"
  | "WEDDING_PACKAGES"
  | "WEDDING_SHONEYMOONS"
  | "WHAT_TO_DO_WITH_GROUPS"
  | "WHAT_TO_DO_WITH_KIDS"
  | "WHITE_WATER_RAFTING"
  | "WILDLIFE_NATURE"
  | "WINE_TASTING_WINERY_TOURS"
  | "WINTER_ACTIVITIES"
  | "YOGA_CLASS"
  | "YOGA_CLASSES"
  | "ZOO_TICKETS"
  | "ZOO_TICKETS_PASSES";

export type ActivityCategoryDetails = {
  __typename?: "ActivityCategoryDetails";
  category: ActivityCategory;
  /** This field is needed to control whether the filter option would be enabled or not on the UI. */
  enabled: Scalars["Boolean"];
  /** This option was selected in the search criteria. This allows for features like checkbox */
  isSelected: Scalars["Boolean"];
  /** localized name of category */
  name: Scalars["String"];
  /** category key to process filtering */
  raw: Scalars["String"];
  /** count of activities associates with this category in search results */
  size: FormattedNumber;
};

export type ActivityCategoryType =
  | "ACTIVITIES"
  | "CATEGORIES"
  | "DEALS_PROMOTIONS"
  | "NA"
  | "RECOMMENDATIONS"
  | "TOURS"
  | "TRANSPORTATION";

/** Click actions for buttons or links. */
export interface ActivityClickAction {
  /** Accessibility text for click action */
  accessibilityText: Scalars["String"];
  /**
   * rfrr used to send tracking for action
   * @deprecated Use ClientSideAnalytics instead.
   */
  analytics?: Maybe<ActivityAnalytics>;
  /** Click tracking analytics for trigger. */
  clientSideAnalytics: ClientSideAnalytics;
}

/** Used to describe an action to close up a dialog. */
export type ActivityCloseDialogAction = UiAction & {
  __typename?: "ActivityCloseDialogAction";
  accessibility?: Maybe<Scalars["String"]>;
  analytics: ClientSideAnalytics;
};

/** Click action to close dialog for dialog footer button. */
export type ActivityCloseDialogClickAction = ActivityClickAction & {
  __typename?: "ActivityCloseDialogClickAction";
  accessibilityText: Scalars["String"];
  analytics?: Maybe<ActivityAnalytics>;
  clientSideAnalytics: ClientSideAnalytics;
};

/** Comparison component UI model. */
export type ActivityComparisonComponent = {
  __typename?: "ActivityComparisonComponent";
  /** A generic carousel. */
  carousel: ActivityCarouselContainer;
  /** Component heading. */
  heading?: Maybe<EgdsHeading>;
};

/** Copy Link action in share menu on activity detail page navigation bar */
export type ActivityCopyLinkAction = ActivityNavigationBarClickAction & {
  __typename?: "ActivityCopyLinkAction";
  accessibilityText: Scalars["String"];
  analytics: ClientSideAnalytics;
  /** Toast to display success message after copy action is performed */
  toast?: Maybe<EgdsToast>;
  /** Value to be copied, eg: Activity URL is copied to clipboard */
  value: Scalars["String"];
};

export type ActivityCrossSellSearchResults = {
  __typename?: "ActivityCrossSellSearchResults";
  /** Activity group returned for destination page */
  group: ActivityGroup;
};

export type ActivityDateRange = {
  __typename?: "ActivityDateRange";
  endDate: Date;
  startDate: Date;
};

export interface ActivityDateRangeInput {
  endDate: DateInput;
  startDate: DateInput;
}

/** Dialog to show date range picker. */
export type ActivityDateRangePickerDialog = ActivityDialog & {
  __typename?: "ActivityDateRangePickerDialog";
  /** Displays date range picker. */
  dateRangePicker: EgdsDateRangePicker;
  trigger: ActivityDialogTrigger;
};

/** Activity search region information */
export type ActivityDestination = {
  __typename?: "ActivityDestination";
  coordinates?: Maybe<Coordinates>;
  pinnedActivityId?: Maybe<Scalars["String"]>;
  referencedActivityId?: Maybe<Scalars["String"]>;
  regionId?: Maybe<Scalars["String"]>;
  regionName?: Maybe<Scalars["String"]>;
  regionType?: Maybe<Scalars["String"]>;
};

/** Activity search region information */
export interface ActivityDestinationInput {
  /** Coordinates of the region, used for region (city or multicity) resolution */
  coordinates?: InputMaybe<CoordinatesInput>;
  /** activity id proposed for pinning on LX-SRP */
  pinnedActivityId?: InputMaybe<Scalars["String"]>;
  /** activity id passed as a reference for activity recommendations on LX-IS */
  referencedActivityId?: InputMaybe<Scalars["String"]>;
  /** Gaia region ID of the search */
  regionId?: InputMaybe<Scalars["String"]>;
  /** Name of the region, used for fuzzy resolution */
  regionName?: InputMaybe<Scalars["String"]>;
  /** Gaia Region Type denoted by regionId, example HOTEL OR CITY */
  regionType?: InputMaybe<Scalars["String"]>;
}

/** Details view options that are not filters */
export type ActivityDetailViewOptions = "NON_CONSOLIDATED_OFFERS" | "SHOP_WITH_POINTS" | "THIRD_PARTY_REVIEWS";

export type ActivityDetailsMessagingAction = {
  __typename?: "ActivityDetailsMessagingAction";
  /** Action text displayed for the url */
  text?: Maybe<Scalars["String"]>;
  /** Action url */
  url: Scalars["URL"];
};

export type ActivityDetailsUisPayLoad = {
  __typename?: "ActivityDetailsUisPayLoad";
  /** Generates UIS Payload for infosite (containing summary, presentation, offers) */
  detailsPayload: Scalars["String"];
  /** Generates UIS Payload for recommendation module */
  recommendationPayload?: Maybe<Scalars["String"]>;
};

/** Dialog types grouped together. */
export interface ActivityDialog {
  /** A link or button trigger to open dialog. */
  trigger: ActivityDialogTrigger;
}

/** Trigger to open a generic dialog. */
export interface ActivityDialogTrigger {
  /** Accessibility text. */
  accessibility: Scalars["String"];
  /** Click tracking analytics for trigger. */
  analytics: ClientSideAnalytics;
}

/** Dialog to show disclaimer content. */
export type ActivityDisclaimerDialog = ActivityDialog & {
  __typename?: "ActivityDisclaimerDialog";
  /** Content to display within the dialog body. */
  contents: Array<EgdsText>;
  /** Action dialogs are containers that content can be rendered in. Clients should orchestrate how content will render within the dialog. Action dialogs specifically contain one or more buttons for users to take action upon. */
  dialog: EgdsActionDialog;
  /** Dialog actions are a list of actions that will be used along with the list of buttons in the EGDSDialogFooter. */
  dialogActions?: Maybe<Array<ActivityClickAction>>;
  trigger: ActivityDialogTrigger;
};

export type ActivityDiscountType =
  | "AIR_ATTACH_MIP"
  | "AIR_HOTEL_ATTACH_MIP"
  | "CAMPAIGN_DEAL"
  | "FREE_ACTIVITY"
  | "GUEST"
  | "HOTEL_ATTACH_MIP"
  | "MOD"
  | "STRIKE_OUT";

export type ActivityDuration = {
  __typename?: "ActivityDuration";
  /** formatted duration, e.g. 1h+, 1h 30m */
  formatted?: Maybe<Scalars["String"]>;
  /** icon to display */
  icon?: Maybe<Icon>;
  /** raw duration with ChronoUnit and value */
  raw: Duration;
};

/** Email action in share menu on activity detail page navigation bar */
export type ActivityEmailAction = ActivityNavigationBarClickAction & {
  __typename?: "ActivityEmailAction";
  accessibilityText: Scalars["String"];
  analytics: ClientSideAnalytics;
  /** Email body */
  mailBody: Scalars["String"];
  /** Email subject */
  mailSubject: Scalars["String"];
  /** Email address to share activity to */
  mailTo?: Maybe<MailToUri>;
};

export type ActivityEmptyStateTile = {
  __typename?: "ActivityEmptyStateTile";
  /** Display the empty state message body. For eg: "Sorry we couldn't find a match" */
  body: Scalars["String"];
  /** Display the empty state heading. For eg: "Try adjusting your filters" */
  heading?: Maybe<Scalars["String"]>;
  /** Display the icon on top. */
  icon?: Maybe<Icon>;
};

/** Click action for error messaging. */
export type ActivityErrorMessagingClickAction = ActivityClickAction & {
  __typename?: "ActivityErrorMessagingClickAction";
  accessibilityText: Scalars["String"];
  analytics?: Maybe<ActivityAnalytics>;
  clientSideAnalytics: ClientSideAnalytics;
};

export type ActivityEventLocationDetails = {
  __typename?: "ActivityEventLocationDetails";
  /** address of location */
  address: Address;
  /** geographical coordinates of location */
  coordinates: Coordinates;
  /** User Friendly Name */
  description: Scalars["String"];
  /** single line address */
  formattedAddress?: Maybe<Scalars["String"]>;
  /** region/destination of an activity, powering back to search and region name display */
  region: ActivityRegion;
};

/** Controls how a expanded link should appear. */
export type ActivityExpando = {
  __typename?: "ActivityExpando";
  /** Analytics when clicking on the collapse button */
  collapseAnalytics?: Maybe<ActivityAnalytics>;
  /** Text appearing when expanded eg: 'See less' */
  collapseLabel: Scalars["String"];
  /** Analytics when clicking on the expand button */
  expandAnalytics?: Maybe<ActivityAnalytics>;
  /** Text appearing when collapsed eg: 'See more' */
  expandLabel: Scalars["String"];
  /**
   * Minimal height of the expando in its collapsed state.
   * For web platforms the associated unit would be in pixels as per the [UTIK-React doc](http://uitk-react.tools.expedia.com/expedia/en_US/components/expando).
   * While for mobile native app platforms the unit would be a number of elements (see the respective documentations).
   */
  minimalHeight?: Maybe<Scalars["Int"]>;
  /**
   * Controls under which condition the expando should appear. It's the minimum value required for the expando to be active.
   * For web platforms the associated unit would be in pixels as per the [UTIK-React doc](http://uitk-react.tools.expedia.com/expedia/en_US/components/expando).
   * While for mobile native app platforms the unit would be a number of elements (see the respective documentations).
   */
  threshold?: Maybe<Scalars["Int"]>;
};

/** A fake input that triggers a dialog to open. */
export type ActivityFakeInputDialogTrigger = ActivityDialogTrigger & {
  __typename?: "ActivityFakeInputDialogTrigger";
  /** Accessibility text for fake input. */
  accessibility: Scalars["String"];
  /** Click tracking analytics for fake input trigger. */
  analytics: ClientSideAnalytics;
  /**
   * Icon to be placed in the input
   * @deprecated Use Icon instead
   */
  graphic?: Maybe<UiGraphic>;
  /** Icon to be placed in the input */
  icon?: Maybe<Icon>;
  /** Top level label for the input */
  label: Scalars["String"];
  /** Selected value to be displayed */
  value?: Maybe<Scalars["String"]>;
};

/** Contains filtering criteria for Activities */
export type ActivityFilter = ActivityThemeFilter;

export type ActivityFreeCancellation = {
  __typename?: "ActivityFreeCancellation";
  /** localised value of label to show */
  formatted: Scalars["String"];
  /** enum value whether activity has free cancellation or not */
  type: ActivityCancellationType;
};

export type ActivityGallery = {
  __typename?: "ActivityGallery";
  /**
   * featured or primary image
   * @deprecated Use featuredMedia instead
   */
  featured: Image;
  /** featured or primary media */
  featuredMedia: Media;
  /**
   * list of images powering gallery
   * @deprecated Use medias instead
   */
  images: Array<Image>;
  /** list of media powering gallery */
  medias: Array<Media>;
};

/** Media gallery of an activity */
export type ActivityGalleryComponent = {
  __typename?: "ActivityGalleryComponent";
  /** A carousel of media gallery */
  carousel?: Maybe<EgdsCarousel>;
  /** list of media powering gallery */
  featuredMedia?: Maybe<Array<ActivityMediaItem>>;
  /** A thumbnail to show all photos */
  thumbnailDialog?: Maybe<ActivityThumbnailMediaGalleryDialog>;
};

/** A graphic element that triggers a dialog to open. */
export type ActivityGraphicDialogTrigger = ActivityDialogTrigger & {
  __typename?: "ActivityGraphicDialogTrigger";
  accessibility: Scalars["String"];
  analytics: ClientSideAnalytics;
  /** A graphic element. */
  graphic: UiGraphic;
};

export type ActivityGroup = {
  __typename?: "ActivityGroup";
  /** See all link for carousal */
  action?: Maybe<ActivityGroupAction>;
  /** Activities returned from the search, sorted in the order specified or in default recommended order */
  activityTiles: Array<ActivityTile>;
  /**
   * Analytics object for the activity groups. To be used for impression tracking on the client.
   * @deprecated Use analyticsList instead
   */
  analytics?: Maybe<ActivityAnalytics>;
  /**  For tracking multiple onLoad events */
  analyticsList: Array<ClientSideAnalytics>;
  /** Localized title for the carousel */
  heading?: Maybe<EgdsText>;
  /**
   * Id for the carousal
   * @deprecated The analytics object provides the complete referrerId now
   */
  id?: Maybe<Scalars["String"]>;
  /**
   * Localized name of title for the carousal
   * @deprecated Use heading instead
   */
  name?: Maybe<Scalars["String"]>;
  /** Navigation actions for carousel */
  navigationActions?: Maybe<ActivityNavigationActions>;
  /**
   * Defines the type of carousel based on data
   * @deprecated Use viewType instead
   */
  type: ActivityGroupType;
  /** Defines the type of carousel based on view */
  viewType: ActivityGroupViewType;
};

export type ActivityGroupAction = {
  __typename?: "ActivityGroupAction";
  /** accessibilityText for the group action link. Eg See all activities */
  accessibilityText: Scalars["String"];
  /** The presence of this field indicates that client side interactions such as `click` should be tracked. */
  analytics?: Maybe<ActivityAnalytics>;
  /** label to be displayed on the <See all> button */
  label: Scalars["String"];
  /** url which will be used for navigating to next page */
  url: Scalars["String"];
};

export type ActivityGroupType =
  | "ACTIVITY_LIST"
  | "ACTIVITY_MESSAGE"
  | "AVAILABLE_TODAY"
  | "CATEGORY"
  | "FILTERED_ACTIVITIES"
  | "INTERESTS"
  | "KEYWORD_SEARCH"
  | "MORE_ACTIVITIES"
  | "NEIGHBOURHOOD"
  | "PINNED_ACTIVITY"
  | "POI"
  | "RECOMMENDATIONS"
  | "SLIM_CATEGORY"
  | "SUB_CATEGORIES"
  | "SUB_CATEGORY"
  | "SWP_SORT_SECTION"
  | "TOP_ACTIVITIES"
  | "XSELL_RECOMMENDATIONS";

export type ActivityGroupViewType =
  | "ACTIVITY_LIST"
  | "ACTIVITY_SPANNED_TILE_LIST"
  | "ACTIVITY_TILES_CAROUSEL"
  | "CATEGORY_TILES_CAROUSEL"
  | "KEYWORD_SEARCH"
  | "MESSAGE"
  | "SLIM_CATEGORY_TILES_CAROUSEL"
  | "TEXT";

export type ActivityIcon = {
  __typename?: "ActivityIcon";
  /** Subtext with extended message.For Eg-free cancellation popup */
  anchoredSubtext?: Maybe<ActivityAnchoredMessage>;
  /**
   * icon to display
   * @deprecated Use nullabe field icon_temp instead
   */
  icon: Icon;
  /** uitk icon to display */
  icon_temp?: Maybe<Icon>;
  /** primary message that should be displayed with icon */
  label: Scalars["String"];
  /** uitk mark to display */
  mark?: Maybe<Mark>;
  /** primary message or sub-text that should be displayed with icon */
  subtext?: Maybe<Scalars["String"]>;
  /** details of icon link, null when icon has no link */
  url?: Maybe<Scalars["URL"]>;
};

/** Card with image on top and content below. This card is commonly seen on the search results page or in carousels. */
export type ActivityImageHeaderCard = ActivityCard & {
  __typename?: "ActivityImageHeaderCard";
  analytics?: Maybe<ClientSideAnalytics>;
  /** Card title/heading. */
  badges?: Maybe<ActivityCardBadges>;
  /** Click action when selecting activity title (`primary`) or image. */
  clickAction?: Maybe<ActivityClickAction>;
  /** List of contents. */
  contents?: Maybe<Array<ActivityCardContent>>;
  /** An image displayed at the top of the card, above contents. */
  image?: Maybe<Image>;
  /** Save activity on clicking heart icon */
  saveItem?: Maybe<TripsSaveItem>;
};

export type ActivityInfo = {
  __typename?: "ActivityInfo";
  /** basic info about the activity */
  activity: Activity;
  /** Provides day-wise prices and availabilities of an activity for provided date range (maximum 14 days) */
  availabilities: Array<ActivityAvailability>;
  /** Provides day-wise prices and availabilities of an activity for a 6 month duration */
  availabilityCalendar: Array<ActivityAvailability>;
  /** A carousel of comparable activities that are related to the currently viewing activity */
  comparison?: Maybe<ActivityComparisonComponent>;
  /** Activity image gallery */
  gallery: ActivityGallery;
  /** Activity image gallery */
  imageGallery?: Maybe<ActivityGalleryComponent>;
  /**
   * Activity location, having event, redemption and region details
   * @deprecated Use staticDetails query which will contain location card.
   */
  location: ActivityLocation;
  /** Represents information about the loyalty points applied to an activity */
  loyaltyPoints?: Maybe<ActivityLoyaltyPoints>;
  /** Toolbar component on top of activity detail page */
  navigationBar?: Maybe<ActivityNavigationBar>;
  /** Activity not found page */
  notFound: ActivityNotFoundComponent;
  /**
   * returns an offer from an offer group identified with the offerId and applying given filters
   * @deprecated will remove filter, replace with offer(offerId)
   */
  offer: ActivityOffer;
  /** Displays a single offer from offerId and provided selections (ie. traveler count, starting time, language, etc.). */
  offerComponent: ActivityOfferDetailsCard;
  /**
   * list of offers for given activity Id. Promo discount applied but SwP excluded. Returns list of offers available either on `selectedDate` or first available date in criteria/default date range
   * @deprecated will remove filter, replace with offers(selectedDate)
   */
  offers: Array<ActivityOffer>;
  /** Displays a list of offers with selectable options to book for an activity. */
  offersComponent?: Maybe<ActivityOffersComponent>;
  /** Displays a message when offers are unavailable, errors, etc. */
  offersMessage?: Maybe<ActivityOfferMessage>;
  /** Activity offers summary for sticky bar component */
  offersSummary: ActivityOffersSummary;
  /** Activity overview section */
  overview?: Maybe<ActivityOverviewComponent>;
  /** info and elements to render activity info on the page */
  presentation: ActivityPresentation;
  /**
   * recommended Activities which are related to queried activity-id with recommendation section title
   * @deprecated Use recommendations instead
   */
  recommendation?: Maybe<ActivityRecommendation>;
  /** A carousel of recommended activities that are related to the queried activity-id with recommendation section title */
  recommendations?: Maybe<ActivityRecommendationsComponent>;
  /** review comments for the activity Id */
  reviews: Array<ActivityReview>;
  /** Activity static details component */
  staticDetails?: Maybe<ActivityStaticDetailsComponent>;
  /** Tab details for Tabbed Navigation bar component */
  tabbedNavigationBar?: Maybe<ActivityTabbedNavigationBar>;
  /** Provides telesales number information to book over the phone */
  telesales?: Maybe<ActivityTelesales>;
  /** UIS Prime user interactions messages to be logged from client side */
  uisPayload: ActivityDetailsUisPayLoad;
};

export type ActivityInfoOfferArgs = {
  filter: ActivityOfferFilterInput;
  offerId: Scalars["String"];
};

export type ActivityInfoOfferComponentArgs = {
  offerId: Scalars["String"];
  selectedDate: DateInput;
};

export type ActivityInfoOffersArgs = {
  filter?: InputMaybe<ActivityOfferFilterInput>;
  selectedDate?: InputMaybe<DateInput>;
};

export type ActivityInfoOffersComponentArgs = {
  selectedDate?: InputMaybe<DateInput>;
};

export type ActivityInfoReviewsArgs = {
  pagination?: InputMaybe<PaginationInput>;
  sortBy?: InputMaybe<ActivityReviewSort>;
  source?: InputMaybe<Scalars["String"]>;
};

export type ActivityItemsByPoiModule = {
  __typename?: "ActivityItemsByPoiModule";
  /** List of Point of Interests and associated activities */
  groups: Array<ActivityPoiGroup>;
};

/** Itinerary information of a Viator activity that includes an itinerary. */
export type ActivityItineraryCard = {
  __typename?: "ActivityItineraryCard";
  /** Content item(s) of an activity itinerary. */
  contents: Array<ActivityItineraryCardContent>;
  /** Heading of the itinerary card. */
  heading: EgdsHeading;
  /** Ref id of the section for navigation */
  sectionRef?: Maybe<Scalars["String"]>;
};

/** Contents of the itinerary card. */
export interface ActivityItineraryCardContent {
  /** Expando that wraps card content. */
  expando?: Maybe<EgdsExpando>;
  /** One or more itinerary stop locations. */
  stops: Array<ActivityItineraryStopLocationContent>;
}

/** Content items for hop-on-hop-off itineraries. */
export type ActivityItineraryCardHopOnHopOffContent = ActivityItineraryCardContent & {
  __typename?: "ActivityItineraryCardHopOnHopOffContent";
  /** Expando that wraps card content. */
  expando?: Maybe<EgdsExpando>;
  /** Itinerary features list. */
  features?: Maybe<EgdsTextIconList>;
  /** Text list of the points of interest passed in the itinerary. */
  pointsOfInterest?: Maybe<ActivityCardTextListContent>;
  /** Itinerary schedule text. */
  schedule?: Maybe<ActivityCardTextContent>;
  /** One or more itinerary stop locations. */
  stops: Array<ActivityItineraryStopLocationContent>;
};

/** Content items for multi-day itineraries. */
export type ActivityItineraryCardMultiDayContent = ActivityItineraryCardContent & {
  __typename?: "ActivityItineraryCardMultiDayContent";
  /** Expando that wraps card content. */
  expando?: Maybe<EgdsExpando>;
  /** Itinerary features list. */
  features?: Maybe<EgdsTextIconList>;
  /** One or more itinerary stop locations. */
  stops: Array<ActivityItineraryStopLocationContent>;
};

/** Content items for single-day itineraries. */
export type ActivityItineraryCardStandardContent = ActivityItineraryCardContent & {
  __typename?: "ActivityItineraryCardStandardContent";
  /** Expando that wraps card content. */
  expando?: Maybe<EgdsExpando>;
  /** Itinerary menu lists. */
  menu?: Maybe<Array<ActivityCardTextListContent>>;
  /** One or more itinerary stop locations. */
  stops: Array<ActivityItineraryStopLocationContent>;
};

/** Itinerary stop location. */
export type ActivityItineraryStopLocationContent = {
  __typename?: "ActivityItineraryStopLocationContent";
  /** Itinerary stop heading. */
  heading?: Maybe<EgdsHeading>;
  /** Itinerary stop icon. */
  icon?: Maybe<Icon>;
  /** Itinerary stop features list */
  list?: Maybe<EgdsTextList>;
  /** Itinerary stop text */
  text?: Maybe<EgdsParagraph>;
};

export type ActivityLeadTicket = {
  __typename?: "ActivityLeadTicket";
  /** Localized ticket label for ticket one ticket, e.g. [per Adult], [par voyageur] */
  label?: Maybe<Scalars["String"]>;
  /** Legal disclaimer on strike through price */
  legalDisclaimer?: Maybe<ActivityAnchoredMessage>;
  /**
   * Activity likely to sell out urgency message on Sticky bar
   * @deprecated To be removed.
   */
  likelyToSellOut?: Maybe<ActivityLikelyToSellOut>;
  /** Loyalty points option for points display */
  loyaltyPointsOption?: Maybe<ActivityLoyaltyPointsOption>;
  /** Lead price of activity */
  price?: Maybe<ActivityPrice>;
  /** Accessibility text for pricing reader */
  priceAccessibilityText?: Maybe<Scalars["String"]>;
};

export type ActivityLeadTicketView = {
  __typename?: "ActivityLeadTicketView";
  /** label of action with view */
  action: ActivityMessageActionLink;
  /** Message to be displayed */
  message?: Maybe<Scalars["String"]>;
  /** Lead ticket among list of available offers */
  ticket: ActivityLeadTicket;
};

export type ActivityLikelyToSellOut = {
  __typename?: "ActivityLikelyToSellOut";
  /** localised value of label to show */
  formatted?: Maybe<Scalars["String"]>;
  /** icon to display */
  icon?: Maybe<Icon>;
};

/** Click action for a link. */
export type ActivityLinkClickAction = ActivityClickAction & {
  __typename?: "ActivityLinkClickAction";
  accessibilityText: Scalars["String"];
  analytics?: Maybe<ActivityAnalytics>;
  /** Relative Url to route outside activities pages */
  anchorTagUrl?: Maybe<Scalars["String"]>;
  clientSideAnalytics: ClientSideAnalytics;
  /** Relative Url to route within activities pages */
  linkTagUrl?: Maybe<Scalars["String"]>;
  /** to decide open link in new tab or same */
  opensInNewTab: Scalars["Boolean"];
};

/** A text and/or graphic link that triggers a dialog to open. */
export type ActivityLinkDialogTrigger = ActivityDialogTrigger & {
  __typename?: "ActivityLinkDialogTrigger";
  accessibility: Scalars["String"];
  analytics: ClientSideAnalytics;
  /** Link trigger graphic. */
  graphic?: Maybe<UiGraphic>;
  /** Link trigger label. */
  label: Scalars["String"];
};

export type ActivityLocation = {
  __typename?: "ActivityLocation";
  /** details of activity location */
  event: ActivityEventLocationDetails;
  /** details of locations where activity can be redeemed */
  redemption: Array<ActivityLocationDetails>;
  /** ref id of the section for tab navigation */
  sectionRef?: Maybe<Scalars["String"]>;
};

/**
 * Location section card that contains headings, map, activity location, and meeting/redemption point
 * Figma: https://www.figma.com/file/m6CNLA6nNaaAHBzIY9dvOg/PDP-optimization?node-id=7853%3A269192. Navigate to the Location section to see the design
 */
export type ActivityLocationCard = ActivityCard & {
  __typename?: "ActivityLocationCard";
  analytics?: Maybe<ClientSideAnalytics>;
  /** the list of POI and redemption point addresses that's related to the activity */
  contents: Array<ActivityCardSectionContent>;
  /** the heading that will be shown in the Location Section */
  heading: EgdsHeading;
  /** Activity dialog triggers and fields that will open up fullscreen map */
  map: ActivityLocationMapDialog;
  /** ref id of the section for navigation */
  sectionRef: Scalars["String"];
};

export type ActivityLocationDetails = {
  __typename?: "ActivityLocationDetails";
  /** address of location */
  address: Address;
  /** geographical coordinates of location */
  coordinates: Coordinates;
  /** User Friendly Name */
  description: Scalars["String"];
  /** distance from hotel to location label */
  distanceFromHotel?: Maybe<ActivityText>;
  /** single line address */
  formattedAddress?: Maybe<Scalars["String"]>;
};

/** Activity dialog triggers and fields that will open up fullscreen map */
export type ActivityLocationMapDialog = ActivityDialog & {
  __typename?: "ActivityLocationMapDialog";
  /** dialog options for dynamic map */
  dialog: EgdsFullScreenDialog;
  /** dynamic map markers and configurations */
  dynamicMap: ActivityMap;
  trigger: ActivityDialogTrigger;
};

export type ActivityLoyaltyPoints = {
  __typename?: "ActivityLoyaltyPoints";
  /** message string stating the amount of loyalty points applied to an activity */
  message: Scalars["String"];
};

/** Loyalty Points Information */
export type ActivityLoyaltyPointsOption = {
  __typename?: "ActivityLoyaltyPointsOption";
  /** Get formatted points string along with unit */
  formattedPoints?: Maybe<Scalars["String"]>;
  /** Caption before price or points, e.g. [or] [and] */
  leadingCaption?: Maybe<Scalars["String"]>;
  /** Loyalty points value */
  pointsAmount?: Maybe<FormattedNumber>;
  /** Boolean to indicate if points to be displayed first or cash */
  pointsFirst: Scalars["Boolean"];
  /** Loyalty points unit, e.g. [points] [PTS] */
  pointsUnit?: Maybe<Scalars["String"]>;
  /** Boolean to indicate if strikethrough needs to be displayed above or below */
  strikeThroughFirst: Scalars["Boolean"];
};

/** Activity fullscreen map and static map's configuration and markers */
export type ActivityMap = {
  __typename?: "ActivityMap";
  /** dynamic configurations */
  egMap: EgdsBasicMap;
  /** markers for that would render on the dynamic maps, and it includes the place card infomation */
  markers: Array<ActivityMapMarker>;
};

/** static map triggers dynamic map dialog to open  */
export type ActivityMapDialogTrigger = ActivityDialogTrigger & {
  __typename?: "ActivityMapDialogTrigger";
  /** Accessibility text for map. */
  accessibility: Scalars["String"];
  /** Click tracking analytics for map trigger. */
  analytics: ClientSideAnalytics;
  /** button label when opening full screen map */
  label?: Maybe<Scalars["String"]>;
  /** the static map that could be clicked to open up dynamic map */
  staticMap: ActivityMap;
  /** Static map image that contains the map url and accessibility */
  staticMapImage?: Maybe<StaticMapImage>;
  /**
   * google static map url that shows the map image
   * @deprecated use staticMap image instead because staticMapUrl does not have map accessibility text
   */
  staticMapUrl?: Maybe<Scalars["String"]>;
};

export type ActivityMapGroupType = "POI";

/**
 * the marker that would appear on maps that represents a location, activity, place, etc.
 * EGDS figma: https://www.figma.com/file/X31Tc9cWj9lbSKQCznru5M/Maps?node-id=3844%3A17057
 */
export type ActivityMapMarker = EgdsMapMarker & {
  __typename?: "ActivityMapMarker";
  markerIconType: Array<Scalars["String"]>;
  markerPosition: Coordinates;
  markerStatus: EgdsMapMarkerStatus;
  markerType: Scalars["String"];
  /** the card that would show at the bottom of the fullscreen dialog when clicking on an marker */
  placeCard?: Maybe<ActivityMapPlaceCard>;
  text: Scalars["String"];
};

/**
 * the card that would show at the bottom of the fullscreen dialog when clicking on a marker
 * Figma: https://www.figma.com/file/m6CNLA6nNaaAHBzIY9dvOg/PDP-optimization?node-id=500%3A0
 */
export type ActivityMapPlaceCard = {
  __typename?: "ActivityMapPlaceCard";
  /** An image that would appear on the place card */
  image?: Maybe<Image>;
  /** The main text of the place card */
  primary: EgdsText;
  /** Additional information about the activity or the location */
  secondaries?: Maybe<Array<EgdsText>>;
  /** the icon and text that would show on top of the main text. For example: Activity location */
  tag: EgdsIconText;
};

/** Activity marketing information to identify sem/seo traffic */
export interface ActivityMarketingInfoInput {
  /** Marketing channel type code. */
  mctc?: InputMaybe<Scalars["Int"]>;
  /** field which identifies sem channel */
  sem?: InputMaybe<Scalars["String"]>;
  /** field which identifies semdtl value */
  semdtl?: InputMaybe<Scalars["String"]>;
}

/** An activity item of type video or image */
export type ActivityMediaItem = MediaItem & {
  __typename?: "ActivityMediaItem";
  /** A media element */
  media: Media;
};

export type ActivityMessage = {
  __typename?: "ActivityMessage";
  /** SubTitle/Description Of the Message */
  subTitle?: Maybe<Scalars["String"]>;
  /** Title Of the Message */
  title?: Maybe<Scalars["String"]>;
};

export type ActivityMessageAction = {
  __typename?: "ActivityMessageAction";
  /** Primary click action */
  first?: Maybe<ActivityMessageClickAction>;
  /** @deprecated Use first instead */
  primary?: Maybe<ActivityMessageActionLink>;
  /** Secondary click action */
  second?: Maybe<ActivityMessageClickAction>;
  /** @deprecated Use second instead */
  secondary?: Maybe<ActivityMessageActionLink>;
};

export type ActivityMessageActionLink = {
  __typename?: "ActivityMessageActionLink";
  /** Accessibility string for the link. Useful when the link opens in a new tab. */
  accessibilityText: Scalars["String"];
  /** Key of the filter used for filtering */
  filterSelection?: Maybe<ActivitySelectedValue>;
  /** Action url */
  href: Scalars["String"];
  /** Rffr used to send tracking for action */
  rfrr?: Maybe<Scalars["String"]>;
  /** Action text displayed for the url */
  text?: Maybe<Scalars["String"]>;
};

export type ActivityMessageClickAction = {
  __typename?: "ActivityMessageClickAction";
  /** Extended message with the text. Eg Link or popup */
  clickAction: ActivityClickAction;
  /** Clickable text displayed */
  text?: Maybe<Scalars["String"]>;
};

export type ActivityMessageResult = {
  __typename?: "ActivityMessageResult";
  action?: Maybe<ActivityMessagingResultAction>;
  /** Used for impression tracking */
  analytics?: Maybe<ActivityAnalytics>;
  /** Key of the filter used for filtering */
  filterKey?: Maybe<Scalars["String"]>;
  /** index of the tile above which the banner will be displayed. (1-indexed) */
  index?: Maybe<Scalars["Int"]>;
  subtitle?: Maybe<ActivityMessagingResultTitle>;
  title?: Maybe<ActivityMessagingResultTitle>;
  /** type of activity message */
  type?: Maybe<ActivityMessageType>;
};

export type ActivityMessageTile = {
  __typename?: "ActivityMessageTile";
  action?: Maybe<ActivityMessageAction>;
  /** Used for impression tracking */
  analytics?: Maybe<ActivityAnalytics>;
  icon?: Maybe<Icon>;
  mark?: Maybe<Mark>;
  subtitle?: Maybe<ActivityMessageTitle>;
  title?: Maybe<ActivityMessageTitle>;
  type?: Maybe<ActivityMessageType>;
};

export type ActivityMessageTitle = {
  __typename?: "ActivityMessageTitle";
  /** UDS ID of the style to apply for the given text */
  styleTokens?: Maybe<Scalars["String"]>;
  /** Text for the messaging result */
  text?: Maybe<Scalars["String"]>;
};

/** Unique identifier for a message if one needs to identify the reason for the message creation */
export type ActivityMessageType =
  | "ADDON"
  | "EARN_2X_REWARD_POINTS"
  | "GIFTING_LX_BANNER"
  | "LOGIN"
  | "SOURCED_CAMPAIGN"
  | "SUMMER_CAMPAIGN_PRIMARY"
  | "SUMMER_CAMPAIGN_SECONDARY";

export type ActivityMessagingAction = {
  __typename?: "ActivityMessagingAction";
  /** Action url */
  href: Scalars["String"];
  /** Rffr used to send tracking for action */
  rfrr?: Maybe<Scalars["String"]>;
  /** Action text displayed for the url */
  text?: Maybe<Scalars["String"]>;
};

export type ActivityMessagingResultAction = {
  __typename?: "ActivityMessagingResultAction";
  primary?: Maybe<ActivityMessagingAction>;
  secondary?: Maybe<ActivityMessagingAction>;
};

export type ActivityMessagingResultTitle = {
  __typename?: "ActivityMessagingResultTitle";
  /** Icon used to display along with the text */
  icon?: Maybe<Icon>;
  /** Mark used to display along with the text */
  mark?: Maybe<Mark>;
  /** Text for the messaging result */
  text?: Maybe<Scalars["String"]>;
};

export type ActivityModulesResponse = {
  __typename?: "ActivityModulesResponse";
  /** List of activities by category. For example: List of activities for each category - Tours, water activities etc.  */
  activitiesByCategories: ActivitiesByCategoriesModule;
  /** List of Point of Interest and associated activities. For example: Statue of Liberty and things to do near Statue of Liberty */
  activityItemsByPoi?: Maybe<ActivityItemsByPoiModule>;
  /** list of activity categories. For example: Tours, water activities, etc */
  categories?: Maybe<ActivityGroup>;
};

export type ActivityMultiItemTripUpdateAction = UiAction & {
  __typename?: "ActivityMultiItemTripUpdateAction";
  accessibility?: Maybe<Scalars["String"]>;
  analytics: ClientSideAnalytics;
  /** Messages corresponding to multi-item trip update callbacks */
  callbackMessages?: Maybe<ActivityActionCallbackMessages>;
  /** Product natural key which uniquely determines the activity */
  offerNaturalKey: ActivityOfferNaturalKey;
  /**
   * Product id which uniquely determines the activity
   * @deprecated use offerNaturalKey
   */
  productId: Scalars["String"];
};

/** Minimum set of data used to retrieve details about an activity product */
export type ActivityNaturalKey = {
  __typename?: "ActivityNaturalKey";
  offerToken: Scalars["String"];
  productToken: Scalars["String"];
};

/** Minimum set of data used to retrieve details about an activity product */
export interface ActivityNaturalKeyInput {
  offerToken: Scalars["String"];
  productToken: Scalars["String"];
}

export type ActivityNavigationAction = {
  __typename?: "ActivityNavigationAction";
  /** Accessibility label for the action */
  accessibility: Scalars["String"];
  /** rfrr used to send tracking for action */
  analytics?: Maybe<ClientSideAnalytics>;
};

export type ActivityNavigationActions = {
  __typename?: "ActivityNavigationActions";
  /** Next action for the carousel */
  next: ActivityNavigationAction;
  /** Previous action for the carousel */
  previous: ActivityNavigationAction;
};

/** Activity Detail Navigation Bar Component */
export type ActivityNavigationBar = {
  __typename?: "ActivityNavigationBar";
  /** Back link to see all activities */
  backLink: EgdsStandardLink;
  /** Primary text in Navigation Bar */
  primary?: Maybe<Scalars["String"]>;
  /** Save activity on Navigation Bar */
  saveItem?: Maybe<TripsSaveItem>;
  /** List of secondary text in Navigation Bar */
  secondaries?: Maybe<Array<Scalars["String"]>>;
  /** Share menu on Navigation Bar */
  shareMenu?: Maybe<EgdsMenu>;
};

/** Interface for navigation bar specific click actions */
export interface ActivityNavigationBarClickAction {
  /** Accessibility string for click action */
  accessibilityText: Scalars["String"];
  /** rfrr used to send tracking for action */
  analytics: ClientSideAnalytics;
}

/** Component to show when an activity is not found. */
export type ActivityNotFoundComponent = {
  __typename?: "ActivityNotFoundComponent";
  /** UI Button that directs clients back to search page. */
  backButton: EgdsButton;
  /** Button actions that directs clients back to search page. */
  backButtonAction: ActivityLinkClickAction;
  /** Magnifying icon that displays on the activity not found page. */
  graphic?: Maybe<UiGraphic>;
  /** Heading of activity not found page. */
  primary: EgdsHeading;
  /** Subtexts on the activity not found page. */
  secondaries: Array<EgdsText>;
};

export type ActivityOffer = {
  __typename?: "ActivityOffer";
  /** Messages to show for each offer */
  activityOfferMessages?: Maybe<ActivityOfferMessages>;
  /** Offer Tickets Summary Section */
  activityOfferTicketsSummary?: Maybe<ActivityOfferTicketsSummary>;
  /** time when activity can be availed by user */
  availableTime: DateTime;
  /**
   * Deals/discount badges to show on offer level
   * @deprecated Use badge from ActivityOfferPriceDetails instead
   */
  badges?: Maybe<ActivityOfferBadges>;
  /** Total count of tickets available for the offer on a particular date */
  count: Scalars["Int"];
  /** Description of the offer */
  description?: Maybe<Scalars["String"]>;
  /** offer features like, duration, cancellation policy, booking fees, etc. */
  features: Array<ActivityIcon>;
  /** To highlight an offer eg: highlight offer of an activity already part of a trip */
  highlighted: Scalars["Boolean"];
  /** If Hotel Pickup is available */
  hotelPickupAvailable: Scalars["Boolean"];
  /** The offer's unique identifier */
  id: Scalars["String"];
  /** Max ticket selection allowed based on availability or special count for few activities like Disney. */
  maxTicketSelectionAllowed?: Maybe<Scalars["Int"]>;
  /** Min ticket selection allowed. It is to handle cases when we dont wantuser to go below certain ticket count like in cases of group and VBP */
  minTicketSelectionAllowed?: Maybe<Scalars["Int"]>;
  /** The name of the offer */
  name: Scalars["String"];
  /** Offer price details of an offer. */
  priceDetails: ActivityOfferPriceDetails;
  /**
   * Discount info about the offer
   * @deprecated We send badges instead directly now
   */
  priceMetaData?: Maybe<ActivityPriceMetadata>;
  /**
   * Price summary for the selected ticket types
   * @deprecated Use priceDetails instead
   */
  priceSummary: ActivityOfferPriceSummary;
  /** price-type, required for processing booking */
  priceType: ActivityPriceType;
  /** promotion id, required for processing booking */
  promoId?: Maybe<Scalars["String"]>;
  /** offer selection options like start-time, language */
  selections?: Maybe<Array<ActivityOfferOption>>;
  /**
   * traveler selector details
   * @deprecated  Use travelerSelectorDialog instead
   */
  ticketTypes: Array<ActivityOfferTicketType>;
  /** Dialog to select traveler counts */
  travelerSelectorDialog: ActivityTravelerSelectorDialog;
  /** Buttons to add,remove and update an offer in trip */
  tripUpdateButtons?: Maybe<ActivityTripUpdateButtons>;
};

export type ActivityOfferBadges = {
  __typename?: "ActivityOfferBadges";
  /** Primary badge to display on activity offer */
  primary?: Maybe<ActivityBadge>;
  /** Secondary badge to display on activity offer */
  secondary?: Maybe<ActivityBadge>;
};

/**
 * Error message that shows up when booking fails
 * Please do not use this further because this is just to support the legacy checkout
 * This should be removed whenever we move over to travel-api and create a graphql mutation for booking.
 */
export type ActivityOfferBookingErrorBanner = {
  __typename?: "ActivityOfferBookingErrorBanner";
  /** Error message banner that would be displayed */
  banner: UiBanner;
  /** Error code that identifies which error message to show */
  statusCode: Scalars["Int"];
};

/** Click action to create a trip for a given offer. */
export type ActivityOfferCreateTripAction = ActivityClickAction & {
  __typename?: "ActivityOfferCreateTripAction";
  accessibilityText: Scalars["String"];
  analytics?: Maybe<ActivityAnalytics>;
  /** Callback success/failure messages of create trip action. */
  callbackMessages: ActivityActionCallbackMessages;
  clientSideAnalytics: ClientSideAnalytics;
  /** The string-ified JSON for the legacy create trip request body. */
  createTripRequestBody: Scalars["String"];
};

/** Details of a single offer displayed on a card. */
export type ActivityOfferDetailsCard = {
  __typename?: "ActivityOfferDetailsCard";
  /** UI button to book an offer. */
  bookButton: EgdsButton;
  /** Book button create trip action. */
  createTripAction: ActivityOfferCreateTripAction;
  /** Displays the activity offer description. */
  description?: Maybe<EgdsParagraph>;
  /** Unique element identifier to handle UI component - ie. Offer Id. */
  elementId: Scalars["String"];
  /** Error messages. */
  errorMessages?: Maybe<Array<ActivityOfferBookingErrorBanner>>;
  /** Displays a list of features of the activity offer. */
  features?: Maybe<ActivityCardTextListContent>;
  /** Displays heading/title. */
  heading: Scalars["String"];
  /** Offer price details of an offer. */
  priceDetails: ActivityOfferPriceDetails;
  selections?: Maybe<Array<ActivityOfferSelectionElement>>;
};

export interface ActivityOfferFilterInput {
  selections?: InputMaybe<Array<ActivitySelectedValueInput>>;
  tickets?: InputMaybe<Array<ActivityTicketInput>>;
}

export type ActivityOfferItem = OfferItem & {
  __typename?: "ActivityOfferItem";
  /** Activity offer price and link */
  activityOffer?: Maybe<OfferData>;
  /** Badge to be displayed for the offer card */
  badge?: Maybe<CampaignOfferBadge>;
  /** City name where activity is located */
  city: Scalars["String"];
  /** Date range the activity offer is valid */
  dates?: Maybe<Scalars["String"]>;
  /** Description of the activity */
  description?: Maybe<Scalars["String"]>;
  /** Time duration it takes to complete the activity */
  duration?: Maybe<Scalars["String"]>;
  /** Formatted UI element for time duration it takes to complete the activity */
  durationLabel?: Maybe<Scalars["String"]>;
  /** If the activity can be cancelled free of charge */
  freeCancellationMessage?: Maybe<Scalars["String"]>;
  /** Image for the activity offer card */
  image: Image;
  /** Name of the destination where the activity is applicable */
  name: Scalars["String"];
  /** Province name where activity is located */
  province?: Maybe<Scalars["String"]>;
  /** Secondary content related to the activity */
  secondaryContent?: Maybe<Scalars["String"]>;
  /** Title of the activity */
  title?: Maybe<Scalars["String"]>;
};

export type ActivityOfferLoyaltyEarnAmount = {
  __typename?: "ActivityOfferLoyaltyEarnAmount";
  /** loyalty earn cash for when this count of tickets are selected */
  loyaltyEarnAmount: Money;
  /** ticket selected count for earn cash details */
  selectedCount: Scalars["Int"];
};

/** Displays a message related to the activity's offers. */
export type ActivityOfferMessage = {
  __typename?: "ActivityOfferMessage";
  primary: Scalars["String"];
  secondaries?: Maybe<Array<Scalars["String"]>>;
};

export type ActivityOfferMessages = {
  __typename?: "ActivityOfferMessages";
  /**
   * Offer likely to sell out urgency message on Offer
   * @deprecated To be removed.
   */
  likelyToSellOut?: Maybe<ActivityLikelyToSellOut>;
  /**
   * Non refundable message on Offer
   * @deprecated To be removed.
   */
  nonRefundable?: Maybe<ActivityMessage>;
  /** Operating hours message of an Offer */
  operatingHours?: Maybe<EgdsText>;
  /** Remove selected offer message on offer */
  removeSelectedOffer?: Maybe<EgdsText>;
  /** Message for VBP offer */
  vbpMessage?: Maybe<Scalars["String"]>;
};

export type ActivityOfferMultiSelectionOption = ActivityOfferOption & {
  __typename?: "ActivityOfferMultiSelectionOption";
  /** Full screen dialog for offer option selection. Includes a toolbar with a close icon and dialog title. */
  dialog: EgdsFullScreenDialog;
  /** Button to select offer option */
  doneButton: UiPrimaryButton;
  fields?: Maybe<Array<ActivityOfferSelectionField>>;
  graphic?: Maybe<UiGraphic>;
  /** Heading to be displayed above offer options */
  heading?: Maybe<EgdsHeading>;
  id: Scalars["String"];
  selections?: Maybe<Array<ActivityOfferSelectionField>>;
  title: Scalars["String"];
  /** Trigger to open offer open selection dialog */
  trigger: ActivityDialogTrigger;
};

/** Data used to retrieve details about an activity product */
export type ActivityOfferNaturalKey = {
  __typename?: "ActivityOfferNaturalKey";
  /** Offer Product Natural Key for offer entity which uniquely determines bookable offer of activity. This includes, site id, Offer id, Offer dates, offer locale, total travelers selected to uniquely identify an offer */
  offerProductNaturalKey: Scalars["String"];
};

/** Data used to retrieve details about an activity product */
export interface ActivityOfferNaturalKeyInput {
  /** Offer Product Natural Key for offer entity which uniquely determines bookable offer of activity. This includes, site id, Offer id, Offer dates, offer locale, total travelers selected to uniquely identify an offer */
  offerProductNaturalKey: Scalars["String"];
}

export interface ActivityOfferOption {
  /** @deprecated Use ActivityOfferMultiSelectionOption.selections now */
  fields?: Maybe<Array<ActivityOfferSelectionField>>;
  /** @deprecated Use ActivityOfferMultiSelectionOption.trigger now */
  graphic?: Maybe<UiGraphic>;
  id: Scalars["String"];
  /** @deprecated Use ActivityOfferMultiSelectionOption.trigger now */
  title: Scalars["String"];
}

export type ActivityOfferPrice = {
  __typename?: "ActivityOfferPrice";
  /** per-ticket price for when this count of tickets */
  perTravelerPrice: ActivityPrice;
  /** ticket selected count for prices details */
  selectedCount: Scalars["Int"];
  /** Loyalty points option for total points display */
  totalLoyaltyPointsOption?: Maybe<ActivityLoyaltyPointsOption>;
  /** total-ticket price for when this count of tickets are selected */
  totalPrice: ActivityPrice;
};

/** Offer price details of an offer. */
export type ActivityOfferPriceDetails = {
  __typename?: "ActivityOfferPriceDetails";
  /** Displays offer special or discount badge. */
  badge?: Maybe<EgdsStandardBadge>;
  /** Displays localized string for `Price details`. */
  detailsTitle: Scalars["String"];
  footer?: Maybe<Array<ActivityOfferPriceDetailsFooterElement>>;
  /** Displays price line items of traveler count and price. */
  lineItems: Array<ActivityOfferPriceLineItems>;
  /** Displays price lockup component for an offer. */
  priceDisplay: ActivityPriceDisplay;
  /** Displays localized string for `Total`. */
  totalTitle: Scalars["String"];
};

/** UI elements for price details footer on an offer card. */
export type ActivityOfferPriceDetailsFooterElement = ActivityDisclaimerDialog | EgdsPlainText;

/** Offer price line items showing traveler count and calculated pricing. */
export type ActivityOfferPriceLineItems = {
  __typename?: "ActivityOfferPriceLineItems";
  /** Accessibility text. */
  accessibility: Scalars["String"];
  /** Displays lockup price. */
  lockupPrice: Scalars["String"];
  /** Displays price breakdown. */
  priceBreakdown: Scalars["String"];
  /** Displays strikethrough price. */
  strikeThroughPrice?: Maybe<Scalars["String"]>;
};

export type ActivityOfferPriceSummary = {
  __typename?: "ActivityOfferPriceSummary";
  /** Ticket breakdown section on the price summary */
  ticketBreakdownSummary: ActivityOfferTicketBreakdownPriceSummary;
  /** Total price section on the price summary */
  totalPriceSummary: ActivityOfferTotalPriceSummary;
};

/** UI elements for selectable options on an offer card. */
export type ActivityOfferSelectionElement =
  | ActivityOfferSelectionGraphicText
  | ActivityRadioGroupDialog
  | ActivityTravelerSelectorDialog;

export type ActivityOfferSelectionField = {
  __typename?: "ActivityOfferSelectionField";
  analytics?: Maybe<ClientSideAnalytics>;
  label: Scalars["String"];
  theme: ActivityOfferUdsToken;
  value: Scalars["String"];
};

/** Displays static graphic text when selectable options are not available. Also provides selected key-value data to the client for offer filtering. */
export type ActivityOfferSelectionGraphicText = {
  __typename?: "ActivityOfferSelectionGraphicText";
  /** Displays a graphic and text. */
  graphicText: EgdsGraphicText;
  /** Selected key data to be used for offer filter inputs. */
  key: Scalars["String"];
  /** Selected value data to be used for offer filter inputs. */
  value: Scalars["String"];
};

export type ActivityOfferSingleSelectionOption = ActivityOfferOption & {
  __typename?: "ActivityOfferSingleSelectionOption";
  fields?: Maybe<Array<ActivityOfferSelectionField>>;
  graphic?: Maybe<UiGraphic>;
  id: Scalars["String"];
  title: Scalars["String"];
};

export type ActivityOfferTicketBreakdownPriceSummary = {
  __typename?: "ActivityOfferTicketBreakdownPriceSummary";
  /** List of selected ticket types */
  ticketTypePrices: Array<ActivityOfferTicketTypePriceSummary>;
  /** Title on this section eg: Price Summary */
  title: Scalars["String"];
};

export type ActivityOfferTicketSummaryExtendedMessage = {
  __typename?: "ActivityOfferTicketSummaryExtendedMessage";
  /** Action(eg: button behavior for popup/toggle) */
  action?: Maybe<ActivityMessagingAction>;
  /** Summary text for the section */
  text: Scalars["String"];
};

export type ActivityOfferTicketType = {
  __typename?: "ActivityOfferTicketType";
  /** default ticket selected count, like 1 Adult, 0 child, 0 infant, etc. */
  defaultSelectedCount: Scalars["Int"];
  /** localized display label for a ticket type */
  label: Scalars["String"];
  /**
   * loyalty earn cash combination for each supported ticket count
   * @deprecated The loyalty earn is being calculated with offers call
   */
  loyaltyEarnAwards?: Maybe<Array<ActivityOfferLoyaltyEarnAmount>>;
  /** Max value of tickets that can be selected */
  maxSelectableCount: Scalars["Int"];
  /** Min value of tickets that can be selected */
  minSelectableCount: Scalars["Int"];
  /** price combination for supported ticket count, considering for few activities, ticket count is restricted to like 2,4 only and perTicket price depends on ticket count */
  prices: Array<ActivityOfferPrice>;
  /** Promotion ID of the ticket */
  promoId?: Maybe<Scalars["String"]>;
  /** localized restriction Text */
  restrictionText?: Maybe<Scalars["String"]>;
  /** step value used to increment tickets on UI */
  step: Scalars["Int"];
  /** required for existing LX booking path. This will be removed/deprecated as LX adopt generic booking path based on naturalKey & token */
  ticketKey: Scalars["String"];
  /** localized ticket value when multiple tickets are selected, e.g. '{count} Adults' or '1 adultes'' */
  ticketPlural: Scalars["String"];
  /** localized ticket value when 1 ticket is selected, e.g. '1 Adult' or '1 adulte' */
  ticketSingular: Scalars["String"];
  /** Describes the type of ticket. eg: Adult, Child etc */
  type: Scalars["String"];
};

export type ActivityOfferTicketTypePriceSummary = {
  __typename?: "ActivityOfferTicketTypePriceSummary";
  /** Total of selected ticket count Ally Eg: Original price was $60 , discounted price is $50 per ticket. price for 2 Adults is $100 */
  accessibilityText: Scalars["String"];
  /** lead price in label eg: $50 X 2 Adults */
  breakdownLeadPriceLabel: Scalars["String"];
  /** Strikeout price in label eg: $60 */
  breakdownStrikeOutPriceLabel?: Maybe<Scalars["String"]>;
  /** Total price as label eg: $100 */
  totalLeadPriceLabel: Scalars["String"];
};

export type ActivityOfferTicketsSummary = {
  __typename?: "ActivityOfferTicketsSummary";
  /** Message related to ticket summary section */
  activityOfferTicketsSummaryMessages?: Maybe<Array<ActivityOfferTicketsSummaryMessage>>;
  /** Icon for ticket selector section. eg: Person (for Activities) or directions_bus (for GT) */
  icon: Scalars["String"];
  /** Title for ticket summary section. eg: Traveler or Cruise */
  title: Scalars["String"];
};

export type ActivityOfferTicketsSummaryMessage = {
  __typename?: "ActivityOfferTicketsSummaryMessage";
  /** Extended message for ticket summary message. Can be shown in pop-up or toggle */
  extendedMessage?: Maybe<ActivityOfferTicketSummaryExtendedMessage>;
  /** Action url */
  href?: Maybe<Scalars["String"]>;
  /** Icon for ticket summary message. eg: information */
  icon?: Maybe<Scalars["String"]>;
  /** rffr used to send tracking for action */
  rfrr?: Maybe<Scalars["String"]>;
  /** Summary text for the section */
  text: Scalars["String"];
  /** Type of the ticket summary meesage */
  type?: Maybe<Scalars["String"]>;
};

export type ActivityOfferTotalPriceSummary = {
  __typename?: "ActivityOfferTotalPriceSummary";
  /** Legal disclaimer on strike through price */
  legalDisclaimer?: Maybe<ActivityAnchoredMessage>;
  /** Loyalty points calculated */
  loyaltyPointsMessage?: Maybe<Scalars["String"]>;
  /** Boolean to indicate if points to be displayed first or cash */
  pointsFirst: Scalars["Boolean"];
  /** Total price calculated on selected tickets */
  price: ActivityPrice;
  /** Localized text for total price  Ally eg: Price was $39.81, price is now $33.78 */
  priceAccessibilityText: Scalars["String"];
  /** Title of the section eg: Total */
  title: Scalars["String"];
};

export type ActivityOfferUdsToken = "SELECTED" | "UNSELECTED";

/** UI components for offers. */
export type ActivityOffersComponent = {
  __typename?: "ActivityOffersComponent";
  /** Displays offers list component. */
  offersListComponent?: Maybe<ActivityOffersListComponent>;
  /** Displays offers summary component typically displayed in small viewport only. */
  offersSummaryComponent?: Maybe<ActivityOffersSummaryComponent>;
  /** Section ref data. */
  sectionRef: Scalars["String"];
};

/** Displays a list of offer cards of an activity along with the date range and date picker components. */
export type ActivityOffersListComponent = {
  __typename?: "ActivityOffersListComponent";
  /** Link that opens date range picker component in a dialog. */
  datePickerLink: ActivityDateRangePickerDialog;
  /** Displays date range component. */
  dateRange: EgdsDateRange;
  /** Displays filter pills to filter offers list. */
  filters?: Maybe<ActivityOffersListFilterPills>;
  /** Displays heading/title. */
  heading?: Maybe<Scalars["String"]>;
  /** List of offers of the activity. */
  offers?: Maybe<Array<ActivityOfferDetailsCard>>;
  /** Displays a message when offers are unavailable, errors, etc. */
  offersMessage?: Maybe<ActivityOfferMessage>;
  /** Displays toggle to use loyalty points. */
  pointsToggle?: Maybe<ActivityToggle>;
};

/** Dialog to show offers list. */
export type ActivityOffersListDialog = ActivityDialog & {
  __typename?: "ActivityOffersListDialog";
  /** Fullscreen dialog. */
  dialog: EgdsFullScreenDialog;
  /** Offers list content to display. */
  offersList: ActivityOffersListComponent;
  trigger: ActivityDialogTrigger;
};

/** Filters that can be applied to the list of offers. */
export type ActivityOffersListFilterPills = {
  __typename?: "ActivityOffersListFilterPills";
  /** Displays heading/title. */
  heading?: Maybe<Scalars["String"]>;
  /** Pill used to toggle offer filters. */
  pills: Array<EgdsBasicPill>;
};

export type ActivityOffersSummary = {
  __typename?: "ActivityOffersSummary";
  /** Filtering options applicable on all offers, like specific meal inclusions */
  filters?: Maybe<Array<ActivityOfferOption>>;
  /** Lead ticket among list of available offers */
  leadTicketView: ActivityLeadTicketView;
};

/** Offers summary component typically displayed in small viewport only. */
export type ActivityOffersSummaryComponent = {
  __typename?: "ActivityOffersSummaryComponent";
  /** Link that opens date range picker component in a dialog. */
  datePickerLink: ActivityDateRangePickerDialog;
  /** Displays date range component. */
  dateRange: EgdsDateRange;
  /** Displays heading/title. */
  heading?: Maybe<Scalars["String"]>;
  /** Button that triggers a dialog containing a list of offers. */
  offersButton: ActivityOffersListDialog;
  /** Provides price display information of the offers. */
  priceDisplay: ActivityPriceDisplay;
};

/** Click action to open details modal in `ActivityAnchoredMessage`. */
export type ActivityOpenDetailsModalClickAction = ActivityClickAction & {
  __typename?: "ActivityOpenDetailsModalClickAction";
  accessibilityText: Scalars["String"];
  /** Activity's unique identifier */
  activityId: Scalars["String"];
  analytics?: Maybe<ActivityAnalytics>;
  clientSideAnalytics: ClientSideAnalytics;
  /** Date range to fetch leadPrice and content */
  dateRange: ActivityDateRange;
  /** Full screen dialog for activity details. Includes a toolbar with a close icon and dialog title. */
  dialog: EgdsFullScreenDialog;
};

/** Used to describe an action to open up a plain dialog. */
export type ActivityOpenDialogAction = UiAction & {
  __typename?: "ActivityOpenDialogAction";
  accessibility?: Maybe<Scalars["String"]>;
  analytics: ClientSideAnalytics;
  /** Types of dialogs. */
  dialog: ActivityDialog;
};

/** User interaction on an element to view offers associated with an activity. A new graphQL query would be fired to fetch offer info, and the fields in this action are input to that query */
export type ActivityOpenOffersModalAction = UiAction & {
  __typename?: "ActivityOpenOffersModalAction";
  accessibility?: Maybe<Scalars["String"]>;
  /** Activity's unique identifier */
  activityId: Scalars["String"];
  analytics: ClientSideAnalytics;
  /** date range to fetch offers for */
  dateRange: ActivityDateRange;
  /** Accessibility text for dialog dismiss button */
  dismissButtonAccessibility: Scalars["String"];
  /** Analytics for dialog dismiss button */
  dismissButtonAnalytics: ClientSideAnalytics;
  /** Heading for offers dialog, eg: `Choose your tickets` */
  heading?: Maybe<EgdsHeading>;
  /** Offers of the activity which are already part of the trip */
  selectedOffers?: Maybe<Array<ActivityOfferNaturalKey>>;
  /** Sub-heading for offers dialog, eg: `Mt. Rainier Full-Day Tour` */
  subHeading?: Maybe<EgdsPlainText>;
};

/**  Component to show activity overview section. */
export type ActivityOverviewComponent = {
  __typename?: "ActivityOverviewComponent";
  /** A static content section can contain rows of card content that are grouped together. */
  contents: ActivityCardSectionContent;
  /** Heading of overview section on IS page. */
  heading: EgdsHeading;
  /** Displays the price info for overview section */
  priceDisplay?: Maybe<ActivityPriceDisplay>;
  /** Displays the reviews summary for overview section */
  reviewSummary?: Maybe<ActivityReviewsSummary>;
  /** ref id of the section for tab navigation */
  sectionRef: Scalars["String"];
  /** Link to a Section Ref */
  seeTicketsAction: ActivityRefClickAction;
  /** Button to view the tickets */
  seeTicketsButton: UiPrimaryButton;
  /** Supplier name subtext on activity overview section. */
  subHeading?: Maybe<Array<EgdsText>>;
};

/** Activity Page Information */
export type ActivityPage = {
  __typename?: "ActivityPage";
  /** Id of the page, used for rfrr. Eg- Des */
  pageId: Scalars["String"];
  /** Name of the page. Eg- DESTINATION_PAGE */
  pageName?: Maybe<Scalars["String"]>;
  /** Title of the page. Eg- Things to do in Rome | Expedia */
  title?: Maybe<Scalars["String"]>;
};

/** Page Hreflang links */
export type ActivityPageHrefLangLink = {
  __typename?: "ActivityPageHrefLangLink";
  /** Hreflang url */
  href: Scalars["String"];
  /** Hreflang locale */
  hrefLang: Scalars["String"];
};

/** Activity page Meta Tag types - NamedMetaTag, PropertyMetaTag and so on */
export type ActivityPageMetaTagType = "HTTP_EQUIV" | "NAME" | "PROPERTY";

/** Page meta tag attributes */
export type ActivityPageSeoMetaTag = {
  __typename?: "ActivityPageSeoMetaTag";
  /** Meta tag content */
  content: Scalars["String"];
  /** Meta tag type - name, property or httpEquiv */
  metaTagType: ActivityPageMetaTagType;
  /** Value of meta tag property or meta tag name. Eg: og:image, og:image:url, description, robots, etc. */
  metaTagValue: Scalars["String"];
};

/** Activity Page Type - infosite */
export type ActivityPageType = "ACTIVITY_INFO";

/** Used for show more action */
export type ActivityPaginationAction = UiAction & {
  __typename?: "ActivityPaginationAction";
  /** Accessibility label for the action */
  accessibility?: Maybe<Scalars["String"]>;
  /** rfrr used to send tracking for action */
  analytics: ClientSideAnalytics;
  /** Value used for show more action */
  pagination: Pagination;
};

export type ActivityPaginationInfo = {
  __typename?: "ActivityPaginationInfo";
  /** Index of the current page. */
  currentPageIndex: Scalars["Int"];
  /** Index of the next page that can be queried. -1 if no next page is there. */
  nextPageIndex: Scalars["Int"];
  /** Number of activities sent in one page. */
  pageSize: Scalars["Int"];
};

/** Used for show more action */
export type ActivityPaginationInfoAction = ActivityClickAction & {
  __typename?: "ActivityPaginationInfoAction";
  /** Accessibility label for the action */
  accessibilityText: Scalars["String"];
  analytics?: Maybe<ActivityAnalytics>;
  /** rfrr used to send tracking for action */
  clientSideAnalytics: ClientSideAnalytics;
  /** Value used for show more action */
  pagination: Pagination;
};

export type ActivityPartnerProvidedDetails = {
  __typename?: "ActivityPartnerProvidedDetails";
  /** Details as paragraph or text body */
  body: Scalars["String"];
  /** heading or identification of details */
  heading: Scalars["String"];
};

/** Activity specific basic pill element that may be selected and/or disabled. */
export type ActivityPill = UiPill & {
  __typename?: "ActivityPill";
  accessibility?: Maybe<Scalars["String"]>;
  action?: Maybe<UiAction>;
  /** @deprecated DO NOT USE. Will be removed. */
  analytics?: Maybe<ActivityAnalytics>;
  disabled: Scalars["Boolean"];
  icon?: Maybe<Icon>;
  /** @deprecated DO NOT USE. Will be removed. */
  label?: Maybe<Scalars["String"]>;
  primary: Scalars["String"];
  selected: Scalars["Boolean"];
  /** @deprecated DO NOT USE. Will be removed. */
  selections?: Maybe<Array<ActivitySelectedValue>>;
};

/** Pills displayed on the page. */
export type ActivityPills = {
  __typename?: "ActivityPills";
  /** Filter pills to displayed */
  appliedFilters: Array<ShoppingSortAndFilterAppliedFilter>;
  /**
   * This property would be used by clients when displaying on screens with larger width.
   * It will contain a longer text to be displayed beside applied filter pills. Example \"Clear all filters\"")
   */
  clearAll?: Maybe<UiTertiaryButton>;
};

export type ActivityPoiGroup = {
  __typename?: "ActivityPoiGroup";
  /** Activities returned from the search associated to Point of Interest */
  activitiesGroup?: Maybe<ActivityGroup>;
  /** Point of Interest returned from the search */
  poiTile: ActivityPoiTile;
};

/** Tile with Point of Interest data */
export type ActivityPoiTile = {
  __typename?: "ActivityPoiTile";
  /** Description of Point of Interest */
  description: Scalars["String"];
  /** Click Action for anchored text on Tile. Example: 'Learn more' anchor text */
  detailsLink?: Maybe<ActivityAnchoredMessage>;
  /** List of Point of Interest Images */
  medias: Array<Media>;
  /** Name of Point of Interest */
  title: Scalars["String"];
};

/** Activity details in points */
export type ActivityPointsToRemember = {
  __typename?: "ActivityPointsToRemember";
  /** Controls how a expanded link should appear */
  expando?: Maybe<ActivityExpando>;
  /** heading or identification of details */
  heading: Scalars["String"];
  /** Graphic/Icon for Heading in Points To remember */
  headingGraphic?: Maybe<UiGraphic>;
  /** Details as bullet points */
  items: Array<Scalars["String"]>;
  /** identifier of details */
  key: Scalars["String"];
  /** ref id of the section for tab navigation */
  sectionRef?: Maybe<Scalars["String"]>;
  /** Link to a Section Ref */
  sectionRefLink?: Maybe<ActivityRefClickAction>;
  /** Structured item list with Icon */
  structuredItems: Array<ActivityIcon>;
};

/** Click action for a popup message usually from `ActivityAnchoredMessage`. */
export type ActivityPopupClickAction = ActivityClickAction & {
  __typename?: "ActivityPopupClickAction";
  accessibilityText: Scalars["String"];
  analytics?: Maybe<ActivityAnalytics>;
  clientSideAnalytics: ClientSideAnalytics;
  /** Action(eg: button behavior for popup/toggle) */
  dismissAction?: Maybe<ActivityMessagingAction>;
  /** List of text messages */
  messages: Array<Scalars["String"]>;
  /**
   * Text for the expanded section
   * @deprecated use messages instead
   */
  text: Scalars["String"];
  /** Title of expanded section */
  title?: Maybe<Scalars["String"]>;
};

/** Activity Contextual information required to render feature icons, error/info banners, etc. */
export type ActivityPresentation = {
  __typename?: "ActivityPresentation";
  /** banner for error, shop-with-points */
  banners: Array<ActivityBanner>;
  /** Details of activity highlights, exclusions, inclusions, highlights, cleanliness etc */
  detailsSectionGroups: Array<ActivitySectionGroup>;
  /** Activity features with icon, like features-animal, duration, free-cancel, etc. */
  features?: Maybe<Array<ActivityIcon>>;
  /** contains legal disclaimer message to be displayed */
  legalDisclaimer?: Maybe<ActivityBanner>;
  /** contains localisation disclaimer message and actions */
  localisationDisclaimer?: Maybe<ActivityBanner>;
  /** loyaltyPoints value used to calculate final offer price */
  loyaltyPointsValue?: Maybe<Money>;
  /** Additional Details like Content for specific activity types like 3P, in form of heading and body/description at end of the page */
  partnerProvidedDetails?: Maybe<Array<ActivityPartnerProvidedDetails>>;
  /**
   * Details of activity exclusions, inclusions, highlights, etc.
   * @deprecated Use detailsSectionGroup instead
   */
  pointsToRemember: Array<ActivityPointsToRemember>;
  /** Addon Promotion module or Login Module */
  promotionMessage?: Maybe<ActivityPromotion>;
  /** map depicting activity event & redemption location */
  staticMap?: Maybe<Scalars["URL"]>;
  /** browser title of activity */
  title: Scalars["String"];
};

export type ActivityPrice = {
  __typename?: "ActivityPrice";
  /** lead or retail price  */
  lead: Money;
  /** strike-out or reference price */
  strikeOut?: Maybe<Money>;
};

/** Pricing info display using `UitkPriceLockup`. Commonly used on activity cards, offer tickets, and details page overview section. */
export type ActivityPriceDisplay = {
  __typename?: "ActivityPriceDisplay";
  /** Disclaimer message dialog. */
  disclaimer?: Maybe<ActivityDisclaimerDialog>;
  /** Enriched text for messages below `UitkPriceLockup` component. */
  footer?: Maybe<Array<EgdsText>>;
  /** Enriched text for messages above `UitkPriceLockup` component. */
  header?: Maybe<Array<EgdsText>>;
  /** Price lockup of activity. */
  priceLockup?: Maybe<EgdsPriceLockup>;
};

export type ActivityPriceMetadata = {
  __typename?: "ActivityPriceMetadata";
  /** localized discount percent for this activity price */
  discountPercent: Scalars["String"];
  /** type of discount available for this activity price */
  discountType: ActivityDiscountType;
};

/** Activity Price types */
export type ActivityPriceType = "GROUP" | "NORMAL" | "VOLUME_BASED";

export type ActivityPromotion = {
  __typename?: "ActivityPromotion";
  /** @deprecated Use clickAction instead */
  action?: Maybe<ActivityPromotionDetailsAction>;
  /** impression tracking */
  analytics?: Maybe<ActivityAnalytics>;
  /** click/action buttons that the message should include */
  clickAction?: Maybe<ActivityMessageAction>;
  /** icon to be shown in the banner */
  icon: Icon;
  /** mark to be shown in the banner */
  mark?: Maybe<Mark>;
  /** Sub-title of message, optional */
  subtitle?: Maybe<Scalars["String"]>;
  /** Primary title of message */
  title: Scalars["String"];
  /** type of message, like addon or sign-up */
  type: ActivityMessageType;
};

export type ActivityPromotionDetailsAction = {
  __typename?: "ActivityPromotionDetailsAction";
  /** primary clickable/action button */
  primary: ActivityDetailsMessagingAction;
  /** secondary/optional clickable/action button */
  secondary?: Maybe<ActivityDetailsMessagingAction>;
};

/** Dialog to display selectable radio options. */
export type ActivityRadioGroupDialog = ActivityDialog & {
  __typename?: "ActivityRadioGroupDialog";
  /** Fullscreen dialog. */
  dialog: EgdsFullScreenDialog;
  /** Done button to select option and close dialog. */
  doneButton: UiPrimaryButton;
  /** Dialog heading. */
  heading?: Maybe<EgdsHeading>;
  /** Radio group of selectable options. */
  radioGroup: EgdsBasicRadioGroup;
  trigger: ActivityDialogTrigger;
};

export type ActivityRecommendation = {
  __typename?: "ActivityRecommendation";
  activities: Array<Activity>;
  /** title of the recommendation module */
  title: Scalars["String"];
};

export type ActivityRecommendationDetails = {
  __typename?: "ActivityRecommendationDetails";
  /** This field is needed to control whether the filter option would be enabled or not on the UI. */
  enabled: Scalars["Boolean"];
  /** view model of category */
  formatted: Icon;
  /** This option was selected in the search criteria. This allows for features like checkbox */
  isSelected: Scalars["Boolean"];
  /** category key to process filtering */
  raw: Scalars["String"];
  /** count of activities associates with this category in search results */
  size: FormattedNumber;
};

/** Recommendations component UI model. */
export type ActivityRecommendationsComponent = {
  __typename?: "ActivityRecommendationsComponent";
  /** A recommendation carousel */
  carousel: ActivityCarouselContainer;
  /** Component heading. */
  heading?: Maybe<EgdsHeading>;
};

export type ActivityRedemption = {
  __typename?: "ActivityRedemption";
  /** Geo-coordinates of activity redemption points */
  locations?: Maybe<Array<Coordinates>>;
  /** Suggests how user can redeem activity */
  type?: Maybe<ActivityRedemptionType>;
};

export type ActivityRedemptionType = "PRINT" | "VOUCHER_LESS";

/** Click action for a link to a section ref. */
export type ActivityRefClickAction = ActivityClickAction & {
  __typename?: "ActivityRefClickAction";
  accessibilityText: Scalars["String"];
  analytics?: Maybe<ActivityAnalytics>;
  clientSideAnalytics: ClientSideAnalytics;
  /** Text for the expanded section */
  label: Scalars["String"];
  /** Section Ref of the target */
  sectionRef: Scalars["String"];
};

/** Activity search region information */
export type ActivityRegion = {
  __typename?: "ActivityRegion";
  /** Full name of the region, used for exact resolution */
  fullRegionName?: Maybe<Scalars["String"]>;
  /** Gaia region ID of the search */
  regionId: Scalars["String"];
  /** Name of the region, used for fuzzy resolution */
  regionName?: Maybe<Scalars["String"]>;
};

/** User interaction on an element to remove offers associated to an activity from the trip */
export type ActivityRemoveOffersFromTripAction = UiAction & {
  __typename?: "ActivityRemoveOffersFromTripAction";
  accessibility?: Maybe<Scalars["String"]>;
  analytics: ClientSideAnalytics;
  /** Messages corresponding to remove offers from trip callbacks */
  callbackMessages?: Maybe<ActivityActionCallbackMessages>;
  /** Set of natural keys used to retrieve details about offers of an activity that are to be removed from the trip */
  offerNaturalKeys: Array<ActivityOfferNaturalKey>;
};

export type ActivityReview = {
  __typename?: "ActivityReview";
  /**
   * Date and time review was avaity was availed
   * @deprecated use formattedActivityDate instead
   */
  activityDate?: Maybe<DateTime>;
  /** Reviewer name, provided by user */
  author?: Maybe<Scalars["String"]>;
  /** Expando to collapse/expand large review text */
  expando?: Maybe<EgdsExpando>;
  /** Localized text that displays Activity Date and time eg: 'Activity date: Oct 26, 2019' */
  formattedActivityDate?: Maybe<Scalars["String"]>;
  /** Localized text that displays Date and time when review was submitted eg: May 9, 2021 */
  formattedSubmissionDate?: Maybe<Scalars["String"]>;
  /** The number of people that found the review useful with suggested icon */
  helpfulVotes: ActivityReviewHelpfulVote;
  /** Unique identifier for a review */
  id: Scalars["String"];
  /**
   * Locale that this review is written in
   * @deprecated Not being queried or used
   */
  locale: Scalars["Locale"];
  /**
   * Overall rating provided by user (out of 5)
   * @deprecated Use overallRatingMessage instead
   */
  overallRating: FormattedNumber;
  /**
   * Rating of an activity like 4.0/5
   * @deprecated Use overallScoreMessage instead
   */
  overallRatingMessage?: Maybe<Scalars["String"]>;
  /** Rating of an activity like 4.0/5 */
  overallScoreMessage?: Maybe<EgdsText>;
  /** Localized text that displays the review source for this comment eg: Reviewed on Expedia/Viator */
  reviewedOn?: Maybe<Scalars["String"]>;
  /**
   * Date and time review was submitted
   * @deprecated Use formattedSubmissionDate instead
   */
  submissionDate?: Maybe<DateTime>;
  /** User provided localized review content */
  text: Scalars["String"];
  /** Reviewer location, provided by user */
  userLocation?: Maybe<Scalars["String"]>;
};

/** Dialog to show reviews. */
export type ActivityReviewCommentsDialog = ActivityDialog & {
  __typename?: "ActivityReviewCommentsDialog";
  /** Selected activity ID - to be used to make activity reviews query */
  activityId: Scalars["String"];
  /** A fullscreen dialog to display all reviews */
  dialog: EgdsFullScreenDialog;
  trigger: ActivityDialogTrigger;
};

export type ActivityReviewDetailsComponent = ActivityReviewsComponent & {
  __typename?: "ActivityReviewDetailsComponent";
  comments: Array<ActivityReview>;
  /** Trigger to open See all reviews dialog */
  seeAllButton?: Maybe<ActivityReviewCommentsDialog>;
  sortTabs?: Maybe<ActivityTabbedNavigationBar>;
  summary?: Maybe<ActivityReviewsSummary>;
};

export type ActivityReviewHelpfulVote = {
  __typename?: "ActivityReviewHelpfulVote";
  /** count of helpful votes */
  count: Scalars["Int"];
  /** depictions icon, e.g. thumbs up */
  icon: Icon;
  message: Scalars["String"];
};

export type ActivityReviewListComponent = ActivityReviewsComponent & {
  __typename?: "ActivityReviewListComponent";
  comments: Array<ActivityReview>;
  /** Button to load more paginated reviews */
  moreButton?: Maybe<ActivityReviewsPaginationButton>;
  sortTabs?: Maybe<ActivityTabbedNavigationBar>;
  summary?: Maybe<ActivityReviewsSummary>;
};

export type ActivityReviewSort = "HIGHEST_TO_LOWEST_RATED" | "LOWEST_TO_HIGHEST_RATED" | "NEWEST_TO_OLDEST";

export interface ActivityReviewsComponent {
  /** Customer review comments for the activity */
  comments: Array<ActivityReview>;
  /** Tabs information for sorting reviews */
  sortTabs?: Maybe<ActivityTabbedNavigationBar>;
  /** Customer review summary information */
  summary?: Maybe<ActivityReviewsSummary>;
}

/** Activity reviews information */
export type ActivityReviewsInfo = {
  __typename?: "ActivityReviewsInfo";
  /**
   * Customer review comments for the activity
   * @deprecated Use reviewsComponent instead
   */
  comments: Array<ActivityReview>;
  /** Reviews Detail Component comprising of summary, comments, sort tabs and see all reviews button */
  reviewsComponent?: Maybe<ActivityReviewDetailsComponent>;
  /** Reviews List Component comprising of summary, comments, sort tabs and Show more button */
  reviewsDialog?: Maybe<ActivityReviewListComponent>;
  /** Review scores information */
  scores?: Maybe<Array<EgdsProgressBar>>;
  /**
   * A button with formatted display text eg: More Reviews
   * @deprecated Use reviewsComponent instead
   */
  showMoreButton?: Maybe<EgdsButton>;
  /**
   * Tabs information for sorting reviews
   * @deprecated Use reviewsComponent instead
   */
  sortTabs?: Maybe<ActivityTabbedNavigationBar>;
  /**
   * Customer review summary information
   * @deprecated Use reviewsComponent instead
   */
  summary?: Maybe<ActivityReviewsSummary>;
};

export type ActivityReviewsPaginationButton = {
  __typename?: "ActivityReviewsPaginationButton";
  action: ActivityPaginationInfoAction;
  button: EgdsButton;
};

export type ActivityReviewsSummary = {
  __typename?: "ActivityReviewsSummary";
  /** Average review score of an activity on the scale of 5 */
  averageScore: EgdsText;
  /** block webcrawler from accessing review */
  blockWebCrawlersEnabled: Scalars["Boolean"];
  /** Verified reviews disclaimer with popup. */
  disclaimer?: Maybe<ActivityDisclaimerDialog>;
  /**
   * Indicates if the review is from External source
   * @deprecated use `blockWebCrawlersEnabled`
   */
  isExternalSource: Scalars["Boolean"];
  /** Message to display the total number of reviews, with a click trigger to display a fullscreen dialog with all reviews */
  reviewCommentsDialog?: Maybe<ActivityReviewCommentsDialog>;
  /**
   * total reviews available for this activity as message to display
   * @deprecated use disclaimer instead
   */
  reviewCountMessage?: Maybe<Scalars["String"]>;
  /**
   * Accessibility text for reviewRating. Like `4 out of 5`
   * @deprecated use accessibility from averageScore EGDSHeading instead
   */
  reviewRatingAccessibilityText?: Maybe<Scalars["String"]>;
  /**
   * Rating of an activity like 4.0/5
   * @deprecated use averageScore instead
   */
  reviewRatingMessage?: Maybe<Scalars["String"]>;
  /**
   * The base of review score: out of 5
   * @deprecated Not used anymore per latest Figma: https://www.figma.com/file/m6CNLA6nNaaAHBzIY9dvOg/PDP-optimization?node-id=8132%3A294377
   */
  reviewScoreBase?: Maybe<EgdsText>;
  /**
   * Average review score of an activity on the scale of 5
   * @deprecated use averageScore instead
   */
  score: FormattedNumber;
  /** ref id of the section for tab navigation */
  sectionRef?: Maybe<Scalars["String"]>;
  /** Source of review rating provided */
  source?: Maybe<Scalars["String"]>;
  /**
   * Total number of reviews for an activity
   * @deprecated use disclaimer instead
   */
  total: Scalars["String"];
  /**
   * Verified reviews disclaimer with popup.
   * @deprecated use disclaimer instead
   */
  verifiedReviewsMessage?: Maybe<ActivityAnchoredMessage>;
};

/** SMS action in share menu on activity detail page navigation bar */
export type ActivitySmsAction = ActivityNavigationBarClickAction & {
  __typename?: "ActivitySMSAction";
  accessibilityText: Scalars["String"];
  analytics: ClientSideAnalytics;
  /** SMS body */
  smsBody: Scalars["String"];
};

export type ActivitySearchByKeywordTile = {
  __typename?: "ActivitySearchByKeywordTile";
  /** The presence of this field indicates that client side interaction like keyword entered should be tracked. */
  analytics?: Maybe<ActivityAnalytics>;
  /** This is for tracking when the keyword is cleared */
  clearAnalytics?: Maybe<ActivityAnalytics>;
  dismiss?: Maybe<Icon>;
  icon?: Maybe<Icon>;
  /** Default placeholder. For eg: Enter a keyword */
  placeholder?: Maybe<Scalars["String"]>;
  /** Search term used for filtering  */
  searchTerm?: Maybe<Scalars["String"]>;
};

export type ActivitySearchFeature = {
  __typename?: "ActivitySearchFeature";
  /**
   * Activity has enhanced cleaning facilities available
   * @deprecated Use enhancedCleaningFeature instead
   */
  enhancedCleaning?: Maybe<ActivityIcon>;
  /** Activity has enhanced cleaning facilities available */
  enhancedCleaningFeature?: Maybe<EgdsText>;
  /**
   * Activity is free cancelable or non cancellable
   * @deprecated Use freeCancellationFeature instead
   */
  freeCancellation?: Maybe<ActivityFreeCancellation>;
  /** Activity is free cancelable or non cancellable */
  freeCancellationFeature?: Maybe<EgdsText>;
  /** Activity has hotel pickup available */
  hotelPickup?: Maybe<ActivityIcon>;
  /** Activity likely to sell out urgency message on SRP tile */
  likelyToSellOut?: Maybe<ActivityLikelyToSellOut>;
  /** Loyalty earn awards of each ticket */
  loyaltyEarnAwards?: Maybe<ActivityIcon>;
  /** Activity pinned tile top/bottom messages on SRP for SEM traffic */
  pinnedTopBottom?: Maybe<Pinned>;
  /** Activity having MIP/MOD promotion available */
  promotion?: Maybe<Icon>;
  /** Details related to selected offer to replay on card. eg: start date and start time */
  selectedOfferDetails?: Maybe<Array<EgdsText>>;
  /** Activity travel distance from hotel to any activity eg:5 km away */
  travelDistance?: Maybe<ActivityTravelDistance>;
  /**
   * Activity travel duration from hotel or airport eg:5 min walk, 10 min drive
   * @deprecated Use travelDistance
   */
  travelDuration?: Maybe<ActivityTravelDuration>;
  /** suggests activity available with volume/group price */
  volumePricing?: Maybe<Icon>;
};

/** Activity search filtering options */
export interface ActivitySearchFiltersInput {
  /** Filter results by user selected activity id from ESS activity Typeahead Suggestions. */
  activityId?: InputMaybe<Scalars["String"]>;
  /** Filter results by activity category, supported with legacy categories */
  categories?: InputMaybe<Array<ActivityCategory>>;
  /** Filter results by activity category keys, supported with nested categories */
  categoryKeys?: InputMaybe<Array<Scalars["String"]>>;
  /** Filter results by user provided free text search keyword */
  keyword?: InputMaybe<Scalars["String"]>;
  /** Filter results by user regionId to support neighborhood filters */
  regionId?: InputMaybe<Scalars["String"]>;
  /**
   * Value selected by the user
   *     E.g.
   *     1. 'sort':'RECOMMENDED'
   *     2. 'slimSearchKeyword':'<KEYWORD ENTERED BY USER>'
   *     4. 'categories': 'ToursSightseeing'
   */
  selections?: InputMaybe<Array<ActivitySelectedValueInput>>;
}

/** Represents the activity search form */
export type ActivitySearchForm = EgdsElement &
  EgdsSearchForm & {
    __typename?: "ActivitySearchForm";
    actionURL: Scalars["String"];
    activitySearchFormInputIds: ActivitySearchFormInputIds;
    egdsElementId?: Maybe<Scalars["String"]>;
    elements: Array<EgdsSearchFormElement>;
    errorSummary?: Maybe<EgdsErrorSummary>;
    playback?: Maybe<EgdsSearchPlayback>;
    search?: Maybe<EgdsButton>;
  };

/** Activity search form input ids that correspond to EGDS elements that clients need to send in the query for activity search */
export type ActivitySearchFormInputIds = {
  __typename?: "ActivitySearchFormInputIds";
  dateRangeInputId: Scalars["String"];
  destinationInputId: Scalars["String"];
};

/** The map information for the properties returned */
export type ActivitySearchMap = {
  __typename?: "ActivitySearchMap";
  /** Returns the center coordinates of the map */
  center: Coordinates;
  /** Returns the title of the map */
  name: Scalars["String"];
  /** Returns the static map url */
  staticMap?: Maybe<Scalars["URL"]>;
  /** Returns the zoom level of the map */
  zoom: Scalars["Int"];
};

/** Search options that are not filters */
export type ActivitySearchOptions =
  | "CATEGORY"
  | "FILTER_NESTED_CATEGORIES"
  | "GAIA_RETURN_ADDITIONAL_DISTANCE_PARAMETER"
  | "GIFTING_ACTIVITIES"
  | "GUEST_PROMO"
  | "NON_CONSOLIDATED_OFFERS"
  | "SHOP_WITH_POINTS"
  | "SHOW_GT_BANNER";

export type ActivitySearchResults = {
  __typename?: "ActivitySearchResults";
  /** Activities returned from the search, sorted in the order specified or in default recommended order */
  activities: Array<Activity>;
  /** Activity groups returned for destination page */
  activityGroups: Array<ActivityGroup>;
  /** The map information for the activities returned */
  map?: Maybe<ActivitySearchMap>;
  /** Insights about search results such as resolved-location, validated dates, activity count */
  searchSummary: ActivitySearchSummary;
  /**
   * Sort And Filter Selected Options, Defaults if necessary, and display options
   * @deprecated Use universalSortAndFilter which is EGDS compliant
   */
  sortAndFilter: ActivitySortAndFilter;
  /** UIS Prime user interactions messages to be logged from client side */
  uisPayload: Scalars["String"];
  /** EGDS Universal Sort And Filter */
  universalSortAndFilter?: Maybe<ShoppingSortAndFilters>;
};

export type ActivitySearchResultsActivityGroupsArgs = {
  types?: InputMaybe<Array<ActivityGroupType>>;
};

export type ActivitySearchResultsMapArgs = {
  type?: InputMaybe<ActivityMapGroupType>;
};

export type ActivitySearchSummary = {
  __typename?: "ActivitySearchSummary";
  /** ATF pills, banners, messages */
  aboveTheFold?: Maybe<ActivityAboveTheFold>;
  /** The count of activities after applying filters (but not pagination) */
  activitySize: Scalars["Int"];
  /** Details for date validation results suggesting if search dates are adjusted/updated to retrieve results */
  dateValidationResult?: Maybe<DateValidationResult>;
  /** The count of activities in the searched location without applying any filter */
  marketSize: Scalars["Int"];
  /** Messaging results which can contain loyalty message, urgency message, or campaign message */
  messages?: Maybe<Array<ActivityMessageResult>>;
  /** heading representing the search results */
  pageHeading?: Maybe<Scalars["String"]>;
  /** The Activity page view info about the page rendered like Des, Cat, SR */
  pageInfo: ActivityPage;
  /** Pagination info for search results list */
  paginationInfo?: Maybe<ActivityPaginationInfo>;
  /** Details region resolved from search-query for returning activities */
  resolvedRegion?: Maybe<ActivityRegion>;
};

export type ActivitySearchTicket = {
  __typename?: "ActivitySearchTicket";
  /** Ticket code for supply, e.g. [Adult], [Adult_1103] */
  code?: Maybe<Scalars["String"]>;
  /** Localized ticket label for ticket one ticket, e.g. [per Adult], [par voyageur] */
  label?: Maybe<Scalars["String"]>;
  /** Legal disclaimer on strike through price */
  legalDisclaimer?: Maybe<ActivityAnchoredMessage>;
  /** Loyalty points option for points display */
  loyaltyPointsOption?: Maybe<ActivityLoyaltyPointsOption>;
  /** Lead price of activity */
  price?: Maybe<ActivityPrice>;
  /** Accessibility text for pricing reader */
  priceAccessibilityText?: Maybe<Scalars["String"]>;
  /** Localized explanatory message for taxes and fees */
  taxesAndFeesMessage?: Maybe<Scalars["String"]>;
  /** Localized ticket type for display, e.g. [adult], [voyageur] */
  type?: Maybe<Scalars["String"]>;
};

/** Search view options that are not filters */
export type ActivitySearchViewOptions =
  | "DISTANCE_FROM_HOTEL_TO_ACTIVITY"
  | "FILTER_NESTED_CATEGORIES"
  | "NEARBY_ACTIVITIES"
  | "SHOP_WITH_POINTS"
  | "SHOW_GT_BANNER"
  | "THIRD_PARTY_REVIEWS"
  | "TRAVEL_DISTANCE_FROM_HOTEL";

/** section containing information about an individual heading */
export type ActivitySection = {
  __typename?: "ActivitySection";
  /** heading or identification of section */
  heading: Scalars["String"];
  /** Graphic/Icon for Heading */
  headingGraphic?: Maybe<UiGraphic>;
  /** Link to a Section Ref */
  sectionRefLink?: Maybe<ActivityRefClickAction>;
  /** structured item list with Icon */
  structuredItems: Array<ActivityIcon>;
};

/** content on details page */
export type ActivitySectionGroup = {
  __typename?: "ActivitySectionGroup";
  /** footer of details */
  footer?: Maybe<Scalars["String"]>;
  /** heading or identification of details */
  heading: Scalars["String"];
  /** ref id of the section for navigation */
  sectionRef?: Maybe<Scalars["String"]>;
  /** sections containing information about an individual heading */
  sections: Array<ActivitySection>;
};

export type ActivitySelectableFilterOption = ActivitySortAndFilterOption & {
  __typename?: "ActivitySelectableFilterOption";
  /** The presence of this field indicates that client side interactions such as `click` should be tracked. */
  analytics?: Maybe<ActivitySortAndFilterAnalytics>;
  /** This field is needed to control whether the filter option would be enabled or not on the UI. */
  enabled: Scalars["Boolean"];
  /** Eventual UDS icon to apply alongside the primarys. */
  icon?: Maybe<Icon>;
  /** Allow to add nested options for category/subcategory combo. */
  nestedOptions?: Maybe<Array<ActivitySelectableFilterOption>>;
  /** Primary text/label to show for the option */
  primary: Scalars["String"];
  /** Used to inform the customer about extra information for this option. E.g. Options is `Early Morning` and secondary text for that is 12AM-6AM */
  secondary?: Maybe<Scalars["String"]>;
  /** Would be true is this option has been selected before or is acting a default value. */
  selected: Scalars["Boolean"];
  /** Technical representation of the selectable option. E.g. `recommendations` as `Family Friendly`. Basically used as key for this option, to be passed to bex-api as query input */
  value: Scalars["String"];
};

export type ActivitySelectedValue = {
  __typename?: "ActivitySelectedValue";
  id: Scalars["String"];
  value: Scalars["String"];
};

export interface ActivitySelectedValueInput {
  id: Scalars["String"];
  value: Scalars["String"];
}

/** Click action with a list of id-value selections usually in `ActivityMessageTile`. */
export type ActivitySelectionClickAction = ActivityClickAction & {
  __typename?: "ActivitySelectionClickAction";
  accessibilityText: Scalars["String"];
  analytics?: Maybe<ActivityAnalytics>;
  clientSideAnalytics: ClientSideAnalytics;
  /** List of key selection used for filtering */
  selectionList?: Maybe<Array<ActivitySelectedValue>>;
};

export type ActivitySelectionField = ActivitySortAndFilterField & {
  __typename?: "ActivitySelectionField";
  /** Identifier used for any selectable sort or filter option. E.g. `categories`, `sort`. Provided by bex-api and needs to be passed as is to `selections` in input */
  id: Scalars["String"];
  /** Example: Let's say there's a field for `Time` in FilterBy section. `Time` has multiple options - 11AM, 12PM etc. */
  label?: Maybe<Scalars["String"]>;
  /** List of selectable options for the field */
  options: Array<ActivitySelectableFilterOption>;
  /** New type representing the UDS component (radio, slider, button toggle, checkbox, etc.) */
  udsToken: ActivityUdsToken;
};

export type ActivitySeoContent = {
  __typename?: "ActivitySeoContent";
  /** Canonical url of the page */
  canonicalUrl?: Maybe<HttpUri>;
  /** Hreflang links */
  hreflangLinks: Array<ActivityPageHrefLangLink>;
  /** Meta attributes of the page */
  metaTags: Array<ActivityPageSeoMetaTag>;
  /** Title of the page */
  title?: Maybe<Scalars["String"]>;
};

export type ActivityShortlistingMessages = {
  __typename?: "ActivityShortlistingMessages";
  /** focus message for the favorite icon when saved */
  removeFocusText?: Maybe<Scalars["String"]>;
  /** remove message on click of the favorite icon */
  removeText?: Maybe<Scalars["String"]>;
  /** focus message for the favorite icon when unsaved */
  saveFocusText?: Maybe<Scalars["String"]>;
  /** save message on click of the favorite icon */
  saveText?: Maybe<Scalars["String"]>;
};

/** Activity sort types */
export type ActivitySort =
  | "CAMPAIGN_DEALS"
  | "DISTANCE_FROM_HOTEL"
  | "PRICE_HIGH_TO_LOW"
  | "PRICE_LOW_TO_HIGH"
  | "RECOMMENDED";

/** sort and filter display view details over raw activity search results */
export type ActivitySortAndFilter = {
  __typename?: "ActivitySortAndFilter";
  appliedFilterCount?: Maybe<Scalars["Int"]>;
  /**
   * category-wise filter display options over raw activity search results
   * @deprecated use sortAndFilterSections now as it's a more generic and powerful schema
   */
  categoryFilterOptions?: Maybe<Array<CategoryFilterViewModel>>;
  clearButtonTitle?: Maybe<Scalars["String"]>;
  closeIcon?: Maybe<Icon>;
  /** default sort for activity search results */
  defaultSort?: Maybe<ActivitySort>;
  /**
   * recommendation-wise filter display options over raw activity search results
   * @deprecated use sortAndFilterSections now as it's a more generic and powerful schema
   */
  recommendationFilterOptions?: Maybe<Array<ActivityRecommendationDetails>>;
  /**
   * Ordered list of sort options
   * @deprecated use sortAndFilterSections now as it's a more generic and powerful schema
   */
  sort: Array<ActivitySortViewModel>;
  /** The section reflects the main search parameters like: recommendations, keywords, categories */
  sortAndFilterSections: Array<ActivitySortAndFilterSection>;
  title: Scalars["String"];
};

export type ActivitySortAndFilterAnalytics = {
  __typename?: "ActivitySortAndFilterAnalytics";
  /** link attached to any event */
  linkName: Scalars["String"];
  /** rfrr to be used with track call for any event */
  referrerId: Scalars["String"];
};

export interface ActivitySortAndFilterField {
  /** Identifier used for any selectable sort or filter option. E.g. `keyword`, `sort`. Provided by bex-api and needs to be passed as is to `selections` in input */
  id: Scalars["String"];
  /** Example: Property class, Stops, Your budget, Departure time */
  label?: Maybe<Scalars["String"]>;
  /** New type representing the UDS component (radio, slider, button toggle, checkbox, etc.) */
  udsToken: ActivityUdsToken;
}

export interface ActivitySortAndFilterOption {
  /** The presence of this field indicates that client side interactions such as `click` should be tracked. */
  analytics?: Maybe<ActivitySortAndFilterAnalytics>;
  /** Eventual UDS icon to apply alongside the primarys. */
  icon?: Maybe<Icon>;
  /** Primary textual representation. E.g. `Price`, `Nonstop`, `Tour & sightseeing` */
  primary: Scalars["String"];
  /** Used to inform the customer about extra information for this option. E.g. For instance the minimum price for traveler */
  secondary?: Maybe<Scalars["String"]>;
}

export type ActivitySortAndFilterSection = {
  __typename?: "ActivitySortAndFilterSection";
  /** Icon type to provide a way for removing applied sort or filter option */
  dismiss?: Maybe<Icon>;
  /** Represents the required details for sort & filter. For example: `Sort by`, `Search by activity name`, `Recommendation` */
  fields?: Maybe<Array<ActivitySortAndFilterField>>;
  /** Text describing what the section is about. For example: `Sort by`, `Search by activity name`, `Recommendation` ... */
  title?: Maybe<Scalars["String"]>;
};

/** Ordered list of sort options */
export type ActivitySortViewModel = {
  __typename?: "ActivitySortViewModel";
  /** localised name of sort option */
  formatted: Scalars["String"];
  /** key value used to get the sort order from domain API */
  raw: ActivitySort;
  /** is the sort option shown as selected on pageload */
  selected: Scalars["Boolean"];
};

/** Static details card with a heading and card content. */
export type ActivityStaticDetailsCard = {
  __typename?: "ActivityStaticDetailsCard";
  /** Card content item(s). */
  content: Array<ActivityCardContent>;
  /** Heading of the static details card. */
  heading: EgdsHeading;
  /** Ref id of the section for navigation */
  sectionRef?: Maybe<Scalars["String"]>;
};

/** Static details of an activity, e.g. inclusions/exclusions, cleanliness practices, and location card. */
export type ActivityStaticDetailsComponent = {
  __typename?: "ActivityStaticDetailsComponent";
  /** Rows of the static details component. */
  sections: Array<ActivityStaticDetailsSection>;
};

/** Contents of the activity static detail card */
export type ActivityStaticDetailsSection = ActivityItineraryCard | ActivityLocationCard | ActivityStaticDetailsCard;

export type ActivitySubMenu = EgdsSubMenu & {
  __typename?: "ActivitySubMenu";
  items: Array<EgdsMenuListItem>;
  title?: Maybe<Scalars["String"]>;
};

/** Activity sub menu item with click action field */
export type ActivitySubMenuItem = EgdsMenuListItem & {
  __typename?: "ActivitySubMenuItem";
  accessibility?: Maybe<Scalars["String"]>;
  /** Click action for each menu item */
  action?: Maybe<ActivityNavigationBarClickAction>;
  analytics?: Maybe<ClientSideAnalytics>;
  /** Icon for each menu item */
  icon?: Maybe<Icon>;
  title: Scalars["String"];
};

/** Activity presentation tab navigation bar */
export type ActivityTabbedNavigationBar = {
  __typename?: "ActivityTabbedNavigationBar";
  /** heading of tab section */
  heading?: Maybe<Scalars["String"]>;
  /** tabs present in the bar */
  tabs: Array<NavigationTab>;
};

/** Telesales phone number details */
export type ActivityTelesales = {
  __typename?: "ActivityTelesales";
  /** Used for impression tracking */
  analytics?: Maybe<ActivityAnalytics>;
  /** Description for phone number to book over the phone */
  label: Scalars["String"];
  /** The phone number that can be used to book over the phone */
  phoneNumberLink: TelUri;
};

export type ActivityText = {
  __typename?: "ActivityText";
  /** Accessibility label for text */
  accessibilityText?: Maybe<Scalars["String"]>;
  /** Size of the text. */
  size: ActivityTextSize;
  /** Text to be displayed */
  text: Scalars["String"];
};

export type ActivityTextAlignment = "CENTRE" | "LEFT" | "RIGHT";

export type ActivityTextInputSortField = ActivitySortAndFilterField & {
  __typename?: "ActivityTextInputSortField";
  /** Logical identifier associated with what has been typed by the user. The identifier is used when applying the filter. */
  id: Scalars["String"];
  /** Example: `Search for activities` */
  label?: Maybe<Scalars["String"]>;
  /** Default text to display in the input field to guide the user on what information is expected. Example: `Enter activity name` */
  placeholder: Scalars["String"];
  /** Typically represented by a input text element. Default value: InputText */
  udsToken: ActivityUdsToken;
  /** Field to send the keyword (if present) entered by the user for searching activity */
  value: Scalars["String"];
};

export type ActivityTextSize = "LARGE" | "MEDIUM" | "SMALL";

export type ActivityTextTile = {
  __typename?: "ActivityTextTile";
  /**
   * Text to be displayed
   * @deprecated Will rename it 'Text' after cleanup
   */
  activityText?: Maybe<ActivityText>;
  /** alignment of the text */
  alignment: ActivityTextAlignment;
  /** Text to be displayed with click action. */
  anchoredText?: Maybe<ActivityAnchoredMessage>;
  /**
   * Size of the text.
   * @deprecated We use ActivityText now
   */
  size: ActivityTextSize;
  /**
   * Text to be displayed
   * @deprecated We use ActivityText now
   */
  text: Scalars["String"];
};

/** Contains list of themes to filter Activities */
export type ActivityThemeFilter = {
  __typename?: "ActivityThemeFilter";
  themes: Array<Scalars["String"]>;
};

/** A media gallery dialog when triggered */
export type ActivityThumbnailMediaGalleryDialog = ActivityDialog & {
  __typename?: "ActivityThumbnailMediaGalleryDialog";
  /** Contents of media gallery */
  dialog: EgdsBasicThumbnailMediaGallery;
  trigger: ActivityDialogTrigger;
};

export interface ActivityTicketInput {
  code: Scalars["String"];
  count: Scalars["Int"];
}

export type ActivityTile =
  | Activity
  | ActivityActionTile
  | ActivityAssortedComponentsTile
  | ActivityBasicTile
  | ActivityEmptyStateTile
  | ActivityMessageTile
  | ActivitySearchByKeywordTile
  | ActivityTextTile;

export type ActivityTileBadges = {
  __typename?: "ActivityTileBadges";
  /** Primary badge to display on activity tile */
  primary?: Maybe<ActivityBadge>;
  /** Secondary badge to display on activity tile */
  secondary?: Maybe<ActivityBadge>;
};

/** Used for displaying text toggle. For eg: SWP */
export type ActivityToggle = UiToggle & {
  __typename?: "ActivityToggle";
  checked: Scalars["Boolean"];
  checkedAccessibilityLabel: Scalars["String"];
  checkedAnalytics?: Maybe<ClientSideAnalytics>;
  checkedDescription: Scalars["String"];
  checkedLabel: Scalars["String"];
  enabled: Scalars["Boolean"];
  label: Scalars["String"];
  uncheckedAccessibilityLabel: Scalars["String"];
  uncheckedAnalytics?: Maybe<ClientSideAnalytics>;
  uncheckedDescription: Scalars["String"];
  uncheckedLabel: Scalars["String"];
};

export type ActivityTravelDistance = {
  __typename?: "ActivityTravelDistance";
  /** localised value of label to show */
  label?: Maybe<Scalars["String"]>;
};

export type ActivityTravelDuration = {
  __typename?: "ActivityTravelDuration";
  /** localised value of label to show */
  formatted?: Maybe<Scalars["String"]>;
};

/** Details of traveler with a specific age. Age will be used to derive the traveler type in package bookings */
export interface ActivityTravelerDetailsInput {
  /** Age of the traveler. Traveler type(adult/infant/youth) can be derived from age */
  age: Scalars["Int"];
  /** Number of travelers with specified age */
  count: Scalars["Int"];
}

/** Container of traveler information */
export interface ActivityTravelerInfoInput {
  /** number of adults from Hotel PDP */
  numberOfAdults: Scalars["Int"];
  /** number of children from Hotel PDP */
  numberOfChildren: Scalars["Int"];
  /** number of infants from Hotel PDP */
  numberOfInfants: Scalars["Int"];
}

/** Dialog to allow select traveler's count. */
export type ActivityTravelerSelectorDialog = ActivityDialog & {
  __typename?: "ActivityTravelerSelectorDialog";
  /** Full screen dialog for traveler selections. Includes a toolbar with a close icon and dialog title. */
  dialog: EgdsFullScreenDialog;
  /** Button to select travelers count */
  doneButton: UiPrimaryButton;
  /** Heading to be displayed above step input */
  heading?: Maybe<EgdsHeading>;
  /** Traveler tickets step input which will be used for adults, children, infant, seniors count. */
  ticketsStepInput: Array<EgdsTravelerStepInput>;
  /** Trigger to open traveler selector dialog. */
  trigger: ActivityDialogTrigger;
};

/** Actions involved to add, remove and update activity to trip. */
export type ActivityTripUpdateButtons = {
  __typename?: "ActivityTripUpdateButtons";
  /** Button to add activity product to trip */
  addToTrip?: Maybe<EgdsButton>;
  /** Button to remove activity product from trip */
  removeFromTrip?: Maybe<EgdsButton>;
  /** Button to update activity product from trip */
  updateTrip?: Maybe<EgdsButton>;
};

export type ActivityUdsToken = "MULTI_SELECT_LIST" | "MULTI_SELECT_RANGE" | "SINGLE_SELECT" | "TEXT";

/** Input to update the activity in the session */
export interface ActivityUpdateInput {
  newActivity: ActivityNaturalKeyInput;
  oldActivity: ActivityNaturalKeyInput;
}

/** User interaction on an element to update an offer in trip */
export type ActivityUpdateOfferInTripAction = UiAction & {
  __typename?: "ActivityUpdateOfferInTripAction";
  accessibility?: Maybe<Scalars["String"]>;
  analytics: ClientSideAnalytics;
  /** Messages corresponding to update offer in trip callbacks */
  callbackMessages?: Maybe<ActivityActionCallbackMessages>;
  /** Natural key of the updated offer which will be added to trip on update */
  newOfferNaturalKey: ActivityOfferNaturalKey;
  /** Natural key of the old offer which was part of the trip */
  oldOfferNaturalKey: ActivityOfferNaturalKey;
};

export interface AddInsuranceRequestInput {
  /** CountryCode from residency selection of user */
  countryCode?: InputMaybe<Scalars["String"]>;
  /** The user selection for the Insurance product(s) */
  insuranceProductIds: Array<Scalars["String"]>;
  /** RegionCode from residency selection of user */
  regionCode?: InputMaybe<Scalars["String"]>;
  /** The user selection for the Insurance product(s) */
  removeInsuranceProductIds?: InputMaybe<Array<Scalars["String"]>>;
  /** The source id of the persistence store.For example Trip for BEX or Record locator for other systems */
  sourceId: Scalars["String"];
  /** The identifier to get the decoded value of params received in shopping response */
  updateRequestId: Scalars["String"];
}

export interface AddInsuranceRequestOldInput {
  insuranceSearchId: Scalars["String"];
  offerTypeId: Scalars["Int"];
}

export type AddInsuranceResponse = {
  __typename?: "AddInsuranceResponse";
  status: InsuranceMutationStatus;
};

export type AddInsuranceResponseOld = {
  __typename?: "AddInsuranceResponseOld";
  message: InsurancePhrase;
  status: InsuranceMutationStatus;
};

/** Details of the layover */
export type AdditionalInformation = {
  __typename?: "AdditionalInformation";
  /** Time spent on a particular Layover, ex: 1h 10m in Charlotte  */
  durationAndStop: Scalars["String"];
  /**
   * Message to inform user that the next flight departs from a different airport, ex: Next Flight departs from JFQ, not CLT
   * @deprecated This will be replaced by nextFlightOriginAirportInfo
   */
  nextFlightOriginAirport?: Maybe<Scalars["String"]>;
  /** Message to inform user that the next flight departs from a different airport, ex: Next Flight departs from JFQ, not CLT */
  nextFlightOriginAirportInfo?: Maybe<FlightsIconAndLabel>;
};

/** The popover used to display additional information */
export type AdditionalInformationPopover = {
  __typename?: "AdditionalInformationPopover";
  analytics?: Maybe<ClientSideAnalytics>;
  closeLabel?: Maybe<Scalars["String"]>;
  enrichedSecondaries: Array<AdditionalInformationPopoverSection>;
  icon?: Maybe<Icon>;
  id?: Maybe<Scalars["String"]>;
  primary?: Maybe<Scalars["String"]>;
  /** @deprecated Use `enrichedSecondaries` instead. */
  secondaries: Array<Scalars["String"]>;
};

/** Popover section for complex grid type of content */
export type AdditionalInformationPopoverGridSection = {
  __typename?: "AdditionalInformationPopoverGridSection";
  subSections: Array<PricePresentationSubSection>;
};

/** Popover section for lists of content */
export type AdditionalInformationPopoverListSection = {
  __typename?: "AdditionalInformationPopoverListSection";
  content: EgdsList;
};

/** Container interface for wrapping different UI element types for popovers */
export type AdditionalInformationPopoverSection =
  | AdditionalInformationPopoverGridSection
  | AdditionalInformationPopoverListSection
  | AdditionalInformationPopoverTextSection;

/** Popover section for simple text content */
export type AdditionalInformationPopoverTextSection = {
  __typename?: "AdditionalInformationPopoverTextSection";
  text: EgdsText;
};

/** Address type with minimal data required */
export type Address = {
  __typename?: "Address";
  city?: Maybe<Scalars["String"]>;
  country: Scalars["String"];
  firstLine: Scalars["String"];
  province?: Maybe<Scalars["String"]>;
  secondLine?: Maybe<Scalars["String"]>;
  thirdLine?: Maybe<Scalars["String"]>;
  zipCode?: Maybe<Scalars["String"]>;
};

export type AdsTargetingData = {
  __typename?: "AdsTargetingData";
  adProvider: Scalars["String"];
  dateEnd?: Maybe<Scalars["String"]>;
  dateStart?: Maybe<Scalars["String"]>;
  dest?: Maybe<Scalars["String"]>;
  locResolver?: Maybe<Scalars["String"]>;
  origin?: Maybe<Scalars["String"]>;
  pageName: Scalars["String"];
  siteId: Scalars["Int"];
  uuid: Scalars["String"];
};

export type Agency = {
  __typename?: "Agency";
  /** Identifies an agency */
  trackingCode?: Maybe<Scalars["String"]>;
};

export type AgencyAddress = {
  __typename?: "AgencyAddress";
  /** The city of the property address */
  city?: Maybe<Scalars["String"]>;
  /** The country of the property address */
  countryCode?: Maybe<Scalars["String"]>;
  /** The first line of the property address */
  firstAddressLine?: Maybe<Scalars["String"]>;
  /** Whether the location of the property should be displayed */
  obfuscationRequired?: Maybe<Scalars["Boolean"]>;
  /** The postal code of the property address */
  postalCode?: Maybe<Scalars["String"]>;
  /** The code of the state/province of the property address */
  provinceCode?: Maybe<Scalars["String"]>;
  /** The name of the state/province of the property address */
  provinceName?: Maybe<Scalars["String"]>;
  /** The second line of the property address */
  secondAddressLine?: Maybe<Scalars["String"]>;
};

export type AgencyBusinessModel = "EXPEDIA_COLLECT" | "HOTEL_COLLECT";

export type AgencyButtonField = ShoppingSortAndFilterField & {
  __typename?: "AgencyButtonField";
  id: Scalars["String"];
  options?: Maybe<Array<ShoppingSelectableFilterOption>>;
  primary?: Maybe<Scalars["String"]>;
  secondary?: Maybe<Scalars["String"]>;
  type?: Maybe<FacetType>;
};

export type AgencyCheckboxField = ShoppingSortAndFilterField & {
  __typename?: "AgencyCheckboxField";
  id: Scalars["String"];
  options?: Maybe<Array<ShoppingSelectableFilterOption>>;
  primary?: Maybe<Scalars["String"]>;
  secondary?: Maybe<Scalars["String"]>;
  type?: Maybe<FacetType>;
};

export interface AgencyDestinationInput {
  coordinates?: InputMaybe<CoordinatesInput>;
  pinnedPropertyId?: InputMaybe<Scalars["String"]>;
  regionId?: InputMaybe<Scalars["String"]>;
}

export type AgencyDetail = {
  __typename?: "AgencyDetail";
  /** List of all the form fields needed to provide agency information for the quote */
  agencyEntryFields: Array<EgdsInputField>;
  /** Elements needed to show the Agency Logo, including toggle messaging based on logo existence */
  logo: AgencyImage;
};

export type AgencyFees = {
  __typename?: "AgencyFees";
  body?: Maybe<Scalars["String"]>;
  title?: Maybe<Scalars["String"]>;
};

export type AgencyImage = {
  __typename?: "AgencyImage";
  altText?: Maybe<Scalars["String"]>;
  /** Text to show in logo field based on toggle state of the logo */
  logoToggle: UiToggle;
  /** Location from which to pull the Agency Logo */
  url?: Maybe<Uri>;
};

export type AgencyLodgingLink = {
  __typename?: "AgencyLodgingLink";
  /** Easy readable string for accessibility */
  accessibilityLabel?: Maybe<Scalars["String"]>;
  /** The path for the link */
  relativePath?: Maybe<Scalars["String"]>;
};

export type AgencyLogo = {
  __typename?: "AgencyLogo";
  altText?: Maybe<Scalars["String"]>;
  /** Text to show in logo field based on toggle state of the logo */
  logoToggle: UiToggle;
  /** Location from which to pull the Agency Logo */
  url?: Maybe<Uri>;
};

/** The map information for the properties returned */
export type AgencyMapMarker = {
  __typename?: "AgencyMapMarker";
  coordinates?: Maybe<Coordinates>;
  icon?: Maybe<Scalars["String"]>;
  label?: Maybe<Scalars["String"]>;
  type?: Maybe<Scalars["String"]>;
};

export type AgencyMoney = {
  __typename?: "AgencyMoney";
  /** The price amount of the rate */
  amount?: Maybe<Scalars["Float"]>;
  /** The currency associated with the price */
  currencyCode?: Maybe<Scalars["String"]>;
  /** The amount of decimal places to display */
  decimalPlaces?: Maybe<Scalars["Int"]>;
};

export type AgencyOfferSummary = {
  __typename?: "AgencyOfferSummary";
  /** Summary of the availability for the property */
  availability?: Maybe<Scalars["Boolean"]>;
  /** The payment type for the offer indicating who collects payment. i.e. expedia or property */
  paymentType?: Maybe<Scalars["String"]>;
  /** The summary to show for the offer. i.e. Fully Refundable */
  refundableMessage?: Maybe<EgdsStylizedText>;
};

export type AgencyPropertyDetails = {
  __typename?: "AgencyPropertyDetails";
  /** Content related to the property */
  amenities?: Maybe<Amenities>;
  /** HTML describing mandatory and optional fees */
  fees?: Maybe<AgencyPropertyFees>;
  /** general information of the property, eg: cleaning and safety */
  generalInfo: AgencyPropertyInfoContent;
  /** Shows content and rates for offers */
  propertyOffers?: Maybe<PropertyOffers>;
  /** Shows content in the property overview section */
  propertyOverview?: Maybe<AgencyPropertyOverview>;
  /** Information about user and agency */
  userContext?: Maybe<UserContext>;
};

export type AgencyPropertyFees = {
  __typename?: "AgencyPropertyFees";
  mandatory: AgencyFees;
  optional: AgencyFees;
};

/** Information of the room */
export type AgencyPropertyInfo = {
  __typename?: "AgencyPropertyInfo";
  /** The city of the property */
  city: Scalars["String"];
  /** Unique ID of the property */
  id?: Maybe<Scalars["String"]>;
  /** The name of the property */
  name?: Maybe<EgdsHeading>;
};

export type AgencyPropertyInfoContent = {
  __typename?: "AgencyPropertyInfoContent";
  items?: Maybe<Array<AgencyPropertyInfoItem>>;
  title: Scalars["String"];
};

export type AgencyPropertyInfoItem = {
  __typename?: "AgencyPropertyInfoItem";
  id?: Maybe<Scalars["String"]>;
  text?: Maybe<Scalars["String"]>;
};

export type AgencyPropertyOverview = {
  __typename?: "AgencyPropertyOverview";
  /** The rating of the property based on guest reviews */
  guestRating: GuestRating;
  /** The unique ID of the property */
  id?: Maybe<Scalars["String"]>;
  /** The location of the property */
  location: Location;
  /** The name of the property */
  name?: Maybe<Scalars["String"]>;
  /** The photos specific to the property */
  photos?: Maybe<ImageGallery>;
  /** The rating of the property */
  propertyRating: AgencyPropertyRating;
};

export type AgencyPropertyPrice = {
  __typename?: "AgencyPropertyPrice";
  /** Information about commission cost */
  commissionSection?: Maybe<CommissionSection>;
  /** The average nightly pricing to display on the page */
  nightlyPriceOption?: Maybe<AgencyPropertyPriceOption>;
  /** Describes whether this rate is standalone or package */
  packageIndicator?: Maybe<Scalars["String"]>;
  /** Supporting message that can be used to display messages on price */
  priceSupportingMessages?: Maybe<PriceSupportingMessages>;
  /** The total pricing to display on the page */
  totalPriceOption?: Maybe<AgencyPropertyPriceOption>;
};

export type AgencyPropertyPriceOption = {
  __typename?: "AgencyPropertyPriceOption";
  /** The unformatted price with additional information */
  displayPrice?: Maybe<AgencyMoney>;
  /** The formatted price with the currency code and decimal places */
  formattedDisplayPrice?: Maybe<Scalars["String"]>;
};

export type AgencyPropertyRating = {
  __typename?: "AgencyPropertyRating";
  /** The rating given to the property */
  rating?: Maybe<Scalars["String"]>;
  /** The type of rating used */
  type?: Maybe<Scalars["String"]>;
};

export type AgencyPropertyReviewsSummary = {
  __typename?: "AgencyPropertyReviewsSummary";
  /** Easy readable string for accessibility */
  accessibilityLabel?: Maybe<Scalars["String"]>;
  /** The number to show for guest rating */
  guestRating?: Maybe<EgdsStylizedText>;
  /** The count of reviews */
  reviewCount?: Maybe<Scalars["String"]>;
  /** The word used for the rating. e.g. Good, Wonderful, Exception */
  superlative?: Maybe<Scalars["String"]>;
};

export interface AgencyPropertySearch {
  /** Data used to populate maps */
  maps?: Maybe<Maps>;
  /** Information about filters */
  shoppingSortAndFilters?: Maybe<ShoppingSortAndFilters>;
}

export type AgencyPropertySearchFailure = AgencyPropertySearch & {
  __typename?: "AgencyPropertySearchFailure";
  /** The specific information about the property */
  errorMessage: EgdsStylizedText;
  /** Data used to populate maps */
  maps?: Maybe<Maps>;
  /** Information about filters */
  shoppingSortAndFilters?: Maybe<ShoppingSortAndFilters>;
};

export interface AgencyPropertySearchFiltersInput {
  guest_rating?: InputMaybe<Scalars["String"]>;
  payment_and_cancellation?: InputMaybe<Array<Scalars["String"]>>;
  point_of_interest?: InputMaybe<Scalars["String"]>;
  price?: InputMaybe<PriceFilterInput>;
  property_type?: InputMaybe<Array<Scalars["String"]>>;
  star_rating?: InputMaybe<Array<Scalars["String"]>>;
}

export type AgencyPropertySearchListing = {
  __typename?: "AgencyPropertySearchListing";
  /** The main image to show for the property */
  cardGallery?: Maybe<Array<Maybe<CardGallery>>>;
  /** Map marker information for plotting on a map */
  mapMarker?: Maybe<AgencyMapMarker>;
  /** Information about the offer */
  offerSummary?: Maybe<AgencyOfferSummary>;
  /** The price to display on the search page */
  price?: Maybe<AgencyPropertyPrice>;
  /** Link to property details */
  propertyDetailsLink?: Maybe<AgencyLodgingLink>;
  /** Unique ID of the property */
  propertyInfo?: Maybe<AgencyPropertyInfo>;
  /** Property Star Rating */
  propertyStarRating?: Maybe<EgdsIconRating>;
  /** All reviews for the property */
  reviews?: Maybe<AgencyPropertyReviewsSummary>;
  /** Information of the room */
  roomInfo?: Maybe<RoomInfo>;
};

export type AgencyPropertySearchSuccess = AgencyPropertySearch & {
  __typename?: "AgencyPropertySearchSuccess";
  /** Data used to populate maps */
  maps?: Maybe<Maps>;
  /** The specific information about the property */
  propertySearchListings: Array<AgencyPropertySearchListing>;
  /** Information about filters */
  shoppingSortAndFilters?: Maybe<ShoppingSortAndFilters>;
};

export type AgencyPropertyUnitKey = {
  __typename?: "AgencyPropertyUnitKey";
  /** lodging type */
  lodgingType: Scalars["String"];
  /** is it a naked package rate */
  packageRates?: Maybe<Scalars["Boolean"]>;
  /** property destination */
  propertyDestination: Scalars["String"];
  /** property natural key */
  propertyNaturalKey: PropertyNaturalKey;
};

export type AgencyQuoteAction = UiAction & {
  __typename?: "AgencyQuoteAction";
  accessibility?: Maybe<Scalars["String"]>;
  actionIdentifier: Scalars["String"];
  analytics: ClientSideAnalytics;
};

export type AgencyQuoteBuilderHeader = {
  __typename?: "AgencyQuoteBuilderHeader";
  clear: UiSecondaryButton;
  expandLink: EgdsExpandoLink;
  generateQuote: UiPrimaryButton;
  quoteTitle: Scalars["String"];
};

export interface AgencyQuoteBuilderPropertyRateCardInput {
  checkIn: DateInput;
  checkOut: DateInput;
  inventoryType: InventoryType;
  packageRate: Scalars["Boolean"];
  pricePerNight: Scalars["String"];
  priceTotal: Scalars["String"];
  propertyDestination: Scalars["String"];
  propertyId: Scalars["String"];
  propertyName: Scalars["String"];
  propertyType: Scalars["String"];
  ratePlanId: Scalars["String"];
  roomTypeDescription: Scalars["String"];
  roomTypeId: Scalars["String"];
  rooms: Array<PropertyRoomInput>;
  starRating?: InputMaybe<Scalars["Float"]>;
}

export type AgencyQuoteBuilderRateCard = {
  __typename?: "AgencyQuoteBuilderRateCard";
  dates: Scalars["String"];
  header: Scalars["String"];
  price: Array<Scalars["String"]>;
  rating?: Maybe<EgdsRating>;
  remove: UiTertiaryButton;
  summary: Array<Scalars["String"]>;
};

export interface AgencyQuoteBuilderRateCardInput {
  propertyInput: AgencyQuoteBuilderPropertyRateCardInput;
}

export interface AgencyQuoteBuilderRemoveInput {
  all: Scalars["Boolean"];
  index?: InputMaybe<Scalars["Int"]>;
}

export type AgencyQuoteBuilderResponse = {
  __typename?: "AgencyQuoteBuilderResponse";
  announceMessage: Scalars["String"];
  header: AgencyQuoteBuilderHeader;
  notification?: Maybe<Scalars["String"]>;
  rateCards: Array<AgencyQuoteBuilderRateCard>;
};

/** Input for deleting quotes */
export interface AgencyQuoteDeleteInput {
  /** List of quote ids to delete */
  quoteIds: Array<Scalars["String"]>;
}

/** Status of quotes delete */
export type AgencyQuoteDeleteStatus = {
  __typename?: "AgencyQuoteDeleteStatus";
  deletedCount: Scalars["Int"];
  isSuccessful: Scalars["Boolean"];
};

/** Status of quotes delete */
export interface AgencyQuoteDeleteStatusInput {
  deletedCount: Scalars["Int"];
  isSuccessful: Scalars["Boolean"];
}

export interface AgencyQuoteDetails {
  pageTitle: EgdsHeading;
  propertyDetailsLink?: Maybe<EgdsStandardLink>;
}

export type AgencyQuoteDetailsFailure = AgencyQuoteDetails & {
  __typename?: "AgencyQuoteDetailsFailure";
  /**
   * Required banner in failure scenario indicating error details
   * @deprecated Use notification placard in place of banner.  Banner will be removed in a future release.
   */
  banner: UiBanner;
  /** Required notification in failure scenario indicating error details */
  notificationPlacard: AgencyQuoteNotificationPlacard;
  /** Main screen title for the quotation tool */
  pageTitle: EgdsHeading;
  /** Link enabling the user to return the referring page */
  propertyDetailsLink?: Maybe<EgdsStandardLink>;
};

export type AgencyQuoteDetailsSuccess = AgencyQuoteDetails & {
  __typename?: "AgencyQuoteDetailsSuccess";
  /** List of all the action buttons available (i.e. Preview, Save as PDF) */
  actionButtons: Array<UiPrimaryButton>;
  /** quote name and traveler's name fields plus the message */
  agencyQuoteIdentityInfo: AgencyQuoteIdentityInfo;
  /** Returns all the Agency site information and hints to fill in any missing form elements */
  agencySiteInfo: AgencyDetail;
  /** Returns all the elements needed to build the Agent communication section of the quotation tool */
  agentMessage: AgentComment;
  /**
   * Optional banner for user alerts
   * @deprecated Use notification placard in place of banner.  Banner will be removed in a future release.
   */
  banner?: Maybe<UiBanner>;
  /** Messages pertaining to the overall trip.  Will apply to all travel cards */
  messages?: Maybe<Array<EgdsText>>;
  /** Optional banner for user notifications */
  notificationPlacard?: Maybe<AgencyQuoteNotificationPlacard>;
  /** Main screen title for the quotation tool */
  pageTitle: EgdsHeading;
  /** @deprecated This link is moved to PropertyUnitCard and should be consumed from there. */
  propertyDetailsLink?: Maybe<EgdsStandardLink>;
  /** Lodging cards, including pricing presentation, to provide hotel specific info for the agent quote */
  propertyRoomCards: Array<PropertyUnitCard>;
  /** Regulatory messages pertaining to the overall trip.  Will apply to all travel cards */
  quoteRegulatoryMessages?: Maybe<Array<EgdsText>>;
  /**
   * Summary of the trip the agent is building.  Will apply to all travel cards
   * @deprecated use Trip Summary in PropertyUnitCard
   */
  tripSummary: EgdsTextSection;
};

export type AgencyQuoteIdentityInfo = {
  __typename?: "AgencyQuoteIdentityInfo";
  /** List of entry fields needed to save quote */
  identityEntryFields: Array<EgdsInputField>;
  /** Any messages to display above the travel cards that apply across all of them */
  messages?: Maybe<Array<EgdsText>>;
};

export type AgencyQuoteInputField = EgdsInputField & {
  __typename?: "AgencyQuoteInputField";
  egdsElementId?: Maybe<Scalars["String"]>;
  errorMessage?: Maybe<Scalars["String"]>;
  instructions?: Maybe<Scalars["String"]>;
  label?: Maybe<Scalars["String"]>;
  labelTemplate?: Maybe<EgdsLocalizedText>;
  leftIcon?: Maybe<Icon>;
  placeholder?: Maybe<Scalars["String"]>;
  readOnly: Scalars["Boolean"];
  required?: Maybe<Scalars["Boolean"]>;
  rightIcon?: Maybe<Icon>;
  validations?: Maybe<Array<EgdsInputValidation>>;
  value?: Maybe<Scalars["String"]>;
};

/** List of Saved Quotes with Header */
export type AgencyQuoteListContent = {
  __typename?: "AgencyQuoteListContent";
  header: AgencyQuoteListHeader;
  quotes?: Maybe<Array<AgencyQuoteListQuote>>;
};

export type AgencyQuoteListElement = {
  __typename?: "AgencyQuoteListElement";
  element: Element;
};

/** List of header content items */
export type AgencyQuoteListHeader = {
  __typename?: "AgencyQuoteListHeader";
  contents?: Maybe<Array<AgencyQuoteListHeaderContent>>;
};

/** Header contents of the quote list */
export type AgencyQuoteListHeaderContent = {
  __typename?: "AgencyQuoteListHeaderContent";
  contentId?: Maybe<Scalars["String"]>;
  element?: Maybe<AgencyQuoteListElement>;
  sortType?: Maybe<AgencyQuoteListSortType>;
};

export interface AgencyQuoteListInput {
  /** Status and number of quotes deleted. */
  deleteStatus?: InputMaybe<AgencyQuoteDeleteStatusInput>;
  /** Page index */
  paginationIndex?: InputMaybe<Scalars["Int"]>;
  /** Search string if we want to filter the agency quote list records */
  searchCriteria?: InputMaybe<Scalars["String"]>;
  /** Information of the tab */
  selectedTab?: InputMaybe<Scalars["String"]>;
  /** Field Id for sort */
  sortContentId?: InputMaybe<Scalars["String"]>;
  /** Sort direction (ascending, descending) */
  sortType?: InputMaybe<AgencyQuoteListSortType>;
}

/** Pagination contains previous and next buttons along with their numeric indexes */
export type AgencyQuoteListPagination = {
  __typename?: "AgencyQuoteListPagination";
  nextButton?: Maybe<EgdsButton>;
  nextIndex?: Maybe<Scalars["Int"]>;
  paginationText?: Maybe<Scalars["String"]>;
  previousButton?: Maybe<EgdsButton>;
  previousIndex?: Maybe<Scalars["Int"]>;
};

/** Content for 1 quote */
export type AgencyQuoteListQuote = {
  __typename?: "AgencyQuoteListQuote";
  contents?: Maybe<Array<AgencyQuoteListQuoteContent>>;
  quoteId: Scalars["String"];
};

/** Quote content */
export type AgencyQuoteListQuoteContent = {
  __typename?: "AgencyQuoteListQuoteContent";
  element?: Maybe<AgencyQuoteListElement>;
};

export type AgencyQuoteListResponse = {
  __typename?: "AgencyQuoteListResponse";
  /** Delete quotes button */
  deleteButton?: Maybe<EgdsButton>;
  /** Quotes deleted toast message */
  deleteToast?: Maybe<EgdsToast>;
  /** Message to be displayed in Quote List */
  message?: Maybe<Scalars["String"]>;
  /** Messages to be displayed in a banner at the top of the page. */
  notificationPlacard?: Maybe<AgencyQuoteNotificationPlacard>;
  /** Page title for the agency quote list */
  pageTitle: Scalars["String"];
  /** Pagination */
  pagination?: Maybe<AgencyQuoteListPagination>;
  /** List of Saved Quotes */
  quoteContent?: Maybe<AgencyQuoteListContent>;
  /** Search field, Search button and Search pill */
  searchSection?: Maybe<AgencyQuoteListSearchSection>;
  /** Tabs for Active or Past quotes */
  tabs?: Maybe<EgdsTabs>;
};

/** Displays the search section which consists of input field, search button and search pill */
export type AgencyQuoteListSearchSection = {
  __typename?: "AgencyQuoteListSearchSection";
  searchBox: EgdsInputField;
  searchButton: EgdsButton;
  searchPills?: Maybe<Array<EgdsPill>>;
};

/** Parameters for header cells for the records to be sorted in ascending, descending or to be unsorted manner */
export type AgencyQuoteListSortType = "ASCENDING" | "DESCENDING" | "NOT_SORTED";

export interface AgencyQuoteNaturalKeyInput {
  lodgingType: Scalars["String"];
  packageRates?: InputMaybe<Scalars["Boolean"]>;
  propertyDestination: Scalars["String"];
  propertyNaturalKeys: Array<PropertyNaturalKeyInput>;
}

export type AgencyQuoteNotificationPlacard = {
  __typename?: "AgencyQuoteNotificationPlacard";
  details: UiBanner;
  /** Designates a severity for the banner with correlates to the display color on the UI */
  displayType: BannerDisplayType;
};

export interface AgencyQuoteSaveAgencyDetailInput {
  /** Address of the agency, line 1 */
  address1?: InputMaybe<Scalars["String"]>;
  /** Address of the agency line 2 */
  address2?: InputMaybe<Scalars["String"]>;
  /** Email of the agent */
  email: Scalars["String"];
  /** Name of the Agency */
  name?: InputMaybe<Scalars["String"]>;
  /** Phone number associated with the agency */
  phone: Scalars["String"];
}

export interface AgencyQuoteSaveCardInput {
  /** Destination of the travel */
  destination: Scalars["String"];
  /** Indicates state for hiding cancellation policy */
  hideCancellationState: Scalars["Boolean"];
  /** Indicates state for hiding price details */
  hidePriceState: Scalars["Boolean"];
  /** Expedia's line of businesses */
  lob: ExpLineOfBusiness;
  /** Natural key for input validation */
  naturalKey: AgencyQuoteNaturalKeyInput;
  /** Total price for the quote */
  totalPrice?: InputMaybe<Scalars["String"]>;
}

export type AgencyQuoteSaveFailure = {
  __typename?: "AgencyQuoteSaveFailure";
  /** Quote save failure message on banner */
  banner: UiBanner;
};

export interface AgencyQuoteSaveInput {
  /** Agency details pulled from database */
  agencyInfo: AgencyQuoteSaveAgencyDetailInput;
  /** Message from the agent, to be added by the agent */
  agentMessage?: InputMaybe<Scalars["String"]>;
  /** Details of the trip on quote, pulled from database */
  quoteCards: Array<AgencyQuoteSaveCardInput>;
  /** Autogenerated Unique Identifier for each quote. Could be Null for saving a quote after Update */
  quoteId?: InputMaybe<Scalars["String"]>;
  /** Name of the quote, to be added by the agent */
  quoteName: Scalars["String"];
  /** Name of the Traveler, to be added by the agent */
  travelerName: Scalars["String"];
}

export type AgencyQuoteSaveResponse = AgencyQuoteSaveFailure | AgencyQuoteSaveSuccess;

export type AgencyQuoteSaveSuccess = {
  __typename?: "AgencyQuoteSaveSuccess";
  quoteId?: Maybe<Scalars["String"]>;
  /** Quote save success toaster message, including quote save message and link to list of all quotes by the agent */
  toast: EgdsToast;
};

export type AgencyQuoteSwitchableMessage = {
  __typename?: "AgencyQuoteSwitchableMessage";
  displayToggle: UiToggle;
  message: EgdsTextSection;
};

export type AgencyQuoteSwitchablePriceSummary = {
  __typename?: "AgencyQuoteSwitchablePriceSummary";
  displayToggle: UiToggle;
  priceBreakdownSummary?: Maybe<PricePresentation>;
};

export type AgencyQuoteToggle = UiToggle & {
  __typename?: "AgencyQuoteToggle";
  /** Sets the current status for the toggle, determining which labels/analytics will be live on the page */
  checked: Scalars["Boolean"];
  checkedAccessibilityLabel?: Maybe<Scalars["String"]>;
  checkedAnalytics?: Maybe<ClientSideAnalytics>;
  checkedDescription?: Maybe<Scalars["String"]>;
  checkedLabel: Scalars["String"];
  /** Indicates if toggle is enabled/disabled */
  enabled: Scalars["Boolean"];
  /** @deprecated This declaration overrides deprecated member but not marked as deprecated itself. */
  label: Scalars["String"];
  uncheckedAccessibilityLabel?: Maybe<Scalars["String"]>;
  uncheckedAnalytics?: Maybe<ClientSideAnalytics>;
  uncheckedDescription?: Maybe<Scalars["String"]>;
  uncheckedLabel: Scalars["String"];
};

export type AgencyRadioField = ShoppingSortAndFilterField & {
  __typename?: "AgencyRadioField";
  id: Scalars["String"];
  options?: Maybe<Array<ShoppingSelectableFilterOption>>;
  primary?: Maybe<Scalars["String"]>;
  secondary?: Maybe<Scalars["String"]>;
  type?: Maybe<FacetType>;
};

export interface AgencyShoppingContextInput {
  bookingDate: Scalars["String"];
  checkin: Scalars["String"];
  checkout: Scalars["String"];
  countryCode: Scalars["String"];
  currency: Scalars["String"];
  language: Scalars["String"];
  occupancy: Array<Scalars["String"]>;
}

export type AgencySiteInfo = {
  __typename?: "AgencySiteInfo";
  /** List of all the form fields needed to provide agency information for the quote */
  agencyEntryFields: Array<EgdsInputField>;
  /** Elements needed to show the Agency Logo, including toggle messaging based on logo existence */
  logo: AgencyLogo;
};

export type AgencySliderField = ShoppingSortAndFilterField & {
  __typename?: "AgencySliderField";
  id: Scalars["String"];
  primary?: Maybe<Scalars["String"]>;
  range?: Maybe<ShoppingRangeFilterOption>;
  secondary?: Maybe<Scalars["String"]>;
  type?: Maybe<FacetType>;
};

export type AgencyUiPrimaryFloatingActionButton = EgdsElement &
  UiFloatingActionButton & {
    __typename?: "AgencyUIPrimaryFloatingActionButton";
    accessibility?: Maybe<Scalars["String"]>;
    action?: Maybe<UiAction>;
    analytics?: Maybe<ClientSideAnalytics>;
    badge?: Maybe<Scalars["Int"]>;
    disabled: Scalars["Boolean"];
    egdsElementId?: Maybe<Scalars["String"]>;
    icon?: Maybe<Icon>;
    primary?: Maybe<Scalars["String"]>;
  };

export type AgencyUiSecondaryFloatingActionButton = EgdsElement &
  UiFloatingActionButton & {
    __typename?: "AgencyUISecondaryFloatingActionButton";
    accessibility?: Maybe<Scalars["String"]>;
    action?: Maybe<UiAction>;
    analytics?: Maybe<ClientSideAnalytics>;
    badge?: Maybe<Scalars["Int"]>;
    disabled: Scalars["Boolean"];
    egdsElementId?: Maybe<Scalars["String"]>;
    icon?: Maybe<Icon>;
    primary?: Maybe<Scalars["String"]>;
  };

export type AgentComment = {
  __typename?: "AgentComment";
  egdsElementId?: Maybe<Scalars["String"]>;
  errorMessage?: Maybe<Scalars["String"]>;
  label?: Maybe<EgdsText>;
  /** Hint text for the message text field prompting agent to add a custom message */
  placeHolder?: Maybe<Scalars["String"]>;
  validations?: Maybe<Array<EgdsInputValidation>>;
  /** Agent message input field contents.  Current implementation this will always be empty */
  value?: Maybe<Scalars["String"]>;
};

export type AgentMessage = {
  __typename?: "AgentMessage";
  label?: Maybe<EgdsText>;
  /** Hint text for the message text field prompting agent to add a custom message */
  placeHolder?: Maybe<Scalars["String"]>;
  /** Agent message input field contents.  Current implementation this will always be empty */
  value?: Maybe<Scalars["String"]>;
};

export type AgentPresence = {
  __typename?: "AgentPresence";
  agentResourceUri: Scalars["String"];
  agentStates: Array<AgentState>;
  avatar: Scalars["String"];
  currentState: AgentState;
  emailId: Scalars["String"];
  firstName: Scalars["String"];
  lastName: Scalars["String"];
  logonName?: Maybe<Scalars["String"]>;
};

export interface AgentQuoteDetails {
  pageTitle: EgdsHeading;
  propertyDetailsLink?: Maybe<EgdsStandardLink>;
}

export type AgentQuoteDetailsFailure = AgentQuoteDetails & {
  __typename?: "AgentQuoteDetailsFailure";
  /** Required banner in failure scenario indicating error details */
  banner: UiBanner;
  /** Main screen title for the quotation tool */
  pageTitle: EgdsHeading;
  /** Link enabling the user to return the referring page */
  propertyDetailsLink?: Maybe<EgdsStandardLink>;
};

export type AgentQuoteDetailsSuccess = AgentQuoteDetails & {
  __typename?: "AgentQuoteDetailsSuccess";
  /** List of all the action buttons available (i.e. Preview, Save as PDF) */
  actionButtons: Array<UiPrimaryButton>;
  /** Returns all the Agency site information and hints to fill in any missing form elements */
  agencySiteInfo: AgencySiteInfo;
  /** Returns all the elements needed to build the Agent communication section of the quotation tool */
  agentMessage: AgentMessage;
  /** Optional banner for user alerts */
  banner?: Maybe<UiBanner>;
  /** Messages pertaining to the overall trip.  Will apply to all travel cards */
  messages?: Maybe<Array<EgdsText>>;
  /** Main screen title for the quotation tool */
  pageTitle: EgdsHeading;
  /** Link enabling the user to return the referring page */
  propertyDetailsLink?: Maybe<EgdsStandardLink>;
  /** Lodging cards, including pricing presentation, to provide hotel specific info for the agent quote */
  propertyRoomCards: Array<PropertyRoomCard>;
  /** Summary of the trip the agent is building.  Will apply to all travel cards */
  tripSummary: EgdsTextSection;
};

export type AgentQuoteInputField = EgdsInputField & {
  __typename?: "AgentQuoteInputField";
  egdsElementId?: Maybe<Scalars["String"]>;
  errorMessage?: Maybe<Scalars["String"]>;
  instructions?: Maybe<Scalars["String"]>;
  label?: Maybe<Scalars["String"]>;
  labelTemplate?: Maybe<EgdsLocalizedText>;
  leftIcon?: Maybe<Icon>;
  placeholder?: Maybe<Scalars["String"]>;
  readOnly: Scalars["Boolean"];
  required?: Maybe<Scalars["Boolean"]>;
  rightIcon?: Maybe<Icon>;
  validations?: Maybe<Array<EgdsInputValidation>>;
  value?: Maybe<Scalars["String"]>;
};

export interface AgentQuoteNaturalKeyInput {
  packageRates?: InputMaybe<Scalars["Boolean"]>;
  propertyDestination: Scalars["String"];
  propertyNaturalKeys: Array<PropertyNaturalKeyInput>;
}

export type AgentQuoteSwitchableMessage = {
  __typename?: "AgentQuoteSwitchableMessage";
  displayToggle: UiToggle;
  message: EgdsTextSection;
};

export type AgentQuoteSwitchablePriceSummary = {
  __typename?: "AgentQuoteSwitchablePriceSummary";
  displayToggle: UiToggle;
  priceBreakdownSummary?: Maybe<PricePresentation>;
};

export type AgentQuoteToggle = UiToggle & {
  __typename?: "AgentQuoteToggle";
  /** Sets the current status for the toggle, determining which labels/analytics will be live on the page */
  checked: Scalars["Boolean"];
  checkedAccessibilityLabel?: Maybe<Scalars["String"]>;
  checkedAnalytics?: Maybe<ClientSideAnalytics>;
  checkedDescription?: Maybe<Scalars["String"]>;
  checkedLabel: Scalars["String"];
  /** Indicates if toggle is enabled/disabled */
  enabled: Scalars["Boolean"];
  label: Scalars["String"];
  uncheckedAccessibilityLabel?: Maybe<Scalars["String"]>;
  uncheckedAnalytics?: Maybe<ClientSideAnalytics>;
  uncheckedDescription?: Maybe<Scalars["String"]>;
  uncheckedLabel: Scalars["String"];
};

export type AgentState = {
  __typename?: "AgentState";
  agentPresenceUri: Scalars["String"];
  localizedText?: Maybe<Scalars["String"]>;
  type: AgentStateType;
};

export interface AgentStateInput {
  agentPresenceUri: Scalars["String"];
  localizedText?: InputMaybe<Scalars["String"]>;
  type: AgentStateType;
}

export type AgentStateType = "NotReady" | "Offline" | "Ready";

/** Coupon and credits Chatbot Web Experience call to action */
export type AirCreditWebAction = UiAction & {
  __typename?: "AirCreditWebAction";
  /** Used to provide accessibility that has to be read on completion of action. */
  accessibility?: Maybe<Scalars["String"]>;
  /** Client analytics data. */
  analytics: ClientSideAnalytics;
  /** Destination link. */
  resource: Uri;
};

/** Represents the various types of loading and loaded states of airlineCreditsPresentation available */
export type AirlineCreditsContentPresentation = AirlineCreditsLoadedPresentation | AirlineCreditsLoadingPresentation;

/** The presentation for the airline credits content */
export type AirlineCreditsLoadedPresentation = {
  __typename?: "AirlineCreditsLoadedPresentation";
  /** The dialogId where this content is rendered, this is used to close it after selecting a credit */
  dialogId: FlightsDialogId;
  /** Represents the nested dialogs that could be displayed within the airline credits content */
  dialogs?: Maybe<Array<FlightsDialog>>;
  /** Used to capture analytics when presentation is viewed */
  onDisplayAnalytics: Array<ClientSideAnalytics>;
  /** All the sections that will be rendered in the airline credits component */
  sections: Array<FlightsCreditSelectionPresentationSection>;
};

/** The presentation for the airline credits content */
export type AirlineCreditsLoadingPresentation = {
  __typename?: "AirlineCreditsLoadingPresentation";
  /** The heading in the loading state of credits */
  heading: Scalars["String"];
  /** The subheading in the loading state of credits */
  subheading: Scalars["String"];
};

export type AirlineCreditsPresentation = {
  __typename?: "AirlineCreditsPresentation";
  /** The dialogId where this content is rendered, this is used to close it after selecting a credit */
  dialogId: FlightsDialogId;
  /** Used to capture analytics when presentation is viewed */
  onDisplayAnalytics: Array<ClientSideAnalytics>;
  /** All the sections that will be rendered in the airline credits component */
  sections: Array<FlightsCreditSelectionPresentationSection>;
};

export type AirlineCreditsResults = {
  __typename?: "AirlineCreditsResults";
  data: Scalars["String"];
};

/** Airport location type chosen in flight search. */
export type AirportLocationType = "AIRPORT" | "METROCODE" | "UNSPECIFIED";

/** Represents alternate airport trip option */
export type AirportOption = {
  __typename?: "AirportOption";
  /** Accessibility Heading for specific alternate airport option */
  accessibilityHeading: Scalars["String"];
  /** Accessibility Message for specific alternate airport option */
  accessibilityMessage: Scalars["String"];
  /** Specifies the Distance of the alternate destination from the actual destination */
  destinationAirportDistance: Scalars["String"];
  /** City Name of the Alternate Destination Airport */
  destinationCityName: Scalars["String"];
  /** Icon between origin and destination airport codes */
  icon: Icon;
  /** Specifies the Distance of the alternate origin from the actual origin */
  originAirportDistance: Scalars["String"];
  /** City Name of the Alternate Origin Airport */
  originCityName: Scalars["String"];
  /** Used for conducting alternate trip search */
  selectAction: FlightsAction;
};

export type AllArticlesErrorView = {
  __typename?: "AllArticlesErrorView";
  /** Represents the error banner details */
  errorMessage: UiBanner;
  /** Represents the help articles title */
  title: Scalars["String"];
};

/** Represents help articles card content on homepage */
export type AllHelpArticles = {
  __typename?: "AllHelpArticles";
  /** Title of articles page */
  dialogTitleOption: HelpArticleHeadingSection;
  /** Title of articles page */
  helpArticleTitle: Scalars["String"];
  /** List of help articles to be shown in the card */
  helpArticlesOnHomepage: Array<HelpArticleCard>;
};

/** Union of AllHelpArticles and AllArticlesErrorView of all articles */
export type AllHelpArticlesView = AllArticlesErrorView | AllHelpArticles;

export type AllHotelProducts = {
  __typename?: "AllHotelProducts";
  hotelProducts: Array<HotelProduct>;
};

export type AllHotelProductsData = {
  __typename?: "AllHotelProductsData";
  messageContent: AllHotelProducts;
  schemaName: Scalars["String"];
};

/** Specifies the behavior of ALTER, which is used to run Abacus experiments on localization messages. */
export type AlterMode =
  /** Localization messages will be replaced with their namespace and loc key. */
  | "DEBUG"
  /** None of the ALTER experiments will be used when resolving localization messages. */
  | "NONE"
  /** Both released and draft ALTER experiments will be used when resolving localization messages. */
  | "PREVIEW"
  /** This is the default. Only released ALTER experiments will be used when resolving localization messages. */
  | "RELEASED";

/** Represents the trip options for nearby airports when the search completes with no offers */
export type AlternateAirportOptions = {
  __typename?: "AlternateAirportOptions";
  /** Used for accessibility on alternate airport options - 'Search different airports' */
  accessibilityTitle: Scalars["String"];
  /** For analytics on alternate airport options */
  airportOptionAnalytics: FlightsAnalytics;
  /** Journey options between nearby airports to origin and destination specified by user */
  airportOptions: Array<AirportOption>;
  /** Label for alternate airport options e.g. 'Search different airports' */
  alternateOptionTitle: Scalars["String"];
};

export type AlternateDateOption = {
  __typename?: "AlternateDateOption";
  dates: LodgingLinkMessage;
  price?: Maybe<PropertyPriceOption>;
};

/** Represents the trip options on alternate dates when the search completes with no offers */
export type AlternateDateOptions = {
  __typename?: "AlternateDateOptions";
  /** Used for accessibility on alternate date options - 'Search different dates' */
  accessibilityTitle: Scalars["String"];
  /** Label for alternate date options e.g. 'Search different dates' */
  alternateOptionTitle: Scalars["String"];
  /** For analytics on alternate date options */
  dateOptionAnalytics: FlightsAnalytics;
  /** Journey options on alternate dates between origin and destination specified by user */
  dateOptions: Array<DateOption>;
};

export type AlternateDatesCard = {
  __typename?: "AlternateDatesCard";
  header?: Maybe<LodgingHeader>;
  options: Array<AlternateDateOption>;
};

export type AlternateRecommendationCard = CarRecommendationCard & {
  __typename?: "AlternateRecommendationCard";
  action?: Maybe<CarAction>;
  analytics?: Maybe<CarAnalytics>;
  button?: Maybe<CarActionableItem>;
  icon?: Maybe<Icon>;
  image?: Maybe<Image>;
  subText?: Maybe<CarPhrase>;
  title?: Maybe<CarPhrase>;
};

export type Amenities = {
  __typename?: "Amenities";
  /** Available amenities for the entire property */
  propertyAmenities?: Maybe<Array<Amenity>>;
  /** Available amenities at the room level */
  roomAmenities?: Maybe<Array<Amenity>>;
};

export type AmenitiesDialog = {
  __typename?: "AmenitiesDialog";
  dialog: EgdsFullScreenDialog;
  trigger: LodgingDialogTriggerMessage;
};

export type Amenity = {
  __typename?: "Amenity";
  id?: Maybe<Scalars["String"]>;
  name?: Maybe<Scalars["String"]>;
};

export type AmenityCategory =
  | "ACCESSIBLE_ROLL_IN_SHOWER"
  | "AIR_CONDITIONING"
  | "ALL_INCLUSIVE"
  | "ARCADE"
  | "BABYSITTING"
  | "BAR"
  | "BARBECUE"
  | "BOWLING"
  | "BREAKFAST_AVAILABLE"
  | "BREAKFAST_INCLUDED"
  | "BREAKFAST_NOT_AVAILABLE"
  | "BUSINESS_SERVICES"
  | "CHILDREN_CLUB"
  | "DAILY_HOUSEKEEPING"
  | "EXTRA_BED"
  | "FIRE_PLACE"
  | "FITNESS_EQUIPMENT"
  | "FREE_AIRPORT_TRANSPORTATION"
  | "FREE_BREAKFAST"
  | "FREE_CANCEL"
  | "FREE_PARKING"
  | "FREE_WELCOME_DRINK"
  | "FREE_WIRED_INTERNET"
  | "FRONT_DESK_24_HOURS"
  | "GROCERY"
  | "HIGH_SPEED_INTERNET"
  | "HOT_TUB"
  | "INTERNET_NOT_AVAILABLE"
  | "IN_ROOM_INTERNET"
  | "KIDS_POOL"
  | "KITCHEN"
  | "LAUNDRY"
  | "LIVING_AREA"
  | "MICROWAVE"
  | "MINI_GOLF"
  | "NON_REFUNDABLE"
  | "ON_PRIVATE_BEACH"
  | "ON_THE_BEACH"
  | "OUTDOOR_SPACE"
  | "PARKING"
  | "PARTIAL_REFUND"
  | "PETS_ALLOWED"
  | "PLAYGROUND"
  | "POOL"
  | "RESERVE_NOW_PAY_DEPOSIT"
  | "RESERVE_NOW_PAY_LATER"
  | "RESTAURANT_IN_HOTEL"
  | "ROOM_SERVICE"
  | "SMOKE_FREE"
  | "SOUNDPROOF_ROOM"
  | "SPA_SERVICES_ON_SITE"
  | "SPECIAL_DEAL"
  | "TENNIS_COURT"
  | "TOYS"
  | "WASHER"
  | "WATERSLIDE"
  | "WIFI_SURCHARGE"
  | "WIRED_INTERNET_SURCHARGE";

/** represents the bag template analytics keys */
export type AnalyticsKey =
  /** Represents the analytics key for number of bags per traveller */
  | "NUMBER_OF_BAGS"
  /** Represents the analytics key for piece or weight selling model criteria analytics per traveller */
  | "PIECE_OR_WEIGHT_CONCEPT"
  /** Represents the analytics key for quantity of bags per traveller (NONE/SOME/ALL) */
  | "QUANTITY_OF_BAGS";

/** Represents per journey ancillary selection */
export interface AncillaryJourneySelectionsInput {
  /** Represents the journey index for which the selection is applicable */
  journeyIndex: Scalars["Int"];
  /** Represents the list of per traveller selection */
  travellerAncillarySelections: Array<TravellerAncillarySelectionInput>;
}

export type AppliedCoupon = {
  __typename?: "AppliedCoupon";
  confirmationMessage?: Maybe<Scalars["String"]>;
  couponCodeError?: Maybe<EgdsTextInputField>;
  couponDetail?: Maybe<EgdsStandardMessagingCard>;
  errorBannerMessage?: Maybe<Scalars["String"]>;
};

export interface ArithmeticOperationsCriteriaInput {
  /** Represents the input numbers to be operated upon */
  inputNumbers: Array<Scalars["Float"]>;
  /** The operation to be performed */
  operation: Operation;
}

/** Possible aspect ratios of EGDS images */
export type AspectRatio =
  /** Aspect ratio 4:3 */
  | "FOUR_THREE"
  /** Aspect ratio 1:1 */
  | "ONE_ONE"
  /** Aspect ratio 16:9 */
  | "SIXTEEN_NINE"
  /** Aspect ratio 3:4 */
  | "THREE_FOUR"
  /** Aspect ratio 3:2 */
  | "THREE_TWO"
  /** Aspect ratio 21:9 */
  | "TWENTY_ONE_NINE";

export type AuthenticationState = "ANONYMOUS" | "AUTHENTICATED" | "IDENTIFIED";

export type AvailabilityCalendar = {
  __typename?: "AvailabilityCalendar";
  /** the configuration for this Availability Calendar which contains information regarding the date considered "today", the range of dates covered by this calendar and other logical defaults/fallbacks if nothing is specified in the days field of the API response */
  configuration: AvailabilityCalendarConfiguration;
  /** the days of this availability calendar that contain availability information */
  days?: Maybe<Array<AvailabilityCalendarDay>>;
  /** the property or unit unique identifier this availability calendar is associated with - this is especially useful in multi unit VR situations where the response will contain multiple availability calendars */
  id: Scalars["ID"];
};

/** This type is used to provide metadata and logical "defaults" for a given availability calendar. By logical "defaults" we are generally referring to values that should be used for dates that lay outside of the range defined by beginDate/endDate */
export type AvailabilityCalendarConfiguration = {
  __typename?: "AvailabilityCalendarConfiguration";
  /** the default availability for a given date that lies outside of the beginDate/endDate for the associated Availability Calendar */
  availableByDefault: Scalars["Boolean"];
  /** the earliest date the response contains availability data for */
  beginDate: Date;
  /** the date being considered as "today" - which is based off of the input property's timezone */
  currentDate: Date;
  /** the default checkin validity after the endDate for the associated Availability Calendar */
  defaultCheckinValidityAfterEndDate: CheckinValidityWithReason;
  /** the default checkout validity for a day in the associated Availability Calendar that is with in stay constraints */
  defaultCheckoutValidityWhenWithinConstraints: CheckoutValidityWithReason;
  /** the default stay constraints for days in the associated Availability Calendar that are outside the the begin/endDate range */
  defaultStayConstraints: StayConstraints;
  /** the latest date the response contains availability data for */
  endDate: Date;
};

export type AvailabilityCalendarDay = {
  __typename?: "AvailabilityCalendarDay";
  /** is this day available (ie. is this day currently booked/reserved) */
  available: Scalars["Boolean"];
  /** an enumeration indicating if this date is valid for checkin otherwise a reason why its not valid for checkin */
  checkinValidity: CheckinValidityWithReason;
  /** an enumerating indicating if this date is valid for checkout otherwise a reason why its not valid for checkout */
  checkoutValidity: CheckoutValidityWithReason;
  /** the date this Availability Calendar day represents */
  date: Date;
  /** the calculated stay constraints for this day */
  stayConstraints: StayConstraints;
};

/** Interface that represents a CTA typically when there are no rate plans */
export type AvailabilityCallToAction = LodgingButton | LodgingPlainMessage;

/** Available flight routes */
export type AvailableRoutes = {
  __typename?: "AvailableRoutes";
  /** destination select String */
  destinationsString?: Maybe<Scalars["String"]>;
  /** list of available origin countries */
  originCountries: Array<OriginCountry>;
  /** origin select String */
  originString?: Maybe<Scalars["String"]>;
};

/** Represents Avatar on VAC */
export type Avatar = {
  __typename?: "Avatar";
  /** avatar icon */
  icon?: Maybe<Icon>;
  /** avatar image */
  image?: Maybe<Image>;
  /** avatar text */
  text?: Maybe<Scalars["String"]>;
};

/** Represents AvatarGroup on VAC */
export type AvatarGroup = {
  __typename?: "AvatarGroup";
  /** list of avatar on VAC */
  items: Array<Avatar>;
};

export type BackToHomepageButton = EmailCtaButton & {
  __typename?: "BackToHomepageButton";
  text: Scalars["String"];
  url: Scalars["URL"];
};

export type Badge = {
  __typename?: "Badge";
  /** @deprecated Only used for uitk-react-badges v2, use text for v3 */
  description?: Maybe<Scalars["String"]>;
  /** @deprecated Only used for uitk-react-badges v2, use icon_temp temporarily */
  icon?: Maybe<BadgeIcon>;
  icon_temp?: Maybe<Icon>;
  mark?: Maybe<Mark>;
  text?: Maybe<Scalars["String"]>;
  /** @deprecated Only used for uitk-react-badges v2, use theme_temp temporarily */
  theme?: Maybe<Theme>;
  theme_temp?: Maybe<Theme>;
};

export type BadgeIcon =
  | "ACCESS_TIME"
  | "ADD"
  | "BUNDLED_SAVINGS_PLUS"
  | "EXP29639_ORB"
  | "FAMILY_FRIENDLY"
  | "INFO_OUTLINE"
  | "LOB_DEALS"
  | "LOCAL_OFFER"
  | "MOD"
  | "SMARTPHONE";

/** Represents the quantity of bags to be sent in analytics none/some/all */
export type BagsSelectionType = "ALL" | "NONE" | "SOME";

export type BannerDisplayType = "ERROR" | "INFO" | "WARN";

/** This represents the price summary per traveler */
export type BannerPlacard = {
  __typename?: "BannerPlacard";
  /** This represents the UIBanner type */
  banner: UiBanner;
  /** This represents the display analytics of a placard */
  displayAnalytics: ClientSideAnalytics;
};

export type BasePoi = {
  __typename?: "BasePoi";
  /** Entity coordinates */
  coordinates?: Maybe<Scalars["String"]>;
  /** Entity id */
  id?: Maybe<Scalars["String"]>;
  /** Entity name */
  name?: Maybe<Scalars["String"]>;
  /** Entity nearby relationship. By default, excludes the items that are inside the parent geo polygon. */
  nearby?: Maybe<Relation>;
  /** Poi popularity score */
  popularity?: Maybe<Scalars["Float"]>;
  /** Entity related relationship. Includes exclusively items that are within the parent geo polygon. */
  related?: Maybe<Relation>;
  /** Entity type. Example: park */
  type?: Maybe<Scalars["String"]>;
};

export type BaseProperty = {
  __typename?: "BaseProperty";
  /** Entity coordinates */
  coordinates?: Maybe<Scalars["String"]>;
  /** Entity Gaia id */
  gaiaId?: Maybe<Scalars["String"]>;
  /** Entity id */
  id?: Maybe<Scalars["String"]>;
  /** Entity name */
  name?: Maybe<Scalars["String"]>;
  /** Entity nearby relationship. By default, excludes the items that are inside the parent geo polygon. */
  nearby?: Maybe<Relation>;
  /** Entity related relationship. Includes exclusively items that are within the parent geo polygon. */
  related?: Maybe<Relation>;
  /** Property star rating */
  starRating?: Maybe<Scalars["Float"]>;
  /** Entity structure name. example: hotel, vacation rental. */
  structureName?: Maybe<Scalars["String"]>;
};

export type BasicShoppingAppliedFilter = ShoppingAppliedFilter & {
  __typename?: "BasicShoppingAppliedFilter";
  /** Used to display a removable pill for an applied filter. */
  filter?: Maybe<EgdsPill>;
  /** Contains a relative path with the updated url params to match the new filter just triggered by a pill */
  linkUrl?: Maybe<UiLinkAction>;
  /** Search criteria that should be used when pill is triggered */
  nextSearchCriteria?: Maybe<ShoppingSearchCriteria>;
};

export type BedInfo = {
  __typename?: "BedInfo";
  quantity?: Maybe<Scalars["String"]>;
  size?: Maybe<Scalars["String"]>;
  type?: Maybe<Scalars["String"]>;
};

/** Bed types in more detail (Twin, Queen, King etc.) */
export type BedInformation = {
  __typename?: "BedInformation";
  englishType: Scalars["String"];
  type: Scalars["String"];
};

export type BedOptionViewModel = {
  __typename?: "BedOptionViewModel";
  bedInfo?: Maybe<Array<BedInfo>>;
  description?: Maybe<Scalars["String"]>;
  id?: Maybe<Scalars["String"]>;
};

/** Bed options in room */
export type BedOptions = {
  __typename?: "BedOptions";
  bedInfo: Array<BedInformation>;
  icon: Scalars["String"];
  name: Scalars["String"];
};

export type BestTimeToGo = {
  __typename?: "BestTimeToGo";
  impression: ClientSideAnalytics;
  monthlyHistoricalForecast: DestinationMonthlyHistoricalForecast;
  subtitle: EgdsSpannableText;
  title: Scalars["String"];
};

export type BexApiDateTime = {
  __typename?: "BexApiDateTime";
  day: Scalars["Int"];
  /**
   * Converts this date-time to the number of seconds from the epoch of 1970-01-01T00:00:00Z
   * @deprecated Use platform formatters and return localized strings instead
   */
  epochSeconds: Scalars["String"];
  /** Format a with a pattern. 'd MMM uuuu' will format 2011-12-03 as '3 Dec 2011' */
  formatted: Scalars["String"];
  /** Localized full date string e.g. en='Wed, Feb 26' de='Mi., 26. Feb.' */
  fullDateFormat?: Maybe<Scalars["String"]>;
  hour: Scalars["Int"];
  /** Localized long date string e.g. en='Feb 26, 2020' de='26. Feb. 2020' */
  longDateFormat?: Maybe<Scalars["String"]>;
  /** Localized medium date string e.g. en='Feb 26' de='26. Feb.' */
  mediumDateFormat?: Maybe<Scalars["String"]>;
  /** Localized medium time string e.g. en='11:06:15AM' de='11:06:20 Uhr' */
  mediumTimeFormat?: Maybe<Scalars["String"]>;
  minute: Scalars["Int"];
  month: Scalars["Int"];
  /**
   * Returns the posix format
   * @deprecated Use platform formatters and return localized strings instead
   */
  raw: Scalars["String"];
  second: Scalars["Int"];
  /** Localized short date string e.g. en='2/26/2020' de='26.02.2020' */
  shortDateFormat?: Maybe<Scalars["String"]>;
  /** Localized short time string e.g. en='11:06am' de='11:06 Uhr' */
  shortTimeFormat?: Maybe<Scalars["String"]>;
  /** @deprecated Use ZonedDateTime if you want time zone information, replace with ZonedDateTime */
  timeZoneOffsetSeconds: Scalars["Int"];
  year: Scalars["Int"];
};

export type BexApiDateTimeFormattedArgs = {
  format: Scalars["String"];
};

/** Type encapsulating title and body with each word having string and style to apply to it */
export type BodyElements = NotificationMessageCard | NotificationMultiBody | NotificationSimpleBody;

/** Response for a checkout booking */
export type BookResponse = {
  __typename?: "BookResponse";
  data?: Maybe<BookResponseType>;
};

export type BookResponseType = {
  __typename?: "BookResponseType";
  /** token used to keep track of and verify version */
  checkoutSessionToken: Scalars["String"];
  /** holds content that indicates the result of the booking */
  feedbackMessage?: Maybe<EgdsToast>;
  /** id for the successful order */
  orderId?: Maybe<Scalars["String"]>;
  /** list of signals from server-side that the ui modules will consume */
  signals: Array<CheckoutUiSignal>;
};

export type BookWithAirlinesDialog = FlightsDialogPresentation & {
  __typename?: "BookWithAirlinesDialog";
  /** List of all available actions in book on airlines site dialog */
  actions: Array<FlightsAction>;
  /** Animation used to display the book directly on airlines site dialog */
  animation: FlightsDialogAnimation;
  /** Represents the analytics to track on when the book directly on airlines site dialog is displayed */
  displayedAnalytics?: Maybe<FlightsAnalytics>;
  /**
   * Header of the book directly on airlines site dialog ex. You are leaving expedia
   * @deprecated deprecating header to introduce a new nullable field for title/header of dialog
   */
  header: Scalars["String"];
  /** Main message in the book directly on airlines site for booking dialog. eg. Continue to book on RyanAir.com. This will open in a new tab. */
  message?: Maybe<Scalars["String"]>;
  /** Title of the book directly on airlines site dialog. ex.Replacing non-nullable header field. eg.You are leaving expedia  */
  title?: Maybe<Scalars["String"]>;
};

/** Booking Servicing change query */
export type BookingServiceChange = {
  __typename?: "BookingServiceChange";
  /**
   * Change your flight
   * @deprecated Please use 'presentation' resolver
   */
  bookingServicingChangePresentation: BookingServicingChangePresentation;
  /** Returns messages related to booking changes (e.g. Information about change fees, seats or bags) */
  messagingElements: Array<BookingServicingMessagingElement>;
  /** Represents price break up for original booking */
  originalBookingPriceDetails: BookingServicingPriceDetails;
  /** Change your flight */
  presentation: BookingServicingChangePresentation;
};

/** Booking Servicing change query */
export type BookingServiceChangeBookingServicingChangePresentationArgs = {
  tripId: Scalars["String"];
};

/** Booking Servicing change query */
export type BookingServiceChangeMessagingElementsArgs = {
  originalBookingId: Scalars["String"];
};

/** Booking Servicing change query */
export type BookingServiceChangeOriginalBookingPriceDetailsArgs = {
  originalBookingId: Scalars["String"];
};

/** Booking Servicing change query */
export type BookingServiceChangePresentationArgs = {
  tripId: Scalars["String"];
};

/** Represents an button with a corresponding action to be performed by the clients upon clicking */
export type BookingServicingButton = {
  __typename?: "BookingServicingButton";
  /** Represents an EGDS button */
  button: EgdsButton;
  /** Represents the action to be performed on client side when button is pressed */
  clientAction: BookingServicingClientAction;
};

/** Represents an action to cancel */
export type BookingServicingCancellationAction = BookingServicingClientAction & {
  __typename?: "BookingServicingCancellationAction";
  /** Used to provide accessibility that has to be read on completion of action */
  accessibility?: Maybe<Scalars["String"]>;
  /** Used to capture client side analytics */
  analyticsList: Array<ClientSideAnalytics>;
};

/** Represents the booking cancellation page */
export type BookingServicingCancellationPresentation = {
  __typename?: "BookingServicingCancellationPresentation";
  /** List of main call to action buttons to show at the bottom of the page */
  actions?: Maybe<Array<BookingServicingClientActionElement>>;
  /** List of all the elements the page should render */
  content?: Maybe<Array<BookingServicingContentElement>>;
  /** Represents the page subtitle */
  subtitle?: Maybe<Scalars["String"]>;
  /** Represents the page title */
  title: Scalars["String"];
};

/** Represents the card containing summary for a cancellation flights + passenger + rules + refund */
export type BookingServicingCancellationSummaryContentElementCard = {
  __typename?: "BookingServicingCancellationSummaryContentElementCard";
  /** Represents a list of extra information */
  additionalInfo?: Maybe<Array<BookingServicingTextSection>>;
  /** Represents the heading */
  heading: Scalars["String"];
  /** Represents the refund cancellation price summary. */
  priceOverview: PricePresentation;
  /** Represents a column */
  primary: BookingServicingTextSection;
  /** Represents a column */
  secondary: BookingServicingTextSection;
  /** Represents the passenger Information to display */
  spannableSectionContent: Array<EgdsSpannableText>;
  /** Represents the flight information summary to display. */
  textSectionContent: Array<BookingServicingTextSection>;
};

/** Represents the various cards present in 'change your flight' page */
export type BookingServicingCard = {
  __typename?: "BookingServicingCard";
  /** Represents contents of the booking change page section */
  content: Array<BookingServicingCardElement>;
  /** Represents title of the booking change page section */
  title: Scalars["String"];
};

export type BookingServicingCardElement =
  | BookingServicingCheckboxesArea
  | BookingServicingSearchForm
  | BookingServicingText;

/** Represents 'Change your flight' page */
export type BookingServicingChangePresentation = {
  __typename?: "BookingServicingChangePresentation";
  /** Represents various sections present of the booking change page */
  sections?: Maybe<Array<BookingServicingElement>>;
  /** Represents the description/subtext of the booking change page */
  subText?: Maybe<Array<EgdsText>>;
  /** Represents the title of the booking change page */
  title: Scalars["String"];
};

/** Represents the checkboxes(apply to all or individual) used throughout the page */
export type BookingServicingCheckboxesArea = {
  __typename?: "BookingServicingCheckboxesArea";
  /** Represents apply all checkbox of the booking change page section */
  applyAll: EgdsBasicCheckBox;
  /** Represents individual checkbox area  of the booking change page section */
  individuals: Array<EgdsBasicCheckBox>;
};

/** Represents union of actions to be performed on client side when button is pressed */
export interface BookingServicingClientAction {
  /** Used to provide accessibility that has to be read on completion of action */
  accessibility?: Maybe<Scalars["String"]>;
  /** Represents the analytics to track when interacting with the given action */
  analyticsList: Array<ClientSideAnalytics>;
}

/** Represents union of action elements */
export type BookingServicingClientActionElement = BookingServicingButton;

/** Union of all possible elements we can show within a Booking Cancellation page */
export type BookingServicingContentElement =
  | BookingServicingCancellationSummaryContentElementCard
  | BookingServicingContentElementCard
  | BookingServicingElementListWrapper
  | BookingServicingElementWrapper
  | BookingServicingPriceSummary;

/** Represents the card containing journey details summary for a cancellation flights + passenger */
export type BookingServicingContentElementCard = {
  __typename?: "BookingServicingContentElementCard";
  /** Represents the description of the card */
  description?: Maybe<Scalars["String"]>;
  /** Represents the heading */
  heading: Scalars["String"];
  /** Information items to display with proper needed types. */
  primarySection: Array<BookingServicingTextSection>;
  /** Information items to display with proper needed types. */
  secondarySection?: Maybe<Array<BookingServicingTextSection>>;
};

export type BookingServicingElement = BookingServicingCard | BookingServicingText;

/** Represents a list of EGDS Elements to be rendered in a booking cancellation page */
export type BookingServicingElementListWrapper = {
  __typename?: "BookingServicingElementListWrapper";
  /** Represents a list of EGDS elements to be rendered */
  elements: Array<EgdsElement>;
};

/** Represents the banner or messaging card to be rendered in a booking cancellation page */
export type BookingServicingElementWrapper = {
  __typename?: "BookingServicingElementWrapper";
  /** Represents an EGDS element to be rendered */
  element: EgdsElement;
};

/** Target of the Link when clicked */
export type BookingServicingLinkTarget =
  /** Link will be opened in an external view e.g. new tab or browser window */
  | "EXTERNAL"
  /** Link will be opened in the same view where the user is currently e.g. same tab or webview inside an app */
  | "INTERNAL";

/** Represents EGDS messaging elements */
export type BookingServicingMessagingElement = EgdsStandardMessagingCard | UiBanner;

/** Represents 'Price Details' */
export type BookingServicingPriceDetails = {
  __typename?: "BookingServicingPriceDetails";
  /** Represents the content of the price details */
  content: PricePresentation;
  /** Represents the expando of the price details */
  expando: BookingServicingPriceExpando;
};

/** Represents 'Price expando' */
export type BookingServicingPriceExpando = {
  __typename?: "BookingServicingPriceExpando";
  /** Represents the collapsed label of the price details */
  collapsedLabel: BookingServicingText;
  /** Represents the expanded label of the price details */
  expandedLabel: BookingServicingText;
  /** Represents the expando card of the price details */
  expando: EgdsExpandoCard;
};

/** Represents the summary component */
export type BookingServicingPriceSummary = {
  __typename?: "BookingServicingPriceSummary";
  /** Represents a list of extra information */
  additionalInfo?: Maybe<Array<BookingServicingTextSection>>;
  /** Represents the title for the booking servicing summary component */
  heading: Scalars["String"];
  /** Represents the price summary overview */
  priceOverview: PricePresentation;
  /** Represents summary details expando and contents */
  summaryDetails?: Maybe<BookingServicingPriceSummaryDetails>;
};

/** Represents the summary details expando link and its contents */
export type BookingServicingPriceSummaryDetails = {
  __typename?: "BookingServicingPriceSummaryDetails";
  /** Represents the content of the expando */
  content: PricePresentation;
  /** Represents information about the expando */
  expando: EgdsExpandoLink;
};

export type BookingServicingQueryState = "LOADED" | "LOADING";

/** Represents an action to navigate to a URL */
export type BookingServicingResourceLinkAction = BookingServicingClientAction & {
  __typename?: "BookingServicingResourceLinkAction";
  /** Used to provide accessibility that has to be read on completion of action */
  accessibility?: Maybe<Scalars["String"]>;
  /** Used to capture client side analytics */
  analyticsList: Array<ClientSideAnalytics>;
  /** Used to link to a new resource URI */
  resource: Uri;
  target: BookingServicingLinkTarget;
};

/** Represents the flight search form used in the page */
export type BookingServicingSearchForm = {
  __typename?: "BookingServicingSearchForm";
  /** Represents search form  of the booking change page section */
  searchForm: FlightSearchInputForm;
};

/** Represents the various text used throughout the page */
export type BookingServicingText = {
  __typename?: "BookingServicingText";
  /** Represents text/description of the booking change page section */
  primary: EgdsText;
  secondary?: Maybe<EgdsText>;
};

/** Group of text elements. */
export type BookingServicingTextSection = {
  __typename?: "BookingServicingTextSection";
  /** List of text items to be displayed */
  contents?: Maybe<EgdsText>;
  /** List of text items to be displayed */
  title: EgdsText;
};

export type BoolRating = {
  __typename?: "BoolRating";
  boolValue?: Maybe<Scalars["Boolean"]>;
  default?: Maybe<Scalars["Boolean"]>;
  falseValue?: Maybe<RatingValueDetails>;
  trueValue?: Maybe<RatingValueDetails>;
};

export type BooleanEnum = "FALSE" | "TRUE";

/** Type used during a product search to specify a given boolean value like the fact customer would prefer to search for direct flights only. */
export type BooleanValue = {
  __typename?: "BooleanValue";
  id: Scalars["String"];
  value: Scalars["Boolean"];
};

/** Type used during a product search to specify a given boolean value like the fact customer would prefer to search for direct flights only. */
export interface BooleanValueInput {
  id: Scalars["String"];
  value: Scalars["Boolean"];
}

/** The coordinates used to determine the map bounds */
export type Bounds = {
  __typename?: "Bounds";
  /** The northeast coordinate used to determine the map bounds */
  northeast: Coordinates;
  /** The southwest coordinate used to determine the map bounds */
  southwest: Coordinates;
};

/** Represents the interface for Branded Deals fallback */
export type BrandedDealCrossSellFallback = MultiItemFlightCrossSellPrimer;

/** Contains list of banner content sections */
export type BrandedDealCrossSellUiContent = {
  __typename?: "BrandedDealCrossSellUIContent";
  primaryContent: BrandedDealCrossSellUiContentSection;
  secondaryContent: BrandedDealCrossSellUiContentSection;
};

/** Any UI element (content, text, link, button, etc) that is needed to build the cross sell UI */
export type BrandedDealCrossSellUiContentItem = BrandedDealCrossSellUiContent | EgdsStylizedText;

/** Contains a list of UI elements */
export type BrandedDealCrossSellUiContentSection = {
  __typename?: "BrandedDealCrossSellUIContentSection";
  details: Array<BrandedDealCrossSellUiElement>;
};

/** Any UI element (text, link, button, etc) that is needed to build the cross sell UI */
export type BrandedDealCrossSellUiElement =
  | BrandedDealCrossSellUiImageWithText
  | MultiItemCrossSellUiBadge
  | MultiItemCrossSellUiHeaderText
  | MultiItemCrossSellUiLinkAction
  | MultiItemCrossSellUiText;

export type BrandedDealCrossSellUiImageWithText = {
  __typename?: "BrandedDealCrossSellUIImageWithText";
  description: MultiItemCrossSellUiText;
  image: Image;
};

/** Contains data to power the branded deals banner */
export type BrandedDealCrossSellUiResponse = {
  __typename?: "BrandedDealCrossSellUIResponse";
  action: MultiItemCrossSellUiLinkAction;
  actionBar: Array<MultiItemCrossSellUiLinkAction>;
  /** @deprecated Use crossSellBadges instead */
  badges?: Maybe<Array<MultiItemCrossSellUiBadge>>;
  brandedDealContent: Array<BrandedDealCrossSellUiContentItem>;
  /** @deprecated Use brandedDealContent instead */
  contentSections: BrandedDealCrossSellUiContent;
  crossSellBadges: Array<EgdsProgramBadge>;
  impressionAnalytics: ClientSideAnalytics;
};

/** Represents the branded deal price of the product */
export type BrandedDealPrice = {
  __typename?: "BrandedDealPrice";
  /** Represents the base price of the product */
  base: Money;
  /** Represents the taxes and fees of the product */
  taxesAndFees: Money;
};

/** Represents the base product price */
export interface BrandedDealProductPriceInput {
  base: MoneyInput;
  taxesAndFees: MoneyInput;
}

export type Breadcrumb = BreadcrumbItem & {
  __typename?: "Breadcrumb";
  text: Scalars["String"];
  uiLinkAction: UiLinkAction;
};

/** Breadcrumbs data from Global Navigation */
export interface BreadcrumbItem {
  /** Text for BreadcrumbItem Link */
  text?: Maybe<Scalars["String"]>;
  /** Link to the BreadcrumbItem page */
  uiLinkAction?: Maybe<UiLinkAction>;
}

/** Breadcrumbs data from Global Navigation */
export type Breadcrumbs = {
  __typename?: "Breadcrumbs";
  /** Breadcrumbs List */
  breadcrumbItems: Array<BreadcrumbItem>;
  /** Client-side impression event analytics */
  impressionAnalytics: ClientSideImpressionEventAnalytics;
  /** Client-side Breadcrumbs menu click event analytics */
  menuAnalytics?: Maybe<ClientSideAnalytics>;
  /** Required SEO data for google bots to show a preview of the breadcrumbs in the search box. */
  seoStructuredData: Scalars["String"];
};

/** Browse request to get articles */
export interface BrowseKnowledgeBaseInput {
  /** Specify specific category from product to retrieve articles */
  category?: InputMaybe<Scalars["String"]>;
  context: ContextInput;
  /** Specify article id to get article data */
  helpArticleId?: InputMaybe<Scalars["String"]>;
  /** Specify specific product from homepage to retrieve articles */
  product?: InputMaybe<Scalars["String"]>;
}

export type BulletStyle = "DEFAULT" | "ICON_ALTERNATE" | "ICON_STANDARD" | "NO_BULLET" | "UNRECOGNIZED";

/** Indicate the business model type of a given offer */
export type BusinessModelType = "EXPEDIA_COLLECT" | "HOTEL_COLLECT";

export interface CdfFeedbackInput {
  context: Array<GraphQlPairInput>;
  formValues: Array<GraphQlPairInput>;
}

export type CdfFieldError = {
  __typename?: "CDFFieldError";
  error: Scalars["String"];
  fieldId: Scalars["ID"];
};

export type CdfFieldSet = {
  __typename?: "CDFFieldSet";
  elements: Array<CdfFieldSetElement>;
  label: Scalars["String"];
};

export type CdfFieldSetElement = CdfInputField | CdfRadioGroup | CdfTextArea | EgdsPlainText;

export type CdfFormPage = {
  __typename?: "CDFFormPage";
  displayCondition?: Maybe<CdfPageDisplayCondition>;
  elements: Array<CdfFormPageElement>;
  submitButton: UiPrimaryButton;
  title?: Maybe<Scalars["String"]>;
};

export type CdfFormPageElement = CdfFieldSet | CdfInputField | CdfRadioGroup | CdfTextArea | EgdsPlainText;

export type CdfFormValidation = {
  __typename?: "CDFFormValidation";
  errors: Array<CdfFieldError>;
};

export type CdfInputField = EgdsInputField & {
  __typename?: "CDFInputField";
  errorMessage?: Maybe<Scalars["String"]>;
  instructions?: Maybe<Scalars["String"]>;
  label?: Maybe<Scalars["String"]>;
  labelTemplate?: Maybe<EgdsLocalizedText>;
  leftIcon?: Maybe<Icon>;
  placeholder?: Maybe<Scalars["String"]>;
  /** Field is in a read-only state displaying only text when readOnly is true. */
  readOnly: Scalars["Boolean"];
  required?: Maybe<Scalars["Boolean"]>;
  rightIcon?: Maybe<Icon>;
  validations?: Maybe<Array<EgdsInputValidation>>;
  value?: Maybe<Scalars["String"]>;
};

export type CdfOpenFormAction = UiAction & {
  __typename?: "CDFOpenFormAction";
  accessibility?: Maybe<Scalars["String"]>;
  analytics: ClientSideAnalytics;
  promptId?: Maybe<Scalars["String"]>;
};

export type CdfOpenNextPageAction = UiAction & {
  __typename?: "CDFOpenNextPageAction";
  accessibility?: Maybe<Scalars["String"]>;
  analytics: ClientSideAnalytics;
};

export type CdfPageDisplayCondition = {
  __typename?: "CDFPageDisplayCondition";
  conditionType: CdfPageDisplayConditionType;
  expectedValue: Scalars["String"];
  fieldId: Scalars["ID"];
};

export type CdfPageDisplayConditionType = "BOOL" | "NONE" | "PATTERN" | "TEXT";

export type CdfPrompt = {
  __typename?: "CDFPrompt";
  callToAction?: Maybe<UiTertiaryButton>;
  pages: Array<CdfFormPage>;
  title?: Maybe<Scalars["String"]>;
};

export type CdfRadioButton = EgdsRadioButton & {
  __typename?: "CDFRadioButton";
  description?: Maybe<Scalars["String"]>;
  disabled: Scalars["Boolean"];
  label: Scalars["String"];
  labelSuffix?: Maybe<Scalars["String"]>;
  value: Scalars["String"];
};

export type CdfRadioGroup = EgdsRadioGroup & {
  __typename?: "CDFRadioGroup";
  errorMessage?: Maybe<Scalars["String"]>;
  groupName: Scalars["String"];
  options: Array<EgdsRadioButton>;
  required?: Maybe<Scalars["Boolean"]>;
  selected?: Maybe<Scalars["String"]>;
};

export type CdfSubmitFormAction = UiAction & {
  __typename?: "CDFSubmitFormAction";
  accessibility?: Maybe<Scalars["String"]>;
  analytics: ClientSideAnalytics;
};

export type CdfTextArea = EgdsInputField & {
  __typename?: "CDFTextArea";
  errorMessage: Scalars["String"];
  instructions?: Maybe<Scalars["String"]>;
  isEditable: Scalars["Boolean"];
  label: Scalars["String"];
  labelTemplate?: Maybe<EgdsLocalizedText>;
  leftIcon?: Maybe<Icon>;
  maxRows?: Maybe<Scalars["Int"]>;
  minRows?: Maybe<Scalars["Int"]>;
  placeholder?: Maybe<Scalars["String"]>;
  /** Field is in a read-only state displaying only text when readOnly is true. */
  readOnly: Scalars["Boolean"];
  required?: Maybe<Scalars["Boolean"]>;
  rightIcon?: Maybe<Icon>;
  validations?: Maybe<Array<EgdsInputValidation>>;
  value?: Maybe<Scalars["String"]>;
};

/** Represents an error message received */
export type CampaignConfigErrorResponse = {
  __typename?: "CampaignConfigErrorResponse";
  message: Scalars["String"];
};

/** Hero heading section */
export type CampaignConfigHero = {
  __typename?: "CampaignConfigHero";
  /** Main hero title */
  primaryText: Scalars["String"];
  /** Secondary hero sub-title */
  secondaryText?: Maybe<Scalars["String"]>;
};

/** A Property */
export type CampaignConfigProperty = {
  __typename?: "CampaignConfigProperty";
  /** The Property city */
  city?: Maybe<Scalars["String"]>;
  /** The Property group ids that this Property belongs to */
  propertyGroupIds: Array<Scalars["Int"]>;
  /** The Property id */
  propertyId?: Maybe<Scalars["Int"]>;
  /** The Property's name */
  propertyName?: Maybe<Scalars["String"]>;
};

export type CampaignContentPaginationInfo = {
  __typename?: "CampaignContentPaginationInfo";
  currentPage: Scalars["Int"];
  hasMoreContentPages: Scalars["Boolean"];
};

/** Object holding offerService URL */
export type CampaignDescriptions = {
  __typename?: "CampaignDescriptions";
  /** Returns full description */
  long?: Maybe<Scalars["String"]>;
  /** Returns abbreviated description */
  short?: Maybe<Scalars["String"]>;
};

/** A recommended campaign */
export type CampaignDetail = {
  __typename?: "CampaignDetail";
  /** Campaign Image on the Launch Page Tiles */
  banner: Image;
  /** Content (offers or destinations) pagination information for the campaign */
  campaignContentPaginationInfo?: Maybe<CampaignContentPaginationInfo>;
  /** Deep link Type could be either a Hotel Search Result url, or a Property Details Page (hotel info site) */
  deeplinkType?: Maybe<DeeplinkType>;
  /** Offer service URL that returns destination view of deals or offers in response */
  description: CampaignDescriptions;
  /** @deprecated No longer relevant, replace with OffersUrl.url */
  destinationUrl?: Maybe<Scalars["String"]>;
  /** Campaign origin city */
  fromOriginHeaderText?: Maybe<Scalars["String"]>;
  /** Campaign title or heading that describes campaign intent for travelers */
  headline: Scalars["String"];
  /** Campaign Identifier for tracking campaign impressions and clicks */
  id: Scalars["String"];
  /** Bespoke URL for landing on custom landing page */
  landingPageUrl?: Maybe<Scalars["URL"]>;
  /** List of offers for campaign */
  offers?: Maybe<Array<OfferItem>>;
  /** Offer service URL that returns inventory view of deals or offers in response */
  offersUrl: OffersUrl;
  /** Product types */
  productTypes: Array<Scalars["String"]>;
  /** Recommended view type */
  recommendedType: RecommendedType;
  /** Distribution response id sent as referrer to stitch two calls made by tile view clients */
  referrer: Scalars["String"];
  /** Terms and Conditions related to the campaign */
  termsAndConditions: Scalars["String"];
};

/** A recommended campaign */
export type CampaignDetailOffersArgs = {
  numberOfDestinations?: InputMaybe<Scalars["Int"]>;
};

export type CampaignOfferBadge = {
  __typename?: "CampaignOfferBadge";
  /** Icon to display */
  icon?: Maybe<Icon>;
  /** Text or label that should be displayed in badge */
  text?: Maybe<Scalars["String"]>;
  /** Type of badge */
  type: CampaignOfferBadgeType;
};

export type CampaignOfferBadgeType = "DEFAULT" | "DISCOUNT";

/** Campaign pagination information */
export type CampaignPagination = {
  __typename?: "CampaignPagination";
  hasNextPage: Scalars["Boolean"];
  /** Referrer passed in request, or distribution response id if the referrer in request is empty. Used to stitch consecutive paginated calls */
  referrer: Scalars["String"];
};

export interface CampaignParametersInput {
  campaignId: Scalars["String"];
  contentPagination?: InputMaybe<ContentPaginationInput>;
  propertyParameters?: InputMaybe<CampaignPropertyParametersInput>;
}

export type CampaignProductType = "ACTIVITY" | "FLIGHT" | "HOTEL" | "PACKAGE";

export interface CampaignPropertyParametersInput {
  guestRating?: InputMaybe<Scalars["Float"]>;
  propertyId: Scalars["String"];
  starRating?: InputMaybe<Scalars["Float"]>;
  type?: InputMaybe<PropertyDetailsPropertyType>;
}

/** Implementation of dialog content interface for cancellation policy dialog */
export type CancellationPolicyDialogContentEntry = DialogContentEntry & {
  __typename?: "CancellationPolicyDialogContentEntry";
  entryContent: Array<Scalars["String"]>;
  entryTitle: LodgingHeader;
};

export interface CancellationWaiverDeclineRequestContext {
  bookingItemId: Scalars["String"];
  message?: InputMaybe<Scalars["String"]>;
  reason: Scalars["String"];
  serviceRequestId: Scalars["String"];
}

export type CarAccessory = {
  __typename?: "CarAccessory";
  accessibility: Scalars["String"];
  analytics: CarAnalytics;
  id: Scalars["String"];
  name: Scalars["String"];
  price?: Maybe<Scalars["String"]>;
  pricePeriod?: Maybe<Scalars["String"]>;
  selectionState: CarAccessorySelectionState;
  text?: Maybe<Scalars["String"]>;
  token?: Maybe<Scalars["String"]>;
};

export type CarAccessorySelectionState = "NOT_SELECTED" | "SELECTED";

export type CarAction = {
  __typename?: "CarAction";
  accessibility?: Maybe<Scalars["String"]>;
  actionType: CarActionType;
  analytics?: Maybe<CarAnalytics>;
};

export type CarActionType =
  /** Apply loyalty points to offer */
  | "APPLY_LOYALTY_POINTS"
  /** Click map marker */
  | "CAR_MAP_MARKER"
  /** Change Search */
  | "CHANGE_SEARCH"
  /** Dismisses a dialog */
  | "DISMISS"
  /** Click to filter car sales */
  | "FILTER_SALE_OFFER"
  /** Submit content to server */
  | "FORM_SUBMISSION"
  /** Go back to search page to see all cars */
  | "GO_BACK_TO_SEARCH"
  /** Open cancellation policy link */
  | "GO_TO_CANCELLATION_POLICY"
  /** Continues to the standalone details page */
  | "GO_TO_CHECKOUT"
  /** Open dialog to see cleaning and safety practices */
  | "GO_TO_CLEANLINESS_DIALOG"
  /** Continues to the standalone details page */
  | "GO_TO_DETAILS"
  /** Continues to the packages path */
  | "GO_TO_PACKAGES"
  /** Open recommended sort FAQ page */
  | "GO_TO_RECOMMENDED_SORT_FAQ"
  /** Continues to the user sign in page */
  | "GO_TO_SIGNIN"
  /** Continues to the user sign up page */
  | "GO_TO_SIGNUP"
  /** Click to sign in and unlock car sales */
  | "GO_TO_SIGN_IN_AND_UNLOCK_CAR_SALES"
  /** Load more results to search page */
  | "LOAD_MORE"
  /** Change Search */
  | "OFF_AIRPORT_CHANGE_SEARCH"
  /** Opens a dialog */
  | "OPEN_DIALOG"
  /** Open merchant rules in iframe */
  | "OPEN_DOC"
  /** Open ground transfers page */
  | "OPEN_GROUND_TRANSFERS"
  /** Opens the inline time wizard */
  | "OPEN_INLINE_TIME_WIZARD"
  /** Opens the inline search wizard */
  | "OPEN_INLINE_WIZARD"
  /** Opens a new tab */
  | "OPEN_NEW_TAB"
  /** Opens on current tab */
  | "OPEN_ON_CURRENT_TAB"
  /** Open vendor rules from domain rules */
  | "OPEN_RULE"
  /** Used to open Telephone Link */
  | "OPEN_TEL"
  /** Refreshes the current page */
  | "REFRESH"
  /** Remove loyalty points to offer */
  | "REMOVE_LOYALTY_POINTS"
  /** Click see cars on map marker item card */
  | "SEE_CARS_AT_MAP_MARKER"
  /** Open share feedback form */
  | "SHARE_FEEDBACK"
  /** Show offers with AARP Exclusive benefits */
  | "SHOW_AARP_EXCLUSIVE_OFFERS"
  /** Show offers with free cancellations */
  | "SHOW_FREE_CANCELLATION_OFFERS"
  /** Click to unlock car sales */
  | "UNLOCK_CAR_SALES";

export type CarActionableItem = {
  __typename?: "CarActionableItem";
  action: CarAction;
  icon?: Maybe<Icon>;
  tel?: Maybe<TelUri>;
  text: Scalars["String"];
  url?: Maybe<HttpUri>;
};

export type CarAdditionalBenefits = {
  __typename?: "CarAdditionalBenefits";
  benefits: Array<CarPhraseIconText>;
  headingText: Scalars["String"];
};

export type CarAnalytics = {
  __typename?: "CarAnalytics";
  linkName: Scalars["String"];
  referrerId: Scalars["String"];
};

export type CarAppliedSortAndFilter = {
  __typename?: "CarAppliedSortAndFilter";
  analytics: ClientSideAnalytics;
  crossIcon: Icon;
  id: Scalars["String"];
  text: Scalars["String"];
  value: Scalars["String"];
};

export type CarAppliedSortAndFilters = {
  __typename?: "CarAppliedSortAndFilters";
  appliedSortAndFilters: Array<CarAppliedSortAndFilter>;
};

export type CarAvailableAccessories = {
  __typename?: "CarAvailableAccessories";
  accessories: Array<CarAccessory>;
  description: Scalars["String"];
  title: Scalars["String"];
};

export type CarBreakupComponent = {
  __typename?: "CarBreakupComponent";
  id: Scalars["String"];
  lineItems: Array<CarBreakupLineItem>;
  title: Scalars["String"];
};

export type CarBreakupLineItem = {
  __typename?: "CarBreakupLineItem";
  accessibility?: Maybe<Scalars["String"]>;
  dialogContent?: Maybe<CarPriceBreakupDialog>;
  icon?: Maybe<Icon>;
  mark?: Maybe<Mark>;
  openDialogAction?: Maybe<CarAction>;
  subText?: Maybe<Scalars["String"]>;
  text: Scalars["String"];
  value: Scalars["String"];
};

export type CarBreakupSummarySection = {
  __typename?: "CarBreakupSummarySection";
  lineItems: Array<CarBreakupLineItem>;
  notIncludedInTotal?: Maybe<CarBreakupComponent>;
  title: Scalars["String"];
  total: Scalars["String"];
};

export type CarButton = {
  __typename?: "CarButton";
  analytics?: Maybe<CarAnalytics>;
  text: Scalars["String"];
};

export type CarDetailContext = {
  __typename?: "CarDetailContext";
  carOfferToken: Scalars["String"];
  /** Encoded string having certain offer information shown on search page. Eg. priceShown, avg category price */
  continuationContextualId?: Maybe<Scalars["String"]>;
  optionAction?: Maybe<CarAccessorySelectionState>;
  optionToken?: Maybe<Scalars["String"]>;
  principalToken?: Maybe<Scalars["String"]>;
  rewardPointsSelection?: Maybe<RewardsPointSelectionEnum>;
  selectedAccessories?: Maybe<Array<Scalars["String"]>>;
};

export interface CarDetailContextInput {
  carOfferToken: Scalars["String"];
  /** Encoded string having certain offer information shown on search page. Eg. priceShown, avg category price */
  continuationContextualId?: InputMaybe<Scalars["String"]>;
  optionAction?: InputMaybe<CarAccessorySelectionState>;
  optionToken?: InputMaybe<Scalars["String"]>;
  principalToken?: InputMaybe<Scalars["String"]>;
  rewardPointsSelection?: InputMaybe<RewardsPointSelectionEnum>;
  selectedAccessories?: InputMaybe<Array<Scalars["String"]>>;
}

export type CarDetailsResult = {
  __typename?: "CarDetailsResult";
  actionableConfidenceMessages: Array<CarPhrase>;
  additionalBenefits?: Maybe<CarAdditionalBenefits>;
  adsTargetingData?: Maybe<AdsTargetingData>;
  availableAccessories?: Maybe<CarAvailableAccessories>;
  carOfferToken?: Maybe<Scalars["String"]>;
  carSearchLink?: Maybe<CarActionableItem>;
  deal?: Maybe<CarMessagingCard>;
  detailSummary: CarDetailsSummary;
  detailsNavTabs?: Maybe<DetailsNavTabs>;
  dropOffCharge?: Maybe<CarMessagingCard>;
  easeCancel?: Maybe<CarMessagingCard>;
  enhancedCleanlinessInfo?: Maybe<EnhancedCleanlinessInfo>;
  importantInfo: CarImportantInfo;
  inclusionsDetail?: Maybe<CarInclusionsDetail>;
  insurancePriming?: Maybe<CarInsurancePriming>;
  loyaltyInfo?: Maybe<Array<CarPhrase>>;
  offerBadges?: Maybe<Array<CarOfferBadge>>;
  onlineCheckInInfo?: Maybe<CarOnlineCheckIn>;
  pairConfidenceMessages?: Maybe<Array<CarPhrase>>;
  priceAlert?: Maybe<CarMessagingCard>;
  priceDetails?: Maybe<CarPriceDetails>;
  priceSummary: CarPriceSummary;
  promotions: Array<CarPromotion>;
  rentalLocations: CarRentalLocations;
  rentalProtectionInfo?: Maybe<RentalProtectionInfo>;
  reserveAction: CarActionableItem;
  reviewsSummary?: Maybe<CarReviewsSummary>;
  saleUnlocked?: Maybe<CarMessagingCard>;
  shareFeedbackAction?: Maybe<CarShareFeedbackAction>;
  skipTheCounterInfo?: Maybe<CarSkipTheCounterInfo>;
  telesales?: Maybe<CarTelesales>;
  variantsSummary?: Maybe<CarVariantsSummary>;
  vehicle?: Maybe<VehicleDetails>;
  vendor: CarVendor;
};

export type CarDetailsSummary = {
  __typename?: "CarDetailsSummary";
  pageTitle: Scalars["String"];
};

export type CarDialogConfidenceMessage = {
  __typename?: "CarDialogConfidenceMessage";
  dialogContent?: Maybe<CarsDialog>;
  icon?: Maybe<Icon>;
  iconMobileRender: Scalars["Boolean"];
  openDialogAction?: Maybe<CarAction>;
  text: Scalars["String"];
};

export type CarDisclaimerDialog = {
  __typename?: "CarDisclaimerDialog";
  closeAnalytics: CarAnalytics;
  /** @deprecated use contents instead */
  content: Array<CarPhrase>;
  contents: Array<Array<CarPhrase>>;
  feedback?: Maybe<UserFeedback>;
};

export type CarDropOffOfferCard = {
  __typename?: "CarDropOffOfferCard";
  carPriceDetail: CarPriceDetail;
  detailsContext: CarDetailContext;
  selectButton: CarActionableItem;
  tripLocations: CarOfferVendorLocations;
  vehicle: VehicleDetails;
  vendor: CarVendor;
  viewMap: CarActionableItem;
};

export type CarDropOffTitle = {
  __typename?: "CarDropOffTitle";
  action: CarAction;
  icon: Icon;
  text: Scalars["String"];
  url?: Maybe<Scalars["String"]>;
};

export type CarFormatStyle = "IFRAME" | "LIST";

export type CarImportantInfo = {
  __typename?: "CarImportantInfo";
  importantInfoItems: Array<CarImportantInfoItems>;
  infos: Array<Scalars["String"]>;
  rulesAndRestrictions: CarActionableItem;
  title: Scalars["String"];
};

export type CarImportantInfoItems = {
  __typename?: "CarImportantInfoItems";
  analytics: CarAnalytics;
  description: Array<Scalars["String"]>;
  name: Scalars["String"];
  subtext: Scalars["String"];
};

export type CarInclusion = {
  __typename?: "CarInclusion";
  analytics: CarAnalytics;
  description?: Maybe<Scalars["String"]>;
  icon?: Maybe<Icon>;
  summary?: Maybe<Scalars["String"]>;
  title: Scalars["String"];
};

export type CarInclusionsDetail = {
  __typename?: "CarInclusionsDetail";
  inclusions: Array<CarInclusion>;
  text: Scalars["String"];
  title: Scalars["String"];
};

export type CarInsurancePriming = {
  __typename?: "CarInsurancePriming";
  icon: Icon;
  text: Scalars["String"];
};

export type CarItemCardMapMarker = CarMapMarker & {
  __typename?: "CarItemCardMapMarker";
  action: CarAction;
  coordinates: Coordinates;
  itemCard: CarMapItemCard;
  type: CarMapMarkerType;
};

/** Represents the various types of listings available */
export type CarListingCard = CarMessagingCard | CarOfferCard | CarSaleCard;

export type CarLoadMoreAction = {
  __typename?: "CarLoadMoreAction";
  action: CarAction;
  icon: Icon;
  searchPagination: CarSearchPagination;
  text: Scalars["String"];
};

export type CarMap = {
  __typename?: "CarMap";
  bounds: CarMapBounds;
  center: Coordinates;
  closeAction: CarAction;
  closeIcon: Icon;
  filterTitle?: Maybe<Scalars["String"]>;
  mapButton: CarActionableItem;
  mapSearchThisAreaButton?: Maybe<CarActionableItem>;
  markers: Array<CarMapMarker>;
  text: Scalars["String"];
  title: Scalars["String"];
  zoomLevel: Scalars["Int"];
};

export type CarMapBounds = {
  __typename?: "CarMapBounds";
  northeast: Coordinates;
  southwest: Coordinates;
};

export type CarMapDropOffLocationCard = {
  __typename?: "CarMapDropOffLocationCard";
  address: Scalars["String"];
  carPriceDetail: CarPriceDetail;
  detailsContext: CarDetailContext;
  distance: Scalars["String"];
  selectButton: CarActionableItem;
  superlative: Scalars["String"];
  vendorImage: Image;
  vendorLocationId: Scalars["String"];
};

export type CarMapItemCard = CarMapDropOffLocationCard | CarMapPickupLocationCard | CarMapSearchLocationCard;

export interface CarMapMarker {
  action: CarAction;
  coordinates: Coordinates;
  type: CarMapMarkerType;
}

export type CarMapMarkerType = "CarMarker" | "PlaceMarker";

export type CarMapPickupLocationCard = {
  __typename?: "CarMapPickupLocationCard";
  action: CarAction;
  address: Scalars["String"];
  distance: Scalars["String"];
  priceSummary: CarPriceSummary;
  seeCarsButtonText: Scalars["String"];
  superlative: Scalars["String"];
  vendorImage: Image;
  vendorLocationId: Scalars["String"];
};

export type CarMapSearchLocationCard = {
  __typename?: "CarMapSearchLocationCard";
  text: Scalars["String"];
  title: Scalars["String"];
};

export type CarMessagingCard = {
  __typename?: "CarMessagingCard";
  analytics?: Maybe<CarAnalytics>;
  carRecommendations?: Maybe<Array<Maybe<CarRecommendations>>>;
  cardDescriptions: Array<CarPhraseText>;
  cardTitle?: Maybe<CarsRichText>;
  /** @deprecated use cardDescriptions instead */
  description: Scalars["String"];
  /** @deprecated use cardDescriptions instead */
  descriptions: Array<Scalars["String"]>;
  dialog?: Maybe<CarsDialog>;
  icon?: Maybe<Icon>;
  illustrationURL?: Maybe<HttpUri>;
  image?: Maybe<Image>;
  links: Array<CarActionableItem>;
  mark?: Maybe<Scalars["String"]>;
  /** @deprecated use cardTitle instead */
  title?: Maybe<Scalars["String"]>;
};

/** Minimum set of data used to retrieve details about a car product */
export type CarNaturalKey = {
  __typename?: "CarNaturalKey";
  offerToken: Scalars["String"];
  specialEquipments?: Maybe<Array<SpecialEquipment>>;
};

/** Minimum set of data used to retrieve details about a car product */
export interface CarNaturalKeyInput {
  offerToken: Scalars["String"];
  specialEquipments?: InputMaybe<Array<SpecialEquipment>>;
}

export type CarOfferBadge = {
  __typename?: "CarOfferBadge";
  icon?: Maybe<Icon>;
  mark?: Maybe<Mark>;
  text: Scalars["String"];
  theme: Scalars["String"];
};

export type CarOfferCard = {
  __typename?: "CarOfferCard";
  accessibilityString?: Maybe<Scalars["String"]>;
  action: CarAction;
  actionableConfidenceMessages: Array<CarPhrase>;
  additionalBenefits?: Maybe<Array<CarPhraseIconText>>;
  cancellationAndPaymentMessages?: Maybe<Array<CarPhrase>>;
  clubbedPriceOptions?: Maybe<ClubbedPriceOptions>;
  detailsContext: CarDetailContext;
  enhancedCleanlinessDialog?: Maybe<EnhancedCleanlinessDialog>;
  guaranteedAnalytics?: Maybe<CarAnalytics>;
  infositeURL: HttpUri;
  isFareComparisonTestEnabled?: Maybe<Scalars["Boolean"]>;
  /** Represents the tokenized string representation of the full multi-item price and breakdowns */
  multiItemPriceToken?: Maybe<Scalars["String"]>;
  offerBadges: Array<CarOfferBadge>;
  offerHeading?: Maybe<Scalars["String"]>;
  priceBadges: Array<CarOfferBadge>;
  priceSummary: CarPriceSummary;
  priceSummaryText?: Maybe<Scalars["String"]>;
  reserveButtonText: Scalars["String"];
  review?: Maybe<CarOfferReview>;
  shortList: CarShortList;
  tripLocations: CarOfferVendorLocations;
  unlockOffer?: Maybe<CarActionableItem>;
  vehicle: VehicleDetails;
  vendor: CarVendor;
};

export type CarOfferLocationInfo = {
  __typename?: "CarOfferLocationInfo";
  locationSubInfo?: Maybe<Array<Scalars["String"]>>;
  text: Scalars["String"];
};

export type CarOfferLocations = {
  __typename?: "CarOfferLocations";
  dropOffLocation?: Maybe<CarOfferLocationInfo>;
  pickUpLocation: CarOfferLocationInfo;
};

export type CarOfferReview = {
  __typename?: "CarOfferReview";
  rating: Scalars["String"];
  richRatingText?: Maybe<CarsRichText>;
  superlative: Scalars["String"];
  totalCount?: Maybe<Scalars["String"]>;
};

export type CarOfferVendorLocationInfo = {
  __typename?: "CarOfferVendorLocationInfo";
  icon: Icon;
  locationSubInfo?: Maybe<Array<Scalars["String"]>>;
  text: Scalars["String"];
};

export type CarOfferVendorLocations = {
  __typename?: "CarOfferVendorLocations";
  /** drop can be null if pickup and drop are at same location-search page */
  dropOffLocation?: Maybe<CarOfferVendorLocationInfo>;
  pickUpLocation: CarOfferVendorLocationInfo;
};

export type CarOnlineCheckIn = {
  __typename?: "CarOnlineCheckIn";
  infos: Array<CarPhrase>;
  title: Scalars["String"];
};

export type CarPaymentInfo = {
  __typename?: "CarPaymentInfo";
  additionalPaymentInfo?: Maybe<Array<Scalars["String"]>>;
  icon: Icon;
  text: Scalars["String"];
};

export type CarPhrase =
  | CarActionableItem
  | CarDialogConfidenceMessage
  | CarOfferBadge
  | CarPhraseHtmlText
  | CarPhraseIconText
  | CarPhraseMark
  | CarPhrasePairText
  | CarPhraseText
  | CarsRichText;

export type CarPhraseHtmlText = {
  __typename?: "CarPhraseHTMLText";
  placeholderTextUrl?: Maybe<Array<CarActionableItem>>;
  value: CarPhraseText;
};

export type CarPhraseIconText = {
  __typename?: "CarPhraseIconText";
  icon?: Maybe<Icon>;
  text: Scalars["String"];
  theme?: Maybe<Scalars["String"]>;
};

export type CarPhraseMark = {
  __typename?: "CarPhraseMark";
  description: Scalars["String"];
  name: Scalars["String"];
  text: Scalars["String"];
  url?: Maybe<HttpUri>;
};

export type CarPhrasePairText = {
  __typename?: "CarPhrasePairText";
  richSubText?: Maybe<CarsRichText>;
  richText?: Maybe<CarsRichText>;
};

export type CarPhraseText = {
  __typename?: "CarPhraseText";
  text: Scalars["String"];
};

export type CarPriceBreakupDialog = {
  __typename?: "CarPriceBreakupDialog";
  breakupContent?: Maybe<Array<CarBreakupLineItem>>;
  commonDialog: CarsDialog;
};

export type CarPriceDetail = {
  __typename?: "CarPriceDetail";
  priceSubInfo?: Maybe<Array<Scalars["String"]>>;
  priceTitle: Scalars["String"];
};

export type CarPriceDetails = {
  __typename?: "CarPriceDetails";
  breakupSection: Array<CarBreakupComponent>;
  closeAction: CarAction;
  closeIcon: Icon;
  priceDetailsButton: CarActionableItem;
  summary: CarBreakupSummarySection;
  title: Scalars["String"];
};

/** price info */
export type CarPriceInfo = {
  __typename?: "CarPriceInfo";
  /** accessibility reading */
  accessibility?: Maybe<Scalars["String"]>;
  formattedValue?: Maybe<Scalars["String"]>;
  /** price of car offer */
  price: Money;
  /** Sample :  per week, total */
  qualifier: Scalars["String"];
  rawPrice?: Maybe<Scalars["Float"]>;
};

/** price summary */
export type CarPriceSummary = {
  __typename?: "CarPriceSummary";
  /** passing single string for accessibility for price */
  accessibility?: Maybe<Scalars["String"]>;
  /** discount percentage badge */
  discountBadge?: Maybe<CarOfferBadge>;
  /** price as per min period daily/weekly/monthly */
  lead?: Maybe<CarPriceInfo>;
  /** Loyalty points option for points display */
  loyaltyPointsOption?: Maybe<LoyaltyPointsOption>;
  /** payment caption. Ex payNow */
  paymentInfo?: Maybe<CarPaymentInfo>;
  /** passing price additional info like With points applied */
  priceAdditionalInfo?: Maybe<Array<Scalars["String"]>>;
  /** strikeout/reference price */
  reference?: Maybe<CarReferencePriceInfo>;
  /** Boolean to indicate if the strike-through price should be displayed first before the lead price */
  strikeThroughFirst?: Maybe<Scalars["Boolean"]>;
  /** total price */
  total: CarPriceInfo;
};

export type CarPromotion = {
  __typename?: "CarPromotion";
  /** this is used for tool tip text */
  additionalInfo?: Maybe<Scalars["String"]>;
  icon: Icon;
  text: Scalars["String"];
};

export interface CarRecommendationCard {
  action?: Maybe<CarAction>;
  icon?: Maybe<Icon>;
}

export type CarRecommendations = {
  __typename?: "CarRecommendations";
  analytics?: Maybe<Array<CarAnalytics>>;
  carRecommendationsCards?: Maybe<Array<CarRecommendationCard>>;
  heading?: Maybe<Scalars["String"]>;
};

export type CarReferencePriceInfo = {
  __typename?: "CarReferencePriceInfo";
  /**
   * accessibility reading
   * @deprecated Use price summary accessibility string
   */
  accessibility?: Maybe<Scalars["String"]>;
  /** used for tool tip for strikeout/reference price */
  additionalInfo?: Maybe<Scalars["String"]>;
  /** reference price */
  price: Money;
};

/** Provides the car rental location information */
export type CarRentalLocation = {
  __typename?: "CarRentalLocation";
  airportCode?: Maybe<Scalars["String"]>;
  coordinates?: Maybe<Coordinates>;
  isExactLocationSearch?: Maybe<Scalars["Boolean"]>;
  regionId?: Maybe<Scalars["String"]>;
  searchTerm?: Maybe<Scalars["String"]>;
};

export type CarRentalLocationDetail = {
  __typename?: "CarRentalLocationDetail";
  address: CarVendorLocationInfo;
  dateTime: CarVendorLocationInfo;
  hoursOfOperation?: Maybe<CarVendorLocationInfo>;
  instruction?: Maybe<CarVendorLocationInfo>;
  title: Scalars["String"];
};

/** Provides the car rental location information */
export interface CarRentalLocationInput {
  airportCode?: InputMaybe<Scalars["String"]>;
  coordinates?: InputMaybe<CoordinatesInput>;
  isExactLocationSearch?: InputMaybe<Scalars["Boolean"]>;
  regionId?: InputMaybe<Scalars["String"]>;
  searchTerm?: InputMaybe<Scalars["String"]>;
}

export type CarRentalLocations = {
  __typename?: "CarRentalLocations";
  dropOffLocation: CarRentalLocationDetail;
  isLocationDataMerged: Scalars["Boolean"];
  pickUpLocation: CarRentalLocationDetail;
  title: Scalars["String"];
};

export type CarReview = {
  __typename?: "CarReview";
  author?: Maybe<Scalars["String"]>;
  classificationName: Scalars["String"];
  expandButton: ExpandButton;
  rentalDuration?: Maybe<Scalars["String"]>;
  submissionTime: Scalars["String"];
  text: Scalars["String"];
  themes?: Maybe<Array<CarReviewThemes>>;
};

export type CarReviewDialogContent = {
  __typename?: "CarReviewDialogContent";
  description: Scalars["String"];
  /** @deprecated use disclaimer text list instead */
  disclaimerFullDescription: Scalars["String"];
  disclaimerLink?: Maybe<CarActionableItem>;
  disclaimerTextList?: Maybe<Array<Scalars["String"]>>;
  disclaimerTitle: Scalars["String"];
  /** @deprecated Use CarReviewsSummary.title instead */
  heading: Scalars["String"];
  /** @deprecated Use feedbackForm instead */
  opinionLabFeedback: OpinionLabFeedback;
  reviewBreakdown: Array<ReviewBreakdown>;
  reviews?: Maybe<Array<CarReview>>;
  reviewsSeeMoreAction?: Maybe<CarButton>;
  totalRatings: Scalars["String"];
  userFeedback: UserFeedback;
};

export type CarReviewThemes = {
  __typename?: "CarReviewThemes";
  icon?: Maybe<Icon>;
  label?: Maybe<Scalars["String"]>;
};

export type CarReviewsSummary = {
  __typename?: "CarReviewsSummary";
  dialogContent?: Maybe<CarReviewDialogContent>;
  dialogTrigger?: Maybe<CarActionableItem>;
  /** @deprecated Use recommendedText instead */
  recommendedRate: Scalars["String"];
  recommendedText: Scalars["String"];
  title: Scalars["String"];
  topReviews: Array<Scalars["String"]>;
};

export type CarRouteType = "ONEWAY" | "ROUNDTRIP";

export type CarRulesAndRestrictionsContainer = {
  __typename?: "CarRulesAndRestrictionsContainer";
  analytics: CarAnalytics;
  footer?: Maybe<CarPhraseText>;
  formatStyle?: Maybe<CarFormatStyle>;
  /** Unique id for each rule container. Same id will be used for hyperlinks in static rules */
  id: Scalars["String"];
  rulesAndRestrictionsItems: Array<CarPhrase>;
  title: CarPhraseText;
};

export interface CarRulesAndRestrictionsCriteriaInput {
  carOfferToken?: InputMaybe<Scalars["String"]>;
  orderId?: InputMaybe<Scalars["String"]>;
  useEgtpPath?: InputMaybe<Scalars["Boolean"]>;
}

export type CarRulesAndRestrictionsResult = {
  __typename?: "CarRulesAndRestrictionsResult";
  carSummary: CarSummary;
  header: CarPhraseText;
  /** @deprecated To be deleted and we need to create separate interface and its implementations(List, Text, Iframe etc) for R&R */
  rulesAndRestrictionsContainer: Array<CarRulesAndRestrictionsContainer>;
  shareFeedbackAction?: Maybe<CarShareFeedbackAction>;
  toolbar: CarToolbar;
};

export type CarSaleCard = {
  __typename?: "CarSaleCard";
  analytics?: Maybe<CarAnalytics>;
  cardAction?: Maybe<CarAction>;
  cardDescription?: Maybe<CarPhraseText>;
  cardTitle?: Maybe<CarsRichText>;
  image?: Maybe<Image>;
  linkText?: Maybe<CarsRichText>;
};

/** Car criteria needed to perform a car search */
export type CarSearchCriteria = {
  __typename?: "CarSearchCriteria";
  primary: PrimaryCarCriteria;
  secondary?: Maybe<ShoppingSearchCriteria>;
};

/** Car criteria needed to perform a car search */
export interface CarSearchCriteriaInput {
  primary: PrimaryCarCriteriaInput;
  secondary?: InputMaybe<ShoppingSearchCriteriaInput>;
}

export type CarSearchFilterNoMatchMessage = {
  __typename?: "CarSearchFilterNoMatchMessage";
  allOffersTextSeparator: Scalars["String"];
  messagingCard: CarMessagingCard;
};

/** Represents the car search form */
export type CarSearchForm = EgdsElement &
  EgdsSearchForm & {
    __typename?: "CarSearchForm";
    actionURL: Scalars["String"];
    /** Represents input field to enter driver age when 'driverAgeRequired' is checked */
    driverAge?: Maybe<EgdsNumberInputField>;
    /**
     * Represents driver age check required.
     * Example:
     * For UK point of sales an age check is required for young or senior drivers.
     */
    driverAgeRequired?: Maybe<EgdsBasicCheckBox>;
    /** Represents drop-off information */
    dropOff: CarSearchFormRentalInformation;
    egdsElementId?: Maybe<Scalars["String"]>;
    /** Elements list will be empty because fields in this form share same fragment type */
    elements: Array<EgdsSearchFormElement>;
    errorSummary?: Maybe<EgdsErrorSummary>;
    /** Represents pick-up information */
    pickUp: CarSearchFormRentalInformation;
    playback?: Maybe<EgdsSearchPlayback>;
    search?: Maybe<EgdsButton>;
  };

/** Represents date input field for pick-up and drop-off information */
export type CarSearchFormRentalInformation = {
  __typename?: "CarSearchFormRentalInformation";
  /** Represents date associated with car pick-up or drop-off */
  date: EgdsSearchFormDatePickerField;
  /** Represents label associated with pick-up or drop-off information */
  label: Scalars["String"];
  /** Represents location associated with car pick-up or drop-off */
  location: EgdsSearchFormLocationField;
  /** Represents time associated with car pick-up or drop-off */
  time: EgdsSelect;
};

export type CarSearchLocation = {
  __typename?: "CarSearchLocation";
  fullName: Scalars["String"];
  regionId?: Maybe<Scalars["String"]>;
  shortName: Scalars["String"];
};

export type CarSearchLocations = {
  __typename?: "CarSearchLocations";
  dropOffLocation?: Maybe<CarSearchLocation>;
  pickUpLocation: CarSearchLocation;
  routeType: CarRouteType;
};

export type CarSearchMultiItemShoppingAction = MultiItemShoppingAction & {
  __typename?: "CarSearchMultiItemShoppingAction";
  shoppingContext: ShoppingContext;
};

export type CarSearchPagination = {
  __typename?: "CarSearchPagination";
  size: Scalars["Int"];
  startingIndex: Scalars["Int"];
};

export type CarSearchResults = {
  __typename?: "CarSearchResults";
  adsTargetingData?: Maybe<AdsTargetingData>;
  carAppliedSortAndFilters: CarAppliedSortAndFilters;
  /** @deprecated use carRentalLocations node instead */
  carRentalLocation: CarOfferLocations;
  carRentalLocations: CarSearchLocations;
  carsShoppingContext: CarsShoppingContext;
  changeRentalLocation?: Maybe<ChangeRentalLocation>;
  filterNoMatchMessage?: Maybe<CarSearchFilterNoMatchMessage>;
  listings: Array<CarListingCard>;
  loadMoreAction?: Maybe<CarLoadMoreAction>;
  loyaltyInfo?: Maybe<Array<CarPhrase>>;
  makeModelDisclaimer: CarPhrase;
  map?: Maybe<CarMap>;
  multiItemAnchorPriceToken?: Maybe<Scalars["String"]>;
  multiItemPickUpDropOffMessage?: Maybe<MultiItemPickUpDropOffMessage>;
  multiItemPlayBackTitleBar?: Maybe<MultiItemPlayBackTitleBar>;
  recommendedSortDisclaimer?: Maybe<CarPhrase>;
  recommendedSortExplanation: CarDisclaimerDialog;
  shareFeedbackAction?: Maybe<CarShareFeedbackAction>;
  shoppingContext?: Maybe<ShoppingContext>;
  sortAndFilter: ShoppingSortAndFilters;
  summary: CarSearchSummary;
};

export type CarSearchSummary = {
  __typename?: "CarSearchSummary";
  carRecommendations?: Maybe<Array<Maybe<CarRecommendations>>>;
  dynamicTitle: Array<Array<CarPhrase>>;
  includedFeeFooter?: Maybe<IncludedFeeFooter>;
  pageTitle: Scalars["String"];
  /** @deprecated to be deleted to use dynamicTitle */
  title: Scalars["String"];
};

export type CarShareFeedbackAction = {
  __typename?: "CarShareFeedbackAction";
  button: CarActionableItem;
  text: Scalars["String"];
};

export type CarShortList = {
  __typename?: "CarShortList";
  favorited: Scalars["Boolean"];
  removeUrl: Scalars["String"];
  saveUrl: Scalars["String"];
};

export type CarSkipTheCounterInfo = {
  __typename?: "CarSkipTheCounterInfo";
  infos: Array<CarPhrase>;
  title: Scalars["String"];
};

export type CarSummary = {
  __typename?: "CarSummary";
  pickupDateTime: CarPhraseText;
  pickupLocation: CarPhraseText;
  vehicleCategory: CarPhraseText;
  vendor: CarVendor;
};

export type CarTelesales = {
  __typename?: "CarTelesales";
  label: Scalars["String"];
  phoneNumberLink: CarActionableItem;
};

export type CarToolbar = {
  __typename?: "CarToolbar";
  action: CarAction;
  icon: Icon;
};

export type CarVariant = {
  __typename?: "CarVariant";
  additionalInfo: CarVariantAdditionalInfo;
  badges: Array<Scalars["String"]>;
  carOfferToken: Scalars["String"];
  features: Array<CarVariantFeature>;
  price: CarVariantPriceSummary;
  selection: CarVariantSelection;
  title: Scalars["String"];
};

export type CarVariantAdditionalInfo = {
  __typename?: "CarVariantAdditionalInfo";
  icon: Icon;
  infoPanel: CarVariantInfoPanel;
};

export type CarVariantFeature = {
  __typename?: "CarVariantFeature";
  icon: Icon;
  text: Scalars["String"];
};

export type CarVariantInfoPanel = {
  __typename?: "CarVariantInfoPanel";
  details: Array<CarVariantInfoPanelDetail>;
  summary: Scalars["String"];
  title: Scalars["String"];
};

export type CarVariantInfoPanelDetail = {
  __typename?: "CarVariantInfoPanelDetail";
  features: Array<CarVariantInfoPanelFeature>;
  text: Scalars["String"];
};

export type CarVariantInfoPanelFeature = {
  __typename?: "CarVariantInfoPanelFeature";
  icon?: Maybe<Icon>;
  text: Scalars["String"];
};

export type CarVariantPriceSummary = {
  __typename?: "CarVariantPriceSummary";
  lead: CarPriceInfo;
  messages: Array<Scalars["String"]>;
  total?: Maybe<CarPriceInfo>;
};

export type CarVariantSelection = {
  __typename?: "CarVariantSelection";
  icon?: Maybe<Icon>;
  status: Scalars["Boolean"];
  text: Scalars["String"];
};

export type CarVariantsSummary = {
  __typename?: "CarVariantsSummary";
  title: Scalars["String"];
  variants: Array<CarVariant>;
};

export type CarVendor = {
  __typename?: "CarVendor";
  image?: Maybe<Image>;
};

export type CarVendorLocationInfo = {
  __typename?: "CarVendorLocationInfo";
  icon: Icon;
  locationSubInfo?: Maybe<Array<Scalars["String"]>>;
  text: Scalars["String"];
};

export type CardGallery = {
  __typename?: "CardGallery";
  /** Alt for the image */
  alt?: Maybe<Scalars["String"]>;
  /** Caption for the image */
  caption?: Maybe<Scalars["String"]>;
  /** Link to the image */
  src?: Maybe<Scalars["String"]>;
};

export type CardSize = "LARGE" | "MEDIUM" | "SMALL";

/** Represents a template and what type of plurality it represents. */
export type CardinalTemplate = {
  __typename?: "CardinalTemplate";
  category: PluralCategory;
  template: Scalars["String"];
};

/** A carousel button action */
export type CarouselAction = {
  __typename?: "CarouselAction";
  accessibility?: Maybe<Scalars["String"]>;
  analytics: ClientSideAnalytics;
};

export type CarouselActions = {
  __typename?: "CarouselActions";
  /** next card action button */
  next: CarouselAction;
  /** previous card action button */
  previous: CarouselAction;
};

/** Enum class to represent the type of carry on bag */
export type CarryOnBagType = "CARRY_ON_BAG";

export type CarsDialog = {
  __typename?: "CarsDialog";
  buttonText: Scalars["String"];
  content?: Maybe<CarsDialogContent>;
  text: Array<Scalars["String"]>;
  title: Scalars["String"];
  type?: Maybe<CarsDialogType>;
};

export type CarsDialogBody = {
  __typename?: "CarsDialogBody";
  body: Array<CarPhrase>;
  title: CarPhrase;
};

export type CarsDialogContent = {
  __typename?: "CarsDialogContent";
  body: Array<CarsDialogBody>;
  footer?: Maybe<Array<CarPhrase>>;
  header: CarPhrase;
};

export type CarsDialogType = "LIMITED_RESULTS" | "LIMITED_RESULTS_WITHOUT_TURO" | "LIMITED_RESULTS_WITH_TURO";

export interface CarsDomainRequestContextInput {
  partnerContext: PartnerContextInput;
  principalJWT: Scalars["String"];
}

export type CarsErrorContent = {
  __typename?: "CarsErrorContent";
  analytics: CarAnalytics;
  errorEventName?: Maybe<Scalars["String"]>;
  heading: Scalars["String"];
  icon?: Maybe<Icon>;
  locationAnalytics?: Maybe<CarAnalytics>;
  resetButtonAction?: Maybe<UiPrimaryButton>;
  subText: Scalars["String"];
};

export type CarsRichText = {
  __typename?: "CarsRichText";
  style?: Maybe<CarsRichTextStyle>;
  theme?: Maybe<Scalars["String"]>;
  value: Scalars["String"];
};

export type CarsRichTextStyle = "BOLD" | "BULLET" | "ITALICIZE";

export type CarsSearchResultsWrapper = {
  __typename?: "CarsSearchResultsWrapper";
  carRecommendationContent?: Maybe<Array<CarRecommendations>>;
  carSearchResults?: Maybe<CarSearchResults>;
  carsErrorContent?: Maybe<CarsErrorContent>;
};

export type CarsShoppingContext = {
  __typename?: "CarsShoppingContext";
  searchId?: Maybe<Scalars["String"]>;
};

export type Cart = {
  __typename?: "Cart";
  id: Scalars["UUID"];
  /**
   * Get the number of items in the cart without fetching item details
   * @deprecated DO NOT USE: Will be removed permanently soon
   */
  itemCount: Scalars["Int"];
  /**
   * Get the list of items in the cart
   * @deprecated DO NOT USE: Will be removed permanently soon
   */
  items: Array<CartItem>;
};

export interface CartItem {
  id: Scalars["UUID"];
}

export type CartMutations = {
  __typename?: "CartMutations";
  /**
   * Add a property to the cart
   * @deprecated DO NOT USE: Will be removed permanently soon
   */
  addProperty: CartSummary;
  /**
   * Remove all items from the cart
   * @deprecated DO NOT USE: Will be removed permanently soon
   */
  emptyCart: CartSummary;
  /**
   * Remove an item from the cart
   * @deprecated DO NOT USE: Will be removed permanently soon
   */
  remove: CartSummary;
};

export type CartMutationsAddPropertyArgs = {
  key: PropertyOfferInput;
  searchContext: CartPropertySearchContextInput;
};

export type CartMutationsRemoveArgs = {
  id: Scalars["UUID"];
};

/** Options for the session cart being created */
export interface CartOptionsInput {
  ttl: CartTtl;
}

export type CartPropertySearchContext = {
  __typename?: "CartPropertySearchContext";
  /**
   * The checking date for the property rental
   * @deprecated DO NOT USE: Will be removed permanently soon
   */
  checkIn: Date;
  /**
   * The checkOut date for the property rental
   * @deprecated DO NOT USE: Will be removed permanently soon
   */
  checkOut: Date;
  /**
   * The id of the region where the hotel is located - from lodging domain
   * @deprecated DO NOT USE: Will be removed permanently soon
   */
  regionId: Scalars["String"];
  /**
   * The list of rooms that user searched for
   * @deprecated DO NOT USE: Will be removed permanently soon
   */
  rooms: Array<PropertyRoom>;
};

export interface CartPropertySearchContextInput {
  /** The checking date for the property rental */
  checkIn: DateInput;
  /** The checkOut date for the property rental */
  checkOut: DateInput;
  /** The id of the region where the hotel is located - from lodging domain */
  regionId: Scalars["String"];
  /** The list of rooms that user searched for */
  rooms: Array<PropertyRoomInput>;
}

/** Summary of a Cart */
export type CartSummary = {
  __typename?: "CartSummary";
  id: Scalars["UUID"];
  itemCount: Scalars["Int"];
};

export type CartTtl = "FIVE_MINUTES" | "SEVEN_DAYS" | "TWELVE_HOURS";

export type CategoryFilterSummary = {
  __typename?: "CategoryFilterSummary";
  details: ActivityCategoryDetails;
  /** count of activities associates with category in raw activity search result */
  size: Scalars["Int"];
  /** list of sub-categories associated */
  subCategories?: Maybe<Array<ActivityCategoryDetails>>;
};

export type CategoryFilterViewModel = {
  __typename?: "CategoryFilterViewModel";
  /** Recommended display order of category-type in filter view model */
  displayOrder: Scalars["Int"];
  /** Localized name of category-type */
  name: Scalars["String"];
  /** Filter summary of categories over raw activity search result */
  summary?: Maybe<Array<CategoryFilterSummary>>;
  /**
   * Category-type is group of multiple categories, like bike-tour, hop-on-hop-off-tour, sightseeing are TOURS
   * @deprecated should use name, i.e. localized value
   */
  type: ActivityCategoryType;
};

export type ChangeFlightLabelPresentation = {
  __typename?: "ChangeFlightLabelPresentation";
  /** Label to surface change flight link */
  changeFlightLabel: FlightsActionableLabel;
  /** departure date and separator to separate from change flight label */
  departureDate: FlightsPhrase;
};

/** Dialog for confirming a change package search */
export type ChangePackageConfirmationDialog = {
  __typename?: "ChangePackageConfirmationDialog";
  content: MishopUiChangePackageConfirmationDialogContent;
  dialog: EgdsActionDialog;
  trigger: EgdsButton;
};

/** Input parameters for a change package request */
export type ChangePackageSearchCriteria = {
  __typename?: "ChangePackageSearchCriteria";
  dateRange: DateRange;
  multiItemSessionId: Scalars["String"];
  origin: PackageLocation;
  travelerGroups: Array<TravelerOccupancyGroup>;
};

/** Represents change rental location module on packages path */
export type ChangeRentalLocation = {
  __typename?: "ChangeRentalLocation";
  /** Represents the link to open change rental location module */
  link: CarPhrase;
  /** Represents text for the place holder of the search input the change rental location module */
  placeHolder: CarPhrase;
  /** Represents the main text on the change rental location module */
  primary: CarPhrase;
  /** Represents the sub text on change rental location module */
  secondary: CarPhrase;
};

export type ChannelType = "VIRTUAL_AGENT";

/** Indicates the type of intent. */
export type ChatBotIntentType = "CANCEL" | "CHANGE" | "VIEW_BOOKING";

/** Indicates the type of product. */
export type ChatBotProductType = "FLIGHT";

/** Indicates the waiver redemption state. */
export type ChatBotWaiverRedemptionState = "CREDIT_REDEMPTION";

/** Authorization object received from client-authorizer, it is used to initialize VirtualAgentControl. */
export type ChatbotAuthentication = {
  __typename?: "ChatbotAuthentication";
  /** AuthCode received from client-authorizer, it is used to initialize VirtualAgentControl for Mobile. */
  code?: Maybe<Scalars["String"]>;
  /** AuthToken received from client-authorizer, it is used to initialize VirtualAgentControl in JavaScript. */
  token?: Maybe<Scalars["String"]>;
};

/** Supported capabilities of chatbot VAC. */
export type ChatbotCapabilities = "CLICKSTREAM" | "GLASSBOX";

/** Chatbot configuration used to initialize VirtualAgentControl in JavaScript. */
export type ChatbotConfig = {
  __typename?: "ChatbotConfig";
  /** Authorization object received from client-authorizer, it is used to initialize VirtualAgentControl. */
  auth: ChatbotAuthentication;
  /**
   * AuthToken object received from client-authorizer, it is used to initialize VirtualAgentControl in JavaScript.
   * @deprecated authToken has been replaced by auth.token
   */
  authToken: Scalars["String"];
  /** Unique channel origin id per chatbot experience, it is used to initialize VirtualAgentControl in JavaScript. */
  channelOriginId: Scalars["String"];
  /** Enumeration of optional capabilities of the Virtual Agent Control, it is used to initialize VirtualAgentControl in JavaScript. */
  chatbotCapabilities?: Maybe<Array<ChatbotCapabilities>>;
  /** Properties for the conversation context, it is used to initialize VirtualAgentControl in JavaScript. */
  conversationProperties: ConversationProperties;
  /** To automatically open chat widget upon chat initialization, it is used to initialize VirtualAgentControl in JavaScript. */
  enableAutoOpenChatWidget?: Maybe<Scalars["Boolean"]>;
  /** To enable proactive conversation to initialize chat upon page load, it is used to initialize VirtualAgentControl in JavaScript. */
  enableProactiveConversation?: Maybe<Scalars["Boolean"]>;
  /** Contains a URL/Wrapper to the JavaScript source file used by the Virtual Agent Control, it is used to initialize VirtualAgentControl. */
  version: ChatbotVersion;
};

export interface ChatbotConversationIntentMessage {
  /** Indicates the type of intent. */
  intent: ChatBotIntentType;
}

export type ChatbotConversationRedeemIntentMessage = ChatbotConversationIntentMessage & {
  __typename?: "ChatbotConversationRedeemIntentMessage";
  /** Customer email address. */
  emailAddress: Scalars["String"];
  intent: ChatBotIntentType;
  /** Trip itinerary number. */
  itineraryNumber: Scalars["String"];
  /** Indicates the type of product. */
  product: ChatBotProductType;
  /** Indicates the waiver redemption state. */
  waiverRedemptionState?: Maybe<ChatBotWaiverRedemptionState>;
};

/** Key-Value pair of intent attributes for chatbot initialization example itineraryNumber, orderLineId */
export interface ChatbotIntentValueInput {
  /** Key to define intent attributes for chatbot initialization example itineraryNumber, orderLineId */
  id: Scalars["String"];
  /** Value for intent attributes for chatbot initialization example of attributes itineraryNumber, orderLineId */
  value: Scalars["String"];
}

/** An ID and URL specifying the JavaScript source used to initialize the chatbot. */
export type ChatbotVersion = {
  __typename?: "ChatbotVersion";
  /** JavaScript source implementing the chatbot. */
  javascriptUrl: HttpUri;
  /** Supported versions of chatbot. */
  versionId: ChatbotVersionId;
  /** HTML page that wraps the initialization of javaScript source implementing the chatbot. It can be directly loaded by mobile apps */
  wrapperUrl?: Maybe<HttpUri>;
};

/** Supported versions of chatbot. */
export type ChatbotVersionId = "V1" | "V2";

/** A property list with hero and column headings intended as checkbox items */
export type CheckablePropertyList = {
  __typename?: "CheckablePropertyList";
  /** Column headings for the property list */
  columnHeadings?: Maybe<Array<Scalars["String"]>>;
  hero?: Maybe<CampaignConfigHero>;
  /** A list of properties */
  properties: Array<CampaignConfigProperty>;
  /** Button to select all items */
  selectAll: EgdsButton;
  /** Button to select no items */
  selectNone: EgdsButton;
};

export type CheckinValidityWithReason =
  /** the associated date is not valid for checkin due to an unknown reason */
  | "INVALID"
  /** the associated date is not valid for checkin due to being in the past */
  | "INVALID_DUE_TO_BEING_IN_PAST"
  /** the associated date is not valid for checkin because checkin was prohibited on that specific date */
  | "INVALID_DUE_TO_CHANGEOVER_EXCLUSION"
  /** the associated date is not valid for checkin because it is too far in the future */
  | "INVALID_DUE_TO_MAX_FUTURE_BOOKING"
  /** the associated date is not valid for checkin because checking in on this date would not meet the owner's minimum prior notification requirements */
  | "INVALID_DUE_TO_MIN_PRIOR_NOTIFICATION"
  /** the associated date is not valid for checkin because checking in on this date does not satisfy the minimum stay duration */
  | "INVALID_DUE_TO_MIN_STAY_NOT_ACHIEVABLE"
  /** the associated date is not valid for checkin because it falls on a day of the week that checkin is prohibited */
  | "INVALID_DUE_TO_NON_CHANGEOVER_DAY_OF_WEEK"
  /** the associated date is not valid for checkin because it is not available (ie. the date is already reserved) */
  | "INVALID_DUE_TO_NOT_AVAILABLE"
  /** the associated date is not valid for checkin because there is not an associated checkout date that would allow the stay to satisfy stay constraints */
  | "INVALID_DUE_TO_NO_VALID_CHECKOUT_WITHIN_CONSTRAINTS"
  /** the associated date is valid for checkin */
  | "VALID";

export type CheckoutAccountCreationResponse = {
  __typename?: "CheckoutAccountCreationResponse";
  analytics: Array<EgClickstreamEvent>;
  createAccount: SmartFormSignalAction;
  heading: Scalars["String"];
  passwordWithStrengthMeter: PasswordWithStrengthMeter;
  subHeading: Scalars["String"];
};

export type CheckoutDetails = {
  __typename?: "CheckoutDetails";
  /** Contains the trust widget model. */
  fraudComponentDetails: FraudComponentDetails;
  /** List details of the session */
  getSession: CheckoutSessionDetailsResponse;
};

export type CheckoutDetailsGetSessionArgs = {
  orderId?: InputMaybe<Scalars["String"]>;
  sessionID: Scalars["UUID"];
};

export type CheckoutDomainInfo = {
  __typename?: "CheckoutDomainInfo";
  name: Scalars["String"];
  refId: Scalars["String"];
};

export interface CheckoutDomainInfoInput {
  name: Scalars["String"];
  refId: Scalars["String"];
}

/** Base Checkout failure reason that might provide an alternative action to remedy the problem */
export type CheckoutFailureReason = FailureReason & {
  __typename?: "CheckoutFailureReason";
  description: Scalars["String"];
  failureDialog: MishopUiNonFullscreenDialog;
  message: Scalars["String"];
};

export type CheckoutMultiItemShoppingAction = MultiItemShoppingAction & {
  __typename?: "CheckoutMultiItemShoppingAction";
  shoppingContext: ShoppingContext;
};

/** Checkout option and its value to apply on the checkoutUrl */
export type CheckoutOption = {
  __typename?: "CheckoutOption";
  type: CheckoutOptionType;
  value: Scalars["String"];
};

/** Checkout option and its value to apply on the checkoutUrl */
export interface CheckoutOptionInput {
  type: CheckoutOptionType;
  value: Scalars["String"];
}

/** Supported Features on prepareCheckout */
export type CheckoutOptionType =
  | "FENCING_ATTRIBUTES"
  | "HOTEL_BUSINESS_MODEL"
  | "HOTEL_MARKETING_CHANNEL"
  | "META_DEEPLINK"
  | "SHOP_WITH_POINTS";

export type CheckoutResource = {
  __typename?: "CheckoutResource";
  /** Name of the participant resource */
  participant: Scalars["String"];
  /** Represents the identifier the participant should use to access downstream data. */
  resourceIdentifier: ResourceIdentifier;
};

export type CheckoutSession = {
  __typename?: "CheckoutSession";
  sessionId?: Maybe<Scalars["String"]>;
};

export type CheckoutSessionDetailsResponse = {
  __typename?: "CheckoutSessionDetailsResponse";
  /** List of participating modules on the page */
  resources?: Maybe<Array<CheckoutResource>>;
  /** List of checkout ui signals generated from retrieving the session */
  signals: Array<CheckoutUiSignal>;
  /** Checkout Session Token used to identify right session version */
  token?: Maybe<Scalars["UUID"]>;
};

export interface CheckoutSessionInfoInput {
  sessionId: Scalars["UUID"];
  sessionToken: Scalars["UUID"];
}

export type CheckoutUiSignal = {
  __typename?: "CheckoutUISignal";
  domainInfoList?: Maybe<Array<CheckoutDomainInfo>>;
  signal: UiSignal;
};

export type CheckoutValidityWithReason =
  /** the associated date's is not valid for checkout for an unknown reason */
  | "INVALID"
  /** the associated date is not valid for checkout because checkout was prohibited on that specific date */
  | "INVALID_DUE_TO_CHANGEOVER_EXCLUSION"
  /** the associated date is not valid for checkout because it falls on a day of the week that checkout is prohibited */
  | "INVALID_DUE_TO_NON_CHANGEOVER_DAY_OF_WEEK"
  /** the associated date is valid for checkout */
  | "VALID";

/** A guest over the age of 2 */
export type Child = {
  __typename?: "Child";
  /** The child's age in years */
  age: Scalars["Int"];
};

/** A guest over the age of 2 */
export interface ChildInput {
  /** The child's age in years */
  age: Scalars["Int"];
}

export type ChronoUnit =
  | "CENTURIES"
  | "DAYS"
  | "DECADES"
  | "ERAS"
  | "FOREVER"
  | "HALFDAYS"
  | "HOURS"
  | "MICROS"
  | "MILLENNIA"
  | "MILLIS"
  | "MINUTES"
  | "MONTHS"
  | "NANOS"
  | "SECONDS"
  | "WEEKS"
  | "YEARS";

export type CleaningAndSafetyPractice = "ENHANCED_CLEANING";

export type CleanlinessDialog = {
  __typename?: "CleanlinessDialog";
  dialog: EgdsFullScreenDialog;
  trigger: LodgingDialogTriggerMessage;
};

/** Analytics to be logged to EG Clickstream on the client */
export type ClickstreamAnalytics = {
  __typename?: "ClickstreamAnalytics";
  event: EgClickstreamEvent;
  payload: EgClickstreamPayload;
};

/** Contains client accessibility attributes */
export type ClientAccessibility = {
  __typename?: "ClientAccessibility";
  text: Scalars["String"];
};

/** Describe which application is invoking bex api */
export type ClientInfo = {
  __typename?: "ClientInfo";
  /** Name of the application */
  name: Scalars["String"];
  /** Version of the application eg:18.10 or 5fbc9958 */
  version?: Maybe<Scalars["String"]>;
};

/** Describe which application is invoking bex api */
export interface ClientInfoInput {
  /** Name of the application */
  name: Scalars["String"];
  /** Version of the application eg:18.10 or 5fbc9958 */
  version?: InputMaybe<Scalars["String"]>;
}

export type ClientRequestContext = {
  __typename?: "ClientRequestContext";
  /** Generate Context information based on the specified ClientRequest. */
  context: Context;
  /** Generate DeviceContext information */
  deviceContext: DeviceContext;
  /** Detail information on the resolved locale for the client request including text-direction. */
  localeInfo: LocaleInfo;
  /** Generate basic Context information (without user) based on the specified ClientRequest. */
  simpleContext: Context;
  /** Generate SiteContext information */
  siteContext: SiteContext;
};

/** Input argument for Request Context */
export interface ClientRequestInput {
  /** Headers of HTTP Request */
  headers: Array<HttpHeaderInput>;
  /** Remote address of HTTP Request */
  remoteAddress: Scalars["String"];
  /** URL of HTTP Request */
  url: Scalars["String"];
}

/** Used to capture client side analytics event like clicks. See https://pages.github.expedia.biz/Brand-Expedia/bernie/docs/analytics-click-events/ */
export type ClientSideAnalytics = {
  __typename?: "ClientSideAnalytics";
  eventType?: Maybe<EgReferrerEventType>;
  linkName: Scalars["String"];
  referrerId: Scalars["String"];
  uisPrimeMessages: Array<EgUisMicroMessage>;
};

/** Client side representation of error. */
export interface ClientSideErrorRepresentation {
  /**
   * Action related to client side representation of error.
   * @deprecated This field is deprecated and replaced with clientSideErrorRepresentationDialog
   */
  clientSideErrorRepresentationAction?: Maybe<PriceInsightsTrackingRetryDialogAction>;
  /** Action related to client side representation of error. */
  clientSideErrorRepresentationDialog?: Maybe<ClientSideErrorRepresentationDialog>;
}

export type ClientSideErrorRepresentationDialog = EgdsDialog & {
  __typename?: "ClientSideErrorRepresentationDialog";
  /** Represents accessibility corresponding to the dialog */
  accessibility?: Maybe<Scalars["String"]>;
  /** Represents close analytics corresponding to the dialog */
  closeAnalytics?: Maybe<ClientSideAnalytics>;
  /** Description on the dialog related to the error. */
  content: Scalars["String"];
  /** Footer with buttons. for eg: Cancel and Retry */
  dialogFooter: ClientSideErrorRepresentationDialogFooter;
  /** Represents display analytics corresponding to the dialog */
  displayAnalytics?: Maybe<ClientSideImpressionEventAnalytics>;
  /** Represent heading for the dialog */
  heading: Scalars["String"];
  /** Represents paragraph corresponding to the dialog */
  paragraph: Scalars["String"];
};

/** Represents footer for the client side error representation dialog */
export type ClientSideErrorRepresentationDialogFooter = {
  __typename?: "ClientSideErrorRepresentationDialogFooter";
  buttons: Array<ClientSideErrorRepresentationDialogFooterButton>;
};

/** Represents button for the client side error representation dialog footer */
export type ClientSideErrorRepresentationDialogFooterButton = {
  __typename?: "ClientSideErrorRepresentationDialogFooterButton";
  /** Represents accessibility corresponding to the button */
  accessibility?: Maybe<Scalars["String"]>;
  /** Represents action corresponding to the button */
  action: ClientSideErrorRepresentationDialogFooterButtonAction;
  /** Represents analytics corresponding to the button */
  analytics?: Maybe<ClientSideAnalytics>;
  /** Represents state corresponding to the button */
  disabled: Scalars["Boolean"];
  /** Represents egds element Id corresponding to the button */
  egdsElementId?: Maybe<Scalars["String"]>;
  /** Represents icon corresponding to the button */
  icon?: Maybe<Icon>;
  /** Represents label for the button */
  primary: Scalars["String"];
};

export type ClientSideErrorRepresentationDialogFooterButtonAction = {
  __typename?: "ClientSideErrorRepresentationDialogFooterButtonAction";
  /** Represents accessibility corresponding to the button */
  accessibility?: Maybe<Scalars["String"]>;
  /** Custom action type to determine which type of case to try again. */
  actionType: DialogButtonActionType;
  /** Represents analytics corresponding to the button */
  analytics?: Maybe<ClientSideAnalytics>;
};

/** Impression tracking data to be fired on the client */
export type ClientSideImpressionAnalytics = {
  __typename?: "ClientSideImpressionAnalytics";
  clickstreamAnalytics?: Maybe<ClickstreamAnalytics>;
  /** @deprecated error has been deprecated */
  error?: Maybe<BooleanEnum>;
  /** @deprecated name has been deprecated, replace with uisPrimeAnalytics.eventType */
  name?: Maybe<EventType>;
  uisPrimeAnalytics?: Maybe<ClientSideAnalytics>;
  /** @deprecated value has been deprecated, replace with uisPrimeAnalytics.referrerId */
  value?: Maybe<Scalars["Float"]>;
};

/** Used to capture client side analytics event for tracking impression of a UI component */
export type ClientSideImpressionEventAnalytics = {
  __typename?: "ClientSideImpressionEventAnalytics";
  /** Represents event name */
  event: Scalars["String"];
  /** Represents link name for referrer event */
  linkName?: Maybe<Scalars["String"]>;
  /** Represents id for referrer event */
  referrerId: Scalars["String"];
  /** Represents url of the component to be tracked */
  url?: Maybe<Scalars["URL"]>;
};

export type ClubbedPrice = {
  __typename?: "ClubbedPrice";
  additionalBenefits?: Maybe<Array<CarPhraseIconText>>;
  cancellationMessages?: Maybe<Array<CarPhrase>>;
  infositeURL: HttpUri;
  offerBadges: Array<CarOfferBadge>;
  paymentMessages: Array<CarPhrase>;
  priceBadges: Array<CarOfferBadge>;
  priceSummary: CarPriceSummary;
  reserveButtonAction: CarAction;
  reserveButtonText: Scalars["String"];
};

export type ClubbedPriceOptions = {
  __typename?: "ClubbedPriceOptions";
  dialogContent: ClubbedPriceOptionsDialog;
  dialogTrigger: CarActionableItem;
};

export type ClubbedPriceOptionsDialog = {
  __typename?: "ClubbedPriceOptionsDialog";
  clubbedPrices: Array<ClubbedPrice>;
  commonAdditionalBenefits?: Maybe<Array<CarPhraseIconText>>;
  modalFooter: Scalars["String"];
  optionsSummary: Array<CarPhrase>;
  title: Scalars["String"];
  vehicleCategory: Scalars["String"];
  vehicleDescription?: Maybe<Scalars["String"]>;
  vendor: CarVendor;
};

/** CoBrand Banner Data from Global Navigation */
export type CoBrandBannerData = {
  __typename?: "CoBrandBannerData";
  endDate?: Maybe<Scalars["String"]>;
  logoData?: Maybe<CoBrandBannerLogoData>;
  startDate?: Maybe<Scalars["String"]>;
  /** @deprecated This property will not be supported in future. Please use styles. */
  style: CoBrandBannerStyle;
  styles: CoBrandBannerStyles;
  textData?: Maybe<CoBrandBannerTextData>;
  timezone?: Maybe<Timezone>;
};

export type CoBrandBannerLogoData = {
  __typename?: "CoBrandBannerLogoData";
  altText: Scalars["String"];
  desktop: CoBrandBannerLogoDetail;
  href?: Maybe<Scalars["URL"]>;
  logoContainerStyle: CoBrandBannerStyle;
  mobile: CoBrandBannerLogoDetail;
  tablet: CoBrandBannerLogoDetail;
};

export type CoBrandBannerLogoDetail = {
  __typename?: "CoBrandBannerLogoDetail";
  imgSrc: Scalars["URL"];
  /** This will at least have the width and height of the image */
  style: Array<CoBrandBannerProperty>;
};

export type CoBrandBannerProperty = {
  __typename?: "CoBrandBannerProperty";
  key: Scalars["String"];
  value: Scalars["String"];
};

export type CoBrandBannerStyle = {
  __typename?: "CoBrandBannerStyle";
  commonStyle?: Maybe<Array<CoBrandBannerProperty>>;
  desktop?: Maybe<Array<CoBrandBannerProperty>>;
  mobile?: Maybe<Array<CoBrandBannerProperty>>;
  tablet?: Maybe<Array<CoBrandBannerProperty>>;
};

export type CoBrandBannerStyles = {
  __typename?: "CoBrandBannerStyles";
  /** This should be used for styling the main container for the co-brand banner. This will at least have the background color for the banner */
  mainContainer: CoBrandBannerStyle;
  /** This property should be used for cross-platform styling in the immediate child of the co-brand banner main container */
  subContainer: CoBrandBannerStyle;
};

export type CoBrandBannerTextData = {
  __typename?: "CoBrandBannerTextData";
  /** This will at least have the header text color */
  textContainerStyle: CoBrandBannerStyle;
  textSections: Array<CoBrandBannerTextSection>;
};

export type CoBrandBannerTextSection = {
  __typename?: "CoBrandBannerTextSection";
  style?: Maybe<Array<CoBrandBannerProperty>>;
  textTokens: Array<CoBrandBannerTextToken>;
};

export type CoBrandBannerTextToken = {
  __typename?: "CoBrandBannerTextToken";
  href?: Maybe<Scalars["URL"]>;
  style?: Maybe<Array<CoBrandBannerProperty>>;
  text: Scalars["String"];
};

/** The type of the collection */
export type CollectionType = "FLIGHT" | "GEOGRAPHY" | "LODGING";

export type CommissionSection = {
  __typename?: "CommissionSection";
  /** Commission amount */
  commission?: Maybe<Scalars["String"]>;
  /** String describing the commission tier/amount in more detail */
  description?: Maybe<Scalars["String"]>;
  /** The id associated with the the tier. e.g. 1 == Basic */
  tierId?: Maybe<Scalars["Int"]>;
  /** Link to mark representing the commission tier */
  tierMark?: Maybe<Mark>;
  /** Name of the commission tier (e.g. Basic, Basic Plus, etc.) */
  tierName?: Maybe<Scalars["String"]>;
};

export type CommissionTier = "BASIC" | "BASIC_PLUS" | "PREMIUM" | "PREMIUM_PLUS";

export type CompetitiveSetDefaultMapMarker = {
  __typename?: "CompetitiveSetDefaultMapMarker";
  markerIconType?: Maybe<Array<Scalars["String"]>>;
  markerType?: Maybe<Scalars["String"]>;
};

export type CompetitiveSetEgClickstreamEvent = {
  __typename?: "CompetitiveSetEGClickstreamEvent";
  actionLocation?: Maybe<Scalars["String"]>;
  clickstreamTraceId?: Maybe<Scalars["String"]>;
  eventCategory: Scalars["String"];
  eventName: Scalars["String"];
  eventType: Scalars["String"];
  eventVersion: Scalars["String"];
};

export type CompetitiveSetEditorResponse = {
  __typename?: "CompetitiveSetEditorResponse";
  map: CompetitorsMap;
  typeahead: CompetitorsTypeahead;
};

export type CompetitiveSetProductType = "LODGING";

export type CompetitiveSetUserAnalytics = {
  __typename?: "CompetitiveSetUserAnalytics";
  competitorProductId?: Maybe<Scalars["String"]>;
  event: CompetitiveSetEgClickstreamEvent;
  productId: Scalars["String"];
  productType: CompetitiveSetProductType;
};

export type CompetitorCard = {
  __typename?: "CompetitorCard";
  productId: Scalars["String"];
  productType: CompetitiveSetProductType;
};

export type CompetitorsCardResponse = {
  __typename?: "CompetitorsCardResponse";
  card?: Maybe<CompetitorCard>;
};

export type CompetitorsMap = {
  __typename?: "CompetitorsMap";
  basicMap: EgdsBasicMap;
  defaultAddedMarker?: Maybe<CompetitiveSetDefaultMapMarker>;
  defaultRemovedMarker?: Maybe<CompetitiveSetDefaultMapMarker>;
  defaultSelectedMarker?: Maybe<CompetitiveSetDefaultMapMarker>;
  markers?: Maybe<Array<Maybe<CompetitorsMapMarker>>>;
};

export type CompetitorsMapMarker = EgdsMapMarker & {
  __typename?: "CompetitorsMapMarker";
  markerIconType?: Maybe<Array<Scalars["String"]>>;
  markerPosition: Coordinates;
  markerStatus?: Maybe<EgdsMapMarkerStatus>;
  markerType?: Maybe<Scalars["String"]>;
  productId?: Maybe<Scalars["String"]>;
  text?: Maybe<Scalars["String"]>;
};

export type CompetitorsTypeahead = {
  __typename?: "CompetitorsTypeahead";
  accessibilityLabel?: Maybe<Scalars["String"]>;
  adapter?: Maybe<CompetitorsTypeaheadEssAdapter>;
  analytics: CompetitiveSetUserAnalytics;
  categorize?: Maybe<Scalars["Boolean"]>;
  clearAllText?: Maybe<Scalars["String"]>;
  debounceRate?: Maybe<Scalars["Int"]>;
  defaultTerm?: Maybe<Scalars["String"]>;
  dismissButtonText?: Maybe<Scalars["String"]>;
  emptyResultsPlaceholder?: Maybe<Scalars["String"]>;
  hasClearButton?: Maybe<Scalars["Boolean"]>;
  hasVisibleLabel?: Maybe<Scalars["Boolean"]>;
  inputField?: Maybe<EgdsTypeaheadInputField>;
  listTitle?: Maybe<Scalars["Boolean"]>;
  selectedItemHeading?: Maybe<Scalars["String"]>;
  showPills?: Maybe<Scalars["Boolean"]>;
};

export type CompetitorsTypeaheadEssAdapter = {
  __typename?: "CompetitorsTypeaheadESSAdapter";
  alternate?: Maybe<Scalars["Boolean"]>;
  browser?: Maybe<Scalars["String"]>;
  device?: Maybe<Scalars["String"]>;
  domain?: Maybe<Scalars["String"]>;
  enableEgta?: Maybe<Scalars["Boolean"]>;
  latLong?: Maybe<Scalars["String"]>;
  nearby?: Maybe<Scalars["Boolean"]>;
  regionId?: Maybe<Scalars["Int"]>;
  showCurrentLocation?: Maybe<Scalars["Boolean"]>;
};

/**
 * Represents the dynamic part of the composite text.  Keys are used to insert the localized fragment into
 * the EGDSCompositeLocalizedText's template.
 */
export type CompositeLocalizedTextModel = {
  __typename?: "CompositeLocalizedTextModel";
  key: Scalars["String"];
  /** @deprecated Use models instead */
  localizedFragment: EgdsLocalizedText;
  models: EgdsTemplateModels;
};

/** A rough measure of the percentage of properties that are sold out in the destination region as calculated by the Urgency Service. */
export type CompressionLevel = "CAP" | "HIGH" | "LOW" | "MEDIUM" | "NA";

/** The top level response from Confirmation Summary query wih component heading, text, image, etc */
export type ConfirmationSummary = {
  __typename?: "ConfirmationSummary";
  /** The heading text of the module */
  assuranceHeading: Scalars["String"];
  /** List of data fields and values to display information to customer */
  confirmationSummarySections: Array<ConfirmationSummarySection>;
  image: Image;
  /** Button for redirecting the customer to their trips page */
  redirectToTripButton: EgdsButton;
};

export type ConfirmationSummarySection = {
  __typename?: "ConfirmationSummarySection";
  /** A description of the information being displayed */
  confirmationSummarySectionDescription: Scalars["String"];
  /** Data values pertinent to the order - email address, itin number, etc */
  confirmationSummarySectionValue: Scalars["String"];
};

/** Return one or the other model for ContactHost CTA. */
export type ContactHostAction = InquiryFormDialogAction | UiLinkAction;

/** Type defining when the contact host CTA is a button. */
export type ContactHostButton = {
  __typename?: "ContactHostButton";
  action?: Maybe<ContactHostAction>;
  button?: Maybe<ContactHostButtonType>;
};

/** Return one or the other model for ContactHostButtonType */
export type ContactHostButtonType = UiSecondaryButton | UiTertiaryButton;

/** Return one or the other model for ContactHost CTA. */
export type ContactHostCta = ContactHostButton;

/** Represents Contact Options Sheet */
export type ContactOptionsSheet = {
  __typename?: "ContactOptionsSheet";
  /** Heading of Contact Us Options form */
  heading: Scalars["String"];
  /** Contact Options list */
  options: Array<ContactUsOption>;
  /** SubHeading of Contact Us Options form */
  subheading: Scalars["String"];
  /** Toolbar of Contact Us  Options form */
  toolBar: ContactUsToolBar;
};

/** Represents Error View */
export type ContactUsErrorView = {
  __typename?: "ContactUsErrorView";
  /** Heading of Error View */
  heading: Scalars["String"];
  /** SubHeading of  Error View */
  subheading?: Maybe<Scalars["String"]>;
  /** Toolbar of Error view */
  toolBar: ContactUsToolBar;
};

export interface ContactUsFormContentInput {
  /** Customer Selected category from dropdown */
  category: Scalars["String"];
  /** Customer selected intent from dropdown */
  intent: Scalars["String"];
  /** Customer Entered Itinerary Number */
  itineraryNumber: Scalars["String"];
  /** Customer Entered Phone Number */
  phoneNumber: Scalars["String"];
}

/** Represents Contact Us Option */
export type ContactUsOption = {
  __typename?: "ContactUsOption";
  /** Icon for left side in contact us option */
  leftIcon: Icon;
  /** Contact Us Option Type */
  option: ContactUsOptionType;
  /** Contact us Option Label */
  optionLabel: Scalars["String"];
  /** Icon for right side in contact us option */
  rightIcon: Icon;
  /** Wait Time */
  waitTime?: Maybe<Scalars["String"]>;
};

export type ContactUsOptionType =
  | "CALL_BACK_WITH_AGENT"
  | "CALL_TO_AGENT"
  | "CHAT_BACK_WITH_AGENT"
  | "CHAT_WITH_AGENT"
  | "SEND_EMAIL_AGENT";

/** Union of Contact Us Options Sheet and Error View for ContactUs Options Sheet */
export type ContactUsOptionsView = ContactOptionsSheet | ContactUsErrorView;

/** Failed Response of Send Email for Contact us */
export type ContactUsSendEmailFailed = {
  __typename?: "ContactUsSendEmailFailed";
  /** button to try again on failure */
  button: UiPrimaryButton;
  /** icon to display */
  icon: Icon;
  /** message of failed send email */
  message: Scalars["String"];
  /** title of failed send email */
  title: Scalars["String"];
};

/** Represents Email Us Sheet Request */
export interface ContactUsSendEmailRequestInput {
  /** Email of customer */
  customerEmail: Scalars["String"];
  /** Name of customer */
  customerName: Scalars["String"];
  /** Message of email */
  message: Scalars["String"];
  /** subject of email */
  subject: Scalars["String"];
}

/** Success Response of Send Email for Contact us */
export type ContactUsSendEmailSuccess = {
  __typename?: "ContactUsSendEmailSuccess";
  /** button to close form on success */
  button: UiPrimaryButton;
  /** icon to display */
  icon: Icon;
  /** message of success send email */
  message: Scalars["String"];
  /** title of success send email */
  title: Scalars["String"];
};

/** Union of Success or Failed Response of Email */
export type ContactUsSendEmailView = ContactUsSendEmailFailed | ContactUsSendEmailSuccess;

/** Represents ContactUs Form */
export type ContactUsSheet = {
  __typename?: "ContactUsSheet";
  /** customer info  */
  customerFormContent: ContactUsSheetContent;
  /** Heading of Contact Us form */
  heading: Scalars["String"];
  /** see contact us options button */
  seeContactUsOptions: UiPrimaryButton;
  /** SubHeading of Contact Us form */
  subheading: Scalars["String"];
  /** Toolbar of Contact Us form */
  toolBar: ContactUsToolBar;
};

/** Contact Us Content in form */
export type ContactUsSheetContent = {
  __typename?: "ContactUsSheetContent";
  /** Represents category dropdown */
  categorySelect: EgdsBasicSelect;
  /** Represents intent dropdown */
  intentSelect: EgdsBasicSelect;
  /** Represents itinerary number of customer in contact us form */
  itineraryNumber: EgdsTextInputField;
  /** Represents phone number of customer in contact us form */
  phoneNumber: EgdsTextInputField;
};

/** Union of Contact Us Sheet and Error View for ContactUs Sheet */
export type ContactUsSheetView = ContactUsErrorView | ContactUsSheet;

/** Tool Bar for contact us */
export type ContactUsToolBar = {
  __typename?: "ContactUsToolBar";
  /** ICON for close tool bar */
  icon: Icon;
  /** Tool bar title */
  title: Scalars["String"];
};

export type ContactUsView = {
  __typename?: "ContactUsView";
  /** Contact us Options view form */
  contactUsOptionsView: ContactUsOptionsView;
  /** Contact us sheet form */
  contactUsSheetView: ContactUsSheetView;
  /** Get Email Form View for Contact Option */
  emailUsFormView: EmailUsFormView;
  /** Speak Next Available Agent View For Contact Option */
  speakNextAvailableAgentView: SpeakNextAvailableAgentView;
};

export type ContactUsViewContactUsOptionsViewArgs = {
  searchFormInput: ContactUsFormContentInput;
};

export type ContactUsViewEmailUsFormViewArgs = {
  optionType: ContactUsOptionType;
};

export type ContactUsViewSpeakNextAvailableAgentViewArgs = {
  optionType: ContactUsOptionType;
};

export type ContactUsViewMutation = {
  __typename?: "ContactUsViewMutation";
  /** Send Email Response */
  sendEmail: ContactUsSendEmailView;
};

export type ContactUsViewMutationSendEmailArgs = {
  sendEmailRequest: ContactUsSendEmailRequestInput;
};

/** UI Theme to be applied to a `UISectionContainer` or a `TripsSectionContainer`. */
export type ContainerTheme = "DEFAULT" | "IMPORTANT";

export type Content = {
  __typename?: "Content";
  /** List of images */
  image?: Maybe<TravelContentImages>;
  /** List of texts */
  text?: Maybe<TravelContentTexts>;
};

export type ContentImageArgs = {
  limit?: InputMaybe<Scalars["Int"]>;
};

export type ContentTextArgs = {
  limit?: InputMaybe<Scalars["Int"]>;
};

export interface ContentPaginationInput {
  pageNumber: Scalars["Int"];
  pageSize?: InputMaybe<Scalars["Int"]>;
}

/** The input BEX context used for identifying users, sites and other platform functions. See the platform-expsite docs for more info: https://docweb.prod.expedia.com/expsite */
export type Context = {
  __typename?: "Context";
  /**
   * Information regarding the application which triggered the query
   * @deprecated Rely on HTTP headers for client identification, replace with Format: `Client-Info=<name>,<version>,<environment>`
   */
  clientInfo?: Maybe<ClientInfo>;
  /** Currency as Alphabetic ISO 4217 code e.g. 'USD'. Use if default currency for Locale needs to be overwritten. */
  currency?: Maybe<Scalars["String"]>;
  /** Debugging context, such as Abacus overrides */
  debugContext?: Maybe<DebugContext>;
  /** Client/user Device information */
  device: Device;
  /** The Expedia Affiliate Partner ID */
  eapid?: Maybe<Scalars["Int"]>;
  /**
   * Deprecated output field added for compatability
   * @deprecated We no longer rely on identity for user determination.
   *         User determination is now based upon passed headers. Soon this will be made nullable and later removed.
   *         Will be replaced by JWTs when available., replace with DUAID Header
   */
  identity: Identity;
  /** The context locale, e.g. en_US */
  locale: Scalars["Locale"];
  /** User preference for tracking which is only required in POSs that require tracking opt in */
  privacyTrackingState?: Maybe<PrivacyTrackingState>;
  /** The context Site ID, e.g. (70201 for Orbitz) */
  siteId: Scalars["Int"];
  /** The legacy TravelProductID */
  tpid?: Maybe<Scalars["Int"]>;
};

/** The input BEX context used for identifying users, sites and other platform functions. See the platform-expsite docs for more info: https://docweb.prod.expedia.com/expsite */
export interface ContextInput {
  /** Information regarding the application which triggered the query */
  clientInfo?: InputMaybe<ClientInfoInput>;
  /** Currency as Alphabetic ISO 4217 code e.g. 'USD'. Use if default currency for Locale needs to be overwritten. */
  currency?: InputMaybe<Scalars["String"]>;
  /** Debugging context, such as Abacus overrides */
  debugContext?: InputMaybe<DebugContextInput>;
  /** Client/user Device information */
  device: DeviceInput;
  /** The Expedia Affiliate Partner ID */
  eapid?: InputMaybe<Scalars["Int"]>;
  /**
   * DEPRECATED: Optional Client/user information. Used for input only. Please send the DUIAD header instead.
   * We no longer rely on identity for user determination.
   * User determination is now based upon passed headers. Soon this will be made nullable and later removed.
   * Will be replaced by JWTs when available.
   */
  identity?: InputMaybe<IdentityInput>;
  /** The context locale, e.g. en_US */
  locale: Scalars["Locale"];
  /** User preference for tracking which is only required in POSs that require tracking opt in */
  privacyTrackingState?: InputMaybe<PrivacyTrackingState>;
  /** The context Site ID, e.g. (70201 for Orbitz) */
  siteId: Scalars["Int"];
  /** The legacy TravelProductID */
  tpid?: InputMaybe<Scalars["Int"]>;
}

/** An interface for notification to show in the client given the context */
export interface ContextualNotification {
  /** Represents the background image to be used in the notification */
  backgroundImage?: Maybe<Image>;
  /** Represents the list of the notification messages to show in the body section of the notification to be displayed on the client */
  body?: Maybe<Array<NotificationPhrase>>;
  /** Represents a link that should be applied to the container of the notification */
  containerLink?: Maybe<NotificationContainerLink>;
  /** Represents the icon that will be used in the notification */
  icon?: Maybe<Icon>;
  /** Represents the notification links to be displayed on the client */
  links?: Maybe<Array<NotificationPhraseLinkNode>>;
  /** Represents a logo image */
  logo?: Maybe<Image>;
  /** Represents the actions to apply on notification reveal */
  revealActions?: Maybe<Array<NotificationAction>>;
  /** Represents heading title of the notification to be displayed on the client */
  title?: Maybe<NotificationPhrase>;
  /** Represents the type of the notification */
  type: NotificationType;
}

/** Represents the context of a conversation */
export interface ConversationContextInput {
  /** Represents the conversation ID, used to route messages */
  conversationId?: InputMaybe<Scalars["String"]>;
  /** Represents the participant ID, used to identify the author of a message or the actor of an event */
  participantId?: InputMaybe<Scalars["String"]>;
  /** Represents the partner ID, used to route messages */
  partnerId?: InputMaybe<Scalars["String"]>;
}

export type ConversationIdentifiers = {
  __typename?: "ConversationIdentifiers";
  /** Represents the conversation ID, used to route messages */
  conversationId: Scalars["String"];
  /** Represents the participant ID, used to identify the author of a message or the actor of an event */
  participantId: Scalars["String"];
};

/** Properties for the conversation context. */
export type ConversationProperties = {
  __typename?: "ConversationProperties";
  /** From where the Virtual Agent was initialized. */
  launchPoint: Scalars["String"];
  /** Category of that individual web pages or app views (i.e. Storefront) */
  pageName?: Maybe<Scalars["String"]>;
  /** Used to skip conversation starter messages when there is an intent */
  skipWelcome?: Maybe<Scalars["String"]>;
  /** Identifier used to to tie chatbot events together */
  traceId?: Maybe<Scalars["UUID"]>;
};

/** Details of the flights information like landing/take-off time and location */
export type CoordinateInformation = {
  __typename?: "CoordinateInformation";
  /** Warning details about departing or arriving flights. Eg Arrives Sat, Jun 25 , or : Next Flight departs from SAW, not IST */
  flightDetailsWarningInfo?: Maybe<FlightsIconAndLabel>;
  /** Icon indicating take-off or landing */
  icon: Icon;
  /**
   * Information about the arrival time of the flight, ex: Arrives Sat, Jun 25
   * @deprecated This will be replaced by flightDetailsWarningInfo
   */
  overnightMessage?: Maybe<Scalars["String"]>;
  /**
   * Information about the arrival time of the flight, ex: Arrives Sat, Jun 25
   * @deprecated This will be replaced by flightDetailsWarningInfo
   */
  overnightMessageInfo?: Maybe<FlightsIconAndLabel>;
  /** Subtitle for the journey connection. City and Airport details of the flight, ex: Seattle-Tacoma Intl. (SEA) */
  subtitle: Scalars["String"];
  /**
   * Title for a connection, ex: 1:00pm - Seattle
   * @deprecated Replaced by titleAndAccessibilityMessage
   */
  title: Scalars["String"];
  /** Title for a connection, ex: 1:00pm - Seattle, accessibility: 1:00pm from Seattle, 5:00pm to Las Vegas */
  titleAndAccessibilityMessage: FlightsMessageAndAccessibility;
};

/** A latitude/longitude pair */
export type Coordinates = {
  __typename?: "Coordinates";
  /** The latitude of the point in degrees */
  latitude: Scalars["Float"];
  /** The longitude of the point in degrees */
  longitude: Scalars["Float"];
};

/** A latitude/longitude pair */
export interface CoordinatesInput {
  /** The latitude of the point in degrees */
  latitude: Scalars["Float"];
  /** The longitude of the point in degrees */
  longitude: Scalars["Float"];
}

/** Action describing the user interaction on an element should copy supplied text onto the device's clipboard */
export type CopyToClipboardAction = TripsAction & {
  __typename?: "CopyToClipboardAction";
  analytics: ClientSideAnalytics;
  toast?: Maybe<TripsInfoToast>;
  value: Scalars["String"];
};

export type CostPercentiles = {
  __typename?: "CostPercentiles";
  eightieth: Money;
  fiftieth: Money;
  ninetieth: Money;
  tenth: Money;
  twentieth: Money;
};

/** Cost percentiles aggregated over a month. */
export type CostPercentilesByMonth = {
  __typename?: "CostPercentilesByMonth";
  month: Month;
  percentiles: CostPercentiles;
};

/** Cost percentiles aggregated over a week. */
export type CostPercentilesByWeek = {
  __typename?: "CostPercentilesByWeek";
  percentiles: CostPercentiles;
  week: Scalars["Int"];
};

export type Coupon = {
  __typename?: "Coupon";
  instanceId: Scalars["String"];
  name: Scalars["String"];
  value?: Maybe<Scalars["String"]>;
};

/** Coupon and credits call to action */
export type CouponAndCreditAction = UiAction & {
  __typename?: "CouponAndCreditAction";
  /** Used to provide accessibility that has to be read on completion of action. */
  accessibility?: Maybe<Scalars["String"]>;
  /** Client analytics data. */
  analytics: ClientSideAnalytics;
  /** Destination link. */
  resource: Uri;
  /** Coupon and credits use instructions */
  useInstructions?: Maybe<CouponAndCreditUseAction>;
};

/** Coupon and credits card */
export type CouponAndCreditCard = {
  __typename?: "CouponAndCreditCard";
  actions: Array<Maybe<UiAction>>;
  airlineIcon?: Maybe<Scalars["String"]>;
  analytics?: Maybe<ClientSideAnalytics>;
  banner?: Maybe<UiBanner>;
  cardContents: Array<Maybe<CouponsAndCreditsCardContent>>;
  heading: Scalars["String"];
  subheading?: Maybe<Scalars["String"]>;
};

/** Coupon and credits Chatbot call to action */
export type CouponAndCreditChatbotAction = UiAction & {
  __typename?: "CouponAndCreditChatbotAction";
  /** Used to provide accessibility that has to be read on completion of action. */
  accessibility?: Maybe<Scalars["String"]>;
  /** Client analytics data. */
  analytics: ClientSideAnalytics;
  /** Chatbot intent configuration used to update the conversation context. */
  intentMessage: ChatbotConversationIntentMessage;
  /** Destination link. */
  resource: Uri;
};

/** Coupon and credits use instructions */
export type CouponAndCreditUseAction = {
  __typename?: "CouponAndCreditUseAction";
  /** Action details for the dialog. */
  actions: Array<UiAction>;
  /** Header text describing dialog content. */
  heading?: Maybe<Scalars["String"]>;
  /** A list of messages forming the content. */
  messages: Array<CouponAndCreditUseInstructionsMessage>;
};

/** Coupon and credits use instructions messaging content */
export type CouponAndCreditUseInstructionsMessage = {
  __typename?: "CouponAndCreditUseInstructionsMessage";
  /** Sub-section containing a list of text message points. */
  elements: Array<Scalars["String"]>;
  /** Content text message. */
  value?: Maybe<Scalars["String"]>;
};

/** A returned coupon */
export type CouponDetail = {
  __typename?: "CouponDetail";
  /** Coupon Id */
  id: Scalars["String"];
  /** Coupon name */
  name: Scalars["String"];
  /** Coupon status message */
  statusMessage: Scalars["String"];
  /** Coupon terms and conditions */
  termsAndConditions: CouponTermsAndConditions;
};

export type CouponEntryTab = EgdsTab & {
  __typename?: "CouponEntryTab";
  accessibility?: Maybe<Scalars["String"]>;
  label: Scalars["String"];
  tabId: Scalars["String"];
};

export interface CouponIdentifierInput {
  type: CouponIdentifierType;
  value: Scalars["String"];
}

export type CouponIdentifierType = "CODE" | "INSTANCE_ID";

export type CouponRedemption = {
  __typename?: "CouponRedemption";
  appliedCoupon?: Maybe<EgdsStandardMessagingCard>;
  callToAction?: Maybe<EgdsStandardMessagingCard>;
  dialog?: Maybe<CouponRedemptionView>;
  errorMessage?: Maybe<Scalars["String"]>;
};

export type CouponRedemptionFromAccount = {
  __typename?: "CouponRedemptionFromAccount";
  apply: EgdsButton;
  coupons: Array<Coupon>;
  text: Scalars["String"];
};

export type CouponRedemptionView = {
  __typename?: "CouponRedemptionView";
  accountCoupons?: Maybe<CouponRedemptionFromAccount>;
  codeEntry: CouponRedemptionWithCode;
  couponEntryTypeSelection: EgdsBasicTabs;
  toolbar: EgdsDialogToolbar;
};

export type CouponRedemptionWithCode = {
  __typename?: "CouponRedemptionWithCode";
  apply: EgdsButton;
  couponCodeInput: EgdsTextInputField;
  signIn?: Maybe<EgdsStandardLink>;
};

/** Terms and conditions for the coupon */
export type CouponTermsAndConditions = {
  __typename?: "CouponTermsAndConditions";
  /** Coupon terms and conditions page URL */
  informationUrl: HttpUri;
  /** Text fot coupon terms and conditions page link */
  text: Scalars["String"];
};

export type CouponsAndCredits = {
  __typename?: "CouponsAndCredits";
  /** Indicates if the user has active coupons, expired coupons or none */
  activeStatus?: Maybe<ActiveState>;
  /** Custom Messaging for active coupon and credit in user account */
  additionalMessaging?: Maybe<Scalars["String"]>;
  /** Banner above coupons and credits */
  banner?: Maybe<UiBanner>;
  /** Coupons and credits in customer account */
  elements: Array<CouponsAndCreditsSectionContainer>;
  /** Coupons and credits navigation */
  navLink?: Maybe<UiLinkAction>;
  sourceAnalyticsTagging?: Maybe<ClientSideAnalytics>;
};

/** Content with optional trailing link */
export type CouponsAndCreditsCardContent = {
  __typename?: "CouponsAndCreditsCardContent";
  link?: Maybe<UiLinkAction>;
  value: Scalars["String"];
};

/** Coupons and credits empty state */
export type CouponsAndCreditsEmptyState = {
  __typename?: "CouponsAndCreditsEmptyState";
  elements: Array<Scalars["String"]>;
};

/** Coupons and credits expando */
export type CouponsAndCreditsExpando = {
  __typename?: "CouponsAndCreditsExpando";
  action: UiAction;
  elements: Array<CouponAndCreditCard>;
};

/** Coupons and credits link with footer */
export type CouponsAndCreditsExplainedLink = {
  __typename?: "CouponsAndCreditsExplainedLink";
  footer?: Maybe<Scalars["String"]>;
  link: UiLinkAction;
};

/** Coupon and credits card grouping */
export type CouponsAndCreditsGroup = {
  __typename?: "CouponsAndCreditsGroup";
  cards: Array<CouponAndCreditCard>;
  expando?: Maybe<CouponsAndCreditsExpando>;
  heading?: Maybe<Scalars["String"]>;
  subheading?: Maybe<Scalars["String"]>;
};

export type CouponsAndCreditsListing = CouponsAndCreditsEmptyState | CouponsAndCreditsGroup;

/** Coupon and credits section */
export type CouponsAndCreditsSectionContainer = {
  __typename?: "CouponsAndCreditsSectionContainer";
  elements: Array<CouponsAndCreditsListing>;
  heading: Scalars["String"];
  links: Array<Maybe<CouponsAndCreditsExplainedLink>>;
};

export type CouponsAndCreditsSimpleAction = UiAction & {
  __typename?: "CouponsAndCreditsSimpleAction";
  accessibility?: Maybe<Scalars["String"]>;
  analytics: ClientSideAnalytics;
};

export type CreditCardApplicationForm = {
  __typename?: "CreditCardApplicationForm";
  sections: Array<CreditCardApplicationFormSection>;
  title?: Maybe<EgdsHeading>;
};

export type CreditCardApplicationFormField = CreditCardApplicationFormInput | CreditCardApplicationFormText;

export type CreditCardApplicationFormInput = {
  __typename?: "CreditCardApplicationFormInput";
  inputField: CreditCardApplicationFormInputField;
};

export type CreditCardApplicationFormInputField =
  | EgdsBasicCheckBox
  | EgdsBasicRadioGroup
  | EgdsBasicSelect
  | EgdsEmailInputField
  | EgdsNumberInputField
  | EgdsTextInputField;

export type CreditCardApplicationFormSection = {
  __typename?: "CreditCardApplicationFormSection";
  fields: Array<CreditCardApplicationFormField>;
  title?: Maybe<EgdsHeading>;
};

export type CreditCardApplicationFormText = {
  __typename?: "CreditCardApplicationFormText";
  textElement: EgdsComposableTextElement;
};

export type CreditCardApplyButton = {
  __typename?: "CreditCardApplyButton";
  action: CreditCardApplyButtonAction;
  button: CreditCardButton;
};

/** Return the possible action of the Apply Button */
export type CreditCardApplyButtonAction = CreditCardEmbeddedApplyAction | UiLinkAction;

export type CreditCardApplyButtonActionType = "EMBEDDED" | "EXTERNAL";

/** Return the possible button type of the Apply Button */
export type CreditCardButton = UiPrimaryButton | UiSecondaryButton;

export type CreditCardEmbeddedApplyAction = {
  __typename?: "CreditCardEmbeddedApplyAction";
  accessibility?: Maybe<Scalars["String"]>;
  analytics: ClientSideAnalytics;
  /** The container for the action result */
  container: CreditCardEmbeddedApplyActionSheet;
};

export type CreditCardEmbeddedApplyActionSheet = {
  __typename?: "CreditCardEmbeddedApplyActionSheet";
  sheet: EgdsSheet;
};

export type CreditCardPromotionResult = {
  __typename?: "CreditCardPromotionResult";
  applyButton: CreditCardApplyButton;
};

/** Enum class to represent the type of credit eligible filter */
export type CreditEligibleFilterType = "CREDIT_ELIGIBLE";

export type CreditRedemptionInsurtechOffersResponse = {
  __typename?: "CreditRedemptionInsurtechOffersResponse";
  /** The content of the module. */
  creditRedemptionInsurtechModule: InsurtechModule;
};

export interface CriteriaRange {
  max?: Maybe<Scalars["Float"]>;
  min?: Maybe<Scalars["Float"]>;
}

/** Crosslinks with different supported link types */
export type CrossLink = EgdsImageLinkCard | EgdsStandardLink;

export type CrossLinkGrid = {
  __typename?: "CrossLinkGrid";
  /** crosslinks link list */
  links: Array<CrossLink>;
};

export type CrossLinksContainer = {
  __typename?: "CrossLinksContainer";
  carousel?: Maybe<EgdsCarousel>;
  description?: Maybe<Scalars["String"]>;
  grid?: Maybe<CrossLinkGrid>;
  header?: Maybe<Scalars["String"]>;
  map?: Maybe<EgdsBasicMap>;
  subheader?: Maybe<Scalars["String"]>;
};

export interface CrossLinksParameterInput {
  name: Scalars["String"];
  value: Scalars["String"];
}

/** DEPRECATED: Use `MultiItemCrossSellUILinkAction` or `MultiItemCrossSellUIButtonAction` instead. This is kept for backward compatibility in existing client. */
export type CrossSellAction = CrossSellButtonAction | CrossSellLinkAction;

/** DEPRECATED: Use `MultiItemCrossSellUILinkAction` or `MultiItemCrossSellUIButtonAction` instead. This is kept for backward compatibility in existing client. */
export type CrossSellButtonAction = UiAction & {
  __typename?: "CrossSellButtonAction";
  accessibility?: Maybe<Scalars["String"]>;
  analytics: ClientSideAnalytics;
  /** The icon to render beside the action if any. */
  icon?: Maybe<Icon>;
  /** Link text or accessibility text. */
  label: Scalars["String"];
  resource: Uri;
};

/** An dialog element containing a dialog trigger, text content and the dialog itself */
export type CrossSellLegalDisclaimerDialog = {
  __typename?: "CrossSellLegalDisclaimerDialog";
  analytics: ClientSideAnalytics;
  dialog: EgdsActionDialog;
  graphic: UiGraphic;
  text: Scalars["String"];
};

/** DEPRECATED: Use `MultiItemCrossSellUILinkAction` instead. This is kept for backward compatibility in existing client. */
export type CrossSellLinkAction = UiAction & {
  __typename?: "CrossSellLinkAction";
  accessibility?: Maybe<Scalars["String"]>;
  analytics: ClientSideAnalytics;
  /** Link text or accessibility text. */
  label: Scalars["String"];
  resource: Uri;
};

/** A message item that can contain a localized message and a legal disclaimer dialog */
export type CrossSellMessageItem = {
  __typename?: "CrossSellMessageItem";
  crossSellMessage: Scalars["String"];
  disclaimerDialog?: Maybe<CrossSellLegalDisclaimerDialog>;
};

export type CrossSellOption = {
  __typename?: "CrossSellOption";
  /** The main action for this CrossSellOption */
  action: CrossSellLinkAction;
  /** The list of secondary actions to interact with this CrossSellOption */
  actionBar?: Maybe<Array<CrossSellAction>>;
  /** The icon to represent this CrossSellOption */
  graphic?: Maybe<UiGraphic>;
  /** The header used for this CrossSellOption */
  header: CrossSellPrimary;
  /** The image to represent this CrossSellOption */
  image?: Maybe<Image>;
  /** The secondary elements for this CrossSellOption, can include text, legal disclaimers and links */
  messageItems: Array<CrossSellSecondary>;
  /**
   * The primary text for this CrossSellOption
   * @deprecated use header instead
   */
  primary: Scalars["String"];
  /**
   * The secondary text for this CrossSellOption
   * @deprecated use messageItems instead
   */
  secondaries?: Maybe<Array<Scalars["String"]>>;
};

/** An element used to build the primary elements for a CrossSellOption */
export type CrossSellPrimary = CrossSellMessageItem;

export type CrossSellProductType = "ACTIVITY" | "CAR" | "FLIGHT" | "HOTEL";

export type CrossSellProductTypeQueries = {
  __typename?: "CrossSellProductTypeQueries";
  /** The product type that we recommend to cross sell */
  productTypes: Array<CrossSellProductType>;
};

export type CrossSellQueries = {
  __typename?: "CrossSellQueries";
  /** List of product types that should be cross-sold to the customer */
  crossSellProductTypes: CrossSellProductTypeQueries;
  /** Grouping of all multiitem dynamic xsell queries */
  dynamic: DynamicCrossSellQueries;
  /** Grouping of all multi-item static xsell queries */
  static: StaticCrossSellQueries;
};

export type CrossSellQueriesCrossSellProductTypesArgs = {
  userLocation?: InputMaybe<CrossSellUserLocationInput>;
};

/** An element used to build the secondary elements for a CrossSellOption */
export type CrossSellSecondary = CrossSellLinkAction | CrossSellMessageItem;

/** Represent the current location of the User so we can propose an origin for the flights */
export interface CrossSellUserLocationInput {
  /** The city of User's current location. ex: SANJOSE */
  city: Scalars["String"];
  /** The continent code of User's current location. ex: NA */
  continent: Scalars["String"];
  /** The country code of User's current location. ex: US */
  country: Scalars["String"];
  /** The region or state code of User's current location. ex: CA */
  region: Scalars["String"];
}

export type CruiseAction = UiAction & {
  __typename?: "CruiseAction";
  accessibility?: Maybe<Scalars["String"]>;
  analytics: ClientSideAnalytics;
};

/** Amenities on a sailing */
export type CruiseAmenities = {
  __typename?: "CruiseAmenities";
  /** The rows for highlights within a given amenity section */
  rows?: Maybe<Array<CruiseHighlightRow>>;
};

export type CruiseBadgeTheme = "DEAL_GENERIC" | "DEAL_MEMBER" | "VIP";

/** Cabin Class attributes */
export type CruiseCabinClass = {
  __typename?: "CruiseCabinClass";
  /** Accessibility text */
  accessibility: Scalars["String"];
  /** Analytics for clicking on cabin class card */
  analytics: ClientSideAnalytics;
  /** Continue button. */
  continueButton: UiPrimaryButton;
  /** Description of the cabin class. */
  descriptionText: Scalars["String"];
  /** Cabin features. */
  features: Array<CruiseCabinClassFeature>;
  /** Carousel of cabin class images */
  galleryCarousel: CruiseGallery;
  /** Lowest and highest occupancy of room types. */
  occupancyRange?: Maybe<CruiseCabinClassOccupancy>;
  /** Price for the experience. */
  price: CruisePrice;
  /** Lowest and highest square footage of room types. */
  squareFootageRange?: Maybe<CruiseCabinClassSquareFootage>;
  /** Title of the cabin class. Inside, Oceanview, Balcony or Suite */
  title: Scalars["String"];
  /** User interest, if user selected this cabin experience before coming to the page. */
  userInterest?: Maybe<CruiseUserInterest>;
};

/** Cabin Class features */
export type CruiseCabinClassFeature = {
  __typename?: "CruiseCabinClassFeature";
  /** Accessibility description for feature. */
  description: Scalars["String"];
  /** Icon for the feature. */
  icon: Icon;
  /** Text defining the feature. */
  text: Scalars["String"];
};

/** Cabin Class Occupancy attributes */
export type CruiseCabinClassOccupancy = {
  __typename?: "CruiseCabinClassOccupancy";
  /** Accessibility description for occupancy */
  description?: Maybe<Scalars["String"]>;
  /** Icon for occupancy range. */
  icon?: Maybe<Icon>;
  /** Lowest and highest occupancy of room types. */
  text?: Maybe<Scalars["String"]>;
};

/** Cabin Class Occupancy attributes */
export type CruiseCabinClassSquareFootage = {
  __typename?: "CruiseCabinClassSquareFootage";
  /** Accessibility description for square footage. */
  description?: Maybe<Scalars["String"]>;
  /** Icon for occupancy range. */
  icon?: Maybe<Icon>;
  /** Lowest and highest occupancy of room types. */
  text?: Maybe<Scalars["String"]>;
};

/** Cabin Experience Section */
export type CruiseCabinExperience = {
  __typename?: "CruiseCabinExperience";
  /** Analytics. */
  analytics: CruiseCabinExperienceAnalytics;
  /** Cabin classes available. */
  cabinClasses?: Maybe<Array<CruiseCabinClass>>;
  /** Description of the section. */
  descriptionText?: Maybe<Scalars["String"]>;
  /** Expressed preference for a Cabin Experience which user previously filtered while searching cruises */
  expressedPreference?: Maybe<CruiseExpressedPreference>;
  /** Text for next button. */
  nextButtonText: Scalars["String"];
  /** Text for prev button. */
  prevButtonText: Scalars["String"];
  /** Title of the section. */
  title?: Maybe<Scalars["String"]>;
};

/** Cabin Experience Section Analytics */
export type CruiseCabinExperienceAnalytics = {
  __typename?: "CruiseCabinExperienceAnalytics";
  /** Carousel name for the analytics. */
  carouselName: Scalars["String"];
  /** Description for the analytics. */
  description: Scalars["String"];
  /** Id for the analytics. */
  id: Scalars["String"];
};

/** Button text of gallery carousel container */
export type CruiseCarouselButtonText = {
  __typename?: "CruiseCarouselButtonText";
  /** a11y text for show all gallery button of carousel container */
  galleryButton: Scalars["String"];
  /** a11y text for next button of carousel container */
  nextButton: Scalars["String"];
  /** a11y text for previous button of carousel container */
  prevButton: Scalars["String"];
};

/** A guest over the age of 2 */
export interface CruiseChildInput {
  /** The child's age in years */
  age: Scalars["Int"];
}

export interface CruiseCommonItinerary {
  callToAction?: Maybe<UiPrimaryButton>;
  itineraryItems?: Maybe<Array<CruiseItineraryItem>>;
  secondaryItineraryItems?: Maybe<Array<CruiseItineraryItem>>;
}

export type CruiseCommonItineraryImpl = CruiseCommonItinerary & {
  __typename?: "CruiseCommonItineraryImpl";
  /** Call to action to see full itinerary */
  callToAction?: Maybe<UiPrimaryButton>;
  /** First part of the individual itinerary items (till maxDaysToShow) */
  itineraryItems?: Maybe<Array<CruiseItineraryItem>>;
  /** Rest of the individual itinerary items (from maxDaysToShow onward) */
  secondaryItineraryItems?: Maybe<Array<CruiseItineraryItem>>;
};

/** Dialog with descriptive information */
export type CruiseDialog = {
  __typename?: "CruiseDialog";
  /** Price disclaimer dialog close action */
  closeAction?: Maybe<UiAction>;
  /** Content of the dialog */
  content: Scalars["String"];
  /** Price disclaimer dialog open action */
  openAction?: Maybe<UiAction>;
  /** Text for accessibility */
  priceText?: Maybe<Scalars["String"]>;
  /** Primary call to action button */
  primaryButton: UiPrimaryButton;
};

/** Duration of cruise to perform a cruise search */
export interface CruiseDurationRangeInput {
  max: Scalars["Int"];
  min: Scalars["Int"];
}

/** User expressed preference for a filtered cabin experience */
export type CruiseExpressedPreference = {
  __typename?: "CruiseExpressedPreference";
  /** Cabin Experience index that user is interested in. */
  cabinExperienceIndex: Scalars["Int"];
};

export type CruiseFeature = "MEMBER_DEALS";

export type CruiseFilterType =
  /** cabin experience - eg. Suite  */
  | "CABIN"
  /** departure port */
  | "DEPARTURE"
  /** use for filtering by the destination */
  | "DESTINATION"
  /** length of cruise nights 1-2, 3-5, 6-9 , 10-14, 15+ */
  | "LENGTH"
  /** use for filtering by the cruise line name */
  | "NAME"
  /** default not set value */
  | "NOT_SET"
  /** ship type */
  | "SHIP"
  /** use for ocean cruise */
  | "THEME_OCEAN"
  /** use for river cruise */
  | "THEME_RIVER";

/** Displays relevant images for the sailing */
export type CruiseGallery = {
  __typename?: "CruiseGallery";
  /** Accessibility string for gallery heading text */
  a11yGalleryHeading?: Maybe<Scalars["String"]>;
  /** Button text of gallery carousel container */
  buttonText: CruiseCarouselButtonText;
  /** close button in the full image take over within the media gallery overlay */
  detailDialogClose?: Maybe<UiAction>;
  /** left/right arrow in the full image take over within the media gallery overlay */
  detailDialogLeftRight?: Maybe<UiAction>;
  /** Accessibility string for closing a dialog */
  dialogCloseText?: Maybe<Scalars["String"]>;
  /** Analytics for trigger of the overlay with media gallery, thumbnail view. */
  dialogOpen?: Maybe<UiAction>;
  /** Analytics for click on a specific image within the carousel to overlay a full image */
  imageClick?: Maybe<UiAction>;
  /** Analytics for engagement of left and right button on gallery carousel */
  leftRightClientSideAnalytics?: Maybe<UiAction>;
  /**
   * List of combined media (images, video) for a given sailing
   * @deprecated Use CruiseMediaItem list instead.
   */
  media?: Maybe<Array<CruiseMedia>>;
  /** List of combined mediaItems (images, video) for a given sailing */
  mediaItems?: Maybe<Array<CruiseMediaItem>>;
  /** Title of the gallery */
  text?: Maybe<Scalars["String"]>;
  /** Closing the thumbnail dialog view */
  thumbnailDialogClose?: Maybe<UiAction>;
  /** clicking on a specific image within the photo thumbnail gallery overlay. */
  thumbnailDialogImageClick?: Maybe<UiAction>;
  /** Button text of video */
  videoButtonText?: Maybe<CruiseVideoButtonText>;
  /** Video play/pause button click */
  videoPlayPauseButtonClick?: Maybe<UiAction>;
};

/** Highlighting a given sailing attribute and an icon showing the perk */
export type CruiseHighlight = {
  __typename?: "CruiseHighlight";
  /** Icon representing a feature or perk */
  icon?: Maybe<Icon>;
  /** Secondary text for the highlight */
  secondaryText?: Maybe<Scalars["String"]>;
  /** Text for the highlight */
  text?: Maybe<Scalars["String"]>;
};

/** A single row of sailing amenities */
export type CruiseHighlightRow = {
  __typename?: "CruiseHighlightRow";
  /** CruiseHighlights relevant to this amenity */
  highlights?: Maybe<Array<CruiseHighlight>>;
  /** Subtitle text for the amenity row */
  subTitle?: Maybe<Scalars["String"]>;
  /** Title text for the amenity */
  title?: Maybe<Scalars["String"]>;
};

/** Icon with descriptive information */
export type CruiseIcon = {
  __typename?: "CruiseIcon";
  /** Analytics data for tracking */
  clientSideAnalytics?: Maybe<ClientSideAnalytics>;
  /** Icon symbol */
  icon?: Maybe<Icon>;
  /** Text or label that should be displayed */
  text?: Maybe<Scalars["String"]>;
  /** Theme for the icon */
  theme?: Maybe<CruiseBadgeTheme>;
};

/** Itinerary of a sailing */
export type CruiseItinerary = CruiseCommonItinerary & {
  __typename?: "CruiseItinerary";
  /** Call to action to see full itinerary */
  callToAction?: Maybe<UiPrimaryButton>;
  /** Carousel of sailing itinerary images */
  galleryCarousel: CruiseGallery;
  /** First part of the individual itinerary items (till maxDaysToShow) */
  itineraryItems?: Maybe<Array<CruiseItineraryItem>>;
  /** Rest of the individual itinerary items (from maxDaysToShow onward) */
  secondaryItineraryItems?: Maybe<Array<CruiseItineraryItem>>;
  /** Title for the itinerary */
  title: Scalars["String"];
};

/** A day of the itinerary */
export type CruiseItineraryItem = {
  __typename?: "CruiseItineraryItem";
  /** a11y description for time */
  accessibilityTimeDescription?: Maybe<Scalars["String"]>;
  /** Button of the itinerary */
  button?: Maybe<EgdsOverlayButton>;
  /** Description of the itinerary */
  description?: Maybe<Scalars["String"]>;
  /** Icon symbol */
  icon?: Maybe<Icon>;
  /** Image of the itinerary */
  image?: Maybe<Image>;
  /** Primary subtitle for the itinerary */
  primarySubtitle?: Maybe<Scalars["String"]>;
  /** Secondary subtitle for the itinerary */
  secondarySubtitle?: Maybe<Scalars["String"]>;
  /** Title for the itinerary */
  title?: Maybe<Scalars["String"]>;
};

/** Cruise line policies */
export type CruiseLinePolicies = {
  __typename?: "CruiseLinePolicies";
  /** list of policies of cruise line */
  policies: Array<CruiseLinePolicy>;
  /** title for the policies section */
  title: Scalars["String"];
};

/** Cruise line policy */
export type CruiseLinePolicy = {
  __typename?: "CruiseLinePolicy";
  /** Click Analytics data for tracking */
  clientSideAnalytics: ClientSideAnalytics;
  /** Accessibility Text for the policy links */
  description: Scalars["String"];
  /** Link to the policy page */
  link?: Maybe<Scalars["String"]>;
  /** Description for the link */
  text: Scalars["String"];
};

/** A video or image with a url, caption and type */
export type CruiseMedia = {
  __typename?: "CruiseMedia";
  /** Alt text for the media item */
  alt?: Maybe<Scalars["String"]>;
  /** Caption for the media item */
  caption?: Maybe<Scalars["String"]>;
  /** link to the media item */
  src?: Maybe<Scalars["String"]>;
  /** Type of media: image or video */
  type?: Maybe<MediaType>;
};

/** A video or image with a url, caption and type */
export type CruiseMediaItem = MediaItem & {
  __typename?: "CruiseMediaItem";
  /** Accessibility text for media */
  alt?: Maybe<Scalars["String"]>;
  /** Media type: image or video */
  media: Media;
};

/** Messaging card */
export type CruiseMessagingCard = {
  __typename?: "CruiseMessagingCard";
  /** Icon in the card */
  icon: Scalars["String"];
  /** Message in the card. */
  message?: Maybe<Scalars["String"]>;
  /** Phone number for the card. */
  phoneNumber?: Maybe<CruisePhoneNumber>;
  /** Request consultation. */
  requestConsultation: CruiseRequestConsultation;
  /** Title in the card. */
  title: Scalars["String"];
};

/** Navigation bar with tabs and a choose button */
export type CruiseNavigationBar = {
  __typename?: "CruiseNavigationBar";
  /** Primary call to action button */
  primaryButton: UiPrimaryButton;
  /** Tabs that should be displayed */
  tabs?: Maybe<Array<SailingNavigationBarTab>>;
};

export type CruiseOffersResults = {
  __typename?: "CruiseOffersResults";
  /** Get Sailing Amenities */
  amenities: CruiseAmenities;
  /** Get cabin experience section */
  cabinExperience?: Maybe<CruiseCabinExperience>;
  /** Get cruise line Policies  */
  cruiseLinePolicies?: Maybe<CruiseLinePolicies>;
  /** Get sailing information */
  details: CruiseSailingDetails;
  /**
   * Get Sailing Gallery
   * @deprecated Use galleryMediaItem instead.
   */
  gallery: CruiseGallery;
  /** Get Sailing Gallery */
  galleryMediaItem: CruiseGallery;
  /** Get generic errors message */
  genericErrorsMessage?: Maybe<NoResultsMessage>;
  /** Get Sailing Cruise Itinerary */
  itinerary: CruiseItinerary;
  /** Get messaging card details */
  messagingCard: CruiseMessagingCard;
  /** Get navigation bar */
  navigationBar?: Maybe<CruiseNavigationBar>;
  /** Get link back to the search results page */
  sailingSearchLink: CruiseSailingSearchLink;
  /** Get Terms and Conditions */
  termsAndConditions: CruiseSubsection;
};

/** Phone number */
export type CruisePhoneNumber = {
  __typename?: "CruisePhoneNumber";
  clientSideAnalytics?: Maybe<ClientSideAnalytics>;
  /** Formatted phone number */
  formatted?: Maybe<Scalars["String"]>;
  /** Phone number without any formatting */
  number?: Maybe<Scalars["String"]>;
};

/** Cruise pricing information */
export type CruisePrice = {
  __typename?: "CruisePrice";
  /** Text for 'including taxes & fees' */
  allInPriceText?: Maybe<Scalars["String"]>;
  /** Badge to display member pricing deal */
  badge?: Maybe<CruiseIcon>;
  /** Dialog for standard rate */
  dialog?: Maybe<CruiseDialog>;
  /** Icon symbol for info. Not used in shared-ui. Remove once shared-ui removes this from fragment. */
  icon?: Maybe<CruiseIcon>;
  /** Price for lead in formatted */
  priceFormatted?: Maybe<Scalars["String"]>;
  /** Price text for accessibility */
  priceText?: Maybe<Scalars["String"]>;
  /** Secondary text for 'per traveler' */
  secondaryText?: Maybe<Scalars["String"]>;
  /** Price for strikeout formatted */
  strikeoutPriceFormatted?: Maybe<Scalars["String"]>;
  /** strikeoutPricing Accessibility Text */
  strikeoutPriceText?: Maybe<Scalars["String"]>;
  /** Text to describe the pricing 'from' */
  text?: Maybe<Scalars["String"]>;
};

/** Cruise product gallery details */
export type CruiseProductGallery = {
  __typename?: "CruiseProductGallery";
  /** Heading text for accessibility */
  heading?: Maybe<Scalars["String"]>;
  /** Next button text for accessibility */
  nextButton?: Maybe<Scalars["String"]>;
  /** Previous button text for accessibility */
  prevButton?: Maybe<Scalars["String"]>;
  /** Analytics for engagement of left and right button on product card gallery */
  thumbnailLeftRightClickAnalytics?: Maybe<UiAction>;
};

/** Request consultation */
export type CruiseRequestConsultation = {
  __typename?: "CruiseRequestConsultation";
  /** Client side analytics */
  clientSideAnalytics: ClientSideAnalytics;
  /** Link for requesting consultation */
  link: Scalars["String"];
  /** Open link in new tab */
  openInNewTab: Scalars["Boolean"];
  /** Text to show */
  text: Scalars["String"];
};

export interface CruiseRequestContextInput {
  /** Cruise features enum to be passed down to cruise supply services as a header value */
  cruiseFeatures?: InputMaybe<Array<CruiseFeature>>;
  /** Default current to be used. If not set, cruise api will fall back to USD */
  defaultCurrency?: InputMaybe<Scalars["String"]>;
  /** Inventory is striped by an optional franchise model key. More info here: https://confluence.expedia.biz/display/EWECruise/Design%3A+Franchise+Model+Key+Management */
  franchiseModelKey?: InputMaybe<Scalars["String"]>;
  /** Flag that is set when the user is shopping as an agent from Partner Central */
  isAgent?: InputMaybe<Scalars["Boolean"]>;
}

/** Basic info about a cruise trip */
export type CruiseSailingDetails = {
  __typename?: "CruiseSailingDetails";
  /** Accessibility: [Departure city], [Departure country],  to [Port name city], [Port name country],  to [Port name city], [Port name ccountry],  to [Return city], [Return country]  */
  a11yDescription?: Maybe<Scalars["String"]>;
  /** [Deparure Port Name] - [Next Port Name] - .... */
  description: Scalars["String"];
  /** Image of given cruise and alt details */
  iconMedia?: Maybe<CruiseMediaItem>;
  /** Path to be used in infosite page url */
  infoSitePath?: Maybe<Scalars["String"]>;
  /** Title to be used on infosite page */
  pageTitle?: Maybe<Scalars["String"]>;
  /** Price section of the trip details */
  priceSummary: CruisePrice;
  /** Primary section of the trip details text */
  primarySubsection?: Maybe<CruiseSubsection>;
  /** Primary subtitle for the details */
  primarySubtitle?: Maybe<Scalars["String"]>;
  /** Secondary section of the trip details text */
  secondarySubsection?: Maybe<CruiseSubsection>;
  /** Secondary subtitle for the details */
  secondarySubtitle?: Maybe<Scalars["String"]>;
  /** [#] Night [Destination] */
  title?: Maybe<Scalars["String"]>;
};

/** Link back to the search results page */
export type CruiseSailingSearchLink = {
  __typename?: "CruiseSailingSearchLink";
  /** Link with a destination uri */
  defaultLink: UiLinkAction;
  /** Icon next to the `text`. */
  icon?: Maybe<Icon>;
  /** Description for the link */
  text: Scalars["String"];
};

/** Property criteria needed to perform a cruise search */
export interface CruiseSearchCriteriaInput {
  primary: PrimaryCruiseCriteriaInput;
  secondary?: InputMaybe<ShoppingSearchCriteriaInput>;
}

/** Cruise Search Filters */
export type CruiseSearchFilters = {
  __typename?: "CruiseSearchFilters";
  /** Filter & Sort dialog */
  filtersDialog: CruiseSearchFiltersDialog;
  /** Adapter details for port typeahead */
  portTypeaheadAdapterDetails: CruiseTypeaheadAdapterDetails;
  /**
   * Remove all filters button text which removes all pills
   * @deprecated Use universalSortAndFilter.clearAll.primary instead
   */
  removeAllFiltersText: Scalars["String"];
  /** Adapter details for ship typeahead */
  shipTypeaheadAdapterDetails: CruiseTypeaheadAdapterDetails;
  /** universal sort and filter in sailing search */
  universalSortAndFilter: ShoppingSortAndFilters;
};

/** Cruise Search Filters Dialog */
export type CruiseSearchFiltersDialog = {
  __typename?: "CruiseSearchFiltersDialog";
  /** Count of applied filters */
  appliedFilterCount?: Maybe<Scalars["String"]>;
  /** Clear button text */
  clearButtonText: Scalars["String"];
  /** Close icon label */
  closeIconLabel: Scalars["String"];
  /** Done button text */
  doneButtonText: Scalars["String"];
  /** Close icon */
  filterButtonIcon: Icon;
  /** Theme for displaying filter count */
  filterCountTheme: CruiseBadgeTheme;
  /** Header of the dialog */
  primary: Scalars["String"];
};

export interface CruiseSearchFiltersInput {
  /** 1 or more cruise line codes separated by ',' delimiter  */
  cruiseLines?: InputMaybe<Scalars["String"]>;
  /** 1 or more port codes separated by ',' delimiter  */
  departureLocations?: InputMaybe<Scalars["String"]>;
  /** 1 or more deeplink destination names separated by ',' delimiter  */
  destinationNames?: InputMaybe<Scalars["String"]>;
  /** Earliest departure date */
  earliestDeptDate?: InputMaybe<Scalars["String"]>;
  /** CruiseFilterType enum name to describe the primary function of the SearchFilter */
  filterType: CruiseFilterType;
  /** Latest departure date */
  latestDeptDate?: InputMaybe<Scalars["String"]>;
  /** Max length of sailing */
  maxLength?: InputMaybe<Scalars["String"]>;
  /** Return sailings with member only offer */
  memberOnlyOffer?: InputMaybe<Scalars["Boolean"]>;
  /** Min length of sailing */
  minLength?: InputMaybe<Scalars["String"]>;
  /** 1 or more promotion codes separated by ',' delimiter  */
  promotionCode?: InputMaybe<Scalars["String"]>;
  /** ocean or river */
  sailingVarieties?: InputMaybe<Scalars["String"]>;
  /** 1 or more ship codes separated by ',' delimiter  */
  ships?: InputMaybe<Scalars["String"]>;
  /** Cabin type filter. One of the ANY, INSIDE, OCEAN_VIEW, BALCONY or SUITE */
  superCategoryCode?: InputMaybe<Scalars["String"]>;
}

/** Represents the cruise search form */
export type CruiseSearchForm = EgdsElement &
  EgdsSearchForm & {
    __typename?: "CruiseSearchForm";
    actionURL: Scalars["String"];
    egdsElementId?: Maybe<Scalars["String"]>;
    elements: Array<EgdsSearchFormElement>;
    errorSummary?: Maybe<EgdsErrorSummary>;
    playback?: Maybe<EgdsSearchPlayback>;
    search?: Maybe<EgdsButton>;
    typeaheadAdapterDetails?: Maybe<TypeaheadAdapterDetails>;
  };

/** See all sailings text and button  */
export type CruiseSearchNavigation = {
  __typename?: "CruiseSearchNavigation";
  /** secondary button - eg. see all sailings landing page link */
  button: UiSecondaryButton;
  /** subtitle - eg. See all available sailings */
  subtitle: Scalars["String"];
  /** title - eg. Don't see what you're looking for? */
  title: Scalars["String"];
};

/**
 * Values : popularity - sorts by Popularity
 * price - sorts by the offer price within all sailings returned
 * length - sorts by the sailing itinerary length, in days
 * departureDate - sorts by sailing departure/embarkation date
 * cruiseLine - sorts by cruise line name
 */
export interface CruiseSearchOptionsInput {
  /** Number of adults - Default is 2 */
  adultCount: Scalars["Int"];
  /** Number of children - Default is 0 */
  childCount: Scalars["Int"];
  /** Limit of how many results will be returned. - Default is 20 */
  limit: Scalars["Int"];
  /** Limit of how many results will be skipped. - Default is 0 */
  offset?: InputMaybe<Scalars["Int"]>;
  /** Field to sort results by - Default is departure-date */
  sortBy?: InputMaybe<Scalars["String"]>;
}

export type CruiseSearchResults = {
  __typename?: "CruiseSearchResults";
  /** Sort and filter elements */
  filters: CruiseSearchFilters;
  /** Sailing search result elements */
  sailingSearch: SailingSearchResults;
};

export type CruiseSearchResultsSailingSearchArgs = {
  cruiseContext: CruiseRequestContextInput;
  limit?: InputMaybe<Scalars["Int"]>;
  offset?: InputMaybe<Scalars["Int"]>;
  sailingToken?: InputMaybe<Scalars["String"]>;
};

/** Represents any piece of text with label and message */
export type CruiseSubsection = {
  __typename?: "CruiseSubsection";
  /** Heading label we render out text describing the message */
  headingLabel?: Maybe<Scalars["String"]>;
  /**
   * Label we render out text describing the message
   * @deprecated Use headingLabel instead
   */
  label: Scalars["String"];
  /** Text of this subsection */
  message: Scalars["String"];
  /** Secondary text of this subsection */
  secondaryMessage?: Maybe<Scalars["String"]>;
};

/** Additional information to initialise ship and port typeahead adapter */
export type CruiseTypeaheadAdapterDetails = {
  __typename?: "CruiseTypeaheadAdapterDetails";
  /** Request body for the typeahead search */
  adapterRequest?: Maybe<CruiseTypeaheadAdapterRequest>;
  /** Domain of the information to be requested from the Typeahead API */
  domainId: Scalars["String"];
  /** List of ESS Categories to categorize the typeahead results */
  essCategories?: Maybe<Array<EssCategory>>;
};

/** Specifies request body for cruise typeahead search */
export type CruiseTypeaheadAdapterRequest = {
  __typename?: "CruiseTypeaheadAdapterRequest";
  /** Field for passing filter context to include results based on selected destination or cruise line */
  filters?: Maybe<CruiseTypeaheadFilterContext>;
  /** Specifies which metadata fields to include in the typeahead results */
  includeMetadata?: Maybe<Array<Scalars["String"]>>;
};

/** Cruise typeahead search filter context */
export type CruiseTypeaheadFilterContext = {
  __typename?: "CruiseTypeaheadFilterContext";
  /** Include destination(s) or cruise line as filter context */
  include?: Maybe<Array<FilterItem>>;
};

/** User interest attributes */
export type CruiseUserInterest = {
  __typename?: "CruiseUserInterest";
  /** Text to show when user is interested. */
  text: Scalars["String"];
};

/** Button text of gallery carousel container */
export type CruiseVideoButtonText = {
  __typename?: "CruiseVideoButtonText";
  /** a11y text for pause video button */
  pauseButton: Scalars["String"];
  /** a11y text for play video button */
  playButton: Scalars["String"];
};

/** Information about a specific currency */
export type Currency = {
  __typename?: "Currency";
  /** The ISO 4217 3-letter code for this currency */
  code: Scalars["String"];
  /** The display name of the currency */
  name: Scalars["String"];
  /** The currency symbol, e.g. '$' */
  symbol: Scalars["String"];
};

export type CurrencySelector = LocalePreferenceSelector & {
  __typename?: "CurrencySelector";
  disabled: Scalars["Boolean"];
  heading: Scalars["String"];
  options: Array<CurrencySelectorOption>;
  queryParameterName: Scalars["String"];
  trackingEvent: Scalars["String"];
};

export type CurrencySelectorOption = LocaleSelectorOption & {
  __typename?: "CurrencySelectorOption";
  name: Scalars["String"];
  selected: Scalars["Boolean"];
  value: Scalars["String"];
};

export type CurrentBreadcrumb = BreadcrumbItem & {
  __typename?: "CurrentBreadcrumb";
  text: Scalars["String"];
  uiLinkAction?: Maybe<UiLinkAction>;
};

export type CurrentTripIntent = {
  __typename?: "CurrentTripIntent";
  /** When is the timeframe of the intended trip */
  timeframe?: Maybe<TripIntentWhen>;
  /** Where the customer intends to travel */
  where?: Maybe<TripIntentWhere>;
  /** Who this trip is intended for */
  who?: Maybe<TripIntentWho>;
  /** Why the customer intends to travel */
  why: TripIntentWhy;
};

export type CustomTagRating = {
  __typename?: "CustomTagRating";
  customValue?: Maybe<StringRating>;
  value?: Maybe<RatingValueDetails>;
};

/** A composable element is a markup union type used to mark than a element (text or lists) can be grouped in the same list. */
export type CustomUiComposableElement = UiSimpleText | UiTextList;

export type Customer = {
  __typename?: "Customer";
  /** Retrieve the current trip intent of customer */
  currentTripIntent: CurrentTripIntent;
  /**
   * Find inbox notifications for a specific user
   * @deprecated Please use https://github.expedia.biz/Brand-Expedia/notifications-spinner instead
   */
  findInboxNotificationsByUser: Array<CustomerNotification>;
  /**
   * Find an inline notification by id
   * @deprecated Please use https://github.expedia.biz/Brand-Expedia/notifications-spinner instead
   */
  findInlineNotificationByUser: CustomerNotification;
  /**
   * Find an inbox notification based on id
   * @deprecated Please use https://github.expedia.biz/Brand-Expedia/notifications-spinner instead
   */
  findNotificationById: CustomerNotification;
  /** Retrieve lodging rebound */
  lodgingRebound?: Maybe<LodgingRebound>;
  /** Hide/Unhide the customer's search history. Calling hide twice in a row (with Id of historyTypes) will permanently delete those interaction */
  mutateHistory?: Maybe<HistoryMutationResponse>;
  /**
   * Retrieve the customer's notifications
   * @deprecated Please use https://github.expedia.biz/Brand-Expedia/notifications-spinner instead
   */
  notification: CustomerNotification;
  /** Retrieve the customer's search history */
  searchHistory?: Maybe<Array<History>>;
  /** Retrieve customer search history grouping tiles */
  searchHistoryGroups?: Maybe<Array<HistoryGroup>>;
};

export type CustomerFindInboxNotificationsByUserArgs = {
  expUserId: Scalars["String"];
};

export type CustomerFindInlineNotificationByUserArgs = {
  dismissed: Scalars["Boolean"];
  expUserId: Scalars["Int"];
  read: Scalars["Boolean"];
  seen: Scalars["Boolean"];
};

export type CustomerFindNotificationByIdArgs = {
  notificationId: Scalars["String"];
};

export type CustomerLodgingReboundArgs = {
  regionId?: InputMaybe<Scalars["String"]>;
};

export type CustomerMutateHistoryArgs = {
  hide?: InputMaybe<Scalars["Boolean"]>;
  historyTypes?: InputMaybe<Array<HistoryType>>;
  interactionId?: InputMaybe<Scalars["String"]>;
};

export type CustomerNotificationArgs = {
  funnelLocation: FunnelLocation;
  lineOfBusiness: ExpLineOfBusiness;
  notificationLocation: NotificationLocation;
  optionalContext?: InputMaybe<CustomerNotificationOptionalContextInput>;
};

export type CustomerSearchHistoryArgs = {
  filterCriteria?: InputMaybe<SearchHistoryFilterCriteriaInput>;
  includeBookedSearches?: InputMaybe<Scalars["Boolean"]>;
  numberOfResults?: InputMaybe<Scalars["Int"]>;
  types?: InputMaybe<Array<HistoryType>>;
};

export type CustomerSearchHistoryGroupsArgs = {
  groupingCriteria?: InputMaybe<SearchHistoryGroupingCriteriaInput>;
  includeBookedSearches?: InputMaybe<Scalars["Boolean"]>;
  types?: InputMaybe<Array<HistoryType>>;
};

/** Personal address of the customer */
export type CustomerAddress = {
  __typename?: "CustomerAddress";
  /** City */
  city?: Maybe<Scalars["String"]>;
  /** CountryAlpha3Code */
  countryAlpha3Code?: Maybe<Scalars["String"]>;
  /** address line 1/street 1 */
  firstLine?: Maybe<Scalars["String"]>;
  /** PostalCode */
  postalCode?: Maybe<Scalars["String"]>;
  /** Province */
  province?: Maybe<Scalars["String"]>;
  /** address line 2/street 2 */
  secondLine?: Maybe<Scalars["String"]>;
};

/** Contact details(address, phone numbers and emergency contacts) of the customer */
export type CustomerContactInfo = {
  __typename?: "CustomerContactInfo";
  /** Address of the customer */
  customerAddress?: Maybe<CustomerAddress>;
  /** Emergency contacts of the customer */
  emergencyContacts?: Maybe<CustomerEmergencyContacts>;
  /** PhoneNumbers of the customer */
  phoneNumbers?: Maybe<CustomerPhoneNumbers>;
};

/** Emergency contact of the customer */
export type CustomerEmergencyContact = {
  __typename?: "CustomerEmergencyContact";
  /** Name of the emergency Contact */
  emergencyContactName?: Maybe<CustomerName>;
  /** PhoneNumber(s) of the emergency contact */
  phoneNumber?: Maybe<CustomerPhoneNumber>;
};

/** Emergency contacts of the customer */
export type CustomerEmergencyContacts = {
  __typename?: "CustomerEmergencyContacts";
  /** List of Emergency contacts */
  emergencyContact?: Maybe<Array<CustomerEmergencyContact>>;
};

/** Gender of the customer */
export type CustomerGender = "FEMALE" | "MALE" | "UNKNOWN";

/** Name of the customer */
export type CustomerName = {
  __typename?: "CustomerName";
  /** First name or first given name  */
  first: Scalars["String"];
  /** Last name or family/clan name */
  last: Scalars["String"];
  /** Middle name or second given name */
  middle?: Maybe<Scalars["String"]>;
};

/** Represents best possible notification to show in the client given the context */
export type CustomerNotification = {
  __typename?: "CustomerNotification";
  /** Represents the attributes required for the notification */
  attributes?: Maybe<Array<CustomerNotificationAttribute>>;
  /** The uds token name used for background id color */
  backgroundId?: Maybe<Scalars["String"]>;
  /** Represents the background image to be used in the notification */
  backgroundImage?: Maybe<Image>;
  /** Represents the list of the notification messages to show in the body section of the notification to be displayed on the client */
  body?: Maybe<Array<CustomerNotificationPhrase>>;
  /** Represents a link that should be applied to the container of the notification */
  containerLink?: Maybe<CustomerNotificationContainerLink>;
  /** Represents the dismiss on interaction with the notification */
  dismiss?: Maybe<CustomerNotificationDismiss>;
  /** Represents the end time of the notification */
  displayEndDateTime?: Maybe<DateTime>;
  /** Represents the start time of the notification */
  displayStartDateTime?: Maybe<DateTime>;
  /** Represents the form to be displayed in the notification */
  form?: Maybe<CustomerNotificationForm>;
  /** Represents the icon that will be used in the notification */
  icon?: Maybe<Icon>;
  /** Represents the notification links to be displayed on the client */
  links?: Maybe<Array<CustomerNotificationPhraseLinkNode>>;
  /** Represents a logo image */
  logo?: Maybe<Image>;
  /** Represents the qr code image to be used in the notification */
  qrCode?: Maybe<Image>;
  /** Represents the actions to apply on notification reveal */
  revealActions?: Maybe<Array<CustomerNotificationAction>>;
  /** Represents the time stamp of notification */
  timeStamp?: Maybe<Scalars["String"]>;
  /** Represents heading title of the notification to be displayed on the client */
  title?: Maybe<CustomerNotificationPhrase>;
  /** Represents the type of the notification */
  type: CustomerNotificationType;
};

/** An interface for a11y labels on the fields in notification */
export interface CustomerNotificationAccessibilityField {
  /** Label where a11y behavior is needed. */
  accessibilityLabel?: Maybe<Scalars["String"]>;
}

/** Represents an action to be done after user interaction */
export type CustomerNotificationAction =
  | CustomerNotificationAnalytics
  | CustomerNotificationCookie
  | CustomerNotificationMarketing
  | CustomerNotificationModifiableAttributes
  | CustomerNotificationSpecifications;

/** Represents the analytics to track on interaction with the notification */
export type CustomerNotificationAnalytics = {
  __typename?: "CustomerNotificationAnalytics";
  /** Represents a short friendly name to clarify the meaning of the client side tracked event */
  description?: Maybe<Scalars["String"]>;
  /** Represents a value for the client side action taken */
  referrerId: Scalars["String"];
};

/** Represents an attribute for a notification */
export type CustomerNotificationAttribute = {
  __typename?: "CustomerNotificationAttribute";
  /** Name of the attribute */
  name?: Maybe<Scalars["String"]>;
  /** Value of the attribute */
  value?: Maybe<Scalars["String"]>;
};

/** Represents the hyperlink data when notification container is a link */
export type CustomerNotificationContainerLink = CustomerNotificationLink & {
  __typename?: "CustomerNotificationContainerLink";
  /** Represents the actions to apply on interaction with the link */
  actions?: Maybe<Array<CustomerNotificationAction>>;
  /** Logical identifier associated with the link */
  id?: Maybe<Scalars["String"]>;
  /** Represents the target of the link */
  target?: Maybe<CustomerNotificationLinkTarget>;
  /** The underlying hyperlink url */
  url?: Maybe<Scalars["URL"]>;
};

/** Represents the cookie that needs to be set after an interaction */
export type CustomerNotificationCookie = {
  __typename?: "CustomerNotificationCookie";
  /** The cookie expires in RFC 1123 format e.g. 'Sat, 9 Nov 2019 18:49:17 GMT' */
  expires: Scalars["String"];
  /** The cookie name */
  name: Scalars["String"];
  /** The cookie value */
  value: Scalars["String"];
};

/** Type encapsulating the dismiss data of a notification */
export type CustomerNotificationDismiss = {
  __typename?: "CustomerNotificationDismiss";
  /** Represents the actions to be applied on interaction with dismiss */
  actions?: Maybe<Array<CustomerNotificationAction>>;
  /** Represents the 'X' icon displayed which dismisses the notification on client */
  icon: Icon;
};

/** Represents a form that should be displayed in the notification */
export type CustomerNotificationForm = {
  __typename?: "CustomerNotificationForm";
  /** The list of feedback messages for the form interaction, it could be warning, error, success messages */
  feedbackMessages?: Maybe<Array<CustomerNotificationMessage>>;
  /** The list of form sections items */
  sections: Array<CustomerNotificationFormSection>;
  /** The localized title text of the form */
  title?: Maybe<Scalars["String"]>;
};

/** The button type of the Customer notification submit button */
export type CustomerNotificationFormButtonType =
  /** Type of floating action button */
  | "FLOATING_ACTION_BUTTON"
  /** Type of primary button */
  | "PRIMARY_BUTTON"
  /** Type of secondary button */
  | "SECONDARY_BUTTON"
  /** Type of tertiary button */
  | "TERTIARY_BUTTON";

/** Represents the form field in the form, eg: any input elements or button */
export interface CustomerNotificationFormField {
  /** The localized label of the form field */
  label: Scalars["String"];
}

/** Represents a form group that should be displayed in the notification UI */
export type CustomerNotificationFormSection = {
  __typename?: "CustomerNotificationFormSection";
  /** The list of form fields in the form section */
  fields: Array<CustomerNotificationFormField>;
  /** The title text of form section */
  title?: Maybe<Scalars["String"]>;
};

/** Represents a link that should be displayed in a notification */
export interface CustomerNotificationLink {
  /** Represents the list of actions that should be applied when user interacts with the link */
  actions?: Maybe<Array<CustomerNotificationAction>>;
  /** Logical identifier associated with the link */
  id?: Maybe<Scalars["String"]>;
  /** Represents the target of the link */
  target?: Maybe<CustomerNotificationLinkTarget>;
  /** Represents the url of the link */
  url?: Maybe<Scalars["URL"]>;
}

/** Represents the target of the link */
export type CustomerNotificationLinkTarget = "NEW_TAB" | "SAME_TAB";

/** Represents the link type */
export type CustomerNotificationLinkType =
  | "ANCHOR"
  | "APP_DOWNLOAD_LINK"
  | "BUTTON"
  | "FLOATING_ACTION_BUTTON"
  | "PRIMARY_BUTTON"
  | "SECONDARY_BUTTON"
  | "TERTIARY_BUTTON";

/** Represents the marketing analytics to track on interaction with the notification */
export type CustomerNotificationMarketing = {
  __typename?: "CustomerNotificationMarketing";
  /** Represents a value used for marketing analytics */
  marketingCode: Scalars["String"];
  /** Represents a detailed value used for marketing analytics */
  marketingCodeDetail: Scalars["String"];
};

/** Represents a message that should be displayed in the notification during form interaction */
export type CustomerNotificationMessage = {
  __typename?: "CustomerNotificationMessage";
  /** The display type of feedback message */
  displayType: CustomerNotificationMessageDisplayType;
  /** The level of feedback message */
  level: CustomerNotificationMessageLevel;
  /** The name of feedback message */
  name: Scalars["String"];
  /** The localized feedback message */
  text: Scalars["String"];
  /** The title text of feedback message */
  title: Scalars["String"];
};

/** The display type of the Customer notification message */
export type CustomerNotificationMessageDisplayType =
  /** Display the message for the form */
  | "FORM"
  /** Dislay message on the page level, eg: fly-in message on the page */
  | "PAGE";

/** The level type of the Customer notification message */
export type CustomerNotificationMessageLevel =
  /** Type of error for the message */
  | "ERROR"
  /** Type of success for the message */
  | "SUCCESS"
  /** Type of warning for the message */
  | "WARNING";

export type CustomerNotificationMessageType =
  /** INVALID_INPUT message */
  | "INVALID_INPUT"
  /** SERVICE_ERROR message */
  | "SERVICE_ERROR"
  /** SUCCESS message */
  | "SUCCESS";

/** Represents the attributes on a notification that could be changed after an interaction */
export type CustomerNotificationModifiableAttributes = {
  __typename?: "CustomerNotificationModifiableAttributes";
  /** Set to true when notification is dismissed */
  dismiss?: Maybe<Scalars["Boolean"]>;
  /** Notification id */
  id?: Maybe<Scalars["String"]>;
  /** Set to true when notification is read */
  read?: Maybe<Scalars["Boolean"]>;
  /** Set to true when notification is seen */
  seen?: Maybe<Scalars["Boolean"]>;
  /**
   * Set to true when notification is starred
   * @deprecated This field is now deprecated.
   */
  star?: Maybe<Scalars["Boolean"]>;
};

/** Represents the attributes on a notification that could be changed after an interaction */
export interface CustomerNotificationModifiableAttributesInput {
  /** Set to true when notification is dismissed */
  dismiss?: InputMaybe<Scalars["Boolean"]>;
  /** Notification id */
  id?: InputMaybe<Scalars["String"]>;
  /** Set to true when notification is read */
  read?: InputMaybe<Scalars["Boolean"]>;
  /** Set to true when notification is seen */
  seen?: InputMaybe<Scalars["Boolean"]>;
  /** Set to true when notification is starred */
  star?: InputMaybe<Scalars["Boolean"]>;
}

/** Optional information to get a better contextual customer notification */
export interface CustomerNotificationOptionalContextInput {
  /** itinerary number */
  itineraryNumber?: InputMaybe<Scalars["String"]>;
  /** list of journey criteria items */
  journeyCriterias?: InputMaybe<Array<CustomerNotificationOptionalContextJourneyCriteriaInput>>;
  /** the optional URL input field to retrieve extra url information, such as deep linking url for the mobile app download notification */
  referer?: InputMaybe<Scalars["URL"]>;
  /** regionId number */
  regionId?: InputMaybe<Scalars["String"]>;
  /** list of GAIA regionIds */
  regionIds?: InputMaybe<Array<Scalars["String"]>>;
  /** trip folder id */
  tripFolderId?: InputMaybe<Scalars["String"]>;
}

/** Journey criteria such as location gaia id and travel date ranges */
export interface CustomerNotificationOptionalContextJourneyCriteriaInput {
  /** start date and end date of the trip */
  dateRange?: InputMaybe<DateRangeInput>;
  /** destination information */
  destination?: InputMaybe<CustomerNotificationOptionalContextJourneyCriteriaLocationInput>;
  /** origin information */
  origin?: InputMaybe<CustomerNotificationOptionalContextJourneyCriteriaLocationInput>;
}

/** Journey criteria such as location gaia id and travel date ranges */
export interface CustomerNotificationOptionalContextJourneyCriteriaLocationInput {
  /** airport code */
  airportTLA?: InputMaybe<Scalars["String"]>;
  /** property id */
  propertyId?: InputMaybe<Scalars["String"]>;
  /** regionId number */
  regionId?: InputMaybe<Scalars["String"]>;
}

/** Represents a sentence consisting of words with various text formatting styles */
export type CustomerNotificationPhrase = CustomerNotificationAccessibilityField & {
  __typename?: "CustomerNotificationPhrase";
  /** Label where a11y behavior is needed on the text phrase */
  accessibilityLabel?: Maybe<Scalars["String"]>;
  /** Plain text representation of the sentence as an un-attributed string */
  completeText: Scalars["String"];
  /** Ordered list of words with their corresponding text styles */
  items: Array<CustomerNotificationPhrasePart>;
};

/** A link with formatted display text */
export type CustomerNotificationPhraseLinkNode = CustomerNotificationLink &
  CustomerNotificationPhrasePart & {
    __typename?: "CustomerNotificationPhraseLinkNode";
    /** Represents the actions to be applied on interaction with the link */
    actions?: Maybe<Array<CustomerNotificationAction>>;
    /** Represents the icon of the link */
    icon?: Maybe<Icon>;
    /** Logical identifier associated with the link */
    id?: Maybe<Scalars["String"]>;
    /** Represents the style of the link */
    linkStyle?: Maybe<CustomerNotificationPhraseLinkStyle>;
    /** The style to apply to the text */
    styles: Array<CustomerNotificationPhrasePartStyle>;
    /** Represents the target of the link */
    target?: Maybe<CustomerNotificationLinkTarget>;
    /** The display text for the link */
    text: Scalars["String"];
    /** Represents the link type */
    type: CustomerNotificationLinkType;
    /** The underlying hyperlink url */
    url?: Maybe<Scalars["URL"]>;
  };

/** The style to apply to phrase links */
export type CustomerNotificationPhraseLinkStyle =
  | "FLOATING_ACTION_BUTTON"
  | "PRIMARY_BUTTON"
  | "SECONDARY_BUTTON"
  | "TERTIARY_BUTTON";

/** Type encapsulating a string and the style to apply to it */
export interface CustomerNotificationPhrasePart {
  /** The styles to be applied */
  styles: Array<CustomerNotificationPhrasePartStyle>;
  /** String to be stylized */
  text: Scalars["String"];
}

/** The text style to apply to strings */
export type CustomerNotificationPhrasePartStyle =
  /** Italic styling */
  | "EMPHASIS"
  /** Bold styling */
  | "IMPORTANT"
  /** Represents no style or regular text */
  | "STANDARD";

/** Type to encapsulate attributed/styled Text */
export type CustomerNotificationPhraseTextNode = CustomerNotificationPhrasePart & {
  __typename?: "CustomerNotificationPhraseTextNode";
  /** The style(s) to apply */
  styles: Array<CustomerNotificationPhrasePartStyle>;
  /** The text string to style */
  text: Scalars["String"];
};

/** Represents a selection field that should be displayed in the notification UI */
export type CustomerNotificationSelectionField = CustomerNotificationFormField & {
  __typename?: "CustomerNotificationSelectionField";
  /** The id of the selection field */
  id: Scalars["String"];
  /** The localized label of the selection field */
  label: Scalars["String"];
  /** The list options of the selection field */
  options?: Maybe<Array<CustomerNotificationSelectionOption>>;
};

/** Represents a selection option field that should be displayed in the notification UI */
export type CustomerNotificationSelectionOption = {
  __typename?: "CustomerNotificationSelectionOption";
  /** The icon of the selection option */
  icon?: Maybe<Icon>;
  /** The unique id of the selection option */
  id: Scalars["String"];
  /** identifier for default selected option */
  selected: Scalars["Boolean"];
  /** The short label of the selection option */
  shortLabel?: Maybe<Scalars["String"]>;
  /** The text of the selection option */
  text: Scalars["String"];
  /** The value of the selection option */
  value: Scalars["String"];
};

/** Represents id of a notification and the attributes that could be changed after an interaction */
export type CustomerNotificationSpecifications = {
  __typename?: "CustomerNotificationSpecifications";
  /** Set to true when notification is dismissed */
  dismiss?: Maybe<Scalars["Boolean"]>;
  /** Notification id */
  id?: Maybe<Scalars["String"]>;
  /** Set to true when notification is read */
  read?: Maybe<Scalars["Boolean"]>;
  /** Set to true when notification is seen */
  seen?: Maybe<Scalars["Boolean"]>;
};

/** Represents a selection field that should be displayed in the notification UI */
export type CustomerNotificationSubmitButton = CustomerNotificationFormField & {
  __typename?: "CustomerNotificationSubmitButton";
  /** Represents the actions to be applied on interaction with the link */
  actions?: Maybe<Array<CustomerNotificationAction>>;
  /** The UI button type of submit button */
  buttonType?: Maybe<CustomerNotificationFormButtonType>;
  /** The icon of the submit button */
  icon?: Maybe<Icon>;
  /** The id of the submit button */
  id: Scalars["String"];
  /** The localized label of the submit button */
  label: Scalars["String"];
};

/** Represents a text input field that should be displayed in the notification UI */
export type CustomerNotificationTextInputField = CustomerNotificationFormField & {
  __typename?: "CustomerNotificationTextInputField";
  /** The icon of the form field */
  icon?: Maybe<Icon>;
  /** The id of the text input field */
  id: Scalars["String"];
  /** The localized label of the text input field */
  label: Scalars["String"];
  /** The placeholder text of the text input field */
  placeholder: Scalars["String"];
};

export type CustomerNotificationTextToDownloadAppResponse = {
  __typename?: "CustomerNotificationTextToDownloadAppResponse";
  /** Represents a list of ids for the invalid input fields to be highlighted on the client */
  invalidFields?: Maybe<Array<Scalars["String"]>>;
  /** Represents the message body to be displayed on the client */
  messageBody?: Maybe<Scalars["String"]>;
  /** Represents the type of message of the response */
  messageType: CustomerNotificationMessageType;
};

export type CustomerNotificationType =
  | "APP_DOWNLOAD"
  | "APP_HERO"
  | "CITI_COBRAND"
  | "CITI_COBRAND_VERTICAL"
  | "CLEANLINESS"
  | "GDPR"
  | "GENERIC"
  | "HEADER"
  | "INBOX"
  | "MAD_MARQUEE"
  | "NONE"
  | "OSANO"
  | "TAKEOVER"
  | "TRAVEL_ADVISORY";

/** Represents the the user input for customer notification mutation */
export interface CustomerNotificationUserInput {
  /** Represents list of customer notification user input */
  inputs: Array<CustomerNotificationUserInputElementInput>;
}

/** Represents customer notification user input */
export interface CustomerNotificationUserInputElementInput {
  /** Represents the type of customer notification user input */
  type: Scalars["String"];
  /** Represents the value of customer notification user input */
  value: Scalars["String"];
}

/** Personal information of the customer */
export type CustomerPersonalInfo = {
  __typename?: "CustomerPersonalInfo";
  /** Date Of Birth of the customer */
  dateOfBirth?: Maybe<Date>;
  /** Gender of the customer */
  gender?: Maybe<CustomerGender>;
  /** name of the customer */
  name?: Maybe<CustomerName>;
};

/** Phone number of the customer */
export type CustomerPhoneNumber = {
  __typename?: "CustomerPhoneNumber";
  /** Country code of the phone number */
  countryCode?: Maybe<Scalars["String"]>;
  /** Phone number */
  phoneNumber?: Maybe<Scalars["String"]>;
};

/** Primary and alternate phone number(s) of the customer */
export type CustomerPhoneNumbers = {
  __typename?: "CustomerPhoneNumbers";
  /** Alternate phone number(s) */
  alternates?: Maybe<Array<CustomerPhoneNumber>>;
  /** Primary phone number */
  primary?: Maybe<CustomerPhoneNumber>;
};

/** Detailed Profile Information of the customer */
export type CustomerProfile = {
  __typename?: "CustomerProfile";
  /** Contact Information of the customer */
  contactInfo?: Maybe<CustomerContactInfo>;
  /** Personal Information of the customer */
  personalInfo?: Maybe<CustomerPersonalInfo>;
};

export type DamageLiability = "COF" | "RDD";

export type DashboardType = "DEFERRED_PAYMENT" | "PERFORMANCE";

/**
 * Used to identify the downstream data source.
 * ENTITY: A stateful data service driven by the owning domain
 * CART: Cart Service
 * OFFER: Offer Service
 * ORDER: Ordering Service
 */
export type DataSourceType = "CART" | "ENTITY" | "OFFER" | "ORDER";

/** A common date object */
export type Date = {
  __typename?: "Date";
  /** The day of the month, e.g. `1` for the 1st */
  day: Scalars["Int"];
  /**
   * Format with a pattern. 'd MMM uuuu' will format 2011-12-03 as '3 Dec 2011'
   * @deprecated Migrate to using platform formatters and return a localized string
   */
  formatted: Scalars["String"];
  /**
   * Get a localized full date string i.e. en='Tue, Oct 13' de='Di. 13 Oct
   * @deprecated Migrate to using platform formatters and return a localized string
   */
  fullDateFormat?: Maybe<Scalars["String"]>;
  /**
   * Get a simple string in ISO local date format '2011-12-03'
   * @deprecated Migrate to using platform formatters and return a localized string
   */
  isoFormat: Scalars["String"];
  /**
   * Get a localized long date string i.e. en='Feb 26, 2020' de='26. Feb. 2020
   * @deprecated Migrate to using platform formatters and return a localized string
   */
  longDateFormat?: Maybe<Scalars["String"]>;
  /**
   * Get a localized medium date string i.e. en='Feb 26' de='26. Feb.
   * @deprecated Migrate to using platform formatters and return a localized string
   */
  mediumDateFormat?: Maybe<Scalars["String"]>;
  /** The numeric month, e.g. `1` for January */
  month: Scalars["Int"];
  /**
   * Get a localized short date string i.e. en='2/26/2020' de='26.02.2020
   * @deprecated Migrate to using platform formatters and return a localized string
   */
  shortDateFormat?: Maybe<Scalars["String"]>;
  /** The four-digit year e.g. `1999` */
  year: Scalars["Int"];
};

/** A common date object */
export type DateFormattedArgs = {
  format: Scalars["String"];
};

/** A common date object */
export interface DateInput {
  /** The day of the month, e.g. `1` for the 1st */
  day: Scalars["Int"];
  /** The numeric month, e.g. `1` for January */
  month: Scalars["Int"];
  /** The four-digit year e.g. `1999` */
  year: Scalars["Int"];
}

/** Represents alternate date trip option */
export type DateOption = {
  __typename?: "DateOption";
  /** Accessibility Heading for specific alternate date option */
  accessibilityHeading: Scalars["String"];
  /** Accessibility Message for specific alternate date option */
  accessibilityMessage: Scalars["String"];
  /** Label for change in days e.g. '02 days later' */
  numDaysDifference: Scalars["String"];
  /** Used for conducting alternate trip search */
  selectAction: FlightsAction;
  /** Label for trip dates e.g. 'Thu,May 13-Fri,May 14' */
  tripDates: Scalars["String"];
  /** Label for airports e.g. 'ORD-SFO' */
  tripOD: Scalars["String"];
};

/** A range of dates, from a starting date to an ending date */
export type DateRange = {
  __typename?: "DateRange";
  /**
   * The duration between the start and end date (assuming start of day) in a specific unit with any remainder discarded. e.g. The difference between 2019-01-01 and 2019-01-04 is 0 weeks, 3 days or 72 hours.'
   * @deprecated Use platform formatters and return localized strings, or use java time class for internal logic
   */
  duration: Duration;
  /** The terminal date in this range */
  end: Date;
  /** The starting date in this range */
  start: Date;
};

/** A range of dates, from a starting date to an ending date */
export type DateRangeDurationArgs = {
  chronoUnit: ChronoUnit;
};

/** A range of dates, from a starting date to an ending date */
export interface DateRangeInput {
  /** The terminal date in this range */
  end: DateInput;
  /** The starting date in this range */
  start: DateInput;
}

/** A common date time, if you need to include timezone information, please use ZonedDateTime */
export type DateTime = {
  __typename?: "DateTime";
  /** The day of the month of the date */
  day: Scalars["Int"];
  /**
   * Converts this date-time to the number of seconds from the epoch of 1970-01-01T00:00:00Z
   * @deprecated Use platform formatters and return localized strings instead
   */
  epochSeconds: Scalars["String"];
  /**
   * Format a with a pattern. 'd MMM uuuu' will format 2011-12-03 as '3 Dec 2011'
   * @deprecated Use platform formatters and return localized strings instead
   */
  formatted: Scalars["String"];
  /**
   * Localized full date string e.g. en='Wed, Feb 26' de='Mi., 26. Feb.'
   * @deprecated Use platform formatters and return localized strings instead
   */
  fullDateFormat?: Maybe<Scalars["String"]>;
  /** The hour of the datetime */
  hour: Scalars["Int"];
  /**
   * Localized long date string e.g. en='Feb 26, 2020' de='26. Feb. 2020'
   * @deprecated Use platform formatters and return localized strings instead
   */
  longDateFormat?: Maybe<Scalars["String"]>;
  /**
   * Localized medium date string e.g. en='Feb 26' de='26. Feb.'
   * @deprecated Use platform formatters and return localized strings instead
   */
  mediumDateFormat?: Maybe<Scalars["String"]>;
  /**
   * Localized medium time string e.g. en='11:06:15AM' de='11:06:20 Uhr'
   * @deprecated Use platform formatters and return localized strings instead
   */
  mediumTimeFormat?: Maybe<Scalars["String"]>;
  /** The minute of the hour */
  minute: Scalars["Int"];
  /** The numeric month of the date */
  month: Scalars["Int"];
  /**
   * Returns the posix format
   * @deprecated Use platform formatters and return localized strings instead
   */
  raw: Scalars["String"];
  /** The second of the minute */
  second: Scalars["Int"];
  /**
   * Localized short date string e.g. en='2/26/2020' de='26.02.2020'
   * @deprecated Use platform formatters and return localized strings instead
   */
  shortDateFormat?: Maybe<Scalars["String"]>;
  /**
   * Localized short time string e.g. en='11:06am' de='11:06 Uhr'
   * @deprecated Use platform formatters and return localized strings instead
   */
  shortTimeFormat?: Maybe<Scalars["String"]>;
  /** @deprecated Use ZonedDateTime if you want time zone information, replace with ZonedDateTime */
  timeZoneOffsetSeconds: Scalars["Int"];
  /** The four-digit year of the date */
  year: Scalars["Int"];
};

/** A common date time, if you need to include timezone information, please use ZonedDateTime */
export type DateTimeFormattedArgs = {
  format: Scalars["String"];
};

/** A common date time, if you need to include timezone information, please use ZonedDateTime */
export interface DateTimeInput {
  /** The day of the month of the date */
  day: Scalars["Int"];
  /** The hour of the datetime */
  hour: Scalars["Int"];
  /** The minute of the hour */
  minute: Scalars["Int"];
  /** The numeric month of the date */
  month: Scalars["Int"];
  /** The second of the minute */
  second: Scalars["Int"];
  /** The four-digit year of the date */
  year: Scalars["Int"];
}

export type DateTimeRecommendationCard = CarRecommendationCard & {
  __typename?: "DateTimeRecommendationCard";
  action?: Maybe<CarAction>;
  icon?: Maybe<Icon>;
  subText?: Maybe<CarPhraseText>;
  text?: Maybe<CarsRichText>;
};

export type DateValidationResult = {
  __typename?: "DateValidationResult";
  /** Search date are adjusted when any of search dates (start or end date) is invalid or unavailable or date range exceeds 14 days window */
  dateAdjusted?: Maybe<Scalars["Boolean"]>;
  /** Localized short end date string e.g. en='2/26/2020' de='26.02.2020' */
  formattedEndDate?: Maybe<Scalars["String"]>;
  /** Localized short start date string e.g. en='2/26/2020' de='26.02.2020' */
  formattedStartDate?: Maybe<Scalars["String"]>;
  /**
   * End date for search results, may be different from end date in query if adjusted due to validation failure
   * @deprecated Use formattedEndDate instead
   */
  searchedEndDate?: Maybe<DateTime>;
  /**
   * Start date for search results, may be different from start date in query if adjusted due to validation failure
   * @deprecated Use formattedStartDate instead
   */
  searchedStartDate?: Maybe<DateTime>;
};

/** Type used during a product search to specify a given date. Usually this date would not be a core search criteria like a departure day for a flight. */
export type DateValue = {
  __typename?: "DateValue";
  id: Scalars["String"];
  value: Date;
};

/** Type used during a product search to specify a given date. Usually this date would not be a core search criteria like a departure day for a flight. */
export interface DateValueInput {
  id: Scalars["String"];
  value: DateInput;
}

export type DealType = "AARP" | "POINTS_PROMOTION";

/** Context used for debugging purposes, such as overriding Abacus experiments */
export type DebugContext = {
  __typename?: "DebugContext";
  /** Abacus exposure overrides to be applied */
  abacusOverrides: Array<Exposure>;
  /** ALTER mode */
  alterMode?: Maybe<AlterMode>;
};

/** Context used for debugging purposes, such as overriding Abacus experiments */
export interface DebugContextInput {
  /** Abacus exposure overrides to be applied */
  abacusOverrides: Array<ExposureInput>;
  /** ALTER mode */
  alterMode?: InputMaybe<AlterMode>;
}

export type DeeplinkType = "HSR" | "PDP";

export type DeferredPaymentReport = {
  __typename?: "DeferredPaymentReport";
  /** A URL from where the report can be retrieved */
  uri?: Maybe<HttpUri>;
};

export type DependentQuestion = {
  __typename?: "DependentQuestion";
  answers?: Maybe<Array<Scalars["String"]>>;
  questionUrn?: Maybe<Scalars["String"]>;
};

/** A wrapper around the Context object from the SDK to add the federation information too */
export type DeprecatedCustomerContext = {
  __typename?: "DeprecatedCustomerContext";
  device: DeprecatedCustomerContextDevice;
  identity: DeprecatedCustomerContextIdentity;
  locale: Scalars["Locale"];
  siteId: Scalars["Int"];
};

export type DeprecatedCustomerContextDevice = {
  __typename?: "DeprecatedCustomerContextDevice";
  type: DeviceType;
};

export type DeprecatedCustomerContextIdentity = {
  __typename?: "DeprecatedCustomerContextIdentity";
  duaid: Scalars["UUID"];
};

/** A wrapper around the Context object from the SDK to add the federation information too */
export type DeprecatedMultiItemContext = {
  __typename?: "DeprecatedMultiItemContext";
  device: DeprecatedMultiItemContextDevice;
  identity: DeprecatedMultiItemContextIdentity;
  locale: Scalars["Locale"];
  siteId: Scalars["Int"];
};

export type DeprecatedMultiItemContextDevice = {
  __typename?: "DeprecatedMultiItemContextDevice";
  type: DeviceType;
};

export type DeprecatedMultiItemContextIdentity = {
  __typename?: "DeprecatedMultiItemContextIdentity";
  duaid: Scalars["UUID"];
};

export type DeprecatedPropertyContext = {
  __typename?: "DeprecatedPropertyContext";
  currency?: Maybe<Scalars["String"]>;
  debugContext?: Maybe<DeprecatedPropertyDebugContext>;
  device: DeprecatedPropertyMultiItemContextDevice;
  eapid?: Maybe<Scalars["Int"]>;
  identity: DeprecatedPropertyMultiItemContextIdentity;
  locale: Scalars["Locale"];
  siteId: Scalars["Int"];
  tpid?: Maybe<Scalars["Int"]>;
};

export type DeprecatedPropertyDebugContext = {
  __typename?: "DeprecatedPropertyDebugContext";
  abacusOverrides: Array<DeprecatedPropertyExposure>;
  alterMode?: Maybe<AlterMode>;
};

export type DeprecatedPropertyExposure = {
  __typename?: "DeprecatedPropertyExposure";
  bucket: Scalars["Int"];
  id: Scalars["String"];
};

export type DeprecatedPropertyMultiItemContext = {
  __typename?: "DeprecatedPropertyMultiItemContext";
  id: Scalars["String"];
  packageType: PackageType;
};

export type DeprecatedPropertyMultiItemContextDevice = {
  __typename?: "DeprecatedPropertyMultiItemContextDevice";
  type: DeviceType;
};

export type DeprecatedPropertyMultiItemContextIdentity = {
  __typename?: "DeprecatedPropertyMultiItemContextIdentity";
  duaid: Scalars["UUID"];
};

export type DeprecatedShoppingContext = {
  __typename?: "DeprecatedShoppingContext";
  multiItem: DeprecatedPropertyMultiItemContext;
};

/** Contains detailed geographic information like the Gaia region id as well as the property ids in the region for the property destination */
export type Destination = {
  __typename?: "Destination";
  /** The Geo location of the region to search */
  coordinates?: Maybe<Coordinates>;
  /** List of coordinates of the map's bounding box. */
  mapBounds?: Maybe<Array<Coordinates>>;
  /** The property ID to use for region resolution (pinned search). */
  pinnedPropertyId?: Maybe<Scalars["String"]>;
  /** List of property IDs to return search information for. */
  propertyIds?: Maybe<Array<Scalars["String"]>>;
  /** The Gaia region ID of the search */
  regionId?: Maybe<Scalars["String"]>;
  /** The name of the region ID, used for fuzzy resolution */
  regionName?: Maybe<Scalars["String"]>;
};

export type DestinationAirport = LocAirport & {
  __typename?: "DestinationAirport";
  /** destination airport Code */
  airportCode: Scalars["String"];
  /** destination airport Name */
  airportName?: Maybe<Scalars["String"]>;
};

export type DestinationCountry = {
  __typename?: "DestinationCountry";
  /** destination country Name */
  countryName?: Maybe<Scalars["String"]>;
  /** list of available destination airports */
  destinations: Array<DestinationAirport>;
};

export type DestinationExpertTips = {
  __typename?: "DestinationExpertTips";
  tips: Array<DestinationTips>;
  title: Scalars["String"];
};

export type DestinationGallery = {
  __typename?: "DestinationGallery";
  carousel: EgdsCarousel;
  items: Array<DestinationGalleryItem>;
};

export type DestinationGalleryItem = DestinationImageGalleryItem;

export type DestinationHeading = {
  __typename?: "DestinationHeading";
  /** Short description. */
  description?: Maybe<Scalars["String"]>;
  /** Read More/Read Less. */
  expando?: Maybe<EgdsExpandoLink>;
  /** Gallery containing the list of images related to the given destination. */
  gallery: DestinationGallery;
  /** Short description of the destination. */
  subtitle?: Maybe<Scalars["String"]>;
  /** Title of the module. */
  title: Scalars["String"];
};

export interface DestinationHeadingCriteriaInput {
  /** Max number of images for the given destination. */
  imageLimit: Scalars["Int"];
  /** Id of the destination. */
  placeId: Scalars["String"];
}

export interface DestinationImageDimensionsInput {
  height: Scalars["Int"];
  width: Scalars["Int"];
}

export type DestinationImageGalleryItem = {
  __typename?: "DestinationImageGalleryItem";
  attribution?: Maybe<EgdsSpannableText>;
  image: Image;
  impression: ClientSideAnalytics;
};

/** Contains detailed geographic information like the Gaia region id as well as the property ids in the region for the property destination */
export interface DestinationInput {
  /** The Geo location of the region to search */
  coordinates?: InputMaybe<CoordinatesInput>;
  /** List of coordinates of the map's bounding box. */
  mapBounds?: InputMaybe<Array<CoordinatesInput>>;
  /** The property ID to use for region resolution (pinned search). */
  pinnedPropertyId?: InputMaybe<Scalars["String"]>;
  /** List of property IDs to return search information for. */
  propertyIds?: InputMaybe<Array<Scalars["String"]>>;
  /** The Gaia region ID of the search */
  regionId?: InputMaybe<Scalars["String"]>;
  /** The name of the region ID, used for fuzzy resolution */
  regionName?: InputMaybe<Scalars["String"]>;
}

export type DestinationInsights = {
  __typename?: "DestinationInsights";
  /** Get top local getaways from an origin (airport code) optionally by month */
  localGetaways: Array<InsightsDestination>;
  /** Get cost percentiles to stay at a destination, optionally filtered by travel month, starRating, and/or lengthOfStay. All cost percentiles are aggregated over a historical sample of lodging bookings. */
  lodgingCost: Array<CostPercentilesByMonth>;
  /** Get a list of months sorted by the popularity of traveling to the given destination */
  popularMonthsToVisit: Array<Month>;
  /** Get destination travel guide info including the url from Blacksmith */
  travelGuide?: Maybe<TravelGuide>;
};

export type DestinationInsightsLocalGetawaysArgs = {
  maxResults?: InputMaybe<Scalars["Int"]>;
  month?: InputMaybe<MonthId>;
};

export type DestinationInsightsLodgingCostArgs = {
  lengthOfStay?: InputMaybe<Scalars["Int"]>;
  month?: InputMaybe<MonthId>;
  starRating?: InputMaybe<Scalars["Int"]>;
};

export type DestinationMonthlyHistoricalForecast = {
  __typename?: "DestinationMonthlyHistoricalForecast";
  actions: Array<EgdsStandardMessagingCard>;
  description: Scalars["String"];
  monthsForecast: MonthsForecastsTabs;
};

export type DestinationOfferItem = OfferItem & {
  __typename?: "DestinationOfferItem";
  /** Affinites for the destination */
  affinities?: Maybe<Array<Scalars["String"]>>;
  /** Badge to be displayed for the offer */
  badge?: Maybe<CampaignOfferBadge>;
  /** Range of dates the offer is applicable */
  dates?: Maybe<Scalars["String"]>;
  /** Description of the destination offer */
  description?: Maybe<Scalars["String"]>;
  /** Flight offer price and link */
  flightOffer?: Maybe<OfferData>;
  /** Image to be displayed for the destination offer */
  image: Image;
  /** Lodging offer price and link */
  lodgingOffer?: Maybe<OfferData>;
  /** Name of the destination where the offer is applicable */
  name: Scalars["String"];
  /** Package offer price and link */
  packageOffer?: Maybe<OfferData>;
  /** Property type count */
  propertyCount?: Maybe<Scalars["String"]>;
  /** Secondary content related to the destination offer */
  secondaryContent?: Maybe<Scalars["String"]>;
};

export type DestinationRecommendationCard = {
  __typename?: "DestinationRecommendationCard";
  action: UiLinkAction;
  analytics: ClientSideAnalytics;
  /** Details of the DestinationCard */
  details: Array<DestinationRecommendationCardContent>;
  heading?: Maybe<DestinationRecommendationHeading>;
  media: DestinationRecommendationCardMedia;
};

export type DestinationRecommendationCardContent = {
  __typename?: "DestinationRecommendationCardContent";
  content?: Maybe<DestinationRecommendationDetailContent>;
  heading?: Maybe<DestinationRecommendationHeading>;
};

/** Image element of the DestinationCard */
export type DestinationRecommendationCardImage = {
  __typename?: "DestinationRecommendationCardImage";
  attribution?: Maybe<EgdsSpannableText>;
  image?: Maybe<Image>;
};

/** Image elements of the DestinationCard */
export type DestinationRecommendationCardImages = {
  __typename?: "DestinationRecommendationCardImages";
  images: Array<DestinationRecommendationCardImage>;
};

export type DestinationRecommendationCardMedia =
  | DestinationRecommendationCardImage
  | DestinationRecommendationCardImages;

/** Inputs for the destinationGroup query */
export interface DestinationRecommendationCriteriaInput {
  /** Max amount of cards to show */
  maxCards?: InputMaybe<Scalars["Int"]>;
  /** Min amount of cards to show */
  minCards?: InputMaybe<Scalars["Int"]>;
  /** Id of the origin destination */
  referencePlaceId: Scalars["String"];
  /** Strategy for place relationship */
  strategy: DestinationRecommendationStrategy;
  /** Type of destinations in the output */
  type: DestinationRecommendationPlaceType;
}

/** Destination recommendation content details */
export type DestinationRecommendationDetailContent = EgdsParagraph;

export type DestinationRecommendationGroup = {
  __typename?: "DestinationRecommendationGroup";
  cards: Array<DestinationRecommendationCard>;
  carousel: EgdsCarousel;
  heading: DestinationRecommendationHeading;
};

export type DestinationRecommendationGroups = {
  __typename?: "DestinationRecommendationGroups";
  groups: Array<DestinationRecommendationGroup>;
  heading?: Maybe<DestinationRecommendationHeading>;
};

export type DestinationRecommendationHeading = {
  __typename?: "DestinationRecommendationHeading";
  subTitle?: Maybe<Scalars["String"]>;
  title: Scalars["String"];
};

export type DestinationRecommendationPlaceType = "CITY" | "NEIGHBORHOOD" | "POI";

/** Strategy to select the relationship of the output destinations and the origin */
export type DestinationRecommendationStrategy = "NEARBY" | "SIMILAR" | "TOP";

export type DestinationTemperature = {
  __typename?: "DestinationTemperature";
  max: Scalars["Int"];
  min: Scalars["Int"];
  weatherIcon: Icon;
};

export type DestinationTip = {
  __typename?: "DestinationTip";
  description: EgdsSpannableText;
  icon: Icon;
};

export type DestinationTipItem = {
  __typename?: "DestinationTipItem";
  destinationTips: Array<DestinationTip>;
  name: Scalars["String"];
};

export type DestinationTips = {
  __typename?: "DestinationTips";
  category: Scalars["String"];
  items: Array<DestinationTipItem>;
};

export type DetailsMultiItemShoppingAction = MultiItemShoppingAction & {
  __typename?: "DetailsMultiItemShoppingAction";
  shoppingContext: ShoppingContext;
};

export type DetailsNavTabs = {
  __typename?: "DetailsNavTabs";
  navTabs: Array<NavTab>;
};

/** Device information */
export type Device = {
  __typename?: "Device";
  type: DeviceType;
};

/** Set of device information used by frontend applications */
export type DeviceContext = {
  __typename?: "DeviceContext";
  /** Device browser brand name */
  brandName?: Maybe<Scalars["String"]>;
  /** Device operating system */
  deviceOS?: Maybe<Scalars["String"]>;
  /** Device operating system version */
  deviceOSVersion?: Maybe<Scalars["String"]>;
  isMobile?: Maybe<Scalars["Boolean"]>;
  isTablet?: Maybe<Scalars["Boolean"]>;
  isWirelessDevice?: Maybe<Scalars["Boolean"]>;
  /** Device browser name */
  mobileBrowser?: Maybe<Scalars["String"]>;
  /** Device model name */
  modelName?: Maybe<Scalars["String"]>;
  physicalScreenHeight?: Maybe<Scalars["Int"]>;
  physicalScreenWidth?: Maybe<Scalars["Int"]>;
  resolutionHeight?: Maybe<Scalars["Int"]>;
  resolutionWidth?: Maybe<Scalars["Int"]>;
};

/** Device information */
export interface DeviceInput {
  type: DeviceType;
}

/** Valid device types */
export type DeviceType =
  | "APP_PHONE"
  | "APP_TABLET"
  | "CHAT_APP"
  | "DESKTOP"
  | "MOBILE_PHONE"
  | "MOBILE_TABLET"
  | "VOICE_APP";

export type DialogAction = {
  __typename?: "DialogAction";
  /** Icon to display. */
  icon?: Maybe<Icon>;
  /** Destination link. */
  linkUrl: Scalars["String"];
  /** Message to be shown of the dialog. */
  message?: Maybe<Scalars["String"]>;
  /** Referrer for analytics. */
  referrerId?: Maybe<Scalars["String"]>;
  /** Action text displayed for the link url. */
  text?: Maybe<Scalars["String"]>;
};

export type DialogButtonActionType =
  | "CLOSE_DIALOG"
  | "CREATE_TRACKING_MUTATION"
  | "DISABLE_TRACKING_MUTATION"
  | "UPDATE_TRACKING_MUTATION";

/** Used to display a title and content in a dialog */
export type DialogContent = {
  __typename?: "DialogContent";
  content?: Maybe<Array<Scalars["String"]>>;
  title?: Maybe<LodgingHeader>;
};

/** Generic wrapper for content to be displayed inside a dialog */
export interface DialogContentEntry {
  entryContent: Array<Scalars["String"]>;
  entryTitle: LodgingHeader;
}

/** Dimensions for a presentation object i.e. image or icon */
export interface DimensionsInput {
  density: Scalars["Float"];
  height: Scalars["Float"];
  width: Scalars["Float"];
}

/** Used as input to request a call to action that, when engaged with, will show a prompt that enables the traveler to provide feedback on the content they are experiencing */
export type DirectFeedback = {
  __typename?: "DirectFeedback";
  promptId: Scalars["ID"];
};

export type DirectFeedbackCheckbox = EgdsCheckBox & {
  __typename?: "DirectFeedbackCheckbox";
  analytics: ClientSideAnalytics;
  description?: Maybe<Scalars["String"]>;
  enabled: Scalars["Boolean"];
  errorMessage?: Maybe<Scalars["String"]>;
  label: EgdsText;
  name?: Maybe<Scalars["String"]>;
  required: Scalars["Boolean"];
  state: EgdsCheckBoxState;
  value?: Maybe<Scalars["String"]>;
};

export type DirectFeedbackFieldError = {
  __typename?: "DirectFeedbackFieldError";
  error: Scalars["String"];
  fieldId?: Maybe<Scalars["ID"]>;
};

export type DirectFeedbackFieldSet = {
  __typename?: "DirectFeedbackFieldSet";
  elements: Array<DirectFeedbackFieldSetElement>;
  label?: Maybe<Scalars["String"]>;
};

export type DirectFeedbackFieldSetElement =
  | DirectFeedbackInputField
  | DirectFeedbackRadioGroup
  | DirectFeedbackTextArea
  | EgdsHeading
  | EgdsPlainText
  | EgdsSpannableText;

export type DirectFeedbackFormDisplayElement =
  | DirectFeedbackTextList
  | EgdsErrorSummary
  | EgdsHeading
  | EgdsPlainText
  | EgdsSpannableText;

export type DirectFeedbackFormPage = {
  __typename?: "DirectFeedbackFormPage";
  commands?: Maybe<Array<EgdsButton>>;
  /** @deprecated Please use displayConditions instead. */
  displayCondition?: Maybe<DirectFeedbackPageDisplayCondition>;
  displayConditions: Array<DirectFeedbackPageDisplayCondition>;
  elements: Array<DirectFeedbackFormPageElement>;
  footer?: Maybe<Array<DirectFeedbackFormDisplayElement>>;
  id?: Maybe<Scalars["String"]>;
  /** @deprecated Please use commands instead. */
  submitButton: UiPrimaryButton;
  subtitle?: Maybe<EgdsText>;
  title?: Maybe<Scalars["String"]>;
};

export type DirectFeedbackFormPageElement =
  | DirectFeedbackFieldSet
  | DirectFeedbackInputField
  | DirectFeedbackMultiSelectGroup
  | DirectFeedbackRadioGroup
  | DirectFeedbackTextArea
  | DirectFeedbackTextList
  | EgdsErrorSummary
  | EgdsHeading
  | EgdsPlainText
  | EgdsSpannableText;

export type DirectFeedbackFormValidation = {
  __typename?: "DirectFeedbackFormValidation";
  errors: Array<DirectFeedbackFieldError>;
  serviceError?: Maybe<EgdsErrorSummary>;
};

export type DirectFeedbackInputField = EgdsInputField & {
  __typename?: "DirectFeedbackInputField";
  analytics: ClientSideAnalytics;
  errorMessage?: Maybe<Scalars["String"]>;
  instructions?: Maybe<Scalars["String"]>;
  label?: Maybe<Scalars["String"]>;
  labelTemplate?: Maybe<EgdsLocalizedText>;
  leftIcon?: Maybe<Icon>;
  name?: Maybe<Scalars["String"]>;
  placeholder?: Maybe<Scalars["String"]>;
  readOnly: Scalars["Boolean"];
  required?: Maybe<Scalars["Boolean"]>;
  rightIcon?: Maybe<Icon>;
  validations?: Maybe<Array<EgdsInputValidation>>;
  value?: Maybe<Scalars["String"]>;
};

export type DirectFeedbackMultiSelectGroup = {
  __typename?: "DirectFeedbackMultiSelectGroup";
  errorMessage?: Maybe<Scalars["String"]>;
  groupName: Scalars["String"];
  legend: Scalars["String"];
  options: Array<EgdsCheckBox>;
  required?: Maybe<Scalars["Boolean"]>;
  selected?: Maybe<Scalars["String"]>;
};

export type DirectFeedbackOpenFormAction = UiAction & {
  __typename?: "DirectFeedbackOpenFormAction";
  accessibility?: Maybe<Scalars["String"]>;
  analytics: ClientSideAnalytics;
  promptId?: Maybe<Scalars["String"]>;
};

export type DirectFeedbackOpenNextPageAction = UiAction & {
  __typename?: "DirectFeedbackOpenNextPageAction";
  accessibility?: Maybe<Scalars["String"]>;
  analytics: ClientSideAnalytics;
  destinationId?: Maybe<Scalars["String"]>;
};

export type DirectFeedbackOpenPreviousPageAction = UiAction & {
  __typename?: "DirectFeedbackOpenPreviousPageAction";
  accessibility?: Maybe<Scalars["String"]>;
  analytics: ClientSideAnalytics;
};

export type DirectFeedbackPageDisplayCondition = {
  __typename?: "DirectFeedbackPageDisplayCondition";
  conditionType: DirectFeedbackPageDisplayConditionType;
  expectedValue: Scalars["String"];
  fieldId: Scalars["ID"];
};

export type DirectFeedbackPageDisplayConditionType = "BOOL" | "NONE" | "PATTERN" | "TEXT";

export type DirectFeedbackPrompt = {
  __typename?: "DirectFeedbackPrompt";
  callToAction?: Maybe<UiTertiaryButton>;
  pages: Array<DirectFeedbackFormPage>;
  subtitle?: Maybe<EgdsText>;
  title?: Maybe<Scalars["String"]>;
};

export type DirectFeedbackRadioButton = EgdsRadioButton & {
  __typename?: "DirectFeedbackRadioButton";
  analytics: ClientSideAnalytics;
  description?: Maybe<Scalars["String"]>;
  disabled: Scalars["Boolean"];
  label: Scalars["String"];
  labelSuffix?: Maybe<Scalars["String"]>;
  value: Scalars["String"];
};

export type DirectFeedbackRadioGroup = EgdsRadioGroup & {
  __typename?: "DirectFeedbackRadioGroup";
  errorMessage?: Maybe<Scalars["String"]>;
  groupName: Scalars["String"];
  legend: Scalars["String"];
  options: Array<EgdsRadioButton>;
  required?: Maybe<Scalars["Boolean"]>;
  selected?: Maybe<Scalars["String"]>;
};

export type DirectFeedbackSubmitFormAction = UiAction & {
  __typename?: "DirectFeedbackSubmitFormAction";
  accessibility?: Maybe<Scalars["String"]>;
  analytics: ClientSideAnalytics;
};

export type DirectFeedbackTextArea = EgdsInputField & {
  __typename?: "DirectFeedbackTextArea";
  analytics: ClientSideAnalytics;
  errorMessage?: Maybe<Scalars["String"]>;
  instructions?: Maybe<Scalars["String"]>;
  isEditable: Scalars["Boolean"];
  label?: Maybe<Scalars["String"]>;
  labelTemplate?: Maybe<EgdsLocalizedText>;
  leftIcon?: Maybe<Icon>;
  maxRows?: Maybe<Scalars["Int"]>;
  minRows?: Maybe<Scalars["Int"]>;
  name?: Maybe<Scalars["String"]>;
  placeholder?: Maybe<Scalars["String"]>;
  readOnly: Scalars["Boolean"];
  required?: Maybe<Scalars["Boolean"]>;
  rightIcon?: Maybe<Icon>;
  validations?: Maybe<Array<EgdsInputValidation>>;
  value?: Maybe<Scalars["String"]>;
};

export type DirectFeedbackTextList = {
  __typename?: "DirectFeedbackTextList";
  bullet: BulletStyle;
  listItems: Array<DirectFeedbackTextListItem>;
};

export type DirectFeedbackTextListItem = {
  __typename?: "DirectFeedbackTextListItem";
  egdsElementId: Scalars["String"];
  icon?: Maybe<Icon>;
  style?: Maybe<EgdsTextListItemStyle>;
  text: EgdsText;
};

export interface DirectFeedbackValuesInput {
  context: Array<GraphQlPairInput>;
  formValues: Array<GraphQlPairInput>;
}

/** Legal disclaimer, denoted with array of Markup text */
export type DisclaimerContentMarkup = {
  __typename?: "DisclaimerContentMarkup";
  content: Array<MarkupText>;
};

export type DisplayPrice = {
  __typename?: "DisplayPrice";
  /** Disclaimer message about the price. */
  disclaimer?: Maybe<LodgingPlainDialog>;
  /** The value to be displayed. */
  price: FormattedMoney;
  /** Describes the role of value, i.e. Lead, Strikeout. */
  role: Scalars["String"];
};

export type DisplayPriceSummaryItem = {
  __typename?: "DisplayPriceSummaryItem";
  leadPrice?: Maybe<LodgingEnrichedMessage>;
  priceLabel?: Maybe<LodgingEnrichedMessage>;
  priceMessages?: Maybe<Array<LodgingEnrichedMessage>>;
};

/** Measurable distance with units */
export type Distance = {
  __typename?: "Distance";
  unit: DistanceUnit;
  value: Scalars["Float"];
};

/** Enum of the units of measure and their abbreviations */
export type DistanceUnit = "KILOMETER" | "MILE";

export type DrivableDestinationsContent = {
  __typename?: "DrivableDestinationsContent";
  /** Hero Image */
  heroImage: HeroImage;
  /** A list of secondarily recommended destinations */
  inspirationModule: InspirationModule;
  /** Incentives Offering ID / Destination Collection ID */
  offeringId: Scalars["String"];
  /** PreHeader */
  preHeader: Scalars["String"];
  /** Primary destination recommendation */
  primaryModule: PrimaryModule;
  /** Incentives Recommendation ID */
  recId: Scalars["String"];
  /** SubjectLine */
  subjectLine: Scalars["String"];
  /** Text Banner */
  textBanner: TextBanner;
};

export type DropOffSearchResults = {
  __typename?: "DropOffSearchResults";
  carDropOffOfferCard: Array<CarDropOffOfferCard>;
  carDropOffOfferCardTitle: Scalars["String"];
  carDropOffTitle: CarDropOffTitle;
  map?: Maybe<CarMap>;
  shareFeedbackAction?: Maybe<CarShareFeedbackAction>;
};

/** A time duration */
export type Duration = {
  __typename?: "Duration";
  /**
   * The time unit of the duration
   * @deprecated Use platform formatters and return localized strings
   */
  unit: ChronoUnit;
  /**
   * The duration value
   * @deprecated Use platform formatters and return localized strings
   */
  value: Scalars["String"];
};

/** Representation for the duration span element. */
export interface DurationSpan {
  /** Close button on the duration span dialog element. */
  closeButton: EgdsButton;
  /** Done button on the duration span dialog element. */
  doneButton: EgdsButton;
  /** Title for the duration span dialog element. Example: Cruise length, Trip Duration. */
  title: Scalars["String"];
}

/** Input validation for the duration span element. */
export type DurationSpanInputValidation = EgdsInputValidation & {
  __typename?: "DurationSpanInputValidation";
  /** Error message to display to the user whenever the validation fails. */
  errorMessage: Scalars["String"];
  /** Component that shows an specific error when changes are tried to be saved. */
  errorSummary?: Maybe<EgdsErrorSummary>;
  /** Specifies the type of validation. */
  type: DurationSpanValidationType;
};

/** Implementation for the duration span field selection element. */
export type DurationSpanSelector = DurationSpan &
  EgdsElement & {
    __typename?: "DurationSpanSelector";
    /** Close button on the duration span dialog element. */
    closeButton: EgdsButton;
    /** Done button on the duration span dialog element. */
    doneButton: EgdsButton;
    /** Duration span dialog element unique identifier. */
    egdsElementId?: Maybe<Scalars["String"]>;
    /** Input field for the maximum span limit. */
    maxDurationSpanLimit: EgdsNumberInputField;
    /** Input field for the minimum span limit. */
    minDurationSpanLimit: EgdsNumberInputField;
    /** Title for the duration span dialog element. Example: Cruise length, Trip Duration. */
    title: Scalars["String"];
    /**
     * Validations with corresponding error messages to display to the user
     * if the inputs don't fulfill the requirements. The order of the validations
     * dictate the order in which the error messages are displayed.
     */
    validations?: Maybe<Array<EgdsInputValidation>>;
  };

/** Different types of duration span input validations. */
export type DurationSpanValidationType =
  /** Used to validate that a maximum input value is greater than a minimum input value. */
  | "MAXIMUM_GREATER_THAN_MINIMUM"
  /** Used to validate that the user input is less than or equal to some specified value. Example: Maximum 10 nights. */
  | "MAXIMUM_VALUE"
  /** Used to validate that a minimum input value is less than a maximum input value. */
  | "MINIMUM_LESS_THAN_MAXIMUM"
  /** Used to validate that the user input is greater than or equal to some specified value. Example: Minimum 2 nights. */
  | "MINIMUM_VALUE"
  /** Used to validate that the user input has a value. */
  | "REQUIRED_VALUE";

/** Represents the data displayed at each side of the timeline */
export type DurationTimelineSideSection = {
  __typename?: "DurationTimelineSideSection";
  /** difference between arrival and departure days. Example: '+2' or '+1' */
  differentDayArrival?: Maybe<Scalars["String"]>;
  /** time of departure/arrival */
  primary: Scalars["String"];
  /** airport name at departure/arrival */
  secondary: Scalars["String"];
};

export type DynamicCrossSellQueries = {
  __typename?: "DynamicCrossSellQueries";
  /** List of dynamic car cross sell cards */
  productCrossSell: MultiItemCrossSellUiResponse;
};

export type DynamicCrossSellQueriesProductCrossSellArgs = {
  crossSellProductType: CrossSellProductType;
  userLocation?: InputMaybe<CrossSellUserLocationInput>;
};

export type DynamicMap = {
  __typename?: "DynamicMap";
  /** Token to use for populating map */
  accessToken?: Maybe<Scalars["String"]>;
  /** The configurations to use for the map */
  mapConfig?: Maybe<DynamicMapConfig>;
  /** The map type to use. i.e. Mapbox or Google */
  mapType?: Maybe<Scalars["String"]>;
  /** The location to view */
  viewState?: Maybe<ViewState>;
};

export type DynamicMapConfig = {
  __typename?: "DynamicMapConfig";
  /** The ID associated with the map style to use */
  googleMapsId?: Maybe<Scalars["String"]>;
  /** The locale to use for the map */
  locale?: Maybe<Scalars["String"]>;
};

export type DynamicPackageDetailsPrimers = DynamicPackageDetailsPrimersSuccess | PackageDetailsPrimersError;

/** Information needed to render the dynamic package details page */
export type DynamicPackageDetailsPrimersSuccess = {
  __typename?: "DynamicPackageDetailsPrimersSuccess";
  heading: EgdsHeading;
  primers: DynamicPackageDetailsSuccessPrimers;
  state: MishopDetailsUiState;
};

/** Primers needed to render the dynamic package details page */
export type DynamicPackageDetailsSuccessPrimers = {
  __typename?: "DynamicPackageDetailsSuccessPrimers";
  bookByPhonePrimer?: Maybe<MishopUiBookByPhonePrimer>;
  checkoutButtonPrimer: MishopUiCheckoutButtonPrimer;
  /** @deprecated legalContentPrimer has been moved to be a member of the PackageUIProductContentPrimer union */
  legalContentPrimer: MishopUiLegalContentPrimer;
  notificationPrimer: MishopUiNotificationPrimer;
  pricingDetailsPrimer: MishopUiPricingDetailsPrimer;
  productContentPrimers: Array<PackageDetailsProductContentPrimer>;
  stepIndicatorPrimer: MishopUiStepIndicatorPrimer;
};

export type DynamicRateRule = {
  __typename?: "DynamicRateRule";
  description?: Maybe<Scalars["String"]>;
  /** @deprecated Use description instead of descriptionId, replace with description */
  descriptionId?: Maybe<Scalars["Int"]>;
  discountPercent?: Maybe<Scalars["Int"]>;
  /** The type of discount rule applied */
  discountType?: Maybe<RateDiscountType>;
  expiration?: Maybe<Duration>;
  sameDay: Scalars["Boolean"];
};

/** The event portion of an EG Clickstream event payload */
export type EgClickstreamEvent = {
  __typename?: "EGClickstreamEvent";
  actionLocation?: Maybe<Scalars["String"]>;
  clickstreamTraceId?: Maybe<Scalars["String"]>;
  eventCategory: Scalars["String"];
  eventName: Scalars["String"];
  eventType: Scalars["String"];
  eventVersion: Scalars["String"];
};

/** EG Clickstream payload to be logged on the client. Should follow schemas defined by EG Clickstream. */
export type EgClickstreamPayload = TripRecommendationModule;

/**
 * Action dialogs are containers that content can be rendered in. Clients should orchestrate how content
 * will render within the dialog. Action dialogs specifically contain one or more buttons for users to take action upon.
 *
 * https://www.figma.com/file/KqOeuNsfHUNAgd4johSxsh/Dialog
 */
export type EgdsActionDialog = EgdsDialog & {
  __typename?: "EGDSActionDialog";
  closeAnalytics?: Maybe<ClientSideAnalytics>;
  footer: EgdsDialogFooter;
};

/**
 * Representation of a badge, implementations could include status, saved, notification, etc.
 *
 * https://www.figma.com/file/aYQZVH6x5kqAGj8LbLzTVWfX/Badges
 */
export interface EgdsBadge {
  accessibility?: Maybe<Scalars["String"]>;
  graphic?: Maybe<UiGraphic>;
  /** Represents display size of badge. Example: 'large', 'small' */
  size?: Maybe<Scalars["String"]>;
  /** Text content to be displayed within the badge */
  text?: Maybe<Scalars["String"]>;
  theme?: Maybe<Scalars["String"]>;
}

/**
 * Represents a notification badge
 * https://www.figma.com/file/aYQZVH6x5kqAGj8LbLzTVWfX/Badge?node-id=7738%3A8273
 */
export type EgdsBadgeNotification = EgdsBadge &
  EgdsElement & {
    __typename?: "EGDSBadgeNotification";
    accessibility?: Maybe<Scalars["String"]>;
    /** Count value to be displayed within the badge */
    count?: Maybe<Scalars["String"]>;
    egdsElementId?: Maybe<Scalars["String"]>;
    graphic?: Maybe<UiGraphic>;
    size?: Maybe<Scalars["String"]>;
    text?: Maybe<Scalars["String"]>;
    /** Represents theme for notification badge. Possible values are 'unread', 'activity', 'action', 'default', 'inverse' */
    theme?: Maybe<Scalars["String"]>;
    visible?: Maybe<Scalars["Boolean"]>;
  };

/**
 * EGDSBaseMap is the blueprint to create an EgMap component
 * Figma - https://www.figma.com/file/X31Tc9cWj9lbSKQCznru5M/Maps?node-id=0%3A1
 */
export interface EgdsBaseMap {
  /** coordinates where the center of the map should be */
  center?: Maybe<Coordinates>;
  /**
   * Change the map locale
   * @deprecated Redundant field: locale is already provided at the shared-ui level
   */
  locale?: Maybe<Scalars["Locale"]>;
  /** map zoom value in correlation with the center coordinate */
  zoom?: Maybe<Scalars["Int"]>;
}

/** EGDSMap configuration that contains the provider('google-maps or mapbox') and api config */
export interface EgdsBaseMapConfig {
  /** API key that will be passed to google-map or mapbox */
  accessToken: Scalars["String"];
  /**
   * configuration for loading google map or mapbox
   * @deprecated prefer using data from EGDSDynamicMapConfig
   */
  config?: Maybe<MapConfiguration>;
  /** the map provider should be either 'google-maps' or 'mapbox'. */
  egdsMapProvider: EgdsMapProvider;
}

/** Basic CheckBox element */
export type EgdsBasicCheckBox = EgdsCheckBox &
  EgdsElement & {
    __typename?: "EGDSBasicCheckBox";
    /** analytics event to fire when checkbox is checked */
    checkedAnalytics?: Maybe<ClientSideAnalytics>;
    description?: Maybe<Scalars["String"]>;
    egdsElementId?: Maybe<Scalars["String"]>;
    enabled: Scalars["Boolean"];
    errorMessage?: Maybe<Scalars["String"]>;
    label: EgdsText;
    name?: Maybe<Scalars["String"]>;
    required: Scalars["Boolean"];
    state: EgdsCheckBoxState;
    /** analytics event to fire when checkbox is unchecked */
    uncheckedAnalytics?: Maybe<ClientSideAnalytics>;
    /** Specifies the value associated with the checkbox if needed */
    value?: Maybe<Scalars["String"]>;
  };

/** Basic date range component */
export type EgdsBasicDateRange = EgdsDateRange & {
  __typename?: "EGDSBasicDateRange";
  loadingMessage?: Maybe<Scalars["String"]>;
  results: Array<EgdsDateRangeResult>;
};

/** Basic date range result component */
export type EgdsBasicDateRangeResult = EgdsDateRangeResult & {
  __typename?: "EGDSBasicDateRangeResult";
  accessibility?: Maybe<Scalars["String"]>;
  analytics?: Maybe<ClientSideAnalytics>;
  date: Date;
  label: Scalars["String"];
  theme?: Maybe<EgdsDateRangeResultTheme>;
};

/**
 * Represents the simplest type of localized string.  There are no plurals or fragments.
 * Example: `Your trip to {destination}`, where `destination` is provided by the client
 */
export type EgdsBasicLocalizedText = EgdsElement &
  EgdsTemplateModels &
  EgdsText & {
    __typename?: "EGDSBasicLocalizedText";
    egdsElementId?: Maybe<Scalars["String"]>;
    /** Provide a list of template models. */
    models: Array<TemplateModel>;
    /** Provide a template string.  Example:  `Your trip from {origin} to {destination}` */
    template: Scalars["String"];
    /** Provide a default value */
    text: Scalars["String"];
  };

/**
 * EGDSBasicMap is the type that could be used by both static map and dynamic map
 * Figma - https://www.figma.com/file/X31Tc9cWj9lbSKQCznru5M/Maps?node-id=0%3A1
 * In order to see the design, please navigate to "How to use Map Components" section then the
 * "Dynamic versus static map" title. You will be able to find both dynamic and static map designs
 */
export type EgdsBasicMap = EgdsBaseMap & {
  __typename?: "EGDSBasicMap";
  /** bounds to use if initialViewport 'bounds' is specified. Otherwise this information is ignored */
  bounds?: Maybe<EgdsMapBounds>;
  /** coordinate to use to center the map if initialViewport 'centerAndZoom' is specified. Otherwise this information is ignored */
  center?: Maybe<Coordinates>;
  /** options to use when computing initial viewport allowing the center to be specified. Only read when initialViewport is set to CENTERED_COMPUTED_BOUNDS, otherwise ignored */
  centeredBoundsOptions?: Maybe<EgdsMapCenteredBoundsOptions>;
  /** options to use when computing initial viewport. This field is only read when initialViewport is set to 'computedBounds), otherwise this information is ignored */
  computedBoundsOptions?: Maybe<EgdsMapComputedBoundsOptions>;
  /** configuration to set up the eg static map or dynamic map */
  config: EgdsBaseMapConfig;
  /** viewport to use when the map is loaded */
  initialViewport?: Maybe<EgdsMapInitialViewport>;
  /** description of map used either as a title or hidden A11y text */
  label?: Maybe<Scalars["String"]>;
  /** @deprecated Redundant field: locale is already provided at the shared-ui level */
  locale?: Maybe<Scalars["Locale"]>;
  /** List of EGDSMapMarker that will show on map */
  markers: Array<EgdsMapMarker>;
  /** zoom value to use if initialViewport 'centerAndZoom' is specified. Otherwise this information is ignored */
  zoom?: Maybe<Scalars["Int"]>;
};

/** Represents basic implementation of EGDSOption. */
export type EgdsBasicOption = EgdsElement &
  EgdsOption & {
    __typename?: "EGDSBasicOption";
    changeAnalytics?: Maybe<ClientSideAnalytics>;
    egdsElementId?: Maybe<Scalars["String"]>;
    label: Scalars["String"];
    selected?: Maybe<Scalars["Boolean"]>;
    value: Scalars["String"];
  };

/**
 * Represents basic key - value chips or pills
 * Clicking or tapping any part of the pill will toggle between select and deselect.
 */
export type EgdsBasicPill = EgdsPill & {
  __typename?: "EGDSBasicPill";
  /** Accessibility label for the pill */
  accessibility?: Maybe<Scalars["String"]>;
  /** analytics tracking for the deselection of pill */
  deselectAnalytics?: Maybe<ClientSideAnalytics>;
  disabled: Scalars["Boolean"];
  /** Icon to be displayed along with the label */
  icon?: Maybe<UiGraphic>;
  id?: Maybe<Scalars["String"]>;
  /**
   * type `name` or param name of the pill.
   * Ex: `paymentType` for a "Free Cancellation" filter pill
   */
  name?: Maybe<Scalars["String"]>;
  /** Label to be displayed on the pill */
  primary?: Maybe<Scalars["String"]>;
  /** analytics tracking for the selection of pill */
  selectAnalytics?: Maybe<ClientSideAnalytics>;
  selected: Scalars["Boolean"];
  /**
   * value of the pill.
   * Ex: `FREE_CANCELLATION` for a "Free Cancellation" filter pill
   */
  value?: Maybe<Scalars["String"]>;
};

/** Basic radio button element */
export type EgdsBasicRadioButton = EgdsRadioButton & {
  __typename?: "EGDSBasicRadioButton";
  description?: Maybe<Scalars["String"]>;
  disabled: Scalars["Boolean"];
  label: Scalars["String"];
  labelSuffix?: Maybe<Scalars["String"]>;
  value: Scalars["String"];
};

/** Basic radio group element */
export type EgdsBasicRadioGroup = EgdsRadioGroup & {
  __typename?: "EGDSBasicRadioGroup";
  errorMessage?: Maybe<Scalars["String"]>;
  groupName: Scalars["String"];
  options: Array<EgdsRadioButton>;
  selected?: Maybe<Scalars["String"]>;
};

export type EgdsBasicRemovablePill = EgdsPill & {
  __typename?: "EGDSBasicRemovablePill";
  /** Accessibility label for the pill */
  accessibility?: Maybe<Scalars["String"]>;
  disabled: Scalars["Boolean"];
  /** Icon to be displayed along with the label */
  icon?: Maybe<UiGraphic>;
  id?: Maybe<Scalars["String"]>;
  /**
   * type `name` or param name of the pill.
   * Ex: `paymentType` for a "Free Cancellation" filter pill
   */
  name?: Maybe<Scalars["String"]>;
  /** Label to be displayed on the pill */
  primary?: Maybe<Scalars["String"]>;
  /** denotes removal trigger of pill */
  remove?: Maybe<UiGraphic>;
  /** analytics tracking for the removal of pill */
  removeAnalytics?: Maybe<ClientSideAnalytics>;
  selected: Scalars["Boolean"];
  /**
   * value of the pill.
   * Ex: `FREE_CANCELLATION` for a "Free Cancellation" filter pill
   */
  value?: Maybe<Scalars["String"]>;
};

/**
 * Represents the standard implementation of EGDSSectionHeading.
 * This can be used for any Product specific use-cases
 * A product can be an Activity / Property / Flight / Car etc.
 *
 * eg it can represent section heading for a list of item.
 */
export type EgdsBasicSectionHeading = EgdsSectionHeading & {
  __typename?: "EGDSBasicSectionHeading";
  /** Represents the graphic rendered before heading */
  graphic?: Maybe<UiGraphic>;
  heading: EgdsHeading;
  subheading?: Maybe<Scalars["String"]>;
};

/** Represents basic implementation of EGDSSelect. */
export type EgdsBasicSelect = EgdsElement &
  EgdsSelect & {
    __typename?: "EGDSBasicSelect";
    clickAnalytics?: Maybe<ClientSideAnalytics>;
    disabled: Scalars["Boolean"];
    egdsElementId?: Maybe<Scalars["String"]>;
    errorMessage?: Maybe<Scalars["String"]>;
    icon?: Maybe<Icon>;
    label: Scalars["String"];
    options: Array<EgdsOption>;
    readOnly: Scalars["Boolean"];
    /** Value for the select field */
    value?: Maybe<Scalars["String"]>;
  };

/** Represents basic implementation of StepInput. */
export type EgdsBasicStepInput = EgdsElement &
  EgdsStepInput & {
    __typename?: "EGDSBasicStepInput";
    /** Analytics event to be fired whenever the value for this field decrease */
    decreaseAnalytics?: Maybe<ClientSideAnalytics>;
    decreaseText?: Maybe<Scalars["String"]>;
    egdsElementId?: Maybe<Scalars["String"]>;
    /** Analytics event to be fired whenever the value for this field increase */
    increaseAnalytics?: Maybe<ClientSideAnalytics>;
    increaseText?: Maybe<Scalars["String"]>;
    key?: Maybe<Scalars["String"]>;
    label: Scalars["String"];
    max?: Maybe<Scalars["Int"]>;
    min?: Maybe<Scalars["Int"]>;
    step: Scalars["Int"];
    subLabel?: Maybe<Scalars["String"]>;
    value: Scalars["Int"];
  };

/** Represents basic implementation of EGDSTab. */
export type EgdsBasicTab = EgdsElement &
  EgdsTab & {
    __typename?: "EGDSBasicTab";
    accessibility?: Maybe<Scalars["String"]>;
    clickAnalytics?: Maybe<ClientSideAnalytics>;
    egdsElementId?: Maybe<Scalars["String"]>;
    label: Scalars["String"];
    tabId: Scalars["String"];
  };

/** Represents basic implementation of EGDSTabs. */
export type EgdsBasicTabs = EgdsElement &
  EgdsTabs & {
    __typename?: "EGDSBasicTabs";
    egdsElementId?: Maybe<Scalars["String"]>;
    selectedTabId?: Maybe<Scalars["String"]>;
    tabs: Array<EgdsTab>;
  };

/** An implementation that represents a basic thumbnail media gallery component. */
export type EgdsBasicThumbnailMediaGallery = EgdsThumbnailMediaGallery & {
  __typename?: "EGDSBasicThumbnailMediaGallery";
  tabs?: Maybe<EgdsTabs>;
  thumbnails: Array<MediaItem>;
  toolbar: EgdsDialogToolbar;
};

/** Represents implementation of EGDSTravelerSelector which will be used for flight, activity, cruises or brands like Vrbo where room less travelers are required. */
export type EgdsBasicTravelerSelector = EgdsElement &
  EgdsTravelerSelector & {
    __typename?: "EGDSBasicTravelerSelector";
    closeButton: EgdsButton;
    doneButton: EgdsButton;
    egdsElementId?: Maybe<Scalars["String"]>;
    /** Additional information displayed at travelers selector. Example: activity name/s. */
    subTitles?: Maybe<Array<Scalars["String"]>>;
    title: Scalars["String"];
    /** Represents travelers category for the travelers selector. */
    travelers?: Maybe<EgdsTravelers>;
    /**
     * Validations with corresponding error messages to display if the input is invalid.
     * The order in which the validations appears indicates the order of priority of which error message to display.
     */
    validations?: Maybe<Array<EgdsInputValidation>>;
  };

/**
 * Triggers another component (e.g. Menu, Sheet, Full-screen dialog).
 * Clicking or tapping any part of the pill will trigger the interaction.
 */
export type EgdsBasicTriggerPill = EgdsPill & {
  __typename?: "EGDSBasicTriggerPill";
  /** Accessibility label for the pill */
  accessibility?: Maybe<Scalars["String"]>;
  /** analytics tracking for the deselection of pill */
  deselectAnalytics?: Maybe<ClientSideAnalytics>;
  disabled: Scalars["Boolean"];
  /** Icon to be displayed along with the label */
  icon?: Maybe<UiGraphic>;
  id?: Maybe<Scalars["String"]>;
  /** Label to be displayed on the pill */
  primary?: Maybe<Scalars["String"]>;
  /** analytics tracking for the selection of pill */
  selectAnalytics?: Maybe<ClientSideAnalytics>;
  selected: Scalars["Boolean"];
  /** denotes Icon, that triggers to another component */
  trigger?: Maybe<UiGraphic>;
};

/** Bulleted variant of EGDS typography list */
export type EgdsBulletedList = EgdsElement &
  EgdsTextList & {
    __typename?: "EGDSBulletedList";
    egdsElementId?: Maybe<Scalars["String"]>;
    listItems: Array<EgdsTextListItem>;
    size?: Maybe<EgdsTextListSize>;
  };

/** Intended to be implemented by EGDS Button objects (including variations) */
export interface EgdsButton {
  accessibility?: Maybe<Scalars["String"]>;
  /**
   * @deprecated
   *         UIAction should not be used as a field because it allows for too many possible types.
   *         If need to specify action have the implementation of EGDSButton add a field for action with interface type of less number of possible subtypes
   *         or a union type with a manageable number of members
   *
   */
  action?: Maybe<UiAction>;
  /** Used to capture client side analytics on button click. */
  analytics?: Maybe<ClientSideAnalytics>;
  disabled: Scalars["Boolean"];
  icon?: Maybe<Icon>;
  primary?: Maybe<Scalars["String"]>;
}

/** Styles established in EGDS design docs. https://www.figma.com/file/bbPtPOgPN4sttR3BzDaTZc/Buttons */
export type EgdsButtonStyle = "PRIMARY" | "SECONDARY" | "TERTIARY";

/** Represents different cards which can be used interchangeably. */
export type EgdsCard = EgdsImageCard | EgdsImageLinkCard;

/** Component that support EGDSCards union type as Carousel Item to be implemented inside EGDSCarousel */
export type EgdsCardCarouselItem = EgdsCarouselItem & {
  __typename?: "EGDSCardCarouselItem";
  /** Union for cards so any applicable cards can be used. */
  card: EgdsCard;
  id?: Maybe<Scalars["String"]>;
};

/**
 * Represents localized text with cardinality.
 *
 * Example: `{num} rooms` where `num` is provided by the client.
 *
 * Note: "Cardinal" text is different than "Ordinal" text in that cardinal number tell "how many" (i.e. "2 rooms"),
 * whereas ordinal numbers tell in which order (i.e. "2nd room").
 */
export type EgdsCardinalLocalizedText = EgdsElement &
  EgdsTemplateModels &
  EgdsText & {
    __typename?: "EGDSCardinalLocalizedText";
    egdsElementId?: Maybe<Scalars["String"]>;
    /** Provide a list of template models. */
    models: Array<TemplateModel>;
    /** Optional secondary templates for different texts than required templates. Example: "{travelerCount} traveler with pets" */
    secondaryTemplates?: Maybe<Array<CardinalTemplate>>;
    /** Provide a list of templates for all supported cardinal categories (0, 1, 2, few, many, other) */
    templates: Array<CardinalTemplate>;
    /** Provide default localized string for initial value and fallback text */
    text: Scalars["String"];
  };

/** Representation of a carousel that can support different kind of cards, including a combination of media and text */
export type EgdsCarousel = {
  __typename?: "EGDSCarousel";
  /** Accessibility text for the carousel */
  carouselId?: Maybe<Scalars["String"]>;
  /** List of CarouselItem that represent different items to display in the carousel */
  items: Array<EgdsCarouselItem>;
  /** Next button on a carousel (can give the flexibility to add text, analytics, accessibility and icons) */
  nextButton?: Maybe<EgdsButton>;
  /** Previous button on a carousel (can give the flexibility to add text, analytics, accessibility and icons) */
  previousButton?: Maybe<EgdsButton>;
};

/** A container that represents basic carousel component. */
export type EgdsCarouselContainer = EgdsGalleryCarousel & {
  __typename?: "EGDSCarouselContainer";
  accessibilityHeadingText: Scalars["String"];
  media: Array<MediaItem>;
  nextButtonText?: Maybe<Scalars["String"]>;
  previousButtonText?: Maybe<Scalars["String"]>;
};

/** Interface that need to be implemented in custom carousel items to be able to use EGDSCarousel */
export interface EgdsCarouselItem {
  id?: Maybe<Scalars["String"]>;
}

/**
 * Represents a CheckBox element
 * Ex. https://www.figma.com/file/fvv9g0KUyrhcLSErmT6Cd5/EGID---Registration?node-id=3659%3A51102
 */
export interface EgdsCheckBox {
  description?: Maybe<Scalars["String"]>;
  enabled: Scalars["Boolean"];
  errorMessage?: Maybe<Scalars["String"]>;
  label: EgdsText;
  name?: Maybe<Scalars["String"]>;
  required: Scalars["Boolean"];
  state: EgdsCheckBoxState;
  value?: Maybe<Scalars["String"]>;
}

/**
 * Represents collections of checkboxes describing a set of related options.
 * UITK react:
 * https://uitk.expedia.biz/expedia/en_US/components/checkbox
 * Figma:
 * https://www.figma.com/file/ifJBz5r2kKpXt6fhle0uWE/Checkbox
 */
export type EgdsCheckBoxGroup = {
  __typename?: "EGDSCheckBoxGroup";
  /** Represents checkbox group error message. */
  errorMessage?: Maybe<Scalars["String"]>;
  /** Represents the name for the checkbox group. It will be used as the name for each child component. */
  groupName: Scalars["String"];
  /** Represents options for checkbox group. */
  options: Array<EgdsCheckBox>;
};

/** Defines how checkbox state should be displayed on client. */
export type EgdsCheckBoxState = "CHECKED" | "INDETERMINATE" | "UNCHECKED";

/**
 * A text element or section of text that can be used to structure text content.
 * Examples include paragraphs, ordered/unordered lists, headings, and sections containing other text elements.
 */
export type EgdsComposableTextElement =
  | EgdsBulletedList
  | EgdsComposableTextElementSectionContainer
  | EgdsGraphicText
  | EgdsHeading
  | EgdsIconText
  | EgdsInlineLink
  | EgdsLinkList
  | EgdsOrderedList
  | EgdsParagraph
  | EgdsPlainText
  | EgdsSpannableText
  | EgdsStandardLink
  | EgdsStylizedText
  | EgdsTextIconList
  | EgdsTextListSection
  | EgdsTextSection
  | EgdsUnorderedList;

/**
 * This should only be used in unique design cases where the UX changes frequently and specific product requirements must be met.
 * Most teams should just use Strings.
 *
 * Contains other EGDSComposableTextElements such paragraphs, ordered/unordered lists, headings, and sections containing other text elements.
 */
export interface EgdsComposableTextElementContainer {
  elements: Array<EgdsComposableTextElement>;
}

/**
 * This should only be used in unique design cases where the UX changes frequently and specific product requirements must be met.
 * Most teams should just use Strings.
 *
 * Groups text content and is composed of sections for the heading and body
 */
export type EgdsComposableTextElementSectionContainer = EgdsComposableTextElementContainer &
  EgdsElement & {
    __typename?: "EGDSComposableTextElementSectionContainer";
    egdsElementId?: Maybe<Scalars["String"]>;
    elements: Array<EgdsComposableTextElement>;
    heading?: Maybe<EgdsSectionHeading>;
  };

/**
 * Represents localized text consisting of multiple localized text fragments.  This is important, as grammar and
 * syntax is different from language to language and simply concatenating two localized strings together often
 * doesn't work.
 * Example: `{rooms}, {travelers}`, where `rooms` is a localized string, such as `{num} rooms` and
 * `travelers` is a localized string, such as `{num} travelers`
 */
export type EgdsCompositeLocalizedText = EgdsElement &
  EgdsText & {
    __typename?: "EGDSCompositeLocalizedText";
    egdsElementId?: Maybe<Scalars["String"]>;
    /** Provide a list of composite models. */
    models: Array<CompositeLocalizedTextModel>;
    /** Provide a template string.  Example:  `{rooms}, {travelers}` */
    template: Scalars["String"];
    /** Provide a default value */
    text: Scalars["String"];
  };

/** Provide datepicker configuration to create calendar for date selection. */
export interface EgdsDatePicker {
  /**
   * Text for full-width Floating Button at bottom of date picker.
   * The button is used for completing user's selection and closing date picker.
   * Example: "Done"
   */
  buttonText: Scalars["String"];
  /**
   * Text for clear dates button.
   * The button is used for clearing user's selection date picker.
   * Example: "Clear dates"
   */
  clearButtonText?: Maybe<Scalars["String"]>;
  /** Provides a value format for the date fields. Example: 'yyyy-MM-dd' */
  dateFormat: Scalars["String"];
  /** Content to display themed text below each date (ie. price levels). */
  datePickerContent?: Maybe<Array<EgdsDatePickerContent>>;
  /**
   * Represents the first date of the week in the datepicker. Example: 'SUN'
   * More details on UITK:
   * http://uitk.expedia.biz/expedia/en_US/components/date-picker#datepicker
   */
  firstDayOfWeek: EgdsDayName;
  /** Provides a text value for the footer i.e. legal disclaimer */
  footerText?: Maybe<Scalars["String"]>;
  /**
   * If non-null a start date will be preselected when you open the date picker.
   * If null no start date will be selected and startDatePlaceholderText will be shown.
   */
  selectedStartDate?: Maybe<Date>;
  /** Boolean to show or hide the clear dates button. */
  showClearDatesButton?: Maybe<Scalars["Boolean"]>;
  /**
   * Shown when user has not yet selected a start date.
   * Example: "Start date"
   */
  startDatePlaceholderText: Scalars["String"];
  /**
   * The first date where a selection is allowed.
   * For example if you want to prohibit selecting dates in the past you can set this value to today's date.
   */
  validDaysLowerBoundInclusive?: Maybe<Date>;
  /** The last date where a selection is allowed. */
  validDaysUpperBoundInclusive?: Maybe<Date>;
}

/** Date picker content to display themed text below each date (ie. price levels). */
export type EgdsDatePickerContent = {
  __typename?: "EGDSDatePickerContent";
  /** Accessibility text for screen readers. */
  accessibility?: Maybe<Scalars["String"]>;
  /** Date (ie. 'yyyy-MM-dd') as key value for content object. */
  dateKey: Scalars["String"];
  /** Text content displayed below date. */
  text?: Maybe<Scalars["String"]>;
  /** Theme to stylized the text. */
  theme?: Maybe<Scalars["String"]>;
};

export type EgdsDatePickerInputField = EgdsInputField & {
  __typename?: "EGDSDatePickerInputField";
  /** Provides a value format for the date fields */
  dateFormat?: Maybe<Scalars["String"]>;
  errorMessage?: Maybe<Scalars["String"]>;
  instructions?: Maybe<Scalars["String"]>;
  label?: Maybe<Scalars["String"]>;
  labelTemplate?: Maybe<EgdsLocalizedText>;
  leftIcon?: Maybe<Icon>;
  placeholder?: Maybe<Scalars["String"]>;
  readOnly: Scalars["Boolean"];
  required?: Maybe<Scalars["Boolean"]>;
  rightIcon?: Maybe<Icon>;
  validations?: Maybe<Array<EgdsInputValidation>>;
  value?: Maybe<Scalars["String"]>;
};

/**
 * Date range shows users a combination of date + price across a range.
 * Figma - https://www.figma.com/file/SDEOy83IJfedgYoCf4ixSY/Date-range?node-id=2312%3A24
 */
export interface EgdsDateRange {
  /** String added to the component to audibly convey that the component is loading. */
  loadingMessage?: Maybe<Scalars["String"]>;
  /** An array of date + price results to display in the Date Range component. */
  results: Array<EgdsDateRangeResult>;
}

export type EgdsDateRangePicker = EgdsDatePicker & {
  __typename?: "EGDSDateRangePicker";
  buttonText: Scalars["String"];
  clearButtonText?: Maybe<Scalars["String"]>;
  dateFormat: Scalars["String"];
  datePickerContent?: Maybe<Array<EgdsDatePickerContent>>;
  /**
   * Shown when user has not yet selected an end date.
   * Example: "End date"
   */
  endDatePlaceholderText: Scalars["String"];
  firstDayOfWeek: EgdsDayName;
  footerText?: Maybe<Scalars["String"]>;
  /**
   * If non-null the maximum number of days that a date range selection can contain.
   * Example use case: A hotel stay can be no longer than <maxNumberOfDaysSelected> days.
   */
  maxNumberOfDaysSelected?: Maybe<Scalars["Int"]>;
  /** Used to capture client side analytics when user clicks next month in calendar. */
  nextButtonAnalytics?: Maybe<ClientSideAnalytics>;
  /** Used to capture client side analytics when user clicks previous month in calendar. */
  previousButtonAnalytics?: Maybe<ClientSideAnalytics>;
  /**
   * If true start and end date can be the same.
   * If false start and end date must be different.
   * Example use case: False for hotels when overnight stays required.
   * Example use case: True for flights that allow departure and arrival date to be the same.
   */
  sameDaySelectionAllowed: Scalars["Boolean"];
  /**
   * If non-null an end date will be preselected when date picker is opened.
   * If null no end date will be selected and endDatePlaceholderText will be shown.
   */
  selectedEndDate?: Maybe<Date>;
  selectedStartDate?: Maybe<Date>;
  showClearDatesButton?: Maybe<Scalars["Boolean"]>;
  startDatePlaceholderText: Scalars["String"];
  validDaysLowerBoundInclusive?: Maybe<Date>;
  validDaysUpperBoundInclusive?: Maybe<Date>;
};

/** Date and price results to display in the Date Range component. */
export interface EgdsDateRangeResult {
  /** The message a screen reader would announce when result has focus. */
  accessibility?: Maybe<Scalars["String"]>;
  analytics?: Maybe<ClientSideAnalytics>;
  /** For displaying the date. */
  date: Date;
  /** Text label typically used for displaying the price. */
  label: Scalars["String"];
  /** Theme used to decorate the text label. */
  theme?: Maybe<EgdsDateRangeResultTheme>;
}

/** Represents the label theme for the date range result. */
export type EgdsDateRangeResultTheme = "LINK" | "POSITIVE";

/** Represents short day name. */
export type EgdsDayName = "FRI" | "MON" | "SAT" | "SUN" | "THU" | "TUE" | "WED";

/** Represents the type of decorative in the text element. e.g. superscript */
export type EgdsDecorativeText =
  /** Renders with a line through the text */
  | "LINE_THROUGH"
  /** Renders as a subscript at the bottom of the text line */
  | "SUBSCRIPT"
  /** Renders as a superscript at the top of the text line */
  | "SUPERSCRIPT"
  /** Renders with a line under the text */
  | "UNDERLINE";

/**
 * A symbolic representation of a detailed gallery view with various types of media like images, videos, etc.
 * https://www.figma.com/file/C4hYbY2GxNUEDa2b09kdc2/Media-gallery?node-id=1131%3A479
 */
export interface EgdsDetailMediaGallery {
  /** Accessibility text for the closing the dialog */
  closeText: Scalars["String"];
  /** List of media including images or videos in the gallery */
  mediaItems: Array<MediaItem>;
  /** Accessibility text for next button on a carousel */
  nextButtonText?: Maybe<Scalars["String"]>;
  /** Accessibility text for previous button on a carousel */
  previousButtonText?: Maybe<Scalars["String"]>;
}

/**
 * Dialogs are containers that content can be rendered in. Clients should orchestrate how content
 * will render within the dialog.
 *
 * https://www.figma.com/file/KqOeuNsfHUNAgd4johSxsh/Dialog
 */
export interface EgdsDialog {
  closeAnalytics?: Maybe<ClientSideAnalytics>;
}

/** Dialog footers provide one or more buttons for users to take action upon */
export interface EgdsDialogFooter {
  buttons: Array<EgdsButton>;
}

/** Dialog toolbars provide a title for the dialog and optional accessibility text for a dialog's close icon */
export type EgdsDialogToolbar = {
  __typename?: "EGDSDialogToolbar";
  closeText?: Maybe<Scalars["String"]>;
  title: Scalars["String"];
};

/** Represents an action to dismiss the component */
export type EgdsDismissAction = {
  __typename?: "EGDSDismissAction";
  accessibility?: Maybe<Scalars["String"]>;
  analytics: ClientSideAnalytics;
  label?: Maybe<Scalars["String"]>;
};

/** configuration to set up dynamic map */
export type EgdsDynamicMapConfig = EgdsBaseMapConfig & {
  __typename?: "EGDSDynamicMapConfig";
  /** access token used with the provider */
  accessToken: Scalars["String"];
  /** @deprecated Prefer using data provided by EGDSDynamicMapConfig and not the one from this object */
  config?: Maybe<MapConfiguration>;
  /** map provider used by the map */
  egdsMapProvider: EgdsMapProvider;
  /** eg maps config service endpoint used to retrieve the configuration */
  externalConfigEndpoint?: Maybe<HttpUri>;
  /** map id to use which will override the egds map id token */
  mapId?: Maybe<Scalars["String"]>;
};

/**
 * UI Element that is compliant with EGDS Component designs.
 * It is intended to be implemented by UIComposableElement, a union for shared EGDS Component models,
 * and candidates for UIComposableElement that are initially limited to an individual spinner's scope
 * to establish viability before being shared with other spinners as a member of UIComposableElement
 */
export interface EgdsElement {
  /**
   * Element unique identifier. Uses include handling diffs for UI updates
   * and identifying the source of data for user input fields
   */
  egdsElementId?: Maybe<Scalars["String"]>;
}

/** Represents a wrapper for the EGDSElement to be rendered in a Credit Selection element */
export type EgdsElementWrapper = {
  __typename?: "EGDSElementWrapper";
  /** An EGDSElement to be rendered */
  element: EgdsElement;
};

/** Implementations may include UI structures, layout templates, or view hierarchies. */
export interface EgdsElements {
  elements: Array<EgdsElement>;
}

/** Represents an email input filed element with autofill property */
export type EgdsEmailInputField = EgdsElement &
  EgdsInputField & {
    __typename?: "EGDSEmailInputField";
    /** Autofill hint for the input value */
    autofill?: Maybe<Scalars["String"]>;
    egdsElementId?: Maybe<Scalars["String"]>;
    errorMessage?: Maybe<Scalars["String"]>;
    instructions?: Maybe<Scalars["String"]>;
    label: Scalars["String"];
    labelTemplate?: Maybe<EgdsLocalizedText>;
    leftIcon?: Maybe<Icon>;
    placeholder?: Maybe<Scalars["String"]>;
    readOnly: Scalars["Boolean"];
    required?: Maybe<Scalars["Boolean"]>;
    rightIcon?: Maybe<Icon>;
    validations?: Maybe<Array<EgdsInputValidation>>;
    value?: Maybe<Scalars["String"]>;
  };

/** Display summarized view of error when user has submitted the form with error in it. */
export type EgdsErrorSummary = EgdsElement & {
  __typename?: "EGDSErrorSummary";
  /** Information for capturing client side analytics event for error link clicks */
  analytics?: Maybe<ClientSideAnalytics>;
  /** Description of error message below the heading */
  body?: Maybe<EgdsText>;
  egdsElementId?: Maybe<Scalars["String"]>;
  /** Display link text when there's one error */
  goToErrorLinkText?: Maybe<Scalars["String"]>;
  /** Display link text when there's more than one error */
  goToFirstErrorLinkText?: Maybe<Scalars["String"]>;
  /** Represents main error message */
  heading: Scalars["String"];
  /** Display text with specified number of errors */
  headingTemplate?: Maybe<EgdsLocalizedText>;
  /** Information for capturing client side impression analytics event for error summary */
  impressionAnalytics?: Maybe<ClientSideImpressionEventAnalytics>;
};

/**
 * Representation of an item in an EGDS expando
 *
 * https://www.figma.com/file/IDIEwURk3g9LQmSHdTjj0R/Expandos
 */
export interface EgdsExpando {
  /** Analytics for when the expando is selected to collapse */
  collapseAnalytics?: Maybe<ClientSideAnalytics>;
  /** Button label when the expando is collapsed */
  collapsedLabel: Scalars["String"];
  /** Analytics for when the expando is selected to expand */
  expandAnalytics?: Maybe<ClientSideAnalytics>;
  /** Flag to indicate if the component is to be expanded by default */
  expanded: Scalars["Boolean"];
  /** Button label when the expando is expanded */
  expandedLabel: Scalars["String"];
}

/**
 * Representation of an expando card
 *
 * https://www.figma.com/file/IDIEwURk3g9LQmSHdTjj0R/Expandos
 */
export type EgdsExpandoCard = EgdsExpando & {
  __typename?: "EGDSExpandoCard";
  collapseAnalytics?: Maybe<ClientSideAnalytics>;
  collapsedLabel: Scalars["String"];
  expandAnalytics?: Maybe<ClientSideAnalytics>;
  expanded: Scalars["Boolean"];
  expandedLabel: Scalars["String"];
  /** The text shown below the title */
  subtitle?: Maybe<Scalars["String"]>;
  /** the position of the trigger icon to expand/collapse */
  triggerPosition?: Maybe<ExpandoTriggerPosition>;
};

/**
 * Representation of an expando link
 *
 * https://www.figma.com/file/IDIEwURk3g9LQmSHdTjj0R/Expandos
 */
export type EgdsExpandoLink = EgdsExpando & {
  __typename?: "EGDSExpandoLink";
  collapseAnalytics?: Maybe<ClientSideAnalytics>;
  collapsedLabel: Scalars["String"];
  expandAnalytics?: Maybe<ClientSideAnalytics>;
  expanded: Scalars["Boolean"];
  expandedLabel: Scalars["String"];
};

/**
 * Representation of an item in an expando list
 *
 * https://www.figma.com/file/IDIEwURk3g9LQmSHdTjj0R/Expandos
 */
export type EgdsExpandoListItem = EgdsExpando & {
  __typename?: "EGDSExpandoListItem";
  collapseAnalytics?: Maybe<ClientSideAnalytics>;
  collapsedLabel: Scalars["String"];
  expandAnalytics?: Maybe<ClientSideAnalytics>;
  expanded: Scalars["Boolean"];
  expandedLabel: Scalars["String"];
  /** the position of the trigger icon to expand/collapse */
  triggerPosition?: Maybe<ExpandoTriggerPosition>;
};

/**
 * Representation of an expando peek
 *
 * https://www.figma.com/file/IDIEwURk3g9LQmSHdTjj0R/Expandos
 */
export type EgdsExpandoPeek = EgdsExpando & {
  __typename?: "EGDSExpandoPeek";
  collapseAnalytics?: Maybe<ClientSideAnalytics>;
  /** Button accessibility when the expando is collapsed */
  collapsedAccessibilityText?: Maybe<Scalars["String"]>;
  collapsedLabel: Scalars["String"];
  expandAnalytics?: Maybe<ClientSideAnalytics>;
  expanded: Scalars["Boolean"];
  /** Button accessibility when the expando is expanded */
  expandedAccessibilityText?: Maybe<Scalars["String"]>;
  expandedLabel: Scalars["String"];
  /**
   * How many items (list, radio group etc) to show in the visible part of expando peek.
   * Note: The composition of any item(s) can only be a maximum of one level deep i.e. parent > children or <>children
   */
  items?: Maybe<Scalars["Int"]>;
  /** How many lines of text to show in the visible part of expando peek */
  lines?: Maybe<Scalars["Int"]>;
  /**
   * The height of the expando peek in its collapsed state
   * @deprecated Removed after EGDS graduated of Expando. Replace with `lines` or `items`.
   */
  minimalHeight?: Maybe<Scalars["Int"]>;
  /**
   * Height of the content must be greater than for the Expando Peek to become active
   * @deprecated Removed after EGDS graduated of Expando.
   */
  threshold?: Maybe<Scalars["Int"]>;
};

/**
 * Action dialogs are containers that content can be rendered in. Clients should orchestrate how content
 * will render within the dialog. Full screen dialogs can be used for more complex or dynamic content.
 * They include a toolbar with a close icon and dialog title.
 *
 * https://www.figma.com/file/XOdo8BowxO8VACXdesonOZ/Full-screen-dialogs?node-id=0%3A1
 */
export type EgdsFullScreenDialog = EgdsDialog & {
  __typename?: "EGDSFullScreenDialog";
  closeAnalytics?: Maybe<ClientSideAnalytics>;
  toolbar: EgdsDialogToolbar;
};

/**
 * A symbolic representation of a carousel various types of media like images, videos, etc.
 * https://www.figma.com/file/0fHu4QkH2E0t4GkYMif7ky/Carousel-gallery
 */
export interface EgdsGalleryCarousel {
  /** Accessibility text for the carousel */
  accessibilityHeadingText: Scalars["String"];
  /** List of media including images or videos in the carousel */
  media: Array<MediaItem>;
  /** Accessibility text for next button on a carousel */
  nextButtonText?: Maybe<Scalars["String"]>;
  /** Accessibility text for previous button on a carousel */
  previousButtonText?: Maybe<Scalars["String"]>;
}

/** Represents a EGDS graphic menu */
export type EgdsGraphicMenu = EgdsMenu & {
  __typename?: "EGDSGraphicMenu";
  accessibility?: Maybe<Scalars["String"]>;
  analytics?: Maybe<ClientSideAnalytics>;
  disabled: Scalars["Boolean"];
  /** Represents the graphics used in the menu */
  graphic: UiGraphic;
  subMenus: Array<EgdsSubMenu>;
  title: Scalars["String"];
};

/** Represents a text a graphic element, icon or mark or ilustration */
export type EgdsGraphicText = EgdsText & {
  __typename?: "EGDSGraphicText";
  graphic: UiGraphic;
  text: Scalars["String"];
  /** Represents a list of trailing graphics to be rendered after the text */
  trailingGraphics?: Maybe<Array<UiGraphic>>;
};

/** Used to represent a heading of text with different EGDS typography styles. */
export type EgdsHeading = EgdsElement &
  EgdsText & {
    __typename?: "EGDSHeading";
    /** Use this field when accessibility text needs to be different from text */
    accessibility?: Maybe<Scalars["String"]>;
    egdsElementId?: Maybe<Scalars["String"]>;
    /** Advanced feature. Only need for specific uses. See EGDSHeadingStyle description */
    headingType?: Maybe<EgdsHeadingStyle>;
    text: Scalars["String"];
  };

/**
 * This should only be used in unique design cases where the UX changes frequently and specific product requirements must be met.
 * Most teams should just use String over EGDSHeading or EGDSText.
 *
 * https://www.figma.com/file/IHAiPyllJIlO6g4f2qdNW4zq/Typography
 */
export type EgdsHeadingStyle = "H1" | "H2" | "H3" | "H4" | "H5" | "H6" | "H7" | "H8";

/** Represents where the icon should be places in a EGDS Standard Link */
export type EgdsIconPosition = "LEADING" | "TRAILING";

/** A symbolic representation that communicates rating values in a 0.5 to 5.0 rating system using icons */
export type EgdsIconRating = EgdsRating & {
  __typename?: "EGDSIconRating";
  accessibility?: Maybe<Scalars["String"]>;
  icon: Icon;
  rating: Scalars["Float"];
};

/** Represents icon and text */
export type EgdsIconText = EgdsText & {
  __typename?: "EGDSIconText";
  icon: Icon;
  text: Scalars["String"];
};

/**
 * Represents card with an image and text.
 * figma: https://www.figma.com/file/M3udFrUojCRwrcoAiPnQ3Yaw/Card?node-id=474%3A114
 */
export type EgdsImageCard = {
  __typename?: "EGDSImageCard";
  /** Description to display on the card, e.g. description of a point of interest */
  description?: Maybe<Scalars["String"]>;
  /** id used to match a card with a corresponding property/place id of a map feature */
  id?: Maybe<Scalars["String"]>;
  /** Image to display on the card */
  image?: Maybe<Image>;
  /** Subtitle to display on the card, e.g. distance from property */
  subTitle?: Maybe<Scalars["String"]>;
  /** Title to display on the card, e.g. property name, point of interest */
  title?: Maybe<Scalars["String"]>;
};

/** Represents an EGDS Image Link */
export type EgdsImageLink = EgdsElement & {
  __typename?: "EGDSImageLink";
  /** Represents the action to perform when the image is selected */
  action: UiLinkAction;
  egdsElementId?: Maybe<Scalars["String"]>;
  /** Display image that when selected performs an action */
  image: Image;
};

/**
 * Represents card with Image, text and link.
 * figma: https://www.figma.com/file/M3udFrUojCRwrcoAiPnQ3Yaw/Card?node-id=474%3A114
 */
export type EgdsImageLinkCard = EgdsElement & {
  __typename?: "EGDSImageLinkCard";
  description?: Maybe<Scalars["String"]>;
  egdsElementId?: Maybe<Scalars["String"]>;
  link: EgdsImageLink;
  subTitle?: Maybe<Scalars["String"]>;
  title?: Maybe<Scalars["String"]>;
};

/** Option for selecting an infant seat on a plane. */
export type EgdsInfantSeat = "IN_SEAT" | "ON_LAP";

/** Radio button for selecting an infant seat on a plane. */
export type EgdsInfantSeatRadioButton = EgdsElement &
  EgdsRadioButton & {
    __typename?: "EGDSInfantSeatRadioButton";
    description?: Maybe<Scalars["String"]>;
    disabled: Scalars["Boolean"];
    egdsElementId?: Maybe<Scalars["String"]>;
    label: Scalars["String"];
    labelSuffix?: Maybe<Scalars["String"]>;
    seatType: EgdsInfantSeat;
    value: Scalars["String"];
  };

/** Inline dialog footers provide one or more buttons displayed in an inline orientation for users to respond to the dialog */
export type EgdsInlineDialogFooter = EgdsDialogFooter & {
  __typename?: "EGDSInlineDialogFooter";
  buttons: Array<EgdsButton>;
};

/** Represents an EGDS Inline Link */
export type EgdsInlineLink = EgdsText & {
  __typename?: "EGDSInlineLink";
  action: UiLinkAction;
  /** Display disabled link state. */
  disabled: Scalars["Boolean"];
  /** Display size of the link. */
  size: EgdsLinkSize;
  text: Scalars["String"];
};

/** Allows users to enter text-based information of various kinds such as destinations, credit cards, passwords, phones, etc */
export interface EgdsInputField {
  /** Text to be displayed as error text when the input field is in an invalid state. */
  errorMessage?: Maybe<Scalars["String"]>;
  instructions?: Maybe<Scalars["String"]>;
  label?: Maybe<Scalars["String"]>;
  /** Used to dynamically update the label text in the client, based on user interaction with the input. */
  labelTemplate?: Maybe<EgdsLocalizedText>;
  leftIcon?: Maybe<Icon>;
  placeholder?: Maybe<Scalars["String"]>;
  /** Field is in a read-only state displaying only text when readOnly is true. */
  readOnly: Scalars["Boolean"];
  required?: Maybe<Scalars["Boolean"]>;
  rightIcon?: Maybe<Icon>;
  /**
   * Validations with corresponding error messages to display if the input is invalid.
   * The order in which the validations appears indicates the order of priority of which error message to display.
   */
  validations?: Maybe<Array<EgdsInputValidation>>;
  value?: Maybe<Scalars["String"]>;
}

/** Used with input fields to specify validations that are attached to it */
export interface EgdsInputValidation {
  /**
   * The content of the error message may depend on the input or other factors,
   * in which case implementations may need to add additional field/s
   * or the structure the response in a way that allows for the appropriate message,
   * and this would serve as the default error message.
   */
  errorMessage: Scalars["String"];
}

/** EGDS Level list */
export type EgdsLevelList = {
  __typename?: "EGDSLevelList";
  items: Array<EgdsLevelListItem>;
};

/** EGDS Level list item */
export type EgdsLevelListItem = {
  __typename?: "EGDSLevelListItem";
  level: Scalars["Int"];
  text: EgdsText;
  type: EgdsTextListType;
};

/** Represents a list of EGDS Standard Links */
export type EgdsLinkList = EgdsElement & {
  __typename?: "EGDSLinkList";
  egdsElementId?: Maybe<Scalars["String"]>;
  listItems: Array<EgdsStandardLink>;
};

/** Represents the size of the text in a EGDS Standard Link */
export type EgdsLinkSize = "LARGE" | "MEDIUM" | "SMALL";

/** DEPRECATED: This interface allows for noncompliance to EGDS. */
export interface EgdsList {
  /** @deprecated This field allows for noncompliance to EGDS. Use EGDSTextList instead */
  items: Array<EgdsText>;
}

/**
 * Loader dialogs are containers that content can be rendered in. Clients should orchestrate how content
 * will render within the dialog. Loader dialogs open when content is actively loading and content
 * needs to communicate some interstitial content.
 *
 * https://www.figma.com/file/KqOeuNsfHUNAgd4johSxsh/Dialog
 */
export type EgdsLoaderDialog = EgdsDialog & {
  __typename?: "EGDSLoaderDialog";
  closeAnalytics?: Maybe<ClientSideAnalytics>;
};

/**
 * Represents a localization template for text.
 * It is required when client side interpolation has placeholder values: Example: `Room {roomIndex}`
 * In above example value of roomIndex will replaced by clients.
 */
export type EgdsLocalizedText = EgdsBasicLocalizedText | EgdsCardinalLocalizedText | EgdsCompositeLocalizedText;

/**
 * Represents a localization template for text.
 * It is required when client side interpolation has placeholder values: Example: 'Room {roomIndex}'
 * In above example value of roomIndex will replaced by clients.
 */
export type EgdsLocalizedTextTemplate = EgdsElement &
  EgdsText & {
    __typename?: "EGDSLocalizedTextTemplate";
    egdsElementId?: Maybe<Scalars["String"]>;
    /** Localized string with tokens interpolated. Example: 'Room {roomIndex}' */
    template: Scalars["String"];
    /** Provide default localized string. Example: 'Room 1' */
    text: Scalars["String"];
    /** Replaceable placeholder. Example:in 'Room {roomIndex}' the 'roomIndex' is token. Clients should know the token in advance. */
    token: Scalars["String"];
  };

/**
 * Represents a loyalty badge
 *
 * https://www.figma.com/file/aYQZVH6x5kqAGj8LbLzTVWfX/Badges
 */
export type EgdsLoyaltyBadge = EgdsBadge &
  EgdsElement & {
    __typename?: "EGDSLoyaltyBadge";
    accessibility?: Maybe<Scalars["String"]>;
    egdsElementId?: Maybe<Scalars["String"]>;
    graphic?: Maybe<UiGraphic>;
    size?: Maybe<Scalars["String"]>;
    text?: Maybe<Scalars["String"]>;
    theme?: Maybe<Scalars["String"]>;
  };

/** Two latitude/longitude pairs to defined southwest and northeast points defining a bbox */
export type EgdsMapBounds = {
  __typename?: "EGDSMapBounds";
  /** The coordinates for the northeast point */
  northeast: Coordinates;
  /** The coordinates for the southwest point */
  southwest: Coordinates;
};

/** Options used to compute the initial viewport for the map with specified center coordinate */
export type EgdsMapCenteredBoundsOptions = {
  __typename?: "EGDSMapCenteredBoundsOptions";
  /** Coordinates of the center point of the computed bounds */
  centeredOn: Coordinates;
  /** List of coordinates used to compute the bounds */
  coordinates: Array<Coordinates>;
};

/** Options used to compute the initial viewport for the map */
export type EgdsMapComputedBoundsOptions = {
  __typename?: "EGDSMapComputedBoundsOptions";
  /** List of coordinates used to computed the bounds */
  coordinates: Array<Coordinates>;
  /** a gaia identifier used to identify the location. will be use for historical bounding box */
  gaiaId?: Maybe<Scalars["String"]>;
  /** Interpolation ratio */
  interpolationRatio?: Maybe<Scalars["Float"]>;
  /** The lower quantile for pin outlier exclusion */
  lowerQuantile?: Maybe<Scalars["Float"]>;
  /** A multiplier for the quantile range */
  marginMultiplier?: Maybe<Scalars["Float"]>;
  /** minimum margin added to the pins when computing the bounding box */
  minMargin?: Maybe<Scalars["Int"]>;
  /** Minimum number of pins for bounding box interpolation calculation */
  minimumPins?: Maybe<Scalars["Int"]>;
  /** The upper quantile for pin outlier exclusion */
  upperQuantile?: Maybe<Scalars["Float"]>;
};

export interface EgdsMapDialog {
  /** Dialog definition */
  dialog?: Maybe<EgdsFullScreenDialog>;
  placesDialogEGDSTextsContentSection?: Maybe<PlacesDialogEgdsTextsContentSection>;
  placesDialogTextInputFieldContentSection?: Maybe<PlacesDialogTextInputFieldContentSection>;
  placesDialogTypeAheadContentSection?: Maybe<PlacesDialogTypeAheadContentSection>;
  placesDialogUITogglesContentSection?: Maybe<PlacesDialogUiTogglesContentSection>;
  /** Button that would trigger the MapDialog on click */
  trigger?: Maybe<EgdsOverlayButton>;
}

/**
 * type EGDSMapFeature contains additional fields to define the
 * appearance of the Marker
 * Figma - figma - https://www.figma.com/file/X31Tc9cWj9lbSKQCznru5M/Maps?node-id=0%3A1
 */
export type EgdsMapFeature = EgdsMapMarker & {
  __typename?: "EGDSMapFeature";
  clientSideAnalytics?: Maybe<ClientSideAnalytics>;
  /** description of the feature */
  description?: Maybe<Scalars["String"]>;
  /** unique identifier for the feature */
  id?: Maybe<Scalars["String"]>;
  markerIconType?: Maybe<Array<Scalars["String"]>>;
  markerPosition: Coordinates;
  markerStatus?: Maybe<EgdsMapMarkerStatus>;
  markerType?: Maybe<Scalars["String"]>;
  /** name of the feature */
  name?: Maybe<Scalars["String"]>;
  /** accessibility message for onEnter event */
  onEnterAccessibilityMessage?: Maybe<Scalars["String"]>;
  /** accessibility message for onSelect event */
  onSelectAccessibilityMessage?: Maybe<Scalars["String"]>;
  /** property price to display on the feature */
  price?: Maybe<Scalars["Float"]>;
  /** list of qualifiers to configure the icons using css class names */
  qualifiers: Array<Scalars["String"]>;
  /** supports popularity prioritization of features */
  score?: Maybe<Scalars["Float"]>;
  text?: Maybe<Scalars["String"]>;
  type?: Maybe<EgdsMapFeatureType>;
};

/** The type of feature - PLACE OR PROPERTY */
export type EgdsMapFeatureType = "PLACE" | "PROPERTY";

/** The initial viewport to use for the map when markers have been pushed and just before they are rendered */
export type EgdsMapInitialViewport =
  /** To use bounds value as initial viewport */
  | "BOUNDS"
  /** To compute a bound from a set of options with a specified center */
  | "CENTERED_COMPUTED_BOUNDS"
  /** To use zoom and center values as initial viewport */
  | "CENTER_AND_ZOOM"
  /** To compute a bound from a set of options */
  | "COMPUTED_BOUNDS"
  /** Will center the map to show all markers pushed to the map */
  | "FIT_MARKERS";

/**
 * type EGDSMapMarkers contains a set of fields to define the location
 *  and appearance of the pin
 * Figma - figma - https://www.figma.com/file/X31Tc9cWj9lbSKQCznru5M/Maps?node-id=0%3A1
 */
export interface EgdsMapMarker {
  /**
   * custom marker icons; attribute that differentiates a normal price/pin type of marker from a custom one UITK
   * For more information: http://uitk.expedia.biz/expedia/en_US/components/map#map_with_egds_icons
   */
  markerIconType?: Maybe<Array<Scalars["String"]>>;
  markerPosition: Coordinates;
  /**
   * marker status that controls different marker pin styles. For example: available, unknown, sold_out, and filtered
   * For more information: http://uitk.expedia.biz/expedia/en_US/components/map#map_with_egds_icons
   */
  markerStatus?: Maybe<EgdsMapMarkerStatus>;
  /**
   * default marker icon for UITK
   * For more information: http://uitk.expedia.biz/expedia/en_US/components/map#map_with_egds_icons
   */
  markerType?: Maybe<Scalars["String"]>;
  /** text right on the marker */
  text?: Maybe<Scalars["String"]>;
}

/** Marker pin style based on the applied filter and inventory - AVAILABLE, FILTERED, SOLD_OUT or UNKNOWN */
export type EgdsMapMarkerStatus = "AVAILABLE" | "FILTERED" | "SOLD_OUT" | "UNKNOWN";

/** 'zoomAndCenter' (requires zoom + center) or 'fitBounds' (map will include all rendered markers) */
export type EgdsMapPositionMode = "FIT_BOUNDS" | "ZOOM_AND_CENTER";

/** type of maps that can be used */
export type EgdsMapProvider = "GOOGLE" | "MAPBOX";

/** required for displaying the right marker style */
export type EgdsMarkerUrls = {
  __typename?: "EGDSMarkerUrls";
  /** marker type */
  type?: Maybe<Scalars["String"]>;
  /** marker style's url */
  url?: Maybe<Scalars["URL"]>;
};

/** Specifies the maximum length that an input needs. For datepicker it can be use to validate maximum number of days. */
export type EgdsMaxLengthInputValidation = EgdsInputValidation & {
  __typename?: "EGDSMaxLengthInputValidation";
  errorMessage: Scalars["String"];
  maxLength: Scalars["Int"];
};

/** EGDSCarouselItem implementation to support media carousel cards */
export type EgdsMediaCarouselItem = EgdsCarouselItem & {
  __typename?: "EGDSMediaCarouselItem";
  id?: Maybe<Scalars["String"]>;
  media: MediaItem;
};

/**
 * Representation of a EGDS menu
 *
 * https://www.figma.com/file/cwNPDX6N1XTWCBQTp2PQ0t/Menus?node-id=746%3A152
 *
 * UITK component defined at http://uitk.expedia.biz/expedia/en_US/components/menu"
 */
export interface EgdsMenu {
  /** Represents the accessibility text for the menu */
  accessibility?: Maybe<Scalars["String"]>;
  /** Used to capture client side analytics */
  analytics?: Maybe<ClientSideAnalytics>;
  /** User cannot interact with the menu when the disabled value is true. */
  disabled: Scalars["Boolean"];
  /** Represents the menu container */
  subMenus: Array<EgdsSubMenu>;
  /** Represents the title of the menu */
  title: Scalars["String"];
}

/** Represents a EGDS Menu icon items */
export type EgdsMenuListIconTextItem = EgdsMenuListItem & {
  __typename?: "EGDSMenuListIconTextItem";
  accessibility?: Maybe<Scalars["String"]>;
  analytics?: Maybe<ClientSideAnalytics>;
  /** Represents the graphics used in the menu list */
  graphic: UiGraphic;
  title: Scalars["String"];
};

/** Represents EGDS menu list item */
export interface EgdsMenuListItem {
  /** Represents the accessibility text for menu list item */
  accessibility?: Maybe<Scalars["String"]>;
  /** Used to capture client side analytics */
  analytics?: Maybe<ClientSideAnalytics>;
  /** Represents the menu list item title */
  title: Scalars["String"];
}

/** Represents a EGDS Menu text items */
export type EgdsMenuTextItem = EgdsMenuListItem & {
  __typename?: "EGDSMenuTextItem";
  accessibility?: Maybe<Scalars["String"]>;
  analytics?: Maybe<ClientSideAnalytics>;
  title: Scalars["String"];
};

/** Specifies the minimum length that an input needs */
export type EgdsMinLengthInputValidation = EgdsInputValidation & {
  __typename?: "EGDSMinLengthInputValidation";
  errorMessage: Scalars["String"];
  minLength: Scalars["Int"];
};

/** EGDS Nested list item with icon level one */
export type EgdsNestedLevelOneIconListItem = EgdsNestedLevelOneListItem & {
  __typename?: "EGDSNestedLevelOneIconListItem";
  icon: Icon;
  style?: Maybe<EgdsTextListItemStyle>;
  text: Scalars["String"];
};

/**
 * EGDS compliant nested list level one https://www.figma.com/file/IHAiPyllJIlO6g4f2qdNW4zq/Typography?node-id=11931%3A11857
 * Right now we are just adding level one as we don't have a use-case for further level, but we want to keep the schema extensible.
 */
export type EgdsNestedLevelOneList = {
  __typename?: "EGDSNestedLevelOneList";
  /** List of item within nested list (level one) */
  items: Array<EgdsNestedLevelOneListItem>;
  /**
   * Represents the size property of the EGDS List, As per figma the default size is LIST_2
   * figma: "https://www.figma.com/file/IHAiPyllJIlO6g4f2qdNW4zq/Typography?node-id=25%3A0"
   */
  size: EgdsTextListSize;
  /**
   * Represents the UI variation of the EGDS List
   * eg. BULLET, NO_BULLET, NUMBERED, ICON
   * figma: "https://www.figma.com/file/IHAiPyllJIlO6g4f2qdNW4zq/Typography?node-id=25%3A0"
   */
  type: EgdsTextListType;
};

/**
 * Nested list item (level one) with EGDS styles.
 * figma: https://www.figma.com/file/IHAiPyllJIlO6g4f2qdNW4zq/Typography?node-id=11931%3A11857")
 */
export interface EgdsNestedLevelOneListItem {
  /**
   * Represents the text style of EGDS List Item (Level one)
   * eg. EMPHASIS, POSITIVE, NEGATIVE etc
   */
  style?: Maybe<EgdsTextListItemStyle>;
  text: Scalars["String"];
}

/** EGDS Nested list item level one */
export type EgdsNestedLevelOneStandardListItem = EgdsNestedLevelOneListItem & {
  __typename?: "EGDSNestedLevelOneStandardListItem";
  style?: Maybe<EgdsTextListItemStyle>;
  text: Scalars["String"];
};

/** Represents a number input element */
export type EgdsNumberInputField = EgdsElement &
  EgdsInputField & {
    __typename?: "EGDSNumberInputField";
    /**
     * Element unique identifier. Uses include handling diffs for UI updates
     * and identifying the source of data for user input fields.
     */
    egdsElementId?: Maybe<Scalars["String"]>;
    /** Text to be displayed as error text when the input field is in an invalid state. */
    errorMessage?: Maybe<Scalars["String"]>;
    /** Detailed instructions to the user on how to use the input element. */
    instructions?: Maybe<Scalars["String"]>;
    /** Text for the label element. */
    label?: Maybe<Scalars["String"]>;
    /** Used to dynamically update the label text in the client, based on user interaction with the input. */
    labelTemplate?: Maybe<EgdsLocalizedText>;
    /** Icon to be positioned to the left side of the input element. */
    leftIcon?: Maybe<Icon>;
    /** Maximum value that can be entered for the input. */
    max?: Maybe<Scalars["Float"]>;
    /** Minimum value that can be entered for the input. */
    min?: Maybe<Scalars["Float"]>;
    /** Placeholder text for the input element. */
    placeholder?: Maybe<Scalars["String"]>;
    /** Determines if the input element should be readonly. */
    readOnly: Scalars["Boolean"];
    /** Informs the user if the field is mandatory. Sets the aria-required label for the field. */
    required?: Maybe<Scalars["Boolean"]>;
    /** Icon to be positioned to the right side of the input element. */
    rightIcon?: Maybe<Icon>;
    /** Interval number for the number input element. */
    step?: Maybe<Scalars["Float"]>;
    /**
     * Validations with corresponding error messages to display if the input is invalid.
     * The order in which the validations appears indicates the order of priority of which error message to display.
     */
    validations?: Maybe<Array<EgdsInputValidation>>;
    /** Value for the input element. */
    value?: Maybe<Scalars["String"]>;
  };

/**
 * Action for opening date picker modal.
 * The will work for native apps but not for UITK DatePicker because UITK couples the date picker with date input fields.
 * For UITK DatePicker use EGDSCompositeDatePicker.
 */
export type EgdsOpenDatePickerAction = UiAction & {
  __typename?: "EGDSOpenDatePickerAction";
  accessibility?: Maybe<Scalars["String"]>;
  analytics: ClientSideAnalytics;
  /** Date picker to open. */
  datePicker: EgdsDatePicker;
};

/**
 * Action for opening traveler selector.
 * figma:
 * https://www.figma.com/file/y59aHUdrzsZBTg5RfbaZ9h/Traveler-selector?node-id=67%3A51
 */
export type EgdsOpenTravelerSelectorAction = UiAction & {
  __typename?: "EGDSOpenTravelerSelectorAction";
  accessibility?: Maybe<Scalars["String"]>;
  analytics: ClientSideAnalytics;
  /** Traveler selector configuration. */
  travelerSelector: EgdsTravelerSelector;
};

/** Used to define an item contained in a html <select> element. */
export interface EgdsOption {
  /** The text visible on screen. */
  label: Scalars["String"];
  /** Default selection for value. */
  selected?: Maybe<Scalars["Boolean"]>;
  /** It is associated with label. It corresponds to html option tag value attribute. */
  value: Scalars["String"];
}

/** Ordered variant of EGDS typography list */
export type EgdsOrderedList = EgdsElement &
  EgdsList &
  EgdsTextList & {
    __typename?: "EGDSOrderedList";
    egdsElementId?: Maybe<Scalars["String"]>;
    /** @deprecated This field allows for noncompliance to EGDS. Use EGDSTextList instead */
    items: Array<EgdsText>;
    listItems: Array<EgdsTextListItem>;
    size?: Maybe<EgdsTextListSize>;
  };

/** Use this button to let users take an alternative, supplemental, or less important action for an overlay button style. */
export type EgdsOverlayButton = EgdsButton &
  EgdsElement & {
    __typename?: "EGDSOverlayButton";
    accessibility?: Maybe<Scalars["String"]>;
    action?: Maybe<UiLinkAction>;
    analytics?: Maybe<ClientSideAnalytics>;
    disabled: Scalars["Boolean"];
    egdsElementId?: Maybe<Scalars["String"]>;
    icon?: Maybe<Icon>;
    primary?: Maybe<Scalars["String"]>;
  };

/** Used to represent a paragraph of text with different EGDS typography styles. */
export type EgdsParagraph = EgdsElement &
  EgdsText & {
    __typename?: "EGDSParagraph";
    egdsElementId?: Maybe<Scalars["String"]>;
    /** @deprecated Allows for invalid values. Use EGDSParagraphStyle instead */
    size: Scalars["Int"];
    /** Advanced feature. Only need for specific uses. See EGDSParagraphStyle description */
    style: EgdsParagraphStyle;
    text: Scalars["String"];
  };

/**
 * This should only be used in unique design cases where the UX changes frequently and specific product requirements must be met.
 * Most teams should just use String over EGDSParagraph or EGDSText.
 *
 * https://www.figma.com/file/IHAiPyllJIlO6g4f2qdNW4zq/Typography
 */
export type EgdsParagraphStyle = "P1" | "P2" | "P3";

/** Represents a password input filed element with autofill property */
export type EgdsPasswordInputField = EgdsElement &
  EgdsInputField & {
    __typename?: "EGDSPasswordInputField";
    /** Autofill hint for the input value */
    autofill?: Maybe<Scalars["String"]>;
    egdsElementId?: Maybe<Scalars["String"]>;
    errorMessage?: Maybe<Scalars["String"]>;
    instructions?: Maybe<Scalars["String"]>;
    label: Scalars["String"];
    labelTemplate?: Maybe<EgdsLocalizedText>;
    leftIcon?: Maybe<Icon>;
    /** Determines if the input value is visible or obscured */
    passwordVisible?: Maybe<Scalars["Boolean"]>;
    placeholder?: Maybe<Scalars["String"]>;
    readOnly: Scalars["Boolean"];
    required?: Maybe<Scalars["Boolean"]>;
    rightIcon?: Maybe<Icon>;
    validations?: Maybe<Array<EgdsInputValidation>>;
    value?: Maybe<Scalars["String"]>;
  };

/** Possible camera movement for the photosphere image */
export type EgdsPhotosphereCameraMovement = "AUTO_PAN" | "DISABLED" | "FULL_MOVE";

/**
 * Representation of a photosphere image (360 image).
 * A photosphere allows users to view and interact with 360-degree images.
 *
 * https://www.figma.com/file/Qv3T2R07UaS4NwSLonHpE3/Photosphere-%5BBETA%5D%5BWIP%5D
 */
export type EgdsPhotosphereImage = {
  __typename?: "EGDSPhotosphereImage";
  /** @deprecated Use description instead */
  altText?: Maybe<Scalars["String"]>;
  /** Aspect Ratio of the image */
  aspectRatio?: Maybe<AspectRatio>;
  /** Allow movement if is using photosphere (default true) */
  cameraMovement?: Maybe<EgdsPhotosphereCameraMovement>;
  /** The localized text describing the photosphere image */
  description: Scalars["String"];
  /** Thumbnail image click analytics */
  thumbnailClickAnalytics?: Maybe<ClientSideAnalytics>;
  url: Scalars["URL"];
};

/**
 * Representation of a photosphere image (360 image).
 * A photosphere allows users to view and interact with 360-degree images.
 *
 * https://www.figma.com/file/Qv3T2R07UaS4NwSLonHpE3/Photosphere-%5BBETA%5D%5BWIP%5D
 */
export type EgdsPhotosphereImageUrlArgs = {
  dimensions?: InputMaybe<DimensionsInput>;
};

/**
 * Use to toggle on one or more categories (e.g. Beach, Family),
 * quick-select an option (e.g. quick response in Chat virtual assistant),
 * or trigger a selection feature (e.g. Datepicker).
 */
export interface EgdsPill {
  accessibility?: Maybe<Scalars["String"]>;
  /** Denotes whether pill is in disabled state */
  disabled: Scalars["Boolean"];
  /** Used to denote informative icon */
  icon?: Maybe<UiGraphic>;
  /** Used to uniquely identify a pill */
  id?: Maybe<Scalars["String"]>;
  /** Used to display text on pill */
  primary?: Maybe<Scalars["String"]>;
  /** Denotes whether pill is in selected state */
  selected: Scalars["Boolean"];
}

/** Represents Simple plain text */
export type EgdsPlainText = EgdsText & {
  __typename?: "EGDSPlainText";
  text: Scalars["String"];
};

/** Represents price lockup elements: Price, price qualifier, strikethrough price, price caption. UITK component defined at http://uitk.expedia.biz/expedia/en_US/components/price-lockup */
export type EgdsPriceLockup = {
  __typename?: "EGDSPriceLockup";
  /** Screenreader friendly string for price information. */
  accessibilityPrice: Scalars["String"];
  /** Screenreader friendly text for dialog information. */
  accessibilityStrikeThroughDialogTrigger?: Maybe<Scalars["String"]>;
  /** Display formatted points on top of price */
  isPointsFirst: Scalars["Boolean"];
  /** Display strike through points on top of price section */
  isStrikeThroughFirst: Scalars["Boolean"];
  /** Caption which leads Points or Price. */
  leadingCaption?: Maybe<Scalars["String"]>;
  /** Formatted points lockup text. */
  lockupFormattedPoints?: Maybe<Scalars["String"]>;
  /** Price text. */
  lockupPrice?: Maybe<Scalars["String"]>;
  /** Bold line stacked underneath `priceSubtextFirst`. */
  priceSubtextBold?: Maybe<Scalars["String"]>;
  /** First line subtext below price. */
  priceSubtextFirst?: Maybe<Array<Scalars["String"]>>;
  /** Standard lines below `priceSubtextFirst`. */
  priceSubtextStandard?: Maybe<Array<Scalars["String"]>>;
  /** Strike through price text. */
  strikeThroughPrice?: Maybe<Scalars["String"]>;
};

/** Represents the UI for the link and the action that needs to be performed when user clicks on the link on Product Rating block message. */
export type EgdsProductRatingLink = {
  __typename?: "EGDSProductRatingLink";
  action: EgdsProductRatingShowTextAction;
  link: EgdsStandardLink;
};

/**
 * Action for showing a text.
 * The UI for this is decided by the client. This is an area where we've chosen to follow the conventions of each platform,
 * because users will be familiar with that pattern across the spectrum of apps they use.
 * Eg for Native it can be shown in a dialog where as in PWA it will be a popover.
 */
export type EgdsProductRatingShowTextAction = {
  __typename?: "EGDSProductRatingShowTextAction";
  /**
   * This represents the disclaimer text
   * Eg. We verify reviews to ensure the traveler booked with Expedia Group.
   * We publish all reviews, positive or negative, that meet our guidelines.
   */
  text: Scalars["String"];
};

/**
 * Represents the top summary view of product rating.
 * Figma: https://www.figma.com/file/ahZ2mxMm5Y8X0l9hoBapCF/Product-reviews?node-id=1%3A2
 */
export type EgdsProductRatingSummary = {
  __typename?: "EGDSProductRatingSummary";
  /** Represents the content with highest priority. Eg 4.5 */
  primary?: Maybe<Scalars["String"]>;
  /** Represents the content with second most highest priority. Eg Excellent */
  secondary?: Maybe<Scalars["String"]>;
  /**
   * Represents messages in support of rating summary.
   *         Eg a link with text \"verified reviews\" which opens up the disclaimer dialog.
   *         Eg a plain text \"126 reviews\" representing the number of reviews for a product.
   */
  supportingMessages: Array<EgdsProductRatingSupportingMessage>;
};

/**
 * Represents a message in support of rating summary."
 *                  Eg a link with text \"verified reviews\" which opens up the disclaimer dialog Or
 *                  a plain text \"126 reviews\" representing the number of reviews for a product.
 */
export type EgdsProductRatingSupportingMessage = EgdsPlainText | EgdsProductRatingLink;

/**
 * Represents a program badge
 *
 * https://www.figma.com/file/aYQZVH6x5kqAGj8LbLzTVWfX/Badges
 */
export type EgdsProgramBadge = EgdsBadge &
  EgdsElement & {
    __typename?: "EGDSProgramBadge";
    accessibility?: Maybe<Scalars["String"]>;
    egdsElementId?: Maybe<Scalars["String"]>;
    graphic?: Maybe<UiGraphic>;
    size?: Maybe<Scalars["String"]>;
    text?: Maybe<Scalars["String"]>;
    theme?: Maybe<Scalars["String"]>;
  };

/** Represents progress as a percentage. UITK component defined at http://uitk-react.tools.expedia.com/expedia/en_US/components/progress-bar */
export type EgdsProgressBar = {
  __typename?: "EGDSProgressBar";
  /** Hidden text for screen reader accessibility. */
  accessibilityLabel: Scalars["String"];
  percent: Scalars["Int"];
  /** Describes progress made so far, e.g. 8.0/10 or $14,000 */
  progressDescription?: Maybe<Scalars["String"]>;
  /** Describes progress bar's purpose. */
  title?: Maybe<Scalars["String"]>;
};

/** Represents individual radio button. Radio buttons are allow one to be selected out of all of them. */
export interface EgdsRadioButton {
  /** Represents the description for the radio button. */
  description?: Maybe<Scalars["String"]>;
  /** User cannot interact with the radio when the disabled value is true. */
  disabled: Scalars["Boolean"];
  /** Represents the label description of radio button. Example: 'Label 1', 'Label 2' */
  label: Scalars["String"];
  /** Represents the secondary label of radio button. Example when price associated with radio: '$999' */
  labelSuffix?: Maybe<Scalars["String"]>;
  /** Represents the value of the radio button. */
  value: Scalars["String"];
}

/**
 * Represents collections of radio buttons describing a set of related options.
 * UITK react:
 * http://uitk.expedia.biz/expedia/en_US/components/radio-button
 * Figma:
 * https://www.figma.com/file/UNXRJ8MDLJjvu7ENZCMhke/Radio-buttons
 */
export interface EgdsRadioGroup {
  /** Represents radio group error message. */
  errorMessage?: Maybe<Scalars["String"]>;
  /** Represents the name for the radio group. It will be used as the name for each child radio component. */
  groupName: Scalars["String"];
  /** Represents options for radio group. */
  options: Array<EgdsRadioButton>;
  /** Represents default selected radio child by passing in its value. */
  selected?: Maybe<Scalars["String"]>;
}

/** A symbolic representation that communicates rating values in a 0.5 to 5.0 rating system */
export interface EgdsRating {
  accessibility?: Maybe<Scalars["String"]>;
  rating: Scalars["Float"];
}

/** Specifies a Regex pattern that an input must adhere to */
export type EgdsRegexInputValidation = EgdsInputValidation & {
  __typename?: "EGDSRegexInputValidation";
  errorMessage: Scalars["String"];
  pattern: Scalars["String"];
};

/**
 * Represents chips or pills when filters are applied.
 * Clicking or tapping any part of the pill will trigger its removal.
 */
export type EgdsRemovablePill = UiRemovablePill & {
  __typename?: "EGDSRemovablePill";
  /** Accessibility label for the pill */
  accessibility?: Maybe<Scalars["String"]>;
  action?: Maybe<UiAction>;
  disabled: Scalars["Boolean"];
  /** Icon to be displayed along with the label */
  icon?: Maybe<Icon>;
  /** Label to be displayed on the pill */
  primary: Scalars["String"];
  remove?: Maybe<Icon>;
  selected: Scalars["Boolean"];
};

/** Specifies that an input is required */
export type EgdsRequiredInputValidation = EgdsInputValidation & {
  __typename?: "EGDSRequiredInputValidation";
  errorMessage: Scalars["String"];
};

/** Represents implementation of EGDSTravelerSelector which will be used for lodging and packages when selecting room configurations. */
export type EgdsRoomsTravelerSelector = EgdsElement &
  EgdsTravelerSelector & {
    __typename?: "EGDSRoomsTravelerSelector";
    /** Button to add another room to select travelers for that room. */
    addAnotherRoomButton: EgdsButton;
    closeButton: EgdsButton;
    /** Indicates the done button on the traveler selector. */
    doneButton: EgdsButton;
    egdsElementId?: Maybe<Scalars["String"]>;
    /**
     * Represents the infants seat selection module with heading, radio buttons and airline age rule
     * @deprecated Use infantsOnLap and infantsInSeat instead.
     */
    infantSeatSelection?: Maybe<EgdsTravelerInfantSeatSelection>;
    /** Max number of rooms allowed. */
    maxRoomCount?: Maybe<Scalars["Int"]>;
    /** Represents list of room configurations for travelers. */
    rooms: Array<EgdsTravelerSelectorRoom>;
    title: Scalars["String"];
    /**
     * Validations with corresponding error messages to display if the input is invalid.
     * The order in which the validations appears indicates the order of priority of which error message to display.
     */
    validations?: Maybe<Array<EgdsInputValidation>>;
  };

/** Specifies that two inputs can't have the same value */
export type EgdsSameValueInputValidation = EgdsInputValidation & {
  __typename?: "EGDSSameValueInputValidation";
  errorMessage: Scalars["String"];
};

/** Represents a search form or search form widget */
export interface EgdsSearchForm {
  /**
   * Specify where to send the form-data when a form is submitted
   * This is a web specific attribute https://developer.mozilla.org/en-US/docs/Web/HTML/Element/form#attr-action
   * eg '/Hotel-Search'
   */
  actionURL: Scalars["String"];
  /** Components for building and structuring the search form or search form widget */
  elements: Array<EgdsSearchFormElement>;
  /** Component that shows the number of errors when form submitted */
  errorSummary?: Maybe<EgdsErrorSummary>;
  /** Optional component to playback or summarize the current search */
  playback?: Maybe<EgdsSearchPlayback>;
  /** Optional component that powers the search button on the form */
  search?: Maybe<EgdsButton>;
}

/**
 * Action in response to user interaction on search form or search form widget.
 * Examples include opening up a date picker, launching Typeahead for destination search, and opening Traveler Selector
 */
export type EgdsSearchFormAction =
  | EgdsOpenDatePickerAction
  | EgdsOpenTravelerSelectorAction
  | EgdsSearchFormSelectAction
  | EgdsShowSearchFormAction
  | EgdsSubmitSearchFormAction
  | OpenDurationSpanAction
  | OpenTypeaheadAction;

/** Button found in search form that has a search form specific action once clicked */
export type EgdsSearchFormButton = EgdsButton &
  EgdsElement & {
    __typename?: "EGDSSearchFormButton";
    accessibility?: Maybe<Scalars["String"]>;
    /**
     * @deprecated
     *         UIAction should not be used as a field because it allows for too many possible types.
     *         If need to specify action have the implementation of EGDSButton add a field for action with interface type of less number of possible subtypes
     *         or a union type with a manageable number of members
     *
     */
    action?: Maybe<UiAction>;
    analytics?: Maybe<ClientSideAnalytics>;
    disabled: Scalars["Boolean"];
    egdsElementId?: Maybe<Scalars["String"]>;
    icon?: Maybe<Icon>;
    /** Action to perform when clicked such as submitting the search form. */
    onClick?: Maybe<EgdsSearchFormAction>;
    primary?: Maybe<Scalars["String"]>;
    style?: Maybe<EgdsButtonStyle>;
  };

/**
 * Dates field on search form or search form widget for entering a start and end dates
 *
 * Figma: https://www.figma.com/file/oYtPus1JugVGjib58w8Jkj/E2E-search?node-id=6434%3A270153
 */
export type EgdsSearchFormDatePickerField = EgdsElement &
  EgdsInputField &
  EgdsSearchFormField & {
    __typename?: "EGDSSearchFormDatePickerField";
    action?: Maybe<EgdsSearchFormAction>;
    egdsElementId: Scalars["String"];
    errorMessage?: Maybe<Scalars["String"]>;
    instructions?: Maybe<Scalars["String"]>;
    label?: Maybe<Scalars["String"]>;
    labelTemplate?: Maybe<EgdsLocalizedText>;
    leftIcon?: Maybe<Icon>;
    placeholder?: Maybe<Scalars["String"]>;
    readOnly: Scalars["Boolean"];
    required?: Maybe<Scalars["Boolean"]>;
    rightIcon?: Maybe<Icon>;
    validations?: Maybe<Array<EgdsInputValidation>>;
    value?: Maybe<Scalars["String"]>;
  };

/**
 * UI element used to create and structure a search form or search form widget.
 * Examples include input fields for selecting date, destination, or travelers, pill groups for selecting LOBs, and containers for organizing the search form into sections
 */
export type EgdsSearchFormElement =
  | EgdsSearchFormDatePickerField
  | EgdsSearchFormInputField
  | EgdsSearchFormLocationField
  | EgdsSearchFormLocationsField
  | EgdsSearchFormTravelersField
  | SearchFormDurationSpanField;

/**
 * UI Element used to create and structure a search form
 * Examples include input fields for selecting date, destination, or travelers, pill groups for selecting LOBs, and containers for organizing the search form into sections
 */
export interface EgdsSearchFormField {
  /** Informs behavior in response to user click */
  action?: Maybe<EgdsSearchFormAction>;
}

/** Input field on search form or search form widget for entering information such as date, destination, or travelers. */
export type EgdsSearchFormInputField = EgdsElement &
  EgdsInputField & {
    __typename?: "EGDSSearchFormInputField";
    /** Informs behavior in response to user click. */
    action?: Maybe<EgdsSearchFormAction>;
    egdsElementId: Scalars["String"];
    errorMessage?: Maybe<Scalars["String"]>;
    instructions?: Maybe<Scalars["String"]>;
    label?: Maybe<Scalars["String"]>;
    labelTemplate?: Maybe<EgdsLocalizedText>;
    leftIcon?: Maybe<Icon>;
    placeholder?: Maybe<Scalars["String"]>;
    readOnly: Scalars["Boolean"];
    required?: Maybe<Scalars["Boolean"]>;
    rightIcon?: Maybe<Icon>;
    validations?: Maybe<Array<EgdsInputValidation>>;
    value?: Maybe<Scalars["String"]>;
  };

/**
 * Location field on search form or search form widget for entering an origin or destination.
 *
 * Figma: https://www.figma.com/file/oYtPus1JugVGjib58w8Jkj/E2E-search?node-id=3769%3A204213
 */
export type EgdsSearchFormLocationField = EgdsElement &
  EgdsInputField &
  EgdsSearchFormField & {
    __typename?: "EGDSSearchFormLocationField";
    action?: Maybe<EgdsSearchFormAction>;
    egdsElementId: Scalars["String"];
    errorMessage?: Maybe<Scalars["String"]>;
    instructions?: Maybe<Scalars["String"]>;
    label?: Maybe<Scalars["String"]>;
    labelTemplate?: Maybe<EgdsLocalizedText>;
    leftIcon?: Maybe<Icon>;
    /** @deprecated Use multiLocations */
    locations?: Maybe<Array<Scalars["String"]>>;
    /** Multiple locations in case multi-selection field is enabled (typeahead). Commonly used for multiple destinations. */
    multiLocations?: Maybe<Array<EgdsSearchFormSelectedLocation>>;
    placeholder?: Maybe<Scalars["String"]>;
    readOnly: Scalars["Boolean"];
    required?: Maybe<Scalars["Boolean"]>;
    rightIcon?: Maybe<Icon>;
    validations?: Maybe<Array<EgdsInputValidation>>;
    value?: Maybe<Scalars["String"]>;
  };

/** Represents two location fields and allows user to swap values between them by clicking on a swapper button */
export type EgdsSearchFormLocationsField = EgdsElement & {
  __typename?: "EGDSSearchFormLocationsField";
  /** Destination location field for a search */
  destination: EgdsSearchFormLocationField;
  egdsElementId: Scalars["String"];
  /** Button element for swapping values of origin and destination fields. This button is for Medium and Large viewport where the fields are in line */
  horizontalSwapper?: Maybe<EgdsButton>;
  /** Origin location field for a search */
  origin: EgdsSearchFormLocationField;
  /** Array that contains validations for locations component */
  validations?: Maybe<Array<EgdsInputValidation>>;
  /** Button element for swapping values of origin and destination fields. This button is for Small viewport where origin and destination are stacked */
  verticalSwapper?: Maybe<EgdsButton>;
};

/** Represent a list of elements and allow user to select a single one */
export type EgdsSearchFormSelectAction = {
  __typename?: "EGDSSearchFormSelectAction";
  /** Used to provide accessibility that has to be read on completion of action. */
  accessibility?: Maybe<Scalars["String"]>;
  analytics: ClientSideAnalytics;
  /** Field to confirm a user selection */
  apply?: Maybe<EgdsButton>;
  /** Used to provide label value for the form. */
  label?: Maybe<Scalars["String"]>;
  /** List of elements available for user selection */
  options: Array<EgdsOption>;
};

export type EgdsSearchFormSelectedLocation = {
  __typename?: "EGDSSearchFormSelectedLocation";
  /**
   * Informs about the preselected values
   * Example: \`Hilton\`, \`Hyatt\`, \`Ramada\`
   */
  text: Scalars["String"];
  /**
   * Optional value or a code associated with the text which can be used to uniquely identify the selection
   * Example: miami-florida, seattle-washington
   */
  value?: Maybe<Scalars["String"]>;
};

/**
 * Travelers field on search form or search form widget for entering travelers types and count.
 *
 * Figma: https://www.figma.com/file/oYtPus1JugVGjib58w8Jkj/E2E-search?node-id=3769%3A204213
 */
export type EgdsSearchFormTravelersField = EgdsElement &
  EgdsInputField &
  EgdsSearchFormField & {
    __typename?: "EGDSSearchFormTravelersField";
    action?: Maybe<EgdsSearchFormAction>;
    egdsElementId: Scalars["String"];
    errorMessage?: Maybe<Scalars["String"]>;
    instructions?: Maybe<Scalars["String"]>;
    label?: Maybe<Scalars["String"]>;
    labelTemplate?: Maybe<EgdsLocalizedText>;
    leftIcon?: Maybe<Icon>;
    placeholder?: Maybe<Scalars["String"]>;
    readOnly: Scalars["Boolean"];
    required?: Maybe<Scalars["Boolean"]>;
    rightIcon?: Maybe<Icon>;
    validations?: Maybe<Array<EgdsInputValidation>>;
    value?: Maybe<Scalars["String"]>;
  };

/** Inputs for search queries such as property search, flights search, etc */
export interface EgdsSearchInputs {
  shoppingSearchCriteria?: Maybe<ShoppingSearchCriteria>;
}

/**
 * Change search playback container
 * https://www.figma.com/file/oYtPus1JugVGjib58w8Jkj/Search-foundations?node-id=9272%3A215198
 */
export type EgdsSearchPlayback = {
  __typename?: "EGDSSearchPlayback";
  /** @deprecated Once user has expanded the form, playback does not allow to collapse again */
  hideButton: EgdsButton;
  primary: EgdsText;
  secondaries: Array<EgdsText>;
  showAction: EgdsSearchFormAction;
};

/**
 * Used to structure content.
 * For example: listing all the upcoming trips and then past trips can be achieved with 2 sections.
 */
export type EgdsSectionContainer = EgdsElement &
  EgdsElements & {
    __typename?: "EGDSSectionContainer";
    egdsElementId?: Maybe<Scalars["String"]>;
    elements: Array<EgdsElement>;
    /** @deprecated Use sectionHeading instead. It allows allows more formatting options. */
    heading?: Maybe<Scalars["String"]>;
    sectionHeading?: Maybe<EgdsSectionHeading>;
    /** @deprecated This leads to ambiguity as section themes are not found in EGDS */
    theme?: Maybe<ContainerTheme>;
  };

/**
 * This should only be used in unique design cases where the UX changes frequently and specific product requirements must be met.
 * Most teams should just use Strings.
 *
 * Represents a section where the heading and subheading should be placed if they exist
 */
export interface EgdsSectionHeading {
  heading: EgdsHeading;
  subheading?: Maybe<Scalars["String"]>;
}

/**
 * Used for select element with a label, optional icon and option values.
 * More details on UITK:
 * http://uitk.expedia.biz/expedia/en_US/components/select
 * Figma:
 * https://www.figma.com/file/LvLAeuvgjQAhxUdAVP9Hzk/Selects
 *
 * The egdsElementId of EGDSElement can be used for 'id' which is further sets 'for' attribute in <label> for accessibility purposes.
 */
export interface EgdsSelect {
  /** User cannot intract with the select when the disabled value is true */
  disabled: Scalars["Boolean"];
  /** Text to be displayed as error text when the select field is in an invalid state. */
  errorMessage?: Maybe<Scalars["String"]>;
  /** Icon to render within the select */
  icon?: Maybe<Icon>;
  /** Text for the label element */
  label: Scalars["String"];
  /** Options for select element */
  options: Array<EgdsOption>;
  /** The selected value is displayed in a read only state when readOnly is true */
  readOnly: Scalars["Boolean"];
}

/**
 * Sheets are containers anchored to an edge of the screen that content can be rendered in.
 * Clients should orchestrate how content will render within the dialog.
 *
 * https://www.figma.com/file/wZZwajWKN1dP9UKIdQVd8P/Sheets
 */
export type EgdsSheet = {
  __typename?: "EGDSSheet";
  closeAnalytics: ClientSideAnalytics;
  closeText?: Maybe<Scalars["String"]>;
};

/** Action for showing the search form. */
export type EgdsShowSearchFormAction = {
  __typename?: "EGDSShowSearchFormAction";
  accessibility: Scalars["String"];
  analytics: ClientSideAnalytics;
  icon: Icon;
  /** URI used as a fallback link when website javascript hasn't hydrated. */
  resource: Uri;
};

/**
 * Date picker for selecting a single date.
 * Use Case Example: Selecting date for one-way flight.
 */
export type EgdsSingleDatePicker = EgdsDatePicker & {
  __typename?: "EGDSSingleDatePicker";
  buttonText: Scalars["String"];
  clearButtonText?: Maybe<Scalars["String"]>;
  dateFormat: Scalars["String"];
  datePickerContent?: Maybe<Array<EgdsDatePickerContent>>;
  firstDayOfWeek: EgdsDayName;
  footerText?: Maybe<Scalars["String"]>;
  selectedStartDate?: Maybe<Date>;
  showClearDatesButton?: Maybe<Scalars["Boolean"]>;
  startDatePlaceholderText: Scalars["String"];
  validDaysLowerBoundInclusive?: Maybe<Date>;
  validDaysUpperBoundInclusive?: Maybe<Date>;
};

export type EgdsSortAndFilterAppliedFilter = ShoppingSortAndFilterAppliedFilter & {
  __typename?: "EGDSSortAndFilterAppliedFilter";
  /** Search criteria that should be used when pill is triggered */
  nextSearchCriteria: ShoppingSearchCriteria;
  /** Used to display a removable pill for an applied filter. */
  pill: UiRemovablePill;
};

/** This can be used for representing text with inline elements such as stylized text (bold, colored, etc) and/or links. */
export type EgdsSpannableText = EgdsElement &
  EgdsText & {
    __typename?: "EGDSSpannableText";
    /**
     * A list of inline EGDSText implementations that comprise the text content.
     * Example Response: `listOf(EGDSStylizedText("Bold",TextWeight.BOLD), EGDSPlainText(" is for emphasis."))`
     * @deprecated Please use inlineContent
     */
    contents: Array<EgdsText>;
    egdsElementId?: Maybe<Scalars["String"]>;
    /**
     * A list of inline EGDSText implementations that comprise the text content.
     * Example Response: `listOf(EGDSStylizedText("Bold",TextWeight.BOLD), EGDSPlainText(" is for emphasis."))`
     */
    inlineContent: Array<EgdsSpannableTextItem>;
    /** The text in its entirety. NO html tags or any other other elements that indicate style should be present. */
    text: Scalars["String"];
  };

/** List of possible EGDSSpannableText inline implementations */
export type EgdsSpannableTextItem = EgdsGraphicText | EgdsHeading | EgdsPlainText | EgdsStandardLink | EgdsStylizedText;

/** Stacked dialog footers provide one or more buttons displayed in a stacked orientation for users to respond to the dialog */
export type EgdsStackedDialogFooter = EgdsDialogFooter & {
  __typename?: "EGDSStackedDialogFooter";
  buttons: Array<EgdsButton>;
};

/**
 * Represents a standard badge
 *
 * https://www.figma.com/file/aYQZVH6x5kqAGj8LbLzTVWfX/Badges
 */
export type EgdsStandardBadge = EgdsBadge &
  EgdsElement & {
    __typename?: "EGDSStandardBadge";
    accessibility?: Maybe<Scalars["String"]>;
    egdsElementId?: Maybe<Scalars["String"]>;
    graphic?: Maybe<UiGraphic>;
    size?: Maybe<Scalars["String"]>;
    text?: Maybe<Scalars["String"]>;
    theme?: Maybe<Scalars["String"]>;
  };

/**
 * Represents an EGDS Standard Link
 * Figma: https://www.figma.com/file/z0DKERbirtEuz6zVMF0HkW/Links?node-id=3206%3A51
 */
export type EgdsStandardLink = EgdsElement &
  EgdsText & {
    __typename?: "EGDSStandardLink";
    action: UiLinkAction;
    /** Display disabled link state. */
    disabled: Scalars["Boolean"];
    egdsElementId?: Maybe<Scalars["String"]>;
    /** Represents an icon next to the link. */
    icon?: Maybe<Icon>;
    /** Display position of the icon next to the link. */
    iconPosition?: Maybe<EgdsIconPosition>;
    /** Display size of the link. */
    size: EgdsLinkSize;
    text: Scalars["String"];
  };

/**
 * Representation of a EGDS message card
 *
 * https://www.figma.com/file/SRnOSnyVYE5dYh7wEQNIfC/Messaging-card-patterns?node-id=1551%3A1450
 *
 * UITK component defined at http://uitk.expedia.biz/expedia/en_US/components/menu"
 */
export type EgdsStandardMessagingCard = EgdsElement & {
  __typename?: "EGDSStandardMessagingCard";
  /** list of card buttons */
  buttons?: Maybe<Array<EgdsButton>>;
  /** dismiss action for messaging card */
  dismiss?: Maybe<EgdsDismissAction>;
  egdsElementId?: Maybe<Scalars["String"]>;
  /** card graphical item displayed along with body message */
  graphic?: Maybe<UiGraphic>;
  /** card title */
  heading?: Maybe<Scalars["String"]>;
  /** list of card links */
  links?: Maybe<Array<EgdsStandardLink>>;
  /** card body text */
  message: Scalars["String"];
  /** right icon for the card */
  rightIcon?: Maybe<Icon>;
};

/**
 * Represents a standard Switch
 *
 * https://www.figma.com/file/69SEMRa1KCBXU6T8uRcdzM/Switches?node-id=20%3A83
 */
export type EgdsStandardSwitch = UiToggle & {
  __typename?: "EGDSStandardSwitch";
  checked: Scalars["Boolean"];
  checkedAccessibilityLabel?: Maybe<Scalars["String"]>;
  checkedAnalytics?: Maybe<ClientSideAnalytics>;
  checkedDescription?: Maybe<Scalars["String"]>;
  checkedLabel: Scalars["String"];
  enabled: Scalars["Boolean"];
  /** @deprecated Use checked or unchecked label */
  label: Scalars["String"];
  uncheckedAccessibilityLabel?: Maybe<Scalars["String"]>;
  uncheckedAnalytics?: Maybe<ClientSideAnalytics>;
  uncheckedDescription?: Maybe<Scalars["String"]>;
  uncheckedLabel: Scalars["String"];
};

/** configuration to set up static map */
export type EgdsStaticMapConfig = EgdsBaseMapConfig & {
  __typename?: "EGDSStaticMapConfig";
  accessToken: Scalars["String"];
  config?: Maybe<MapConfiguration>;
  egdsMapProvider: EgdsMapProvider;
  markerUrls: Array<EgdsMarkerUrls>;
  positionMode?: Maybe<EgdsMapPositionMode>;
};

/**
 * Allows users to increment and decrement a value using controls"
 * More details on UITK step-input:
 * http://uitk.expedia.biz/expedia/en_US/components/step-input
 *
 * Figma:
 * https://www.figma.com/file/L4BMgfIGUiqx0zM5yBVBxv/Step-inputs
 */
export interface EgdsStepInput {
  /** Screenreader-specific text for the decrease button */
  decreaseText?: Maybe<Scalars["String"]>;
  /** Screenreader-specific text for the increase button */
  increaseText?: Maybe<Scalars["String"]>;
  /** Unique identifier for the entity which this step input represents. For example, key for "Child" could be "children" */
  key?: Maybe<Scalars["String"]>;
  /** Label for the step input */
  label: Scalars["String"];
  /** Maximum value the user can input */
  max?: Maybe<Scalars["Int"]>;
  /** Minimum value the user can input */
  min?: Maybe<Scalars["Int"]>;
  /** How much the value changes by, per step */
  step: Scalars["Int"];
  /** A small string of subtext underneath the title */
  subLabel?: Maybe<Scalars["String"]>;
  /** Initial value for step input. */
  value: Scalars["Int"];
}

/**
 * Represents stylized text with optional weight, theme and size
 * https://www.figma.com/file/IHAiPyllJIlO6g4f2qdNW4zq/Typography?node-id=7554%3A6533
 */
export type EgdsStylizedText = EgdsText & {
  __typename?: "EGDSStylizedText";
  /** Use this field when accessibility text needs to be different from text */
  accessibility?: Maybe<Scalars["String"]>;
  /** Represents a decorative for the text */
  decorative?: Maybe<EgdsDecorativeText>;
  /** The egds size of this text. http://egds.expedia.biz/latest/tokens/default#foundation-type-size */
  size?: Maybe<Scalars["String"]>;
  text: Scalars["String"];
  theme?: Maybe<TextTheme>;
  weight?: Maybe<TextWeight>;
};

/** Represents a EGDS submenu */
export interface EgdsSubMenu {
  /** Represents the array of menu list items */
  items: Array<EgdsMenuListItem>;
  /** Represents the menu title */
  title?: Maybe<Scalars["String"]>;
}

/**
 * Action for submitting search form. This action includes fixed inputs for the search query that are not dependent on what the user entered in the search form.
 * This action does not include some of the data needed to perform the search query
 * because the user may have entered that data in other parts of the form after the response that included this action had been received.
 */
export type EgdsSubmitSearchFormAction = UiAction & {
  __typename?: "EGDSSubmitSearchFormAction";
  accessibility?: Maybe<Scalars["String"]>;
  analytics: ClientSideAnalytics;
  /** Query input data that is not dependent on what user entered in the form. */
  fixedInputs?: Maybe<EgdsSearchInputs>;
};

/** Represent a Tab. */
export interface EgdsTab {
  accessibility?: Maybe<Scalars["String"]>;
  label: Scalars["String"];
  tabId: Scalars["String"];
}

/** Helps the user easily navigate between related content groups or views. */
export interface EgdsTabs {
  selectedTabId?: Maybe<Scalars["String"]>;
  tabs: Array<EgdsTab>;
}

/** Represents the container for the list of template models */
export interface EgdsTemplateModels {
  models: Array<TemplateModel>;
}

/** Implementations may include links, stylized text, or simple text without additional attributes. */
export interface EgdsText {
  text: Scalars["String"];
}

/** Represents a large text format input with multiple rows */
export type EgdsTextAreaInputField = EgdsElement &
  EgdsInputField & {
    __typename?: "EGDSTextAreaInputField";
    /** Determines if the textarea should be disabled */
    disabled?: Maybe<Scalars["Boolean"]>;
    egdsElementId?: Maybe<Scalars["String"]>;
    errorMessage?: Maybe<Scalars["String"]>;
    instructions?: Maybe<Scalars["String"]>;
    label: Scalars["String"];
    labelTemplate?: Maybe<EgdsLocalizedText>;
    leftIcon?: Maybe<Icon>;
    /** Sets the max row number the textarea will grow to before scrolling as a user types or pastes in content */
    maxRows?: Maybe<Scalars["Int"]>;
    /** Sets the initial number of rows the textarea will accommodate */
    minRows?: Maybe<Scalars["Int"]>;
    placeholder?: Maybe<Scalars["String"]>;
    readOnly: Scalars["Boolean"];
    required?: Maybe<Scalars["Boolean"]>;
    rightIcon?: Maybe<Icon>;
    validations?: Maybe<Array<EgdsInputValidation>>;
    value?: Maybe<Scalars["String"]>;
  };

/**
 * This should only be used in unique design cases where the UX changes frequently and specific product requirements must be met.
 * Most teams should just use Strings.
 *
 * Groups text content such as paragraphs.
 * The first of item of this list may require different spacing than the spacing between items in the list")
 */
export interface EgdsTextContainer {
  contents: Array<EgdsText>;
}

/** EGDS typography list item with link and icon */
export type EgdsTextIconLinkListItem = EgdsElement &
  EgdsText &
  EgdsTextListItem & {
    __typename?: "EGDSTextIconLinkListItem";
    action: UiLinkAction;
    /** Display disabled link state. */
    disabled: Scalars["Boolean"];
    egdsElementId?: Maybe<Scalars["String"]>;
    icon: Icon;
    /** @deprecated Should not use Recursive datatype. Use custom lists. */
    nestedList?: Maybe<EgdsTextList>;
    /** Display size of the link. */
    size?: Maybe<EgdsLinkSize>;
    style?: Maybe<EgdsTextListItemStyle>;
    subText?: Maybe<Scalars["String"]>;
    text: Scalars["String"];
  };

/** Icon variant of EGDS typography list */
export type EgdsTextIconList = EgdsElement &
  EgdsTextList & {
    __typename?: "EGDSTextIconList";
    egdsElementId?: Maybe<Scalars["String"]>;
    listItems: Array<EgdsTextIconListItem>;
    size?: Maybe<EgdsTextListSize>;
  };

/** EGDS typography list item with icon */
export type EgdsTextIconListItem = EgdsElement &
  EgdsText &
  EgdsTextListItem & {
    __typename?: "EGDSTextIconListItem";
    egdsElementId?: Maybe<Scalars["String"]>;
    icon: Icon;
    /** Information for capturing client side impression analytics event */
    impressionAnalytics?: Maybe<ClientSideImpressionEventAnalytics>;
    /** Represents the first level of nesting within EGDS List */
    nestedLevelOneList?: Maybe<EgdsNestedLevelOneList>;
    /** @deprecated Should not use Recursive datatype. Use custom lists. */
    nestedList?: Maybe<EgdsTextList>;
    style?: Maybe<EgdsTextListItemStyle>;
    subText?: Maybe<Scalars["String"]>;
    text: Scalars["String"];
  };

/** Represents a text input filed element with autofill property */
export type EgdsTextInputField = EgdsElement &
  EgdsInputField & {
    __typename?: "EGDSTextInputField";
    /** Autofill hint for the input value */
    autofill?: Maybe<Scalars["String"]>;
    egdsElementId?: Maybe<Scalars["String"]>;
    errorMessage?: Maybe<Scalars["String"]>;
    instructions?: Maybe<Scalars["String"]>;
    label: Scalars["String"];
    labelTemplate?: Maybe<EgdsLocalizedText>;
    leftIcon?: Maybe<Icon>;
    placeholder?: Maybe<Scalars["String"]>;
    readOnly: Scalars["Boolean"];
    required?: Maybe<Scalars["Boolean"]>;
    rightIcon?: Maybe<Icon>;
    validations?: Maybe<Array<EgdsInputValidation>>;
    value?: Maybe<Scalars["String"]>;
  };

/** EGDS compliant typography list https://www.figma.com/file/IHAiPyllJIlO6g4f2qdNW4zq/Typography */
export interface EgdsTextList {
  listItems: Array<EgdsTextListItem>;
  size?: Maybe<EgdsTextListSize>;
}

/**
 * This should only be used in unique design cases where the UX changes frequently and specific product requirements must be met.
 * Most teams should just use Strings.
 *
 * Contains a text list (i.e. ordered, unordered, bulleted, etc).
 * Can be used to create a composite text object such as a section containing a heading, list, and footer.
 */
export interface EgdsTextListContainer {
  list: EgdsTextList;
}

/** Typography list item with EGDS styles https://www.figma.com/file/IHAiPyllJIlO6g4f2qdNW4zq/Typography */
export interface EgdsTextListItem {
  /** @deprecated Should not use Recursive datatype. Use custom lists. */
  nestedList?: Maybe<EgdsTextList>;
  style?: Maybe<EgdsTextListItemStyle>;
  /** Represents the subHeading/subTitle/description of a List Item/Element. */
  subText?: Maybe<Scalars["String"]>;
  /** Represents the heading/title of a List Item/Element. */
  text: Scalars["String"];
}

export type EgdsTextListItemStyle = "DEFAULT" | "EMPHASIS" | "LOYALTY" | "NEGATIVE" | "POSITIVE";

/**
 * This should only be used in unique design cases where the UX changes frequently and specific product requirements must be met.
 * Most teams should just use Strings.
 *
 * Groups a section of text containing a list
 */
export type EgdsTextListSection = EgdsElement &
  EgdsTextListContainer & {
    __typename?: "EGDSTextListSection";
    egdsElementId?: Maybe<Scalars["String"]>;
    heading?: Maybe<EgdsSectionHeading>;
    list: EgdsTextList;
  };

/** https://www.figma.com/file/IHAiPyllJIlO6g4f2qdNW4zq/Typography */
export type EgdsTextListSize = "LIST_1" | "LIST_2" | "LIST_3";

/**
 * This represents UI variations of EGDS List
 *        figma: https://www.figma.com/file/IHAiPyllJIlO6g4f2qdNW4zq/Typography?node-id=11931%3A11857
 */
export type EgdsTextListType = "BULLET" | "ICON" | "NO_BULLET" | "NUMBER";

/** Represents a EGDS Text menu */
export type EgdsTextMenu = EgdsMenu & {
  __typename?: "EGDSTextMenu";
  accessibility?: Maybe<Scalars["String"]>;
  analytics?: Maybe<ClientSideAnalytics>;
  disabled: Scalars["Boolean"];
  subMenus: Array<EgdsSubMenu>;
  title: Scalars["String"];
};

/**
 * This should only be used in unique design cases where the UX changes frequently and specific product requirements must be met.
 * Most teams should just use Strings.
 *
 * Groups text content and is composed of sections for the heading and body
 */
export type EgdsTextSection = EgdsElement &
  EgdsTextContainer & {
    __typename?: "EGDSTextSection";
    contents: Array<EgdsText>;
    egdsElementId?: Maybe<Scalars["String"]>;
    heading?: Maybe<EgdsSectionHeading>;
  };

/** EGDS typography list item */
export type EgdsTextStandardListItem = EgdsElement &
  EgdsText &
  EgdsTextListItem & {
    __typename?: "EGDSTextStandardListItem";
    egdsElementId?: Maybe<Scalars["String"]>;
    /** Represents the first level of nesting within EGDS List */
    nestedLevelOneList?: Maybe<EgdsNestedLevelOneList>;
    /** @deprecated Should not use Recursive datatype. Use custom lists. */
    nestedList?: Maybe<EgdsTextList>;
    style?: Maybe<EgdsTextListItemStyle>;
    subText?: Maybe<Scalars["String"]>;
    text: Scalars["String"];
  };

/** EGDS typography list item with Mark */
export type EgdsTextWithMarkListItem = EgdsElement &
  EgdsText &
  EgdsTextListItem & {
    __typename?: "EGDSTextWithMarkListItem";
    egdsElementId?: Maybe<Scalars["String"]>;
    /** EGDS visual assets that do not follow standard sizing to be made icons. */
    mark?: Maybe<Mark>;
    /** @deprecated Should not use Recursive datatype. Use custom lists. */
    nestedList?: Maybe<EgdsTextList>;
    style?: Maybe<EgdsTextListItemStyle>;
    subText?: Maybe<Scalars["String"]>;
    text: Scalars["String"];
  };

/**
 * A symbolic representation of a thumbnail gallery view with various types of media like images, videos, etc.
 * https://www.figma.com/file/C4hYbY2GxNUEDa2b09kdc2/Media-gallery?node-id=1131%3A479
 */
export interface EgdsThumbnailMediaGallery {
  /** Dialog tabs  */
  tabs?: Maybe<EgdsTabs>;
  /** List of media including images or videos in the gallery */
  thumbnails: Array<MediaItem>;
  /** Dialog toolbar for media gallery */
  toolbar: EgdsDialogToolbar;
}

/** Toast notifications are unobstructive window elements used to display quick, auto-expiring messages to users on an action they've taken */
export type EgdsToast = EgdsElement & {
  __typename?: "EGDSToast";
  button?: Maybe<UiPrimaryButton>;
  egdsElementId?: Maybe<Scalars["String"]>;
  text: Scalars["String"];
};

/** Represents travelers used for traveler selector. */
export interface EgdsTraveler {
  /** Represents possible list of ages of traveler. Example: '', '1', '2'....'17'  */
  ages?: Maybe<Array<EgdsSelect>>;
  /** Represents traveler configuration. */
  count: EgdsStepInput;
}

/** Represents child age selection for traveler selector. */
export type EgdsTravelerChildAgeSelect = EgdsElement &
  EgdsSelect & {
    __typename?: "EGDSTravelerChildAgeSelect";
    disabled: Scalars["Boolean"];
    egdsElementId?: Maybe<Scalars["String"]>;
    errorMessage?: Maybe<Scalars["String"]>;
    icon?: Maybe<Icon>;
    label: Scalars["String"];
    /** Localized label with template for child age. Example: 'Child 1 age', 'Child 2 age' */
    labelTemplate: EgdsLocalizedText;
    options: Array<EgdsOption>;
    readOnly: Scalars["Boolean"];
    /** Age value for child. */
    value?: Maybe<Scalars["Int"]>;
  };

/** Represents implementation of children for traveler selector. */
export type EgdsTravelerChildren = EgdsTraveler & {
  __typename?: "EGDSTravelerChildren";
  /** Default age selection configuration for child. This template will be used to create new child in the room. */
  ageTemplate: EgdsSelect;
  ages: Array<EgdsSelect>;
  count: EgdsStepInput;
};

/** Represents implementation of infants for traveler selector. */
export type EgdsTravelerInfant = EgdsTraveler & {
  __typename?: "EGDSTravelerInfant";
  /** Default age selection configuration for infant. This template will be used to create new infant in the room. */
  ageTemplate: EgdsSelect;
  ages: Array<EgdsSelect>;
  count: EgdsStepInput;
};

/** Represents infants seat selection for traveler selector. */
export type EgdsTravelerInfantSeatSelection = EgdsElement &
  EgdsRadioGroup & {
    __typename?: "EGDSTravelerInfantSeatSelection";
    /** Link represent airline rules for infant age selection. */
    airlineAgeRule: EgdsStandardLink;
    egdsElementId?: Maybe<Scalars["String"]>;
    errorMessage: Scalars["String"];
    groupName: Scalars["String"];
    /** Label for seat selection options. Example: 'Where will the infant sit?' */
    label: Scalars["String"];
    labelTemplate: EgdsLocalizedText;
    /** Possible options for infants seat. Example: 'In seat', ' On lap'  */
    options: Array<EgdsRadioButton>;
    selected: Scalars["String"];
  };

/**
 * Representation of traveler selector.
 * The implementation can include travelers or rooms configuration which will be used to select the number of travelers for lodging, flights, packages, cruises and activities.
 * figma:
 *  https://www.figma.com/file/y59aHUdrzsZBTg5RfbaZ9h/Traveler-selector?node-id=67%3A51
 */
export interface EgdsTravelerSelector {
  /** Close button on the traveler selector. */
  closeButton: EgdsButton;
  /** Done button on the traveler selector. */
  doneButton: EgdsButton;
  /** Title of the traveler selector. Example: Travelers, Travelers in the cabin. */
  title: Scalars["String"];
}

/** Represents a room in traveler selector. The room will be used to represent hotel room in for lodging and package. */
export type EgdsTravelerSelectorRoom = {
  __typename?: "EGDSTravelerSelectorRoom";
  /** Adults configuration for the room. */
  adults: EgdsStepInput;
  /** Children configuration for the room. */
  children: EgdsTraveler;
  /**
   * Infants configuration for the room.
   * @deprecated Use infantsOnLap and infantsInSeat instead.
   */
  infants?: Maybe<EgdsTraveler>;
  /** Represents infant travelers under certain age that require a seat reservation. */
  infantsInSeat?: Maybe<EgdsTraveler>;
  /** Represents infant travelers under certain age that don't require a seat selection. */
  infantsOnLap?: Maybe<EgdsTraveler>;
  /** Label associated with the room. Example: 'Room 1' */
  label: EgdsLocalizedText;
  /** Represent remove room button. Example: 'Remove room' */
  removeRoomButton?: Maybe<EgdsButton>;
};

/** Represents implementation of StepInput which will be used for adults, children, infant, seniors count. */
export type EgdsTravelerStepInput = EgdsElement &
  EgdsStepInput & {
    __typename?: "EGDSTravelerStepInput";
    /**
     * Informs behavior in response to user click.
     * @deprecated Need specific tracking for increase and decrease count event. Hence, deprecating the action and adding new analytics fields for increase and decrease count.
     */
    action?: Maybe<EgdsSearchFormAction>;
    /** Informs behavior in response when user click to decrease travelers count. */
    decreaseAnalytics: ClientSideAnalytics;
    decreaseText?: Maybe<Scalars["String"]>;
    /** Localized screen-reader specific text for announcing a decrement in traveler count. Example: 'Decrease the number of adults in room 1' */
    decreaseTextTemplate?: Maybe<EgdsLocalizedText>;
    egdsElementId?: Maybe<Scalars["String"]>;
    /** Informs behavior in response when user click to increase travelers count. */
    increaseAnalytics: ClientSideAnalytics;
    increaseText?: Maybe<Scalars["String"]>;
    /** Localized screen-reader specific text for announcing an increment in traveler count. Example: 'Increase the number of adults in room 1' */
    increaseTextTemplate?: Maybe<EgdsLocalizedText>;
    key?: Maybe<Scalars["String"]>;
    label: Scalars["String"];
    max?: Maybe<Scalars["Int"]>;
    min?: Maybe<Scalars["Int"]>;
    step: Scalars["Int"];
    subLabel?: Maybe<Scalars["String"]>;
    value: Scalars["Int"];
  };

/** Represents all category of travelers used in travelers selector. */
export type EgdsTravelers = {
  __typename?: "EGDSTravelers";
  /** Represents adult travelers. */
  adults: EgdsStepInput;
  /** Represents child travelers. */
  children?: Maybe<EgdsTraveler>;
  /** Represents infant travelers under certain age that require a seat reservation. */
  infantsInSeat?: Maybe<EgdsTraveler>;
  /** Represents infant travelers under certain age that don't require a seat selection. */
  infantsOnLap?: Maybe<EgdsTraveler>;
  /** Represents pets travelers. */
  pets?: Maybe<EgdsCheckBox>;
  /** Represents senior travelers. */
  seniors?: Maybe<EgdsStepInput>;
};

/** Used with traveler selector field to specify validations on travelers. */
export type EgdsTravelersInputValidation = EgdsInputValidation & {
  __typename?: "EGDSTravelersInputValidation";
  errorMessage: Scalars["String"];
  /** Component that shows an specific error when travelers are saved */
  errorSummary?: Maybe<EgdsErrorSummary>;
  /** Specifies the maximum count this validation needs. */
  maxCount?: Maybe<Scalars["Int"]>;
  /** The minimum age of travelers to carry infant. */
  minAgeToHoldInfant?: Maybe<Scalars["Int"]>;
  /** Specifies the type of validation. */
  type: EgdsTravelersValidationType;
};

/** Represents different type of travelers validation. */
export type EgdsTravelersValidationType =
  /** Used to validate child age required. */
  | "CHILD_AGE_REQUIRED"
  /** Used to validate maximum number of allowed infants in seat. */
  | "MANY_INFANT_IN_SEAT"
  /** Used to validate maximum number of allowed infants on lap. */
  | "MANY_INFANT_ON_LAP"
  /** Used to validate maximum allowed travelers for search. */
  | "MAX_TRAVELERS";

/**
 * Input field which opens a list of autocomplete selections from the Typeahead API.
 *
 * More details on UITK:
 * http://uitk.expedia.biz/expedia/en_US/components/typeahead
 * Figma:
 * https://www.figma.com/file/oCe7wGPkh8SU8As0KJ3u2C/Typeahead?node-id=3381%3A0
 */
export type EgdsTypeaheadInputField = EgdsElement &
  EgdsInputField & {
    __typename?: "EGDSTypeaheadInputField";
    egdsElementId?: Maybe<Scalars["String"]>;
    errorMessage?: Maybe<Scalars["String"]>;
    instructions?: Maybe<Scalars["String"]>;
    label: Scalars["String"];
    labelTemplate?: Maybe<EgdsLocalizedText>;
    leftIcon?: Maybe<Icon>;
    placeholder?: Maybe<Scalars["String"]>;
    readOnly: Scalars["Boolean"];
    renderType?: Maybe<EgdsTypeaheadRenderType>;
    required?: Maybe<Scalars["Boolean"]>;
    rightIcon?: Maybe<Icon>;
    /** Parameters to pass to underlying Typeahead API on client */
    typeaheadInfo: TypeaheadInfo;
    /** Placeholder text for the typeahead input when presented */
    typeaheadPlaceholder?: Maybe<Scalars["String"]>;
    validations?: Maybe<Array<EgdsInputValidation>>;
    value?: Maybe<Scalars["String"]>;
  };

/** Multi select typeahead properties */
export type EgdsTypeaheadMultiSelect = {
  __typename?: "EGDSTypeaheadMultiSelect";
  /** Text for clear all items button text */
  clearAllText?: Maybe<Scalars["String"]>;
  /** Specifies is multiple locations selection feature is enable */
  isMultiLocation?: Maybe<Scalars["Boolean"]>;
  /** Text to display selected item heading */
  selectedItemHeading?: Maybe<Scalars["String"]>;
  /** Flag to show pills for the selected results */
  showPills: Scalars["Boolean"];
};

/** Defines how typeahead results should be displayed on client. */
export type EgdsTypeaheadRenderType = "ADAPTIVE" | "DIALOG" | "MENU";

/** Unordered variant of EGDS typography list */
export type EgdsUnorderedList = EgdsElement &
  EgdsList &
  EgdsTextList & {
    __typename?: "EGDSUnorderedList";
    egdsElementId?: Maybe<Scalars["String"]>;
    /** @deprecated This field allows for noncompliance to EGDS. Use EGDSTextList instead */
    items: Array<EgdsText>;
    listItems: Array<EgdsTextListItem>;
    size?: Maybe<EgdsTextListSize>;
  };

/** The map information for the properties returned */
export type EgDynamicMap = {
  __typename?: "EGDynamicMap";
  /** Returns model with content for search button which should be displayed on the map */
  action?: Maybe<UiPrimaryButton>;
  /** Returns the title of the map */
  heading?: Maybe<EgdsHeading>;
  /** Data used by the map */
  map?: Maybe<EgdsBasicMap>;
  /** Returns the static map url */
  staticMapSrc?: Maybe<HttpUri>;
  /** Returns the subtitle of the map */
  subheading?: Maybe<EgdsHeading>;
};

/**
 * Used to specify event type for an interaction.
 * See https://github.expedia.biz/Brand-Expedia/uis-prime-schemas/blob/master/schemas/micro/platform/referrer.json#L26
 */
export type EgReferrerEventType =
  /** Used to track a click on a UI component. */
  | "CLICK"
  /** Used to track an impression of a UI component. */
  | "IMPRESSION";

/** Used for analytics micro messages, e.g. deals, sponsored */
export type EgUisMicroMessage = {
  __typename?: "EGUisMicroMessage";
  /** Represents message content for the uis prime message as a json. */
  messageContent: Scalars["String"];
  /** Represents name of the uis prime schema. e.g. allHotelProducts, pageIdentity */
  schemaName: Scalars["String"];
};

export type EmCardComponents = {
  __typename?: "EMCardComponents";
  card: EgdsImageLinkCard;
};

export type EmClickAction = {
  __typename?: "EMClickAction";
  action?: Maybe<UiLinkAction>;
  clickActionType: ClickActionType;
};

export type EmMediaComponents = {
  __typename?: "EMMediaComponents";
  items?: Maybe<Array<Maybe<MediaAsset>>>;
};

export type EmTextComponents = {
  __typename?: "EMTextComponents";
  description?: Maybe<Scalars["String"]>;
  header?: Maybe<EgdsHeading>;
  subHeader?: Maybe<EgdsHeading>;
};

/** Wrapping for EM List Components */
export type EmTextListComponents = {
  __typename?: "EMTextListComponents";
  list: List;
  textComponents: EmTextComponents;
};

/** Wrapping for Content With Media */
export type EmTextMediaActions = {
  __typename?: "EMTextMediaActions";
  clickActions?: Maybe<Array<Maybe<EmClickAction>>>;
  mediaAssets?: Maybe<EmMediaComponents>;
  textComponents: EmTextComponents;
};

/** Expedia Suggest Service Category */
export type EssCategory = {
  __typename?: "ESSCategory";
  /** ESS Category key */
  key: Scalars["String"];
  /** ESS Category value */
  value: Scalars["String"];
};

export type EditUniversalProfileResponse = {
  __typename?: "EditUniversalProfileResponse";
  /** Delete Account Mutation */
  deleteAccount: UniversalProfileActionResponse;
  /** Edit Basic Information Mutation */
  editBasicInformation: UniversalProfileActionResponse;
  /** Edit Contact Information Mutation */
  editContactInformation: UniversalProfileActionResponse;
  /** Edit Email Mutation */
  editEmail: UniversalProfileActionResponse;
  /** Sign Out Mutation */
  signOut: UniversalProfileActionResponse;
};

export type EditUniversalProfileResponseDeleteAccountArgs = {
  universalProfileContext: UniversalProfileContextInput;
};

export type EditUniversalProfileResponseEditBasicInformationArgs = {
  request: UniversalProfileBasicInformationRequestInput;
  universalProfileContext: UniversalProfileContextInput;
};

export type EditUniversalProfileResponseEditContactInformationArgs = {
  request: UniversalProfileContactInformationRequestInput;
  universalProfileContext: UniversalProfileContextInput;
};

export type EditUniversalProfileResponseEditEmailArgs = {
  request: UniversalProfileContactInformationRequestInput;
  universalProfileContext: UniversalProfileContextInput;
};

export type EditUniversalProfileResponseSignOutArgs = {
  universalProfileContext: UniversalProfileContextInput;
};

export type EditorialComponent = {
  __typename?: "EditorialComponent";
  content: EditorialComponentContent;
};

/**
 * Represent collection of editorial components
 *                    that can deliver several editorial experiences
 */
export type EditorialComponentContent =
  | EmCardComponents
  | EmMediaComponents
  | EmTextComponents
  | EmTextListComponents
  | EmTextMediaActions
  | StructuredContentMediaGalleryCarousel;

/** Editorial Content wrapper listing its body elements, title and subtitle. */
export type EditorialContent = TravelExperienceContent & {
  __typename?: "EditorialContent";
  id: Scalars["ID"];
  /** Editorial Content Sub-Title */
  subtitle?: Maybe<Scalars["String"]>;
  /** Editorial Content Title */
  title?: Maybe<Scalars["String"]>;
  /**
   * Editorial Content raw HTML
   * @deprecated Deprecated
   */
  unformattedHtml?: Maybe<Scalars["String"]>;
};

export type EgAdditionalContext = {
  __typename?: "EgAdditionalContext";
  userInterface?: Maybe<EgUserInterface>;
};

export type EgClickStreamPartnerCommon = {
  __typename?: "EgClickStreamPartnerCommon";
  resource_id?: Maybe<Scalars["String"]>;
};

export type EgClickstreamData = IEgClickstreamData & {
  __typename?: "EgClickstreamData";
  event?: Maybe<EgClickstreamEvent>;
  experience?: Maybe<EgClickstreamExperience>;
};

export type EgClickstreamEvent = {
  __typename?: "EgClickstreamEvent";
  action_location?: Maybe<Scalars["String"]>;
  event_name: Scalars["String"];
  event_type: Scalars["String"];
  event_version: Scalars["String"];
};

export type EgClickstreamExperience = {
  __typename?: "EgClickstreamExperience";
  app_name?: Maybe<Scalars["String"]>;
  app_version?: Maybe<Scalars["String"]>;
  experience_platform?: Maybe<Scalars["String"]>;
  page_name?: Maybe<Scalars["String"]>;
  page_name_detailed?: Maybe<Scalars["String"]>;
  page_product_line?: Maybe<Scalars["String"]>;
};

export type EgClickstreamLodgingProduct = {
  __typename?: "EgClickstreamLodgingProduct";
  property_brand_id?: Maybe<Scalars["Int"]>;
  property_city_name?: Maybe<Scalars["String"]>;
  property_country_name?: Maybe<Scalars["String"]>;
  property_market?: Maybe<Scalars["String"]>;
  property_name?: Maybe<Scalars["String"]>;
  property_sub_market?: Maybe<Scalars["String"]>;
  property_type?: Maybe<Scalars["String"]>;
  structure_type_id?: Maybe<Scalars["Int"]>;
};

export type EgClickstreamPartnerCommonData = {
  __typename?: "EgClickstreamPartnerCommonData";
  resource_id?: Maybe<Scalars["String"]>;
};

export type EgClickstreamProductListData = {
  __typename?: "EgClickstreamProductListData";
  lodging_product: EgClickstreamLodgingProduct;
};

export type EgClickstreamVirtualMarketCoachData = {
  __typename?: "EgClickstreamVirtualMarketCoachData";
  opportunities_available?: Maybe<Scalars["Int"]>;
  sort_order?: Maybe<Scalars["Int"]>;
};

export type EgNotificationAttributes = {
  __typename?: "EgNotificationAttributes";
  notificationBool?: Maybe<Scalars["Int"]>;
  notificationCount?: Maybe<Scalars["Int"]>;
};

export type EgPropertyCount = {
  __typename?: "EgPropertyCount";
  propertyCount?: Maybe<Scalars["Int"]>;
};

export type EgSuggestionList = {
  __typename?: "EgSuggestionList";
  textDisplayed?: Maybe<Scalars["String"]>;
};

export type EgTypeAHead = {
  __typename?: "EgTypeAHead";
  searchInput?: Maybe<Scalars["String"]>;
  suggestionList?: Maybe<Array<Maybe<EgSuggestionList>>>;
};

export type EgUserInterface = {
  __typename?: "EgUserInterface";
  componentBadgeName?: Maybe<Scalars["String"]>;
  componentElementText?: Maybe<Scalars["String"]>;
};

export interface EmailCtaButton {
  text: Scalars["String"];
  url: Scalars["URL"];
}

/** Union of Email Us sheet and Error View for Email us form */
export type EmailUsFormView = ContactUsErrorView | EmailUsSheet;

/** Represents Email Us Sheet */
export type EmailUsSheet = {
  __typename?: "EmailUsSheet";
  /** Label to go back from Email Us page */
  back: Scalars["String"];
  /** Email of customer */
  customerEmail: EgdsEmailInputField;
  /** Name of customer */
  customerName: EgdsTextInputField;
  /** Heading of  Email Us sheet */
  heading: Scalars["String"];
  /** Message of email */
  message: EgdsTextAreaInputField;
  /** send button for email */
  send: UiPrimaryButton;
  /** SubHeading of  Email Us sheet */
  subheading: Scalars["String"];
  /** subject of email */
  subject: EgdsTextInputField;
  /** Toolbar of Email Us sheet */
  toolBar: ContactUsToolBar;
};

export type EnhancedCleanlinessDialog = {
  __typename?: "EnhancedCleanlinessDialog";
  carouselButtonAllyStrings?: Maybe<Array<Scalars["String"]>>;
  content: Array<EnhancedCleanlinessDialogContent>;
  description: Scalars["String"];
  imageList?: Maybe<Array<Image>>;
  images?: Maybe<Array<HttpUri>>;
  shareFeedbackAction?: Maybe<CarShareFeedbackAction>;
  title: Scalars["String"];
};

export type EnhancedCleanlinessDialogContent = {
  __typename?: "EnhancedCleanlinessDialogContent";
  infos: Array<Scalars["String"]>;
  title: EnhancedCleanlinessInfoLineItem;
};

export type EnhancedCleanlinessInfo = {
  __typename?: "EnhancedCleanlinessInfo";
  dialog: EnhancedCleanlinessDialog;
  infoProviderText: Scalars["String"];
  infos: Array<EnhancedCleanlinessInfoLineItem>;
  seeAllAction: CarActionableItem;
  title: Scalars["String"];
  vendorCleanlinessBadge: HttpUri;
};

export type EnhancedCleanlinessInfoLineItem = {
  __typename?: "EnhancedCleanlinessInfoLineItem";
  icon: Icon;
  text: Scalars["String"];
};

/** Represents general node for Error Messaging on the UI */
export interface ErrorMessagingPresentation {
  /** Related EGCS analytics with Error messaging */
  egcsErrorAnalytics: EgClickstreamEvent;
  /** Related analytics with Error messaging */
  errorAnalytics: ClientSideImpressionEventAnalytics;
}

/**
 * "The `EssentialInfoItemInput` contains essentialInfoItemId along with bookingItemID separated by -. eg. 1-4020303
 * essentialInfoItemId identifies which essential info to render and bookingItemID is used as an parameter to lodgingDemandReservationService's getVrStayEssentialInfo API
 */
export type EssentialInfoItem = {
  __typename?: "EssentialInfoItem";
  itemId: Scalars["String"];
};

/**
 * "The `EssentialInfoItemInput` contains essentialInfoItemId along with bookingItemID separated by -. eg. 1-4020303
 * essentialInfoItemId identifies which essential info to render and bookingItemID is used as an parameter to lodgingDemandReservationService's getVrStayEssentialInfo API
 */
export interface EssentialInfoItemInput {
  itemId: Scalars["String"];
}

/** Describes the ETP dialog and its rate plan button trigger */
export type EtpDialog = LodgingDialog & {
  __typename?: "EtpDialog";
  toolbar: LodgingDialogToolbar;
  trigger: LodgingDialogTriggerMessage;
};

export type EventType =
  | "DeleteTripAlertPresented"
  | "DeleteTripDialogPresented"
  | "DeleteTripErrorToastPresented"
  | "DeleteTripFailed"
  | "DeleteTripSucceeded"
  | "DeleteTripSuccessToastPresented"
  | "HeroModuleCampaign"
  | "HeroModuleColdStart"
  | "ItinActiveCar"
  | "ItinActiveCruise"
  | "ItinActiveFlight"
  | "ItinActiveGT"
  | "ItinActiveHotel"
  | "ItinActiveLX"
  | "ItinActivePackageFH"
  | "ItinActiveRail"
  | "ItinCancellation"
  | "MoveItemDrawerPresented"
  | "MoveItemErrorToastPresented"
  | "MoveItemSubmitted"
  | "MoveItemSuccessToastPresented"
  | "MoveItemSuceeded"
  | "MoveLinkedItemsDialogPresented"
  | "RemoveItemDialogPresented"
  | "TripItemMenuPresented"
  | "TripSignInDialogPresented"
  | "TripsCollabInviteConfirmationViewed"
  | "TripsCollabInviteFailureViewed"
  | "TripsCollabInviteSucceeded"
  | "TripsCollabJoinGroupFailed"
  | "TripsCollabJoinGroupSucceeded"
  | "TripsCollabJoinTripConfirmationViewed"
  | "TripsCollabJoinTripErrorToastPresented"
  | "TripsCollabLandingScreenRedirectToTripOverView"
  | "TripsCollabLandingScreenViewed"
  | "TripsCollabManageGroupViewed"
  | "TripsCollabViewPresentedActivities"
  | "TripsCollabViewPresentedCars"
  | "TripsCollabViewPresentedCruise"
  | "TripsCollabViewPresentedFlight"
  | "TripsCollabViewPresentedHotel"
  | "TripsCollabViewPresentedVacationRental"
  | "TripsEditItemSucceeded"
  | "TripsEditTripErrorToastPresented"
  | "TripsEditTripPresented"
  | "TripsEditTripSubmitted"
  | "TripsEditTripSuccessToastPresented"
  | "TripsFlightScheduleChangeBannerDisplayed"
  | "TripsHeroModuleCurrentTrip"
  | "TripsHeroModulePossibleActivityTrip"
  | "TripsHeroModulePossibleAirTrip"
  | "TripsHeroModulePossibleCarTrip"
  | "TripsHeroModulePossibleHotelTrip"
  | "TripsHeroModulePossiblePackageHFTrip"
  | "TripsHeroModulePossibleTrip"
  | "TripsHeroModulePotentialTrip"
  | "TripsHeroModuleUpcomingTrip"
  | "TripsItemDetailViewed"
  | "TripsListViewed"
  | "TripsModuleDestinationGuide"
  | "TripsModuleRecommendedActivity"
  | "TripsModuleRecommendedCar"
  | "TripsModuleRecommendedHotel"
  | "TripsOverviewViewed"
  | "TripsTravelPlannerItinNumberPresent"
  | "Unknown";

/** The ExitIntent coupon popup for Lodging SRP */
export type ExitIntent = {
  __typename?: "ExitIntent";
  /** The background image for the popup itself */
  backgroundImageUrl?: Maybe<Scalars["String"]>;
  /** A link to open the coupon terms and conditions */
  clickHereLinkUrl?: Maybe<Scalars["String"]>;
  /** The URL of the brand/POS being shopped on */
  logoUrl?: Maybe<Scalars["String"]>;
  /** The data model for the text content */
  message: ExitIntentMessage;
};

/** The text content related to ExitIntent */
export type ExitIntentMessage = {
  __typename?: "ExitIntentMessage";
  /** Messaging to be paired with the clickHereLinkUrl to open the full terms and conditions */
  clickHere?: Maybe<Scalars["String"]>;
  /** The coupon code to be used during checkout */
  couponCode?: Maybe<Scalars["String"]>;
  /** First line of the popup heading */
  headingOne?: Maybe<Scalars["String"]>;
  /** The heading paired with the coupon code */
  headingThree?: Maybe<Scalars["String"]>;
  /** Second line of the popup heading */
  headingTwo?: Maybe<Scalars["String"]>;
  /** The discount percentage message */
  percentOff?: Maybe<Scalars["String"]>;
  /** First line of the terms and conditions short message */
  termsAndConditionsOne?: Maybe<Scalars["String"]>;
  /** Second line of the terms and conditions short message */
  termsAndConditionsTwo?: Maybe<Scalars["String"]>;
};

export type ExpLineOfBusiness =
  | "ACTIVITIES"
  | "CAR"
  | "CRUISES"
  | "FLIGHT"
  | "GROUNDTRANSFERS"
  | "HOTEL"
  | "PACKAGES"
  | "RAILS"
  | "UNCLASSIFIED";

export type ExpandButton = {
  __typename?: "ExpandButton";
  collapseButton: Scalars["String"];
  expandButton: Scalars["String"];
};

/** For limiting the amount of options a filter can show by default */
export type ExpandoPeekOptions = {
  __typename?: "ExpandoPeekOptions";
  /** The amount of filter options to show */
  hiddenThreshold: Scalars["Int"];
  seeLessLabel: Scalars["String"];
  seeMoreLabel: Scalars["String"];
};

/** Specifies the position of the trigger icon  */
export type ExpandoTriggerPosition = "LEADING" | "TRAILING";

/** Represents the experience data of click stream event */
export type Experience = {
  __typename?: "Experience";
  appName: Scalars["String"];
  appVersion: Scalars["String"];
  pageName: Scalars["String"];
  pageNameDetailed: Scalars["String"];
};

/** An exposure to an abacus experiment */
export type Exposure = {
  __typename?: "Exposure";
  /** The experiment bucket of the exposure */
  bucket: Scalars["Int"];
  /** The numeric Abacus ID for an experiment */
  id: Scalars["String"];
};

/** An exposure to an abacus experiment */
export interface ExposureInput {
  /** The experiment bucket of the exposure */
  bucket: Scalars["Int"];
  /** The numeric Abacus ID for an experiment */
  id: Scalars["String"];
}

export type FacetType = "BUTTON" | "CHECKBOX" | "RADIO" | "SLIDER";

export interface FailureReason {
  description: Scalars["String"];
  message: Scalars["String"];
}

/** Represents the action in the price lockup depending the state of the fare */
export type FareAction = {
  __typename?: "FareAction";
  /** Represents the action in the fare card */
  action: FlightsActionButton;
  /** Represents the states for which this action will be rendered */
  states: Array<FareState>;
};

/** Represents dynamic element associated with fare choices */
export type FareChoiceInformationDynamicElement = {
  __typename?: "FareChoiceInformationDynamicElement";
  /** Represents the total price per person of a particular fare combination */
  farePricePerPerson: Scalars["String"];
};

/** Summary of the selected fare and an option to either see details or change fare, in case there are no amenities bag details will be sent */
export type FareDetails = {
  __typename?: "FareDetails";
  /** Fees for Cancellation and changes */
  changeAndCancellationFees?: Maybe<FlightsChangeAndCancellationFees>;
  /** Policies for Cancellation and changes */
  changePolicies?: Maybe<FlightsTextSection>;
  /** Default detailed baggage information shown when upsell and amenities does not exist for base fare */
  defaultBaggageInformation?: Maybe<FlightsBaggageInformation>;
  /**
   * Preview link details of Seat Map for the selected fare.
   * @deprecated Use ancillarySummaryCard query for Seat Map in the selected fare.
   */
  fareSeatMapInformation?: Maybe<FareSeatMapInformation>;
  /** Name of the fare with an option to change it or see the details of the amenities */
  fareSummary?: Maybe<FareSummary>;
};

/** Represents the data to be rendered at the top of the fare card */
export type FareHeading = {
  __typename?: "FareHeading";
  /** Represents the badge to render in the fare card */
  badge?: Maybe<EgdsBadge>;
  /** Represents fare details such as the cabin class */
  fareDetails?: Maybe<Array<EgdsText>>;
  /** Represents the list of price lockups to render */
  farePricing: Array<FarePricing>;
};

/** Represents the fare card to be rendered inside the fares carousel */
export type FareInformationCard = {
  __typename?: "FareInformationCard";
  /** Represents a11y string to read on the whole card */
  accessibilityMessage?: Maybe<Scalars["String"]>;
  /** Represents the list of actions to render in the card depending the card state */
  action: Array<FareAction>;
  /** Represents the amenities to show in the fare card */
  amenities: FlightsCategorizedList;
  /**
   * Represents the analytics if this fare is clicked
   * @deprecated Not needed as we now use the analytics from the action button on the fare card
   */
  clickEventAnalytics?: Maybe<Array<ClientSideAnalytics>>;
  /** Represents fare details such as the cabin class */
  fareDetails: Array<EgdsText>;
  /** fare's a featured header, like Good value */
  featuredHeader?: Maybe<Scalars["String"]>;
  /** Represents the heading area for the fares card */
  heading: FareHeading;
  /** Indicates whether the Fare is selected for this Journey */
  highlighted: Scalars["Boolean"];
  /** Represents price match promise presentation in the fare card */
  priceMatchPromise?: Maybe<FarePriceMatchPromisePresentation>;
  /** Represents the analytics to trigger when the fare is scrolled to */
  scrollAnalytics: Array<ClientSideAnalytics>;
  /** Represents the default state of the card from the server */
  state: FareState;
};

/** Represents a pmp card */
export interface FarePriceMatchPromiseCard {
  /** Represents the header of the pmp card */
  header: EgdsGraphicText;
  /**
   * Represents the heading of the pmp card
   * @deprecated Use header which uses EGDSGraphicText instead of heading which uses EGDSIconText
   */
  heading: EgdsIconText;
  /** Represents onView analytics for a selection pmp card. This will be triggered when this card is visible on the client's viewport */
  onDisplayAnalytics: Array<ClientSideAnalytics>;
  /** State where the current PMP presentation card will be rendered */
  priceMatchPromiseState: PriceMatchPromiseState;
  /** Represents the subheading of the pmp card */
  subHeading: Scalars["String"];
}

/** Represents the pmp presentation */
export type FarePriceMatchPromisePresentation = {
  __typename?: "FarePriceMatchPromisePresentation";
  /** Represents the list of PMP cards to render */
  cards: Array<FarePriceMatchPromiseCard>;
  /** Base state of PMP module from experience layer */
  priceMatchPromiseState: PriceMatchPromiseState;
};

/** Represents the selectable pmp card */
export type FarePriceMatchPromiseRemovableCard = FarePriceMatchPromiseCard & {
  __typename?: "FarePriceMatchPromiseRemovableCard";
  /** Represents the header of the pmp card */
  header: EgdsGraphicText;
  /**
   * Represents the heading of the pmp card
   * @deprecated Use header which uses EGDSGraphicText instead of heading which uses EGDSIconText
   */
  heading: EgdsIconText;
  /** Represents onView analytics for a selection pmp card. This will be triggered when this card is visible on the client's viewport */
  onDisplayAnalytics: Array<ClientSideAnalytics>;
  /** States when this PMP presentation card will be rendered */
  priceMatchPromiseState: PriceMatchPromiseState;
  /** Represents the link for removing pmp only provided when PMP is applied and can be removed */
  removeAction: FlightsActionLink;
  /** Represents the subheading of the pmp card */
  subHeading: Scalars["String"];
};

/** Represents the selectable pmp card */
export type FarePriceMatchPromiseSelectableCard = FarePriceMatchPromiseCard & {
  __typename?: "FarePriceMatchPromiseSelectableCard";
  /** Represents the checkbox for toggling pmp */
  checkbox: FlightsActionCheckbox;
  /** Represents the header of the pmp card */
  header: EgdsGraphicText;
  /**
   * Represents the heading of the pmp card
   * @deprecated Use header which uses EGDSGraphicText instead of heading which uses EGDSIconText
   */
  heading: EgdsIconText;
  /** Represents the trigger for the pmp info dialog */
  infoTrigger: FlightsDialogTrigger;
  /** Represents onView analytics for a selection pmp card. This will be triggered when this card is visible on the client's viewport */
  onDisplayAnalytics: Array<ClientSideAnalytics>;
  /** Represents the price for selecting pmp */
  price: Scalars["String"];
  /** States when this PMP presentation card will be rendered */
  priceMatchPromiseState: PriceMatchPromiseState;
  /** Represents the subheading of the pmp card */
  subHeading: Scalars["String"];
};

/** Represents the selectable pmp card */
export type FarePriceMatchPromiseStaticCard = FarePriceMatchPromiseCard & {
  __typename?: "FarePriceMatchPromiseStaticCard";
  /** Represents the header of the pmp card */
  header: EgdsGraphicText;
  /**
   * Represents the heading of the pmp card
   * @deprecated Use header which uses EGDSGraphicText instead of heading which uses EGDSIconText
   */
  heading: EgdsIconText;
  /** Represents onView analytics for a selection pmp card. This will be triggered when this card is visible on the client's viewport */
  onDisplayAnalytics: Array<ClientSideAnalytics>;
  /** States when this PMP presentation card will be rendered */
  priceMatchPromiseState: PriceMatchPromiseState;
  /** Represents the subheading of the pmp card */
  subHeading: Scalars["String"];
};

/** Represents the priceLockup to be rendered depending on the state */
export type FarePricing = {
  __typename?: "FarePricing";
  /** Represents the add-ons that apply to the fare */
  addOnIcons?: Maybe<Array<Icon>>;
  /** Represents the price lockup in the fare card */
  priceLockup: EgdsPriceLockup;
  /** Represents the price section in the fare card */
  priceSection?: Maybe<FlightsDetailsAndFaresPriceSection>;
  /** Represents the states list for which this price lockup would be rendered */
  states: Array<FareState>;
};

/** Represents various alert dialog to be shown related to seat map selection action */
export type FareSeatMapAlertDialog = {
  __typename?: "FareSeatMapAlertDialog";
  /** Represents alert dialog for any condition not fulfilled */
  alert: FlightsDialogStandard;
  /** Id of the alert dialog to be mapped with type of dialog. Example: 'SEAT_MAP_NEXT_FLIGHT' */
  id: FlightsActionType;
};

export type FareSeatMapAvailableFlightLegSelection = {
  __typename?: "FareSeatMapAvailableFlightLegSelection";
  /** Represents error analytics to be fired for the object when there is an error. */
  errorAnalytics: FlightsAnalytics;
  /** Unique identifier for the air segment selected */
  identifier: Scalars["String"];
  /** Boolean Value to depict the selected card */
  isSelected: Scalars["Boolean"];
  /** Represents seat map summary like traveler information for each flight in trip */
  seatMapLegSummary?: Maybe<FlightsSeatMapLegSummary>;
  /** Represents unique seat attributes for air segment selected */
  seatSegment?: Maybe<SeatSegment>;
  /** Details of Card when selected */
  selectedCard: FlightsIconPlacard;
  /** Details of Card when unselected */
  unselectedCard: FlightsIconPlacard;
};

export type FareSeatMapAvailableFlightLegsDetails = {
  __typename?: "FareSeatMapAvailableFlightLegsDetails";
  /** List of all the available flight leg lists with seat maps */
  flightLegSelectionList: Array<FareSeatMapAvailableFlightLegSelection>;
  /** Unique identifier for the air offer selected */
  offerIdentifier: Scalars["String"];
  /** Represents onView analytics for the object. This will be triggered when the list is opened on the client's viewport */
  onViewedAnalytics?: Maybe<Array<FlightsAnalytics>>;
  /** Represents pricing construct containing price related information. Ex: '[AA.QNNF00S7:SEADEL][AA.QNNF00S7CH:SEADEL][AA.QNNF00S7CH:SEADEL]{BFSDiag}{FC}11JUL21SEA AA X/LON BA DEL M318.00NUC318.00END ROE1.000000{/FC}{DollarAfc}{/DollarAfc}{/BFSDiag}{Published}' */
  pricingConstruct?: Maybe<Scalars["String"]>;
};

export type FareSeatMapDynamicElement = {
  __typename?: "FareSeatMapDynamicElement";
  /** Details about the drop down menu containing Flights leg list */
  flightLegsDetails?: Maybe<FareSeatMapAvailableFlightLegsDetails>;
  /** Analytics when seat map is displayed or removed on selection of an upsell */
  onSelectAnalytics: Array<FlightsAnalytics>;
};

/** Seat Map Details for the selected fare if available otherwise null */
export type FareSeatMapInformation = {
  __typename?: "FareSeatMapInformation";
  /** @deprecated This field is now deprecated., replace with Use baseOfferAncillaryID */
  ancillaryId?: Maybe<Scalars["String"]>;
  /** Link to open Preview Seat Map dialog, Example: See seat map */
  details?: Maybe<FlightsAction>;
  /** Flag to enable and disable seat selection based on abacus */
  enableSeatSelection?: Maybe<Scalars["Boolean"]>;
  /** @deprecated This field is now deprecated., replace with Use the sibling node with list of FlightsSeatSelectionErrorMessage */
  errorMessage?: Maybe<Scalars["String"]>;
  /** Represents list of error messages for seat selection failures. Example: 'Your seats could not be selected. Please try again.' */
  errorMessages?: Maybe<Array<FlightsSeatSelectionErrorMessage>>;
  /** Seat Map View Details containing various components like SeatMap Legends, Leg Selection DropDown and actual Seat Map */
  fareSeatMapViewDetails?: Maybe<FareSeatMapViewDetails>;
  /** Message informing user about the different sections in the preview, ex: Seat Map Cabin, Main */
  message: Scalars["String"];
  /** Represents Details of seat selected and marked on details page */
  selectedSeatDetails?: Maybe<Array<FlightsSelectedSeatDetail>>;
  /** Represents the number of skeleton while seat selection is loading post seat selection by traveler while waiting for update calls to sharedUI */
  skeletonCount: Scalars["Int"];
  /** Heading of the seat map section. ex: Seat(s)/Select Seat(s)/Seat map */
  title: Scalars["String"];
};

/** Legends details for the Seat Map */
export type FareSeatMapLegendsInformation = {
  __typename?: "FareSeatMapLegendsInformation";
  /** Message used to describe seatMap legends for screen readers */
  accessibilityMessage: Scalars["String"];
  /** Dismiss legend dialog view related analytics */
  dismissSeatMapLegends?: Maybe<FlightsAnalytics>;
  /** Represents the legend component. */
  legendDetails: FlightsSeatMapLegends;
  /** View Legends Button on mobile */
  viewLegendButton?: Maybe<FlightsActionableIcon>;
};

export type FareSeatMapViewDetails = {
  __typename?: "FareSeatMapViewDetails";
  /** Describes icon to dismiss seat map dialog */
  dismissSeatMapDialog: FlightsActionableIcon;
  /** Represents the error message to be shown in case of downstream failure or timeout. Ex: Sorry, please try again. */
  errorMessage?: Maybe<FlightsIconPlacard>;
  /** Complete details of all the Legends available with SeatMap */
  fareSeatMapLegendsInformation?: Maybe<FareSeatMapLegendsInformation>;
  /** Details about the drop down menu containing Flights leg list */
  flightLegsDetails?: Maybe<FareSeatMapAvailableFlightLegsDetails>;
  /** Accessibility Message when seat map view is displayed on screen */
  onLoadAccessibilityMessage?: Maybe<Scalars["String"]>;
  /** Represents various alert dialog to be shown related to seat map selection action */
  seatMapAlertDialog?: Maybe<Array<FareSeatMapAlertDialog>>;
  /** Represents the analytics for metrics related to seatMapDialog */
  seatMapDialogAnalyticsList?: Maybe<Array<FlightsAnalytics>>;
  /** Heading of the seat preview dialog. ex: Seat Map */
  title: Scalars["String"];
};

/** Represents the state of the fare */
export type FareState =
  /** Fare is selected */
  | "SELECTED"
  /** Fare is selected with PMP */
  | "SELECTED_PMP_SELECTED"
  /** Fare is unselected */
  | "UNSELECTED"
  /** Fare is unselected with PMP */
  | "UNSELECTED_PMP_SELECTED";

/** Name of the fare with an option to change it or see the details of the amenities */
export type FareSummary = {
  __typename?: "FareSummary";
  /** Link to either change fare or show details, the action for both of them is same, ex: Change Fare or Show Details */
  details: FlightsAction;
  /** Details and fares for the selected journey, null for single fare without amenities */
  detailsAndFares?: Maybe<FlightsDetailsAndFaresPresentation>;
  /** Message that gives option to upgarde the fare ex: Upgrade to get free seats */
  flightsFareNudgeMessage?: Maybe<FlightsIconAndLabel>;
  /**
   * Fare summary and details for a Journey, null for bargain fares and single fare without amenities
   * @deprecated Replaced with details and fares node
   */
  flightsSelectedJourneyAvailableFaresInformation?: Maybe<FlightsSelectedJourneyAvailableFares>;
  /** Message informing user about the applicability of fare if there are multiple pax, ex: Your selection applies to each traveler */
  message: Scalars["String"];
  /** Selected fare name, ex: Fare: Basic Economy */
  title: Scalars["String"];
  /** Flag to determine whether Upsell Nudging is Enabled or not */
  upsellNudgingFeatureEnabled: Scalars["Boolean"];
};

/** Represents the analytics for loading of fares on side sheet */
export type FaresTypesLoadingAnalytics = {
  __typename?: "FaresTypesLoadingAnalytics";
  /** Represents the click analytics on inactive continue button on sidesheet  */
  continueButtonOnClickAnalytics: FlightsAnalytics;
  /** Represents the display analytics if fare options failed to display after loading state */
  faresLoadErrorAnalytics: FlightsAnalytics;
  /** Represents the display analytics if fare options are displayed in loading state */
  faresLoadingDisplayedAnalytics: FlightsAnalytics;
  /** Represents the loading time analytics for fares on sidesheet */
  faresLoadingTimeAnalytics: FlightsAnalytics;
};

/** Minimum set of data used to retrieve details about a property product */
export type FederationPropertyNaturalKey = {
  __typename?: "FederationPropertyNaturalKey";
  checkIn: FederationPropertyNaturalKeyDate;
  checkOut: FederationPropertyNaturalKeyDate;
  id: Scalars["String"];
  inventoryType: InventoryType;
  noCreditCard?: Maybe<Scalars["Boolean"]>;
  ratePlanId: Scalars["String"];
  ratePlanType?: Maybe<Scalars["String"]>;
  roomTypeId: Scalars["String"];
  rooms: Array<FederationPropertyNaturalKeyRoom>;
  shoppingPath?: Maybe<ShoppingPathType>;
};

/** Copy of the shared Date type, but with federation info. Used in federation to @requires data in other spinners */
export type FederationPropertyNaturalKeyDate = {
  __typename?: "FederationPropertyNaturalKeyDate";
  /** The day of the month, e.g. `1` for the 1st */
  day: Scalars["Int"];
  /** The numeric month, e.g. `1` for January */
  month: Scalars["Int"];
  /** The four-digit year e.g. `1999` */
  year: Scalars["Int"];
};

/** Indicates how many rooms will be occupied and by whom. Used in federation to @requires data in other spinners */
export type FederationPropertyNaturalKeyRoom = {
  __typename?: "FederationPropertyNaturalKeyRoom";
  childAges: Array<Scalars["Int"]>;
  numberOfAdults: Scalars["Int"];
};

export type FeeType =
  | "CARD_ON_FILE_DAMAGE_LIABILITY"
  | "DEFAULT"
  | "DEFAULT_SUPPLIER_COLLECTED"
  | "GROUPED_MANDATORY_FEES"
  | "L26_TAX_BREAKOUT"
  | "NORMAL"
  | "OTHER"
  | "PER_PERSON_PER_NIGHT"
  | "PROPERTY"
  | "REFUNDABLE_DAMAGE_DEPOSIT"
  | "RESORT";

export type Feedback = {
  __typename?: "Feedback";
  /** Action details for feedback */
  action?: Maybe<FeedbackAction>;
};

export type FeedbackAction = {
  __typename?: "FeedbackAction";
  /** Action text displayed for button */
  text?: Maybe<Scalars["String"]>;
};

/** Message to display for property reviews a11y label. */
export type FeedbackIndicator = AccessibilityField & {
  __typename?: "FeedbackIndicator";
  /** Label where a11y behavior is needed. */
  accessibilityLabel?: Maybe<Scalars["String"]>;
  /**
   * Message to display.
   * @deprecated Use accessibilityLabel, replace with accessibilityLabel
   */
  label?: Maybe<Scalars["String"]>;
};

export type FeedbackOption = {
  __typename?: "FeedbackOption";
  inputHeading: Scalars["String"];
  inputTextPlaceholder: Scalars["String"];
  option: CarActionableItem;
};

export type Fees = {
  __typename?: "Fees";
  description?: Maybe<Scalars["String"]>;
  id?: Maybe<Scalars["Int"]>;
  inSaleCurrency?: Maybe<Scalars["Boolean"]>;
  included?: Maybe<Scalars["Boolean"]>;
  price?: Maybe<Money>;
  type?: Maybe<FeeType>;
};

/** Contains information to pre-filter a flight search */
export type FilterCard = EgdsCarouselItem & {
  __typename?: "FilterCard";
  /** Action buttons to go to next card or skip all the sections */
  actions: Array<EgdsButton>;
  /** List of filter options to be selected */
  filters: Array<EgdsButton>;
  /** Description of the option that will be shown */
  heading: Scalars["String"];
  /** Pre-filter card identifier */
  id?: Maybe<Scalars["String"]>;
  /** Illustration to display for this specific card */
  illustration: Illustration;
  /** Pagination index text */
  pageIndex: Scalars["String"];
  /** Personal prefix text */
  subheading: Scalars["String"];
};

/** Filter item for cruise typeahead search request */
export type FilterItem = {
  __typename?: "FilterItem";
  /**
   * Filter item field type
   * Example: entity.metadata.cruiseLineDeepLink or entity.metadata.linkedDestination
   */
  field: Scalars["String"];
  /**
   * Filter item values
   * Example: cruiseLine [royal, princess] or destination [bahamas, europe]
   */
  values: Array<Scalars["String"]>;
};

export type FilterOption = UiToggle & {
  __typename?: "FilterOption";
  checked: Scalars["Boolean"];
  checkedAccessibilityLabel?: Maybe<Scalars["String"]>;
  checkedAnalytics?: Maybe<ClientSideAnalytics>;
  checkedDescription?: Maybe<Scalars["String"]>;
  checkedLabel: Scalars["String"];
  enabled: Scalars["Boolean"];
  label: Scalars["String"];
  uncheckedAccessibilityLabel?: Maybe<Scalars["String"]>;
  uncheckedAnalytics?: Maybe<ClientSideAnalytics>;
  uncheckedDescription?: Maybe<Scalars["String"]>;
  uncheckedLabel: Scalars["String"];
};

export type FilterOptionRange = {
  __typename?: "FilterOptionRange";
  max?: Maybe<Scalars["Float"]>;
  min?: Maybe<Scalars["Float"]>;
};

/** Enum class to represent the type of flexible change policies */
export type FilterPolicyType = "NO_CHANGE_FEE";

/** Enum class to represent the type of travel and baggage */
export type FilterTravelAndBaggageType =
  | "CARRY_ON_BAG"
  | "FIRST_CHECKED_BAG"
  | "NO_CANCEL_FEE"
  | "NO_CHANGE_FEE"
  | "SEAT_CHOICE";

export type FilterViewModel = {
  __typename?: "FilterViewModel";
  /** @deprecated No longer used, was part of a losing variant in tnl 42928 */
  dropdownOptions?: Maybe<ShowDropdownOptions>;
  graphic?: Maybe<UiGraphic>;
  isRange?: Maybe<Scalars["Boolean"]>;
  label?: Maybe<Scalars["String"]>;
  max?: Maybe<Scalars["Int"]>;
  min?: Maybe<Scalars["Int"]>;
  /** @deprecated This field will be deprecated in the future, use title instead */
  name: Scalars["String"];
  options: Array<OptionViewModel>;
  placeholder?: Maybe<Scalars["String"]>;
  /**
   * threshold for displaying expand/collapse for sort/filter options
   * @deprecated This value has been refactored into showListOptions and is no longer used
   */
  seeMoreOptionsToggleThreshold?: Maybe<Scalars["Int"]>;
  selected: Scalars["Boolean"];
  showListOptions?: Maybe<ExpandoPeekOptions>;
  step?: Maybe<Scalars["Int"]>;
  subLabel?: Maybe<Scalars["String"]>;
  title: Scalars["String"];
};

/** This represents the filters data */
export type Filters = {
  __typename?: "Filters";
  /** This represents the EGDS filter component */
  filters: ShoppingSortAndFilters;
};

/** This represents the filters data when search fails */
export type FiltersFailure = {
  __typename?: "FiltersFailure";
  /** This represents the filters title */
  title: EgdsStylizedText;
};

/** This represents the filters data when search is loading */
export type FiltersSkeletons = {
  __typename?: "FiltersSkeletons";
  /** Placeholder for inner properties */
  text: Scalars["String"];
};

/** Wrapper to display pre-filtering section */
export type FiltersWrapper = {
  __typename?: "FiltersWrapper";
  /** Carousel to display FilterCards */
  carousel: EgdsCarousel;
  /** Filtering introductory message */
  heading: Scalars["String"];
};

/** Representation of the Find Answers dialog containing a search form querying property details and reviews. */
export type FindAnswersDialog = {
  __typename?: "FindAnswersDialog";
  /** Name of the dialog; intent is to indicate route param. */
  dialogName: Scalars["String"];
  /** Representation of the top header bar of a UDS dialog. */
  header: LodgingDialogToolbar;
  /** Trigger that will open the dialog. */
  trigger: FindAnswersDialogTrigger;
};

/** Interface for triggers opening the Find Answers dialog. */
export interface FindAnswersDialogTrigger {
  /** Client analytics data. */
  clientSideAnalytics?: Maybe<ClientSideAnalytics>;
}

export type FindAnswersMessage = {
  __typename?: "FindAnswersMessage";
  dialog: FindAnswersDialog;
  supportingText?: Maybe<Scalars["String"]>;
};

export type FlavorType = "DEMO" | "INT" | "LAB" | "PROD" | "SANDBOX";

/** Controls the alignment along the cross axis. */
export type FlexAlignItems = "CENTER" | "END" | "START" | "STRETCH";

/** The direction children items are placed inside the flex container, it determines the direction of the main axis (and the cross axis, perpendicular to the main axis). */
export type FlexDirection = "ROW";

/** Controls the alignment along the main axis. */
export type FlexJustifyContent = "CENTER" | "END" | "SPACE_AROUND" | "SPACE_BETWEEN" | "START";

/** Controls whether the flex container is single-line or multi-line, and the direction of the cross axis. */
export type FlexWrap = "NOWRAP";

/** The core criteria needed for a flex search */
export type FlexibleSearchCriteria = {
  __typename?: "FlexibleSearchCriteria";
  /** A list of months represented by their integer values, e.g. 1 -> January, 2 -> February, etc. */
  flexibleSearchMonths?: Maybe<Array<Scalars["Int"]>>;
  /** The type of flexible search trip duration, e.g. Weekend, Week, Month */
  flexibleSearchTripDurationType?: Maybe<FlexibleSearchTripDurationType>;
  /** The number of days that a traveler's selected check-in date is flexible by */
  numFlexibleDays?: Maybe<Scalars["Int"]>;
};

/** The core criteria needed for a flex search */
export interface FlexibleSearchCriteriaInput {
  /** A list of months represented by their integer values, e.g. 1 -> January, 2 -> February, etc. */
  flexibleSearchMonths?: InputMaybe<Array<Scalars["Int"]>>;
  /** The type of flexible search trip duration, e.g. Weekend, Week, Month */
  flexibleSearchTripDurationType?: InputMaybe<FlexibleSearchTripDurationType>;
  /** The number of days that a traveler's selected check-in date is flexible by */
  numFlexibleDays?: InputMaybe<Scalars["Int"]>;
}

/** The trip duration type for the flex search */
export type FlexibleSearchTripDurationType = "MONTH" | "WEEK" | "WEEKEND";

/** Represents the ancillaries available along with the applicable traveler */
export type FlightAncillariesPerTraveler = {
  __typename?: "FlightAncillariesPerTraveler";
  /** Contains the ancillary information for a traveler */
  ancillaryOptions?: Maybe<Array<FlightSelectableAncillary>>;
  /** Error message in case ancillary is not available for a particular traveler type | eg: Bags are not available for an infant */
  errorMessage?: Maybe<EgdsText>;
  /**
   * Represents Traveler identifier
   * @deprecated This must be replaced by travellerIdentifier because when there is only one traveller we do not show heading
   */
  heading: EgdsHeading;
  /** Represents traveler index */
  travelerIndex: Scalars["Int"];
  /** Represents Traveler identifier */
  travellerIdentifier?: Maybe<EgdsText>;
};

export type FlightAncillaryBagSelection = {
  __typename?: "FlightAncillaryBagSelection";
  /** Represents count of options available for corresponding bag */
  availableOptionsCount?: Maybe<Scalars["Int"]>;
  /** Represents index of the selected bag */
  selectedBagIndex: Scalars["Int"];
  /** Represents the price of selected bag */
  selectedBagPrice?: Maybe<Scalars["Float"]>;
};

export interface FlightAncillaryBagSelectionInput {
  /** Represents count of options available for corresponding bag */
  availableOptionsCount?: InputMaybe<Scalars["Int"]>;
  /** Represents index of the selected bag */
  selectedBagIndex: Scalars["Int"];
  /** Represents the price of selected bag */
  selectedBagPrice?: InputMaybe<Scalars["Float"]>;
}

/** Represents details of air ancillary selections for a journey */
export type FlightAncillaryJourneySelection = {
  __typename?: "FlightAncillaryJourneySelection";
  /** Represents the state of `apply same ancillaries for all travellers` checkbox */
  applySameAncillaryForAllTravellers: Scalars["Boolean"];
  /** It's contains the count of included checked bag */
  checkedBagIncluded?: Maybe<Scalars["Int"]>;
  /** Represents list of selected ancillaries for each traveller */
  flightAncillaryTravelerSelections: Array<FlightAncillaryTravelerSelection>;
  /** Represents index of the journey */
  journeyIndex: Scalars["Int"];
};

/** Represents details of air ancillary selections for a journey */
export interface FlightAncillaryJourneySelectionInput {
  /** Represents the state of `apply same ancillaries for all travellers` checkbox */
  applySameAncillaryForAllTravellers: Scalars["Boolean"];
  /** It's contains the count of included checked bag */
  checkedBagIncluded?: InputMaybe<Scalars["Int"]>;
  /** Represents list of selected ancillaries for each traveller */
  flightAncillaryTravelerSelections: Array<FlightAncillaryTravelerSelectionInput>;
  /** Represents index of the journey */
  journeyIndex: Scalars["Int"];
}

/** Represents list of selected ancillaries for a traveller */
export type FlightAncillaryTravelerSelection = {
  __typename?: "FlightAncillaryTravelerSelection";
  /** Represents sequence index of the combined ancillaries in cache */
  combinedAncillaryIndex?: Maybe<Scalars["Int"]>;
  /** Represents list of selected bags */
  flightAncillaryBagSelections: Array<FlightAncillaryBagSelection>;
  /** Represents index of the traveller */
  travelerIndex: Scalars["Int"];
};

/** Represents list of selected ancillaries for a traveller */
export interface FlightAncillaryTravelerSelectionInput {
  /** Represents sequence index of the combined ancillaries in cache */
  combinedAncillaryIndex?: InputMaybe<Scalars["Int"]>;
  /** Represents list of selected bags */
  flightAncillaryBagSelections: Array<FlightAncillaryBagSelectionInput>;
  /** Represents index of the traveller */
  travelerIndex: Scalars["Int"];
}

/** Fee schedule for baggage (e.g. '2nd checked bag: $50') */
export type FlightBaggageInformationDetail = {
  __typename?: "FlightBaggageInformationDetail";
  /** description for the baggage information item */
  baggageDetail: Scalars["String"];
  /**
   * description for the baggage information item
   * @deprecated Will start sending all details for baggage in baggageDetail node
   */
  detail: Scalars["String"];
  /** Label for the baggage information item.Example: '2nd checked bag' */
  topic: Scalars["String"];
  /** value and unit, so that they are kept together in line wraps */
  unit?: Maybe<Scalars["String"]>;
};

export type FlightCabinClassInfo = "BUSINESS" | "COACH" | "FIRST" | "PREMIUM_ECONOMY";

/** Flight cabin class */
export type FlightClass = "BUSINESS" | "ECONOMY" | "FIRST_CLASS" | "PREMIUM_ECONOMY";

/** Cost percentiles to fly between an origin and a destination. */
export type FlightCost = {
  __typename?: "FlightCost";
  /** Cost percentiles by departure month. */
  byDepartureMonth: Array<CostPercentilesByMonth>;
  /** Cost percentiles aggregated over a year. */
  yearly?: Maybe<CostPercentiles>;
};

/** Represents cross sell product types that will be displayed */
export type FlightCrossSellProductType = "CAR" | "HOTEL";

export type FlightDestinationInsights = {
  __typename?: "FlightDestinationInsights";
  /** Destinations to where there are nonstop flights from a given origin (airport code). Results can be filtered by a destination higher level region. */
  nonStop: FlightDestinationResults;
  /** Destinations to travel to from a given origin (airport code) sorted by annual popularity, or optionally filtered by month. */
  popular: Array<InsightsDestination>;
  /** Destinations to where there are flights from a given origin (airport code) under a given maximum cost (when compared against 20th cost percentiles aggregated over a historical sample of flights).Results can be filtered by a destination higher level region. */
  underCost: FlightDestinationResults;
  /** Destinations to where there are flights from a given origin (airport code) under a given duration (in minutes).Results can be filtered by a destination higher level region. */
  underDuration: FlightDestinationResults;
};

export type FlightDestinationInsightsNonStopArgs = {
  destinationHLR?: InputMaybe<Scalars["String"]>;
  maxResults?: InputMaybe<Scalars["Int"]>;
};

export type FlightDestinationInsightsPopularArgs = {
  maxResults?: InputMaybe<Scalars["Int"]>;
  month?: InputMaybe<MonthId>;
};

export type FlightDestinationInsightsUnderCostArgs = {
  destinationHLR?: InputMaybe<Scalars["String"]>;
  maxCost: Scalars["Int"];
  maxResults?: InputMaybe<Scalars["Int"]>;
};

export type FlightDestinationInsightsUnderDurationArgs = {
  destinationHLR?: InputMaybe<Scalars["String"]>;
  maxDuration: Scalars["Int"];
  maxResults?: InputMaybe<Scalars["Int"]>;
};

/** Flight destination airports */
export type FlightDestinationResults = {
  __typename?: "FlightDestinationResults";
  /** Domestic flight destination airports */
  domestic: Array<Maybe<InsightsAirport>>;
  /** International flight destination airports */
  international: Array<Maybe<InsightsAirport>>;
};

/** Flight detail in response */
export type FlightDetail = {
  __typename?: "FlightDetail";
  carrier: Scalars["String"];
  departureDate: Scalars["String"];
  destination: Scalars["String"];
  origin: Scalars["String"];
  preferredClass: FlightClass;
  travelerDetails: Array<TravelerDetailsForItinerary>;
};

export type FlightInsights = {
  __typename?: "FlightInsights";
  /** Get cost percentiles to fly between an origin (airport code or country gaia id) and a destination (airport code), optionally filtered by carrier. All cost percentiles are aggregated over a historical sample of round-trip flight searches.  */
  cost?: Maybe<FlightCost>;
  /** Get cost percentiles to fly between an origin (airport code) and a destination (airport code) when booked within an advance purchase window, where an advance purchase window is the number of weeks prior to the departure date. */
  purchaseWindowCost: Array<CostPercentilesByWeek>;
  /** Get a flight summary of the shortest flight between the given origin (airport code) and destination (airport code), optionally filtered by carrier. */
  shortestFlightSummary?: Maybe<FlightSummary>;
};

export type FlightInsightsCostArgs = {
  carrier?: InputMaybe<Scalars["String"]>;
};

export type FlightInsightsShortestFlightSummaryArgs = {
  carrier?: InputMaybe<Scalars["String"]>;
};

/** Static Ancillary details at appropriate itinerary breakdown level (journeys for bags, segments for seats) */
export type FlightJourneyAncillariesSection = {
  __typename?: "FlightJourneyAncillariesSection";
  /** List of all the informational ancillaries corresponding to the card */
  ancillariesWrapper: FlightsCategorizedList;
  /** Represents list of selected ancillary for travelers' */
  selectedItems?: Maybe<FlightsCategorizedList>;
};

/** Flight details legs information */
export type FlightLeg = {
  __typename?: "FlightLeg";
  /** Arrival airport code */
  arrivalAirport?: Maybe<Scalars["String"]>;
  /** Arrival date */
  arrivalDate?: Maybe<ZonedDateTime>;
  /** Departure airport code */
  departureAirport?: Maybe<Scalars["String"]>;
  /** Departure date */
  departureDate?: Maybe<ZonedDateTime>;
  /** Flight details leg segments */
  segmentList?: Maybe<Array<FlightSegment>>;
  /** Number of stops */
  stopCount?: Maybe<Scalars["Int"]>;
};

/** Minimum set of data used to retrieve details about a flight product */
export type FlightNaturalKey = {
  __typename?: "FlightNaturalKey";
  offerToken: Scalars["String"];
  productTokens: Array<Scalars["String"]>;
  travelers: Array<TravelerDetails>;
};

/** Minimum set of data used to retrieve details about a flight product */
export interface FlightNaturalKeyInput {
  offerToken: Scalars["String"];
  productTokens: Array<Scalars["String"]>;
  travelers: Array<TravelerDetailsInput>;
}

export type FlightOfferItem = OfferItem & {
  __typename?: "FlightOfferItem";
  /** Image for airline logo */
  airlineImage?: Maybe<Image>;
  /** Airline name */
  airlineName?: Maybe<Scalars["String"]>;
  /** Badge to be displayed for the offer */
  badge?: Maybe<CampaignOfferBadge>;
  /** Range of dates the offer is applicable */
  dates?: Maybe<Scalars["String"]>;
  /** Description of the flight offer */
  description?: Maybe<Scalars["String"]>;
  /** destination airport code */
  destinationAirportCode?: Maybe<Scalars["String"]>;
  /** destination city */
  destinationCity?: Maybe<Scalars["String"]>;
  /** flight class */
  flightClass?: Maybe<Scalars["String"]>;
  /** Flight offer price and link */
  flightOffer?: Maybe<OfferData>;
  /** Image for destination of the flight offer */
  image: Image;
  /** Name of the flight where the offer is applicable */
  name: Scalars["String"];
  /** origin airport code */
  originAirportCode?: Maybe<Scalars["String"]>;
  /** origin city */
  originCity?: Maybe<Scalars["String"]>;
  /** Secondary content related to the flight offer */
  secondaryContent?: Maybe<Scalars["String"]>;
  /** trip type */
  tripType?: Maybe<Scalars["String"]>;
};

/** Flight details passengers */
export type FlightPassengers = {
  __typename?: "FlightPassengers";
  /** Number of adults */
  adults?: Maybe<Scalars["Int"]>;
  /** Children ages */
  agesOfChildren?: Maybe<Array<Scalars["Int"]>>;
  /** Number of infant in lap */
  infantsInLap?: Maybe<Scalars["Int"]>;
  /** Number of infant in seat */
  infantsInSeat?: Maybe<Scalars["Int"]>;
};

/** All criteria needed to perform a flight search */
export type FlightSearchCriteria = {
  __typename?: "FlightSearchCriteria";
  primary: PrimaryFlightCriteria;
  secondary?: Maybe<ShoppingSearchCriteria>;
};

/** All criteria needed to perform a flight search */
export interface FlightSearchCriteriaInput {
  primary: PrimaryFlightCriteriaInput;
  secondary?: InputMaybe<ShoppingSearchCriteriaInput>;
}

/** Represents the flight search form */
export type FlightSearchForm = EgdsElement &
  EgdsSearchForm & {
    __typename?: "FlightSearchForm";
    actionURL: Scalars["String"];
    addLeg?: Maybe<EgdsButton>;
    egdsElementId?: Maybe<Scalars["String"]>;
    elements: Array<EgdsSearchFormElement>;
    errorSummary?: Maybe<EgdsErrorSummary>;
    flightTypeSelector: EgdsSearchFormInputField;
    legHeading?: Maybe<EgdsLocalizedText>;
    playback?: Maybe<EgdsSearchPlayback>;
    removeLeg?: Maybe<EgdsButton>;
    search?: Maybe<EgdsButton>;
  };

/** Represents the actual implementation of flight search form used in the page */
export type FlightSearchInputForm = EgdsElement &
  EgdsSearchForm & {
    __typename?: "FlightSearchInputForm";
    /** Represents which page to open on submit of search form */
    actionURL: Scalars["String"];
    /** Represents button to add a leg used only in multi-destination flights */
    addLeg?: Maybe<EgdsButton>;
    /** Represents egds element id */
    egdsElementId?: Maybe<Scalars["String"]>;
    /** Represents various input/selector fields in the search form */
    elements: Array<EgdsSearchFormElement>;
    /** Represents summarized view of errors in the search form */
    errorSummary?: Maybe<EgdsErrorSummary>;
    /** Represents tripType selector */
    flightTypeSelector: EgdsSearchFormInputField;
    /** Represents heading of the leg */
    legHeading?: Maybe<EgdsLocalizedText>;
    /** Represents Change search playback container */
    playback?: Maybe<EgdsSearchPlayback>;
    /** Represents remove leg button */
    removeLeg?: Maybe<EgdsButton>;
    /** Represents search button */
    search?: Maybe<EgdsButton>;
  };

export type FlightSearchMultiItemShoppingAction = MultiItemShoppingAction & {
  __typename?: "FlightSearchMultiItemShoppingAction";
  journeyContinuationId?: Maybe<Scalars["String"]>;
  shoppingContext: ShoppingContext;
};

export type FlightSearchPreferences = {
  __typename?: "FlightSearchPreferences";
  airline?: Maybe<Scalars["String"]>;
  cabinClass: FlightCabinClassInfo;
  isNonStopOnly: Scalars["Boolean"];
  isRefundableOnly: Scalars["Boolean"];
};

/** Flight details leg segment information */
export type FlightSegment = {
  __typename?: "FlightSegment";
  /** Flight details airline information */
  airline?: Maybe<HistoryAirline>;
  /** Arrival airport code */
  arrivalAirport?: Maybe<Scalars["String"]>;
  /** Arrival date */
  arrivalDate?: Maybe<ZonedDateTime>;
  /** Departure airport code */
  departureAirport?: Maybe<Scalars["String"]>;
  /** Departure date */
  departureDate?: Maybe<ZonedDateTime>;
  /** Flight number */
  flightNumber?: Maybe<Scalars["String"]>;
  /** Flight segment duration */
  totalDurationInMinutes?: Maybe<Scalars["String"]>;
};

/** Represents Ancillary information */
export type FlightSelectableAncillary = EgdsRadioGroup & {
  __typename?: "FlightSelectableAncillary";
  errorMessage?: Maybe<Scalars["String"]>;
  /** Baggage group name */
  groupHeading: EgdsText;
  /** @deprecated Use groupHeading as this field needs to be bold */
  groupName: Scalars["String"];
  /** Holds the type of value | eg: None or Valid */
  optionType: FlightSelectableAncillaryOptionValuesType;
  /** Represents all the ancillaries */
  options: Array<FlightSelectableAncillaryOption>;
  selected?: Maybe<Scalars["String"]>;
  /** Represent the subheading for the ancillary. eg: Price per traveler */
  subHeading: EgdsText;
};

/** Represents Ancillary Information Options */
export type FlightSelectableAncillaryOption = EgdsRadioButton & {
  __typename?: "FlightSelectableAncillaryOption";
  description?: Maybe<Scalars["String"]>;
  disabled: Scalars["Boolean"];
  label: Scalars["String"];
  labelSuffix?: Maybe<Scalars["String"]>;
  /** Holds the type of value | eg: None or Valid */
  optionType: FlightSelectableAncillaryOptionValuesType;
  /** Represent the price of the ancillary */
  price: Scalars["Float"];
  /** Represent if the ancillary is selected or not */
  selected: Scalars["Boolean"];
  value: Scalars["String"];
  /** Represents localized weight of each bag */
  weight: Scalars["String"];
};

/** Represent Type for the values of FlightSelectableAncillaryOption */
export type FlightSelectableAncillaryOptionValuesType =
  /** Represents NONE value */
  | "NONE"
  /** Represents a Valid value | eg: upto 15 kg */
  | "VALID";

/** Represents Ancillary information */
export type FlightSelectableBaggageAncillary = EgdsRadioGroup & {
  __typename?: "FlightSelectableBaggageAncillary";
  errorMessage?: Maybe<Scalars["String"]>;
  groupName: Scalars["String"];
  /** Holds the type of value | eg: None or Valid */
  optionType: FlightSelectableAncillaryOptionValuesType;
  /** Represents all the ancillaries */
  options: Array<FlightSelectableBaggageAncillaryOption>;
  selected?: Maybe<Scalars["String"]>;
  /** Represent the subheading for the ancillary. eg: Price per traveler */
  subHeading: Scalars["String"];
};

/** Represents Ancillary Information Options */
export type FlightSelectableBaggageAncillaryOption = EgdsRadioButton & {
  __typename?: "FlightSelectableBaggageAncillaryOption";
  description?: Maybe<Scalars["String"]>;
  disabled: Scalars["Boolean"];
  label: Scalars["String"];
  labelSuffix?: Maybe<Scalars["String"]>;
  /** Holds the type of value | eg: None or Valid */
  optionType: FlightSelectableAncillaryOptionValuesType;
  /** Represents the encoded ancillary token for each selectable bag */
  selectableAncillaryToken: Scalars["String"];
  /** Represent if the ancillary is selected or not */
  selected: Scalars["Boolean"];
  value: Scalars["String"];
  /** Represents localized weight of each bag */
  weight: Scalars["String"];
};

/** Represents a leg in the leg selection dropdown */
export type FlightSelectedLegOption = {
  __typename?: "FlightSelectedLegOption";
  /** Contains the flight actions for a particular leg */
  action: FlightsClientAction;
  /** Contains the label for the leg */
  label: Scalars["String"];
  /** Contains the identifier for the leg */
  selectedJourneyIndex: Scalars["Int"];
};

/** Represents the booking full page empty state presentation */
export type FlightServicingBookingEmptyState = {
  __typename?: "FlightServicingBookingEmptyState";
  /** Represents the EGDS empty state presentation */
  presentation: UiEmptyState;
  /** Represents the pimary action to be taken from the empty state */
  primaryAction: FlightsClientAction;
};

/** Represents the booking failure response */
export type FlightServicingBookingFailure = {
  __typename?: "FlightServicingBookingFailure";
  /** Represents the full page empty state */
  emptyState?: Maybe<FlightServicingBookingEmptyState>;
  /** Represents the configuration for the 3DS challenge */
  encodedChallengeConfig?: Maybe<Scalars["String"]>;
  /** Represents the booking error summary to display when checkout can re-render */
  errorSummary?: Maybe<EgdsErrorSummary>;
  /** Represents the booking errors to display in placards e.g. Price Changes */
  placards?: Maybe<Array<FlightsUiPlacard>>;
};

/** Represents the booking success response */
export type FlightServicingBookingSuccess = {
  __typename?: "FlightServicingBookingSuccess";
  /** Represents the redirect uri to the confirmation view */
  action: FlightsResourceRedirectAction;
};

export type FlightSortAndFilterAppliedFilter = ShoppingSortAndFilterAppliedFilter & {
  __typename?: "FlightSortAndFilterAppliedFilter";
  nextSearchCriteria: ShoppingSearchCriteria;
  pill: UiRemovablePill;
};

/** Flights specific Change selection implementation with link, jcid, label and accessibility */
export type FlightStepIndicatorChangeSelection = StepIndicatorChangeSelection & {
  __typename?: "FlightStepIndicatorChangeSelection";
  a11yLabel: Scalars["String"];
  action: UiLinkAction;
  journeyContinuationId: Scalars["String"];
  label: Scalars["String"];
  multiItemShoppingAction?: Maybe<FlightSearchMultiItemShoppingAction>;
};

/** Flight step indicator label that contains OD pair and icon separator */
export type FlightStepIndicatorLabel = StepIndicatorLabel & {
  __typename?: "FlightStepIndicatorLabel";
  destination: Scalars["String"];
  icon: Icon;
  origin: Scalars["String"];
  text: Scalars["String"];
};

/** A flight summary with a list of stops and a 2-letter IATA code for the carrier or '__' when the flight is on multiple airlines. */
export type FlightSummary = {
  __typename?: "FlightSummary";
  carrier?: Maybe<Scalars["String"]>;
  /** Flown duration (in minutes) is the trip duration minus stops. */
  flownDuration?: Maybe<Duration>;
  /** A list of stops on the trip, if any. */
  stops: Array<InsightsAirport>;
  /** Trip duration (in minutes) is the sum of flown duration and stops. */
  tripDuration?: Maybe<Duration>;
};

/** Represents the class for associating accessibility message with various sort and filter objects */
export type FlightsAccessibilityMessage = {
  __typename?: "FlightsAccessibilityMessage";
  /** Represents the accessibility message to be read when a particular action is complete. Ex. Results now sorted by departure */
  onCompletion?: Maybe<Scalars["String"]>;
  /** Represents the accessibility message with details on description of the item usage. Ex. Sorting the results by duration */
  usage?: Maybe<Scalars["String"]>;
};

/** Describes an actionable area for the next section */
export type FlightsAction = {
  __typename?: "FlightsAction";
  /** Represents accessibility message associated with any action */
  accessibilityActionMessage?: Maybe<FlightsAccessibilityMessage>;
  /** Checkout processing screen accessibility message */
  accessibilityCheckoutMessage?: Maybe<Scalars["String"]>;
  /**
   * Represents the accessibility message associated with this trigger
   * @deprecated This will be replaced by accessibilityShowMoreMessage
   */
  accessibilityMessage?: Maybe<Scalars["String"]>;
  /** Represents the accesibility message for interaction with the icon */
  accessibilityUsageMessage?: Maybe<FlightsSimpleLocalizationTemplate>;
  /**
   * Represents the analytics to track on interaction with trigger
   * @deprecated This will be replaced by analyticsList
   */
  analytics: FlightsAnalytics;
  /** Represents the analytics to track on interaction with trigger */
  analyticsList: Array<FlightsAnalytics>;
  /** Represents the cheapest price of the listings returned */
  cheapestListingInfo?: Maybe<FlightsCheapestListingInfo>;
  /** Text shown in the actionable area. Example: 'Search for Hotels', 'No Thanks' */
  displayAction: Scalars["String"];
  /** Represents the display analytics if action text is displayed */
  displayAnalytics?: Maybe<FlightsAnalytics>;
  displayType: FlightsActionDisplayType;
  /** Represents if a button or link is enable or disable  */
  enable?: Maybe<Scalars["Boolean"]>;
  /** Represents criteria for flights information page. */
  flightsDetailCriteria?: Maybe<FlightsDetailCriteria>;
  /** Icon denoting the seat variant. Ex: accessible, unavailable etc */
  icon?: Maybe<Icon>;
  /** Represents the search criteria and search preferences of user */
  journeySearchCriteria?: Maybe<FlightsJourneySearchCriteria>;
  /** Represents the relative packageable URL */
  relativePackageableURI?: Maybe<HttpUri>;
  /** Represents the relative destination URL */
  relativeURI?: Maybe<HttpUri>;
  searchPagination?: Maybe<Pagination>;
  shoppingContext?: Maybe<ShoppingContext>;
  /** Represents information needed for step Indicator in loaded state response */
  stepIndicator?: Maybe<FlightsStepIndicator>;
  /** Switch denoting the opt-in status. Ex: opt-in, opt-out */
  switchToggle?: Maybe<FlightsSwitchToggle>;
  type: FlightsActionType;
};

/** Describes an actionable area for the next section with label */
export type FlightsActionAndLabel = {
  __typename?: "FlightsActionAndLabel";
  /** Represents label associated with the action */
  label: Scalars["String"];
  /** Represents the button/ link shown */
  selectAction: FlightsAction;
};

/** Represents an EGDS Button that contains a FlightsClientAction */
export type FlightsActionButton = EgdsButton &
  EgdsElement & {
    __typename?: "FlightsActionButton";
    accessibility?: Maybe<Scalars["String"]>;
    /**
     * @deprecated
     *         UIAction should not be used as a field because it allows for too many possible types.
     *         If need to specify action have the implementation of EGDSButton add a field for action with interface type of less number of possible subtypes
     *         or a union type with a manageable number of members
     *
     */
    action?: Maybe<UiAction>;
    analytics?: Maybe<ClientSideAnalytics>;
    /** Represents an action to be performed on the client side when the button is pressed */
    clientAction: FlightsClientAction;
    disabled: Scalars["Boolean"];
    egdsElementId?: Maybe<Scalars["String"]>;
    /** Represents an optional icon */
    icon?: Maybe<Icon>;
    /** Represents the position of the icon */
    iconPosition?: Maybe<FlightsIconPosition>;
    /** Represents the main text of the button */
    primary?: Maybe<Scalars["String"]>;
    /** Represents the button style */
    style: EgdsButtonStyle;
    /** Represents the button width in the UI */
    width?: Maybe<FlightsButtonWidth>;
  };

/** Represents an EGDS Checkbox that contains a FlightsClientAction */
export type FlightsActionCheckbox = EgdsCheckBox &
  EgdsElement & {
    __typename?: "FlightsActionCheckbox";
    /** Represents an action to be performed on the client side when the checkbox is ticked */
    clientAction: FlightsClientAction;
    description?: Maybe<Scalars["String"]>;
    egdsElementId?: Maybe<Scalars["String"]>;
    enabled: Scalars["Boolean"];
    errorMessage?: Maybe<Scalars["String"]>;
    label: EgdsText;
    name?: Maybe<Scalars["String"]>;
    required: Scalars["Boolean"];
    state: EgdsCheckBoxState;
    value?: Maybe<Scalars["String"]>;
  };

/** Describes the type of actionable button. Types reference UDS tokens for buttons. */
export type FlightsActionDisplayType =
  /** Checkbox. Example: To add Price Match Promise */
  | "CHECKBOX"
  /** Primary action. Example: 'Add Hotel Now' button, 'Retry' button */
  | "PRIMARY"
  /** Radio Button. Example: To choose seats for a particular traveler */
  | "RADIO_BUTTON"
  /** Secondary action. */
  | "SECONDARY"
  /** Switch toggle action. Example: price alerts subscription toggle */
  | "SWITCH"
  /** Tertiary action. Example: 'No Thanks' */
  | "TERTIARY"
  /** Toggle action. Example: seat button in seat map */
  | "TOGGLE";

/** Represents an EGDS Link that contains a FlightsClientAction */
export type FlightsActionLink = EgdsElement & {
  __typename?: "FlightsActionLink";
  /** Used to provide accessibility of the action link. */
  accessibility?: Maybe<Scalars["String"]>;
  /** Represents client side analytics */
  analytics?: Maybe<ClientSideAnalytics>;
  /** Represents an action to be performed on the client side when the link is clicked */
  clientAction: FlightsClientAction;
  /** Represents if link is disabled */
  disabled: Scalars["Boolean"];
  egdsElementId?: Maybe<Scalars["String"]>;
  /** Represents an optional icon */
  icon?: Maybe<Icon>;
  /** Represents the position of the icon */
  iconPosition?: Maybe<FlightsIconPosition>;
  /** Represents the text of the link */
  primary?: Maybe<Scalars["String"]>;
};

/** Available action types an actionable element */
export type FlightsActionType =
  /** Add Price Match Promise to the seleted fare */
  | "ADD_PRICE_MATCH_PROMISE"
  /** User has selected seat(s) for all passengers in that leg */
  | "ALL_SEATS_SELECTED_FOR_A_LEG"
  /** Selects the chosen fare and reloads dynamic elements */
  | "APPLY_FARE"
  /** Highlights the fare chosen by the user */
  | "CHOOSE_FARE"
  /** Dialog Box used when customer clicks the 'Next Flight' Button before selecting seats for Current Flight */
  | "CLICKING_NEXT_FLIGHT_BEFORE_FINISHING_CURRENT_FLIGHT_SEAT_SELECTION_DIALOG"
  /** Dialog Box used when customer clicks the 'Continue Booking' Button before selecting all the seats */
  | "CONTINUE_BOOKING_WITHOUT_SELECTING_SEATS_DIALOG"
  /** Go to coupon credit page */
  | "COUPON_CREDIT"
  /** Dismisses a dialog */
  | "DISMISS"
  /** Activates the suggested filter */
  | "ENABLE_SUGGESTED_FILTER"
  /** Fetch more search listings */
  | "FETCH_SEARCH_LISTINGS"
  /** Redirect used when customer clicks signin/signup page/module option from 'you might have credits module listing' */
  | "GO_TO_AUTH"
  /** Go to Checkout page */
  | "GO_TO_CHECKOUT"
  /** Continues to the standalone details page */
  | "GO_TO_DETAILS"
  /** Continues to the next set of journey results */
  | "GO_TO_NEXT_JOURNEY"
  /** Continues to the packages path */
  | "GO_TO_PACKAGES"
  /** Redirects to flights search page */
  | "GO_TO_SEARCH"
  /** Redirects back to storefront */
  | "GO_TO_STOREFRONT"
  /** Opens a dialog for to display cross sell information */
  | "LOAD_CROSS_SELL_DIALOG"
  /** open amenities tray and upsell options for standard offer flight listings */
  | "LOAD_STANDARD_OFFER_FARE_RULE_MODULE"
  /** Opens a dialog to display tax breakdown information */
  | "LOAD_TAX_BREAKDOWN_DIALOG"
  /** User has not selected seat(s) for any passengers in that leg */
  | "NO_SEATS_SELECTED_FOR_A_LEG"
  /** Opens bags selection alert dialog on clicking on checkout button on FIS */
  | "OPEN_BAGS_SELECTION_ALERT_DIALOG_ON_CHECKOUT"
  /** Opens sidesheet for bags selection */
  | "OPEN_BAGS_SELECTION_SHEET"
  /** Opens a dialog to to go to Airlines Site for Booking */
  | "OPEN_BOOK_DIRECTLY_WITH_AIRLINES_DIALOG"
  /** Dialog Box used when customer clicks the 'Select credit' or 'Change Credit' option from 'you might have credits module listing' */
  | "OPEN_CREDIT_DIALOG"
  /** Open Fare Seat information when clicked on required seat button */
  | "OPEN_FARE_SEAT_MAP_SEAT_SHEET"
  /** Open Fare Seat view to preview the seat map */
  | "OPEN_FARE_SEAT_MAP_VIEW"
  /** Open Fare Seat view to select the seat */
  | "OPEN_FARE_SEAT_SELECT_VIEW"
  /** Open Flight leg drop down in seat map view */
  | "OPEN_FLIGHT_LEG_DROP_DOWN_IN_SEAT_MAP_DIALOG"
  /** Open Legend info sheet in bottom in case of mobile */
  | "OPEN_LEGEND_INFO_SHEET_MOBILE"
  /** Open price summary */
  | "OPEN_PRICE_SUMMARY"
  /** Opens seat selection alert dialog on clicking on checkout button on FIS */
  | "OPEN_SEAT_SELECTION_ALERT_DIALOG_ON_CHECKOUT"
  /** Redirects to Airlines Site for Booking */
  | "REDIRECT_TO_AIRLINES_FOR_BOOKING"
  /** Refreshes the current page */
  | "REFRESH"
  /** Actionable item to add a journey */
  | "SEARCH_FORM_ADD_JOURNEY"
  /** Closes the expanded Search Form */
  | "SEARCH_FORM_CLOSE_BUTTON"
  /** Actionable item to remove a journey */
  | "SEARCH_FORM_REMOVE_JOURNEY"
  /** Dialog Box used when customer clicks the 'Close' Button before selecting all the seats */
  | "SEAT_MAP_CLOSE_WITHOUT_SELECTING_SEATS_DIALOG"
  /** Continues to flight details page after selecting seats for all flights */
  | "SEAT_MAP_CONTINUE_BOOKING"
  /** Closes the current flight seat selection page and continues for next flight */
  | "SEAT_MAP_GO_TO_NEXT_FLIGHT"
  /** Go to next flight section for selecting seats */
  | "SEAT_MAP_NEXT_FLIGHT"
  /** Saves user's seat preferences and redirects to FIS */
  | "SEAT_MAP_SAVE_AND_EXIT"
  /** Stays at Page displaying Seat Map when selected by user */
  | "SEAT_MAP_STAY_HERE"
  /** Continues to stay on the current flight seat selection page */
  | "SEAT_MAP_STAY_ON_THIS_PAGE"
  /** Allows User to Continue Booking from the Seat Selection Dialog Box */
  | "SEAT_SELECT_DIALOG_CONTINUE_BOOKING"
  /** Displays seat map preview corresponding to each traveler */
  | "SEAT_SELECT_PREVIEW_FOR_TRAVELER"
  /** Select Flight leg in seat map drop down menu */
  | "SELECT_FLIGHT_LEG_IN_SEAT_MAP_DIALOG"
  /** Select the seat */
  | "SELECT_SEAT"
  /** Open Opinion Lab Share Feedback dialogue */
  | "SHARE_FEEDBACK"
  /** Open a modal showing details of the free Price Match Promise product */
  | "SHOW_FREE_PRICE_MATCH_PROMISE_DETAILS"
  /** Open a modal showing details of the Price Match Promise product */
  | "SHOW_PRICE_MATCH_PROMISE_DETAILS"
  /** User has selected seat(s) for at least 1 passenger but not all passengers in that leg */
  | "SOME_SEATS_SELECTED_FOR_A_LEG"
  /** Subscribe to emails */
  | "SUBSCRIBE_TO_EMAILS"
  /** Subscribe/Unsubscribes from price alerts */
  | "TOGGLE_PRICE_ALERTS"
  /** Unselect the selected seat */
  | "UNSELECT_SEAT"
  /** Opens FIS sidesheet and highlights next fare to upgrade */
  | "UPGRADE_TO_NEXT_FARE";

/** Represents an error message and action displayed to the user when the server or client encounters an error */
export type FlightsActionableErrorMessaging = FlightsErrorMessagingPresentation & {
  __typename?: "FlightsActionableErrorMessaging";
  /** Represents a button/link action to retry or re-search */
  action: FlightsAction;
  /** Represents a list of buttons/link action to search with different start and end dates */
  errorRecoveryButtons?: Maybe<Array<FlightsAction>>;
  /** Icon included at the top of the message. Example: Search icon */
  icon: Icon;
  /** Message content. Example: 'Please try your search again later.' */
  message: Scalars["String"];
  /** Title of the message. Example: 'Sorry, we're having a problem on our end..' */
  title: Scalars["String"];
};

/** Describes an actionable icon */
export type FlightsActionableIcon = {
  __typename?: "FlightsActionableIcon";
  /** Represents the accessibility message associated with this trigger */
  accessibilityMessage?: Maybe<Scalars["String"]>;
  /** Represents the analytics to track on interaction with trigger */
  analytics: FlightsAnalytics;
  /** Text shown in the actionable area. Example: 'Taxes and fees' for tax breakdown */
  displayText?: Maybe<Scalars["String"]>;
  /** Icon. Example: 'X' */
  icon: Icon;
  /** Available action types on actionable icon */
  type: FlightsActionType;
};

export type FlightsActionableLabel = {
  __typename?: "FlightsActionableLabel";
  accessibility?: Maybe<FlightsAccessibilityMessage>;
  active: Scalars["Boolean"];
  analytics?: Maybe<FlightsAnalytics>;
  label: Scalars["String"];
  url?: Maybe<Scalars["URL"]>;
};

/** Possible advanced filter types */
export type FlightsAdvancedFilterType = "NONSTOP" | "REFUNDABLE";

/** Represents details of air ancillary selection request */
export interface FlightsAirAncillarySelectionDetailInput {
  /** Represents index of each traveler. Example: '1' */
  travelerIndex: Scalars["Int"];
  /** Represents details of flight, ancillaries in encoded form mapped to each traveler. */
  unselectedAirAncillaryProductToken: Scalars["String"];
}

/** Hygiene Amenities group divided by Airline */
export type FlightsAirlineAmenityGroup = {
  __typename?: "FlightsAirlineAmenityGroup";
  /** List of all the  hygiene amenities */
  amenities?: Maybe<Array<FlightsIconAndLabel>>;
  /** Text for the airline hygiene amenities */
  headerText?: Maybe<Scalars["String"]>;
};

export type FlightsAirlineCreditsResponse = {
  __typename?: "FlightsAirlineCreditsResponse";
  flightsCreditSelectionPresentation: FlightsCreditSelectionPresentation;
};

/** Represents the value associated with airport filter */
export type FlightsAirportCodeFilterValue = {
  __typename?: "FlightsAirportCodeFilterValue";
  airportCode: Scalars["String"];
};

/** Represents the value associated with airport filter */
export interface FlightsAirportCodeFilterValueInput {
  airportCode: Scalars["String"];
}

/** Represent the data needed to track client side tracked events */
export type FlightsAnalytics = {
  __typename?: "FlightsAnalytics";
  /** Represents a short friendly name to clarify the meaning of the client side tracked event */
  linkName: Scalars["String"];
  /** Represents a value for the client side action taken */
  referrerId: Scalars["String"];
};

/** Accessibility message to be announced when ancillary selections are done */
export type FlightsAncillaryAccessibilityMessage = {
  __typename?: "FlightsAncillaryAccessibilityMessage";
  /** Accessibility message */
  accessibilityMessage: Scalars["String"];
  /** Type of message */
  id: FlightsAncillarySelectionAccessibilityMsgType;
};

/** Represents various alert dialogs to be shown for ancillary selection */
export type FlightsAncillaryAlertDialog = {
  __typename?: "FlightsAncillaryAlertDialog";
  /** Represents alert dialog for any condition not fulfilled */
  alertDialog: FlightsDialogStandard;
  /** Id of the alert dialog to be mapped with type of dialog */
  id: FlightsActionType;
};

/** Generic class to hold static ancillaries information */
export type FlightsAncillaryAvailabilityDetail = {
  __typename?: "FlightsAncillaryAvailabilityDetail";
  /** Contains the identifier for the leg */
  selectedJourneyIndex: Scalars["Int"];
  /**
   * List of all the informational ancillaries corresponding to the card
   * @deprecated It supports only text, to support suffix `- added` use staticAncillariesInfo
   */
  staticAncillaries: Array<EgdsIconText>;
  /** List of all the informational ancillaries corresponding to the card */
  staticAncillariesInfo: Array<EgdsSpannableText>;
};

/** List of all the available flight legs with ancillaries */
export type FlightsAncillaryAvailableFlightLegSelection = {
  __typename?: "FlightsAncillaryAvailableFlightLegSelection";
  /** Contains additional information for ancillaries | eg: Baggage selection applies to all the flights */
  additionalInfo?: Maybe<EgdsText>;
  /** Details of ancillaries available per traveler */
  ancillariesPerTravelerList?: Maybe<Array<FlightAncillariesPerTraveler>>;
  /** Message in case no ancillary is available */
  ancillaryNotAvailableMessage?: Maybe<FlightsAncillaryMessage>;
  /**
   * Contains option to select same ancillaries for all travelers
   * @deprecated New node required for checkbox with analytics, replace with applySameAncillaryCheckBox
   */
  applySameAncillary?: Maybe<EgdsBasicCheckBox>;
  /** Contains option to select same ancillaries for all travelers with analytics */
  applySameAncillaryCheckBox?: Maybe<ActionCheckBox>;
  /** Data for details page in the loaded call */
  availabilityDetails?: Maybe<FlightsAncillaryAvailabilityDetail>;
  /** Contains the identifier for the leg */
  selectedJourneyIndex: Scalars["Int"];
};

/** Ancillary card */
export type FlightsAncillaryCard = {
  __typename?: "FlightsAncillaryCard";
  /** Represents the appropriate action, ex: Add bags */
  action?: Maybe<FlightsDialogTrigger>;
  /** Represents the journey sections with amenities and selected info all combined */
  content?: Maybe<FlightsCategorizedList>;
  /**
   * Represents the ancillary show more toggle, ex: Show More
   * @deprecated Use: val expandToggle: EGDSExpandoPeek? = null
   */
  displayToggle: EgdsExpandoPeek;
  /** Represents the ancillary show more toggle, ex: Show More */
  expandToggle?: Maybe<EgdsExpandoPeek>;
  /** Represents the card text, can be Bags or Seats */
  heading: Scalars["String"];
  /** Represents the urgency message */
  highlightMessage?: Maybe<EgdsText>;
  /**
   * Represents the journey sections with amenities and selected info
   * @deprecated Use: val content: FlightsCategorizedList, all static and selected items are combined
   */
  sections?: Maybe<Array<FlightJourneyAncillariesSection>>;
};

/** Represents a button to save ancillary or to move to next journey for ancillary selection eg: Continue Booking or Next Flight */
export type FlightsAncillaryContinueAction = FlightsClientAction & {
  __typename?: "FlightsAncillaryContinueAction";
  /** Used to provide accessibility that has to be read on completion of action. */
  accessibility?: Maybe<Scalars["String"]>;
  /** Used to capture client side analytics */
  analyticsList: Array<ClientSideAnalytics>;
};

/** Ancillary summary criteria for the selected fare */
export interface FlightsAncillaryCriteriaInput {
  /** Represents ancillaryID to signify whether ancillaries were selected, null when no ancillaries were selected. */
  ancillaryId?: InputMaybe<Scalars["String"]>;
  /** Represents the list of per segment(seats)/per product(bags) selections */
  ancillaryJourneySelections?: InputMaybe<Array<AncillaryJourneySelectionsInput>>;
  /** Represents the ancillary requested in the summary */
  ancillaryType: FlightsAncillaryType;
  /** Represents details of selected ancillaries for each journey */
  flightAncillaryJourneySelections?: InputMaybe<Array<FlightAncillaryJourneySelectionInput>>;
  /** Represent the continuation identifier for spinner to deduce all journeys selected by the user. */
  journeyContinuationId: Scalars["String"];
  /** Represents Air Offer Token of the selected flight, null for first call on page load */
  selectedOfferToken?: InputMaybe<Scalars["String"]>;
}

/** Ancillary details for the selected fare loaded state */
export type FlightsAncillaryDetails = {
  __typename?: "FlightsAncillaryDetails";
  /** Represents list of error messages for ancillary selection failures */
  errorMessages?: Maybe<Array<FlightsAncillaryMessage>>;
  /** Represents various alert dialogs to be shown for ancillary selection */
  flightsAncillaryAlertDialogList?: Maybe<Array<FlightsDialog>>;
  /**
   * Represents various alert dialogs to be shown for ancillary selection
   * @deprecated New implementation on Shared-UI requires new type, replace with flightsAncillaryAlertDialogList
   */
  flightsAncillaryAlertDialogs?: Maybe<Array<FlightsAncillaryAlertDialog>>;
  /** Contains global data for footer. eg: total price */
  footer: FlightsAncillaryFooter;
  /** List of all the available flight legs with ancillaries */
  journeyAncillaryDetails: Array<FlightsAncillaryAvailableFlightLegSelection>;
  /** Analytics related to scroll depth */
  scrollAnalytics?: Maybe<ClientSideAnalytics>;
  /** Represents the data for selected Journey */
  selectedJourneyIndex: Scalars["Int"];
};

/** Represents all the dialog boxes for Ancillary details page eg: when user clicks on close */
export type FlightsAncillaryDetailsDialog = {
  __typename?: "FlightsAncillaryDetailsDialog";
  /** Represents the dialog box for the Continue booking button */
  flightsContinueBookingDialog: FlightsDialog;
  /**
   * Represents the dialog box for the close button
   * @deprecated Use flightsDialogCompleteSelectionClose  and flightsDialogCompleteSelectionClose instead
   */
  flightsDialogClose: FlightsDialog;
  /** Represents the dialog box for the close button when selections are complete */
  flightsDialogCompleteSelectionClose: FlightsDialog;
  /** Represents the dialog box for the close button when selections are incomplete */
  flightsDialogIncompleteSelectionClose: FlightsDialog;
};

/** Ancillary details for the selected fare loading state */
export type FlightsAncillaryDetailsLoading = {
  __typename?: "FlightsAncillaryDetailsLoading";
  /** Contains the analytics for side sheet cross button pressed */
  analytics?: Maybe<ClientSideAnalytics>;
  /** Contains the elements for Dialog boxes for the details page */
  flightsAncillaryDialog: FlightsAncillaryDetailsDialog;
  /** Footer of the ancillary details card */
  footer: FlightsAncillaryFooter;
  /** Header of the ancillary details card */
  heading: EgdsHeading;
  /** Represents all the information for the flight dropdown */
  journeySelectionDropDown?: Maybe<JourneySelectionDropDown>;
  /** Represents the data for selected Journey */
  selectedJourneyIndex: Scalars["Int"];
};

/** Ancillary details for the selected fare prefetched in ancillary summary */
export type FlightsAncillaryDetailsPrefetch = {
  __typename?: "FlightsAncillaryDetailsPrefetch";
  /** Data for details page in the loaded call */
  availabilityDetails?: Maybe<Array<FlightsAncillaryAvailabilityDetail>>;
  /** Represents list of error messages when the API fals to get the details data.' */
  errorMessages?: Maybe<Array<FlightsAncillaryMessage>>;
};

/** Enum class to represent the ancillary display action */
export type FlightsAncillaryDisplayAction = "NONE" | "PREFETCH";

/** Error Message when an error occur during ancillary selection */
export type FlightsAncillaryErrorMessage = {
  __typename?: "FlightsAncillaryErrorMessage";
  /** Accessibility message for error */
  accessibilityMessage?: Maybe<FlightsResponsiveAccessibilityMessage>;
  /** List of analytics to be fired */
  analyticsList?: Maybe<Array<ClientSideAnalytics>>;
  /** Error message heading */
  heading?: Maybe<EgdsStylizedText>;
  /** Type of error */
  id: FlightsAncillarySelectionErrorType;
  /** Message to be displayed */
  message: EgdsStylizedText;
};

/** Represents the footer for the selected card */
export type FlightsAncillaryFooter = {
  __typename?: "FlightsAncillaryFooter";
  /** Contains global data for the footer. eg: Total price */
  globalFooter: FlightsAncillaryGlobalFooter;
  /** Footer of the ancillary details card. eg: Action buttons */
  journeyFooter: Array<FlightsAncillaryJourneyFooter>;
};

export type FlightsAncillaryGlobalFooter = {
  __typename?: "FlightsAncillaryGlobalFooter";
  /** Represents the label for Ancillary footer. for eg: Bag(s) */
  label: EgdsText;
  /** Represents the number of ancillary selected */
  selectedCount: Scalars["Int"];
  /**
   * Represents the number of ancillary selected message. Example:'{bagNumber} selected'
   * @deprecated use selectedMessageTemplates for future development
   */
  selectedMessage: EgdsLocalizedTextTemplate;
  /** Represents the the selected baggage templates */
  selectedMessageTemplates: Array<SelectedAncillaryTemplate>;
  /** Represents template analytics for ancillary */
  templateAnalytics?: Maybe<Array<TemplateAnalytics>>;
  /** Represents the total price for ancillaries selected. Example: '$999' or '$${totalAmount}' */
  totalPrice: EgdsLocalizedTextTemplate;
};

/** Static Ancillary details at appropriate itinerary breakdown level (journeys for bags, segments for seats) */
export type FlightsAncillaryInformation = {
  __typename?: "FlightsAncillaryInformation";
  /** Steps to select ancillary later, if unavailable at flight booking */
  additionalInfo?: Maybe<EgdsPlainText>;
  /** List of all the informational ancillaries corresponding to the card */
  flightsAncillaryAvailabilityDetails: FlightsAncillaryAvailabilityDetail;
  /** Heading of the ancillary section. ex: ATL to LAX */
  heading?: Maybe<EgdsHeading>;
  /** Represents list of selected ancillary for travelers' */
  selectedAncillarySummary?: Maybe<Array<FlightsAncillaryTravelerSummaryItem>>;
};

/** Ancillary footer for the selected journey */
export type FlightsAncillaryJourneyFooter = {
  __typename?: "FlightsAncillaryJourneyFooter";
  /** Represents the button action. Example: 'Next Flight' OR 'Continue Booking' */
  buttonAction: FlightsActionButton;
  /** Represents the types of action based on number of ancillaries selected for a flight */
  buttonActionTypes: Array<FlightsLegAncillarySummaryActionType>;
  /** Identifier to identify the footer w.r.t to journey */
  selectedJourneyIndex: Scalars["Int"];
  /** Represents template analytics for ancillary */
  templateAnalytics?: Maybe<Array<TemplateAnalytics>>;
};

/** Error Message when an error occur during ancillary selection */
export type FlightsAncillaryMessage = {
  __typename?: "FlightsAncillaryMessage";
  /** Accessibility message for error */
  accessibilityMessage?: Maybe<FlightsResponsiveAccessibilityMessage>;
  /** List of analytics to be fired */
  analyticsList?: Maybe<Array<ClientSideAnalytics>>;
  /** Error message heading */
  heading?: Maybe<EgdsHeading>;
  /** Type of error */
  id: FlightsAncillarySelectionErrorType;
  /** Message to be displayed */
  message: EgdsText;
  /** Theme of message */
  theme: TextTheme;
};

export type FlightsAncillaryResponse = {
  __typename?: "FlightsAncillaryResponse";
  ancillaryDetail?: Maybe<FlightsAncillaryDetails>;
  ancillarySummary?: Maybe<FlightsAncillarySummaryPresentation>;
  ancillarySummaryCard?: Maybe<FlightsAncillarySummaryCardPresentation>;
  baggageDetails?: Maybe<FlightsBaggageAncillaryDetailsPresentation>;
  seatAncillaryDetails?: Maybe<FlightsSeatAncillaryDetailsPresentation>;
};

/** Represents journey info of ancillary dropdown with respective label. Ex: Seattle to Chicago (American Airlines). */
export type FlightsAncillarySelect = {
  __typename?: "FlightsAncillarySelect";
  /** Represents option labels. Ex: Flight 1 of 2. */
  optionLabels: Array<Scalars["String"]>;
  /** Represents journey leg select options. Ex: Seattle to Chicago (American Airlines) */
  selectOptions: EgdsSelect;
};

/** Represents selected ancillary item */
export type FlightsAncillarySelectedItem = {
  __typename?: "FlightsAncillarySelectedItem";
  /** Represents the seat name assigned. Ex: 'ORD to JKF: Seat A2', '1st checked bag (15kg)' */
  assignedAncillaryLabel: EgdsPlainText;
  /** Represents the ancillary price. Example: '-' or '$20 roundtrip' */
  price: EgdsPlainText;
};

/** Accessibility message types to be announced post selection */
export type FlightsAncillarySelectionAccessibilityMsgType =
  /** Ancillary Selection Failed */
  | "SELECTION_FAILED"
  /** Ancillary Selection Success */
  | "SELECTION_SUCCESS";

/** Error types which can occur during ancillary selection */
export type FlightsAncillarySelectionErrorType =
  /** Baggage Details loaded call failed */
  | "BAGGAGE_DETAILS_LOADED_FAILED"
  /** Ancillary details loading failed */
  | "DETAILS_LOADING_FAILED"
  /** Ancillary Pre-Selection Unavailable */
  | "PRE_SELECTION_FAILED"
  /** Ancillary Selection Failed */
  | "SELECTION_FAILED"
  /** Ancillary Selection Unavailable */
  | "SELECTION_UNAVAILABLE";

/** Ancillary summary for the selected fare in loaded state */
export type FlightsAncillarySummary = FlightsAncillarySummaryPresentation & {
  __typename?: "FlightsAncillarySummary";
  /** Represents list of accessibility messages to be called out on ancillary selections. Ex: 'Your bag add ons have been applied.' */
  accessibilityMessages: Array<FlightsAncillaryAccessibilityMessage>;
  /** AirOffer token for the selected fare to be used for further Ancillary Details call if needed */
  airOfferToken?: Maybe<Scalars["String"]>;
  /** Used to capture client side analytics on ancillary card display */
  analyticsList: Array<ClientSideAnalytics>;
  /** Represents the static ancillary details at appropriate itinerary breakdown level (bounds for bags, segments for seats) for the selected fare */
  ancillariesPerJourney?: Maybe<Array<FlightsAncillaryInformation>>;
  /** Represents loading state information when user clicks on action link */
  ancillaryDetailsLoading: FlightsAncillaryDetailsLoading;
  /** Ancillary show more toggle ex: Show More */
  displayToggle: EgdsExpando;
  /** Link to open ancillary edit action, Ex: Edit Bags */
  editAncillariesAction?: Maybe<FlightsActionLink>;
  /** Represents list of error messages for seat/bag selection failures. Example: 'Your seats could not be selected. Please try again.' */
  errorMessages?: Maybe<Array<FlightsAncillaryMessage>>;
  /** Represents details of air ancillary selections for each journey */
  flightAncillaryJourneySelections?: Maybe<Array<FlightAncillaryJourneySelection>>;
  /** Ancillary details for the pre fetch loaded state */
  flightsAncillaryDetailsPrefetch: FlightsAncillaryDetailsPrefetch;
  /** Heading of the ancillary summary section. ex: Seats/Bags */
  heading: EgdsHeading;
  /** Highlight on ancillary card. ex: Bag prices may increase at the airport */
  highlightMessage?: Maybe<EgdsHeading>;
  /** Link to open ancillary select action, Example: Choose seat map */
  loadAncillariesAction?: Maybe<FlightsActionButton>;
  /** Represents the scroll analytics if ancillary card comes in viewport */
  scrollAnalyticsList: Array<ClientSideAnalytics>;
};

/** Represents the analytics for ancillary card */
export type FlightsAncillarySummaryAnalytics = {
  __typename?: "FlightsAncillarySummaryAnalytics";
  /** Represents the generic analytics */
  analyticsList: Array<ClientSideAnalytics>;
  /** Represents the scroll analytics */
  scrollAnalyticsList: Array<ClientSideAnalytics>;
};

/** Ancillary summary card */
export type FlightsAncillarySummaryCard = {
  __typename?: "FlightsAncillarySummaryCard";
  /** Represents the accessibility messages for ancillary card */
  accessibilityMessages: Array<FlightsAncillaryAccessibilityMessage>;
  /** Represents the analytics for ancillary card */
  analytics: FlightsAncillarySummaryAnalytics;
  /** Represents the ancillary card contents */
  ancillaryCard: FlightsAncillaryCard;
  /** Represents the error messages for ancillary summary */
  errorMessages?: Maybe<Array<FlightsAncillaryMessage>>;
  /** Represents the display action prefetch/none */
  onDisplayAction: FlightsAncillaryDisplayAction;
};

/** Ancillary summary for the selected fare in loading state */
export type FlightsAncillarySummaryCardLoading = {
  __typename?: "FlightsAncillarySummaryCardLoading";
  /** Error message to be shown in case ancillary summary card loaded fails */
  errorMessage: EgdsStylizedText;
  /** Heading of the ancillary summary section. ex: Seats/Bags */
  heading: Scalars["String"];
};

/** Ancillary summary for the selected fare */
export type FlightsAncillarySummaryCardPresentation = FlightsAncillarySummaryCard | FlightsAncillarySummaryCardLoading;

/** Ancillary summary for the selected fare in loading state */
export type FlightsAncillarySummaryLoading = FlightsAncillarySummaryPresentation & {
  __typename?: "FlightsAncillarySummaryLoading";
  /** Heading of the ancillary summary section. ex: Seats/Bags */
  heading: EgdsHeading;
};

/** Ancillary summary for the selected fare */
export interface FlightsAncillarySummaryPresentation {
  /** Heading of the ancillary summary section. ex: Seats/Bags */
  heading: EgdsHeading;
}

/** Represents traveler ancillary selection details */
export type FlightsAncillaryTravelerSummaryItem = {
  __typename?: "FlightsAncillaryTravelerSummaryItem";
  /** Represents ancillary item list details. */
  ancillaryItemDetails: Array<FlightsAncillarySelectedItem>;
  /** Represents the label for traveler info . Ex: 'Traveler 1: Adult' */
  label: EgdsStylizedText;
  /** Represents the traveler index. Ex: 1 */
  travelerIndex: Scalars["Int"];
};

/** Type of ancillaries supported */
export type FlightsAncillaryType = "BAGS" | "BAGS_V2" | "SEATS";

/** Response of the ancillary service being updated from downlevel service */
export type FlightsAncillaryUpdateResponse = {
  __typename?: "FlightsAncillaryUpdateResponse";
  /** It contains the unique ancillary id for successful non empty selection request.  */
  ancillaryId?: Maybe<Scalars["String"]>;
  /** It shows error in case update ancillary call gets failed. */
  error?: Maybe<Scalars["String"]>;
};

/** Represents the pill displayed for each applied filter */
export type FlightsAppliedFilter = {
  __typename?: "FlightsAppliedFilter";
  /** Represents the message read by AT for each pill */
  accessibilityMessage: Scalars["String"];
  /** Represents the analytics to track on interaction when the pill is clicked */
  analytics: FlightsAnalytics;
  /** Represents the icon clicking on which removes the pill as well as the applied filter */
  dismissIcon: Icon;
  /** Represents accessibility message after the icon clicking on which removes the pill as well as the applied filter */
  dismissIconAccessibility?: Maybe<Scalars["String"]>;
  /** Represents the identifier for the particular filter */
  identifier: Scalars["String"];
  /** Represents the label displayed on each pill */
  label: Scalars["String"];
  /** Represents the search criteria to be sent to the server when the pill is dismissed.The results need to repopulated from server as this particular applied filter is no longer applicable */
  nextSearchSortFilterCriteria?: Maybe<FlightsSearchSortAndFilterCriteria>;
};

/** Represents the display to be rendered showcasing the already applied filters */
export type FlightsAppliedFiltersSummary = {
  __typename?: "FlightsAppliedFiltersSummary";
  /** Represents accessibility message for filter pills group. Example: 'Applied Filters' */
  accessibility?: Maybe<Scalars["String"]>;
  /** Represents list of pills. Each pill corresponds to one already applied filters */
  appliedFilters?: Maybe<Array<FlightsAppliedFilter>>;
};

export type FlightsArithmeticResponse = {
  __typename?: "FlightsArithmeticResponse";
  formattedResult: EgdsText;
};

/** Represents the email of the authenticated user in session on the servicing view */
export type FlightsAuthenticatedUser = {
  __typename?: "FlightsAuthenticatedUser";
  /** Represents text describing who is logged in */
  accessibility: Scalars["String"];
  /** Represents the email of the authenticated user in session(ie: 'johndoe@gmail.com') */
  email: Scalars["String"];
  /** Represents the heading (ie: 'Signed in as') */
  heading: Scalars["String"];
  /** Represents a message where will be send the confirmation by email */
  message: Scalars["String"];
};

/** Summary of all available fares for a Journey */
export interface FlightsAvailableFares {
  /** Describes button action to accept chosen fare and continue */
  applySelection?: Maybe<FlightsAction>;
  /** Describes icon to dismiss summary/details */
  dismissDetailedJourneyInformation: FlightsActionableIcon;
  /** Summary of all available fares for a Journey */
  fareChoiceInformation?: Maybe<FlightsFareChoiceInformation>;
  /** Journey highlight like Origin to Destination, departure day, airline */
  flightsJourneyHeaders: FlightsJourneyHeaders;
  /** Represents the accesibility message to be announced when summary/details opens */
  openAccessibility: Scalars["String"];
}

/** Represents any information which is to be displayed in a badge. Example: 'No change fees' */
export type FlightsBadge = {
  __typename?: "FlightsBadge";
  /** Represents the accessibility message for the badge */
  accessibilityMessage?: Maybe<Scalars["String"]>;
  /** Represents the Icon to be displayed along with the text */
  icon?: Maybe<Icon>;
  /** Represents the text which is to be displayed inside a badge */
  text?: Maybe<Scalars["String"]>;
  /** Represents the theme of the badge. Example: 'Theme.DEAL_GENERIC' */
  type: FlightsBadgeTheme;
};

/** Represents the theme values for a Badge */
export type FlightsBadgeTheme =
  | "BRAND"
  | "DEAL_BUNDLED"
  | "DEAL_GENERIC"
  | "DEAL_MEMBER"
  | "FAMILY_FRIENDLY"
  | "NOTIFICATION"
  | "SAVED"
  | "SPONSORED"
  | "SUPPLIER_PROMO"
  | "VIEWED"
  | "VIP";

/** Represents the ancillaries available along with the applicable traveler */
export type FlightsBaggageAncillariesPerTraveler = {
  __typename?: "FlightsBaggageAncillariesPerTraveler";
  /** Contains the ancillary information for a traveler */
  ancillaryOptions?: Maybe<Array<FlightSelectableBaggageAncillary>>;
  /** Error message in case ancillary is not available for a particular traveler type | eg: Bags are not available for an infant */
  errorMessage?: Maybe<Scalars["String"]>;
  /** Represents traveler index */
  travelerIndex: Scalars["Int"];
  /** Represents Traveler identifier Adult | Child etc */
  travellerIdentifier?: Maybe<Scalars["String"]>;
};

/** Baggage ancillary details body having the main content */
export type FlightsBaggageAncillaryDetailsContent = {
  __typename?: "FlightsBaggageAncillaryDetailsContent";
  /** Contains the elements for Dialog boxes for the bag details page */
  flightsAncillaryDialog?: Maybe<FlightsAncillaryDetailsDialog>;
  /** List of all the available flight legs with ancillaries */
  journeyAncillaryDetails: Array<FlightsJourneyBaggageSelectionPresentation>;
  /** Represents journey info in dropdown. Ex: Seattle to Chicago (American Airlines). */
  journeySelect?: Maybe<FlightsAncillarySelect>;
};

/** Baggage ancillary details for the selected fare in loaded state */
export type FlightsBaggageAncillaryDetailsLoaded = {
  __typename?: "FlightsBaggageAncillaryDetailsLoaded";
  /** Represents wrapper for baggage details dialog/SideSheet */
  baggageDetailsWrapper: FlightsDialogSheet;
  /** Represents the body of the baggage ancillary details sheet */
  content: FlightsBaggageAncillaryDetailsContent;
  /** Represents the footer of the baggage ancillary details sheet */
  footer: FlightsBaggageAncillaryFooter;
  /** Represents the air offer token of the selected flights */
  offerIdentifier?: Maybe<Scalars["String"]>;
};

/** Baggage Ancillary details for the selected fare in loading state */
export type FlightsBaggageAncillaryDetailsLoading = {
  __typename?: "FlightsBaggageAncillaryDetailsLoading";
  /** Represents wrapper for baggage details dialog/SideSheet */
  baggageDetailsWrapper: FlightsDialogSheet;
  /** Error message to be shown in cases Baggage Ancillary Details loaded call fails */
  errorMessage: FlightsAncillaryErrorMessage;
};

/** Baggage Ancillary details for the selected fare */
export type FlightsBaggageAncillaryDetailsPresentation =
  | FlightsBaggageAncillaryDetailsLoaded
  | FlightsBaggageAncillaryDetailsLoading
  | FlightsBaggageAncillaryDetailsSelectionChange;

/** Contains the nodes to be updated on selection change */
export type FlightsBaggageAncillaryDetailsSelectionChange = {
  __typename?: "FlightsBaggageAncillaryDetailsSelectionChange";
  /** Represents the footer of the baggage ancillary details sheet */
  footer: FlightsBaggageAncillaryFooter;
};

/** Represents the footer for the baggage details card */
export type FlightsBaggageAncillaryFooter = {
  __typename?: "FlightsBaggageAncillaryFooter";
  /** Contains global data for the footer. eg: Total price */
  globalFooter: FlightsBaggageAncillaryGlobalFooter;
  /** Footer of the ancillary details card on a per journey level. eg: Action buttons */
  journeyFooter: Array<FlightsBaggageAncillaryJourneyFooter>;
};

/** Represents the Overall footer applicable for all journey for Baggage Details */
export type FlightsBaggageAncillaryGlobalFooter = {
  __typename?: "FlightsBaggageAncillaryGlobalFooter";
  /** Represents the list of analytics for ancillary */
  analytics?: Maybe<Array<ClientSideAnalytics>>;
  /** Represents label for 'Bag(s)' */
  label: Scalars["String"];
  /** Represents the number of ancillary selected message. Example:'2 selected' */
  selectedMessage: Scalars["String"];
  /** Represents the total price for ancillaries selected. Example: '$999' */
  totalPrice: Scalars["String"];
};

/** Ancillary footer for the selected journey */
export type FlightsBaggageAncillaryJourneyFooter = {
  __typename?: "FlightsBaggageAncillaryJourneyFooter";
  /** Represents the list of analytics for ancillary */
  analytics?: Maybe<Array<ClientSideAnalytics>>;
  /** Represents the button action. Example: 'Next Flight' OR 'Continue Booking' */
  buttonAction: FlightsActionButton;
  /** Identifier to identify the footer w.r.t to journey */
  selectedJourneyIndex: Scalars["Int"];
};

/** List of all the available flight legs with ancillaries */
export type FlightsBaggageAvailableFlightLegSelection = {
  __typename?: "FlightsBaggageAvailableFlightLegSelection";
  /** Contains additional information for ancillaries | eg: Baggage selection applies to all the flights */
  additionalInfo?: Maybe<Scalars["String"]>;
  /** Details of baggage ancillaries available per traveler */
  ancillariesPerTravelerList?: Maybe<Array<FlightsBaggageAncillariesPerTraveler>>;
  /** Message in case no ancillary is available */
  ancillaryNotAvailableMessage?: Maybe<FlightsAncillaryMessage>;
  /** Contains option to select same ancillaries for all travelers with analytics */
  applySameAncillaryCheckBox?: Maybe<FlightsActionCheckbox>;
  /** Static ancillaries available for the Journey */
  staticAncillaries?: Maybe<FlightsCategorizedList>;
  /** Contains the message to be shown if the bags are sold under weight concept */
  weightConceptMessage?: Maybe<EgdsSpannableText>;
};

/** Represents the baggage information */
export type FlightsBaggageInformation = {
  __typename?: "FlightsBaggageInformation";
  /** More info can be gained from this sectionExample: 'These fees are approximately what you'll pay at the airport.Confirm with Airline.''Purchase checked bags from Airline throughthe link in the confirmation or check-in emails.' */
  bagFeesMoreInfo: Array<FlightsPhrase>;
  /** Default bag selection fee message to show before selecting any upsellExample: 'Select a fare above to see bag fees.' */
  defaultBagSelectionMessage?: Maybe<Scalars["String"]>;
  /** Fee schedule for baggage (e.g. '2nd checked bag: $50') */
  details?: Maybe<Array<FlightBaggageInformationDetail>>;
  /** Text used to dismiss the baggage information modal */
  dismissAction?: Maybe<Scalars["String"]>;
  /**
   * Represents the display analytics if baggage info is displayed
   * @deprecated Will start sending all display analytics for baggage in displayAnalyticsItems node
   */
  displayAnalytics?: Maybe<FlightsAnalytics>;
  /** Represents display analytics */
  displayAnalyticsItems?: Maybe<Array<FlightsAnalytics>>;
  /** Trigger to open the details */
  displayDetailsAction?: Maybe<Scalars["String"]>;
  /** Title for the baggage information sectionExample: 'Estimated bag fees for Saver' when fare name exist or 'Estimated bag fees' when fare name does not exist */
  label: Scalars["String"];
};

export type FlightsBannerPlacard = FlightsUiPlacard & {
  __typename?: "FlightsBannerPlacard";
  /** Represents flights banner */
  banner: UiBanner;
  /** Represents the display type for banners */
  displayType: FlightsPlacardDisplayType;
  /**
   * Represents onView analytics for a Placard. This will be triggered when the placard is visible on the client's viewport
   * @deprecated Use onViewedAnalyticsList for future use.
   */
  onViewedAnalytics?: Maybe<FlightsAnalytics>;
  /** Represents onView analytics list for a Placard. This will be triggered when the placard is visible on the client's viewport */
  onViewedAnalyticsList?: Maybe<Array<ClientSideAnalytics>>;
};

/** The flights search results offer representing an Expedia bargain fare (EBF/Whitelabel Fare) */
export type FlightsBargainFareOffer = FlightsOffer & {
  __typename?: "FlightsBargainFareOffer";
  /** Represents the accessibility heading for this EBF offer */
  accessibilityHeading?: Maybe<Scalars["String"]>;
  /** Represents the accessibility message for this EBF offer */
  accessibilityMessage: Scalars["String"];
  /** Represents the pricing info for the offer listing */
  bargainPricingInformation?: Maybe<FlightsPricingInformation>;
  /** Represents the description text shown on the EBF offer listing viz.'Get the flight now ... */
  description: FlightsPhrase;
  /** Represents the header text shown on the EBF offer listing viz.'Expedia Bargain Fare */
  header: FlightsPhrase;
  /** Represents the header image shown on the EBF offer listing.This is present only on Hotwire */
  headerImage?: Maybe<Image>;
  /** Represents the image shown on the EBF offer listing */
  image: Image;
  /** Represents the jcid if this offer is selected. */
  journeyContinuationId?: Maybe<Scalars["String"]>;
  /** Represents the list of FlightOfferJourney objects. FlightJourney object has all the details necessary for rendering the details of the Flights offer, such as sidesheet */
  journeys: Array<FlightsOfferJourney>;
  /** Represents the analytics to track on interaction with trigger */
  onClickAnalyticsList: Array<FlightsAnalytics>;
  /** Represents the select button shown on the offer listing */
  selectOfferAction: FlightsAction;
};

export type FlightsBargainFareSelectedJourneyDetails = FlightsSelectedJourneyDetails & {
  __typename?: "FlightsBargainFareSelectedJourneyDetails";
  /** Represents information sent to clients to help user change the selected flight */
  changeFlight: FlightsAction;
  /** Policies for the Journey */
  flightsJourneyPolicies?: Maybe<FlightsTextSection>;
  /** Represents the basic highlights in multiple segments or Origin Destination pairs */
  journeyHighlights: Array<FlightsJourneyHighlights>;
  /** Represents onView analytics for Journey Information. This will be triggered when it is visible on the client's viewport */
  onViewedAnalytics?: Maybe<FlightsAnalytics>;
};

/** Brief description of selected bargain fare itinerary like range for departure time, stops etc. */
export type FlightsBargainJourneySummary = FlightsJourneySummary & {
  __typename?: "FlightsBargainJourneySummary";
  /** Informs the user about the arrival day, ex: Arrives same day */
  arrivalDayInformation: Scalars["String"];
  /** Combination of messages that gives a summary of the trip like duration and stops, cabin class details etc. */
  basicFlightDetails: Array<FlightsMessageAndAccessibility>;
  /** Difference between arrival a departure days. Example: '+2' or '+1', accessibility: Flight spans 2 days, currently not shown in bargain fare */
  differentDayArrival?: Maybe<FlightsMessageAndAccessibility>;
  /** The price of the bargain journey with styling, non-null on FSR */
  formattedPrice?: Maybe<FlightsPhrase>;
  /** Details of the flight departure and arrival time, egs: 1:00pm - 6:00pm, accessibility being 1:00pm to 6:00pm */
  heading: FlightsMessageAndAccessibility;
  /** Icon and message to display a red-eye flight related message */
  redEyeMessage?: Maybe<FlightsIconAndLabel>;
  /** Represents the wordage for the total price of this bargain journey for all passengers . Ex: $345 Roundtrip for 3 travelers, non-null on FSR */
  totalPrice?: Maybe<Scalars["String"]>;
  /** Represents the type of trip that belongs to the offer. Ex: Oneway per traveler, Roundtrip per traveler, non-null on FSR */
  tripTypePerTraveler?: Maybe<Scalars["String"]>;
};

/** Represents the booking action on the servicing view */
export type FlightsBooking = {
  __typename?: "FlightsBooking";
  /** Represents the booking button with action */
  action?: Maybe<FlightsActionButton>;
  /** Represents the list of links (ie: terms and conditions links) */
  links: EgdsLinkList;
  /** Represents onView analytics for the object. This will be triggered when the component is visible on the client's viewport */
  onViewedAnalytics: ClientSideAnalytics;
  /**
   * Represents the booking action
   * @deprecated This will be replaced with action
   */
  primaryAction: FlightsBookingAction;
  /**
   * Represents the booking button
   * @deprecated This will be replaced with action
   */
  primaryButton: UiPrimaryButton;
  /**
   * Represents the primary copy (ie: terms and conditions)
   * @deprecated This will be replaced with primaryText
   */
  primaryCopy: Scalars["String"];
  /** Represents the primary copy (ie: terms and conditions) */
  primaryText?: Maybe<EgdsPlainText>;
  /** Represents the secondary copy (ie: secure booking message) */
  secondaryCopy: EgdsIconText;
};

/** Represents an action to click a button */
export type FlightsBookingAction = FlightsClientAction & {
  __typename?: "FlightsBookingAction";
  /** Used to provide accessibility that has to be read on completion of action. */
  accessibility?: Maybe<Scalars["String"]>;
  /** Used to capture client side analytics */
  analyticsList: Array<ClientSideAnalytics>;
};

/** Action to move between bounds in FSR */
export type FlightsBoundNavigation = FlightsClientAction & {
  __typename?: "FlightsBoundNavigation";
  accessibility?: Maybe<Scalars["String"]>;
  /** Used to capture client side analytics */
  analyticsList: Array<ClientSideAnalytics>;
  /** The package URI to redirect to. */
  jcid: Scalars["String"];
  /** The multi item price token. */
  mipt?: Maybe<Scalars["String"]>;
  /** The new bound page id */
  pageId: Scalars["String"];
  /** The package URI to redirect to. */
  stepIndicatorJcid: Scalars["String"];
};

/** Represents the button width in the UI */
export type FlightsButtonWidth =
  /** Button will take the width it needs */
  | "DEFAULT"
  /** Button will take the full width of the content */
  | "FULL_WIDTH";

/** Cabin class chosen in flight */
export type FlightsCabinClass = "BUSINESS" | "COACH" | "FIRST" | "PREMIUM_ECONOMY";

/** Represents each filter item in a FlightsCardsDisplayFilterOption */
export type FlightsCardsDisplayFilterItem = FlightsFilterItem & {
  __typename?: "FlightsCardsDisplayFilterItem";
  /** Represents the accessibility message for the filter item */
  accessibility?: Maybe<FlightsAccessibilityMessage>;
  /** Represents the icon to be displayed in the card for this item */
  card: Icon;
  /** Boolean which represents whether a particular item is selected or not when filters are cleared */
  defaultSelected: Scalars["Boolean"];
  /** Represents the analytics to track on interaction when this filter item is deselected */
  deselectAnalytics: FlightsAnalytics;
  /** Represents the additional details to be displayed in the card for this item ex '05:00 - 11:59 */
  details?: Maybe<Scalars["String"]>;
  /** Represents the object to be sent back to the server in the subsequent request when this particular filter item is selected */
  flightsSearchFilterValues: FlightsSearchFilterValues;
  /** Represents the identifier for the particular filter item */
  identifier: Scalars["String"];
  /** Represents the label for this filter item. Ex Morning */
  label: Scalars["String"];
  /** Represents the analytics to track on interaction when this filter item is selected */
  selectAnalytics: FlightsAnalytics;
  /** Boolean which represents whether a particular item is selected or not */
  selected: Scalars["Boolean"];
  /** Represents the sub label for this filter item. Ex (5:00am - 11:59am) */
  subLabel: Scalars["String"];
  /** Represents the filter value for this filter item. Would aid in solving the client side sort and filter */
  value: FlightsFilterValue;
};

/** Represents the cards based filter module . Ex Departure time based filter on mApp */
export type FlightsCardsDisplayFilterOption = FlightsFilterOption & {
  __typename?: "FlightsCardsDisplayFilterOption";
  /** Represents analytics to track application of the filter */
  filterAppliedAnalytics?: Maybe<FlightsAnalytics>;
  /** Represents the list of filter items associated with this filter option */
  items: Array<FlightsCardsDisplayFilterItem>;
  /** Represents the label associated with particular filter option */
  label: Scalars["String"];
  /** Represents whether the filter supports multi-selection */
  supportsMultipleSelection: Scalars["Boolean"];
  /** Represents the FilterType for this filter option */
  type: FlightsFilterType;
};

/** Represents the value associated with travel and baggage filter - carry on bag */
export type FlightsCarryOnBagBasedFilterValue = {
  __typename?: "FlightsCarryOnBagBasedFilterValue";
  carryOnBag: CarryOnBagType;
};

/** Represents the value associated with travel and baggage filter - carry on bag */
export interface FlightsCarryOnBagBasedFilterValueInput {
  carryOnBag: CarryOnBagType;
}

/** A list of categorized items in flights experiences */
export type FlightsCategorizedList = {
  __typename?: "FlightsCategorizedList";
  /** Represents a section inside the categorized list */
  sections: Array<FlightsCategorizedListSection>;
};

/** An item inside a section of a categorize list */
export type FlightsCategorizedListItem = {
  __typename?: "FlightsCategorizedListItem";
  /** List of analytics associated with the list item */
  displayAnalytics?: Maybe<Array<ClientSideAnalytics>>;
  /** Primary text to be rendered in the left hand side of the list */
  primary: EgdsSpannableText;
  /**
   * Secondary text to be rendered in the right hand side of the list
   * @deprecated secondary replaces with secondaryContent as it supports EGDSSpannableText
   */
  secondary?: Maybe<Scalars["String"]>;
  /** Secondary text to be rendered in the right hand side of the list */
  secondaryContent?: Maybe<EgdsSpannableText>;
  /** Tertiary text to be rendered underneath the primary text */
  tertiary?: Maybe<Scalars["String"]>;
};

/** A section inside a flights categorized list */
export type FlightsCategorizedListSection = {
  __typename?: "FlightsCategorizedListSection";
  /** Represents the category heading for the items */
  accessibilityMessage?: Maybe<Scalars["String"]>;
  /** Represents additional info below a whole section of lists this is rendered as a normal sized text */
  additionalInfo?: Maybe<Array<Scalars["String"]>>;
  /** Represents the list of specifications to render underneath the list this is rendered as a small sized text */
  footnote?: Maybe<Array<Scalars["String"]>>;
  /** Represents the category heading for the items */
  heading?: Maybe<Scalars["String"]>;
  /** Represents the items inside this category */
  items: Array<FlightsCategorizedListItem>;
};

/** Represents section for change and cancellation fees */
export type FlightsChangeAndCancellationFees = {
  __typename?: "FlightsChangeAndCancellationFees";
  /** Change and Cancellation details like label, fees, etc. */
  changeAndCancellationDetails: Array<FlightsLabelAndValue>;
  /** List of analytics to be fired based on fees displayed */
  displayAnalytics?: Maybe<Array<FlightsAnalytics>>;
  /** Heading of section, ex: Change and Cancellation */
  heading: Scalars["String"];
};

/** Represents info about the cheapest listing in the search results */
export type FlightsCheapestListingInfo = {
  __typename?: "FlightsCheapestListingInfo";
  /**
   * An object which represents flexible search accuracy for searched date
   * @deprecated We now need 2 nodes to represent 2 different types of analytics
   */
  analytics: FlightsAnalytics;
  /** An object which represents analytics for flexible search accuracy for searched date */
  deviationAnalytics?: Maybe<FlightsAnalytics>;
  /** An object which represents nff analytics for flexible search accuracy for searched date */
  nffAnalytics: FlightsAnalytics;
  /** Lowest price of an offer, from the available list of offers */
  price: Scalars["String"];
};

/** Represents the value associated with travel and baggage filter - checked bag */
export type FlightsCheckedBagBasedFilterValue = {
  __typename?: "FlightsCheckedBagBasedFilterValue";
  numOfCheckedBags: Scalars["Int"];
};

/** Represents the value associated with travel and baggage filter - checked bag */
export interface FlightsCheckedBagBasedFilterValueInput {
  numOfCheckedBags: Scalars["Int"];
}

/** Represents an action to click */
export type FlightsClickAction = FlightsClientAction & {
  __typename?: "FlightsClickAction";
  /** Used to provide accessibility that has to be read on completion of action. */
  accessibility?: Maybe<Scalars["String"]>;
  /** Used to capture client side analytics */
  analyticsList: Array<ClientSideAnalytics>;
};

export interface FlightsClientAction {
  /** Used to provide accessibility that has to be read on completion of action */
  accessibility?: Maybe<Scalars["String"]>;
  /** Represents the analytics to track when interacting with this action */
  analyticsList: Array<ClientSideAnalytics>;
}

/** Represents union of flights action elements */
export type FlightsClientActionElement = FlightsActionButton | FlightsActionLink;

export type FlightsClientMetadata = FlightsPwaMetadata;

/** Represents the main confirmation content on the confirmation servicing view */
export type FlightsConfirmation = {
  __typename?: "FlightsConfirmation";
  /** Represents the 'view my itinerary' button with action */
  action?: Maybe<FlightsActionButton>;
  /** Represents the itinerary number */
  itinerary: EgdsStylizedText;
  /** Represents a label to denote the itinerary number (ie: 'Expedia itinerary number') */
  label: EgdsPlainText;
  /** Represents the list of announcements */
  list: EgdsUnorderedList;
  /**
   * Represents the 'view my itinerary' action
   * @deprecated This will be replaced with action
   */
  primaryAction: FlightsBookingAction;
  /**
   * Represents the 'view my itinerary' button
   * @deprecated This will be replaced with action
   */
  primaryButton: UiPrimaryButton;
};

/** Details of a single flight (from take-off to landing) in the entire journey, represents a connection */
export type FlightsConnection = {
  __typename?: "FlightsConnection";
  /** Model of the aircraft, ex: Boeing 737-900 */
  aircraftModel?: Maybe<Scalars["String"]>;
  /** Carrier details with the operating carrier, ex: American 173 operated by Air Canada */
  airlineInfo: Scalars["String"];
  /** Cabin class information, ex: Economy/Coach(B) */
  cabinClassAndBookingCode: Scalars["String"];
  /** Details of the flights destination information like landing/take-off time and location */
  connectionArrival: CoordinateInformation;
  /** Details of the flights origin information like landing/take-off time and location */
  connectionDeparture: CoordinateInformation;
  /** Duration of this flight, ex: 2h 30m flight */
  duration: Scalars["String"];
  /** represents leg duratioin accessibility text  */
  durationAccessibilityMessage: Scalars["String"];
  /** Represents the amenities included in this flight. Amenities include Wi-Fi, Entertainment and Electric outlets. */
  journeyAmenities?: Maybe<FlightsJourneyAmenities>;
  /** Airline operated by value */
  operatedBy?: Maybe<Scalars["String"]>;
};

/** Describes different aspects of a flight connection */
export type FlightsConnectionInformation = {
  __typename?: "FlightsConnectionInformation";
  /** Details of a single flight (from take-off to landing) in the entire journey, represents a connection */
  flightsConnection: FlightsConnection;
  /** Informs the user whether the flight is pending for govt. approval */
  governmentApprovalMessage?: Maybe<Scalars["String"]>;
};

/** Represents the coupon credits card in the listings */
export type FlightsCouponCredit = {
  __typename?: "FlightsCouponCredit";
  /** Represents the link shown on the coupon credit card */
  couponCreditAction: FlightsAction;
  /** Represents comment icon and label on the the coupon credit card */
  imageListingLabel: FlightsImageListingLabel;
};

/** Used to represent the action of removing a selected credit */
export type FlightsCreditClearAction = FlightsClientAction & {
  __typename?: "FlightsCreditClearAction";
  accessibility?: Maybe<Scalars["String"]>;
  /** Used to capture client side analytics */
  analyticsList: Array<ClientSideAnalytics>;
};

/** Represents the value credit eligible filter */
export type FlightsCreditEligibleFilterValue = {
  __typename?: "FlightsCreditEligibleFilterValue";
  creditEligible: CreditEligibleFilterType;
};

/** Represents the value credit eligible filter */
export interface FlightsCreditEligibleFilterValueInput {
  creditEligible: CreditEligibleFilterType;
}

export type FlightsCreditResidualMessaging = {
  __typename?: "FlightsCreditResidualMessaging";
  analytics: Array<ClientSideAnalytics>;
  /** Represents heading for Legal message e.g `Nice Work!` */
  heading: EgdsHeading;
  /** Represents messages for Legal messages e.g `This will be use all of your airline credit. No value will be left.` */
  messages: Array<EgdsElement>;
};

/** Used to represent the action of selecting a credit */
export type FlightsCreditSelectionAction = FlightsClientAction & {
  __typename?: "FlightsCreditSelectionAction";
  accessibility?: Maybe<Scalars["String"]>;
  /** Used to capture client side analytics */
  analyticsList: Array<ClientSideAnalytics>;
  /** Represents the encoded OBID containing information about the selected credit */
  originalBookingId: Scalars["String"];
};

/** Represents an element inside the Select Airline Credits component */
export type FlightsCreditSelectionElement = FlightsElementsWrapper | FlightsOfferCard;

/** Represents the flights credit selection presentation */
export type FlightsCreditSelectionPresentation = {
  __typename?: "FlightsCreditSelectionPresentation";
  /** @deprecated Deprecated to support loading state, replace with airlineCreditsPresentation */
  airlineCreditsContent: AirlineCreditsPresentation;
  /** This will render the airline credits content */
  airlineCreditsPresentation: AirlineCreditsContentPresentation;
  /** This will render airline credits wrapper components */
  airlineCreditsWrapper: FlightsDialogSheet;
  /** This will render the dialogs that could be rendered from the airline credits content */
  dialogs?: Maybe<Array<FlightsDialog>>;
  /** This will render the trigger for the airline credits dialog */
  trigger: FlightsDialogTrigger;
};

/** Represents the Airline Credits section */
export type FlightsCreditSelectionPresentationSection = {
  __typename?: "FlightsCreditSelectionPresentationSection";
  /** All the elements that will be rendered in an airline credit section */
  elements: Array<FlightsCreditSelectionElement>;
};

/** Represents an action to open the Airline Credit Selector component */
export type FlightsCreditSelectorOpenAction = FlightsClientAction & {
  __typename?: "FlightsCreditSelectorOpenAction";
  /** Used to provide accessibility that has to be read on completion of action. */
  accessibility?: Maybe<Scalars["String"]>;
  /** Used to capture client side analytics */
  analyticsList: Array<ClientSideAnalytics>;
};

/** Represents an action to open the Airline Credit Selector component */
export type FlightsCreditSelectorOpenUiAction = UiAction & {
  __typename?: "FlightsCreditSelectorOpenUIAction";
  /** Used to provide accessibility that has to be read on completion of action. */
  accessibility?: Maybe<Scalars["String"]>;
  /** Used to capture client side analytics */
  analytics: ClientSideAnalytics;
};

/** Represents the listing displayed showing servicing info module */
export type FlightsCreditsAvailableListing = {
  __typename?: "FlightsCreditsAvailableListing";
  /** If present, an alert dialog should be rendered immediately. Used to prompt users to decide if they want to see credits. */
  immediateDialogAction?: Maybe<FlightsDialogTriggerUiAction>;
  /** Represents the messaging card / placard */
  messagingCardPlacard: FlightsMessagingCardPlacard;
  /** Represent a standard messaging card */
  standardMessagingCard?: Maybe<EgdsStandardMessagingCard>;
  /** @deprecated This field is now deprecated., replace with toastNotification */
  toast: EgdsToast;
  /** Represents the toast at the bottom of the page */
  toastNotification?: Maybe<EgdsToast>;
};

/** Represents the listing displayed advertising savings on buying Flights cross-sell */
export type FlightsCrossSellMessage = {
  __typename?: "FlightsCrossSellMessage";
  /**
   * Represents the clickable link shown on the listing
   * @deprecated We don't need FlightsActionableLabel as this will be replaced with a shared-ui component
   */
  crossSellLabel: FlightsActionableLabel;
  /**
   * Represents the savings message shown on this listing
   * @deprecated We don't need FlightsPhrase as this will be replaced with a shared-ui component
   */
  message: FlightsPhrase;
  /** Represents a multi-item cross sell banner primer */
  multiItemFlightCrossSellPrimer: MultiItemFlightCrossSellPrimer;
};

/** The flights search results offer representing a suggested cross-sell offer(Flight + Hotel) */
export type FlightsCrossSellOffer = {
  __typename?: "FlightsCrossSellOffer";
  /**
   * Represents the accessibility heading for this cross-sell offer
   * @deprecated Not in usage
   */
  accessibilityHeading?: Maybe<Scalars["String"]>;
  /**
   * Represents the accessibility message for this cross-sell offer
   * @deprecated Not in usage
   */
  accessibilityMessage: Scalars["String"];
  /**
   * Represents the info-link clicking on which opens tool-tip with more details
   * @deprecated Not in usage
   */
  displayDetailsAction: Scalars["String"];
  /**
   * Represents the analytics to track when collapsing the details
   * @deprecated Not in usage
   */
  displayDetailsActionCollapseAnalytics: FlightsAnalytics;
  /**
   * Represents the analytics to track when expanding the details
   * @deprecated Not in usage
   */
  displayDetailsActionExpandAnalytics: FlightsAnalytics;
  /**
   * Represents the jcid if this offer is selected.
   * @deprecated Not in usage
   */
  journeyContinuationId?: Maybe<Scalars["String"]>;
  /**
   * Represents the list of FlightOfferJourney objects. FlightJourney object has all the details necessary for rendering the details of the Flights offer
   * @deprecated Not in usage
   */
  journeys: Array<FlightsOfferJourney>;
  /** Represents the branded deal cross sell primer */
  multiItemFlightCrossSellOfferPrimer?: Maybe<MultiItemFlightCrossSellOfferPrimer>;
  /**
   * Represents the analytics to track on interaction with trigger
   * @deprecated Not in usage
   */
  onClickAnalyticsList: Array<FlightsAnalytics>;
  /**
   * Represents the savings information to be shown in the tool-tip when displayDetailsAction is clicked
   * @deprecated Not in usage
   */
  savings: FlightsSearchCrossSellOfferSavings;
  /**
   * Represents the select button shown on the offer listing
   * @deprecated Not in usage
   */
  selectOfferAction: FlightsAction;
};

/** Represents an individual cross sort item */
export type FlightsCrossSortItem = {
  __typename?: "FlightsCrossSortItem";
  /** Represents the analytics to track on interaction with this sort */
  analytics?: Maybe<FlightsAnalytics>;
  /** The initial weight of the element upon render */
  defaultWeight: Scalars["Int"];
  /** Represents the icon and the label for the item (e.g. 'Seat selection' with a seat icon */
  label: FlightsIconAndLabel;
  /** The type of this cross sort item */
  type: FlightsCrossSortType;
};

/** Represents an individual cross sort parameter */
export type FlightsCrossSortOption = {
  __typename?: "FlightsCrossSortOption";
  /** Enumeration of the parameter type for the accompanying weight */
  type: FlightsCrossSortType;
  /** The current weight of the individual cross sort parameter */
  weight: Scalars["Int"];
};

/** Represents an individual cross sort parameter */
export interface FlightsCrossSortOptionInput {
  /** Enumeration of the parameter type for the accompanying weight */
  type: FlightsCrossSortType;
  /** The current weight of the individual cross sort parameter */
  weight: Scalars["Int"];
}

/** User specified parameters for cross sort */
export type FlightsCrossSortOptionType = {
  __typename?: "FlightsCrossSortOptionType";
  /** The array of all cross-sort parameters selected by the user */
  crossSortOption: Array<FlightsCrossSortOption>;
};

/** User specified parameters for cross sort */
export interface FlightsCrossSortOptionTypeInput {
  /** The array of all cross-sort parameters selected by the user */
  crossSortOption: Array<FlightsCrossSortOptionInput>;
}

/** Represents the cross sort module containing a list of individual cross sort sliders */
export interface FlightsCrossSortPresentation {
  /** The highest possible value on the sort */
  ceiling?: Maybe<Scalars["Int"]>;
  /** Represents the list of cross sort items (such as sliders) in the module */
  crossSortItems: Array<FlightsCrossSortItem>;
  /** The lowest possible value on the sort */
  floor?: Maybe<Scalars["Int"]>;
  /** The header text on the cross sort module */
  heading: Scalars["String"];
  /** The smallest possible change in value of the sort */
  step?: Maybe<Scalars["Int"]>;
  /** The subheader text on the cross sort module */
  subHeading: Scalars["String"];
}

export type FlightsCrossSortPresentationResult = FlightsCrossSortPresentation & {
  __typename?: "FlightsCrossSortPresentationResult";
  /** The highest possible value on the sort */
  ceiling?: Maybe<Scalars["Int"]>;
  /** Represents the list of cross sort items (such as sliders) in the module */
  crossSortItems: Array<FlightsCrossSortItem>;
  /** The lowest possible value on the sort */
  floor?: Maybe<Scalars["Int"]>;
  /** The header text on the cross sort module */
  heading: Scalars["String"];
  /** The smallest possible change in value of the sort */
  step?: Maybe<Scalars["Int"]>;
  /** The subheader text on the cross sort module */
  subHeading: Scalars["String"];
};

export type FlightsCrossSortType =
  | "CABIN_CLASS"
  | "CANCELLATION"
  | "CARRY_ON_BAG"
  | "CHANGE_ALLOWED"
  | "CHECKED_BAG"
  | "DURATION"
  | "NUM_OF_STOPS"
  | "PRICE"
  | "SEAT_CHOICE";

/** Represents content of date picker cell. */
export type FlightsDatePickerCellContent = {
  __typename?: "FlightsDatePickerCellContent";
  /** Represents the message for accessibility on date picker of calendar. */
  accessibility?: Maybe<Scalars["String"]>;
  /** Represents respective price value for the calendar cell. */
  content: FlightsFareCalendarPrice;
  /** Represents respective date for the calendar cell. */
  date: ZonedDateTime;
  /** Click to select a date in the fare calendar followed by click of 'Done' button or outside date calendar */
  selectAnalytics: FlightsAnalytics;
};

/** Represents criteria for continue booking for selecting ancillaries on flight information page */
export interface FlightsDetailAncillaryUpdateCriteriaInput {
  /** Represents details of air ancillary selection request */
  airAncillaryDetails: Array<FlightsAirAncillarySelectionDetailInput>;
  /** Represents the list of per segment(seats)/per product(bags) selections */
  ancillaryJourneySelections?: InputMaybe<Array<AncillaryJourneySelectionsInput>>;
  /** Represents the ancillary type for update */
  ancillaryType?: InputMaybe<FlightsAncillaryType>;
  /** Represents details of selected ancillaries for each journey */
  flightAncillaryJourneySelections?: InputMaybe<Array<FlightAncillaryJourneySelectionInput>>;
  /** Represent the continuation identifier for spinner to deduce all journeys selected by the user. */
  journeyContinuationId: Scalars["String"];
  /** Represents Air Offer Token of the selected flight */
  journeyIdentifier: Scalars["String"];
}

/** Represents criteria for flights information page. */
export interface FlightsDetailComponentsCriteriaInput {
  /** Represents FlightsSearchContext of the selected flight */
  flightsSearchContext: FlightsSearchContextInput;
  /** Represents FlightsJourneyCriteria of the selected flight */
  journeyCriteria: Array<FlightsJourneyCriteriaInput>;
  /** Represents Air Offer Token of the selected flight */
  journeyIdentifier: Scalars["String"];
  /** Represents Price of the selected flight */
  originalPrice?: InputMaybe<MoneyInput>;
  /** Represents QueryParams of the selected flight */
  queryParams?: InputMaybe<Array<GraphQlPairInput>>;
  /** Represents FlightsSearchPreferences of the selected flight */
  searchPreferences?: InputMaybe<FlightsSearchPreferencesInput>;
  /** Represents FlightsTravelerDetails of the selected flight */
  travelerDetails: Array<FlightsTravelerDetailsInput>;
  /** Represents upsell offer token of the selected flight */
  upsellOfferToken?: InputMaybe<Scalars["String"]>;
}

/** Represents criteria for flights information page. */
export type FlightsDetailCriteria = {
  __typename?: "FlightsDetailCriteria";
  /** Encoded representation of ancillaries that was selected on FIS. */
  ancillaryId?: Maybe<Scalars["String"]>;
  /** Represents the type of the channel for example VirtualAgent */
  channelType?: Maybe<ChannelType>;
  /** Represent the continuation identifier for spinner to deduce all journeys selected by the user. */
  journeyContinuationId: Scalars["String"];
  /** Represents the identifier for the spinner to deduce which all credits have been selected by the user */
  originalBookingId?: Maybe<Scalars["String"]>;
  /** Represents upsell offer token of the selected flight */
  upsellOfferToken?: Maybe<Scalars["String"]>;
};

/** Represents criteria for flights information page. */
export interface FlightsDetailCriteriaInput {
  /** Encoded representation of ancillaries that was selected on FIS. */
  ancillaryId?: InputMaybe<Scalars["String"]>;
  /** Represents the type of the channel for example VirtualAgent */
  channelType?: InputMaybe<ChannelType>;
  /** Represent the continuation identifier for spinner to deduce all journeys selected by the user. */
  journeyContinuationId: Scalars["String"];
  /** Represents the identifier for the spinner to deduce which all credits have been selected by the user */
  originalBookingId?: InputMaybe<Scalars["String"]>;
  /** Represents upsell offer token of the selected flight */
  upsellOfferToken?: InputMaybe<Scalars["String"]>;
}

/** Summary and Details for a Journey */
export type FlightsDetailedJourneyInformation = {
  __typename?: "FlightsDetailedJourneyInformation";
  /** Show/Hide details toggle to change the summary view to detailed view of the trip */
  details: FlightsToggle;
  /** Represents list of details for each journey part for the trip, null for bargain fares */
  flightJourneyDetails: FlightsJourneyDetails;
};

/** Container for the information of the journey and fares */
export type FlightsDetailsAndFaresContent = {
  __typename?: "FlightsDetailsAndFaresContent";
  /** The dialogId where this content is rendered, this is used to close it after selecting a credit */
  dialogId: FlightsDialogId;
  /** The dynamic dialog ID if present this takes precedence over dialogId */
  dynamicDialogId?: Maybe<Scalars["String"]>;
  /** Nested dialogs to be rendered from details and fares content */
  nestedDialogs?: Maybe<Array<FlightsDialog>>;
  /** Nested dialogs to be rendered from details and fares content specific for Price Match Promise */
  priceMatchPromiseNestedDialogs?: Maybe<Array<FlightsDialog>>;
  /** Container for the different sections of the Details and Fares. */
  sections: Array<FlightsDetailsAndFaresSection>;
};

/** Represents the dialog and sheet footer content */
export type FlightsDetailsAndFaresFooter = {
  __typename?: "FlightsDetailsAndFaresFooter";
  /** Represents the action button to render inside footer */
  action: FlightsActionButton;
  /** The dialogId where this footer is rendered, this is used to close it after selecting a credit */
  dialogId: FlightsDialogId;
  /** The dynamic dialog ID if present this takes precedence over dialogId */
  dynamicDialogId?: Maybe<Scalars["String"]>;
  /** Represents the priceLockup to render inside footer */
  priceLockup: EgdsPriceLockup;
};

/** Summary of all available fares and details for a Journey */
export type FlightsDetailsAndFaresPresentation = {
  __typename?: "FlightsDetailsAndFaresPresentation";
  /** All the information of the journey and fares. */
  content: FlightsDetailsAndFaresContent;
  /** Displays the information which handles the different breakpoints and uses `content` */
  flightsFaresWrapper: FlightsDialogSheet;
  /** Represents the dialog and sheet footer content. */
  footer?: Maybe<FlightsDetailsAndFaresFooter>;
  /** Calls the wrapper into action */
  trigger: FlightsDialogTrigger;
};

/** Represents price summary elements: Price, price qualifier, strikethrough price, price caption. */
export type FlightsDetailsAndFaresPriceSection = {
  __typename?: "FlightsDetailsAndFaresPriceSection";
  /** Price rendered on the left of the main price */
  leadingPrice?: Maybe<EgdsSpannableText>;
  /** Primary price rendered */
  price: EgdsSpannableText;
  /** List of texts rendered bellow the main price */
  secondaryTexts?: Maybe<Array<EgdsSpannableText>>;
  /** Price rendered on the right of the main price */
  trailingPrice?: Maybe<EgdsSpannableText>;
};

/** Represents a Flights Details and Fares dialog section */
export type FlightsDetailsAndFaresSection =
  | FlightsFaresInformation
  | FlightsHygieneAmenitiesSection
  | FlightsJourneyDetailsInformation
  | FlightsJourneyHeaderInformation
  | FlightsJourneyWithDetails
  | FlightsMessagingCard
  | FlightsSustainabilityCard
  | TextWrapper;

/** Represents the information of the user device */
export interface FlightsDevicePermissionsInput {
  /** Represents the array of all the notifications enabled for the user device */
  pushNotificationsEnabled: Array<NotificationsType>;
}

/** Type used to render dialogs in a feature */
export type FlightsDialog = {
  __typename?: "FlightsDialog";
  /** Provides the content inside of the dialog */
  content?: Maybe<Array<EgdsElement>>;
  /** Represents information about the dialog */
  dialog: EgdsDialog;
  /** Provides the dialog ID associated with trigger */
  dialogId: FlightsDialogId;
  /** Represents the display analytics of the dialog */
  displayAnalytics?: Maybe<ClientSideAnalytics>;
  /** Represents the dynamically created ID of the dialog to render  */
  dynamicDialogId?: Maybe<Scalars["String"]>;
  /** Provides the footer content of the dialog */
  footer?: Maybe<Array<EgdsElement>>;
};

/** Represents flights dialog actions */
export type FlightsDialogAction = "CLOSE" | "OPEN" | "TOGGLE";

/** Represents the type of animation the dialog will use when displayed */
export type FlightsDialogAnimation = "FADE" | "NONE";

export type FlightsDialogChangeFlight = FlightsDialogPresentation & {
  __typename?: "FlightsDialogChangeFlight";
  /** List of all available actions in the change flight dialog */
  actions: Array<FlightsAction>;
  /** Animation used to display the change flight dialog */
  animation: FlightsDialogAnimation;
  /** Represents the analytics to track on when the change flight dialog is displayed */
  displayedAnalytics?: Maybe<FlightsAnalytics>;
  /**
   * Header of the change flight dialog ex. Changing this could affect your other flights. You might have to choose all other flights again
   * @deprecated deprecating header to introduce a new nullable field for title/header of dialog
   */
  header: Scalars["String"];
  /** Main message in the change flight dialog. */
  message?: Maybe<Scalars["String"]>;
  /** Title of the change flight dialog. ex.Replacing non-nullable header field. Changing this could affect your other flights. You might have to choose all other flights again. */
  title?: Maybe<Scalars["String"]>;
};

/** Represents an action to close a dialog */
export type FlightsDialogCloseAction = FlightsClientAction & {
  __typename?: "FlightsDialogCloseAction";
  /** Used to provide accessibility that has to be read on completion of action. */
  accessibility?: Maybe<Scalars["String"]>;
  /** Used to capture client side analytics */
  analyticsList: Array<ClientSideAnalytics>;
};

/** Represents an action to close a dialog */
export type FlightsDialogCloseUiAction = UiAction & {
  __typename?: "FlightsDialogCloseUIAction";
  /** Used to provide accessibility that has to be read on completion of action. */
  accessibility?: Maybe<Scalars["String"]>;
  /** Used to capture client side analytics */
  analytics: ClientSideAnalytics;
};

/** Represents IDs for flights dialogs */
export type FlightsDialogId =
  /** Represents the Airlines credit dialog */
  | "AIRLINE_CREDITS"
  /** Represents the Close button dialog for the baggage details when complete selections have been made */
  | "BAGGAGE_CLOSE_COMPLETE_DIALOG"
  /** Represents the Close button dialog for the baggage details */
  | "BAGGAGE_CLOSE_DIALOG"
  /** Represents the Close button dialog for the baggage details when incomplete selections have been made */
  | "BAGGAGE_CLOSE_INCOMPLETE_DIALOG"
  /** Represents the Continue booking dialog for the baggage details */
  | "BAGGAGE_CONTINUE_BOOKING"
  /** Represents the dialog ID for Baggage details */
  | "BAGGAGE_DETAILS_DIALOG"
  /** Represents the bags popup dialog on checkout button */
  | "BAGS_POPUP_ON_CHECKOUT"
  /** Represents the check credits dialog for users coming from MCC and VA */
  | "CHECK_CREDITS_DIALOG"
  /** Represents the Flights Details and Fares dialog */
  | "FLIGHTS_DETAILS_AND_FARES"
  /** The Forced choice modal that appears in large breakpoints when going to FIS */
  | "FORCED_CHOICE_MODAL"
  /** Represents the How Airlines Work dialog inside Select Credits */
  | "HOW_CREDITS_WORK"
  /** Represents the Leave This Page dialog inside Select Credits */
  | "LEAVE_TO_COUPONS"
  /** Represents the bags opening dialog eg:- sidesheet for desktop , fullscreendialog for mobile */
  | "PAID_BAGS_DIALOG"
  /** Represents the Info dialog for Price Match Promise Selected Card */
  | "PMP_INFO_DIALOG"
  /** Represents the Remove dialog for Price Match Promise Selected Card */
  | "PMP_REMOVE_DIALOG"
  /** Represents the seats popup dialog on checkout button */
  | "SEATS_POPUP_ON_CHECKOUT"
  /** Represents the Close button dialog for the seat details */
  | "SEAT_CLOSE_COMPLETE_DIALOG"
  /** Represents the Continue booking dialog for the baggage details */
  | "SEAT_CONTINUE_BOOKING"
  /** Represents the seats opening dialog eg:- sidesheet for desktop , fullscreendialog for mobile */
  | "SEAT_SELECTION_DIALOG"
  /** Represents the dialog on traveler mismatch for credits offer */
  | "TRAVELER_MISMATCH_DIALOG";

export type FlightsDialogMultiPassengerCredit = FlightsDialogPresentation & {
  __typename?: "FlightsDialogMultiPassengerCredit";
  /** List of all available actions in the dialog */
  actions: Array<FlightsAction>;
  /** Animation used to display the dialog */
  animation: FlightsDialogAnimation;
  /** Represents the analytics to track on when the dialog is displayed */
  displayedAnalytics: FlightsAnalytics;
  /**
   * Header of the dialog. Example: 'Please refresh your search for the latest prices'
   * @deprecated deprecating header to introduce a new nullable field for title/header of dialog
   */
  header: Scalars["String"];
  /** Primary message of the dialog containing information about the user's credit selection */
  message: Scalars["String"];
  /** Complementary messages. Example: ['If you need to use this credit for a single passenger', 'Call customer support at 234'] */
  secondaries?: Maybe<Array<EgdsStylizedText>>;
  /** Title of the dialog. Example: 'Change search to multi-passenger?' */
  title?: Maybe<Scalars["String"]>;
};

/** Represents a Dialog or Modal */
export interface FlightsDialogPresentation {
  /** List of all available actions in the dialog */
  actions: Array<FlightsAction>;
  /** Animation used to display the dialog */
  animation: FlightsDialogAnimation;
  /** Represents the analytics to track on when the dialog is displayed */
  displayedAnalytics?: Maybe<FlightsAnalytics>;
  /**
   * Header of the dialog
   * @deprecated deprecating header to introduce a new nullable field for title/header of dialog
   */
  header: Scalars["String"];
  /** Main message of the dialog */
  message?: Maybe<Scalars["String"]>;
  /** Title of the dialog. Replacing non-nullable header field */
  title?: Maybe<Scalars["String"]>;
}

export type FlightsDialogServerError = FlightsDialogPresentation & {
  __typename?: "FlightsDialogServerError";
  /** List of all available actions in the dialog */
  actions: Array<FlightsAction>;
  /** Animation used to display the dialog */
  animation: FlightsDialogAnimation;
  /** Represents the analytics to track on when the dialog is displayed */
  displayedAnalytics?: Maybe<FlightsAnalytics>;
  /**
   * Header of the dialog. Example: No Network
   * @deprecated deprecating header to introduce a new nullable field for title/header of dialog
   */
  header: Scalars["String"];
  /** Main message in the dialog. Example: 'Sorry, we could not connect to Expedia's servers.' */
  message?: Maybe<Scalars["String"]>;
  /** Title of the dialog. Replacing non-nullable header field. Example: No Network */
  title?: Maybe<Scalars["String"]>;
};

/** Type used to render a dialog in small viewport and sheet in medium/large */
export type FlightsDialogSheet = {
  __typename?: "FlightsDialogSheet";
  /** Represents the dialog to render */
  dialog: FlightsDialog;
  /** Represents the ID of the dialog to render */
  dialogId: FlightsDialogId;
  /** Represents the dynamically created ID of the dialog to render  */
  dynamicDialogId?: Maybe<Scalars["String"]>;
  /** Represents the sheet to render */
  sheet: FlightsSideSheet;
};

export type FlightsDialogStaleSession = FlightsDialogPresentation & {
  __typename?: "FlightsDialogStaleSession";
  /** List of all available actions in the dialog */
  actions: Array<FlightsAction>;
  /** Animation used to display the dialog */
  animation: FlightsDialogAnimation;
  /** Represents the analytics to track on when the dialog is displayed */
  displayedAnalytics: FlightsAnalytics;
  /**
   * Header of the dialog. Example: 'Please refresh your search for the latest prices'
   * @deprecated deprecating header to introduce a new nullable field for title/header of dialog
   */
  header: Scalars["String"];
  /** Main message in the dialog. Example: 'Flight prices change frequently due to availability and demand' */
  message?: Maybe<Scalars["String"]>;
  /** Represents the length of time before displaying the dialog. Example: 1200 */
  timeoutInSeconds: Scalars["Int"];
  /** Title of the dialog. Replacing non-nullable header field. Example: 'Please refresh your search for the latest prices */
  title?: Maybe<Scalars["String"]>;
};

/** Represents the Flights Standard dialog which can be used for any standard dialog implementation. */
export type FlightsDialogStandard = FlightsDialogPresentation & {
  __typename?: "FlightsDialogStandard";
  /** List of all available actions in the dialog */
  actions: Array<FlightsAction>;
  /** Animation used to display the dialog */
  animation: FlightsDialogAnimation;
  /** Represents the analytics to track on when the dialog is displayed */
  displayedAnalytics: FlightsAnalytics;
  /** @deprecated deprecating header to introduce a new nullable field for title/header of dialog */
  header: Scalars["String"];
  /** Main message in the dialog. Example: 'Please refresh the page to resolve the error. If the error persists, please try your search again.' */
  message?: Maybe<Scalars["String"]>;
  /** Title of the dialog. Replacing non-nullable header field. Example: 'We've encountered a problem on our end in selecting your fare' */
  title?: Maybe<Scalars["String"]>;
};

/** Represents an EGDS dialog trigger */
export type FlightsDialogTrigger = EgdsButton &
  EgdsElement & {
    __typename?: "FlightsDialogTrigger";
    /** @deprecated Will be provided in trigger field */
    accessibility?: Maybe<Scalars["String"]>;
    /**
     * @deprecated
     *         UIAction should not be used as a field because it allows for too many possible types.
     *         If need to specify action have the implementation of EGDSButton add a field for action with interface type of less number of possible subtypes
     *         or a union type with a manageable number of members
     *
     */
    action?: Maybe<UiAction>;
    /** @deprecated Will be provided in trigger field */
    analytics?: Maybe<ClientSideAnalytics>;
    /** Represents the action for the dialog */
    dialogAction: FlightsDialogAction;
    /** Provides the dialog ID associated with trigger */
    dialogId: FlightsDialogId;
    /** @deprecated Will be provided in trigger field */
    disabled: Scalars["Boolean"];
    /** Represents the dynamically created ID of the dialog to render  */
    dynamicDialogId?: Maybe<Scalars["String"]>;
    egdsElementId?: Maybe<Scalars["String"]>;
    /** @deprecated Will be provided in trigger field */
    icon?: Maybe<Icon>;
    /** @deprecated Will be provided in trigger field */
    primary?: Maybe<Scalars["String"]>;
    /** Represents the link or button trigger */
    trigger: FlightsDialogTriggerType;
  };

/** Represents an action to open a dialog */
export type FlightsDialogTriggerAction = FlightsClientAction & {
  __typename?: "FlightsDialogTriggerAction";
  /** Used to provide accessibility that has to be read on completion of action. */
  accessibility?: Maybe<Scalars["String"]>;
  /** Used to capture client side analytics */
  analyticsList: Array<ClientSideAnalytics>;
  /** Contains the information about the dialog that this action triggers */
  dialog: EgdsDialog;
  /** Content to render inside the dialog that this action triggers */
  dialogContents: Array<EgdsElement>;
};

/** Represents union of flights dialog trigger types */
export type FlightsDialogTriggerType =
  | FlightsActionButton
  | FlightsActionLink
  | FlightsSmartShoppingActionButton
  | FlightsSmartShoppingActionLink;

/** Represents an action to open a dialog */
export type FlightsDialogTriggerUiAction = UiAction & {
  __typename?: "FlightsDialogTriggerUIAction";
  /** Used to provide accessibility that has to be read on completion of action. */
  accessibility?: Maybe<Scalars["String"]>;
  /** Used to capture client side analytics */
  analytics: ClientSideAnalytics;
  /** Contains the information about the dialog that this action triggers */
  dialog: EgdsDialog;
  /** Content to render inside the dialog that this action triggers */
  dialogContents: Array<EgdsElement>;
};

/** Represents flights component */
export type FlightsDisplayComponent = "SMART_NFF_ALTERNATE_SUGGESTION";

/** Represents display count of a component within a session e.g How many time NFF shows consecutively   */
export type FlightsDisplayComponentCountingValue = FlightsDisplayComponentValue & {
  __typename?: "FlightsDisplayComponentCountingValue";
  /** Represents display count of a flights component */
  displayCount: Scalars["Int"];
  flightsDisplayComponent: FlightsDisplayComponent;
};

/** Represents display count of a component within a session e.g How many time NFF shows consecutively   */
export interface FlightsDisplayComponentCountingValueInput {
  /** Represents display count of a flights component */
  displayCount: Scalars["Int"];
  flightsDisplayComponent: FlightsDisplayComponent;
}

/** Represents Flights components value */
export interface FlightsDisplayComponentValue {
  flightsDisplayComponent: FlightsDisplayComponent;
}

/** Represents flights component display values */
export interface FlightsDisplayComponentValuesInput {
  /** Represents counting values of flights display component */
  displayCountingValues?: InputMaybe<Array<FlightsDisplayComponentCountingValueInput>>;
}

/** Represents the value associated with duration based filter */
export type FlightsDurationBasedFilterValue = {
  __typename?: "FlightsDurationBasedFilterValue";
  maxDuration: Scalars["Int"];
};

/** Represents the value associated with duration based filter */
export interface FlightsDurationBasedFilterValueInput {
  maxDuration: Scalars["Int"];
}

/** Represents the offer timeline information */
export type FlightsDurationTimeline = {
  __typename?: "FlightsDurationTimeline";
  /** Represents timeline additional information rendered below */
  additionalInfo: Scalars["String"];
  /** Offer end data for multiple breakpoints */
  end: DurationTimelineSideSection;
  /** Represents timeline heading */
  heading: Scalars["String"];
  /** Offer start data for multiple breakpoints */
  start: DurationTimelineSideSection;
  /** Number of dots displayed in the timeline */
  stops: Scalars["Int"];
};

/** Represents dynamic elements associated with selected set of journeys */
export interface FlightsDynamicElements {
  dynamicElementsGroupTrackEventAnalytics?: Maybe<FlightsDynamicElementsTrackEventAnalytics>;
  flightsJourneyDetailsDynamicElements?: Maybe<Array<FlightsJourneyDetailsDynamicElements>>;
}

/** Represents the analytics to track on interaction with dynamic elements group */
export type FlightsDynamicElementsTrackEventAnalytics = {
  __typename?: "FlightsDynamicElementsTrackEventAnalytics";
  /** Represents the analytics type to be tracked on interaction with dynamic elements */
  analyticsList: Array<FlightsAnalytics>;
  /** Stringified summary of all flight products which are part of analytics tracking */
  stringifiedAllFlightProducts: Scalars["String"];
};

/** Represents a wrapper for the EGDSElement to be rendered in a Credit Selection element */
export type FlightsElementsWrapper = {
  __typename?: "FlightsElementsWrapper";
  /** An EGDSElement to be rendered */
  element: EgdsElement;
};

/** Represents the email subscription card in the listings */
export type FlightsEmailSubscription = {
  __typename?: "FlightsEmailSubscription";
  /** Represents mail icon on the the email subscription card */
  icon: Icon;
  /** Represents email input field label on the the email subscription card */
  label: Scalars["String"];
  /** Represents the link shown on the email subscription card */
  submitAction: FlightsAction;
  /** Represents title on the the email subscription card */
  title: Scalars["String"];
};

/** Represents a message to be displayed to users in case of any sort of failure */
export interface FlightsErrorMessagingPresentation {
  /** Icon included at the top of the message. Example: Search icon */
  icon: Icon;
  /** Message content */
  message: Scalars["String"];
  /** Title of the message */
  title: Scalars["String"];
}

/** Represents a message that can be displayed during an error state */
export type FlightsErrorSummary = {
  __typename?: "FlightsErrorSummary";
  /** Represents the analytics for impression tracking */
  displayAnalytics: FlightsAnalytics;
  /** Represents the message at the top of the error summary */
  header: Scalars["String"];
  /** Represents the analytics for link click tracking */
  linkAnalytics: FlightsAnalytics;
  /** Represents the interactable text related to the error */
  linkText: Scalars["String"];
};

/** Represent the event information needed for tracking */
export interface FlightsEventAnalytics {
  /** Represent the event category for event tracking */
  eventCategory: Scalars["String"];
  /** Represent the event type for event tracking */
  eventType: Scalars["String"];
  /** Represent the page name for event tracking */
  pageName: Scalars["String"];
}

/** Represents fare calendar price. */
export type FlightsFareCalendarPrice = {
  __typename?: "FlightsFareCalendarPrice";
  /** Represents respective price for the date cell. */
  price?: Maybe<Money>;
  /** Represents respective css class name for positive or negative value for the price. */
  priceTheme: FlightsFareCalendarPriceTheme;
  /** Formatted and localized displayable string for the price */
  valueText: Scalars["String"];
};

/** Css class names for datepicker cell content. */
export type FlightsFareCalendarPriceTheme = "NEGATIVE" | "POSITIVE" | "UNDEFINED";

/** Represents the flight fare calendar response. */
export type FlightsFareCalendarResponse = {
  __typename?: "FlightsFareCalendarResponse";
  /** An object which represents coverage analytics for fare calendar price */
  coverageAnalytics: FlightsAnalytics;
  /** Date picker cell contents. */
  datePickerCellContents: Array<FlightsDatePickerCellContent>;
  /** Localized disclaimer text for prices shown in datepicker. */
  disclaimerText: Scalars["String"];
};

/** Summary of all available fares for a Journey */
export type FlightsFareChoiceInformation = {
  __typename?: "FlightsFareChoiceInformation";
  /** Represents the review fare header accessibility text */
  accessibleHeading: Scalars["String"];
  /** Represents the number of fares available with this offer */
  availableFaresCount: Scalars["Int"];
  /** Represents the conversion analytics for all fare types */
  convertAnalytics?: Maybe<Array<FlightsAnalytics>>;
  /** Default baggage messaging to show when no Fare is selected */
  defaultBaggageInformation: FlightsBaggageInformation;
  /** Represents the dialogs available for fares Eg: Price match promise info dialog */
  dialogs?: Maybe<Array<FlightsDialog>>;
  /**
   * Represents the display analytics if fare options are displayed
   * @deprecated This field will be replaced by displayAnalyticsList
   */
  displayAnalytics: FlightsAnalytics;
  /** Represents the display analytics list if fare options and/or credit eligible fare are displayed */
  displayAnalyticsList: Array<FlightsAnalytics>;
  /** Represents the error analytics for all fare choices on side sheet */
  errorAnalytics?: Maybe<Array<FlightsAnalytics>>;
  /** A list of all available Fares for the Journey */
  fareTypes: Array<FlightsJourneyFare>;
  /** Represents the skeleton count for fare types loading state */
  fareTypesSkeletonCount: Scalars["Int"];
  /** A list of generic available Fares for the Journey, possible types: FlightsJourneyFare, FlightsPMPJourneyFare */
  fares?: Maybe<Array<FlightsJourneyFareBase>>;
  /** Represents the analytics for loading of fares on side sheet */
  faresTypesLoadingAnalytics: FaresTypesLoadingAnalytics;
  /** Headline for the list of available fares, e.g. 'Select fare to ...' */
  heading: FlightsResponsiveMessage;
  /** Message informing user about the applicability of fare if there are multiple pax, ex: Your selection applies to each traveler */
  message: Scalars["String"];
  /** Represents the carousel next button accessibility text */
  nextFareChoiceAccessibilityMessage: Scalars["String"];
  /** Represents the link to understand percentage delays and cancellation */
  percentageDelaysAndCancellationLink?: Maybe<FlightsLinkAction>;
  /** Represents the carousel previous button accessibility text */
  previousFareChoiceAccessibilityMessage: Scalars["String"];
  /** Represents the dialogs available for fares that is specific for Price match promise */
  priceMatchPromiseDialogs?: Maybe<Array<FlightsDialog>>;
  /** Represents the analytics for forward/back scroll */
  scrollAnalytics: FlightsAnalytics;
  /** Represents the Sustainability information for flights Eg: Link to airlines sustainability page */
  sustainabilityInformation?: Maybe<FlightsIconPhrases>;
  /** Represents the type of trip that belongs to the offer. Ex: Oneway per traveler, Roundtrip per traveler */
  tripTypePerTraveler: Scalars["String"];
};

/** Represents a rule or restriction for a specific fare type. */
export type FlightsFareRule = {
  __typename?: "FlightsFareRule";
  /** Represents the icon and name of a rule. Ex: done, not-allowed, monetization_on, Ex: no carry on, pay to choose your seats, changes */
  displayName: FlightsIconAndLabel;
  /** Represents the value for a rule. Ex: fee applies, included */
  value?: Maybe<Scalars["String"]>;
};

/** Temporary implementation for flight selection in details and fares' fare types. Should get deprecated once forced choice is implemented in shared-ui */
export type FlightsFareTypeSelectionAction = FlightsClientAction & {
  __typename?: "FlightsFareTypeSelectionAction";
  accessibility?: Maybe<Scalars["String"]>;
  /** Used to capture client side analytics */
  analyticsList: Array<ClientSideAnalytics>;
  /** Provides the dialog ID associated with trigger */
  dialogId?: Maybe<Scalars["String"]>;
  /** The URI to redirect to. */
  nextPage: Uri;
  /** The package URI to redirect to. */
  packagePage?: Maybe<Uri>;
};

/** The available fares section of Details and Fares */
export type FlightsFaresInformation = {
  __typename?: "FlightsFaresInformation";
  /**
   * Represents the carousel data
   * @deprecated Deprecated in favor of faresCarousel
   */
  carousel: EgdsCarouselContainer;
  /** Represents the analytics to trigger when the carousel is displayed */
  displayAnalytics: Array<ClientSideAnalytics>;
  /** Represents the fares that will be rendered inside the carousel */
  fares: Array<FareInformationCard>;
  /** Represents the carousel data */
  faresCarousel: EgdsCarousel;
  /** Represents the heading on top of the carousel */
  heading?: Maybe<Scalars["String"]>;
  /** Represents the analytics to trigger when the carousel is scrolled */
  scrollAnalytics: Array<ClientSideAnalytics>;
  /** Represents the subheading after the heading */
  subheading?: Maybe<Scalars["String"]>;
};

/** Represent the fares needs to be present in listing results */
export type FlightsFaresSeparationType = "BASE_AND_UPSELL" | "ONLY_BASE" | "ONLY_UPSELL";

/** Represents the feedback card in the listings */
export type FlightsFeedback = {
  __typename?: "FlightsFeedback";
  /** Represents the link shown on the feedback card */
  feedbackLinkAction: FlightsAction;
  /** Represents comment icon and label on the the feedback card */
  iconAndLabel: FlightsIconAndLabel;
};

/** Represents each item in a filter module(FlightsFilterOption) ex <1 Stop  $135> */
export interface FlightsFilterItem {
  /** Represents the accessibility message for the filter item */
  accessibility?: Maybe<FlightsAccessibilityMessage>;
  /** Boolean which represents whether a particular item is selected or not when filters are cleared */
  defaultSelected: Scalars["Boolean"];
  /** Represents the object to be sent back to the server in the subsequent request when this particular filter item is selected */
  flightsSearchFilterValues: FlightsSearchFilterValues;
  /** Represents the identifier for the particular filter item */
  identifier: Scalars["String"];
  /** Represents the label for this filter item */
  label: Scalars["String"];
  /** Boolean which represents whether a particular item is selected or not */
  selected: Scalars["Boolean"];
  /** Represents the filter value for this filter item. Would aid in solving the client side sort and filter */
  value: FlightsFilterValue;
}

/** Represent the data needed to track the filter item */
export type FlightsFilterItemAnalytics = {
  __typename?: "FlightsFilterItemAnalytics";
  /** Category of the filter getting tracked */
  category?: Maybe<Scalars["String"]>;
  /** Captures the ID of the applied filter, this ID will be specific to each brand until unified */
  id?: Maybe<Scalars["String"]>;
  /** Max filter value for filter that the user specifies a range */
  max?: Maybe<Scalars["String"]>;
  /** Min filter value for filter that the user specifies a range */
  min?: Maybe<Scalars["String"]>;
  /** Index of the filter getting tracked relative to the position it appears in that filter category */
  position?: Maybe<Scalars["String"]>;
  /** Value relating to the filter that has been applied */
  value?: Maybe<Scalars["String"]>;
};

/** Represents the object required to render the Filter display on client */
export type FlightsFilterLoadedPresentation = FlightsFilterPresentation & {
  __typename?: "FlightsFilterLoadedPresentation";
  /** Represents the accessibility message for filter display */
  accessibility: FlightsAccessibilityMessage;
  /** Represents the supported list of filter options */
  emptyFiltersMessage?: Maybe<Scalars["String"]>;
  /** Represents the EGCS search filter interaction event to track */
  eventAnalytics: FlightsFiltersEventAnalytics;
  /** Represents the supported list of filter options */
  options?: Maybe<Array<FlightsFilterOption>>;
  /** Represents the title label for filter display 'Filter By' */
  title?: Maybe<Scalars["String"]>;
};

/** Represents the object required to render the Filter display in a loading state on client */
export type FlightsFilterLoadingPresentation = FlightsFilterPresentation & {
  __typename?: "FlightsFilterLoadingPresentation";
  /** Represents the accessibility message for filter display */
  accessibility: FlightsAccessibilityMessage;
  /** Represents the list of filter options to display in a loading state */
  options: Array<FlightsFilterSkeletonOption>;
  /** This is skeleton items displayed on s&f screen. 0 -> no skeleton 1-> single line skeleton 2 -> double line skeleton. */
  skeletonCount: Scalars["Int"];
  /** Represents the title label for filter display 'Filter By' */
  title?: Maybe<Scalars["String"]>;
};

/** Represents one filter module on UI , ex. filter by airline or filter by stops */
export interface FlightsFilterOption {
  /** Represents the label associated with particular filter option */
  label: Scalars["String"];
  /** Represents whether the filter supports multi-selection */
  supportsMultipleSelection: Scalars["Boolean"];
  /** Represents the FilterType for this filter option */
  type: FlightsFilterType;
}

/** Represents the object required to render the Filter display on client */
export interface FlightsFilterPresentation {
  /** Represents the accessibility message for filter display */
  accessibility: FlightsAccessibilityMessage;
  /** Represents the title label for filter display 'Filter By' */
  title?: Maybe<Scalars["String"]>;
}

/** Represents the filter skeletons to be displayed in the loading state  */
export type FlightsFilterSkeletonOption = {
  __typename?: "FlightsFilterSkeletonOption";
  /** Represents the number of skeleton items to be shown in the loading state  */
  itemCount: Scalars["Int"];
  /** Represents the label associated with particular filter option */
  label: Scalars["String"];
  /** Represents the label corresponding to 'from:' used labelling the starting price for each filter item */
  priceFromLabel?: Maybe<Scalars["String"]>;
};

export type FlightsFilterType =
  | "ARRIVAL_AIRPORT"
  | "ARRIVAL_TIME"
  | "CARRY_ON_BAG"
  | "CHECKED_BAG"
  | "CREDIT_ELIGIBLE"
  | "DEPARTURE_AIRPORT"
  | "DEPARTURE_TIME"
  | "DURATION"
  | "FLEXIBLE_CHANGE_POLICIES"
  | "NO_CANCEL_FEE"
  | "NO_CHANGE_FEE"
  | "NUM_OF_STOPS"
  | "PREFERRED_AIRLINE"
  | "SEAT_CHOICE"
  | "TRAVEL_AND_BAGGAGE";

/** Represents the value associated with each filter */
export type FlightsFilterValue =
  | FlightsAirportCodeFilterValue
  | FlightsCarryOnBagBasedFilterValue
  | FlightsCheckedBagBasedFilterValue
  | FlightsCreditEligibleFilterValue
  | FlightsDurationBasedFilterValue
  | FlightsFlexibleChangePolicyBasedFilterValue
  | FlightsNoCancelFeeBasedFilterValue
  | FlightsNoChangeFeeBasedFilterValue
  | FlightsPreferredAirlineFilterValue
  | FlightsSeatChoiceBasedFilterValue
  | FlightsStopBasedFilterValue
  | FlightsTimeBasedFilterValue
  | FlightsTravelAndBaggageBasedFilterValue;

/** Represent the data needed to track filter event */
export type FlightsFiltersEventAnalytics = FlightsEventAnalytics & {
  __typename?: "FlightsFiltersEventAnalytics";
  /** Represent the filter specific event category */
  eventCategory: Scalars["String"];
  /** Represent the filter specific event type */
  eventType: Scalars["String"];
  /** Represent the event name for filter applied */
  filterAppliedEventName: Scalars["String"];
  /** Represent the event name for filter removed */
  filterRemovedEventName: Scalars["String"];
  /** Represent the filter specific page name */
  pageName: Scalars["String"];
};

/** Represents the value associated with flexible change policies filter */
export type FlightsFlexibleChangePolicyBasedFilterValue = {
  __typename?: "FlightsFlexibleChangePolicyBasedFilterValue";
  policyName: FilterPolicyType;
};

/** Represents the value associated with flexible change policies filter */
export interface FlightsFlexibleChangePolicyBasedFilterValueInput {
  policyName: FilterPolicyType;
}

export type FlightsFlexibleGridType =
  /** Flex Search type shown for OW */
  | "FLEX_SEARCH"
  /** Flex Search Grid type shown for RT Outbound */
  | "FLEX_SEARCH_GRID"
  /** No Flex Search variant shown */
  | "FLEX_SEARCH_NOT_APPLICABLE";

/** Interface for a cell that can had different pieces of data and ui in a grid */
export interface FlightsFlexibleSearchCell {
  /** Formatted strings for use in accessibility readout of the cells */
  accessibility: FlightsFlexibleSearchCellAccessibility;
  /** Formatted and localized displayable string for the result */
  labelText?: Maybe<Scalars["String"]>;
  /** Formatted and localized displayable string for the result */
  valueText?: Maybe<Scalars["String"]>;
}

/** Formatted strings for use in accessibility readout */
export type FlightsFlexibleSearchCellAccessibility = {
  __typename?: "FlightsFlexibleSearchCellAccessibility";
  /** Formatted departureDate string for accessibility readout */
  departureDate?: Maybe<Scalars["String"]>;
  /** Formatted flex grid description for accessibility readout when customer highlights on a grid */
  highlightDescription?: Maybe<Scalars["String"]>;
  /** Formatted image alt description for accessibility readout */
  imageDescription?: Maybe<Scalars["String"]>;
  /** Formatted price string for accessibility readout */
  price?: Maybe<Scalars["String"]>;
  /** Formatted returnDate string for accessibility readout */
  returnDate?: Maybe<Scalars["String"]>;
  /** Formatted flex grid description for accessibility readout when customer selects a grid */
  selectionDescription?: Maybe<Scalars["String"]>;
};

export type FlightsFlexibleSearchGridDateHeaders = {
  __typename?: "FlightsFlexibleSearchGridDateHeaders";
  /** A list of header cells for the grid. Will either contain cells of type FlightsFlexibleSearchHeaderCell or FlightsFlexibleSearchLegendCell */
  returnDateHeaders: Array<FlightsFlexibleSearchCell>;
};

export type FlightsFlexibleSearchGridLegendBadge = {
  __typename?: "FlightsFlexibleSearchGridLegendBadge";
  /** Accessibility for grid rows and columns. Example: Departure dates/ Return dates . */
  accessibility: Scalars["String"];
  /** Represents the icon to display for the legend. */
  icon?: Maybe<Icon>;
  /** Represents the text to display for the legend. */
  labelText?: Maybe<Scalars["String"]>;
};

export type FlightsFlexibleSearchGridTrigger = {
  __typename?: "FlightsFlexibleSearchGridTrigger";
  /** Represents the accessibility string for slim card */
  accessibility: FlightsAccessibilityMessage;
  /** Represents the calendar icon to shown when the grid is collapsed */
  calendarIcon?: Maybe<Icon>;
  /** Represents the localised text which hides the grid when clicked */
  collapseAction?: Maybe<Scalars["String"]>;
  /** Click event for the action to collapse the flexible grid out of view */
  collapseAnalytics: FlightsAnalytics;
  /** Represents the localised text which shows the grid when clicked */
  expandAction: Scalars["String"];
  /** Click event for the action to expand the flexible grid in to view */
  expandAnalytics: FlightsAnalytics;
  /** Represents the right chevron icon in the slim wizard when the grid is collapsed */
  flexGridTransitionIcon?: Maybe<Icon>;
  /** Represents the sub text to show when the grid is collapsed */
  subText?: Maybe<Scalars["String"]>;
};

/** Cheapest price amongst all flights flying on a given route and day */
export type FlightsFlexibleSearchHeaderCell = FlightsFlexibleSearchCell & {
  __typename?: "FlightsFlexibleSearchHeaderCell";
  /** Formatted strings for use in accessibility readout */
  accessibility: FlightsFlexibleSearchCellAccessibility;
  /** Will represent part of formatted and localized displayable departureDate string */
  labelText?: Maybe<Scalars["String"]>;
  /** The theme used for decorating the cell */
  theme: FlightsFlexibleSearchHeaderCellTheme;
  /** Will represent part or whole of formatted and localized displayable departureDate string */
  valueText?: Maybe<Scalars["String"]>;
};

export type FlightsFlexibleSearchHeaderCellTheme =
  /** Theme to represent an outbound or inbound departureDate header */
  | "DEFAULT"
  /** Theme to represent an outbound or inbound departureDate that was searched on */
  | "SEARCHED_DATE_HEADER";

/** Represents a legend cell in the grid */
export type FlightsFlexibleSearchLegendCell = FlightsFlexibleSearchCell & {
  __typename?: "FlightsFlexibleSearchLegendCell";
  /** Formatted strings for use in accessibility readout */
  accessibility: FlightsFlexibleSearchCellAccessibility;
  /** Formatted strings for use in accessibility readout */
  accessibilityMessage?: Maybe<FlightsAccessibilityMessage>;
  /** An Icon to help decorate and describe the grid */
  icon?: Maybe<Icon>;
  /** Represents part of formatted and localized displayable legend string */
  labelText?: Maybe<Scalars["String"]>;
  /** The theme used for decorating the cell */
  theme: FlightsFlexibleSearchLegendCellTheme;
  /** Represents part or whole of formatted and localized displayable legend string */
  valueText?: Maybe<Scalars["String"]>;
};

export type FlightsFlexibleSearchLegendCellTheme = "DEFAULT";

/** Response of the flexible search request */
export type FlightsFlexibleSearchResponse = {
  __typename?: "FlightsFlexibleSearchResponse";
  /** An object which represents accuracy deviation analytics for mApp */
  accuracyDeviationAnalytics?: Maybe<FlightsAnalytics>;
  /** An object which represents accuracy NFF analytics for mApp */
  accuracyNffAnalytics?: Maybe<FlightsAnalytics>;
  /** An object with values used for logging */
  analytics: FlightsFlexibleSearchResponseAnalytics;
  /** An object which represents coverage analytics */
  coverageAnalytics: FlightsAnalytics;
  /** An object which represents coverage analytics for invalid cells for RT flex grid */
  coverageNotValidAnalytics?: Maybe<FlightsAnalytics>;
  /** An object which represents the departure legend Badge */
  departureLegend?: Maybe<FlightsFlexibleSearchGridLegendBadge>;
  /** Icon whose on-click will dismiss the flexible grid view */
  dismiss?: Maybe<Icon>;
  /** Accessibilty for close icon/dismiss action  */
  dismissGridAccessibility: FlightsAccessibilityMessage;
  /** Click event for the action to dismiss the flexible grid view  */
  dismissGridAnalytics: FlightsAnalytics;
  /** An Enum to represent the type of flex grid shown */
  flexGridType: FlightsFlexibleGridType;
  /** An object which represents the grid in the collapsed state */
  gridTrigger?: Maybe<FlightsFlexibleSearchGridTrigger>;
  /** Localized accessibility text for loading query state of flexible date grid */
  loadingStateAccessibility: Scalars["String"];
  /** A matrix representation for flexible search results */
  resultsGrid: FlightsFlexibleSearchResultsGrid;
  /** An object which contains the header cells for the return dates of the grid */
  returnDateHeaders?: Maybe<FlightsFlexibleSearchGridDateHeaders>;
  /** An object which gives a summary of the selected result cell */
  searchTriggerAction?: Maybe<Scalars["String"]>;
  /** Boolean to show or hide to flex grid */
  showFlexGrid: Scalars["Boolean"];
  /** Localized subTitle string of the flexible search price UI */
  subTitle: Scalars["String"];
  /** Localized title string of the flexible search price UI */
  title: Scalars["String"];
  /** Localized accessibility string for title of flexible search */
  titleAccessibility: Scalars["String"];
};

/** Represents the flexible search response analytics */
export type FlightsFlexibleSearchResponseAnalytics = {
  __typename?: "FlightsFlexibleSearchResponseAnalytics";
  /** Count of cells populated with price */
  priceFillRate: Scalars["String"];
};

/** Cheapest price amongst all flights flying on a given route and day */
export type FlightsFlexibleSearchResultAnalytics = {
  __typename?: "FlightsFlexibleSearchResultAnalytics";
  /** The difference in dates between the departureDate in the cell and the searched departureDate */
  departureDateDifferential?: Maybe<Scalars["String"]>;
  /** The difference in price between the price in the cell and the price for the searched departureDate */
  priceDifferential?: Maybe<Scalars["String"]>;
  /** The difference in dates between the departureDate in the cell and the searched departureDate */
  returnDateDifferential?: Maybe<Scalars["String"]>;
};

/** Cheapest price amongst all flights flying on a given route and day */
export type FlightsFlexibleSearchResultCell = FlightsFlexibleSearchCell & {
  __typename?: "FlightsFlexibleSearchResultCell";
  /** Formatted strings for use in accessibility readout */
  accessibility: FlightsFlexibleSearchCellAccessibility;
  /** An object with values used for logging */
  analytics?: Maybe<FlightsFlexibleSearchResultAnalytics>;
  /** Available information of current cell */
  domain?: Maybe<FlightsFlexibleSearchResultCellDomain>;
  /** Defines whether or not flexible grid cell should be a link */
  isLink: Scalars["Boolean"];
  /** The formatted and localized string for journey dates represented by the cell */
  journeyDate?: Maybe<Scalars["String"]>;
  /** The formatted and localized date */
  labelText?: Maybe<Scalars["String"]>;
  /** Used for conducting additional flexible searches */
  nextSearchCriteria?: Maybe<FlightsNextJourneyCriteria>;
  /** Click event for the action to select a cell in the flexible grid view */
  selectAnalytics: FlightsAnalytics;
  /** Represents whether the select button should be active for the cell */
  selectButtonActive?: Maybe<Scalars["Boolean"]>;
  /** Represents any additional summary about the cell */
  summary?: Maybe<Scalars["String"]>;
  /** The theme used for decorating the cell */
  theme: FlightsFlexibleSearchResultCellTheme;
  /**
   * Formatted and localized displayable string for the result.
   *         May have one of the following values:
   *         1. Price of a flight
   *         2. "Search" when cheapest price is unknown for the flights flying for the given date and route
   *         3. "No flights" when cheapest price in unavailable because flights aren't flying for the given date and route
   *         4. Date for matrix headers
   */
  valueText?: Maybe<Scalars["String"]>;
};

/** Available information of current cell */
export type FlightsFlexibleSearchResultCellDomain = {
  __typename?: "FlightsFlexibleSearchResultCellDomain";
  /** Price of the offer in current cell */
  price: Money;
};

export type FlightsFlexibleSearchResultCellTheme =
  /** Default theme */
  | "DEFAULT_PRICE"
  /** Theme to represent highest priced cells in the matrix */
  | "HIGHEST_PRICE"
  /** Theme to represent the lowest price displayed in the matrix */
  | "LOWEST_PRICE"
  /** Theme to represent when no price is available, 'Search' */
  | "NO_PRICE"
  /** Theme to represent the price corresponding to the flight on the input departureDate */
  | "SEARCHED_DATE"
  /** Theme to represent a cell that corresponds to the input departureDate and is also lowest price displayed in the matrix */
  | "SEARCHED_DATE_LOWEST_PRICE"
  /** Theme to represent a cell that corresponds to the input departureDate and is also the price is not available */
  | "SEARCHED_DATE_NO_PRICE"
  /** Theme to represent a cell that corresponds to the input departureDate and flights dont fly on the given departureDate */
  | "SEARCHED_DATE_UNAVAILABLE_FLIGHTS"
  /** Theme to represent the price is unavailable because flights don't fly for the given departureDate and route, 'No Flights' */
  | "UNAVAILABLE_FLIGHTS";

export type FlightsFlexibleSearchResultsGrid = {
  __typename?: "FlightsFlexibleSearchResultsGrid";
  /** A list of rows for a multi-dimensional flexible search matrix */
  results: Array<Array<FlightsFlexibleSearchCell>>;
};

/** Represents the Flights Forced Choice Model dialog */
export type FlightsForcedChoiceCrossSellDialog = FlightsDialogPresentation & {
  __typename?: "FlightsForcedChoiceCrossSellDialog";
  /** List of all available actions in the dialog */
  actions: Array<FlightsAction>;
  /** Animation used to display the dialog */
  animation: FlightsDialogAnimation;
  /** Annotation at the bottom of the dialog. Example: '* Average savings based on all vacation package bookings' */
  annotation: FlightsPhrase;
  /** Check-in datepicker for One Way Forced Choice */
  checkInDate?: Maybe<FlightsSearchFormDateField>;
  /** Check-out datepicker for One Way Forced Choice */
  checkOutDate?: Maybe<FlightsSearchFormDateField>;
  /** Represents the analytics to track on when the dialog display is blocked */
  displayBlockedAnalytics: FlightsAnalytics;
  /** Represents the number of times Forced Choice model will be shown to user for single search */
  displayCounter?: Maybe<Scalars["Int"]>;
  /** Represents the analytics to track on when the dialog is displayed */
  displayedAnalytics: FlightsAnalytics;
  /**
   * Header of the dialog. Example: 'Save $265* on average when you book your Flight and Hotel'
   * @deprecated deprecating header to introduce a new nullable field for title/header of dialog
   */
  header: Scalars["String"];
  /** Header of the hotel dates section. Example: 'New York hotel dates' */
  hotelDatesTitle?: Maybe<Scalars["String"]>;
  message?: Maybe<Scalars["String"]>;
  /** Body of the dialog. Can include a message and a subheader */
  messageBody: Array<EgdsText>;
  /**
   * Subheader of the dialog. Example: check icon + 'Includes your selected flight'
   * @deprecated Deprecating to introduce a new field of type EGDSText to handle different copy use cases
   */
  subHeader: FlightsIconAndPhrase;
  /** Title of the dialog. Replacing non-nullable header field. Example: 'Save $265* on average when you book your Flight and Hotel' */
  title?: Maybe<Scalars["String"]>;
};

/** Summary of the hygiene amenities */
export type FlightsHygieneAmenitiesPresentation = {
  __typename?: "FlightsHygieneAmenitiesPresentation";
  airlineAmenityGroups: Array<FlightsAirlineAmenityGroup>;
  /** Represents the label to show the amenities */
  amenitiesAction?: Maybe<FlightsTextSection>;
  /** Represents the disclaimer message showed after the hygiene amenities */
  disclaimerMessage: Scalars["String"];
  /**
   * Represents the label to show the amenities
   * @deprecated This will be replaced by amenitiesAction
   */
  displayAction?: Maybe<FlightsTextSection>;
  /** Represents the link to understand how airlines are keeping travelers safe */
  flightInformationLink?: Maybe<FlightsLinkAction>;
};

/** The hygiene amenities section of the Details and Fares dialog */
export type FlightsHygieneAmenitiesSection = {
  __typename?: "FlightsHygieneAmenitiesSection";
  /** List of the hygiene amenities */
  amenities: Array<EgdsIconText>;
  /** Footer of the section. */
  footer: Scalars["String"];
  /** Contains the header of the section */
  header: Scalars["String"];
};

/** Represents a label with a decorating icon and accessibility */
export type FlightsIconAndAccessibility = {
  __typename?: "FlightsIconAndAccessibility";
  /** Accessibility Text for the icon */
  accessibility?: Maybe<Scalars["String"]>;
  /** Icon that decorates the label */
  icon: Icon;
};

/** Represents the text with icon on dialog */
export type FlightsIconAndHeading = {
  __typename?: "FlightsIconAndHeading";
  /** Represents the heading for icon wrapper. */
  heading: Scalars["String"];
  /** Represents the list of text with icon on dialog */
  icons: Array<FlightsIconAndLabel>;
};

/** Represents a themed label with a decorating icon */
export type FlightsIconAndLabel = {
  __typename?: "FlightsIconAndLabel";
  /** Accessibility Text for the icon */
  accessibility?: Maybe<Scalars["String"]>;
  /** List of analytics associated with label */
  displayAnalytics?: Maybe<Array<FlightsAnalytics>>;
  /** Icon that decorates the label */
  icon: Icon;
  /** Label next to the icon */
  label: Scalars["String"];
  /** Sublabel for hygiene amenities in FIS */
  subLabel?: Maybe<Scalars["String"]>;
  /** Theme for the label */
  theme: TextTheme;
  /** Value associated with the label */
  value?: Maybe<Scalars["String"]>;
};

/** Represents a phrase with a decorating icon */
export type FlightsIconAndPhrase = {
  __typename?: "FlightsIconAndPhrase";
  /** Icon that decorates the label */
  icon: Icon;
  /** Phrase next to the icon */
  label: FlightsPhrase;
};

/** Represents an array of phrases with decorating icon */
export type FlightsIconPhrases = FlightsText & {
  __typename?: "FlightsIconPhrases";
  /** Icon that decorates the label/text message */
  icon?: Maybe<Icon>;
  /** Represents the text message */
  text: Array<FlightsPhrase>;
};

export type FlightsIconPlacard = FlightsPlacard & {
  __typename?: "FlightsIconPlacard";
  /** Represents the links/actions after the message if present */
  actions?: Maybe<Array<FlightsAction>>;
  /** Represents the display type for banners */
  displayType?: Maybe<FlightsPlacardDisplayType>;
  /** Represents the heading of placard if present */
  heading?: Maybe<Scalars["String"]>;
  /** Represents the icon of placard if applicable */
  icon?: Maybe<Icon>;
  /** Represents the message text for the placard */
  message: Scalars["String"];
  /** Represents analytics to be tracked when the Placard is available but not yet within the client's viewport */
  onAvailableAnalytics?: Maybe<FlightsAnalytics>;
  /** Represents onView analytics for a Placard. This will be triggered when the placard is visible on the client's viewport */
  onViewedAnalytics?: Maybe<FlightsAnalytics>;
};

/** Represents the position of the icon */
export type FlightsIconPosition =
  /** Icon will be rendered at the beginning of the content */
  | "LEADING"
  /** Icon will be rendered at the end of the content */
  | "TRAILING";

/** Represents an image with an accompanying label */
export type FlightsImageAndLabel = {
  __typename?: "FlightsImageAndLabel";
  /** Image that decorates the label */
  image: Image;
  /**
   * Label next to the icon
   * @deprecated Everywhere in the code this phrase is styled as STANDARD, which should not be required by PWA, instead a simple string can be sent, for strings which need phrases use FlightsImagePhrases
   */
  label: FlightsPhrase;
  /** Text next to the icon */
  text: Scalars["String"];
};

/** Represents a label and sublabel with a decorating Image for FSR */
export type FlightsImageListingLabel = {
  __typename?: "FlightsImageListingLabel";
  /** Image that decorates the label */
  image: Image;
  /** Label next to the icon */
  label: Scalars["String"];
  /** Sublabel for label */
  subLabel?: Maybe<Scalars["String"]>;
};

export type FlightsImagePhrases = FlightsText & {
  __typename?: "FlightsImagePhrases";
  /** Icon that decorates the label/text message */
  image: Image;
  /** Represents the text message */
  text: Array<FlightsPhrase>;
};

export type FlightsImagePlacard = FlightsPlacard & {
  __typename?: "FlightsImagePlacard";
  /** Represents the links/actions after the message if present */
  actions?: Maybe<Array<FlightsAction>>;
  /** Represents the display type for banners */
  displayType?: Maybe<FlightsPlacardDisplayType>;
  /** Represents the heading of placard if present */
  heading?: Maybe<Scalars["String"]>;
  /** Represents the image of placard */
  image: Image;
  /** Represents the message text for the placard */
  message: Scalars["String"];
  /** Represents analytics to be tracked when the Placard is available but not yet within the client's viewport */
  onAvailableAnalytics?: Maybe<FlightsAnalytics>;
  /** Represents onView analytics for a Placard. This will be triggered when the placard is visible on the client's viewport */
  onViewedAnalytics?: Maybe<FlightsAnalytics>;
};

/** Represents important info for trip */
export type FlightsImportantTripInfo = {
  __typename?: "FlightsImportantTripInfo";
  /** Represents heading e.g `Important Trip Information` */
  heading: EgdsHeading;
  /** Represents rules for trip and it will be OrderedList */
  rules: EgdsOrderedList;
};

/** Represents analytics to be applied on overall FIS */
export type FlightsInformationAnalytics = {
  __typename?: "FlightsInformationAnalytics";
  /** Represents the analytics to track if the user has scrolled through the footer */
  footerOnViewedAnalytics?: Maybe<FlightsAnalytics>;
  /** List of analytics to be fired after page load */
  onLoadAnalyticsList?: Maybe<Array<FlightsAnalytics>>;
};

/** Represents dynamic elements */
export type FlightsInformationDynamicElements = FlightsDynamicElements & {
  __typename?: "FlightsInformationDynamicElements";
  /** Represents AirOfferToken for selected set of fares */
  airOfferToken: Scalars["String"];
  dynamicElementsGroupTrackEventAnalytics?: Maybe<FlightsDynamicElementsTrackEventAnalytics>;
  fareChoiceInformationDynamicElement?: Maybe<FareChoiceInformationDynamicElement>;
  /** Represents dynamic element associated with fare choices with PMP */
  fareChoiceInformationDynamicElementWithPMP?: Maybe<FareChoiceInformationDynamicElement>;
  flightsJourneyDetailsDynamicElements?: Maybe<Array<FlightsJourneyDetailsDynamicElements>>;
  priceSummary: FlightsLoadedPriceSummary;
  /** Represents priceSummary with PMP applied */
  priceSummaryWithPMP?: Maybe<FlightsLoadedPriceSummary>;
  /** Represents the total price of an fare for all passengers . Ex: $345 Roundtrip for 3 travelers */
  totalPrice: Scalars["String"];
  /** Represents the total price of an fare for all passengers including PMP price . Ex: $345 Roundtrip for 3 travelers */
  totalPriceWithPMP?: Maybe<Scalars["String"]>;
};

/** Represents dynamic elements on the flights information page */
export type FlightsInformationDynamicElementsGroup = {
  __typename?: "FlightsInformationDynamicElementsGroup";
  /** Encoded representation of ancillaries that was selected on FIS. */
  ancillaryId?: Maybe<Scalars["String"]>;
  /** Represents dynamic elements associated with selected set of journeys */
  dynamicElements: FlightsDynamicElements;
  /** Represents identifier to find dynamic elements associated with selected set of journeys */
  identifier: Scalars["String"];
};

/** Price Match Promise UI Model */
export type FlightsInformationPriceMatchPromise = {
  __typename?: "FlightsInformationPriceMatchPromise";
  /** PMP messaging card to be shown on FIS */
  card?: Maybe<FlightsMessagingCardPlacard>;
  /** Price Match Promise toggle card, this supports switch toggle which will replace other versions of pmp card */
  merchandisingToggleCard?: Maybe<PriceMatchPromiseToggleableCard>;
  /** PMP Upfunnel qualtrics survey element id to render hidden html element needed to show the survey upon existence */
  surveyElementId?: Maybe<Scalars["String"]>;
};

export type FlightsInformationResponse = {
  __typename?: "FlightsInformationResponse";
  analytics?: Maybe<FlightsInformationAnalytics>;
  banners?: Maybe<Array<FlightsPlacard>>;
  baseOfferAncillaryID?: Maybe<Scalars["String"]>;
  brandPolicies?: Maybe<FlightsTextSection>;
  clientMetadata?: Maybe<FlightsClientMetadata>;
  dynamicElementsGroups?: Maybe<Array<FlightsInformationDynamicElementsGroup>>;
  flightsInformationPriceMatchPromise?: Maybe<FlightsInformationPriceMatchPromise>;
  flightsOpinionLab?: Maybe<FlightsActionAndLabel>;
  flightsSelectedJourneyDetails?: Maybe<Array<FlightsSelectedJourneyDetails>>;
  /** @deprecated This will be replaced by FlightsSelectedJourneyDetails interface */
  flightsSelectedJourneyReview?: Maybe<Array<FlightsSelectedJourneyReview>>;
  flightsSupportedAncillaries?: Maybe<FlightsSupportedAncillaryInfo>;
  freeCancellation?: Maybe<FlightsPlacard>;
  freePriceMatchPromise?: Maybe<FreePriceMatchPromise>;
  /** @deprecated At FIS we need to have a list of gaia Ids for each destination */
  gaiaId?: Maybe<Scalars["String"]>;
  gaiaIds?: Maybe<Array<Scalars["String"]>>;
  hygieneAmenitiesPresentation?: Maybe<FlightsHygieneAmenitiesPresentation>;
  journeyContinuationId?: Maybe<Scalars["String"]>;
  journeyStartEndDates?: Maybe<Array<JourneyStartEndDates>>;
  messagingCards?: Maybe<Array<FlightsPlacard>>;
  multiItemDynamicCrossSellPrimer?: Maybe<MultiItemDynamicCrossSellPrimer>;
  pageTitle?: Maybe<FlightsPageTitle>;
  partnerLoyaltyEarnMessage?: Maybe<FlightsMarkPlacard>;
  priceSummary?: Maybe<FlightsPriceSummary>;
  separateTicketBanner?: Maybe<FlightsIconPlacard>;
  serverErrorMessaging?: Maybe<FlightsErrorMessagingPresentation>;
  stepIndicator?: Maybe<FlightsStepIndicator>;
};

export type FlightsInformationResponseBaseOfferAncillaryIdArgs = {
  queryState?: InputMaybe<FlightsQueryState>;
};

export type FlightsInformationResponseBrandPoliciesArgs = {
  queryState?: InputMaybe<FlightsQueryState>;
};

export type FlightsInformationResponseClientMetadataArgs = {
  queryState?: InputMaybe<FlightsQueryState>;
};

export type FlightsInformationResponseDynamicElementsGroupsArgs = {
  queryState?: InputMaybe<FlightsQueryState>;
};

export type FlightsInformationResponseFlightsOpinionLabArgs = {
  queryState?: InputMaybe<FlightsQueryState>;
};

export type FlightsInformationResponseFlightsSelectedJourneyReviewArgs = {
  queryState?: InputMaybe<FlightsQueryState>;
};

export type FlightsInformationResponseFlightsSupportedAncillariesArgs = {
  queryState?: InputMaybe<FlightsQueryState>;
};

export type FlightsInformationResponseGaiaIdArgs = {
  queryState?: InputMaybe<FlightsQueryState>;
};

export type FlightsInformationResponseGaiaIdsArgs = {
  queryState?: InputMaybe<FlightsQueryState>;
};

export type FlightsInformationResponseHygieneAmenitiesPresentationArgs = {
  queryState?: InputMaybe<FlightsQueryState>;
};

export type FlightsInformationResponseJourneyContinuationIdArgs = {
  queryState?: InputMaybe<FlightsQueryState>;
};

export type FlightsInformationResponseJourneyStartEndDatesArgs = {
  queryState?: InputMaybe<FlightsQueryState>;
};

export type FlightsInformationResponseMultiItemDynamicCrossSellPrimerArgs = {
  queryState?: InputMaybe<FlightsQueryState>;
};

export type FlightsInformationResponsePageTitleArgs = {
  queryState?: InputMaybe<FlightsQueryState>;
};

export type FlightsInformationResponsePriceSummaryArgs = {
  queryState?: InputMaybe<FlightsQueryState>;
};

/** Group of elements to display different information. */
export type FlightsInformationText = {
  __typename?: "FlightsInformationText";
  /** Information items to display with proper needed types. */
  content: Array<FlightsInformationTextItem>;
};

export type FlightsInformationTextItem = IconWrapper | MarkWrapper | SuperlativeText | TextWrapper;

/** Amenities for the journey like wi-fi, entertainment etc. */
export type FlightsJourneyAmenities = {
  __typename?: "FlightsJourneyAmenities";
  /** Message used to describe amenities for screen readers */
  accessibilityMessage: Scalars["String"];
  /** List of all the available amenities */
  amenities: Array<FlightsIconAndLabel>;
  /** Represents the analytics to track on interaction with the amenities trigger */
  analytics?: Maybe<FlightsAnalytics>;
};

/** List of Rules and Amenities with a label to indicate applicability */
export type FlightsJourneyAmenitiesWithLabel = {
  __typename?: "FlightsJourneyAmenitiesWithLabel";
  /** Label of applicability for the ruleset */
  label: Scalars["String"];
  /** List of rules and amenities */
  rules: FlightsJourneyAmenities;
};

/** List of Amenities(wi-fi, entertainment etc) for the journey */
export type FlightsJourneyAmenityRules = {
  __typename?: "FlightsJourneyAmenityRules";
  /** List of all the available amenities */
  amenities: Array<FlightsIconAndLabel>;
  /** Represents the default number of amenities to be displayed on the fare cards */
  itemsDefaultDisplayCount: Scalars["Int"];
};

/** Summary of all available fares and details for a Journey */
export type FlightsJourneyAvailableFares = FlightsAvailableFares & {
  __typename?: "FlightsJourneyAvailableFares";
  /** Describes button action to accept chosen fare and continue */
  applySelection: FlightsAction;
  /** Describes icon to dismiss summary/details */
  dismissDetailedJourneyInformation: FlightsActionableIcon;
  /** Summary of all available fares for a Journey, null for bargain fares */
  fareChoiceInformation?: Maybe<FlightsFareChoiceInformation>;
  /** Journey highlight like Origin to Destination, departure day, airline */
  flightsJourneyHeaders: FlightsJourneyHeaders;
  /** Detailed review of the journey with summary information, null for bargain fares */
  flightsJourneyInformation?: Maybe<FlightsDetailedJourneyInformation>;
  /** Policies for the Journey, only for bargain fares */
  flightsJourneyPolicies?: Maybe<FlightsTextSection>;
  /** Collapsed summarised view with fields like time, duration and stops of the entire journey */
  flightsJourneySummary: FlightsJourneySummary;
  /** Represents the array of the hygiene amenities */
  hygieneAmenitiesPresentation?: Maybe<FlightsHygieneAmenitiesPresentation>;
  /** Represents the accesibility message to be announced when summary/details opens */
  openAccessibility: Scalars["String"];
};

/** Represents the map of journeyContinuationId to available fares. */
export type FlightsJourneyAvailableFaresInformationElements = {
  __typename?: "FlightsJourneyAvailableFaresInformationElements";
  /** Summary of all available fares for a Journey */
  flightsJourneyAvailableFaresInformation?: Maybe<FlightsJourneyAvailableFares>;
  /** Represents the unique identifier for each offer fares */
  journeyContinuationId: Scalars["String"];
  /**
   * Stringified summary of all available fares for a Journey
   * @deprecated Not in usage
   */
  stringifiedFlightsJourneyAvailableFaresInformation?: Maybe<Scalars["String"]>;
};

/** Represents baggage selection content section in error scenario of each leg. */
export type FlightsJourneyBaggageSelectionFailure = {
  __typename?: "FlightsJourneyBaggageSelectionFailure";
  /** Represents the error message to be shown in case of downstream failure or timeout. Ex: Sorry, please try again. */
  errorMessage: FlightsAncillaryErrorMessage;
  /** Static ancillaries available for the Journey */
  staticAncillaries?: Maybe<FlightsCategorizedList>;
};

/** Represents either the success/failed baggage details content */
export type FlightsJourneyBaggageSelectionPresentation =
  | FlightsJourneyBaggageSelectionFailure
  | FlightsJourneyBaggageSelectionSuccess;

/** Represents baggage details content section with baggage selection of each product in success scenario */
export type FlightsJourneyBaggageSelectionSuccess = {
  __typename?: "FlightsJourneyBaggageSelectionSuccess";
  /** Represents list of selectable baggages for each leg. */
  journeyContent: FlightsBaggageAvailableFlightLegSelection;
};

/** The input object for flights search */
export type FlightsJourneyCriteria = {
  __typename?: "FlightsJourneyCriteria";
  /** Arrival date of the flight */
  arrivalDate?: Maybe<Date>;
  /** Departure date of the flight */
  departureDate: Date;
  /** Three letter code of the destination airport */
  destination: Scalars["String"];
  /** Location type of the destination airport */
  destinationAirportLocationType?: Maybe<AirportLocationType>;
  /**
   * # Deprecated: Please use cabinClass in FlightsSearchPreferences
   * @deprecated Use cabinClass in FlightsSearchPreferences, replace with FlightsSearchPreferences.CabinClass
   */
  flightsCabinClass?: Maybe<FlightsCabinClass>;
  /** Three letter code of the origin airport */
  origin: Scalars["String"];
  /** Location type of the origin airport */
  originAirportLocationType?: Maybe<AirportLocationType>;
};

/** The input object for flights search */
export interface FlightsJourneyCriteriaInput {
  /** Arrival date of the flight */
  arrivalDate?: InputMaybe<DateInput>;
  /** Departure date of the flight */
  departureDate: DateInput;
  /** Three letter code of the destination airport */
  destination: Scalars["String"];
  /** Location type of the destination airport */
  destinationAirportLocationType?: InputMaybe<AirportLocationType>;
  /** # Deprecated: Please use cabinClass in FlightsSearchPreferences */
  flightsCabinClass?: InputMaybe<FlightsCabinClass>;
  /** Three letter code of the origin airport */
  origin: Scalars["String"];
  /** Location type of the origin airport */
  originAirportLocationType?: InputMaybe<AirportLocationType>;
}

/** Details of the complete journey includes layover details, journey amenities like wifi, arrival details etc. */
export type FlightsJourneyDetails = {
  __typename?: "FlightsJourneyDetails";
  /** Represents the amenities included in this flight. Amenities include Wi-Fi, Entertainment and Electric outlets with labels. */
  journeyAmenities?: Maybe<Array<FlightsIconAndLabel>>;
  /**
   * Journey parts like segments and their layovers constituting the complete trip
   * @deprecated This field will be replaced by journeySections
   */
  journeyParts: Array<JourneyPart>;
  /** Journey sections like segments and their layovers constituting the complete trip */
  journeySections: Array<JourneySection>;
};

export type FlightsJourneyDetailsDynamicElements = {
  __typename?: "FlightsJourneyDetailsDynamicElements";
  /** Encoded representation of ancillary at bound level that was selected on FIS. */
  ancillaryId?: Maybe<Scalars["String"]>;
  /** Button to open Seat Map for selection, Example: Choose your seats */
  details?: Maybe<FlightsAction>;
  /** link that gives option to upgarde the fare or see fare details */
  fareChangeAction?: Maybe<FlightsAction>;
  fareName?: Maybe<Scalars["String"]>;
  /** Preview link details of Seat Map for the selected fare. */
  fareSeatMapDynamicElement?: Maybe<FareSeatMapDynamicElement>;
  /** Message that gives option to upgarde the fare ex: Upgrade to get free seats */
  flightsFareNudgeMessage?: Maybe<FlightsIconAndLabel>;
  journeyPartsDynamicElements: Array<JourneyPartsDynamicElements>;
  /** Message informing user about the different possible scenarios for seat selection */
  message?: Maybe<Scalars["String"]>;
  /** Heading of the seat map section. ex: Seat(s)/Select Seat(s) */
  seatMapTitle?: Maybe<Scalars["String"]>;
  /** Represents Details of seat selected and marked on details page */
  selectedSeatDetails?: Maybe<Array<FlightsSelectedSeatDetail>>;
  /**
   * Heading of the seat map section. ex: Seat(s)/Select Seat(s)
   * @deprecated This field will be replaced by seatMapTitle
   */
  title: Scalars["String"];
  /** Flag to determine whether Upsell Nudging is Enabled or not */
  upsellNudgingFeatureEnabled: Scalars["Boolean"];
};

/** This represents the journey details information */
export type FlightsJourneyDetailsInformation = {
  __typename?: "FlightsJourneyDetailsInformation";
  /**
   * This represents the journey details information that is rendered inside the expando
   * @deprecated Use expandoContent instead of this type
   */
  content: Array<FlightsJourneyDetailsInformationSection>;
  /** This represents the expando link that is used to toggle the details content */
  expando: EgdsExpandoLink;
  /** This represents the sections of journey details that are rendered inside the expando */
  expandoContent: Array<FlightsJourneyDetailsSection>;
};

export type FlightsJourneyDetailsInformationSection = FlightsJourneyDetails;

/** This represents a section of journey details */
export type FlightsJourneyDetailsSection = {
  __typename?: "FlightsJourneyDetailsSection";
  /** List of amenities in the journey */
  amenities?: Maybe<Array<EgdsGraphicText>>;
  /** Decorators added to the section */
  decorator?: Maybe<Array<FlightsTextSectionDecorator>>;
  /** Text that gets rendered aligned without covering the graphic column */
  details: Array<EgdsText>;
  /** Graphic that gets rendered aligned to the left */
  graphic?: Maybe<UiGraphic>;
};

/** The standard available fare for the Journey */
export type FlightsJourneyFare = FlightsJourneyFareBase & {
  __typename?: "FlightsJourneyFare";
  /** Accessibility message for interaction with fare name and price */
  accessibilityMessage: Scalars["String"];
  /** Rules and Amenities to display in the ameniity hierarchy state */
  amenityHierarchyRules?: Maybe<Array<FlightsJourneyAmenitiesWithLabel>>;
  /** Represents rules and amenities to display on the fare-cards expando peek */
  amenityRules: FlightsJourneyAmenityRules;
  /** A list of badges to highlight specific features of a fare */
  badges?: Maybe<Array<EgdsBadge>>;
  /** Detailed information about baggage for the Journey's Fare */
  baggageFeesInformation: FlightsBaggageInformation;
  /** The physical cabin type for the Fare */
  cabinClass: Scalars["String"];
  /** Represents cabin class and booking codes of various segments for the fare. Ex. Economy/Coach(N) */
  cabinClassAndBookingCodes?: Maybe<Array<Scalars["String"]>>;
  /** Section describing change and cancellation with messages for this fare (e.g. 'Change your ticket for $150') */
  changeCancellationMessages?: Maybe<FlightsTextSection>;
  /**
   * Action representing the event of user selecting this Fare
   * @deprecated This will be replaced by selectFareAction
   */
  chooseFareAction: FlightsAction;
  /**
   * Alternate action text for the action associated with this Fare
   * @deprecated This will be replaced by selectFareActionAltText
   */
  chooseFareActionAltText?: Maybe<Scalars["String"]>;
  /** Represents the analytics if this fare is clicked */
  clickEventAnalytics: FlightsAnalytics;
  /**
   * Rules and Amenities to display in the collapsed state
   * @deprecated Replaced by amenityRules to have UITK expando peek on client side
   */
  collapsedRules: FlightsJourneyAmenities;
  /**
   * Rules and Amenities to display in the expanded state
   * @deprecated Replaced by amenityRules to have UITK expando peek on client side
   */
  expandedRules: Array<FlightsJourneyAmenitiesWithLabel>;
  /** Fare specific journey policy information such as standby or frequent flyer messaging */
  fareJourneyPolicies?: Maybe<FlightsTextSection>;
  /** Represents the analytics if this fare is latest/highest fare seen */
  fareScrollAnalytics: FlightsAnalytics;
  /** Represents the flights and packaged products natural keys */
  flightsOfferNaturalKeys?: Maybe<FlightsOfferNaturalKeys>;
  /** The price of the Journey in the context of previously selected fares. Could be either Total Price or Delta Price */
  formattedMainPrice: FlightsPhrase;
  /** The price of Journey for the Fare with styling */
  formattedPrice: FlightsPhrase;
  /** Indicates whether the Fare is selected for this Journey */
  highlighted: Scalars["Boolean"];
  /** Unique identifier for the fare of this journey (AirProductToken) */
  identifier: Scalars["String"];
  /** Represents the total price of a fare for all passengers. Nullable for packages path. Ex: $345 Roundtrip for 3 travelers */
  journeyFareTotalPrice?: Maybe<Scalars["String"]>;
  /** Represents Loyalty points for display on selected Journey, applicable for Burn POS */
  loyaltyPointsOption?: Maybe<FlightsLoyaltyPointsOption>;
  /** Represents the action to execute for multi-item shoppers upon selection with corresponding input for the action */
  multiItemAction?: Maybe<MultiItemAction>;
  /** Represents the tokenized string representation of the full multi-item price and breakdowns */
  multiItemPriceToken?: Maybe<Scalars["String"]>;
  /** The name (generic or branded) for the Fare */
  name: Scalars["String"];
  /** Represents the package offer containing that flight offer for packaged flights. */
  packageOfferId?: Maybe<Scalars["String"]>;
  /** Represents Earn Loyalty points for display on selected Journey, applicable for Earn POS */
  partnerLoyaltyEarnAward?: Maybe<FlightsMarkAndLabel>;
  /**
   * The price of the Journey for the Fare
   * @deprecated Replaced by formattedPrice
   */
  price: Money;
  /** Accessibility message representing the total price based on the selected fare */
  priceAccessibilityMessage: Scalars["String"];
  /** Represents the price lockup of the fare */
  priceLockup: EgdsPriceLockup;
  /**
   * An icon to indicate recommendation of the Fare
   * @deprecated Replaced by badges
   */
  recommendation?: Maybe<FlightsBadge>;
  /** Accessibility message informing the user the location of the safety amenities */
  safetyLocationAccessibilityMessage?: Maybe<Scalars["String"]>;
  /** Action representing the event of user selecting this Fare */
  selectFareAction: FlightsAction;
  /** Alternate action text for the action associated with this Fare */
  selectFareActionAltText?: Maybe<Scalars["String"]>;
  /** Indicates whether the Fare is selected for this Journey */
  selected: Scalars["Boolean"];
  /** Accessibility message for selection of fare name and price */
  selectedFareAccessibilityMessage: Scalars["String"];
  /** Toggle to show either the collapsed ruleset or the expanded ruleset */
  showMoreAmenitiesToggle?: Maybe<FlightsToggle>;
  /**
   * Toggle to show either the collapsed ruleset or the expanded ruleset
   * @deprecated Replaced by showMoreAmenitiesToggle
   */
  showMoreToggle: FlightsToggle;
  /**
   * Represents the total price of an fare for all passengers . Ex: $345 Roundtrip for 3 travelers
   * @deprecated Replaced by journeyFareTotalPrice
   */
  totalPrice: Scalars["String"];
  /** Represents the upsell unique offer token (airOfferToken) */
  upsellOfferToken: Scalars["String"];
};

/** An interface for the available fare types for the Journey */
export interface FlightsJourneyFareBase {
  /** Accessibility message for interaction with fare name and price */
  accessibilityMessage: Scalars["String"];
  /** Rules and Amenities to display in the ameniity hierarchy state */
  amenityHierarchyRules?: Maybe<Array<FlightsJourneyAmenitiesWithLabel>>;
  /** Represents rules and amenities to display on the fare-cards expando peek */
  amenityRules: FlightsJourneyAmenityRules;
  /** A list of badges to highlight specific features of a fare */
  badges?: Maybe<Array<EgdsBadge>>;
  /** Detailed information about baggage for the Journey's Fare */
  baggageFeesInformation: FlightsBaggageInformation;
  /** The physical cabin type for the Fare */
  cabinClass: Scalars["String"];
  /** Represents cabin class and booking codes of various segments for the fare. Ex. Economy/Coach(N) */
  cabinClassAndBookingCodes?: Maybe<Array<Scalars["String"]>>;
  /** Section describing change and cancellation with messages for this fare (e.g. 'Change your ticket for $150') */
  changeCancellationMessages?: Maybe<FlightsTextSection>;
  /**
   * Action representing the event of user selecting this Fare
   * @deprecated This will be replaced by selectFareAction
   */
  chooseFareAction: FlightsAction;
  /**
   * Alternate action text for the action associated with this Fare
   * @deprecated This will be replaced by selectFareActionAltText
   */
  chooseFareActionAltText?: Maybe<Scalars["String"]>;
  /** Represents the analytics if this fare is clicked */
  clickEventAnalytics: FlightsAnalytics;
  /**
   * Rules and Amenities to display in the collapsed state
   * @deprecated Replaced by amenityRules to have UITK expando peek on client side
   */
  collapsedRules: FlightsJourneyAmenities;
  /**
   * Rules and Amenities to display in the expanded state
   * @deprecated Replaced by amenityRules to have UITK expando peek on client side
   */
  expandedRules: Array<FlightsJourneyAmenitiesWithLabel>;
  /** Fare specific journey policy information such as standby or frequent flyer messaging */
  fareJourneyPolicies?: Maybe<FlightsTextSection>;
  /** Represents the analytics if this fare is latest/highest fare seen */
  fareScrollAnalytics: FlightsAnalytics;
  /** Represents the flights and packaged products natural keys */
  flightsOfferNaturalKeys?: Maybe<FlightsOfferNaturalKeys>;
  /**
   * The price of the Journey in the context of previously selected fares. Could be either Total Price or Delta Price
   * @deprecated Replaced by priceLockup
   */
  formattedMainPrice: FlightsPhrase;
  /**
   * The price of Journey for the Fare with styling
   * @deprecated Replaced by priceLockup
   */
  formattedPrice: FlightsPhrase;
  /** Indicates whether the Fare is highlighted for this Journey */
  highlighted: Scalars["Boolean"];
  /** Unique identifier for the fare of this journey (AirProductToken) */
  identifier: Scalars["String"];
  /**
   * Represents the total price of a fare for all passengers. Nullable for packages path. Ex: $345 Roundtrip for 3 travelers
   * @deprecated Replaced by priceLockup
   */
  journeyFareTotalPrice?: Maybe<Scalars["String"]>;
  /** Represents Loyalty points for display on selected Journey, applicable for Burn POS */
  loyaltyPointsOption?: Maybe<FlightsLoyaltyPointsOption>;
  /** Represents the action to execute for multi-item shoppers upon selection with corresponding input for the action */
  multiItemAction?: Maybe<MultiItemAction>;
  /** Represents the tokenized string representation of the full multi-item price and breakdowns */
  multiItemPriceToken?: Maybe<Scalars["String"]>;
  /** The name (generic or branded) for the Fare */
  name: Scalars["String"];
  /** Represents the package offer containing that flight offer for packaged flights. */
  packageOfferId?: Maybe<Scalars["String"]>;
  /** Represents Earn Loyalty points for display on selected Journey, applicable for Earn POS */
  partnerLoyaltyEarnAward?: Maybe<FlightsMarkAndLabel>;
  /**
   * The price of the Journey for the Fare
   * @deprecated Replaced by priceLockup
   */
  price: Money;
  /** Accessibility message representing the total price based on the selected fare */
  priceAccessibilityMessage: Scalars["String"];
  /** Represents the price lockup of the fare */
  priceLockup: EgdsPriceLockup;
  /**
   * An icon to indicate recommendation of the Fare
   * @deprecated Replaced by badges
   */
  recommendation?: Maybe<FlightsBadge>;
  /** Accessibility message informing the user the location of the safety amenities */
  safetyLocationAccessibilityMessage?: Maybe<Scalars["String"]>;
  /** Action representing the event of user selecting this Fare */
  selectFareAction: FlightsAction;
  /** Alternate action text for the action associated with this Fare */
  selectFareActionAltText?: Maybe<Scalars["String"]>;
  /** Indicates whether the Fare is selected for this Journey */
  selected: Scalars["Boolean"];
  /** Accessibility message for selection of fare name and price */
  selectedFareAccessibilityMessage: Scalars["String"];
  /** Toggle to show either the collapsed ruleset or the expanded ruleset */
  showMoreAmenitiesToggle?: Maybe<FlightsToggle>;
  /**
   * Toggle to show either the collapsed ruleset or the expanded ruleset
   * @deprecated Replaced by showMoreAmenitiesToggle
   */
  showMoreToggle: FlightsToggle;
  /**
   * Represents the total price of an fare for all passengers . Ex: $345 Roundtrip for 3 travelers
   * @deprecated Replaced by priceLockup
   */
  totalPrice: Scalars["String"];
  /** Represents the upsell unique offer token (airOfferToken) */
  upsellOfferToken: Scalars["String"];
}

/** The headers section of the Details and Fares dialog */
export type FlightsJourneyHeaderInformation = {
  __typename?: "FlightsJourneyHeaderInformation";
  /**
   * Content of the headers section.
   * @deprecated Use JourneyHeaderInformation please
   */
  content: Array<FlightsInformationText>;
  /** Content of the headers section */
  headerInformation: Array<EgdsText>;
};

/** Journey highlight like Origin to Destination, departure day, airline */
export type FlightsJourneyHeaders = {
  __typename?: "FlightsJourneyHeaders";
  /** Represents the accessibility of the heading */
  accessibilityMessage?: Maybe<Scalars["String"]>;
  /** Represents information sent to clients to help user change the selected flight behind new shopping experience */
  changeFlight?: Maybe<FlightsAction>;
  /** Review trip sub-heading, ex. airline logo, airline <delimiter> journey date */
  flightsJourneySubheading: Scalars["String"];
  /**
   * Review trip sub-heading, ex. airline logo, not required for bargain fare
   * @deprecated Use instead flightsJourneySubheadingMark - new field using the EGDS Mark instead of Image
   */
  flightsJourneySubheadingImage?: Maybe<Image>;
  /** Review trip sub-heading, ex. airline logo, not required for bargain fare */
  flightsJourneySubheadingMark?: Maybe<Mark>;
  /** Review trip heading, ex. Chicago to Albuquerque */
  heading: Scalars["String"];
  /** Represents the amenities included in this flight. Amenities include Wi-Fi, Entertainment and Electric outlets. */
  journeyAmenities?: Maybe<FlightsJourneyAmenities>;
  /** Represents the subheading that has info related to the flight time, duration and number of stops. This field is to be used in case of upsell nudge */
  journeyDurationAndStopsSubheading?: Maybe<FlightsMessageAndAccessibility>;
  /** Represents the text that has info related to the flight time, duration and number of stops */
  journeyTimeAndStopsSubheading: FlightsJourneyTimeAndStops;
};

/** Represent highlights of a segment or Origin-destination pair */
export type FlightsJourneyHighlights = {
  __typename?: "FlightsJourneyHighlights";
  /** Journey highlight like Origin to Destination, departure day, airline */
  flightsJourneyHeaders: FlightsJourneyHeaders;
  /**
   * Collapsed view with details like time, duration and stops of the entire journey
   * @deprecated This is a non-nullable field and will be replaced by flightsJourneySummaryDetail
   */
  flightsJourneySummary: FlightsJourneySummary;
  /** Collapsed view with details like time, duration and stops of the entire journey */
  flightsJourneySummaryDetail?: Maybe<FlightsJourneySummary>;
};

export type FlightsJourneyRating = {
  __typename?: "FlightsJourneyRating";
  /** Represents the analytics to track on interaction with the score trigger */
  analytics: FlightsAnalytics;
  /** Describes what the score is */
  description: Scalars["String"];
  /** Sort description of the journey score. Example: 'Excellent Flights (8.7/10)' */
  label: Scalars["String"];
};

/** Represents all the common information in the journey review block on FIS  */
export type FlightsJourneyReviewCommon = {
  __typename?: "FlightsJourneyReviewCommon";
  /** Represents the change flight link. It will be in the template form for the last element of the list. */
  changeFlight: FlightsAction;
  /** Represents the skeleton count for fare summary block */
  fareSummarySkeletonCount: Scalars["Int"];
  /** Represents the skeleton count inside the flight summary block */
  flightSummarySkeletonCount: Scalars["Int"];
};

/** Represents information required for different clients like mobile apps to help user change the selected flight. previousFlightSelections is also used by PWA */
export type FlightsJourneySearchCriteria = {
  __typename?: "FlightsJourneySearchCriteria";
  /** Represents the flight search context like tripType */
  flightsSearchContext: FlightsSearchContext;
  /** Represents the search criteria of user */
  journeyCriteria: Array<FlightsJourneyCriteria>;
  /** Represents the flights user selected for each segment when the user proceeded to FIS.This node will be populated on the search response only if customer is returning to FSR from FIS. */
  previousFlightSelections?: Maybe<Array<JourneyFlightSelection>>;
  /** Represents the search preferences of user on flight selection like AirlinePreference */
  searchPreferences?: Maybe<FlightsSearchPreferences>;
  /** Represents the traveler details */
  travelerDetails: Array<FlightsTravelerDetails>;
};

/** Represents seat map content section with seat map grids of each leg. */
export type FlightsJourneySeatAncillaryCabinFailure = {
  __typename?: "FlightsJourneySeatAncillaryCabinFailure";
  /** Represents the error message to be shown in case of downstream failure or timeout. Ex: We’re having trouble loading the seatmap for your flight.. */
  errorMessage: FlightsMessagingCardPlacard;
};

/** Represents seat map content section with seat map grids of each leg. */
export type FlightsJourneySeatAncillaryCabinSuccess = {
  __typename?: "FlightsJourneySeatAncillaryCabinSuccess";
  /** Represents list of seat maps for each leg. */
  journeySeatContent: FlightsJourneySeatContent;
};

/** Represents seat map content section with seat map grids of each leg. */
export type FlightsJourneySeatContent = {
  __typename?: "FlightsJourneySeatContent";
  /** Represents the display analytics for a cabin. */
  displayAnalytics: Array<ClientSideAnalytics>;
  /** Represents list of seat maps for each leg. */
  seatMapGridDetails: FlightsSeatMapGridDetails;
  /** Represents various messages needed when seat is selected */
  seatSelectionMessages: FlightsSeatSelectionNotificationMessages;
  /** Represents the list of seat confirmed details info. */
  seatsConfirmedDetails?: Maybe<Array<FlightsSeatsConfirmedDetails>>;
};

export type FlightsJourneySeatMapCabinContent =
  | FlightsJourneySeatAncillaryCabinFailure
  | FlightsJourneySeatAncillaryCabinSuccess;

/** Brief description of selected itinerary like time of flight, stops etc. */
export interface FlightsJourneySummary {
  /** Combination of messages that gives a summary of the trip like duration and stops, cabin class details etc. */
  basicFlightDetails: Array<FlightsMessageAndAccessibility>;
  /** Difference between arrival and departure days. Example: '+2' or '+1', accessibility: Flight spans 2 days */
  differentDayArrival?: Maybe<FlightsMessageAndAccessibility>;
  /** Details of the flight departure and arrival time, egs: 1:00pm - 6:00pm, accessibility being 1:00pm to 6:00pm */
  heading: FlightsMessageAndAccessibility;
  /** Icon and message to display a red-eye flight related message */
  redEyeMessage?: Maybe<FlightsIconAndLabel>;
}

/** Brief description of time of flight, duration and stops */
export type FlightsJourneyTimeAndStops = {
  __typename?: "FlightsJourneyTimeAndStops";
  differentDayArrival?: Maybe<FlightsMessageAndAccessibility>;
  durationAndStops: FlightsMessageAndAccessibility;
  flightTimes: FlightsMessageAndAccessibility;
};

/** The information to display when the offer renders details expanded e.g. Expedia Bargain Fare */
export type FlightsJourneyWithDetails = {
  __typename?: "FlightsJourneyWithDetails";
  /** Expanded details about the journey trip */
  details: Array<EgdsText>;
  /** Footer note about the journey underneath the details */
  footnotes: Array<EgdsText>;
  /** Journey heading */
  header: Scalars["String"];
  /** Journey sub heading */
  subheader: Scalars["String"];
};

/** Represents a label along with its value */
export type FlightsLabelAndValue = {
  __typename?: "FlightsLabelAndValue";
  /** Accessibility message for the label and value */
  accessibilityMessage: Scalars["String"];
  /** Label, ex: Changes, Cancellations, etc */
  label: Scalars["String"];
  /** Value to be shown for the label */
  value: Scalars["String"];
};

/** Represents ancillary leg summary's action type based on number of ancillaries selected for a flight */
export type FlightsLegAncillarySummaryActionType = {
  __typename?: "FlightsLegAncillarySummaryActionType";
  /** Represents the analytics to track with the action type */
  analyticsList: Array<ClientSideAnalytics>;
  /** Id of the action type to be mapped with number of ancillaries selected */
  id: FlightsActionType;
};

/** Represents an action to select a leg in add ancillary */
export type FlightsLegDropdownItemSelection = FlightsClientAction & {
  __typename?: "FlightsLegDropdownItemSelection";
  /** Used to provide accessibility that has to be read on completion of action. */
  accessibility?: Maybe<Scalars["String"]>;
  /** Used to capture client side analytics */
  analyticsList: Array<ClientSideAnalytics>;
};

/** Describes an actionable area for the next section */
export type FlightsLinkAction = {
  __typename?: "FlightsLinkAction";
  /** Represents accessibility text for actionable area */
  accessibility?: Maybe<Scalars["String"]>;
  /** Represents the analytics to track on interaction with trigger. */
  analytics: FlightsAnalytics;
  /** Text shown in the actionable area. Example: 'Airline Age Rules' */
  displayAction: Scalars["String"];
  /** Represents the destination URL for the trigger */
  url: Scalars["URL"];
};

/** Target of the Link when clicked */
export type FlightsLinkTarget =
  /** Link will be opened in an external view e.g. new tab or browser window */
  | "EXTERNAL"
  /** Link will be opened in the same view where the user is currently e.g. same tab or webview inside an app */
  | "INTERNAL";

/** Represents each filter item in a FlightsListDisplayFilterOption */
export type FlightsListDisplayFilterItem = FlightsFilterItem & {
  __typename?: "FlightsListDisplayFilterItem";
  /** Represents the accessibility message for the filter item */
  accessibility?: Maybe<FlightsAccessibilityMessage>;
  /** Represents the EGCS analytics to track on interaction when this filter item is applied or removed */
  analytics: FlightsFilterItemAnalytics;
  /** Boolean which represents whether a particular item is selected or not when filters are cleared */
  defaultSelected: Scalars["Boolean"];
  /** Represents the analytics to track on interaction when this filter item is deselected */
  deselectAnalytics: FlightsAnalytics;
  /** Represents the object to be sent back to the server in the subsequent request when this particular filter item is selected */
  flightsSearchFilterValues: FlightsSearchFilterValues;
  /** Represents the formatted multiItem starting price of offers which would be returned if this filter item is selected */
  formattedMultiItemStartingPrice?: Maybe<Scalars["String"]>;
  /** Represents the identifier for the particular filter item */
  identifier: Scalars["String"];
  /** Represents the label for this filter item */
  label: Scalars["String"];
  /** Represents the analytics to track on interaction when this filter item is selected */
  selectAnalytics: FlightsAnalytics;
  /** Represents the analytics to track on interaction position when this filter item is selected */
  selectPositionAnalytics?: Maybe<FlightsAnalytics>;
  /** Boolean which represents whether a particular item is selected or not */
  selected: Scalars["Boolean"];
  /** Represents the starting price of offers which would be returned if this filter item is selected */
  startingPrice?: Maybe<Money>;
  /** Represents the filter value for this filter item. Would aid in solving the client side sort and filter */
  value: FlightsFilterValue;
};

/** Represents the list based filter module . Ex Preferred airline based filter on PWA */
export type FlightsListDisplayFilterOption = FlightsFilterOption & {
  __typename?: "FlightsListDisplayFilterOption";
  /** Represents the list of filter items associated with this filter option */
  items: Array<FlightsListDisplayFilterItem>;
  /** Represents the default number of items to be displayed on the filter. If this is more the items.size, showMoreToggle needs to be displayed */
  itemsDefaultDisplayCount: Scalars["Int"];
  /** Represents the label associated with particular filter option */
  label: Scalars["String"];
  /** Represents the label corresponding to 'from:' used labelling the starting price for each filter item */
  priceFromLabel?: Maybe<Scalars["String"]>;
  /** Represents the 'show more/show less' text shown for filters which have large number of items , ex. Preferred Airlines filter */
  showMoreToggle?: Maybe<FlightsToggle>;
  /** Represents whether the filter supports multi-selection */
  supportsMultipleSelection: Scalars["Boolean"];
  /** Represents the FilterType for this filter option */
  type: FlightsFilterType;
};

/** Represents the various types of listings available */
export type FlightsListing =
  | EgdsElementWrapper
  | FlightsBargainFareOffer
  | FlightsCouponCredit
  | FlightsCreditsAvailableListing
  | FlightsCrossSellMessage
  | FlightsCrossSellOffer
  | FlightsElementsWrapper
  | FlightsEmailSubscription
  | FlightsFeedback
  | FlightsListingMessagingCard
  | FlightsListingOffer
  | FlightsOfferCard
  | FlightsPriceAlertsListing
  | FlightsSocialProofMessage
  | FlightsSponsoredContentAdListing
  | FlightsStandardOffer
  | FlightsSuggestedFilterMessageListing
  | FlightsSustainabilityMessage;

/** Represents the messaging cards of listing on top of listings */
export type FlightsListingMessagingCard = {
  __typename?: "FlightsListingMessagingCard";
  /** Represents the messaging card of listing  e.g sign in card in case of member only deal */
  messagingCard: FlightsMessagingCardPlacard;
};

export type FlightsListingOffer = {
  __typename?: "FlightsListingOffer";
  /** This represents the clickable offer card itself */
  card: FlightsOfferCard;
  /** This represents additional information presentation for the journey and fares */
  detailsAndFares: FlightsDetailsAndFaresPresentation;
};

export type FlightsListingResult = FlightsLoadedListingResult | FlightsLoadingListingResult | FlightsProgressBarDetails;

/** Represents various analytics associated with listing */
export type FlightsListingsAnalytics = {
  __typename?: "FlightsListingsAnalytics";
  /** Represents the analytics to track the fill rate of amenities */
  amenitiesFillRateAnalytics?: Maybe<FlightsAnalytics>;
  /** Represents analytics to track if best bets is being showed */
  bestBetsDisplayedAnalytics?: Maybe<FlightsAnalytics>;
  /** Represents analytics for fare calendar for NFF or deviation from actual price shown on calendar whenever available */
  fareCalendarAnalytics?: Maybe<FlightsAnalytics>;
  /** Represents analytics to track the percentage of fares with upsells */
  fareUpsellPercentageAnalytics?: Maybe<FlightsAnalytics>;
  /** Represents the analytics to track if more listings loader was displayed */
  moreListingsDisplayedAnalytics?: Maybe<FlightsAnalytics>;
  /** Represents the analytics to track if more listings failed to load */
  moreListingsErrorAnalytics?: Maybe<FlightsAnalytics>;
  /** Represents the analytics to track time for more listings */
  moreListingsLoadTimeAnalytics?: Maybe<FlightsAnalytics>;
  /**
   * Represents the analytics to track if the user has scrolled through to the end of the listings
   * @deprecated This is not needed. Handle last offer analytics in offer node itself
   */
  onViewedAnalytics: FlightsAnalytics;
  /** Represents the analytics to track if the user has scrolled through to the end of the listings list */
  onViewedAnalyticsList: Array<FlightsAnalytics>;
  /** Represents the analytics to track if pinned listing was displayed */
  pinnedListingDisplayedAnalytics?: Maybe<FlightsAnalytics>;
};

/** Represents the pagination configuration for offer listings */
export type FlightsListingsPagination = {
  __typename?: "FlightsListingsPagination";
  /** Represent the fares needs to be present in listing results, for ex 'ONLY_BASE */
  faresSeparationType: FlightsFaresSeparationType;
  /** Represent the page size for the listings and associated fares call */
  pagination: Pagination;
};

/** Represents an action to load ancillaries options */
export type FlightsLoadAncillariesAction = FlightsClientAction & {
  __typename?: "FlightsLoadAncillariesAction";
  /** Used to provide accessibility that has to be read on completion of action. */
  accessibility?: Maybe<Scalars["String"]>;
  /** Used to capture client side analytics */
  analyticsList: Array<ClientSideAnalytics>;
};

/** Represents the listings in loaded state */
export type FlightsLoadedListingResult = {
  __typename?: "FlightsLoadedListingResult";
  accessibilityMessage?: Maybe<Scalars["String"]>;
  /** Represents the message for accessibility after results get loaded if they were filtered. Example : 'Results are now filtered' */
  appliedFilterAccessibility?: Maybe<Scalars["String"]>;
  /** Represents the message for accessibility after results get loaded. Example : 'Results now sorted by price' */
  appliedSortingAccessibility?: Maybe<Scalars["String"]>;
  /** Represents various analytics associated with listing */
  flightsListingsAnalytics: FlightsListingsAnalytics;
  listings?: Maybe<Array<FlightsListing>>;
  /** Represents the button for fetching more listings. */
  listingsAction?: Maybe<FlightsAction>;
  /** Represents the message if more listings are available */
  moreListingsAvailable?: Maybe<Scalars["String"]>;
  /** Represents the message if pinned listing is not available */
  pinnedListingUnavailableMessage?: Maybe<Scalars["String"]>;
  /** Represents the message for accessibility when the results are loaded after clicking show more button */
  showMoreListingLoadedAccessibilityMessage?: Maybe<Scalars["String"]>;
  /** Represents the toast to be triggered when the listings are loaded */
  toasts?: Maybe<Array<EgdsToast>>;
};

/** Represents loaded state of Price Summary for an offer */
export type FlightsLoadedPriceSummary = FlightsPriceSummary & {
  __typename?: "FlightsLoadedPriceSummary";
  /** Represents book directly on airlines site dialog */
  bookWithAirlinesDialog?: Maybe<BookWithAirlinesDialog>;
  /** Represents list of price summaries. Example: 'Taxes and Fees $999' */
  breakdown: Array<FlightsPriceSummaryGroup>;
  /** Represents the button action. Example: GO_TO_CHECKOUT */
  buttonAction: FlightsAction;
  /**
   * Action allowing user to use their air credits
   * @deprecated No longer in use, to be cleaned up
   */
  creditShoppingRedirectAction?: Maybe<FlightsAction>;
  /**
   * Messaging informing the user regarding the use of air credits
   * @deprecated No longer in use, to be cleaned up
   */
  creditShoppingRedirectMessaging?: Maybe<Scalars["String"]>;
  /** Represents the 'X' icon which dismisses the price Summary */
  dismiss: FlightsActionableIcon;
  /** Represents the analytics to price summary card when it is displayed */
  displayAnalytics?: Maybe<Array<ClientSideAnalytics>>;
  /** Represents various alert dialogs to be shown for ancillary selection */
  flightsAncillaryAlertDialogList?: Maybe<Array<FlightsDialog>>;
  /**
   * Represents various alert dialogs to be shown for ancillary selection
   * @deprecated New implementation on Shared-UI requires new type, replace with flightsAncillaryAlertDialogList
   */
  flightsAncillaryAlertDialogs?: Maybe<Array<FlightsAncillaryAlertDialog>>;
  /** Represents policies related to fares, taxes, cancellation and amenities */
  policies: FlightsTextSection;
  /** Represents the price presentation */
  pricePresentation?: Maybe<PricePresentation>;
  /** Represents Sign in messaging card in case of member only deal and user is not logged in and it will be visible only for mobile site */
  signInMessagingCard?: Maybe<EgdsStandardMessagingCard>;
  /** Represents the title. Example: 'Price Summary' */
  title: Scalars["String"];
  /** Represents the subtotal and discount */
  totals?: Maybe<Array<FlightsPriceSummaryGroup>>;
  /** Represents the trip total label, price and rate currency message */
  tripTotalDetails: FlightsPriceSummaryTripTotalItem;
  /** Represents the trip total label for mobile, Example: Trip Total */
  tripTotalLabel: Scalars["String"];
  /** Represents action for price summary link in collapsed view.  Example: 'View price summary' */
  viewPriceSummary: FlightsAction;
};

export type FlightsLoadedSearchForm = FlightsSearchForm & {
  __typename?: "FlightsLoadedSearchForm";
  /** Represents the accessibility message when results are shown. Example: 'Change your search' */
  accessibilityMessage?: Maybe<Scalars["String"]>;
  addJourneyAction?: Maybe<FlightsAction>;
  /** Represents whether airport dropdown is enabled or not */
  airportDropdownEnabled?: Maybe<Scalars["Boolean"]>;
  /** Count of the currently applied filter */
  appliedFilterCount?: Maybe<Scalars["Int"]>;
  /** Available flight routes for search */
  availableRoutes?: Maybe<AvailableRoutes>;
  /** Represents the accessibility message when close button is clicked */
  closeActionAccessibility?: Maybe<Scalars["String"]>;
  closeFormAction?: Maybe<FlightsAction>;
  /** Represents the analytics to track on collapse interaction */
  collapseFormAnalytics: FlightsAnalytics;
  /** Represents the accessibility message for OD Pair, Date and Traveler. */
  collapsedFormAccessibility?: Maybe<FlightsResponsiveAccessibilityMessage>;
  /** Represents the departure and return dates. Example: 'Jan 23 - Feb 13' */
  departureAndReturnDates?: Maybe<FlightsResponsiveMessage>;
  /** Represents the error message displayed for a search form error state */
  errorSummary: FlightsErrorSummary;
  /** Icon and label that opens the filter display */
  expandFilterAction: FlightsIconAndLabel;
  /** Represents the analytics to track on expand interaction */
  expandFormAnalytics: FlightsAnalytics;
  /** Icon that opens the search form */
  expandSearchFormAction: Icon;
  journeys: Array<FlightsSearchFormJourneyCriteria>;
  /**
   * Represents whether multi destination is enabled or not
   * @deprecated This field is now deprecated
   */
  mDestEnabled?: Maybe<Scalars["Boolean"]>;
  /** Represents the template for a new, empty journey criteria */
  newJourneyTemplate: FlightsSearchFormJourneyCriteria;
  /** Represents the origin and destination. Example: 'Seattle to San Francisco' */
  originAndDestinationLocations?: Maybe<Scalars["String"]>;
  /** Represents the search button text */
  searchAction?: Maybe<Scalars["String"]>;
  /** Represents the accessibility message for Search Button */
  searchActionAccessibility?: Maybe<Scalars["String"]>;
  /** Represents whether the  search button is active */
  searchActionActive: Scalars["Boolean"];
  /** Represents the analytics to track on search interaction */
  searchActionAnalytics: FlightsAnalytics;
  searchOptions: Array<FlightsSearchFormOption>;
  /** Represents the total number of travelers with a token to be replaced with the actual number.. Example: '{numberOfTravelers} travelers' */
  travelersSummary: FlightsMultiPluralLocalizationTemplate;
};

/** Represents the result required to render the Sort & Filter view on the client */
export type FlightsLoadedSortAndFilterResult = FlightsSortAndFilterResult & {
  __typename?: "FlightsLoadedSortAndFilterResult";
  /** Represents the display to be rendered showcasing the already applied filters */
  appliedFiltersSummary?: Maybe<FlightsAppliedFiltersSummary>;
  /** Represents the button whose on click triggers the sorting & filtering of results */
  applyAction: FlightsSortAndFilterAction;
  /** Represents the 'Clear all' label displayed which clears all the Sort & Filter options already selected */
  clearAllSelectionLabel: FlightsActionableLabel;
  /** Represents the 'clear' label displayed which clears all the Sort & Filter options already selected */
  clearSelectionLabel: FlightsActionableLabel;
  /** Represents the 'X' icon displayed which dismisses the Sort & Filter view on client */
  dismiss: Icon;
  /** Represents the accessibility message over 'X' icon displayed which dismisses the Sort & Filter view on client */
  dismissAccessibility?: Maybe<Scalars["String"]>;
  /** Represents the analytics to track on interaction with the dismiss icon */
  dismissAnalytics: FlightsAnalytics;
  /** Represents the analytics for metrics related to fare level filtering */
  filterAnalyticsList?: Maybe<Array<FlightsAnalytics>>;
  /** Represents the object required to render the Filter options presentation on client */
  filterPresentation?: Maybe<FlightsFilterLoadedPresentation>;
  /** Represents the 'Sort & Filter' label and image to be displayed on the view */
  revealAction: FlightsSortAndFilterRevealAction;
  /** Represents the analytics to track on interaction with the reveal action */
  revealActionAnalytics: FlightsAnalytics;
  /** Represents the object required to render the Sort options presentation on client */
  sortPresentation: FlightsSortLoadedPresentation;
  /** Represents the 'Filters' label to be displayed on the filters view */
  title: Scalars["String"];
};

/** Represents the loading state of listings. */
export type FlightsLoadingListingResult = {
  __typename?: "FlightsLoadingListingResult";
  /** Represents the message for accessibility while search results are loading. Example : 'MEX to MAN Flights | Travelocity' */
  accessibility?: Maybe<Scalars["String"]>;
  /** Represents message received when filters are applied and listings are loading */
  flightsPlacard?: Maybe<FlightsPlacard>;
  /** Represents the search in progress flight image shown while listings are loading */
  image: Image;
  /** Represents the number of skeleton listings displayed while listings are loading */
  listingsSkeletonCount: Scalars["Int"];
  /** Represents the message like 'Searching for flights from 400+ airlines..' displayed while listings are loading */
  message: Scalars["String"];
  /** Represents the OD string like 'SEA to SFO' displayed while listings are loading */
  originDestination: Scalars["String"];
  /** Represents the pagination config that will be used to make listings loaded call */
  paginationConfig?: Maybe<Array<FlightsListingsPagination>>;
  /** Represents the prefilters fragment including carousel */
  preFilterWrapper?: Maybe<FiltersWrapper>;
  /**
   * Represents the display of progress bar when the results are loading
   * @deprecated We don't need it now since we have created the Progress Details which will be null when not needed
   */
  progressBar: FlightsProgressBarDisplay;
  /** Represents the details of progress bar when the results are loading */
  progressBarDetails?: Maybe<FlightsProgressBarDetails>;
  /** Represent cached results to show on loading state. */
  stringifiedCachedSearchResults?: Maybe<Scalars["String"]>;
  /** Represents toast message when filters are applied */
  toast?: Maybe<EgdsToast>;
};

/** Represents loading state of Price Summary for an offer */
export type FlightsLoadingPriceSummary = FlightsPriceSummary & {
  __typename?: "FlightsLoadingPriceSummary";
  /** Represents the button action. Example: GO_TO_CHECKOUT */
  buttonAction: FlightsAction;
  /** Represents the number of skeleton while price summary is loading */
  skeletonCount: Scalars["Int"];
  /** Represents the title, Example: Price Summary */
  title: Scalars["String"];
  /** Represents the trip total label for mobile, Example: Trip Total */
  tripTotalLabel: Scalars["String"];
};

export type FlightsLoadingSearchForm = FlightsSearchForm & {
  __typename?: "FlightsLoadingSearchForm";
  /** Represents the accessibility message when results are shown */
  accessibilityMessage?: Maybe<Scalars["String"]>;
  addJourneyAction?: Maybe<FlightsAction>;
  /** Represents whether airport dropdown is enabled or not */
  airportDropdownEnabled?: Maybe<Scalars["Boolean"]>;
  /** Count of the currently applied filter */
  appliedFilterCount?: Maybe<Scalars["Int"]>;
  /** Available flight routes for search */
  availableRoutes?: Maybe<AvailableRoutes>;
  /** Represents the accessibility message when close button is clicked */
  closeActionAccessibility?: Maybe<Scalars["String"]>;
  closeFormAction?: Maybe<FlightsAction>;
  /** Represents the analytics to track on collapse interaction */
  collapseFormAnalytics: FlightsAnalytics;
  /** Represents the accessibility message for OD Pair, Date and Traveler. */
  collapsedFormAccessibility?: Maybe<FlightsResponsiveAccessibilityMessage>;
  /** Represents the departure and return dates. Example: 'Jan 23 - Feb 13' */
  departureAndReturnDates?: Maybe<FlightsResponsiveMessage>;
  /** Represents the error message displayed for a search form error state */
  errorSummary: FlightsErrorSummary;
  /** Icon and label that opens the filter display */
  expandFilterAction: FlightsIconAndLabel;
  /** Represents the analytics to track on expand interaction */
  expandFormAnalytics: FlightsAnalytics;
  /** Icon that opens the search form */
  expandSearchFormAction: Icon;
  journeys: Array<FlightsSearchFormJourneyCriteria>;
  /**
   * Represents whether multi destination is enabled or not
   * @deprecated This field is now deprecated
   */
  mDestEnabled?: Maybe<Scalars["Boolean"]>;
  /** Represents the template for a new, empty journey criteria */
  newJourneyTemplate: FlightsSearchFormJourneyCriteria;
  /** Represents the origin and destination. Example: 'Seattle to San Francisco' */
  originAndDestinationLocations?: Maybe<Scalars["String"]>;
  /** Represents the search button text */
  searchAction?: Maybe<Scalars["String"]>;
  /** Represents the accessibility message for Search Button */
  searchActionAccessibility?: Maybe<Scalars["String"]>;
  /** Represents whether the  search button is active */
  searchActionActive: Scalars["Boolean"];
  searchOptions: Array<FlightsSearchFormOption>;
  /** Represents the total number of travelers with a token to be replaced with the actual number.. Example: '{numberOfTravelers} travelers' */
  travelersSummary: FlightsMultiPluralLocalizationTemplate;
};

/** Represents the result required to render the Sort & Filter view on the client in a loading state */
export type FlightsLoadingSortAndFilterResult = FlightsSortAndFilterResult & {
  __typename?: "FlightsLoadingSortAndFilterResult";
  /** Represents the object required to render the Filter options presentation on client */
  filterPresentation: FlightsFilterLoadingPresentation;
  /** Represents the 'Sort & Filter' label and image to be displayed on the view */
  revealAction: FlightsSortAndFilterRevealAction;
  /** Represents the object required to render the Sort options presentation on client */
  sortPresentation: FlightsSortLoadingPresentation;
  /** Represents the 'Filters' label to be displayed on the filters view */
  title: Scalars["String"];
};

export interface FlightsLocalizationTemplate {
  /** Initial string with the token already replaced with a value */
  initialValue?: Maybe<Scalars["String"]>;
  /** List of all the tokens in the template.Example: ['{numberOfTravelers}'] */
  tokens: Array<Scalars["String"]>;
}

/** Loyalty Points Information */
export type FlightsLoyaltyPointsOption = {
  __typename?: "FlightsLoyaltyPointsOption";
  /** Accessibility information for loyalty e.g. Price is 35,000 points and C$43.44 */
  accessibility: Scalars["String"];
  /** Loyalty points formatted text e.g. 15,000 pts */
  formattedPoints: Scalars["String"];
  /** Boolean to indicate if points should be displayed first or the cash */
  isPointsFirst: Scalars["Boolean"];
  /** Boolean to indicate if the strike-through price should be displayed first before the lead price */
  isStrikeThroughFirst: Scalars["Boolean"];
  /** Caption before price or points, e.g. [or] [and] */
  leadingCaption: Scalars["String"];
  /** Display fixed Price for the partial that needs to be paid by cash e.g. C$43.76 */
  overageAmount?: Maybe<Scalars["String"]>;
  /** Value of Points which are strike through and displayed in case of promotions e.g. 20,000 pts */
  strikeThroughFormattedPoints?: Maybe<Scalars["String"]>;
};

/** Represents a label with a decorating mark */
export type FlightsMarkAndLabel = {
  __typename?: "FlightsMarkAndLabel";
  /** Accessibility Text for the mark */
  accessibility?: Maybe<Scalars["String"]>;
  /** Label next to the mark */
  label: Scalars["String"];
  /** Mark that decorates the label */
  mark?: Maybe<Mark>;
  /** Sublabel for additional text */
  subLabel?: Maybe<Scalars["String"]>;
};

export type FlightsMarkPlacard = FlightsPlacard & {
  __typename?: "FlightsMarkPlacard";
  /** Represents the links/actions after the message if present */
  actions?: Maybe<Array<FlightsAction>>;
  /** Represents the display type for banners */
  displayType?: Maybe<FlightsPlacardDisplayType>;
  /** Represents the heading of placard if present */
  heading?: Maybe<Scalars["String"]>;
  /** Represents the mark of placard if applicable */
  mark?: Maybe<Mark>;
  /** Represents the message text for the placard */
  message: Scalars["String"];
  /** Represents analytics to be tracked when the Placard is available but not yet within the client's viewport */
  onAvailableAnalytics?: Maybe<FlightsAnalytics>;
  /** Represents onView analytics for a Placard. This will be triggered when the placard is visible on the client's viewport */
  onViewedAnalytics?: Maybe<FlightsAnalytics>;
};

/** Represents a message with its accessibility message  */
export type FlightsMessageAndAccessibility = {
  __typename?: "FlightsMessageAndAccessibility";
  /** Represents the accessibility of the message */
  accessibilityMessage: Scalars["String"];
  /** Represents the size of text. */
  size?: Maybe<Scalars["Int"]>;
  /** Represents the message to be displayed */
  text: Scalars["String"];
  /** Theme for the text */
  theme?: Maybe<TextTheme>;
};

/** The Messaging card section of the Details and Fares */
export type FlightsMessagingCard = {
  __typename?: "FlightsMessagingCard";
  /** Represents the card to Messaging */
  cardContent: EgdsStandardMessagingCard;
  /** Represents the analytics to messaging card when it is displayed */
  displayAnalytics?: Maybe<Array<ClientSideAnalytics>>;
};

export type FlightsMessagingCardPlacard = FlightsUiPlacard & {
  __typename?: "FlightsMessagingCardPlacard";
  /** Represents the button if present that can be either FlightsActionButton or FlightsActionLink */
  actionElement?: Maybe<FlightsClientActionElement>;
  /**
   * Represents the links/actions if present
   * @deprecated This field is now deprecated because it is becoming so overloaded., replace with FlightsActionButton.FlightsClientAction
   */
  actions?: Maybe<Array<FlightsAction>>;
  /**
   * Represents the button if present
   * @deprecated Please from now on use FlightsClientActionElement for button if present
   */
  button?: Maybe<FlightsActionButton>;
  /** Represents the display type for banners */
  displayType: FlightsPlacardDisplayType;
  /** Represents flights messagingCards */
  messagingCard: UiMessagingCard;
  /**
   * Represents onView analytics for a Placard. This will be triggered when the placard is visible on the client's viewport
   * @deprecated Use onViewedAnalyticsList for future use.
   */
  onViewedAnalytics?: Maybe<FlightsAnalytics>;
  /** Represents onView analytics list for a Placard. This will be triggered when the placard is visible on the client's viewport */
  onViewedAnalyticsList?: Maybe<Array<ClientSideAnalytics>>;
};

/** Metrics names */
export type FlightsMetricName = "LISTINGS_SUPPLY_RESPONSE_TIME";

/** Represents a localization template for scenarios that involve plural and singular wordsdepending on a variable number. Depending on the number clients will choose one template and replace tokens inside of it.Example: '{numberOfTravelers} travelers' */
export type FlightsMultiPluralLocalizationTemplate = FlightsLocalizationTemplate & {
  __typename?: "FlightsMultiPluralLocalizationTemplate";
  /** Localized string with tokens interpolated for numeric values.Used when (n mod 100 = 3..10). Example: '{numberOfTravelers} travelers.' */
  fewTemplate: Scalars["String"];
  initialValue?: Maybe<Scalars["String"]>;
  /** Localized string with tokens interpolated for numeric values.Used when (n mod 100 = 11..99). Example: '{numberOfTravelers} travelers.' */
  manyTemplate: Scalars["String"];
  /** Localized string with tokens interpolated for numeric values.Used when (n = 1). Example: '{numberOfTravelers} traveler.' */
  oneTemplate: Scalars["String"];
  /** Localized string with tokens interpolated for numeric values.Used when for any other number not included in the other scenarios. Example: '{numberOfTravelers} travelers.' */
  otherTemplate: Scalars["String"];
  tokens: Array<Scalars["String"]>;
  /** Localized string with tokens interpolated for numeric values.Used when (n = 2). Example: '{numberOfTravelers} travelers.' */
  twoTemplate: Scalars["String"];
  /** Localized string with tokens interpolated for numeric values.Used when (n = 0). Example: '{numberOfTravelers} travelers.' */
  zeroTemplate: Scalars["String"];
};

/** Action to move to FIS or UDP */
export type FlightsNavigateToDetails = FlightsClientAction & {
  __typename?: "FlightsNavigateToDetails";
  accessibility?: Maybe<Scalars["String"]>;
  /** Used to capture client side analytics */
  analyticsList: Array<ClientSideAnalytics>;
  /** The dialogId to open FCM for large breakpoint */
  dialogId: Scalars["String"];
  /** The multi item price token needed in packages path */
  nextPage: Uri;
  /** The UDP page to move the user when is in a package path */
  packagesUrl?: Maybe<Uri>;
};

/** The marker interface for all types (for different clients) which can be used to make a flights search call */
export type FlightsNextJourneyCriteria = FlightsNextJourneyCriteriaLink | FlightsNextJourneyCriteriaValues;

/** Input needed by web/PWA to make the next search call */
export type FlightsNextJourneyCriteriaLink = {
  __typename?: "FlightsNextJourneyCriteriaLink";
  link: Scalars["URL"];
};

export type FlightsNextJourneyCriteriaValues = {
  __typename?: "FlightsNextJourneyCriteriaValues";
  journeyCriteria: Array<Maybe<FlightsJourneyCriteria>>;
  searchPreferences: FlightSearchPreferences;
};

/** Represents the value associated with travel and baggage filter - no cancel fee */
export type FlightsNoCancelFeeBasedFilterValue = {
  __typename?: "FlightsNoCancelFeeBasedFilterValue";
  noCancelFee: NoCancelFeeType;
};

/** Represents the value associated with travel and baggage filter - no cancel fee */
export interface FlightsNoCancelFeeBasedFilterValueInput {
  noCancelFee: NoCancelFeeType;
}

/** Represents the value associated with travel and baggage filter - no change name */
export type FlightsNoChangeFeeBasedFilterValue = {
  __typename?: "FlightsNoChangeFeeBasedFilterValue";
  noChangeFee: NoChangeFeeType;
};

/** Represents the value associated with travel and baggage filter - no change name */
export interface FlightsNoChangeFeeBasedFilterValueInput {
  noChangeFee: NoChangeFeeType;
}

/** Represents a message to be displayed to users when the search completes with no offers */
export type FlightsNoFlightsFoundMessaging = FlightsErrorMessagingPresentation & {
  __typename?: "FlightsNoFlightsFoundMessaging";
  /** Icon included at the top of the message. Example: Search icon */
  icon: Icon;
  /** Message content. Example: 'Here are some tips to help find flights' */
  message: Scalars["String"];
  /** Title of the message */
  title: Scalars["String"];
};

/** Represents a message to be displayed to users when the filters they applied ruled out all the possible flights */
export type FlightsNoFlightsFoundWithFilterMessaging = FlightsErrorMessagingPresentation & {
  __typename?: "FlightsNoFlightsFoundWithFilterMessaging";
  /**
   * Represents button/link action below the message to clear applied filters.
   * @deprecated Conflicting with action in FlightsActionableErrorMessaging. Replaced with clearFiltersAction
   */
  action?: Maybe<FlightsAction>;
  /** Represents button/link action below the message to clear applied filters. To be shown in mWeb only. */
  clearFiltersAction?: Maybe<FlightsAction>;
  /** Icon included at the top of the message. Example: Search icon */
  icon: Icon;
  /** Message content. Example: 'Please change the selected filters and try your search again' */
  message: Scalars["String"];
  /** Title of the message. Example: 'There are no flights that match your search criteria.' */
  title: Scalars["String"];
};

/** Interface encapsulating common properties between all the various types of listings available via flights search results query */
export interface FlightsOffer {
  accessibilityHeading?: Maybe<Scalars["String"]>;
  accessibilityMessage?: Maybe<Scalars["String"]>;
  journeyContinuationId?: Maybe<Scalars["String"]>;
  journeys: Array<FlightsOfferJourney>;
  onClickAnalyticsList: Array<FlightsAnalytics>;
  selectOfferAction: FlightsAction;
}

/** Represents various analytics associated with an offer */
export type FlightsOfferAnalytics = {
  __typename?: "FlightsOfferAnalytics";
  /** Represents the analytics to track when amenities information is not available for the searched route */
  amenitiesInfoNotAvailableAnalytics?: Maybe<FlightsAnalytics>;
  /**
   * Represents onView analytics for an offer. This will be triggered when an offer is visible on the client's viewport
   * @deprecated This field is replaced by the onViewedAnalyticsList
   */
  onViewedAnalytics: FlightsAnalytics;
  /** Represents onView analytics for an offer. This will be triggered when an offer is visible on the client's viewport */
  onViewedAnalyticsList: Array<FlightsAnalytics>;
};

/** Represents what baggage fees an offer may have and where to learn more about them */
export type FlightsOfferBaggageFeesInformation = {
  __typename?: "FlightsOfferBaggageFeesInformation";
  /** Represents the analytics to track on interaction with the baggage fee link */
  analytics: FlightsAnalytics;
  /** Represents an icon to denote the availability of checked baggage. Ex: baggage icon or no-baggage icon */
  icon: Icon;
  /** Represents a label to denote the availability of checked baggage. Ex: Baggage fee info, Checked bag NOT included */
  label: Scalars["String"];
  /** Represents the url to learn more about baggage fees. */
  link?: Maybe<Scalars["URL"]>;
};

export type FlightsOfferCard = {
  __typename?: "FlightsOfferCard";
  /** This represent the additional information rendered after the content and each item will include a separator line on top of it */
  additionalContentSections?: Maybe<Array<EgdsElement>>;
  /** This represent the action when the offer is clicked */
  clickAction?: Maybe<FlightsClientAction>;
  /** This represent the main content rendered in the offer */
  content: FlightsOfferContent;
  /** This represent the featured section of the offer */
  featuredHeader?: Maybe<FlightsOfferFeaturedHeader>;
  /** This represent the offer's analytics when displayed */
  onDisplayAnalytics?: Maybe<ClientSideAnalytics>;
  /** This represent if the offer is rendered as selected */
  selected: Scalars["Boolean"];
};

/** This represent the transportation offer content */
export type FlightsOfferContent = {
  __typename?: "FlightsOfferContent";
  /** This represent the section rendered at the top of the left and center sections in desktop. Contains EGDS Badges. */
  badges?: Maybe<Array<EgdsStandardBadge>>;
  /** This represent the pricing section of the offer */
  priceSection: FlightsOfferPriceSection;
  /** This represent the left section of the offer */
  primarySection: EgdsTextSection;
  /** Secondary content. Rendered below primary content in mobile, and in a separate center column in desktop */
  secondarySection?: Maybe<EgdsTextSection>;
  /** This represent the section rendered underneath the left and center sections in desktop, in mobile it renders below the primary and secondary section */
  tertiarySection?: Maybe<EgdsTextSection>;
};

/** Represents the section for displaying the rules and restrictions of a basic economy offer. */
export type FlightsOfferFareRulesPresentation = {
  __typename?: "FlightsOfferFareRulesPresentation";
  /** Represents the accessibility message for Rules and Restrictions */
  accessibilityMessage?: Maybe<Scalars["String"]>;
  /** Represents the action text for displaying the rules and restrictions. Ex: Fare Rules and Restrictions */
  displayAction: FlightsToggle;
  /** Represents Fare Upgrade message or SingleFareMessage. Ex: You may be able to upgrade before checkout/There is only one fare offered for this flight */
  fareTrayMessage?: Maybe<FlightsResponsiveMessage>;
  /** Represents the list of available fares for an offer. */
  fareTypes: Array<FlightsOfferFareType>;
};

/** Represents the section for a specific fare's rules. */
export type FlightsOfferFareType = {
  __typename?: "FlightsOfferFareType";
  /** Represents the name of a fare type. Ex: Basic Economy, Economy */
  name?: Maybe<Scalars["String"]>;
  /** Represents the absolute price of an offer. */
  price?: Maybe<Scalars["String"]>;
  /** Represents a list of rules for a fare type. */
  rules: Array<FlightsFareRule>;
  /** Represents the button for selecting an offer. */
  selectFareAction: FlightsAction;
};

/** This represents an offer featured with some text at the top */
export type FlightsOfferFeaturedHeader = {
  __typename?: "FlightsOfferFeaturedHeader";
  /** This represents the text rendered in the left side of the featured section */
  heading: EgdsHeading;
  /** This represents the icon to be rendered in the featured section */
  icon?: Maybe<Icon>;
};

export type FlightsOfferJourney = {
  __typename?: "FlightsOfferJourney";
  /** Icon and message describing adjusted property nights based on flight arrival time */
  adjustedStayDatesMessage?: Maybe<FlightsIconPhrases>;
  /** List of airlines included in the journey */
  airlines: Array<FlightsImageAndLabel>;
  /** Cabin classes of the flights in the journey. Could be more than one. Example: 'Premium Economy + Economy' */
  cabinClass: Scalars["String"];
  /** Represents departure and arrival Information. Example: 'Delhi (DEL) - Seattle (SEA)' for desktop and 'Seattle - Delhi' for mobile device */
  departureAndArrivalLocations: Scalars["String"];
  /** Combination of departure and arrival time connected by a hyphen */
  departureAndArrivalTime: FlightsPhrase;
  /** Difference between arrival and departure days.Example: '+2' or '+1' */
  differentDayArrival?: Maybe<Scalars["String"]>;
  /** accessibility message that clarifies the difference between arrival a departure days text. Example: 'Flight spans 2 days' */
  differentDayArrivalAccessibilityMessage?: Maybe<Scalars["String"]>;
  /** Icon used to toggle hiding and showing the journey information */
  displayAction: Icon;
  /** Duration of the flights plus the number of stopsExample: '21h 10m (1 Stop)' */
  durationAndStops: Scalars["String"];
  /** Flight number, airline, and operating airline if it applies. Example: 'American Airlines 6058 operated by Compass Airlines' */
  flightOperatedBy?: Maybe<Scalars["String"]>;
  /** Summary of all available fares and details for a Journey */
  flightsDetailsAndFaresPresentation: FlightsDetailsAndFaresPresentation;
  /** Summary of all available fares for a Journey */
  flightsJourneyAvailableFaresInformation?: Maybe<FlightsJourneyAvailableFares>;
  /** Represents analytics to track the presence of highlight messages and restrictive icons */
  highlightRelevantFaresAnalytics?: Maybe<Array<FlightsAnalytics>>;
  /** Represents the hygiene amenities message in the offer. */
  hygieneAmenitiesMessage?: Maybe<Scalars["String"]>;
  /**
   * Represents the array of the hygiene amenities
   * @deprecated This node will be moved to FlightsJourneyAvailableFares
   */
  hygieneAmenitiesPresentation?: Maybe<FlightsHygieneAmenitiesPresentation>;
  /** Represents the amenities included in all the flights. Amenities include Wi-Fi, Entertainment and Electric outlets. */
  journeyAmenities?: Maybe<FlightsJourneyAmenities>;
  /** Represents the analytics to track when amenities are not available for the journey */
  journeyAmenitiesNotAvailableAnalytics?: Maybe<FlightsAnalytics>;
  /** Represents the label that for the Details view in Mobile App. Example: 'SEA to SFO. Mon 19 Aug' */
  label: Scalars["String"];
  /** Combination of layovers and duration at each layover. Example: '2h 16m in Los Angeles' for desktop and '2h 16m in LAX' for mobile device */
  layoverInformation?: Maybe<Scalars["String"]>;
  /** Positive highlights string to highlight relevant fares */
  positiveHighlightsMessage?: Maybe<Scalars["String"]>;
  /** Represents the rating given to the journey. */
  rating?: Maybe<FlightsJourneyRating>;
  /** Icons and accessibility string to highlight restrictive amenities */
  restrictiveAmenityIcons?: Maybe<Array<Icon>>;
  /**
   * Stringified summary of all available fares for a Journey
   * @deprecated Not in usage
   */
  stringifiedFlightsJourneyAvailableFaresInformation?: Maybe<Scalars["String"]>;
  /** Accessibility message which clarifies number of seats left at a price. Example: '3 left at this price' */
  urgencyAccessibilityMessage?: Maybe<Scalars["String"]>;
  /** Indicates the number of seats left for the current journey. Example: '3 left at' */
  urgencyMessage?: Maybe<Scalars["String"]>;
};

/** Contains the flights and packaged products natural keys. The natural key is the minimum set of data to retrieve details about a product */
export type FlightsOfferNaturalKeys = {
  __typename?: "FlightsOfferNaturalKeys";
  flightNaturalKey: FlightNaturalKey;
  /** Represents the minimum data used to retrieve details about the packaged products for a multi-item search */
  packagedProductsNaturalKeys?: Maybe<Array<ProductNaturalKey>>;
};

/** This represent the data rendered in price section of the offer */
export type FlightsOfferPriceSection = {
  __typename?: "FlightsOfferPriceSection";
  /** This represent the price lockup */
  priceLockup: EgdsPriceLockup;
  /** This represent the information rendered underneath the price lockup */
  subTexts?: Maybe<Array<EgdsText>>;
};

/** Represents a text section heading for Transportation offer content */
export type FlightsOfferSectionHeading = EgdsSectionHeading & {
  __typename?: "FlightsOfferSectionHeading";
  /** Represents an EGDS Icon to render after the main header */
  additionalIcon?: Maybe<Icon>;
  /** Represents the main heading text */
  heading: EgdsHeading;
  /** Represents an EGDS Mark to render before the main header */
  mark?: Maybe<Mark>;
  /** Represents a subheading */
  subheading?: Maybe<Scalars["String"]>;
};

/** Represents the airline that sponsors an offer */
export type FlightsOfferSponsoredAirline = {
  __typename?: "FlightsOfferSponsoredAirline";
  /** Represents the ad unit ID that served the Ad */
  adUnitID?: Maybe<Scalars["String"]>;
  /** Represents the advertiser ID that served the Ad */
  advertiserID?: Maybe<Scalars["String"]>;
  /** Represents the airline code, airline details for FSL Ad */
  airlineCode?: Maybe<Scalars["String"]>;
  /** Represents the click tracking URL that will be fired when Ad is clicked on the client */
  clickTrackingURL?: Maybe<Scalars["String"]>;
  /** Represents the creative ID that served the Ad */
  creativeID?: Maybe<Scalars["String"]>;
  /** Represents the impression tracking URL that will be fired when Ad is served on the client */
  delayedImpressionURL?: Maybe<Scalars["String"]>;
  /** Represents the lineItem ID that served the Ad */
  lineItemID?: Maybe<Scalars["String"]>;
  /** Represents the order ID that served the Ad */
  orderID?: Maybe<Scalars["String"]>;
  /** Represents the sponosred header by an airline */
  sponsoredHeader?: Maybe<Scalars["String"]>;
  /** Represents the sponosred text by an airline */
  sponsoredText?: Maybe<Scalars["String"]>;
};

/** Represents a tag for displaying superlatives */
export type FlightsOfferTag = {
  __typename?: "FlightsOfferTag";
  /** Represents an image of a plane */
  image: Image;
  /** Represents what type of tag or superlative applies to an offer Ex: Cheapest nonstop flight */
  message: Scalars["String"];
};

/** Represents the opinion lab link below listings */
export type FlightsOpinionLab = {
  __typename?: "FlightsOpinionLab";
  /** Represents the analytics to track on interaction with the opinion lab link */
  analytics: FlightsAnalytics;
  /** Comment icon and label that opens the opinion lab link */
  iconAndLabel: FlightsIconAndLabel;
  /** Represents the url to open the opinion lab in a new window */
  link: Scalars["URL"];
};

/** The PMP available fare for the Journey, which provides Price Match Promise selection */
export type FlightsPmpJourneyFare = FlightsJourneyFareBase & {
  __typename?: "FlightsPMPJourneyFare";
  /** Accessibility message for interaction with fare name and price */
  accessibilityMessage: Scalars["String"];
  /** Rules and Amenities to display in the ameniity hierarchy state */
  amenityHierarchyRules?: Maybe<Array<FlightsJourneyAmenitiesWithLabel>>;
  /** Represents rules and amenities to display on the fare-cards expando peek */
  amenityRules: FlightsJourneyAmenityRules;
  /** A list of badges to highlight specific features of a fare */
  badges?: Maybe<Array<EgdsBadge>>;
  /** Detailed information about baggage for the Journey's Fare */
  baggageFeesInformation: FlightsBaggageInformation;
  /** The physical cabin type for the Fare */
  cabinClass: Scalars["String"];
  /** Represents cabin class and booking codes of various segments for the fare. Ex. Economy/Coach(N) */
  cabinClassAndBookingCodes?: Maybe<Array<Scalars["String"]>>;
  /** Section describing change and cancellation with messages for this fare (e.g. 'Change your ticket for $150') */
  changeCancellationMessages?: Maybe<FlightsTextSection>;
  /**
   * Action representing the event of user selecting this Fare
   * @deprecated This will be replaced by selectFareAction
   */
  chooseFareAction: FlightsAction;
  /**
   * Alternate action text for the action associated with this Fare
   * @deprecated This will be replaced by selectFareActionAltText
   */
  chooseFareActionAltText?: Maybe<Scalars["String"]>;
  /** Represents the analytics if this fare is clicked */
  clickEventAnalytics: FlightsAnalytics;
  /**
   * Rules and Amenities to display in the collapsed state
   * @deprecated Replaced by amenityRules to have UITK expando peek on client side
   */
  collapsedRules: FlightsJourneyAmenities;
  /**
   * Rules and Amenities to display in the expanded state
   * @deprecated Replaced by amenityRules to have UITK expando peek on client side
   */
  expandedRules: Array<FlightsJourneyAmenitiesWithLabel>;
  /** Fare specific journey policy information such as standby or frequent flyer messaging */
  fareJourneyPolicies?: Maybe<FlightsTextSection>;
  /** Represents the analytics if this fare is latest/highest fare seen */
  fareScrollAnalytics: FlightsAnalytics;
  /** Represents the flights and packaged products natural keys */
  flightsOfferNaturalKeys?: Maybe<FlightsOfferNaturalKeys>;
  /** The price of the Journey in the context of previously selected fares. Could be either Total Price or Delta Price */
  formattedMainPrice: FlightsPhrase;
  /** The price of Journey for the Fare with styling */
  formattedPrice: FlightsPhrase;
  /** Indicates whether the Fare is highlighted for this Journey */
  highlighted: Scalars["Boolean"];
  /** Unique identifier for the fare of this journey (AirProductToken) */
  identifier: Scalars["String"];
  /** Indicates the status of the PMP is selected or not */
  isPmpSelected: Scalars["Boolean"];
  /** Represents the total price of a fare for all passengers. Nullable for packages path. Ex: $345 Roundtrip for 3 travelers */
  journeyFareTotalPrice?: Maybe<Scalars["String"]>;
  /** Represents Loyalty points for display on selected Journey, applicable for Burn POS */
  loyaltyPointsOption?: Maybe<FlightsLoyaltyPointsOption>;
  /** Represents the action to execute for multi-item shoppers upon selection with corresponding input for the action */
  multiItemAction?: Maybe<MultiItemAction>;
  /** Represents the tokenized string representation of the full multi-item price and breakdowns */
  multiItemPriceToken?: Maybe<Scalars["String"]>;
  /** The name (generic or branded) for the Fare */
  name: Scalars["String"];
  /** Represents the package offer containing that flight offer for packaged flights. */
  packageOfferId?: Maybe<Scalars["String"]>;
  /** Represents Earn Loyalty points for display on selected Journey, applicable for Earn POS */
  partnerLoyaltyEarnAward?: Maybe<FlightsMarkAndLabel>;
  /**
   * The price of the Journey for the Fare
   * @deprecated Replaced by formattedPrice
   */
  price: Money;
  /** Accessibility message representing the total price based on the selected fare */
  priceAccessibilityMessage: Scalars["String"];
  /** Represents the price lockup of the fare */
  priceLockup: EgdsPriceLockup;
  /** The price of Journey for the Fare with styling, with Price Match Promise applied */
  priceLockupWithPMP: EgdsPriceLockup;
  /** Price Match Promise selected card section, in case PMP was added for this fare */
  priceMatchPromiseSelectedCardSection?: Maybe<PriceMatchPromiseSelectedCardSection>;
  /** Price Match Promise selection card section, in case PMP is available for this fare */
  priceMatchPromiseSelectionCardSection?: Maybe<PriceMatchPromiseSelectionCardSection>;
  /** Price Match Promise toggle card, this supports switch toggle which will replace other versions of pmp card */
  priceMatchPromiseToggleCard?: Maybe<PriceMatchPromiseToggleableCard>;
  /**
   * An icon to indicate recommendation of the Fare
   * @deprecated Replaced by badges
   */
  recommendation?: Maybe<FlightsBadge>;
  /** Accessibility message informing the user the location of the safety amenities */
  safetyLocationAccessibilityMessage?: Maybe<Scalars["String"]>;
  /** Action representing the event of user selecting this Fare */
  selectFareAction: FlightsAction;
  /** Alternate action text for the action associated with this Fare */
  selectFareActionAltText?: Maybe<Scalars["String"]>;
  /** Action representing the event of user selecting this Fare, when PMP is applied */
  selectFareActionWithPMP: FlightsAction;
  /** Indicates whether the Fare is selected for this Journey */
  selected: Scalars["Boolean"];
  /** Accessibility message for selection of fare name and price */
  selectedFareAccessibilityMessage: Scalars["String"];
  /** Toggle to show either the collapsed ruleset or the expanded ruleset */
  showMoreAmenitiesToggle?: Maybe<FlightsToggle>;
  /**
   * Toggle to show either the collapsed ruleset or the expanded ruleset
   * @deprecated Replaced by showMoreAmenitiesToggle
   */
  showMoreToggle: FlightsToggle;
  /**
   * Represents the total price of an fare for all passengers . Ex: $345 Roundtrip for 3 travelers
   * @deprecated Replaced by journeyFareTotalPrice
   */
  totalPrice: Scalars["String"];
  /** Represents the upsell unique offer token (airOfferToken) */
  upsellOfferToken: Scalars["String"];
};

/** Represents client metadata like details of page */
export type FlightsPwaMetadata = {
  __typename?: "FlightsPWAMetadata";
  /** Analytics to be fired for the page name */
  pageAnalytics?: Maybe<ClientSideAnalytics>;
  /** Name of the page to be shown on tab field. Example: 'SEA to SFO flights' */
  pageName: Scalars["String"];
  /**
   * Analytics to be fired for the page name
   * @deprecated This will be replaced with pageAnalytics
   */
  pageNameAnalytics: FlightsAnalytics;
  /** List of Response metrics eg: Supply response time */
  responseMetrics?: Maybe<Array<FlightsResponseTimeMetrics>>;
  /** List of Response Tags eg: LISTING_CACHE_SOURCE, LISTING_DOWNLEVEL_SOURCE */
  responseTags?: Maybe<Array<ResponseTagType>>;
};

/** Represents the title of the page */
export type FlightsPageTitle = {
  __typename?: "FlightsPageTitle";
  /** Departure dates of the flights shown to the user. Example: 'Fri, Aug 9' */
  date?: Maybe<FlightsResponsiveMessage>;
  /** Subtitle of the page. Example: 'Prices displayed include taxes. Prices may change based on availability and are not final until you complete your purchase.' */
  disclaimerSubTitle?: Maybe<FlightsPhrase>;
  /** Represents loading accessibility of the page, for example 'Loading flight details for your <from destination> to <to destination> <trip type> journey' */
  pageAccessibility?: Maybe<Scalars["String"]>;
  /**
   * Subtitle of the page. Example: 'Prices are roundtrip per person'
   * @deprecated This field is now deprecated., replace with disclaimerSubTitle
   */
  subTitle?: Maybe<FlightsResponsiveMessage>;
  /** Title of the page. Example: 'Select your departure to New York' */
  title: FlightsResponsiveMessage;
};

/** Represents payment on the servicing view */
export type FlightsPayment = {
  __typename?: "FlightsPayment";
  /** Represents analytics to be tracked when payment is absent (ie: non-payment scenarios) */
  onAbsentPaymentAnalytics?: Maybe<Array<ClientSideAnalytics>>;
  /** Represents the fields to render the payment presentation */
  paymentPresentation?: Maybe<FlightsPaymentPresentation>;
};

/** Represents the payment presentation on the servicing view */
export type FlightsPaymentPresentation = {
  __typename?: "FlightsPaymentPresentation";
  /** Represents the heading (ie: 'Payment') */
  heading: Scalars["String"];
  /** Represents the list of secure payment assurances */
  iconMessages?: Maybe<Array<EgdsIconText>>;
  /** Represents the JSON stringified config to initialize the eg-payments-web widget */
  initializeConfig: Scalars["String"];
  /** Represents analytics to be tracked when payment is available but not yet within the client's viewport */
  onAvailablePaymentAnalytics?: Maybe<Array<ClientSideAnalytics>>;
  /** Represents onView analytics for payment. This will be triggered when payment is visible on the client's viewport */
  onViewedPaymentAnalytics?: Maybe<Array<ClientSideAnalytics>>;
};

/** Represents a sentence consisting of words with various text formatting styles */
export type FlightsPhrase = {
  __typename?: "FlightsPhrase";
  /** Plain text representation of the sentence as an un-attributed string */
  completeText: Scalars["String"];
  /** Delimeter to join the parts of the phrase, ex. American Airlines <delimiter> Fri, Jun 25 */
  delimeter?: Maybe<Scalars["String"]>;
  /** Ordered list of words with their corresponding text styles */
  items: Array<FlightsPhrasePart>;
  /** Represents the size of text. */
  size?: Maybe<Scalars["Int"]>;
  /** Represents theme for the text */
  theme?: Maybe<TextTheme>;
};

/** Formatted display text along with dialog */
export type FlightsPhraseDialogNode = FlightsPhrasePart & {
  __typename?: "FlightsPhraseDialogNode";
  /** Represents the accessibility for dialogs */
  accessibility?: Maybe<Scalars["String"]>;
  /** Represents the icon for display along with the text */
  actionableIcon?: Maybe<Icon>;
  /** Represents the analytics to track on interaction with the dialog */
  analytics: FlightsAnalytics;
  /** Represents the dialog to be shown on click of the text */
  dialog: FlightsDialogPresentation;
  /**
   * Represents the icon for display along with the text
   * @deprecated This field will be replaced by actionableIcon
   */
  icon?: Maybe<Scalars["String"]>;
  /** The style to apply to the text */
  styles: Array<FlightsPhrasePartStyle>;
  /** The display text for the dialog */
  text: Scalars["String"];
};

/** A link with formatted display text */
export type FlightsPhraseLinkNode = FlightsPhrasePart & {
  __typename?: "FlightsPhraseLinkNode";
  /** Represents the accessibility for links, ex: for change flight: Change your <sector> flight */
  accessibility?: Maybe<Scalars["String"]>;
  /** Represents the analytics to track on interaction with the link */
  analytics: FlightsAnalytics;
  /** Represents the display analytics if link is displayed */
  displayAnalytics?: Maybe<FlightsAnalytics>;
  /** Represents the icon for links, ex: open_in_new */
  icon?: Maybe<Scalars["String"]>;
  /** The underlying hyperlink */
  link: Scalars["URL"];
  /** Represents the scroll analytics if link comes in viewport */
  scrollAnalytics?: Maybe<FlightsAnalytics>;
  /** The style to apply to the text */
  styles: Array<FlightsPhrasePartStyle>;
  /** The display text for the link */
  text: Scalars["String"];
};

/** Type encapsulating a string and the style to apply to it */
export interface FlightsPhrasePart {
  /** The styles to be applied */
  styles: Array<FlightsPhrasePartStyle>;
  /** String to be stylized */
  text: Scalars["String"];
}

/** The text style to apply to strings */
export type FlightsPhrasePartStyle =
  /** Italic styling */
  | "EMPHASIS"
  /** Bold styling */
  | "IMPORTANT"
  /** Represents no style or regular text */
  | "STANDARD";

/** Type to encapsulate attributed/styled Text */
export type FlightsPhraseTextNode = FlightsPhrasePart & {
  __typename?: "FlightsPhraseTextNode";
  /** The style(s) to apply */
  styles: Array<FlightsPhrasePartStyle>;
  /** The text string to style */
  text: Scalars["String"];
};

/** Represents the placard (banner/messaging cards) */
export interface FlightsPlacard {
  /** Represents the links/actions after the message if present */
  actions?: Maybe<Array<FlightsAction>>;
  /** Represents the display type for banners */
  displayType?: Maybe<FlightsPlacardDisplayType>;
  /** Represents the heading of placard if present */
  heading?: Maybe<Scalars["String"]>;
  /** Represents the message text for the placard */
  message: Scalars["String"];
  /** Represents analytics to be tracked when the Placard is available but not yet within the client's viewport */
  onAvailableAnalytics?: Maybe<FlightsAnalytics>;
  /** Represents onView analytics for a Placard. This will be triggered when the placard is visible on the client's viewport */
  onViewedAnalytics?: Maybe<FlightsAnalytics>;
}

/** Represents an object to be used to differentiate the type of Placards(Ex : Placards to be shown immediately vs those which are shown during server error */
export type FlightsPlacardDisplayType =
  /** Represents the placard type to be shown immediately */
  | "IMMEDIATE"
  /** Represents the placard type to be shown during server error of sort and filter action */
  | "SORT_FILTERS_SERVER_ERROR";

export type FlightsPlacardResponse = {
  __typename?: "FlightsPlacardResponse";
  placards?: Maybe<Array<FlightsUiPlacard>>;
};

/** Represents a type of placards the client can request for */
export type FlightsPlacardType =
  /** Represents the placard of type free cancellation */
  | "FREE_CANCELLATION"
  /** Represents the placard of type hotel attach */
  | "HOTEL_ATTACH"
  /** Represents the placard of type loyalty reward */
  | "LOYALTY_REWARD"
  /** Represents the placard of type no change fees */
  | "NO_CHANGE_FEES"
  /** Represents the placard of type passport */
  | "PASSPORT"
  /** Represents the placard of type price change */
  | "PRICE_CHANGE"
  /** Represents the placard of type split ticket */
  | "SPLIT_TICKET";

/** Represents the value associated with preferred airline filter */
export type FlightsPreferredAirlineFilterValue = {
  __typename?: "FlightsPreferredAirlineFilterValue";
  carrierCode: Scalars["String"];
};

/** Represents the value associated with preferred airline filter */
export interface FlightsPreferredAirlineFilterValueInput {
  carrierCode: Scalars["String"];
}

/** Represents the listing displayed showing the price context module */
export type FlightsPriceAlertsListing = {
  __typename?: "FlightsPriceAlertsListing";
  /** Represents the messaging card / placard */
  priceAlerts: FlightsIconPlacard;
};

/** Represents the Price Alerts component */
export type FlightsPriceAlertsOptInResponse = {
  __typename?: "FlightsPriceAlertsOptInResponse";
  /** Represents the updated optInStatus. Used to reconcile UI in case of a failure to update status */
  optInStatus: Scalars["Boolean"];
  /** Represents the result of opting the user in/out of price alerts. Example: 'You are now tracking prices' */
  toast: EgdsToast;
};

/** Represents the Flight Price Summary */
export interface FlightsPriceSummary {
  /** Represents the button action. Example: GO_TO_CHECKOUT */
  buttonAction: FlightsAction;
  /** Represents the title. Example: 'Price Summary' */
  title: Scalars["String"];
  /** Represents the trip total label for mobile, Example: Trip Total */
  tripTotalLabel: Scalars["String"];
}

/** Represents the price summary per traveler */
export type FlightsPriceSummaryGroup = {
  __typename?: "FlightsPriceSummaryGroup";
  /** Represents the label and price accessibility. Example: 'Traveler 1: Adult <price>' */
  accessibilityMessage?: Maybe<Scalars["String"]>;
  /** Represents price breakdown per traveler. Example: 'Taxes and Fees  $999' */
  entries: Array<FlightsPriceSummaryItem>;
  /** Represents the title information. Example: 'Traveler 1: Adult  $999' */
  title?: Maybe<FlightsPriceSummaryItem>;
};

/** Represents label and price for price summary item */
export type FlightsPriceSummaryItem = {
  __typename?: "FlightsPriceSummaryItem";
  /** Represents detailed information about the summary item. If present, overrides label with action text. */
  details?: Maybe<FlightsPriceSummaryItemDetails>;
  /** Represents the label for charge type. Example: Taxes and fees */
  label: Scalars["String"];
  /** Represents the loyalty/reward price for charge type. Example: 50,000 pts */
  loyaltyPoints?: Maybe<Scalars["String"]>;
  /** Represents the price for charge type. Example: $999.0 */
  price: Scalars["String"];
  /** Represents the rounded price for charge type. Example: $999 */
  roundedPrice?: Maybe<Scalars["String"]>;
  /** Represents the font styles of label and price field. Example: 'IMPORTANT for bold' */
  styles?: Maybe<Array<FlightsPhrasePartStyle>>;
};

/** Represents detailed information about the summary item, and its load action button */
export type FlightsPriceSummaryItemDetails = {
  __typename?: "FlightsPriceSummaryItemDetails";
  /** Represents the action icon for loading details of the item. Example: 'Taxes and Fees' for tax breakdown */
  action: FlightsActionableIcon;
  /** Represents the details of the price summary item */
  breakdown: FlightsPriceSummaryItemGroup;
};

/** Represents the error message and it's analytics, when breakdown is not available */
export type FlightsPriceSummaryItemError = {
  __typename?: "FlightsPriceSummaryItemError";
  /** Represents the analytics to track on interaction with trigger */
  analytics: FlightsAnalytics;
  /** Represents the error message, Example: 'Breakdown not available' */
  message: Scalars["String"];
};

/** Represents the details of the price summary item */
export type FlightsPriceSummaryItemGroup = {
  __typename?: "FlightsPriceSummaryItemGroup";
  /** Represents the 'Close' icon which dismisses the dialog */
  action: FlightsAction;
  /** Represents price breakdown for the price summary item. Example: `K3 - Goods and Services Tax` */
  entries: Array<FlightsPriceSummaryItem>;
  /** Represents the error message and it's analytics when breakdown is not available */
  error?: Maybe<FlightsPriceSummaryItemError>;
  /** Represents the title, Example: A breakdown of taxes, fees and charges */
  title: Scalars["String"];
};

/** Represents the payment item payment breakdown. Example 'Pay Now $999' */
export type FlightsPriceSummaryPaymentItem = {
  __typename?: "FlightsPriceSummaryPaymentItem";
  /** Represents the list of messages below the payment Item. */
  messages?: Maybe<Array<FlightsPhrase>>;
  /** Represents the payment Items label and price details. */
  title: FlightsPriceSummaryItem;
};

/** Represents the trip total details */
export type FlightsPriceSummaryTripTotalItem = {
  __typename?: "FlightsPriceSummaryTripTotalItem";
  /** Represents the Ancillary Includes add on Text. Example: 'including add-ons' */
  ancillaryIncludesText?: Maybe<Scalars["String"]>;
  /** Represents the list of messages below the trip total. Example: Agent fee Message, Currency Conversion Messages etc */
  messages?: Maybe<Array<FlightsTextSection>>;
  /** Represents the list of payment breakdown of the trip total amount. */
  paymentBreakdown?: Maybe<Array<FlightsPriceSummaryPaymentItem>>;
  /**
   * Represents the currency message below the trip total. Example: 'Rates are quoted in US dollars'
   * @deprecated This will be replaced by ratesCurrencyText
   */
  ratesCurrencyMessage: Scalars["String"];
  /** Represents the currency message below the trip total, can be nullable if we have currency conversion. Example: 'Rates are quoted in US dollars' */
  ratesCurrencyText?: Maybe<Scalars["String"]>;
  /** Represents the trip total label and price. Example: 'Trip Total  $9999'  */
  tripTotal: FlightsPriceSummaryItem;
};

/** Represents a set of information that relates to the price on an offer */
export type FlightsPricingInformation = {
  __typename?: "FlightsPricingInformation";
  /** Represents a message to denote that the offer is cancellable without penalty within a certain period of time. Ex: Free Cancel w/in 24 hrs */
  cancellationMessage?: Maybe<Scalars["String"]>;
  /** Represents a message for displaying loyalty mark and points on an offer */
  loyaltyEarnMessage?: Maybe<FlightsMarkAndLabel>;
  /**
   * Represents a message for displaying loyalty branding and points on an offer
   * @deprecated this is replaced by loyaltyEarnMessage
   */
  loyaltyMessage?: Maybe<FlightsImageAndLabel>;
  /** Represents Loyalty points option for points display on burn POS */
  loyaltyPointsOption?: Maybe<FlightsLoyaltyPointsOption>;
  /** Represents the main price shown on flight cards. Could be either total price in case of OWs or delta price in case of RT/MD */
  mainPrice: FlightsPhrase;
  /** Represents a message for displaying loyalty mark and points on an offer for partners */
  partnerLoyaltyEarnMessage?: Maybe<FlightsMarkAndLabel>;
  /**
   * Represents the price of an offer or a message on how to get the price. Ex: $999, select to price, 4 left at $99
   * @deprecated Being replaced with mainPrice to denote the main price shown on flight cards
   */
  price: FlightsPhrase;
  /** Represents the price lockup component */
  priceLockup: EgdsPriceLockup;
  /** Represents a phrase to display the offer's price for each traveler */
  pricePerTraveler: FlightsPhrase;
  /** Represents the sub price shown on flight cards. Could be either null in case of OWs or total price in case of RT/MD */
  subPrice?: Maybe<FlightsPhrase>;
  /** The text will be shown under the price lock up */
  subText?: Maybe<Array<Scalars["String"]>>;
  /** List of subtexts to show below the price lockup. Example: 'Credit applied' */
  subTexts?: Maybe<Array<EgdsText>>;
  /** Represents a label to denote that the offer contains taxes and fees */
  taxesLabel?: Maybe<Scalars["String"]>;
  /** Represents a label for the total price of an offer */
  totalLabel: Scalars["String"];
  /** Represents a phrase to display the offer's price for all travelers total */
  totalPriceForAllTravelers?: Maybe<FlightsPhrase>;
  /**
   * Represents the type of trip that belongs to the offer. Ex: roundtrip, oneway, multi-city
   * @deprecated Being replaced by subText
   */
  tripType?: Maybe<Scalars["String"]>;
};

/** Represents the details for the progress bar when the results are loading. */
export type FlightsProgressBarDetails = {
  __typename?: "FlightsProgressBarDetails";
  /**
   * Represents the message for accessibility for amount of results are loaded in percent. Example : '40 percent loaded'
   * @deprecated We don't need it now since we have created the accessibilityMessage
   */
  accessibility: FlightsSimpleLocalizationTemplate;
  /** Represents the accessibility message for the listings loading bar */
  accessibilityMessage?: Maybe<Scalars["String"]>;
  /** Represents the value in milliseconds for normal listings response result. */
  listingsLatency: Scalars["Int"];
  /** Represents the value in milliseconds for sort and filter listings response result. */
  sortAndFilterLatency: Scalars["Int"];
};

/** Represents the display of progress bar when the results are loading */
export type FlightsProgressBarDisplay = "DISABLED" | "ENABLED";

/** Represents the state the client wants to query */
export type FlightsQueryState = "LOADED" | "LOADING";

/** Action to redirect to a link when is small breakpoint and show a dialogs in large. */
export type FlightsRedirectOrDialog = FlightsClientAction & {
  __typename?: "FlightsRedirectOrDialog";
  /** Used to provide accessibility that has to be read on completion of action */
  accessibility?: Maybe<Scalars["String"]>;
  /** Used to capture client side analytics */
  analyticsList: Array<ClientSideAnalytics>;
  /** The dialog to be triggered. */
  dialogId: Scalars["String"];
  /** The URI to redirect to. */
  nextPage: Uri;
};

/** Represents an action to refresh the page/view */
export type FlightsRefreshAction = FlightsClientAction & {
  __typename?: "FlightsRefreshAction";
  /** Used to provide accessibility that has to be read on completion of action. */
  accessibility?: Maybe<Scalars["String"]>;
  /** Used to capture client side analytics */
  analyticsList: Array<ClientSideAnalytics>;
};

/** Used to represent the action of removing Price Match Promise on FIS */
export type FlightsRemovePriceMatchPromiseAction = FlightsClientAction & {
  __typename?: "FlightsRemovePriceMatchPromiseAction";
  /** Used to provide accessibility that has to be read on completion of action. */
  accessibility?: Maybe<Scalars["String"]>;
  /** Used to capture client side analytics */
  analyticsList: Array<ClientSideAnalytics>;
  /** Used for the offer JCID without PMP */
  journeyContinuationId: Scalars["String"];
};

/** Represents an action to link to a new resource URI */
export type FlightsResourceLinkAction = FlightsClientAction & {
  __typename?: "FlightsResourceLinkAction";
  /** Used to provide accessibility that has to be read on completion of action. */
  accessibility?: Maybe<Scalars["String"]>;
  /** Used to capture client side analytics */
  analyticsList: Array<ClientSideAnalytics>;
  /** Used to link to a new resource URI */
  resource: Uri;
  /** target of the link */
  target: FlightsLinkTarget;
};

/** Represents an action to redirect to a new resource URI */
export type FlightsResourceRedirectAction = FlightsClientAction & {
  __typename?: "FlightsResourceRedirectAction";
  /** Used to provide accessibility that has to be read on completion of action. */
  accessibility?: Maybe<Scalars["String"]>;
  /** Used to capture client side analytics */
  analyticsList: Array<ClientSideAnalytics>;
  /** Used to redirect to a new resource URI */
  resource: Uri;
};

/** Metrics associated with the response */
export type FlightsResponseTimeMetrics = {
  __typename?: "FlightsResponseTimeMetrics";
  name: FlightsMetricName;
  value: Scalars["String"];
};

/** Represents a accessibility message which is responsive and changes based on display size */
export type FlightsResponsiveAccessibilityMessage = {
  __typename?: "FlightsResponsiveAccessibilityMessage";
  /** Represents the accessibility message to be called out on large screen factors */
  longMessage?: Maybe<Scalars["String"]>;
  /** Represents the accessibility message to be called out on small screen factors */
  shortMessage?: Maybe<Scalars["String"]>;
};

/** Describes the icon according the view */
export type FlightsResponsiveIcon = {
  __typename?: "FlightsResponsiveIcon";
  /** Represents the icon for the large view. Example: Desktop */
  largeView: Icon;
  /** Represents the icon for the small view. Example: Mobile */
  smallView: Icon;
};

/** Represents a message which is responsive and changes based on display size */
export type FlightsResponsiveMessage = {
  __typename?: "FlightsResponsiveMessage";
  /** Represents the message to be displayed on large screen factors */
  longMessage: Scalars["String"];
  /** Represents the message to be displayed on small screen factors */
  shortMessage?: Maybe<Scalars["String"]>;
};

/** Represents any rules or restrictions for a basic economy flight */
export type FlightsRestrictiveFareRules = {
  __typename?: "FlightsRestrictiveFareRules";
  /** Represents the display text used to dismiss the modal */
  dismissLabel: Scalars["String"];
  /** Represents the text and icon of an actionable element that displays the rules */
  displayAction: FlightsIconAndPhrase;
  /** Represents a list of rules displayed on the modal */
  rules: Array<Scalars["String"]>;
  /** Represents the title displayed on the modal */
  title: Scalars["String"];
};

/** Represents the support phone number servicing view */
export type FlightsReviewAndBook = {
  __typename?: "FlightsReviewAndBook";
  /** Represents the heading for the phone modal (ie: Review and book */
  heading: EgdsHeading;
  /** Represents support number string (ie: Book online or call 1-800-342-8257) */
  message?: Maybe<EgdsPlainText>;
};

/** Represents all the information required for the loading state when we are going from FSR to FIS on mobile view */
export type FlightsReviewLoadingElements = {
  __typename?: "FlightsReviewLoadingElements";
  /** Represents the client metadata. */
  clientMetaData: FlightsPwaMetadata;
  /** Represents the information in multiple journey review blocks common for all offers */
  flightsJourneyReviewCommon: Array<FlightsJourneyReviewCommon>;
  /** Represents the free cancellation banner. */
  freeCancellation: FlightsPlacard;
  /** Represents the title of the page. */
  pageTitle: FlightsPageTitle;
  /** Represents the price summary node in  case of loading state */
  priceSummary: FlightsLoadingPriceSummary;
};

/** Represents each rewards option shown to the user as part of rewards pricing info */
export type FlightsRewardsOption = {
  __typename?: "FlightsRewardsOption";
  /** Represents the accessibility message for the option */
  accessibility?: Maybe<FlightsAccessibilityMessage>;
  /**
   * Represents the identifier for the particular option item
   * @deprecated This field will be replaced by identifier
   */
  id: FlightsRewardsOptionId;
  /** Represents the identifier for the particular option item */
  identifier: RewardsOption;
  /** Represents the label for the option. Ex Fixed Points Pricing or Flexible Points Pricing */
  label: Scalars["String"];
  /** Boolean which represents whether the option is selected or not */
  selected: Scalars["Boolean"];
};

/** Enum class to represent the id associated with the rewards option */
export type FlightsRewardsOptionId = "ALTAIR" | "AVION" | "NONAVION";

/** Represents the info and/or choice of pricing options for fares */
export type FlightsRewardsPricingInfo = {
  __typename?: "FlightsRewardsPricingInfo";
  /** Loyalty reward banners associated with points pricing */
  loyaltyBanners?: Maybe<Array<FlightsPlacard>>;
  /**
   * MessagingCards/Banners associated with LoyaltyPoints
   * @deprecated Using stale version of components not used on UI, replace with loyaltyBanners
   */
  loyaltyMessagingCards?: Maybe<Array<FlightsMessagingCardPlacard>>;
  /** Rewards option choices shown to the user in radio buttons. Example: 'RBC Fixed pricing or Flex Pricing' */
  options?: Maybe<Array<FlightsRewardsOption>>;
  /** Subtext shown based on the pricing selection. */
  subText: Array<FlightsPhrase>;
  /** Rewards pricing title. Example: 'Avion Rewards Flexible Points Pricing' or 'Pricing options' */
  title: FlightsResponsiveMessage;
};

export interface FlightsSearchComponentCriteriaInput {
  /** Represents Unresolved list of params for meta. Like MDPCID, etc. */
  queryParams?: InputMaybe<Array<GraphQlPairInput>>;
}

/** Context for flights search */
export type FlightsSearchContext = {
  __typename?: "FlightsSearchContext";
  /** Represent the continuation identifier for spinner to deduce which all journeys have been selected. Null value represents the request is for first journey. */
  journeysContinuationId?: Maybe<Scalars["String"]>;
  /** Represents the identifier for the spinner to deduce which all credits have been selected by the user */
  originalBookingId?: Maybe<Scalars["String"]>;
  /** Represents the flights user selected for each segment when the user proceeded to FIS.This node will be populated on the search response only if customer is returning to FSR from FIS. */
  previousFlightSelections?: Maybe<Array<JourneyFlightSelection>>;
  /** Represents the previously selected credit's originalBookingId to correctly render the toast when credits are changed */
  previousOriginalBookingId?: Maybe<Scalars["String"]>;
  /** Represents the mismatched search criteria between the current search and servicing need */
  searchCriteriaMismatch?: Maybe<Array<FlightsSearchCriteriaMismatch>>;
  /** Trip type in search */
  tripType: FlightsTripType;
};

/** Context for flights search */
export interface FlightsSearchContextInput {
  /** Represent the continuation identifier for spinner to deduce which all journeys have been selected. Null value represents the request is for first journey. */
  journeysContinuationId?: InputMaybe<Scalars["String"]>;
  /** Represents the identifier for the spinner to deduce which all credits have been selected by the user */
  originalBookingId?: InputMaybe<Scalars["String"]>;
  /** Represents the flights user selected for each segment when the user proceeded to FIS.This node will be populated on the search response only if customer is returning to FSR from FIS. */
  previousFlightSelections?: InputMaybe<Array<JourneyFlightSelectionInput>>;
  /** Represents the previously selected credit's originalBookingId to correctly render the toast when credits are changed */
  previousOriginalBookingId?: InputMaybe<Scalars["String"]>;
  /** Represents the mismatched search criteria between the current search and servicing need */
  searchCriteriaMismatch?: InputMaybe<Array<FlightsSearchCriteriaMismatch>>;
  /** Trip type in search */
  tripType: FlightsTripType;
}

/** Used to represent an action to change search criteria */
export type FlightsSearchCriteriaChangeAction = FlightsClientAction & {
  __typename?: "FlightsSearchCriteriaChangeAction";
  /** Used to provide accessibility that has to be read on completion of action */
  accessibility?: Maybe<Scalars["String"]>;
  /** Used to capture client side analytics */
  analyticsList: Array<ClientSideAnalytics>;
  /** Represents the search criteria and search preferences of user */
  searchCriteria?: Maybe<FlightsJourneySearchCriteria>;
};

/** Represents the mismatched criterion between the current search and servicing need */
export type FlightsSearchCriteriaMismatch = "TRAVELER";

/** Represents the section for displaying the benefits of an offer when packaged with a hotel. */
export type FlightsSearchCrossSellOfferSavings = {
  __typename?: "FlightsSearchCrossSellOfferSavings";
  /** Represents a more in-depth description of what is included when packaging the offer with a hotel. Ex: Expedia found you big savings by... */
  description: Scalars["String"];
  /** Represents the analytics to track on interaction with the description trigger to dismiss the message */
  dismissAnalytics: FlightsAnalytics;
  /** Represents the text to dismiss the description. Ex: Got it */
  dismissLabel: Scalars["String"];
  /** Represents the analytics to track on interaction with the tagline trigger */
  displayAnalytics: FlightsAnalytics;
  /** Represents a tagline to grab a user's attention. Ex: Book this flight with a hotel, get 100% off your flight */
  tagline: Scalars["String"];
};

/** Represents an element of the list which the client needs to send back to the server as part of the request. This will be part of each FilterItem so client need not apply any logic on filter selection but simply add this to the next request */
export type FlightsSearchFilterValues = {
  __typename?: "FlightsSearchFilterValues";
  /** Represents the value associated with arrival airport filter. */
  arrivalAirportCodeFilterValue?: Maybe<FlightsAirportCodeFilterValue>;
  /** Represents the FilterValue object corresponding to the Arrival Time filter. */
  arrivalTimeFilterValue?: Maybe<FlightsTimeBasedFilterValue>;
  /** Represents the value associated with travel and baggage filter - carry on bag. */
  carryOnBagBasedFilterValue?: Maybe<FlightsCarryOnBagBasedFilterValue>;
  /** Represents the value associated with travel and baggage filter - checked bag. */
  checkedBagBasedFilterValue?: Maybe<FlightsCheckedBagBasedFilterValue>;
  /** Represents the value associated with credit eligible filter */
  creditEligibleFilterValue?: Maybe<FlightsCreditEligibleFilterValue>;
  /** Represents the value associated with departure airport filter. */
  departureAirportCodeFilterValue?: Maybe<FlightsAirportCodeFilterValue>;
  /** Represents the FilterValue object corresponding to the Departure Time filter. */
  departureTimeFilterValue?: Maybe<FlightsTimeBasedFilterValue>;
  /** Represents the FilterValue object corresponding to the Duration filter. */
  durationFilterValue?: Maybe<FlightsDurationBasedFilterValue>;
  /** Represents the value associated with flexible change policies filter. */
  flexibleChangePolicyBasedFilterValue?: Maybe<FlightsFlexibleChangePolicyBasedFilterValue>;
  /** Represents the value associated with travel and baggage filter - no cancel fee. */
  noCancelFeeBasedFilterValue?: Maybe<FlightsNoCancelFeeBasedFilterValue>;
  /**
   * Represents the value associated with travel and baggage filter - no change fee.
   * @deprecated Depercated in favour of FlightsFilterType
   */
  noChangeFeeBasedFilterValue?: Maybe<FlightsNoChangeFeeBasedFilterValue>;
  /** Represents the FilterValue object corresponding to the Number of stops filter. */
  numOfStopFilterValue?: Maybe<FlightsStopBasedFilterValue>;
  /** Represents the FilterValue object corresponding to the Preferred Airline filter. */
  preferredAirlineFilterValue?: Maybe<FlightsPreferredAirlineFilterValue>;
  /** Represents the value associated with travel and baggage filter - seat choice. */
  seatChoiceBasedFilterValue?: Maybe<FlightsSeatChoiceBasedFilterValue>;
  /**
   * Represents the value associated with travel and baggage filter.
   * @deprecated Deprecating travelAndBaggageBasedFilterValue to introduce values in separated fields
   */
  travelAndBaggageBasedFilterValue?: Maybe<FlightsTravelAndBaggageBasedFilterValue>;
};

/** Represents an element of the list which the client needs to send back to the server as part of the request. This will be part of each FilterItem so client need not apply any logic on filter selection but simply add this to the next request */
export interface FlightsSearchFilterValuesInput {
  /** Represents the value associated with arrival airport filter. */
  arrivalAirportCodeFilterValue?: InputMaybe<FlightsAirportCodeFilterValueInput>;
  /** Represents the FilterValue object corresponding to the Arrival Time filter. */
  arrivalTimeFilterValue?: InputMaybe<FlightsTimeBasedFilterValueInput>;
  /** Represents the value associated with travel and baggage filter - carry on bag. */
  carryOnBagBasedFilterValue?: InputMaybe<FlightsCarryOnBagBasedFilterValueInput>;
  /** Represents the value associated with travel and baggage filter - checked bag. */
  checkedBagBasedFilterValue?: InputMaybe<FlightsCheckedBagBasedFilterValueInput>;
  /** Represents the value associated with credit eligible filter */
  creditEligibleFilterValue?: InputMaybe<FlightsCreditEligibleFilterValueInput>;
  /** Represents the value associated with departure airport filter. */
  departureAirportCodeFilterValue?: InputMaybe<FlightsAirportCodeFilterValueInput>;
  /** Represents the FilterValue object corresponding to the Departure Time filter. */
  departureTimeFilterValue?: InputMaybe<FlightsTimeBasedFilterValueInput>;
  /** Represents the FilterValue object corresponding to the Duration filter. */
  durationFilterValue?: InputMaybe<FlightsDurationBasedFilterValueInput>;
  /** Represents the value associated with flexible change policies filter. */
  flexibleChangePolicyBasedFilterValue?: InputMaybe<FlightsFlexibleChangePolicyBasedFilterValueInput>;
  /** Represents the value associated with travel and baggage filter - no cancel fee. */
  noCancelFeeBasedFilterValue?: InputMaybe<FlightsNoCancelFeeBasedFilterValueInput>;
  /** Represents the value associated with travel and baggage filter - no change fee. */
  noChangeFeeBasedFilterValue?: InputMaybe<FlightsNoChangeFeeBasedFilterValueInput>;
  /** Represents the FilterValue object corresponding to the Number of stops filter. */
  numOfStopFilterValue?: InputMaybe<FlightsStopBasedFilterValueInput>;
  /** Represents the FilterValue object corresponding to the Preferred Airline filter. */
  preferredAirlineFilterValue?: InputMaybe<FlightsPreferredAirlineFilterValueInput>;
  /** Represents the value associated with travel and baggage filter - seat choice. */
  seatChoiceBasedFilterValue?: InputMaybe<FlightsSeatChoiceBasedFilterValueInput>;
  /** Represents the value associated with travel and baggage filter. */
  travelAndBaggageBasedFilterValue?: InputMaybe<FlightsTravelAndBaggageBasedFilterValueInput>;
}

export interface FlightsSearchForm {
  /** Represents the accessibility message when search button is clicked */
  accessibilityMessage?: Maybe<Scalars["String"]>;
  addJourneyAction?: Maybe<FlightsAction>;
  /** Represents whether airport dropdown is enabled or not */
  airportDropdownEnabled?: Maybe<Scalars["Boolean"]>;
  /** Count of the currently applied filter */
  appliedFilterCount?: Maybe<Scalars["Int"]>;
  /** Available flight routes for search */
  availableRoutes?: Maybe<AvailableRoutes>;
  /** Represents the accessibility message when close button is clicked */
  closeActionAccessibility?: Maybe<Scalars["String"]>;
  /** Represents the close search form button text */
  closeFormAction?: Maybe<FlightsAction>;
  /** Represents the analytics to track on collapse interaction */
  collapseFormAnalytics: FlightsAnalytics;
  /** Represents the accessibility message for OD Pair, Date and Traveler. */
  collapsedFormAccessibility?: Maybe<FlightsResponsiveAccessibilityMessage>;
  /** Represents the departure and return dates. Example: 'Jan 23 - Feb 13' */
  departureAndReturnDates?: Maybe<FlightsResponsiveMessage>;
  /** Represents the error message displayed for a search form error state */
  errorSummary: FlightsErrorSummary;
  /** Icon and label that opens the filter display */
  expandFilterAction: FlightsIconAndLabel;
  /** Represents the analytics to track on expand interaction */
  expandFormAnalytics: FlightsAnalytics;
  /** Icon that opens the search form */
  expandSearchFormAction: Icon;
  journeys: Array<FlightsSearchFormJourneyCriteria>;
  /**
   * Represents whether multi destination is enabled or not
   * @deprecated This field is now deprecated
   */
  mDestEnabled?: Maybe<Scalars["Boolean"]>;
  /** Represents the template for a new, empty journey criteria */
  newJourneyTemplate: FlightsSearchFormJourneyCriteria;
  /** Represents the origin and destination. Example: 'Seattle to San Francisco' */
  originAndDestinationLocations?: Maybe<Scalars["String"]>;
  /** Represents the search button text */
  searchAction?: Maybe<Scalars["String"]>;
  /** Represents the accessibility message for Search Button */
  searchActionAccessibility?: Maybe<Scalars["String"]>;
  /** Represents whether the  search button is active */
  searchActionActive: Scalars["Boolean"];
  searchOptions: Array<FlightsSearchFormOption>;
  /** Represents the total number of travelers with a token to be replaced with the actual number.. Example: '{numberOfTravelers} travelers' */
  travelersSummary: FlightsMultiPluralLocalizationTemplate;
}

/** Represents the preferred airline form field */
export type FlightsSearchFormAirlineOption = FlightsSearchFormOption & {
  __typename?: "FlightsSearchFormAirlineOption";
  /** Represents the analytics to track on done clicked of the preferred airline section */
  applyAnalytics: FlightsAnalytics;
  /** Represents the analytics to track on cancel of the preferred airline section */
  cancelAnalytics: FlightsAnalytics;
  /** Close icon for mobile breakpoint with accessibility */
  closeIcon?: Maybe<FlightsIconAndAccessibility>;
  /** Done/Complete Action when you open Preferred Airline options */
  doneAction: Scalars["String"];
  /** Done/Complete Action accessibility text */
  doneActionAccessibility?: Maybe<Scalars["String"]>;
  /** Icon to the left of the field when in mobile breakpoint */
  fieldIcon: Icon;
  icon: Icon;
  items: Array<FlightsSearchFormAirlineOptionItem>;
  label: Scalars["String"];
  labelAccessibility?: Maybe<Scalars["String"]>;
  /** Represents the analytics to track on open of the preferred airline section */
  openAnalytics: FlightsAnalytics;
  /** Represents selected Item */
  selectedItem: FlightsSearchFormAirlineOptionItem;
};

/** Represents an airline preference */
export type FlightsSearchFormAirlineOptionItem = {
  __typename?: "FlightsSearchFormAirlineOptionItem";
  /** Represents an airline code. Example: 'AA' */
  airline: Scalars["String"];
  /** Represents the analytics to track on select of an airline */
  airlineSelectedAnalytics: FlightsAnalytics;
  label: Scalars["String"];
  /** Indicates if this preference is currently selected */
  selected: Scalars["Boolean"];
};

/** Represents the cabin class form field */
export type FlightsSearchFormCabinClassOption = FlightsSearchFormOption & {
  __typename?: "FlightsSearchFormCabinClassOption";
  /** Icon to the left of the field when in mobile breakpoint */
  fieldIcon: Icon;
  icon: Icon;
  items: Array<FlightsSearchFormCabinClassOptionItem>;
  label: Scalars["String"];
  labelAccessibility?: Maybe<Scalars["String"]>;
  /** Represents the analytics to track on open of the cabin class section */
  openAnalytics: FlightsAnalytics;
  /** Represents selected Item */
  selectedItem: FlightsSearchFormCabinClassOptionItem;
};

/** Represents a cabin class preference */
export type FlightsSearchFormCabinClassOptionItem = {
  __typename?: "FlightsSearchFormCabinClassOptionItem";
  /** Represents the cabin class */
  cabinClass: FlightsCabinClass;
  /** Represents the analytics to track on select of a cabin class */
  cabinClassSelectedAnalytics: FlightsAnalytics;
  label: Scalars["String"];
  /** Indicates if this preference is currently selected */
  selected: Scalars["Boolean"];
};

/** Represents a date field */
export type FlightsSearchFormDateField = {
  __typename?: "FlightsSearchFormDateField";
  /** Represents the accessibility for the label. Example: 'Trip {tripNumber} departure date' */
  accessibility?: Maybe<FlightsMultiPluralLocalizationTemplate>;
  /** Represents the analytics to track on date changed interaction */
  analytics: FlightsAnalytics;
  /** When there's an error with the existing value of this field this field represents the error message.Example 'We can only accept dates that occur between 7/22/2019 and 6/16/2020' */
  currentError?: Maybe<Scalars["String"]>;
  /** Field date */
  date?: Maybe<Date>;
  /** Date format */
  dateFormat: Scalars["String"];
  /** Represents how far into the datepicker we can select. Example: 330 */
  daysBookableInAdvance: Scalars["Int"];
  /** Text for done button. */
  doneAction: Scalars["String"];
  /** Represents the analytics to track on date click event interaction */
  handleClickAnalytics: FlightsAnalytics;
  /** Field label. Example 'Departing' */
  label: Scalars["String"];
  /** Specifies the maximum length/duration of stay allowed */
  maxStayDurationAllowed?: Maybe<Scalars["Int"]>;
  /** Field placeholder. Example 'Departing' */
  placeholder: Scalars["String"];
  /** Represents a list of all possible errors that this field can throw. Should be implemented on the client side */
  possibleErrors: Array<FlightsSearchFormError>;
  /** Represents a header for possible errors. Example 'Please correct these errors' */
  possibleErrorsHeader?: Maybe<FlightsIconAndPhrase>;
};

/** Represents a possible field error */
export type FlightsSearchFormError = {
  __typename?: "FlightsSearchFormError";
  /** Represents the analytics to track on display of a particular error caused by invalid input */
  analytics: FlightsAnalytics;
  /** Represents the message to be shown to the user */
  message: Scalars["String"];
  /** Describes a type of error */
  type: FlightsSearchFormErrorType;
};

export type FlightsSearchFormErrorType =
  /** Age of child is missing */
  | "CHILD_AGE_MISSING"
  /** Date before previous date - Multi-dest */
  | "DATE_BEFORE_PREVIOUS_DATE"
  /** Date must be between a range */
  | "DATE_NOT_IN_VALID_RANGE"
  /** Dates must be greater than or equal to default date/checkin date. */
  | "DATE_NOT_IN_VALID_RANGE_TO_DEFAULT_DATE"
  /** Age of infant is missing */
  | "INFANT_AGE_MISSING"
  /** Date must be in the correct format */
  | "INVALID_DATE_FORMAT"
  /** Total traveler count must be equal or lower than max */
  | "INVALID_TRAVELER_COUNT"
  /** At least 1 traveler required in a booking */
  | "LESS_THAN_MINIMUM_ADULT"
  /** Location must not be blank */
  | "LOCATION_EMPTY"
  /** Origin and destination location must not be the same */
  | "LOCATION_SAME"
  /** Dates must be no more than 26 days apart */
  | "MAX_STAY_DURATION_ERROR"
  /** Origin and Destination city cannot be same */
  | "SAME_CITY"
  /** Special characters are not allowed */
  | "SPECIAL_CHARACTER_NOT_ALLOWED"
  /** Enter at least 3 characters of the airport name */
  | "TOO_SHORT_AIRPORT_STRING"
  /** Number of infant in lap must be equal or lower than number of adults */
  | "UNATTENDED_INFANT_IN_LAP"
  /** There can't be more than 2 infants per traveler (age 12+) in a booking */
  | "UNATTENDED_INFANT_IN_SEAT";

/** The set of journey criteria fields */
export type FlightsSearchFormJourneyCriteria = {
  __typename?: "FlightsSearchFormJourneyCriteria";
  /** Localized text template for accessibility depending upon the trip type.Example: 'Trip {tripNumber} search details' */
  accessibility?: Maybe<FlightsMultiPluralLocalizationTemplate>;
  /** The departure date field */
  departureDate: FlightsSearchFormDateField;
  /** The destination location field */
  destinationLocation: FlightsSearchFormLocationField;
  /** Localized text template that indicates the journey number. Example 'Flight {flightNumber}' */
  label: FlightsSimpleLocalizationTemplate;
  /** The origin location field */
  originLocation: FlightsSearchFormLocationField;
  removeJourneyAction?: Maybe<FlightsAction>;
  /** The return date field */
  returnDate?: Maybe<FlightsSearchFormDateField>;
  /** The icon to swap the origin and destination fields. */
  swapLocationsAction: FlightsSwapLocationAction;
};

/** Represents a location field */
export type FlightsSearchFormLocationField = {
  __typename?: "FlightsSearchFormLocationField";
  /** Field accessibility for the location field. Example: 'Trip {tripNumber} departure airport' */
  accessibility?: Maybe<FlightsMultiPluralLocalizationTemplate>;
  /** TLA/Airport Code value for airport name. Example: 'SEA' */
  airportCode?: Maybe<Scalars["String"]>;
  /** Represents the analytics to track on location field change interaction */
  analytics: FlightsAnalytics;
  /** When there's an error with the existing value of this field this field represents the error message. Example 'Please use letters to search for airports' */
  currentError?: Maybe<Scalars["String"]>;
  /** Icon rendered inside the field */
  icon: Icon;
  /** Field label. Example: 'Flying from' */
  label: Scalars["String"];
  nearbyAirports?: Maybe<FlightsSearchFormNearbyAirportsPresentation>;
  /** Represents the analytics to track on the first type interaction in a typeahead component */
  onTypeAnalytics: FlightsAnalytics;
  /** Field placeholder. Example: 'Flying from' */
  placeholder: Scalars["String"];
  /** Represents a list of all possible errors that this field can throw. Should be implemented on the client side */
  possibleErrors: Array<FlightsSearchFormError>;
  /** Field value. Example: 'SEA - Seattle Tacoma Intl.' */
  value?: Maybe<Scalars["String"]>;
};

/** Represents the More filters form field */
export type FlightsSearchFormMoreFiltersOption = FlightsSearchFormOption & {
  __typename?: "FlightsSearchFormMoreFiltersOption";
  /** Done/Complete Action when you open more options */
  doneAction: Scalars["String"];
  icon: Icon;
  /** List of all more filters (Nonstop , Refundable */
  items: Array<FlightsSearchFormMoreFiltersOptionItem>;
  label: Scalars["String"];
  labelAccessibility?: Maybe<Scalars["String"]>;
  /** Represents the analytics to track on open of the more options section */
  openAnalytics: FlightsAnalytics;
};

/** Represents a list of more filters */
export type FlightsSearchFormMoreFiltersOptionItem = {
  __typename?: "FlightsSearchFormMoreFiltersOptionItem";
  /** Represents the analytics to track when remove an additional option */
  advancedFilterRemoveAnalytics: FlightsAnalytics;
  /** Represents the analytics to track on change of additional options */
  advancedFilterSelectedAnalytics: FlightsAnalytics;
  /** Represents the advance filter type */
  advancedFilterType: FlightsAdvancedFilterType;
  label: Scalars["String"];
  /** Indicates if this preference is currently selected */
  selected: Scalars["Boolean"];
};

/** Represents a nearby airport */
export type FlightsSearchFormNearbyAirportItem = {
  __typename?: "FlightsSearchFormNearbyAirportItem";
  /** Represents the nearby airport name that gets set on the locaiton field when selected. Example: 'Portland, OR (PDX-Portland Intl.)' */
  airportName: Scalars["String"];
  /** Represents the analytics to track on select of a particular nearby airport item */
  analytics: FlightsAnalytics;
  /** Represents the nearby airport name and distance from current location. Example: '129 mi - PDX (Portland)' */
  label: Scalars["String"];
};

/** Represents the nearby airports container */
export type FlightsSearchFormNearbyAirportsPresentation = {
  __typename?: "FlightsSearchFormNearbyAirportsPresentation";
  /** Represents the accessibility text for container.Example: 'Trip {tripNumber} nearby departure airports' */
  accessibility?: Maybe<FlightsMultiPluralLocalizationTemplate>;
  /** Represents the analytics to track on nearby airports link interaction */
  analytics: FlightsAnalytics;
  /** Text inside the actionable area that toggles the nearby airports container. Example: 'Nearby Airports' */
  displayAction: Scalars["String"];
  /** Header of the neary airports container that indicates the currently selected location. Example: 'SEA (Seattle)' */
  header?: Maybe<Scalars["String"]>;
  /** Represents a list of nearby airports */
  items?: Maybe<Array<FlightsSearchFormNearbyAirportItem>>;
};

/** Represents a search parameter */
export interface FlightsSearchFormOption {
  /** Chevron icon used to indicate that this is a list form field */
  icon: Icon;
  /** Describes the search parameter. Example: Preferred Airline, Preferred Class */
  label: Scalars["String"];
  /** Describes the accessibility message for search parameter. Example:'Route Type' */
  labelAccessibility?: Maybe<Scalars["String"]>;
  /** Represents the analytics to track on open of the more options section */
  openAnalytics: FlightsAnalytics;
}

/** Represents the items for traveler age */
export type FlightsSearchFormTravelerAgeOptionItem = {
  __typename?: "FlightsSearchFormTravelerAgeOptionItem";
  label: Scalars["String"];
  /** Indicates if this preference is currently selected */
  selected: Scalars["Boolean"];
  /** Represents an age */
  value: Scalars["Int"];
};

/** Represents a traveler Infants field */
export type FlightsSearchFormTravelerInfantOptionItem = FlightsSearchFormTravelerItem & {
  __typename?: "FlightsSearchFormTravelerInfantOptionItem";
  caption?: Maybe<Scalars["String"]>;
  currentError?: Maybe<Scalars["String"]>;
  /** Represents the accessibility message for decrease of traveler count */
  decreaseCountAccessibility?: Maybe<Scalars["String"]>;
  /** Represents the analytics to track on decrease of adult count */
  decreaseCountAnalytics: FlightsAnalytics;
  /** Represents the accessibility message for increase of traveler count */
  increaseCountAccessibility?: Maybe<Scalars["String"]>;
  /** Represents the analytics to track on increase of adult count */
  increaseCountAnalytics: FlightsAnalytics;
  /** Represents infants option */
  infantsOption: FlightsSearchFormTravelerInfantsOption;
  label: Scalars["String"];
  max: Scalars["Int"];
  minCount: Scalars["Int"];
  travelerAgeSelectorTemplate?: Maybe<FlightsTravelerAgeSelector>;
  travelerAges?: Maybe<Array<FlightsTravelerAgeSelector>>;
  travelerCount: Scalars["Int"];
  type: FlightsTravelerType;
};

export type FlightsSearchFormTravelerInfantsOption = {
  __typename?: "FlightsSearchFormTravelerInfantsOption";
  /** List of all possible search parameter options */
  items: Array<FlightsSearchFormTravelerInfantsSelection>;
  /** Describes the infants in seat and on lap limitation */
  label: Scalars["String"];
};

export type FlightsSearchFormTravelerInfantsSelection = {
  __typename?: "FlightsSearchFormTravelerInfantsSelection";
  /** Describes the search parameter. Example: 'In Seat', 'On Lap' */
  label: Scalars["String"];
  /** Indicates if this preference is currently selected */
  selected: Scalars["Boolean"];
  /** Describes what type of infant traveler this is */
  type: FlightsTravelerType;
};

/** Represents a traveler field */
export interface FlightsSearchFormTravelerItem {
  /** Subtext that adds more context to the field. Example: 'Ages 0 - 17' */
  caption?: Maybe<Scalars["String"]>;
  /** When there's an error with the existing value of this field this field represents the error message. Example 'Enter between 1 and 6 travelers for this trip.' */
  currentError?: Maybe<Scalars["String"]>;
  /** Represents the accessibility message for decrease of traveler count */
  decreaseCountAccessibility?: Maybe<Scalars["String"]>;
  /** Represents the analytics to track on decrease of traveler count */
  decreaseCountAnalytics: FlightsAnalytics;
  /** Represents the accessibility message for increase of traveler count */
  increaseCountAccessibility?: Maybe<Scalars["String"]>;
  /** Represents the analytics to track on increase of traveler count */
  increaseCountAnalytics: FlightsAnalytics;
  label: Scalars["String"];
  /** Maximum allowed number. Example: 6 */
  max: Scalars["Int"];
  /** Minimum required number. Example: 1 for adults */
  minCount: Scalars["Int"];
  /** The default age picker when a new traveler is added  */
  travelerAgeSelectorTemplate?: Maybe<FlightsTravelerAgeSelector>;
  /** The age picker returned by server to render the ages of already requested travelers  */
  travelerAges?: Maybe<Array<FlightsTravelerAgeSelector>>;
  /** Current value of the field */
  travelerCount: Scalars["Int"];
  /** Describes what type of traveler this is */
  type: FlightsTravelerType;
}

/** Represents the traveler form fields */
export type FlightsSearchFormTravelersOption = FlightsSearchFormOption & {
  __typename?: "FlightsSearchFormTravelersOption";
  /** Represents the number of adults selected when clicking on done in travelers section */
  adultSelectedAnalytics: FlightsAnalytics;
  /** Icon to the left of the field when in mobile breakpoint */
  ageRulesLink: FlightsLinkAction;
  /** Represents the analytics to track on done clicked of the travelers section */
  applyAnalytics: FlightsAnalytics;
  /** Represents Cancel Action when you open traveler options */
  cancelAction: Scalars["String"];
  /** Represents Cancel Action accessibility text */
  cancelActionAccessibility?: Maybe<Scalars["String"]>;
  /** Represents the analytics to track on cancel of the travelers section */
  cancelAnalytics: FlightsAnalytics;
  /** Represents the analytics to track on change for travelers count in travelers section */
  changeAnalytics: FlightsAnalytics;
  /** Represents the number of children selected when clicking on done in travelers section */
  childrenSelectedAnalytics: FlightsAnalytics;
  /** Close icon for mobile breakpoint with accessibility */
  closeIcon?: Maybe<FlightsIconAndAccessibility>;
  /** Represents current errors on this field */
  currentErrors?: Maybe<Array<Maybe<Scalars["String"]>>>;
  /** Done/Complete Action when you open traveler options */
  doneAction: Scalars["String"];
  /** Done/Complete Action accessibility text */
  doneActionAccessibility?: Maybe<Scalars["String"]>;
  /** Icon to the left of the field when in mobile breakpoint */
  fieldIcon: Icon;
  icon: Icon;
  /** Represents the lap placement for infants selected when clicking on done in travelers section */
  infantLapAnalytics: FlightsAnalytics;
  /** Represents the seat placement for infants selected when clicking on done in travelers section */
  infantSeatAnalytics: FlightsAnalytics;
  /** Represents the number of infant selected when clicking on done in travelers section */
  infantSelectedAnalytics: FlightsAnalytics;
  items: Array<FlightsSearchFormTravelerItem>;
  label: Scalars["String"];
  labelAccessibility?: Maybe<Scalars["String"]>;
  /** Represents the analytics to track on open of the travelers section */
  openAnalytics: FlightsAnalytics;
  /** Represents a list of all possible errors that this field can throw. Should be implemented on the client side */
  possibleErrors: Array<FlightsSearchFormError>;
  /** Represents the label for the maximum travelers allowed. */
  travelerLimitLabel: Scalars["String"];
  /** Represents the total number of travelers with a token to be replaced with the actual number.. Example: '{numberOfTravelers} travelers' */
  valueTemplate: FlightsMultiPluralLocalizationTemplate;
};

/** Represents a traveler field */
export type FlightsSearchFormTravelersOptionItem = FlightsSearchFormTravelerItem & {
  __typename?: "FlightsSearchFormTravelersOptionItem";
  caption?: Maybe<Scalars["String"]>;
  currentError?: Maybe<Scalars["String"]>;
  /** Represents the accessibility message for decrease of traveler count */
  decreaseCountAccessibility?: Maybe<Scalars["String"]>;
  decreaseCountAnalytics: FlightsAnalytics;
  /** Represents the accessibility message for increase of traveler count */
  increaseCountAccessibility?: Maybe<Scalars["String"]>;
  increaseCountAnalytics: FlightsAnalytics;
  label: Scalars["String"];
  max: Scalars["Int"];
  minCount: Scalars["Int"];
  travelerAgeSelectorTemplate?: Maybe<FlightsTravelerAgeSelector>;
  travelerAges?: Maybe<Array<FlightsTravelerAgeSelector>>;
  travelerCount: Scalars["Int"];
  type: FlightsTravelerType;
};

/** Represents the trip type form field */
export type FlightsSearchFormTripTypeOption = FlightsSearchFormOption & {
  __typename?: "FlightsSearchFormTripTypeOption";
  icon: Icon;
  /** List of all possible trip type options */
  items: Array<FlightsSearchFormTripTypeOptionItem>;
  label: Scalars["String"];
  labelAccessibility?: Maybe<Scalars["String"]>;
  /** Represents the analytics to track on open the trip type menu */
  openAnalytics: FlightsAnalytics;
};

/** Represents a trip type preference */
export type FlightsSearchFormTripTypeOptionItem = {
  __typename?: "FlightsSearchFormTripTypeOptionItem";
  label: Scalars["String"];
  /** Indicates if this preference is currently selected */
  selected: Scalars["Boolean"];
  /** Represents the trip type */
  tripType: FlightsTripType;
  /** Represents the analytics to track on select of a trip type */
  tripTypeSelectedAnalytics: FlightsAnalytics;
};

/** Primary flights criteria part of the search wizard that have an impact on the first results set.It's different from the side filter part of the secondary search criteria that are filtering on top of it. The side filter should be using a server driven approach. */
export type FlightsSearchPreferences = {
  __typename?: "FlightsSearchPreferences";
  /** Advanced filters like non-stop, refundable */
  advancedFilters?: Maybe<Array<FlightsAdvancedFilterType>>;
  airline?: Maybe<Scalars["String"]>;
  cabinClass: FlightsCabinClass;
};

/** Primary flights criteria part of the search wizard that have an impact on the first results set.It's different from the side filter part of the secondary search criteria that are filtering on top of it. The side filter should be using a server driven approach. */
export interface FlightsSearchPreferencesInput {
  /** Advanced filters like non-stop, refundable */
  advancedFilters?: InputMaybe<Array<FlightsAdvancedFilterType>>;
  airline?: InputMaybe<Scalars["String"]>;
  cabinClass: FlightsCabinClass;
}

export type FlightsSearchResponse = {
  __typename?: "FlightsSearchResponse";
  allBanners?: Maybe<Array<FlightsPlacard>>;
  availableFares?: Maybe<Array<FlightsJourneyAvailableFaresInformationElements>>;
  /** @deprecated This will be replaced by new node - allBanners */
  banners?: Maybe<Array<FlightsPlacard>>;
  cheapestListingInfo?: Maybe<FlightsCheapestListingInfo>;
  clientMetadata?: Maybe<FlightsClientMetadata>;
  crossSort?: Maybe<FlightsCrossSortPresentationResult>;
  dialogs?: Maybe<Array<FlightsDialogPresentation>>;
  failedRequestMessaging?: Maybe<FlightsActionableErrorMessaging>;
  flexibleSearchResponse?: Maybe<FlightsFlexibleSearchResponse>;
  flightsOpinionLab?: Maybe<FlightsActionAndLabel>;
  flightsReviewLoadingElements?: Maybe<FlightsReviewLoadingElements>;
  freePriceMatchPromise?: Maybe<FreePriceMatchPromise>;
  gaiaId?: Maybe<Scalars["String"]>;
  listingResult?: Maybe<FlightsListingResult>;
  listingsHeaderPlacards?: Maybe<Array<FlightsMessagingCardPlacard>>;
  noListingMessaging?: Maybe<FlightsErrorMessagingPresentation>;
  /** @deprecated This will be replaced by new Opinion Lab button at the bottom of the listings */
  opinionLab?: Maybe<FlightsOpinionLab>;
  pageTitle?: Maybe<FlightsPageTitle>;
  rewardsPricingInfo?: Maybe<FlightsRewardsPricingInfo>;
  searchForm?: Maybe<FlightsSearchForm>;
  selectedJourneyPresentations?: Maybe<Array<FlightsSelectedJourneyPresentation>>;
  shoppingContext?: Maybe<ShoppingContext>;
  sortAndFilterResult?: Maybe<FlightsSortAndFilterResult>;
  stepIndicator?: Maybe<FlightsStepIndicator>;
  universalSortAndFilterResult?: Maybe<ShoppingSortAndFilters>;
};

export type FlightsSearchResponseCheapestListingInfoArgs = {
  queryState?: InputMaybe<FlightsQueryState>;
};

export type FlightsSearchResponseClientMetadataArgs = {
  queryState?: InputMaybe<FlightsQueryState>;
};

export type FlightsSearchResponseFlightsOpinionLabArgs = {
  queryState?: InputMaybe<FlightsQueryState>;
};

export type FlightsSearchResponseFlightsReviewLoadingElementsArgs = {
  queryState?: InputMaybe<FlightsQueryState>;
};

export type FlightsSearchResponseGaiaIdArgs = {
  queryState?: InputMaybe<FlightsQueryState>;
};

export type FlightsSearchResponseListingResultArgs = {
  queryState?: InputMaybe<FlightsQueryState>;
};

export type FlightsSearchResponseOpinionLabArgs = {
  queryState?: InputMaybe<FlightsQueryState>;
};

export type FlightsSearchResponsePageTitleArgs = {
  queryState?: InputMaybe<FlightsQueryState>;
};

export type FlightsSearchResponseRewardsPricingInfoArgs = {
  queryState?: InputMaybe<FlightsQueryState>;
};

export type FlightsSearchResponseSearchFormArgs = {
  queryState?: InputMaybe<FlightsQueryState>;
};

export type FlightsSearchResponseSortAndFilterResultArgs = {
  queryState?: InputMaybe<FlightsQueryState>;
};

export type FlightsSearchResponseUniversalSortAndFilterResultArgs = {
  queryState?: InputMaybe<FlightsQueryState>;
};

/** Represents dynamic elements */
export type FlightsSearchResultsDynamicElements = FlightsDynamicElements & {
  __typename?: "FlightsSearchResultsDynamicElements";
  dynamicElementsGroupTrackEventAnalytics?: Maybe<FlightsDynamicElementsTrackEventAnalytics>;
  flightsJourneyDetailsDynamicElements?: Maybe<Array<FlightsJourneyDetailsDynamicElements>>;
};

/** Represents the sort and filter criteria for a given search */
export type FlightsSearchSortAndFilterCriteria = {
  __typename?: "FlightsSearchSortAndFilterCriteria";
  /** Represents the list of filters to be applied on the search results */
  filterCriteria: Array<FlightsSearchFilterValues>;
};

export type FlightsSeatAncillaryDetailsContent = {
  __typename?: "FlightsSeatAncillaryDetailsContent";
  /** Represents seat map content section with seat map grid. */
  journeySeatMapCabinSections: Array<FlightsJourneySeatMapCabinContent>;
  /** Represents journey info in dropdown. Ex: Seattle to Chicago (American Airlines). */
  journeySelectionDropDown: FlightsAncillarySelect;
  /** Represents legend floating button to open legend bottom sheet. */
  legendButton: UiFloatingActionButton;
  /** Accessibility Message when seat map view is displayed on screen */
  onLoadAccessibilityMessage: Scalars["String"];
  /** Represents traveler tabs. Ex: Traveler 1, Traveler 2 etc */
  travelerTabs: EgdsBasicTabs;
};

/** Seat ancillary details for the selected fare loaded state */
export type FlightsSeatAncillaryDetailsLoaded = {
  __typename?: "FlightsSeatAncillaryDetailsLoaded";
  /** Represents seat details content. */
  content: FlightsSeatAncillaryDetailsContent;
  /** Contains the elements for Dialog boxes for the seat details page */
  flightsAncillaryDialog: FlightsAncillaryDetailsDialog;
  /** Represents seat details footer. */
  footer: FlightsSeatAncillaryFooter;
  /** Represents offer identifier for selected offer/base offer */
  offerIdentifier?: Maybe<Scalars["String"]>;
  /** Represents wrapper for seat details dialog/sideSheet */
  seatDetailsWrapper: FlightsDialogSheet;
};

/** Seat ancillary details for the selected fare loading state */
export type FlightsSeatAncillaryDetailsLoading = {
  __typename?: "FlightsSeatAncillaryDetailsLoading";
  /** Represents the error message to be shown in case of failure or timeout. Ex: We’re having trouble loading the seatmap for your flight.. */
  errorMessage: FlightsMessagingCardPlacard;
  /**
   * Represents the display action prefetch/none
   * @deprecated Will be used in Ancillary summary card query
   */
  onDisplayAction: FlightsAncillaryDisplayAction;
  /** Represents wrapper for seat details dialog/sideSheet */
  seatDetailsWrapper: FlightsDialogSheet;
};

/** Represents seat ancillary details on selection of seats */
export type FlightsSeatAncillaryDetailsOnSelection = {
  __typename?: "FlightsSeatAncillaryDetailsOnSelection";
  /** Represents seat details footer. */
  footer: FlightsSeatAncillaryFooter;
};

/** Seat ancillary details for the selected fare */
export type FlightsSeatAncillaryDetailsPresentation =
  | FlightsSeatAncillaryDetailsLoaded
  | FlightsSeatAncillaryDetailsLoading
  | FlightsSeatAncillaryDetailsOnSelection;

export type FlightsSeatAncillaryFooter = {
  __typename?: "FlightsSeatAncillaryFooter";
  /** Represents footer for each leg with price and button action. Ex: Next Flight, Continue Booking */
  journeyFooters: Array<FlightsSeatAncillaryJourneyFooter>;
  /** Represents legend footer for each leg with legend variants and price range of that leg. Ex: Available, Accessible, $5-$20 etc */
  legendFooters: Array<FlightsSeatAncillaryLegendDetailsFooter>;
};

/** Ancillary footer for the selected journey */
export type FlightsSeatAncillaryJourneyFooter = {
  __typename?: "FlightsSeatAncillaryJourneyFooter";
  /** Represents analytics for ancillary */
  analyticsList?: Maybe<Array<ClientSideAnalytics>>;
  /** Represents the button action. Example: 'Next Flight' OR 'Continue Booking' */
  buttonAction: FlightsActionButton;
  /** Represents the seat map total details for a flight */
  selectedSeatsSummary: FlightsSelectedSeatsSummary;
};

/** Represents the details of legend footer section. */
export type FlightsSeatAncillaryLegendDetailsFooter = {
  __typename?: "FlightsSeatAncillaryLegendDetailsFooter";
  /** Represents close legend button action */
  close: FlightsActionButton;
  /** Represents the list of all legends. Ex: accessible, unavailable  */
  legendVariants: Array<FlightsSeatLegendVariant>;
  /** Heading of the legends box. ex: Legend */
  title: Scalars["String"];
};

export type FlightsSeatCell = {
  __typename?: "FlightsSeatCell";
  /** Represents the accessibility message associated with each seat. */
  accessibilityMessage?: Maybe<Scalars["String"]>;
  /** Represents button action on which seat info will be shown. */
  action?: Maybe<FlightsAction>;
  /** Represents the click analytics on click of a seat. */
  clickAnalytics?: Maybe<Array<FlightsAnalytics>>;
  /** Icon denoting the seat map variant. Ex: exit icon */
  icon?: Maybe<Icon>;
  /** Represents the seat info details along with price to be shown on the click of a seat. */
  info?: Maybe<FlightsSeatInfo>;
  /** Represents empty seat in seat map. */
  isEmpty: Scalars["Boolean"];
  /** Represents seat name of a particular variant. Ex: in cases of aisle, column header seats */
  name?: Maybe<Scalars["String"]>;
  /** Represents span of a seat for client to know which seats occupy more columns. For Ex: Restroom, Gallery will have 3 span */
  span?: Maybe<Scalars["Int"]>;
  /** Represent seat variant. Ex: available, unavailable, preferred etc */
  variant: SeatVariant;
};

/** Represents the value associated with travel and baggage filter - seat choice */
export type FlightsSeatChoiceBasedFilterValue = {
  __typename?: "FlightsSeatChoiceBasedFilterValue";
  seatChoice: SeatChoiceType;
};

/** Represents the value associated with travel and baggage filter - seat choice */
export interface FlightsSeatChoiceBasedFilterValueInput {
  seatChoice: SeatChoiceType;
}

export type FlightsSeatInfo = {
  __typename?: "FlightsSeatInfo";
  /** Represents amenities of a seat. Ex: '{WiFi available}' */
  amenities?: Maybe<EgdsUnorderedList>;
  /** Seat related air ancillary product token required while updating seat selection */
  ancillaryToken?: Maybe<Scalars["String"]>;
  /** Represents close seat button action */
  closeSeat: FlightsActionButton;
  /** Represents seat name and price of a seat.Example: 'Seat 3D - $10' with details and accessibilityMessage. */
  priceLockup: EgdsPriceLockup;
  /** Represents select seat button action. Ex: 'Select seat' */
  selectSeat: FlightsActionButton;
  /** Represents unselect seat button action. Ex: 'Unselect seat' */
  unselectSeat: FlightsActionButton;
};

export type FlightsSeatLegendCellCard = {
  __typename?: "FlightsSeatLegendCellCard";
  /** Represents the accessibility message associated with a card. */
  accessibilityMessage?: Maybe<Scalars["String"]>;
  /** Represents the seat icon in card. Ex: accessible, unavailable etc */
  icon?: Maybe<Icon>;
  /** Represents the text in the card when icon not needed for some cases like Selection, Currency. Ex: '1', '$' etc */
  text?: Maybe<EgdsStylizedText>;
};

export type FlightsSeatLegendVariant = {
  __typename?: "FlightsSeatLegendVariant";
  /** Represents the legend card. */
  legendCard: FlightsSeatLegendCellCard;
  /** Represents the title of the legend. Ex: Available, Unavailable */
  title: Scalars["String"];
};

export type FlightsSeatMapCellCard = {
  __typename?: "FlightsSeatMapCellCard";
  /** Represents the accessibility message associated with a card. */
  accessibilityMessage?: Maybe<Scalars["String"]>;
  /** Represents the seat icon in card. Ex: accessible, unavailable etc */
  icon?: Maybe<Icon>;
  /** Represents the text in the card when icon not needed for some cases like Selection, Currency. Ex: '1', '$' etc */
  text?: Maybe<Scalars["String"]>;
};

/** Represents criteria for flights seat map. */
export interface FlightsSeatMapCriteriaInput {
  /** Represents which offer seat map to be shown. This will be decoded and used to create seat map service request */
  offerIdentifier: Scalars["String"];
  /** Represents pricing construct containing price related information. Ex: '[AA.QNNF00S7:SEADEL][AA.QNNF00S7CH:SEADEL][AA.QNNF00S7CH:SEADEL]{BFSDiag}{FC}11JUL21SEA AA X/LON BA DEL M318.00NUC318.00END ROE1.000000{/FC}{DollarAfc}{/DollarAfc}{/BFSDiag}{Published}' */
  pricingConstruct?: InputMaybe<Scalars["String"]>;
  /** Represents list of segments for which seat map for selection is to be shown. */
  seatSegments?: InputMaybe<Array<SeatSegmentInput>>;
  /** Represents list of segments for which seat map is to be shown. This will identify the segments from the decoded offer identifier and request seat map downstream. */
  segmentIdentifiers: Array<Scalars["String"]>;
}

/** Represents seat map grid details with rows info and wing details. */
export type FlightsSeatMapGridDetails = {
  __typename?: "FlightsSeatMapGridDetails";
  /** Cabin dimension details for cabin width calculation */
  cabinDimensionDetails: SeatMapCabinDimensionDetails;
  /** An object which contains the list of rows in a cabin. */
  seatMapRows: Array<FlightsSeatMapRow>;
};

/** Represents seat map summary for each flight present in trip */
export type FlightsSeatMapLegSummary = {
  __typename?: "FlightsSeatMapLegSummary";
  /** Represents the button action. Example: 'Next Flight' OR 'Continue Booking' */
  buttonAction: FlightsAction;
  /** Represents the types of action based on number of seats selected for a flight */
  buttonActionTypes: Array<FlightsSeatMapLegSummaryActionType>;
  /** Represents the seat map total details for a flight */
  seatTotalDetails: FlightsSeatMapTotalDetails;
  /** Represents Traveler summary with seat information */
  travelerSummary: FlightsSeatMapTravelersSummary;
};

/** Represents seat map leg summary's action type based on number of seats selected for a flight */
export type FlightsSeatMapLegSummaryActionType = {
  __typename?: "FlightsSeatMapLegSummaryActionType";
  /** Represents the analytics to track with the action type */
  analyticsList: Array<FlightsAnalytics>;
  /** Id of the action type to be mapped with number of seats selected */
  id: FlightsActionType;
};

export type FlightsSeatMapLegendVariant = {
  __typename?: "FlightsSeatMapLegendVariant";
  /** Represents the legend card. */
  legendCard: FlightsSeatMapCellCard;
  /** Represents the title of the legend. Ex: Available, Unavailable */
  title: Scalars["String"];
};

export type FlightsSeatMapLegends = {
  __typename?: "FlightsSeatMapLegends";
  /** Represents close legend button action */
  close: FlightsActionButton;
  /** Represents the list of all legends. Ex: accessible, unavailable  */
  legendVariants: Array<FlightsSeatMapLegendVariant>;
  /** Heading of the legends box. ex: Legend */
  title: Scalars["String"];
};

export type FlightsSeatMapPlaneDetails = {
  __typename?: "FlightsSeatMapPlaneDetails";
  /** Represents the display analytics for a cabin. */
  displayAnalytics: Array<FlightsAnalytics>;
  /** This will be used for unique identification of segment */
  identifier: Scalars["String"];
  /** Represents the legend component. */
  legendDetails: FlightsSeatMapLegends;
  /** An object which contains the list of rows in a cabin. */
  seatMapRows: Array<FlightsSeatMapRowType>;
  /** Represents various messages needed when seat is selected */
  seatSelectionMessages?: Maybe<FlightsSeatSelectionMessages>;
  /** Wing Information */
  wingDetails?: Maybe<FlightsSeatMapWingDetails>;
};

/** Response of the flights seat map request */
export type FlightsSeatMapResponse = {
  __typename?: "FlightsSeatMapResponse";
  /** Represents the error message to be shown in case of downstream failure or no response. Ex: Sorry, please try again. */
  errorMessage?: Maybe<FlightsErrorMessagingPresentation>;
  /** An object which contains the seat map list for each segment. */
  seatMapPlanes?: Maybe<Array<FlightsSeatMapPlaneDetails>>;
};

export type FlightsSeatMapRow = {
  __typename?: "FlightsSeatMapRow";
  /** An object which contains the list of seats in row of seat map. */
  seatMapRowSeats?: Maybe<Array<FlightsSeatCell>>;
};

export type FlightsSeatMapRowType = {
  __typename?: "FlightsSeatMapRowType";
  /** An object which contains the list of seats in row of seat map. */
  seatMapRowSeats?: Maybe<Array<FlightsSeatMapSeatCell>>;
};

export type FlightsSeatMapSeatCell = {
  __typename?: "FlightsSeatMapSeatCell";
  /** Represents the accessibility message associated with each seat. */
  accessibilityMessage?: Maybe<Scalars["String"]>;
  /** Represents button action on which seat info will be shown. */
  action?: Maybe<FlightsAction>;
  /** Represents the click analytics on click of a seat. */
  clickAnalytics?: Maybe<Array<FlightsAnalytics>>;
  /** Icon denoting the seat map variant. Ex: exit icon */
  icon?: Maybe<Icon>;
  /** Represents empty seat in seat map. */
  isEmptySeat: Scalars["Boolean"];
  /** Represents seat name of a particular variant. Ex: in cases of aisle, column header seats */
  seatName?: Maybe<Scalars["String"]>;
  /** Represents seat price of a particular seat when. Example: '$99' */
  seatPrice?: Maybe<Money>;
  /** Represents the seat info details along with price to be shown on the click of a seat. */
  seatPriceInfo?: Maybe<FlightsSeatMapSeatPriceInfo>;
  /** Represents span of a seat for client to know which seats occupy more columns. For Ex: Restroom, Gallery will have 3 span */
  seatSpan?: Maybe<Scalars["Int"]>;
  /** Represent seat variant. Ex: available, unavailable, preferred etc */
  variant: FlightsSeatMapSeatVariant;
};

/** Represents seat details being selected */
export type FlightsSeatMapSeatDetails = {
  __typename?: "FlightsSeatMapSeatDetails";
  /** Represents the seat name assigned. Example: 6A */
  assignedSeat?: Maybe<Scalars["String"]>;
  /** Represents the id of traveler to map with seat assigned. */
  id: Scalars["Int"];
  /** Represents the seat price. Example: '-' or '$20' */
  price: FlightsSeatMapSeatPrice;
};

/** Represents the seat price. Example: '$20' */
export type FlightsSeatMapSeatPrice = {
  __typename?: "FlightsSeatMapSeatPrice";
  /** Represents the seat price. Example: '20' */
  amount?: Maybe<Scalars["Float"]>;
  /** Default price to shown when there is no price.Example '-' */
  default: Scalars["String"];
  /** Represents the seat price along with template. Example: '$${amount}' */
  selected?: Maybe<FlightsSimpleLocalizationTemplate>;
};

export type FlightsSeatMapSeatPriceInfo = {
  __typename?: "FlightsSeatMapSeatPriceInfo";
  /** Represents the accessibility message associated with each seat's price info. */
  accessibilityMessage: Scalars["String"];
  /** Represents amenities of a seat. Ex: '{WiFi available}' */
  amenities?: Maybe<Array<Scalars["String"]>>;
  /** Represents close seat button action */
  closeSeat?: Maybe<FlightsAction>;
  /** Represents preview only message. */
  message: Scalars["String"];
  /** Represents price of a seat. */
  price: Scalars["String"];
  /** Represents details of a seat. Ex: seatName, cabinName */
  seatDetails: Array<Scalars["String"]>;
  /** Represents seat name and price of a seat.Example: 'Seat 3D - $10'. */
  seatNameWithPrice?: Maybe<Scalars["String"]>;
  /** Represents select seat button action. Ex: 'Select seat' */
  selectSeat?: Maybe<FlightsAction>;
  /** Represents select seat button action. Ex: 'Select seat' */
  unselectSeat?: Maybe<FlightsAction>;
  /** Seat related air ancillary product token required while updating seat selection */
  unselectedAirAncillaryProductToken?: Maybe<Scalars["String"]>;
};

/** Enum class to represent the seat type variant. */
export type FlightsSeatMapSeatVariant =
  | "ACCESSIBLE"
  | "AISLE"
  | "AVAILABLE"
  | "COLUMN"
  | "EXIT"
  | "GALLEY"
  | "PREFERRED"
  | "RESTROOM"
  | "ROW"
  | "SELECTED"
  | "UNAVAILABLE";

/** Represents the seat map total details */
export type FlightsSeatMapTotalDetails = {
  __typename?: "FlightsSeatMapTotalDetails";
  /** Represents the accessibility message for `Seat total, $0' */
  accessibilityMessage?: Maybe<Scalars["String"]>;
  /** Represents the seat total label. Example: 'Seat total' or 'Seat(s):' */
  label: FlightsResponsiveMessage;
  /** Represents the default value for seat label. Example: '-' */
  noSeatSelected: Scalars["String"];
  /** Represents seat delimiter. Example: '|' */
  seatDelimiter: Scalars["String"];
  /** Represents the number of seat selected message. Example:'{travelerNumber} of 3 selected' */
  seatsSelectedMessage: FlightsSimpleLocalizationTemplate;
  /** Represents the values for seats being selected. */
  selectedSeats: Array<FlightsSeatMapSeatDetails>;
  /** Represents the total price for seats selected. Example: '$999' or '$${totalAmount}' */
  totalPrice: FlightsSimpleLocalizationTemplate;
};

/** Represents traveler summary information with seat details */
export type FlightsSeatMapTravelerSummaryItem = {
  __typename?: "FlightsSeatMapTravelerSummaryItem";
  /** Represents the button action. Example: 'Traveler 1' */
  action: FlightsActionAndLabel;
  /** Represents the number for traveler. Example: '1' */
  id: Scalars["Int"];
  /** Represents seat details. */
  seatDetails: FlightsSeatMapSeatDetails;
};

/** Represents Traveler summary with seat information */
export type FlightsSeatMapTravelersSummary = {
  __typename?: "FlightsSeatMapTravelersSummary";
  /** Represents the title for travelers. Example: 'Travelers'. */
  title: FlightsResponsiveMessage;
  /** List of travelers summary item, */
  travelers: Array<FlightsSeatMapTravelerSummaryItem>;
};

/** Wing Information of plane */
export type FlightsSeatMapWingDetails = {
  __typename?: "FlightsSeatMapWingDetails";
  /** Ending row index for wing to be shown in seat map */
  endRow: Scalars["Int"];
  /** Starting row index for wing to be shown in seat map */
  startRow: Scalars["Int"];
};

/** Error Message when an error occur during seat selection */
export type FlightsSeatSelectionErrorMessage = {
  __typename?: "FlightsSeatSelectionErrorMessage";
  /** List of analytics to be fired */
  analytics?: Maybe<Array<FlightsAnalytics>>;
  /** Type of error */
  id: FlightsSeatSelectionErrorType;
  /** Message to be displayed */
  message: Scalars["String"];
  /** Theme of message */
  theme: TextTheme;
};

/** Error types which can occur during seat selection */
export type FlightsSeatSelectionErrorType =
  /** Seat Selection Failed */
  | "SELECTION_FAILED"
  /** Seat Selection Unavailable */
  | "SELECTION_UNAVAILABLE";

/** Various messages associated with seat selection on UI */
export type FlightsSeatSelectionMessages = {
  __typename?: "FlightsSeatSelectionMessages";
  /** Represents the message for seat selected.Ex:'Seat {seatName} selected!' */
  seatSelected: FlightsSimpleLocalizationTemplate;
  /** Represents the message for seat selected when all seats selected for a flight.Ex:'Seat {seatName} selected! Great job! You have selected seats for all travelers on this flight.' */
  seatsSelectedForFlight: FlightsSimpleLocalizationTemplate;
  /** Represents the message for seat selected when all seats selected for entire trip.Ex:'Seat {seatName} selected! Great job! You have finished selecting seats for all flights in your trip.' */
  seatsSelectedForTrip: FlightsSimpleLocalizationTemplate;
};

/** Various messages associated with seat selection on UI */
export type FlightsSeatSelectionNotificationMessages = {
  __typename?: "FlightsSeatSelectionNotificationMessages";
  /** Represents the message for seat selected.Ex:'Seat {seatName} selected!' */
  seatSelected: FlightsSimpleLocalizationTemplate;
  /** Represents the message for seat selected when all seats selected for a flight.Ex:'Seat {seatName} selected! Great job! You have selected seats for all travelers on this flight.' */
  seatsSelectedForFlight: FlightsSimpleLocalizationTemplate;
  /** Represents the message for seat selected when all seats selected for entire trip.Ex:'Seat {seatName} selected! Great job! You have finished selecting seats for all flights in your trip.' */
  seatsSelectedForTrip: FlightsSimpleLocalizationTemplate;
};

export type FlightsSeatsConfirmedDetails = {
  __typename?: "FlightsSeatsConfirmedDetails";
  /** Seat related air ancillary product token required for price calculation and updating seat selection */
  ancillaryToken: Scalars["String"];
  /** Selected seat name. Ex: 2A */
  name: Scalars["String"];
  /** Traveler index for selected seat. Ex: 1, 2, 3 etc */
  travelerIndex: Scalars["Int"];
};

/** Summary of all available fares for a Journey */
export type FlightsSelectedJourneyAvailableFares = FlightsAvailableFares & {
  __typename?: "FlightsSelectedJourneyAvailableFares";
  /** Describes button action to accept chosen fare and continue, null for single fare amenities */
  applySelection?: Maybe<FlightsAction>;
  /** Describes icon to dismiss summary/details */
  dismissDetailedJourneyInformation: FlightsActionableIcon;
  /** Summary of all available fares for a Journey */
  fareChoiceInformation: FlightsFareChoiceInformation;
  /** Journey highlight like Origin to Destination, departure day, airline */
  flightsJourneyHeaders: FlightsJourneyHeaders;
  /** Represents the accesibility message to be announced when summary/details opens */
  openAccessibility: Scalars["String"];
};

/** Interface encapsulating common properties between all the states of review */
export interface FlightsSelectedJourneyDetails {
  /** Represents information sent to clients to help user change the selected flight */
  changeFlight: FlightsAction;
  /** Policies for the Journey */
  flightsJourneyPolicies?: Maybe<FlightsTextSection>;
  /** Represents the basic highlights in multiple segments or Origin Destination pairs */
  journeyHighlights: Array<FlightsJourneyHighlights>;
  /** Represents onView analytics for Journey Information. This will be triggered when it is visible on the client's viewport */
  onViewedAnalytics?: Maybe<FlightsAnalytics>;
}

/** Represent the details of journey selected by customer. e.g. In a RoundTrip this will be details Outbound journey selected */
export type FlightsSelectedJourneyPresentation = {
  __typename?: "FlightsSelectedJourneyPresentation";
  /** List of airlines included in the journey */
  airlines: Array<FlightsImageAndLabel>;
  /** Combination of the airport codes involved in the journey including layovers duration. Example: 'SEA - 2h 16m in LAX - LAS' */
  airportStops: Scalars["String"];
  /** Label representing departure date and change flight link presentation */
  changeFlightLabelPresentation: ChangeFlightLabelPresentation;
  /** Combination of departure and arrival time connected by a hyphen */
  departureAndArrivalTime: FlightsPhrase;
  /** Duration of the flights plus the number of stopsExample: '21h 10m (1 Stop)' */
  durationAndStops: Scalars["String"];
  /** Represents the tray window shown with fare rule details about the offer listing */
  fareRulesPresentation?: Maybe<FlightsOfferFareRulesPresentation>;
  /** Flight number, airline, and operating airline if it applies. Example: 'American Airlines 6058 operated by Compass Airlines' */
  flightOperatedBy: Scalars["String"];
  /** Represents the amenities included in all the flights. Amenities include Wi-Fi, Entertainment and Electric outlets. */
  journeyAmenities?: Maybe<FlightsJourneyAmenities>;
  /** Represents the pricing info for the offer listing */
  pricingInformation: FlightsPricingInformation;
  /** Title to be surfaced for selected flight */
  title: FlightsPhrase;
};

/** Interface encapsulating common properties between all the states of review */
export interface FlightsSelectedJourneyReview {
  /** Represents information sent to clients to help user change the selected flight */
  changeFlight: FlightsAction;
  /** Represents change flight dialog */
  changeFlightDialog?: Maybe<FlightsDialogChangeFlight>;
  /** Represents onView analytics for Journey Information. This will be triggered when it is visible on the client's viewport */
  collapseAnalytics?: Maybe<FlightsAnalytics>;
  /** Represents onView analytics for Journey Information. This will be triggered when it is visible on the client's viewport */
  expandAnalytics?: Maybe<FlightsAnalytics>;
  /** Summary of the selected fare and an option to either see details or change fare, in case there are no amenities bag details will be sent */
  fareDetails: FareDetails;
  /** Journey highlight like Origin to Destination, departure day, airline */
  flightsJourneyHeaders: FlightsJourneyHeaders;
  /** Summary and Details for a Journey */
  flightsJourneyInformation?: Maybe<FlightsDetailedJourneyInformation>;
  /** Policies for the Journey */
  flightsJourneyPolicies?: Maybe<FlightsTextSection>;
  /** Collapsed view with details like time, duration and stops of the entire journey */
  flightsJourneySummary: FlightsJourneySummary;
  /** @deprecated This field is now deprecated., replace with Use the sibling of FlightsSelectedJourneyReview */
  hygieneAmenitiesPresentation?: Maybe<FlightsHygieneAmenitiesPresentation>;
  /** Represents the basic highlights in multiple segments or Origin Destination pairs */
  journeyHighlights?: Maybe<Array<FlightsJourneyHighlights>>;
  /** Represents journey related information not directly displayed currently. */
  journeyInformation?: Maybe<JourneyInformation>;
  /** Represents onView analytics for Journey Information. This will be triggered when it is visible on the client's viewport */
  onViewedAnalytics?: Maybe<FlightsAnalytics>;
}

/** Represents all the common information in the journey review block on FIS  */
export type FlightsSelectedSeatDetail = {
  __typename?: "FlightsSelectedSeatDetail";
  /** Represents information of flight leg. Example: 'Flight 1 - Chicago to Denver' */
  flightInformation?: Maybe<Scalars["String"]>;
  /** Represents information of seat selected along with corresponding traveler. Example: 'Traveler 1 - Seat 6A' */
  travelerSeatsInformation?: Maybe<Array<Scalars["String"]>>;
};

/** Represents the footer for the selected card */
export type FlightsSelectedSeatsSummary = {
  __typename?: "FlightsSelectedSeatsSummary";
  /** Represents the accessibility message for `Seat total, $0' */
  accessibilityMessage: Scalars["String"];
  /** Represents the selected seats label separated with delimiter. Ex: Seat(s): - or Ex: Seat(s): 2A|2B|2C */
  label: EgdsSpannableText;
  /** Represents the number of seat selected message. Example:'1 of 3 selected' */
  message: EgdsStylizedText;
  /** Represents the total price for seats selected. Example: '$999' or '$${totalAmount}' */
  totalPrice: EgdsPriceLockup;
};

/** Action to get a value, e.g. fare is selected jcid or upsellOfferToken is given */
export type FlightsSelectionAction = FlightsClientAction & {
  __typename?: "FlightsSelectionAction";
  /** Used to provide accessibility that has to be read on completion of action. */
  accessibility?: Maybe<Scalars["String"]>;
  /** Used to capture client side analytics */
  analyticsList: Array<ClientSideAnalytics>;
  /** Represents the value to be passed. */
  value: Scalars["String"];
};

export type FlightsServicingBookingResponse = {
  __typename?: "FlightsServicingBookingResponse";
  failure?: Maybe<FlightServicingBookingFailure>;
  success?: Maybe<FlightServicingBookingSuccess>;
};

/** Represents criteria for flights servicing confirmation page. */
export interface FlightsServicingConfirmationCriteriaInput {
  /** Represent the continuation identifier for spinner to deduce all journeys selected by the user. */
  journeyContinuationId?: InputMaybe<Scalars["String"]>;
  /** Represents the identifier for the spinner to deduce which all credits have been selected by the user */
  originalBookingId: Scalars["String"];
  /** Represents the trip id */
  tripId?: InputMaybe<Scalars["String"]>;
}

export type FlightsServicingConfirmationResponse = {
  __typename?: "FlightsServicingConfirmationResponse";
  clientMetadata: FlightsPwaMetadata;
  confirmationHeading: Scalars["String"];
  errorMessaging?: Maybe<FlightServicingBookingFailure>;
  hotelAttach?: Maybe<FlightsMessagingCardPlacard>;
  mainContent: FlightsConfirmation;
};

/** Represents criteria for flights servicing page. */
export interface FlightsServicingCriteriaInput {
  /** Encoded representation of ancillaries that was selected on FIS. */
  ancillaryId?: InputMaybe<Scalars["String"]>;
  /** Represents the identifier to deduce change order flow */
  isResumeChange?: InputMaybe<Scalars["Boolean"]>;
  /** Represent the continuation identifier for spinner to deduce all journeys selected by the user. */
  journeyContinuationId: Scalars["String"];
  /** Represents the identifier for the spinner to deduce which all credits have been selected by the user */
  originalBookingId?: InputMaybe<Scalars["String"]>;
  /** Represents the trip id */
  tripId?: InputMaybe<Scalars["String"]>;
  /** Represents upsell offer token of the selected flight */
  upsellOfferToken?: InputMaybe<Scalars["String"]>;
}

export type FlightsServicingResponse = {
  __typename?: "FlightsServicingResponse";
  addCollectRequired?: Maybe<Scalars["Boolean"]>;
  authenticatedUser: FlightsAuthenticatedUser;
  booking: FlightsBooking;
  clientMetadata: FlightsPwaMetadata;
  creditResidualMessaging?: Maybe<FlightsCreditResidualMessaging>;
  importantTripInfo: FlightsImportantTripInfo;
  payment: FlightsPayment;
  placards?: Maybe<Array<FlightsUiPlacard>>;
  priceSummary?: Maybe<FlightsPriceSummary>;
  reviewAndBook: FlightsReviewAndBook;
  serverErrorMessaging?: Maybe<FlightServicingBookingFailure>;
  tripSummary?: Maybe<FlightsTripSummary>;
};

export type FlightsServicingResponsePriceSummaryArgs = {
  queryState?: InputMaybe<FlightsQueryState>;
};

export type FlightsServicingResponseTripSummaryArgs = {
  queryState?: InputMaybe<FlightsQueryState>;
};

/** Type used to render a UitkSheet */
export interface FlightsSheet {
  /** Represents the content of the sheet */
  content?: Maybe<Array<EgdsElement>>;
}

/** Type used to render a UitkSideSheet */
export type FlightsSideSheet = FlightsSheet & {
  __typename?: "FlightsSideSheet";
  /** Represents the content of the side sheet  */
  content?: Maybe<Array<EgdsElement>>;
  /** Represents the content of the side sheet footer  */
  footer?: Maybe<Array<EgdsElement>>;
  /** Represents the title of the side sheet  */
  title?: Maybe<Scalars["String"]>;
};

/** Represents a localization template for scenarios that require client side interpolation of valuesbut that do not require pluralization of words. Example: 'Delete flight {flightNumber}' */
export type FlightsSimpleLocalizationTemplate = FlightsLocalizationTemplate & {
  __typename?: "FlightsSimpleLocalizationTemplate";
  initialValue?: Maybe<Scalars["String"]>;
  /** Localized string with tokens interpolated.Example: '{numberOfTravelers} travelers.' */
  template: Scalars["String"];
  tokens: Array<Scalars["String"]>;
};

/** Represents the slider based filter module . Ex Duration based filter on mApp */
export type FlightsSliderDisplayFilterOption = FlightsFilterOption & {
  __typename?: "FlightsSliderDisplayFilterOption";
  /** Represents analytics to track application of the filter */
  filterAppliedAnalytics?: Maybe<FlightsAnalytics>;
  /** Represents the list of filter items associated with this filter option */
  items: Array<FlightsSliderFilterItem>;
  /** Represents the label associated with particular filter option */
  label: Scalars["String"];
  /** Represents the currently selected index for the filter option */
  selectedIndex: Scalars["Int"];
  /** Represents whether the filter supports multi-selection */
  supportsMultipleSelection: Scalars["Boolean"];
  /** Represents the FilterType for this filter option */
  type: FlightsFilterType;
};

/** Represents each filter item in a FlightsSliderFilterOption */
export type FlightsSliderFilterItem = FlightsFilterItem & {
  __typename?: "FlightsSliderFilterItem";
  /** Represents the accessibility message for the filter item */
  accessibility?: Maybe<FlightsAccessibilityMessage>;
  /** Boolean which represents whether a particular item is selected or not when filters are cleared */
  defaultSelected: Scalars["Boolean"];
  /** Represents the object to be sent back to the server in the subsequent request when this particular filter item is selected */
  flightsSearchFilterValues: FlightsSearchFilterValues;
  /** Represents the identifier for the particular filter item */
  identifier: Scalars["String"];
  /** Represents the label for this filter item */
  label: Scalars["String"];
  /** Boolean which represents whether a particular item is selected or not */
  selected: Scalars["Boolean"];
  /** Represents the filter value for this filter item. Would aid in solving the client side sort and filter */
  value: FlightsFilterValue;
};

/** Represents smart implementation and provides alternate options when search completes with no offers */
export type FlightsSmartNoFlightsFoundMessaging = FlightsErrorMessagingPresentation & {
  __typename?: "FlightsSmartNoFlightsFoundMessaging";
  /** Journey options between nearby alternate airports for journey dates specified by the user */
  alternateAirportOptions?: Maybe<AlternateAirportOptions>;
  /** Journey options for alternate dates between origin and destination specified by the user */
  alternateDateOptions?: Maybe<AlternateDateOptions>;
  /** 'Edit search' Button to Edit the Search Criteria in case we do not get any alternate options for NFF */
  editSearchButton?: Maybe<FlightsAction>;
  /** Flights component display info */
  flightsDisplayComponentCountingValue?: Maybe<FlightsDisplayComponentCountingValue>;
  /** Icon included at the top of the message. Example: Search icon */
  icon: Icon;
  /** Message content. Example: 'Here are some tips to help find flights' */
  message: Scalars["String"];
  /** Title of the message */
  title: Scalars["String"];
};

/** Represents an EGDS Button that contains a FlightsClientAction */
export type FlightsSmartShoppingActionButton = EgdsButton & {
  __typename?: "FlightsSmartShoppingActionButton";
  accessibility?: Maybe<Scalars["String"]>;
  /**
   * @deprecated
   *         UIAction should not be used as a field because it allows for too many possible types.
   *         If need to specify action have the implementation of EGDSButton add a field for action with interface type of less number of possible subtypes
   *         or a union type with a manageable number of members
   *
   */
  action?: Maybe<UiAction>;
  analytics?: Maybe<ClientSideAnalytics>;
  /** Represents an action to be performed on the client side when the button is pressed */
  clientAction: FlightsSmartShoppingClientAction;
  disabled: Scalars["Boolean"];
  /** Represents an optional icon */
  icon?: Maybe<Icon>;
  /** Represents the position of the icon */
  iconPosition?: Maybe<FlightsSmartShoppingIconPosition>;
  /** Represents the main text of the button */
  primary?: Maybe<Scalars["String"]>;
  /** Represents the button style */
  style: EgdsButtonStyle;
  /** Represents the button width in the UI */
  width?: Maybe<FlightsSmartShoppingButtonWidth>;
};

/** Represents an EGDS Link that contains a FlightsClientAction */
export type FlightsSmartShoppingActionLink = {
  __typename?: "FlightsSmartShoppingActionLink";
  /** Used to provide accessibility of the action link. */
  accessibility?: Maybe<Scalars["String"]>;
  /** Represents client side analytics */
  analytics?: Maybe<ClientSideAnalytics>;
  /** Represents an action to be performed on the client side when the link is clicked */
  clientAction: FlightsSmartShoppingClientAction;
  /** Represents if link is disabled */
  disabled: Scalars["Boolean"];
  /** Represents an optional icon */
  icon?: Maybe<Icon>;
  /** Represents the position of the icon */
  iconPosition?: Maybe<FlightsSmartShoppingIconPosition>;
  /** Represents the text of the link */
  primary?: Maybe<Scalars["String"]>;
};

/** Represents the additional elements rendered below the card */
export type FlightsSmartShoppingAdditionalContent = EgdsPlainText | FlightsSmartShoppingActionLink;

/** Represents the button width in the UI */
export type FlightsSmartShoppingButtonWidth =
  /** Button will take the width it needs */
  | "DEFAULT"
  /** Button will take the full width of the content */
  | "FULL_WIDTH";

/** Represents an action to click */
export type FlightsSmartShoppingClickAction = FlightsSmartShoppingClientAction & {
  __typename?: "FlightsSmartShoppingClickAction";
  /** Used to provide accessibility that has to be read on completion of action. */
  accessibility?: Maybe<Scalars["String"]>;
  /** Used to capture client side analytics */
  analyticsList: Array<ClientSideAnalytics>;
};

export interface FlightsSmartShoppingClientAction {
  /** Used to provide accessibility that has to be read on completion of action */
  accessibility?: Maybe<Scalars["String"]>;
  /** Represents the analytics to track when interacting with this action */
  analyticsList: Array<ClientSideAnalytics>;
}

/** Represents flights dialog actions */
export type FlightsSmartShoppingDialogAction = "CLOSE" | "OPEN" | "TOGGLE";

/** Represents IDs for flights dialogs */
export type FlightsSmartShoppingDialogId =
  /** Represents the Airlines credit dialog */
  | "AIRLINE_CREDITS"
  /** Represents the Close button dialog for the baggage details when complete selections have been made */
  | "BAGGAGE_CLOSE_COMPLETE_DIALOG"
  /** Represents the Close button dialog for the baggage details when incomplete selections have been made */
  | "BAGGAGE_CLOSE_INCOMPLETE_DIALOG"
  /** Represents the Continue booking dialog for the baggage details */
  | "BAGGAGE_CONTINUE_BOOKING"
  /** Represents the dialog ID for Baggage details */
  | "BAGGAGE_DETAILS_DIALOG"
  /** Represents the bags popup dialog on checkout button */
  | "BAGS_POPUP_ON_CHECKOUT"
  /** Represents the check credits dialog for users coming from MCC and VA */
  | "CHECK_CREDITS_DIALOG"
  /** Represents the Flights Details and Fares dialog */
  | "FLIGHTS_DETAILS_AND_FARES"
  /** The Forced choice modal that appears in large breakpoints when going to FIS */
  | "FORCED_CHOICE_MODAL"
  /** Represents the How Airlines Work dialog inside Select Credits */
  | "HOW_CREDITS_WORK"
  /** Represents the Leave This Page dialog inside Select Credits */
  | "LEAVE_TO_COUPONS"
  /** Represents the bags opening dialog eg:- sidesheet for desktop , fullscreendialog for mobile */
  | "PAID_BAGS_DIALOG"
  /** Represents the Info dialog for Price Match Promise Selected Card */
  | "PMP_INFO_DIALOG"
  /** Represents the Remove dialog for Price Match Promise Selected Card */
  | "PMP_REMOVE_DIALOG"
  /** Represents the seats popup dialog on checkout button */
  | "SEATS_POPUP_ON_CHECKOUT"
  /** Represents the Close button dialog for the seat details */
  | "SEAT_CLOSE_COMPLETE_DIALOG"
  /** Represents the Continue booking dialog for the baggage details */
  | "SEAT_CONTINUE_BOOKING"
  /** Represents the seats opening dialog eg:- sidesheet for desktop , fullscreendialog for mobile */
  | "SEAT_SELECTION_DIALOG"
  /** Represents the dialog on traveler mismatch for credits offer */
  | "TRAVELER_MISMATCH_DIALOG";

/** Represents an EGDS dialog trigger */
export type FlightsSmartShoppingDialogTrigger = {
  __typename?: "FlightsSmartShoppingDialogTrigger";
  /** Represents the action for the dialog */
  dialogAction: FlightsSmartShoppingDialogAction;
  /** Provides the dialog ID associated with trigger */
  dialogId: FlightsSmartShoppingDialogId;
  /** Represents the dynamically created ID of the dialog to render  */
  dynamicDialogId?: Maybe<Scalars["String"]>;
  /** Represents the link or button trigger */
  trigger: FlightsDialogTriggerType;
};

/** Represents the position of the icon */
export type FlightsSmartShoppingIconPosition =
  /** Icon will be rendered at the beginning of the content */
  | "LEADING"
  /** Icon will be rendered at the end of the content */
  | "TRAILING";

/** Target of the Link when clicked */
export type FlightsSmartShoppingLinkTarget =
  /** Link will be opened in an external view e.g. new tab or browser window */
  | "EXTERNAL"
  /** Link will be opened in the same view where the user is currently e.g. same tab or webview inside an app */
  | "INTERNAL";

/** List of possible implementations for the offers and elements in listings */
export type FlightsSmartShoppingListing = EgdsStylizedText | FlightsSmartShoppingOfferCard;

export type FlightsSmartShoppingListingsResults =
  | FlightsSmartShoppingLoadedListings
  | FlightsSmartShoppingLoadingListings;

/** Represents the loaded state of listings for smart shopping. */
export type FlightsSmartShoppingLoadedListings = {
  __typename?: "FlightsSmartShoppingLoadedListings";
  /** Represents the accessibility message when the listings are loaded */
  accessibilityMessage?: Maybe<Scalars["String"]>;
  /** Represents various analytics associated with listing */
  flightsListingsAnalytics: Array<ClientSideAnalytics>;
  listings: Array<FlightsSmartShoppingListing>;
};

/** Represents the loading state of listings for smart shopping. */
export type FlightsSmartShoppingLoadingListings = {
  __typename?: "FlightsSmartShoppingLoadingListings";
  /** Represents the message for accessibility while search results are loading. Example : 'MEX to MAN Flights | Travelocity' */
  accessibility?: Maybe<Scalars["String"]>;
  /** Represents the search in progress flight image shown while listings are loading */
  image: Image;
  /** Represents the number of skeleton listings displayed while listings are loading */
  listingsSkeletonCount: Scalars["Int"];
  /** Represents the message like 'Searching for flights from 400+ airlines..' displayed while listings are loading */
  message: Scalars["String"];
  /** Represents the OD string like 'SEA to SFO' displayed while listings are loading */
  originDestination: Scalars["String"];
};

export type FlightsSmartShoppingOfferCard = {
  __typename?: "FlightsSmartShoppingOfferCard";
  additionalContentSections: Array<FlightsSmartShoppingAdditionalContent>;
  /** This represent the action when the offer is clicked */
  clientAction: FlightsSmartShoppingClientAction;
  /** This represent the main content rendered in the offer */
  content: FlightsSmartShoppingOfferContent;
  /** This represents the dialog to be triggered when clicking on the offer */
  dialogTrigger: FlightsSmartShoppingDialogTrigger;
  /** This represent the featured section of the offer */
  featuredHeader?: Maybe<FlightsSmartShoppingOfferFeaturedHeader>;
  /** This represent the offer's analytics when displayed */
  onDisplayAnalytics?: Maybe<ClientSideAnalytics>;
  /** This represent if the offer is rendered as selected */
  selected: Scalars["Boolean"];
};

/** This represent the transportation offer content */
export type FlightsSmartShoppingOfferContent = {
  __typename?: "FlightsSmartShoppingOfferContent";
  /** This represent the section rendered at the top of the left and center sections in desktop. Contains EGDS Badges. */
  badges?: Maybe<Array<EgdsBadge>>;
  /** This represent the pricing section of the offer */
  priceSection?: Maybe<FlightsSmartShoppingPriceSummary>;
  primarySection: Array<FlightsSmartShoppingPrimarySection>;
  secondarySection: Array<FlightsSmartShoppingSecondarySection>;
  tertiarySection: Array<FlightsSmartShoppingTertiarySection>;
};

/** This represents an offer featured with some text at the top */
export type FlightsSmartShoppingOfferFeaturedHeader = {
  __typename?: "FlightsSmartShoppingOfferFeaturedHeader";
  /** This represents the text rendered in the left side of the featured section */
  heading: Scalars["String"];
  /** This represents the icon to be rendered in the featured section */
  icon?: Maybe<Icon>;
};

/** Represents price summary elements: Price, price qualifier, strikethrough price, price caption. */
export type FlightsSmartShoppingPriceSummary = {
  __typename?: "FlightsSmartShoppingPriceSummary";
  /** Price rendered on the left of the main price */
  leadingPrice?: Maybe<EgdsSpannableText>;
  /** Primary price rendered */
  price: EgdsSpannableText;
  /** List of texts rendered above the main price */
  primaryText?: Maybe<Array<EgdsSpannableText>>;
  /** List of texts rendered bellow the main price */
  secondaryText?: Maybe<Array<EgdsSpannableText>>;
  /** Price rendered on the right of the main price */
  trailingPrice?: Maybe<EgdsSpannableText>;
};

/** List of possible implementations for the offer card primary section */
export type FlightsSmartShoppingPrimarySection = EgdsTextSection;

/** Represents an action to link to a new resource URI */
export type FlightsSmartShoppingResourceLinkAction = FlightsSmartShoppingClientAction & {
  __typename?: "FlightsSmartShoppingResourceLinkAction";
  /** Used to provide accessibility that has to be read on completion of action. */
  accessibility?: Maybe<Scalars["String"]>;
  /** Used to capture client side analytics */
  analyticsList: Array<ClientSideAnalytics>;
  /** Used to link to a new resource URI */
  resource: Uri;
  /** target of the link */
  target: FlightsSmartShoppingLinkTarget;
};

/** List of possible implementations for the offer card secondary section */
export type FlightsSmartShoppingSecondarySection = EgdsTextSection;

/** Action to get a value, e.g. fare is selected jcid or upsellOfferToken is given */
export type FlightsSmartShoppingSelectionAction = FlightsSmartShoppingClientAction & {
  __typename?: "FlightsSmartShoppingSelectionAction";
  /** Used to provide accessibility that has to be read on completion of action. */
  accessibility?: Maybe<Scalars["String"]>;
  /** Used to capture client side analytics */
  analyticsList: Array<ClientSideAnalytics>;
  /** Represents the value to be passed. */
  value: Scalars["String"];
};

/** List of possible implementations for the offer card secondary section */
export type FlightsSmartShoppingTertiarySection = EgdsGraphicText | EgdsTextSection | FlightsDurationTimeline;

/** Represents the listing displayed for flights urgency messaging */
export type FlightsSocialProofMessage = {
  __typename?: "FlightsSocialProofMessage";
  /** Represents the icon displayed in the flights urgency listing */
  icon: Icon;
  /** Represents the message displayed in the flights urgency listing */
  message: FlightsPhrase;
};

/** Represents the button whose on click triggers the sorting & filtering of results */
export type FlightsSortAndFilterAction = {
  __typename?: "FlightsSortAndFilterAction";
  /** Represents the accessibility message for this button */
  accessibility: FlightsAccessibilityMessage;
  /** Represents the analytics to track on interaction with this button */
  analytics: FlightsAnalytics;
  /** Represents the additional text displayed on button. mApp only ex. 'from USDxyz' */
  details?: Maybe<Scalars["String"]>;
  /** Represents text displayed on button. 'Done' for PWA and 'See x results' on mApp */
  label: Scalars["String"];
};

/** Represents the result required to render the Sort & Filter view on the client */
export interface FlightsSortAndFilterResult {
  /** Represents the object required to render the Filter options presentation on client */
  filterPresentation?: Maybe<FlightsFilterPresentation>;
  /** Represents the 'Sort & Filter' label and image to be displayed on the view */
  revealAction: FlightsSortAndFilterRevealAction;
  /** Represents the object required to render the Sort options presentation on client */
  sortPresentation: FlightsSortPresentation;
  /** Represents the 'Filters' label to be displayed on the filters view */
  title: Scalars["String"];
}

export type FlightsSortAndFilterRevealAction = {
  __typename?: "FlightsSortAndFilterRevealAction";
  accessibility?: Maybe<FlightsAccessibilityMessage>;
  appliedFilterCount?: Maybe<Scalars["Int"]>;
  enabled: Scalars["Boolean"];
  iconAndLabel: FlightsIconAndLabel;
};

/** Represents the object required to render the Sorting display on client */
export type FlightsSortLoadedPresentation = FlightsSortPresentation & {
  __typename?: "FlightsSortLoadedPresentation";
  /** Represents the default selected sort option when user clears selection */
  defaultSelectedOption: FlightsSortOptionItem;
  /** Represents the 'sort by' label */
  label: Scalars["String"];
  /** Represents the supported list of sort options */
  options: Array<FlightsSortOptionItem>;
  /** Represents the icon to be displayed corresponding to a selected sort option */
  selected: Icon;
  /** Represents the selected sort option */
  selectedOption: FlightsSortOptionItem;
  /** Sort option picker is inactive in case of NFFs.This boolean represents whether the picker is active or inactive */
  selectionActive: Scalars["Boolean"];
  /** Represents the icon to be displayed corresponding to an unselected sort option */
  unselected: Icon;
};

/** Represents the object required to render the Sorting display in a loading state on client */
export type FlightsSortLoadingPresentation = FlightsSortPresentation & {
  __typename?: "FlightsSortLoadingPresentation";
  /** Represents the 'sort by' label */
  label: Scalars["String"];
  /** Represents the selected sort option */
  selectedOption: FlightsSortOptionItem;
  /** Sort option picker is inactive in case of NFFs.This boolean represents whether the picker is active or inactive */
  selectionActive: Scalars["Boolean"];
};

/** Represents a sort option for sorting display */
export type FlightsSortOptionItem = {
  __typename?: "FlightsSortOptionItem";
  /** Represents the accessibility message for this sort option */
  accessibility?: Maybe<FlightsAccessibilityMessage>;
  /** Represents the analytics to track on interaction with this sort */
  analytics: FlightsAnalytics;
  /** Represents the label corresponding to the sort option */
  label: Scalars["String"];
  /** Represents the FlightsSortOptionType associated with this option. Clients have to send this back in the subsequent request to the server */
  sortType: FlightsSortOptionType;
};

/** Represents the combination of SortType and SortOrder ex. Price Increasing */
export type FlightsSortOptionType = {
  __typename?: "FlightsSortOptionType";
  /** The array of all cross-sort parameters selected by the user */
  crossSortOptionList?: Maybe<Array<FlightsCrossSortOption>>;
  /** @deprecated Use crossSortOptionList instead */
  crossSortOptionType?: Maybe<FlightsCrossSortOptionType>;
  sortOrder: FlightsSortOrder;
  sortType: FlightsSortType;
};

/** Represents the combination of SortType and SortOrder ex. Price Increasing */
export interface FlightsSortOptionTypeInput {
  /** The array of all cross-sort parameters selected by the user */
  crossSortOptionList?: InputMaybe<Array<FlightsCrossSortOptionInput>>;
  crossSortOptionType?: InputMaybe<FlightsCrossSortOptionTypeInput>;
  sortOrder: FlightsSortOrder;
  sortType: FlightsSortType;
}

/** Enum which lists the sort orders */
export type FlightsSortOrder = "DECREASING" | "INCREASING";

/** Represents the object required to render the Sorting display on client */
export interface FlightsSortPresentation {
  /** Represents the 'sort by' label */
  label: Scalars["String"];
  /** Represents the selected sort option */
  selectedOption: FlightsSortOptionItem;
  /** Sort option picker is inactive in case of NFFs.This boolean represents whether the picker is active or inactive */
  selectionActive: Scalars["Boolean"];
}

/** Enum class which lists all the supported sorting criteria */
export type FlightsSortType =
  | "ARRIVAL"
  | "BEST_BETS"
  | "CROSS_SORT"
  | "DEPARTURE"
  | "DURATION"
  | "PRICE"
  | "RECOMMENDED";

/** Sponsored Content Ad Placement Listing */
export type FlightsSponsoredContentAdListing = {
  __typename?: "FlightsSponsoredContentAdListing";
  /** Represents the sponsored content placement */
  sponsoredContentPlacement: SponsoredContentPlacement;
};

export type FlightsStandardFareSelectedJourneyDetails = FlightsSelectedJourneyDetails & {
  __typename?: "FlightsStandardFareSelectedJourneyDetails";
  /** Represents information sent to clients to help user change the selected flight */
  changeFlight: FlightsAction;
  /** Represents change flight dialog */
  changeFlightDialog?: Maybe<FlightsDialogChangeFlight>;
  /** Summary of the selected fare and an option to either see details or change fare, in case there are no amenities bag details will be sent */
  fareDetails: FareDetails;
  /** Summary and Details for a Journey */
  flightsJourneyInformation?: Maybe<FlightsDetailedJourneyInformation>;
  /** Policies for the Journey */
  flightsJourneyPolicies?: Maybe<FlightsTextSection>;
  /** Represents the basic highlights in multiple segments or Origin Destination pairs */
  journeyHighlights: Array<FlightsJourneyHighlights>;
  /** Represents onView analytics for Journey Information. This will be triggered when it is visible on the client's viewport */
  onViewedAnalytics?: Maybe<FlightsAnalytics>;
};

/** The standard flights search results offer representing a flight offer based on user' search criteriaIt will have one, two or multiple `journeys` representing flights in case of one way, two way, or multi city searches */
export type FlightsStandardOffer = FlightsOffer & {
  __typename?: "FlightsStandardOffer";
  /** Represents the accessibility heading for the standard flight offer */
  accessibilityHeading?: Maybe<Scalars["String"]>;
  /** Represents the accessibility message for the standard flight offer */
  accessibilityMessage?: Maybe<Scalars["String"]>;
  /** Represents additional info reg the fare , ex. 'There may be additional fee based .....' */
  additionalMessaging?: Maybe<FlightsPhrase>;
  /**
   * Represents the list of badges
   * @deprecated Use badgesList as that one uses EGDSBadge
   */
  badges?: Maybe<Array<FlightsBadge>>;
  /** Represents the list of badges */
  badgesList?: Maybe<Array<EgdsBadge>>;
  /** Represents the Baggage fee info clickable link shown on the flight offer listing */
  baggageFeesInformation?: Maybe<FlightsOfferBaggageFeesInformation>;
  /** Represents the info-link clicking on which opens tool-tip with more details */
  displayDetailsAction: FlightsToggle;
  /** Represents various analytics associated with an offer */
  flightsOfferAnalytics: FlightsOfferAnalytics;
  /** Represents the tray window shown with fare rule details about the offer listing  */
  flightsOfferFareRulesPresentation?: Maybe<FlightsOfferFareRulesPresentation>;
  /** Represents whether the flight is eligible for free cancellation or not. This will only be used by mobile for making FIS loading state */
  freeCancellation: FreeCancellationApplicability;
  /** Represents the jcid if this offer is selected. */
  journeyContinuationId?: Maybe<Scalars["String"]>;
  /** Represents the list of FlightOfferJourney objects. FlightJourney object has all the details necessary for rendering the details of the Flights offer */
  journeys: Array<FlightsOfferJourney>;
  /** Represents the analytics to track on interaction with trigger */
  onClickAnalyticsList: Array<FlightsAnalytics>;
  /** Represents the highlight text for a pinned offer' */
  pinnedOfferMessage?: Maybe<Scalars["String"]>;
  /** Represents the pricing info for the offer listing */
  pricingInformation: FlightsPricingInformation;
  /** Represents the info displayed on the pop-up that shows up on mApp for restrictive fares */
  restrictiveFareRules?: Maybe<FlightsRestrictiveFareRules>;
  /** Represents the select button shown on the offer listing */
  selectOfferAction: FlightsAction;
  /** Represents special fare type tags like 'Starter' or 'Fly' */
  specialFareType?: Maybe<Scalars["String"]>;
  /** Represents the Sponsored messaging shown with the offer listing */
  sponsoredAirline?: Maybe<FlightsOfferSponsoredAirline>;
  /** Represents the flight superlatives messaging on the offer listing */
  tag?: Maybe<FlightsOfferTag>;
};

/** Represents information needed for step indicator loading state and query for loaded state to MIS spinner */
export type FlightsStepIndicator = {
  __typename?: "FlightsStepIndicator";
  /** Represents the error analytics for step indicator */
  errorAnalytics: FlightsAnalytics;
  /**  journeyContinuationId containing encoded data for MIS spinner for rendering loaded step indicator. */
  journeyContinuationId: Scalars["String"];
  /** Count for skeletons of step indicator based on device type and page */
  skeletonCount?: Maybe<Scalars["Int"]>;
};

/** Represents the value associated with number of stops based filter */
export type FlightsStopBasedFilterValue = {
  __typename?: "FlightsStopBasedFilterValue";
  stopInfo: FlightsStopInfo;
};

/** Represents the value associated with number of stops based filter */
export interface FlightsStopBasedFilterValueInput {
  stopInfo: FlightsStopInfoInput;
}

/** Enum class to represent the operation associated with num of stops */
export type FlightsStopFilterOperation = "EQUAL" | "GREATER_THAN_EQUAL" | "LESS_THAN_EQUAL";

/** Represents the stop related info for each number of stops based filter value. Combination of the number of stops and an operation.Ex. 2+ would be represented by {2,MORE_THAN} , 2 by {2,EQUAL} and <2 by {2,LESS_THAN} */
export type FlightsStopInfo = {
  __typename?: "FlightsStopInfo";
  numberOfStops: Scalars["Int"];
  stopFilterOperation: FlightsStopFilterOperation;
};

/** Represents the stop related info for each number of stops based filter value. Combination of the number of stops and an operation.Ex. 2+ would be represented by {2,MORE_THAN} , 2 by {2,EQUAL} and <2 by {2,LESS_THAN} */
export interface FlightsStopInfoInput {
  numberOfStops: Scalars["Int"];
  stopFilterOperation: FlightsStopFilterOperation;
}

/** Represents each filter item in suggested filters on flight search results */
export type FlightsSuggestedFilterItem = FlightsFilterItem & {
  __typename?: "FlightsSuggestedFilterItem";
  /** Represents the accessibility message for the filter item */
  accessibility?: Maybe<FlightsAccessibilityMessage>;
  /** Boolean which represents whether a particular item is selected or not when filters are cleared */
  defaultSelected: Scalars["Boolean"];
  /** Represents the object to be sent back to the server in the subsequent request when this particular filter item is selected */
  flightsSearchFilterValues: FlightsSearchFilterValues;
  /** Represents the identifier for the particular filter item */
  identifier: Scalars["String"];
  /** Represents the label for this filter item */
  label: Scalars["String"];
  /** Boolean which represents whether a particular item is selected or not */
  selected: Scalars["Boolean"];
  /** Represents the filter value for this filter item. Would aid in solving the client side sort and filter */
  shoppingFilterValue: SelectedValue;
  /** Represents the FilterType for this suggested filter option */
  type: FlightsFilterType;
  /** Represents the filter value for this filter item. Would aid in solving the client side sort and filter */
  value: FlightsFilterValue;
};

/** Represents the listing displayed for flights suggested filter */
export type FlightsSuggestedFilterMessageListing = {
  __typename?: "FlightsSuggestedFilterMessageListing";
  /** Represents the accessibility message for SuggestedFilter listing */
  accessibilityMessage: Scalars["String"];
  /** Represents the suggested filter in the listing */
  suggestedFilter: FlightsSuggestedFilterItem;
  /** Represents the heading, message, clickable text(s) and image to show on the suggested filter banner. */
  suggestedFilterDetails: FlightsImagePlacard;
};

/** Represents information needed for supported ancillary summary loading state and query for ancillary loaded state */
export type FlightsSupportedAncillaryInfo = {
  __typename?: "FlightsSupportedAncillaryInfo";
  /** Represents the supported ancillaries */
  ancillaryTypes: Array<FlightsAncillaryType>;
  /** Represent the continuation identifier for spinner to deduce all journeys selected by the user. */
  journeyContinuationId: Scalars["String"];
};

/** The Sustainability card section of the Details and Fares dialog */
export type FlightsSustainabilityCard = {
  __typename?: "FlightsSustainabilityCard";
  /** Content of the headers section. */
  cardContent: FlightsIconPhrases;
};

/** Represents the details for dialog card over the listings */
export type FlightsSustainabilityDialogDetails = {
  __typename?: "FlightsSustainabilityDialogDetails";
  /** Represents the sub items on dialog */
  closingText: FlightsTextSection;
  /** Represents the dismiss action for dialog */
  dismiss: FlightsAction;
  /** Represents the heading shown on the dialog. Eg: Small Changes, big impact */
  heading: Scalars["String"];
  /** Represents the equivalence of information on dialog */
  iconRow: FlightsIconAndHeading;
  /** Represents the text on dialog that describes information */
  introduction: Array<FlightsPhrase>;
};

/** Represents the sustainability card in the listings */
export type FlightsSustainabilityMessage = {
  __typename?: "FlightsSustainabilityMessage";
  /** Represents the dialog content for more information */
  details: FlightsSustainabilityDialogDetails;
  /** Represents information on the icon card */
  information: FlightsIconPlacard;
};

/** Describes an actionable area to swap between locations */
export type FlightsSwapLocationAction = {
  __typename?: "FlightsSwapLocationAction";
  /** Represents the accesibility text for actionable area */
  accessibilityMessage: Scalars["String"];
  /** Represents the accesibility message for interaction with the icon */
  accessibilityUsageMessage: FlightsSimpleLocalizationTemplate;
  /** Represents the analytics to track on interaction with trigger. */
  analytics: FlightsAnalytics;
  /** Icon for the swap action */
  icon: FlightsResponsiveIcon;
  /** Represents the accesibility text for the actionable area when more than one journey is expected. */
  multiDestAccessibilityMessage: FlightsSimpleLocalizationTemplate;
};

export type FlightsSwitchToggle = UiToggle & {
  __typename?: "FlightsSwitchToggle";
  checked: Scalars["Boolean"];
  checkedAccessibilityLabel?: Maybe<Scalars["String"]>;
  checkedAnalytics?: Maybe<ClientSideAnalytics>;
  checkedDescription?: Maybe<Scalars["String"]>;
  checkedLabel: Scalars["String"];
  /** Represents an action to be performed on the client side when the switch is toggled */
  clientAction: FlightsClientAction;
  enabled: Scalars["Boolean"];
  label: Scalars["String"];
  uncheckedAccessibilityLabel?: Maybe<Scalars["String"]>;
  uncheckedAnalytics?: Maybe<ClientSideAnalytics>;
  uncheckedDescription?: Maybe<Scalars["String"]>;
  uncheckedLabel: Scalars["String"];
};

/** Represents an action to toggle */
export type FlightsSwitchToggleAction = FlightsClientAction & {
  __typename?: "FlightsSwitchToggleAction";
  /** Used to provide accessibility that has to be read on completion of action. */
  accessibility?: Maybe<Scalars["String"]>;
  /** Used to capture client side analytics */
  analyticsList: Array<ClientSideAnalytics>;
  /** Used to provide accessibility announcement that has to be read toggling on. */
  checkedAccessibilityAnnouncement?: Maybe<Scalars["String"]>;
  /** Used to provide accessibility announcement that has to be read toggling off. */
  uncheckedAccessibilityAnnouncement?: Maybe<Scalars["String"]>;
};

/** Represents a interface for text message with an image/icon */
export interface FlightsText {
  /** Represents the text message */
  text: Array<FlightsPhrase>;
}

/** Represents a text list item that can support elements with different styles */
export type FlightsTextContainerListItem = EgdsTextListItem & {
  __typename?: "FlightsTextContainerListItem";
  /** Represents the content of the list item. Could be any of the implementations of EGDSText, some of which support different styling */
  content: EgdsText;
  /** Optional nested Text List */
  nestedList?: Maybe<EgdsTextList>;
  /** Represents the text style used for this item (e.g. Positive, Negative, Emphasis, etc) */
  style?: Maybe<EgdsTextListItemStyle>;
  /** Represents the subHeading/subTitle/description of a List Item/Element. */
  subText?: Maybe<Scalars["String"]>;
  /** Represents the heading/title of a List Item/Element. */
  text: Scalars["String"];
};

/** Represents messages to be displayed */
export type FlightsTextSection = {
  __typename?: "FlightsTextSection";
  /** Represents Show/Hide details toggle for text section */
  displayAction?: Maybe<FlightsToggle>;
  /** Represents the display analytics for the Text section. */
  displayAnalytics?: Maybe<FlightsAnalytics>;
  /** Represents a list of analytics for the Text section. */
  displayAnalyticsList?: Maybe<Array<FlightsAnalytics>>;
  /** Represents heading for the text section */
  heading?: Maybe<Scalars["String"]>;
  /** Represents the list of text messages */
  messages: Array<FlightsPhrase>;
  /** Represents onView analytics for a Text section. This will be triggered when the text section is visible on the client's viewport */
  onViewedAnalytics?: Maybe<FlightsAnalytics>;
};

/** This represents a decorator that can be applied to a section */
export type FlightsTextSectionDecorator =
  /** This represents a separator that renders after the text section */
  | "BOTTOMSEPARATOR"
  /** This represents a separator that renders above the text section */
  | "TOPSEPARATOR";

/** Represents the value associated with any time based filter, like DepartureTime or ArrivalTime based filter */
export type FlightsTimeBasedFilterValue = {
  __typename?: "FlightsTimeBasedFilterValue";
  timeOfDay: FlightsTimeOfDay;
};

/** Represents the value associated with any time based filter, like DepartureTime or ArrivalTime based filter */
export interface FlightsTimeBasedFilterValueInput {
  timeOfDay: FlightsTimeOfDay;
}

/** Enum representing the various time slots in a day  */
export type FlightsTimeOfDay = "AFTERNOON" | "EARLY_MORNING" | "EVENING" | "MORNING";

/** Represents an object to be used for toggle/expandable nodes */
export type FlightsToggle = {
  __typename?: "FlightsToggle";
  /** Represents the toggle for to be collapsed phase. For Eg. Show Less ... */
  collapseActionable: TogglePhase;
  /** Represents the toggle for to be expanded phase. For Eg. Show More ... */
  expandActionable: TogglePhase;
  /** Represents initial state of toggle */
  expanded: Scalars["Boolean"];
};

/** Represents the value associated with travel and baggage filter */
export type FlightsTravelAndBaggageBasedFilterValue = {
  __typename?: "FlightsTravelAndBaggageBasedFilterValue";
  travelAndBaggageName: FilterTravelAndBaggageType;
};

/** Represents the value associated with travel and baggage filter */
export interface FlightsTravelAndBaggageBasedFilterValueInput {
  travelAndBaggageName: FilterTravelAndBaggageType;
}

export type FlightsTravelerAgeSelector = {
  __typename?: "FlightsTravelerAgeSelector";
  /** Represents the analytics to track on change of a child age */
  analytics: FlightsAnalytics;
  /** Chevron icon */
  icon: Icon;
  /** Represents the list of valid age options */
  items: Array<FlightsSearchFormTravelerAgeOptionItem>;
  /** Label ex. 'Age of child 1' */
  label: FlightsSimpleLocalizationTemplate;
  /** Field placeholder. Example: 'Age */
  placeholder: Scalars["String"];
};

/** Traveler details for flights search */
export type FlightsTravelerDetails = {
  __typename?: "FlightsTravelerDetails";
  /** Age for each traveler */
  ages?: Maybe<Array<Scalars["Int"]>>;
  /** Traveler count */
  count: Scalars["Int"];
  /** Traveler type */
  travelerType: FlightsTravelerType;
};

/** Traveler details for flights search */
export interface FlightsTravelerDetailsInput {
  /** Age for each traveler */
  ages?: InputMaybe<Array<Scalars["Int"]>>;
  /** Traveler count */
  count: Scalars["Int"];
  /** Traveler type */
  travelerType: FlightsTravelerType;
}

/** Represent all the possible traveler types */
export type FlightsTravelerType = "ADULT" | "CHILD" | "INFANT_IN_LAP" | "INFANT_IN_SEAT";

/** Represents the selected trip summary on the servicing view */
export type FlightsTripSummary = {
  __typename?: "FlightsTripSummary";
  /** Represents the trip summary heading (ie: 'Roundtrip flight') */
  heading: Scalars["String"];
  /** Represents the trip summary journey playback */
  journeys: Array<FlightsTripSummaryJourney>;
  /** Represents the trip summary subheading (ie: '2 tickets: 2 adults') */
  subheading: Scalars["String"];
};

export type FlightsTripSummaryJourney = {
  __typename?: "FlightsTripSummaryJourney";
  /** Represents the message for accessibility on the trip summary journey heading */
  accessibility?: Maybe<Scalars["String"]>;
  /** Represents the trip summary items detailing the journey information */
  contentItems: Array<FlightsInformationText>;
  /** Represents the trip summary journey heading (origin and destination) */
  header?: Maybe<EgdsHeading>;
  /**
   * Represents the trip summary journey heading (origin and destination)
   * @deprecated This will be replaced by header & accessibility fields
   */
  heading: FlightsMessageAndAccessibility;
  /**
   * Represents the trip summary items detailing the journey information
   * @deprecated This will be replaced with contentItems
   */
  items: Array<FlightsTripSummaryJourneyItem>;
};

export type FlightsTripSummaryJourneyItem = {
  __typename?: "FlightsTripSummaryJourneyItem";
  /** Represents the message for accessibility on the text describing journey information */
  accessibility?: Maybe<Scalars["String"]>;
  /** Difference between arrival a departure days. Example: '+2' or '+1' */
  differentDayArrival?: Maybe<EgdsStylizedText>;
  /** Represents the icon next to the airline information */
  icon?: Maybe<Icon>;
  /**
   * Represents text describing journey information
   * @deprecated This will be replaced by text & accessibility fields
   */
  label: FlightsMessageAndAccessibility;
  /** Represents text describing journey information */
  text?: Maybe<EgdsPlainText>;
};

/** Trip type chosen in flight search */
export type FlightsTripType = "MULTI_DESTINATION" | "ONE_WAY" | "ROUND_TRIP";

/** Represents the placard (banner/messaging cards) */
export interface FlightsUiPlacard {
  /** Represents the display type for banners */
  displayType: FlightsPlacardDisplayType;
  /** Represents onView analytics for a Placard. This will be triggered when the placard is visible on the client's viewport */
  onViewedAnalytics?: Maybe<FlightsAnalytics>;
  /** Represents onView analytics list for a Placard. This will be triggered when the placard is visible on the client's viewport */
  onViewedAnalyticsList?: Maybe<Array<ClientSideAnalytics>>;
}

/** Dialog used to display floorPlan */
export type FloorPlanDialog = LodgingDialog & {
  __typename?: "FloorPlanDialog";
  images: Array<PropertyImage>;
  toolbar?: Maybe<LodgingDialogToolbar>;
  trigger: LodgingDialogTriggerMessage;
};

/** Footer data from Global Navigation */
export type Footer = {
  __typename?: "Footer";
  footerHeadingLabel?: Maybe<Scalars["String"]>;
  minimal?: Maybe<Scalars["Boolean"]>;
  sectionData: Array<Maybe<FooterSectionData>>;
};

export type FooterButton = {
  __typename?: "FooterButton";
  target?: Maybe<Scalars["String"]>;
  text?: Maybe<Scalars["String"]>;
  trackingEvent?: Maybe<Scalars["String"]>;
  type: FooterButtonType;
  url?: Maybe<Scalars["URL"]>;
};

export type FooterButtonType = "PRIMARY" | "SECONDARY" | "TERTIARY";

export type FooterData =
  | FooterButton
  | FooterImage
  | FooterLink
  | FooterSeparator
  | FooterText
  | NorthstarFooterImage
  | NorthstarFooterSection
  | NorthstarFooterSectionLink
  | NorthstarFooterText;

export type FooterImage = {
  __typename?: "FooterImage";
  altText?: Maybe<Scalars["String"]>;
  imgSrc?: Maybe<Scalars["URL"]>;
  newWindowText?: Maybe<Scalars["String"]>;
  target?: Maybe<Scalars["String"]>;
  url?: Maybe<Scalars["URL"]>;
};

export type FooterLink = {
  __typename?: "FooterLink";
  target?: Maybe<Scalars["String"]>;
  text?: Maybe<Scalars["String"]>;
  trackingEvent?: Maybe<Scalars["String"]>;
  url?: Maybe<Scalars["URL"]>;
};

export type FooterSectionButtons = FooterSectionData & {
  __typename?: "FooterSectionButtons";
  data: Array<Maybe<FooterData>>;
};

export interface FooterSectionData {
  data: Array<Maybe<FooterData>>;
}

export type FooterSectionImages = FooterSectionData & {
  __typename?: "FooterSectionImages";
  data: Array<Maybe<FooterImage>>;
};

export type FooterSectionLinks = FooterSectionData & {
  __typename?: "FooterSectionLinks";
  data: Array<Maybe<FooterLink>>;
};

export type FooterSectionText = FooterSectionData & {
  __typename?: "FooterSectionText";
  data: Array<Maybe<FooterText>>;
};

export type FooterSeparator = {
  __typename?: "FooterSeparator";
  type: FooterSeparatorType;
};

export type FooterSeparatorType = "HORIZONTAL_RULE";

export type FooterText = {
  __typename?: "FooterText";
  text?: Maybe<Scalars["String"]>;
};

export type Forecast = {
  __typename?: "Forecast";
  /** Display Date of the forecast */
  date?: Maybe<Scalars["String"]>;
  /** Weather Icon */
  icon?: Maybe<Icon>;
  /** Chances of rain */
  precipitationProbablity?: Maybe<Scalars["String"]>;
  /** Mobile link to Accuweather's website */
  seeMoreLink?: Maybe<Scalars["String"]>;
  /** Label for hyperlink to Accuweather's website  */
  seeMoreLinkText?: Maybe<Scalars["String"]>;
  /** Min/Max Temperature with unit */
  temperature?: Maybe<Array<TemperatureRange>>;
  /** Unique id for Weather condition */
  weatherConditionId: Scalars["Int"];
  /** Phrase describing weather condition */
  weatherDescription?: Maybe<Scalars["String"]>;
};

export type ForecastsResponseData = {
  __typename?: "ForecastsResponseData";
  dailyForecasts: Array<Forecast>;
  expires?: Maybe<DateTime>;
  severity: Scalars["Int"];
};

export type FormattedMoney = AccessibilityField & {
  __typename?: "FormattedMoney";
  /** Label where a11y behavior is needed. */
  accessibilityLabel?: Maybe<Scalars["String"]>;
  /** The amount localised and formatted. */
  formatted: Scalars["String"];
  /** @deprecated Use accessibilityLabel., replace with accessibilityLabel */
  label?: Maybe<Scalars["String"]>;
};

/** Numbers that also need to be formatted */
export type FormattedNumber = {
  __typename?: "FormattedNumber";
  /**
   * The formatted number value
   * @deprecated Use platform formatters and return localized strings instead
   */
  formatted: Scalars["String"];
  /**
   * The raw number value
   * @deprecated Use platform formatters and return localized strings instead
   */
  raw: Scalars["Float"];
};

export type FraudComponentDetails = {
  __typename?: "FraudComponentDetails";
  /** The associated placement of the widget (i.e. an enumeration of the web page's use case). */
  placement: Scalars["String"];
  /** This value is used by TrustWidget for tracking and is a combination of multiple fields. */
  reportingSegment: Scalars["String"];
  /** TrustWidget source, this is to be used as source on an async <script> tag. */
  url: Scalars["String"];
  /** The way by which the browser's session ID will be provided to the Trust Widget script. */
  webSessionProviderMethod: Scalars["String"];
  /** Helps the TrustWidget script how to retrieve and populate the session ID. */
  webSessionProviderMethodParam: Scalars["String"];
};

/** Represents all the common information in the journey review block on FIS  */
export type FreeCancellationApplicability = "ALL_JOURNEYS" | "CURRENT_JOUNRNEY" | "NOT_APPLICABLE";

/** A modal contains features and cancellation rules of free pmp. */
export type FreePmpDetailsModal = {
  __typename?: "FreePmpDetailsModal";
  /** Displays the cancellation rule for free pmp if the flight changes. */
  cancellationRule: Scalars["String"];
  /** Represents features of free PMP, e.g., [{timeline, We'll auto-check the price everyday}] */
  productFeatures: Array<FlightsIconAndLabel>;
  /** The title of the modal, e.g., Price Match Promise */
  title: Scalars["String"];
};

/** Free Price Match Promise UI Model */
export type FreePriceMatchPromise = {
  __typename?: "FreePriceMatchPromise";
  /** The placard to be shown on FSR & FIS */
  card: FlightsImagePlacard;
  /** A UI model represents the details modal for free pmp */
  detailsModal: FreePmpDetailsModal;
};

/** Frequently Asked Questions Content wrapper. */
export type FrequentlyAskedQuestions = TravelExperienceContent & {
  __typename?: "FrequentlyAskedQuestions";
  id: Scalars["ID"];
  /** List of frequently asked questions */
  questionsAndAnswers: Array<QuestionAndAnswer>;
  /** Use this button to see less */
  seeLess: EgdsButton;
  /** Use this button to see more questions */
  seeMore: EgdsButton;
  /** Required SEO data for google bots to show a preview of the FAQ questions in the search box. */
  seoStructuredData?: Maybe<Scalars["String"]>;
  /** Default title = Frequently asked questions */
  title: Scalars["String"];
};

export type FunnelLocation =
  | "CHECKOUT"
  | "CHECKOUT_ERROR"
  | "CONFIRMATION"
  | "DETAILS"
  | "ENTRY"
  | "FEATURES"
  | "PAYMENT_ERROR"
  | "POST_BOOKING"
  | "SEARCH_RESULTS"
  | "SYSTEM"
  | "USER";

export type Gaia = {
  __typename?: "Gaia";
  destination: Scalars["Int"];
  origin?: Maybe<Scalars["Int"]>;
  pointOfInterest?: Maybe<Scalars["String"]>;
};

/** Possible direction types for ground transfers */
export type GeoType = "AIRPORT" | "DESTINATION" | "PROPERTY";

/** Support for `geo` based URI constructed with latitude, longitude and uncertainty */
export type GeoUri = Uri & {
  __typename?: "GeoURI";
  latitude: Scalars["Float"];
  longitude: Scalars["Float"];
  uncertainty?: Maybe<Scalars["Int"]>;
  value: Scalars["String"];
};

/** Geo feature from gaia */
export type GeographicFeature = {
  __typename?: "GeographicFeature";
  coordinates: Coordinates;
  fullName: Scalars["String"];
  id: Scalars["String"];
  name: Scalars["String"];
  type: RegionType;
};

export type GetReviewQuestionsResponse = {
  __typename?: "GetReviewQuestionsResponse";
  sectionGroups?: Maybe<Array<ReviewSectionGroup>>;
};

export type GlanceCobrowseConfiguration = {
  __typename?: "GlanceCobrowseConfiguration";
  environment: Scalars["String"];
  groupid: Scalars["String"];
  inputEvents: Scalars["String"];
  locale: Scalars["String"];
  scriptSrc: Scalars["String"];
};

export type GlobalInspiration = {
  __typename?: "GlobalInspiration";
  bodyCopy: Scalars["String"];
  headline: Scalars["String"];
  iconImageUrl: Scalars["String"];
  inspirations: Array<Inspiration>;
};

/** Line of business that is querying the global navigation elements. */
export type GlobalNavigationLineOfBusiness = "ACTIVITY" | "CAR" | "CRUISE" | "FLIGHT" | "HOTEL" | "PACKAGE" | "UNKNOWN";

/**
 * An object with simple key/value combination. This can be used to represent generic input where you do not know all the values that can be provided.
 *
 * It should be avoided in favor of a strict type with set fields, but can be useful in specific situations.
 */
export type GraphQlPair = {
  __typename?: "GraphQLPair";
  key: Scalars["String"];
  value: Scalars["String"];
};

/**
 * An object with simple key/value combination. This can be used to represent generic input where you do not know all the values that can be provided.
 *
 * It should be avoided in favor of a strict type with set fields, but can be useful in specific situations.
 */
export interface GraphQlPairInput {
  key: Scalars["String"];
  value: Scalars["String"];
}

export type GroundTransfersAction =
  | GroundTransfersBookAction
  | GroundTransfersDetailsOpenAction
  | GroundTransfersDismissAction
  | GroundTransfersLinkClickAction
  | GroundTransfersMultiItemTripUpdateAction
  | GroundTransfersSelectionClickAction;

export type GroundTransfersActionCallbackMessages = {
  __typename?: "GroundTransfersActionCallbackMessages";
  /** Message for failure callback */
  failure: Scalars["String"];
  /** Message for success callback */
  success: Scalars["String"];
};

/** Used for displaying text with action */
export type GroundTransfersActionText = GroundTransfersText & {
  __typename?: "GroundTransfersActionText";
  /** Action associated to text */
  action: GroundTransfersAction;
  /** Text style to apply to text */
  style: GroundTransfersStyle;
  /** Text value to be displayed */
  text: Scalars["String"];
};

export type GroundTransfersBadge = {
  __typename?: "GroundTransfersBadge";
  /** icon, mark info to be displayed on the badge */
  graphic?: Maybe<UiGraphic>;
  /** label to be displayed on the badge like 10% off or Trip savings */
  label?: Maybe<Scalars["String"]>;
  /** theme to be displayed on the badge */
  theme: GroundTransfersBadgeTheme;
};

export type GroundTransfersBadgeTheme = "DEAL_BUNDLED" | "DEAL_GENERIC" | "DEAL_MEMBER";

export type GroundTransfersBookAction = UiAction & {
  __typename?: "GroundTransfersBookAction";
  accessibility?: Maybe<Scalars["String"]>;
  /** Analytics information associated with the link click */
  analytics: ClientSideAnalytics;
  /** Link of the book button along with all the details required for the create trip call */
  url: Scalars["String"];
};

export type GroundTransfersCard = GroundTransfersResultCard | GroundTransfersUiMessagingCard;

export type GroundTransfersDetailsContent = {
  __typename?: "GroundTransfersDetailsContent";
  /**
   * List of bullet points to be displayed in the dialog
   * @deprecated use tabs now
   */
  details: Array<GroundTransfersText>;
  /** Heading of the content */
  heading?: Maybe<GroundTransfersText>;
  /** ground transfer details shown on tabs */
  tabs: Array<GroundTransfersDetailsTab>;
};

export type GroundTransfersDetailsOpenAction = UiAction & {
  __typename?: "GroundTransfersDetailsOpenAction";
  accessibility?: Maybe<Scalars["String"]>;
  /** Analytics information associated with the link click */
  analytics: ClientSideAnalytics;
  /** Dialog to be opened when the action is made */
  details: GroundTransfersDetailsPresentation;
};

export type GroundTransfersDetailsPresentation = {
  __typename?: "GroundTransfersDetailsPresentation";
  /** Content of the button in the details section */
  bookButton: UiPrimaryButton;
  /**
   * Content of the details section
   * @deprecated Use structuredContent now
   */
  content: Array<GroundTransfersDetailsContent>;
  /** Dismiss action to close the dialog */
  dismissButton: UiTertiaryButton;
  /** Structured content of the details section */
  structuredContent: Array<GroundTransfersDetailsStructuredContent>;
  /** Title to be displayed on the dialog toolbar */
  title?: Maybe<Scalars["String"]>;
};

export type GroundTransfersDetailsStructuredContent =
  | GroundTransfersPlainStructuredContent
  | GroundTransfersTabularStructuredContent;

export type GroundTransfersDetailsTab = {
  __typename?: "GroundTransfersDetailsTab";
  /** Content body */
  details: Array<GroundTransfersStructuredSection>;
  /** Detail to be shown at the end */
  footer: Array<GroundTransfersText>;
  /** Label shown on the tab */
  label: Scalars["String"];
};

/** Possible direction types for ground transfers */
export type GroundTransfersDirection = "FROM_AIRPORT" | "ROUNDTRIP" | "TO_AIRPORT";

export type GroundTransfersDismissAction = UiAction & {
  __typename?: "GroundTransfersDismissAction";
  accessibility?: Maybe<Scalars["String"]>;
  /** Analytics information associated with the link click */
  analytics: ClientSideAnalytics;
};

export type GroundTransfersDropdownField = ShoppingSortAndFilterField & {
  __typename?: "GroundTransfersDropdownField";
  options: Array<ShoppingSelectableFilterOption>;
  primary?: Maybe<Scalars["String"]>;
  secondary?: Maybe<Scalars["String"]>;
};

export type GroundTransfersFigure = {
  __typename?: "GroundTransfersFigure";
  /** Badge to be displayed on top of the image */
  badge?: Maybe<GroundTransfersBadge>;
  /** Image to be displayed like that of the GT result */
  image?: Maybe<Image>;
};

/** Used for displaying text with Graphic and action. */
export type GroundTransfersGraphicText = GroundTransfersText & {
  __typename?: "GroundTransfersGraphicText";
  /** accessibility label when the accessibility string is different from the text. Eg: for duration, text: 6h, accessibilityText: Travel time 6 hours */
  accessibilityText?: Maybe<Scalars["String"]>;
  /** Action associated to text */
  action?: Maybe<GroundTransfersAction>;
  /** leading graphic (icon/mark/illustration) to display with text */
  leading?: Maybe<UiGraphic>;
  /** Text style to apply to text */
  style: GroundTransfersStyle;
  /** Text value to be displayed */
  text: Scalars["String"];
  /** leading graphic (icon/mark/illustration) to display with text */
  trailing?: Maybe<UiGraphic>;
};

export type GroundTransfersGroup = {
  __typename?: "GroundTransfersGroup";
  /** A list of analytics information for impression tracking of the group */
  analytics: Array<ClientSideAnalytics>;
  /** List of GroundTransfers/message cards sorted in the required order */
  cards: Array<GroundTransfersCard>;
  /** Heading to be displayed for a group of gt cards */
  heading?: Maybe<GroundTransfersText>;
  /** Defines the action information of the navigation UI component. Eg: Carousel component in cross-sell module */
  navigationActions?: Maybe<GroundTransfersNavigationActions>;
  /** Defines the way in which the cards are to be displayed on UI */
  viewType: GroundTransfersGroupViewType;
};

export type GroundTransfersGroupViewType = "CARDS_LIST";

/** Provides the ground transfers criteria for each part of the journey. For instance, round-trip journey will comprise 2 parts, airport(origin) to hotel(destination) and hotel(origin) to airport(destination). */
export type GroundTransfersJourneyCriteria = {
  __typename?: "GroundTransfersJourneyCriteria";
  dateTime: DateTime;
  destination: GroundTransfersLocation;
  origin: GroundTransfersLocation;
};

/** Provides the ground transfers criteria for each part of the journey. For instance, round-trip journey will comprise 2 parts, airport(origin) to hotel(destination) and hotel(origin) to airport(destination). */
export interface GroundTransfersJourneyCriteriaInput {
  dateTime: DateTimeInput;
  destination: GroundTransfersLocationInput;
  origin: GroundTransfersLocationInput;
}

export type GroundTransfersLinkClickAction = UiAction & {
  __typename?: "GroundTransfersLinkClickAction";
  accessibility?: Maybe<Scalars["String"]>;
  /** Accessibility string for the link. Useful when the link opens in a new tab. */
  accessibilityText: Scalars["String"];
  /** Analytics information associated with the link click */
  analytics: ClientSideAnalytics;
  /** Relative Url to route outside the page */
  anchorTagUrl?: Maybe<Scalars["String"]>;
  /** Relative Url to route within the page */
  linkTagUrl?: Maybe<Scalars["String"]>;
  /** Defines whether to open the link in same or new tab */
  opensInNewTab: Scalars["Boolean"];
};

/** Provides the ground transfers location information for destination, airport and hotel */
export type GroundTransfersLocation = {
  __typename?: "GroundTransfersLocation";
  coordinates?: Maybe<Coordinates>;
  id?: Maybe<Scalars["String"]>;
  name?: Maybe<Scalars["String"]>;
  type: GeoType;
};

/** Provides the ground transfers location information for destination, airport and hotel */
export interface GroundTransfersLocationInput {
  coordinates?: InputMaybe<CoordinatesInput>;
  id?: InputMaybe<Scalars["String"]>;
  name?: InputMaybe<Scalars["String"]>;
  type: GeoType;
}

/** Loyalty Points Information */
export type GroundTransfersLoyaltyPointsOption = {
  __typename?: "GroundTransfersLoyaltyPointsOption";
  /** Loyalty points formatted text with points unit */
  formattedPoints: Scalars["String"];
  /** Caption before price or points, e.g. [or] [and] */
  leadingCaption: Scalars["String"];
  /** Boolean to indicate if points to be displayed first or cash */
  pointsFirst: Scalars["Boolean"];
};

export type GroundTransfersMap = {
  __typename?: "GroundTransfersMap";
  /** Accessibility text for the mini map link */
  accessibilityText: Scalars["String"];
  /** dismiss action to display on dialog */
  dismiss: UiTertiaryButton;
  /** Action associated with map click */
  expand: GroundTransfersAction;
  /** Map dialog title to display */
  header: Scalars["String"];
  /** labels to show for Map eg. travel duration or see map */
  labels: Array<GroundTransfersText>;
  /** Marker details to show on map */
  markers: Array<GroundTransfersMarker>;
  /** list of routes between airport and property */
  routes: Array<GroundTransfersMapRoute>;
};

export type GroundTransfersMapRoute = {
  __typename?: "GroundTransfersMapRoute";
  /** Transit used to reach destination to be displayed */
  transit: GroundTransfersMapTransitOption;
  /** Travel modes to reach destination to be displayed */
  travelMode: GroundTransfersMapTravelMode;
};

export type GroundTransfersMapTransitOption = "BUS" | "NONE" | "TRAIN";

export type GroundTransfersMapTravelMode = "DRIVING" | "TRANSIT";

export type GroundTransfersMarker = {
  __typename?: "GroundTransfersMarker";
  /** Analytics information associated with the marker click */
  analytics: ClientSideAnalytics;
  /** Coordinates of location */
  coordinates: Coordinates;
  /** detail card for property or airport */
  details: GroundTransfersMarkerDetails;
  /** Icon to display when the marked is clicked/selected */
  selectGraphic: UiGraphic;
  /** Icon to display when the markeris in default unselected state */
  unselectGraphic: UiGraphic;
};

export type GroundTransfersMarkerDetails = {
  __typename?: "GroundTransfersMarkerDetails";
  /** type property or airport */
  entityType: Scalars["String"];
  /** Name of property or airport */
  primary: Scalars["String"];
  /** Address of property or airport */
  secondary: Array<Scalars["String"]>;
};

export type GroundTransfersMetaInfo = {
  __typename?: "GroundTransfersMetaInfo";
  /** title for the page tab */
  title: Scalars["String"];
};

export type GroundTransfersMultiItemTripUpdateAction = UiAction & {
  __typename?: "GroundTransfersMultiItemTripUpdateAction";
  accessibility?: Maybe<Scalars["String"]>;
  analytics: ClientSideAnalytics;
  /** Messages corresponding to multi-item trip update callbacks */
  callbackMessages: GroundTransfersActionCallbackMessages;
  /** Natural Key that contains the offer token of the gt offer */
  naturalKey: GroundTransfersNaturalKey;
  /**
   * Product Natural Key for offer entity which uniquely determines the ground transfer. This includes, site id, Offer id, Offer dates, offer locale, total travellers selected to uniquely identify an offer.
   * @deprecated Use naturalKey
   */
  offerProductNaturalKey: Scalars["String"];
  /** Indicates the trip update action to be used - Add/Remove */
  updateTripType: UpdateTripType;
};

/** The ground transfers natural key that contains an offer token */
export type GroundTransfersNaturalKey = {
  __typename?: "GroundTransfersNaturalKey";
  offerToken: Scalars["String"];
};

/** The ground transfers natural key that contains an offer token */
export interface GroundTransfersNaturalKeyInput {
  offerToken: Scalars["String"];
}

export type GroundTransfersNavigationAction = {
  __typename?: "GroundTransfersNavigationAction";
  /** accessibility label for the navigation action */
  accessibility: Scalars["String"];
  /** Analytics information associated with the navigation action */
  analytics?: Maybe<ClientSideAnalytics>;
};

export type GroundTransfersNavigationActions = {
  __typename?: "GroundTransfersNavigationActions";
  /** next navigation action */
  next: GroundTransfersNavigationAction;
  /** previous navigation action */
  previous: GroundTransfersNavigationAction;
};

export type GroundTransfersNoResultsFoundMessage = {
  __typename?: "GroundTransfersNoResultsFoundMessage";
  /** Icon included at the top of the message. Example: Search icon */
  graphic?: Maybe<UiGraphic>;
  /** Text for search again. Eg: Try searching nearby airports or alternative dates */
  subtitle: Scalars["String"];
  /** Title of the message. Eg: Sorry, we couldn’t find any airport transportation */
  title: Scalars["String"];
};

export type GroundTransfersPlainStructuredContent = {
  __typename?: "GroundTransfersPlainStructuredContent";
  /** Heading of the plain structured content */
  heading?: Maybe<GroundTransfersText>;
  /** Ground transfer section to power simple content */
  sections: Array<GroundTransfersStructuredSection>;
};

/** Used for displaying plain text */
export type GroundTransfersPlainText = GroundTransfersText & {
  __typename?: "GroundTransfersPlainText";
  /** accessibility label when the accessibility string is different from the text. Eg: for review, text: 3/5, accessibilityText: 3 out of 5 */
  accessibilityText?: Maybe<Scalars["String"]>;
  /** Text style to apply to text */
  style: GroundTransfersStyle;
  /** Text value to be displayed */
  text: Scalars["String"];
};

export type GroundTransfersPriceInfo = {
  __typename?: "GroundTransfersPriceInfo";
  /** accessibility label for the price section */
  accessibilityLabel: Scalars["String"];
  /** Final retail price of the ground transfer */
  displayPrice: Scalars["String"];
  /** Loyalty Points Information */
  loyaltyPointsOption?: Maybe<GroundTransfersLoyaltyPointsOption>;
  /** Boolean to indicate if the strike-through price should be displayed before the display price */
  strikeThroughFirst: Scalars["Boolean"];
  /** Strikethrough price of the ground transfer */
  strikeThroughPrice: Scalars["String"];
  /** list of messages like one way/roundtrip, include/exclude taxes and fees */
  subtexts: Array<Scalars["String"]>;
};

export type GroundTransfersRemovablePill = UiRemovablePill & {
  __typename?: "GroundTransfersRemovablePill";
  /** accessibility label for the pill */
  accessibility?: Maybe<Scalars["String"]>;
  /** Action when pill is clicked */
  action?: Maybe<UiAction>;
  disabled: Scalars["Boolean"];
  /** Icon to be displayed along with the label */
  icon?: Maybe<Icon>;
  /** Label to be displayed on the pill */
  primary: Scalars["String"];
  remove?: Maybe<Icon>;
  selected: Scalars["Boolean"];
};

export type GroundTransfersResultCard = {
  __typename?: "GroundTransfersResultCard";
  /** accessibility text for the card. Eg: Private Standard Car by Carmel Limo at $46.75 one-way */
  accessibilityText: Scalars["String"];
  /** Action associated with card click */
  action: GroundTransfersAction;
  /** Badge to be displayed on the results card */
  badge?: Maybe<GroundTransfersBadge>;
  /** Link to open the details of the GT result */
  details: GroundTransfersText;
  /** Badge to focus that this GT has enhanced cleaning provided */
  enhancedCleaning?: Maybe<GroundTransfersText>;
  /** Header text to be displayed on top of the card when the product is added to the trip */
  featuredHeader?: Maybe<Scalars["String"]>;
  /** List of features like passenger count, duration etc */
  features: Array<GroundTransfersText>;
  /** Image and the other associated elements like badges which are placed on the image */
  figure: GroundTransfersFigure;
  /** Free cancellation details of the ground transfer */
  freeCancellation: Array<GroundTransfersText>;
  /** Partner loyalty earn message with mark/icon */
  loyaltyEarnAward?: Maybe<GroundTransfersGraphicText>;
  /** Price info of the GT result */
  priceInfo: GroundTransfersPriceInfo;
  /** Primary text displayed of the card. For eg: title */
  primary?: Maybe<Scalars["String"]>;
  /** Review summary like the score and review count */
  reviews: Array<GroundTransfersText>;
  /** Secondary texts to be displayed on the card For eg: supplier name */
  secondaries?: Maybe<Array<Scalars["String"]>>;
  /** Represents the button to be displayed on the card for trip update action */
  tripUpdateButton?: Maybe<EgdsButton>;
  /**
   * Actions involved to add, remove ground transfer to trip.
   * @deprecated Use tripUpdateButton
   */
  tripUpdateButtons?: Maybe<GroundTransfersTripUpdateButtons>;
};

export interface GroundTransfersSearchCriteriaInput {
  primary: PrimaryGroundTransfersCriteriaInput;
  secondary?: InputMaybe<ShoppingSearchCriteriaInput>;
}

export type GroundTransfersSearchPlayback = {
  __typename?: "GroundTransfersSearchPlayback";
  /** date time range for search to be displayed */
  dateTimeRange: OptionalDateTimeRange;
  /** direction to be displayed */
  direction: GroundTransfersDirection;
  /** list of location info's of airport and property to be displayed */
  locations: Array<GroundTransfersLocation>;
  /** list of traveler info to be displayed */
  travelers: Array<GroundTransfersTravelerDetails>;
};

export type GroundTransfersSearchResults = {
  __typename?: "GroundTransfersSearchResults";
  /** Represents map shown for showing different routes */
  map?: Maybe<GroundTransfersMap>;
  /** Represents a message to be displayed to users when there are no results found */
  noResultsFoundMessage?: Maybe<GroundTransfersNoResultsFoundMessage>;
  /** Ground transfer results and message cards combined together as groups */
  searchGroups: Array<GroundTransfersGroup>;
  /** Summary for the page like title, heading, etc */
  searchSummary?: Maybe<GroundTransfersSearchSummary>;
  /** Sort and Filter options and their respective state */
  sortAndFilter: ShoppingSortAndFilters;
};

export type GroundTransfersSearchSummary = {
  __typename?: "GroundTransfersSearchSummary";
  /** Heading to be displayed on the page */
  heading?: Maybe<Scalars["String"]>;
  /** Page information like the page title */
  metaInfo: GroundTransfersMetaInfo;
  /** Search playback information to show on change search */
  playback: GroundTransfersSearchPlayback;
  /** Shop with Points toggle */
  shopWithPoints?: Maybe<UiToggle>;
  /** Disclaimer shown for the sort order of the results */
  sortDisclaimer?: Maybe<GroundTransfersText>;
  /** Subtitle with number of results and taxes and fees information */
  subheading?: Maybe<Scalars["String"]>;
};

export type GroundTransfersSectionStyle = "BULLETED" | "STANDARD";

export type GroundTransfersSelectionClickAction = UiAction & {
  __typename?: "GroundTransfersSelectionClickAction";
  accessibility?: Maybe<Scalars["String"]>;
  /** Analytics information associated with the link click */
  analytics: ClientSideAnalytics;
  /** List of selections for filtering results */
  selections: Array<SelectedValue>;
  /** List of selections to remove from filters */
  selectionsToRemove: Array<SelectedValue>;
};

export type GroundTransfersSortAndFilterAppliedFilter = ShoppingSortAndFilterAppliedFilter & {
  __typename?: "GroundTransfersSortAndFilterAppliedFilter";
  /** sort and filter criteria that should be used when pill is triggered */
  nextSearchCriteria: ShoppingSearchCriteria;
  /** Used to display a removable pill for an applied filter */
  pill: GroundTransfersRemovablePill;
};

export type GroundTransfersStructuredSection = {
  __typename?: "GroundTransfersStructuredSection";
  /**  heading of the content like the keep it clean headings. For eg: Social distancing */
  heading?: Maybe<GroundTransfersText>;
  /** List of bullet points or basic content to be displayed inside the tab */
  items: Array<GroundTransfersText>;
  /** The style for showing content. Eg:a a bulleted list for ground transfer details */
  style: GroundTransfersSectionStyle;
};

/** Text style to apply to text */
export type GroundTransfersStyle =
  /** Bold styling */
  | "EMPHASISED"
  /** Green text styling */
  | "POSITIVE"
  /** Regular text with no styling, default Value */
  | "STANDARD";

export type GroundTransfersTabularStructuredContent = {
  __typename?: "GroundTransfersTabularStructuredContent";
  /** Heading of the tabular structured content */
  heading?: Maybe<GroundTransfersText>;
  /** Ground transfer details shown on tabs */
  tabs: Array<GroundTransfersDetailsTab>;
};

export interface GroundTransfersText {
  style: GroundTransfersStyle;
  text: Scalars["String"];
}

/** Used for displaying text toggle. For eg: SWP */
export type GroundTransfersToggle = UiToggle & {
  __typename?: "GroundTransfersToggle";
  checked: Scalars["Boolean"];
  checkedAccessibilityLabel?: Maybe<Scalars["String"]>;
  checkedAnalytics?: Maybe<ClientSideAnalytics>;
  checkedDescription?: Maybe<Scalars["String"]>;
  checkedLabel: Scalars["String"];
  enabled: Scalars["Boolean"];
  /** @deprecated Replace with the checked/unchecked variants */
  label: Scalars["String"];
  uncheckedAccessibilityLabel?: Maybe<Scalars["String"]>;
  uncheckedAnalytics?: Maybe<ClientSideAnalytics>;
  uncheckedDescription?: Maybe<Scalars["String"]>;
  uncheckedLabel: Scalars["String"];
};

/** Represents the traveler details */
export type GroundTransfersTravelerDetails = {
  __typename?: "GroundTransfersTravelerDetails";
  count: Scalars["Int"];
  type: GroundTransfersTravelerDetailsType;
};

/** Represents the traveler details */
export interface GroundTransfersTravelerDetailsInput {
  count: Scalars["Int"];
  type: GroundTransfersTravelerDetailsType;
}

/** Possible traveler details types */
export type GroundTransfersTravelerDetailsType = "ADULT" | "CHILD" | "INFANT";

export type GroundTransfersTripUpdateButtons = {
  __typename?: "GroundTransfersTripUpdateButtons";
  /** Button to add ground transfer product to trip */
  addToTrip: UiSecondaryButton;
  /** Button to remove ground transfer product from trip */
  removeFromTrip: UiSecondaryButton;
};

export type GroundTransfersUiMessagingCard = {
  __typename?: "GroundTransfersUIMessagingCard";
  actions?: Maybe<UiMessagingCardActions>;
  graphic?: Maybe<UiGraphic>;
  /** title or primary heading of the message card */
  primary?: Maybe<Scalars["String"]>;
  /** optional description displayed inside the message card */
  secondaries?: Maybe<Array<Scalars["String"]>>;
};

export type GuestRating = {
  __typename?: "GuestRating";
  /** The amenities rating based on guest reviews */
  amenities?: Maybe<Scalars["String"]>;
  /** The cleanliness rating based on guest reviews */
  cleanliness?: Maybe<Scalars["String"]>;
  /** The comfort rating based on guest reviews */
  comfort?: Maybe<Scalars["String"]>;
  /** The condition rating based on guest reviews */
  condition?: Maybe<Scalars["String"]>;
  /** The count of guest reviews */
  count?: Maybe<Scalars["Int"]>;
  /** The location rating based on guest reviews */
  location?: Maybe<Scalars["String"]>;
  /** The neighborhood rating based on guest reviews */
  neighborhood?: Maybe<Scalars["String"]>;
  /** The overall rating based on guest reviews */
  overall?: Maybe<Scalars["String"]>;
  /** The percent of guest's that recommended the property */
  recommendationPercent?: Maybe<Scalars["String"]>;
  /** The service rating based on guest reviews */
  service?: Maybe<Scalars["String"]>;
};

/** Header data from Global Navigation.  This is used display the header across sites */
export type Header = {
  __typename?: "Header";
  /** BSA Banner. */
  bsaBanner?: Maybe<HeaderBanner>;
  /** Expanded navigation section of the header. */
  expandedNavigation?: Maybe<HeaderSection>;
  /** Header Logo section */
  logos?: Maybe<HeaderSection>;
  /** Primary navigation section of the header. */
  primaryNavigation?: Maybe<HeaderSection>;
  /** Secondary navigation section of the header. */
  secondaryNavigation?: Maybe<HeaderSection>;
  /** View size of the Header. */
  viewSize: HeaderViewSize;
};

export interface HeaderAction {
  analytics: ClientSideAnalytics;
}

/** Header section alignment of elements to either the start or end of the section container. */
export type HeaderAlignment = "END" | "START";

/** Data for the BSA banner. */
export type HeaderBanner = {
  __typename?: "HeaderBanner";
  button?: Maybe<HeaderButton>;
  subText: Scalars["String"];
  text: Scalars["String"];
};

/** Navigation button on the header.  Similar to the navigation links on the header but with slightly design specific style differences. */
export type HeaderButton = {
  __typename?: "HeaderButton";
  /** Link action on the button. Includes analytics details. */
  action: UiLinkAction;
  /** Type of button.  Primary or tertiary. */
  buttonType: HeaderButtonType;
  /** Describes the action this link button take. Intended to replace the 'action' field */
  headerAction: HeaderAction;
  /** Specifies the button's target. '_blank' or '_self'. */
  linkTarget: Scalars["String"];
  /** Identifier used by synthetic testing to find UI element */
  testId?: Maybe<Scalars["String"]>;
  /** Text to display on the header button. */
  text: Scalars["String"];
};

/** Determines the type of button to display.  Primary or tertiary. */
export type HeaderButtonType = "PRIMARY" | "TERTIARY";

/** Header dialog element. */
export type HeaderDialog = {
  __typename?: "HeaderDialog";
  /** Icon that is displayed on the menu trigger. */
  icon?: Maybe<Icon>;
  /** Position of the icon in relation to the text.  Options are LEFT or RIGHT. */
  iconPosition: HeaderItemPosition;
  /** Property to identify dialogs. */
  id: Scalars["String"];
  /** Menu elements displayed in the menu dropdown. */
  items: Array<Maybe<HeaderMenuItem>>;
  /** Text displayed on the menu trigger. */
  text: Scalars["String"];
  /** Analytics tracking rfrrId. */
  trackingEvent: Scalars["String"];
};

/** Used to position the header menu dropdown as well as icons in links and buttons.  Options are LEFT or RIGHT. */
export type HeaderItemPosition = "LEFT" | "RIGHT";

/** Header layout. */
export type HeaderLayout = "DEFAULT" | "MINIMAL" | "SIMPLIFIED";

/** Used to describe a URI based link in the Header. */
export type HeaderLinkAction = HeaderAction & {
  __typename?: "HeaderLinkAction";
  analytics: ClientSideAnalytics;
  /** If the link is intended to be a relative link */
  isRelative: Scalars["Boolean"];
  /** Specifies the link's target. '_blank' or '_self'. */
  linkTarget: Scalars["String"];
  resource: Uri;
};

export type HeaderLocaleLinkAction = HeaderAction & {
  __typename?: "HeaderLocaleLinkAction";
  analytics: ClientSideAnalytics;
  langid: Scalars["Int"];
  locale: Scalars["String"];
};

/** Header logo element */
export type HeaderLogo = {
  __typename?: "HeaderLogo";
  /** Link action associated with the header logo.  For example, the url and analytics for clicks on the header logo. */
  action: UiLinkAction;
  /** Alt text on the logo.  Required for accessibility. */
  altText: Scalars["String"];
  /** Image source details. */
  imgSrc: Image;
};

/** Shared UI Component for Loyalty Member Status.  Displays the customer's name and loyalty tier. */
export type HeaderLoyaltyMemberStatus = HeaderSharedUi & {
  __typename?: "HeaderLoyaltyMemberStatus";
  skipSsr: Scalars["Boolean"];
};

/** Used to pass certain marketing details to the header for google ad awareness */
export interface HeaderMarketingInput {
  googleClickIdentifier?: InputMaybe<Scalars["String"]>;
  metaDistributionPartnersDetails?: InputMaybe<Scalars["String"]>;
}

/** Shared UI Component for Member Wallet.  Displays the customer's loyalty points and coupon information. */
export type HeaderMemberWallet = HeaderSharedUi & {
  __typename?: "HeaderMemberWallet";
  skipSsr: Scalars["Boolean"];
};

/** Header menu element. */
export type HeaderMenu = {
  __typename?: "HeaderMenu";
  /** Menu should render in open state */
  autoOpen: Scalars["Boolean"];
  /** Icon that is displayed on the menu trigger. */
  icon?: Maybe<Icon>;
  /** Position of the icon in relation to the text.  Options are LEFT or RIGHT. */
  iconPosition: HeaderItemPosition;
  /** Menu elements displayed in the menu dropdown. */
  items: Array<Maybe<HeaderMenuItem>>;
  /** Position of the menu dropdown.  Options are LEFT or RIGHT of the menu trigger. */
  menuPosition: HeaderItemPosition;
  /** Describes the certain ui state for the menu in the header. */
  menuState?: Maybe<HeaderState>;
  /** Text displayed on the menu trigger. */
  text: Scalars["String"];
  /** Analytics tracking rfrrId. */
  trackingEvent: Scalars["String"];
};

/** Illustration that can be placed within a menu */
export type HeaderMenuIllustration = {
  __typename?: "HeaderMenuIllustration";
  illustration: Illustration;
};

export type HeaderMenuItem =
  | HeaderButton
  | HeaderDialog
  | HeaderLoyaltyMemberStatus
  | HeaderMemberWallet
  | HeaderMenuIllustration
  | HeaderMenuLink
  | HeaderPicker
  | HeaderSeparator
  | HeaderSignInButton
  | HeaderSignOutMenuLink
  | HeaderSignUpButton
  | HeaderText
  | NotificationCenter
  | TripsNavigation;

/** A link that is specifically used in the header menu dropdown.  Examples include navigation links, support links and feedback links. */
export type HeaderMenuLink = {
  __typename?: "HeaderMenuLink";
  /** Link action associated with the menu link.  Example: url and analytics. */
  action: UiLinkAction;
  /** Describes the action this link should take. Intended to replace the 'action' field */
  headerAction: HeaderAction;
  /** Icon that is displayed on the menu link. */
  icon?: Maybe<Icon>;
  /** Specifies the link's target. '_blank' or '_self'. */
  linkTarget: Scalars["String"];
  /** Accessibility text when a link opens in a new tab or window. */
  newTabText: Scalars["String"];
  /** Identifier used by synthetic testing to find UI element */
  testId?: Maybe<Scalars["String"]>;
  /** Text displayed on the menu link. */
  text: Scalars["String"];
};

/** An interface for results summary messages. */
export interface HeaderMessage {
  value: Scalars["String"];
}

/** Navigation button on header. */
export type HeaderNavButton = {
  __typename?: "HeaderNavButton";
  /** Navigation Button action.  Includes navigation link and analytics. */
  action: UiLinkAction;
  /** Determines whether the navigation button is the current active element.  The button will be styled accordingly. */
  active: Scalars["Boolean"];
  /** Describes the action this button should take. Intended to replace the 'action' field */
  headerAction: HeaderAction;
  /** Icon that is displayed on the navigation button. */
  icon?: Maybe<Icon>;
  /** Specifies the link's target. '_blank' or '_self'. */
  linkTarget: Scalars["String"];
  /** Accessibility text when a link opens in a new tab or window. */
  newTabText: Scalars["String"];
  /** Identifier used by synthetic testing to find UI element */
  testId?: Maybe<Scalars["String"]>;
  /** Text displayed on the header navigation button. */
  text: Scalars["String"];
};

/** Header navigation link. */
export type HeaderNavLink = {
  __typename?: "HeaderNavLink";
  /** Link action associated with the navigation link.  Example: url and analytics for navigation. */
  action: UiLinkAction;
  /** Describes the action this link should take. Intended to replace the 'action' field */
  headerAction: HeaderAction;
  /** Icon that is displayed on the navigation link. */
  icon?: Maybe<Icon>;
  /** Specifies the link's target. '_blank' or '_self'. */
  linkTarget: Scalars["String"];
  /** Accessibility text when a link opens in a new tab or window. */
  newTabText: Scalars["String"];
  /** Identifier used by synthetic testing to find UI element */
  testId?: Maybe<Scalars["String"]>;
  /** Text displayed on the navigation link. */
  text: Scalars["String"];
};

/** Used to describe the UI state specific for the communication for notification center */
export type HeaderNotificationCenterState = {
  __typename?: "HeaderNotificationCenterState";
  /** Value for red dot state control for notification center on account menu */
  messageSeen: Scalars["Boolean"];
};

/** Used to describe a an action to open the virtual agent in the Header. Includes a fallback action if the agent is unavailable. */
export type HeaderOpenVirtualAgentAction = HeaderAction & {
  __typename?: "HeaderOpenVirtualAgentAction";
  analytics: ClientSideAnalytics;
  /** Values to pass to the VA when setting context */
  conversationProperties?: Maybe<VaConversationProperties>;
  /** Action to take if the virtual agent is not available. */
  fallbackAction: HeaderAction;
};

/** Shared UI Component for Picker.  Displays the picker component for site, locale, currency. */
export type HeaderPicker = HeaderSharedUi & {
  __typename?: "HeaderPicker";
  skipSsr: Scalars["Boolean"];
};

/** Correlates to a specific section on the header.  Examples include: logo, primaryNavigation, secondaryNavigation, expandedNavigation. */
export type HeaderSection = {
  __typename?: "HeaderSection";
  /** Used to align content for a particular header section.  The options are START or END. */
  alignment: HeaderAlignment;
  /** Section data for the header section. Elements to render in the section. */
  sectionData: Array<HeaderSectionData>;
};

export type HeaderSectionData =
  | HeaderButton
  | HeaderLogo
  | HeaderLoyaltyMemberStatus
  | HeaderMemberWallet
  | HeaderMenu
  | HeaderMenuLink
  | HeaderNavButton
  | HeaderNavLink
  | HeaderPicker
  | HeaderSignInButton
  | HeaderSignOutMenuLink
  | HeaderSignUpButton
  | NotificationCenter
  | TripsNavigation;

/** Header separator.  Example: Horizontal Rule. */
export type HeaderSeparator = {
  __typename?: "HeaderSeparator";
  type: HeaderSeparatorType;
};

/** Inserts a separator in header menus. */
export type HeaderSeparatorType = "HORIZONTAL_RULE";

export interface HeaderSharedUi {
  skipSsr: Scalars["Boolean"];
}

/** Sign in specific button. */
export type HeaderSignInButton = {
  __typename?: "HeaderSignInButton";
  /** Link action on the button. Includes analytics details. */
  action: UiLinkAction;
  /** Type of button.  Primary or tertiary. */
  buttonType: HeaderButtonType;
  /** Describes the action this button should take. Intended to replace the 'action' field */
  headerAction: HeaderAction;
  /** Specifies the button's target. '_blank' or '_self'. */
  linkTarget: Scalars["String"];
  /** Identifier used by synthetic testing to find UI element */
  testId?: Maybe<Scalars["String"]>;
  /** Text to display on the header button. */
  text: Scalars["String"];
};

/** Sign out link element on the header menu. */
export type HeaderSignOutMenuLink = {
  __typename?: "HeaderSignOutMenuLink";
  /** Link action associated with the menu link.  Example: url and analytics. */
  action: UiLinkAction;
  /** Describes the action this link should take. Intended to replace the 'action' field */
  headerAction: HeaderAction;
  /** Icon that is displayed on the sign out menu link. */
  icon?: Maybe<Icon>;
  /** Specifies the link's target. '_blank' or '_self'. */
  linkTarget: Scalars["String"];
  /** Accessibility text when a link opens in a new tab or window. */
  newTabText: Scalars["String"];
  /** Identifier used by synthetic testing to find UI element */
  testId?: Maybe<Scalars["String"]>;
  /** Text displayed on the sign out link. */
  text: Scalars["String"];
};

/** Sign up specific button. */
export type HeaderSignUpButton = {
  __typename?: "HeaderSignUpButton";
  /** Link action on the button. Includes analytics details. */
  action: UiLinkAction;
  /** Type of button.  Primary or tertiary. */
  buttonType: HeaderButtonType;
  /** Describes the action this button should take. Intended to replace the 'action' field */
  headerAction: HeaderAction;
  /** Specifies the button's target. '_blank' or '_self'. */
  linkTarget: Scalars["String"];
  /** Identifier used by synthetic testing to find UI element */
  testId?: Maybe<Scalars["String"]>;
  /** Text to display on the header button. */
  text: Scalars["String"];
};

export type HeaderState = HeaderNotificationCenterState;

/** Header text.  Primarily used to display text in the account menu. */
export type HeaderText = {
  __typename?: "HeaderText";
  /** The subtext to display. */
  subText?: Maybe<Scalars["String"]>;
  /** The text to display. */
  text: Scalars["String"];
  /** Type of text.  Heading or subheading. */
  textType: HeaderTextType;
};

/** Type of text.  Heading or subheading. */
export type HeaderTextType = "HEADING" | "SUBHEADING";

/** Different viewport sizes to display the header. */
export type HeaderViewSize = "EXTRA_LARGE" | "LARGE" | "MEDIUM" | "SMALL";

/** Represents an article */
export type HelpArticle = {
  __typename?: "HelpArticle";
  /** Id of the article */
  helpArticleId: Scalars["String"];
  /** Arrow Icon of the article */
  icon: Icon;
  /** Title of the article */
  title: Scalars["String"];
};

/** Represents help articles homepage */
export type HelpArticleCard = HelpArticlesLayout & {
  __typename?: "HelpArticleCard";
  /** Heading section of the card */
  helpArticleHeadingSection: HelpArticleHeadingSection;
  /** List of articles to be shown in the card */
  helpArticlesInCard: Array<HelpArticle>;
  /** More articles link section */
  moreHelpArticleLink?: Maybe<HelpArticleMoreSection>;
};

/** Represents help article click stream analytics event */
export type HelpArticleClickStreamAnalytics = {
  __typename?: "HelpArticleClickStreamAnalytics";
  /** Represents the help article event payload */
  article?: Maybe<HelpArticleEventPayload>;
  /** Represents the event details */
  event: EgClickstreamEvent;
  /** Represents the experience data of click stream event */
  experience: Experience;
  /** Represents the work flow item of help_article.presented event */
  workFlowList: Array<WorkFlowItem>;
};

/** Represents an article info */
export type HelpArticleData = {
  __typename?: "HelpArticleData";
  /** Category section of article */
  categories?: Maybe<Array<HelpArticleHeadingSection>>;
  /** Header section of the article */
  heading: HelpArticleHeadingSection;
  /** Represents help article click stream analytics event */
  helpArticleClickStreamAnalytics: HelpArticleClickStreamAnalytics;
  /** Content of the article in EGDS format */
  helpArticleContent?: Maybe<HelpArticlePortableTextContent>;
  /** More about category section of article */
  moreAboutCategory?: Maybe<Scalars["String"]>;
  /** Product of article */
  productTitle: Scalars["String"];
  /**
   * Title is coming from all articles and don't use it
   * @deprecated old title for dialog , replace with dialogTitleOption
   */
  title: HelpArticleHeadingSection;
};

/** Union of HelpArticleData and HelpArticleErrorView of article data */
export type HelpArticleDataView = HelpArticleData | HelpArticleErrorView;

/** Represents help articles in dialog */
export type HelpArticleDialog = HelpArticlesLayout & {
  __typename?: "HelpArticleDialog";
  /** List of articles to be shown in the dialog */
  articlesList: Array<HelpArticle>;
  /** Heading section of the dialog */
  helpArticleHeadingSection: HelpArticleHeadingSection;
};

export type HelpArticleErrorView = {
  __typename?: "HelpArticleErrorView";
  /** Represents the error heading */
  errorHeading: Scalars["String"];
  /** Represents the error message */
  errorMessage: Scalars["String"];
};

/** Represents help article event payload */
export type HelpArticleEventPayload = {
  __typename?: "HelpArticleEventPayload";
  /** Represents product or category of an article */
  articleGroup?: Maybe<Scalars["String"]>;
  /** Represents current article id */
  articleId?: Maybe<Scalars["String"]>;
  /** Represents hyperlink of internal external article */
  articleLink?: Maybe<Scalars["String"]>;
  /** Represents link type of an article */
  articleLinkType?: Maybe<Scalars["String"]>;
  /** Represents current article name */
  articleName?: Maybe<Scalars["String"]>;
};

/** Represents heading section on each card on homepage */
export type HelpArticleHeadingSection = {
  __typename?: "HelpArticleHeadingSection";
  /** Heading text of the card */
  headingText: Scalars["String"];
  icon?: Maybe<Icon>;
};

/** Represents more section on each card on homepage */
export type HelpArticleMoreSection = {
  __typename?: "HelpArticleMoreSection";
  accessibility: Scalars["String"];
  icon: Icon;
  /** Link  text */
  linkName: Scalars["String"];
  viewIcon: Icon;
};

/** Wrapping for Long Form Rich Text content */
export type HelpArticlePortableTextContent = {
  __typename?: "HelpArticlePortableTextContent";
  helpArticlePortableTextContent: Array<HelpArticlePortableTextEgds>;
};

/** Represent elements of Long Form text that can be of several types to bring a cohesive editorial like experience */
export type HelpArticlePortableTextEgds =
  | EgdsHeading
  | EgdsInlineLink
  | EgdsOrderedList
  | EgdsPlainText
  | EgdsSearchFormSelectAction
  | EgdsSpannableText
  | EgdsStylizedText
  | EgdsUnorderedList
  | HelpArticleTable;

/** Table in help article data */
export type HelpArticleTable = {
  __typename?: "HelpArticleTable";
  body: HelpArticleTableBody;
  caption?: Maybe<Scalars["String"]>;
  header: Array<Scalars["String"]>;
};

/** Table body in help article data */
export type HelpArticleTableBody = {
  __typename?: "HelpArticleTableBody";
  rows: Array<HelpArticleTableRow>;
};

/** Table cell in help article data */
export type HelpArticleTableCell = {
  __typename?: "HelpArticleTableCell";
  content: Array<HelpArticleTableCellContent>;
};

/** Represent elements of Long Form text that can be of several types to bring a cohesive editorial like experience */
export type HelpArticleTableCellContent =
  | EgdsHeading
  | EgdsInlineLink
  | EgdsPlainText
  | EgdsSpannableText
  | EgdsStylizedText;

/** Table row in help article data */
export type HelpArticleTableRow = {
  __typename?: "HelpArticleTableRow";
  cells: Array<HelpArticleTableCell>;
};

/** Wrapping type for help articles layout */
export interface HelpArticlesLayout {
  /** Heading section of the dialog */
  helpArticleHeadingSection: HelpArticleHeadingSection;
}

export type HelpArticlesResultsView = {
  __typename?: "HelpArticlesResultsView";
  /** Retrieve all help articles of partner */
  allArticles: AllHelpArticlesView;
  /** Retrieve help article data by article by id */
  articlesById: HelpArticleDataView;
  /** Retrieve More help articles specific product or category */
  moreArticles: MoreHelpArticlesView;
};

export type HelpArticlesResultsViewArticlesByIdArgs = {
  helpArticlesSearchRequest: HelpArticlesSearchRequestInput;
};

export type HelpArticlesResultsViewMoreArticlesArgs = {
  helpArticlesSearchRequest: HelpArticlesSearchRequestInput;
};

/** Browse request to get articles */
export interface HelpArticlesSearchRequestInput {
  /** Specify specific category from product to retrieve articles */
  category?: InputMaybe<Scalars["String"]>;
  /** Specify article id to get article data */
  helpArticleId?: InputMaybe<Scalars["String"]>;
  /** Specify specific product from homepage to retrieve articles */
  product?: InputMaybe<Scalars["String"]>;
}

/** Union of different views of articles */
export type HelpArticlesView = AllHelpArticles | HelpArticleData | MoreHelpArticles;

export type HeroCampaignContent = HeroTakeoverContent & {
  __typename?: "HeroCampaignContent";
  explore?: Maybe<TripsButton>;
  primaries?: Maybe<Array<Scalars["String"]>>;
  search?: Maybe<TripsButton>;
};

/** The hero component primary, secondary, icons, background image and a list of view elements. */
export type HeroComponent = {
  __typename?: "HeroComponent";
  background?: Maybe<Image>;
  elements?: Maybe<Array<TripsComposableElement>>;
  icons?: Maybe<Array<Icon>>;
  impressionTracking?: Maybe<ClientSideImpressionAnalytics>;
  primary?: Maybe<Scalars["String"]>;
  secondaries?: Maybe<Array<Scalars["String"]>>;
};

export type HeroDefaultContent = HeroTakeoverContent & {
  __typename?: "HeroDefaultContent";
  primaries?: Maybe<Array<Scalars["String"]>>;
  search?: Maybe<TripsButton>;
};

export type HeroImage = {
  __typename?: "HeroImage";
  heroImagePath: Scalars["String"];
  heroImageTargetPageUrl: Scalars["String"];
};

export type HeroPossibleTripContent = HeroTakeoverContent & {
  __typename?: "HeroPossibleTripContent";
  card?: Maybe<TripsSlimCard>;
  search?: Maybe<TripsButton>;
};

/** The Hero Takeover. */
export type HeroTakeover = {
  __typename?: "HeroTakeover";
  background?: Maybe<Image>;
  content?: Maybe<HeroTakeoverContent>;
  impressionTracking?: Maybe<ClientSideImpressionEventAnalytics>;
};

/** Content to be displayed during hero takeover. */
export interface HeroTakeoverContent {
  search?: Maybe<TripsButton>;
}

export type HeroTripsContent = HeroTakeoverContent & {
  __typename?: "HeroTripsContent";
  carousel?: Maybe<TripsCarouselContainer>;
  search?: Maybe<TripsButton>;
};

/** Hero View type to be rendered based on requested type */
export type HeroViewType = "HERO_COMPONENT" | "HERO_TAKEOVER";

/** Customer search history */
export type History = {
  __typename?: "History";
  /** Search history items */
  items?: Maybe<Array<Maybe<HistoryItem>>>;
  /** Search history type */
  type?: Maybe<HistoryType>;
};

/** Activity details history item */
export type HistoryActivityDetail = HistoryProductInfo & {
  __typename?: "HistoryActivityDetail";
  /** Discount */
  discount?: Maybe<Scalars["Int"]>;
  /** Activity duration */
  duration?: Maybe<Scalars["String"]>;
  /** Is this item qualifying for free cancellation */
  freeCancellation?: Maybe<Scalars["Boolean"]>;
  /** Activity details id */
  id?: Maybe<Scalars["Int"]>;
  /** Image url for activity detail. */
  imageUrl?: Maybe<Image>;
  /** Ticket type */
  leadTicketType?: Maybe<Scalars["String"]>;
  /** Activity name */
  name?: Maybe<Scalars["String"]>;
  /** Activity price */
  referencePrice?: Maybe<Money>;
  /**
   * Legacy field from schema stitching
   * @deprecated We will be migrating region data into a text field for clients that does not expose the raw geo domain class
   */
  regionDetail?: Maybe<GeographicFeature>;
  /** Activity search region id */
  regionId?: Maybe<Scalars["String"]>;
  /** Activity detail url. */
  searchUrl?: Maybe<Scalars["String"]>;
};

/** Activity search history item */
export type HistoryActivitySearch = HistoryProductInfo & {
  __typename?: "HistoryActivitySearch";
  /** Number of search result */
  numberOfResults?: Maybe<Scalars["Int"]>;
  /**
   * Legacy field from schema stitching
   * @deprecated We will be migrating region data into a text field for clients that does not expose the raw geo domain class
   */
  regionDetail?: Maybe<GeographicFeature>;
  /** Activity search region id */
  regionId?: Maybe<Scalars["String"]>;
  /** Activity search url. */
  searchUrl?: Maybe<Scalars["String"]>;
};

/** Flight details airline information */
export type HistoryAirline = {
  __typename?: "HistoryAirline";
  /** Airline code */
  airlineCode?: Maybe<Scalars["String"]>;
  /** Airline name */
  airlineName?: Maybe<Scalars["String"]>;
};

/** Car details history item */
export type HistoryCarDetail = HistoryProductInfo & {
  __typename?: "HistoryCarDetail";
  /** Car category */
  carCategory?: Maybe<Scalars["String"]>;
  /** Car type */
  carType?: Maybe<Scalars["String"]>;
  /** Car vendor */
  carVendor?: Maybe<Scalars["String"]>;
  /**
   * Legacy field from schema stitching
   * @deprecated We will be migrating region data into a text field for clients that does not expose the raw geo domain class
   */
  dropOffRegionDetail?: Maybe<GeographicFeature>;
  /** Car details drop off region id */
  dropOffRegionId?: Maybe<Scalars["String"]>;
  /** Car image url */
  imageURL?: Maybe<Image>;
  /** Car details period price per day/week/month */
  periodPrice?: Maybe<Money>;
  /**
   * Legacy field from schema stitching
   * @deprecated We will be migrating region data into a text field for clients that does not expose the raw geo domain class
   */
  pickUpRegionDetail?: Maybe<GeographicFeature>;
  /** Car details piid */
  piid?: Maybe<Scalars["String"]>;
  /** Car details price period DAILY/WEEKLY/MONTHLY */
  pricePeriod?: Maybe<Scalars["String"]>;
  /** Car details region id */
  regionId?: Maybe<Scalars["String"]>;
  /** Car search key which can be used to match respective car search */
  searchKey?: Maybe<Scalars["String"]>;
};

/** Car search history item */
export type HistoryCarSearch = HistoryProductInfo & {
  __typename?: "HistoryCarSearch";
  /** Car search daily price */
  dailyPrice?: Maybe<Money>;
  /**
   * Legacy field from schema stitching
   * @deprecated We will be migrating region data into a text field for clients that does not expose the raw geo domain class
   */
  dropOffRegionDetail?: Maybe<GeographicFeature>;
  /** Car drop off region id */
  dropOffRegionId?: Maybe<Scalars["String"]>;
  /**
   * Legacy field from schema stitching
   * @deprecated We will be migrating region data into a text field for clients that does not expose the raw geo domain class
   */
  pickUpRegionDetail?: Maybe<GeographicFeature>;
  /** Car search region id */
  regionId?: Maybe<Scalars["String"]>;
  /** Car search key which can be used to match respective car details */
  searchKey?: Maybe<Scalars["String"]>;
};

/** Cruise search history item */
export type HistoryCruiseSearch = HistoryProductInfo & {
  __typename?: "HistoryCruiseSearch";
  /** Cruise search region id */
  regionId?: Maybe<Scalars["String"]>;
  /** Cruise search region name */
  regionName?: Maybe<Scalars["String"]>;
};

/** Flight details history item */
export type HistoryFlightDetail = HistoryProductInfo & {
  __typename?: "HistoryFlightDetail";
  /** Cheapest search price per person */
  cheapestOfferPerPerson?: Maybe<Money>;
  /** Flight destination airport code */
  destinationAirportCode?: Maybe<Scalars["String"]>;
  /** Flight detail destination region id */
  destinationRegionId?: Maybe<Scalars["String"]>;
  /** Flight destination region name */
  destinationRegionName?: Maybe<Scalars["String"]>;
  /** Flight legs */
  flightLegList?: Maybe<Array<FlightLeg>>;
  /** Passengers information */
  flightPassengers?: Maybe<FlightPassengers>;
  /** Flight detail source destination information. */
  localizedFlightName?: Maybe<Scalars["String"]>;
  /** Flight origin airport code */
  originAirportCode?: Maybe<Scalars["String"]>;
  /** Flight detail origin region id */
  originRegionId?: Maybe<Scalars["String"]>;
  /** Flight origin region name */
  originRegionName?: Maybe<Scalars["String"]>;
  /** Flight details region id */
  regionId?: Maybe<Scalars["String"]>;
  /** Flight route type */
  routeType?: Maybe<Scalars["String"]>;
  /** Flight detail url. */
  searchUrl?: Maybe<Scalars["String"]>;
};

/** Flight search history item */
export type HistoryFlightSearch = HistoryProductInfo & {
  __typename?: "HistoryFlightSearch";
  /** Cheapest search price per person */
  cheapestOfferPerPerson?: Maybe<Money>;
  /** Flight destination airport code */
  destinationAirportCode?: Maybe<Scalars["String"]>;
  /** Flight search destination airport region id */
  destinationRegionId?: Maybe<Scalars["String"]>;
  /** Flight destination airport region name */
  destinationRegionName?: Maybe<Scalars["String"]>;
  /** Passengers information */
  flightPassengers?: Maybe<FlightPassengers>;
  /** Flight search source destination information. */
  localizedFlightName?: Maybe<Scalars["String"]>;
  /** Flight origin airport code */
  originAirportCode?: Maybe<Scalars["String"]>;
  /** Flight search origin region id */
  originRegionId?: Maybe<Scalars["String"]>;
  /** Flight origin region name */
  originRegionName?: Maybe<Scalars["String"]>;
  /** Flight search region id */
  regionId?: Maybe<Scalars["String"]>;
  /** Flight route type */
  routeType?: Maybe<Scalars["String"]>;
  /** Flight search url. */
  searchUrl?: Maybe<Scalars["String"]>;
};

/** Customer search history group. */
export type HistoryGroup = {
  __typename?: "HistoryGroup";
  /** Data groups to display. */
  displayData: SearchHistoryDisplayData;
  /** Filter criteria for the searchHistory query. */
  filterCriteria: SearchHistoryFilterCriteria;
};

/** Search history item details */
export type HistoryItem = {
  __typename?: "HistoryItem";
  /** Search end date */
  endDate: ZonedDateTime;
  /** Item id */
  id?: Maybe<Scalars["String"]>;
  /** Date when search made */
  lastViewedDate: ZonedDateTime;
  /** Localized time when the item was searched. */
  localizedAsOfDateTime?: Maybe<Scalars["String"]>;
  /** Search date range information. */
  localizedDateRange?: Maybe<Scalars["String"]>;
  /** Original search price of item */
  originalSearchPrice?: Maybe<Money>;
  /** More details for the item */
  productInfo?: Maybe<HistoryProductInfo>;
  /** Search start date */
  startDate: ZonedDateTime;
};

export type HistoryMutationResponse = {
  __typename?: "HistoryMutationResponse";
  message?: Maybe<Scalars["String"]>;
};

/** Package search history item */
export type HistoryPackageSearch = HistoryProductInfo & {
  __typename?: "HistoryPackageSearch";
  /** Arrival airport code */
  arrivalAirport?: Maybe<Scalars["String"]>;
  /** Departure airport code */
  departureAirport?: Maybe<Scalars["String"]>;
  /** Is any infants InLap */
  infantsInLap: Scalars["Boolean"];
  /** Localized origin and destination information. */
  localizedPackageName?: Maybe<Scalars["String"]>;
  /** Localized package type information. */
  localizedPackagesTemplate?: Maybe<Scalars["String"]>;
  /** Localized region name, format: {DepartureRegionName} to {ArrivalRegionName} */
  localizedRegionName?: Maybe<Scalars["String"]>;
  /** Is non stop flight */
  nonStop: Scalars["Boolean"];
  /** Number of infants InLap */
  numberOfInfantsInLap?: Maybe<Scalars["Int"]>;
  /** Number of rooms selected */
  numberOfRooms?: Maybe<Scalars["Int"]>;
  /**
   * Legacy field from schema stitching
   * @deprecated We will be migrating region data into a text field for clients that does not expose the raw geo domain class
   */
  regionDetail?: Maybe<GeographicFeature>;
  /** Package search region id */
  regionId?: Maybe<Scalars["String"]>;
  /** Rooms with occupants */
  roomOccupants?: Maybe<Array<RoomOccupants>>;
  /** Package search url */
  searchUrl?: Maybe<Scalars["String"]>;
};

/** More details for the item */
export interface HistoryProductInfo {
  /** Search region id */
  regionId?: Maybe<Scalars["String"]>;
}

/** Hotel details history item */
export type HistoryPropertyDetail = HistoryProductInfo & {
  __typename?: "HistoryPropertyDetail";
  /** Hotel checkin date */
  checkinDate: ZonedDateTime;
  /** @deprecated Checkin date in posix format. Ony to be used by federation queries */
  checkinDateRaw: Scalars["String"];
  /** Hotel checkout date */
  checkoutDate: ZonedDateTime;
  /** @deprecated Checkout date in posix format. Ony to be used by federation queries */
  checkoutDateRaw: Scalars["String"];
  /** @deprecated DO NOT USE: The field exists for the federation migration only */
  deprecatedContext: DeprecatedCustomerContext;
  /** Localized hotel total rating, format: '{totalReviews}/5 */
  formattedRating: Scalars["String"];
  /** Localized hotel total reviews, format: '({numberOfReviews} reviews)' or '({oneReview} review)' */
  formattedReviewCount: Scalars["String"];
  /**
   * Federation: Extends the type with property gallery given the propertyId
   * @deprecated Added for stitching migration purposes only. Can be deleted once all clients migrate., replace with propertyImageGallery
   */
  gallery?: Maybe<PropertyGallery>;
  /** Number of rooms selected */
  numberOfRooms?: Maybe<Scalars["Int"]>;
  /** Number of traveler included child */
  numberOfTravelers?: Maybe<Scalars["Int"]>;
  /**
   * Federation: Extends the type with property offers
   * @deprecated Added for stitching migration purposes only. Can be deleted once all clients migrate., replace with propertyOffers
   */
  offers?: Maybe<OfferDetails>;
  /** Hotel id */
  propertyId?: Maybe<Scalars["String"]>;
  /** Federation: Extends the type with property gallery given the propertyId */
  propertyImageGallery?: Maybe<PropertyImageGallery>;
  /** Federation: Extends the type with property offers */
  propertyOffers?: Maybe<OfferDetails>;
  /**
   * Federation: Extends the type with property review given the propertyId
   * @deprecated Deprecated field: don't use it
   */
  propertyReviews?: Maybe<PropertyReviews>;
  /** Federation: Extends the type with property summary details given the propertyId */
  propertySummary?: Maybe<PropertySummary>;
  /**
   * Legacy field from schema stitching
   * @deprecated We will be migrating region data into a text field for clients that does not expose the raw geo domain class
   */
  regionDetail?: Maybe<GeographicFeature>;
  /** Hotel details search region id */
  regionId?: Maybe<Scalars["String"]>;
  /**
   * Federation: Extends the type with property reviews given the propertyId
   * @deprecated Added for stitching migration purposes only. Can be deleted once all clients migrate., replace with propertyReviews
   */
  reviewInfo?: Maybe<PropertyReviews>;
  /** Rooms with occupants */
  roomOccupants?: Maybe<Array<RoomOccupants>>;
  /** Hotel detail url. */
  searchUrl?: Maybe<Scalars["String"]>;
  /**
   * Federation: Extends the type with property summary details given the propertyId
   * @deprecated Added for stitching migration purposes only. Can be deleted once all clients migrate., replace with propertySummary
   */
  summary?: Maybe<PropertySummary>;
};

/** Hotel details history item */
export type HistoryPropertyDetailPropertyImageGalleryArgs = {
  context: ContextInput;
};

/** Hotel details history item */
export type HistoryPropertyDetailPropertyOffersArgs = {
  context: ContextInput;
};

/** Hotel details history item */
export type HistoryPropertyDetailPropertyReviewsArgs = {
  context: ContextInput;
};

/** Hotel details history item */
export type HistoryPropertyDetailPropertySummaryArgs = {
  context: ContextInput;
};

/** Hotel search history item */
export type HistoryPropertySearch = HistoryProductInfo & {
  __typename?: "HistoryPropertySearch";
  /** Localized rooms and guest information for hotel search. */
  localizedRoomsTemplate?: Maybe<Scalars["String"]>;
  /** Number of rooms selected */
  numberOfRooms?: Maybe<Scalars["Int"]>;
  /** Number of traveler included child */
  numberOfTravelers?: Maybe<Scalars["Int"]>;
  /**
   * Legacy field from schema stitching
   * @deprecated We will be migrating region data into a text field for clients that does not expose the raw geo domain class
   */
  regionDetail?: Maybe<GeographicFeature>;
  /** Hotel search region id */
  regionId?: Maybe<Scalars["String"]>;
  /** Rooms with occupants */
  roomOccupants?: Maybe<Array<RoomOccupants>>;
  /** Hotel search url. */
  searchUrl?: Maybe<Scalars["String"]>;
};

export type HistoryType =
  | "ACTIVITY_DETAIL"
  | "ACTIVITY_SEARCH"
  | "CAR_DETAIL"
  | "CAR_SEARCH"
  | "CRUISE_SEARCH"
  | "FLIGHT_DETAIL"
  | "FLIGHT_SEARCH"
  | "PACKAGE_SEARCH"
  | "PROPERTY_DETAIL"
  | "PROPERTY_SEARCH";

export type HomeMultiItemShoppingAction = MultiItemShoppingAction & {
  __typename?: "HomeMultiItemShoppingAction";
  shoppingContext: ShoppingContext;
};

/** Wrapping type for home components and views */
export type HomeResponse = HeroComponent | HeroTakeover;

export type HotelAmenity = {
  __typename?: "HotelAmenity";
  code: Scalars["Int"];
};

/** Hotel detail in response */
export type HotelDetail = {
  __typename?: "HotelDetail";
  checkInDate: Scalars["String"];
  checkOutDate: Scalars["String"];
  city: Scalars["String"];
  propertyName: Scalars["String"];
  travelerDetails: Array<TravelerDetailsForItinerary>;
};

export type HotelOfferItem = OfferItem & {
  __typename?: "HotelOfferItem";
  /** Badge to be displayed for the hotel offer */
  badge?: Maybe<CampaignOfferBadge>;
  /** Range of dates the offer is applicable */
  dates?: Maybe<Scalars["String"]>;
  /** Description of the hotel offer */
  description?: Maybe<Scalars["String"]>;
  /** Discount Badge to be displayed for the hotel offer */
  discountBadge?: Maybe<CampaignOfferBadge>;
  /** Free Cancellation message */
  freeCancellationMessage?: Maybe<Scalars["String"]>;
  /** Guest review count */
  guestReviewCount?: Maybe<Scalars["String"]>;
  /** Guest review qualifier text */
  guestReviewQualifierText?: Maybe<Scalars["String"]>;
  /** Guest review rating of the hotel */
  guestReviewRating?: Maybe<Scalars["String"]>;
  /** Guest review rating qualifier text */
  guestReviewRatingQualifierText?: Maybe<Scalars["String"]>;
  /** Guest review text */
  guestReviewText?: Maybe<Scalars["String"]>;
  /** Image to be displayed for the hotel offer */
  image: Image;
  /** Location of the hotel */
  location?: Maybe<Scalars["String"]>;
  /** Lodging offer price and link */
  lodgingOffer?: Maybe<OfferData>;
  /** MOD content */
  mod?: Maybe<ModItem>;
  /** Name of the hotel where the offer is applicable */
  name: Scalars["String"];
  /** Secondary content related to the destination offer */
  secondaryContent?: Maybe<Scalars["String"]>;
  /** Star rating of the hotel */
  starRating?: Maybe<Scalars["Float"]>;
  /** VAP message */
  vapMessage?: Maybe<Scalars["String"]>;
  /** VIP message */
  vipMessage?: Maybe<Scalars["String"]>;
};

export type HotelProduct = {
  __typename?: "HotelProduct";
  displayedAmenities: Array<HotelAmenity>;
  productId: Scalars["Int"];
  productType?: Maybe<Scalars["String"]>;
};

export interface HttpHeaderInput {
  name: Scalars["String"];
  values: Array<Scalars["String"]>;
}

export type HttpStatus =
  | "ACCEPTED"
  | "ALREADY_REPORTED"
  | "BAD_GATEWAY"
  | "BAD_REQUEST"
  | "BANDWIDTH_LIMIT_EXCEEDED"
  | "CHECKPOINT"
  | "CONFLICT"
  | "CONTINUE"
  | "CREATED"
  | "DESTINATION_LOCKED"
  | "EXPECTATION_FAILED"
  | "FAILED_DEPENDENCY"
  | "FORBIDDEN"
  | "FOUND"
  | "GATEWAY_TIMEOUT"
  | "GONE"
  | "HTTP_VERSION_NOT_SUPPORTED"
  | "IM_USED"
  | "INSUFFICIENT_SPACE_ON_RESOURCE"
  | "INSUFFICIENT_STORAGE"
  | "INTERNAL_SERVER_ERROR"
  | "I_AM_A_TEAPOT"
  | "LENGTH_REQUIRED"
  | "LOCKED"
  | "LOOP_DETECTED"
  | "METHOD_FAILURE"
  | "METHOD_NOT_ALLOWED"
  | "MOVED_PERMANENTLY"
  | "MOVED_TEMPORARILY"
  | "MULTIPLE_CHOICES"
  | "MULTI_STATUS"
  | "NETWORK_AUTHENTICATION_REQUIRED"
  | "NON_AUTHORITATIVE_INFORMATION"
  | "NOT_ACCEPTABLE"
  | "NOT_EXTENDED"
  | "NOT_FOUND"
  | "NOT_IMPLEMENTED"
  | "NOT_MODIFIED"
  | "NO_CONTENT"
  | "OK"
  | "PARTIAL_CONTENT"
  | "PAYLOAD_TOO_LARGE"
  | "PAYMENT_REQUIRED"
  | "PERMANENT_REDIRECT"
  | "PRECONDITION_FAILED"
  | "PRECONDITION_REQUIRED"
  | "PROCESSING"
  | "PROXY_AUTHENTICATION_REQUIRED"
  | "REQUESTED_RANGE_NOT_SATISFIABLE"
  | "REQUEST_ENTITY_TOO_LARGE"
  | "REQUEST_HEADER_FIELDS_TOO_LARGE"
  | "REQUEST_TIMEOUT"
  | "REQUEST_URI_TOO_LONG"
  | "RESET_CONTENT"
  | "SEE_OTHER"
  | "SERVICE_UNAVAILABLE"
  | "SWITCHING_PROTOCOLS"
  | "TEMPORARY_REDIRECT"
  | "TOO_EARLY"
  | "TOO_MANY_REQUESTS"
  | "UNAUTHORIZED"
  | "UNAVAILABLE_FOR_LEGAL_REASONS"
  | "UNPROCESSABLE_ENTITY"
  | "UNSUPPORTED_MEDIA_TYPE"
  | "UPGRADE_REQUIRED"
  | "URI_TOO_LONG"
  | "USE_PROXY"
  | "VARIANT_ALSO_NEGOTIATES";

/** Support for `http` or `https` based URI constructed based on a valid `java.net.URL` object. */
export type HttpUri = Uri & {
  __typename?: "HttpURI";
  relativePath: Scalars["String"];
  value: Scalars["String"];
};

export type Hypertext = {
  __typename?: "Hypertext";
  text: Scalars["String"];
  url?: Maybe<Scalars["URL"]>;
};

export type HypertextItem = Item & {
  __typename?: "HypertextItem";
  hypertext: Hypertext;
  text: Scalars["String"];
};

export interface IEgClickstreamData {
  event?: Maybe<EgClickstreamEvent>;
  experience?: Maybe<EgClickstreamExperience>;
}

export interface ISupplyPaymentLineItem {
  amount: SupplyPaymentDetailsAmountLineItem;
  footerNoteText?: Maybe<EgdsStylizedText>;
  lineItemText: EgdsStylizedText;
  originalAmount?: Maybe<SupplyPaymentDetailsAmountLineItem>;
  sideNoteText?: Maybe<EgdsStylizedText>;
}

export interface ISupplyPaymentMoreInfo {
  tooltip?: Maybe<SupplyPaymentTooltip>;
}

export interface ISupplyScoreFactorPanelContent {
  clickstreamPresented?: Maybe<SupplyScoreEgClickstreamData>;
}

/**
 * Representation of an Icon and Icon SpotLight
 * https://www.figma.com/file/Cq6XtgvVIEriWmWmVIMPzNOE/Icons?node-id=6402%3A115
 */
export type Icon = {
  __typename?: "Icon";
  /** The localized text describing the icon */
  description: Scalars["String"];
  /** The egds value used for loading this icon */
  id: Scalars["String"];
  /** The size of the icon */
  size?: Maybe<IconSize>;
  /** The spotlight theme of the icon */
  spotLight?: Maybe<IconSpotLight>;
  /** The theme of the icon */
  theme?: Maybe<IconTheme>;
  /** The localized text describing the title for the icon, mainly used as label in accessibility, such as tooltip */
  title?: Maybe<Scalars["String"]>;
  /** The egds id used for loading this icon */
  token: Scalars["String"];
  /** Parameter to show icon with background ellipse or not */
  withBackground?: Maybe<Scalars["Boolean"]>;
};

/** supported sizes of icons */
export type IconSize = "EXTRA_SMALL" | "LARGE" | "MEDIUM" | "MEDIUM_LARGE" | "SMALL" | "XLARGE";

/** Supported themes of spotlights. See the prop definitions here: https://www.figma.com/file/Cq6XtgvVIEriWmWmVIMPzNOE/Icons?node-id=6402%3A115 */
export type IconSpotLight = "INFO" | "POSITIVE" | "STANDARD" | "WARNING";

/** Supported themes of icons. See the prop definitions here: http://uitk-react.tools.expedia.com/expedia/en_US/components/icons */
export type IconTheme = "default" | "emphasis" | "negative" | "positive";

export type IconWrapper = {
  __typename?: "IconWrapper";
  /** Text to be read by the screen reader. */
  accessibilityMessage?: Maybe<Scalars["String"]>;
  /** List of icons */
  icons: Array<Icon>;
};

/** Enum to specify the type for inputId */
export type IdentifierType = "CART_ID" | "ENTITY_ID" | "OFFER_ID" | "ORDER_ID";

/** Identity information for a specific user or device */
export type Identity = {
  __typename?: "Identity";
  /** The Expedia user authenticated state */
  authState?: Maybe<AuthenticationState>;
  /** The device ID (DUAID) */
  duaid: Scalars["UUID"];
  /** The Expedia User ID */
  expUserId?: Maybe<Scalars["String"]>;
  /** The user TUID */
  tuid?: Maybe<Scalars["String"]>;
};

export type IdentityAccountCreationState = "INVALID" | "NOT_UPGRADED" | "UPGRADED";

export type IdentityAccountCreationType = "INVALID" | "REGISTERED" | "UNREGISTERED";

export type IdentityAccountResponse = IdentityCreateAccountErrorResponse | IdentityCreateAccountSuccessResponse;

export type IdentityAccountTakeOverDevice = {
  __typename?: "IdentityAccountTakeOverDevice";
  payload: Scalars["String"];
  type: IdentityAccountTakeOverDeviceType;
};

export interface IdentityAccountTakeOverDeviceInput {
  payload: Scalars["String"];
  type: IdentityAccountTakeOverDeviceType;
}

export type IdentityAccountTakeOverDeviceType = "TRUST_WIDGET";

/** EG Universal Login AccountTakeOver input from client */
export interface IdentityAccountTakeOverInput {
  inputs: Array<GraphQlPairInput>;
  type: Scalars["String"];
}

export type IdentityAccountTakeOverShield = {
  __typename?: "IdentityAccountTakeOverShield";
  accountTakeOverTokens?: Maybe<Array<IdentityAccountTakeOverToken>>;
  crossSiteRequestForgeryData: IdentityCrossSiteRequestForgery;
  devices?: Maybe<Array<IdentityAccountTakeOverDevice>>;
  placement?: Maybe<Scalars["String"]>;
};

export interface IdentityAccountTakeOverShieldInput {
  accountTakeOverTokens?: InputMaybe<Array<IdentityAccountTakeOverTokenInput>>;
  crossSiteRequestForgeryData: IdentityCrossSiteRequestForgeryInput;
  devices?: InputMaybe<Array<IdentityAccountTakeOverDeviceInput>>;
  placement?: InputMaybe<Scalars["String"]>;
}

export type IdentityAccountTakeOverToken = {
  __typename?: "IdentityAccountTakeOverToken";
  name: Scalars["String"];
  value: Scalars["String"];
};

export interface IdentityAccountTakeOverTokenInput {
  name: Scalars["String"];
  value: Scalars["String"];
}

export type IdentityAccountTakeOverType = "CAPTCHA_SAFETYNET_ANDROID" | "CSRF" | "DEVICE_CHECK" | "TRUST_WIDGET";

export interface IdentityAccountTakeOverWidgetAction {
  inputKeys: Array<Scalars["String"]>;
  type: IdentityAccountTakeOverType;
}

export interface IdentityAction {
  accessibility?: Maybe<Scalars["String"]>;
  analytics: ClientSideAnalytics;
}

/** EG Universal Login basic block containing list of EGDSElements */
export type IdentityBasicBlock = EgdsElement &
  EgdsElements &
  IdentityBlock & {
    __typename?: "IdentityBasicBlock";
    egdsElementId?: Maybe<Scalars["String"]>;
    elements: Array<EgdsElement>;
    properties?: Maybe<IdentityBlockProperties>;
  };

/** EG Universal Login basic block properties definition */
export type IdentityBasicBlockProperties = IdentityBlockProperties & {
  __typename?: "IdentityBasicBlockProperties";
  hidden: Scalars["Boolean"];
  internalSpace?: Maybe<IdentitySpaceSize>;
  topSpace?: Maybe<IdentitySpaceSize>;
};

/** EG Universal login block which can can be part IdentityLayoutSection */
export interface IdentityBlock {
  properties?: Maybe<IdentityBlockProperties>;
}

/** EG Universal login properties for IdentityBlock. Mainly contains spacing and visibility. */
export interface IdentityBlockProperties {
  hidden: Scalars["Boolean"];
  topSpace?: Maybe<IdentitySpaceSize>;
}

/** EG Universal Login Button to be used whenever we want to display button */
export type IdentityButton = EgdsElement & {
  __typename?: "IdentityButton";
  action: IdentityAction;
  egdsElementId?: Maybe<Scalars["String"]>;
  element: EgdsButton;
  rules: Array<IdentityRule>;
};

export type IdentityCsrfAto = {
  __typename?: "IdentityCSRFAto";
  placement: Scalars["String"];
  token: Scalars["String"];
  type: IdentityAccountTakeOverType;
};

export type IdentityCaptchaSafetyNetAndroidWidgetAction = IdentityAccountTakeOverWidgetAction & {
  __typename?: "IdentityCaptchaSafetyNetAndroidWidgetAction";
  inputKeys: Array<Scalars["String"]>;
  siteKey: Scalars["String"];
  type: IdentityAccountTakeOverType;
};

export type IdentityChannelType = "ANDROID" | "DESKTOP" | "IOS";

/** EG Universal Login input for IdentityClientInfo query and mutation */
export interface IdentityClientInfoInput {
  appName: Scalars["String"];
  appVersion: Scalars["String"];
  channelType: IdentityChannelType;
  deviceOS: Scalars["String"];
  deviceType: DeviceType;
}

export type IdentityCommonWordsValidation = EgdsInputValidation & {
  __typename?: "IdentityCommonWordsValidation";
  errorMessage: Scalars["String"];
};

export type IdentityComponentLayout =
  | IdentityForgotPasswordComponentLayout
  | IdentityResetPasswordComponentLayout
  | IdentitySingleColumnComponentLayout
  | IdentitySuccessComponentLayout;

export type IdentityCreateAccountErrorResponse = {
  __typename?: "IdentityCreateAccountErrorResponse";
  accountTakeOverShield: IdentityAccountTakeOverShield;
  error: Scalars["String"];
  message: Scalars["String"];
};

/** EG Identity Creation Account Request */
export interface IdentityCreateAccountRequestInput {
  accountTakeOverShield: IdentityAccountTakeOverShieldInput;
  channelType?: InputMaybe<Scalars["String"]>;
  email: Scalars["String"];
  firstName: Scalars["String"];
  lastName: Scalars["String"];
  password: Scalars["String"];
  phoneDetails?: InputMaybe<IdentityPhoneDetailsInput>;
  rememberMe?: InputMaybe<Scalars["Boolean"]>;
}

export type IdentityCreateAccountSuccessResponse = {
  __typename?: "IdentityCreateAccountSuccessResponse";
  accountTakeOverShield: IdentityAccountTakeOverShield;
  accountType: IdentityAccountCreationType;
  accountUpgradeStatus: IdentityAccountCreationState;
  egUserId: Scalars["String"];
};

export type IdentityCrossSiteRequestForgery = {
  __typename?: "IdentityCrossSiteRequestForgery";
  token: Scalars["String"];
};

export interface IdentityCrossSiteRequestForgeryInput {
  token: Scalars["String"];
}

export type IdentityCsrfWidgetAction = IdentityAccountTakeOverWidgetAction & {
  __typename?: "IdentityCsrfWidgetAction";
  inputKeys: Array<Scalars["String"]>;
  token: Scalars["String"];
  type: IdentityAccountTakeOverType;
};

export type IdentityDeviceCheckWidgetAction = IdentityAccountTakeOverWidgetAction & {
  __typename?: "IdentityDeviceCheckWidgetAction";
  inputKeys: Array<Scalars["String"]>;
  type: IdentityAccountTakeOverType;
};

export interface IdentityErrorField {
  elementId: Scalars["String"];
  errorText: Scalars["String"];
}

/** EG Universal Login response in case of error containing fields and elements to be updated */
export type IdentityErrorResponse = IdentityResponse & {
  __typename?: "IdentityErrorResponse";
  clientSideImpressionEventAnalytics: ClientSideImpressionEventAnalytics;
  errorFields: Array<IdentityErrorField>;
  updateAction?: Maybe<IdentityUpdateComponentAction>;
};

export type IdentityForbiddenInputsValidation = EgdsInputValidation & {
  __typename?: "IdentityForbiddenInputsValidation";
  errorMessage: Scalars["String"];
  inputIds: Array<Scalars["String"]>;
};

export type IdentityForgotPasswordComponentLayout = {
  __typename?: "IdentityForgotPasswordComponentLayout";
  description: EgdsSpannableText;
  emailInputField: EgdsEmailInputField;
  errorSummaryCard: EgdsStandardMessagingCard;
  heading: EgdsHeading;
  sendEmailButton: IdentityButton;
  toolbar?: Maybe<UiToolbar>;
};

/** Identity information for a specific user or device */
export interface IdentityInput {
  /** The Expedia user authenticated state */
  authState?: InputMaybe<AuthenticationState>;
  /** The device ID (DUAID) */
  duaid: Scalars["UUID"];
  /** The Expedia User ID */
  expUserId?: InputMaybe<Scalars["String"]>;
  /** The user TUID */
  tuid?: InputMaybe<Scalars["String"]>;
}

export type IdentityLayout = "FORGOT_PASSWORD" | "RESET_PASSWORD" | "SIGNIN" | "SIGNUP";

/** EG Universal Login layout section containing list of blocks */
export type IdentityLayoutSection = {
  __typename?: "IdentityLayoutSection";
  blocks: Array<IdentityBlock>;
};

/** EG Universal Login rule which dictates which elements should be error free before performing action */
export type IdentityNoErrorRule = {
  __typename?: "IdentityNoErrorRule";
  elements: Array<Scalars["String"]>;
};

/** EG Universal Login layout one tap component to tell clients to look for authentication information */
export type IdentityOneTapSelection = {
  __typename?: "IdentityOneTapSelection";
  cancelAnalytics: ClientSideAnalytics;
  clientFailureAnalytics: ClientSideAnalytics;
  clientSideImpressionEventAnalytics: ClientSideImpressionEventAnalytics;
  emailInputId: Scalars["String"];
  googleSocialButtonId?: Maybe<Scalars["String"]>;
  inputIdsMapping?: Maybe<IdentitySignInInputIdsMapping>;
  submitAction: IdentityAction;
  submitButtonId: Scalars["String"];
};

export type IdentityPasswordStrengthComponent = EgdsElement & {
  __typename?: "IdentityPasswordStrengthComponent";
  egdsElementId?: Maybe<Scalars["String"]>;
  excludeValidationsList: IdentityValidationList;
  includeValidationsList: IdentityValidationList;
  passwordInput: EgdsPasswordInputField;
  progressBar: IdentityProgressBar;
};

export interface IdentityPhoneDetailsInput {
  countryCode: Scalars["String"];
  locale: Scalars["String"];
  phoneNumber: Scalars["String"];
}

export type IdentityProgressBar = {
  __typename?: "IdentityProgressBar";
  states: Array<IdentityValidationState>;
  title: Scalars["String"];
};

export type IdentityRegexCustomValidation = EgdsInputValidation & {
  __typename?: "IdentityRegexCustomValidation";
  errorMessage: Scalars["String"];
  pattern: Scalars["String"];
  title: Scalars["String"];
};

export type IdentityResetPasswordComponentLayout = {
  __typename?: "IdentityResetPasswordComponentLayout";
  errorSummaryCard: EgdsStandardMessagingCard;
  heading: EgdsHeading;
  passwordInputField: EgdsPasswordInputField;
  savePasswordButton: IdentityButton;
  toolbar?: Maybe<UiToolbar>;
};

export interface IdentityResponse {
  clientSideImpressionEventAnalytics: ClientSideImpressionEventAnalytics;
}

export type IdentityRule = IdentityNoErrorRule | IdentityVisibilityRule;

export type IdentitySaveCredentialsInputIdsMapping = {
  __typename?: "IdentitySaveCredentialsInputIdsMapping";
  password: Scalars["String"];
  userName: Scalars["String"];
};

/** EG Universal Login session which contains information to be stored at clients */
export type IdentitySession = {
  __typename?: "IdentitySession";
  domain: Scalars["String"];
  expires?: Maybe<Scalars["String"]>;
  httpOnly: Scalars["Boolean"];
  maxAge: Scalars["String"];
  name: Scalars["String"];
  path: Scalars["String"];
  secure: Scalars["Boolean"];
  value: Scalars["String"];
};

/** EG Universal Login action to be used in mutation success response where we need to send sessions to clients */
export type IdentitySessionAction = IdentityAction & {
  __typename?: "IdentitySessionAction";
  accessibility?: Maybe<Scalars["String"]>;
  analytics: ClientSideAnalytics;
  session: Array<IdentitySession>;
};

export type IdentitySignInInputIdsMapping = {
  __typename?: "IdentitySignInInputIdsMapping";
  password: Scalars["String"];
  userName: Scalars["String"];
};

/** EG Universal Login vertical single column layout containing sections */
export type IdentitySingleColumnComponentLayout = EgdsElement & {
  __typename?: "IdentitySingleColumnComponentLayout";
  egdsElementId?: Maybe<Scalars["String"]>;
  identityOneTapSelection?: Maybe<IdentityOneTapSelection>;
  main?: Maybe<IdentityLayoutSection>;
  toolbar?: Maybe<UiToolbar>;
  top?: Maybe<IdentityLayoutSection>;
};

/** EG Universal Login Button to be used whenever we want to display social login button */
export type IdentitySocialButton = EgdsElement & {
  __typename?: "IdentitySocialButton";
  action: IdentitySocialSubmitAction;
  egdsElementId?: Maybe<Scalars["String"]>;
  inputIdsMapping?: Maybe<IdentitySocialSignInInputIdsMapping>;
  label: Scalars["String"];
  mark: Mark;
};

export interface IdentitySocialInput {
  nonce: Scalars["String"];
  socialType: IdentitySocialType;
  token: Scalars["String"];
  tokenType: IdentitySocialTokenType;
}

export type IdentitySocialSignInInputIdsMapping = {
  __typename?: "IdentitySocialSignInInputIdsMapping";
  firstName: Scalars["String"];
  lastName: Scalars["String"];
};

/** EG Universal Identity action to be used for any social login submission */
export type IdentitySocialSubmitAction = IdentityAction & {
  __typename?: "IdentitySocialSubmitAction";
  accessibility?: Maybe<Scalars["String"]>;
  analytics: ClientSideAnalytics;
  atoActions: Array<IdentityAccountTakeOverWidgetAction>;
  cancelAnalytics: ClientSideAnalytics;
  clientFailureAnalytics: ClientSideAnalytics;
  context: Scalars["String"];
  inputIds: Array<Scalars["String"]>;
  nonce: Scalars["String"];
  socialType: IdentitySocialType;
  submitAnalytics: ClientSideAnalytics;
};

export type IdentitySocialTokenType = "Access" | "AuthCode" | "ID";

export type IdentitySocialType = "APPLE" | "FACEBOOK" | "GOOGLE";

/** EG Universal Login spacing definition */
export type IdentitySpaceSize =
  | "S0X"
  | "S0XH"
  | "S1X"
  | "S2X"
  | "S3X"
  | "S4X"
  | "S5X"
  | "S6X"
  | "S8X"
  | "S10X"
  | "S11X"
  | "S12X"
  | "S14X"
  | "S16X"
  | "S18X";

/** EG Universal Identity action to be used for any form submission */
export type IdentitySubmitAction = IdentityAction & {
  __typename?: "IdentitySubmitAction";
  accessibility?: Maybe<Scalars["String"]>;
  analytics: ClientSideAnalytics;
  atoActions: Array<IdentityAccountTakeOverWidgetAction>;
  context: Scalars["String"];
  inputIds: Array<Scalars["String"]>;
  saveCredentialsInputIds?: Maybe<IdentitySaveCredentialsInputIdsMapping>;
};

/** EG Universal Login input for IdentityFormSubmit mutation */
export interface IdentitySubmitRequestInput {
  atoInputs: Array<IdentityAccountTakeOverInput>;
  context: Scalars["String"];
  input: Array<GraphQlPairInput>;
  socialInput?: InputMaybe<IdentitySocialInput>;
}

/** EG Universal Login success layout component  */
export type IdentitySuccessComponentLayout = {
  __typename?: "IdentitySuccessComponentLayout";
  icon: Icon;
  primary: Scalars["String"];
  secondary?: Maybe<Scalars["String"]>;
};

/** EG Universal Login response in case of success with layout to be displayed or sessions to be stored */
export type IdentitySuccessResponse = IdentityResponse & {
  __typename?: "IdentitySuccessResponse";
  clientSideImpressionEventAnalytics: ClientSideImpressionEventAnalytics;
  identityComponentLayout?: Maybe<IdentityComponentLayout>;
  identityRedirectAction?: Maybe<UiLinkAction>;
  identitySaveCredentials?: Maybe<Scalars["Boolean"]>;
  identitySessionAction?: Maybe<IdentitySessionAction>;
};

export type IdentityTrustWidgetAction = IdentityAccountTakeOverWidgetAction & {
  __typename?: "IdentityTrustWidgetAction";
  inputKeys: Array<Scalars["String"]>;
  type: IdentityAccountTakeOverType;
};

/** EG Universal Login rule which dictates which tells client to update element with new action */
export type IdentityUpdateComponentAction = {
  __typename?: "IdentityUpdateComponentAction";
  action: IdentityAction;
  actionForElement: Scalars["String"];
};

/** EG Universal Login error field which tells which element and text and optional heading to update */
export type IdentityUpdateErrorSummary = IdentityErrorField & {
  __typename?: "IdentityUpdateErrorSummary";
  blockId: Scalars["String"];
  elementId: Scalars["String"];
  errorText: Scalars["String"];
  heading?: Maybe<Scalars["String"]>;
};

export type IdentityValidationList = {
  __typename?: "IdentityValidationList";
  icon: Scalars["String"];
  title: Scalars["String"];
  validations: Array<EgdsInputValidation>;
};

export type IdentityValidationState = {
  __typename?: "IdentityValidationState";
  strengthIndicator: Scalars["String"];
  validationSum: Scalars["Int"];
};

/** EG Universal Login rule which dictates which elements should trigger visibility of the element */
export type IdentityVisibilityRule = {
  __typename?: "IdentityVisibilityRule";
  elements: Array<Scalars["String"]>;
  initialVisibility: Scalars["Boolean"];
};

/**
 * A pictorial representation that communicates and illuminates a concept, idea, or process to a user with delight, interest, and beauty.
 * https://www.figma.com/file/PhrzWgeLfR11IxzTZ80ypI/BEX-Illustration
 */
export type Illustration = EgdsElement & {
  __typename?: "Illustration";
  /** The localized text describing the illustration */
  description: Scalars["String"];
  egdsElementId?: Maybe<Scalars["String"]>;
  /** The token name used for loading this illustration */
  id: Scalars["String"];
  /** The location of the illustration pointing to CDN */
  url: Scalars["URL"];
};

export type Image = {
  __typename?: "Image";
  /**
   * Alternate text to be used for accessibility features
   * @deprecated Use description instead
   */
  altText?: Maybe<Scalars["String"]>;
  /** Aspect Ratio of the image */
  aspectRatio?: Maybe<AspectRatio>;
  /** The localized text describing the image */
  description: Scalars["String"];
  /** thumbnail image click analytics */
  thumbnailClickAnalytics?: Maybe<ClientSideAnalytics>;
  url: Scalars["URL"];
};

export type ImageUrlArgs = {
  dimensions?: InputMaybe<DimensionsInput>;
};

export type ImageGallery = {
  __typename?: "ImageGallery";
  /** The main image to show for the property */
  featured?: Maybe<TaapAgencyImage>;
  /** All images for the property */
  images?: Maybe<Array<Maybe<TaapAgencyImage>>>;
};

export type ImportantInfoDetails = {
  __typename?: "ImportantInfoDetails";
  importantInfoMessage?: Maybe<ImportantInfoSection>;
};

/** ImportantInfo section title and list */
export type ImportantInfoSection = {
  __typename?: "ImportantInfoSection";
  infoList: EgdsBulletedList;
  title: Scalars["String"];
};

/** Represents the attributes on an inline notification */
export type InboxNotification = ContextualNotification & {
  __typename?: "InboxNotification";
  /** Represents the background image to be used in the notification */
  backgroundImage?: Maybe<Image>;
  /** Represents the list of the notification messages to show in the body section of the notification to be displayed on the client */
  body?: Maybe<Array<NotificationPhrase>>;
  /** Represents a link that should be applied to the container of the notification */
  containerLink?: Maybe<NotificationContainerLink>;
  /** Represents the end time of the notification */
  displayEndDateTime?: Maybe<BexApiDateTime>;
  /** Represents the start time of the notification */
  displayStartDateTime?: Maybe<BexApiDateTime>;
  /** Represents the icon that will be used in the notification */
  icon?: Maybe<Icon>;
  /** Represents the notification links to be displayed on the client */
  links?: Maybe<Array<NotificationPhraseLinkNode>>;
  /** Represents a logo image */
  logo?: Maybe<Image>;
  /** Represents the actions to apply on notification reveal */
  revealActions?: Maybe<Array<NotificationAction>>;
  /** Represents the subtype of the notification */
  subType?: Maybe<NotificationSubType>;
  /** Represents the time stamp of notification */
  timeStamp?: Maybe<Scalars["String"]>;
  /** Represents heading title of the notification to be displayed on the client */
  title?: Maybe<NotificationPhrase>;
  /** Represents the type of the notification */
  type: NotificationType;
};

/** Delete the given notification */
export type InboxNotificationDeleteResponse = {
  __typename?: "InboxNotificationDeleteResponse";
  /** The status of delete operation */
  operationStatus: OperationStatus;
};

/** Update result of the given notification */
export type InboxNotificationUpdateResponse = {
  __typename?: "InboxNotificationUpdateResponse";
  /** Represents the type of message of the response */
  messageType: NotificationMessageType;
  /** The updated notificationId */
  notificationId: Scalars["String"];
};

/** Update result of the given notification */
export type InboxNotificationUpdateStateResponse = {
  __typename?: "InboxNotificationUpdateStateResponse";
  /** The updated notificationId */
  notificationId: Scalars["String"];
  /** Represents the notification state of the updated notification */
  notificationState: NotificationState;
  /** Represents the operation status of the update query performed */
  operationStatus: OperationStatus;
};

export type IncentivesActionLink = {
  __typename?: "IncentivesActionLink";
  /** Incentives action link accessibility text */
  accessibility?: Maybe<Scalars["String"]>;
  /** Client-side analytics */
  analytics: ClientSideAnalytics;
  /** Incentives action button */
  button?: Maybe<EgdsButton>;
  /** Client-side click analytics */
  clickAnalytics: ClientSideAnalytics;
  /** Client-side impression analytics */
  impressionAnalytics: ClientSideAnalytics;
  /** Incentives action link */
  resource: HttpUri;
};

export type IncentivesCollection = {
  __typename?: "IncentivesCollection";
  /** Incentives collection action link */
  actionLink?: Maybe<IncentivesActionLink>;
  collectionBody?: Maybe<IncentivesCollectionBody>;
  /** Incentives collection header */
  collectionHeader?: Maybe<IncentivesCollectionHeader>;
  /** List of collection cards */
  collectionItems?: Maybe<Array<IncentivesCollectionItem>>;
  /** Eg Recommendation Id, used for tracking */
  egRecommendationResponseId?: Maybe<Scalars["String"]>;
  /** Impression analytics to track items/collection impression events */
  impressionAnalytics?: Maybe<ClientSideImpressionEventAnalytics>;
};

export type IncentivesCollectionBody = IncentivesHeroTilesBody | IncentivesMediaTilesBody;

export type IncentivesCollectionError = {
  __typename?: "IncentivesCollectionError";
  /** Incentives collection action link */
  action?: Maybe<IncentivesActionLink>;
  /** Incentives collection error header */
  header?: Maybe<IncentivesCollectionHeader>;
};

export type IncentivesCollectionHeader = {
  __typename?: "IncentivesCollectionHeader";
  /** Collection description */
  description?: Maybe<Scalars["String"]>;
  /** Incentives collection image */
  incentivesImage?: Maybe<IncentivesImage>;
  /** Collection subtitle */
  subtitle?: Maybe<Scalars["String"]>;
  /** Incentives collection terms and conditions dialog */
  termsAndConditionsDialog?: Maybe<TermsAndConditions>;
  /** Incentives collection header */
  title: Scalars["String"];
};

export type IncentivesCollectionItem = IncentivesContentItem;

export type IncentivesCollectionSuccess = {
  __typename?: "IncentivesCollectionSuccess";
  collectionBody?: Maybe<IncentivesCollectionBody>;
  /** List of collection cards */
  collectionItems?: Maybe<Array<IncentivesCollectionItem>>;
  /** Eg Recommendation Id, used for tracking */
  egRecommendationResponseId?: Maybe<Scalars["String"]>;
  /** Incentives collection header */
  header?: Maybe<IncentivesCollectionHeader>;
  /** Impression analytics to track items/collection impression events */
  impressionAnalytics?: Maybe<ClientSideImpressionEventAnalytics>;
};

export type IncentivesCollectionView = IncentivesCollectionError | IncentivesCollectionSuccess;

export type IncentivesContentItem = {
  __typename?: "IncentivesContentItem";
  /** Incentives content item action link */
  actionLink: IncentivesActionLink;
  /** Size of the displayed card */
  cardSize: CardSize;
  /** Incentives content item description */
  description?: Maybe<Scalars["String"]>;
  /** Incentives content item image */
  incentivesImage: IncentivesImage;
  /** Recommendation Id (E.g. item gaia id), used for tracking */
  recommendationId?: Maybe<Scalars["String"]>;
  /** Incentives content item subtitle */
  subtitle?: Maybe<Scalars["String"]>;
  /** Incentives content item title */
  title: Scalars["String"];
};

export type IncentivesHeroTile = {
  __typename?: "IncentivesHeroTile";
  /** Incentives action */
  action: IncentivesActionLink;
  /** Incentives tile content */
  content: IncentivesTileContent;
  /** Incentives image */
  image: Image;
  /** Incentives offers */
  offers: Array<IncentivesOfferTile>;
};

export type IncentivesHeroTilesBody = {
  __typename?: "IncentivesHeroTilesBody";
  /** Incentives summary */
  summary?: Maybe<IncentivesResultsSummary>;
  /** Incentives Tiles */
  tiles: Array<IncentivesHeroTile>;
};

export type IncentivesImage = {
  __typename?: "IncentivesImage";
  /** Incentives collection image attribution */
  attribution?: Maybe<IncentivesImageAttribution>;
  /** Incentives collection image */
  image: Image;
};

export type IncentivesImageAttribution = {
  __typename?: "IncentivesImageAttribution";
  /** Incentives attribution dialog */
  dialog: IncentivesImageAttributionDialog;
  /** Incentives attribution dialog trigger */
  dialogTriggerAccessibility: Scalars["String"];
};

export type IncentivesImageAttributionDialog = {
  __typename?: "IncentivesImageAttributionDialog";
  /** Localized attribution dialog close text e.g. 'close' */
  closeText: Scalars["String"];
  /** Attribution dialog text e.g. 'Photo by Author name' */
  text: Scalars["String"];
};

export type IncentivesJourney = IncentivesTiles;

export type IncentivesMedia = {
  __typename?: "IncentivesMedia";
  /** Incentives media badges */
  badges: Array<EgdsBadge>;
  /** Incentives gallery carousel */
  gallery: EgdsGalleryCarousel;
};

export type IncentivesMediaItem = MediaItem & {
  __typename?: "IncentivesMediaItem";
  /** Incentives media image */
  media: Image;
};

export type IncentivesMediaTile = {
  __typename?: "IncentivesMediaTile";
  /** Incentives action */
  action?: Maybe<IncentivesActionLink>;
  /** Incentives card link */
  cardLink: IncentivesActionLink;
  /** Incentives content */
  content: IncentivesTileContent;
  /** Incentives media */
  media: IncentivesMedia;
  /** Incentives price */
  price: IncentivesMediaTilePrice;
  /** Incentives rating */
  rating: EgdsSpannableText;
};

export type IncentivesMediaTilePrice = {
  __typename?: "IncentivesMediaTilePrice";
  /** Incentives price badges */
  badge?: Maybe<EgdsBadge>;
  /** Incentives price lockup */
  price: EgdsPriceLockup;
};

export type IncentivesMediaTilesBody = {
  __typename?: "IncentivesMediaTilesBody";
  /** Incentives summary */
  summary?: Maybe<IncentivesResultsSummary>;
  /** Incentives tiles */
  tiles: Array<IncentivesMediaTile>;
};

export type IncentivesOfferTile = {
  __typename?: "IncentivesOfferTile";
  /** Incentives card link */
  cardLink: IncentivesActionLink;
  /** Incentives offer tile option */
  options: Array<IncentivesOfferTileOption>;
  /** Incentives price */
  price: EgdsSpannableText;
};

export type IncentivesOfferTileOption = {
  __typename?: "IncentivesOfferTileOption";
  /** Incentives badge */
  badge: EgdsStandardBadge;
  /** Incentives destination */
  destination: EgdsGraphicText;
  /** Incentives info */
  info: EgdsGraphicText;
  /** Incentives origin */
  origin: EgdsGraphicText;
  /** Incentives time */
  time: EgdsSpannableText;
};

export type IncentivesResultsSummary = {
  __typename?: "IncentivesResultsSummary";
  /** Incentives summary date */
  dealsDate: EgdsSpannableText;
  /** Incentives summary message */
  message?: Maybe<Scalars["String"]>;
};

export type IncentivesTileContent = {
  __typename?: "IncentivesTileContent";
  /** Incentives content description */
  description?: Maybe<Scalars["String"]>;
  /** Incentives content subtitle */
  subTitle?: Maybe<Scalars["String"]>;
  /** Incentives content title */
  title: Scalars["String"];
};

export type IncentivesTiles = {
  __typename?: "IncentivesTiles";
  /** Incentives collection items */
  tiles: Array<IncentivesCollectionItem>;
};

export type IncludedFeeFooter = {
  __typename?: "IncludedFeeFooter";
  description: Scalars["String"];
  title: Scalars["String"];
};

/** A single step in the step indicator module */
export type IndicatorStep = {
  __typename?: "IndicatorStep";
  a11yLabel: Scalars["String"];
  changeSelection?: Maybe<StepIndicatorChangeSelection>;
  currentStep: Scalars["Boolean"];
  label: StepIndicatorLabel;
};

/** Represents the attributes on an inline notification */
export type InlineNotification = ContextualNotification & {
  __typename?: "InlineNotification";
  /** Represents the attributes required by the notification */
  attributes?: Maybe<Array<NotificationAttribute>>;
  /** Represents the background image to be used in the notification */
  backgroundImage?: Maybe<Image>;
  /** Represents the list of the notification messages to show in the body section of the notification to be displayed on the client */
  body?: Maybe<Array<NotificationPhrase>>;
  /** Represents a link that should be applied to the container of the notification */
  containerLink?: Maybe<NotificationContainerLink>;
  /** Represents the qr code image with qrCodeTitle field to be used in the notification */
  customQrCode?: Maybe<NotificationQrCode>;
  /** Represents the dismiss on interaction with the notification */
  dismiss?: Maybe<NotificationDismiss>;
  /** Represents the form to be displayed in the notification */
  form?: Maybe<NotificationForm>;
  /** Represents the icon that will be used in the notification */
  icon?: Maybe<Icon>;
  /** Represents legalText or link to be displayed on the client */
  legalText?: Maybe<NotificationPhrase>;
  /** Represents the notification links to be displayed on the client */
  links?: Maybe<Array<NotificationPhraseLinkNode>>;
  /** Represents a logo image */
  logo?: Maybe<Image>;
  /** Represents the qr code image to be used in the notification */
  qrCode?: Maybe<Image>;
  /** Represents the actions to apply on notification reveal */
  revealActions?: Maybe<Array<NotificationAction>>;
  /** Represents the list of the multi body notification messages to show in the body section of the notification to be displayed on the client */
  subBody?: Maybe<Array<BodyElements>>;
  /** Represents heading title of the notification to be displayed on the client */
  title?: Maybe<NotificationPhrase>;
  /** Represents the type of the notification */
  type: NotificationType;
};

/** Represents a list of inline items that are text */
export type InlinePriceLineText = {
  __typename?: "InlinePriceLineText";
  inlineItems: Array<PriceLineText>;
};

/** Type used for displaying inquiry dialog opened on CTA click. */
export type InquiryFormDialogAction = {
  __typename?: "InquiryFormDialogAction";
  dialogAnalytics?: Maybe<ClientSideAnalytics>;
  inquiryFormModal?: Maybe<InquiryFormLayout>;
};

/** Input type for fetching the Inquiry form. */
export interface InquiryFormInput {
  petsAllowed?: InputMaybe<Scalars["Boolean"]>;
  primaryPropertyCriteriaInput?: InputMaybe<PrimaryPropertyCriteriaInput>;
}

/** Return one or the other model for InquiryFormInputElement */
export type InquiryFormInputElement =
  | EgdsBasicCheckBox
  | EgdsBasicSelect
  | EgdsSearchFormTravelersField
  | EgdsTextAreaInputField
  | EgdsTextInputField;

/** Represents the inquiry form query response */
export type InquiryFormLayout = {
  __typename?: "InquiryFormLayout";
  analytics?: Maybe<ClientSideAnalytics>;
  datePicker?: Maybe<EgdsDateRangePicker>;
  disclaimer?: Maybe<Array<EgdsText>>;
  formInput?: Maybe<Array<InquiryFormInputElement>>;
  header?: Maybe<Scalars["String"]>;
  submitButton?: Maybe<UiPrimaryButton>;
};

export type InquiryProminence = "HIGH" | "LOW" | "MEDIUM";

/** Input type for submitting a new Inquiry request. */
export interface InquiryRequestInput {
  inquirerPhoneCountryCode?: InputMaybe<Scalars["String"]>;
  inquirerPhoneNumber?: InputMaybe<Scalars["String"]>;
  message: Scalars["String"];
  optInForMarketing?: InputMaybe<Scalars["Boolean"]>;
  petsAllowed?: InputMaybe<Scalars["Boolean"]>;
  primaryPropertyCriteriaInput: PrimaryPropertyCriteriaInput;
}

/** Type used for displaying confirmation modal after Inquiry submission. */
export type InquiryResponse = {
  __typename?: "InquiryResponse";
  body?: Maybe<Array<Scalars["String"]>>;
  doneButton?: Maybe<UiPrimaryButton>;
  header?: Maybe<Scalars["String"]>;
};

/** Airport info */
export type InsightsAirport = {
  __typename?: "InsightsAirport";
  /** Airport Code, e.g. JFK for John F. Kennedy Intl airport, LHR for London Heathrow airport */
  code: Scalars["String"];
  /** Airport name, e.g. New York (JFK) for John F. Kennedy Intl Airport, London (LHR) for London Heathrow airport */
  name: Scalars["String"];
};

export type InsightsDestination = {
  __typename?: "InsightsDestination";
  /** Gaia regionId of the destination */
  regionId: Scalars["String"];
};

/** A location can be represented by a region id or an airport code. */
export interface InsightsLocationInput {
  /** Three letter IATA code associated with am airport near the location */
  airportCode?: InputMaybe<Scalars["String"]>;
  /** Gaia region id of the location */
  regionId?: InputMaybe<Scalars["String"]>;
}

export type Inspiration = {
  __typename?: "Inspiration";
  ctaText: Scalars["String"];
  ctaUrl: Scalars["String"];
  name: Scalars["String"];
};

export type InspirationModule = {
  __typename?: "InspirationModule";
  ctaText: Scalars["String"];
  headline: Scalars["String"];
  iconImage: Scalars["String"];
  secondaryDestinations?: Maybe<Array<SecondaryDestination>>;
};

export type InsuranceAdditionalInfo = {
  __typename?: "InsuranceAdditionalInfo";
  /** Info dialog for additional information */
  infoDialog?: Maybe<InsuranceInfoDialog>;
};

export type InsuranceBadge = {
  __typename?: "InsuranceBadge";
  /** Icon if any */
  icon?: Maybe<Icon>;
  /** Text */
  text?: Maybe<Scalars["String"]>;
};

export type InsuranceBanner = {
  __typename?: "InsuranceBanner";
  /** The heading of the banner */
  heading?: Maybe<Scalars["String"]>;
  /** The icon of the banner */
  icon?: Maybe<Icon>;
  /** The text of the first link in the banner */
  link?: Maybe<InsuranceLink>;
  /** The main message of the banner body */
  message: Scalars["String"];
};

export type InsuranceBenefit = {
  __typename?: "InsuranceBenefit";
  /** Insurance Details and Disclosure Link */
  details?: Maybe<InsurancePhrase>;
  /** Header of Solicitations */
  header?: Maybe<InsurancePhrase>;
  /** Solicitations of Insurance Product */
  solicitations: InsuranceSolicitationList;
};

/** GraphQL request for benefit details */
export interface InsuranceBenefitDetailsQueryRequestInput {
  /** Benefit Id for which the details are requested */
  benefitId: Scalars["String"];
  /** emil src to collect analytics when it's true  */
  isEmailSrc?: InputMaybe<Scalars["Boolean"]>;
  /** Order Id of the booking */
  orderNumber?: InputMaybe<Scalars["String"]>;
  /** Trip Id of the booking */
  tripId?: InputMaybe<Scalars["String"]>;
}

/** GraphQL response for benefit details */
export type InsuranceBenefitDetailsQueryResponse = {
  __typename?: "InsuranceBenefitDetailsQueryResponse";
  /** Additional attributes */
  attributes: TripCareAttributes;
  /** Header info for benefit details page */
  header: TripCareHeader;
  /** Components to be displayed on UI based on column */
  sections: Array<TripCareLayoutComponent>;
};

export interface InsuranceBookingCancellationRequestInput {
  orderId: Scalars["String"];
  orderLineId: Scalars["String"];
}

export type InsuranceBookingCancellationResponse = {
  __typename?: "InsuranceBookingCancellationResponse";
  errorCode?: Maybe<Scalars["String"]>;
  status: Scalars["String"];
};

/** GraphQL response having Booking Overview Errors */
export type InsuranceBookingOverviewErrorResponse = {
  __typename?: "InsuranceBookingOverviewErrorResponse";
  /** Error Messages for Booking Overview Failures */
  errorMessages: Array<TripCareError>;
};

export interface InsuranceBookingOverviewRequestInput {
  orderNumber?: InputMaybe<Scalars["String"]>;
  tripId?: InputMaybe<Scalars["String"]>;
}

export type InsuranceBookingOverviewResponse = {
  __typename?: "InsuranceBookingOverviewResponse";
  attributes: TripCareAttributes;
  header: TripCareHeader;
  insuranceOverview: TripCareSectionComponent;
};

/** GraphQL request for Insurance Claim Details */
export interface InsuranceClaimDetailsRequestInput {
  /** Order Id of the booking */
  orderNumber?: InputMaybe<Scalars["String"]>;
}

export type InsuranceClaimDetailsResponse = {
  __typename?: "InsuranceClaimDetailsResponse";
  /** Additional attributes */
  attributes: TripCareAttributes;
  /** Header info for benefit details page */
  header: TripCareHeader;
  /** Components to be displayed on UI based on column */
  sections: Array<TripCareLayoutComponent>;
};

export type InsuranceCountry = {
  __typename?: "InsuranceCountry";
  /** Country code used for residency selection */
  code: Scalars["String"];
  /** Default language in country ,to be used in change language option */
  defaultLanguage?: Maybe<Scalars["String"]>;
  /** Country name in residency selection displayed to user */
  name: Scalars["String"];
  /** Regions for a country available in residency selection (non-us case) */
  regions?: Maybe<Array<InsuranceRegion>>;
};

/** Represents criteria for insurance. */
export type InsuranceCriteria = {
  __typename?: "InsuranceCriteria";
  /** Represents free price match promise marketing placement */
  freePmpCustomerPlacement?: Maybe<Scalars["String"]>;
  /** offer token for insurance product */
  insuranceOfferToken?: Maybe<Scalars["String"]>;
  /** Represents PMP up-funnel selection */
  selectedProductId?: Maybe<Scalars["String"]>;
};

/** Represents criteria for insurance. */
export interface InsuranceCriteriaInput {
  /** Represents free price match promise marketing placement */
  freePmpCustomerPlacement?: InputMaybe<Scalars["String"]>;
  /** offer token for insurance product */
  insuranceOfferToken?: InputMaybe<Scalars["String"]>;
  /** Represents PMP up-funnel selection */
  selectedProductId?: InputMaybe<Scalars["String"]>;
}

export type InsuranceDetailPrimingCard = {
  __typename?: "InsuranceDetailPrimingCard";
  /** footer of priming card */
  footer?: Maybe<InsuranceFooter>;
  /** header of priming card */
  header?: Maybe<InsuranceHeader>;
  /** insurance product for priming card */
  products: Array<InsurancePrimingProduct>;
};

export interface InsuranceDetailPrimingForCarInput {
  /** Identifier token for car inventory */
  carOfferToken: Scalars["String"];
  /** Encoded string having certain offer information shown on search page. Eg. priceShown, avg category price */
  continuationContextualId?: InputMaybe<Scalars["String"]>;
  /** Drop-off location for car */
  dropOffLocation?: InputMaybe<InsuranceLocationInput>;
  /** Pick-up location for car */
  pickUpLocation: InsuranceLocationInput;
  /** Reward point selection on  Car offer */
  rewardPointsSelection?: InputMaybe<InsuranceRewardsPointSelectionEnum>;
  /** List of accessories added with Car */
  selectedAccessories?: InputMaybe<Array<Scalars["String"]>>;
}

export interface InsuranceDetailPrimingRequestInput {
  /** Car request for insurance priming */
  carRequest: InsuranceDetailPrimingForCarInput;
}

export type InsuranceDialog = {
  __typename?: "InsuranceDialog";
  /** Dialog action primary button */
  buttonPrimary: InsuranceDialogButton;
  /** Dialog header */
  header?: Maybe<InsuranceHeader>;
  /** It's a unique id to differentiate multiple dialog on same page, also this id is used by uitk react dialog component to update url query param (pwaDialog) */
  id?: Maybe<Scalars["String"]>;
  /** Dialog body text array */
  texts: Array<Scalars["String"]>;
  type: InsuranceMessageType;
};

export type InsuranceDialogButton = {
  __typename?: "InsuranceDialogButton";
  /** Button text */
  text: Scalars["String"];
};

export type InsuranceDialogToggle = {
  __typename?: "InsuranceDialogToggle";
  /** Client analytics object */
  analytics: ClientSideAnalytics;
  /** Dialog cta text */
  toggleText: Scalars["String"];
};

export interface InsuranceFileAClaimRequestInput {
  benefitId: Scalars["String"];
  /** emil src to collect analytics when it's true  */
  isEmailSrc?: InputMaybe<Scalars["Boolean"]>;
  orderNumber?: InputMaybe<Scalars["String"]>;
  tripId?: InputMaybe<Scalars["String"]>;
}

export type InsuranceFileAClaimResponse = {
  __typename?: "InsuranceFileAClaimResponse";
  header: TripCareHeader;
  sections: Array<TripCareLayoutComponent>;
};

export type InsuranceFooter = {
  __typename?: "InsuranceFooter";
  /** Footer message */
  text: Scalars["String"];
};

export type InsuranceHeader = {
  __typename?: "InsuranceHeader";
  /** Recommended badge present along with header */
  badge?: Maybe<InsuranceBadge>;
  /** Icon related to header like important ,disclaimer icon */
  icon?: Maybe<Icon>;
  /** Illustration */
  illustration?: Maybe<Illustration>;
  /** Text message to be displayed in header */
  subText?: Maybe<Scalars["String"]>;
  /** Text message to be displayed in header */
  text: Scalars["String"];
};

export type InsuranceHeaderOld = {
  __typename?: "InsuranceHeaderOld";
  /** Recommended Text */
  recommended?: Maybe<Scalars["String"]>;
  /** Title like Protect your trip */
  title?: Maybe<InsurancePhrase>;
};

export type InsuranceInfoDialog = {
  __typename?: "InsuranceInfoDialog";
  /** Dialog to open on cta */
  dialog: InsuranceDialog;
  /** Trigger for info dialog */
  toggle: InsuranceDialogToggle;
};

export type InsuranceLanguageChangeOption = {
  __typename?: "InsuranceLanguageChangeOption";
  /** Change language label */
  label: Scalars["String"];
  /** Language list */
  languages: Array<InsuranceLanguageModuleContent>;
};

export type InsuranceLanguageModuleContent = {
  __typename?: "InsuranceLanguageModuleContent";
  /** Language code */
  language: Scalars["String"];
  /** Language locale */
  locale: Scalars["String"];
};

export type InsuranceLink = {
  __typename?: "InsuranceLink";
  /** Label for specially-abled users */
  accessibilityLabel?: Maybe<Scalars["String"]>;
  /** Details for analytics events to be published  */
  analytics?: Maybe<ClientSideAnalytics>;
  /** Text displayed to user for link */
  label: Scalars["String"];
  /** Url of link */
  url: HttpUri;
};

export type InsuranceListLayout = "SINGLE_COLUMN";

export type InsuranceListType = "ORDERED" | "UNORDERED";

export type InsuranceListTypeOld = "ICON" | "NUMBERED";

export type InsuranceListUiConfigurations = {
  __typename?: "InsuranceListUIConfigurations";
  /** The icon to be used on each item, in case of bulleted list */
  icon?: Maybe<Icon>;
  /** Specifies the layout of the list - single or multi columnar */
  layout?: Maybe<InsuranceListLayout>;
  /** If a list item has a sublist, defines the configurations of the sublist */
  sublistUIConfigurations?: Maybe<InsuranceSublistUiConfigurations>;
  /** Specifies the type of the list - ordered or unordered */
  type?: Maybe<InsuranceListType>;
};

export interface InsuranceLocationInput {
  /** Region id */
  regionId: Scalars["String"];
  /** Search term */
  searchTerm: Scalars["String"];
}

export type InsuranceMessage = {
  __typename?: "InsuranceMessage";
  /** Text content of message */
  content: Scalars["String"];
  /** Icon to be associated with insurance message - error or important info */
  icon?: Maybe<Icon>;
  /** Type of the message, e.g.: Error, Warning */
  type: InsuranceMessageType;
};

export type InsuranceMessageType = "ERROR" | "INFO" | "WARNING";

export type InsuranceModule = {
  __typename?: "InsuranceModule";
  /** Specifying additional information to be delegated to user before purchase like covid disclaimer */
  banner?: Maybe<InsuranceBanner>;
  /** General Disclaimer */
  disclaimer?: Maybe<InsuranceParagraph>;
  /** Language Disclosure */
  disclosure?: Maybe<InsuranceParagraph>;
  /** Header specifying the protection plan's coverage */
  header: InsuranceHeader;
  /** Change language option in case of row pos */
  insuranceLanguageChangeOption?: Maybe<InsuranceLanguageChangeOption>;
  /** insurance that has been updated in shop call */
  insuranceUpdateDetails?: Maybe<InsuranceUpdateDetails>;
  /** A list of insurance messages, can be errors, warnings or information */
  messages?: Maybe<Array<InsuranceMessage>>;
  /** InsuranceOffers given to user encapsulating details of related insurance options */
  offers?: Maybe<Array<InsuranceOffer>>;
  /** Residency details to be displayed for non-us point of sales */
  residencyModule?: Maybe<InsuranceResidencyModule>;
  /** Sub headers with additional information about module */
  subHeaders?: Maybe<Array<InsuranceHeader>>;
  /** Id to be passed in update insurance requests */
  updateRequestId: Scalars["String"];
};

export type InsuranceMutationStatus = "FAILED" | "SUCCESS";

export type InsuranceMutationType = "ADD_INSURANCE" | "REMOVE_INSURANCE";

export type InsuranceOffer = {
  __typename?: "InsuranceOffer";
  /** Decline offer details - customers choose not to select any of the options in the offer */
  declineOfferCard?: Maybe<InsuranceSelectionCard>;
  /** Message to be displayed when one of insurance selection - either yes or no is mandatory */
  forcedChoiceText?: Maybe<Scalars["String"]>;
  /** Protection detail of offer - part of trip it is covering */
  header?: Maybe<InsuranceHeader>;
  /** Insurance options encapsulating insurance product selection */
  options: Array<InsuranceOption>;
  /** Or text displayed between options of same offer */
  orText?: Maybe<Scalars["String"]>;
  /** Message in each offer to select one of radio buttons */
  selectionIntimationMessage?: Maybe<Scalars["String"]>;
  /** Terms and Conditions URL (insurance partner link) */
  termsAndConditionsLink?: Maybe<InsuranceLink>;
};

export type InsuranceOfferOld = {
  __typename?: "InsuranceOfferOld";
  label?: Maybe<InsurancePhrase>;
  offerSelectionMessage: InsuranceOptionSelectedMessage;
  /** Type of Insurance Product */
  offerTypeId?: Maybe<Scalars["Int"]>;
  /** Price of Insurance Product */
  price?: Maybe<Money>;
  /** Price of Insurance Product */
  priceBreakdown?: Maybe<InsurancePhrase>;
};

export type InsuranceOption = {
  __typename?: "InsuranceOption";
  /** Yes selection details for insurance option */
  acceptOptionCard: InsuranceSelectionCard;
  /** Insurance product containing details of benefits offered */
  insuranceProduct?: Maybe<InsuranceProduct>;
  /** Customer testimonial for insurance product */
  testimonial?: Maybe<InsuranceTestimonial>;
};

export type InsuranceOptionSelectedMessage = {
  __typename?: "InsuranceOptionSelectedMessage";
  message?: Maybe<InsurancePhrase>;
  reconsider?: Maybe<Scalars["String"]>;
};

export type InsuranceOptions = {
  __typename?: "InsuranceOptions";
  errorLabel: InsurancePhrase;
  offers?: Maybe<Array<InsuranceOfferOld>>;
  selectionLabel: InsurancePhrase;
};

export type InsuranceParagraph = {
  __typename?: "InsuranceParagraph";
  /** The icon of the card if any */
  icon?: Maybe<Icon>;
  /** The text of the link */
  link?: Maybe<InsuranceLink>;
  /** The main message of the card */
  message: Scalars["String"];
};

/** Represents a sentence consisting of words with various text formatting styles */
export type InsurancePhrase = {
  __typename?: "InsurancePhrase";
  /** Plain text representation of the sentence as an un-attributed string */
  completeText?: Maybe<Scalars["String"]>;
  /** Ordered list of words with their corresponding text styles */
  items?: Maybe<Array<InsurancePhrasePart>>;
};

export type InsurancePhraseLinkNode = InsurancePhrasePart & {
  __typename?: "InsurancePhraseLinkNode";
  /** The underlying hyperlink */
  link: Scalars["URL"];
  /** The style to apply to the text */
  styles?: Maybe<Array<InsurancePhrasePartStyle>>;
  /** The display text for the link */
  text?: Maybe<Scalars["String"]>;
};

export interface InsurancePhrasePart {
  /** The styles to be applied */
  styles?: Maybe<Array<InsurancePhrasePartStyle>>;
  /** String to be stylized */
  text?: Maybe<Scalars["String"]>;
}

export type InsurancePhrasePartStyle =
  /** Green */
  | "COLOR_GREEN"
  /** Red */
  | "COLOR_RED"
  /** Italic styling */
  | "EMPHASIS"
  /** Bold styling */
  | "IMPORTANT"
  /** Represents no style or regular text */
  | "STANDARD";

/** Type to encapsulate attributed/styled Text */
export type InsurancePhraseTextNode = InsurancePhrasePart & {
  __typename?: "InsurancePhraseTextNode";
  /** The style(s) to apply */
  styles?: Maybe<Array<InsurancePhrasePartStyle>>;
  /** The text string to style */
  text?: Maybe<Scalars["String"]>;
};

export type InsurancePrice = {
  __typename?: "InsurancePrice";
  /** Type first text to be displayed below the price value, e.g. 'per person' */
  subtextFirst?: Maybe<Scalars["String"]>;
  /** List of text to be displayed below the price value in order */
  subtextStandard?: Maybe<Array<Scalars["String"]>>;
  /** Formatted price value */
  value: Scalars["String"];
};

export type InsurancePrimingProduct = {
  __typename?: "InsurancePrimingProduct";
  /** List of additional info for individual product */
  additionalInfo?: Maybe<Array<InsuranceAdditionalInfo>>;
  /** Product separator */
  divider?: Maybe<Scalars["Boolean"]>;
  /** footer of insurance product for priming card */
  footer?: Maybe<InsuranceFooter>;
  /** header of insurance product for priming card */
  header?: Maybe<InsuranceHeader>;
  /** insurance product price */
  price?: Maybe<InsurancePrice>;
  /** insurance product solicitations for priming card */
  solicitations: Array<InsuranceSolicitation>;
};

export type InsuranceProduct = {
  __typename?: "InsuranceProduct";
  /** Specifies details related to insurance benefits */
  header?: Maybe<Scalars["String"]>;
  /** Benefits offered in insurance product */
  solicitations: Array<InsuranceSolicitation>;
  /** Describes how the list of insuranceSolicitations should appear visually */
  solicitationsUIConfigurations?: Maybe<InsuranceListUiConfigurations>;
  /** Terms and Conditions URL (insurance partner link) */
  termsAndConditionsLink: InsuranceLink;
};

export type InsuranceRegion = {
  __typename?: "InsuranceRegion";
  /** Region code to be used in residency selection for non-us products */
  code: Scalars["String"];
  /** Region name to be displayed in residency selection for non-us products */
  name: Scalars["String"];
};

export type InsuranceResidencyModule = {
  __typename?: "InsuranceResidencyModule";
  /** List of available countries and their regions */
  countries: Array<InsuranceCountry>;
  /** Country selection */
  countryCode?: Maybe<Scalars["String"]>;
  /** Label to be displayed above country drop down */
  countryLabel: Scalars["String"];
  /** Important information briefing the user about residency selection */
  header: InsuranceParagraph;
  /** Province selection */
  provinceCode?: Maybe<Scalars["String"]>;
  /** Label to be displayed above province drop down */
  provinceLabel: Scalars["String"];
  /** Specifying information if products not available for residency */
  residencyNotAvailableMessage?: Maybe<InsuranceParagraph>;
  /** Residency tool tip contains details about residency selection */
  toolTip?: Maybe<InsuranceToolTipWithDialogBox>;
};

export type InsuranceRewardsPointSelectionEnum = "APPLY_REWARD_POINTS" | "DO_NOT_APPLY_REWARD_POINTS";

export type InsuranceSelectionCard = {
  __typename?: "InsuranceSelectionCard";
  /** Recommended badge associated with option */
  badge?: Maybe<InsuranceBadge>;
  /** Information about actions which would be taken on offer after selecting this card */
  description: Scalars["String"];
  /** Id of the product */
  id?: Maybe<Scalars["Int"]>;
  /** Insurance product containing details of benefits offered */
  insuranceProduct?: Maybe<InsuranceProduct>;
  /** Error message to be displayed when selection - add/remove fails */
  messageOnSelectionFail: InsuranceDialog;
  /** Message to be displayed post user interaction with insurance */
  messageOnSelectionSuccess: InsuranceToast;
  price?: Maybe<InsurancePrice>;
  /** Insurance selection already made by user (if any) */
  selected?: Maybe<Scalars["Boolean"]>;
  /** Id of the product */
  selectionId?: Maybe<Scalars["Int"]>;
  /** subtext for selection card */
  subDescription?: Maybe<Scalars["String"]>;
};

export interface InsuranceSelectionDetailsInput {
  /** Insurance id of already added insurance */
  existingInsuranceProductIds?: InputMaybe<Array<Scalars["String"]>>;
}

export interface InsuranceShoppingRequestInput {
  /** Country code of user's residency - to be passed if akamai headers not present */
  countryCode?: InputMaybe<Scalars["String"]>;
  /** Details of already added insurance */
  insuranceSelectionDetails?: InputMaybe<InsuranceSelectionDetailsInput>;
  /** Region code of user's residency - to be passed if akamai headers not present */
  regionCode?: InputMaybe<Scalars["String"]>;
  /** TripId */
  tripId: Scalars["UUID"];
  /** In order to ignore the caching at client level and make an actual shopping call version hash is changed in subsequent requests */
  versionHash?: InputMaybe<Scalars["String"]>;
}

export type InsuranceShoppingResponse = {
  __typename?: "InsuranceShoppingResponse";
  /** List of insurance modules localized in supporting locales of respective site */
  insuranceModules: Array<LocalizedInsuranceModule>;
};

export type InsuranceShoppingResponseOld = {
  __typename?: "InsuranceShoppingResponseOld";
  /** Benefits offered in Insurance Product */
  benefit?: Maybe<InsuranceBenefit>;
  /** Header Message of Insurance Module like Protect your trip */
  header?: Maybe<InsuranceHeaderOld>;
  /** Options provided to client to choose */
  options?: Maybe<InsuranceOptions>;
  /** Insurance Record Id Uniquely identify insurance Product */
  searchId?: Maybe<Scalars["String"]>;
  /** Social Proof of other clients buying insurance */
  socialProof?: Maybe<InsuranceSocialProof>;
  /** Urgency Message to prompt client to buy insurance */
  urgency?: Maybe<InsurancePhrase>;
};

export type InsuranceSocialProof = {
  __typename?: "InsuranceSocialProof";
  dynamicSocialProof: InsurancePhrase;
  testimonial: InsuranceTestimonialOld;
};

export type InsuranceSolicitation = {
  __typename?: "InsuranceSolicitation";
  /** Detailed explanation of solicitation benefits covered and under what circumstances */
  details?: Maybe<Array<Scalars["String"]>>;
  /** The main sentence of the solicitation ,summarizing the underlying details */
  sentence: Scalars["String"];
};

export type InsuranceSolicitationList = {
  __typename?: "InsuranceSolicitationList";
  solicitations: Array<InsuranceSolicitationOld>;
  type: InsuranceListTypeOld;
};

export type InsuranceSolicitationOld = {
  __typename?: "InsuranceSolicitationOld";
  description?: Maybe<InsurancePhrase>;
  title: InsurancePhrase;
};

export type InsuranceSublistUiConfigurations = {
  __typename?: "InsuranceSublistUIConfigurations";
  /** Specifies the type of the list - ordered or unordered */
  type?: Maybe<InsuranceListType>;
};

export type InsuranceSwitchToggleAction = FlightsClientAction & {
  __typename?: "InsuranceSwitchToggleAction";
  /** Used to provide accessibility that has to be read on completion of action. */
  accessibility?: Maybe<Scalars["String"]>;
  /** Used to capture client side analytics */
  analyticsList: Array<ClientSideAnalytics>;
  /** Used to provide accessibility announcement that has to be read toggling on. */
  checkedAccessibilityAnnouncement?: Maybe<Scalars["String"]>;
  /** Used to pass insurance criteria */
  insuranceCriteria?: Maybe<InsuranceCriteria>;
  /** Used to provide accessibility announcement that has to be read toggling off. */
  uncheckedAccessibilityAnnouncement?: Maybe<Scalars["String"]>;
};

export type InsuranceTestimonial = {
  __typename?: "InsuranceTestimonial";
  /** Name of the testimonial author */
  author: Scalars["String"];
  /** Testimonial by author - can be an experience of author where insurance proved to be helpful */
  text: Scalars["String"];
};

export type InsuranceTestimonialOld = {
  __typename?: "InsuranceTestimonialOld";
  name: InsurancePhrase;
  testimonial: InsurancePhrase;
};

export type InsuranceToast = {
  __typename?: "InsuranceToast";
  text: Scalars["String"];
};

export type InsuranceToolTipWithDialogBox = {
  __typename?: "InsuranceToolTipWithDialogBox";
  /** Tool tip content */
  content: InsuranceDialog;
  /** Tool tip label */
  label: Scalars["String"];
};

export interface InsuranceTripMutationRequestInput {
  action: InsuranceMutationType;
  insuranceSearchId?: InputMaybe<Scalars["String"]>;
  offerTypeId?: InputMaybe<Scalars["Int"]>;
}

export type InsuranceTripMutationResponse = {
  __typename?: "InsuranceTripMutationResponse";
  message?: Maybe<InsurancePhrase>;
  status: InsuranceMutationStatus;
};

export type InsuranceUpdateDetails = {
  __typename?: "InsuranceUpdateDetails";
  /** Insurance ids of insurance removed */
  removedInsuranceProductIds?: Maybe<Array<Scalars["String"]>>;
};

/** Interface for insurtech custom actions */
export interface InsurtechAction {
  /** Adding accessibility for the action */
  accessibility?: Maybe<Scalars["String"]>;
  /** Adding analytics optionally to track user's actions */
  analytics?: Maybe<ClientSideAnalytics>;
}

/** Wrapper of the checkBox group assigned with custom action. */
export type InsurtechCheckBoxWrapper = {
  __typename?: "InsurtechCheckBoxWrapper";
  /** The action will perform when selecting the check button option. */
  action: InsurtechAction;
  /** The EGDS check box */
  checkBox: EgdsCheckBox;
  /** The price will of the offered insurance */
  price?: Maybe<EgdsPriceLockup>;
};

export type InsurtechCheckboxAction = InsurtechAction & {
  __typename?: "InsurtechCheckboxAction";
  accessibility?: Maybe<Scalars["String"]>;
  addInsuranceMessage?: Maybe<Scalars["String"]>;
  analytics?: Maybe<ClientSideAnalytics>;
  insuranceOfferToken?: Maybe<Scalars["String"]>;
  removeInsuranceMessage?: Maybe<Scalars["String"]>;
};

/** Client Id Possibilities */
export type InsurtechClientId = "CAR_INFO_SITE" | "EG_CHECKOUT" | "FCR_CHECKOUT";

/** Union that have the possibilities of the dialog content */
export type InsurtechDialogContent = InsurtechTextDialog;

/** Wrapper component to render link that showing dialog */
export type InsurtechDialogTrigger = {
  __typename?: "InsurtechDialogTrigger";
  /** The link that opens the dialog */
  action: InsurtechLink;
  /** The EGDS dialog type */
  dialog: EgdsDialog;
  /** The dialog content */
  dialogContent: InsurtechDialogContent;
  /** The dialog id */
  dialogId: Scalars["String"];
};

export type InsurtechDialogTriggerAction = InsurtechAction & {
  __typename?: "InsurtechDialogTriggerAction";
  accessibility?: Maybe<Scalars["String"]>;
  analytics?: Maybe<ClientSideAnalytics>;
};

export type InsurtechDismissDialogAction = UiAction & {
  __typename?: "InsurtechDismissDialogAction";
  accessibility: Scalars["String"];
  analytics: ClientSideAnalytics;
};

/** List of elements that represent the components of the section */
export type InsurtechElement =
  | EgdsBulletedList
  | EgdsOrderedList
  | EgdsPlainText
  | EgdsStandardLink
  | EgdsTextIconList
  | EgdsUnorderedList
  | InsurtechCheckBoxWrapper
  | InsurtechLink
  | InsurtechLinkList
  | InsurtechNotice
  | InsurtechRadioGroupWrapper
  | InsurtechSpannableText
  | UiBanner;

/** Custom Link for insurtech module */
export type InsurtechLink = {
  __typename?: "InsurtechLink";
  /** Custom insurtech action for the link */
  action: InsurtechAction;
  /** Icon that might be needed beside the link */
  icon?: Maybe<Icon>;
  size: EgdsLinkSize;
  /** The link text */
  text: Scalars["String"];
};

/** List of Insurtech Links */
export type InsurtechLinkList = {
  __typename?: "InsurtechLinkList";
  links: Array<InsurtechLink>;
};

export type InsurtechModule = {
  __typename?: "InsurtechModule";
  /** badge at the heading of the module. */
  badge?: Maybe<EgdsBadge>;
  contentSections: Array<InsurtechSection>;
  /** The main heading of the module. */
  heading: Scalars["String"];
  residencySection: Array<InsurtechElement>;
};

/** Status Possibilities */
export type InsurtechMutationStatus = "FAILED" | "SUCCESS";

/** Notice message, presented as icon along with spannable text. */
export type InsurtechNotice = {
  __typename?: "InsurtechNotice";
  /** Content as list of inline text elements. */
  content: InsurtechSpannableText;
  /** An icon that conveys what the notice is about, e.g.: warning icon */
  icon: Icon;
};

/** Custom Price representation that will render within spannable text with special formatting. */
export type InsurtechPricePresentation = {
  __typename?: "InsurtechPricePresentation";
  /** Price as text, that will have special styling in frontend. */
  text: Scalars["String"];
};

/** Wrapper of the radio buttons group assigned with custom action. */
export type InsurtechRadioGroupWrapper = {
  __typename?: "InsurtechRadioGroupWrapper";
  /** The action will perform when selecting the radio button option. */
  action: InsurtechAction;
  /** The label of the radio group */
  label: Scalars["String"];
  /** Represents radio buttons describing a set of offer selection options. */
  radioButtonGroup: EgdsRadioGroup;
  /** Specify whether selecting option from the radio group is required or not. */
  required?: Maybe<Scalars["Boolean"]>;
  /** The selected offer identity that will be needed in case of deletion. */
  selectedOffer?: Maybe<OfferIdentity>;
  /** The target offer identity that will be using in mutation to add or delete offers. */
  targetOfferIdentity: OfferIdentity;
};

export type InsurtechSection = {
  __typename?: "InsurtechSection";
  /** Content of the section */
  elements: Array<InsurtechElement>;
  /** Heading of the section */
  heading?: Maybe<Scalars["String"]>;
};

/** insurtech residency actions */
export type InsurtechSetResidencyAction = InsurtechAction & {
  __typename?: "InsurtechSetResidencyAction";
  accessibility?: Maybe<Scalars["String"]>;
  analytics?: Maybe<ClientSideAnalytics>;
  /** Value of the new residency that should be force selected */
  value?: Maybe<ResidencyDetails>;
};

/** Spannable text that may contains custom elements, can be used for representing text with inline. */
export type InsurtechSpannableText = {
  __typename?: "InsurtechSpannableText";
  contents: Array<InsurtechSpannableTextElement>;
};

/** Possible elements that can be rendering within the spannable text. */
export type InsurtechSpannableTextElement =
  | EgdsPlainText
  | EgdsStylizedText
  | InsurtechDialogTrigger
  | InsurtechLink
  | InsurtechPricePresentation;

/** the content of per calender day dialog */
export type InsurtechTextDialog = {
  __typename?: "InsurtechTextDialog";
  text: Scalars["String"];
};

/** Toggle offer actions */
export type InsurtechToggleOfferAction = InsurtechAction & {
  __typename?: "InsurtechToggleOfferAction";
  accessibility?: Maybe<Scalars["String"]>;
  analytics?: Maybe<ClientSideAnalytics>;
  /** Failed message that will be shown when failed adding or removing insurance */
  failedMessage: Scalars["String"];
};

export type InsurtechUpdateOfferAction = InsurtechAction & {
  __typename?: "InsurtechUpdateOfferAction";
  /** @deprecated wrong naming convention */
  AddOfferConfirmationMessage: Scalars["String"];
  /** @deprecated wrong naming convention */
  RemoveOfferConfirmationMessage: Scalars["String"];
  accessibility?: Maybe<Scalars["String"]>;
  /** Success message that will be shown when successfully adding insurance */
  addInsurtechOfferConfirmationMessage: Scalars["String"];
  analytics?: Maybe<ClientSideAnalytics>;
  /** Failed message that will be shown when failed adding or removing insurance */
  failedMessage: Scalars["String"];
  /** Failed message that will be shown when successfully removing insurance */
  removeInsurtechOfferConfirmationMessage: Scalars["String"];
};

/** Provides the interest of a Customer for a particular search */
export type Interest = {
  __typename?: "Interest";
  /** SEM id of interest */
  desmetId?: Maybe<Scalars["String"]>;
  /** Name of interest */
  name?: Maybe<Scalars["String"]>;
};

/** Provides the interest of a Customer for a particular search */
export interface InterestInput {
  /** SEM id of interest */
  desmetId?: InputMaybe<Scalars["String"]>;
  /** Name of interest */
  name?: InputMaybe<Scalars["String"]>;
}

/** Indicate the inventory type of a given offer */
export type InventoryType =
  | "AICTRAVELGROUP"
  | "AMOMA"
  | "ANA"
  | "BESTBUYHOTEL"
  | "BONOTEL"
  | "CNTRAVEL"
  | "CTRIP"
  | "DESPEGAR"
  | "DIDATRAVEL"
  | "DIRECT_AGENCY"
  | "EUROPLAYAS"
  | "EXCITEHOLIDAYS"
  | "EZZEGO_1"
  | "GETAROOM"
  | "HOME_AWAY"
  | "HOTELDOBESTDAYTRAVEL"
  | "HOTEL_BEDS"
  | "HRS"
  | "JAC_TRAVEL"
  | "JAL"
  | "JALAN"
  | "JTB"
  | "JUMBOTOURS"
  | "MAGICROOMS"
  | "MERCHANT"
  | "MGBEDBANK"
  | "MIKI"
  | "MTS"
  | "NTA"
  | "NUITEE"
  | "OPAQUE"
  | "OSTROVOK"
  | "PEGASUS"
  | "RAKUTEN"
  | "RESTEL"
  | "ROOMER"
  | "SMYROOMS"
  | "SUNHOTELS"
  | "THOMASCOOK_EUR"
  | "THOMASCOOK_UK"
  | "TOURICO"
  | "TRAVELLANDA"
  | "TRAVELREPUBLIC"
  | "VENERE"
  | "VRBO"
  | "WELCOME_BEDS"
  | "WOORI"
  | "WORLDHOTELLINK"
  | "WORLDSPAN"
  | "WOTIF"
  | "YOUTRAVEL"
  | "ZUMATA";

export interface Item {
  text: Scalars["String"];
}

/** Itinerary in response */
export type Itinerary = {
  __typename?: "Itinerary";
  flightItinerary?: Maybe<FlightDetail>;
  hotelItinerary?: Maybe<HotelDetail>;
};

/** Information about the itinerary */
export type ItineraryCarousel = {
  __typename?: "ItineraryCarousel";
  /** Button text of gallery carousel container */
  buttonText: CruiseCarouselButtonText;
  /** All the individual items/stops of the itinerary for the carousel cards */
  cards: Array<CruiseItineraryItem>;
};

/** Information about the itinerary */
export type ItineraryDetails = {
  __typename?: "ItineraryDetails";
  /** Mapbox API Key */
  apiKey: Scalars["String"];
  /** All the individual items/stops of the itinerary for the map */
  itineraryMapItems: Array<ItineraryItem>;
};

/** Information about the itinerary for the dynamic map */
export type ItineraryDynamicMapDetails = {
  __typename?: "ItineraryDynamicMapDetails";
  /** Close button for the full screen sheet */
  close: Icon;
  /** Details needed for the carousel */
  itineraryCarousel: ItineraryCarousel;
  /** Details needed for the map */
  itineraryMap: ItineraryMap;
};

/** A day of the itinerary for dynamic map */
export type ItineraryDynamicMapItem = {
  __typename?: "ItineraryDynamicMapItem";
  /** Button for the itinerary item */
  button?: Maybe<EgdsOverlayButton>;
  /** Coordinates for the itinerary item */
  coordinates: Coordinates;
  /** Description for the itinerary item */
  description: Scalars["String"];
  /** Unique identifier for the itinerary item */
  id: Scalars["String"];
};

/** A day of the itinerary */
export type ItineraryItem = {
  __typename?: "ItineraryItem";
  /** Coordinates for the itinerary item */
  coordinates: Coordinates;
  /** Unique identifier for the itinerary item */
  id: Scalars["String"];
  /** Marker image used for rendering on map */
  marker: Image;
};

/** Information about the itinerary */
export type ItineraryMap = {
  __typename?: "ItineraryMap";
  /** Mapbox API Key */
  apiKey: Scalars["String"];
  /** All the individual items/stops of the itinerary for the map */
  markers: Array<ItineraryDynamicMapItem>;
};

/** Information about the itinerary */
export type ItineraryStaticMapDetails = {
  __typename?: "ItineraryStaticMapDetails";
  /** itinerary static map image for large breakpoint */
  large: Image;
  /** itinerary static map image for medium breakpoint */
  medium: Image;
  /** itinerary static map image for small breakpoint */
  small: Image;
};

/** Represents the union of the flights connection information */
export type JourneyConnectionInformation = AdditionalInformation | FlightsConnectionInformation;

/** Represents a pair of segment order as index and the flight identifier as value */
export type JourneyFlightSelection = {
  __typename?: "JourneyFlightSelection";
  /** Represents the segment index. */
  journeyIndex: Scalars["Int"];
  /** Represents the flight combination the customer previously selected for the indexed segment. This will be used to highlight the previously selected offer for pinned listing. */
  offerIdentifier: Scalars["String"];
};

/** Represents a pair of segment order as index and the flight identifier as value */
export interface JourneyFlightSelectionInput {
  /** Represents the segment index. */
  journeyIndex: Scalars["Int"];
  /** Represents the flight combination the customer previously selected for the indexed segment. This will be used to highlight the previously selected offer for pinned listing. */
  offerIdentifier: Scalars["String"];
}

/** Represents journey related information not directly displayed currently. */
export type JourneyInformation = {
  __typename?: "JourneyInformation";
  /** Destination three letter acronym for airport name. For example: 'LHR' */
  destinationAirportCode: Scalars["String"];
  /** Origin three letter acronym for airport name. For example: 'SEA' */
  originAirportCode: Scalars["String"];
  /** Trip type of journey. For example: 'OneWay' */
  tripType: Scalars["String"];
};

/** A part of the journey, part being a connection or a hop and its corresponding additional details */
export type JourneyPart = {
  __typename?: "JourneyPart";
  /** Layover details like destination and duration spent on the stop, next flights origin details */
  connectionAdditionalInformation?: Maybe<AdditionalInformation>;
  /** Describes different aspects of a flight connection */
  flightsConnectionInformation: FlightsConnectionInformation;
};

export type JourneyPartsDynamicElements = {
  __typename?: "JourneyPartsDynamicElements";
  cabinClassAndBookingCode: Scalars["String"];
};

/** Represents a part of a journey, part being a connection, or a hop and its corresponding additional details */
export type JourneySection = {
  __typename?: "JourneySection";
  /** Describes all the information that contain a part, flights connection, additional information */
  journeyConnectionInformation: Array<JourneyConnectionInformation>;
};

/** Contains the information for flight dropdown */
export type JourneySelectionDropDown = {
  __typename?: "JourneySelectionDropDown";
  /** Contains the icon for the leg selection dropdown */
  icon: Icon;
  /** Details of selected leg in dropdown */
  journeySelectionOptions: Array<FlightSelectedLegOption>;
};

/** List of all start and end dates for each journey, used for fetching Covid banner */
export type JourneyStartEndDates = {
  __typename?: "JourneyStartEndDates";
  /** End date for journey in format YYYY-mm-dd */
  endDate: Scalars["String"];
  /** Start date for journey in format YYYY-mm-dd */
  startDate: Scalars["String"];
};

/** Key phrases for a given property */
export type KeyPhrase = {
  __typename?: "KeyPhrase";
  /** The key phrase tag. This will help in getting relevant key phrases for the property. */
  text?: Maybe<Scalars["String"]>;
};

export type KeyPhrasesClientType = "DEFAULT" | "FILTER" | "SNIPPET";

/** A list of key phrases and a localized component label */
export type KeyPhrasesComponent = {
  __typename?: "KeyPhrasesComponent";
  /** Localized component title */
  label?: Maybe<Scalars["String"]>;
  /** List of popular mentions */
  phrases?: Maybe<Array<KeyPhrase>>;
};

export type LanguageSelector = LocalePreferenceSelector & {
  __typename?: "LanguageSelector";
  heading: Scalars["String"];
  options: Array<LanguageSelectorOption>;
  queryParameterName: Scalars["String"];
  trackingEvent: Scalars["String"];
};

export type LanguageSelectorOption = LocaleSelectorOption & {
  __typename?: "LanguageSelectorOption";
  name: Scalars["String"];
  selected: Scalars["Boolean"];
  value: Scalars["String"];
};

/** PWA ONLY: Input that is sent directly from the URL value. These inputs can not be parsed on a server render of the PWA and must be converted in the spinner */
export interface LegacyPropertySearchCriteriaInput {
  /** Maps to PropertyFilterAmenity */
  amenities?: InputMaybe<Array<Scalars["String"]>>;
  /** Maps to ReviewScoreRange */
  guestRating?: InputMaybe<Scalars["String"]>;
  /** Maps to PaymentType enum to account for legacy URL values */
  paymentType?: InputMaybe<Array<Scalars["String"]>>;
  /** List of the price buckets to use. Starts from 0 index e.g. `[0,1,2]` */
  priceBuckets?: InputMaybe<Array<Scalars["Int"]>>;
  /** User preference for tracking which is only required in POSs that require tracking opt in */
  privacyTrackingState?: InputMaybe<PrivacyTrackingState>;
  /** Maps to PropertySort */
  sort?: InputMaybe<Scalars["String"]>;
  /** Maps to starList */
  stars?: InputMaybe<Scalars["String"]>;
  /** Maps to StructureType */
  structureTypes?: InputMaybe<Array<Scalars["String"]>>;
}

/** The legacy model for the iOS trips widget */
export type LegacyWidget = {
  __typename?: "LegacyWidget";
  icons?: Maybe<Array<Scalars["String"]>>;
  imageURL?: Maybe<Scalars["URL"]>;
  productDetailViewModels?: Maybe<Array<TripsWidgetTripProductDetailViewModel>>;
  productsCountText?: Maybe<Scalars["String"]>;
  relevance?: Maybe<TripsWidgetTripDetailItemRelevance>;
  subtitleText?: Maybe<Scalars["String"]>;
  textWithIconViewModels?: Maybe<Array<TripsWidgetTextWithIconViewModel>>;
  titleText?: Maybe<Scalars["String"]>;
  tripId?: Maybe<Scalars["String"]>;
  url?: Maybe<Scalars["URL"]>;
};

/** A list containing trips for the iOS trips widget. */
export type LegacyWidgetComponent = {
  __typename?: "LegacyWidgetComponent";
  trips: Array<LegacyWidget>;
};

export type LegalDetails = {
  __typename?: "LegalDetails";
  disclaimerMessage?: Maybe<Array<LegalSection>>;
  fullContent?: Maybe<LegalFullContent>;
};

/** LegalDialogLink contains the link which when clicked will pop up a new page and content of the page can be rendered using dialogId. */
export type LegalDialogLink = {
  __typename?: "LegalDialogLink";
  /** to render dialog content on the basis of dialogId */
  dialogId: Scalars["String"];
  text: Scalars["String"];
  toolbar?: Maybe<EgdsDialogToolbar>;
};

/** Return one or the other model for LegalElements */
export type LegalElement = EgdsInlineLink | EgdsPlainText | LegalDialogLink;

/** LegalRnRSection is the single expando section */
export type LegalExpandoSection = {
  __typename?: "LegalExpandoSection";
  /** Content field of the expando section */
  content: LegalRnRContent;
  /** Contains Properties related to Exapndo, and will have the implementation of different kinds of EGDS Expandos' like EGDSExpandoCard, EGDSExpandoPeek */
  expando: EgdsExpando;
};

/** Legal RnR Response Object */
export type LegalFullContent = {
  __typename?: "LegalFullContent";
  productPolicies: Array<LegalProductPolicy>;
  toolbarTitle: Scalars["String"];
};

/** It Contains RnR full content header information like title and image url */
export type LegalFullContentHeader = {
  __typename?: "LegalFullContentHeader";
  image?: Maybe<Scalars["String"]>;
  title: Scalars["String"];
};

/** Legal Product Policy Object */
export type LegalProductPolicy = {
  __typename?: "LegalProductPolicy";
  header: Header;
  rnrSection: Array<RnrSection>;
};

/** LegalRnRContent contains html content for each expando or bullet list item */
export type LegalRnRContent = {
  __typename?: "LegalRnRContent";
  htmlContent: Array<Scalars["String"]>;
  urn: Scalars["String"];
};

/** Legal Paragraph that may contain different kinds of elements like legal text, action dialog, action link */
export type LegalSection = {
  __typename?: "LegalSection";
  elements: Array<LegalElement>;
};

export type LimitedResultMessageOnRecommendationCard = CarRecommendationCard & {
  __typename?: "LimitedResultMessageOnRecommendationCard";
  action?: Maybe<CarAction>;
  icon?: Maybe<Icon>;
  recommendationDialog?: Maybe<CarsDialog>;
};

/** Line of business in request */
export type LineOfBusiness = "FLIGHT" | "HOTEL";

/** Line of business */
export type LineOfBusinessDomain =
  | "ACTIVITIES"
  | "CAR"
  | "CRUISES"
  | "FLIGHT"
  | "GROUNDTRANSFERS"
  | "LODGING"
  | "PACKAGES"
  | "RAILS"
  | "UNCLASSIFIED";

/** ADs related property search options  */
export type Listings =
  /** Only return travelAds */
  "ADS_ONLY";

export type ListingsHeading = SortAndLegalHeading;

/** This represents the basic Listings Heading wrapper */
export type ListingsHeadingComponent = {
  __typename?: "ListingsHeadingComponent";
  /** This represents an implementation of the ListingsHeadingInterface */
  listingsHeading: ListingsHeading;
};

/** An interface for a11y live announce messages. */
export interface LiveAnnounce {
  /** A11y message read after an interaction changes the page. */
  liveAnnounceMessage?: Maybe<Scalars["String"]>;
  /** Setting that controls whether message is read immediately or after other messages. */
  liveAnnouncePoliteness?: Maybe<LiveAnnouncePoliteness>;
}

export type LiveAnnouncePoliteness = "ASSERTIVE" | "OFF" | "POLITE";

/** Loaded information's trip review */
export type LoadedFlightsSelectedJourneyReview = FlightsSelectedJourneyReview & {
  __typename?: "LoadedFlightsSelectedJourneyReview";
  /** Represents information sent to clients when user clicks on 'ChangeFlight' */
  changeFlight: FlightsAction;
  /** Represents change flight dialog */
  changeFlightDialog?: Maybe<FlightsDialogChangeFlight>;
  /** Represents onView analytics for Journey Information. This will be triggered when it is visible on the client's viewport */
  collapseAnalytics?: Maybe<FlightsAnalytics>;
  /** Represents onView analytics for Journey Information. This will be triggered when it is visible on the client's viewport */
  expandAnalytics?: Maybe<FlightsAnalytics>;
  /** Summary of the selected fare and an option to either see details or change fare, in case there are no amenities bag details will be sent */
  fareDetails: FareDetails;
  /** Journey highlight like Origin to Destination, departure day, airline */
  flightsJourneyHeaders: FlightsJourneyHeaders;
  /** Summary and Details for a Journey */
  flightsJourneyInformation?: Maybe<FlightsDetailedJourneyInformation>;
  /** Policies for the Journey */
  flightsJourneyPolicies?: Maybe<FlightsTextSection>;
  /** Collapsed view with details like time, duration and stops of the entire journey */
  flightsJourneySummary: FlightsJourneySummary;
  /** @deprecated This field is now deprecated., replace with Use the sibling of FlightsSelectedJourneyReview */
  hygieneAmenitiesPresentation?: Maybe<FlightsHygieneAmenitiesPresentation>;
  /** Represents the basic highlights in multiple segments or Origin Destination pairs */
  journeyHighlights?: Maybe<Array<FlightsJourneyHighlights>>;
  /** Represents journey related information not directly displayed currently. */
  journeyInformation?: Maybe<JourneyInformation>;
  /** Represents onView analytics for Journey Information. This will be triggered when it is visible on the client's viewport */
  onViewedAnalytics?: Maybe<FlightsAnalytics>;
  /** Flag to determine whether Upsell Nudging is Enabled or not */
  upsellNudgingFeatureEnabled: Scalars["Boolean"];
};

/** Brief description of selected standard itinerary like time of flight, stops etc. */
export type LoadedFlightsStandardJourneySummary = FlightsJourneySummary & {
  __typename?: "LoadedFlightsStandardJourneySummary";
  /** Combination of messages that gives a summary of the trip like duration and stops, cabin class details etc. */
  basicFlightDetails: Array<FlightsMessageAndAccessibility>;
  /** Difference between arrival a departure days. Example: '+2' or '+1', accessibility: Flight spans 2 days */
  differentDayArrival?: Maybe<FlightsMessageAndAccessibility>;
  /** Details of the flight departure and arrival time, egs: 1:00pm - 6:00pm, accessibility being 1:00pm to 6:00pm */
  heading: FlightsMessageAndAccessibility;
  /** Represents the amenities included in this flight. Amenities include Wi-Fi, Entertainment and Electric outlets. */
  journeyAmenities?: Maybe<FlightsJourneyAmenities>;
  /** Icon and message to display a red-eye flight related message */
  redEyeMessage?: Maybe<FlightsIconAndLabel>;
};

/** Loading state for information's trip review */
export type LoadingFlightsSelectedJourneyReview = FlightsSelectedJourneyReview & {
  __typename?: "LoadingFlightsSelectedJourneyReview";
  /** Represents information sent to clients when user clicks on 'ChangeFlight' */
  changeFlight: FlightsAction;
  /** Represents change flight dialog */
  changeFlightDialog?: Maybe<FlightsDialogChangeFlight>;
  /** Represents onView analytics for Journey Information. This will be triggered when it is visible on the client's viewport */
  collapseAnalytics?: Maybe<FlightsAnalytics>;
  /** Represents onView analytics for Journey Information. This will be triggered when it is visible on the client's viewport */
  expandAnalytics?: Maybe<FlightsAnalytics>;
  /** Summary of the selected fare and an option to either see details or change fare, in case there are no amenities bag details will be sent */
  fareDetails: FareDetails;
  /** Skeleton count (number of lines for loading state) for change fare section */
  fareSummarySkeletonCount: Scalars["Int"];
  /** Journey highlight like Origin to Destination, departure day, airline */
  flightsJourneyHeaders: FlightsJourneyHeaders;
  /** Summary and Details for a Journey */
  flightsJourneyInformation?: Maybe<FlightsDetailedJourneyInformation>;
  /** Policies for the Journey */
  flightsJourneyPolicies?: Maybe<FlightsTextSection>;
  /** Collapsed view with details like time, duration and stops of the entire journey */
  flightsJourneySummary: FlightsJourneySummary;
  /** @deprecated This field is now deprecated., replace with Use the sibling of FlightsSelectedJourneyReview */
  hygieneAmenitiesPresentation?: Maybe<FlightsHygieneAmenitiesPresentation>;
  /** Represents the basic highlights in multiple segments or Origin Destination pairs */
  journeyHighlights?: Maybe<Array<FlightsJourneyHighlights>>;
  /** Represents journey related information not directly displayed currently. */
  journeyInformation?: Maybe<JourneyInformation>;
  /** Represents onView analytics for Journey Information. This will be triggered when it is visible on the client's viewport */
  onViewedAnalytics?: Maybe<FlightsAnalytics>;
  /** Flag to determine whether Upsell Nudging is Enabled or not */
  upsellNudgingFeatureEnabled: Scalars["Boolean"];
};

/** Brief description of selected standard itinerary like time of flight, stops etc. */
export type LoadingFlightsStandardJourneySummary = FlightsJourneySummary & {
  __typename?: "LoadingFlightsStandardJourneySummary";
  /** Combination of messages that gives a summary of the trip like duration and stops, cabin class details etc. */
  basicFlightDetails: Array<FlightsMessageAndAccessibility>;
  /** Difference between arrival a departure days. Example: '+2' or '+1', accessibility: Flight spans 2 days */
  differentDayArrival?: Maybe<FlightsMessageAndAccessibility>;
  /** Details of the flight departure and arrival time, egs: 1:00pm - 6:00pm, accessibility being 1:00pm to 6:00pm */
  heading: FlightsMessageAndAccessibility;
  /** Represents the amenities included in this flight. Amenities include Wi-Fi, Entertainment and Electric outlets. */
  journeyAmenities?: Maybe<FlightsJourneyAmenities>;
  /** Icon and message to display a red-eye flight related message */
  redEyeMessage?: Maybe<FlightsIconAndLabel>;
  /** Indicates the number of pairs of long and short line for the skeleton, the number of lines for loading state */
  skeletonCount: Scalars["Int"];
};

export interface LocAirport {
  /** Airport Code */
  airportCode: Scalars["String"];
  /** Airport Name */
  airportName?: Maybe<Scalars["String"]>;
}

export type LocaleInfo = {
  __typename?: "LocaleInfo";
  /** the base locale name e.g. en_US, ar_SA */
  baseName: Scalars["Locale"];
  /** The text direction of the locale e.g. ltr (left to right) or rtl (right to left) */
  textDirection: TextDirection;
};

export interface LocalePreferenceSelector {
  heading: Scalars["String"];
  options: Array<Maybe<LocaleSelectorOption>>;
  queryParameterName: Scalars["String"];
  trackingEvent: Scalars["String"];
}

export interface LocaleSelectorOption {
  name: Scalars["String"];
  selected: Scalars["Boolean"];
  value: Scalars["String"];
}

export type LocalizedInsuranceModule = {
  __typename?: "LocalizedInsuranceModule";
  /** Localized insurance module content in repective locale */
  insuranceModule: InsuranceModule;
  /** Locale in which schema needs to be localized */
  locale: Scalars["Locale"];
};

export type Location = {
  __typename?: "Location";
  /** The address of the property */
  address?: Maybe<AgencyAddress>;
  /** The coordinates for the location of the property */
  coordinates?: Maybe<Coordinates>;
  /** Coordinates to display if obfuscation is required */
  obfuscatedCoordinates?: Maybe<Coordinates>;
  /** Whether the location of the property should be displayed */
  obfuscationRequired?: Maybe<Scalars["Boolean"]>;
};

export type LocationRecommendationCard = CarRecommendationCard & {
  __typename?: "LocationRecommendationCard";
  action?: Maybe<CarAction>;
  city?: Maybe<CarPhraseText>;
  distanceText?: Maybe<CarPhraseText>;
  icon?: Maybe<Icon>;
  location?: Maybe<CarsRichText>;
  pickUpLocation?: Maybe<CarSearchLocation>;
  type?: Maybe<Scalars["String"]>;
};

/** Dialog used to show amenities info */
export type LodgingAmenitiesDialog = LodgingDialog & {
  __typename?: "LodgingAmenitiesDialog";
  toolbar?: Maybe<LodgingDialogToolbar>;
  trigger: LodgingDialogTriggerMessage;
};

/** A section of the lodging card dedicated to the media badges */
export type LodgingBadgesGroup = {
  __typename?: "LodgingBadgesGroup";
  /** Badge that belong only media section */
  primaryBadge?: Maybe<EgdsStandardBadge>;
  secondaryBadge?: Maybe<EgdsStandardBadge>;
  tertiaryBadge?: Maybe<EgdsStandardBadge>;
};

/** Dialog used to display lines of text content and actions only. */
export type LodgingBasicContentActionDialog = {
  __typename?: "LodgingBasicContentActionDialog";
  content: Array<Scalars["String"]>;
  dialog: EgdsActionDialog;
};

export type LodgingButton = {
  __typename?: "LodgingButton";
  accessibilityLabel?: Maybe<Scalars["String"]>;
  analytics?: Maybe<ClientSideAnalytics>;
  lodgingClientSideAnalyticsSuccess?: Maybe<LodgingClientSideAnalyticsSuccess>;
  lodgingRecommendationClickstreamEvent?: Maybe<LodgingRecommendationClickstreamEvent>;
  text: Scalars["String"];
};

export interface LodgingButtonAction {
  analytics?: Maybe<ClientSideAnalytics>;
  text?: Maybe<Scalars["String"]>;
}

/** Dialog used to display penalties for all cancellation policies available in a room */
export type LodgingCancellationPolicyDialog = LodgingDialog & {
  __typename?: "LodgingCancellationPolicyDialog";
  content: Array<CancellationPolicyDialogContentEntry>;
  primaryUIButton?: Maybe<UiPrimaryButton>;
  toolbar?: Maybe<LodgingDialogToolbar>;
  trigger: LodgingDialogTriggerMessage;
};

/** A universal lodging card for representing a search or details lodging product. */
export type LodgingCard = {
  __typename?: "LodgingCard";
  callOut?: Maybe<EgdsText>;
  cardLink?: Maybe<UiLinkAction>;
  clickstreamEvents: LodgingCardClickstreamEvents;
  compareSection?: Maybe<LodgingCardCompareSection>;
  featuredHeader?: Maybe<LodgingCardFeaturedHeader>;
  /** @deprecated Deprecated in favor of headingSection.featuredMessages */
  featuredMessages: Array<LodgingCardFeaturedMessage>;
  footerActions: Array<LodgingCardFooterAction>;
  headingSection?: Maybe<LodgingCardHeadingSection>;
  /** Property Id of the product */
  id: Scalars["String"];
  impressionAnalytics?: Maybe<ClientSideImpressionEventAnalytics>;
  mediaSection: LodgingCardMediaSection;
  priceSection?: Maybe<LodgingCardPriceSection>;
  /** @deprecated Deprecated in favor of headingSection.heading */
  propertyName: EgdsHeading;
  /** @deprecated Deprecated in favor of headingSection.productRating */
  propertyRating?: Maybe<EgdsRating>;
  summarySections: Array<LodgingCardSection>;
};

export type LodgingCardChangeAction = LodgingCardChangeUnitDialog | LodgingCardChangeUnitSheet;

export type LodgingCardChangeUnitDialog = {
  __typename?: "LodgingCardChangeUnitDialog";
  dialog: EgdsFullScreenDialog;
  trigger: LodgingCardMoreDetailsTrigger;
};

export type LodgingCardChangeUnitDialogAction = {
  __typename?: "LodgingCardChangeUnitDialogAction";
  dialog: EgdsFullScreenDialog;
  trigger: LodgingCardMoreDetailsTrigger;
};

export type LodgingCardChangeUnitSheet = {
  __typename?: "LodgingCardChangeUnitSheet";
  sheet: EgdsSheet;
  trigger: LodgingCardMoreDetailsTrigger;
};

export type LodgingCardChangeUnitSheetAction = {
  __typename?: "LodgingCardChangeUnitSheetAction";
  sheet: EgdsSheet;
  trigger: LodgingCardMoreDetailsTrigger;
};

/** EG Clickstream event payloads */
export type LodgingCardClickstreamEvents = {
  __typename?: "LodgingCardClickstreamEvents";
  productPresented?: Maybe<LodgingProductEvent>;
  productSelected?: Maybe<LodgingProductEvent>;
};

/** Return EGDSBasicCheckBox type */
export type LodgingCardCompareAction = EgdsBasicCheckBox;

/** A section of the Lodging Card dedicated to displaying information about comparison. */
export type LodgingCardCompareSection = {
  __typename?: "LodgingCardCompareSection";
  compareAction: LodgingCardCompareAction;
};

export type LodgingCardDetailsAction = LodgingCardPropertyDetailsDialog | LodgingCardUnitDetailsDialog;

/** A featured header to be added to the top of a lodging card. */
export type LodgingCardFeaturedHeader = {
  __typename?: "LodgingCardFeaturedHeader";
  header: EgdsHeading;
};

/** Featured messages for the lodging card. e.g Viewed, Private Host, etc. */
export type LodgingCardFeaturedMessage = {
  __typename?: "LodgingCardFeaturedMessage";
  icon?: Maybe<Icon>;
  text: Scalars["String"];
};

/** Actions a user can take in relation to the LodgingCard, located in the card footer. */
export type LodgingCardFooterAction = LodgingCardLinkAction;

/** A section of the lodging card dedicated to heading content like heading, rating, messages at the top */
export type LodgingCardHeadingSection = {
  __typename?: "LodgingCardHeadingSection";
  /** Amenities with icons highlights of the property, e.g Air conditioned, Free breakfast */
  amenities: Array<EgdsIconText>;
  /** Messages that belong at the card level and are to be prominent in the UI, e.g Viewed, Private host */
  featuredMessages: Array<LodgingCardFeaturedMessage>;
  heading: Scalars["String"];
  /** Messages that belong at the card level rather than the summary section level, e.g Neighborhood, Distance from X, Entire home by X */
  messages: Array<EgdsText>;
  productRating?: Maybe<EgdsRating>;
};

export type LodgingCardLinkAction = {
  __typename?: "LodgingCardLinkAction";
  link: EgdsStandardLink;
};

/** A section of the lodging card dedicated to the image gallery and any media that sits on top such as a badge or short list icon. */
export type LodgingCardMediaSection = {
  __typename?: "LodgingCardMediaSection";
  /** @deprecated Deprecated in favor of mediaSection.badges.primaryBadge */
  badge?: Maybe<EgdsStandardBadge>;
  badges?: Maybe<LodgingBadgesGroup>;
  gallery?: Maybe<LodgingGalleryCarousel>;
  /** @deprecated Deprecated in favor of saveTripItem */
  saveItem?: Maybe<LodgingSaveItem>;
  /** A field of the lodging card dedicated to saving/removing the lodging to/from a trip. */
  saveTripItem?: Maybe<TripsSaveItem>;
  /** @deprecated Deprecated in favor of mediaSection.badges.secondaryBadge */
  secondaryBadge?: Maybe<EgdsStandardBadge>;
};

export type LodgingCardMoreDetailsTrigger = {
  __typename?: "LodgingCardMoreDetailsTrigger";
  accessibilityLabel: Scalars["String"];
  analytics: ClientSideAnalytics;
  icon?: Maybe<Icon>;
  label: Scalars["String"];
};

export type LodgingCardPhrase = {
  __typename?: "LodgingCardPhrase";
  accessibilityLabel: Scalars["String"];
  /** @deprecated Deprecated in favor of phraseParts */
  parts: Array<EgdsText>;
  phraseParts: Array<LodgingCardPhrasePart>;
};

/** Return EGDSIconRating, EGDSStylizedText or EGDSPlainText type */
export type LodgingCardPhrasePart = EgdsIconRating | EgdsPlainText | EgdsStylizedText;

/** A section of the Lodging Card dedicated to displaying information about price and offers. */
export type LodgingCardPriceSection = {
  __typename?: "LodgingCardPriceSection";
  badge?: Maybe<EgdsStandardBadge>;
  button?: Maybe<LodgingPrimaryAltButton>;
  priceSummary?: Maybe<PropertyPrice>;
};

/** A section of the lodging card dedicated to providing a summarized view of the property or property unit. */
export type LodgingCardProductSummarySection = {
  __typename?: "LodgingCardProductSummarySection";
  amenities: Array<EgdsIconText>;
  /** @deprecated Deprecated in favor of changeActionDialog and changeActionSheet. */
  changeAction?: Maybe<LodgingCardChangeAction>;
  changeActionDialog?: Maybe<LodgingCardChangeUnitDialogAction>;
  changeActionSheet?: Maybe<LodgingCardChangeUnitSheetAction>;
  descriptionSection?: Maybe<LodgingCardPropertyDescriptionSection>;
  detailsAction?: Maybe<LodgingCardDetailsAction>;
  /** Highlighted key details of property, e.g Fully refundable, Reserve now, pay later */
  footerMessages?: Maybe<EgdsTextList>;
  guestRating?: Maybe<LodgingCardPhrase>;
  heading?: Maybe<EgdsHeading>;
  messages: Array<EgdsText>;
  /** @deprecated Deprecated in favor of footerMessages */
  valuePropositions?: Maybe<EgdsTextIconList>;
};

/** A section of the lodging card to show a description of the property or property unit. */
export type LodgingCardPropertyDescriptionSection = {
  __typename?: "LodgingCardPropertyDescriptionSection";
  description?: Maybe<EgdsParagraph>;
  heading?: Maybe<EgdsHeading>;
  image?: Maybe<Image>;
  link?: Maybe<EgdsStandardLink>;
};

export type LodgingCardPropertyDetailsDialog = {
  __typename?: "LodgingCardPropertyDetailsDialog";
  dialog: EgdsFullScreenDialog;
  trigger: LodgingCardMoreDetailsTrigger;
};

export type LodgingCardSection = LodgingCardProductSummarySection;

export type LodgingCardUnitDetailsDialog = {
  __typename?: "LodgingCardUnitDetailsDialog";
  dialog: EgdsFullScreenDialog;
  trigger: LodgingCardMoreDetailsTrigger;
};

/** A universal carousel container for representing a carousel containing various LodgingCarouselContainerItems */
export type LodgingCarouselContainer = {
  __typename?: "LodgingCarouselContainer";
  /** Contains data for the buttons in carousel */
  carousel?: Maybe<EgdsCarousel>;
  heading: LodgingCarouselContainerHeading;
  /** Analytics for client side impressions */
  impressionAnalytics?: Maybe<ClientSideImpressionEventAnalytics>;
  /** Carousel Items or cards that needs to be displayed within carousel */
  items: Array<LodgingCarouselContainerItem>;
};

/** Return EGDSStylizedText or EGDSExpandoCard */
export type LodgingCarouselContainerHeading = EgdsExpandoCard | EgdsStylizedText;

/** Return LodgingCard or LodgingUnitCard type */
export type LodgingCarouselContainerItem = LodgingCard | LodgingUnitCard;

/** A categorized unit for room or rate categorization */
export type LodgingCategorizedUnit = AccessibilityField & {
  __typename?: "LodgingCategorizedUnit";
  /** Label where a11y behavior is needed. */
  accessibilityLabel?: Maybe<Scalars["String"]>;
  /** @deprecated Deprecated in favor of highlightedMessages */
  cancellationPolicy?: Maybe<RatePlanMessage>;
  /** @deprecated Deprecated in favor of PropertyUnit.detailsDialog */
  detailsDialog?: Maybe<LodgingDialog>;
  featureHeader?: Maybe<EgdsHeading>;
  features?: Maybe<Array<PropertyInfoItem>>;
  /** List of actions the user can perform with the unit (dismiss, etc.) */
  footerActions?: Maybe<Array<UiPrimaryButton>>;
  header?: Maybe<LodgingHeader>;
  highlightedMessages: Array<RatePlanMessage>;
  /** Introduces the included perks of the property unit based on recommendation */
  includedPerks?: Maybe<PropertyInfoContent>;
  /**
   * A label for accessibility purposes.
   * @deprecated Use accessibilityLabel, replace with accessibilityLabel
   */
  label?: Maybe<Scalars["String"]>;
  /** EG Recs response */
  lodgingRecommendationClickstreamEvent?: Maybe<LodgingRecommendationClickstreamEvent>;
  primaryHeader?: Maybe<LodgingOfferSelectionHeader>;
  primarySelections?: Maybe<Array<LodgingPrimaryOfferSelection>>;
  secondaryHeader?: Maybe<LodgingOfferSelectionHeader>;
  tertiaryHeader?: Maybe<LodgingOfferSelectionHeader>;
  /** Unique Id e.g. roomId */
  unitId?: Maybe<Scalars["String"]>;
};

export type LodgingChatbot = {
  __typename?: "LodgingChatbot";
  action?: Maybe<UiPrimaryButton>;
  botNoLabel: Scalars["String"];
  botSkipLabel: Scalars["String"];
  botYesLabel: Scalars["String"];
  content?: Maybe<Scalars["String"]>;
  feedbackContentLabel: Scalars["String"];
  feedbackFormContentLabel: Scalars["String"];
  feedbackFormLabel: Scalars["String"];
  feedbackFormSubmitLabel: Scalars["String"];
  feedbackFormTitleLabel: Scalars["String"];
  header?: Maybe<LodgingHeader>;
};

/** Used to capture success event to the AdaptEx library. See https://pages.github.expedia.biz/eg-reinforcement-learning/mab-docs/#compute-and-send-feedback-directly-to-the-platform for more */
export type LodgingClientSideAnalyticsSuccess = {
  __typename?: "LodgingClientSideAnalyticsSuccess";
  /** Unique identifier for the campaign */
  campaignId: Scalars["String"];
  /** ClientSideAnalytics for AdaptEx success events */
  clientSideAnalytics?: Maybe<ClientSideAnalytics>;
  /** Sequence of feedback events that AdaptEx consumes */
  events: Array<LodgingClientSideAnalyticsSuccessEvents>;
};

/** Definies an AdaptEx events payload */
export type LodgingClientSideAnalyticsSuccessEvents = {
  __typename?: "LodgingClientSideAnalyticsSuccessEvents";
  /** Was the bandit displayed to the user? */
  banditDisplayed: Scalars["Boolean"];
  /** Target of the event, to be used by the stream processor to filter the relevant events */
  eventTarget: Scalars["String"];
  /** Type of the event, to be used by the stream processor to filter the relevant events */
  eventType: Scalars["String"];
  /** Unique payload for the bandit payload */
  payloadId: Scalars["String"];
};

/** Used to display multiple content in a dialog */
export type LodgingComplexDialog = LodgingDialog & {
  __typename?: "LodgingComplexDialog";
  content?: Maybe<Array<DialogContent>>;
  primaryUIButton?: Maybe<UiPrimaryButton>;
  toolbar?: Maybe<LodgingDialogToolbar>;
  trigger: LodgingDialogTriggerMessage;
};

/** A message with plain text and URL action link */
export type LodgingComplexLinkMessage = {
  __typename?: "LodgingComplexLinkMessage";
  /** An action link with text */
  actionLink: LodgingLinkMessage;
  /** A plain message */
  text: LodgingPlainMessage;
};

/** Describes the type of product (line of business) that is being sold */
export type LodgingCrossSellProductType = "CAR";

/** Results from Lodging Destination */
export type LodgingDestinationResults = {
  __typename?: "LodgingDestinationResults";
  /** Dated Search text and hsr links for upcoming nights and weekends */
  datedSearches: LodgingList;
};

/** Results from Lodging Destination */
export type LodgingDestinationResultsDatedSearchesArgs = {
  dataType: Scalars["String"];
  pageType: Scalars["String"];
};

/** Generic dialog used across Lodging LOB. */
export interface LodgingDialog {
  toolbar?: Maybe<LodgingDialogToolbar>;
  trigger: LodgingDialogTriggerMessage;
}

/** Generic error response. */
export type LodgingDialogErrorResponse = {
  __typename?: "LodgingDialogErrorResponse";
  body: Scalars["String"];
  button: UiPrimaryButton;
};

export type LodgingDialogToolbar = {
  __typename?: "LodgingDialogToolbar";
  /** Client analytics data. */
  clientSideAnalytics?: Maybe<ClientSideAnalytics>;
  /** Icon to display next to `title`. */
  icon?: Maybe<Icon>;
  /** Representation of the title of a dialog toolbar. */
  title?: Maybe<Scalars["String"]>;
};

export type LodgingDialogTrigger = {
  __typename?: "LodgingDialogTrigger";
  /** Action details for dialog trigger message. */
  actionDetails?: Maybe<DialogAction>;
  /** Client analytics data. */
  clientSideAnalytics?: Maybe<ClientSideAnalytics>;
  /** Name of the dialog to be launched. */
  dialogName: Scalars["String"];
  /**
   * Referrer for analytics.
   * @deprecated Replaced with the more flexible ClientSideAnalytics type., replace with clientSideAnalytics.referrerId
   */
  referrerId?: Maybe<Scalars["String"]>;
};

/** A message with an action, with optional icon and theme. */
export type LodgingDialogTriggerMessage = FindAnswersDialogTrigger &
  HeaderMessage & {
    __typename?: "LodgingDialogTriggerMessage";
    accessibilityLabel?: Maybe<Scalars["String"]>;
    /** Client analytics data. */
    clientSideAnalytics?: Maybe<ClientSideAnalytics>;
    /** @deprecated Use this trigger message as part of a dialog. */
    dialogTrigger: LodgingDialogTrigger;
    /** Icon to display next to `value`. */
    icon?: Maybe<Icon>;
    /** Mark to display next to `value`. */
    mark?: Maybe<Mark>;
    /** Secondary message to display. */
    secondaryValue?: Maybe<Scalars["String"]>;
    theme?: Maybe<LodgingMessageTheme>;
    /** Primary message to display. */
    value: Scalars["String"];
  };

/** Message with optional icon and theme. */
export type LodgingEnrichedMessage = AccessibilityField & {
  __typename?: "LodgingEnrichedMessage";
  /** Label where a11y behavior is needed. */
  accessibilityLabel?: Maybe<Scalars["String"]>;
  /** Badge to display next to `value` */
  badge?: Maybe<Badge>;
  /** Mark to display next to `value`. */
  egdsMark?: Maybe<Mark>;
  /** Icon to display next to `value`. */
  icon?: Maybe<Icon>;
  /**
   * Accessibility label.
   * @deprecated Use accessibilityLabel, replace with accessibilityLabel
   */
  label?: Maybe<Scalars["String"]>;
  /** Mark to display next to `value`. */
  mark?: Maybe<LodgingMark>;
  /** Theme information for a piece of content. Can indicate color. */
  state?: Maybe<Scalars["String"]>;
  /**
   * Sub text to the value.
   * @deprecated Do not use this field. Deprecated in favor of a new type that will include two message types that can be used to display main text and sub text.
   */
  subText?: Maybe<Scalars["String"]>;
  /** @deprecated Use state to indicate theme. */
  theme?: Maybe<LodgingMessageTheme>;
  /** Message to display. */
  value: Scalars["String"];
};

/** Generic error response. */
export type LodgingErrorResponse = {
  __typename?: "LodgingErrorResponse";
  body?: Maybe<Scalars["String"]>;
  button: UiPrimaryButton;
  errorRecoveryButtons?: Maybe<Array<UiTertiaryButton>>;
  header?: Maybe<Scalars["String"]>;
  icon?: Maybe<Icon>;
};

export interface LodgingExpando {
  collapseButton: LodgingButton;
  expandButton: LodgingButton;
}

export type LodgingExpandoPeek = LodgingExpando & {
  __typename?: "LodgingExpandoPeek";
  collapseButton: LodgingButton;
  expandButton: LodgingButton;
};

export type LodgingExperiment = {
  __typename?: "LodgingExperiment";
  /** For urgent, non-TnL features, put `-1`. */
  id: Scalars["Int"];
  /** For urgent, non-TnL features, should be a descriptive name. */
  name: Scalars["String"];
};

export type LodgingExperimentOwner = {
  __typename?: "LodgingExperimentOwner";
  /** Slack channels for contact/notification purposes. */
  channels: Array<Scalars["String"]>;
  /** Larger org the team is part of (eg: 'LShop') */
  org: Scalars["String"];
  /** Team or squad name, should be distinctive (eg: 'bex-api-pdp-migration-squad' NOT 'LShop'). */
  team: Scalars["String"];
};

export interface LodgingExperimentalFeature {
  /** Purpose of this experimental field. */
  description: Scalars["String"];
  /** Abacus information */
  experiment: LodgingExperiment;
  /** When this field got added; should be updated right before merge. */
  implementationDate: Date;
  /** Basic contact information, without PII. */
  owner: LodgingExperimentOwner;
}

export type LodgingExperimentalMetaData = LodgingExperimentalFeature & {
  __typename?: "LodgingExperimentalMetaData";
  /** Purpose of this experimental field. */
  description: Scalars["String"];
  /** Abacus information */
  experiment: LodgingExperiment;
  /** When this field got added; should be updated right before merge. */
  implementationDate: Date;
  /** Basic contact information, without PII. */
  owner: LodgingExperimentOwner;
};

export interface LodgingExperimentalSection {
  features: Array<LodgingExperimentalMetaData>;
}

export type LodgingExperimentalSectionFeaturesArgs = {
  createdAfter?: InputMaybe<DateInput>;
  createdBefore?: InputMaybe<DateInput>;
  description?: InputMaybe<Scalars["String"]>;
  id?: InputMaybe<Scalars["Int"]>;
  name?: InputMaybe<Scalars["String"]>;
  org?: InputMaybe<Scalars["String"]>;
  team?: InputMaybe<Scalars["String"]>;
};

/** Information about filter */
export type LodgingFilterAttributes = {
  __typename?: "LodgingFilterAttributes";
  /** Filter category/group */
  category: Scalars["String"];
  /** Filter name */
  id: Scalars["String"];
  /** Filter position within category (1-indexed, NOT 0-indexed */
  position: Scalars["Int"];
  /** Filter value */
  value?: Maybe<Scalars["String"]>;
};

export type LodgingFilterClickstreamEvents = {
  __typename?: "LodgingFilterClickstreamEvents";
  filterDeselected?: Maybe<LodgingFilterEvent>;
  filterSelected?: Maybe<LodgingFilterEvent>;
};

/** Aggregated filter with a dialog for filter options */
export type LodgingFilterDialogPill = {
  __typename?: "LodgingFilterDialogPill";
  /** Dialog with filter selection options */
  filterDialog?: Maybe<LodgingFilterSelectionDialog>;
  /** Trigger Pill for filter options */
  triggerPill?: Maybe<EgdsBasicTriggerPill>;
};

/** EG Clickstream event payload for Lodging Filters */
export type LodgingFilterEvent = {
  __typename?: "LodgingFilterEvent";
  event: EgClickstreamEvent;
  search_request: LodgingSearchRequest;
};

/** Pills indicating user-selected filters that apply to offers. */
export type LodgingFilterPill = EgdsBasicPill | LodgingFilterDialogPill;

/** Dialog with filter selection options */
export type LodgingFilterSelectionDialog = {
  __typename?: "LodgingFilterSelectionDialog";
  clearAll?: Maybe<EgdsButton>;
  dialog: EgdsActionDialog;
  filterSection?: Maybe<ShoppingSortAndFilterField>;
  toolbar: EgdsDialogToolbar;
};

/** Data used for constructing a form. Includes action, inputs, submit information (e.g. Pay now button) */
export type LodgingForm = {
  __typename?: "LodgingForm";
  action: Scalars["String"];
  inputs?: Maybe<Array<LodgingFormInput>>;
  method: LodgingFormMethod;
  submit: LodgingButton;
};

export type LodgingFormInput = LodgingTextInput;

export type LodgingFormMethod = "GET" | "POST";

export type LodgingGalleryCarousel = EgdsGalleryCarousel & {
  __typename?: "LodgingGalleryCarousel";
  accessibilityHeadingText: Scalars["String"];
  /** Analytics data for tracking when image close */
  exitAnalytics?: Maybe<ClientSideAnalytics>;
  /** Analytics data for tracking image click. */
  imageClickAnalytics?: Maybe<ClientSideAnalytics>;
  /** Analytics data for tracking intersection while scrolling. */
  intersectionAnalytics?: Maybe<ClientSideAnalytics>;
  media: Array<LodgingMediaItem>;
  /** Analytics data for tracking nav Button click. */
  navClickAnalytics?: Maybe<ClientSideAnalytics>;
  nextButtonText?: Maybe<Scalars["String"]>;
  previousButtonText?: Maybe<Scalars["String"]>;
};

/** Dialog used to display images from an image gallery */
export type LodgingGalleryDialog = LodgingDialog & {
  __typename?: "LodgingGalleryDialog";
  toolbar?: Maybe<LodgingDialogToolbar>;
  trigger: LodgingDialogTriggerMessage;
};

/** Header used across Lodging LOB */
export type LodgingHeader = AccessibilityField & {
  __typename?: "LodgingHeader";
  accessibilityLabel?: Maybe<Scalars["String"]>;
  badge?: Maybe<Badge>;
  headerImage?: Maybe<Image>;
  icon?: Maybe<Icon>;
  impressionAnalytics?: Maybe<ClientSideImpressionEventAnalytics>;
  label?: Maybe<Scalars["String"]>;
  mark?: Maybe<Mark>;
  subText?: Maybe<Scalars["String"]>;
  text?: Maybe<Scalars["String"]>;
};

export type LodgingHeading = {
  __typename?: "LodgingHeading";
  /**
   * Semantic heading level
   * @deprecated No longer used in latest version of uitk-react-text
   */
  level: Scalars["Int"];
  /** Visual size of heading */
  size: Scalars["Int"];
  /** Semantic heading tag */
  tag?: Maybe<Scalars["String"]>;
  /** Text content */
  value: Scalars["String"];
};

export type LodgingIllustration = {
  __typename?: "LodgingIllustration";
  assetUri?: Maybe<HttpUri>;
  description?: Maybe<Scalars["String"]>;
};

/** A dialog launcher consisting of a text input component */
export type LodgingInputDialogTrigger = FindAnswersDialogTrigger & {
  __typename?: "LodgingInputDialogTrigger";
  /** Client analytics data. */
  clientSideAnalytics?: Maybe<ClientSideAnalytics>;
  /** Component that will launch the dialog. */
  component: LodgingTextInput;
};

export type LodgingInputType = "EMAIL" | "HIDDEN" | "PASSWORD" | "TEL" | "TEXT" | "URL";

export type LodgingIntentCard = {
  __typename?: "LodgingIntentCard";
  /** vr card image */
  gallery: LodgingGalleryCarousel;
  /** vr card title */
  headingTitle: Scalars["String"];
  /** event data to be fired on card rendered */
  impressionTracking: ClientSideImpressionEventAnalytics;
  /** vr card message */
  message?: Maybe<Scalars["String"]>;
  /** button to display all related properties */
  primaryButton: UiPrimaryButton;
};

export interface LodgingJumpLink {
  icon?: Maybe<Icon>;
  localizedName: Scalars["String"];
  sectionName: Scalars["String"];
}

/** A message action that consists of a link. */
export type LodgingLink = {
  __typename?: "LodgingLink";
  /** Analytics data for tracking. */
  clientSideAnalytics?: Maybe<ClientSideAnalytics>;
  /**
   * Referrer for analytics.
   * @deprecated Don't use this., replace with clientSideAnalytics
   */
  referrerId?: Maybe<Scalars["String"]>;
  /** target for the action url - _blank|_self|_parent|_top|framename */
  target?: Maybe<Scalars["String"]>;
  /** Destination page URI. */
  uri: HttpUri;
  /**
   * Destination page.
   * @deprecated use uri, replace with uri
   */
  url: Scalars["URL"];
};

export type LodgingLinkButton = {
  __typename?: "LodgingLinkButton";
  /** Link associated with the Button */
  action?: Maybe<UiLinkAction>;
  /** Button for user engagement */
  button: EgdsButton;
};

/** A message with an action, with optional icon and theme. */
export type LodgingLinkMessage = AccessibilityField &
  HeaderMessage & {
    __typename?: "LodgingLinkMessage";
    /** Label where a11y behavior is needed. */
    accessibilityLabel?: Maybe<Scalars["String"]>;
    /** Icon to display next to `value`. */
    icon?: Maybe<Icon>;
    /**
     * Message for the accessibility label.
     * @deprecated Use accessibilityLabel, replace with accessibilityLabel
     */
    label?: Maybe<Scalars["String"]>;
    /** An action users can perform. */
    link: LodgingLink;
    /** Message to display. */
    value: Scalars["String"];
  };

/** List of links with Labels with title */
export type LodgingList = {
  __typename?: "LodgingList";
  items: Array<LodgingListLineItem>;
  title?: Maybe<LodgingHeader>;
};

/** Lodging destination based info */
export type LodgingListLineItem = {
  __typename?: "LodgingListLineItem";
  label?: Maybe<EgdsText>;
  link?: Maybe<EgdsStandardLink>;
};

/** A universal card which divides properties into sections based on their purpose. It can happen that a section is empty as no property meets the requirement */
export type LodgingListingDivider = {
  __typename?: "LodgingListingDivider";
  /** Buttons for user engagement. */
  actions: Array<EgdsButton>;
  /** Rendering information for the divider's background (primary/secondary). */
  backgroundTheme?: Maybe<Scalars["String"]>;
  /** Icon or other graphic element. */
  graphic?: Maybe<UiGraphic>;
  /** Data for tracking user action with the divider. */
  impressionAnalytics?: Maybe<ClientSideImpressionEventAnalytics>;
  /** Additional message of the divider. */
  subtitle?: Maybe<EgdsText>;
  /** The main message of the divider. */
  title?: Maybe<EgdsHeading>;
};

/** Dialog used to show the map */
export type LodgingMapDialog = LodgingDialog & {
  __typename?: "LodgingMapDialog";
  toolbar?: Maybe<LodgingDialogToolbar>;
  trigger: LodgingDialogTriggerMessage;
};

/** The marker that would appear on maps that represents a location. */
export type LodgingMapMarker = EgdsMapMarker & {
  __typename?: "LodgingMapMarker";
  /** the card would show the static map markers on the SRP page. */
  card?: Maybe<LodgingCard>;
  markerIconType: Array<Scalars["String"]>;
  markerPosition: Coordinates;
  markerStatus?: Maybe<EgdsMapMarkerStatus>;
  markerType: Scalars["String"];
  text: Scalars["String"];
};

/** LodgingMark is a Brand specific visual */
export type LodgingMark = {
  __typename?: "LodgingMark";
  /** Description is used for screen readers */
  description: Scalars["String"];
  id: Scalars["String"];
};

export type LodgingMediaItem = MediaItem & {
  __typename?: "LodgingMediaItem";
  /** Media id */
  id?: Maybe<Scalars["String"]>;
  media: Media;
};

/** Dialog used to display sign in option */
export type LodgingMemberSignInDialog = {
  __typename?: "LodgingMemberSignInDialog";
  actionDialog?: Maybe<EgdsActionDialog>;
  dialogContent?: Maybe<EgdsParagraph>;
  title?: Maybe<Scalars["String"]>;
  trigger?: Maybe<LodgingDialogTriggerMessage>;
};

/** Theme information for a message. */
export type LodgingMessageTheme =
  /** To be used for warnings/errors; typically red. */
  | "AGGRESSIVE"
  /** To be used for success/perks; typically green. */
  | "HIGHLIGHT"
  /** To be used for emphasis; typically bold. */
  | "STRONG";

/** Represents a card with both a header and text content. */
export type LodgingNotificationsCard = {
  __typename?: "LodgingNotificationsCard";
  /** Header text content. */
  header?: Maybe<LodgingHeader>;
  /** Contains lines of text content in card body. */
  messages: Array<RatePlanMessage>;
};

export type LodgingOfferFilters = {
  __typename?: "LodgingOfferFilters";
  /** Hidden header message for the screen reader */
  accessibilityHeader?: Maybe<Scalars["String"]>;
  /** Filter pill options for offers */
  filterPills?: Maybe<Array<LodgingFilterPill>>;
  /** Heading text for filters */
  heading?: Maybe<EgdsHeading>;
  /** Live announce message for the screen reader */
  liveAnnounce?: Maybe<Scalars["String"]>;
};

/** Interface for offers, messaging, or anything in the offers results list. */
export type LodgingOfferListing = LodgingCategorizedUnit | LodgingHeader | MessageResult;

/** A typical categorized option, e.g. Non-refundable, e.g. Parking */
export type LodgingOfferOption = LiveAnnounce & {
  __typename?: "LodgingOfferOption";
  accessibilityLabel?: Maybe<Scalars["String"]>;
  clientSideAnalytics?: Maybe<ClientSideAnalytics>;
  description: Scalars["String"];
  dialog?: Maybe<LodgingPlainDialog>;
  enabled: Scalars["Boolean"];
  /** A11y message read after an interaction changes the page. */
  liveAnnounceMessage?: Maybe<Scalars["String"]>;
  /** Setting that controls whether message is read immediately or after other messages. */
  liveAnnouncePoliteness?: Maybe<LiveAnnouncePoliteness>;
  optionId?: Maybe<Scalars["String"]>;
  price?: Maybe<Scalars["String"]>;
  /** Indicates which radio option must be selected */
  selected: Scalars["Boolean"];
  subText?: Maybe<Scalars["String"]>;
};

/** Header for offer selections, e.g. Room features, e.g. Extras */
export type LodgingOfferSelectionHeader = {
  __typename?: "LodgingOfferSelectionHeader";
  dialog?: Maybe<LodgingComplexDialog>;
  title: LodgingHeader;
};

/** Pagination data for the results list */
export type LodgingPagination = {
  __typename?: "LodgingPagination";
  subSets?: Maybe<LodgingPaginationSubSets>;
  /** Represents the different options to trigger pagination call */
  trigger?: Maybe<LodgingPaginationTrigger>;
};

/** Subset Info */
export type LodgingPaginationSubSet = {
  __typename?: "LodgingPaginationSubSet";
  size: Scalars["Int"];
  startingIndex: Scalars["Int"];
};

/** Information on result lists subsets */
export type LodgingPaginationSubSets = {
  __typename?: "LodgingPaginationSubSets";
  nextSubSet?: Maybe<LodgingPaginationSubSet>;
};

/** Represents the different options to trigger pagination call */
export type LodgingPaginationTrigger = LodgingScrollTrigger | UiPrimaryButton;

export type LodgingPill = {
  __typename?: "LodgingPill";
  /** Text of the pill displayed to users. */
  pillLabel: Scalars["String"];
  /** Infosite query string without the filter. */
  query?: Maybe<Scalars["String"]>;
  /** `SELECTED` or `UNSELECTED` (for now), to support empty pill use case. */
  state?: Maybe<Scalars["String"]>;
  /** Filter type, eg: `paymentType`. */
  type: Scalars["String"];
  /** Filter value, eg: `FREE_CANCELLATION`. */
  value?: Maybe<Scalars["String"]>;
};

/** Use to display information */
export type LodgingPlainDialog = LodgingDialog & {
  __typename?: "LodgingPlainDialog";
  content: Array<Scalars["String"]>;
  /** @deprecated use primaryUIButton, replace with primaryUIButton */
  primaryButton?: Maybe<LodgingButton>;
  primaryUIButton?: Maybe<UiPrimaryButton>;
  /** @deprecated use secondaryUIButton, replace with secondaryUIButton */
  secondaryButton?: Maybe<LodgingButton>;
  secondaryUIButton?: Maybe<UiSecondaryButton>;
  /** @deprecated use tertiaryUIButton, replace with tertiaryUIButton */
  tertiaryButton?: Maybe<LodgingButton>;
  tertiaryUIButton?: Maybe<UiTertiaryButton>;
  title?: Maybe<Scalars["String"]>;
  toolbar?: Maybe<LodgingDialogToolbar>;
  trigger: LodgingDialogTriggerMessage;
};

/** Message consisting of plain text. */
export type LodgingPlainMessage = HeaderMessage & {
  __typename?: "LodgingPlainMessage";
  /** Message to display. */
  value: Scalars["String"];
};

/** The marker that would appear on maps that represents a location. */
export type LodgingPlottableMapMarker = LodgingMapMarker;

/** Represents the components of the total price generated for a property */
export type LodgingPriceBreakDown = {
  __typename?: "LodgingPriceBreakDown";
  /** @deprecated This field will hold button/CTA localized content and will be behind TnL - 34934,34935. */
  ctaLabel?: Maybe<Scalars["String"]>;
  footer?: Maybe<LodgingPriceBreakDownEntry>;
  header: Scalars["String"];
  priceBreakDownEntries?: Maybe<Array<LodgingPriceBreakDownEntry>>;
  unbundledEntries?: Maybe<Array<LodgingPriceBreakDownEntry>>;
};

/** Represents a single component of the total price generated for a property */
export type LodgingPriceBreakDownEntry = {
  __typename?: "LodgingPriceBreakDownEntry";
  amount?: Maybe<Scalars["String"]>;
  description?: Maybe<Scalars["String"]>;
  detail?: Maybe<Scalars["String"]>;
};

/** Clickable presentation for LodgingCard SRP */
export type LodgingPrimaryAltButton = {
  __typename?: "LodgingPrimaryAltButton";
  accessibility?: Maybe<Scalars["String"]>;
  action?: Maybe<UiLinkAction>;
  analytics?: Maybe<ClientSideAnalytics>;
  disabled: Scalars["Boolean"];
  icon?: Maybe<Icon>;
  primary?: Maybe<Scalars["String"]>;
};

/** Primary offer selection, e.g. City View feature */
export type LodgingPrimaryOfferSelection = {
  __typename?: "LodgingPrimaryOfferSelection";
  primarySelection?: Maybe<LodgingOfferOption>;
  propertyUnit: PropertyUnit;
  secondarySelections?: Maybe<Array<LodgingSecondaryOfferSelection>>;
};

/** For Search, Expedia property ID */
export type LodgingProduct = {
  __typename?: "LodgingProduct";
  product_id: Scalars["String"];
};

/** EG Clickstream event payload for Lodging Products */
export type LodgingProductEvent = {
  __typename?: "LodgingProductEvent";
  event: EgClickstreamEvent;
  product_list: Array<LodgingProduct>;
  search_request: LodgingSearchRequest;
};

/** Lodging offer response */
export type LodgingProductView = LodgingProductViewSuccess;

/** Layout view that includes a heading and lodging offer details */
export type LodgingProductViewSuccess = {
  __typename?: "LodgingProductViewSuccess";
  card: LodgingCard;
};

/** Represents the rebound information given the context */
export type LodgingRebound = {
  __typename?: "LodgingRebound";
  /** Represents a list of all the rebound information given the context */
  itemDetails?: Maybe<Array<LodgingReboundDetail>>;
  /** Represents the card with the message about the Rebound */
  messagingCard?: Maybe<UiMessagingCard>;
  /** Represents the details about the Rebound */
  messagingDetails?: Maybe<MessagingDetails>;
};

/** Represents each individual rebound information given the context */
export type LodgingReboundDetail = {
  __typename?: "LodgingReboundDetail";
  /** Represents the date range to do the booking */
  bookingDateRange?: Maybe<DateRange>;
  /** Represents the Property Chain Id */
  chainId?: Maybe<Scalars["String"]>;
  /** Represents the Property Chain Name */
  chainName?: Maybe<Scalars["String"]>;
  /** Represents the name to be used for display */
  displayName?: Maybe<Scalars["String"]>;
  /** Represents the Percentage of the coupon */
  percentage: Scalars["Int"];
  /** Represents the Property Id */
  propertyId?: Maybe<Scalars["String"]>;
  /** Represents the date range to stay */
  stayDateRange?: Maybe<DateRange>;
};

/** EG Recs recommendation module for BEX Lodging */
export type LodgingRecommendationClickstreamEvent = {
  __typename?: "LodgingRecommendationClickstreamEvent";
  /** Recommendation response id that gets returned from the EG Recs API call */
  recommendationResponseId?: Maybe<Scalars["String"]>;
};

/** Property Summary */
export type LodgingReviewSummary = {
  __typename?: "LodgingReviewSummary";
  /** This is the checkin score of a property collected by reviews */
  checkInScore?: Maybe<SummaryUnit>;
  /** This is the location score of a property collected by reviews */
  locationScore?: Maybe<SummaryUnit>;
  /** This is the property Id */
  propertyId: Scalars["String"];
  /** This is the list of room summaries by roomType id */
  roomsScore?: Maybe<Array<RoomSummary>>;
};

/** Save Item model */
export type LodgingSaveItem = {
  __typename?: "LodgingSaveItem";
  /** Analytics data for tracking. */
  analytics?: Maybe<ClientSideAnalytics>;
  /** Sets the initial state of the toggle */
  initialChecked: Scalars["Boolean"];
  /** Schema dedicated to saving an item to a user's list */
  items: Array<LodgingSaveItemItem>;
  /** Accessibility labels for the toggle to save/remove an item from the user's list */
  labels?: Maybe<LodgingSaveItemLabels>;
  /** Messages to notify the user that an item has been saved/removed from their list */
  messages?: Maybe<LodgingSaveItemMessages>;
};

export type LodgingSaveItemItem = {
  __typename?: "LodgingSaveItemItem";
  itemId: Scalars["String"];
};

/** Accessibility labels for the toggle to save/remove an item from the user's list */
export type LodgingSaveItemLabels = {
  __typename?: "LodgingSaveItemLabels";
  /** Accessibility label for the toggle to remove an item to the user's list */
  removeLabel?: Maybe<Scalars["String"]>;
  /** Accessibility label for the toggle to save an item to the user's list */
  saveLabel?: Maybe<Scalars["String"]>;
};

/** Messages to notify the user that an item has been saved/removed from their list */
export type LodgingSaveItemMessages = {
  __typename?: "LodgingSaveItemMessages";
  /** Messages to notify the user that an item has been removed from their list */
  removeMessage?: Maybe<Scalars["String"]>;
  /** Messages to notify the user that an item has been saved from their list */
  saveMessage?: Maybe<Scalars["String"]>;
};

/** Information to trigger pagination on scroll */
export type LodgingScrollTrigger = {
  __typename?: "LodgingScrollTrigger";
  analytics?: Maybe<ClientSideAnalytics>;
  triggerAfterPosition?: Maybe<Scalars["Int"]>;
};

/** Represents the lodging search form */
export type LodgingSearchForm = EgdsElement &
  EgdsSearchForm & {
    __typename?: "LodgingSearchForm";
    actionURL: Scalars["String"];
    button: EgdsButton;
    egdsElementId?: Maybe<Scalars["String"]>;
    elements: Array<EgdsSearchFormElement>;
    errorSummary?: Maybe<EgdsErrorSummary>;
    lodgingSearchFormInputIds: LodgingSearchFormInputIds;
    playback?: Maybe<EgdsSearchPlayback>;
    search?: Maybe<EgdsButton>;
  };

/** Fixed inputs for lodging search queries */
export type LodgingSearchFormFixedInputs = EgdsSearchInputs & {
  __typename?: "LodgingSearchFormFixedInputs";
  shoppingSearchCriteria?: Maybe<ShoppingSearchCriteria>;
};

/** Lodging search form input ids that correspond to EGDS elements that clients need to send in the query for lodging search */
export type LodgingSearchFormInputIds = {
  __typename?: "LodgingSearchFormInputIds";
  dateRangeInputId: Scalars["String"];
  destinationInputId: Scalars["String"];
  shoppingSearchCriteriaIds?: Maybe<Array<Scalars["String"]>>;
  travelerSelectorId: Scalars["String"];
};

/** Information about the query for tracking */
export type LodgingSearchRequest = {
  __typename?: "LodgingSearchRequest";
  /** Information about filters used to make the query */
  filters?: Maybe<Array<LodgingFilterAttributes>>;
  /** Search query Trace ID */
  search_id: Scalars["String"];
};

/** Represents the various types of lodging search result messages */
export type LodgingSearchResultHeaderMessage = EgdsPlainText | EgdsStandardLink;

/** Secondary offer selection, e.g. Cancellation Policies */
export type LodgingSecondaryOfferSelection = {
  __typename?: "LodgingSecondaryOfferSelection";
  /** @deprecated Deprecated for TNL 41893 - ABS recommendations */
  recommendedSelection?: Maybe<Scalars["Boolean"]>;
  secondarySelection?: Maybe<LodgingOfferOption>;
  tertiarySelections?: Maybe<Array<LodgingOfferOption>>;
};

export type LodgingShoppingAction = SelectPackageActionInput;

/** Filter options */
export type LodgingSimilarSelectionOptions = {
  __typename?: "LodgingSimilarSelectionOptions";
  /** Link */
  options: Array<Maybe<LodgingLinkMessage>>;
  /** Title */
  title?: Maybe<Scalars["String"]>;
};

export type LodgingStickyButton = LodgingButtonAction & {
  __typename?: "LodgingStickyButton";
  analytics?: Maybe<ClientSideAnalytics>;
  targetRef?: Maybe<PropertySectionRef>;
  text?: Maybe<Scalars["String"]>;
};

/** External survey trigger */
export type LodgingSurveyTrigger = {
  __typename?: "LodgingSurveyTrigger";
  /** Description of the view that the trigger appears in */
  view: Scalars["String"];
};

/** Placeholder type for eventual UDS text input component. */
export type LodgingTextInput = {
  __typename?: "LodgingTextInput";
  /** Icon displayed in the text field. */
  icon?: Maybe<Icon>;
  /** Name of the input field. */
  name?: Maybe<Scalars["String"]>;
  /** Placeholder label in the text field. */
  placeholder?: Maybe<Scalars["String"]>;
  /** Input type. e.g. TEXT, HIDDEN, TEL, EMAIL etc. */
  type?: Maybe<LodgingInputType>;
  /** Value for the input field. */
  value?: Maybe<Scalars["String"]>;
};

/** A simple fly-in (toast) message to be shown as a notification. */
export type LodgingToastMessage = {
  __typename?: "LodgingToastMessage";
  /** Message to display. */
  value: Scalars["String"];
};

export type LodgingToggle = UiToggle & {
  __typename?: "LodgingToggle";
  checked: Scalars["Boolean"];
  checkedAccessibilityLabel?: Maybe<Scalars["String"]>;
  checkedAnalytics: ClientSideAnalytics;
  checkedDescription?: Maybe<Scalars["String"]>;
  checkedLabel: Scalars["String"];
  enabled: Scalars["Boolean"];
  label: Scalars["String"];
  uncheckedAccessibilityLabel?: Maybe<Scalars["String"]>;
  uncheckedAnalytics: ClientSideAnalytics;
  uncheckedDescription?: Maybe<Scalars["String"]>;
  uncheckedLabel: Scalars["String"];
};

/** Card used to render an UnescoPledge */
export type LodgingTravelPledgeCard = {
  __typename?: "LodgingTravelPledgeCard";
  /** Section related the categories */
  categories: Array<EgdsIconText>;
  /** Style of the categories section */
  categoriesLabel: EgdsStylizedText;
  /** Creation date of the UnescoPledge */
  creationDate: Scalars["String"];
  /** ID of an UnescoPledge */
  pledgeId: Scalars["ID"];
  /** Title of the card, it's the name of the property */
  propertyName: EgdsStylizedText;
  /** Button to see the full travel pledge */
  showFullPledge: LodgingTravelPledgeDetailsDialog;
};

/** Type to select a category of action for an UnescoPledge */
export type LodgingTravelPledgeCategory =
  /** Category to support local communities */
  | "COMMUNITY_ENGAGEMENT"
  /** Category to save energy consumption */
  | "CONSERVE_ENERGY"
  /** Category to save water consumption */
  | "CONSERVE_WATER"
  /** USE AT YOUR OWN RISK! Category used just for testing  */
  | "FEEDBACK_MESSAGE"
  /** Category to add additional information about sustainability */
  | "OTHER"
  /** Category to reduce plastic usage */
  | "REDUCE_PLASTIC"
  /** Category to reduce waste */
  | "REDUCE_WASTE";

/** Type which define an UnescoPledge data structure */
export type LodgingTravelPledgeDetailsDialog = {
  __typename?: "LodgingTravelPledgeDetailsDialog";
  /** Sustainability actions on the UnescoPledge */
  commitmentDetails: PropertyContentSectionGroup;
  /** Label for accessibility of Icon close in the dialog */
  iconLabel: EgdsStylizedText;
  /** ID of an UnescoPledge */
  pledgeId: Scalars["ID"];
  /** Name and city of the property signed on the UnescoPledge */
  propertyName: EgdsStylizedText;
  /** Button to open a dialog to show the full pledge */
  showDetails: EgdsButton;
};

/** Type to specify a filter related UnescoPledges */
export interface LodgingTravelPledgeFilterInput {
  /** Categories to filter */
  categories?: InputMaybe<Array<LodgingTravelPledgeCategory>>;
  /** Number of UnescoPledges to visualize */
  pledgesNumber?: InputMaybe<Scalars["Int"]>;
  /** Number of the starting index of UnescoPledges list */
  startingIndex?: InputMaybe<Scalars["Int"]>;
  /** String value to search around PropertyCountry, Property City and PropertyName */
  textSearchValue?: InputMaybe<Scalars["String"]>;
}

/** Return type for a list of UnescoPledgeCard */
export type LodgingTravelPledges = {
  __typename?: "LodgingTravelPledges";
  /** Feedback message used when no pledges are retrieved */
  feedbackMessage?: Maybe<MessageResult>;
  /** Starting index to retrieve UnescoPledgeCard */
  lastIndex: Scalars["Int"];
  /** Boolean to know if there are other UnescoPledgeCard to retrieve */
  showMore?: Maybe<EgdsButton>;
  /** Total number of UnescoPledgeCard stored */
  total: EgdsStylizedText;
  /** UnescoPledgeCard to render */
  travelPledgeCards: Array<LodgingTravelPledgeCard>;
};

/** A card that represents a unit in the rooms overview carousel. */
export type LodgingUnitCard = {
  __typename?: "LodgingUnitCard";
  /**
   * Message for sold out room
   * @deprecated callout is deprecated, use trigger.value with theme:AGGRESSIVE
   */
  callOut?: Maybe<EgdsStylizedText>;
  /**
   * Http URI that links to unit information in the R&R section
   * @deprecated cardLink is deprecated, use unitId to open more-details-modal
   */
  cardLink?: Maybe<UiLinkAction>;
  /** Unit name */
  header?: Maybe<EgdsHeading>;
  /** Unit hero image */
  image?: Maybe<Image>;
  /**
   * Blue link with price as the text
   * @deprecated link is deprecated, use trigger field to display pricing
   */
  link?: Maybe<EgdsInlineLink>;
  /** Trigger field to display price and sold-out message */
  trigger?: Maybe<LodgingDialogTriggerMessage>;
  /** unique Id that represents a room */
  unitId?: Maybe<Scalars["String"]>;
};

export type Loyalty = {
  __typename?: "Loyalty";
  /** @deprecated Used with the legacy loyalty status only. Will be removed in the future */
  member: LoyaltyMember;
  /** @deprecated Used with the legacy loyalty status only. Will be removed in the future */
  memberStatus: Scalars["String"];
};

/** Represents the entire Accounts Page Points Widget */
export type LoyaltyAccountStatusDetails = {
  __typename?: "LoyaltyAccountStatusDetails";
  /** Brand logo to be displayed on accounts page */
  brandMark: Mark;
  /** List of sections (groupings of UI elements) */
  sections: Array<LoyaltyAccountStatusSection>;
  /** Name of the traveler */
  travelerName: Scalars["String"];
};

/** Represents a collection of UI elements that together make up a section/grouping that will be displayed in the UI */
export type LoyaltyAccountStatusSection = {
  __typename?: "LoyaltyAccountStatusSection";
  items: Array<LoyaltyAccountStatusSectionItem>;
  /** Title of the section */
  title: Scalars["String"];
};

/** List of Loyalty UI elements of any of the possible types. */
export type LoyaltyAccountStatusSectionItem =
  | EgdsHeading
  | EgdsPlainText
  | EgdsProgressBar
  | EgdsStandardBadge
  | EgdsStandardLink;

export type LoyaltyEarnCalculationDetailsCard = {
  __typename?: "LoyaltyEarnCalculationDetailsCard";
  /** The body of the card excluding icons */
  body: LoyaltyEarnCalculationWidgetSpannableText;
  /** An optional link that the entire card should link to */
  containerLink?: Maybe<EgdsInlineLink>;
  /** An optional icon to append at the end of the card */
  triggerIcon?: Maybe<Icon>;
  /** User account icon */
  userAccountIcon: Icon;
};

export type LoyaltyEarnCalculationWidgetSpannableText = {
  __typename?: "LoyaltyEarnCalculationWidgetSpannableText";
  contents: Array<LoyaltyEarnMessageSpannableTextTypes>;
  /** The text in its entirety. NO html tags or any other other elements that indicate style should be present. */
  text: Scalars["String"];
};

export type LoyaltyEarnCalculationWidgetSubMenu = EgdsSubMenu & {
  __typename?: "LoyaltyEarnCalculationWidgetSubMenu";
  items: Array<EgdsMenuListItem>;
  title?: Maybe<Scalars["String"]>;
};

/** A list of EGDS Elements that make up the LoyaltyEarnMessageSpannableText */
export type LoyaltyEarnMessageSpannableTextTypes = EgdsPlainText | EgdsTextMenu;

/** Information meant to educate the user on the loyalty program */
export type LoyaltyEducation = {
  __typename?: "LoyaltyEducation";
  /** The action a user can take based on the information presented */
  action?: Maybe<LoyaltyEducationAction>;
  /** The content on which they will be educated */
  content: LoyaltyEducationContent;
  /** Title of the content so the user knows what they are being educated about */
  title?: Maybe<Scalars["String"]>;
};

/** The action a user can take */
export type LoyaltyEducationAction = {
  __typename?: "LoyaltyEducationAction";
  /** Where/What the action does */
  href?: Maybe<Scalars["String"]>;
  /** The referrer id. Used for analytics purposes so we know if the action is being interacted with */
  rfrr?: Maybe<Scalars["String"]>;
  /** The text of the action so the user knows what it is they are doing */
  text?: Maybe<Scalars["String"]>;
};

/** Represents the various types of education content */
export type LoyaltyEducationContent = LoyaltyPointsEducation | LoyaltyProgramEducation;

/** Perks of the program */
export type LoyaltyEducationPerks = {
  __typename?: "LoyaltyEducationPerks";
  /** descriptions of the perks */
  descriptions: Array<Scalars["String"]>;
  /** icon for the perks */
  icon?: Maybe<Scalars["String"]>;
};

/** Represents a single section of what the user is getting educated on such as points earning */
export type LoyaltyEducationSection = {
  __typename?: "LoyaltyEducationSection";
  /** A description of what this section is */
  description?: Maybe<Scalars["String"]>;
  /** Perks relevant for this section */
  perks?: Maybe<LoyaltyEducationPerks>;
  /** Title of the section */
  title?: Maybe<Scalars["String"]>;
};

export type LoyaltyMember = {
  __typename?: "LoyaltyMember";
  /** @deprecated Used with the legacy loyalty status only. Will be removed in the future */
  firstName: Scalars["String"];
};

/** Information to educate the user on the points */
export type LoyaltyPointsEducation = {
  __typename?: "LoyaltyPointsEducation";
  /** Description of the points */
  description?: Maybe<Scalars["String"]>;
  /** Hero image for the content */
  heroImage?: Maybe<Image>;
  /** Features of the points program such as earning and burning */
  programFeatures: Array<LoyaltyEducationSection>;
};

/** Loyalty Points Information */
export type LoyaltyPointsOption = {
  __typename?: "LoyaltyPointsOption";
  /** Get formatted points string along with unit */
  formattedPoints?: Maybe<Scalars["String"]>;
  /** Caption before price or points, e.g. [or] [and] */
  leadingCaption: Scalars["String"];
  /** Loyalty points value */
  pointsAmount?: Maybe<FormattedNumber>;
  /** Boolean to indicate if points should be displayed first or the cash */
  pointsFirst: Scalars["Boolean"];
  /** Loyalty points unit, e.g. [points] [PTS] */
  pointsUnit?: Maybe<Scalars["String"]>;
};

export type LoyaltyPrice = {
  __typename?: "LoyaltyPrice";
  /** loyalty price amount */
  amount?: Maybe<FormattedNumber>;
  /** loyalty price promotion Description */
  promotionValue?: Maybe<Scalars["String"]>;
  /** loyalty price strikeout amount */
  totalStrikeOutPoints?: Maybe<FormattedNumber>;
  /** loyalty price unit i.e. points */
  unit?: Maybe<Scalars["String"]>;
};

/** Information to educate the user on the program as a whole */
export type LoyaltyProgramEducation = {
  __typename?: "LoyaltyProgramEducation";
  /** Text telling to user to join the program */
  joinProgramText?: Maybe<Scalars["String"]>;
  /** The perks of the program */
  perks: LoyaltyEducationPerks;
};

/** Enumeration for 2fa/mfa verification method */
export type MfaVerificationMethod = "CALL" | "SMS";

export type Moderation_Rule = "ADVISE" | "BLOCK";

export type Moderation_Type = "CHARACTER" | "WORD";

export type ModItem = {
  __typename?: "MODItem";
  /** Member offer availability text */
  modAvailabilityText?: Maybe<Scalars["String"]>;
  /** Member offer signin text */
  modSignInText?: Maybe<Scalars["String"]>;
  /** Member offer tag text */
  modTagText?: Maybe<Scalars["String"]>;
  /** sign in url, accepts a return path to be set as the redirection url */
  signInUrl?: Maybe<HttpUri>;
};

export type ModItemSignInUrlArgs = {
  returnPath?: InputMaybe<Scalars["String"]>;
};

/** Support for `mailto` based URI constructed based on the email address. */
export type MailToUri = Uri & {
  __typename?: "MailToURI";
  emailAddress: Scalars["String"];
  value: Scalars["String"];
};

export type MainReviewFailureComponent = NoProductReviewError;

export type MainReviewLoadingComponent = PriceSummaryDetailsFooterSkeletons;

export type MainReviewSection = MainReviewSectionFailure | MainReviewSectionLoading | MainReviewSectionSuccess;

/** This represents the components for MAIN section when page is in failure state */
export type MainReviewSectionFailure = {
  __typename?: "MainReviewSectionFailure";
  /** This has the list of components to render */
  components: Array<MainReviewFailureComponent>;
};

/** This represents the components for MAIN section when page is loading */
export type MainReviewSectionLoading = {
  __typename?: "MainReviewSectionLoading";
  /** This has the list of components to render */
  components: Array<MainReviewLoadingComponent>;
};

/** This represents the components for MAIN section when page is success */
export type MainReviewSectionSuccess = {
  __typename?: "MainReviewSectionSuccess";
  /** This has the list of components to render */
  components: Array<MainReviewSuccessComponent>;
};

export type MainReviewSuccessComponent =
  | BannerPlacard
  | MessagePlacard
  | MobilitySearchPriceSummaryDialog
  | PriceSummaryDetailsFooter;

export type MainSearchFailureComponent = NoListingsMessage;

export type MainSearchLoadingComponent = ProductListingsSkeletons;

export type MainSearchSection = MainSearchSectionFailure | MainSearchSectionLoading | MainSearchSectionSuccess;

/** This represents the components for MAIN section when search failed */
export type MainSearchSectionFailure = {
  __typename?: "MainSearchSectionFailure";
  /** This has the list of components to render */
  components: Array<MainSearchFailureComponent>;
};

/** This represents the components for MAIN section when search is loading */
export type MainSearchSectionLoading = {
  __typename?: "MainSearchSectionLoading";
  /** This has the list of components to render */
  components: Array<MainSearchLoadingComponent>;
};

/** This represents the components for MAIN section when search is success */
export type MainSearchSectionSuccess = {
  __typename?: "MainSearchSectionSuccess";
  /** This has the list of components to render */
  components: Array<MainSearchSuccessComponent>;
};

export type MainSearchSuccessComponent = BannerPlacard | ListingsHeadingComponent | MessagePlacard | ProductListings;

export type ManagementResponse = {
  __typename?: "ManagementResponse";
  date?: Maybe<Scalars["String"]>;
  displayLocale?: Maybe<Scalars["String"]>;
  header?: Maybe<LodgingHeader>;
  id?: Maybe<Scalars["String"]>;
  response?: Maybe<Scalars["String"]>;
  userNickname?: Maybe<Scalars["String"]>;
};

export type MandatoryFees = {
  __typename?: "MandatoryFees";
  dailyFees: Money;
  totalFees: Money;
  totalPriceWithFees?: Maybe<Money>;
};

export type ManualPriceCheckSection = {
  __typename?: "ManualPriceCheckSection";
  /** Manual price check loading state message */
  loader?: Maybe<PriceMatchPromiseLoader>;
  /** Text content of the manual price check section */
  mainCopy: Array<EgdsComposableTextElement>;
  /** The button to perform a manual price check operation */
  priceCheckButton?: Maybe<UiPrimaryButton>;
  /** Extra text content for the manual check section */
  secondaryCopy?: Maybe<Array<EgdsComposableTextElement>>;
};

/** MapConfiguration is the general configuration to load map */
export interface MapConfiguration {
  /**
   * api key or access token
   * @deprecated Use accessToken from EGDSDynamicMapConfig
   */
  api: Scalars["String"];
  /**
   * eg maps config service endpoint used to retrieve the configuration
   * @deprecated Use the field from EGDSDynamicMapConfig
   */
  externalConfigEndpoint?: Maybe<HttpUri>;
  /**
   * api url
   * @deprecated Map provider api are provider by uitk-react-map or eg-maps in order to ensure that the version has been tested so dont use this field
   */
  url: Scalars["URL"];
}

/** The UDS icon used for the map marker */
export type MapIconType =
  | "AIRPORT"
  | "CIRCLE"
  | "GROCERY"
  | "HOTEL"
  | "LANDMARK"
  | "METRO"
  | "RESTAURANT"
  | "SOLD_OUT"
  | "TRAIN";

/** The map information for the properties returned */
export type MapMarker = {
  __typename?: "MapMarker";
  /** Client analytics data. */
  clientSideAnalytics?: Maybe<ClientSideAnalytics>;
  /** The icon used for the map marker */
  icon: MapIconType;
  /** The localized label to display on the marker */
  label: Scalars["String"];
  /** The coordinates used to determine the marker placement */
  latLong: Coordinates;
  /** Summary information for the marker */
  type?: Maybe<MarkerType>;
};

export type Maps = {
  __typename?: "Maps";
  /** Data used to populate the dynamic map */
  dynamicMap?: Maybe<DynamicMap>;
};

/** EGDS visual assets that do not follow standard sizing to be made icons */
export type Mark = {
  __typename?: "Mark";
  /** The localized text describing the mark */
  description: Scalars["String"];
  /** The egds value used for loading this mark */
  id: Scalars["String"];
  /** The egds orientation of this mark */
  orientation?: Maybe<Orientation>;
  /** The egds size of this mark */
  size?: Maybe<Scalars["String"]>;
  /** The egds id used for loading this mark */
  token: Scalars["String"];
  /** The image source URL for loading this mark */
  url?: Maybe<HttpUri>;
};

export type MarkWrapper = {
  __typename?: "MarkWrapper";
  /** Mark element wrapper */
  mark: Mark;
};

/** The type of map marker */
export type MarkerType = "HOTEL" | "POI";

export type MarketingFeeDetails = {
  __typename?: "MarketingFeeDetails";
  /** Mark to display next to `tierName`. */
  egdsMark?: Maybe<Mark>;
  /** localised and formatted version of the marketing fee */
  formattedFee?: Maybe<Scalars["String"]>;
  /** Mark to display next to `tierName`. */
  mark?: Maybe<LodgingMark>;
  /**
   * detailed information about the marketing fee
   * @deprecated Obtain through marketingFeeMessageDialog., replace with marketingFeeMessageDialog
   */
  marketingFeeMessage: LodgingPlainMessage;
  /** details information about the marketing fee presented in a dialog */
  marketingFeeMessageDialog?: Maybe<LodgingBasicContentActionDialog>;
  /**
   * icon representing the marketing fee tier
   * @deprecated Obtain through the tierMessage field instead, replace with tierMessage
   */
  tierIcon: Scalars["String"];
  /** detailed information about the marketing fee tier */
  tierMessage: LodgingEnrichedMessage;
  /**
   * name of marketing fee tier
   * @deprecated Obtain through the tierMessage field instead, replace with tierMessage
   */
  tierName: Scalars["String"];
};

export type MarketingSection = {
  __typename?: "MarketingSection";
  /** @deprecated This is deprecated. Please use feeDialog instead */
  feeDetails: MarketingFeeDetails;
  /** detailed information about the marketing fee */
  feeDialog: LodgingPlainDialog;
  paymentDetails?: Maybe<LodgingEnrichedMessage>;
  title?: Maybe<LodgingHeader>;
};

/** Some text that contains markup with the type of markup it contains */
export type MarkupText = {
  __typename?: "MarkupText";
  /** The type of markup */
  markupType: MarkupTextType;
  /** A string of text that contains markup */
  text: Scalars["String"];
};

/** Used to indicate what type of markup a field contains */
export type MarkupTextType =
  /** Hypertext markup language */
  "HTML";

export type MaxOccupancyViewModel = {
  __typename?: "MaxOccupancyViewModel";
  adults?: Maybe<Scalars["String"]>;
  children?: Maybe<Scalars["String"]>;
  minimumAge?: Maybe<MinimumAge>;
  total?: Maybe<Scalars["String"]>;
};

/** Information needed to transition the customer towards booking */
export type MaxRoomsFailure = FailureReason & {
  __typename?: "MaxRoomsFailure";
  description: Scalars["String"];
  groupLinkMessage?: Maybe<Scalars["String"]>;
  message: Scalars["String"];
};

export type MealPlanFilterAmenity = "ALL_INCLUSIVE" | "FREE_BREAKFAST" | "FULL_BOARD" | "HALF_BOARD";

/** A media element. eg. a Video or an Image */
export type Media = EgdsPhotosphereImage | Image | Video;

/** Wrapping Single Media Asset. */
export type MediaAsset = {
  __typename?: "MediaAsset";
  /** Media Asset Alt Text */
  altText?: Maybe<Scalars["String"]>;
  /** Media Asset Caption */
  caption?: Maybe<Scalars["String"]>;
  /** Media Asset Author or Credit */
  credit?: Maybe<Scalars["String"]>;
  /** Media Asset Id */
  id: Scalars["String"];
  /** Media Asset Type */
  mediaAssetType?: Maybe<Scalars["String"]>;
  /** Media Asset Library Id */
  mediaLibraryId?: Maybe<Scalars["String"]>;
  /** Media Type */
  mediaType: Media;
  /** Media Click Target */
  targetURL?: Maybe<Scalars["String"]>;
  /** Media Asset Usage */
  usage?: Maybe<Scalars["String"]>;
};

/** A media item that contains media. eg. a Video or an Image */
export interface MediaItem {
  media: Media;
}

export type MediaType = "IMAGE" | "VIDEO";

export type MemberWallet = {
  __typename?: "MemberWallet";
  content: MemberWalletContent;
  details: MemberWalletDetails;
  info: MemberWalletInfo;
};

export type MemberWalletBadge = UiAction & {
  __typename?: "MemberWalletBadge";
  accessibility?: Maybe<Scalars["String"]>;
  analytics: ClientSideAnalytics;
  resource: Uri;
  text: Scalars["String"];
  theme: MemberWalletBadgeTheme;
};

export type MemberWalletBadgeTheme = "LOYALTY_HIGH_TIER" | "LOYALTY_LOW_TIER" | "LOYALTY_MIDDLE_TIER";

export type MemberWalletCallToActionLink = {
  __typename?: "MemberWalletCallToActionLink";
  action: UiLinkAction;
  icon?: Maybe<Icon>;
  text: Scalars["String"];
};

export type MemberWalletContent = {
  __typename?: "MemberWalletContent";
  items: Array<MemberWalletContentItems>;
};

export type MemberWalletContentItems = MemberWalletCallToActionLink;

export type MemberWalletCoupons = {
  __typename?: "MemberWalletCoupons";
  label: Scalars["String"];
  linkAction?: Maybe<UiLinkAction>;
  text: Scalars["String"];
};

export type MemberWalletDetails = {
  __typename?: "MemberWalletDetails";
  items: Array<MemberWalletDetailsItems>;
  moreInfo?: Maybe<MemberWalletMoreInfo>;
};

export type MemberWalletDetailsItem = {
  __typename?: "MemberWalletDetailsItem";
  action?: Maybe<UiAction>;
  label: Scalars["String"];
  mark?: Maybe<Mark>;
  text: Scalars["String"];
};

export type MemberWalletDetailsItems = MemberWalletCoupons | MemberWalletDetailsItem | MemberWalletPoints;

export type MemberWalletHeading = {
  __typename?: "MemberWalletHeading";
  subText?: Maybe<Scalars["String"]>;
  text: Scalars["String"];
};

export type MemberWalletInfo = {
  __typename?: "MemberWalletInfo";
  items: Array<MemberWalletInfoItems>;
};

export type MemberWalletInfoItems = MemberWalletBadge | MemberWalletHeading;

export type MemberWalletMoreInfo = {
  __typename?: "MemberWalletMoreInfo";
  moreInfoLinkAction?: Maybe<UiLinkAction>;
  moreInfoLinkText?: Maybe<Scalars["String"]>;
  moreInfoText: Scalars["String"];
};

export type MemberWalletPoints = {
  __typename?: "MemberWalletPoints";
  action?: Maybe<MemberWalletUiAction>;
  information: PointsInformation;
  label: Scalars["String"];
  text: Scalars["String"];
};

export type MemberWalletUiAction = UiAction & {
  __typename?: "MemberWalletUIAction";
  accessibility?: Maybe<Scalars["String"]>;
  analytics: ClientSideAnalytics;
};

/** Object holding list of coupons */
export type MerchCoupons = {
  __typename?: "MerchCoupons";
  /** List of coupon details */
  coupons: Array<CouponDetail>;
};

/** This represents the message placards */
export type MessagePlacard = {
  __typename?: "MessagePlacard";
  /** This represents the display analytics of a placard */
  displayAnalytics: ClientSideAnalytics;
  /** This represents the UIMessagingCard type */
  messagingCard: UiMessagingCard;
};

export type MessageResult = AccessibilityField & {
  __typename?: "MessageResult";
  /** Label where a11y behavior is needed. */
  accessibilityLabel?: Maybe<Scalars["String"]>;
  action?: Maybe<MessagingResultAction>;
  /** The list of content for expanded messages. */
  content: Array<EgdsIconText>;
  featuredImage?: Maybe<Image>;
  index?: Maybe<Scalars["Int"]>;
  /**
   * A label for accessibility purposes.
   * @deprecated Use accessibilityLabel, replace with accessibilityLabel
   */
  label?: Maybe<Scalars["String"]>;
  subtitle?: Maybe<MessagingResultTitle>;
  title?: Maybe<MessagingResultTitle>;
  /** @deprecated This will be removed in the future. */
  type?: Maybe<MessageType>;
};

/** Unique identifier for a message if one needs to identify the reason for the message creation */
export type MessageType =
  | "ADDON"
  | "BRANDED_THEME_ACCENT"
  | "BRANDED_THEME_DARK"
  | "BRANDED_THEME_LIGHT"
  | "COMPRESSION"
  | "COUPON"
  | "DOUBLE_POINTS"
  | "FREE_CANCELLATION"
  | "FREE_LX"
  | "HOTRATE"
  | "LEGAL"
  | "LOGIN"
  | "LOYALTY"
  | "NO_CC"
  | "OVERFILTERED"
  | "PARTNER_LINKOFF"
  | "VACATION_RENTALS";

export type MessagingAction = {
  __typename?: "MessagingAction";
  /** the native action metadata */
  actionDetails?: Maybe<ActionDetails>;
  /** Analytics data for the action */
  analytics?: Maybe<ClientSideAnalytics>;
  /**
   * Action url
   * @deprecated Use the linkUrl field instead, replace with linkUrl
   */
  href: Scalars["String"];
  /** Icon to display */
  icon?: Maybe<Icon>;
  linkUrl: Scalars["String"];
  /** @deprecated Use analytics */
  referrerId?: Maybe<Scalars["String"]>;
  /**
   * Rffr used to send tracking for action
   * @deprecated Use the referrerId field instead, replace with referrerId
   */
  rfrr?: Maybe<Scalars["String"]>;
  /** Action text displayed for the url */
  text?: Maybe<Scalars["String"]>;
};

/** Represents the details about the Rebound */
export type MessagingDetails = {
  __typename?: "MessagingDetails";
  /** Represents the elements of the Details */
  elements?: Maybe<Array<CustomUiComposableElement>>;
  /** Represents the header of the Details */
  heading?: Maybe<Scalars["String"]>;
};

export type MessagingResultAction = {
  __typename?: "MessagingResultAction";
  primary?: Maybe<MessagingAction>;
  secondary?: Maybe<MessagingAction>;
};

export type MessagingResultTitle = {
  __typename?: "MessagingResultTitle";
  /** Label where a11y behavior is needed. */
  accessibilityLabel?: Maybe<Scalars["String"]>;
  /** Mark used to display along with the text and token */
  egdsMark?: Maybe<Mark>;
  /** Icon used to display along with the text */
  icon?: Maybe<Icon>;
  /** Illustration to be displayed on messaging card */
  illustration?: Maybe<LodgingIllustration>;
  /**
   * Mark used to display along with the text
   * @deprecated Use egdsMark
   */
  mark?: Maybe<LodgingMark>;
  /** Text for the messaging result */
  text?: Maybe<Scalars["String"]>;
  /** Messaging theme */
  theme?: Maybe<Theme>;
};

export type MinNightStayInputField = {
  __typename?: "MinNightStayInputField";
  stepInput?: Maybe<EgdsBasicStepInput>;
};

export type MinNightStayResult = {
  __typename?: "MinNightStayResult";
  minNightStayValue: Scalars["Int"];
};

export type MinimumAge = {
  __typename?: "MinimumAge";
  adult?: Maybe<Scalars["String"]>;
  childAge?: Maybe<Scalars["String"]>;
  infant?: Maybe<Scalars["String"]>;
};

/** An arbitrary action with a link target */
export type MishopDetailsUiAction = UiAction & {
  __typename?: "MishopDetailsUIAction";
  accessibility?: Maybe<Scalars["String"]>;
  action: MultiItemShoppingAction;
  analytics: ClientSideAnalytics;
  icon?: Maybe<Icon>;
  label: Scalars["String"];
  resource: Uri;
};

/** Contains the necessary data for calling all of the queries to populate mishop details */
export type MishopDetailsUiPrimer = {
  __typename?: "MishopDetailsUIPrimer";
  bookByPhonePrimer?: Maybe<MishopUiBookByPhonePrimer>;
  changePackageWizardPrimer?: Maybe<MishopUiChangePackageFormPrimer>;
  checkoutButtonPrimer?: Maybe<MishopUiCheckoutButtonPrimer>;
  crossSellPrimer?: Maybe<MishopUiCrossSellPrimer>;
  error?: Maybe<MishopUiPrimerError>;
  heading?: Maybe<MishopUiHeaderText>;
  legalContentPrimer?: Maybe<MishopUiLegalContentPrimer>;
  notificationPrimer?: Maybe<MishopUiNotificationPrimer>;
  pricingDetailsPrimer?: Maybe<MishopUiPricingDetailsPrimer>;
  productContentPrimer?: Maybe<MishopUiProductContentPrimer>;
  state?: Maybe<MishopDetailsUiState>;
  stepIndicatorPrimer?: Maybe<MishopUiStepIndicatorPrimer>;
};

/** Contains the current session id */
export type MishopDetailsUiState = {
  __typename?: "MishopDetailsUIState";
  multiItemSessionId: Scalars["String"];
};

/** Product natural keys required for session recovery */
export interface MishopRecoveryNaturalKeysInput {
  flightNaturalKeys: Array<FlightNaturalKeyInput>;
  propertyNaturalKeys: Array<PropertyNaturalKeyInput>;
}

/** Contains necessary data for searching and displaying Activity results for cross sell */
export type MishopUiActivitiesCrossSellPrimer = {
  __typename?: "MishopUIActivitiesCrossSellPrimer";
  searchContext: PrimaryActivitiesCriteria;
};

/** Contains the total price to send to Affirm */
export type MishopUiAffirmPromo = {
  __typename?: "MishopUIAffirmPromo";
  totalPrice: Scalars["Int"];
};

/** A section comprised of a group name followed by a list of items in that group  */
export type MishopUiAmenityGroup = {
  __typename?: "MishopUIAmenityGroup";
  icon: Icon;
  primary: MishopUiHeaderText;
  secondaries: Array<MishopUiText>;
};

/** A wrapper type for the UIBanner type */
export type MishopUiBanner = {
  __typename?: "MishopUIBanner";
  banner: UiBanner;
};

/** Contains necessary data for loading book-by-phone shared component */
export type MishopUiBookByPhonePrimer = {
  __typename?: "MishopUIBookByPhonePrimer";
  propertyId: Scalars["String"];
};

/** Contains information to display a Button */
export interface MishopUiButton {
  accessibility: Scalars["String"];
  action: MultiItemShoppingAction;
  analytics: ClientSideAnalytics;
}

/** Contains necessary data for fetching car content */
export type MishopUiCarContentPrimer = MishopUiContentPrimer & {
  __typename?: "MishopUICarContentPrimer";
  naturalKey: CarNaturalKey;
};

/** A generic carousel with name, analytics and accessibility */
export type MishopUiCarousel = {
  __typename?: "MishopUICarousel";
  analytics: ClientSideAnalytics;
  carouselActions: MishopUiCarouselActions;
  content: MishopUiCarouselContent;
  name: Scalars["String"];
};

export type MishopUiCarouselAction = {
  __typename?: "MishopUICarouselAction";
  accessibility: Scalars["String"];
  analytics: ClientSideAnalytics;
};

export type MishopUiCarouselActions = {
  __typename?: "MishopUICarouselActions";
  next: MishopUiCarouselAction;
  previous: MishopUiCarouselAction;
};

export type MishopUiCarouselContent = PackageUiPreBundledCards;

/** The internal content for the prebundle change wizard confirmation dialog */
export type MishopUiChangePackageConfirmationDialogContent = {
  __typename?: "MishopUIChangePackageConfirmationDialogContent";
  message: EgdsParagraph;
  primary: EgdsHeading;
};

/** Change Package Search Form Schema */
export type MishopUiChangePackageForm = EgdsSearchForm & {
  __typename?: "MishopUIChangePackageForm";
  actionURL: Scalars["String"];
  /** Default change package search criteria.  The wizard will override changed fields in change package query */
  changePackageCriteria: ChangePackageSearchCriteria;
  elements: Array<EgdsSearchFormElement>;
  errorSummary?: Maybe<EgdsErrorSummary>;
  playback?: Maybe<EgdsSearchPlayback>;
  search?: Maybe<EgdsButton>;
  updatePricesDialog: ChangePackageConfirmationDialog;
};

/** Change Package Search Form Primer */
export type MishopUiChangePackageFormPrimer = {
  __typename?: "MishopUIChangePackageFormPrimer";
  accessibility: Scalars["String"];
  /** @deprecated DO NOT USE: Will be removed permanently soon */
  multiItemSessionId: Scalars["String"];
  searchCriteria: PackageSearchCriteria;
};

/** Change Package Search Form Primer */
export interface MishopUiChangePackageFormPrimerInput {
  multiItemSessionId: Scalars["String"];
}

/** Contains the necessary data for rendering the checkout button and calling the mutation */
export type MishopUiCheckoutButtonPrimer = {
  __typename?: "MishopUICheckoutButtonPrimer";
  accessibility: Scalars["String"];
  checkoutOptions: Array<CheckoutOption>;
  clickAnalytics: ClientSideAnalytics;
  errorAnalytics: ClientSideAnalytics;
  products: MultiItemProducts;
  responseOptions: Array<PrepareCheckoutResponseOption>;
  text: Scalars["String"];
  totalPrice?: Maybe<Money>;
};

/** Collapsible rich content container with a header */
export type MishopUiCollapsableSection = {
  __typename?: "MishopUICollapsableSection";
  content: Array<EgdsElement>;
  title: EgdsText;
};

/** Contains necessary data for fetching product content */
export interface MishopUiContentPrimer {
  naturalKey: ProductNaturalKey;
}

/** Contains a list of cross sell primer models used to render product cross sells on the details page. */
export type MishopUiCrossSellPrimer = {
  __typename?: "MishopUICrossSellPrimer";
  crossSellProductPrimers: Array<MishopUiCrossSellProductPrimer>;
};

/** Contains necessary data for searching and displaying cross sell products */
export type MishopUiCrossSellProductPrimer = MishopUiActivitiesCrossSellPrimer | MishopUiGroundTransfersCrossSellPrimer;

/** Contains the necessary data for rendering the customer notification banner that is relevant to the customer's travel destination */
export type MishopUiCustomerNotification = {
  __typename?: "MishopUICustomerNotification";
  regionId?: Maybe<Scalars["String"]>;
};

/** A UI element that describes a default navigation bar */
export type MishopUiDefaultNavigationBar = EgdsTabs & {
  __typename?: "MishopUIDefaultNavigationBar";
  selectedTabId?: Maybe<Scalars["String"]>;
  tabs: Array<MishopUiNavigationBarTab>;
};

/** Detail gallery view media item */
export type MishopUiDetailGalleryMediaItem = MediaItem & {
  __typename?: "MishopUIDetailGalleryMediaItem";
  media: Media;
};

/** Detail gallery media view */
export type MishopUiDetailMediaGallery = EgdsDetailMediaGallery & {
  __typename?: "MishopUIDetailMediaGallery";
  closeAnalytics: ClientSideAnalytics;
  closeText: Scalars["String"];
  mediaItems: Array<MishopUiDetailGalleryMediaItem>;
  navigationAnalytics: ClientSideAnalytics;
  nextButtonText?: Maybe<Scalars["String"]>;
  previousButtonText?: Maybe<Scalars["String"]>;
};

/** Gallery action that opens a detail media gallery view */
export type MishopUiDetailMediaGalleryAction = {
  __typename?: "MishopUIDetailMediaGalleryAction";
  analytics: ClientSideAnalytics;
  dialogName: Scalars["String"];
  mediaDetailGallery: MishopUiDetailMediaGallery;
};

/** A dialog with generic content */
export interface MishopUiDialog {
  closeAnalytics: ClientSideAnalytics;
  content: MishopUiDialogContent;
  trigger: MishopUiDialogTrigger;
}

/** A trigger that automatically opens a dialog */
export type MishopUiDialogAutoOpenTrigger = MishopUiDialogTrigger & {
  __typename?: "MishopUIDialogAutoOpenTrigger";
  analytics: ClientSideAnalytics;
  dialogName: Scalars["String"];
};

/** The type of button to display */
export type MishopUiDialogButtonType = "PRIMARY" | "TERTIARY";

/** The internal content for the close button of a dialog */
export type MishopUiDialogCloseButton = MishopUiDialogFooterButton & {
  __typename?: "MishopUIDialogCloseButton";
  analytics: ClientSideAnalytics;
  text: Scalars["String"];
  type: MishopUiDialogButtonType;
};

/** The internal content of a dialog */
export type MishopUiDialogContent = {
  __typename?: "MishopUIDialogContent";
  elements: Array<MishopUiDialogContentElement>;
};

/** Any UI element that is needed to build the content of a fullscreen dialog */
export type MishopUiDialogContentElement =
  | MishopUiDialogErrorElement
  | MishopUiParagraphSection
  | MishopUiPricePresentation
  | MishopUiPropertyCleanliness
  | MishopUiRoomDetails
  | MishopUiStrikeThroughPriceDisclaimer;

/** The internal content of an error dialog */
export type MishopUiDialogErrorElement = {
  __typename?: "MishopUIDialogErrorElement";
  primary: MishopUiHeaderText;
  secondaries: Array<MishopUiText>;
};

/** The internal content of a dialog footer */
export type MishopUiDialogFooter = {
  __typename?: "MishopUIDialogFooter";
  buttons: Array<MishopUiDialogFooterButton>;
  stacked?: Maybe<Scalars["Boolean"]>;
};

/** The generic content for a button of a dialog */
export interface MishopUiDialogFooterButton {
  analytics: ClientSideAnalytics;
  text: Scalars["String"];
  type: MishopUiDialogButtonType;
}

/** The internal content for the home button of a dialog */
export type MishopUiDialogHomeButton = MishopUiDialogFooterButton & {
  __typename?: "MishopUIDialogHomeButton";
  action: MultiItemShoppingAction;
  analytics: ClientSideAnalytics;
  resource: Uri;
  text: Scalars["String"];
  type: MishopUiDialogButtonType;
};

/** A link that triggers a dialog to open */
export type MishopUiDialogLinkTrigger = MishopUiDialogTrigger & {
  __typename?: "MishopUIDialogLinkTrigger";
  analytics: ClientSideAnalytics;
  dialogName: Scalars["String"];
  icon?: Maybe<Icon>;
  label: Scalars["String"];
};

/** An link that triggers a strikethrough disclaimer dialog to open */
export type MishopUiDialogPriceLockupTrigger = MishopUiDialogTrigger & {
  __typename?: "MishopUIDialogPriceLockupTrigger";
  analytics: ClientSideAnalytics;
  dialogName: Scalars["String"];
  priceLockup?: Maybe<MishopUiPriceLockup>;
};

/** The internal content for the retry button of a dialog */
export type MishopUiDialogRetryButton = MishopUiDialogFooterButton & {
  __typename?: "MishopUIDialogRetryButton";
  action: MultiItemShoppingAction;
  analytics: ClientSideAnalytics;
  text: Scalars["String"];
  type: MishopUiDialogButtonType;
};

/** A link that triggers a generic dialog to open */
export interface MishopUiDialogTrigger {
  analytics: ClientSideAnalytics;
  dialogName: Scalars["String"];
}

/** Contains information to display an Error Element */
export type MishopUiEmptyStateError = {
  __typename?: "MishopUIEmptyStateError";
  action?: Maybe<MishopUiButton>;
  icon: Icon;
  primary: EgdsHeading;
  secondaries: Array<EgdsPlainText>;
};

/** Contains information to display an Error Element */
export type MishopUiEmptyStateErrorElement = {
  __typename?: "MishopUIEmptyStateErrorElement";
  action: MishopUiButton;
  icon: Icon;
  primary: MishopUiHeaderText;
  secondaries: Array<MishopUiText>;
};

/** A button that, when clicked, links to an external view or page */
export type MishopUiExternalLinkButton = MishopUiButton & {
  __typename?: "MishopUIExternalLinkButton";
  accessibility: Scalars["String"];
  action: MultiItemShoppingAction;
  analytics: ClientSideAnalytics;
  label: Scalars["String"];
  resource?: Maybe<Uri>;
};

/** Contains necessary data for fetching flight content */
export type MishopUiFlightContentPrimer = MishopUiContentPrimer & {
  __typename?: "MishopUIFlightContentPrimer";
  /** @deprecated Remove actionBar after migrating to shared-ui journey-summary */
  actionBar: Array<MishopDetailsUiAction>;
  contentHeader?: Maybe<MishopUiProductHeader>;
  detailsCriteria: MishopUiFlightDetailsCriteria;
  errorMessage: MishopUiText;
  /** @deprecated Will be removed once 41511 is at 100% */
  flightChangeLink: Uri;
  naturalKey: FlightNaturalKey;
  /** @deprecated Nullable replacement for flightChangeLink introduced to not break client. Will be removed once 41511 is at 100% */
  overrideChangeFlightUrl?: Maybe<Uri>;
  upsellOfferToken: Scalars["String"];
};

/** Contains the data needed for fetching flight details */
export type MishopUiFlightDetailsCriteria = {
  __typename?: "MishopUIFlightDetailsCriteria";
  journeyCriteria: Array<MishopUiFlightsJourneyCriteria>;
  shoppingContext: ShoppingContext;
  travelerDetails: Array<MishopUiTravelerDetails>;
  tripType: FlightsTripType;
};

/** Basic information about a single, selected flight leg */
export type MishopUiFlightsJourneyCriteria = {
  __typename?: "MishopUIFlightsJourneyCriteria";
  departureDate: Date;
  destination: Scalars["String"];
  flightsCabinClass: FlightsCabinClass;
  origin: Scalars["String"];
};

/** A fullscreen dialog with generic content */
export type MishopUiFullscreenDialog = MishopUiDialog & {
  __typename?: "MishopUIFullscreenDialog";
  closeAnalytics: ClientSideAnalytics;
  content: MishopUiDialogContent;
  fillViewport: Scalars["Boolean"];
  toolbar: MishopUiToolbar;
  trigger: MishopUiDialogTrigger;
};

/** A gallery carousel with name, analytics and accessibility */
export type MishopUiGalleryCarousel = EgdsGalleryCarousel & {
  __typename?: "MishopUIGalleryCarousel";
  accessibilityHeadingText: Scalars["String"];
  galleryOverlayButton?: Maybe<MishopUiThumbnailMediaGalleryAction>;
  media: Array<MishopUiGalleryMediaItem>;
  mediaAction?: Maybe<MishopUiDetailMediaGalleryAction>;
  navigationAnalytics?: Maybe<ClientSideAnalytics>;
  nextButtonText?: Maybe<Scalars["String"]>;
  previousButtonText?: Maybe<Scalars["String"]>;
};

/** Gallery item with media and detail gallery action */
export type MishopUiGalleryMediaItem = MediaItem & {
  __typename?: "MishopUIGalleryMediaItem";
  media: Media;
  mediaAction?: Maybe<MishopUiDetailMediaGalleryAction>;
};

/** Contains necessary data for searching and displaying Ground Transfer results for cross sell */
export type MishopUiGroundTransfersCrossSellPrimer = {
  __typename?: "MishopUIGroundTransfersCrossSellPrimer";
  searchContext: PrimaryGroundTransfersCriteria;
};

/** A generic header */
export type MishopUiHeaderText = {
  __typename?: "MishopUIHeaderText";
  text: Scalars["String"];
};

/** A UI button that jump link you to a section */
export type MishopUiJumpLinkButton = {
  __typename?: "MishopUIJumpLinkButton";
  accessibility: Scalars["String"];
  jumpTo: Scalars["String"];
  label: Scalars["String"];
};

/** A UI element that describes a jump link navigation bar */
export type MishopUiJumpLinkNavigationBar = EgdsTabs & {
  __typename?: "MishopUIJumpLinkNavigationBar";
  selectedTabId?: Maybe<Scalars["String"]>;
  tabs: Array<MishopUiNavigationBarTab>;
};

/** Contains content pertaining to package specific legal requirements */
export type MishopUiLegalContentPrimer = {
  __typename?: "MishopUILegalContentPrimer";
  shoppedProducts: Array<ShoppedProduct>;
};

/** A UI element that describes a package legal information view */
export type MishopUiLegalInformationView = MishopUiLegalInformationViewSuccess;

/** A UI element that describes a populated package legal information view */
export type MishopUiLegalInformationViewSuccess = {
  __typename?: "MishopUILegalInformationViewSuccess";
  sections: Array<MishopUiCollapsableSection>;
};

/** A hyper-linked header */
export type MishopUiLinkedHeaderText = {
  __typename?: "MishopUILinkedHeaderText";
  action: MishopDetailsUiAction;
};

/** A UI element that describes a navigation bar tab with jump links */
export type MishopUiNavigationBarTab = EgdsTab & {
  __typename?: "MishopUINavigationBarTab";
  accessibility?: Maybe<Scalars["String"]>;
  analytics: ClientSideAnalytics;
  label: Scalars["String"];
  tabId: Scalars["String"];
};

/** A non-fullscreen dialog with generic content */
export type MishopUiNonFullscreenDialog = MishopUiDialog & {
  __typename?: "MishopUINonFullscreenDialog";
  closeAnalytics: ClientSideAnalytics;
  content: MishopUiDialogContent;
  footer: MishopUiDialogFooter;
  trigger: MishopUiDialogTrigger;
};

/** A notification message or banner */
export type MishopUiNotification = MishopUiCustomerNotification | MishopUiPlacardNotification;

/** Contains the necessary data for rendering all the notification messages (e.g. customer notification, price change banner, etc) */
export type MishopUiNotificationPrimer = {
  __typename?: "MishopUINotificationPrimer";
  notifications: Array<MishopUiNotification>;
};

/** Dialog to show on top of page when an error occurs */
export type MishopUiOperationFailureDialog = {
  __typename?: "MishopUIOperationFailureDialog";
  content: EgdsParagraph;
  dialog: EgdsActionDialog;
};

/** A UI element that describes package content state */
export type MishopUiPackageSummaryContent = MishopUiPackageSummaryContentSuccess;

/** Contains the necessary data for calling packageSummaryContent query */
export type MishopUiPackageSummaryContentPrimer = MishopUiContentPrimer & {
  __typename?: "MishopUIPackageSummaryContentPrimer";
  naturalKey: PackageNaturalKey;
};

/** Contains the necessary data for calling packageSummaryContent query */
export interface MishopUiPackageSummaryContentPrimerInput {
  naturalKey: PackageNaturalKeyInput;
}

/** A UI element that describes a successful package content */
export type MishopUiPackageSummaryContentSuccess = {
  __typename?: "MishopUIPackageSummaryContentSuccess";
  customizeButton: MishopUiJumpLinkButton;
  descriptions: Array<EgdsText>;
  gallery: MishopUiGalleryCarousel;
  heading: MishopUiSectionHeading;
  navigationBar: MishopUiJumpLinkNavigationBar;
};

export type MishopUiParagraph = {
  __typename?: "MishopUIParagraph";
  text: Scalars["String"];
};

/** Contains information to display modal content */
export type MishopUiParagraphSection = {
  __typename?: "MishopUIParagraphSection";
  content: Array<MishopUiParagraph>;
  header: MishopUiHeaderText;
};

/** A placard to display notifications to the customer via a banner or messaging card */
export type MishopUiPlacard = MishopUiBanner;

/** Contains the necessary data for rendering to the customer a placard describing announcements relevant to their trip */
export type MishopUiPlacardNotification = {
  __typename?: "MishopUIPlacardNotification";
  multiItemPriceToken?: Maybe<Scalars["String"]>;
  placardType: MishopUiPlacardType;
  priceDetailsOptions?: Maybe<PriceDetailsOptions>;
  shoppedProducts: Array<ShoppedProduct>;
};

/** Contains the necessary data for rendering to the customer a placard describing announcements relevant to their trip */
export interface MishopUiPlacardNotificationInput {
  multiItemPriceToken?: InputMaybe<Scalars["String"]>;
  placardType: MishopUiPlacardType;
  priceDetailsOptions?: InputMaybe<PriceDetailsOptionsInput>;
  shoppedProducts: Array<ShoppedProductInput>;
}

export type MishopUiPlacardType = "PRICE_CHANGE";

/** Any UI element that is needed to build the UI for price content */
export type MishopUiPriceDetailView = MishopUiPriceDetailViewFailure | MishopUiPriceDetailViewSuccess;

/** Contains the necessary data for rendering price info error */
export type MishopUiPriceDetailViewFailure = {
  __typename?: "MishopUIPriceDetailViewFailure";
  content: MishopUiEmptyStateErrorElement;
};

/** Contains the necessary data for rendering price info */
export type MishopUiPriceDetailViewSuccess = {
  __typename?: "MishopUIPriceDetailViewSuccess";
  affirmPromo?: Maybe<MishopUiAffirmPromo>;
  checkoutButtonPrimer: MishopUiCheckoutButtonPrimer;
  detail: MishopUiPricePresentation;
  pricePresentationAndSummary: MishopUiPricePresentationAndSummary;
  /** @deprecated Will be removed once all clients have stopped requesting for this field */
  tabTitles: Array<Scalars["String"]>;
};

/** Contains the necessary data for rendering price lockup info */
export type MishopUiPriceLockup = {
  __typename?: "MishopUIPriceLockup";
  accessiblePrice: Scalars["String"];
  accessibleStrikeThroughDialogTrigger: Scalars["String"];
  strikeThroughPrice: Scalars["String"];
};

/** Wrapper type around the price presentation node */
export type MishopUiPricePresentation = {
  __typename?: "MishopUIPricePresentation";
  pricePresentation: PricePresentation;
};

/** Contains the necessary data for rendering the full screen dialog for the price summary */
export type MishopUiPricePresentationAndSummary = {
  __typename?: "MishopUIPricePresentationAndSummary";
  pricePresentationDialog: MishopUiFullscreenDialog;
  priceSummary: MishopUiPriceSummary;
};

/** Contains the necessary data for rendering the price summary info */
export type MishopUiPriceSummary = {
  __typename?: "MishopUIPriceSummary";
  accessibility?: Maybe<Scalars["String"]>;
  displayPrice: MishopUiText;
  strikeThroughPriceDialog?: Maybe<MishopUiNonFullscreenDialog>;
  title: MishopUiText;
};

/** Contains the necessary data for rendering price info */
export type MishopUiPriceView = {
  __typename?: "MishopUIPriceView";
  checkoutButtonPrimer: MishopUiCheckoutButtonPrimer;
  detail: MishopUiPricePresentation;
  pricePresentationAndSummary: MishopUiPricePresentationAndSummary;
};

/** Contains the necessary data for calling the pricingDetails query */
export type MishopUiPricingDetailsPrimer = {
  __typename?: "MishopUIPricingDetailsPrimer";
  errorMessage?: Maybe<MishopUiText>;
  multiItemPriceToken?: Maybe<Scalars["String"]>;
  priceDetailsOptions: PriceDetailsOptions;
  shoppedProducts: Array<ShoppedProduct>;
};

/** Contains the necessary data to render the error empty state when primers call fails */
export type MishopUiPrimerError = {
  __typename?: "MishopUIPrimerError";
  content: Array<MishopUiPrimerErrorContentElement>;
  icon: Icon;
};

/** Any UI element that is needed to build the content for the error primer */
export type MishopUiPrimerErrorContentElement =
  | MishopDetailsUiAction
  | MishopUiEmptyStateErrorElement
  | MishopUiHeaderText;

/** Product details for a single LOB */
export type MishopUiProduct = {
  __typename?: "MishopUIProduct";
  content: Array<MishopUiProductContentElement>;
  header: MishopUiProductHeader;
};

/** Contains all the LOB product details */
export interface MishopUiProductCard {
  actionBar?: Maybe<Array<MishopDetailsUiAction>>;
}

/** Any UI element that is needed to build the UI for product content */
export type MishopUiProductContentElement = MishopUiPropertyProductCard | MishopUiPropertyProductCardFailure;

/** Contains all of the primers necessary for rendering all product content */
export type MishopUiProductContentPrimer = {
  __typename?: "MishopUIProductContentPrimer";
  contentPrimers: Array<MishopUiContentPrimer>;
};

/** Product details header that introduces the actual product details content */
export type MishopUiProductHeader = {
  __typename?: "MishopUIProductHeader";
  icon?: Maybe<Icon>;
  primary: MishopUiHeaderText;
  referenceId: Scalars["String"];
  secondaries: Array<MishopUiText>;
};

export type MishopUiProductType = "ACTIVITY" | "CAR" | "FLIGHT" | "GROUND_TRANSFER" | "PROPERTY";

/** Any UI element that is needed to build the UI for the property content */
export type MishopUiPropertyCardContentElement =
  | MishopDetailsUiAction
  | MishopUiFullscreenDialog
  | MishopUiHeaderText
  | MishopUiLinkedHeaderText
  | MishopUiNonFullscreenDialog
  | MishopUiPropertyRating
  | MishopUiText;

/** A list of content to display on the property details card */
export type MishopUiPropertyCardContentSection = {
  __typename?: "MishopUIPropertyCardContentSection";
  content: Array<MishopUiPropertyCardContentElement>;
};

/** The internal content of a dialog */
export type MishopUiPropertyCleanliness = {
  __typename?: "MishopUIPropertyCleanliness";
  cleanlinessInformationSections: Array<MishopUiPropertyCleanlinessElement>;
  primary: MishopUiHeaderText;
};

/** Any UI element that is needed to build the UI for the property cleanliness view */
export type MishopUiPropertyCleanlinessElement = MishopUiAmenityGroup | MishopUiText;

/** Contains necessary data for fetching property content */
export type MishopUiPropertyContentPrimer = MishopUiContentPrimer & {
  __typename?: "MishopUIPropertyContentPrimer";
  changePropertyAction: PropertySearchMultiItemShoppingAction;
  changeRoomAction: PropertyDetailsMultiItemShoppingAction;
  naturalKey: PropertyNaturalKey;
  /** @deprecated Use relativeChangePropertyLink or relativeChangeRoomLink */
  propertyChangeLink?: Maybe<Scalars["String"]>;
  relativeChangePropertyLink: Scalars["String"];
  relativeChangeRoomLink: Scalars["String"];
};

/** Contains necessary data for fetching property content */
export interface MishopUiPropertyContentPrimerInput {
  changePropertyAction: PropertySearchMultiItemShoppingActionInput;
  changeRoomAction: PropertyDetailsMultiItemShoppingActionInput;
  naturalKey: PropertyNaturalKeyInput;
  propertyChangeLink?: InputMaybe<Scalars["String"]>;
  relativeChangePropertyLink: Scalars["String"];
  relativeChangeRoomLink: Scalars["String"];
}

/** Contains all of the hotel product details */
export type MishopUiPropertyProductCard = MishopUiProductCard & {
  __typename?: "MishopUIPropertyProductCard";
  actionBar?: Maybe<Array<MishopDetailsUiAction>>;
  contentSections: Array<MishopUiPropertyCardContentSection>;
  image?: Maybe<Image>;
};

/** Contains actionable error when hotel product details is missing */
export type MishopUiPropertyProductCardActionableError = {
  __typename?: "MishopUIPropertyProductCardActionableError";
  content: MishopUiEmptyStateErrorElement;
};

/** Contains fallback content when hotel product details is missing */
export type MishopUiPropertyProductCardFailure = MishopUiProductCard & {
  __typename?: "MishopUIPropertyProductCardFailure";
  actionBar?: Maybe<Array<MishopDetailsUiAction>>;
  actionableError: MishopUiPropertyProductCardActionableError;
  failureMsg: MishopUiText;
};

/** Information relating to the hotel's customer rating and reviews */
export type MishopUiPropertyRating = {
  __typename?: "MishopUIPropertyRating";
  numericRating: MishopUiText;
  reviewsText: MishopUiText;
};

/** The room information as internal content of a dialog */
export type MishopUiRoomDetails = {
  __typename?: "MishopUIRoomDetails";
  naturalKey: PropertyNaturalKey;
};

/** A UI element that describe the heading of package content section */
export type MishopUiSectionHeading = EgdsSectionHeading & {
  __typename?: "MishopUISectionHeading";
  heading: EgdsHeading;
  subheading?: Maybe<Scalars["String"]>;
};

/** Contains necessary data for fetching simple property content without change links */
export type MishopUiSimplePropertyContentPrimer = MishopUiContentPrimer & {
  __typename?: "MishopUISimplePropertyContentPrimer";
  naturalKey: PropertyNaturalKey;
};

/** Contains data to render the step indicator */
export type MishopUiStepIndicatorPrimer = {
  __typename?: "MishopUIStepIndicatorPrimer";
  multiItemSessionId: Scalars["String"];
};

/** Wrapper type around strikeThrough disclaimer dialog content */
export type MishopUiStrikeThroughPriceDisclaimer = {
  __typename?: "MishopUIStrikeThroughPriceDisclaimer";
  text: MishopUiText;
};

/** Simple text that can be enhanced with color, boldness, etc */
export type MishopUiText = {
  __typename?: "MishopUIText";
  accessibility?: Maybe<Scalars["String"]>;
  text: Scalars["String"];
  theme?: Maybe<TextTheme>;
  weight?: Maybe<TextWeight>;
};

/** A UI container that holds a list of EGDSText elements */
export type MishopUiTextContainer = {
  __typename?: "MishopUITextContainer";
  elements: Array<EgdsText>;
};

/** Version of EGDSTextListItem that contains a MishopUITextContainer */
export type MishopUiTextContainerListItem = EgdsTextListItem & {
  __typename?: "MishopUITextContainerListItem";
  element: MishopUiTextContainer;
  nestedList?: Maybe<EgdsTextList>;
  style?: Maybe<EgdsTextListItemStyle>;
  subText?: Maybe<Scalars["String"]>;
  text: Scalars["String"];
};

/** Thumbnail media gallery view */
export type MishopUiThumbnailMediaGallery = EgdsThumbnailMediaGallery & {
  __typename?: "MishopUIThumbnailMediaGallery";
  analytics: ClientSideAnalytics;
  mediaAction?: Maybe<MishopUiDetailMediaGalleryAction>;
  tabs?: Maybe<MishopUiDefaultNavigationBar>;
  thumbnails: Array<MishopUiGalleryMediaItem>;
  toolbar: EgdsDialogToolbar;
};

/** Thumbnail gallery action that opens a detail media gallery view */
export type MishopUiThumbnailMediaGalleryAction = {
  __typename?: "MishopUIThumbnailMediaGalleryAction";
  analytics: ClientSideAnalytics;
  dialogName: Scalars["String"];
  mediaThumbnailGallery: MishopUiThumbnailMediaGallery;
};

/** A toolbar for dialogs or other similar UI components */
export type MishopUiToolbar = {
  __typename?: "MishopUIToolbar";
  iconLabel: Scalars["String"];
  title: Scalars["String"];
};

/** Basic info about each traveler category */
export type MishopUiTravelerDetails = {
  __typename?: "MishopUITravelerDetails";
  ages?: Maybe<Array<Scalars["Int"]>>;
  count: Scalars["Int"];
  travelerType: TravelerDetailsType;
};

/** Support for Mobile App URI (expda, obtz and so on) */
export type MobileAppUri = Uri & {
  __typename?: "MobileAppURI";
  value: Scalars["String"];
};

/** This represents a opened dialog */
export interface MobilityDialogs {
  /** This represents dialog accessibility. Example: 'Price Summary' */
  accessibilityMessage?: Maybe<Scalars["String"]>;
  /** This represents the dialog that is triggered. Example: 'View price summary > Price Summary' */
  dialog: EgdsDialog;
  /** This represents the 'X' icon to dismiss the dialog */
  dismiss: Icon;
}

/** This represents the product review layout */
export type MobilityProductReview = {
  __typename?: "MobilityProductReview";
  /** This represents the MAIN section of of mobility product review page */
  main: MainReviewSection;
  /** This represents the SECONDARY section of mobility product review page, this is only rendered in desktop */
  secondary: SecondaryReviewSection;
};

/** This represents the listings layout */
export type MobilityProductSearchResults = {
  __typename?: "MobilityProductSearchResults";
  /** This represents the MAIN section of transportation search page */
  main: MainSearchSection;
  /** This represents the SECONDARY section of transportation search page */
  secondary: SecondarySearchSection;
};

export type MobilitySearchDialogsId =
  /** This represents a dialog to display price summary details */
  "PRICE_SUMMARY_DETAILS";

/** This represents the search form displayed in the header, implements EGDSSearchForm */
export type MobilitySearchForm = EgdsSearchForm & {
  __typename?: "MobilitySearchForm";
  /** This represents the action to be taken on submission */
  actionURL: Scalars["String"];
  /** This represents the list of form elements to render */
  elements: Array<EgdsSearchFormElement>;
  /** This represents the error summary to be displayed */
  errorSummary?: Maybe<EgdsErrorSummary>;
  /** This represents the playback containing the search dialog on mobile */
  playback?: Maybe<EgdsSearchPlayback>;
  /** Optional component that powers the search button on the form */
  search?: Maybe<EgdsButton>;
};

/** This represents the price summary per traveler */
export type MobilitySearchPriceSummaryDialog = MobilityDialogs & {
  __typename?: "MobilitySearchPriceSummaryDialog";
  /** This represents dialog accessibility. Example: 'Price Summary' */
  accessibilityMessage?: Maybe<Scalars["String"]>;
  /** This represents the dialog that is triggered. Example: 'View price summary > Price Summary' */
  dialog: EgdsDialog;
  /** This represents dialog accessibility. Example: 'Price Summary' */
  dialogId: MobilitySearchDialogsId;
  /** This represents the 'X' icon to dismiss the dialog */
  dismiss: Icon;
};

/** Pricing information */
export type Money = {
  __typename?: "Money";
  /** DEPRECATED: Use platform formatters and return localized strings instead. Numeric portion of the price */
  amount: Scalars["Float"];
  /**
   * Currency information about the price. Not safe, will throw an error on invalid string
   * @deprecated Currency should be calculated from the context which may not be present so we need to make it nullable going forward, replace with currencyInfo
   */
  currency: Currency;
  /**
   * Currency information calculated from the context
   * @deprecated Use platform formatters and return localized strings instead
   */
  currencyInfo?: Maybe<Currency>;
  /**
   * Get a formatted string based on the context. Pass false to display the number with decimals
   * @deprecated Use platform formatters and return localized strings instead
   */
  formatted: Scalars["String"];
  /**
   * The raw numeric price
   * @deprecated Needed for backwards compatibility, replace with amount
   */
  raw: Scalars["Float"];
};

/** Pricing information */
export type MoneyFormattedArgs = {
  formatWholeValue?: InputMaybe<Scalars["Boolean"]>;
};

/** Pricing information */
export interface MoneyInput {
  /** DEPRECATED: Use platform formatters and return localized strings instead. Numeric portion of the price */
  amount: Scalars["Float"];
  /** DEPRECATED: The currency should be specified from the context instead. The ISO 4217 3-letter code for this currency eg: USD EUR GBP ... */
  currency?: InputMaybe<Scalars["String"]>;
}

/** Represents a single month for operations that bucket by month */
export type Month = {
  __typename?: "Month";
  /** The ID enum used to identify a month bucket */
  id: MonthId;
  /** The localized name of the month */
  name: Scalars["String"];
  /** The ordinal value for the month, e.g. 1 for January */
  ordinal: Scalars["Int"];
};

/** ID used to identify a month for queries that bucket data by month */
export type MonthId =
  | "APRIL"
  | "AUGUST"
  | "DECEMBER"
  | "FEBRUARY"
  | "JANUARY"
  | "JULY"
  | "JUNE"
  | "MARCH"
  | "MAY"
  | "NOVEMBER"
  | "OCTOBER"
  | "SEPTEMBER";

export type MonthsForecastTab = {
  __typename?: "MonthsForecastTab";
  accessibility?: Maybe<Scalars["String"]>;
  click: ClientSideAnalytics;
  label: Scalars["String"];
  monthName: Scalars["String"];
  temperature: DestinationTemperature;
};

export type MonthsForecastsTabs = {
  __typename?: "MonthsForecastsTabs";
  monthsTabs: Array<MonthsForecastTab>;
  overallMaxTemperature: Scalars["Int"];
  overallMinTemperature: Scalars["Int"];
};

/** Represents help articles dialog content for product or category */
export type MoreHelpArticles = {
  __typename?: "MoreHelpArticles";
  /**
   * Old Title of articles page, not to be used now
   * @deprecated old title for dialog , replace with dialogTitleOption
   */
  helpArticleTitle: Scalars["String"];
  /** List of help articles to be shown in the dialog */
  helpArticlesInDialog: Array<HelpArticleDialog>;
};

/** Union of MoreHelpArticles and HelpArticleErrorView of more articles */
export type MoreHelpArticlesView = HelpArticleErrorView | MoreHelpArticles;

/** An input validation that tests if an input has multiple valid emails delimited by a "," */
export type MultiEmailValidation = EgdsInputValidation & {
  __typename?: "MultiEmailValidation";
  errorMessage: Scalars["String"];
};

/** Union for multi-item actions */
export type MultiItemAction = MultiItemSelectPackageAction | MultiItemSelectProductsAction;

/** Response containing whether the merge and publish was successful */
export type MultiItemAnalyticsMutationResponse = {
  __typename?: "MultiItemAnalyticsMutationResponse";
  success: Scalars["Boolean"];
};

/** The multi-item context used for package searches, contains information needed for package searches and retrieving package sessions */
export type MultiItemContext = {
  __typename?: "MultiItemContext";
  /** The multi-item session id used to retrieve the customers package search criteria and selected products */
  id: Scalars["String"];
  /** The package type for this search */
  packageType: PackageType;
};

/** The multi-item context used for package searches, contains information needed for package searches and retrieving package sessions */
export interface MultiItemContextInput {
  /** The multi-item session id used to retrieve the customers package search criteria and selected products */
  id: Scalars["String"];
  /** The package type for this search */
  packageType: PackageType;
}

export type MultiItemCrossSellUiBadge = {
  __typename?: "MultiItemCrossSellUIBadge";
  text: Scalars["String"];
};

/** An arbitrary button action with a link target */
export type MultiItemCrossSellUiButtonAction = UiAction & {
  __typename?: "MultiItemCrossSellUIButtonAction";
  accessibility: Scalars["String"];
  analytics: ClientSideAnalytics;
  label: Scalars["String"];
  resource: Uri;
};

/** An arbitrary checkout button action */
export type MultiItemCrossSellUiCheckoutButtonAction = UiAction & {
  __typename?: "MultiItemCrossSellUICheckoutButtonAction";
  accessibility: Scalars["String"];
  analytics: ClientSideAnalytics;
  label: Scalars["String"];
  responseOptions: Array<PrepareCheckoutResponseOption>;
  shoppedProducts: MultiItemProducts;
  totalPrice?: Maybe<Money>;
};

/** Any UI element (text, link, button, etc) that is needed to build the cross sell UI */
export type MultiItemCrossSellUiElement =
  | MultiItemCrossSellUiBadge
  | MultiItemCrossSellUiButtonAction
  | MultiItemCrossSellUiCheckoutButtonAction
  | MultiItemCrossSellUiHeaderText
  | MultiItemCrossSellUiImage
  | MultiItemCrossSellUiLinkAction
  | MultiItemCrossSellUiPriceDetails
  | MultiItemCrossSellUiText;

/** A generic header */
export type MultiItemCrossSellUiHeaderText = {
  __typename?: "MultiItemCrossSellUIHeaderText";
  accessibility?: Maybe<Scalars["String"]>;
  level: Scalars["Int"];
  size: Scalars["Int"];
  text: Scalars["String"];
};

export type MultiItemCrossSellUiImage = {
  __typename?: "MultiItemCrossSellUIImage";
  image: Image;
};

/** An arbitrary link action with a link target */
export type MultiItemCrossSellUiLinkAction = UiAction & {
  __typename?: "MultiItemCrossSellUILinkAction";
  accessibility: Scalars["String"];
  analytics: ClientSideAnalytics;
  icon?: Maybe<Icon>;
  label: Scalars["String"];
  resource: Uri;
};

/** All fields required to render the price details for a dynamic xsell listing */
export type MultiItemCrossSellUiPriceDetails = {
  __typename?: "MultiItemCrossSellUIPriceDetails";
  /** The accessible string for screen readers to read the price */
  accessiblePrice: Scalars["String"];
  /** The formatted price of the cross sell option */
  price: Scalars["String"];
  /** The text to display underneath the formatted price */
  priceSubtext: Scalars["String"];
  /** Add subtext that will be stacked underneath the price */
  priceSubtextStandard?: Maybe<Scalars["String"]>;
  /** The strikethrough price */
  strikethroughPrice?: Maybe<Scalars["String"]>;
};

/** A list of content to display on the Car CrossSell card */
export type MultiItemCrossSellUiProductCard = {
  __typename?: "MultiItemCrossSellUIProductCard";
  content: Array<MultiItemCrossSellUiElement>;
};

/** Product details header that introduces the actual product details content */
export type MultiItemCrossSellUiProductHeader = {
  __typename?: "MultiItemCrossSellUIProductHeader";
  /** The secondary elements for this CrossSellOption, can include text, legal disclaimers and links */
  messageItems: Array<CrossSellSecondary>;
  primary: MultiItemCrossSellUiHeaderText;
  /** @deprecated use messageItems instead */
  secondaries: Array<MultiItemCrossSellUiText>;
};

/** Contains all of the product to CrossSell */
export type MultiItemCrossSellUiResponse = {
  __typename?: "MultiItemCrossSellUIResponse";
  actionBar: Array<MultiItemCrossSellUiLinkAction>;
  header: MultiItemCrossSellUiProductHeader;
  impressionAnalytics: ClientSideAnalytics;
  productCards: Array<MultiItemCrossSellUiProductCard>;
};

/** Simple text that can be enhanced with color, boldness, etc */
export type MultiItemCrossSellUiText = {
  __typename?: "MultiItemCrossSellUIText";
  accessibility?: Maybe<Scalars["String"]>;
  text: Scalars["String"];
  theme?: Maybe<TextTheme>;
};

export interface MultiItemDetailsPrimersQuery {
  /** Get primers for details page */
  primers: MishopDetailsUiPrimer;
}

export type MultiItemDetailsQuery = {
  __typename?: "MultiItemDetailsQuery";
  /** Get changePackage form components */
  changePackageForm: MishopUiChangePackageForm;
  /** Get Legal information regarding a Package */
  legalInformation: MishopUiLegalInformationView;
  /** Get model for package summary content section */
  packageSummaryContent: MishopUiPackageSummaryContent;
  /** Get placard for customer notifications */
  placard?: Maybe<MishopUiPlacard>;
  /** Get product policies for a package */
  policies: PackageUiPolicies;
  /** Get price presentation for the first of the given shopped products */
  priceDetails: MishopUiPriceDetailView;
  /**
   * Get price presentation for the first of the given shopped products
   * @deprecated Use the `priceDetails` query instead
   */
  pricingDetails: MishopUiPriceView;
  /** Get banner for changed product notification */
  productChangedBanner: Array<MishopUiBanner>;
  /** Get product content heading */
  productHeader?: Maybe<MishopUiProductHeader>;
  /** Get model for property details card */
  propertyContent: MishopUiProduct;
  /** Get see all packages link that takes the user to the prebundle search page */
  seeAllPackagesLink: PackageUiSeeAllPackagesLink;
};

export type MultiItemDetailsQueryChangePackageFormArgs = {
  primer: MishopUiChangePackageFormPrimerInput;
};

export type MultiItemDetailsQueryLegalInformationArgs = {
  shoppedProducts: Array<ShoppedProductInput>;
};

export type MultiItemDetailsQueryPackageSummaryContentArgs = {
  packageSummaryContentPrimer: MishopUiPackageSummaryContentPrimerInput;
};

export type MultiItemDetailsQueryPlacardArgs = {
  placardNotificationPrimer: MishopUiPlacardNotificationInput;
};

export type MultiItemDetailsQueryPoliciesArgs = {
  products: MultiItemProductsInput;
};

export type MultiItemDetailsQueryPriceDetailsArgs = {
  multiItemPriceToken?: InputMaybe<Scalars["String"]>;
  priceDetailsOptions?: InputMaybe<PriceDetailsOptionsInput>;
  shoppedProducts: Array<ShoppedProductInput>;
};

export type MultiItemDetailsQueryPricingDetailsArgs = {
  shoppedProducts: Array<ShoppedProductInput>;
};

export type MultiItemDetailsQueryProductChangedBannerArgs = {
  productChangedBannerPrimers: Array<PackageUiProductChangedBannerPrimerInput>;
};

export type MultiItemDetailsQueryProductHeaderArgs = {
  productHeaderPrimer: PackageUiProductHeaderPrimerInput;
};

export type MultiItemDetailsQueryPropertyContentArgs = {
  propertyContentPrimer: MishopUiPropertyContentPrimerInput;
};

export type MultiItemDetailsQuerySeeAllPackagesLinkArgs = {
  searchCriteria: PackageSearchCriteriaInput;
};

/** Represents the multi item dynamic cross sell primer */
export type MultiItemDynamicCrossSellPrimer = {
  __typename?: "MultiItemDynamicCrossSellPrimer";
  /** Represents multi item search context with flight search criteria */
  multiItemSearchContext: MultiItemSearchContext;
  /** Represents the flightOfferToken of the selected flight */
  multiItemSelectedFlightProducts: MultiItemSelectedFlightProducts;
};

/** Represents the multi item cross sell offer primer */
export type MultiItemFlightCrossSellOfferPrimer = {
  __typename?: "MultiItemFlightCrossSellOfferPrimer";
  /** Represents the fallback component for Branded Deal when there's no deal available */
  brandedDealFallBack?: Maybe<BrandedDealCrossSellFallback>;
  /** Represents the list of flightOfferToken of the packageable products */
  multiItemPackageableProduct?: Maybe<MultiItemPackageableProduct>;
  /** Represents multi item search context with flight search criteria */
  multiItemSearchContext: MultiItemSearchContext;
  /** Represents the branded deal price of the product */
  price?: Maybe<BrandedDealPrice>;
};

/** Represents the multi item cross sell primer */
export type MultiItemFlightCrossSellPrimer = {
  __typename?: "MultiItemFlightCrossSellPrimer";
  /** Represents the product that will be cross sold */
  flightCrossSellProductType?: Maybe<FlightCrossSellProductType>;
  /** Represents multi item search context with flight search criteria */
  multiItemSearchContext: MultiItemSearchContext;
};

/** Represents the packageable product for Branded deals */
export type MultiItemPackageableProduct = {
  __typename?: "MultiItemPackageableProduct";
  /** Represents the selected Flights Natural Key */
  flights: Array<MultiItemSelectedFlightNaturalKey>;
};

/** Represents the pickup/dropOff information message displayed on multi-item path */
export type MultiItemPickUpDropOffMessage = {
  __typename?: "MultiItemPickUpDropOffMessage";
  message: CarPhrase;
};

export type MultiItemPlayBackSecondaryMessage = {
  __typename?: "MultiItemPlayBackSecondaryMessage";
  /** Represents the accessibility text for screen readers */
  accessibilityMessage: CarPhrase;
  /** Represents the long format multi-item journey dates - (Thu, Feb 13 - Sat, Feb 15 · 3 travelers) */
  longMessage: CarPhrase;
  /** Represents the short format multi-item journey dates - (Feb 13 - Feb 15 · 3 travelers) */
  shortMessage: CarPhrase;
};

/** Represents the playback title bar module on on the multi-item path */
export type MultiItemPlayBackTitleBar = {
  __typename?: "MultiItemPlayBackTitleBar";
  /** Represents the main (origin/destination) message */
  primary: CarPhrase;
  /** Represents the secondary text that has the journey dates and number of travelers */
  secondary: MultiItemPlayBackSecondaryMessage;
};

/** All natural keys for the products that the customer has already selected on the shopping path */
export type MultiItemProducts = {
  __typename?: "MultiItemProducts";
  activities?: Maybe<Array<ActivityNaturalKey>>;
  cars?: Maybe<Array<CarNaturalKey>>;
  flights?: Maybe<Array<FlightNaturalKey>>;
  groundTransfers?: Maybe<Array<GroundTransfersNaturalKey>>;
  packages?: Maybe<Array<PackageNaturalKey>>;
  properties?: Maybe<Array<PropertyNaturalKey>>;
};

/** All natural keys for the products that the customer has already selected on the shopping path */
export interface MultiItemProductsInput {
  activities?: InputMaybe<Array<ActivityNaturalKeyInput>>;
  cars?: InputMaybe<Array<CarNaturalKeyInput>>;
  flights?: InputMaybe<Array<FlightNaturalKeyInput>>;
  groundTransfers?: InputMaybe<Array<GroundTransfersNaturalKeyInput>>;
  packages?: InputMaybe<Array<PackageNaturalKeyInput>>;
  properties?: InputMaybe<Array<PropertyNaturalKeyInput>>;
}

/** All criteria needed for a multi-item search */
export type MultiItemSearchContext = {
  __typename?: "MultiItemSearchContext";
  cars?: Maybe<Array<CarSearchCriteria>>;
  flights?: Maybe<Array<FlightSearchCriteria>>;
  properties?: Maybe<Array<PropertySearchCriteria>>;
};

/** A user friendly actionable error */
export type MultiItemSearchContextActionableError = {
  __typename?: "MultiItemSearchContextActionableError";
  content: MultiItemSearchContextErrorContentElement;
};

/** Response containing the updated shopping context with a session id */
export type MultiItemSearchContextCreatedResponse = {
  __typename?: "MultiItemSearchContextCreatedResponse";
  action: MultiItemShoppingAction;
  redirectUrl?: Maybe<Scalars["URL"]>;
  /** @deprecated Use action.shoppingContext */
  shoppingContext: ShoppingContext;
  target?: Maybe<UiLinkTarget>;
};

/** Interface for session error element */
export type MultiItemSearchContextErrorContentElement = MishopUiEmptyStateErrorElement;

/** Result returned in the event an error has occurred */
export type MultiItemSearchContextErrorResponse = {
  __typename?: "MultiItemSearchContextErrorResponse";
  /** @deprecated Use errorContent instead */
  actionableError: MultiItemSearchContextActionableError;
  /** @deprecated Use errorContent instead */
  content?: Maybe<MishopUiEmptyStateError>;
  /** @deprecated WIP - This error is meant to replace the existing error content on the page */
  errorContent?: Maybe<PackageUiEmptyStateError>;
  failureDialog?: Maybe<MishopUiOperationFailureDialog>;
  message?: Maybe<Scalars["String"]>;
};

/** All criteria needed for a multi-item search */
export interface MultiItemSearchContextInput {
  cars?: InputMaybe<Array<CarSearchCriteriaInput>>;
  flights?: InputMaybe<Array<FlightSearchCriteriaInput>>;
  properties?: InputMaybe<Array<PropertySearchCriteriaInput>>;
}

/** Interface for session responses */
export type MultiItemSearchContextResult = MultiItemSearchContextCreatedResponse | MultiItemSearchContextErrorResponse;

/** Represents the action for multi-item select package mutation */
export type MultiItemSelectPackage = FlightsClientAction & {
  __typename?: "MultiItemSelectPackage";
  accessibility?: Maybe<Scalars["String"]>;
  /** Used to capture client side analytics */
  analyticsList: Array<ClientSideAnalytics>;
  /** Represents the package offer containing the flight offer */
  packageOfferId: Scalars["String"];
};

/** Represents the action for multi-item select package mutation */
export type MultiItemSelectPackageAction = {
  __typename?: "MultiItemSelectPackageAction";
  /** Represents the package offer containing the flight offer */
  packageOfferId: Scalars["String"];
};

/** Represents the action for multi-item select products mutation. */
export type MultiItemSelectProducts = FlightsClientAction & {
  __typename?: "MultiItemSelectProducts";
  accessibility?: Maybe<Scalars["String"]>;
  /** Used to capture client side analytics. */
  analyticsList: Array<ClientSideAnalytics>;
  /** Flights and packaged products natural keys. The natural key is the minimum set of data to retrieve details about a product. */
  flightsOfferNaturalKeys: FlightsOfferNaturalKeys;
  /** Represents the full package price. */
  multiItemPriceToken?: Maybe<Scalars["String"]>;
  /** Identifier for the multi item session. */
  multiItemSessionId: Scalars["String"];
};

/** Represents the action for multi-item select products mutation */
export type MultiItemSelectProductsAction = {
  __typename?: "MultiItemSelectProductsAction";
  flightsOfferNaturalKeys: FlightsOfferNaturalKeys;
  multiItemPriceToken?: Maybe<Scalars["String"]>;
  multiItemSessionId: Scalars["String"];
};

/** Represents the Selected Flights Natural Key */
export type MultiItemSelectedFlightNaturalKey = {
  __typename?: "MultiItemSelectedFlightNaturalKey";
  /** Represents the Selected Flight Offer Token */
  offerToken: Scalars["String"];
  /** Represents the Selected Flight Product Tokens */
  productTokens: Array<Scalars["String"]>;
  /** Represents Traveler details - age and traveler type */
  travelers: Array<TravelerDetails>;
};

export type MultiItemSelectedFlightProducts = {
  __typename?: "MultiItemSelectedFlightProducts";
  /** Represents the list of selected Flights Natural Key */
  flights: Array<MultiItemSelectedFlightNaturalKey>;
};

export type MultiItemSessionMutations = {
  __typename?: "MultiItemSessionMutations";
  addProducts: MultiItemSearchContextResult;
  changePackage: MultiItemSearchContextResult;
  initiate: MultiItemSearchContextResult;
  removeProducts: MultiItemSearchContextResult;
  selectPackage: MultiItemSearchContextResult;
  selectProducts: MultiItemSearchContextResult;
  updateProduct: MultiItemSearchContextResult;
};

export type MultiItemSessionMutationsAddProductsArgs = {
  activities?: InputMaybe<Array<ActivityNaturalKeyInput>>;
  groundTransfers?: InputMaybe<Array<GroundTransfersNaturalKeyInput>>;
  sessionId: Scalars["String"];
};

export type MultiItemSessionMutationsChangePackageArgs = {
  searchCriteria: PackageSearchCriteriaInput;
  sessionId: Scalars["String"];
};

export type MultiItemSessionMutationsInitiateArgs = {
  searchContext: MultiItemSearchContextInput;
};

export type MultiItemSessionMutationsRemoveProductsArgs = {
  activities?: InputMaybe<Array<ActivityNaturalKeyInput>>;
  groundTransfers?: InputMaybe<Array<GroundTransfersNaturalKeyInput>>;
  sessionId: Scalars["String"];
};

export type MultiItemSessionMutationsSelectPackageArgs = {
  packageOfferId: Scalars["String"];
  sessionId: Scalars["String"];
};

export type MultiItemSessionMutationsSelectProductsArgs = {
  cars?: InputMaybe<Array<CarNaturalKeyInput>>;
  flights?: InputMaybe<Array<FlightNaturalKeyInput>>;
  priceToken?: InputMaybe<Scalars["String"]>;
  properties?: InputMaybe<Array<PropertyNaturalKeyInput>>;
  sessionId: Scalars["String"];
};

export type MultiItemSessionMutationsUpdateProductArgs = {
  activity?: InputMaybe<ActivityUpdateInput>;
  flights?: InputMaybe<Array<FlightNaturalKeyInput>>;
  priceToken?: InputMaybe<Scalars["String"]>;
  sessionId: Scalars["String"];
};

export interface MultiItemShoppingAction {
  shoppingContext: ShoppingContext;
}

export type Mutation = {
  __typename?: "Mutation";
  /** Updates the account specified in `actionContext` with the supplied form input data, driven by a `ProfileAccountFormSubmitAction` */
  accountFormSubmit: ProfileAccountFormComponent;
  /** Add Insurance */
  addGlobalInsurance: AddInsuranceResponse;
  /** Add Insurance - to be removed (do not use) */
  addInsurance: AddInsuranceResponse;
  /** Add Insurance */
  addInsuranceOld: AddInsuranceResponseOld;
  /** Agency Delete Quote */
  agencyDeleteQuote: AgencyQuoteDeleteStatus;
  /** Agency Quote Builder Add */
  agencyQuoteBuilderAdd: AgencyQuoteBuilderResponse;
  /** Agency Quote Builder Handoff */
  agencyQuoteBuilderHandoff: AgencyQuoteBuilderResponse;
  /** Agency Quote Builder Remove */
  agencyQuoteBuilderRemove: AgencyQuoteBuilderResponse;
  /** Save Agency Quote */
  agencySaveQuote: AgencyQuoteSaveResponse;
  /** GraphQL Mutation for apply coupon */
  applyCoupon: AppliedCoupon;
  approveCancellationWaiver: SupplyCancellationWaiverApprovalResponseContent;
  /** Create Question Api */
  askProductQuestion?: Maybe<Scalars["String"]>;
  /**
   * Batch updates inbox notifications by user id based on changes to the seen and read attributes
   * @deprecated Please use https://github.expedia.biz/Brand-Expedia/notifications-spinner instead
   */
  batchUpdateInboxNotificationsByUserId: Array<CustomerNotification>;
  book: BookResponse;
  /**
   * Top level cart mutations
   * @deprecated DO NOT USE: Will be removed permanently soon
   */
  cartItems: CartMutations;
  /** Submit feedback prompt response by prompt id */
  cdfSubmitFeedback: CdfFormValidation;
  /** Contact Us Options View */
  contactUsOptions: ContactUsViewMutation;
  /** Mutation that creates new checkout session for R1 Cars */
  createEcommCheckoutSession: CheckoutSession;
  /** Creates a new multi item session */
  createMultiItemSession: MultiItemSearchContextResult;
  /** Create price alert subscription */
  createPriceTracking: PriceInsightsTrackingView;
  /**
   * Top level cart query that creates a session cart
   * @deprecated DO NOT USE: Will be removed permanently soon
   */
  createSessionCart: Cart;
  declineCancellationWaiver: SupplyCancellationWaiverDeclineSuccessContent;
  /** Deletes a notification using the notification id provided */
  deleteNotificationById: InboxNotificationDeleteResponse;
  /** Submit feedback response by prompt id */
  directFeedbackSubmit: DirectFeedbackFormValidation;
  /** Create price alert subscription */
  disablePriceTracking: PriceInsightsTrackingView;
  /** Top level universal profile query */
  editUniversalProfile: EditUniversalProfileResponse;
  /** Retrieve response with ancillary updated token. */
  flightsAncillaryUpdate?: Maybe<FlightsAncillaryUpdateResponse>;
  /** Flights servicing booking mutation */
  flightsServicingCompleteBooking: FlightsServicingBookingResponse;
  getResponseMessage: Scalars["String"];
  /** Hide all search histories for the customer. */
  hideAllSearchHistories?: Maybe<HistoryMutationResponse>;
  /** Hide the customer's search history. Calling hide twice for the given interactionId will permanently delete that interaction. */
  hideSearchHistory?: Maybe<HistoryMutationResponse>;
  /** Full Account Create Mutation */
  identityCreateAccount: IdentityAccountResponse;
  /** Mutation to submit the sign-in experience */
  identityFormSubmit?: Maybe<IdentityResponse>;
  /** Add Remove Insurance */
  insuranceAddRemove?: Maybe<InsuranceTripMutationResponse>;
  /** Insurance Booking Cancellation */
  insuranceBookingCancellation?: Maybe<InsuranceBookingCancellationResponse>;
  /** Mark Answer Helpful Api */
  markAnswerHelpful?: Maybe<Scalars["Boolean"]>;
  /**
   * Call analytics service to get merged message and then publish to UIS Prime
   * @deprecated this mutation is deprecated but required for UIS Prime, it may be removed with the move to eg clickstream
   */
  mergeMultiItemAnalytics: MultiItemAnalyticsMutationResponse;
  multiFactorCodeGeneration: SupplyMultiFactorAuthenticationExperience;
  multiFactorCodeVerification: SupplyMultiFactorAuthenticationExperience;
  /** Top level multi-item session mutation */
  multiItemShopping: MultiItemSessionMutations;
  /** Transition between Shopping and Checkout. The natural keys consist of the minimum set of data used to get the details of a product from a supply service */
  prepareCheckout: PrepareCheckoutResponse;
  /**
   * Transition between Shopping and Checkout using the cart to obtain the keys of the products being checked out
   * @deprecated DO NOT USE: Will be removed permanently soon
   */
  prepareCheckoutByCartId: PrepareCheckoutResponse;
  /** Transition between Shopping and Checkout using the sessionId to obtain the keys of the products being checked out */
  prepareCheckoutBySessionId: PrepareCheckoutResponse;
  /** Performs a price check operation */
  priceMatchPromiseCheckPrice?: Maybe<PriceCheckMutationResult>;
  /** A temporary test hook for publishing messages to ably */
  publishToAbly: Scalars["String"];
  /** Reject a review */
  rejectReview: Scalars["Boolean"];
  /** GraphQL Mutation for remove coupon */
  removeCoupon: CouponRedemption;
  /** Remove Insurance */
  removeGlobalInsurance: RemoveInsuranceResponse;
  /** Remove Insurance */
  removeInsurance: RemoveInsuranceResponse;
  /** Add Insurance */
  removeInsuranceOld: RemoveInsuranceResponseOld;
  /** Remove a shortlisted item */
  removeShortlistItem: RemoveItemResults;
  /** Mutation to dismiss notification */
  retailTravelAgentDismissNotification?: Maybe<RetailTravelAgentMutateNotificationResult>;
  /** Mutation to set notification as read */
  retailTravelAgentSetAsReadNotification?: Maybe<RetailTravelAgentMutateNotificationResult>;
  /** Shortlist a new item */
  saveShortlistItem?: Maybe<SavedItem>;
  saveSupplyRegulatorySettings?: Maybe<SupplyRegulatoryFlow>;
  /** Send message to the Conversation Platform */
  sendMessage?: Maybe<VirtualAgentControlSendMessageResult>;
  /** Send text using OneReach Service */
  sendTextToDownloadApp: NotificationTextToDownloadAppResponse;
  /** ServiceAutomation Mutations */
  serviceAutomation: ServiceAutomationTopLevelMutation;
  /** Changes the status of price alerts for a given search */
  setFlightPriceAlertOptIn?: Maybe<FlightsPriceAlertsOptInResponse>;
  setMinNightStay?: Maybe<MinNightStayResult>;
  /** Global insurance Shopping Request */
  shopGlobalInsurance?: Maybe<InsuranceShoppingResponse>;
  smartForm: SmartFormMutation;
  /** Mutation for submitting a new inquiry. */
  submitInquiry: InquiryResponse;
  supplyActionTip: SupplyActionTipResponse;
  supplyContentUpdateHeadlineDescription: SupplyContentDescriptionUpdate;
  supplyContentUpdateLocation: SupplyContentUpdateLocationResult;
  supplyContentUpdateManualTranslation: SupplyContentManualTranslationUpdate;
  supplyContentUpdateYourStory: SupplyContentDescriptionUpdate;
  supplyFeesUpdate: SupplyFees;
  supplyMultiFactorCodeGeneration: SupplyMultiFactorAuthenticationExperience;
  supplyMultiFactorCodeVerification: SupplyMultiFactorAuthenticationExperience;
  supplyOnboardingAvailabilityUpdate?: Maybe<SupplyOnboardingAvailabilityUpdate>;
  supplyOnboardingPublishListing?: Maybe<SupplyOnboardingPublishListingResult>;
  supplyOnboardingWelcomeNavigate: SupplyOnboardingWelcomeNavigationUpdate;
  supplyOnboardingWorkFlowNavigate: SupplyOnboardingWorkFlowNavigationUpdate;
  supplyTaxesUpdate: SupplyTaxesEditor;
  supplyUpdateNewListingOfferEnrollment: SupplyUpdateNewListingOfferEnrollment;
  supplyUpdatePartnerBillingAddress: SupplyOnboardingPartnerBillingAddress;
  supplyUpdatePartnerBusinessName: SupplyOnboardingPartnerBusinessNameResult;
  supplyUpdatePartnerHostType: SupplyOnboardingHostTypeResult;
  supplyUpdatePartnerPayoutDeferredAccount: SupplyUpdatePartnerPayoutDeferredAccount;
  supplyUpdatePropertyRates: SupplyUpdatePropertyRates;
  /** Send text using OneReach Service */
  textToDownloadApp: CustomerNotificationTextToDownloadAppResponse;
  trip: TripMutation;
  /** Unhide all search histories for the customer. */
  unhideAllSearchHistories?: Maybe<HistoryMutationResponse>;
  /** Unhide the customer's search history. */
  unhideSearchHistory?: Maybe<HistoryMutationResponse>;
  updateAgentPresence: UpdatePresence;
  /** Updates an inbox notification based on changes to the seen and read attributes */
  updateInbox?: Maybe<Array<InboxNotificationUpdateResponse>>;
  /**
   * Updates an inbox notification based on changes to the seen and read attributes
   * @deprecated Please use https://github.expedia.biz/Brand-Expedia/notifications-spinner instead
   */
  updateInboxNotification: Array<CustomerNotification>;
  /** Updates an inbox notifications based on changes state attribute */
  updateInboxState?: Maybe<Array<InboxNotificationUpdateStateResponse>>;
  /** A mutation to update an offer by either adding or removing an InsurTech (insurance or assurance) offer to it. */
  updateInsurtechOffer: UpdateInsurtechOfferResponse;
  updateNewListingOfferEnrollment: SupplyUpdateNewListingOfferEnrollment;
  updatePartnerBillingAddress: SupplyOnboardingPartnerBillingAddress;
  updatePartnerBusinessName: SupplyOnboardingPartnerBusinessNameResult;
  updatePartnerHostType: SupplyOnboardingHostTypeResult;
  updatePartnerPayoutDeferredAccount: SupplyUpdatePartnerPayoutDeferredAccount;
  /** Represents the mutation to update a payment session */
  updatePaymentSession: PaymentModuleSession;
  /** Create price alert subscription */
  updatePriceTracking: PriceInsightsTrackingView;
  updatePropertyRates: SupplyUpdatePropertyRates;
  updateSupplyAmenities: SupplyAmenitiesGroup;
  /**
   * Upvote totalThanks field for a review
   * @deprecated Use upvotePropertyReviewWithAccessibility
   */
  upvotePropertyReview: Scalars["String"];
  /** Upvote totalThanks field for a review */
  upvotePropertyReviewWithAccessibility: UpvotePropertyReviewWithAccessibility;
  /** Mutation for submitting a wizard action */
  userProfileWizardSubmit: ProfileWizardResponse;
  /** Updates the userSetting specified in `actionContext` with the supplied form input data, driven by a `ProfileFormSubmitAction` */
  userSettingFormSubmit: ProfileComponent;
  /** Virtual agent will process checkout for the selected flight */
  virtualAgentFlightCheckout: VirtualAgentCheckoutResponse;
};

export type MutationAccountFormSubmitArgs = {
  actionContext: Scalars["String"];
  context: ContextInput;
  inputs: Array<GraphQlPairInput>;
};

export type MutationAddGlobalInsuranceArgs = {
  addInsuranceRequest: AddInsuranceRequestInput;
  context: ContextInput;
};

export type MutationAddInsuranceArgs = {
  addInsuranceRequest: AddInsuranceRequestInput;
  context: ContextInput;
};

export type MutationAddInsuranceOldArgs = {
  addInsuranceRequest: AddInsuranceRequestOldInput;
  context: ContextInput;
};

export type MutationAgencyDeleteQuoteArgs = {
  context: ContextInput;
  quoteDeleteInput: AgencyQuoteDeleteInput;
};

export type MutationAgencyQuoteBuilderAddArgs = {
  context: ContextInput;
  rateCard: AgencyQuoteBuilderRateCardInput;
};

export type MutationAgencyQuoteBuilderHandoffArgs = {
  context: ContextInput;
};

export type MutationAgencyQuoteBuilderRemoveArgs = {
  context: ContextInput;
  removeRateCards: AgencyQuoteBuilderRemoveInput;
};

export type MutationAgencySaveQuoteArgs = {
  context: ContextInput;
  quoteSaveInput: AgencyQuoteSaveInput;
};

export type MutationApplyCouponArgs = {
  context: ContextInput;
  coupons: Array<CouponIdentifierInput>;
  moduleInstanceId: Scalars["String"];
};

export type MutationApproveCancellationWaiverArgs = {
  approvalRequestContext: SupplyCancellationWaiverApprovalRequestContext;
  context: ContextInput;
  propertyContext: PropertyContext;
};

export type MutationAskProductQuestionArgs = {
  context: ContextInput;
  email: Scalars["String"];
  productId: Scalars["String"];
  productQuestionTopic: ProductQuestionTopic;
  question: Scalars["String"];
  questioner?: InputMaybe<Scalars["String"]>;
};

export type MutationBatchUpdateInboxNotificationsByUserIdArgs = {
  context: ContextInput;
  expUserId: Scalars["String"];
  modifiableAttributes: CustomerNotificationModifiableAttributesInput;
};

export type MutationBookArgs = {
  checkoutSessionInfo: CheckoutSessionInfoInput;
  context: ContextInput;
  domainInfoList?: InputMaybe<Array<CheckoutDomainInfoInput>>;
};

export type MutationCartItemsArgs = {
  context: ContextInput;
  id?: InputMaybe<Scalars["UUID"]>;
};

export type MutationCdfSubmitFeedbackArgs = {
  context: ContextInput;
  feedback: CdfFeedbackInput;
  id: Scalars["ID"];
};

export type MutationContactUsOptionsArgs = {
  context: ContextInput;
};

export type MutationCreateEcommCheckoutSessionArgs = {
  context: ContextInput;
  piid: Scalars["String"];
  spEquipment?: InputMaybe<Array<Scalars["String"]>>;
  totalPrice: Scalars["String"];
  tripid: Scalars["String"];
};

export type MutationCreateMultiItemSessionArgs = {
  context: ContextInput;
  searchContext: MultiItemSearchContextInput;
};

export type MutationCreatePriceTrackingArgs = {
  context: ContextInput;
  priceInsightsSearchContext: PriceInsightsSearchContextInput;
  priceShown: Scalars["String"];
};

export type MutationCreateSessionCartArgs = {
  cartOptions: CartOptionsInput;
  context: ContextInput;
};

export type MutationDeclineCancellationWaiverArgs = {
  context: ContextInput;
  declineRequestContext: CancellationWaiverDeclineRequestContext;
  propertyContext: PropertyContext;
};

export type MutationDeleteNotificationByIdArgs = {
  context?: InputMaybe<ContextInput>;
  notificationId: Scalars["String"];
};

export type MutationDirectFeedbackSubmitArgs = {
  context: ContextInput;
  feedback: DirectFeedbackValuesInput;
  id: Scalars["ID"];
};

export type MutationDisablePriceTrackingArgs = {
  context: ContextInput;
  priceShown?: InputMaybe<Scalars["String"]>;
  subscriptionId: Scalars["String"];
};

export type MutationEditUniversalProfileArgs = {
  context: ContextInput;
};

export type MutationFlightsAncillaryUpdateArgs = {
  context: ContextInput;
  detailAncillaryUpdateCriteria: FlightsDetailAncillaryUpdateCriteriaInput;
  shoppingContext?: InputMaybe<ShoppingContextInput>;
};

export type MutationFlightsServicingCompleteBookingArgs = {
  context: ContextInput;
  edgeToken: Scalars["String"];
  flightsServicingCriteria: FlightsServicingCriteriaInput;
  insuranceCriteria?: InputMaybe<InsuranceCriteriaInput>;
  paymentSessionId?: InputMaybe<Scalars["String"]>;
  queryState?: InputMaybe<FlightsQueryState>;
  shoppingContext?: InputMaybe<ShoppingContextInput>;
};

export type MutationGetResponseMessageArgs = {
  text: Scalars["String"];
};

export type MutationHideAllSearchHistoriesArgs = {
  context: ContextInput;
};

export type MutationHideSearchHistoryArgs = {
  context: ContextInput;
  historyTypes?: InputMaybe<Array<HistoryType>>;
  interactionId?: InputMaybe<Scalars["String"]>;
};

export type MutationIdentityCreateAccountArgs = {
  context: ContextInput;
  createAccountRequest: IdentityCreateAccountRequestInput;
};

export type MutationIdentityFormSubmitArgs = {
  context: ContextInput;
  identityClientInfo?: InputMaybe<IdentityClientInfoInput>;
  submitRequest: IdentitySubmitRequestInput;
};

export type MutationInsuranceAddRemoveArgs = {
  addRemoveInsuranceRequest: InsuranceTripMutationRequestInput;
  context: ContextInput;
};

export type MutationInsuranceBookingCancellationArgs = {
  context: ContextInput;
  insuranceBookingCancellationRequest: InsuranceBookingCancellationRequestInput;
};

export type MutationMarkAnswerHelpfulArgs = {
  answerId: Scalars["String"];
  questionId: Scalars["String"];
};

export type MutationMergeMultiItemAnalyticsArgs = {
  context: ContextInput;
  messageType: Scalars["String"];
  traceIds: Array<Scalars["String"]>;
};

export type MutationMultiFactorCodeGenerationArgs = {
  context: ContextInput;
  mfaCodeGenerationInput: SupplyMultiFactorCodeGenerationInput;
};

export type MutationMultiFactorCodeVerificationArgs = {
  context: ContextInput;
  mfaCodeVerificationInput: SupplyMultiFactorCodeVerificationInput;
};

export type MutationMultiItemShoppingArgs = {
  context: ContextInput;
};

export type MutationPrepareCheckoutArgs = {
  activities?: InputMaybe<Array<ActivityNaturalKeyInput>>;
  cars?: InputMaybe<Array<CarNaturalKeyInput>>;
  checkoutOptions?: InputMaybe<Array<CheckoutOptionInput>>;
  context: ContextInput;
  cookies?: InputMaybe<Scalars["String"]>;
  flights?: InputMaybe<Array<FlightNaturalKeyInput>>;
  groundTransfers?: InputMaybe<Array<GroundTransfersNaturalKeyInput>>;
  packages?: InputMaybe<Array<PackageNaturalKeyInput>>;
  properties?: InputMaybe<Array<PropertyNaturalKeyInput>>;
  responseOptions?: InputMaybe<Array<PrepareCheckoutResponseOption>>;
  totalPrice?: InputMaybe<MoneyInput>;
};

export type MutationPrepareCheckoutByCartIdArgs = {
  cartId: Scalars["UUID"];
  checkoutOptions?: InputMaybe<Array<CheckoutOptionInput>>;
  context: ContextInput;
  marketingChannelId?: InputMaybe<Scalars["Int"]>;
  totalPrice?: InputMaybe<MoneyInput>;
};

export type MutationPrepareCheckoutBySessionIdArgs = {
  checkoutOptions?: InputMaybe<Array<CheckoutOptionInput>>;
  context: ContextInput;
  cookies?: InputMaybe<Scalars["String"]>;
  multiItemSessionId: Scalars["String"];
};

export type MutationPriceMatchPromiseCheckPriceArgs = {
  context: ContextInput;
  tripContextToken?: InputMaybe<Scalars["String"]>;
  tripNumber: Scalars["String"];
};

export type MutationPublishToAblyArgs = {
  channelName?: InputMaybe<Scalars["String"]>;
  messages: Array<Scalars["String"]>;
};

export type MutationRejectReviewArgs = {
  brandType: Scalars["String"];
  context: ContextInput;
  flagCode: Array<Scalars["String"]>;
  id: Scalars["String"];
};

export type MutationRemoveCouponArgs = {
  context: ContextInput;
  coupons: Array<CouponIdentifierInput>;
  moduleInstanceId: Scalars["String"];
};

export type MutationRemoveGlobalInsuranceArgs = {
  context: ContextInput;
  removeInsuranceRequest: RemoveInsuranceRequestInput;
};

export type MutationRemoveInsuranceArgs = {
  context: ContextInput;
  removeInsuranceRequest: RemoveInsuranceRequestInput;
};

export type MutationRemoveInsuranceOldArgs = {
  context: ContextInput;
  removeInsuranceRequest: RemoveInsuranceRequestOldInput;
};

export type MutationRemoveShortlistItemArgs = {
  context: ContextInput;
  pageName?: InputMaybe<Scalars["String"]>;
  productId: Scalars["String"];
  productType: ProductType;
};

export type MutationRetailTravelAgentDismissNotificationArgs = {
  context: ContextInput;
  id: Scalars["ID"];
};

export type MutationRetailTravelAgentSetAsReadNotificationArgs = {
  context: ContextInput;
  id: Scalars["ID"];
};

export type MutationSaveShortlistItemArgs = {
  context: ContextInput;
  metadata?: InputMaybe<Array<ShortlistMetadataInput>>;
  pageName?: InputMaybe<Scalars["String"]>;
  productId: Scalars["String"];
  productType: ProductType;
};

export type MutationSaveSupplyRegulatorySettingsArgs = {
  context: ContextInput;
  propertyContext: PropertyContext;
  settings: Array<SupplyRegulatorySettingInput>;
};

export type MutationSendMessageArgs = {
  context: ContextInput;
  conversationContext: ConversationContextInput;
  messageInput: VirtualAgentControlMessageInput;
};

export type MutationSendTextToDownloadAppArgs = {
  context: ContextInput;
  customerInput: NotificationUserInput;
  placementId: Scalars["String"];
};

export type MutationSetFlightPriceAlertOptInArgs = {
  context: ContextInput;
  journeyCriteria: Array<FlightsJourneyCriteriaInput>;
  lowestPrice: Scalars["String"];
  optInStatus: Scalars["Boolean"];
  searchPreferences?: InputMaybe<FlightsSearchPreferencesInput>;
  travelerDetails?: InputMaybe<Array<FlightsTravelerDetailsInput>>;
};

export type MutationSetMinNightStayArgs = {
  context: ContextInput;
  minNightStayValue: Scalars["Int"];
  propertyContext: PropertyContext;
};

export type MutationShopGlobalInsuranceArgs = {
  context: ContextInput;
  insuranceShoppingRequest: InsuranceShoppingRequestInput;
};

export type MutationSmartFormArgs = {
  context: ContextInput;
  sessionId: Scalars["String"];
};

export type MutationSubmitInquiryArgs = {
  context: ContextInput;
  inquiryRequest?: InputMaybe<InquiryRequestInput>;
};

export type MutationSupplyActionTipArgs = {
  actionInputs: Array<SupplyQuickActionFormContextInput>;
  context: ContextInput;
  propertyContext: PropertyContext;
};

export type MutationSupplyContentUpdateHeadlineDescriptionArgs = {
  context: ContextInput;
  params?: InputMaybe<SupplyContentHeadlineDescriptionUpdateInput>;
  propertyContext: PropertyContext;
};

export type MutationSupplyContentUpdateLocationArgs = {
  context: ContextInput;
  propertyContext: PropertyContext;
  updateLocationInput: SupplyContentUpdateLocationInput;
};

export type MutationSupplyContentUpdateManualTranslationArgs = {
  context: ContextInput;
  params: SupplyContentManualTranslationUpdateInput;
  propertyContext: PropertyContext;
};

export type MutationSupplyContentUpdateYourStoryArgs = {
  context: ContextInput;
  params: SupplyContentYourStoryUpdateInput;
  propertyContext: PropertyContext;
};

export type MutationSupplyFeesUpdateArgs = {
  context: ContextInput;
  feesInput: Array<SupplyFeesInput>;
  propertyContext: PropertyContext;
};

export type MutationSupplyMultiFactorCodeGenerationArgs = {
  context: ContextInput;
  mfaCodeGenerationInput: SupplyMultiFactorCodeGenerationInput;
};

export type MutationSupplyMultiFactorCodeVerificationArgs = {
  context: ContextInput;
  mfaCodeVerificationInput: SupplyMultiFactorCodeVerificationInput;
};

export type MutationSupplyOnboardingAvailabilityUpdateArgs = {
  availabilityType?: InputMaybe<SupplyOnboardingAvailabilityType>;
  context: ContextInput;
  propertyContext: PropertyContext;
};

export type MutationSupplyOnboardingPublishListingArgs = {
  context: ContextInput;
  propertyContext: PropertyContext;
};

export type MutationSupplyOnboardingWelcomeNavigateArgs = {
  context: ContextInput;
  propertyContext: PropertyContext;
};

export type MutationSupplyOnboardingWorkFlowNavigateArgs = {
  context: ContextInput;
  currentStep: Scalars["String"];
  propertyContext: PropertyContext;
  type: SupplyOnboardingButtonType;
};

export type MutationSupplyTaxesUpdateArgs = {
  context: ContextInput;
  propertyContext: PropertyContext;
  taxesInput: SupplyTaxesInput;
};

export type MutationSupplyUpdateNewListingOfferEnrollmentArgs = {
  context: ContextInput;
  input?: InputMaybe<SupplyNewListingOfferEnrollmentInput>;
  propertyContext: PropertyContext;
};

export type MutationSupplyUpdatePartnerBillingAddressArgs = {
  billingAddressInput: SupplyOnboardingPartnerBillingAddressInput;
  context: ContextInput;
};

export type MutationSupplyUpdatePartnerBusinessNameArgs = {
  businessNameInput: SupplyOnboardingPartnerBusinessNameInput;
  context: ContextInput;
};

export type MutationSupplyUpdatePartnerHostTypeArgs = {
  context: ContextInput;
  hostType: Scalars["String"];
  propertyContext: PropertyContext;
};

export type MutationSupplyUpdatePartnerPayoutDeferredAccountArgs = {
  context: ContextInput;
  input: SupplyPartnerPayoutDeferredAccountInput;
  propertyContext: PropertyContext;
};

export type MutationSupplyUpdatePropertyRatesArgs = {
  context: ContextInput;
  input: SupplyPropertyRateInput;
  propertyContext: PropertyContext;
};

export type MutationTextToDownloadAppArgs = {
  context: ContextInput;
  customerInput: CustomerNotificationUserInput;
  placementId: Scalars["String"];
};

export type MutationTripArgs = {
  context: ContextInput;
};

export type MutationUnhideAllSearchHistoriesArgs = {
  context: ContextInput;
};

export type MutationUnhideSearchHistoryArgs = {
  context: ContextInput;
  historyTypes?: InputMaybe<Array<HistoryType>>;
  interactionId?: InputMaybe<Scalars["String"]>;
};

export type MutationUpdateAgentPresenceArgs = {
  context: ContextInput;
  flavor: FlavorType;
  partnerId: Scalars["String"];
  roleId: Scalars["String"];
  updatePresenceTo: AgentStateInput;
  userId: Scalars["String"];
};

export type MutationUpdateInboxArgs = {
  context?: InputMaybe<ContextInput>;
  modifiableAttributes: Array<NotificationSpecificationsInput>;
};

export type MutationUpdateInboxNotificationArgs = {
  modifiableAttributes: Array<CustomerNotificationModifiableAttributesInput>;
};

export type MutationUpdateInboxStateArgs = {
  context?: InputMaybe<ContextInput>;
  notificationIds: Array<Scalars["String"]>;
  state: NotificationState;
};

export type MutationUpdateInsurtechOfferArgs = {
  context: ContextInput;
  updateInsurtechOfferRequest: UpdateInsurtechOfferRequestInput;
};

export type MutationUpdateNewListingOfferEnrollmentArgs = {
  context: ContextInput;
  input?: InputMaybe<SupplyNewListingOfferEnrollmentInput>;
  propertyContext: PropertyContext;
};

export type MutationUpdatePartnerBillingAddressArgs = {
  billingAddressInput: SupplyOnboardingPartnerBillingAddressInput;
  context: ContextInput;
};

export type MutationUpdatePartnerBusinessNameArgs = {
  businessNameInput: SupplyOnboardingPartnerBusinessNameInput;
  context: ContextInput;
};

export type MutationUpdatePartnerHostTypeArgs = {
  context: ContextInput;
  hostType: Scalars["String"];
  propertyContext: PropertyContext;
};

export type MutationUpdatePartnerPayoutDeferredAccountArgs = {
  context: ContextInput;
  input: SupplyPartnerPayoutDeferredAccountInput;
  propertyContext: PropertyContext;
};

export type MutationUpdatePaymentSessionArgs = {
  paymentSessionId: Scalars["String"];
  tokenizedPaymentCard: Scalars["String"];
};

export type MutationUpdatePriceTrackingArgs = {
  context: ContextInput;
  priceInsightsSearchContext?: InputMaybe<PriceInsightsSearchContextInput>;
  priceShown: Scalars["String"];
  subscriptionId: Scalars["String"];
};

export type MutationUpdatePropertyRatesArgs = {
  context: ContextInput;
  input: SupplyPropertyRateInput;
  propertyContext: PropertyContext;
};

export type MutationUpdateSupplyAmenitiesArgs = {
  context: ContextInput;
  input: SupplyAmenitiesUpdateInput;
  propertyContext: PropertyContext;
};

export type MutationUpvotePropertyReviewArgs = {
  id: Scalars["String"];
};

export type MutationUpvotePropertyReviewWithAccessibilityArgs = {
  context: ContextInput;
  index: Scalars["Int"];
  reviewId: Scalars["String"];
};

export type MutationUserProfileWizardSubmitArgs = {
  collectedActionContexts: Array<Scalars["String"]>;
  context: ContextInput;
  wizardContext: ProfileWizardContextInput;
};

export type MutationUserSettingFormSubmitArgs = {
  actionContext: Scalars["String"];
  context: ContextInput;
  inputs: Array<GraphQlPairInput>;
};

export type MutationVirtualAgentFlightCheckoutArgs = {
  context: ContextInput;
  flightsDetailsCriteria: FlightsDetailCriteriaInput;
  virtualAgentContext: VirtualAgentContextInput;
};

export type NavTab = {
  __typename?: "NavTab";
  analytics: CarAnalytics;
  name: Scalars["String"];
};

/** Individual tab section for tabbed navigation bar */
export type NavigationTab = {
  __typename?: "NavigationTab";
  /**
   * The presence of this field indicates that client side interactions such as `click` should be tracked.
   * @deprecated Use clickAction instead
   */
  analytics?: Maybe<ActivityAnalytics>;
  /** click action to select the tab for filtering */
  clickAction?: Maybe<ActivityClickAction>;
  /** Name of the tab */
  label: Scalars["String"];
  /**
   * ref Id of section to scroll to
   * @deprecated Use clickAction instead
   */
  sectionRef: Scalars["String"];
  /** selected tab value */
  selected?: Maybe<Scalars["Boolean"]>;
};

export type NavigationTabs = {
  __typename?: "NavigationTabs";
  tabs: Array<PropertyNavigationBarTab>;
};

/** Content of Airport suggesting module */
export type NearbyAirportsSuggestion = {
  __typename?: "NearbyAirportsSuggestion";
  content: PackageUiNearbyAirports;
  expando: EgdsExpandoCard;
};

export type Neighborhood = {
  __typename?: "Neighborhood";
  name: Scalars["String"];
  regionId: Scalars["String"];
};

export type NightlyRate = {
  __typename?: "NightlyRate";
  available: Scalars["Boolean"];
  date?: Maybe<DateTime>;
  displayPrice?: Maybe<Money>;
  strikeOutPrice?: Maybe<Money>;
};

/** Enum class to represent the type of no cancel fee */
export type NoCancelFeeType = "NO_CANCEL_FEE";

/** Enum class to represent the type of no change fee */
export type NoChangeFeeType = "NO_CHANGE_FEE";

/** This represents the no listings message */
export type NoListingsMessage = {
  __typename?: "NoListingsMessage";
  /** Placeholder for inner properties */
  text: Scalars["String"];
};

export type NoMultiItemShoppingAction = MultiItemShoppingAction & {
  __typename?: "NoMultiItemShoppingAction";
  shoppingContext: ShoppingContext;
};

/** This represents the no review error message */
export type NoProductReviewError = {
  __typename?: "NoProductReviewError";
  /** This represents client side analytics to be tracked */
  analytics: ClientSideAnalytics;
  /** This represents the error heading. Example: 'Sorry, we're having a problem on our end.' */
  heading: EgdsText;
  /** This represents the magnifying glass icon */
  icon: Icon;
  /** This represents the error message. Example: 'Please try your search again later.' */
  message: EgdsText;
  /** This represents the retry button */
  retryButton: EgdsButton;
};

/**
 * A message to be displayed when there are no results, e.g. a messaging card or an empty state
 * Figma: https://www.figma.com/file/0OuX8BMSFmFdWYXfdCEjrj/Empty-state
 *        https://www.figma.com/file/V9juOKAE4bgugBqxRiPBjJ/Messaging-cards
 */
export type NoResultsMessage = UiEmptyState | UiMessagingCard;

export type NorthstarFooterImage = {
  __typename?: "NorthstarFooterImage";
  altText?: Maybe<Scalars["String"]>;
  imgSrc?: Maybe<Scalars["URL"]>;
  newWindowText?: Maybe<Scalars["String"]>;
  target?: Maybe<Scalars["String"]>;
  url?: Maybe<Scalars["URL"]>;
};

export type NorthstarFooterSection = {
  __typename?: "NorthstarFooterSection";
  data?: Maybe<Array<NorthstarFooterSectionLink>>;
  text?: Maybe<Scalars["String"]>;
};

export type NorthstarFooterSectionImages = FooterSectionData & {
  __typename?: "NorthstarFooterSectionImages";
  data: Array<Maybe<NorthstarFooterImage>>;
};

export type NorthstarFooterSectionLink = {
  __typename?: "NorthstarFooterSectionLink";
  target?: Maybe<Scalars["String"]>;
  text?: Maybe<Scalars["String"]>;
  trackingEvent?: Maybe<Scalars["String"]>;
  url?: Maybe<Scalars["URL"]>;
};

export type NorthstarFooterSectionLinks = FooterSectionData & {
  __typename?: "NorthstarFooterSectionLinks";
  data: Array<Maybe<FooterData>>;
  minimal?: Maybe<Scalars["Boolean"]>;
};

export type NorthstarFooterSectionText = FooterSectionData & {
  __typename?: "NorthstarFooterSectionText";
  data: Array<Maybe<NorthstarFooterText>>;
  minimal?: Maybe<Scalars["Boolean"]>;
};

export type NorthstarFooterText = {
  __typename?: "NorthstarFooterText";
  text?: Maybe<Scalars["String"]>;
};

export type NorthstarMinimalFooterSectionLinks = FooterSectionData & {
  __typename?: "NorthstarMinimalFooterSectionLinks";
  data: Array<Maybe<FooterData>>;
};

/** An interface for a11y labels on the fields in notification */
export interface NotificationAccessibilityField {
  /** Label where a11y behavior is needed. */
  accessibilityLabel?: Maybe<Scalars["String"]>;
}

/** Represents an action to be done after user interaction */
export type NotificationAction =
  | NotificationAnalytics
  | NotificationAnalyticsEgClickstream
  | NotificationCookie
  | NotificationMarketing
  | NotificationSchema
  | NotificationSpecifications;

/** Represents the analytics to track on interaction with the notification */
export type NotificationAnalytics = {
  __typename?: "NotificationAnalytics";
  /** Represents a short friendly name to clarify the meaning of the client side tracked event */
  description?: Maybe<Scalars["String"]>;
  /** Represents a value for the client side action taken */
  referrerId: Scalars["String"];
  /** Represents a schema with attributes */
  schema?: Maybe<Array<NotificationSchema>>;
};

/** Represents the analytics to track on interaction with the notification */
export type NotificationAnalyticsEgClickstream = {
  __typename?: "NotificationAnalyticsEgClickstream";
  /** Represents a short friendly name to clarify the meaning of the client side tracked event */
  description?: Maybe<Scalars["String"]>;
  /** Represents an egclickstream event */
  event: EgClickstreamEvent;
  /** Represents a schema with attributes */
  schema?: Maybe<Array<NotificationSchema>>;
};

/** Represents an attribute for a notification */
export type NotificationAnalyticsSchemaAttribute = {
  __typename?: "NotificationAnalyticsSchemaAttribute";
  /** Name of the attribute */
  name: Scalars["String"];
  /** Value of the attribute */
  value: Scalars["String"];
};

/** Represents an attribute for a notification */
export type NotificationAttribute = {
  __typename?: "NotificationAttribute";
  /** Name of the attribute */
  name?: Maybe<Scalars["String"]>;
  /** Value of the attribute */
  value?: Maybe<Scalars["String"]>;
};

/** Shared UI Component for customer notification center.  Displays the customer's inbox notifications. */
export type NotificationCenter = HeaderSharedUi & {
  __typename?: "NotificationCenter";
  skipSsr: Scalars["Boolean"];
};

/** Represents the notification object on notification center */
export type NotificationCenterCacheItem = {
  __typename?: "NotificationCenterCacheItem";
  /** Represents the icon that will be used in the notification center */
  icon?: Maybe<Icon>;
  /** Represents heading title of the notification center object to be displayed on the client */
  title?: Maybe<NotificationPhrase>;
  /** Represents number of unseen notifications */
  unseen?: Maybe<Scalars["Int"]>;
};

/** Represents the notification object on notification center */
export type NotificationCenterItem = {
  __typename?: "NotificationCenterItem";
  /** Represents localization texts for delete form on notification center */
  deleteActionForm?: Maybe<NotificationForm>;
  /** Represents empty state for notification center */
  emptyState?: Maybe<NotificationEmptyState>;
  /** Represents the icon that will be used in the notification center */
  icon?: Maybe<Icon>;
  /** Represents inbox notification list that will be used in notification center */
  notifications?: Maybe<Array<NotificationInbox>>;
  /** Represents redirect path for unauthenticated users */
  redirectPath?: Maybe<Scalars["String"]>;
  /** Represents click tracking for entry points */
  revealActions?: Maybe<Array<NotificationAction>>;
  /** Represents heading title of the notification center object to be displayed on the client */
  title?: Maybe<NotificationPhrase>;
  /** Represents number of unseen notifications */
  unseen?: Maybe<Scalars["Int"]>;
};

/** Represents the hyperlink data when notification container is a link */
export type NotificationContainerLink = NotificationLink & {
  __typename?: "NotificationContainerLink";
  /** Represents the actions to apply on interaction with the link */
  actions?: Maybe<Array<NotificationAction>>;
  /** Logical identifier associated with the link */
  id?: Maybe<Scalars["String"]>;
  /** Represents the target of the link */
  target?: Maybe<NotificationLinkTarget>;
  /** The underlying hyperlink uri */
  uri?: Maybe<Uri>;
};

/** Represents the cookie that needs to be set after an interaction */
export type NotificationCookie = {
  __typename?: "NotificationCookie";
  /** The cookie expires in RFC 1123 format e.g. 'Sat, 9 Nov 2019 18:49:17 GMT' */
  expires: Scalars["String"];
  /** The cookie name */
  name: Scalars["String"];
  /** The cookie value */
  value: Scalars["String"];
};

/** Type encapsulating the dismiss data of a notification */
export type NotificationDismiss = {
  __typename?: "NotificationDismiss";
  /** Represents the actions to be applied on interaction with dismiss */
  actions?: Maybe<Array<NotificationAction>>;
  /** Represents the 'X' icon displayed which dismisses the notification on client */
  icon: Icon;
};

/** Type encapsulating EGDS Text, Link, Icon component with their corresponding attributes. */
export type NotificationEgdsItems = NotificationEgdsLinkNode | NotificationEgdsTextNode;

/** Type encapsulating Notification EGDS Link Node and attributes */
export type NotificationEgdsLinkNode = {
  __typename?: "NotificationEGDSLinkNode";
  /** URL and analytics information association with link. */
  action: UiLinkAction;
  /** Display disabled link state. */
  disabled: Scalars["Boolean"];
  /** size of the link. */
  size: EgdsLinkSize;
  text: Scalars["String"];
};

/** Type encapsulating Notification EGDS Text component with their corresponding attributes. */
export type NotificationEgdsTextNode = {
  __typename?: "NotificationEGDSTextNode";
  text: Scalars["String"];
  theme?: Maybe<TextTheme>;
  weight?: Maybe<TextWeight>;
};

/** Represents an attribute for empty state of notification center */
export type NotificationEmptyState = {
  __typename?: "NotificationEmptyState";
  /** Body of the empty state */
  body?: Maybe<Array<NotificationPhrase>>;
  /** Icon of the empty state */
  icon?: Maybe<Icon>;
  /** Title of the empty state */
  title?: Maybe<NotificationPhrase>;
};

/** Represents a form that should be displayed in the notification */
export type NotificationForm = {
  __typename?: "NotificationForm";
  /** The error list of form analytics */
  errorFormAnalytics?: Maybe<Array<NotificationAction>>;
  /** The list of feedback messages for the form interaction, it could be warning, error, success messages */
  feedbackMessages?: Maybe<Array<NotificationMessage>>;
  /** The list of form sections items */
  sections: Array<NotificationFormSection>;
  /** The success list of form analytics */
  successFormAnalytics?: Maybe<Array<NotificationAction>>;
  /** The localized title text of the form */
  title?: Maybe<Scalars["String"]>;
};

/** The button type of the Customer notification submit button */
export type NotificationFormButtonType =
  /** Type of floating action button */
  | "FLOATING_ACTION_BUTTON"
  /** Type of primary button */
  | "PRIMARY_BUTTON"
  /** Type of secondary button */
  | "SECONDARY_BUTTON"
  /** Type of tertiary button */
  | "TERTIARY_BUTTON";

/** Represents the form field in the form, eg: any input elements or button */
export interface NotificationFormField {
  /** The localized label of the form field */
  label: Scalars["String"];
}

/** Represents a form group that should be displayed in the notification UI */
export type NotificationFormSection = {
  __typename?: "NotificationFormSection";
  /** The list of form fields in the form section */
  fields: Array<NotificationFormField>;
  /** The title text of form section */
  title?: Maybe<Scalars["String"]>;
};

/** Represents inbox notification attributes on notification center */
export type NotificationInbox = ContextualNotification & {
  __typename?: "NotificationInbox";
  /** Represents the background image to be used in the notification */
  backgroundImage?: Maybe<Image>;
  /** Represents the list of the notification messages to show in the body section of the notification to be displayed on the client */
  body?: Maybe<Array<NotificationPhrase>>;
  /** Represents a link that should be applied to the container of the notification */
  containerLink?: Maybe<NotificationContainerLink>;
  /** Represents the icon that will be used in the notification */
  icon?: Maybe<Icon>;
  /** Represents the notification links to be displayed on the client */
  links?: Maybe<Array<NotificationPhraseLinkNode>>;
  /** Represents a logo image */
  logo?: Maybe<Image>;
  /** Represents the id of the notification */
  notificationId?: Maybe<Scalars["String"]>;
  /** Represents the actions to apply on notification reveal */
  revealActions?: Maybe<Array<NotificationAction>>;
  /** Represents the state of notification */
  state: NotificationState;
  /** Represents the subtype of the notification */
  subType?: Maybe<NotificationSubType>;
  /** Represents the time stamp of notification */
  timeStamp?: Maybe<Scalars["String"]>;
  /** Represents heading title of the notification to be displayed on the client */
  title?: Maybe<NotificationPhrase>;
  /** Represents the type of the notification */
  type: NotificationType;
  /** Represents the user actions of the notification. For example, delete, mark as read and mark as unread */
  userActions?: Maybe<Array<NotificationUserAction>>;
};

/** Represents a link that should be displayed in a notification */
export interface NotificationLink {
  /** Represents the list of actions that should be applied when user interacts with the link */
  actions?: Maybe<Array<NotificationAction>>;
  /** Logical identifier associated with the link */
  id?: Maybe<Scalars["String"]>;
  /** Represents the target of the link */
  target?: Maybe<NotificationLinkTarget>;
  /** Represents the uri of the link */
  uri?: Maybe<Uri>;
}

/** Represents the target of the link */
export type NotificationLinkTarget = "NEW_TAB" | "SAME_TAB";

/** Represents the link type */
export type NotificationLinkType =
  | "ANCHOR"
  | "APP_DOWNLOAD_LINK"
  | "BUTTON"
  | "FLOATING_ACTION_BUTTON"
  | "PRIMARY_BUTTON"
  | "SECONDARY_BUTTON"
  | "TERTIARY_BUTTON";

export type NotificationLocation =
  | "AFTER_HEADER"
  | "AFTER_WIZARD"
  | "FOOTER"
  | "IN_PAGE"
  | "IN_PAGE_AD"
  | "LEGAL"
  | "POPUP"
  | "PRE_HEADER";

export type NotificationLocationOnPage =
  | "AFTER_HEADER"
  | "AFTER_WIZARD"
  | "ERROR"
  | "FOOTER"
  | "IN_PAGE"
  | "IN_PAGE_AD"
  | "LEGAL"
  | "POPUP"
  | "PRE_HEADER";

/** Represents the marketing analytics to track on interaction with the notification */
export type NotificationMarketing = {
  __typename?: "NotificationMarketing";
  /** Represents a value used for marketing analytics */
  marketingCode: Scalars["String"];
  /** Represents a detailed value used for marketing analytics */
  marketingCodeDetail: Scalars["String"];
};

/** Represents a message that should be displayed in the notification during form interaction */
export type NotificationMessage = {
  __typename?: "NotificationMessage";
  /** The display type of feedback message */
  displayType: NotificationMessageDisplayType;
  /** The level of feedback message */
  level: NotificationMessageLevel;
  /** The name of feedback message */
  name: Scalars["String"];
  /** The localized feedback message */
  text: Scalars["String"];
  /** The title text of feedback message */
  title: Scalars["String"];
};

/** Represents title and body of Notification with optional UiGraphic and links */
export type NotificationMessageCard = {
  __typename?: "NotificationMessageCard";
  /** Represents the body of the body element */
  body: Array<NotificationPhrase>;
  /** Represents a graphic element of the body element. Can be an icon, mark or illustration */
  graphicElement?: Maybe<UiGraphic>;
  /** Defines the layout that should be used for the message card */
  layout: NotificationMessageCardLayout;
  /** Represents the links of the body element */
  links?: Maybe<Array<NotificationPhraseLinkNode>>;
  /** Represents the title of the body element */
  title: NotificationPhrase;
};

/** Enumeration of possible layout types */
export type NotificationMessageCardLayout = "ICON_ON_SIDE" | "ICON_ON_TOP";

/** The display type of the Customer notification message */
export type NotificationMessageDisplayType =
  /** Display the message for the form */
  | "FORM"
  /** Dislay message on the page level, eg: fly-in message on the page */
  | "PAGE";

/** The level type of the Customer notification message */
export type NotificationMessageLevel =
  /** Type of error for the message */
  | "ERROR"
  /** Type of info for the message */
  | "INFO"
  /** Type of success for the message */
  | "SUCCESS"
  /** Type of warning for the message */
  | "WARNING";

export type NotificationMessageType =
  /** INVALID_INPUT message */
  | "INVALID_INPUT"
  /** SERVICE_ERROR message */
  | "SERVICE_ERROR"
  /** SUCCESS message */
  | "SUCCESS";

/** Represents title and body of Notification message along with various text formatting styles applied with each word */
export type NotificationMultiBody = {
  __typename?: "NotificationMultiBody";
  /** Represents list of notification body elements */
  body: Array<NotificationPhrase>;
  /** Represents notification title element */
  title: NotificationPhrase;
};

/** Optional information to get a better contextual customer notification */
export interface NotificationOptionalContextInput {
  /** the optional field containing an error token, triggering the retrieval of an error message */
  errorToken?: InputMaybe<Scalars["String"]>;
  /** itinerary number */
  itineraryNumber?: InputMaybe<Scalars["String"]>;
  /** list of journey criteria items */
  journeyCriterias?: InputMaybe<Array<NotificationOptionalContextJourneyCriteriaInput>>;
  /** the optional URL input field to retrieve extra url information, such as deep linking url for the mobile app download notification */
  referer?: InputMaybe<Scalars["URL"]>;
  /** the optional field containing the token to retrieve the travel information */
  travelApiId?: InputMaybe<Scalars["String"]>;
  /** trip folder id */
  tripFolderId?: InputMaybe<Scalars["String"]>;
  /** trip item id */
  tripItemId?: InputMaybe<Scalars["String"]>;
}

/** Journey criteria such as location gaia id and travel date ranges */
export interface NotificationOptionalContextJourneyCriteriaInput {
  /** start date and end date of the trip */
  dateRange?: InputMaybe<DateRangeInput>;
  /** destination information */
  destination?: InputMaybe<NotificationOptionalContextJourneyCriteriaLocationInput>;
  /** origin information */
  origin?: InputMaybe<NotificationOptionalContextJourneyCriteriaLocationInput>;
  /** trip schedule changes status */
  scheduleChangeStatus?: InputMaybe<TripScheduleChangeStatus>;
  /** trip type */
  tripType?: InputMaybe<FlightsTripType>;
}

/** Journey criteria such as location gaia id and travel date ranges */
export interface NotificationOptionalContextJourneyCriteriaLocationInput {
  /** airport code */
  airportTLA?: InputMaybe<Scalars["String"]>;
  /** property id */
  propertyId?: InputMaybe<Scalars["String"]>;
  /** regionId number */
  regionId?: InputMaybe<Scalars["String"]>;
}

/** Represents a sentence consisting of words with various text formatting styles */
export type NotificationPhrase = NotificationAccessibilityField & {
  __typename?: "NotificationPhrase";
  /** Label where a11y behavior is needed on the text phrase */
  accessibilityLabel?: Maybe<Scalars["String"]>;
  /** Plain text representation of the sentence as an un-attributed string */
  completeText: Scalars["String"];
  /** Ordered list of words for EGDSText component with their corresponding attributes. */
  egdsItems: Array<NotificationEgdsItems>;
  /** Ordered list of words with their corresponding text styles */
  items: Array<NotificationPhrasePart>;
};

/** A link with formatted display text */
export type NotificationPhraseLinkNode = NotificationLink &
  NotificationPhrasePart & {
    __typename?: "NotificationPhraseLinkNode";
    /** Represents the actions to be applied on interaction with the link */
    actions?: Maybe<Array<NotificationAction>>;
    /** Represents the icon of the link */
    icon?: Maybe<Icon>;
    /** Logical identifier associated with the link */
    id?: Maybe<Scalars["String"]>;
    /** Represents the style of the link */
    linkStyle?: Maybe<NotificationPhraseLinkStyle>;
    /** The style to apply to the text */
    styles: Array<NotificationPhrasePartStyle>;
    /** Represents the target of the link */
    target?: Maybe<NotificationLinkTarget>;
    /** The display text for the link */
    text: Scalars["String"];
    /** Represents the link type */
    type: NotificationLinkType;
    /** The underlying hyperlink uri */
    uri?: Maybe<Uri>;
  };

/** The style to apply to phrase links */
export type NotificationPhraseLinkStyle =
  | "FLOATING_ACTION_BUTTON"
  | "PRIMARY_BUTTON"
  | "SECONDARY_BUTTON"
  | "TERTIARY_BUTTON";

/** Type encapsulating a string and the style to apply to it */
export interface NotificationPhrasePart {
  /** The styles to be applied */
  styles: Array<NotificationPhrasePartStyle>;
  /** String to be stylized */
  text: Scalars["String"];
}

/** The text style to apply to strings */
export type NotificationPhrasePartStyle =
  /** Italic styling */
  | "EMPHASIS"
  /** Bold styling */
  | "IMPORTANT"
  /** Represents no style or regular text */
  | "STANDARD";

/** Type to encapsulate attributed/styled Text */
export type NotificationPhraseTextNode = NotificationPhrasePart & {
  __typename?: "NotificationPhraseTextNode";
  /** The style(s) to apply */
  styles: Array<NotificationPhrasePartStyle>;
  /** The text string to style */
  text: Scalars["String"];
};

/** Represents a custom qr code class */
export type NotificationQrCode = {
  __typename?: "NotificationQRCode";
  /** Image class reference */
  image: Image;
  /** Localized title for the qr code */
  title: Scalars["String"];
};

export type NotificationQuery = {
  __typename?: "NotificationQuery";
  /** Find inbox notifications for a specific user */
  inboxNotification: Array<InboxNotification>;
  /** Retrieve the customer's notifications */
  inlineNotification: InlineNotification;
  /** Find notification center object for a specific user */
  notificationCenter: NotificationCenterItem;
  /** Find notification unseen count from cache object for a specific user */
  notificationCenterUnseen: NotificationCenterCacheItem;
};

export type NotificationQueryInlineNotificationArgs = {
  lineOfBusiness: LineOfBusinessDomain;
  notificationLocation: NotificationLocationOnPage;
  optionalContext?: InputMaybe<NotificationOptionalContextInput>;
  optionalPageId?: InputMaybe<Scalars["String"]>;
  pageLocation: PageLocation;
};

export type NotificationQueryNotificationCenterArgs = {
  useCache?: InputMaybe<Scalars["Boolean"]>;
};

/** Represents a schema with attributes */
export type NotificationSchema = {
  __typename?: "NotificationSchema";
  /** Represents schema attributes for a notification */
  messageContent: Array<NotificationAnalyticsSchemaAttribute>;
  /** Represents a name of schema */
  name: Scalars["String"];
};

/** Represents a selection field that should be displayed in the notification UI */
export type NotificationSelectionField = NotificationFormField & {
  __typename?: "NotificationSelectionField";
  /** The id of the selection field */
  id: Scalars["String"];
  /** The localized label of the selection field */
  label: Scalars["String"];
  /** The list options of the selection field */
  options?: Maybe<Array<NotificationSelectionOption>>;
};

/** Represents a selection option field that should be displayed in the notification UI */
export type NotificationSelectionOption = {
  __typename?: "NotificationSelectionOption";
  /** The icon of the selection option */
  icon?: Maybe<Icon>;
  /** The unique id of the selection option */
  id: Scalars["String"];
  /** identifier for default selected option */
  selected: Scalars["Boolean"];
  /** The short label of the selection option */
  shortLabel?: Maybe<Scalars["String"]>;
  /** The text of the selection option */
  text: Scalars["String"];
  /** The value of the selection option */
  value: Scalars["String"];
};

/** Represents simple sentence of Notification message along with various text formatting styles applied with each word */
export type NotificationSimpleBody = {
  __typename?: "NotificationSimpleBody";
  /** Represents notification title element */
  title: NotificationPhrase;
};

/** Represents the attributes on a notification that could be changed after an interaction */
export type NotificationSpecifications = {
  __typename?: "NotificationSpecifications";
  /** Set to true when notification is dismissed */
  dismiss?: Maybe<Scalars["Boolean"]>;
  /** Notification id */
  id?: Maybe<Scalars["String"]>;
  /** Set to true when notification is read */
  read?: Maybe<Scalars["Boolean"]>;
  /** Set to true when notification is seen */
  seen?: Maybe<Scalars["Boolean"]>;
};

/** Represents the attributes on a notification that could be changed after an interaction */
export interface NotificationSpecificationsInput {
  /** Set to true when notification is dismissed */
  dismiss?: InputMaybe<Scalars["Boolean"]>;
  /** Notification id */
  id?: InputMaybe<Scalars["String"]>;
  /** Set to true when notification is read */
  read?: InputMaybe<Scalars["Boolean"]>;
  /** Set to true when notification is seen */
  seen?: InputMaybe<Scalars["Boolean"]>;
}

export type NotificationState = "READ" | "SEEN" | "UNKNOWN" | "UNSEEN";

export type NotificationSubType = "COUPON_CAMPAIGN" | "DEFAULT";

/** Represents a selection field that should be displayed in the notification UI */
export type NotificationSubmitButton = NotificationFormField & {
  __typename?: "NotificationSubmitButton";
  /** Represents the actions to be applied on interaction with the link */
  actions?: Maybe<Array<NotificationAction>>;
  /** The UI button type of submit button */
  buttonType?: Maybe<NotificationFormButtonType>;
  /** The icon of the submit button */
  icon?: Maybe<Icon>;
  /** The id of the submit button */
  id: Scalars["String"];
  /** The localized label of the submit button */
  label: Scalars["String"];
};

/** Represents a text input field that should be displayed in the notification UI */
export type NotificationTextInputField = NotificationFormField & {
  __typename?: "NotificationTextInputField";
  /** The icon of the form field */
  icon?: Maybe<Icon>;
  /** The id of the text input field */
  id: Scalars["String"];
  /** The localized label of the text input field */
  label: Scalars["String"];
  /** The placeholder text of the text input field */
  placeholder: Scalars["String"];
};

export type NotificationTextToDownloadAppResponse = {
  __typename?: "NotificationTextToDownloadAppResponse";
  /** Represents a list of ids for the invalid input fields to be highlighted on the client */
  invalidFields?: Maybe<Array<Scalars["String"]>>;
  /** Represents the message body to be displayed on the client */
  messageBody?: Maybe<Scalars["String"]>;
  /** Represents the type of message of the response */
  messageType: NotificationMessageType;
};

export type NotificationType =
  | "ALERT"
  | "APP_DOWNLOAD"
  | "APP_HERO"
  | "BOTTOM_SHEET"
  | "CENTERED_SHEET"
  | "CITI_COBRAND"
  | "CITI_COBRAND_VERTICAL"
  | "CLEANLINESS"
  | "ERROR"
  | "GENERIC"
  | "HEADER"
  | "INBOX"
  | "MAD_MARQUEE"
  | "NONE"
  | "ONETRUST"
  | "OSANO"
  | "RAF_BANNER"
  | "TAKEOVER"
  | "TRAVEL_ADVISORY"
  | "TRUST_MSG_BANNER"
  | "UNRECOVERABLE_ERROR";

/** Avaiable user actions for an inbox notification */
export type NotificationUserAction = {
  __typename?: "NotificationUserAction";
  actions?: Maybe<Array<NotificationAction>>;
  icon?: Maybe<Icon>;
  text: Scalars["String"];
  type: NotificationUserActionType;
};

export type NotificationUserActionType = "DELETE" | "MARK_AS_READ" | "MARK_AS_UNREAD" | "UNKNOWN";

/** Represents the the user input for customer notification mutation */
export interface NotificationUserInput {
  /** Represents list of customer notification user input */
  inputs: Array<NotificationUserInputElementInput>;
}

/** Represents customer notification user input */
export interface NotificationUserInputElementInput {
  /** Represents the type of customer notification user input */
  type: Scalars["String"];
  /** Represents the value of customer notification user input */
  value: Scalars["String"];
}

export type NotificationsType = "ALL";

export type NumberRating = {
  __typename?: "NumberRating";
  default?: Maybe<Scalars["Int"]>;
  maxValue?: Maybe<Scalars["Int"]>;
  minValue?: Maybe<Scalars["Int"]>;
  numberValue?: Maybe<Scalars["Int"]>;
  values?: Maybe<Array<RatingValueDetails>>;
};

/** Type used during a product search to specify a given numeric value like the number of stars for a hotel. */
export type NumberValue = {
  __typename?: "NumberValue";
  id: Scalars["String"];
  value: Scalars["Int"];
};

/** Type used during a product search to specify a given numeric value like the number of stars for a hotel. */
export interface NumberValueInput {
  id: Scalars["String"];
  value: Scalars["Int"];
}

export type Offer = {
  __typename?: "Offer";
  action?: Maybe<LodgingShoppingAction>;
  availability?: Maybe<PropertyAvailability>;
  /** @deprecated deprecated in favor of offerBookButton */
  bookButton?: Maybe<LodgingForm>;
  cancellationPolicy?: Maybe<PropertyCancellationPolicy>;
  /** key/value pair data attribute for bots locating the book button */
  dataAttributes?: Maybe<GraphQlPair>;
  deposit?: Maybe<Money>;
  depositPolicies: Array<Scalars["String"]>;
  description?: Maybe<Scalars["String"]>;
  dynamicRateRule?: Maybe<DynamicRateRule>;
  etpModalPolicies?: Maybe<Array<Scalars["String"]>>;
  feeMessages?: Maybe<Array<LodgingEnrichedMessage>>;
  /** @deprecated FeeMessages will contain the messaging previously found here */
  fees: Array<Fees>;
  hotelCollect?: Maybe<Scalars["Boolean"]>;
  /** @deprecated deprecated - adding tempararily for pwa support, logic will be moved serverside */
  installmentPayable: Scalars["Boolean"];
  /** @deprecated deprecated in favour of priceBreakDownSummary, replace with priceBreakDownSummary */
  lodgingPriceBreakDown?: Maybe<LodgingPriceBreakDown>;
  loyaltyMessage?: Maybe<LodgingEnrichedMessage>;
  mandatoryFees?: Maybe<MandatoryFees>;
  /** @deprecated Look for minRoomsLeft in availability.minRoomsLeft */
  minRoomsLeft?: Maybe<Scalars["Int"]>;
  nightlyRates: Array<NightlyRate>;
  noCreditCard: Scalars["Boolean"];
  offerBookButton?: Maybe<LodgingForm>;
  /** Title for enumeration of the offer (e.g. Option 1, Option 2, etc.)  */
  optionTitle?: Maybe<LodgingHeader>;
  paymentChoice?: Maybe<Scalars["Boolean"]>;
  paymentModel?: Maybe<PropertyPaymentModel>;
  pointsApplied?: Maybe<Scalars["String"]>;
  price?: Maybe<PropertyPrice>;
  priceAfterLoyaltyPointsApplied?: Maybe<PropertyPrice>;
  priceBreakDownSummary?: Maybe<PriceSummary>;
  priceLabel?: Maybe<Scalars["String"]>;
  pricePresentation?: Maybe<PricePresentation>;
  pricePresentationDialog?: Maybe<PricePresentationDialog>;
  pricingScheme?: Maybe<PricingScheme>;
  /** @deprecated deprecated in favor of propertyNaturalKeys to support MRP offer, replace with propertyNaturalKeys */
  propertyNaturalKey?: Maybe<PropertyNaturalKey>;
  propertyNaturalKeys: Array<PropertyNaturalKey>;
  providerId?: Maybe<Scalars["Int"]>;
  ratePlanId?: Maybe<Scalars["String"]>;
  roomTypeId?: Maybe<Scalars["String"]>;
  saleCurrency?: Maybe<Scalars["String"]>;
  showNightlyRateMessage?: Maybe<Scalars["Boolean"]>;
  showTaxesAndFeesIncludedMessage?: Maybe<Scalars["Boolean"]>;
  showTotalPrice?: Maybe<Scalars["Boolean"]>;
  sourceType?: Maybe<SourceType>;
  supplyCurrency?: Maybe<Scalars["String"]>;
  totalPriceMessage?: Maybe<Scalars["String"]>;
  variableMargin?: Maybe<Scalars["Int"]>;
};

export type OfferActionLink = {
  __typename?: "OfferActionLink";
  href: Scalars["String"];
  referrerId?: Maybe<Scalars["String"]>;
  text: Scalars["String"];
};

/** A list of attributes about the property that are present when applicable */
export type OfferAttribute = {
  __typename?: "OfferAttribute";
  icon?: Maybe<Icon>;
  type?: Maybe<OfferAttributeType>;
};

export type OfferAttributeType = "FREE_BREAKFAST" | "FREE_CANCELLATION" | "NO_CC_REQUIRED" | "PAYMENT_CHOICE" | "VIP";

/** Badge information for the property */
export type OfferBadge = {
  __typename?: "OfferBadge";
  primary?: Maybe<Badge>;
  secondary?: Maybe<Badge>;
  tertiary?: Maybe<Badge>;
};

/** UI Element to build a particular section of product details. All the different section of product details must Implement this. */
export interface OfferCardElement {
  /** Element unique identifier. Uses include handling diffs for UI updates and identifying the source of data for user input fields */
  elementID: Scalars["String"];
}

/** UI Element to build a particular section of product details. All the different section of product details must Implement this. */
export interface OfferCardUnit {
  /** Element unique identifier. Uses include handling diffs for UI updates and identifying the source of data for user input fields */
  elementID: Scalars["String"];
}

export type OfferData = {
  __typename?: "OfferData";
  /** Offer link and text */
  actionLink: OfferActionLink;
  /** Offer price and qualifier text */
  price: OfferPrice;
  /** Strikethrough price */
  strikeThroughPrice?: Maybe<OfferPrice>;
};

/** Property offer details, formerly known as rooms and rates */
export type OfferDetails = {
  __typename?: "OfferDetails";
  /** Message for alternate dates */
  alternateAvailabilityMsg?: Maybe<LodgingComplexLinkMessage>;
  /** Displays a card featuring 1 to 6 links to different available dates for the selected property. */
  alternateDates?: Maybe<AlternateDatesCard>;
  /** Union of categorized units and messages */
  categorizedListings?: Maybe<Array<LodgingOfferListing>>;
  /** This field will only be populated if there was an error that needs to be displayed to the client. */
  errorMessage?: Maybe<MessageResult>;
  /**
   * Experimental features.
   * @deprecated Deprecated. Contents are volatile and subject to change at any moment. Use at your own risk!
   */
  experimental?: Maybe<PropertyOffersExperimentalSection>;
  /**
   * Pills indicating user-selected filters that apply to offers.
   * @deprecated Use offerFilters
   */
  filterPills?: Maybe<Array<LodgingPill>>;
  /** The property id for querying Apollo cache */
  id: Scalars["String"];
  /** Includes the perks that are common across all units that the property has to offer */
  includedPerks?: Maybe<PropertyInfoContent>;
  /** @deprecated For COVID-19 Usage only */
  legalBanner?: Maybe<MessageResult>;
  /** Legal information of property, banners, reviews and ratings */
  legalDisclaimer?: Maybe<DisclaimerContentMarkup>;
  /** Union of lodging units and messages */
  listings?: Maybe<Array<PropertyInfoOffersListing>>;
  listingsHeader: LodgingHeader;
  /** Property offer details loading message */
  loading?: Maybe<OfferDetailsLoading>;
  /** @deprecated Intended for abacus TnL 35916 */
  loyaltyDiscount?: Maybe<PropertyLoyaltyDiscount>;
  marketingChannelId?: Maybe<Scalars["Int"]>;
  /** Pills indicating available filter options for the offers */
  offerFilters?: Maybe<LodgingOfferFilters>;
  /** Offer-level messaging */
  offerLevelMessages?: Maybe<Array<MessageResult>>;
  /** Link back to Partner Search Results */
  partnerPropertySearchLink?: Maybe<LodgingLinkMessage>;
  /** @deprecated Moved under ratePlans to include marketing section details, replace with units.ratePlans */
  paymentPolicy: Array<PropertyPaymentPolicyInfo>;
  /** Describes the list with Pricing FAQs of specific properties */
  pricingFrequentlyAskedQuestions?: Maybe<Array<PropertyFaq>>;
  /** Displays a highlight feature for the property, Ex: VIP benefits module */
  propertyHighlightSection?: Maybe<PropertyHighlightSection>;
  /** Property-level messaging */
  propertyLevelOffersMessage?: Maybe<MessageResult>;
  /** Link back to Search Results */
  propertySearchLink?: Maybe<LodgingLinkMessage>;
  /** Playback of search criteria, potentially with updated values. */
  searchCriteria?: Maybe<PropertySearchCriteria>;
  /** Serp metadata messages */
  serpMetadata?: Maybe<SerpMetadata>;
  /** Shopping context for multi item shopping */
  shoppingContext?: Maybe<ShoppingContext>;
  /** Offer Details for singleUnit VR mainly for the price box data */
  singleUnitOffer?: Maybe<SingleUnitOfferDetails>;
  /** Dialog box for  singleUnitOffer - price box data */
  singleUnitOfferDialog?: Maybe<SingleUnitOfferDialog>;
  /** All offers are sold out */
  soldOut: Scalars["Boolean"];
  /** SpaceDetails for singleUnit VR to show bedroom,bathroom details */
  spaceDetails?: Maybe<SpaceDetails>;
  stickyBar?: Maybe<PropertyDetailsStickyBar>;
  /** A toast message to display when offers are loaded */
  toastMessage?: Maybe<LodgingToastMessage>;
  /** Trip Summary card content */
  tripSummary?: Maybe<TripSummaryContent>;
  units: Array<PropertyUnit>;
  /**
   * Carousel giving an overview of rooms above the rooms and rates section
   * Figma: https://www.figma.com/file/PzfKJZsskFPDV9YZ1q4qOj/Smart-Shopping-(ABS)---Core?node-id=597%3A42741
   */
  unitsCarousel?: Maybe<LodgingCarouselContainer>;
};

export type OfferDetailsLoading = AccessibilityField & {
  __typename?: "OfferDetailsLoading";
  /** Loading message read by screen readers but not visible on the page */
  accessibilityLabel?: Maybe<Scalars["String"]>;
  /** @deprecated Use accessibilityLabel, replace with accessibilityLabel */
  label?: Maybe<Scalars["String"]>;
};

export type OfferIdentity = {
  __typename?: "OfferIdentity";
  /** Type of the offer details whether token or id */
  type: OfferIdentityType;
  /** The value of the identifier */
  value: Scalars["String"];
};

export interface OfferIdentityInput {
  /** Type of the offer details whether token or id */
  type: OfferIdentityType;
  /** The value of the identifier */
  value: Scalars["String"];
}

/** The identity to get or update insurtech offers could be both */
export type OfferIdentityType = "EG_OFFER_ID" | "EG_OFFER_TOKEN";

export interface OfferItem {
  /** Badge to be displayed for the offer */
  badge?: Maybe<CampaignOfferBadge>;
  /** Description of the offer */
  description?: Maybe<Scalars["String"]>;
  /** Image to be displayed for the offer */
  image: Image;
  /** Name of the destination where the offer is applicable */
  name: Scalars["String"];
  /** Secondary content related to the offer */
  secondaryContent?: Maybe<Scalars["String"]>;
}

export type OfferPrice = {
  __typename?: "OfferPrice";
  /** Message showing the total price for the offer length of stay */
  additionalPriceInformation?: Maybe<Scalars["String"]>;
  /** Price ally alt text */
  allyText?: Maybe<Scalars["String"]>;
  /** Check prices alt text when offer is unpriced */
  checkPriceAltText?: Maybe<Scalars["String"]>;
  /** Check prices text when offer is unpriced */
  checkPriceText?: Maybe<Scalars["String"]>;
  /** Disclaimer a11y text */
  disclaimerA11yText?: Maybe<Scalars["String"]>;
  /** Disclaimer close dialog button text */
  disclaimerCloseDialogText?: Maybe<Scalars["String"]>;
  /** Disclaimer text associated with the price */
  disclaimerText: Scalars["String"];
  /** Includes taxes and fees text */
  includesTaxesAndFeesText?: Maybe<Scalars["String"]>;
  /** Prefix text associated with the price */
  prefixText?: Maybe<Scalars["String"]>;
  /** Price qualifier text */
  qualifierText: Scalars["String"];
  /** Price value */
  value: Scalars["String"];
};

export type OfferSummary = {
  __typename?: "OfferSummary";
  attributes?: Maybe<Array<OfferAttribute>>;
  /** @deprecated Use messages: List< OfferSummaryMessage> to get multiple messages. */
  message?: Maybe<Scalars["String"]>;
  messages?: Maybe<Array<OfferSummaryMessage>>;
  /** @deprecated Use messages: List< OfferSummaryMessage> to get multiple themes. */
  theme?: Maybe<Theme>;
};

/** Section that contains all the attributes related to product */
export type OfferSummaryDisclaimer = OfferCardElement & {
  __typename?: "OfferSummaryDisclaimer";
  closeAccessibilityDescription?: Maybe<Scalars["String"]>;
  closeButtonText?: Maybe<Scalars["String"]>;
  /** List that contains attribute Icon along with its title and description */
  content: Array<Scalars["String"]>;
  elementID: Scalars["String"];
  openAccessibilityDescription?: Maybe<Scalars["String"]>;
};

export type OfferSummaryMessage = {
  __typename?: "OfferSummaryMessage";
  mark?: Maybe<Mark>;
  message?: Maybe<Scalars["String"]>;
  moreInfoDialog?: Maybe<LodgingPlainDialog>;
  theme?: Maybe<Theme>;
  type?: Maybe<Scalars["String"]>;
};

/** Section that contains all the attributes related to product */
export type OfferSummaryPriceItem = OfferCardElement & {
  __typename?: "OfferSummaryPriceItem";
  elementID: Scalars["String"];
  /** List that contains attribute Icon along with its title and description */
  text: EgdsStylizedText;
};

/** Section that contains all the attributes related to product */
export type OfferSummaryPriceStrikethrough = OfferCardUnit & {
  __typename?: "OfferSummaryPriceStrikethrough";
  /** List that contains attribute Icon along with its title and description */
  disclaimer: OfferSummaryDisclaimer;
  elementID: Scalars["String"];
  /** List that contains attribute Icon along with its title and description */
  price: Scalars["String"];
};

export interface OfferTokenInput {
  productLine: ProductLine;
  token: Scalars["String"];
}

/** Section that contains all the information required to build tooltip */
export type OffersCard = {
  __typename?: "OffersCard";
  /** Contains the title of the policy along with information about its theme */
  sections: Array<OfferCardElement>;
};

/** Section that contains all the attributes related to product */
export type OffersCardMediaSection = OfferCardElement & {
  __typename?: "OffersCardMediaSection";
  /** List that contains attribute Icon along with its title and description */
  badge?: Maybe<EgdsStandardBadge>;
  elementID: Scalars["String"];
  /** List that contains attribute Icon along with its title and description */
  image: Image;
  /** List that contains attribute Icon along with its title and description */
  imagesList?: Maybe<EgdsGalleryCarousel>;
};

/** Section that contains all the attributes related to product */
export type OffersCardPricingSection = OfferCardElement & {
  __typename?: "OffersCardPricingSection";
  /** List that contains attribute Icon along with its title and description */
  badge: EgdsStandardBadge;
  elementID: Scalars["String"];
  /** List that contains attribute Icon along with its title and description */
  items: Array<OfferSummaryPriceItem>;
  /** List that contains attribute Icon along with its title and description */
  price: Scalars["String"];
  /** List that contains attribute Icon along with its title and description */
  strikethroughPrice: OfferSummaryPriceStrikethrough;
};

/** Section that contains all the attributes related to product */
export type OffersCardProductHeader = OfferCardUnit & {
  __typename?: "OffersCardProductHeader";
  /** List that contains attribute Icon along with its title and description */
  badge?: Maybe<EgdsStandardBadge>;
  /** Product description */
  description: EgdsStylizedText;
  elementID: Scalars["String"];
  /** List that contains attribute Icon along with its title and description */
  location?: Maybe<EgdsStylizedText>;
  /** Product title */
  title: EgdsHeading;
};

/** Section that contains all the product related information */
export type OffersCardProductSection = OfferCardElement & {
  __typename?: "OffersCardProductSection";
  elementID: Scalars["String"];
  /** Offer Card primary Units */
  primary: Array<OfferCardUnit>;
  /** Offer Card secondary Units */
  secondary?: Maybe<Array<OfferCardUnit>>;
};

/** Section that contains all the information required to build tooltip */
export type OffersListingView = {
  __typename?: "OffersListingView";
  /** Contains the title of the policy along with information about its theme */
  elements: Array<OffersCard>;
};

export type OffersRecommendationCard = {
  __typename?: "OffersRecommendationCard";
  cardAction: UiLinkAction;
  details: Array<OffersRecommendationCardDetail>;
  heading: OffersRecommendationHeading;
  impression: ClientSideAnalytics;
  media: OffersRecommendationCardMedia;
  price: PropertyPrice;
  /** @deprecated Use impression or cardAction.analytics */
  uisPrimeRecommendationAnalytics: UisPrimeRecommendationsItem;
};

export type OffersRecommendationCardDetail = {
  __typename?: "OffersRecommendationCardDetail";
  content: OffersRecommendationCardDetailContent;
  heading?: Maybe<Scalars["String"]>;
};

/** Offer recommendation content details */
export type OffersRecommendationCardDetailContent = EgdsParagraph | EgdsTextIconList | ProductRatingSummary;

/** Type of the media card */
export type OffersRecommendationCardMedia = Image;

/** Type of the recommendation container */
export type OffersRecommendationContainer = EgdsCarousel;

export type OffersRecommendationContainerType = "CAROUSEL" | "GRID";

/** Offer Recommendation Group */
export type OffersRecommendationGroup = {
  __typename?: "OffersRecommendationGroup";
  cards: Array<OffersRecommendationCard>;
  container?: Maybe<OffersRecommendationContainer>;
  heading?: Maybe<OffersRecommendationHeading>;
  impression?: Maybe<ClientSideAnalytics>;
  moreOffers?: Maybe<EgdsStandardLink>;
  /** @deprecated We need a separate event for each card, see OffersRecommendationCard.impression and OffersRecommendationCard.cardAction.analytics */
  uisPrimeRecommendationAnalytics: UisPrimeRecommendationsEvent;
};

export type OffersRecommendationHeading = {
  __typename?: "OffersRecommendationHeading";
  subTitle?: Maybe<Scalars["String"]>;
  title: Scalars["String"];
};

export type OffersRecommendationStrategy = "ALTERNATE" | "ATTACH" | "CO_CLICK" | "NEARBY" | "POPULAR" | "TRENDING";

/** Object holding offerService URL */
export type OffersUrl = {
  __typename?: "OffersUrl";
  /** URL type to show offers: DESTINATIONS OR OFFERS */
  type: RecommendedType;
  /** OffersService URL */
  url: Scalars["URL"];
};

export interface OnboardingContext {
  onboardingSource: Scalars["String"];
}

export type OneKeyBurnSwitch = {
  __typename?: "OneKeyBurnSwitch";
  /** Represents a badge shown with OneKeyBurnSwitch */
  graphic: UiGraphic;
  /** Represents a switch toggle used to toggle loyalty points. */
  switch: EgdsStandardSwitch;
};

export type OneKeyLoyaltyBanner = {
  __typename?: "OneKeyLoyaltyBanner";
  element: OneKeyLoyaltyBannerTypes;
};

/** The different forms of OneKeyLoyaltyCard */
export type OneKeyLoyaltyBannerTypes = EgdsStandardMessagingCard | OneKeyBurnSwitch | OneKeyStatusCard;

export type OneKeyStatusCard = {
  __typename?: "OneKeyStatusCard";
  /** represents action when OneKeyStatus card is clicked */
  action?: Maybe<UiLinkAction>;
  /** Represents the OneKeyStatus card content */
  content: EgdsStandardMessagingCard;
};

/**
 * Action for opening the duration span element.
 * figma: https://www.figma.com/file/eiXu9ARV67TsK58GPfKdku/Cruise-search-(CSR)?node-id=2905%3A161931
 */
export type OpenDurationSpanAction = {
  __typename?: "OpenDurationSpanAction";
  /** Message for accessibility purposes on duration span action completion. */
  accessibility?: Maybe<Scalars["String"]>;
  /** Captures client side analytics events for the duration span element. */
  analytics: ClientSideAnalytics;
  /** Configuration for the duration span element. */
  durationSpan: DurationSpan;
};

/** OpenGraph wrapper, check https://ogp.me/ for more information. */
export type OpenGraph = {
  __typename?: "OpenGraph";
  content: Scalars["String"];
  property: Scalars["String"];
};

/**
 * Open a typeahead dialog
 * https://www.figma.com/file/oCe7wGPkh8SU8As0KJ3u2C/Typeahead
 */
export type OpenTypeaheadAction = UiAction & {
  __typename?: "OpenTypeaheadAction";
  accessibility?: Maybe<Scalars["String"]>;
  /**
   * Enables exact search term matching
   * @deprecated Use info.allowExactMatch
   */
  allowExactMatch: Scalars["Boolean"];
  analytics: ClientSideAnalytics;
  /**
   * Flag used to categorize the typeahead results
   * @deprecated Use info.categorize
   */
  categorize: Scalars["Boolean"];
  /**
   * Text for clear all items button text
   * @deprecated Use info.typeaheadMultiSelect.clearAllText
   */
  clearAllText?: Maybe<Scalars["String"]>;
  /**
   * Text for dismiss button text
   * @deprecated Use info.dismissButtonText
   */
  dismissButtonText?: Maybe<Scalars["String"]>;
  /**
   * Placeholder for using when no results have been gather, commonly displayed when user hasn't performed a search before
   * @deprecated Use info.emptyResultsPlaceholder
   */
  emptyResultsPlaceholder?: Maybe<Scalars["String"]>;
  info: TypeaheadInfo;
  /**
   * When this flag is set, the heading for the categorized results is shown
   * @deprecated Use info.listTitle
   */
  listTitle: Scalars["Boolean"];
  /**
   * Text to display selected item heading
   * @deprecated Use info.typeaheadMultiSelect.selectedItemHeading
   */
  selectedItemHeading?: Maybe<Scalars["String"]>;
  /**
   * Flag to show pills for the selected results
   * @deprecated Use info.typeaheadMultiSelect.showPills
   */
  showPills: Scalars["Boolean"];
};

export type Operation = "ADDITION" | "MULTIPLICATION";

export type OperationStatus = "FAILURE" | "INVALID_INPUT" | "SUCCESS";

export type OpinionLabFeedback = {
  __typename?: "OpinionLabFeedback";
  opinionSurveyTitle: Scalars["String"];
  options: Array<FeedbackOption>;
  submit: CarActionableItem;
  submitConfirmation: Scalars["String"];
};

export type OptionViewModel = {
  __typename?: "OptionViewModel";
  ariaLabel?: Maybe<Scalars["String"]>;
  /** Analytics data for tracking when user select/deselect option fields */
  clickAnalytics?: Maybe<ClientSideAnalytics>;
  clickstreamEvents?: Maybe<LodgingFilterClickstreamEvents>;
  count?: Maybe<Scalars["Int"]>;
  description?: Maybe<Scalars["String"]>;
  /** @deprecated Don't get/set value from this field, replace with optionValue */
  enumValue?: Maybe<Scalars["String"]>;
  filterCategory?: Maybe<Scalars["String"]>;
  filterType?: Maybe<Scalars["String"]>;
  /** Icon or Mark that provides a visual description of the filter. e.g. a Mark that displays a VIP token next to the VIP filter label */
  graphic?: Maybe<UiGraphic>;
  /** @deprecated we are replacing icon with UIGraphic, which is a union type of Icon, Illustration and Mark */
  icon?: Maybe<Scalars["String"]>;
  /** This option was selected in the search criteria. This allows for features like pills */
  isSelected: Scalars["Boolean"];
  label?: Maybe<Scalars["String"]>;
  optionValue?: Maybe<Scalars["String"]>;
  range?: Maybe<FilterOptionRange>;
  /** Text to show if this is a selected option. Used for features like pills. Labels like `sort` need to be combined, while `stars` can just be the option label. */
  selectedLabel?: Maybe<Scalars["String"]>;
  /** @deprecated Don't get/set value from this field, replace with optionValue */
  value?: Maybe<Scalars["String"]>;
};

/** A range of dates & times, without timezone support, from a starting date & time to an ending date & time */
export type OptionalDateTimeRange = {
  __typename?: "OptionalDateTimeRange";
  /** Optional terminal date & time in this range */
  end?: Maybe<DateTime>;
  /** Optional starting date & time in this range */
  start?: Maybe<DateTime>;
};

/** A range of dates & times, without timezone support, from a starting date & time to an ending date & time */
export interface OptionalDateTimeRangeInput {
  /** Optional terminal date & time in this range */
  end?: InputMaybe<DateTimeInput>;
  /** Optional starting date & time in this range */
  start?: InputMaybe<DateTimeInput>;
}

export interface OrderInfoInput {
  orderId: Scalars["String"];
  orderLine?: InputMaybe<Scalars["String"]>;
}

/** Possible values for UITK mark's orientation prop */
export type Orientation =
  /** Landscape orientation */
  | "LANDSCAPE"
  /** Portrait orientation */
  | "PORTRAIT";

export type OriginAirport = LocAirport & {
  __typename?: "OriginAirport";
  /** origin airport Code */
  airportCode: Scalars["String"];
  /** origin airport Name */
  airportName?: Maybe<Scalars["String"]>;
  /** list of available destination countries */
  destinationCountries: Array<DestinationCountry>;
};

export type OriginCountry = {
  __typename?: "OriginCountry";
  /** origin country Name */
  countryName?: Maybe<Scalars["String"]>;
  /** list of available origin origins */
  origins: Array<OriginAirport>;
};

export type PackageDestinationQueries = {
  __typename?: "PackageDestinationQueries";
  /** A query to get an experience to view different pre-bundled search destinations */
  morePackageDestinations: PackageUiMoreDestinationsResponse;
  /** Package destination summary query to get an overview of destination content */
  packageDestinationSummary: PackageUiDestinationSummaryResponse;
};

export type PackageDestinationQueriesMorePackageDestinationsArgs = {
  searchCriteria: PackageSearchCriteriaInput;
};

export type PackageDetailsMultiItemShoppingAction = MultiItemShoppingAction & {
  __typename?: "PackageDetailsMultiItemShoppingAction";
  shoppingContext: ShoppingContext;
};

/** Error state for when package details primers fail */
export type PackageDetailsPrimersError = {
  __typename?: "PackageDetailsPrimersError";
  content: PackageUiEmptyStateError;
};

/** Information needed to render the prebundle package product details */
export type PackageDetailsProductContentPrimer = {
  __typename?: "PackageDetailsProductContentPrimer";
  headerPrimer: PackageUiProductHeaderPrimer;
  productChangedBannerPrimer?: Maybe<PackageUiProductChangedBannerPrimer>;
  productContentPrimer: PackageUiProductContentPrimer;
};

/** Package location */
export type PackageLocation = {
  __typename?: "PackageLocation";
  airportCode: Scalars["String"];
  /** The Geo location of the region to search */
  coordinates?: Maybe<Coordinates>;
  regionId?: Maybe<Scalars["String"]>;
  /** The name of the region */
  regionName?: Maybe<Scalars["String"]>;
};

/** Package location */
export interface PackageLocationInput {
  airportCode: Scalars["String"];
  /** The Geo location of the region to search */
  coordinates?: InputMaybe<CoordinatesInput>;
  regionId?: InputMaybe<Scalars["String"]>;
  /** The name of the region */
  regionName?: InputMaybe<Scalars["String"]>;
}

/** Minimum set of data used to retrieve content about a package */
export type PackageNaturalKey = {
  __typename?: "PackageNaturalKey";
  offerToken: Scalars["String"];
};

/** Minimum set of data used to retrieve content about a package */
export interface PackageNaturalKeyInput {
  offerToken: Scalars["String"];
}

export type PackageOfferItem = OfferItem & {
  __typename?: "PackageOfferItem";
  /** Badge to be displayed for the offer */
  badge?: Maybe<CampaignOfferBadge>;
  /** Range of dates the offer is applicable */
  dates?: Maybe<Scalars["String"]>;
  /** Description of the flight offer */
  description?: Maybe<Scalars["String"]>;
  /** Flight offer item */
  flightOfferItem?: Maybe<FlightOfferItem>;
  /** Hotel offer item */
  hotelOfferItem?: Maybe<HotelOfferItem>;
  /** Image for destination of the flight offer */
  image: Image;
  /** Name of the flight where the offer is applicable */
  name: Scalars["String"];
  /** Package offer price and link */
  packageOffer?: Maybe<OfferData>;
  /** Secondary content related to the flight offer */
  secondaryContent?: Maybe<Scalars["String"]>;
};

export type PackagePrimersQueries = {
  __typename?: "PackagePrimersQueries";
  /** Primer query to power the dynamic package details view */
  dynamicPackageDetailsPrimers: DynamicPackageDetailsPrimers;
  /** Primer query to power the prebundle package details view */
  prebundlePackageDetailsPrimers: PrebundlePackageDetailsPrimers;
};

export type PackagePrimersQueriesDynamicPackageDetailsPrimersArgs = {
  multiItemPriceToken?: InputMaybe<Scalars["String"]>;
  multiItemSessionId: Scalars["String"];
  recoveryNaturalKeys?: InputMaybe<MishopRecoveryNaturalKeysInput>;
};

export type PackagePrimersQueriesPrebundlePackageDetailsPrimersArgs = {
  multiItemPriceToken?: InputMaybe<Scalars["String"]>;
  multiItemSessionId: Scalars["String"];
};

/** Represents the search criteria with which customers searched for pre-bundled packages */
export type PackageSearchCriteria = {
  __typename?: "PackageSearchCriteria";
  primary: PrimaryPackageSearchCriteria;
  secondary?: Maybe<ShoppingSearchCriteria>;
};

/** Represents the search criteria with which customers searched for packages */
export interface PackageSearchCriteriaInput {
  primary: PrimaryPackageSearchCriteriaInput;
  secondary?: InputMaybe<ShoppingSearchCriteriaInput>;
}

export type PackageSearchForm = EgdsSearchForm & {
  __typename?: "PackageSearchForm";
  actionURL: Scalars["String"];
  elements: Array<EgdsSearchFormElement>;
  errorSummary?: Maybe<EgdsErrorSummary>;
  playback?: Maybe<EgdsSearchPlayback>;
  search?: Maybe<EgdsButton>;
  searchCriteria: PackageSearchCriteria;
};

export type PackageSort = "PRICE_HIGH_TO_LOW" | "PRICE_LOW_TO_HIGH" | "RECOMMENDED";

export type PackageType = "FLIGHT_CAR" | "FLIGHT_HOTEL" | "FLIGHT_HOTEL_CAR" | "HOTEL_CAR";

/**
 * A generic button that represents one of the possible package footer buttons for an EGDSActionDialog. This one
 * button type should be used for all dialog footer buttons since "dialogAction" is where behavioral differention
 * will occur.
 */
export type PackageUiActionDialogFooterButton = EgdsButton & {
  __typename?: "PackageUIActionDialogFooterButton";
  accessibility?: Maybe<Scalars["String"]>;
  /**
   * @deprecated
   *         UIAction should not be used as a field because it allows for too many possible types.
   *         If need to specify action have the implementation of EGDSButton add a field for action with interface type of less number of possible subtypes
   *         or a union type with a manageable number of members
   *
   */
  action?: Maybe<UiAction>;
  analytics?: Maybe<ClientSideAnalytics>;
  dialogAction: PackageUiActionDialogFooterButtonAction;
  disabled: Scalars["Boolean"];
  icon?: Maybe<Icon>;
  primary?: Maybe<Scalars["String"]>;
  style: EgdsButtonStyle;
};

export type PackageUiActionDialogFooterButtonAction =
  | PackageUiActionDialogFooterButtonCloseAction
  | PackageUiActionDialogSearchLinkAction;

export type PackageUiActionDialogFooterButtonCloseAction = {
  __typename?: "PackageUIActionDialogFooterButtonCloseAction";
  analytics: ClientSideAnalytics;
};

export type PackageUiActionDialogSearchLinkAction = {
  __typename?: "PackageUIActionDialogSearchLinkAction";
  analytics: ClientSideAnalytics;
  newTabAccessibilityText?: Maybe<Scalars["String"]>;
  resource: Uri;
  target: UiLinkTarget;
};

export type PackageUiActivityHeaderPrimer = {
  __typename?: "PackageUIActivityHeaderPrimer";
  productType: MishopUiProductType;
};

export interface PackageUiActivityHeaderPrimerInput {
  productType: MishopUiProductType;
}

export type PackageUiDestination = {
  __typename?: "PackageUIDestination";
  imageAction: PackageUiDestinationAction;
  /** The name of the destination */
  name: Scalars["String"];
};

export type PackageUiDestinationAction = {
  __typename?: "PackageUIDestinationAction";
  imageLink: EgdsImageLink;
};

export type PackageUiDestinationEditorial = {
  __typename?: "PackageUIDestinationEditorial";
  /**
   * @deprecated
   *         This is a temporary component with unformatted html content that we are using for our web launch of prebundled packages.
   *
   *         A new component is being worked on that will have structured content that we will use to replace this html content when it's available for both web and app.
   *
   *         https://jira.expedia.biz/browse/POT-19295
   *
   *         https://pages.github.expedia.biz/Expedia-UI/shared-ui/components/retail/travel-content/editorial/editorial
   *
   */
  htmlContent: Scalars["String"];
  icon: Icon;
  title: Scalars["String"];
};

export type PackageUiDestinationEditorialExpando = {
  __typename?: "PackageUIDestinationEditorialExpando";
  /**
   * @deprecated
   *         This is a temporary component with unformatted html content that we are using for our web launch of prebundled packages.
   *
   *         A new component is being worked on that will have structured content that we will use to replace this html content when it's available for both web and app.
   *
   *         https://jira.expedia.biz/browse/POT-19295
   *
   *         https://pages.github.expedia.biz/Expedia-UI/shared-ui/components/retail/travel-content/editorial/editorial
   *
   */
  htmlContent: Scalars["String"];
  item: EgdsExpandoListItem;
};

/**
 * An experience that presents customers with a summary of travel destination content.
 *
 * Figma: https://www.figma.com/file/iLrELeHssY12NY6YFTi1f8/Packages-2.0---Search-%26-Discovery?node-id=3911%3A91159
 */
export type PackageUiDestinationSummary = {
  __typename?: "PackageUIDestinationSummary";
  accessibilityHeading?: Maybe<Scalars["String"]>;
  editorialExpandos: Array<PackageUiDestinationEditorialExpando>;
  editorials: Array<PackageUiDestinationEditorial>;
  header: PackageUiDestinationSummaryHeader;
  travelGuide?: Maybe<PackageUiTravelGuideButton>;
};

export type PackageUiDestinationSummaryHeader = {
  __typename?: "PackageUIDestinationSummaryHeader";
  image: Image;
  primary: Scalars["String"];
  secondaries: Array<Scalars["String"]>;
};

export type PackageUiDestinationSummaryResponse = PackageUiDestinationSummary;

/** Empty error state interface */
export interface PackageUiEmptyStateError {
  errorAction?: Maybe<PackageUiErrorAction>;
  icon: Icon;
  primary: EgdsHeading;
  secondaries: Array<EgdsText>;
}

/** Error action */
export interface PackageUiErrorAction {
  analytics: ClientSideAnalytics;
  button: EgdsButton;
}

/** Action that links off the page */
export type PackageUiExternalLinkAction = PackageUiErrorAction & {
  __typename?: "PackageUIExternalLinkAction";
  action: MultiItemShoppingAction;
  analytics: ClientSideAnalytics;
  button: EgdsButton;
  resource?: Maybe<Uri>;
};

/** Empty error state with an external link action */
export type PackageUiExternalLinkEmptyStateError = PackageUiEmptyStateError & {
  __typename?: "PackageUIExternalLinkEmptyStateError";
  errorAction?: Maybe<PackageUiExternalLinkAction>;
  icon: Icon;
  primary: EgdsHeading;
  secondaries: Array<EgdsText>;
};

export type PackageUiFlightHeaderPrimer = {
  __typename?: "PackageUIFlightHeaderPrimer";
  productType: MishopUiProductType;
};

export interface PackageUiFlightHeaderPrimerInput {
  productType: MishopUiProductType;
}

export type PackageUiGroundTransferHeaderPrimer = {
  __typename?: "PackageUIGroundTransferHeaderPrimer";
  productType: MishopUiProductType;
};

export interface PackageUiGroundTransferHeaderPrimerInput {
  productType: MishopUiProductType;
}

export type PackageUiHideSearchFormAction = EgdsButton & {
  __typename?: "PackageUIHideSearchFormAction";
  accessibility?: Maybe<Scalars["String"]>;
  /**
   * @deprecated
   *         UIAction should not be used as a field because it allows for too many possible types.
   *         If need to specify action have the implementation of EGDSButton add a field for action with interface type of less number of possible subtypes
   *         or a union type with a manageable number of members
   *
   */
  action?: Maybe<UiAction>;
  analytics?: Maybe<ClientSideAnalytics>;
  disabled: Scalars["Boolean"];
  icon?: Maybe<Icon>;
  primary?: Maybe<Scalars["String"]>;
  style: EgdsButtonStyle;
};

export type PackageUiIncludedProducts = PackageUiIncludedProductsTitles;

export type PackageUiIncludedProductsDetails = {
  __typename?: "PackageUIIncludedProductsDetails";
  includedProducts: PackageUiIncludedProducts;
  title: EgdsPlainText;
};

export type PackageUiIncludedProductsTitles = {
  __typename?: "PackageUIIncludedProductsTitles";
  titles: EgdsTextIconList;
};

/**
 * An experience that presents customers with a list of destinations to explore for additional pre-bundled packages.
 *
 * Figma: https://www.figma.com/file/iLrELeHssY12NY6YFTi1f8/Packages-2.0---Search-%26-Discovery?node-id=3981%3A91979
 */
export type PackageUiMoreDestinations = {
  __typename?: "PackageUIMoreDestinations";
  destinations: Array<PackageUiDestination>;
  title: Scalars["String"];
};

export type PackageUiMoreDestinationsResponse = PackageUiMoreDestinations;

/** Primary text and Links with suggesting Airports */
export type PackageUiNearbyAirports = {
  __typename?: "PackageUINearbyAirports";
  airports: Array<EgdsStandardLink>;
  primary: Scalars["String"];
};

export type PackageUiPolicies = PackageUiPoliciesSuccess;

/** Contains the natural keys for products that we need to retrieve policies for */
export type PackageUiPoliciesPrimer = {
  __typename?: "PackageUIPoliciesPrimer";
  products: MultiItemProducts;
};

/** Contains overall policy section title and policy content sections for the success scenario */
export type PackageUiPoliciesSuccess = {
  __typename?: "PackageUIPoliciesSuccess";
  policyContentSections: Array<PackageUiPolicyContentSection>;
  referenceId: Scalars["String"];
  title: Scalars["String"];
};

/** UI elements used to display product policy content */
export type PackageUiPoliciesText = EgdsIconText | EgdsPlainText;

/** Contains a title for the policy section as well as the error message */
export type PackageUiPolicyContentErrorSection = PackageUiPolicyContentSection & {
  __typename?: "PackageUIPolicyContentErrorSection";
  errorMessage: EgdsStylizedText;
  sectionTitle: Scalars["String"];
};

export interface PackageUiPolicyContentSection {
  sectionTitle: Scalars["String"];
}

/** Contains a title for the policy section as well as the actual policies */
export type PackageUiPolicyContentSuccessSection = PackageUiPolicyContentSection & {
  __typename?: "PackageUIPolicyContentSuccessSection";
  productPolicies: Array<PackageUiProductPolicy>;
  sectionTitle: Scalars["String"];
};

/** Overview of package policies */
export type PackageUiPolicyOverview = PackageUiPolicyContentSection & {
  __typename?: "PackageUIPolicyOverview";
  description: Scalars["String"];
  sectionTitle: Scalars["String"];
};

export type PackageUiPreBundledCard = {
  __typename?: "PackageUIPreBundledCard";
  action: PackageUiSelectPackageButton;
  analytics: ClientSideAnalytics;
  /** @deprecated Displaying only 1 image per card so deprecating this node in favor of the image node */
  gallery: MishopUiGalleryCarousel;
  image?: Maybe<Image>;
  includedProductsDetails: PackageUiIncludedProductsDetails;
  price: EgdsPriceLockup;
  theme: EgdsHeading;
  title: EgdsHeading;
};

export type PackageUiPreBundledCards = {
  __typename?: "PackageUIPreBundledCards";
  cards: Array<PackageUiPreBundledCard>;
};

/** UI elements used inside the prebundled force-choice module. */
export type PackageUiPreBundledPackageSearchEntryContent = EgdsBulletedList | EgdsParagraph;

/** Contains the data that give the previous and current packageOfferId and the list of previous offers */
export type PackageUiProductChangedBannerPrimer = {
  __typename?: "PackageUIProductChangedBannerPrimer";
  currentPackageOfferId: PackageNaturalKey;
  previousOffers: MultiItemProducts;
  previousPackageOfferId: PackageNaturalKey;
};

/** Contains the necessary data to render banner for a changed product */
export interface PackageUiProductChangedBannerPrimerInput {
  currentPackageOfferId: PackageNaturalKeyInput;
  previousOffers: MultiItemProductsInput;
  previousPackageOfferId: PackageNaturalKeyInput;
}

export type PackageUiProductContentPrimer =
  | MishopUiActivitiesCrossSellPrimer
  | MishopUiCarContentPrimer
  | MishopUiFlightContentPrimer
  | MishopUiGroundTransfersCrossSellPrimer
  | MishopUiLegalContentPrimer
  | MishopUiPropertyContentPrimer
  | MishopUiSimplePropertyContentPrimer;

/** Information needed to render the prebundle package product header */
export type PackageUiProductHeaderPrimer = {
  __typename?: "PackageUIProductHeaderPrimer";
  activityHeaderPrimer?: Maybe<PackageUiActivityHeaderPrimer>;
  flightHeaderPrimer?: Maybe<PackageUiFlightHeaderPrimer>;
  groundTransferHeaderPrimer?: Maybe<PackageUiGroundTransferHeaderPrimer>;
  propertyHeaderPrimer?: Maybe<PackageUiPropertyHeaderPrimer>;
};

/** Information needed to render the prebundle package product header */
export interface PackageUiProductHeaderPrimerInput {
  activityHeaderPrimer?: InputMaybe<PackageUiActivityHeaderPrimerInput>;
  flightHeaderPrimer?: InputMaybe<PackageUiFlightHeaderPrimerInput>;
  groundTransferHeaderPrimer?: InputMaybe<PackageUiGroundTransferHeaderPrimerInput>;
  propertyHeaderPrimer?: InputMaybe<PackageUiPropertyHeaderPrimerInput>;
}

/** Contains a title for a product within a section as well as the policy descriptions for that product */
export type PackageUiProductPolicy = {
  __typename?: "PackageUIProductPolicy";
  policyDescriptions: Array<PackageUiPoliciesText>;
  productTitle: Scalars["String"];
};

export type PackageUiPropertyHeaderPrimer = {
  __typename?: "PackageUIPropertyHeaderPrimer";
  productType: MishopUiProductType;
};

export interface PackageUiPropertyHeaderPrimerInput {
  productType: MishopUiProductType;
}

export type PackageUiSeeAllPackagesLink = PackageUiSeeAllPackagesLinkSuccess;

/** Contains the search criteria needed to build the url that takes the user back to the prebundle search page */
export type PackageUiSeeAllPackagesLinkPrimer = {
  __typename?: "PackageUISeeAllPackagesLinkPrimer";
  searchCriteria: PackageSearchCriteria;
};

/** Contains a standard link which has the icon, text and link back to the prebundle search page */
export type PackageUiSeeAllPackagesLinkSuccess = {
  __typename?: "PackageUISeeAllPackagesLinkSuccess";
  seeAllPackages: EgdsStandardLink;
};

export type PackageUiSelectPackageButton = MishopUiButton & {
  __typename?: "PackageUISelectPackageButton";
  accessibility: Scalars["String"];
  action: MultiItemShoppingAction;
  analytics: ClientSideAnalytics;
  label: Scalars["String"];
  recommendationsAnalytics: Array<RecommendationAnalytics>;
};

export type PackageUiTravelGuideAction = {
  __typename?: "PackageUITravelGuideAction";
  regionId: Scalars["String"];
  resource: Uri;
};

export type PackageUiTravelGuideButton = EgdsButton & {
  __typename?: "PackageUITravelGuideButton";
  accessibility?: Maybe<Scalars["String"]>;
  /**
   * @deprecated
   *         UIAction should not be used as a field because it allows for too many possible types.
   *         If need to specify action have the implementation of EGDSButton add a field for action with interface type of less number of possible subtypes
   *         or a union type with a manageable number of members
   *
   */
  action?: Maybe<UiAction>;
  analytics?: Maybe<ClientSideAnalytics>;
  buttonAction: PackageUiTravelGuideAction;
  disabled: Scalars["Boolean"];
  icon?: Maybe<Icon>;
  primary?: Maybe<Scalars["String"]>;
  style: EgdsButtonStyle;
};

export type PackagesSearchForm = EgdsElement &
  EgdsSearchForm & {
    __typename?: "PackagesSearchForm";
    actionURL: Scalars["String"];
    egdsElementId?: Maybe<Scalars["String"]>;
    elements: Array<EgdsSearchFormElement>;
    errorSummary?: Maybe<EgdsErrorSummary>;
    packageSelection?: Maybe<PackagesSearchFormSelection>;
    playback?: Maybe<EgdsSearchPlayback>;
    search?: Maybe<EgdsButton>;
  };

export type PackagesSearchFormSelection = {
  __typename?: "PackagesSearchFormSelection";
  car?: Maybe<EgdsBasicPill>;
  flight?: Maybe<EgdsBasicPill>;
  noSelectionMessage: UiEmptyState;
  stay?: Maybe<EgdsBasicPill>;
};

/** Optional custom context information about the page where the query results will eventually be rendered */
export interface PageContextInput {
  propertySearch?: InputMaybe<PropertySearchCriteriaInput>;
}

export type PageLayoutExperimentalFeature = LodgingExperimentalFeature & {
  __typename?: "PageLayoutExperimentalFeature";
  description: Scalars["String"];
  experiment: LodgingExperiment;
  implementationDate: Date;
  owner: LodgingExperimentOwner;
  templateName?: Maybe<Scalars["String"]>;
};

/** Page identity */
export type PageLocation =
  /** All checkout related pages */
  | "CHECKOUT"
  /** Checkout error pages for all LOBs */
  | "CHECKOUT_ERROR"
  /** Order confirmation pages for all LOBs */
  | "CONFIRMATION"
  /** All product detail pages are identified as DETAILS */
  | "DETAILS"
  /** All landing, launch, published and any other page that will lead a user down to a search or detail page regardless of LOB */
  | "ENTRY"
  /** Pages that are not in the main shopping flow or that show up all across the flow such as Ads, Recommendation, Urgency, Scratchpad, etc. */
  | "FEATURES"
  /** Payment error pages for all LOBs */
  | "PAYMENT_ERROR"
  /** Post booking pages including itin, trip summary, trip details, customer service etc */
  | "POST_BOOKING"
  /** All LOB search result pages are identified as SEARCH_RESULTS */
  | "SEARCH_RESULTS"
  /** All pages that are not customer facing, that are for internal system or monitoring such as isWorking, health check, dev tools page, etc */
  | "SYSTEM"
  /** User pages including sign-in, my account and rewards */
  | "USER";

export type PageState = "LOADED" | "LOADING";

/** Separate a large list of results into multiple sublists */
export type Pagination = {
  __typename?: "Pagination";
  /** Number of results to get past the starting index */
  size?: Maybe<Scalars["Int"]>;
  /** The inclusive 0-based starting index of the results. Defaults to 0 */
  startingIndex?: Maybe<Scalars["Int"]>;
};

/** Context of pagination and max number of elements. If not defined, the default set of elements are provided with no option to request more. */
export interface PaginationContextInput {
  pageSize?: InputMaybe<Scalars["Int"]>;
}

/** Separate a large list of results into multiple sublists */
export interface PaginationInput {
  /** Number of results to get past the starting index */
  size?: InputMaybe<Scalars["Int"]>;
  /** The inclusive 0-based starting index of the results. Defaults to 0 */
  startingIndex?: InputMaybe<Scalars["Int"]>;
}

/** Represents the key value pair between analytics and its identifier for paid bags */
export type PaidBagsTemplateAnalytics = TemplateAnalytics & {
  __typename?: "PaidBagsTemplateAnalytics";
  /** Represents analytics */
  analytics: ClientSideAnalytics;
  /** Represents the analytics identifier */
  analyticsIdentifier: AnalyticsKey;
  /** Represents the set of choices to send in analytics for bags quantity */
  bagsQuantity?: Maybe<BagsSelectionType>;
};

export interface PartnerContextInput {
  detailsSiteConfiguration?: InputMaybe<TravelStoreV1CarDetailsInput>;
  partnerAccountId: Scalars["String"];
  searchSiteConfiguration?: InputMaybe<TravelStoreV1CarSearchInput>;
}

export type PartnerRecommendationCard = CarRecommendationCard & {
  __typename?: "PartnerRecommendationCard";
  action?: Maybe<CarAction>;
  analytics?: Maybe<CarAnalytics>;
  button?: Maybe<CarActionableItem>;
  dialog?: Maybe<PartnerRecommendationDialog>;
  icon?: Maybe<Icon>;
  image?: Maybe<Image>;
  subText?: Maybe<CarPhrase>;
  title?: Maybe<CarPhrase>;
};

export type PartnerRecommendationDialog = {
  __typename?: "PartnerRecommendationDialog";
  button: CarActionableItem;
  closeDialog: CarAction;
  content: PartnerRecommendationDialogContent;
  image: Image;
  subTitle: CarPhrase;
  text: Array<Array<CarPhrase>>;
  title: CarPhrase;
};

export type PartnerRecommendationDialogContent = {
  __typename?: "PartnerRecommendationDialogContent";
  body: Array<Array<CarPhrase>>;
  confidenceMessage: Array<CarPhrase>;
  title: CarPhrase;
};

export type PasswordResetButton = {
  __typename?: "PasswordResetButton";
  /** [static text] button name */
  text: Scalars["String"];
  /** password reset URL */
  url: Scalars["URL"];
};

export type PasswordResetContent = {
  __typename?: "PasswordResetContent";
  /** [static text] description */
  bodyCopy: Scalars["String"];
  /** [dynamic content] greeting with user first name */
  header?: Maybe<Scalars["String"]>;
  /** [static text] detailing time-sensitivity of this CTA */
  instruction: Scalars["String"];
  /** CTA button with text and password reset url */
  passwordResetButton: PasswordResetButton;
  /** PreHeader for Password Reset Service Email */
  preHeader?: Maybe<Scalars["String"]>;
  /** [static text] detailing what to do if this was not initiated by the user */
  secondaryInstruction: Scalars["String"];
  /** Subject Line for Password Reset Service Email */
  subjectLine?: Maybe<Scalars["String"]>;
};

export type PasswordUpdatedResult = {
  __typename?: "PasswordUpdatedResult";
  bodyCopy: Scalars["String"];
  ctaButton: BackToHomepageButton;
  header: Scalars["String"];
  instruction: HypertextItem;
  preHeader: Scalars["String"];
  subjectLine: Scalars["String"];
};

/** Represents PasswordStrengthMeter component. UITK component defined at https://www.figma.com/file/RUAR7jULx2vGF7ZF9NGNTA/PASSWORD-COMPONENT?node-id=629%3A13853 */
export type PasswordWithStrengthMeter = {
  __typename?: "PasswordWithStrengthMeter";
  hints: Array<PasswordWithStrengthMeterHint>;
  password: PasswordWithStrengthMeterInputField;
  progressBar: PasswordWithStrengthMeterProgressBar;
};

export type PasswordWithStrengthMeterCustomInputValidation = EgdsInputValidation & {
  __typename?: "PasswordWithStrengthMeterCustomInputValidation";
  errorMessage: Scalars["String"];
  pattern: Scalars["String"];
  state: Scalars["String"];
};

export type PasswordWithStrengthMeterHint = {
  __typename?: "PasswordWithStrengthMeterHint";
  state: Scalars["String"];
  text: Scalars["String"];
};

export type PasswordWithStrengthMeterInputField = {
  __typename?: "PasswordWithStrengthMeterInputField";
  analytics: Array<EgClickstreamEvent>;
  password: EgdsPasswordInputField;
};

export type PasswordWithStrengthMeterInputStrength = "STRONG" | "VERY_STRONG" | "WEAK";

export type PasswordWithStrengthMeterProgressBar = {
  __typename?: "PasswordWithStrengthMeterProgressBar";
  progressBar: EgdsProgressBar;
  progressBarCriteria: Array<PasswordWithStrengthMeterProgressBarCriteria>;
};

export type PasswordWithStrengthMeterProgressBarCriteria = {
  __typename?: "PasswordWithStrengthMeterProgressBarCriteria";
  description: Scalars["String"];
  strength: PasswordWithStrengthMeterInputStrength;
  theme: PasswordWithStrengthMeterProgressBarTheme;
};

export type PasswordWithStrengthMeterProgressBarTheme = "MUTED" | "POSITIVE";

/** Represents the billing zip code input text field */
export type PaymentBillingZipCodeInputField = PaymentFormField & {
  __typename?: "PaymentBillingZipCodeInputField";
  actions: Array<PaymentFieldOnBlurAction>;
  identifier: Scalars["String"];
  isMandatory?: Maybe<Scalars["Boolean"]>;
  label: Scalars["String"];
  placeholder: Scalars["String"];
  /** Represents validations for zip code field */
  validations: Array<PaymentFormValidation>;
};

export type PaymentCardDetails = {
  __typename?: "PaymentCardDetails";
  /** Represents the brand */
  brand: Scalars["String"];
  /** Represents the card logo */
  cardLogo?: Maybe<Mark>;
  /** Represents the card type */
  cardType?: Maybe<Scalars["String"]>;
  /** Represents the spacing pattern */
  spacingPattern: Scalars["String"];
};

export type PaymentConfidenceMessages = {
  __typename?: "PaymentConfidenceMessages";
  /** Represents the confidence messages */
  confidenceMessages: Array<PaymentIconAndDescription>;
};

/** Represents validation for card logos. */
export type PaymentContainedWithinFieldValidation = PaymentFormValidation & {
  __typename?: "PaymentContainedWithinFieldValidation";
  allowedValues: Array<Scalars["String"]>;
  errorMessage: Scalars["String"];
};

export type PaymentCreditCardNumberInputField = PaymentFormField & {
  __typename?: "PaymentCreditCardNumberInputField";
  actions: Array<PaymentFieldOnBlurAction>;
  /** Represents validations for credit card number input field */
  brandNameValidations: Array<PaymentFormValidation>;
  identifier: Scalars["String"];
  inputMode?: Maybe<Scalars["String"]>;
  isMandatory?: Maybe<Scalars["Boolean"]>;
  label: Scalars["String"];
  placeholder: Scalars["String"];
  /** Represents validations for credit card number input field */
  validations: Array<PaymentFormValidation>;
};

/** Represents the iframe element for PAN input */
export type PaymentCreditCardNumberInputFieldIframeElement = PaymentIFrameElement & {
  __typename?: "PaymentCreditCardNumberInputFieldIframeElement";
  content: PaymentCreditCardNumberInputField;
  url: Scalars["String"];
  visible: Scalars["Boolean"];
};

/** Represents a button in dialogue content fragment */
export type PaymentDialogButton = {
  __typename?: "PaymentDialogButton";
  action?: Maybe<PaymentDialogButtonAction>;
  text: Scalars["String"];
  type: EgdsButtonStyle;
};

export type PaymentDialogButtonAction = UiAction & {
  __typename?: "PaymentDialogButtonAction";
  accessibility?: Maybe<Scalars["String"]>;
  actionIdentifier?: Maybe<Scalars["String"]>;
  analytics: ClientSideAnalytics;
};

/** Dialog content representing placement of security code on allowed cards */
export interface PaymentDialogContent {
  identifier: Scalars["String"];
}

/** Represents a dialog box opened on clicking PaymentInteractiveIcon */
export type PaymentDialogElement = UiAction & {
  __typename?: "PaymentDialogElement";
  accessibility?: Maybe<Scalars["String"]>;
  analytics: ClientSideAnalytics;
  buttons: Array<PaymentDialogButton>;
  content: Array<PaymentDialogContent>;
  identifier: Scalars["String"];
  secondaryButton?: Maybe<UiSecondaryButton>;
};

export type PaymentDropdownAction = PaymentFieldOnBlurAction;

/** Represents a type utilized by the client to render PaymentUIElement on the same line but different columns. */
export type PaymentEvenColumns = {
  __typename?: "PaymentEvenColumns";
  /** List of PaymentUIElement containing dropdown options and fields for expiration month and year. */
  elements: Array<PaymentUiElement>;
};

/** Represents validation for expiration month and year of credit card */
export type PaymentExpirationDateValidation = PaymentFormValidation & {
  __typename?: "PaymentExpirationDateValidation";
  errorMessage: Scalars["String"];
  expirationMonthId: Scalars["String"];
  expirationYearId: Scalars["String"];
};

/** Generic interface to capture events. */
export interface PaymentFieldAction {
  analytics: ClientSideAnalytics;
}

/** Action representing the event where the field is blurred out to the user once they hover out of the field. */
export type PaymentFieldOnBlurAction = PaymentFieldAction & {
  __typename?: "PaymentFieldOnBlurAction";
  analytics: ClientSideAnalytics;
};

/** Represents a drop down form field in a payment module. */
export type PaymentFormDropdown = PaymentFormField & {
  __typename?: "PaymentFormDropdown";
  actions: Array<PaymentDropdownAction>;
  identifier: Scalars["String"];
  isMandatory?: Maybe<Scalars["Boolean"]>;
  label: Scalars["String"];
  options: Array<PaymentFormDropdownElement>;
  placeholder: Scalars["String"];
  selectedItemId: Scalars["String"];
  validations: Array<PaymentFormValidation>;
};

/** Represents data of dropdown field */
export interface PaymentFormDropdownElement {
  identifier: Scalars["String"];
  label: Scalars["String"];
  value: Scalars["String"];
}

/** Represents individual item in list of PaymentFormDropdownElement */
export type PaymentFormDropdownItem = PaymentFormDropdownElement & {
  __typename?: "PaymentFormDropdownItem";
  identifier: Scalars["String"];
  label: Scalars["String"];
  value: Scalars["String"];
};

/** Generic entity for an form field */
export interface PaymentFormField {
  identifier: Scalars["String"];
}

/** Represents validation for the credit card input fields */
export interface PaymentFormValidation {
  errorMessage: Scalars["String"];
}

/** Represents the presence of an iframe element */
export interface PaymentIFrameElement {
  url: Scalars["String"];
  visible: Scalars["Boolean"];
}

/** Represents an entity for displaying a message with an icon */
export type PaymentIconAndDescription = {
  __typename?: "PaymentIconAndDescription";
  description: Scalars["String"];
};

/** Represents an interactive dialog in cvv input field */
export type PaymentIconDialog = PaymentInteractiveIcon & {
  __typename?: "PaymentIconDialog";
  dialog: PaymentDialogElement;
  icon: Icon;
  label?: Maybe<Scalars["String"]>;
};

/** Represents the CVV Input text field */
export type PaymentInformativeInputField = PaymentFormField & {
  __typename?: "PaymentInformativeInputField";
  actions: Array<PaymentFieldAction>;
  identifier: Scalars["String"];
  inputMode?: Maybe<Scalars["String"]>;
  interactiveIcon: PaymentInteractiveIcon;
  label: Scalars["String"];
  placeholder: Scalars["String"];
  /** Represents validations for CVV input field */
  validations: Array<PaymentFormValidation>;
};

/** Represents the iframe element for CVV input */
export type PaymentInformativeInputFieldIframeElement = PaymentIFrameElement & {
  __typename?: "PaymentInformativeInputFieldIframeElement";
  content: PaymentInformativeInputField;
  url: Scalars["String"];
  visible: Scalars["Boolean"];
};

/** Represents the Card Holder Name Input field */
export type PaymentInputField = PaymentFormField & {
  __typename?: "PaymentInputField";
  actions: Array<PaymentFieldAction>;
  defaultValue?: Maybe<Scalars["String"]>;
  identifier: Scalars["String"];
  inputCriteria?: Maybe<Scalars["String"]>;
  isMandatory?: Maybe<Scalars["Boolean"]>;
  label: Scalars["String"];
  placeholder: Scalars["String"];
  validations: Array<PaymentFormValidation>;
};

/** Represents Information icon in CVV Input field */
export interface PaymentInteractiveIcon {
  icon: Icon;
}

/** Represents validation for credit card number */
export type PaymentLuhnValidation = PaymentFormValidation & {
  __typename?: "PaymentLuhnValidation";
  errorMessage: Scalars["String"];
};

/** Represents validation for max length of Card Holder Name (Set to 61 currently) */
export type PaymentMaxLengthValidation = PaymentFormValidation & {
  __typename?: "PaymentMaxLengthValidation";
  errorMessage: Scalars["String"];
  maxLength: Scalars["Int"];
};

export type PaymentMenuPaymentOption = {
  __typename?: "PaymentMenuPaymentOption";
  content: Array<PaymentUiElement>;
  description: Scalars["String"];
  paymentOptionType: Scalars["String"];
  paymentTypeLogo?: Maybe<PaymentTypeLogo>;
};

export type PaymentModule = {
  __typename?: "PaymentModule";
  /** Represents the authorization token required for tokenization */
  accessTokenForCardTokenization: Scalars["String"];
  /** Represents the tokenization service URI */
  cardTokenizationServiceURI: Scalars["String"];
  /** Represents the list of all the UI elements which makes the module */
  elements: Array<PaymentUiElement>;
  /** List of all iframe elements which load within the module */
  iframes: Array<PaymentIFrameElement>;
  /** Represents the title of the module */
  title: Scalars["String"];
};

export type PaymentModuleSession = {
  __typename?: "PaymentModuleSession";
  encodedInitConfig?: Maybe<Scalars["String"]>;
  paymentSessionId?: Maybe<Scalars["String"]>;
  verificationRequired?: Maybe<Scalars["Boolean"]>;
  verificationType?: Maybe<Scalars["String"]>;
};

export type PaymentOptionChangeMenu = {
  __typename?: "PaymentOptionChangeMenu";
  /** Represents list of payment options */
  menuItems: Array<PaymentMenuPaymentOption>;
};

/** Represents validation for added regex patterns */
export type PaymentPatternFieldValidation = PaymentFormValidation & {
  __typename?: "PaymentPatternFieldValidation";
  errorMessage: Scalars["String"];
  regexPattern: Scalars["String"];
};

/** Represents validation for mandatory fields */
export type PaymentRequiredFieldValidation = PaymentFormValidation & {
  __typename?: "PaymentRequiredFieldValidation";
  errorMessage: Scalars["String"];
};

/** Represents data modal for placement of security code on allowed cards */
export type PaymentTitledImageDialogContent = PaymentDialogContent & {
  __typename?: "PaymentTitledImageDialogContent";
  identifier: Scalars["String"];
  imageContent: Image;
  textContent: Scalars["String"];
};

/** Represents the invisible iframe element for tokenization */
export type PaymentTokenizationIframeElement = PaymentIFrameElement & {
  __typename?: "PaymentTokenizationIframeElement";
  accessTokenForCardTokenization: Scalars["String"];
  url: Scalars["String"];
  visible: Scalars["Boolean"];
};

export type PaymentType =
  | "COUPON_ELIGIBLE"
  | "FREE_CANCELLATION"
  | "PAY_LATER"
  | "PAY_LATER_WITH_DEPOSIT"
  | "PAY_WITHOUT_CREDITCARD";

export type PaymentTypeLogo = {
  __typename?: "PaymentTypeLogo";
  icon?: Maybe<Icon>;
  mark?: Maybe<Mark>;
  size: PaymentTypeLogoSize;
};

export type PaymentTypeLogoList = {
  __typename?: "PaymentTypeLogoList";
  /** Represents the list of all payment logos for a card type */
  paymentLogos: Array<PaymentTypeLogo>;
};

/** Represents the logo size used by the client to render */
export type PaymentTypeLogoSize = "LARGE" | "SMALL";

/** Represents all the possible UI elements needed for the module to render. */
export type PaymentUiElement =
  | PaymentBillingZipCodeInputField
  | PaymentConfidenceMessages
  | PaymentCreditCardNumberInputField
  | PaymentCreditCardNumberInputFieldIframeElement
  | PaymentEvenColumns
  | PaymentFormDropdown
  | PaymentInformativeInputField
  | PaymentInformativeInputFieldIframeElement
  | PaymentInputField
  | PaymentOptionChangeMenu
  | PaymentTypeLogoList;

export type PersonalizedOffersRecommendations = {
  __typename?: "PersonalizedOffersRecommendations";
  offers: Array<OffersRecommendationGroup>;
  title?: Maybe<Scalars["String"]>;
};

/** Represents Speak next available agent phone number display */
export type PhoneNumberData = {
  __typename?: "PhoneNumberData";
  /** call button with icon */
  call?: Maybe<UiPrimaryButton>;
  /** phone number for customer to dial */
  phoneNumber: Scalars["String"];
  /** phone type label  */
  phoneType: Scalars["String"];
  /** separator icon for phone type */
  separator: Icon;
};

/** Data to power the multi-item picker from Global Navigation */
export type Picker = {
  __typename?: "Picker";
  /** Optional text to be shown at the top of the picker component in a banner */
  bannerText?: Maybe<Scalars["String"]>;
  closeDialogText: Scalars["String"];
  /** @deprecated Replaced by urlToSubmit and queryParamsToSubmit for better granularity */
  domainUrlToSubmit?: Maybe<Scalars["URL"]>;
  heading: Scalars["String"];
  preferences: Array<Maybe<LocalePreferenceSelector>>;
  /** Optional query parameters to submit when applying changes. Used to update site locale preferences like currency */
  queryParamsToSubmit?: Maybe<Array<GraphQlPair>>;
  /** @deprecated Replaced by bannerText, better named and optional */
  regionBannerText: Scalars["String"];
  submitText: Scalars["String"];
  submitTrackingEvent: Scalars["String"];
  trigger: PickerTrigger;
  /** Optional URL to submit when applying changes. Used for switching domains for other POS */
  urlToSubmit?: Maybe<Scalars["URL"]>;
};

export type PickerTrigger = {
  __typename?: "PickerTrigger";
  displayType: PickerTriggerDisplayType;
  flagName?: Maybe<Scalars["String"]>;
  iconName?: Maybe<Scalars["String"]>;
  text: Scalars["String"];
  trackingEvent: Scalars["String"];
};

export type PickerTriggerDisplayType = "GLOBAL_NAV_BUTTON" | "GLOBAL_NAV_LINK";

export type PickerTriggerPlacementType = "MENU_ITEM" | "NAV_LINK";

/** Activity pinned details */
export type Pinned = {
  __typename?: "Pinned";
  /** Activity tile bottom text for pinned on SRP for SEM traffic */
  tileBottom?: Maybe<Icon>;
  /** Activity tile top text for pinned on SRP for SEM traffic */
  tileTop?: Maybe<Icon>;
};

/** Selected/pinned property messaging details */
export type PinnedPropertyModel = {
  __typename?: "PinnedPropertyModel";
  heading: Scalars["String"];
};

export type PlacesDialog = EgdsMapDialog & {
  __typename?: "PlacesDialog";
  /** Dialog definition */
  dialog?: Maybe<EgdsFullScreenDialog>;
  placesDialogEGDSTextsContentSection?: Maybe<PlacesDialogEgdsTextsContentSection>;
  placesDialogTextInputFieldContentSection?: Maybe<PlacesDialogTextInputFieldContentSection>;
  /** Dialog Content */
  placesDialogTypeAheadContentSection?: Maybe<PlacesDialogTypeAheadContentSection>;
  placesDialogUITogglesContentSection?: Maybe<PlacesDialogUiTogglesContentSection>;
  /** Button that would trigger the MapDialog on click */
  trigger?: Maybe<EgdsOverlayButton>;
};

export interface PlacesDialogContentSection {
  heading?: Maybe<EgdsHeading>;
  subHeading?: Maybe<EgdsText>;
}

export type PlacesDialogEgdsTextsContentSection = PlacesDialogContentSection & {
  __typename?: "PlacesDialogEGDSTextsContentSection";
  content?: Maybe<Array<EgdsText>>;
  heading?: Maybe<EgdsHeading>;
  subHeading?: Maybe<EgdsText>;
};

export type PlacesDialogTextInputFieldContentSection = PlacesDialogContentSection & {
  __typename?: "PlacesDialogTextInputFieldContentSection";
  content?: Maybe<EgdsTextInputField>;
  heading?: Maybe<EgdsHeading>;
  subHeading?: Maybe<EgdsText>;
};

export type PlacesDialogTypeAheadContentSection = PlacesDialogContentSection & {
  __typename?: "PlacesDialogTypeAheadContentSection";
  content?: Maybe<EgdsTypeaheadInputField>;
  heading?: Maybe<EgdsHeading>;
  subHeading?: Maybe<EgdsText>;
};

export type PlacesDialogUiTogglesContentSection = PlacesDialogContentSection & {
  __typename?: "PlacesDialogUITogglesContentSection";
  content?: Maybe<Array<UiToggle>>;
  heading?: Maybe<EgdsHeading>;
  subHeading?: Maybe<EgdsText>;
};

/** A domain object that can be plotted on a map */
export interface Plottable {
  /** The plottable object's unique identifier */
  mapMarker?: Maybe<MapMarker>;
}

/**
 * Languages vary in how they handle plurals of nouns or unit expressions ("hour" vs "hours", and so on).
 * Some languages have two forms, like English; some languages have only a single form; and some languages have multiple forms. CLDR uses short, mnemonic tags for these plural categories.
 * http://cldr.unicode.org/index/cldr-spec/plural-rules
 */
export type PluralCategory = "FEW" | "MANY" | "ONE" | "OTHER" | "TWO" | "ZERO";

export type PoiContent = {
  __typename?: "PoiContent";
  description?: Maybe<Scalars["String"]>;
  id: Scalars["String"];
  image?: Maybe<Image>;
};

/** A single hotel or vacation rental */
export type PointOfInterest = Plottable &
  PropertyDetailPlottable & {
    __typename?: "PointOfInterest";
    /**
     * ID of the POI
     * @deprecated For PWA use only as a part of PDP migration.
     */
    id?: Maybe<Scalars["String"]>;
    /** Map marker information for plotting on a map */
    mapMarker: MapMarker;
    poiContent?: Maybe<PoiContent>;
    /** Distance of the POI to the property. */
    subtitle?: Maybe<Scalars["String"]>;
    /** The name of the POI */
    title: Scalars["String"];
  };

/** Points related property search options  */
export type Points =
  /** Don't use loyalty points to calculate the strikeout price. */
  | "SHOP_WITHOUT_POINTS"
  /** Use loyalty points to calculate the strikeout price. aka `swpApplied=true` */
  | "SHOP_WITH_POINTS";

export type PointsInformation = {
  __typename?: "PointsInformation";
  closeLabel: Scalars["String"];
  text: Scalars["String"];
};

/** Section that contains all the information required to build tooltip */
export type PolicyDetailsSection = {
  __typename?: "PolicyDetailsSection";
  /** Accessibility text for the policy section */
  policyA11yText?: Maybe<Scalars["String"]>;
  /** Contains the title of the policy along with information about its theme */
  title: EgdsStylizedText;
  /** Contains the content that will be shown inside tooltip */
  tooltipContent?: Maybe<Array<Scalars["String"]>>;
  /** Contains the information about tooltip icon (i) along with its theme, size */
  tooltipIcon?: Maybe<Icon>;
};

/** Wrapper type that holds a collection of expando sections. */
export type PolicyExpandoList = {
  __typename?: "PolicyExpandoList";
  expandoSections: Array<PolicyExpandoSection>;
};

/** A single expando section */
export type PolicyExpandoSection = {
  __typename?: "PolicyExpandoSection";
  content: Content;
  /** Contains Properties related to Expando, and will have the implementation of different kinds of EGDS Expandos' like EGDSExpandoCard, EGDSExpandoPeek */
  heading: EgdsExpando;
  /** Unique identifier of the expando section */
  urn: Scalars["String"];
};

/** Policy content in HTML format. */
export type PolicyHtmlContent = {
  __typename?: "PolicyHTMLContent";
  htmlContent: Array<Scalars["String"]>;
};

export interface PolicySearchCriteriaInput {
  cartId?: InputMaybe<Scalars["String"]>;
  entityId?: InputMaybe<Scalars["String"]>;
  offerToken?: InputMaybe<OfferTokenInput>;
  orderInfo?: InputMaybe<OrderInfoInput>;
}

/** Tabular section in long form text component */
export type PortableTextHtmlTableSection = {
  __typename?: "PortableTextHTMLTableSection";
  rows?: Maybe<Array<Maybe<SectionRow>>>;
};

/** Wrapping for Long Form Rich Text content with File */
export type PortableTextWithLink = {
  __typename?: "PortableTextWithLink";
  fileLink?: Maybe<EgdsStandardLink>;
  portableTextContent: Array<PortableTextContent>;
};

export type PosSelector = LocalePreferenceSelector & {
  __typename?: "PosSelector";
  heading: Scalars["String"];
  options: Array<PosSelectorOption>;
  queryParameterName: Scalars["String"];
  trackingEvent: Scalars["String"];
};

export type PosSelectorOption = LocaleSelectorOption & {
  __typename?: "PosSelectorOption";
  flag: Scalars["String"];
  name: Scalars["String"];
  selected: Scalars["Boolean"];
  value: Scalars["String"];
};

export type PreBundledPackageSearchEmptyStateErrorResponse = PackageUiEmptyStateError & {
  __typename?: "PreBundledPackageSearchEmptyStateErrorResponse";
  errorAction?: Maybe<PackageUiExternalLinkAction>;
  icon: Icon;
  primary: EgdsHeading;
  secondaries: Array<EgdsText>;
};

/**
 * Represents an experience that presents customers with a force choice module with the intent of
 * directing them to the prebundled search page.
 *
 * Figma: https://www.figma.com/file/iLrELeHssY12NY6YFTi1f8/Packages-2.0---Search-%26-Discovery?node-id=2803%3A74415
 */
export type PreBundledPackageSearchEntryResponse = {
  __typename?: "PreBundledPackageSearchEntryResponse";
  contentSections: Array<PackageUiPreBundledPackageSearchEntryContent>;
  dialog: EgdsActionDialog;
  header: Scalars["String"];
  image?: Maybe<Image>;
  impressionAnalytics: ClientSideAnalytics;
};

/** Interface for pre-bundled package search responses */
export type PreBundledPackageSearchResponse =
  | PreBundledPackageSearchEmptyStateErrorResponse
  | PreBundledPackageSearchSuccessResponse;

export type PreBundledPackageSearchSuccessResponse = {
  __typename?: "PreBundledPackageSearchSuccessResponse";
  accessibilityHeading?: Maybe<Scalars["String"]>;
  cards: Array<PackageUiPreBundledCard>;
  carousel: MishopUiCarousel;
  header: EgdsHeading;
  recommendationsAnalytics: Array<RecommendationAnalytics>;
  subHeader: EgdsPlainText;
};

export type PrebundlePackageDetailsPrimers = PackageDetailsPrimersError | PrebundlePackageDetailsPrimersSuccess;

/** Information needed to render the prebundle package details page */
export type PrebundlePackageDetailsPrimersSuccess = {
  __typename?: "PrebundlePackageDetailsPrimersSuccess";
  /**
   * Error that should be shown when any of the view-critical modules fail to load. This node will always be
   * populated, so it's up to clients to determine when to show it and what constitutes a "view-critical" module.
   *
   * Figma: https://www.figma.com/file/NZSrQ0BBqZZ9ozOJE7oBtW/Packages-2.0---Package-Details-Page?node-id=2948%3A55305
   */
  criticalModuleFailureError: PackageUiExternalLinkEmptyStateError;
  heading: EgdsHeading;
  primers: PrebundlePackageDetailsSuccessPrimers;
};

/** Primers needed to render the prebundle package details page */
export type PrebundlePackageDetailsSuccessPrimers = {
  __typename?: "PrebundlePackageDetailsSuccessPrimers";
  changePackageWizardPrimer: MishopUiChangePackageFormPrimer;
  checkoutButtonPrimer: MishopUiCheckoutButtonPrimer;
  notificationPrimer: MishopUiNotificationPrimer;
  packageSummaryContentPrimer: MishopUiPackageSummaryContentPrimer;
  policiesPrimer: PackageUiPoliciesPrimer;
  pricingDetailsPrimer: MishopUiPricingDetailsPrimer;
  productContentPrimers: Array<PackageDetailsProductContentPrimer>;
  seeAllPackagesLinkPrimer?: Maybe<PackageUiSeeAllPackagesLinkPrimer>;
};

/** Information needed to transition the customer towards booking */
export type PrepareCheckoutResponse = {
  __typename?: "PrepareCheckoutResponse";
  checkoutUrl?: Maybe<Scalars["URL"]>;
  failureReason?: Maybe<FailureReason>;
  tripId?: Maybe<Scalars["UUID"]>;
};

/** Options that alter behavior of mutation - for backward compatibility */
export type PrepareCheckoutResponseOption = "ALTERNATIVE_ACTION_ON_FAILURE";

export type PriceBreakDownModel = {
  __typename?: "PriceBreakDownModel";
  breakDownHeader?: Maybe<Scalars["String"]>;
  mandatoryFee?: Maybe<Scalars["String"]>;
  mandatoryTax?: Maybe<Scalars["String"]>;
  refundableMessaging?: Maybe<Scalars["String"]>;
  resortFee?: Maybe<Scalars["String"]>;
  totalBasePrice?: Maybe<Scalars["String"]>;
  totalPrice?: Maybe<Scalars["String"]>;
  totalTaxAndFees?: Maybe<Scalars["String"]>;
};

export type PriceCheckHistory = {
  __typename?: "PriceCheckHistory";
  /** Data related to history section like trip details */
  copy?: Maybe<Array<EgdsComposableTextElement>>;
  /** Heading of the price check history section */
  heading: EgdsHeading;
  /** A message that might add information related to the prce checks, e.g.: No price checks were found */
  message?: Maybe<PriceMatchPromiseMessage>;
  /** List of tabs */
  priceMatchPromiseTabs: Array<PriceMatchPromiseTab>;
};

export type PriceCheckMutationResult = {
  __typename?: "PriceCheckMutationResult";
  /** The message of the result */
  message?: Maybe<Array<EgdsComposableTextElement>>;
  /** The updated PriceMatchPromiseDetails after the mutation completes */
  priceMatchPromiseDetails?: Maybe<PriceMatchPromiseDetails>;
  /** Returned if a toast is to be displayed as part of the result */
  toast?: Maybe<PriceMatchPromiseToast>;
};

export type PriceDetails = {
  __typename?: "PriceDetails";
  /** Prices for display */
  pricePresentation: PricePresentation;
  /** @deprecated Used only for tracking purposes */
  trackingData?: Maybe<TrackingData>;
};

export type PriceDetailsOptions = {
  __typename?: "PriceDetailsOptions";
  metaDeeplink: Scalars["Boolean"];
};

export interface PriceDetailsOptionsInput {
  metaDeeplink: Scalars["Boolean"];
}

export type PriceDisplayMessage = {
  __typename?: "PriceDisplayMessage";
  /** Describes how to layout price display message lines */
  lineItems: Array<PriceDisplayMessageItem>;
};

/** Interface for anything in the displayMessages list. */
export type PriceDisplayMessageItem = DisplayPrice | LodgingEnrichedMessage;

export interface PriceFilterInput {
  facetValuesSize: Scalars["Int"];
  max: Scalars["Int"];
  maxIndex: Scalars["Int"];
  min: Scalars["Int"];
}

export type PriceFilterPills = {
  __typename?: "PriceFilterPills";
  aggregate?: Maybe<PriceFilterPillsAggregate>;
  buckets?: Maybe<Array<Scalars["Int"]>>;
};

export type PriceFilterPillsAggregate = {
  __typename?: "PriceFilterPillsAggregate";
  label?: Maybe<Scalars["String"]>;
  value?: Maybe<Scalars["String"]>;
};

/** TimeSeries price graph and price alerts switch components */
export type PriceInsights = {
  __typename?: "PriceInsights";
  /** Toggle switch for price alerts */
  priceInsightsCard?: Maybe<PriceInsightsCard>;
  /** Carousel of subscription cards for traveller */
  priceInsightsTrackingCarousel?: Maybe<PriceInsightsTrackingCarouselContainer>;
  /** Live price for subscription ID */
  priceInsightsTrackingLivePrice?: Maybe<Array<PriceInsightsTrackingLivePrice>>;
};

/** TimeSeries price graph and price alerts switch components */
export type PriceInsightsPriceInsightsCardArgs = {
  deepLinkQueryParams?: InputMaybe<Array<PriceInsightsDeepLinkQueryParamInput>>;
  searchContext: PriceInsightsSearchContextInput;
};

/** TimeSeries price graph and price alerts switch components */
export type PriceInsightsPriceInsightsTrackingLivePriceArgs = {
  displayedIndex?: InputMaybe<Scalars["Int"]>;
  subscriptionIds: Array<Scalars["String"]>;
};

export interface PriceInsightsAnalytics {
  /** Represents the analytics to track on display of the component */
  displayAnalyticsList?: Maybe<Array<ClientSideImpressionEventAnalytics>>;
  /** Represents the EGCS analytics to track on display of the component */
  egcsDisplayAnalyticsList?: Maybe<Array<EgClickstreamEvent>>;
  /** Represents the EGCS analytics to track on interaction with the component */
  egcsOnClickAnalyticsList?: Maybe<Array<EgClickstreamEvent>>;
  /** Represents the analytics to track on interaction with the component */
  onClickAnalyticsList?: Maybe<Array<ClientSideAnalytics>>;
}

/** Represents the complete price insights card */
export type PriceInsightsCard = PriceInsightsAnalytics & {
  __typename?: "PriceInsightsCard";
  /** Represents the accessibility content */
  accessibility?: Maybe<ClientAccessibility>;
  /** Represents the middle content on the card */
  content?: Maybe<PriceInsightsCardContent>;
  displayAnalyticsList?: Maybe<Array<ClientSideImpressionEventAnalytics>>;
  egcsDisplayAnalyticsList?: Maybe<Array<EgClickstreamEvent>>;
  egcsOnClickAnalyticsList?: Maybe<Array<EgClickstreamEvent>>;
  /** Represents the error messaging node for Price Insights card. */
  errorMessaging?: Maybe<ErrorMessagingPresentation>;
  /** Represents the forecasting message on the card. Example: 'We predict the lowest price will be around $170 - $180 between Feb 11-17' */
  forecast?: Maybe<PriceInsightsCardForecast>;
  /** Represents the heading on the card. Example: 'Current lowest price $331' */
  header?: Maybe<PriceInsightsCardHeader>;
  onClickAnalyticsList?: Maybe<Array<ClientSideAnalytics>>;
  /** Represents the alert switch on the card */
  priceTrackingToggle?: Maybe<PriceInsightsTrackingToggle>;
  /** Represents the result of toggle status change by system. */
  toast?: Maybe<EgdsToast>;
};

/** Union for all the price insights card content elements */
export interface PriceInsightsCardContent {
  /** Represents the accessibility content */
  accessibility?: Maybe<ClientAccessibility>;
  /** Represent the horizontal and vertical labels for the text based content */
  legend: PriceInsightsGraphLegend;
}

/** Represents the sheet for the price insights disclaimer */
export type PriceInsightsCardDisclaimerSheet = {
  __typename?: "PriceInsightsCardDisclaimerSheet";
  content: Array<PriceInsightsCardDisclaimerSheetSubContent>;
  sheet: EgdsSheet;
};

/** Represents the sub-content for price insights disclaimer sheet */
export type PriceInsightsCardDisclaimerSheetSubContent = {
  __typename?: "PriceInsightsCardDisclaimerSheetSubContent";
  /** Represents the content of the sub-content for price insights disclaimer sheet */
  content: EgdsStylizedText;
  /** Represents the title of the sub-content for price insights disclaimer sheet */
  title: EgdsHeading;
};

/** Represents the price insights disclaimer tool tip on the card */
export type PriceInsightsCardDisclaimerToolTip = {
  __typename?: "PriceInsightsCardDisclaimerToolTip";
  /** Represents the accessibility for the price insights disclaimer tool tip */
  accessibility?: Maybe<ClientAccessibility>;
  action: PriceInsightsCardDisclaimerToolTipAction;
  /** Represents the icon for the price insights disclaimer tool tip */
  icon: Icon;
};

/** Represents the action for the price insights disclaimer tool tip */
export type PriceInsightsCardDisclaimerToolTipAction = UiAction & {
  __typename?: "PriceInsightsCardDisclaimerToolTipAction";
  accessibility: Scalars["String"];
  analytics: ClientSideAnalytics;
  disclaimer: PriceInsightsCardDisclaimerSheet;
};

/** Represents node for Error Messaging on the UI for Price Insights Card. */
export type PriceInsightsCardErrorMessaging = ErrorMessagingPresentation & {
  __typename?: "PriceInsightsCardErrorMessaging";
  egcsErrorAnalytics: EgClickstreamEvent;
  errorAnalytics: ClientSideImpressionEventAnalytics;
};

export type PriceInsightsCardForecast = {
  __typename?: "PriceInsightsCardForecast";
  /** Represents the forecasting message on the card. Example: 'We predict the lowest price will be around $170 - $180 between Feb 11-17' */
  message: EgdsIconText;
};

/** Represents the heading on the card. Example: 'Current lowest price $331' */
export type PriceInsightsCardHeader = {
  __typename?: "PriceInsightsCardHeader";
  /** Represents the accessibility content */
  accessibility?: Maybe<ClientAccessibility>;
  /** Represents the sub title on the card. Example: '$371' */
  cardSubTitle: EgdsHeading;
  /** Represents the sub title description on the card. Example: 'Current lowest price' */
  cardSubTitleDescription: EgdsStylizedText;
  /** Represents the sub title on the card. Example: '$371 ($742 total for 2 rooms)' */
  cardSubTitleText?: Maybe<EgdsSpannableText>;
  /** Represents the title on the card. Example: 'Price Insights' */
  cardTitle: EgdsHeading;
  /** Represents the optional title description on the card. Example: 'It’s a great time to book! The current price is low for your trip dates.' */
  cardTitleDescription?: Maybe<EgdsSpannableText>;
  disclaimerToolTip?: Maybe<PriceInsightsCardDisclaimerToolTip>;
  /**
   * Represents the subtitle on the card. Example: '$331'
   * @deprecated This field is replaced with cardSubTitleDescription
   */
  subTitle: EgdsStylizedText;
  /**
   * Represents the title on the card. Example: 'Current lowest price'
   * @deprecated This field is replaced with cardSubTitle
   */
  title: EgdsStylizedText;
};

/** Represents card message element with accessibility */
export type PriceInsightsCardMessage = {
  __typename?: "PriceInsightsCardMessage";
  /** Represents the accessibility content */
  accessibility?: Maybe<ClientAccessibility>;
  /** Represent the message for the text based content */
  message: EgdsIconText;
};

/** Contains details needed to show a price tracking card */
export type PriceInsightsCarouselTrackingCard = PriceInsightsAnalytics & {
  __typename?: "PriceInsightsCarouselTrackingCard";
  /** Deeplink information to launch the next page on tap of Carousel Tracking card */
  action?: Maybe<UiLinkAction>;
  displayAnalyticsList?: Maybe<Array<ClientSideImpressionEventAnalytics>>;
  /** The displayed index of this card */
  displayIndex?: Maybe<Scalars["Int"]>;
  egcsDisplayAnalyticsList?: Maybe<Array<EgClickstreamEvent>>;
  egcsOnClickAnalyticsList?: Maybe<Array<EgClickstreamEvent>>;
  /** Error label that can be used in case of query failure during live price fetch */
  livePriceUnavailableLabel: EgdsIconText;
  onClickAnalyticsList?: Maybe<Array<ClientSideAnalytics>>;
  /** Top title */
  primary: Scalars["String"];
  /** Subtitles with every value in new line */
  secondaries: Array<Scalars["String"]>;
  subscriptionId: Scalars["String"];
};

/** Represents a query parameter in the deep link. */
export interface PriceInsightsDeepLinkQueryParamInput {
  key: Scalars["String"];
  value: Scalars["String"];
}

/** Represent the dialog button action */
export type PriceInsightsExistingDialogButtonAction = ClientSideErrorRepresentation &
  UiAction & {
    __typename?: "PriceInsightsExistingDialogButtonAction";
    accessibility?: Maybe<Scalars["String"]>;
    analytics: ClientSideAnalytics;
    clientSideErrorRepresentationAction?: Maybe<PriceInsightsTrackingRetryDialogAction>;
    clientSideErrorRepresentationDialog?: Maybe<ClientSideErrorRepresentationDialog>;
    /** Represents the EGCS analytics to track on click action */
    egcsOnClickAnalytics?: Maybe<EgClickstreamEvent>;
    /** Represents the price on which subscription needs to be created */
    priceShown: Scalars["String"];
    /** Client needs to pass subscription id for updating subscription */
    subscriptionId: Scalars["String"];
  };

export type PriceInsightsExistingTrackingDialogAction = EgdsDialog &
  PriceInsightsTrackingToggleAction & {
    __typename?: "PriceInsightsExistingTrackingDialogAction";
    accessibility?: Maybe<Scalars["String"]>;
    closeAnalytics?: Maybe<ClientSideAnalytics>;
    /** Dialog description for updating the existing alert */
    description: Scalars["String"];
    /** Represents one or more buttons displayed in an inline orientation for users to respond to the dialog */
    dialogFooter: EgdsInlineDialogFooter;
    /** Represents the analytics to track on display of the component */
    displayAnalytics?: Maybe<ClientSideImpressionEventAnalytics>;
    /** Represents the EGCS analytics to track on display of the component */
    egcsDisplayAnalytics?: Maybe<EgClickstreamEvent>;
    /** Dialog title for updating the existing alert */
    title: Scalars["String"];
  };

/** Area bounded by 4 data point on the graph */
export type PriceInsightsGraphArea = {
  __typename?: "PriceInsightsGraphArea";
  /** Represents the bottom left corner of the area */
  bottomLeft: PriceInsightsGraphPoint;
  /** Represents the bottom right corner of the area */
  bottomRight: PriceInsightsGraphPoint;
  /** Represents the top left corner of the area */
  topLeft: PriceInsightsGraphPoint;
  /** Represents the top right corner of the area */
  topRight: PriceInsightsGraphPoint;
};

/** Represent the graph based price insights card content elements */
export type PriceInsightsGraphBasedContent = PriceInsightsCardContent & {
  __typename?: "PriceInsightsGraphBasedContent";
  /** Represents the accessibility content */
  accessibility?: Maybe<ClientAccessibility>;
  /** Represent the data points for graph based price insights card content elements */
  data: Array<PriceInsightsGraphData>;
  /** Represent the horizontal and vertical labels for the graph based content */
  legend: PriceInsightsGraphLegend;
  /** maximum value on vertical axis */
  maxValue: Scalars["Int"];
  /** minimum value on vertical axis */
  minValue: Scalars["Int"];
  /** Represent the shaded areas on the graph */
  shading?: Maybe<Array<PriceInsightsGraphShading>>;
  /** Represent max number of points on x axis */
  totalHorizontalPoints: Scalars["Int"];
};

/** Union for all the price insights data points */
export type PriceInsightsGraphData =
  | PriceInsightsGraphDataDottedLine
  | PriceInsightsGraphDataMarker
  | PriceInsightsGraphDataSolidLine;

/** Represents graph data point for dotted line */
export type PriceInsightsGraphDataDottedLine = {
  __typename?: "PriceInsightsGraphDataDottedLine";
  points: Array<PriceInsightsGraphPoint>;
};

/** Represents graph data point for marker */
export type PriceInsightsGraphDataMarker = {
  __typename?: "PriceInsightsGraphDataMarker";
  points: Array<PriceInsightsGraphPoint>;
};

/** Represents graph data point for solid line */
export type PriceInsightsGraphDataSolidLine = {
  __typename?: "PriceInsightsGraphDataSolidLine";
  points: Array<PriceInsightsGraphPoint>;
};

/** Represent label corresponding to price insights graph */
export type PriceInsightsGraphLabel = {
  __typename?: "PriceInsightsGraphLabel";
  /** Represent EGDSStylized text for label */
  content: EgdsStylizedText;
  /** Represent multiplier for plotting of label on axis */
  normalisedPosition: Scalars["Float"];
  /**
   * Represent EGDSStylized text for label
   * @deprecated This field is deprecated and replaced with field named content.
   */
  text: EgdsStylizedText;
};

/** Represent the horizontal and vertical labels for graph content */
export type PriceInsightsGraphLegend = {
  __typename?: "PriceInsightsGraphLegend";
  /** Represent average price label for the price insights graph */
  averagePriceLabel?: Maybe<PriceInsightsGraphLabel>;
  /** Represent the horizontal labels */
  horizontalLabels?: Maybe<Array<PriceInsightsGraphLabel>>;
  /** Represent the vertical labels */
  verticalLabels: Array<PriceInsightsGraphLabel>;
};

/** data point on the graph line */
export type PriceInsightsGraphPoint = {
  __typename?: "PriceInsightsGraphPoint";
  /** Normalised vertical axis value with min and max positions for Graph.e.g. iOS will be using (value - minimum/2)/maximum */
  normalizedValue: Scalars["Float"];
  /** Represents position with respect to zeroth point for all points under PriceInsightsGraphDatae.g. Having 10 points, 5th point will have offSet 5 and so on. It doesn't matter first 4 points were solid,dotted or marker point */
  offsetHorizontal: Scalars["Int"];
  /** Represents value on vertical axis */
  value: Scalars["Int"];
};

/** Union for all the price insights data points */
export type PriceInsightsGraphShading = PriceInsightsGraphShadingHatch | PriceInsightsGraphShadingSolid;

/** Represents a hatched shading area */
export type PriceInsightsGraphShadingHatch = {
  __typename?: "PriceInsightsGraphShadingHatch";
  area: Array<PriceInsightsGraphArea>;
};

/** Represents a solid shading area */
export type PriceInsightsGraphShadingSolid = {
  __typename?: "PriceInsightsGraphShadingSolid";
  area: Array<PriceInsightsGraphArea>;
};

/** Represent the dialog button action */
export type PriceInsightsRetryTrackingDialogButtonAction = UiAction & {
  __typename?: "PriceInsightsRetryTrackingDialogButtonAction";
  accessibility?: Maybe<Scalars["String"]>;
  /** Custom action type to determine which type of case to try again. */
  actionType: DialogButtonActionType;
  analytics: ClientSideAnalytics;
};

/** Represent search context for all product lines */
export interface PriceInsightsSearchContextInput {
  carSearchCriteria?: InputMaybe<CarSearchCriteriaInput>;
  flightSearchCriteria?: InputMaybe<FlightSearchCriteriaInput>;
  propertySearchCriteria?: InputMaybe<PropertySearchCriteriaInput>;
}

export type PriceInsightsSubscriptionSeenAction = {
  __typename?: "PriceInsightsSubscriptionSeenAction";
  accessibility?: Maybe<Scalars["String"]>;
  priceValue: Scalars["String"];
  subscriptionId: Scalars["String"];
};

/** Represent the text based price insights card content elements */
export type PriceInsightsTextBasedContent = PriceInsightsCardContent & {
  __typename?: "PriceInsightsTextBasedContent";
  /**
   * Represents the accessibility content
   * @deprecated Changed to optIn and optOut accessibility content
   */
  accessibility?: Maybe<ClientAccessibility>;
  /** Represent the horizontal and vertical labels for the text based content */
  legend: PriceInsightsGraphLegend;
  /**
   * Represent the message for the text based content
   * @deprecated This will be replaced by optInMessage and optOutMessage
   */
  message: EgdsIconText;
  /** Represent the opt in message for the text based content */
  optInCardMessage: PriceInsightsCardMessage;
  /**
   * Represent the opt in message for the text based content
   * @deprecated Changed to provide accessibility
   */
  optInMessage: EgdsIconText;
  /** Represent the opt in message for the text based content */
  optOutCardMessage: PriceInsightsCardMessage;
  /**
   * Represent the opt out message for the text based content
   * @deprecated Changed to provide accessibility
   */
  optOutMessage: EgdsIconText;
};

/** Used to align a set of cards horizontally with a scrolling effect. The recommended card to use is `PriceInsightsTrackingCard` */
export type PriceInsightsTrackingCarouselContainer = {
  __typename?: "PriceInsightsTrackingCarouselContainer";
  elements: Array<PriceInsightsCarouselTrackingCard>;
  heading?: Maybe<Scalars["String"]>;
};

export type PriceInsightsTrackingLivePrice = PriceInsightsAnalytics & {
  __typename?: "PriceInsightsTrackingLivePrice";
  displayAnalyticsList?: Maybe<Array<ClientSideImpressionEventAnalytics>>;
  egcsDisplayAnalyticsList?: Maybe<Array<EgClickstreamEvent>>;
  egcsOnClickAnalyticsList?: Maybe<Array<EgClickstreamEvent>>;
  /** Last seen price label */
  lastSeenPriceLabel?: Maybe<EgdsText>;
  /** Live price with increase/decrease indicator. If no change in price then EGDSStylizedText will be used else EGDSIconText will be used. */
  livePriceLabel?: Maybe<EgdsText>;
  /** Error label that can be used in case of failure during live price fetch */
  livePriceUnavailableLabel?: Maybe<EgdsIconText>;
  onClickAnalyticsList?: Maybe<Array<ClientSideAnalytics>>;
  /** Action to update the last seen price back to server */
  seenAction?: Maybe<PriceInsightsSubscriptionSeenAction>;
  subscriptionId: Scalars["String"];
};

/** Represent the retry dialog box when mutation fails (Applicable for all 3 - Create, Disable, Update). */
export type PriceInsightsTrackingRetryDialogAction = EgdsDialog &
  PriceInsightsTrackingToggleAction & {
    __typename?: "PriceInsightsTrackingRetryDialogAction";
    accessibility?: Maybe<Scalars["String"]>;
    closeAnalytics?: Maybe<ClientSideAnalytics>;
    /** Description on the dialog related to the error. */
    content: Scalars["String"];
    /** Footer with buttons. for eg: Cancel and Retry */
    dialogFooter: EgdsInlineDialogFooter;
    displayAnalytics?: Maybe<ClientSideImpressionEventAnalytics>;
    /** Represent heading for the dialog */
    heading: Scalars["String"];
    /** Represents paragraph corresponding to the dialog */
    paragraph: Scalars["String"];
  };

/** Switch to toggle on/off price alerts */
export type PriceInsightsTrackingToggle = UiToggle & {
  __typename?: "PriceInsightsTrackingToggle";
  checked: Scalars["Boolean"];
  checkedAccessibilityDescription?: Maybe<Scalars["String"]>;
  checkedAccessibilityLabel?: Maybe<Scalars["String"]>;
  checkedAnalytics?: Maybe<ClientSideAnalytics>;
  checkedDescription: Scalars["String"];
  checkedLabel: Scalars["String"];
  /** Represents the EGCS checked analytics of the component */
  egcsCheckedAnalytics?: Maybe<EgClickstreamEvent>;
  /** Represents the EGCS unchecked analytics of the component */
  egcsUnCheckedAnalytics?: Maybe<EgClickstreamEvent>;
  enabled: Scalars["Boolean"];
  label: Scalars["String"];
  /** Action client needs to take when switch turns to OFF state */
  toggleOffAction: PriceInsightsTrackingToggleOffAction;
  /** Action client needs to take when switch turns to ON state */
  toggleOnAction: PriceInsightsTrackingToggleOnAction;
  uncheckedAccessibilityDescription?: Maybe<Scalars["String"]>;
  uncheckedAccessibilityLabel?: Maybe<Scalars["String"]>;
  uncheckedAnalytics?: Maybe<ClientSideAnalytics>;
  uncheckedDescription: Scalars["String"];
  uncheckedLabel: Scalars["String"];
};

export interface PriceInsightsTrackingToggleAction {
  accessibility?: Maybe<Scalars["String"]>;
}

/** Represent the subscription mutation which client will call */
export type PriceInsightsTrackingToggleOffAction = ClientSideErrorRepresentation &
  PriceInsightsTrackingToggleAction & {
    __typename?: "PriceInsightsTrackingToggleOffAction";
    accessibility?: Maybe<Scalars["String"]>;
    analytics: ClientSideAnalytics;
    clientSideErrorRepresentationAction?: Maybe<PriceInsightsTrackingRetryDialogAction>;
    clientSideErrorRepresentationDialog?: Maybe<ClientSideErrorRepresentationDialog>;
    /** Represents the price on which subscription needs to be created */
    priceShown: Scalars["String"];
    /** Client needs to pass only subscription id while calling mutation */
    subscriptionId: Scalars["String"];
  };

export type PriceInsightsTrackingToggleOnAction =
  | PriceInsightsExistingTrackingDialogAction
  | UiCreatePriceInsightsTrackingAction
  | UiValidateTravelerLoggedInAction;

/** Represents create/update/disable price insights response */
export type PriceInsightsTrackingView = {
  __typename?: "PriceInsightsTrackingView";
  /** Represents the updated price alert switch. Used to reconcile UI in case of a failure to update status */
  priceTrackingToggle?: Maybe<PriceInsightsTrackingToggle>;
  /** Represent the retry dialog box when mutation fails (Applicable for all 3 - Create, Disable, Update). */
  retryTrackingDialog?: Maybe<PriceInsightsTrackingRetryDialogAction>;
  /** Represents the result of opting the user in of price alerts.Example: 'You'll receive push notification when prices change for this search' */
  toast?: Maybe<EgdsToast>;
};

/** Represents a badge that indicates a saving or branded deal */
export type PriceLineBadge = {
  __typename?: "PriceLineBadge";
  badge?: Maybe<EgdsStandardBadge>;
};

/** Represents a line item that is header */
export type PriceLineHeading = {
  __typename?: "PriceLineHeading";
  additionalInfo?: Maybe<AdditionalInformationPopover>;
  icon?: Maybe<Icon>;
  primary: Scalars["String"];
  size: Scalars["String"];
  tag: Scalars["String"];
};

/** Represents a line item that is text */
export type PriceLineText = {
  __typename?: "PriceLineText";
  additionalInfo?: Maybe<AdditionalInformationPopover>;
  /** Represents visual assets Icons, Illustrations, and Marks which can be used interchangeably */
  graphic?: Maybe<UiGraphic>;
  /** @deprecated Use `graphic` instead. */
  icon?: Maybe<Icon>;
  primary: Scalars["String"];
  theme?: Maybe<TextTheme>;
  weight?: Maybe<TextWeight>;
};

export type PriceMatchPromiseChartType = "BAR" | "LINE";

export type PriceMatchPromiseDetails = {
  __typename?: "PriceMatchPromiseDetails";
  /**
   * Heading of the page
   * @deprecated change element type, replace with headingCopy
   */
  heading?: Maybe<EgdsHeading>;
  /** Heading of the page */
  headingCopy?: Maybe<Array<EgdsComposableTextElement>>;
  /** Information about the PMP product, and links to it's policies, faqs, etc. */
  infoSection?: Maybe<PriceMatchPromiseInfo>;
  /** KrazyGlue script url to use for cross sell functionality */
  krazyGlueScriptUrl?: Maybe<Scalars["String"]>;
  /** Manual price check section, containing a button to perform a manual price check */
  manualPriceCheck?: Maybe<ManualPriceCheckSection>;
  /** In case of failures to prepare PMP details, this message will be populated */
  message?: Maybe<PriceMatchPromiseMessage>;
  /** Price history section, data represented as chart, list or both */
  priceCheckHistory?: Maybe<PriceCheckHistory>;
  /** Recap of the latest updates related to Price Match Promise, i.e.: latest updates, current prices, etc. */
  recap?: Maybe<PriceMatchPromiseRecap>;
  /** contain pmp trip base64 data related to PMP */
  tripContextToken?: Maybe<Scalars["String"]>;
};

export type PriceMatchPromiseHistoryChart = {
  __typename?: "PriceMatchPromiseHistoryChart";
  /** The type of the chart, e.g.: 'LINE */
  chartType: PriceMatchPromiseChartType;
  /** The list of data that will be charted */
  data: Array<PriceMatchPromiseHistoryChartDataPoint>;
  /** The formatting pattern for horizontal labels, e.g.: 'MMM dd' can be used with date values for formatting */
  horizontalLabelFormatter?: Maybe<Scalars["String"]>;
  /** The type of the horizontal scale, e.g.: 'TIME */
  horizontalScaleType: PriceMatchPromiseScaleType;
  /** The formatting pattern for values' labels, e.g.: '{value}$' will result in '100$' as a value label */
  verticalValueFormatter?: Maybe<Scalars["String"]>;
};

export type PriceMatchPromiseHistoryChartDataPoint = {
  __typename?: "PriceMatchPromiseHistoryChartDataPoint";
  /** The X part of the data point */
  x: Scalars["String"];
  /** The Y part of the data point */
  y: Scalars["String"];
};

export type PriceMatchPromiseHistoryList = {
  __typename?: "PriceMatchPromiseHistoryList";
  /** The highlight of the price checks history list, e.g.: '' */
  highlight?: Maybe<PriceMatchPromiseHistoryListHighlight>;
  /** The list of price check history events */
  priceChecks: Array<PriceMatchPromiseHistoryListItem>;
  /** The link for show less in the list view */
  showLessAction?: Maybe<EgdsStandardLink>;
  /** The link for show more in the list view */
  showMoreAction?: Maybe<EgdsStandardLink>;
};

export type PriceMatchPromiseHistoryListHighlight = {
  __typename?: "PriceMatchPromiseHistoryListHighlight";
  /** The heading of the highlight will show in banner */
  heading: Scalars["String"];
  /** The message of the highlight will show in banner */
  message: Scalars["String"];
};

export type PriceMatchPromiseHistoryListItem = {
  __typename?: "PriceMatchPromiseHistoryListItem";
  /** A list of the other price check events that occurred in the same day */
  additionalPriceChecks?: Maybe<Array<PriceMatchPromiseHistoryListItem>>;
  /** The link to the dialog that will display the other price checks for the day */
  additionalPriceChecksDialogTitle?: Maybe<Scalars["String"]>;
  /** The link to the dialog that will display the other price checks for the day */
  additionalPriceChecksLink?: Maybe<EgdsStandardLink>;
  /** Textual elements that are part of the highlight */
  copy: Array<EgdsComposableTextElement>;
  /** If applicable, the delta in price related to this highlight */
  priceDelta?: Maybe<PriceMatchPromisePriceDelta>;
};

export type PriceMatchPromiseInfo = {
  __typename?: "PriceMatchPromiseInfo";
  /** Text content of the information section */
  copy: Array<EgdsComposableTextElement>;
  /** Heading of the information section */
  heading: EgdsHeading;
  /** List of links that contain information about PMP, polcies, faqs? etc. */
  links?: Maybe<EgdsLinkList>;
};

export type PriceMatchPromiseLoader = {
  __typename?: "PriceMatchPromiseLoader";
  /** The message of the loader */
  copy?: Maybe<Array<EgdsComposableTextElement>>;
};

export type PriceMatchPromiseMessage = {
  __typename?: "PriceMatchPromiseMessage";
  /** The body text of the message, formed of at least one composable text element */
  copy?: Maybe<Array<EgdsComposableTextElement>>;
  /** The icon reflecting the meaning of the message body, e.g.: error icon, info icon */
  icon?: Maybe<Icon>;
};

export type PriceMatchPromisePriceDelta = {
  __typename?: "PriceMatchPromisePriceDelta";
  /** An icon illustrating the delta in price, e.g.: up/down-arrow */
  icon?: Maybe<Icon>;
  /** Formatted price delta value */
  price: Scalars["String"];
};

export type PriceMatchPromisePriceHighlight = {
  __typename?: "PriceMatchPromisePriceHighlight";
  /** Text to be displayed below the price value, e.g. 'Original Flight Price' */
  description?: Maybe<Scalars["String"]>;
  /** Formatted price value */
  price: Scalars["String"];
  /** Text theme e.g. positive  */
  textTheme?: Maybe<TextTheme>;
};

export type PriceMatchPromisePriceHighlightsSection = {
  __typename?: "PriceMatchPromisePriceHighlightsSection";
  /** Text that contains information related to the Price Highlights section */
  copy?: Maybe<EgdsSpannableText>;
  /** A list of price highlights, e.g.: original price, current price */
  priceHighlights?: Maybe<Array<PriceMatchPromisePriceHighlight>>;
};

export type PriceMatchPromiseRecap = {
  __typename?: "PriceMatchPromiseRecap";
  /** Text text content of the recap section */
  copy?: Maybe<Array<EgdsComposableTextElement>>;
  /**
   * A list of price highlights, e.g.: original price, current price
   * @deprecated This will be replaced with  priceHighlightsSection
   */
  priceHighlights?: Maybe<Array<PriceMatchPromisePriceHighlight>>;
  /** A section containing the most important highlights in the prices, e.g.; Original Price, Current Price */
  priceHighlightsSection?: Maybe<PriceMatchPromisePriceHighlightsSection>;
};

export type PriceMatchPromiseScaleType = "DATE" | "LABEL" | "TIME";

/** A selection card section in selected state to view Price Match Promise in the fare */
export type PriceMatchPromiseSelectedCardSection = {
  __typename?: "PriceMatchPromiseSelectedCardSection";
  /** The description of the card */
  description: Scalars["String"];
  /** The header of the card, e.g., Price Match Promise */
  header: Scalars["String"];
  /** Price Match Promise logo */
  icon: Icon;
  /** Represents onView analytics for a selected pmp card. This will be triggered when this card is visible on the client's viewport */
  onDisplayAnalytics?: Maybe<Array<FlightsAnalytics>>;
  /** The action to remove Price Match Promise */
  removeActionLink?: Maybe<FlightsActionLink>;
};

/** A selection card section in initial state to view Price Match Promise in the fare */
export type PriceMatchPromiseSelectionCardSection = {
  __typename?: "PriceMatchPromiseSelectionCardSection";
  /** The description of the card */
  description: Scalars["String"];
  /** The header of the card, e.g., Price Match Promise */
  header: Scalars["String"];
  /** Price Match Promise logo */
  icon: Icon;
  /** This will render the trigger for the display more information about Price Match Promise dialog */
  infoTrigger?: Maybe<FlightsDialogTrigger>;
  /** Represents onView analytics for a selection pmp card. This will be triggered when this card is visible on the client's viewport */
  onDisplayAnalytics?: Maybe<Array<FlightsAnalytics>>;
  /** Represents the price of Price Match Promise product */
  price?: Maybe<Scalars["String"]>;
  /** The action to apply Price Match Promise */
  toggleCheckbox?: Maybe<FlightsActionCheckbox>;
};

/** Represents the state for the PMP module */
export type PriceMatchPromiseState =
  /** Represents when the PMP module is removable */
  | "REMOVABLE"
  /** Represents when the PMP module is selectable */
  | "SELECTABLE"
  /** Represents when the PMP module is static */
  | "STATIC"
  /** Represents when the PMP module is toggleable */
  | "TOGGLEABLE";

export type PriceMatchPromiseTab = {
  __typename?: "PriceMatchPromiseTab";
  /** Analytics data for the tab */
  analytics?: Maybe<ClientSideAnalytics>;
  /** The label to be used for this tab, it shall be used on the tab button that shows this tab */
  label: Scalars["String"];
  /** Tab data, can be anything that extends the base PriceMatchPromiseTabData interface, e.g.: PriceMatchPromiseHistoryChart, PriceMatchPromiseHistoryList */
  tabData: PriceMatchPromiseTabData;
};

export type PriceMatchPromiseTabData = PriceMatchPromiseHistoryChart | PriceMatchPromiseHistoryList;

export type PriceMatchPromiseToast = {
  __typename?: "PriceMatchPromiseToast";
  /** The message of the toast */
  message: Scalars["String"];
};

/** Represents the switch toggleable pmp card */
export type PriceMatchPromiseToggleableCard = FarePriceMatchPromiseCard & {
  __typename?: "PriceMatchPromiseToggleableCard";
  /** Represents toggleable card content section */
  contentSection: ToggleableCardContentSection;
  /**
   * Represents the header of the pmp card
   * @deprecated Use headingSection instead of header
   */
  header: EgdsGraphicText;
  /**
   * Represents the heading of the pmp card
   * @deprecated Use headingSection instead of heading
   */
  heading: EgdsIconText;
  /** Represents toggleable card heading section */
  headingSection: ToggleableCardHeadingSection;
  /** Represents onView analytics for a toggleable pmp card. This will be triggered when this card is visible on the client's viewport */
  onDisplayAnalytics: Array<ClientSideAnalytics>;
  /** States when this PMP presentation card will be rendered */
  priceMatchPromiseState: PriceMatchPromiseState;
  /**
   * Represents the subheading of the pmp card
   * @deprecated Use subHeading from headingSection instead of subHeading
   */
  subHeading: Scalars["String"];
};

/** Represents the price summary/details containing the various sections and line items to give the customer an idea of what their money is going towards */
export type PricePresentation = {
  __typename?: "PricePresentation";
  footer?: Maybe<PricePresentationFooter>;
  /** @deprecated Use title of type PricePresentationTitle */
  header: PricePresentationHeader;
  sections: Array<PricePresentationSection>;
  title?: Maybe<PricePresentationTitle>;
};

/** Dialog used to display property price details. */
export type PricePresentationDialog = LodgingDialog & {
  __typename?: "PricePresentationDialog";
  toolbar?: Maybe<LodgingDialogToolbar>;
  trigger: LodgingDialogTriggerMessage;
};

/** The footer of the summary typically where any disclaimers are shown */
export type PricePresentationFooter = {
  __typename?: "PricePresentationFooter";
  header?: Maybe<Scalars["String"]>;
  messages: Array<PricePresentationLineItemMessage>;
};

export type PricePresentationHeader = {
  __typename?: "PricePresentationHeader";
  primary: Scalars["String"];
};

/** An individual line item consisting of a name and value representing something like a fee's name and amount */
export type PricePresentationLineItem = {
  __typename?: "PricePresentationLineItem";
  enrichedValue?: Maybe<PricePresentationLineItemEntry>;
  name: PricePresentationLineItemEntry;
  /** @deprecated Use enrichedValue of type PricePresentationLineItemEntry */
  value?: Maybe<PriceLineText>;
};

/** The entry of a line item. This is typically used to describe what the line item is such as the fee name */
export type PricePresentationLineItemEntry = {
  __typename?: "PricePresentationLineItemEntry";
  primaryMessage: PricePresentationLineItemMessage;
  secondaryMessages: Array<PricePresentationLineItemMessage>;
};

/** interface to represent the various line item messages. There can be of various types such as text or a badge */
export type PricePresentationLineItemMessage = InlinePriceLineText | PriceLineBadge | PriceLineHeading | PriceLineText;

/** A section within the price summary. This could be the price breakdown or total section */
export type PricePresentationSection = {
  __typename?: "PricePresentationSection";
  header?: Maybe<PricePresentationLineItem>;
  subSections: Array<PricePresentationSubSection>;
};

/** A subsection of the price summary. This is for smaller groupings within a section */
export type PricePresentationSubSection = {
  __typename?: "PricePresentationSubSection";
  header?: Maybe<PricePresentationLineItem>;
  items: Array<PricePresentationLineItem>;
};

/** Represents the title of the summary */
export type PricePresentationTitle = {
  __typename?: "PricePresentationTitle";
  primary: Scalars["String"];
};

/** Represents a range of prices for filtering properties. Follows currency rules of the user's point of sale */
export type PriceRange = CriteriaRange & {
  __typename?: "PriceRange";
  /** The maximum price, e.g. 500.00 */
  max?: Maybe<Scalars["Float"]>;
  /** The minimum price, e.g. 50.00 */
  min?: Maybe<Scalars["Float"]>;
};

/** Represents a range of prices for filtering properties. Follows currency rules of the user's point of sale */
export interface PriceRangeInput {
  /** The maximum price, e.g. 500.00 */
  max?: InputMaybe<Scalars["Float"]>;
  /** The minimum price, e.g. 50.00 */
  min?: InputMaybe<Scalars["Float"]>;
}

/** This is top node of PriceBreakDown module. */
export type PriceSummary = {
  __typename?: "PriceSummary";
  disclaimers?: Maybe<Array<LodgingEnrichedMessage>>;
  /** @deprecated Use PriceSummarySection::sectionFooter instead */
  footer?: Maybe<PriceSummaryFooter>;
  /** @deprecated Use priceSummaryHeading instead */
  heading: Scalars["String"];
  priceSummaryHeading?: Maybe<LodgingEnrichedMessage>;
  sections: Array<PriceSummarySection>;
};

/** This represents the price summary component */
export type PriceSummaryDetails = {
  __typename?: "PriceSummaryDetails";
  /** This represents list of price summaries. Example: 'Taxes and Fees $999' */
  breakdown: Array<PriceSummaryGroup>;
  /** This represents the button action. Example: GO_TO_CHECKOUT */
  buttonAction: UiPrimaryButton;
  /** This represents the title. Example: 'Price Summary' */
  heading: EgdsText;
  /** This represents the trip total label, price and rate currency message */
  tripTotalDetails: PriceSummaryTripTotal;
};

/** This represents the price summary footer within mobile */
export type PriceSummaryDetailsFooter = {
  __typename?: "PriceSummaryDetailsFooter";
  /** This represents the button action. Example: GO_TO_CHECKOUT */
  buttonAction: UiPrimaryButton;
  /** This represents the heading. Example: '$999' */
  heading: EgdsText;
  /** This represents action for price summary link in collapsed view. Only in mobile. Example: 'View price summary' */
  priceSummaryTrigger: EgdsInlineLink;
  /** This represents the trip total label. Example: Trip Total */
  subHeading: EgdsText;
};

/** This represents the price summary component when is loading */
export type PriceSummaryDetailsFooterSkeletons = {
  __typename?: "PriceSummaryDetailsFooterSkeletons";
  /** This represents the button action. DISABLED. Example: GO_TO_CHECKOUT */
  buttonAction: UiPrimaryButton;
  /** This represents the trip total label. Example: Trip Total */
  subHeading: EgdsText;
};

export type PriceSummaryFooter = {
  __typename?: "PriceSummaryFooter";
  /** @deprecated Use PriceSummary.disclaimers instead */
  disclaimerMessages?: Maybe<Array<LodgingEnrichedMessage>>;
  footerHeading?: Maybe<LodgingEnrichedMessage>;
  footerMessages?: Maybe<Array<LodgingEnrichedMessage>>;
  /** @deprecated Use footerHeading instead */
  heading?: Maybe<Scalars["String"]>;
  /** @deprecated Use footerMessages instead */
  messages?: Maybe<Array<Scalars["String"]>>;
};

/** This represents the price summary per traveler */
export type PriceSummaryGroup = {
  __typename?: "PriceSummaryGroup";
  /** This represents the label and price accessibility. Example: 'Traveler 1: Adult <price>' */
  accessibilityMessage?: Maybe<Scalars["String"]>;
  /** This represents price breakdown per traveler. Example: 'Taxes and Fees  $999' */
  entries: Array<PriceSummaryItem>;
  /** This represents the title information. Example: 'Traveler 1: Adult  $999' */
  heading: EgdsText;
  /** This represents the price for charge type. Example: $999.0 */
  price: EgdsText;
};

/** This represents label and price for price summary item */
export type PriceSummaryItem = {
  __typename?: "PriceSummaryItem";
  /** This represents the label and price accessibility. Example: 'Traveler 1: Adult <price>' */
  accessibilityMessage?: Maybe<Scalars["String"]>;
  /** This represents the label for charge type. Example: Taxes and fees */
  concept: EgdsText;
  /** This represents the price for charge type. Example: $999.0 */
  price: EgdsText;
};

export type PriceSummaryLineItem = {
  __typename?: "PriceSummaryLineItem";
  name: PriceSummaryLineItemEntry;
  value: PriceSummaryLineItemEntry;
};

export type PriceSummaryLineItemEntry = {
  __typename?: "PriceSummaryLineItemEntry";
  /** @deprecated Use primaryMessage instead */
  primary: Scalars["String"];
  primaryMessage: LodgingEnrichedMessage;
  /** @deprecated Use secondaryMessages instead */
  secondary?: Maybe<Array<Scalars["String"]>>;
  secondaryMessages?: Maybe<Array<LodgingEnrichedMessage>>;
};

export type PriceSummarySection = {
  __typename?: "PriceSummarySection";
  /** @deprecated Use sectionFooter instead */
  footer?: Maybe<PriceSummaryLineItem>;
  /** @deprecated Use priceSummaryHeading instead */
  heading?: Maybe<Scalars["String"]>;
  items: Array<PriceSummaryLineItem>;
  sectionFooter?: Maybe<PriceSummaryFooter>;
  sectionHeading?: Maybe<LodgingEnrichedMessage>;
};

/** This represents the price summary component when is loading */
export type PriceSummarySkeletons = {
  __typename?: "PriceSummarySkeletons";
  /** This represents the button action. DISABLED. Example: GO_TO_CHECKOUT */
  buttonAction: UiPrimaryButton;
  /** This represents the title. Example: 'Price Summary' */
  heading: EgdsText;
};

/** This represents the trip total details */
export type PriceSummaryTripTotal = {
  __typename?: "PriceSummaryTripTotal";
  /** This represents the label and price accessibility. Example: 'Traveler 1: Adult <price>' */
  accessibilityMessage?: Maybe<Scalars["String"]>;
  /** This represents the currency message below the trip total. Example: 'Rates are quoted in US dollars' */
  ratesCurrencyText: EgdsText;
  /** This represents the trip total label and price. Example: 'Trip Total -  $999'  */
  tripTotal: PriceSummaryItem;
};

export type PriceSupportingMessages = {
  __typename?: "PriceSupportingMessages";
  /** Displays nightly price */
  nightlyPriceMessage?: Maybe<Scalars["String"]>;
  /** Displays total for X nights */
  totalForNightsMessage?: Maybe<Scalars["String"]>;
  /** The formatted price message to display on the card */
  totalPriceMessage: Scalars["String"];
};

export type PriceViewModel = {
  __typename?: "PriceViewModel";
  leadPrice?: Maybe<Scalars["String"]>;
  priceSubtext: PriceSupportingMessages;
};

export type PricingScheme = {
  __typename?: "PricingScheme";
  type: PricingSchemeType;
};

export type PricingSchemeType = "DAILY_RATE" | "TOTAL_RATE";

export type PrimaryActivitiesCriteria = {
  __typename?: "PrimaryActivitiesCriteria";
  dateRange?: Maybe<ActivityDateRange>;
  destination?: Maybe<ActivityDestination>;
  filters?: Maybe<Array<ActivityFilter>>;
  pinnedActivityIds?: Maybe<Array<Scalars["String"]>>;
  selectedOffers?: Maybe<Array<ActivityOfferNaturalKey>>;
};

/** The core criteria needed for a car search */
export type PrimaryCarCriteria = {
  __typename?: "PrimaryCarCriteria";
  dropOffDateTime: DateTime;
  dropOffLocation?: Maybe<CarRentalLocation>;
  pickUpDateTime: DateTime;
  pickUpLocation: CarRentalLocation;
};

/** The core criteria needed for a car search */
export interface PrimaryCarCriteriaInput {
  dropOffDateTime: DateTimeInput;
  dropOffLocation?: InputMaybe<CarRentalLocationInput>;
  pickUpDateTime: DateTimeInput;
  pickUpLocation: CarRentalLocationInput;
}

/** The core criteria needed for a cruise search */
export interface PrimaryCruiseCriteriaInput {
  adultCount?: InputMaybe<Scalars["Int"]>;
  childCount?: InputMaybe<Scalars["Int"]>;
  children?: InputMaybe<Array<CruiseChildInput>>;
  departureDateRange?: InputMaybe<DateRangeInput>;
  destinations?: InputMaybe<Array<Scalars["String"]>>;
  durationRange?: InputMaybe<CruiseDurationRangeInput>;
}

/** Represents the core criteria needed for a flight search */
export type PrimaryFlightCriteria = {
  __typename?: "PrimaryFlightCriteria";
  journeyCriterias: Array<FlightsJourneyCriteria>;
  searchPreferences?: Maybe<FlightsSearchPreferences>;
  travelers: Array<TravelerDetails>;
  tripType: FlightsTripType;
};

/** Represents the core criteria needed for a flight search */
export interface PrimaryFlightCriteriaInput {
  journeyCriterias: Array<FlightsJourneyCriteriaInput>;
  searchPreferences?: InputMaybe<FlightsSearchPreferencesInput>;
  travelers: Array<TravelerDetailsInput>;
  tripType: FlightsTripType;
}

/** The core criteria needed for a ground transfers or air transportation search */
export type PrimaryGroundTransfersCriteria = {
  __typename?: "PrimaryGroundTransfersCriteria";
  /** @deprecated Use journeyCriteria instead */
  dateRange: OptionalDateTimeRange;
  /** @deprecated Use journeyCriteria instead */
  direction: GroundTransfersDirection;
  journeyCriteria?: Maybe<Array<GroundTransfersJourneyCriteria>>;
  /** @deprecated Use journeyCriteria instead */
  locations: Array<GroundTransfersLocation>;
  /** @deprecated Use pinnedOfferIds instead */
  pinnedOffers?: Maybe<Array<GroundTransfersNaturalKey>>;
  pinnedProductIds?: Maybe<Array<Scalars["String"]>>;
  selectedOffers?: Maybe<Array<GroundTransfersNaturalKey>>;
  shoppingPath?: Maybe<ShoppingPathType>;
  travelerDetails: Array<GroundTransfersTravelerDetails>;
};

/** The core criteria needed for a ground transfers or air transportation search */
export interface PrimaryGroundTransfersCriteriaInput {
  dateRange: OptionalDateTimeRangeInput;
  direction: GroundTransfersDirection;
  journeyCriteria?: InputMaybe<Array<GroundTransfersJourneyCriteriaInput>>;
  locations: Array<GroundTransfersLocationInput>;
  pinnedOffers?: InputMaybe<Array<GroundTransfersNaturalKeyInput>>;
  pinnedProductIds?: InputMaybe<Array<Scalars["String"]>>;
  selectedOffers?: InputMaybe<Array<GroundTransfersNaturalKeyInput>>;
  shoppingPath?: InputMaybe<ShoppingPathType>;
  travelerDetails: Array<GroundTransfersTravelerDetailsInput>;
}

export type PrimaryModule = {
  __typename?: "PrimaryModule";
  bodyCopy: Scalars["String"];
  ctaLink: Scalars["String"];
  ctaText?: Maybe<Scalars["String"]>;
  disclaimerInlineLink: Scalars["String"];
  disclaimerInlineLinkText: Scalars["String"];
  disclaimerText?: Maybe<Scalars["String"]>;
  headline: Scalars["String"];
};

/** Playback of the user entered search criteria for packages */
export type PrimaryPackageSearchCriteria = {
  __typename?: "PrimaryPackageSearchCriteria";
  /** Cabin class chosen for flight */
  cabinClass?: Maybe<FlightsCabinClass>;
  dateRange?: Maybe<DateRange>;
  destination?: Maybe<PackageLocation>;
  origin?: Maybe<PackageLocation>;
  travelerOccupancyGroups?: Maybe<Array<TravelerOccupancyGroup>>;
};

export interface PrimaryPackageSearchCriteriaInput {
  /** Cabin class chosen for flight */
  cabinClass?: InputMaybe<FlightsCabinClass>;
  /** If not provided, packages returned will be for different duration and popular advance purchase window based on the themes */
  dateRange?: InputMaybe<DateRangeInput>;
  /** If not provided, packages returned will be for different popular destinations based on the themes */
  destination?: InputMaybe<PackageLocationInput>;
  /** If not provided, it will be resolved using user profile or ip sniffing */
  origin?: InputMaybe<PackageLocationInput>;
  /** If not provided, it will be defaulted to 1 occupancy unit for 2 adults */
  travelerOccupancyGroups?: InputMaybe<Array<TravelerOccupancyGroupInput>>;
}

/** The core criteria needed for a property search */
export type PrimaryPropertyCriteria = {
  __typename?: "PrimaryPropertyCriteria";
  dateRange?: Maybe<PropertyDateRange>;
  destination: Destination;
  flexSearchCriteria?: Maybe<FlexibleSearchCriteria>;
  rooms: Array<Room>;
};

/** The core criteria needed for a property search */
export interface PrimaryPropertyCriteriaInput {
  dateRange?: InputMaybe<PropertyDateRangeInput>;
  destination: DestinationInput;
  flexSearchCriteria?: InputMaybe<FlexibleSearchCriteriaInput>;
  rooms: Array<RoomInput>;
}

/** User preference for data sharing with third parties which users may update */
export type PrivacySellState = "CAN_NOT_SELL" | "CAN_SELL";

/** Privacy tracking user preference. We can retrieve info on if the site allows tracking from Site Info and null can also be used to represent a selection or not */
export type PrivacyTrackingState = "CAN_NOT_TRACK" | "CAN_TRACK";

/** Section that contains all the attributes related to product */
export type ProductAmenitiesSection = ProductDetailsElement & {
  __typename?: "ProductAmenitiesSection";
  /** List that contains attribute Icon along with its title and description */
  amenities: EgdsTextIconList;
  elementID: Scalars["String"];
  /** Contains the title of the amenities section along with information about its theme */
  title?: Maybe<EgdsStylizedText>;
};

/** Section that contains all the attributes related to product */
export type ProductAttributesSection = ProductDetailsElement & {
  __typename?: "ProductAttributesSection";
  /** List that contains attribute Icon along with its title and description */
  attributes: EgdsTextIconList;
  elementID: Scalars["String"];
};

/** Section that contains all the benefits related to product */
export type ProductBenefitsSection = OfferCardUnit &
  ProductDetailsElement & {
    __typename?: "ProductBenefitsSection";
    /** List that contains all the benefits related to the product */
    benefits: Array<EgdsStylizedText>;
    elementID: Scalars["String"];
  };

/** Return PropertyCarouselContainer type */
export type ProductCarouselContainer = LodgingCarouselContainer;

export type ProductCarouselResults = {
  __typename?: "ProductCarouselResults";
  carousels: Array<ProductCarouselContainer>;
};

export type ProductDetails = {
  __typename?: "ProductDetails";
  /** Footer contains information about the supplier */
  footer?: Maybe<SupplierInformation>;
  /** The header contains the title of the product, image and features of the product */
  header: ProductInformation;
  /** Section contains the travel schedule and any additional information at the airport */
  section: Array<TravelScheduleLeg>;
};

/** UI Element to build a particular section of product details. All the different section of product details must Implement this. */
export interface ProductDetailsElement {
  /** Element unique identifier. Uses include handling diffs for UI updates and identifying the source of data for user input fields */
  elementID: Scalars["String"];
}

/** Header section for the product details module */
export type ProductDetailsHeader = {
  __typename?: "ProductDetailsHeader";
  /** Contains description / sub-title that will be shown in header of product details module */
  description?: Maybe<Scalars["String"]>;
  /** Contains Image section that will be shown in header of product details module */
  headerImage?: Maybe<ProductImage>;
  /** Contains heading that will be shown in header of product details module */
  heading?: Maybe<EgdsHeading>;
  /** @deprecated Deprecated for type 'ProductImage' to support width, replace with headerImage */
  image?: Maybe<Image>;
  /** Contains review information that will be shown in header of product details module */
  rating?: Maybe<EgdsProductRatingSummary>;
};

/** Wrapping type for product details module. Contains header and section */
export type ProductDetailsLayout = {
  __typename?: "ProductDetailsLayout";
  body?: Maybe<Array<ProductDetailsElement>>;
  elements: Array<Maybe<ProductDetailsElement>>;
  footer: Array<Maybe<ProductDetailsElement>>;
  header: ProductDetailsHeader;
};

/** Definition for Product Details Image Type */
export type ProductImage = {
  __typename?: "ProductImage";
  /** Contains Image description of the Product Image */
  altText?: Maybe<Scalars["String"]>;
  /** Contains aspectRatio of the Product Image */
  aspectRatio?: Maybe<AspectRatio>;
  /** Contains URL of the Product Image */
  url?: Maybe<Scalars["URL"]>;
  /** Contains Image width of the Product Image */
  width?: Maybe<ProductImageWidth>;
};

/** Enum to specify image width for product image */
export type ProductImageWidth = "FULL_WIDTH" | "HALF_WIDTH" | "QUARTER_WIDTH" | "THIRD_WIDTH";

/** Product-specific shortlist info */
export interface ProductInfo {
  type?: Maybe<ProductType>;
}

export type ProductInformation = {
  __typename?: "ProductInformation";
  /** The attributes and features of the product */
  attributes: Array<EgdsIconText>;
  /** The image of the product */
  image: Array<Image>;
  /** The title of the product */
  title: EgdsStylizedText;
};

export type ProductLine =
  | "ACTIVITY"
  | "CAR"
  | "CRUISE"
  | "FLIGHT"
  | "GROUND_TRANSFER"
  | "INSURANCE"
  | "LODGING"
  | "PACKAGE"
  | "PRODUCT_LINE_INVALID"
  | "RAIL"
  | "UNRECOGNIZED";

export type ProductListResponse = {
  __typename?: "ProductListResponse";
  elements: Array<EgdsSectionContainer>;
};

/** This represents the listings data */
export type ProductListings = {
  __typename?: "ProductListings";
  /** Placeholder for inner properties */
  text: Scalars["String"];
};

/** This represents the listings skeletons data */
export type ProductListingsSkeletons = {
  __typename?: "ProductListingsSkeletons";
  /** Placeholder for inner properties */
  text: Scalars["String"];
};

/** Marker Interface for every LOBs natural key output class. */
export type ProductNaturalKey =
  | ActivityNaturalKey
  | CarNaturalKey
  | FlightNaturalKey
  | GroundTransfersNaturalKey
  | PackageNaturalKey
  | PropertyNaturalKey;

/** Section that contains all the policies related to product */
export type ProductPoliciesSection = ProductDetailsElement & {
  __typename?: "ProductPoliciesSection";
  /** Contains policy title along with a tooltip containing more detailed information about policy */
  details?: Maybe<ProductTextInfoSection>;
  elementID: Scalars["String"];
  /** Contains policy description */
  policyDescription?: Maybe<Scalars["String"]>;
  /**
   * Contains policy title along with a tooltip containing more detailed information about policy
   * @deprecated Deprecated to support icon and tooltip too, replace with details
   */
  policyDetails: PolicyDetailsSection;
};

/** Attributes for Product policy(eg: car, hotels, insurance etc.) */
export type ProductPolicy = {
  __typename?: "ProductPolicy";
  policySection: PolicySection;
  productLogoUrl?: Maybe<Scalars["String"]>;
  productName: Scalars["String"];
  productSummary?: Maybe<Scalars["String"]>;
};

/** Question And Answer Search filters */
export interface ProductQuestionFiltersInput {
  /** Filter Questions and Answers on the basis of this keyword */
  searchTerm?: InputMaybe<Scalars["String"]>;
}

export type ProductQuestionTopic = "HOTEL";

/** Response of QuestionsAnswers Api */
export type ProductQuestions = {
  __typename?: "ProductQuestions";
  /** List of Questions */
  questions: Array<UserQuestion>;
  /** Total number of Questions present for the filter applied */
  totalCount?: Maybe<FormattedNumber>;
};

/** Represents the UI for the link and the action that needs to be performed when user clicks on the link on Product Rating block message. */
export type ProductRatingLink = {
  __typename?: "ProductRatingLink";
  action: ProductRatingShowTextAction;
  link: EgdsStandardLink;
};

/**
 * Action for showing a text.
 * The UI for this is decided by the client. This is an area where we've chosen to follow the conventions of each platform,
 * because users will be familiar with that pattern across the spectrum of apps they use.
 * Eg for Native it can be shown in a dialog where as in PWA it will be a popover.
 */
export type ProductRatingShowTextAction = {
  __typename?: "ProductRatingShowTextAction";
  /**
   * This represents the disclaimer text
   * Eg. We verify reviews to ensure the traveler booked with Expedia Group.
   * We publish all reviews, positive or negative, that meet our guidelines.
   */
  text: Scalars["String"];
};

/**
 * This represents the rating summary block, that can be used to display any product rating summary.
 * A product can be an activity / Property / Car etc.
 * Figma: https://www.figma.com/file/ahZ2mxMm5Y8X0l9hoBapCF/Product-reviews?node-id=1%3A2
 */
export type ProductRatingSummary = {
  __typename?: "ProductRatingSummary";
  /** Represents the accessibility label for the component. Eg Rated 4.5 out of 5 with a total of 4 thousand 635 reviews */
  accessibilityLabel?: Maybe<Scalars["String"]>;
  /** Represents the content with highest priority. Eg 4.5 */
  primary?: Maybe<Scalars["String"]>;
  /** Represents the content with second most highest priority. Eg Excellent */
  secondary?: Maybe<Scalars["String"]>;
  /**
   * Represents messages in support of rating summary.
   *         Eg a link with text \"verified reviews\" which opens up the disclaimer dialog.
   *         Eg a plain text \"126 reviews\" representing the number of reviews for a product.
   */
  supportingMessages: Array<ProductRatingSupportingMessage>;
};

/**
 * Represents a message in support of rating summary."
 *                  Eg a link with text \"verified reviews\" which opens up the disclaimer dialog Or
 *                  a plain text \"126 reviews\" representing the number of reviews for a product.
 */
export type ProductRatingSupportingMessage = EgdsPlainText | ProductRatingLink;

export type ProductSectionHeading = EgdsSectionHeading & {
  __typename?: "ProductSectionHeading";
  heading: EgdsHeading;
  subheading?: Maybe<Scalars["String"]>;
};

export type ProductSummaryCard = EgdsElement & {
  __typename?: "ProductSummaryCard";
  description: Scalars["String"];
  egdsElementId: Scalars["String"];
  id: Scalars["Int"];
  name: Scalars["String"];
};

/** Input to productSummary Query */
export interface ProductSummaryInput {
  /** Identifier String of Input */
  id: Scalars["String"];
  /** Identifier Type of Input */
  idType: IdentifierType;
}

/** Section that contains all the information about the supplier of the product */
export type ProductSupplierSection = ProductDetailsElement & {
  __typename?: "ProductSupplierSection";
  /** Contains info about supplier name/ type */
  description?: Maybe<Scalars["String"]>;
  elementID: Scalars["String"];
  /** Contains info about supplier logo */
  logo: Image;
};

/** Section that contains all the information required to build tooltip */
export type ProductTextInfoSection = {
  __typename?: "ProductTextInfoSection";
  /** Accessibility text for the policy section */
  policyA11yText?: Maybe<Scalars["String"]>;
  /** Contains the title of the policy along with information about its theme */
  title: EgdsStylizedText;
  /** Contains the content that will be shown inside tooltip */
  tooltipContent?: Maybe<Array<Scalars["String"]>>;
  /** Contains the information about tooltip icon (i) along with its theme, size */
  tooltipIcon?: Maybe<Icon>;
};

/** Section that contains all the travel schedules / information related to product */
export type ProductTravelScheduleSection = ProductDetailsElement & {
  __typename?: "ProductTravelScheduleSection";
  /** Contains all the subtexts of the travel section */
  bulletins?: Maybe<Array<Maybe<ProductTextInfoSection>>>;
  elementID: Scalars["String"];
  /** Contains the travel section label */
  label: EgdsStylizedText;
  /**
   * Contains all the subtexts of the travel section
   * @deprecated Deprecated to support icon and tooltip too, replace with bulletins
   */
  messages: Array<EgdsStylizedText>;
};

export type ProductType =
  | "ARTICLE"
  | "CAR_DETAILS"
  | "DESTINATION"
  | "DESTINATION_EXPERIENCE"
  | "EXPERIENCE"
  | "EXPERT_TIP"
  | "FLIGHT_SEARCH"
  | "LX_DETAILS"
  | "NEIGHBORHOOD"
  | "POI_GAIA"
  | "PROPERTY_DETAILS";

/** Represents a bottom sheet containing form elements. */
export type ProfileAccountFormBottomSheetComponent = {
  __typename?: "ProfileAccountFormBottomSheetComponent";
  bottomSheetElements: Array<ProfileBottomSheetElement>;
  impressionAnalytics?: Maybe<ClientSideImpressionEventAnalytics>;
};

/** A UI element which may be included in a centered account form */
export type ProfileAccountFormCenteredElement = UiEmptyState;

/** Represents a centered vertical list of form elements. */
export type ProfileAccountFormCenteredVerticalComponent = {
  __typename?: "ProfileAccountFormCenteredVerticalComponent";
  centeredElements: Array<ProfileAccountFormCenteredElement>;
  impressionAnalytics?: Maybe<ClientSideImpressionEventAnalytics>;
};

/** Represents top-level account UI component */
export type ProfileAccountFormComponent =
  | ProfileAccountFormBottomSheetComponent
  | ProfileAccountFormCenteredVerticalComponent
  | ProfileAccountFormVerticalComponent
  | ProfileActionDialogComponent
  | ProfilePopUiToRoot
  | ProfilePresentUi
  | ProfilePushUi;

/** Represents UI components that can be content in a navigation flow */
export type ProfileAccountFormContent =
  | ProfileAccountFormBottomSheetComponent
  | ProfileAccountFormCenteredVerticalComponent
  | ProfileAccountFormVerticalComponent
  | ProfileActionDialogComponent;

/** A UI element which may be included in an account form */
export type ProfileAccountFormElement =
  | EgdsBasicSelect
  | EgdsCheckBoxGroup
  | EgdsErrorSummary
  | EgdsHeading
  | EgdsParagraph
  | EgdsTypeaheadInputField
  | ProfileAccountFormSectionContainer
  | ProfileEgdsSectionContainer
  | ProfileFormSection
  | ProfileSlimCard
  | UiEmptyState
  | UiMessagingCard
  | UiPrimaryButton;

/** A grouping of ProfileAccountFormSectionElements */
export type ProfileAccountFormSectionContainer = {
  __typename?: "ProfileAccountFormSectionContainer";
  heading?: Maybe<Scalars["String"]>;
  sectionContainerElements: Array<ProfileAccountFormSectionElement>;
};

/** A UI element which may be included in a section container */
export type ProfileAccountFormSectionElement = Illustration | UiPrimaryButton | UiTertiaryButton;

/** Account form submit action which contains client side analytics along with payload to encapsulate form details */
export type ProfileAccountFormSubmitAction = ProfileAction &
  UiAction & {
    __typename?: "ProfileAccountFormSubmitAction";
    accessibility?: Maybe<Scalars["String"]>;
    /** Opaque property which encapsulates form details. Clients should pass this to mutation when action is performed. */
    actionContext: Scalars["String"];
    analytics: ClientSideAnalytics;
    /** The `egdsElementId`s of the fields which clients should pass into the `accountFormSubmit` in the `formState` argument. GraphQLPairs should contain the field id as the key and field value as its value */
    inputIds: Array<Scalars["String"]>;
  };

/** Represents a vertical list of form elements. */
export type ProfileAccountFormVerticalComponent = {
  __typename?: "ProfileAccountFormVerticalComponent";
  /** @deprecated Use anchoredButtons instead since that supports multiple buttons */
  anchoredButton?: Maybe<ProfileButton>;
  anchoredButtons?: Maybe<Array<ProfileButton>>;
  anchoredButtonsLayout?: Maybe<ProfileButtonLayout>;
  elements: Array<ProfileAccountFormElement>;
  /** @deprecated Use anchoredButton profile component instead */
  floatingButton?: Maybe<UiPrimaryButton>;
  impressionAnalytics?: Maybe<ClientSideImpressionEventAnalytics>;
  toast?: Maybe<EgdsToast>;
};

/** A link with a ProfileAction. */
export type ProfileAccountLink = EgdsElement & {
  __typename?: "ProfileAccountLink";
  action: ProfileAction;
  disabled: Scalars["Boolean"];
  egdsElementId?: Maybe<Scalars["String"]>;
  icon?: Maybe<Icon>;
  iconPosition?: Maybe<EgdsIconPosition>;
  size: EgdsLinkSize;
  text: Scalars["String"];
};

/** Represents any action for a profile UI component */
export interface ProfileAction {
  accessibility?: Maybe<Scalars["String"]>;
  analytics: ClientSideAnalytics;
}

/** Represents a card with an actionable button on the right */
export type ProfileActionButtonCard = EgdsElement & {
  __typename?: "ProfileActionButtonCard";
  cardAction?: Maybe<ProfileAction>;
  egdsElementId?: Maybe<Scalars["String"]>;
  impressionTracking?: Maybe<ClientSideImpressionEventAnalytics>;
  leftIcon?: Maybe<Icon>;
  primaries?: Maybe<Array<EgdsStylizedText>>;
  rightButton?: Maybe<ProfileButton>;
  secondaries?: Maybe<Array<EgdsStylizedText>>;
  tertiaries?: Maybe<Array<EgdsStylizedText>>;
};

/** Represents a dialog that contains heading, content and actionable buttons. */
export type ProfileActionDialogComponent = {
  __typename?: "ProfileActionDialogComponent";
  actionButtonLayout: ProfileButtonLayout;
  actionButtons: Array<ProfileButton>;
  content?: Maybe<Array<EgdsText>>;
  disableBackground: Scalars["Boolean"];
  heading?: Maybe<Scalars["String"]>;
  impressionAnalytics?: Maybe<ClientSideImpressionEventAnalytics>;
};

/** Action to open add membership screen and query for addMembershipForm */
export type ProfileAddMembershipAction = UiAction & {
  __typename?: "ProfileAddMembershipAction";
  accessibility?: Maybe<Scalars["String"]>;
  analytics: ClientSideAnalytics;
};

/** Action to open add passport screen and query for addPassportForm */
export type ProfileAddPassportAction = UiAction & {
  __typename?: "ProfileAddPassportAction";
  accessibility?: Maybe<Scalars["String"]>;
  analytics: ClientSideAnalytics;
};

/** A UI element which may be included in a bottom sheet form */
export type ProfileBottomSheetElement =
  | EgdsBasicSelect
  | EgdsErrorSummary
  | EgdsHeading
  | EgdsTextInputField
  | UiPrimaryButton
  | UiSecondaryButton;

/** Represents a bulleted list of items. */
export type ProfileBulletedList = EgdsElement & {
  __typename?: "ProfileBulletedList";
  egdsElementId?: Maybe<Scalars["String"]>;
  listItems: Array<EgdsText>;
};

/** A profile button UI element */
export type ProfileButton = {
  __typename?: "ProfileButton";
  action: ProfileAction;
  button: EgdsButton;
};

/** Represents layout of buttons. */
export type ProfileButtonLayout =
  /** Horizontally stacked buttons. */
  | "INLINE"
  /** Vertically stacked buttons. */
  | "STACKED";

/** Used to align a set of elements horizontally. Clients should scroll the initial view to center the element at `scrollToSelectedItem` index */
export type ProfileCarouselContainer = ProfileContainer & {
  __typename?: "ProfileCarouselContainer";
  elements: Array<ProfileComposableElement>;
  scrollToSelectedItem: Scalars["Int"];
};

export type ProfileChangedResult = {
  __typename?: "ProfileChangedResult";
  additionalText: Scalars["String"];
  bodyCopy: Scalars["String"];
  ctaButton: BackToHomepageButton;
  header: Scalars["String"];
  preHeader: Scalars["String"];
  subjectLine: Scalars["String"];
};

/** Represents top-level UI that is made up of a list of composable elements and impression tracking. */
export type ProfileComponent = {
  __typename?: "ProfileComponent";
  elements: Array<EgdsElement>;
  impressionAnalytics?: Maybe<ClientSideImpressionEventAnalytics>;
  toast?: Maybe<EgdsToast>;
};

export type ProfileComposableElement =
  | ProfileCarouselContainer
  | ProfileContentCard
  | ProfileFlexContainer
  | ProfileFullBleedImageCard
  | ProfileSectionContainer
  | ProfileSlimCard
  | ProfileUiPill;

/** Interface representing a group of elements */
export interface ProfileContainer {
  elements: Array<ProfileComposableElement>;
}

export interface ProfileContent {
  primary?: Maybe<Scalars["String"]>;
  secondaries?: Maybe<Array<Scalars["String"]>>;
}

/** UI card with primary text and additional rows */
export type ProfileContentCard = {
  __typename?: "ProfileContentCard";
  contentPrimary?: Maybe<Scalars["String"]>;
  rows: Array<ProfileContent>;
};

export type ProfileContentItem = ProfileContentTextItem;

/** UI card with primary and secondary text and additional rows */
export type ProfileContentParagraph = ProfileContent & {
  __typename?: "ProfileContentParagraph";
  items?: Maybe<Array<ProfileContentItem>>;
  primary?: Maybe<Scalars["String"]>;
  secondaries?: Maybe<Array<Scalars["String"]>>;
};

/** Text and icon item pair */
export type ProfileContentTextItem = {
  __typename?: "ProfileContentTextItem";
  icon?: Maybe<Icon>;
  primary?: Maybe<Scalars["String"]>;
};

/** Represents an action to let clients know that they need to dismiss the current UI component. */
export type ProfileDismissAction = ProfileAction & {
  __typename?: "ProfileDismissAction";
  accessibility?: Maybe<Scalars["String"]>;
  analytics: ClientSideAnalytics;
};

/** A grouping of EGDSElements with an optional theme and header */
export type ProfileEgdsSectionContainer = EgdsElement &
  EgdsElements & {
    __typename?: "ProfileEGDSSectionContainer";
    egdsElementId?: Maybe<Scalars["String"]>;
    elements: Array<EgdsElement>;
    heading?: Maybe<Scalars["String"]>;
    theme?: Maybe<ContainerTheme>;
  };

/** Represents an action to let clients know that they need to exit current flow. */
export type ProfileExitFlowAction = ProfileAction & {
  __typename?: "ProfileExitFlowAction";
  accessibility?: Maybe<Scalars["String"]>;
  analytics: ClientSideAnalytics;
};

/** Represents an action to let clients know that they need to exit current flow and perform a sign out. */
export type ProfileExitFlowAndSignOutAction = ProfileAction & {
  __typename?: "ProfileExitFlowAndSignOutAction";
  accessibility?: Maybe<Scalars["String"]>;
  analytics: ClientSideAnalytics;
};

/** Container for elements which are laid out horizontally and wrap vertically dependent on client width */
export type ProfileFlexContainer = {
  __typename?: "ProfileFlexContainer";
  elements: Array<ProfileComposableElement>;
};

/** Horizontal container which lays its elements out with equal spacing and distribution. Optional error message for grouped validation. */
export type ProfileFormHorizontalContainer = EgdsElement & {
  __typename?: "ProfileFormHorizontalContainer";
  egdsElementId?: Maybe<Scalars["String"]>;
  elements: Array<EgdsElement>;
  errorMessage?: Maybe<Scalars["String"]>;
};

/** Represents a section of form fields with a heading. */
export type ProfileFormSection = EgdsElement & {
  __typename?: "ProfileFormSection";
  egdsElementId?: Maybe<Scalars["String"]>;
  elements: Array<EgdsElement>;
  heading: EgdsHeading;
  subheading?: Maybe<Scalars["String"]>;
};

/** Form submit action which contains client side analytics along with payload to encapsulate form details */
export type ProfileFormSubmitAction = UiAction & {
  __typename?: "ProfileFormSubmitAction";
  accessibility?: Maybe<Scalars["String"]>;
  /** Opaque property which encapsulates form details. Clients should pass this to mutation when action is performed. */
  actionContext: Scalars["String"];
  analytics: ClientSideAnalytics;
  /** The `egdsElementId`s of the fields which clients should pass into the `userSettingFormSubmit` in the `formState` argument. GraphQLPairs should contain the field id as the key and field value as its value */
  inputIds: Array<Scalars["String"]>;
};

/** Used to display a large image with optional overlaid text and icons */
export type ProfileFullBleedImageCard = {
  __typename?: "ProfileFullBleedImageCard";
  action?: Maybe<UiAction>;
  background?: Maybe<Image>;
  fullBleedPrimary?: Maybe<Scalars["String"]>;
  icons?: Maybe<Array<Icon>>;
  impressionTracking?: Maybe<ClientSideImpressionEventAnalytics>;
  secondaries?: Maybe<Array<Scalars["String"]>>;
};

/** A link with a customizable UIAction. */
export type ProfileLink = EgdsElement & {
  __typename?: "ProfileLink";
  action: UiAction;
  disabled: Scalars["Boolean"];
  egdsElementId?: Maybe<Scalars["String"]>;
  icon?: Maybe<Icon>;
  iconPosition?: Maybe<EgdsIconPosition>;
  size: EgdsLinkSize;
  text: Scalars["String"];
};

/** Used to represent an action which should open a URI on the client */
export type ProfileLinkAction = UiAction & {
  __typename?: "ProfileLinkAction";
  accessibility?: Maybe<Scalars["String"]>;
  analytics: ClientSideAnalytics;
  resource: Uri;
  target: ProfileLinkTarget;
};

/** Specifies whether to open the link in the same user interface context or in a different context */
export type ProfileLinkTarget = "EXTERNAL" | "INTERNAL";

/** Input field for numeric data */
export type ProfileNumberField = EgdsElement &
  EgdsInputField & {
    __typename?: "ProfileNumberField";
    egdsElementId?: Maybe<Scalars["String"]>;
    errorMessage?: Maybe<Scalars["String"]>;
    hasError: Scalars["Boolean"];
    instructions?: Maybe<Scalars["String"]>;
    label?: Maybe<Scalars["String"]>;
    labelTemplate?: Maybe<EgdsLocalizedText>;
    leftIcon?: Maybe<Icon>;
    placeholder?: Maybe<Scalars["String"]>;
    readOnly: Scalars["Boolean"];
    required: Scalars["Boolean"];
    rightIcon?: Maybe<Icon>;
    validations?: Maybe<Array<EgdsInputValidation>>;
    value?: Maybe<Scalars["String"]>;
  };

/** Action to query for passport forms */
export type ProfilePassportFormAction = ProfileAction & {
  __typename?: "ProfilePassportFormAction";
  accessibility?: Maybe<Scalars["String"]>;
  /** Opaque property which encapsulates passport details. Clients should pass this to query when action is performed. */
  actionContext: Scalars["String"];
  analytics: ClientSideAnalytics;
};

/** Input field for phone numbers */
export type ProfilePhoneNumberField = EgdsElement &
  EgdsInputField & {
    __typename?: "ProfilePhoneNumberField";
    egdsElementId?: Maybe<Scalars["String"]>;
    errorMessage?: Maybe<Scalars["String"]>;
    hasError: Scalars["Boolean"];
    instructions?: Maybe<Scalars["String"]>;
    label?: Maybe<Scalars["String"]>;
    labelTemplate?: Maybe<EgdsLocalizedText>;
    leftIcon?: Maybe<Icon>;
    placeholder?: Maybe<Scalars["String"]>;
    readOnly: Scalars["Boolean"];
    required: Scalars["Boolean"];
    rightIcon?: Maybe<Icon>;
    validations?: Maybe<Array<EgdsInputValidation>>;
    value?: Maybe<Scalars["String"]>;
  };

/** Represents a navigation flow to pop screens from navigation stack to root screen and render the content. */
export type ProfilePopUiToRoot = {
  __typename?: "ProfilePopUIToRoot";
  content: ProfileAccountFormContent;
};

/** Represents a navigation flow to present content on top of the current screen. */
export type ProfilePresentUi = {
  __typename?: "ProfilePresentUI";
  content: ProfileAccountFormContent;
};

/** Represents a navigation flow to push a new screen onto the stack and render the content. */
export type ProfilePushUi = {
  __typename?: "ProfilePushUI";
  content: ProfileAccountFormContent;
  title: Scalars["String"];
};

/** Represents individual radio button. */
export type ProfileRadioButton = EgdsElement &
  EgdsRadioButton & {
    __typename?: "ProfileRadioButton";
    description?: Maybe<Scalars["String"]>;
    disabled: Scalars["Boolean"];
    egdsElementId?: Maybe<Scalars["String"]>;
    label: Scalars["String"];
    labelSuffix?: Maybe<Scalars["String"]>;
    submitAnalytics?: Maybe<ClientSideAnalytics>;
    value: Scalars["String"];
  };

/** Represents a group of radio buttons. At most one may be selected at a time indicated by the selected property. */
export type ProfileRadioButtonGroup = EgdsElement &
  EgdsRadioGroup & {
    __typename?: "ProfileRadioButtonGroup";
    egdsElementId?: Maybe<Scalars["String"]>;
    errorMessage?: Maybe<Scalars["String"]>;
    groupName: Scalars["String"];
    options: Array<EgdsRadioButton>;
    selected?: Maybe<Scalars["String"]>;
  };

/** An action which instructs the client to reload the entire component */
export type ProfileReloadAction = UiAction & {
  __typename?: "ProfileReloadAction";
  accessibility?: Maybe<Scalars["String"]>;
  analytics: ClientSideAnalytics;
};

/** Action to query for rewardProgramsForm */
export type ProfileRewardProgramFormAction = UiAction & {
  __typename?: "ProfileRewardProgramFormAction";
  accessibility?: Maybe<Scalars["String"]>;
  /** Opaque property which encapsulates membership details. Clients should pass this to query when action is performed. */
  actionContext: Scalars["String"];
  analytics: ClientSideAnalytics;
};

/** A grouping of elements with an optional theme and header */
export type ProfileSectionContainer = ProfileContainer & {
  __typename?: "ProfileSectionContainer";
  elements: Array<ProfileComposableElement>;
  heading?: Maybe<Scalars["String"]>;
  theme?: Maybe<ContainerTheme>;
};

/** A list of selectable values. Only one may be selected at a time. */
export type ProfileSelectField = EgdsElement & {
  __typename?: "ProfileSelectField";
  egdsElementId?: Maybe<Scalars["String"]>;
  hasError: Scalars["Boolean"];
  label: Scalars["String"];
  options: Array<ProfileSwitchOption>;
};

/** Action to let clients know that they need to perform a sign out. */
export type ProfileSignOutAction = ProfileAction & {
  __typename?: "ProfileSignOutAction";
  accessibility?: Maybe<Scalars["String"]>;
  analytics: ClientSideAnalytics;
};

/** Represents a slim card with an optional action */
export type ProfileSlimCard = EgdsElement & {
  __typename?: "ProfileSlimCard";
  /** @deprecated Use profileAction instead */
  action?: Maybe<UiAction>;
  alertMessages?: Maybe<Array<Scalars["String"]>>;
  egdsElementId?: Maybe<Scalars["String"]>;
  icon?: Maybe<Icon>;
  impressionTracking?: Maybe<ClientSideImpressionEventAnalytics>;
  profileAction?: Maybe<ProfileAction>;
  secondaries?: Maybe<Array<Scalars["String"]>>;
  slimCardPrimary?: Maybe<Scalars["String"]>;
  tertiaries?: Maybe<Array<Scalars["String"]>>;
};

/** A predetermined selectable input value (such as a drop down selection or a radio button) */
export type ProfileSwitchOption = EgdsElement & {
  __typename?: "ProfileSwitchOption";
  egdsElementId?: Maybe<Scalars["String"]>;
  label: Scalars["String"];
  selected: Scalars["Boolean"];
  value: Scalars["String"];
};

/** Text input field used for inputting data. */
export type ProfileTextField = EgdsElement &
  EgdsInputField & {
    __typename?: "ProfileTextField";
    egdsElementId?: Maybe<Scalars["String"]>;
    errorMessage?: Maybe<Scalars["String"]>;
    instructions?: Maybe<Scalars["String"]>;
    label?: Maybe<Scalars["String"]>;
    labelTemplate?: Maybe<EgdsLocalizedText>;
    leftIcon?: Maybe<Icon>;
    placeholder?: Maybe<Scalars["String"]>;
    readOnly: Scalars["Boolean"];
    required: Scalars["Boolean"];
    rightIcon?: Maybe<Icon>;
    validations?: Maybe<Array<EgdsInputValidation>>;
    value?: Maybe<Scalars["String"]>;
  };

/** Standard pill element which may be selected and/or disabled */
export type ProfileUiPill = UiPill & {
  __typename?: "ProfileUIPill";
  accessibility?: Maybe<Scalars["String"]>;
  /** @deprecated Use profileAction instead */
  action?: Maybe<UiAction>;
  disabled: Scalars["Boolean"];
  icon?: Maybe<Icon>;
  primary: Scalars["String"];
  profileAction?: Maybe<ProfileAction>;
  selected: Scalars["Boolean"];
};

/** Action to query for updateMembershipForm */
export type ProfileUpdateMembershipAction = UiAction & {
  __typename?: "ProfileUpdateMembershipAction";
  accessibility?: Maybe<Scalars["String"]>;
  /** Opaque property which encapsulates membership details. Clients should pass this to query when action is performed. */
  actionContext: Scalars["String"];
  analytics: ClientSideAnalytics;
};

/** Action to query for updatePassportForm */
export type ProfileUpdatePassportAction = UiAction & {
  __typename?: "ProfileUpdatePassportAction";
  accessibility?: Maybe<Scalars["String"]>;
  /** Opaque property which encapsulates passport details. Clients should pass this to query when action is performed. */
  actionContext: Scalars["String"];
  analytics: ClientSideAnalytics;
};

/** Top level wizard UI object */
export type ProfileWizardComponent = {
  __typename?: "ProfileWizardComponent";
  elements: Array<ProfileComposableElement>;
  impressionAnalytics?: Maybe<ClientSideImpressionEventAnalytics>;
};

/** Represents where a wizard will be displayed */
export interface ProfileWizardContextInput {
  lineOfBusiness: LineOfBusinessDomain;
  pageLocation: PageLocation;
}

export type ProfileWizardResponse = ProfileWizardComponent | WizardAdditionalUserInputRequiredAction;

/** A single hotel or vacation rental. This type is deprecated in favor of LodgingCard. */
export type Property = Plottable & {
  __typename?: "Property";
  /** Information about the property address */
  addressMessaging?: Maybe<Scalars["String"]>;
  /** Amenities offered by the property, ex. airConditioning, pool */
  amenities: Array<PropertyAmenityValue>;
  /** Whether the hotel has available inventory, or the reason why not. */
  availability: PropertyAvailability;
  clickstreamEvents: LodgingCardClickstreamEvents;
  /** Data Attributes for selected/pinned property */
  dataAttributes?: Maybe<GraphQlPair>;
  /** Geographical details about the destination */
  destinationInfo: PropertyDestinationInfo;
  /**
   * Errors in the query preventing a successful response.
   * @deprecated Look for errors in response.errors instead
   */
  errors?: Maybe<Array<Scalars["String"]>>;
  /** Featured checkin date */
  featuredCheckinDate?: Maybe<Scalars["String"]>;
  /** Featured checkout date */
  featuredCheckoutDate?: Maybe<Scalars["String"]>;
  /** Featured messages about the property, ex: Viewed, Enhanced cleaning, Private host */
  featuredMessages?: Maybe<Array<LodgingEnrichedMessage>>;
  /**
   * Gallery images
   * @deprecated Deprecated, replace with propertyGallery
   */
  gallery?: Maybe<Array<Image>>;
  /**
   * A short localized string of highlighted property information, ex: bedroom, bathroom, occupancy of displayed rate plan
   * @deprecated Use highlightedPropertyDetails
   */
  highlightedPropertyDetail?: Maybe<Scalars["String"]>;
  /** A short localized list of highlighted property information, ex: bedroom, bathroom, entire message of displayed rate plan */
  highlightedPropertyDetails: Array<Scalars["String"]>;
  /** The property's unique identifier */
  id: Scalars["String"];
  /**
   * Featured property image
   * @deprecated replaced by propertyImage
   */
  image?: Maybe<Image>;
  /** Gallery images with accessibility label */
  imageGallery?: Maybe<PropertyImageGallery>;
  /**
   * URL to link to the Infosite/Details page populated with tracking info
   * @deprecated Don't use this anymore., replace with propertyDetailsLink
   */
  infositeURL: Scalars["String"];
  /**
   * Latitude/Longitude of property. In rare cases this is not known and will not be returned.
   * @deprecated Moved to mapMarker.latLong
   */
  latLong?: Maybe<Coordinates>;
  /** Disclaimer information about the property for legal compliance */
  legalDisclaimer?: Maybe<PropertyLegalDisclaimer>;
  /** Footer model to display actionable message on a property card */
  listingFooter?: Maybe<MessagingAction>;
  /** @deprecated deprecated in favour of priceBreakDownSummary, replace with priceBreakDownSummary */
  lodgingPriceBreakDown?: Maybe<LodgingPriceBreakDown>;
  /** Map marker information for plotting on a map */
  mapMarker?: Maybe<MapMarker>;
  /** The name of the property */
  name: Scalars["String"];
  /** Information about the neighborhood */
  neighborhood?: Maybe<Region>;
  /** Primary and/or secondary and/or tertiary badge information that appears on property listing */
  offerBadge?: Maybe<OfferBadge>;
  /** Information about the offer */
  offerSummary: OfferSummary;
  /** Message details for selected/pinned property */
  pinnedDetails?: Maybe<PinnedPropertyModel>;
  /** The lead price */
  price?: Maybe<PropertyPrice>;
  /** The lead price after the customer's applicable loyalty points are applied. */
  priceAfterLoyaltyPointsApplied?: Maybe<PropertyPrice>;
  /** This contain all detail which need to show under PriceBreakDown */
  priceBreakDownSummary?: Maybe<PriceSummary>;
  /** Details about applied price discounts */
  priceMetadata: PropertyPriceMetadata;
  /** Link to property details with tracking data for UIS Prime */
  propertyDetailsLink?: Maybe<LodgingLink>;
  /** Property Fees provided by the property */
  propertyFees?: Maybe<Array<Fees>>;
  /**
   * Gallery images
   * @deprecated Use imageGallery
   */
  propertyGallery?: Maybe<Array<PropertyImage>>;
  /** Featured property image */
  propertyImage?: Maybe<PropertyImage>;
  /** Indicates whether the property has a HotelPaymentFlags e.g NOCreditCard, MixedRatePlan, ArtificiallyFencedRate */
  propertyPaymentFlags: Array<PropertyPaymentFlags>;
  /** Localized string and logo to identify the source of the property */
  propertySource?: Maybe<PropertySource>;
  /**
   * Badge to display type of property
   * @deprecated Experiment stopped and field is no more supported
   */
  propertyTypeBadge?: Maybe<Scalars["String"]>;
  /** Provider id to determine hotel inventory type */
  providerId?: Maybe<Scalars["String"]>;
  /** Identifier for the rate plan */
  ratePlanId?: Maybe<Scalars["String"]>;
  /**
   * Icon used for viewed flag
   * @deprecated Use featuredMessages
   */
  recentlyViewed?: Maybe<Icon>;
  /** GAIA identifier of geographical region */
  regionId: Scalars["String"];
  /** Customer review information */
  reviews: PropertyReviewsSummary;
  /** Identifier for the room type */
  roomTypeId?: Maybe<Scalars["String"]>;
  /** A field of the property dedicated to saving/removing the lodging to/from a trip. */
  saveTripItem?: Maybe<TripsSaveItem>;
  /**
   * Information if the property is shortListed and the urls to call to save or remove the property
   * @deprecated Deprecated in favor of saveTripItem
   */
  shortList?: Maybe<ShortList>;
  /** Additional details about the property when it is a sponsored listing */
  sponsoredListing?: Maybe<SponsoredListing>;
  /** The star rating of the property (1.0 - 5.0 in 0.5 increments). This value will return null without a stars filter applied. */
  star?: Maybe<Scalars["Float"]>;
  /** Star Rating Icon to use */
  starRatingIcon: Scalars["String"];
  /** Star Rating Text, ex: 4-star property, Property class: 4 */
  starRatingText?: Maybe<Scalars["String"]>;
  /** Type of physical property, e.g. Hotel, Motel */
  structureType: StructureType;
  /** Supporting message that can be used to display tax and fee include information */
  supportingMessages?: Maybe<Array<Scalars["String"]>>;
  /**
   * Thumbor property image
   * @deprecated Moved to image. This field does not return a thumbor image.
   */
  thumborImage?: Maybe<Image>;
  /**
   * Indicates whether the property is a VIP property
   * @deprecated Use vipMessaging
   */
  vip: Scalars["Boolean"];
  /** VIP display messaging if the property is a VIP property */
  vipMessaging?: Maybe<Scalars["String"]>;
};

export type PropertyAddress = {
  __typename?: "PropertyAddress";
  addressLine?: Maybe<Scalars["String"]>;
  city?: Maybe<Scalars["String"]>;
  countryCode?: Maybe<Scalars["String"]>;
  firstAddressLine?: Maybe<Scalars["String"]>;
  postalCode?: Maybe<Scalars["String"]>;
  province?: Maybe<Scalars["String"]>;
  secondAddressLine?: Maybe<Scalars["String"]>;
};

/** Encapsulate alternate date option details. Includes price, saving, los, redirect URL for alternate date range. */
export type PropertyAlternateDateOption = {
  __typename?: "PropertyAlternateDateOption";
  /** Date range for the alternate data returned */
  dateRange: PropertyDateRange;
  /** Price for the returned date range */
  price: Money;
  /** Any price disclaimer for the property */
  pricingDisclaimer: Scalars["String"];
  /** Difference in price from current selected dates and alternate date range */
  savings: Money;
  /** Message corresponding to the length of stay selected by the user */
  stayDurationMessage: Scalars["String"];
  /** Url for the Pinned HSR page where used will land on click of the alternate date option on property card */
  url: Scalars["URL"];
};

/** Encapsulate alternate date details for a property. Contains list of alternate date options for a given property. */
export type PropertyAlternateDateResult = {
  __typename?: "PropertyAlternateDateResult";
  alternateOptions: Array<PropertyAlternateDateOption>;
  /** Id of the property for which alternate date is fetched */
  propertyId: Scalars["String"];
};

export type PropertyAmenities = {
  __typename?: "PropertyAmenities";
  /** @deprecated Only used on Mobile app, moved into amenities field */
  allUnits?: Maybe<PropertyInfoSection>;
  /**
   * Exhaustive list of amenities grouped by scope: Property amenities or Room amenities
   * @deprecated Property and Room amenities are deprecated. Make use of propertyAmenities and roomAmenities inside propertyContentSectionGroups
   */
  amenities: Array<PropertyInfoSection>;
  /**
   * Link to show more amenities.
   * @deprecated The summary structure should be refactored, prevent use that structure on future implementation
   */
  amenitiesDialog?: Maybe<LodgingAmenitiesDialog>;
  /** @deprecated Only used on Mobile app, moved into amenities field */
  property?: Maybe<PropertyInfoSection>;
  /** List of the preferred property content to display on top of the page */
  propertyContentPreferences?: Maybe<PropertyContent>;
  /** List of relevant amenities grouped by type: Main amenities and For Families amenities */
  relevantAmenities: Array<PropertyInfoSection>;
  /** Amenities to be displayed on the takeover dialog */
  takeover?: Maybe<PropertyTakeoverAmenities>;
  /** @deprecated Use topAmenities */
  top: Array<PropertyInfoItem>;
  /** List of the most valued amenities to display on top of the page */
  topAmenities?: Maybe<PropertyInfoContent>;
};

export type PropertyAmenity = {
  __typename?: "PropertyAmenity";
  icon?: Maybe<Scalars["String"]>;
  text: Scalars["String"];
};

export type PropertyAmenityCategory = {
  __typename?: "PropertyAmenityCategory";
  /** @deprecated Use type instead of code */
  code?: Maybe<Scalars["String"]>;
  icon?: Maybe<Scalars["String"]>;
  text: Scalars["String"];
  type?: Maybe<PropertyAmenityCategoryType>;
};

/** Type that represents the amenity category icons for the property */
export type PropertyAmenityCategoryType =
  | "ACCESSIBLE_ROLL_IN_SHOWER"
  | "AIR_CONDITIONING"
  | "ALL_INCLUSIVE"
  | "ARCADE"
  | "BABYSITTING"
  | "BAR"
  | "BOWLING"
  | "BREAKFAST_AVAILABLE"
  | "BUSINESS_SERVICES"
  | "CHILDREN_CLUB"
  | "DAILY_HOUSEKEEPING"
  | "EXTRA_BED"
  | "FITNESS_EQUIPMENT"
  | "FREE_AIRPORT_TRANSPORTATION"
  | "FREE_BREAKFAST"
  | "FREE_PARKING"
  | "FREE_WELCOME_DRINK"
  | "FRONT_DESK_24_HOURS"
  | "GROCERY"
  | "HIGH_SPEED_INTERNET"
  | "HOT_TUB"
  | "IN_ROOM_INTERNET"
  | "KIDS_POOL"
  | "KITCHEN"
  | "LAUNDRY"
  | "LIVING_AREA"
  | "MICROWAVE"
  | "MINI_GOLF"
  | "PARKING"
  | "PETS_ALLOWED"
  | "PLAYGROUND"
  | "POOL"
  | "RESTAURANT_IN_HOTEL"
  | "ROOM_SERVICE"
  | "SMOKE_FREE"
  | "SOUNDPROOF_ROOM"
  | "SPA_SERVICES_ON_SITE"
  | "SPECIAL_DEAL"
  | "TENNIS_COURT"
  | "TOYS"
  | "WATERSLIDE";

/** A section of amenities */
export type PropertyAmenitySection = {
  __typename?: "PropertyAmenitySection";
  /** the amenities in the section */
  amenities: Array<PropertyAmenity>;
  /** a description of the section */
  description: Array<Scalars["String"]>;
  /** The subtype of the section */
  subType?: Maybe<PropertyAmenityType>;
  /** title of the section */
  title: Scalars["String"];
  /** The type of the section */
  type: PropertyAmenityType;
};

export type PropertyAmenityType =
  | "ACCESSIBILITY"
  | "BATHROOM"
  | "BEDROOM"
  | "BUSINESS_SERVICES"
  | "CONVENIENCES"
  | "ENTERTAINMENT"
  | "FAMILY_FRIENDLY"
  | "FOOD_DRINK"
  | "GUEST_SERVICES"
  | "INTERNET"
  | "MORE"
  | "OUTDOOR"
  | "OUTDOOR_SPACE"
  | "PARKING"
  | "PROPERTY"
  | "ROOM"
  | "SPA"
  | "THINGS_TO_DO";

export type PropertyAmenityValue = {
  __typename?: "PropertyAmenityValue";
  icon: Scalars["String"];
  id: Scalars["Int"];
  name: Scalars["String"];
};

export type PropertyAvailability = {
  __typename?: "PropertyAvailability";
  available: Scalars["Boolean"];
  minRoomsLeft?: Maybe<Scalars["Int"]>;
  scarcityMessage?: Maybe<Scalars["String"]>;
  text?: Maybe<Scalars["String"]>;
  theme?: Maybe<Theme>;
  unavailableReasons: Array<PropertyUnavailableValue>;
};

/** Represents calendar with lowest price available for a date */
export type PropertyCalendar = {
  __typename?: "PropertyCalendar";
  /** Legal disclaimer message */
  disclaimer: LodgingPlainMessage;
  /** Represents detailed footer description */
  legend?: Maybe<Array<PropertyCalendarLegend>>;
  /** Represents a single date and lowest price available for that date */
  propertyCalendarRates: Array<PropertyCalendarRate>;
};

export interface PropertyCalendarLegend {
  /** Legend label message */
  label: Scalars["String"];
}

export type PropertyCalendarPriceTrend =
  /** Negative price trend */
  | "NEGATIVE"
  /** Positive price trend */
  | "POSITIVE";

export type PropertyCalendarPriceTrendLegend = PropertyCalendarLegend & {
  __typename?: "PropertyCalendarPriceTrendLegend";
  /** Legend label message */
  label: Scalars["String"];
  /** Legend symbol */
  symbol: Scalars["String"];
  /** Marker to which legend it is applied */
  trend: PropertyCalendarPriceTrend;
};

/** Represents a single date and lowest price available for that date */
export type PropertyCalendarRate = {
  __typename?: "PropertyCalendarRate";
  /** Label where a11y behavior is needed. */
  accessibilityLabel: Scalars["String"];
  /** Represents the specific date on the calendar */
  date: Date;
  /** The price to be displayed in relation to the date, -- if unavailable */
  displayPrice: Scalars["String"];
  /**
   * a11y label.
   * @deprecated Use accessibilityLabel, replace with accessibilityLabel
   */
  label?: Maybe<Scalars["String"]>;
  /**
   * The price to be displayed in relation to the date, null if unavailable
   * @deprecated Deprecated in favour of displayPrice
   */
  price?: Maybe<Money>;
};

export type PropertyCancellationPolicy = {
  __typename?: "PropertyCancellationPolicy";
  /** @deprecated Use cancellationWindow since the date time can be nullable */
  cancellationDateTime: ZonedDateTime;
  cancellationWindow?: Maybe<ZonedDateTime>;
  text: Scalars["String"];
  type: PropertyCancellationPolicyType;
};

export type PropertyCancellationPolicyType =
  | "NON_REFUNDABLE"
  | "REFUNDABLE_WITH_NO_PENALTY"
  | "REFUNDABLE_WITH_PENALTY";

export type PropertyCartItem = CartItem & {
  __typename?: "PropertyCartItem";
  /** @deprecated DO NOT USE: This is required for the federation migration. Clients should only ever pass the context as input */
  deprecatedContext: DeprecatedMultiItemContext;
  /**
   * Federation: Extends the type with property gallery given the propertyId
   * @deprecated Added for stitching migration purposes only. Can be deleted once all clients migrate., replace with propertyImageGallery
   */
  gallery?: Maybe<PropertyGallery>;
  id: Scalars["UUID"];
  /**
   * The list of rooms in the property, user had selected
   * @deprecated DO NOT USE: Will be removed permanently soon
   */
  offers: Array<PropertyOffer>;
  /**
   * Get the property gallery from the property id.Requires the context is passed in as this is resolved through federation.
   * @deprecated Replaced by the type PropertyImageGallery as part of BFF to BEX-API migration, replace with propertyImageGallery
   */
  propertyGallery?: Maybe<PropertyGallery>;
  /**
   * Property id for the offers
   * @deprecated DO NOT USE: Will be removed permanently soon
   */
  propertyId: Scalars["String"];
  /** Get the property gallery from the property id.Requires the context is passed in as this is resolved through federation. */
  propertyImageGallery?: Maybe<PropertyImageGallery>;
  /** Get the complete property summary from the property id.Requires the context is passed in as this is resolved through federation. */
  propertySummary?: Maybe<PropertySummary>;
  /**
   * The search context for the property
   * @deprecated DO NOT USE: Will be removed permanently soon
   */
  searchContext: CartPropertySearchContext;
  /**
   * Federation: Extends the type with property summary details given the propertyId
   * @deprecated Added for stitching migration purposes only. Can be deleted once all clients migrate., replace with propertySummary
   */
  summary?: Maybe<PropertySummary>;
};

export type PropertyCartItemPropertyGalleryArgs = {
  context: ContextInput;
};

export type PropertyCartItemPropertyImageGalleryArgs = {
  context: ContextInput;
};

export type PropertyCartItemPropertySummaryArgs = {
  context: ContextInput;
};

/** Server driven property content containing PropertyContentItems */
export type PropertyContent = {
  __typename?: "PropertyContent";
  /** Expansion, collapse and analytics associated with component */
  expando?: Maybe<LodgingExpando>;
  /** Heading describing the collection of content */
  header?: Maybe<LodgingHeader>;
  /** Collection of individual pieces of UI */
  items: Array<PropertyContentItem>;
  /** Maximum columns to display the content */
  maxColumns?: Maybe<Scalars["Int"]>;
  /** SEO Structured data for the content */
  structuredData?: Maybe<SeoStructuredData>;
};

/** Return PropertyContent or EGDSStandardMessagingCard type */
export type PropertyContentElement = EgdsStandardMessagingCard | PropertyContent;

/** Empty interface to achieve a Union of PropertyContentItem types */
export type PropertyContentItem =
  | LodgingLinkMessage
  | PropertyContentItemImages
  | PropertyContentItemMarkup
  | PropertyContentItemText
  | PropertyContentItemTexts;

/** Server driven collection of images */
export type PropertyContentItemImages = {
  __typename?: "PropertyContentItemImages";
  /** Collection of images */
  contents: Array<PropertyImage>;
};

/** Content that already contains markup */
export type PropertyContentItemMarkup = {
  __typename?: "PropertyContentItemMarkup";
  /** Property content that contains markup with the type of markup it contains */
  content: MarkupText;
};

/** Server driven text */
export type PropertyContentItemText = {
  __typename?: "PropertyContentItemText";
  /** Collection of text describing the property */
  content: PropertyContentText;
};

/** Server driven collection of text that will be displayed in a list such as <ul> for example */
export type PropertyContentItemTexts = {
  __typename?: "PropertyContentItemTexts";
  /** Text describing the property */
  contents: Array<PropertyContentText>;
};

/** Server driven section of content used to group related sub sections of information */
export type PropertyContentSection = {
  __typename?: "PropertyContentSection";
  /** Property Content section action */
  action?: Maybe<PropertyContentSectionAction>;
  /**
   * Location in the DOM which the associated jump link takes the user to
   * @deprecated Do not use; please follow same pattern as PropertyContentSectionGroup., replace with sectionName
   */
  anchor?: Maybe<Scalars["String"]>;
  /** Subsections of related content describing a property */
  bodySubSections: Array<PropertyContentSubSection>;
  /** Heading describing the type of content in the related subsections */
  header?: Maybe<LodgingHeader>;
  headingContentElements: Array<PropertyContentElement>;
  /** Document section for a jump link to jump to */
  sectionName?: Maybe<Scalars["String"]>;
};

/** Empty interface to achieve a Union of PropertyContentSectionAction types */
export type PropertyContentSectionAction = PropertyContentSectionDialog;

/** Grouping of server driven dialog */
export type PropertyContentSectionDialog = {
  __typename?: "PropertyContentSectionDialog";
  /** Dialog content: A subset of inline EGDSText implementations that comprise the dialog content. */
  content: EgdsSpannableText;
  /** EGDSDialog */
  dialog: EgdsDialog;
  /** Trigger message, accessibility and analytics tied to the dialog */
  trigger: PropertyContentSectionDialogTrigger;
};

/** Server driven text */
export type PropertyContentSectionDialogTrigger = {
  __typename?: "PropertyContentSectionDialogTrigger";
  accessibility?: Maybe<Scalars["String"]>;
  analytics: ClientSideAnalytics;
  message: Scalars["String"];
};

/** Grouping of server driven UI sections */
export type PropertyContentSectionGroup = {
  __typename?: "PropertyContentSectionGroup";
  /** Expando to drive the collapsing or expansion of this section */
  expando?: Maybe<LodgingExpando>;
  /** Tracking data of the user impression with the content */
  impressionAnalytics?: Maybe<ClientSideImpressionEventAnalytics>;
  /** Navigation Tab Information related to content */
  sectionName?: Maybe<Scalars["String"]>;
  /** Collection of content sections containing information about an individual property */
  sections: Array<PropertyContentSection>;
};

/** Grouping of all the different PropertyContentSectionGroup fields */
export type PropertyContentSectionGroups = {
  __typename?: "PropertyContentSectionGroups";
  /** About the location content. This will deprecate content coming from summary.location.whatsAround */
  aboutTheLocation?: Maybe<PropertyContentSectionGroup>;
  /** Host profile information such as languages spoken, time as a member, why VR was chosen, etc. */
  aboutThisHost?: Maybe<PropertyContentSectionGroup>;
  /** About this property specific PropertyContentSectionGroup */
  aboutThisProperty?: Maybe<PropertyContentSectionGroup>;
  /** Property and Room Amenities. This will deprecate amenities coming from summary.amenities.propertyAmenities and summary.amenities.roomAmenities */
  amenities?: Maybe<PropertyContentSectionGroup>;
  /**
   * Cleaning and Safety Practices information. DO NOT request this field if you're requesting `aboutThisProperty`.
   * @deprecated cleanliness is deprecated. This content should be part of aboutThisProperty sectionGroup
   */
  cleanliness?: Maybe<PropertyContentSectionGroup>;
  /** Closures information. DO NOT request this field if you're requesting `aboutThisProperty`. */
  closures?: Maybe<PropertyContentSectionGroup>;
  /** Fees, Deposits and Optional Extra Fees */
  feesInformation?: Maybe<PropertyContentSectionGroup>;
  /** Important Information specific PropertyContentSectionGroup */
  importantInfo?: Maybe<PropertyContentSectionGroup>;
  /** Policies specific PropertyContentSectionGroup */
  policies?: Maybe<PropertyContentSectionGroup>;
  /** Special Features specific PropertyContentSectionGroup */
  specialFeatures?: Maybe<PropertyContentSectionGroup>;
};

/** Subsection of content that groups individual pieces of UI */
export type PropertyContentSubSection = {
  __typename?: "PropertyContentSubSection";
  /**
   * Collection of closely related content describing a property
   * @deprecated Use elements., replace with elements
   */
  contents: Array<PropertyContent>;
  elements: Array<PropertyContentElement>;
  /** Expando to drive the collapsing or expansion of this sub section */
  expando?: Maybe<LodgingExpando>;
  /** Limit of the number of columns that should be displayed */
  maxColumns: Scalars["Int"];
};

/** Server driven text with a primary message and supporting message */
export type PropertyContentText = {
  __typename?: "PropertyContentText";
  /** Text describing the property */
  primary: LodgingEnrichedMessage;
  /** Supporting text detailing the primary text */
  secondary?: Maybe<LodgingPlainMessage>;
};

export interface PropertyContext {
  propertyId: Scalars["String"];
}

export type PropertyDateRange = {
  __typename?: "PropertyDateRange";
  checkInDate: Date;
  checkOutDate: Date;
};

export interface PropertyDateRangeInput {
  checkInDate: DateInput;
  checkOutDate: DateInput;
}

export type PropertyDestinationInfo = {
  __typename?: "PropertyDestinationInfo";
  /** Crow-flies distance between the destination center and property location */
  distanceFromDestination?: Maybe<Distance>;
  /** Localized messaging indicating the distance from the searched destination */
  distanceFromMessaging?: Maybe<Scalars["String"]>;
  /** Indicates if the property was found outside of the searched destination */
  includedFromSupplementalSearch: Scalars["Boolean"];
  /** Latitude/Longitude of property. In rare cases this is not known and will not be returned. */
  latLong?: Maybe<Coordinates>;
  /** GAIA identifier of geographical region */
  regionId: Scalars["String"];
};

export interface PropertyDetailPlottable {
  mapMarker: MapMarker;
}

export type PropertyDetails = {
  __typename?: "PropertyDetails";
  contentSections: Array<PropertyInfoContent>;
  description?: Maybe<EgdsParagraph>;
  gallery?: Maybe<PropertyImageGallery>;
  heading: EgdsHeading;
  rating?: Maybe<EgdsRating>;
  reviewSummary?: Maybe<PropertyReviewSummary>;
};

export type PropertyDetailsExperimentalSection = LodgingExperimentalSection & {
  __typename?: "PropertyDetailsExperimentalSection";
  /** Details experimental features as a list for automation purposes. */
  features: Array<LodgingExperimentalMetaData>;
  pageLayoutExperimentalFeature: PageLayoutExperimentalFeature;
  propertyTaglineExperimentalFeature: PropertyTaglineExperimentalFeature;
};

export type PropertyDetailsExperimentalSectionFeaturesArgs = {
  createdAfter?: InputMaybe<DateInput>;
  createdBefore?: InputMaybe<DateInput>;
  description?: InputMaybe<Scalars["String"]>;
  id?: InputMaybe<Scalars["Int"]>;
  name?: InputMaybe<Scalars["String"]>;
  org?: InputMaybe<Scalars["String"]>;
  team?: InputMaybe<Scalars["String"]>;
};

export type PropertyDetailsMultiItemShoppingAction = MultiItemShoppingAction & {
  __typename?: "PropertyDetailsMultiItemShoppingAction";
  shoppingContext: ShoppingContext;
};

export interface PropertyDetailsMultiItemShoppingActionInput {
  shoppingContext: ShoppingContextInput;
}

export type PropertyDetailsPropertyType = "HOTEL" | "VACATION_RENTAL";

export type PropertyDetailsStickyBar = {
  __typename?: "PropertyDetailsStickyBar";
  /** @deprecated Use propertyPrice instead */
  displayPrice?: Maybe<Scalars["String"]>;
  /** @deprecated Use propertyPrice instead */
  price?: Maybe<PropertyPriceOption>;
  propertyPrice?: Maybe<PropertyPrice>;
  /** @deprecated Use propertyPrice instead */
  qualifier?: Maybe<Scalars["String"]>;
  stickyButton?: Maybe<LodgingStickyButton>;
  structuredData?: Maybe<PropertySeoStructuredData>;
  /** @deprecated Use propertyPrice instead */
  subText?: Maybe<Scalars["String"]>;
};

export type PropertyEditorial = {
  __typename?: "PropertyEditorial";
  /** List of paragraphs describing a property location. Should not contain HTML */
  content: Array<Scalars["String"]>;
  /**
   * Link to the Destination Page (DX) of the property location. Under abTest 33466
   * @deprecated Use crossLinks, replace with crossLinks
   */
  crossLink?: Maybe<LodgingLinkMessage>;
  /** Links to the Destination Page (DX) and Alternative accommodations of the property location. Under abTest 33466 */
  crossLinks?: Maybe<Array<LodgingLinkMessage>>;
  title: Scalars["String"];
};

/** Describes a question & answer for a specific property. */
export type PropertyFaq = {
  __typename?: "PropertyFAQ";
  /** Describes an answer for a specific property. */
  answer: PropertyFaqContent;
  /** Describes a question a specific property. */
  question: PropertyFaqContent;
};

export type PropertyFaqContent = {
  __typename?: "PropertyFAQContent";
  /** Content that contains markup with the type of markup it contains */
  content: MarkupText;
  /**
   * Content.
   * @deprecated Will be remove in favor of content property which it can contains markup
   */
  text: Scalars["String"];
  /** Client analytic data. */
  tracking?: Maybe<ClientSideAnalytics>;
};

/** Describes a list of FAQs for a specific properties */
export type PropertyFaQs = {
  __typename?: "PropertyFAQs";
  /** Property FAQs action */
  action?: Maybe<Array<SpannableTextDialog>>;
  /** Describes the ask a question button */
  askAQuestion?: Maybe<UiSecondaryButton>;
  /** Describes the list with FAQs of specific properties */
  faqs: Array<PropertyFaq>;
  /** Describes the element that contains FAQs */
  title: LodgingHeader;
};

export type PropertyFees = {
  __typename?: "PropertyFees";
  mandatory?: Maybe<PropertyInfoSubSection>;
  optional?: Maybe<PropertyInfoSubSection>;
};

export type PropertyFilterAccessibility =
  | "ACCESSIBLE_BATHROOM"
  | "ACCESSIBLE_PARKING"
  | "ELEVATOR"
  | "IN_ROOM_ACCESSIBLE"
  | "ROLL_IN_SHOWER"
  | "SERVICE_ANIMAL"
  | "SIGN_LANGUAGE_INTERPRETER"
  | "STAIR_FREE_PATH";

export type PropertyFilterAmenity =
  | "AIR_CONDITIONING"
  | "ALL_INCLUSIVE"
  | "BALCONY_OR_TERRACE"
  | "BAR"
  | "BEACH"
  | "CASINO"
  | "CRIB"
  | "ELECTRIC_CAR"
  | "FREE_AIRPORT_TRANSPORTATION"
  | "FREE_BREAKFAST"
  | "FREE_PARKING"
  | "GOLF"
  | "GYM"
  | "HOT_SPRING"
  | "HOT_TUB"
  | "KITCHEN_KITCHEN"
  | "KITCHEN_KITCHENETTE"
  | "OCEAN_VIEW"
  | "PARKING"
  | "PETS"
  | "POOL"
  | "RESTAURANT_IN_HOTEL"
  | "SPA_ON_SITE"
  | "WASHER_DRYER"
  | "WATER_PARK"
  | "WIFI";

/** Returns information to help inform property filter input */
export type PropertyFilterMetadata = {
  __typename?: "PropertyFilterMetadata";
  /** Returns the list of amenity types available in the result set */
  amenities: Array<PropertyAmenityValue>;
  /** Returns GAIA regions (neighborhoods) associated with the propertySearch destination */
  neighborhoods: Array<Neighborhood>;
  /** Returns the min and max price of the result set in point of sale currency */
  priceRange: PriceRange;
  /** Returns the list of structure types available in the result set */
  structureTypes: Array<StructureTypeValue>;
};

export type PropertyFilteredReviewsDialog = {
  __typename?: "PropertyFilteredReviewsDialog";
  ratingPercentage: EgdsFullScreenDialog;
  trigger: LodgingDialogTriggerMessage;
};

export type PropertyGallery = {
  __typename?: "PropertyGallery";
  featured?: Maybe<Image>;
  images: Array<Image>;
};

/** Category for images a property's gallery */
export type PropertyGalleryCategory = {
  __typename?: "PropertyGalleryCategory";
  /** Content description for screen reader */
  accessibilityLabel?: Maybe<Scalars["String"]>;
  /** Category ID */
  id: Scalars["String"];
  /** List of images from the property that belong to this category */
  images: Array<PropertyImage>;
  /** Category display name */
  name: Scalars["String"];
};

/** Property Group Creation experience */
export type PropertyGroupForm = {
  __typename?: "PropertyGroupForm";
  error?: Maybe<CampaignConfigErrorResponse>;
  form: PropertyGroupFormFields;
  hero: CampaignConfigHero;
  propertyList?: Maybe<CheckablePropertyList>;
  validationWarnings: PropertyGroupFormValidationWarnings;
};

/** Form control and data */
export type PropertyGroupFormFields = {
  __typename?: "PropertyGroupFormFields";
  /** Other buttons for a form */
  cancel: EgdsButton;
  /** Input name for new property group */
  nameInput: EgdsInputField;
  /** Submit button for a form */
  submit: EgdsButton;
};

/** Validation warnings */
export type PropertyGroupFormValidationWarnings = {
  __typename?: "PropertyGroupFormValidationWarnings";
  /** Warning if no name has been entered */
  noNameInput?: Maybe<Scalars["String"]>;
  /** Warning if no properties have been selected */
  noSelectedProperties?: Maybe<Scalars["String"]>;
};

export type PropertyHeading = EgdsSectionHeading & {
  __typename?: "PropertyHeading";
  heading: EgdsHeading;
  subheading?: Maybe<Scalars["String"]>;
};

/** Server driven property highlight section */
export type PropertyHighlightSection = AccessibilityField & {
  __typename?: "PropertyHighlightSection";
  /** Label where a11y behavior is needed. */
  accessibilityLabel?: Maybe<Scalars["String"]>;
  /** Footer link for the section */
  footerLink?: Maybe<LodgingLinkMessage>;
  /** Header for the section */
  header?: Maybe<LodgingHeader>;
  /**
   * Message for a11y label.
   * @deprecated Use accessibilityLabel, replace with accessibilityLabel
   */
  label?: Maybe<Scalars["String"]>;
  /** sub sections for the highlight section */
  subSections: Array<PropertyHighlightSubSection>;
};

/** Sub section for the highlight section */
export type PropertyHighlightSubSection = AccessibilityField & {
  __typename?: "PropertyHighlightSubSection";
  /** Label where a11y behavior is needed. */
  accessibilityLabel?: Maybe<Scalars["String"]>;
  /** Content items for highlight sub section */
  contents: Array<LodgingEnrichedMessage>;
  /** Text description for the section */
  description?: Maybe<Scalars["String"]>;
  /** Footer link for the subSection */
  footerLink?: Maybe<LodgingLinkMessage>;
  /**
   * Message for a11y label.
   * @deprecated Use accessibilityLabel, replace with accessibilityLabel
   */
  label?: Maybe<Scalars["String"]>;
  /** Text description for the title of the section */
  title?: Maybe<LodgingEnrichedMessage>;
};

/** Image for this property */
export type PropertyImage = {
  __typename?: "PropertyImage";
  /** Accessibility description for the action of tapping this image */
  actionAccessibility?: Maybe<Scalars["String"]>;
  /** Accessibility text for this image */
  alt?: Maybe<Scalars["String"]>;
  /** Fallback image to use if `image` fails to load */
  fallbackImage?: Maybe<Image>;
  /** Image for this property */
  image: Image;
  /** Unique identifier of the image */
  imageId?: Maybe<Scalars["String"]>;
  /** Low resolution version of this image */
  lowResImage?: Maybe<Image>;
  /** Image Type/Categorization - e.g. Pool Image - Used for Analytics */
  subjectId?: Maybe<Scalars["Int"]>;
  /** Thumbnail version of this image */
  thumbnail?: Maybe<Image>;
};

/** Image gallery for this property */
export type PropertyImageGallery = AccessibilityField & {
  __typename?: "PropertyImageGallery";
  /** Label where a11y behavior is needed. */
  accessibilityLabel?: Maybe<Scalars["String"]>;
  /** All categories for this property */
  categories?: Maybe<Array<PropertyGalleryCategory>>;
  /** Featured image for this property */
  featured?: Maybe<PropertyImage>;
  /** Buttons that can be assigned to the gallery for post actions. */
  galleryButtons?: Maybe<Array<EgdsOverlayButton>>;
  /** All images for this property */
  images: Array<PropertyImage>;
  /**
   * Accessibility label
   * @deprecated Use accessibilityLabel, replace with accessibilityLabel
   */
  label?: Maybe<Scalars["String"]>;
  /** Dialog for the fullscreen images of a property */
  mediaGalleryDialog?: Maybe<LodgingGalleryDialog>;
  /** Dialog for the thumbnail images of a property */
  thumbnailGalleryDialog?: Maybe<LodgingGalleryDialog>;
};

export type PropertyInfo = {
  __typename?: "PropertyInfo";
  /** @deprecated for federation use.  Do not use this. */
  deprecatedPropertyContext: DeprecatedPropertyContext;
  /** @deprecated for federation use.  Do not use this. */
  deprecatedShoppingContext?: Maybe<DeprecatedShoppingContext>;
  /** Direct feedback prompt ID */
  directFeedback?: Maybe<DirectFeedback>;
  /**
   * Experimental features.
   * @deprecated Deprecated. Contents are volatile and subject to change at any moment. Use at your own risk!
   */
  experimental: PropertyDetailsExperimentalSection;
  /** Get feedback information */
  feedback: Feedback;
  /** Get Frequently Asked Questions with its responses */
  frequentlyAskedQuestions?: Maybe<PropertyFaQs>;
  /**
   * Get property image gallery
   * @deprecated Replaced by propertyGallery as part of BFF to BEX-API migration
   */
  gallery?: Maybe<PropertyGallery>;
  /** The property id */
  id: Scalars["String"];
  /**
   * Get infosite url
   * @deprecated Use the one in Offers
   */
  infositeUrl?: Maybe<Scalars["URL"]>;
  /** returns lodging summary for prebundle package */
  lodgingProduct: LodgingProductView;
  /** Get property rooms and rates pricing */
  offer?: Maybe<OfferDetails>;
  /**
   * offerOptions for federation
   * @deprecated do not use. This is for federation use
   */
  offerOptions?: Maybe<Array<PropertyInfoOptions>>;
  /** Get property rooms and rates pricing */
  offers?: Maybe<OfferDetails>;
  /** Get property calendar rate information with pricing in relation to dates */
  propertyCalendar: PropertyCalendar;
  /** Get content on the infosite page */
  propertyContentSectionGroups: PropertyContentSectionGroups;
  /** Get content details for a property */
  propertyDetails: PropertyDetails;
  /** Get property image gallery */
  propertyGallery?: Maybe<PropertyImageGallery>;
  /** @deprecated Moved to PropertySummary, replace with PropertySummary.spaceOverview: PropertyInfoContent? */
  propertyHighlightedDetails?: Maybe<PropertyInfoContent>;
  /**
   * propertyName for federation
   * @deprecated do not use. This is for federation use
   */
  propertyName?: Maybe<Scalars["String"]>;
  /**
   * referrer for federation
   * @deprecated do not use. This is for federation use
   */
  referrer?: Maybe<Scalars["String"]>;
  /** Get a single property review */
  review?: Maybe<PropertyReview>;
  /** Get property reviews and review summary information */
  reviewInfo: PropertyReviews;
  /** Provide required values to be able to trigger Trip planning view. */
  saveTripItem?: Maybe<TripsSaveItem>;
  /** Get the information related to Property Share and also a list of Links that we want to share like Facebook */
  shareInfo?: Maybe<ShareInfo>;
  /**
   * Information if the property is shortListed and the urls to call to save or remove the property
   * @deprecated Deprecated in favor of tripsSaveItem
   */
  shortList?: Maybe<ShortList>;
  /** Get similar properties list with recommended filter options */
  similarProperties?: Maybe<SimilarProperties>;
  /** Get property summary information */
  summary?: Maybe<PropertySummary>;
  /** Get property telesales phone number details */
  telesales?: Maybe<Telesales>;
  /** Get top positive and top critical reviews */
  topReviews?: Maybe<PropertyTopReviews>;
};

export type PropertyInfoInfositeUrlArgs = {
  dateRange?: InputMaybe<PropertyDateRangeInput>;
  roomInput?: InputMaybe<Array<RoomInput>>;
};

export type PropertyInfoLodgingProductArgs = {
  searchCriteria: PropertySearchCriteriaInput;
  searchOffer: SearchOfferInput;
};

export type PropertyInfoOfferArgs = {
  marketing?: InputMaybe<PropertyMarketingInfoInput>;
  naturalKeys: Array<PropertyNaturalKeyInput>;
};

export type PropertyInfoOffersArgs = {
  dateRange?: InputMaybe<PropertyDateRangeInput>;
  marketing?: InputMaybe<PropertyMarketingInfoInput>;
  roomInput?: InputMaybe<Array<RoomInput>>;
  searchCriteria?: InputMaybe<PropertySearchCriteriaInput>;
  searchOffer?: InputMaybe<SearchOfferInput>;
  travelAdTrackingInfo?: InputMaybe<PropertyTravelAdTrackingInfoInput>;
};

export type PropertyInfoPropertyCalendarArgs = {
  dateRange: PropertyDateRangeInput;
  roomInput: Array<RoomInput>;
};

export type PropertyInfoPropertyContentSectionGroupsArgs = {
  damageLiability?: InputMaybe<DamageLiability>;
  dateRange?: InputMaybe<PropertyDateRangeInput>;
  searchCriteria?: InputMaybe<PropertySearchCriteriaInput>;
};

export type PropertyInfoPropertyDetailsArgs = {
  searchCriteria?: InputMaybe<PropertySearchCriteriaInput>;
};

export type PropertyInfoReviewArgs = {
  id: Scalars["String"];
  locale?: InputMaybe<Scalars["Locale"]>;
};

export type PropertyInfoReviewInfoArgs = {
  end?: InputMaybe<Scalars["Int"]>;
  filters?: InputMaybe<PropertyReviewFiltersInput>;
  pagination?: InputMaybe<PaginationInput>;
  searchCriteria?: InputMaybe<PropertySearchCriteriaInput>;
  sortBy?: InputMaybe<PropertyReviewSort>;
  start?: InputMaybe<Scalars["Int"]>;
};

export type PropertyInfoSaveTripItemArgs = {
  searchCriteria?: InputMaybe<PropertySearchCriteriaInput>;
};

export type PropertyInfoSimilarPropertiesArgs = {
  propertyRecommendationStrategy?: InputMaybe<PropertyRecommendationStrategy>;
  searchCriteria?: InputMaybe<PropertySearchCriteriaInput>;
};

export type PropertyInfoTopReviewsArgs = {
  searchCriteria?: InputMaybe<PropertySearchCriteriaInput>;
};

export type PropertyInfoAction = PropertyInfoJumpLink;

export type PropertyInfoContent = {
  __typename?: "PropertyInfoContent";
  header?: Maybe<LodgingHeader>;
  /** @deprecated Use header instead */
  heading?: Maybe<Scalars["String"]>;
  icon?: Maybe<Icon>;
  /** Analytics data for tracking icon click. */
  iconAnalytics?: Maybe<ClientSideAnalytics>;
  items: Array<PropertyInfoItem>;
  jumpLink?: Maybe<PropertyInfoJumpLink>;
  seeMoreAction?: Maybe<SeeMoreAction>;
  structuredData?: Maybe<SeoStructuredData>;
  /** @deprecated UI needs a nullable label. Use heading instead. */
  title: Scalars["String"];
};

export type PropertyInfoItem = AccessibilityField & {
  __typename?: "PropertyInfoItem";
  accessibilityLabel?: Maybe<Scalars["String"]>;
  graphic?: Maybe<UiGraphic>;
  icon?: Maybe<Icon>;
  label?: Maybe<Scalars["String"]>;
  moreInfo?: Maybe<Scalars["String"]>;
  moreInfoDialog?: Maybe<LodgingPlainDialog>;
  state?: Maybe<Scalars["String"]>;
  structuredData?: Maybe<SeoStructuredData>;
  text: Scalars["String"];
};

export type PropertyInfoJumpLink = LodgingJumpLink & {
  __typename?: "PropertyInfoJumpLink";
  accessibilityLabel?: Maybe<Scalars["String"]>;
  icon?: Maybe<Icon>;
  localizedName: Scalars["String"];
  sectionName: Scalars["String"];
};

export type PropertyInfoMap = LodgingDialog & {
  __typename?: "PropertyInfoMap";
  /** Returns the bounds of the map */
  bounds?: Maybe<Bounds>;
  /** Returns the center coordinates of the map */
  center?: Maybe<Coordinates>;
  /** Child dialogs that can be triggered when the map is open */
  dialogs?: Maybe<Array<PlacesDialog>>;
  /** Returns the list of map marker filters of the map */
  markerPills: Array<PropertyInfoMapPill>;
  /** Returns the list of markers that should be displayed on the map */
  markers?: Maybe<Array<PropertyDetailPlottable>>;
  /** Returns the static map url */
  staticMapSrc?: Maybe<Scalars["String"]>;
  /**
   * Returns the title of the map
   * @deprecated Use toolbar, replace with toolbar
   */
  title?: Maybe<Scalars["String"]>;
  /** Representation of the top header bar of a EGDS dialog. */
  toolbar?: Maybe<LodgingDialogToolbar>;
  /** Trigger that will open the dialog. */
  trigger: LodgingDialogTriggerMessage;
  /** Returns the zoom level of the map */
  zoom?: Maybe<Scalars["Int"]>;
};

export type PropertyInfoMapPill = {
  __typename?: "PropertyInfoMapPill";
  isSelected: Scalars["Boolean"];
  label: Scalars["String"];
  type: Scalars["String"];
};

/** Interface for offers, messaging, or anything in the offers results list. */
export type PropertyInfoOffersListing = MessageResult | PropertyUnit | RecommendedOffer;

/** Options that are not filters. Refer @code { SearchOptions } */
export type PropertyInfoOptions =
  /** Use loyalty points to calculate the strikeout price. aka `swpApplied=true` */
  "SHOP_WITH_POINTS";

export type PropertyInfoSection = {
  __typename?: "PropertyInfoSection";
  action?: Maybe<PropertyInfoAction>;
  contents: Array<PropertyInfoContent>;
  /** @deprecated Label used by the PWA to drive automation testing */
  dataLabel?: Maybe<Scalars["String"]>;
  /** Expansion, collapse and analytics associated with component */
  expando?: Maybe<LodgingExpando>;
  header?: Maybe<LodgingHeader>;
  /** @deprecated PropertyInfoSubSection is competing similar model as PropertyInfoContent but is less flexible. Replaced by contents field. */
  sections: Array<PropertyInfoSubSection>;
  /** @deprecated Replaced by the more flexible LodgingHeader type, replace with header.text */
  title?: Maybe<Scalars["String"]>;
};

export type PropertyInfoSubSection = {
  __typename?: "PropertyInfoSubSection";
  body: Array<Scalars["String"]>;
  descriptions: Array<Scalars["String"]>;
  title?: Maybe<Scalars["String"]>;
};

/** Disclaimer information about the property for legal compliance */
export type PropertyLegalDisclaimer = {
  __typename?: "PropertyLegalDisclaimer";
  /** Localized list of disclaimer texts about the property */
  disclaimerContents?: Maybe<Array<Scalars["String"]>>;
  /** Localized title with disclaimer info */
  title?: Maybe<Scalars["String"]>;
};

/** Listing card which can be expanded to display a list of icon text. */
export type PropertyListingsIconTextExpando = {
  __typename?: "PropertyListingsIconTextExpando";
  /** Content displayed/hidden when the card is expanded/collapsed */
  expandedContent?: Maybe<Array<EgdsGraphicText>>;
  /** Information to display in the expando section of the card e.g.  expanded title, collapse title */
  expandoCard?: Maybe<EgdsExpandoCard>;
  /** UI Graphic to display the graphic along with the expando title */
  graphic?: Maybe<UiGraphic>;
};

export type PropertyLocation = {
  __typename?: "PropertyLocation";
  address?: Maybe<PropertyAddress>;
  coordinates?: Maybe<Coordinates>;
  /**
   * Returns the CTA label for map
   * @deprecated The summary structure should be refactored, prevent use that structure on future implementation
   */
  mapDialog?: Maybe<LodgingMapDialog>;
  multiCityRegion?: Maybe<Region>;
  /** @deprecated Replaced by 'staticImage' field. */
  overviewStaticMapSrc?: Maybe<Scalars["String"]>;
  parentRegion?: Maybe<Region>;
  /** Returns the static map url with a description */
  staticImage?: Maybe<Image>;
  whatsAround?: Maybe<PropertyWhatsAround>;
};

/** Discount information based on Loyalty program for the user */
export type PropertyLoyaltyDiscount = {
  __typename?: "PropertyLoyaltyDiscount";
  /**
   * Messaging indicating the currency value of the loyalty points applied
   * @deprecated Legacy message used on HSR for showing loyalty points, replace with saveWithPointsMessage, saveWithPointsActionMessage
   */
  pointsAppliedMessage?: Maybe<Scalars["String"]>;
  /** Discount available to use based on Loyalty points */
  pointsDiscount?: Maybe<Money>;
  /** Use this component to let users switch/toggle usage of points */
  pointsToggle?: Maybe<UiToggle>;
  /** Discount available to use for VIP properties based on Loyalty points */
  pointsVIPDiscount?: Maybe<Money>;
  /** Messaging for toggling loyalty points */
  saveWithPointsActionMessage?: Maybe<Scalars["String"]>;
  /** Messaging indicating the currency value of the loyalty points */
  saveWithPointsMessage?: Maybe<Scalars["String"]>;
  /** Tier Name for this loyalty program, for example 'GOLD','SILVER'  */
  tierName?: Maybe<Scalars["String"]>;
};

/** Container of all the marketing data */
export type PropertyMarketingInfo = {
  __typename?: "PropertyMarketingInfo";
  /** Deprecated: Don't get/set value from this field, ReplaceWith("marketingChannels"), Meta affcid channel code */
  affcid?: Maybe<Scalars["String"]>;
  /** Deprecated: Don't get/set value from this field, ReplaceWith("marketingChannels"), Meta afflid channel code */
  afflid?: Maybe<Scalars["String"]>;
  /** Deprecated: Don't get/set value from this field, ReplaceWith("marketingChannels"), Meta afmcid channel code */
  afmcid?: Maybe<Scalars["String"]>;
  /** Deprecated: Don't get/set value from this field, ReplaceWith("marketingChannels"), Meta brandcid channel code */
  brandcid?: Maybe<Scalars["String"]>;
  /** Deprecated: Don't get/set value from this field, ReplaceWith("marketingChannels"), Meta emlcid channel code */
  emlcid?: Maybe<Scalars["String"]>;
  /** Deprecated: Don't get/set value from this field, ReplaceWith("marketingChannels"), Meta emldtl channel code */
  emldtl?: Maybe<Scalars["String"]>;
  /** Deprecated: Don't get/set value from this field, ReplaceWith("marketingChannels"), Meta gclid channel code */
  gclid?: Maybe<Scalars["String"]>;
  /** Deprecated: Don't get/set value from this field, ReplaceWith("marketingChannels"), Meta icmcid channel code */
  icmcid?: Maybe<Scalars["String"]>;
  /** Deprecated: Don't get/set value from this field, ReplaceWith("marketingChannels"), Meta icmdtl channel code */
  icmdtl?: Maybe<Scalars["String"]>;
  /** Deprecated: Don't get/set value from this field, ReplaceWith("marketingChannels"), Meta k_user_id channel code */
  k_user_id?: Maybe<Scalars["String"]>;
  /** Deprecated: Don't get/set value from this field, ReplaceWith("marketingChannels"), Meta kword channel code */
  kword?: Maybe<Scalars["String"]>;
  /** Deprecated: Don't get/set value from this field, ReplaceWith("marketingChannels"), Meta lnkloc channel code */
  lnkloc?: Maybe<Scalars["String"]>;
  /**
   * A consolidated list of marketing channels in key/value pairs.
   * Example: [{"key": "mctc", "value": "2"}, {"key": "icmdtl", "value": "some values"}]
   */
  marketingChannels?: Maybe<Array<PropertyMarketingTag>>;
  /**
   * A consolidated list of marketing prices in key/value pairs.
   * Example: [{"key": "exp_dp", "value": "100"}, {"key": "exp_tx", "value": "10"}]
   */
  marketingPrices?: Maybe<Array<PropertyMarketingTag>>;
  /** Deprecated: Don't get/set value from this field , ReplaceWith("marketingChannels") ,Marketing Channel Type Code: Indicates traffic type, i.e. 5 for Trivago */
  mctc?: Maybe<Scalars["Int"]>;
  /** Deprecated: Don't get/set value from this field, ReplaceWith("marketingChannels"), Meta mdpcid channel code */
  mdpcid?: Maybe<Scalars["String"]>;
  /** Deprecated: Don't get/set value from this field,ReplaceWith("marketingChannels"),  Meta mdpdtl channel code */
  mdpdtl?: Maybe<Scalars["String"]>;
  /** Deprecated: Don't get/set value from this field, ReplaceWith("marketingChannels"), Meta olacid channel code */
  olacid?: Maybe<Scalars["String"]>;
  /** Deprecated: Don't get/set value from this field, ReplaceWith("marketingChannels"), Meta oladtl channel code */
  oladtl?: Maybe<Scalars["String"]>;
  /** Deprecated: Don't get/set value from this field, ReplaceWith("marketingChannels"), Meta semcid channel code */
  semcid?: Maybe<Scalars["String"]>;
  /** Deprecated: Don't get/set value from this field, ReplaceWith("marketingChannels"), Meta semdtl channel code */
  semdtl?: Maybe<Scalars["String"]>;
  /** Deprecated: Don't get/set value from this field, ReplaceWith("marketingChannels"), Meta seocid channel code */
  seocid?: Maybe<Scalars["String"]>;
};

/** Container of all the marketing data */
export interface PropertyMarketingInfoInput {
  /** Deprecated: Don't get/set value from this field, ReplaceWith("marketingChannels"), Meta affcid channel code */
  affcid?: InputMaybe<Scalars["String"]>;
  /** Deprecated: Don't get/set value from this field, ReplaceWith("marketingChannels"), Meta afflid channel code */
  afflid?: InputMaybe<Scalars["String"]>;
  /** Deprecated: Don't get/set value from this field, ReplaceWith("marketingChannels"), Meta afmcid channel code */
  afmcid?: InputMaybe<Scalars["String"]>;
  /** Deprecated: Don't get/set value from this field, ReplaceWith("marketingChannels"), Meta brandcid channel code */
  brandcid?: InputMaybe<Scalars["String"]>;
  /** Deprecated: Don't get/set value from this field, ReplaceWith("marketingChannels"), Meta emlcid channel code */
  emlcid?: InputMaybe<Scalars["String"]>;
  /** Deprecated: Don't get/set value from this field, ReplaceWith("marketingChannels"), Meta emldtl channel code */
  emldtl?: InputMaybe<Scalars["String"]>;
  /** Deprecated: Don't get/set value from this field, ReplaceWith("marketingChannels"), Meta gclid channel code */
  gclid?: InputMaybe<Scalars["String"]>;
  /** Deprecated: Don't get/set value from this field, ReplaceWith("marketingChannels"), Meta icmcid channel code */
  icmcid?: InputMaybe<Scalars["String"]>;
  /** Deprecated: Don't get/set value from this field, ReplaceWith("marketingChannels"), Meta icmdtl channel code */
  icmdtl?: InputMaybe<Scalars["String"]>;
  /** Deprecated: Don't get/set value from this field, ReplaceWith("marketingChannels"), Meta k_user_id channel code */
  k_user_id?: InputMaybe<Scalars["String"]>;
  /** Deprecated: Don't get/set value from this field, ReplaceWith("marketingChannels"), Meta kword channel code */
  kword?: InputMaybe<Scalars["String"]>;
  /** Deprecated: Don't get/set value from this field, ReplaceWith("marketingChannels"), Meta lnkloc channel code */
  lnkloc?: InputMaybe<Scalars["String"]>;
  /**
   * A consolidated list of marketing channels in key/value pairs.
   * Example: [{"key": "mctc", "value": "2"}, {"key": "icmdtl", "value": "some values"}]
   */
  marketingChannels?: InputMaybe<Array<PropertyMarketingTagInput>>;
  /**
   * A consolidated list of marketing prices in key/value pairs.
   * Example: [{"key": "exp_dp", "value": "100"}, {"key": "exp_tx", "value": "10"}]
   */
  marketingPrices?: InputMaybe<Array<PropertyMarketingTagInput>>;
  /** Deprecated: Don't get/set value from this field , ReplaceWith("marketingChannels") ,Marketing Channel Type Code: Indicates traffic type, i.e. 5 for Trivago */
  mctc?: InputMaybe<Scalars["Int"]>;
  /** Deprecated: Don't get/set value from this field, ReplaceWith("marketingChannels"), Meta mdpcid channel code */
  mdpcid?: InputMaybe<Scalars["String"]>;
  /** Deprecated: Don't get/set value from this field,ReplaceWith("marketingChannels"),  Meta mdpdtl channel code */
  mdpdtl?: InputMaybe<Scalars["String"]>;
  /** Deprecated: Don't get/set value from this field, ReplaceWith("marketingChannels"), Meta olacid channel code */
  olacid?: InputMaybe<Scalars["String"]>;
  /** Deprecated: Don't get/set value from this field, ReplaceWith("marketingChannels"), Meta oladtl channel code */
  oladtl?: InputMaybe<Scalars["String"]>;
  /** Deprecated: Don't get/set value from this field, ReplaceWith("marketingChannels"), Meta semcid channel code */
  semcid?: InputMaybe<Scalars["String"]>;
  /** Deprecated: Don't get/set value from this field, ReplaceWith("marketingChannels"), Meta semdtl channel code */
  semdtl?: InputMaybe<Scalars["String"]>;
  /** Deprecated: Don't get/set value from this field, ReplaceWith("marketingChannels"), Meta seocid channel code */
  seocid?: InputMaybe<Scalars["String"]>;
}

/**
 * An object with simple key/value combination for a marketing channel or price.
 * Example: {"key": "mctc", "value": "3"}
 */
export type PropertyMarketingTag = {
  __typename?: "PropertyMarketingTag";
  key: Scalars["String"];
  value: Scalars["String"];
};

/**
 * An object with simple key/value combination for a marketing channel or price.
 * Example: {"key": "mctc", "value": "3"}
 */
export interface PropertyMarketingTagInput {
  key: Scalars["String"];
  value: Scalars["String"];
}

/** Minimum set of data used to retrieve details about a property product */
export type PropertyNaturalKey = {
  __typename?: "PropertyNaturalKey";
  businessModelType?: Maybe<BusinessModelType>;
  checkIn: Date;
  checkOut: Date;
  id: Scalars["String"];
  inventoryType: InventoryType;
  noCreditCard?: Maybe<Scalars["Boolean"]>;
  /** Pet permissibility & inclusion at property. Necessary when pets are used in primary search criteria */
  petsIncluded?: Maybe<Scalars["Boolean"]>;
  ratePlanId: Scalars["String"];
  ratePlanType?: Maybe<Scalars["String"]>;
  roomTypeId: Scalars["String"];
  rooms: Array<PropertyRoom>;
  shoppingPath?: Maybe<ShoppingPathType>;
};

/** Minimum set of data used to retrieve details about a property product */
export interface PropertyNaturalKeyInput {
  businessModelType?: InputMaybe<BusinessModelType>;
  checkIn: DateInput;
  checkOut: DateInput;
  id: Scalars["String"];
  inventoryType: InventoryType;
  noCreditCard?: InputMaybe<Scalars["Boolean"]>;
  /** Pet permissibility & inclusion at property. Necessary when pets are used in primary search criteria */
  petsIncluded?: InputMaybe<Scalars["Boolean"]>;
  ratePlanId: Scalars["String"];
  ratePlanType?: InputMaybe<Scalars["String"]>;
  roomTypeId: Scalars["String"];
  rooms: Array<PropertyRoomInput>;
  shoppingPath?: InputMaybe<ShoppingPathType>;
}

export type PropertyNavigationBarTab = LodgingJumpLink & {
  __typename?: "PropertyNavigationBarTab";
  icon?: Maybe<Icon>;
  localizedName: Scalars["String"];
  sectionName: Scalars["String"];
  /** Default tab to be displayed if state = ACTIVE */
  state?: Maybe<Scalars["String"]>;
  tabLink?: Maybe<LodgingLinkMessage>;
};

/** Minimum set of data used to retrieve details about a property product */
export type PropertyOffer = {
  __typename?: "PropertyOffer";
  /** @deprecated DO NOT USE: This is required for the federation migration */
  deprecatedContext?: Maybe<DeprecatedMultiItemContext>;
  /** @deprecated DO NOT USE: This is required for the federation migration */
  federationNaturalKeys?: Maybe<Array<FederationPropertyNaturalKey>>;
  /** Sometimes, 1 room's offer needs to be represented by more than 1 Property Natural Key, e.g: Mixed Rate Plan */
  naturalKeys: Array<PropertyNaturalKey>;
  /** @deprecated Added for stitching migration purposes only. Can be deleted once all clients migrate., replace with propertyOffer */
  offer?: Maybe<OfferDetails>;
  /** The index of the room user is adding */
  offerIndex: Scalars["Int"];
  /** The property id for all the offers in the natural keys */
  propertyId?: Maybe<Scalars["String"]>;
  propertyOffer?: Maybe<OfferDetails>;
};

/** Minimum set of data used to retrieve details about a property product */
export type PropertyOfferPropertyOfferArgs = {
  context: ContextInput;
};

/** Minimum set of data used to retrieve details about a property product */
export interface PropertyOfferInput {
  /** Sometimes, 1 room's offer needs to be represented by more than 1 Property Natural Key, e.g: Mixed Rate Plan */
  naturalKeys: Array<PropertyNaturalKeyInput>;
  /** The index of the room user is adding */
  offerIndex: Scalars["Int"];
}

export type PropertyOfferItem = OfferItem & {
  __typename?: "PropertyOfferItem";
  /** Badge to be displayed for the hotel offer */
  badge?: Maybe<CampaignOfferBadge>;
  /** Range of dates the offer is applicable */
  dates?: Maybe<Scalars["String"]>;
  /** Description of the hotel offer */
  description?: Maybe<Scalars["String"]>;
  /** Discount Badge to be displayed for the hotel offer */
  discountBadge?: Maybe<CampaignOfferBadge>;
  /** Free Cancellation message */
  freeCancellationMessage?: Maybe<Scalars["String"]>;
  /** Guest review count */
  guestReviewCount?: Maybe<Scalars["String"]>;
  /** Guest review qualifier text */
  guestReviewQualifierText?: Maybe<Scalars["String"]>;
  /** Guest review rating of the hotel */
  guestReviewRating?: Maybe<Scalars["String"]>;
  /** Guest review rating qualifier text */
  guestReviewRatingQualifierText?: Maybe<Scalars["String"]>;
  /** Guest review text */
  guestReviewText?: Maybe<Scalars["String"]>;
  /** Image to be displayed for the hotel offer */
  image: Image;
  /** Location of the hotel */
  location?: Maybe<Scalars["String"]>;
  /** Lodging offer price and link */
  lodgingOffer?: Maybe<OfferData>;
  /** MOD content */
  mod?: Maybe<ModItem>;
  /** Name of the hotel where the offer is applicable */
  name: Scalars["String"];
  /** Secondary content related to the destination offer */
  secondaryContent?: Maybe<Scalars["String"]>;
  /** Star rating of the hotel */
  starRating?: Maybe<Scalars["Float"]>;
  /** VAP message */
  vapMessage?: Maybe<Scalars["String"]>;
  /** VIP message */
  vipMessage?: Maybe<Scalars["String"]>;
};

export type PropertyOffers = {
  __typename?: "PropertyOffers";
  /** Information about individual room offers */
  rooms?: Maybe<Array<RoomViewModel>>;
};

export type PropertyOffersExperimentalSection = LodgingExperimentalSection & {
  __typename?: "PropertyOffersExperimentalSection";
  /** Offers experimental features as a list for automation purposes. */
  features: Array<LodgingExperimentalMetaData>;
};

export type PropertyOffersExperimentalSectionFeaturesArgs = {
  createdAfter?: InputMaybe<DateInput>;
  createdBefore?: InputMaybe<DateInput>;
  description?: InputMaybe<Scalars["String"]>;
  id?: InputMaybe<Scalars["Int"]>;
  name?: InputMaybe<Scalars["String"]>;
  org?: InputMaybe<Scalars["String"]>;
  team?: InputMaybe<Scalars["String"]>;
};

export type PropertyOverview = AccessibilityField & {
  __typename?: "PropertyOverview";
  accessibilityLabel?: Maybe<Scalars["String"]>;
  inventoryType?: Maybe<InventoryType>;
  label?: Maybe<Scalars["String"]>;
  propertyRating?: Maybe<EgdsIconRating>;
  propertyTagline?: Maybe<Scalars["String"]>;
  shortDescription?: Maybe<Scalars["String"]>;
  /** @deprecated Use propertyRating */
  starRating?: Maybe<Scalars["Float"]>;
  vipMessaging?: Maybe<Scalars["String"]>;
};

export type PropertyPaymentFlags = "ARTIFICIALLY_FENCED_RATE" | "MIXED_RATE_PLAN" | "NO_CREDIT_CARD";

export type PropertyPaymentModel = "PAY_LATER" | "PAY_LATER_WITH_DEPOSIT" | "PAY_NOW";

export type PropertyPaymentOption = {
  __typename?: "PropertyPaymentOption";
  image?: Maybe<Scalars["URL"]>;
  name: Scalars["String"];
};

export type PropertyPaymentPolicyInfo = {
  __typename?: "PropertyPaymentPolicyInfo";
  descriptions: Array<PropertyInfoContent>;
  heading: Scalars["String"];
  paymentType: PropertyPaymentType;
  price?: Maybe<PropertyPrice>;
};

/** Indicate what are the payment options for a given offer */
export type PropertyPaymentType = "PAY_LATER" | "PAY_LATER_WITH_DEPOSIT" | "PAY_NOW";

/** The policies for a property */
export type PropertyPolicies = {
  __typename?: "PropertyPolicies";
  /** The check in end time */
  checkinEnd?: Maybe<Scalars["String"]>;
  /** instructions on how to check in */
  checkinInstructions: Array<Scalars["String"]>;
  /** The minimum age a guest has to be in order to check in */
  checkinMinAge?: Maybe<Scalars["String"]>;
  /** policies for the Check-in sub-section */
  checkinPolicies: Array<Scalars["String"]>;
  /** The check in start time */
  checkinStart?: Maybe<Scalars["String"]>;
  /** policies for the Check-out sub-section */
  checkoutPolicies: Array<Scalars["String"]>;
  /** the checkout time */
  checkoutTime?: Maybe<Scalars["String"]>;
  /** child and bed policies sub-section */
  childAndBed?: Maybe<PropertyInfoSubSection>;
  /** need to know sub-section */
  needToKnow?: Maybe<PropertyInfoSubSection>;
  /** The payment options accepted in order to make a booking */
  paymentOptions: Array<PropertyPaymentOption>;
  /** pets policies sub-section */
  pets?: Maybe<PropertyInfoSubSection>;
  /** should mention policies sub-section */
  shouldMention?: Maybe<PropertyInfoSubSection>;
};

export type PropertyPrice = {
  __typename?: "PropertyPrice";
  /**
   * Used in conjunction with displayMessages to describe the layout. i.e. LEFT, RIGHT
   * @deprecated UI should determine the alignment
   */
  alignment?: Maybe<Scalars["String"]>;
  /** @deprecated Legal disclaimer, replace with disclaimer in PropertyPriceOption */
  disclaimer?: Maybe<LodgingPlainMessage>;
  /** Describes how to layout the price and its messages */
  displayMessages?: Maybe<Array<PriceDisplayMessage>>;
  /** @deprecated Replace with list of options */
  lead?: Maybe<Money>;
  /** TAAP marketing fees */
  marketingFeeDetails?: Maybe<MarketingFeeDetails>;
  /** MultiItem price token */
  multiItemPriceToken?: Maybe<Scalars["String"]>;
  /** list of price options i.e. cash, points */
  options?: Maybe<Array<PropertyPriceOption>>;
  /** @deprecated Use priceMessaging instead */
  priceMessages?: Maybe<Array<LodgingPlainMessage>>;
  /** list of price messages */
  priceMessaging?: Maybe<Array<LodgingEnrichedMessage>>;
  /** @deprecated Replace with list of priceMessages */
  roomNightMessage?: Maybe<Scalars["String"]>;
  /** @deprecated Replace with list of options */
  strikeOut?: Maybe<Money>;
  /** @deprecated Replace with list of options */
  strikeOutType?: Maybe<StrikeOutType>;
  /** Total Price Signal for Checkout - uses Checkout definition of total price */
  total?: Maybe<Money>;
};

/** Contains metadata about lead discounts */
export type PropertyPriceMetadata = {
  __typename?: "PropertyPriceMetadata";
  /** The type of discount rule applied */
  discountType?: Maybe<RateDiscountType>;
  /** Special rate plans for this property */
  rateDiscount?: Maybe<RateDiscount>;
  saleCurrency?: Maybe<Scalars["String"]>;
  supplyCurrency?: Maybe<Scalars["String"]>;
  /** The overall discount percentage applied to a property */
  totalDiscountPercentage?: Maybe<Scalars["Int"]>;
};

export type PropertyPriceOption = AccessibilityField & {
  __typename?: "PropertyPriceOption";
  /** Label where a11y behavior is needed. */
  accessibilityLabel?: Maybe<Scalars["String"]>;
  /**
   * Disclaimer message.
   * @deprecated This is deprecated. Please use priceDisclaimer instead
   */
  disclaimer?: Maybe<LodgingPlainMessage>;
  /** price amount */
  displayPrice?: Maybe<Money>;
  /** formatted price amount containing any leadingCaption */
  formattedDisplayPrice?: Maybe<Scalars["String"]>;
  /**
   * Message for the accessibility label.
   * @deprecated Use accessibilityLabel, replace with accessibilityLabel
   */
  label?: Maybe<Scalars["String"]>;
  /** caption before price i.e. 'or' */
  leadingCaption?: Maybe<Scalars["String"]>;
  /** loyalty price i.e. points */
  loyaltyPrice?: Maybe<LoyaltyPrice>;
  /** Disclaimer message. */
  priceDisclaimer?: Maybe<LodgingPlainDialog>;
  /** strikeout price amount */
  strikeOut?: Maybe<Money>;
};

export type PropertyRating = EgdsRating & {
  __typename?: "PropertyRating";
  accessibility?: Maybe<Scalars["String"]>;
  rating: Scalars["Float"];
};

export type PropertyRecommendationStrategy = "NEARBY_PROPERTIES" | "SIMILAR_PROPERTIES";

/** The renovation notice for a property */
export type PropertyRenovations = {
  __typename?: "PropertyRenovations";
  /** Renovations & Closures */
  header?: Maybe<Scalars["String"]>;
  /** List of renovations notice returned from LSDS. */
  renovations?: Maybe<Array<Scalars["String"]>>;
  /** This property may be going under renovations. */
  subtitle?: Maybe<Scalars["String"]>;
  /** Title of renovations. */
  title?: Maybe<Scalars["String"]>;
};

export type PropertyResultsSummary = {
  __typename?: "PropertyResultsSummary";
  /** The count of available properties in the search */
  availablePropertiesSize: Scalars["Int"];
  /** @deprecated Replaces with generic message models., replace with resultsSummary */
  headerMessages?: Maybe<Array<ResultsHeaderMessage>>;
  /**
   * Loyalty Program Education
   * @deprecated Deprecating as we are moving away from dialogs style models along with its' contents
   */
  loyaltyEducation?: Maybe<LoyaltyEducation>;
  /** Loyalty information */
  loyaltyInfo?: Maybe<PropertyLoyaltyDiscount>;
  /** The count of properties in the searched market */
  marketSize: Scalars["Int"];
  /** The count of properties matched by the search */
  matchedPropertiesSize: Scalars["Int"];
  /**
   * Messages displayed within search results containing loyalty message, urgency message, or campaign message
   * @deprecated Use PropertySearchResults.propertySearchListings
   */
  messages?: Maybe<Array<MessageResult>>;
  /** @deprecated Not needed, pageView beacon is fired in experience-api-lodging-search */
  pageViewBeacon: Scalars["String"];
  /** The count of properties that the search rendered */
  pricedHotelSize: Scalars["Int"];
  /** Pricing Scheme for the POS - Total Rate or Daily Rate */
  pricingScheme?: Maybe<PricingScheme>;
  /** Property type carousel for VR qualified traffic */
  propertyTypeCarousel?: Maybe<SearchCarousel>;
  /** Search Region */
  region?: Maybe<Region>;
  /** Region level compression data */
  regionCompression?: Maybe<RegionCompression>;
  /** A list of various result messages for the properties search results */
  resultMessages: Array<LodgingSearchResultHeaderMessage>;
  /**
   * A heading to describe a section of the Search Results page
   * @deprecated Use PropertySearchResults.propertySearchListings
   */
  resultSectionHeadings?: Maybe<Array<ResultSectionHeading>>;
  /** Message to provide a heading representing the search results */
  resultsHeading?: Maybe<Scalars["String"]>;
  /**
   * Messages to provide a summary information about the search results
   * @deprecated Use resultMessages, replace with resultMessages
   */
  resultsSummary?: Maybe<Array<HeaderMessage>>;
  /** @deprecated Need to return a model instead of a string, replace with resultsSummary */
  resultsTitle?: Maybe<Scalars["String"]>;
  /** @deprecated Need to return a list of models instead of a single title, replace with resultsSummary */
  resultsTitleModel?: Maybe<ResultTitleModel>;
};

/** List of user generated reviews */
export type PropertyReview = {
  __typename?: "PropertyReview";
  /**
   * Reviewer author
   * @deprecated Deprecated along with the userLocation in favor of the reviewAuthorAttribution which combines them
   */
  author?: Maybe<Scalars["String"]>;
  /** Contains information about brand where review was first generated */
  brandType?: Maybe<Scalars["String"]>;
  /** This ID is used as an input for the directFeedbackPromptById query and it specifies which feedback prompt the traveler will see if they engage with the call to action */
  contentDirectFeedbackPromptId?: Maybe<Scalars["ID"]>;
  /** Text describing the usage of the feedback indicator */
  feedbackIndicator?: Maybe<FeedbackIndicator>;
  /**
   * The number of people that found the review useful
   * @deprecated Deprecated in favor of the reviewInteractionSections
   */
  helpfulReviewVotes?: Maybe<Scalars["String"]>;
  /** Unique identifier for a review */
  id: Scalars["String"];
  /** Review impression tracking */
  impressionAnalytics?: Maybe<ClientSideImpressionEventAnalytics>;
  /** Locale that this review is written in */
  locale: Scalars["Locale"];
  /** These are general remarks about the property location */
  locationRemarks?: Maybe<Scalars["String"]>;
  /** Response(s) from property management */
  managementResponses: Array<ManagementResponse>;
  /** These are negative remarks about the property */
  negativeRemarks?: Maybe<Scalars["String"]>;
  /** Property photos provided by user with analytics tracking data */
  photoSection?: Maybe<LodgingGalleryCarousel>;
  /** Property photos, provided by user */
  photos: Array<Image>;
  /** These are positive remarks about the property */
  positiveRemarks?: Maybe<Scalars["String"]>;
  /** Contains Vrbo brand logo and messages for users */
  propertyReviewSource?: Maybe<PropertyReviewSource>;
  /** Overall rating provided by user (out of 5) */
  ratingOverall: Scalars["Float"];
  /** Overall rating provided by user (out of 5) a11y label for screen readers */
  ratingOverallLabel: LodgingEnrichedMessage;
  /** Lodging header combining author name and location */
  reviewAuthorAttribution?: Maybe<LodgingHeader>;
  /** This is the section that contains review footer information */
  reviewFooter?: Maybe<PropertyReviewFooterSection>;
  /** Contains items for users to interact with review content */
  reviewInteractionSections?: Maybe<Array<PropertyReviewInteraction>>;
  /**
   * The flag of the review region
   * @deprecated Deprecated in favor of the PropertyReviewFooterSection
   */
  reviewRegion?: Maybe<Mark>;
  /** Review score with description (superlative) */
  reviewScoreWithDescription?: Maybe<LodgingEnrichedMessage>;
  /** Is the reviewer a verified traveler? */
  reviewerVerified: Scalars["Boolean"];
  /** Analytics data for tracking text see more click. */
  seeMoreAnalytics?: Maybe<ClientSideAnalytics>;
  /**
   * The stay duration of the reviewer
   * @deprecated Deprecated in favor of the PropertyReviewFooterSection
   */
  stayDuration?: Maybe<Scalars["String"]>;
  /**
   * Date and time review was submitted
   * @deprecated submissionTime is deprecated. Use submissionTimeLocalized.
   */
  submissionTime: DateTime;
  /** Localized date and time of review submitted */
  submissionTimeLocalized: Scalars["String"];
  /** A localized string representing the rating e.g. Excellent */
  superlative?: Maybe<Scalars["String"]>;
  /** User provided review content */
  text: Scalars["String"];
  /** Liked and disliked review themes */
  themes?: Maybe<Array<ReviewThemes>>;
  /** Review title, provided by user */
  title: Scalars["String"];
  /** Contains information around translation: what texts to show to the user, the locales etc... */
  translationInfo?: Maybe<PropertyReviewTranslationInfo>;
  /** Traveler/Traveler companion of traveler e.g Traveled with Partner */
  travelers: Array<Scalars["String"]>;
  /**
   * Reviewer name, provided by user
   * @deprecated Consolidated into author field, replace with author
   */
  userDisplayName: Scalars["String"];
  /** Reviewer location, provided by user */
  userLocation: Scalars["String"];
  /**
   * Reviewer nickname, provided by user
   * @deprecated Consolidated into author field, replace with author
   */
  userNickname: Scalars["String"];
};

export type PropertyReviewAggregates = {
  __typename?: "PropertyReviewAggregates";
  /** Returns a list of KeyPhrases and a localized component label */
  popularMentions?: Maybe<KeyPhrasesComponent>;
  /** Returns a list of propertySentiment */
  propertySentiment?: Maybe<Array<PropertySentiment>>;
  /** Returns a list of Summary of property */
  propertySummaries?: Maybe<Array<LodgingReviewSummary>>;
};

export type PropertyReviewAggregatesPopularMentionsArgs = {
  client?: InputMaybe<KeyPhrasesClientType>;
  limit?: InputMaybe<Scalars["Int"]>;
};

/** Filters review results by category type */
export type PropertyReviewCategory =
  | "BUSINESS_TRAVELERS"
  | "COUPLES"
  | "EVERYONE"
  | "FAMILIES"
  | "GETAWAY_WITH_FRIENDS"
  | "GOLF"
  | "OTHER"
  | "OVERNIGHT_STAY"
  | "PERSONAL_EVENT"
  | "SHOPPING"
  | "SPA"
  | "STUDENTS";

/** A property review sample */
export type PropertyReviewContent = {
  __typename?: "PropertyReviewContent";
  submissionDetails: Scalars["String"];
  text: Scalars["String"];
};

/** Property review count text */
export type PropertyReviewCountDetails = {
  __typename?: "PropertyReviewCountDetails";
  /** Verified review count, i.e 100 verified reviews */
  fullDescription?: Maybe<Scalars["String"]>;
  /** Review count, i.e 100 reviews */
  shortDescription?: Maybe<Scalars["String"]>;
};

/** [Optional] Review results filters */
export interface PropertyReviewFiltersInput {
  /** Filter review results by category */
  category?: InputMaybe<PropertyReviewCategory>;
  /** Include or disclude reviews that only have ratings */
  includeRatingsOnlyReviews?: InputMaybe<Scalars["Boolean"]>;
  /** Get reviews immediately when true (without 90 days syndication) */
  includeRecentReviews?: InputMaybe<Scalars["Boolean"]>;
  /** Filter reviews by specified languages by receiving lang code e.g. 'en' */
  language?: InputMaybe<Scalars["String"]>;
  /** Filter review results by reviewers' locale. Example: ko_KR returns reviews made by users on Korea POSa */
  locale?: InputMaybe<Scalars["Locale"]>;
  /** Filter review results by a list of review ratings */
  ratings?: InputMaybe<Array<Scalars["Float"]>>;
  /** Filter review results by review type: POSITIVE or CRITICAL */
  reviewType?: InputMaybe<PropertyReviewType>;
  /** Filter review results by room type */
  roomTypeId?: InputMaybe<Scalars["Int"]>;
  /** Filter review results by user provided keyword */
  searchTerm?: InputMaybe<Scalars["String"]>;
  /** Sort reviews by Recency, high-to-low rating and low-to-high rating */
  sortRating?: InputMaybe<Array<Scalars["String"]>>;
  /** DEPRECATED - Replaced by travelerType param. Filter review results by travel companions */
  travelCompanion?: InputMaybe<Array<Scalars["String"]>>;
  /** Filter reviews by tripReason and travelerCompanion depending on this list */
  travelerType?: InputMaybe<Array<Scalars["String"]>>;
  /** DEPRECATED - Replaced by travelerType param. Filter review results by trip reasons */
  tripReason?: InputMaybe<Array<Scalars["String"]>>;
}

/** Property review flag Dialog to Report Inappropriate content */
export type PropertyReviewFlagDialog = LodgingDialog & {
  __typename?: "PropertyReviewFlagDialog";
  content: PropertyReviewFlagDialogContent;
  toolbar?: Maybe<LodgingDialogToolbar>;
  trigger: LodgingDialogTriggerMessage;
};

/** Property review flag Dialog Content containing options and text to be shown to user */
export type PropertyReviewFlagDialogContent = {
  __typename?: "PropertyReviewFlagDialogContent";
  /** Community Info  */
  communityInfo: Scalars["String"];
  /** Options to be shown to user to allow reason selection */
  flagOptions: FilterViewModel;
  /** Partner related information  */
  partnerInfo: Scalars["String"];
  /** Partner Link  */
  partnerLink: LodgingLinkMessage;
  /** Submit button on form */
  primaryUIButton: UiPrimaryButton;
};

/** Message used for review types and matching SEO structured data */
export type PropertyReviewFooterMessage = {
  __typename?: "PropertyReviewFooterMessage";
  seoStructuredData?: Maybe<SeoStructuredData>;
  /** Messages that are used to render footer information for reviews */
  text: PropertyReviewFooterMessageText;
};

/** Return EGDSGraphicText or EGDSPlainText type */
export type PropertyReviewFooterMessageText = EgdsGraphicText | EgdsPlainText;

/** This will contain the list of information detailing the stay duration, author, the flag of the review region and the SEO data */
export type PropertyReviewFooterSection = {
  __typename?: "PropertyReviewFooterSection";
  messages: Array<PropertyReviewFooterMessage>;
};

/** Contains information required for users to interact with review content */
export type PropertyReviewInteraction = AccessibilityField & {
  __typename?: "PropertyReviewInteraction";
  /** Label where a11y behavior is needed. */
  accessibilityLabel?: Maybe<Scalars["String"]>;
  /** Analytics data for tracking review Interaction click */
  feedbackAnalytics?: Maybe<ClientSideAnalytics>;
  /** Icon representing ReviewInteractionType */
  icon?: Maybe<Icon>;
  /**
   * Message for a11y label.
   * @deprecated Use accessibilityLabel, replace with accessibilityLabel
   */
  label?: Maybe<Scalars["String"]>;
  /** Primary string to be displayed for interaction */
  primaryDisplayString?: Maybe<Scalars["String"]>;
  reviewInteractionType: ReviewInteractionType;
};

/** Property review rating and its counts */
export type PropertyReviewRatingCount = AccessibilityField & {
  __typename?: "PropertyReviewRatingCount";
  /** Accessibility label that describes the review count data */
  accessibilityLabel?: Maybe<Scalars["String"]>;
  /** The formatted review counts for the rating */
  count: FormattedNumber;
  /** Describes the rating (e.g. 5 - Excellent) */
  description: Scalars["String"];
  /**
   * Accessibility label
   * @deprecated Use accessibilityLabel, replace with accessibilityLabel
   */
  label?: Maybe<Scalars["String"]>;
  /** The percent out of 100, rounded to the nearest integer, of total reviews of this rating */
  percent: Scalars["Int"];
  /** A review rating */
  rating: Scalars["Int"];
};

/** [Optional] Hotel reviews sort types. Defaults to NEWEST_TO_OLDEST_BY_LANGUAGE */
export type PropertyReviewSort =
  | "HIGHEST_TO_LOWEST_RATED"
  | "LOWEST_TO_HIGHEST_RATED"
  | "NEWEST_TO_OLDEST"
  | "NEWEST_TO_OLDEST_BY_LANGUAGE"
  | "OLDEST_TO_NEWEST"
  | "OLDEST_TO_NEWEST_BY_LANGUAGE";

/** A property review source brand with corresponding logo */
export type PropertyReviewSource = AccessibilityField & {
  __typename?: "PropertyReviewSource";
  accessibilityLabel?: Maybe<Scalars["String"]>;
  graphic?: Maybe<Mark>;
  label?: Maybe<Scalars["String"]>;
  text: LodgingPlainMessage;
};

/** Review info about the property */
export type PropertyReviewSummary = AccessibilityField & {
  __typename?: "PropertyReviewSummary";
  /** Label where a11y behavior is needed. */
  accessibilityLabel?: Maybe<Scalars["String"]>;
  /**
   * amenityScore has raw and formatted number
   * @deprecated Use the generic list of review summaries, replace with reviewSummaryDetails
   */
  amenityScore?: Maybe<FormattedNumber>;
  /**
   * amenityScoreOverMax formatted number over max rating '5'
   * @deprecated Use the generic list of review summaries, replace with reviewSummaryDetails
   */
  amenityScoreOverMax?: Maybe<Scalars["String"]>;
  /**
   * amenityScore rounded to one decimal place and then converted to an integer percent out of 100
   * @deprecated Use the generic list of review summaries, replace with reviewSummaryDetails
   */
  amenityScorePercent?: Maybe<Scalars["Int"]>;
  averageOverallRating: FormattedNumber;
  /** @deprecated Use the generic list of review summaries, replace with reviewSummaryDetails */
  cleanliness: FormattedNumber;
  /**
   * cleanliness formatted number over max rating '5'
   * @deprecated Use the generic list of review summaries, replace with reviewSummaryDetails
   */
  cleanlinessOverMax?: Maybe<Scalars["String"]>;
  /**
   * cleanliness rounded to one decimal place and then converted to an integer percent out of 100
   * @deprecated Use localized and generic alternative, replace with reviewSummaryDetails
   */
  cleanlinessPercent: Scalars["Int"];
  /** @deprecated Use the generic list of review summaries, replace with reviewSummaryDetails */
  convenienceOfLocation: FormattedNumber;
  /** Property level review messaging */
  highlightMessage?: Maybe<MessageResult>;
  /** @deprecated Use the generic list of review summaries, replace with reviewSummaryDetails */
  hotelCondition: FormattedNumber;
  /**
   * hotelCondition formatted number over max rating '5'
   * @deprecated Use the generic list of review summaries, replace with reviewSummaryDetails
   */
  hotelConditionOverMax?: Maybe<Scalars["String"]>;
  /**
   * hotelCondition rounded to one decimal place and then converted to an integer percent out of 100
   * @deprecated Use the generic list of review summaries, replace with reviewSummaryDetails
   */
  hotelConditionPercent: Scalars["Int"];
  /**
   * 'Guest Reviews' hidden header
   * @deprecated Use accessibilityLabel, replace with accessibilityLabel
   */
  label?: Maybe<Scalars["String"]>;
  lastIndex: Scalars["Int"];
  /**
   * overall score with description - e.g. 4.3/5 Excellent
   * @deprecated overall score with description, instead use overallScoreWithDescriptionA11y , replace with overallScoreWithDescriptionA11y
   */
  overallScoreWithDescription?: Maybe<Scalars["String"]>;
  /** overall score with description - e.g. 4.3/5 Excellent - an a11y label */
  overallScoreWithDescriptionA11y?: Maybe<LodgingEnrichedMessage>;
  /** A button to get the next page of reviews. If there are no further pages, this will return null. */
  paginateAction?: Maybe<LodgingButton>;
  propertyId: Scalars["String"];
  /** propertyReviewCountDetails holds details on property review counts */
  propertyReviewCountDetails?: Maybe<PropertyReviewCountDetails>;
  /** List of review rating and counts */
  ratingCounts?: Maybe<Array<PropertyReviewRatingCount>>;
  /** @deprecated The data is no longer available */
  recommendedPercent: FormattedNumber;
  /** @deprecated This data should be accessed from the propertyReviewCountDetails property, replace with propertyReviewCountDetails */
  reviewCountLocalized?: Maybe<Scalars["String"]>;
  reviewDisclaimer?: Maybe<Scalars["String"]>;
  reviewDisclaimerAccessibilityLabel?: Maybe<Scalars["String"]>;
  /** Analytics data for tracking review disclaimer. */
  reviewDisclaimerAnalytics?: Maybe<ClientSideAnalytics>;
  reviewDisclaimerLabel?: Maybe<Scalars["String"]>;
  reviewDisclaimerUrl?: Maybe<LodgingLinkMessage>;
  /** Data for Review Highlights module */
  reviewHighlights?: Maybe<PropertyInfoContent>;
  /** List of review summary details */
  reviewSummaryDetails?: Maybe<Array<ReviewSummaryDetail>>;
  /** @deprecated Use the generic list of review summaries, replace with reviewSummaryDetails */
  roomComfort: FormattedNumber;
  /**
   * roomComfort formatted number over max rating '5'
   * @deprecated Use the generic list of review summaries, replace with reviewSummaryDetails
   */
  roomComfortOverMax?: Maybe<Scalars["String"]>;
  /**
   * roomComfort rounded to one decimal place and then converted to an integer percent out of 100
   * @deprecated Use the generic list of review summaries, replace with reviewSummaryDetails
   */
  roomComfortPercent: Scalars["Int"];
  seeAllAction?: Maybe<PropertyFilteredReviewsDialog>;
  /** Translated call to action label for see all reviews */
  seeAllReviewsCallToActionLabel?: Maybe<Scalars["String"]>;
  /** @deprecated Use the generic list of review summaries, replace with reviewSummaryDetails */
  serviceAndStaff: FormattedNumber;
  /**
   * serviceAndStaff formatted number over max rating '5'
   * @deprecated Use the generic list of review summaries, replace with reviewSummaryDetails
   */
  serviceAndStaffOverMax?: Maybe<Scalars["String"]>;
  /**
   * serviceAndStaff rounded to one decimal place and then converted to an integer percent out of 100
   * @deprecated Use the generic list of review summaries, replace with reviewSummaryDetails
   */
  serviceAndStaffPercent: Scalars["Int"];
  /** Icon/mark to display the source of reviews */
  source?: Maybe<LodgingEnrichedMessage>;
  superlative?: Maybe<Scalars["String"]>;
  /** Total number of reviews for this property */
  totalCount: FormattedNumber;
  /** @deprecated Raw number only, instead use FormattedNumber in totalCount, replace with totalCount */
  totalReviewCount: Scalars["Int"];
};

export type PropertyReviewTranslationInfo = {
  __typename?: "PropertyReviewTranslationInfo";
  /** Localized label to show the user while the translation is loading */
  loadingTranslationText: Scalars["String"];
  /** Locale in which the review was originally written */
  originalReviewLocale: Scalars["Locale"];
  /** Localized label for the call to action to show the review in its original language */
  seeOriginalText: Scalars["String"];
  /** Locale to which the review was translated */
  targetLocale?: Maybe<Scalars["Locale"]>;
  /** Mark containing information about the translation provider. Ex google */
  translatedBy: Mark;
  /** Localized label for the translate call to action */
  translationCallToActionLabel: Scalars["String"];
};

/** [Optional] Review filter type */
export type PropertyReviewType =
  /** filter reviews by rating <= 2 */
  | "CRITICAL"
  /** filter reviews by rating >= 3 */
  | "POSITIVE"
  /** filter reviews by latest date */
  | "RECENT";

export type PropertyReviews = AccessibilityField & {
  __typename?: "PropertyReviews";
  /** Label where a11y behavior is needed. */
  accessibilityLabel?: Maybe<Scalars["String"]>;
  /**
   * Message for a11y label.
   * @deprecated Use accessibilityLabel, replace with accessibilityLabel
   */
  label?: Maybe<Scalars["String"]>;
  noResultsMessage?: Maybe<NoResultsMessage>;
  reviewFlag?: Maybe<ReviewFlag>;
  reviews: Array<PropertyReview>;
  reviewsExpando?: Maybe<EgdsExpandoPeek>;
  sortAndFilter: SortAndFilterViewModel;
  summary: PropertyReviewSummary;
  writeReviewLink?: Maybe<LodgingLinkMessage>;
};

/** Review information about this property */
export type PropertyReviewsSummary = {
  __typename?: "PropertyReviewsSummary";
  /** Icon/mark to display the source of reviews */
  egdsMark?: Maybe<Mark>;
  /** Localized average review score */
  localizedScore?: Maybe<Scalars["String"]>;
  /** @deprecated Localized subtitle, instead use localizedSubtitleA11y , replace with localizedSubtitleA11y */
  localizedSubtitle?: Maybe<Scalars["String"]>;
  /** Localized subtitle - e.g. 4.5/5 (500 reviews) - with a11y label */
  localizedSubtitleA11y?: Maybe<LodgingEnrichedMessage>;
  /** Localized Total number of reviews */
  localizedTotal?: Maybe<Scalars["String"]>;
  /** Icon/mark to display the source of reviews */
  mark?: Maybe<LodgingMark>;
  /** Relevant review sample */
  relevantRecentReview?: Maybe<PropertyReviewContent>;
  /** Average review score */
  score?: Maybe<Scalars["Float"]>;
  /** Review score denominator */
  scoreDenominator: Scalars["Int"];
  /** Review Superlative */
  superlative?: Maybe<Scalars["String"]>;
  /** Total number of reviews */
  total?: Maybe<Scalars["Int"]>;
};

/** Indicates how many rooms will be occupied and by whom */
export type PropertyRoom = {
  __typename?: "PropertyRoom";
  childAges: Array<Scalars["Int"]>;
  numberOfAdults: Scalars["Int"];
};

export type PropertyRoomCard = {
  __typename?: "PropertyRoomCard";
  /** Cancellation Policy messaging with toggle that allows for showing and hiding the message */
  cancellationPolicy: AgentQuoteSwitchableMessage;
  /** Rate plan room level amenities over and above the base rate plan for that room type */
  extras?: Maybe<EgdsTextSection>;
  /** Any messages to display above the travel cards that apply across all of them */
  messages?: Maybe<Array<EgdsText>>;
  /** Price Presentation with toggle that allows for showing and hiding the entire pricing section */
  priceSummary: AgentQuoteSwitchablePriceSummary;
  /** List of Icons with text that highlight the property level amenities */
  propertyAmenities?: Maybe<Array<EgdsIconText>>;
  /** Property Image(s) for the image gallery */
  propertyGallery: Array<Image>;
  propertyName: EgdsHeading;
  propertyRating?: Maybe<EgdsRating>;
  /** List of Icons with text that highlight the room level amenities */
  roomFeatures?: Maybe<Array<EgdsIconText>>;
  /** Room type, bedding options, occupancy, etc. */
  roomSummary: EgdsTextSection;
};

/** Indicates how many rooms will be occupied and by whom */
export interface PropertyRoomInput {
  childAges: Array<Scalars["Int"]>;
  numberOfAdults: Scalars["Int"];
}

export type PropertySeoStructuredData = {
  __typename?: "PropertySEOStructuredData";
  content?: Maybe<Scalars["String"]>;
  itemprop: Scalars["String"];
  itemscope: Scalars["Boolean"];
  itemtype?: Maybe<Scalars["URL"]>;
};

/** Property criteria needed to perform a property search */
export type PropertySearchCriteria = {
  __typename?: "PropertySearchCriteria";
  primary: PrimaryPropertyCriteria;
  secondary?: Maybe<ShoppingSearchCriteria>;
};

/** Property criteria needed to perform a property search */
export interface PropertySearchCriteriaInput {
  primary: PrimaryPropertyCriteriaInput;
  secondary?: InputMaybe<ShoppingSearchCriteriaInput>;
}

export type PropertySearchExperimentalSection = LodgingExperimentalSection & {
  __typename?: "PropertySearchExperimentalSection";
  /** Offers experimental features as a list for automation purposes. */
  features: Array<LodgingExperimentalMetaData>;
  pageLayoutFeatureExperiment: PageLayoutExperimentalFeature;
};

export type PropertySearchExperimentalSectionFeaturesArgs = {
  createdAfter?: InputMaybe<DateInput>;
  createdBefore?: InputMaybe<DateInput>;
  description?: InputMaybe<Scalars["String"]>;
  id?: InputMaybe<Scalars["Int"]>;
  name?: InputMaybe<Scalars["String"]>;
  org?: InputMaybe<Scalars["String"]>;
  team?: InputMaybe<Scalars["String"]>;
};

/** Property search filtering options */
export type PropertySearchFilters = {
  __typename?: "PropertySearchFilters";
  /** Filter results by available accessibility amenities. Example: [ROLL_IN_SHOWER] will return properties with a roll in shower */
  accessibility?: Maybe<Array<PropertyFilterAccessibility>>;
  /** Filter results by TAAP Agency business model. */
  agencyBusinessModels?: Maybe<Array<AgencyBusinessModel>>;
  /** Filter results by available amenities. Example: [POOL,WIFI] will return properties with a pool and wifi */
  amenities?: Maybe<Array<PropertyFilterAmenity>>;
  /** Filter results by the bedroom count. Only includes Vacation Rentals */
  bedroomFilter?: Maybe<Array<Scalars["Int"]>>;
  /** Filter results by chain id. Input supports a valid chain id */
  chain?: Maybe<Scalars["String"]>;
  /** Filter results by property cleanliness attribute */
  cleaningAndSafetyPractices?: Maybe<Array<CleaningAndSafetyPractice>>;
  /** Filter results by TAAP commission tier. */
  commissionTiers?: Maybe<Array<CommissionTier>>;
  /** Filter results by Deals */
  deals?: Maybe<Array<DealType>>;
  /** Filter results by available meal plan. Example: FULL_BOARD will return properties with a full board */
  mealPlan?: Maybe<Array<MealPlanFilterAmenity>>;
  /** Filter results by neighborhood. Input supports a valid GAIA ID */
  neighborhood?: Maybe<Scalars["String"]>;
  /** Filter results by the payment type. */
  paymentType?: Maybe<Array<PaymentType>>;
  /** Filter results by popular location. Input supports a valid coordinates combination string */
  poi?: Maybe<Scalars["String"]>;
  /** Filter results by price. Can provide a min only, a max only, or a range. */
  price?: Maybe<PriceRange>;
  /** Deprecated: Legacy input is now combined", ReplaceWith("LegacyPropertySearchCriteria", PWA ONLY: Support for legacy PWA price buckets in the url. Use 'price' instead */
  priceBuckets?: Maybe<Array<Scalars["Int"]>>;
  /** Filter results by user provided string */
  propertyName?: Maybe<Scalars["String"]>;
  /** Property syle filters */
  propertyStyles?: Maybe<Array<PropertyStyle>>;
  /** Filter results by average guest rating. Can provide a min only, a max only, or a range. */
  reviewScore?: Maybe<ReviewScoreRange>;
  /** Rewards Type filters */
  rewards?: Maybe<Array<Scalars["String"]>>;
  /** Filter results by availability */
  showAvailableOnly?: Maybe<Scalars["Boolean"]>;
  /** Filter results by property star rating. Example: 30, 50 returns properties rated 3 to 3.9 and 5 to 5.9 */
  starList?: Maybe<Array<Scalars["Float"]>>;
  /** Deprecated - ReplaceWith("starList") , Filter results by property star rating. Example: THREE returns properties rated 3.0+ */
  stars?: Maybe<StarRange>;
  /** Deprecated: TNL 42683 - BEX_VR_STAY_FILTER, Filter results by Stay Type. Example: Hotels and Resorts, Vacation Rentals */
  stayTypes?: Maybe<Array<StayType>>;
  /** Filter results by structure type. Example: HOTEL returns properties of structure type 'HOTEL' */
  structureTypes?: Maybe<Array<StructureType>>;
  /** An SEM theme that needs to be passed through to other services */
  theme?: Maybe<Scalars["String"]>;
  /** Filter results by the type of traveler. */
  travelerType?: Maybe<Array<TravelerType>>;
  /** Filter results by VIP only properties */
  vipOnly?: Maybe<Scalars["Boolean"]>;
};

/** Property search filtering options */
export interface PropertySearchFiltersInput {
  /** Filter results by available accessibility amenities. Example: [ROLL_IN_SHOWER] will return properties with a roll in shower */
  accessibility?: InputMaybe<Array<PropertyFilterAccessibility>>;
  /** Filter results by TAAP Agency business model. */
  agencyBusinessModels?: InputMaybe<Array<AgencyBusinessModel>>;
  /** Filter results by available amenities. Example: [POOL,WIFI] will return properties with a pool and wifi */
  amenities?: InputMaybe<Array<PropertyFilterAmenity>>;
  /** Filter results by the bedroom count. Only includes Vacation Rentals */
  bedroomFilter?: InputMaybe<Array<Scalars["Int"]>>;
  /** Filter results by chain id. Input supports a valid chain id */
  chain?: InputMaybe<Scalars["String"]>;
  /** Filter results by property cleanliness attribute */
  cleaningAndSafetyPractices?: InputMaybe<Array<CleaningAndSafetyPractice>>;
  /** Filter results by TAAP commission tier. */
  commissionTiers?: InputMaybe<Array<CommissionTier>>;
  /** Filter results by Deals */
  deals?: InputMaybe<Array<DealType>>;
  /** Filter results by available meal plan. Example: FULL_BOARD will return properties with a full board */
  mealPlan?: InputMaybe<Array<MealPlanFilterAmenity>>;
  /** Filter results by neighborhood. Input supports a valid GAIA ID */
  neighborhood?: InputMaybe<Scalars["String"]>;
  /** Filter results by the payment type. */
  paymentType?: InputMaybe<Array<PaymentType>>;
  /** Filter results by popular location. Input supports a valid coordinates combination string */
  poi?: InputMaybe<Scalars["String"]>;
  /** Filter results by price. Can provide a min only, a max only, or a range. */
  price?: InputMaybe<PriceRangeInput>;
  /** Deprecated: Legacy input is now combined", ReplaceWith("LegacyPropertySearchCriteria", PWA ONLY: Support for legacy PWA price buckets in the url. Use 'price' instead */
  priceBuckets?: InputMaybe<Array<Scalars["Int"]>>;
  /** Filter results by user provided string */
  propertyName?: InputMaybe<Scalars["String"]>;
  /** Property syle filters */
  propertyStyles?: InputMaybe<Array<PropertyStyle>>;
  /** Filter results by average guest rating. Can provide a min only, a max only, or a range. */
  reviewScore?: InputMaybe<ReviewScoreRangeInput>;
  /** Rewards Type filters */
  rewards?: InputMaybe<Array<Scalars["String"]>>;
  /** Filter results by availability */
  showAvailableOnly?: InputMaybe<Scalars["Boolean"]>;
  /** Filter results by property star rating. Example: 30, 50 returns properties rated 3 to 3.9 and 5 to 5.9 */
  starList?: InputMaybe<Array<Scalars["Float"]>>;
  /** Deprecated - ReplaceWith("starList") , Filter results by property star rating. Example: THREE returns properties rated 3.0+ */
  stars?: InputMaybe<StarRangeInput>;
  /** Deprecated: TNL 42683 - BEX_VR_STAY_FILTER, Filter results by Stay Type. Example: Hotels and Resorts, Vacation Rentals */
  stayTypes?: InputMaybe<Array<StayType>>;
  /** Filter results by structure type. Example: HOTEL returns properties of structure type 'HOTEL' */
  structureTypes?: InputMaybe<Array<StructureType>>;
  /** An SEM theme that needs to be passed through to other services */
  theme?: InputMaybe<Scalars["String"]>;
  /** Filter results by the type of traveler. */
  travelerType?: InputMaybe<Array<TravelerType>>;
  /** Filter results by VIP only properties */
  vipOnly?: InputMaybe<Scalars["Boolean"]>;
}

/** Represents the various types of lodging listings available */
export type PropertySearchListing =
  | EgdsStandardMessagingCard
  | LodgingCard
  | LodgingHeading
  | LodgingIntentCard
  | LodgingListingDivider
  | LodgingSurveyTrigger
  | MessageResult
  | Property
  | PropertyListingsIconTextExpando
  | PropertySearchListingsOverfilteredCard
  | PropertySearchListingsSoldOutCard
  | SponsoredContentPlacement
  | StaticLodgingMultiItemCrossSell;

/** A Overfiltered messaging card which informs the user that their search results are overfiltered. */
export type PropertySearchListingsOverfilteredCard = {
  __typename?: "PropertySearchListingsOverfilteredCard";
  /** The action associated to the card. In this case a remove all filters button link. */
  action?: Maybe<LodgingLinkButton>;
  /** The structure/skeleton of the messaging card. */
  content?: Maybe<EgdsStandardMessagingCard>;
  /** The removable filter pills on the Overfiltered card. */
  filterPills?: Maybe<Array<ShoppingAppliedFilter>>;
  /** Analytics data for impression tracking of the user with the Overfiltered card. */
  impressionAnalytics?: Maybe<ClientSideImpressionEventAnalytics>;
};

/** A SoldOut divider card which divides listing properties into sections and let the user pick dates from the Datepicker. */
export type PropertySearchListingsSoldOutCard = {
  __typename?: "PropertySearchListingsSoldOutCard";
  /** The action associated to the card. In this case a button for date picker. */
  actionButton?: Maybe<EgdsButton>;
  /** Analytics data for impression tracking of the user with the Sold Out card. */
  analytics?: Maybe<ClientSideImpressionEventAnalytics>;
  /** The structure/skeleton of the messaging card. */
  content?: Maybe<EgdsStandardMessagingCard>;
};

/** The map information for the properties returned */
export type PropertySearchMap = {
  __typename?: "PropertySearchMap";
  /** Returns model with content for search button which should be displayed on the map */
  action: UiPrimaryButton;
  /** Returns the bounds of the map */
  bounds: Bounds;
  /** Returns the center coordinates of the map */
  center: Coordinates;
  /** Returns the list of markers that should be displayed on the map which implement EGDSMapMarker */
  mapMarkers?: Maybe<Array<LodgingPlottableMapMarker>>;
  /** Returns the list of markers that should be displayed on the map */
  markers: Array<Plottable>;
  /** Messaging model inside the map */
  messagingModel?: Maybe<MessageResult>;
  /** Returns the static map url */
  staticMapSrc?: Maybe<Scalars["String"]>;
  /** Returns the subtitle of the map */
  subtitle?: Maybe<Scalars["String"]>;
  /** Returns the title of the map */
  title: Scalars["String"];
  /** Returns the zoom level of the map */
  zoom: Scalars["Int"];
};

export type PropertySearchMultiItemShoppingAction = MultiItemShoppingAction & {
  __typename?: "PropertySearchMultiItemShoppingAction";
  shoppingContext: ShoppingContext;
};

export interface PropertySearchMultiItemShoppingActionInput {
  shoppingContext: ShoppingContextInput;
}

/** Search options that are not filters. Previously these were a large set of boolean flags in ExpWeb called `searchOptions` */
export type PropertySearchOptions =
  /** Only return travelAds, excluding this will result in a mixed set of organic listings and ads */
  | "ADS_ONLY"
  /** Use loyalty points to calculate the strikeout price. aka `swpApplied=true` */
  | "SHOP_WITH_POINTS";

/** Results from property search */
export type PropertySearchResults = {
  __typename?: "PropertySearchResults";
  /** Clickstream events for Search */
  clickstream: SearchClickstreamEvents;
  /** Resolved search criteria. */
  criteria: PropertySearchCriteria;
  /** Dialog Error Response for any client related search errors */
  dialogErrorResponse?: Maybe<LodgingDialogErrorResponse>;
  /** The map information for the properties returned */
  dynamicMap?: Maybe<EgDynamicMap>;
  /** Error Response for any client related search errors */
  errorResponse?: Maybe<LodgingErrorResponse>;
  /**
   * Provides exit intent popup for users leaving the search results page
   * @deprecated This is to support the comet exit intent without impacting the migration effort
   */
  exitIntent?: Maybe<ExitIntent>;
  /**
   * Experimental features.
   * @deprecated Deprecated. Contents are volatile and subject to change at any moment. Use at your own risk!
   */
  experimental: PropertySearchExperimentalSection;
  /**
   * Search results specific metadata used for constructing filters
   * @deprecated This is to support the native apps. Do not use, replace with sortAndFilter
   */
  filterMetadata: PropertyFilterMetadata;
  /** Legal information of property,reviews and ratings */
  legalDisclaimer?: Maybe<DisclaimerContentMarkup>;
  /**
   * The map information for the properties returned
   * @deprecated Use dynamicMap instead
   */
  map?: Maybe<PropertySearchMap>;
  /** Multi Item Session Context containing the session contents used to rebuild the search */
  multiItemSearchContext?: Maybe<MultiItemSearchContext>;
  /** Rate-type navigation tabs */
  navigationTabs?: Maybe<NavigationTabs>;
  /** Data for implementing pagination on the client side */
  pagination?: Maybe<LodgingPagination>;
  /**
   * The individual properties returned from the search, sorted in the order specified or in default recommended order
   * @deprecated Use propertySearchListings
   */
  properties: Array<Property>;
  /** A combination of sorted properties and alternate listings like banners, cross sells, etc */
  propertySearchListings: Array<PropertySearchListing>;
  /** Provides calculated price trend information of listed property ids between dates. (experimental feature: 39068) */
  rateCalendar: PropertyCalendar;
  /** DEPRECATED: Use `criteria`. The search criteria that was used after all defaults were applied */
  searchCriteria: SearchCriteria;
  /** Shopping context for multi item shopping */
  shoppingContext?: Maybe<ShoppingContext>;
  /** Sort And Filter Selected Options, Defaults if necessary, and display options */
  sortAndFilter: SortAndFilter;
  /** Insights about the search results, such as the percentage of sold out inventory in the destination (aka compression) */
  summary: PropertyResultsSummary;
  /** Page level elements describing which sort & filters can be applied and what are the key elements to use if they are displayed in a modal. */
  universalSortAndFilter: ShoppingSortAndFilters;
};

export type PropertySectionHeading = EgdsSectionHeading & {
  __typename?: "PropertySectionHeading";
  heading: EgdsHeading;
  subheading?: Maybe<Scalars["String"]>;
};

export type PropertySectionRef = "PRICE_DISPLAY_SERVICE_RESPONSE" | "RECOMMENDED_OFFER" | "ROOMS_AND_RATES";

/** Property sentiment for a given property and sentiment tag */
export type PropertySentiment = {
  __typename?: "PropertySentiment";
  /** The number of user who have left similar responses */
  subtext?: Maybe<Scalars["String"]>;
  /** The superlative and sentiment tag. The superlative is derived from the sentiment score for that tag */
  text?: Maybe<Scalars["String"]>;
};

/** Property shop options; If this field is not supplied, a server default will be chosen */
export type PropertyShopOptions = {
  __typename?: "PropertyShopOptions";
  /** Ads related property search option */
  listings?: Maybe<Listings>;
  /** Paandi redirection to white label */
  paandiRedirection?: Maybe<Scalars["String"]>;
  /** Points related property search option */
  points?: Maybe<Points>;
  /** DEPRECATED. regionType only used for EG-Typeahead url params */
  typeaheadRegionType?: Maybe<Scalars["Int"]>;
};

/** Property shop options; If this field is not supplied, a server default will be chosen */
export interface PropertyShopOptionsInput {
  /** Ads related property search option */
  listings?: InputMaybe<Listings>;
  /** Paandi redirection to white label */
  paandiRedirection?: InputMaybe<Scalars["String"]>;
  /** Points related property search option */
  points?: InputMaybe<Points>;
  /** DEPRECATED. regionType only used for EG-Typeahead url params */
  typeaheadRegionType?: InputMaybe<Scalars["Int"]>;
}

/** Hotel sort types */
export type PropertySort =
  | "AARP_MEMBER_DISCOUNT"
  | "BEST_DEAL"
  | "DISTANCE"
  | "MAXIMUM_SAVINGS"
  | "MAXIMUM_SAVINGS_PERCENT"
  | "MEMBER_PRICING"
  | "PACKAGE_SAVINGS"
  | "PRICE_HIGH_TO_LOW"
  | "PRICE_LOW_TO_HIGH"
  | "PRICE_RELEVANT"
  | "PROPERTY_CLASS"
  | "PROPERTY_NAME"
  | "RECOMMENDED"
  | "REVIEW"
  | "REVIEW_RELEVANT"
  | "VACATION_RENTAL";

/** A property source type with corresponding logo */
export type PropertySource = AccessibilityField & {
  __typename?: "PropertySource";
  accessibilityLabel?: Maybe<Scalars["String"]>;
  graphic?: Maybe<UiGraphic>;
  label?: Maybe<Scalars["String"]>;
  text: LodgingPlainMessage;
};

export type PropertyStarRating = EgdsRating & {
  __typename?: "PropertyStarRating";
  accessibility?: Maybe<Scalars["String"]>;
  rating: Scalars["Float"];
};

export type PropertyStyle = "BOUTIQUE" | "HOMES" | "HOTELS" | "LGBT" | "LUXURY" | "OUTDOOR" | "UNIQUE";

/** Information about the property */
export type PropertySummary = {
  __typename?: "PropertySummary";
  /** The amenities for the property */
  amenities?: Maybe<PropertyAmenities>;
  /**
   * Ordered list of the amenity categories
   * @deprecated Deprecating for amenities.top, icons to be passed directly rather than amenity categories, replace with amenities.top
   */
  amenityCategories: Array<PropertyAmenityCategory>;
  /**
   * Ordered list of the amenity sections for this property. A section with a null subtype is a parent section and any sections with the same type and a non-null subtype are its children
   * @deprecated No longer used, replace with amenities
   */
  amenitySections: Array<PropertyAmenitySection>;
  /** For prominent banner messages of the property */
  bannerMessage?: Maybe<MessageResult>;
  /** Cleaning and safety practices of the property */
  cleaningAndSafety?: Maybe<PropertyInfoContent>;
  /** Title for details page */
  detailsTitle?: Maybe<Scalars["String"]>;
  /** Featured messages about the property, ex: Entire home, Private host */
  featuredMessages?: Maybe<Array<LodgingEnrichedMessage>>;
  /** The fees for this property */
  fees?: Maybe<PropertyFees>;
  /**
   * Input field dialog launcher for Find Answers search form.
   * @deprecated Intent: Move to Reviews when orchestration permits.
   */
  findAnswersDialog?: Maybe<FindAnswersDialog>;
  /** Message block with dialog launcher for Find Answers search form. */
  findAnswersMessage?: Maybe<FindAnswersMessage>;
  /** The property's unique identifier */
  id: Scalars["String"];
  /** The name of the property in latin alphabet */
  latinAlphabetName: Scalars["String"];
  /** Location information for the property */
  location?: Maybe<PropertyLocation>;
  /** Lodging Chatbot for the property */
  lodgingChatbot?: Maybe<LodgingChatbot>;
  /** Map information of the Property & POIs */
  map?: Maybe<PropertyInfoMap>;
  /** Property Summary Messages, ex: 4-star property */
  messages: Array<PropertySummaryMessages>;
  /** The name of the property */
  name: Scalars["String"];
  /** Navigation bar on PDP page */
  navigationBarTabs?: Maybe<Array<PropertyNavigationBarTab>>;
  /** the nearby things to do around the property */
  nearby?: Maybe<PropertyInfoSection>;
  /** Nearby point of interest around the property, which include landmarks, restaurants & airports. */
  nearbyPOIs?: Maybe<PropertyInfoContent>;
  /** Overview information for the property */
  overview?: Maybe<PropertyOverview>;
  /**
   * The policies for this property
   * @deprecated No longer used, replace with propertyContentSectionGroups.policies
   */
  policies?: Maybe<PropertyPolicies>;
  /** Messages to provide information about the Property near the title area */
  propertyHeaderMessages?: Maybe<Array<HeaderMessage>>;
  /** For Vrbo badging and messaging on PDP */
  propertySource?: Maybe<PropertyInfoItem>;
  /**
   * PropertyType showing on PDP page
   * @deprecated Use featuredMessages
   */
  propertyTypeBadge?: Maybe<Scalars["String"]>;
  /**
   * The renovations and closure notice for this property
   * @deprecated No longer used, replace with propertyContentSectionGroups.policies.sections
   */
  renovations?: Maybe<PropertyRenovations>;
  /** Property Summary Overview beds, baths, sleeps */
  spaceOverview?: Maybe<PropertyInfoContent>;
  /** Icon for star rating */
  starRatingIcon?: Maybe<Icon>;
  /** Type of physical property, e.g. Hotel, Motel */
  structure?: Maybe<StructureType>;
  /** tagline for the property */
  tagline?: Maybe<Scalars["String"]>;
  /**
   * The phone number that can be used to book over the phone
   * @deprecated No longer used, replace with propertyInfo.telesales
   */
  telesalesPhoneNumber: Scalars["String"];
};

/** Information about the property */
export type PropertySummaryAmenitiesArgs = {
  dateRange?: InputMaybe<PropertyDateRangeInput>;
  searchCriteria?: InputMaybe<PropertySearchCriteriaInput>;
};

/** Return EGDSPlainText type */
export type PropertySummaryMessages = EgdsPlainText;

export type PropertyTaglineExperimentalFeature = LodgingExperimentalFeature & {
  __typename?: "PropertyTaglineExperimentalFeature";
  description: Scalars["String"];
  experiment: LodgingExperiment;
  implementationDate: Date;
  owner: LodgingExperimentOwner;
  propertyTagline?: Maybe<Scalars["String"]>;
};

export type PropertyTakeoverAmenities = {
  __typename?: "PropertyTakeoverAmenities";
  /** List of amenity closures to be displayed on the takeover dialog */
  amenityClosures?: Maybe<PropertyInfoContent>;
  /** List of highlight amenities to be displayed on the takeover dialog */
  highlight: Array<PropertyInfoContent>;
  /** List of property amenities to be displayed on the takeover dialog */
  property: Array<PropertyInfoContent>;
};

/** Retrieve top positive and top critical reviews for a property */
export type PropertyTopReviews = {
  __typename?: "PropertyTopReviews";
  /** The top critical review for the property */
  critical?: Maybe<PropertyReview>;
  /** The top review that better account for uniqueness for the property */
  highlighted?: Maybe<LodgingEnrichedMessage>;
  /** The top positive review for the property */
  positive?: Maybe<PropertyReview>;
};

/** Data used for travelAd click tracking */
export type PropertyTravelAdTrackingInfo = {
  __typename?: "PropertyTravelAdTrackingInfo";
  beaconIssued?: Maybe<Scalars["String"]>;
  candidateHmGuid?: Maybe<Scalars["String"]>;
  position?: Maybe<Scalars["String"]>;
  rank?: Maybe<Scalars["String"]>;
  slots?: Maybe<Scalars["String"]>;
  testVersionOverride?: Maybe<Scalars["String"]>;
  trackingData: Scalars["String"];
};

/** Data used for travelAd click tracking */
export interface PropertyTravelAdTrackingInfoInput {
  beaconIssued?: InputMaybe<Scalars["String"]>;
  candidateHmGuid?: InputMaybe<Scalars["String"]>;
  position?: InputMaybe<Scalars["String"]>;
  rank?: InputMaybe<Scalars["String"]>;
  slots?: InputMaybe<Scalars["String"]>;
  testVersionOverride?: InputMaybe<Scalars["String"]>;
  trackingData: Scalars["String"];
}

export type PropertyUnavailableValue = {
  __typename?: "PropertyUnavailableValue";
  code: Scalars["Int"];
  reason: Scalars["String"];
};

export type PropertyUnit = AccessibilityField & {
  __typename?: "PropertyUnit";
  /** Label where a11y behavior is needed. */
  accessibilityLabel?: Maybe<Scalars["String"]>;
  availabilityCallToAction?: Maybe<AvailabilityCallToAction>;
  /** @deprecated This data is now contained in the schema for components where it's used, e.g features, detailsDialog */
  bedOptions: Array<BedOptions>;
  bookingUrl?: Maybe<Scalars["String"]>;
  description?: Maybe<Scalars["String"]>;
  detailsDialog?: Maybe<LodgingDialog>;
  features: Array<PropertyInfoItem>;
  /** @deprecated Deprecated in favor of more flexible PropertyImageGallery type, replace with unitGallery */
  gallery: Array<PropertyImage>;
  header?: Maybe<LodgingHeader>;
  id: Scalars["String"];
  /**
   * A label for accessibility purposes.
   * @deprecated Use accessibilityLabel, replace with accessibilityLabel
   */
  label?: Maybe<Scalars["String"]>;
  maxOccupancy?: Maybe<UnitOccupancy>;
  /** @deprecated Deprecated in favor of more flexible LodgingHeader type, replace with header.text */
  name?: Maybe<Scalars["String"]>;
  /** @deprecated Deprecated in favor of more flexible PropertyImageGallery type, replace with unitGallery */
  photos: Array<Image>;
  ratePlans: Array<RatePlan>;
  ratePlansExpando: RatePlansExpando;
  roomAmenities?: Maybe<PropertyContentSection>;
  size?: Maybe<Scalars["String"]>;
  /** @deprecated Deprecated - use spaceDetails */
  sleepingArrangement?: Maybe<SleepingArrangement>;
  /** Space Details Layout module for multi unit VR to show sleepingArrangement details. */
  spaceDetails?: Maybe<SpaceDetails>;
  /** @deprecated Deprecated in favor of availabilityCallToAction, replace with availabilityCallToAction */
  unavailableRatePlans: Array<RatePlan>;
  unitGallery?: Maybe<PropertyImageGallery>;
};

export type PropertyUnitCard = {
  __typename?: "PropertyUnitCard";
  /** AgencyQuoteNaturalKeyInput to support post save operation */
  agencyPropertyUnitKey: AgencyPropertyUnitKey;
  /** Cancellation Policy messaging with toggle that allows for showing and hiding the message */
  cancellationPolicy: AgencyQuoteSwitchableMessage;
  /** Link enabling the user to return the referring page */
  detailsLink?: Maybe<EgdsStandardLink>;
  /** Rate plan room level amenities over and above the base rate plan for that room type */
  extras?: Maybe<EgdsTextSection>;
  /** Any messages to display above the travel cards that apply across all of them */
  messages?: Maybe<Array<EgdsText>>;
  /** Price Presentation with toggle that allows for showing and hiding the entire pricing section */
  priceSummary: AgencyQuoteSwitchablePriceSummary;
  /** List of Icons with text that highlight the property level amenities */
  propertyAmenities?: Maybe<Array<EgdsIconText>>;
  /** Property Image(s) for the image gallery */
  propertyGallery: Array<Image>;
  propertyName: EgdsHeading;
  propertyRating?: Maybe<EgdsRating>;
  /** Any regulatory messages to display below the travel cards that apply across all of them */
  regulatoryMessages?: Maybe<Array<EgdsText>>;
  /** Link to remove the rate card */
  removeRateLink?: Maybe<EgdsStandardLink>;
  /** List of Icons with text that highlight the room level amenities */
  roomFeatures?: Maybe<Array<EgdsIconText>>;
  /** Room type, bedding options, occupancy, etc. */
  roomSummary: EgdsTextSection;
  /** Search Playback for card */
  tripSummary?: Maybe<EgdsTextSection>;
};

export type PropertyUnitDetails = {
  __typename?: "PropertyUnitDetails";
  details?: Maybe<PropertyInfoSection>;
  dialogFeatures?: Maybe<EgdsTextIconList>;
  gallery: Array<PropertyImage>;
  /** Title before list of rate plans (e.g. Room options) */
  ratePlanTitle?: Maybe<LodgingHeader>;
  ratePlans: Array<RatePlan>;
  /** @deprecated Sleeping Arrangements details for properties with multiple units. Use PropertyUnit.spaceDetails */
  sleepingArrangement?: Maybe<SleepingArrangement>;
};

/** Dialog used to display Property Unit details. */
export type PropertyUnitDetailsDialog = LodgingDialog & {
  __typename?: "PropertyUnitDetailsDialog";
  content: PropertyUnitDetails;
  toolbar?: Maybe<LodgingDialogToolbar>;
  trigger: LodgingDialogTriggerMessage;
};

export type PropertyWhatsAround = {
  __typename?: "PropertyWhatsAround";
  editorial?: Maybe<PropertyEditorial>;
  /**
   * Returns the CTA label for map
   * @deprecated The summary structure should be refactored, prevent use that structure on future implementation
   */
  mapDialog?: Maybe<LodgingMapDialog>;
  nearbyPOIs: Array<PropertyInfoContent>;
  /** Returns the static map url with a description */
  staticImage?: Maybe<Image>;
  /** @deprecated Replaced by 'staticImage' field. */
  staticMapSrc?: Maybe<Scalars["String"]>;
  title: Scalars["String"];
};

export type QualtricsConfig = {
  __typename?: "QualtricsConfig";
  /** This is ZoneId, which is different for each brand, this is required to */
  zoneId: Scalars["String"];
};

/**
 * TODO:  Will remove these previous operations when Shared-UI uses the new ones with correct names
 * Duplicate of operations for correcting names based on comments in: https://github.expedia.biz/weaver/weaver-schema-stitcher/pull/899#issuecomment-1646168
 */
export type Query = {
  __typename?: "Query";
  /** Returns UI for viewing/updating user's logged in devices */
  activeSessionsForm: ProfileAccountFormComponent;
  /** activity cross sell search */
  activityCrossSellSearch: ActivityCrossSellSearchResults;
  /** Details of an activity */
  activityInfo: ActivityInfo;
  /** activity modules */
  activityModules: ActivityModulesResponse;
  /** Reviews of an activity */
  activityReviews: ActivityReviewsInfo;
  /** Search for activities */
  activitySearch: ActivitySearchResults;
  /** Seo content for activity page */
  activitySeoContent: ActivitySeoContent;
  /** Detailed information about a specific property */
  agencyPropertyInfo: AgencyPropertyDetails;
  /** Retrieves a list of available properties for search page */
  agencyPropertySearch: AgencyPropertySearch;
  agencyQuoteBuilder: AgencyQuoteBuilderResponse;
  /** Provides all elements and sections needed to build the Quotation Tool */
  agencyQuoteInfo: AgencyQuoteDetails;
  /** Retrieves a list of saved quotes for Taap Agent */
  agencyQuoteList: AgencyQuoteListResponse;
  /** Provides all elements and sections needed to build the Quotation Tool */
  agentQuoteInfo: AgentQuoteDetails;
  /** Basic query that returns string */
  altDestinationsHackathon22: Scalars["String"];
  associatedPropertySearch: SupplyPropertySearchResultContent;
  /** destination Weather forecast given a source place */
  bestTimeToGo?: Maybe<BestTimeToGo>;
  /** Fetch flight cancellation response for selected flight */
  bookingServicingCancellation: BookingServicingCancellationPresentation;
  /** Fetch response for a particular booking */
  bookingServicingChange?: Maybe<BookingServiceChange>;
  /** Query to retrieve site breadcrumbs */
  breadcrumbs: Breadcrumbs;
  businessPartnerInformation: SupplyPartnerInformation;
  /** Query for the Create Property Group experience */
  campaignConfigPropertyGroupForm?: Maybe<PropertyGroupForm>;
  /** Query Recommended campaigns for a siteId and locale provided in context */
  campaignRecommendations?: Maybe<RecommendedCampaigns>;
  cancellationWaiverApproval: SupplyCancellationWaiverApprovalSection;
  cancellationWaiverDetails: SupplyCancellationWaiverCardDetails;
  /** details call (CIS page) for cars */
  carDetail: CarDetailsResult;
  /** Drop off search for cars */
  carDropOffSearch: DropOffSearchResults;
  /** rules and restrictions for cars */
  carRulesAndRestrictions: CarRulesAndRestrictionsResult;
  /** Search for cars */
  carSearchOrRecommendations: CarsSearchResultsWrapper;
  /**
   * Top level cart query that looks up/creates a cart based on the context OR performs a lookup based on the cart ID when it is present
   * @deprecated DO NOT USE: Will be removed permanently soon
   */
  cart: Cart;
  /** Retrieve feedback prompt configuration by prompt ID. */
  cdfPromptById?: Maybe<CdfPrompt>;
  /** Provides initialization config for CPCE chatbot integrations */
  chatbotConfig?: Maybe<ChatbotConfig>;
  /** Top level Checkout Query */
  checkout: CheckoutDetails;
  /** EG Identity account creation module for CKO page */
  checkoutAccountCreation: CheckoutAccountCreationResponse;
  coBrandBanner: CoBrandBannerData;
  competitiveSetEditor: CompetitiveSetEditorResponse;
  competitorCard: CompetitorsCardResponse;
  /** Retrieves information needed for the confirmation summary module */
  confirmationSummary: ConfirmationSummary;
  /** Top level query for fetching contact host component */
  contactHost: ContactHostCta;
  /** Contact Us Options View */
  contactUsOptions: ContactUsView;
  contractTerms: SupplyContractTerms;
  /** GraphQL Query for first landing page in coupon from checkout page */
  couponRedemption: CouponRedemption;
  /** Top level coupons and credits query */
  couponsAndCredits: CouponsAndCredits;
  creditCardApplicationForm?: Maybe<CreditCardApplicationForm>;
  creditCardPromotion?: Maybe<CreditCardPromotionResult>;
  /** Credit Redemption Insurance Request */
  creditRedemptionInsurtechOffers?: Maybe<CreditRedemptionInsurtechOffersResponse>;
  /** Grouping of all multiitem xsell-related queries */
  crossSell: CrossSellQueries;
  /** Query to retrieve links based on the strategy name provided */
  crosslinks?: Maybe<CrossLinksContainer>;
  /** Search results for Cruise */
  cruiseSearch: CruiseSearchResults;
  /** Top level customer query */
  customer: Customer;
  /** Top level customer profile query */
  customerProfile: CustomerProfile;
  /** Get daily weather forecast */
  dailyWeatherForecast: ForecastsResponseData;
  /** Provides access to a deferred payment report */
  deferredPaymentReport?: Maybe<DeferredPaymentReport>;
  /** Returns UI for deleting user's account */
  deleteAccountForm: ProfileAccountFormComponent;
  /** Destination Travel Guide Expert tips. */
  destinationExpertTips: DestinationExpertTips;
  /** Destination Travel guide Heading. */
  destinationHeading?: Maybe<DestinationHeading>;
  /** Query to retrieve Destination Hero */
  destinationHero?: Maybe<TravelExperienceContent>;
  destinationInsights: DestinationInsights;
  /** Top level query for recently viewed properties */
  destinationPropertiesCarousel?: Maybe<LodgingCarouselContainer>;
  /** Recommend destination given a source place and a strategy */
  destinationRecommendation?: Maybe<DestinationRecommendationGroup>;
  /** Retrieve feedback prompt configuration by prompt ID. */
  directFeedbackPromptById?: Maybe<DirectFeedbackPrompt>;
  /** Basic query that returns string */
  docExperienceApiGreeting: Scalars["String"];
  /** Query that retrieves DrivableDestinations */
  drivableDestinations: DrivableDestinationsContent;
  /** Simple experience-api-unesco-spinner Query that returns a string message test */
  experienceapiunescospinnerHello: Scalars["String"];
  /** Retrieve fare calendar for flights. */
  fareCalendar: Scalars["String"];
  /** Fetch Itinerary for a user */
  fetchItinerary: Itinerary;
  /** Fetch Itinerary for a user with speech */
  fetchItineraryWithSpeech: Itinerary;
  /** Query to fetch an UnescoPledge from an ID */
  fetchLodgingUnescoPledge?: Maybe<UnescoPledge>;
  /** Query to fetch a list of TravelPledges using some filters */
  fetchLodgingUnescoPledges?: Maybe<UnescoPledges>;
  /** Query to fetch initial filters components */
  fetchLodgingUnescoSearchSortAndFilter?: Maybe<ShoppingSortAndFilters>;
  /** Retrieve fare calendar for flights. */
  flexibleSearch: Scalars["String"];
  /** Flight Destination Insights query */
  flightDestinationInsights: FlightDestinationInsights;
  /** Get flight insights between an origin and a destination. */
  flightInsights: FlightInsights;
  /** Returns UI for updating the current user's flight preferences */
  flightPreferencesForm: ProfileAccountFormComponent;
  /** Retrieves the Select Airline Credits component */
  flightsAirlineCredits: FlightsAirlineCreditsResponse;
  /** Fetch requested ancillary summary for selected flight */
  flightsAncillary: FlightsAncillaryResponse;
  /**
   * Fetch requested arithmetic result for input parameters
   * @deprecated This is a stop-gap solution for finding the sum total of bag selections on merchandising hub.The ideal approach is to let backend figure out the price of selected bags using identifiers and not expose this operation to client.Refer https://jira.expedia.biz/browse/AIRMRCH-1453 for details.
   */
  flightsBaggagePriceCalculations: FlightsArithmeticResponse;
  /** Check fare availability, policies and other details for selected flight */
  flightsDetail: FlightsInformationResponse;
  /** Retrieve fare calendar for flights. */
  flightsFareCalendar?: Maybe<FlightsFareCalendarResponse>;
  /** Retrieve offers listings for flights. */
  flightsListings: FlightsSmartShoppingListingsResults;
  /**
   * Fetch the requested type of placards
   * @deprecated Placards info will be find on specific queries
   */
  flightsPlacard: FlightsPlacardResponse;
  /** Search for flights */
  flightsSearch: FlightsSearchResponse;
  /**
   * Retrieve seat map for flights.
   * @deprecated Use Flight seatAncillaryDetails query for seat details
   */
  flightsSeatMap?: Maybe<FlightsSeatMapResponse>;
  /** Flights checkout servicing */
  flightsServicing: FlightsServicingResponse;
  /** Flights servicing confirmation */
  flightsServicingConfirmation: FlightsServicingConfirmationResponse;
  foobar?: Maybe<Scalars["String"]>;
  /** Query to retrieve frequently asked questions using tag. */
  frequentlyAskedQuestions?: Maybe<Array<Maybe<TravelExperienceContent>>>;
  getAgentPresence: AgentPresence;
  getMultiFactorAuthenticationView: SupplyMultiFactorAuthenticationExperience;
  getSupplyOnboardingPageTitle?: Maybe<SupplyOnboardingPageTitle>;
  /** Returns a user's details given egaid */
  getUserInformation: UserInformationQueryResult;
  globalFooter: Footer;
  globalHeader: Header;
  /** Global Inspiration Module */
  globalInspiration: GlobalInspiration;
  /** Global insurance Shopping Request */
  globalInsuranceSearch?: Maybe<InsuranceShoppingResponse>;
  /** Search for ground transfers */
  groundTransfersSearch: GroundTransfersSearchResults;
  guestInfo: SupplyReservationsGuestInfo;
  /** Basic query that returns string */
  health: Scalars["String"];
  /** Basic query that returns string */
  hello: Scalars["String"];
  /** Basic query that returns string */
  helloCollectionApi: Scalars["String"];
  /** Basic query that returns values from graphQLContext and passed in context */
  helloCollectionApiWGC: Scalars["String"];
  /** Basic query that returns string */
  helloDummy: Scalars["String"];
  /** Sample query that returns values from essService */
  helloEssSample: Scalars["String"];
  /** Sample query that returns values from fxrs service */
  helloFxrsSample: Scalars["String"];
  /** Basic query that returns values from graphQLContext and passed in context */
  helloGraphQLContextSampleGaia: Scalars["String"];
  /** Basic query that returns string */
  helloSample: Scalars["String"];
  /** Basic query that returns values from graphQLContext and passed in context */
  helloWithGraphQLContext: Scalars["String"];
  /** Basic query that returns values from graphQLContext and passed in context */
  helloWithGraphQLContextDummy: Scalars["String"];
  /** Basic query that returns values from graphQLContext and passed in context */
  helloWithGraphQLContextSample: Scalars["String"];
  /**
   * Retrieve all help articles, for specific product or category or retrieve it article by id
   * @deprecated helpArticles query is deprecated, replace with searchHelpArticles
   */
  helpArticles: HelpArticlesView;
  /** EG Universal Login Experience layout query */
  identityLayout: IdentityResponse;
  /** Top level Query for important info section */
  importantInfo: ImportantInfoDetails;
  /** Query that returns an Incentives collection */
  incentivesCollection: IncentivesCollection;
  /** Query that returns an Incentives collection view either a success view or an error view */
  incentivesCollectionView: IncentivesCollectionView;
  /** Incentives query that returns journey recommendations */
  incentivesJourney: IncentivesJourney;
  /** Insurance Benefit Details */
  insuranceBenefitDetails?: Maybe<InsuranceBenefitDetailsQueryResponse>;
  /** Insurance Booking Overview */
  insuranceBookingOverview?: Maybe<InsuranceBookingOverviewResponse>;
  /** Insurance Booking Overview Error Cases */
  insuranceBookingOverviewError?: Maybe<InsuranceBookingOverviewErrorResponse>;
  /** Insurance Claims Details */
  insuranceClaimDetails?: Maybe<InsuranceClaimDetailsResponse>;
  /** Insurance Priming Request */
  insuranceDetailPriming?: Maybe<InsuranceDetailPrimingCard>;
  /** Insurance File a claim */
  insuranceFileAClaim?: Maybe<InsuranceFileAClaimResponse>;
  /** Insurance Shopping Request */
  insuranceSearch?: Maybe<InsuranceShoppingResponseOld>;
  interactionList: SupplyReservationsInteractionView;
  /**
   * The widget query returns a list of upcoming trips and related data to power native application widgets.
   * @deprecated Only to be used by iOS to move from legacy to bex-api, will be removed in future
   */
  legacyWidget: WidgetResponse;
  /** Top level Checkout Legal Query */
  legal: LegalDetails;
  localePreferences: Picker;
  /** Search for Destination  */
  lodgingDestination: LodgingDestinationResults;
  /** Query to fetch initial filters components */
  lodgingTravelPledgeSearchSortAndFilter?: Maybe<ShoppingSortAndFilters>;
  /** Query to fetch a list of TravelPledges using some filters */
  lodgingTravelPledges?: Maybe<LodgingTravelPledges>;
  /** @deprecated Only used for the legacy loyalty experience.  Will be replaced in the near future with the memberWallet query */
  loyalty: Loyalty;
  /** Top Level Accounts Status Widget query */
  loyaltyAccountStatusDetails?: Maybe<LoyaltyAccountStatusDetails>;
  /** Returns earn message details */
  loyaltyEarnCalculationDetails: LoyaltyEarnCalculationDetailsCard;
  memberWallet: MemberWallet;
  membersOnlyDealsTiers: SupplyMembersOnlyDealsTiers;
  /** Get details for multiple coupons */
  merchCoupons?: Maybe<MerchCoupons>;
  /** Product Information Review Query */
  mobilityProductReview: MobilityProductReview;
  /** Mobility Search Query */
  mobilityProductSearch: MobilityProductSearchResults;
  /** Mobility Search Form Query */
  mobilityProductSearchForm: EgdsSearchForm;
  /** Step Indicator query that returns steps, change links, and prices from the session id and/or jcid */
  multiItemStepIndicator: StepIndicator;
  /** Nearby airport suggestion query that returns links to search with nearby airports on a packages page. */
  nearbyAirportsSuggestion?: Maybe<NearbyAirportsSuggestion>;
  /** Top level notification query */
  notification: NotificationQuery;
  /** Query that builds search module layout */
  offersListing?: Maybe<OffersListingView>;
  /** Top level offers recommendations query */
  offersRecommendationByProduct?: Maybe<OffersRecommendationGroup>;
  onboardingPropertyRatesExperience: SupplyOnboardingPropertyRatesExperience;
  /** Returns data */
  oneKeyLoyaltyBanner?: Maybe<OneKeyLoyaltyBanner>;
  /**
   * Top level query to get destination experiences for packages
   * @deprecated Work in progress: Do not use! Still subject to breaking changes
   */
  packageDestination: PackageDestinationQueries;
  /** Top level query to obtain the query model to render the mishop-details-ui page. */
  packageDetails: MultiItemDetailsQuery;
  /** Grouping of all package primers queries */
  packagePrimers: PackagePrimersQueries;
  /** Returns UI for viewing/updating user's passports */
  passportsForm: ProfileAccountFormComponent;
  /** email body for password reset */
  passwordReset: PasswordResetContent;
  /** EG Identity PasswordStrengthMeter Component */
  passwordStrengthMeter: PasswordWithStrengthMeter;
  /** Password Updated Email */
  passwordUpdated: PasswordUpdatedResult;
  paymentDetails: SupplyPaymentDetails;
  /** Powers the payment module */
  paymentModule: PaymentModule;
  /** Powers the payment module card info */
  paymentModuleCardInfo: PaymentCardDetails;
  /** Returns UI for updating the current user's personal profile information */
  personalInfoForm: ProfileComponent;
  /** Top level personalized offers recommendations query */
  personalizedOffersRecommendation?: Maybe<PersonalizedOffersRecommendations>;
  /** Pre-bundled packages search query to get curated package offers. */
  preBundledPackageSearch: PreBundledPackageSearchResponse;
  /** Pre-bundled packages search entry point to get dialog content that will drive customers to the pre-bundled search experience */
  preBundledPackageSearchEntry?: Maybe<PreBundledPackageSearchEntryResponse>;
  /** Pre-bundled packages search form to get search wizard content that will allow customers to re-search for more pre-bundled packages based on new search criteria */
  preBundledPackageSearchForm: PackageSearchForm;
  /** Retrieves price details for a given offer */
  priceDetails?: Maybe<PriceDetails>;
  /** Returns price history, forecasting and alerts information tied to input search context */
  priceInsights?: Maybe<PriceInsights>;
  /** Returns details about a PMP purchase */
  priceMatchPromise?: Maybe<PriceMatchPromiseDetails>;
  /**
   * Query that builds product details module layout
   * @deprecated Use the productSummary query which can auto detect product line, replace with productSummary
   */
  productDetails?: Maybe<ProductDetailsLayout>;
  /**
   * Product details query that retrieves product details details of a given product
   * @deprecated Don't use this. It will be removed soon
   */
  productDetailsTemp: ProductDetails;
  /**
   * The cooler SRP experience.
   * @deprecated Only for Hackathon purposes, do not use
   */
  productListingCarousels?: Maybe<ProductCarouselResults>;
  /** Get customers' product questions and answers */
  productQuestions?: Maybe<ProductQuestions>;
  /** Query that builds summarised product layout */
  productSummary?: Maybe<ProductDetailsLayout>;
  /** Query to retrieve a list of products */
  products: ProductListResponse;
  /** Profile Change Email */
  profileChanged: ProfileChangedResult;
  /** Search Alternate dates for properties based on property ids */
  propertyAlternateDateSearch: Array<PropertyAlternateDateResult>;
  /**
   * returns availability data in a calendar-like (day by day) format for a given property (keyed by eid)
   *   a "property" in this case can be a single unit VR or multi-unit VR which will affect the number of
   *   availability calendars returned (for ex: 1 availability calendar per unit for a multi-unit VR)
   */
  propertyAvailabilityCalendars?: Maybe<Array<AvailabilityCalendar>>;
  propertyFilter: SupplyPropertyFilterSection;
  /** Top level property query */
  propertyInfo: PropertyInfo;
  /** Top level property offers query */
  propertyOffers?: Maybe<OfferDetails>;
  /**
   * Get the Point of interest content for a property.
   * @deprecated For PWA only
   */
  propertyPoiContent?: Maybe<Array<PoiContent>>;
  /** Get a single property review */
  propertyReview?: Maybe<PropertyReview>;
  /** Top level property query */
  propertyReviewAggregates: PropertyReviewAggregates;
  /** Get property reviews and review summary information */
  propertyReviewInfo: PropertyReviews;
  /** Retrieves review summaries for multiple properties */
  propertyReviewSummaries: Array<PropertyReviewSummary>;
  /** Search for hotels and vacation rentals */
  propertySearch: PropertySearchResults;
  /** Get top positive and top critical reviews */
  propertyTopReviews?: Maybe<PropertyTopReviews>;
  /** Room level customer review summaries. */
  propertyUnitReviewSummaries?: Maybe<Array<LodgingReviewSummary>>;
  /** Top level qualtrics config query */
  qualtricsConfig?: Maybe<QualtricsConfig>;
  /** Reasons To Believe Module */
  reasonsToBelieve: ReasonsToBelieve;
  /** Top level query for recently viewed properties */
  recentlyViewedPropertiesCarousel?: Maybe<LodgingCarouselContainer>;
  rentalAgreement: SupplyReservationsRentalAgreement;
  /** Returns Request Context Information from the client HTTP request. Note that debugContext and clientInfo are not populated in the return object. */
  requestContext: ClientRequestContext;
  /** Returns all notifications of a travel agent */
  retailTravelAgentNotificationCenter: RetailTravelAgentNotificationResult;
  /** Returns Review Questions */
  reviewQuestions: GetReviewQuestionsResponse;
  /** Returns UI for viewing/adding/updating user's reward programs and memberships */
  rewardProgramsForm: ProfileAccountFormComponent;
  /** Top level Query for Rules and Restrictions */
  rulesAndRestrictions: RnRDetails;
  /** Cruise Deals Search */
  sailingDeals: SailingDeals;
  /** Detailed information for a sailing. */
  sailingDetails: SailingDetailsResults;
  /** Cruise offers for a given sailing. */
  sailingOffers: CruiseOffersResults;
  /** Search airline credits query */
  searchAirlineCredits: AirlineCreditsResults;
  /** Top level search form query contains set of sub-queries that return lob specific search forms */
  searchForm: SearchFormResults;
  /** Retrieve all help articles, for specific product or category or retrieve it article by id */
  searchHelpArticles: HelpArticlesResultsView;
  /** Servicing Queries */
  servicing: Servicing;
  /** Returns insurtech module details */
  shopInsurtechOffers: ShopInsurtechOffersResponse;
  /** Top level query to obtain the primers for the products to be displayed. */
  shoppingPathPrimers: MultiItemDetailsPrimersQuery;
  /** Top level shortlist query */
  shortlist: Shortlist;
  /**
   * Get a list of similar properties with deals
   * @deprecated DO NOT USE: TNL 40644 is being rolled-back, clean-up instruction here https://confluence.expedia.biz/display/EWM/Similar+Properties+with+Deals
   */
  similarPropertiesDeals: SimilarPropertiesDeals;
  /** Return site information for a list of site ids. If a site id cannot be resolved, the site information will be omitted and the error detail will be populated in GraphQL errors */
  siteConfigurations: Array<SiteConfiguration>;
  smartForm: SmartFormQuery;
  /** Soft Account Creation Module */
  softAccountCreation: SoftAccountCreation;
  /** Soft Account Creation Module */
  softAccountCreationCheckList: SoftAccountCreationCheckList;
  /** testing rest call to opensearch domain */
  spinnerGetOpenSearchInfoUnesco: Scalars["String"];
  /** Top level sponsored content query */
  sponsoredContent: SponsoredContentQuery;
  /** Top level query for lodging Carousels */
  sponsoredPropertiesCarousel?: Maybe<LodgingCarouselContainer>;
  /** DEPRECATED: Use `crossSell.static` instead */
  staticMultiItemCrossSell: StaticMultiItemCrossSellResponse;
  stepReviewInlineEditingSheet?: Maybe<StepReviewInlineEditingSheet>;
  supplyAmenitiesGroup: SupplyAmenitiesGroup;
  supplyBusinessPartnerInformation: SupplyPartnerInformation;
  supplyCancellationWaiverDecline: SupplyCancellationWaiverDeclineFlowContent;
  supplyCoachingTipsBlock: SupplyCoachingTipsBlock;
  supplyContentHeadlineDescription: SupplyContentHeadlineDescription;
  supplyContentHub?: Maybe<SupplyContentHub>;
  supplyContentHubNavigation?: Maybe<SupplyContentHubNavigation>;
  supplyContentLocationSharing: SupplyContentLocationSharing;
  supplyContentManualTranslationSetting: SupplyContentManualTranslationSettingDialog;
  supplyContentSaveButton: SupplyContentSaveButton;
  supplyContentYourStory: SupplyContentYourStory;
  supplyFees: SupplyFees;
  supplyMarketMakerGrid: SupplyMarketMakerGrid;
  supplyMultiFactorAuthenticationView: SupplyMultiFactorAuthenticationExperience;
  supplyNavigation: SupplyNavigation;
  supplyNavigationNotification: SupplyNavigationNotificationContent;
  supplyNavigationPropertyDetails: SupplyNavigationMenuContent;
  supplyNavigationUserImpersonationBanner?: Maybe<SupplyNavigationUserImpersonationBanner>;
  supplyOnboardingAvailability?: Maybe<SupplyOnboardingAvailability>;
  supplyOnboardingNavigationHeader?: Maybe<SupplyOnboardingNavigationHeader>;
  supplyOnboardingPaymentTermsAndConditions: SupplyOnboardingPaymentTermsAndConditionsView;
  supplyOnboardingPropertyRatesExperience: SupplyOnboardingPropertyRatesExperience;
  supplyOnboardingPublishListing?: Maybe<SupplyOnboardingPublishListing>;
  supplyOnboardingReadiness?: Maybe<SupplyOnboardingReadiness>;
  supplyOnboardingReview?: Maybe<SupplyOnboardingReviewExperience>;
  supplyOnboardingTipCard: SupplyOnboardingTipCard;
  supplyOnboardingUnfinishedSteps?: Maybe<StepReviewList>;
  supplyOnboardingWelcome?: Maybe<SupplyOnboardingWelcome>;
  supplyOnboardingWorkFlowNavigation?: Maybe<SupplyOnboardingWorkFlowNavigation>;
  supplyPartnerGlanceCobrowse?: Maybe<GlanceCobrowseConfiguration>;
  supplyPropertyEditorPageTitle?: Maybe<SupplyPropertyEditorPageTitle>;
  supplyRegulatoryFlow: SupplyRegulatoryFlow;
  supplyRegulatoryFlowTitle: SupplyRegulatoryFlowTitle;
  supplyScoreDetails: SupplyScoreDetails;
  supplyScoreFactorAuditTrail: SupplyScoreFactorAuditTrail;
  supplyTaxes: SupplyTaxes;
  /**
   * Top level property offers query strictly for testing
   * @deprecated DO NOT USE! For testing only!!!
   */
  testingQueryOffers?: Maybe<OfferDetails>;
  /** Destination Travel guide ThingsToDo. */
  thingsToDo?: Maybe<DestinationRecommendationGroups>;
  /** Retrieves details for the Authentication Options Card */
  travelAgentAuthenticationOptions: TravelAgentAuthenticationOptionsResponse;
  /** Retrieves agent dashboard information */
  travelAgentDashboard?: Maybe<TravelAgentDashboard>;
  /**
   * TAAP Search Wizard
   * @deprecated This does not facilitate server-driven UI, not a good basis for future schema.
   */
  travelAgentSearchWizardConfig?: Maybe<TravelAgentSearchWizardConfig>;
  /** Travel Content Main Query */
  travelContent: TravelContent;
  /** Query to retrieve editorial content by content-id or URI context. */
  travelContentEditorial?: Maybe<Array<Maybe<TravelExperienceContent>>>;
  /** Query to retrieve seo metadata content. */
  travelContentSeo?: Maybe<SeoMetaContent>;
  /** Query to retrieve traveler experience manager content using the contentID. */
  travelExperienceContent?: Maybe<Array<Maybe<TravelExperienceContent>>>;
  /** Top level for experience manager contents */
  travelExperienceManagerContent: TravelExperienceContentResults;
  /** The trip top-level query contains a set of sub-queries that return views of a single trip or single trip item. */
  trip: Trip;
  /** The trips top-level query contains a set of sub-queries that return views of multiple trips. */
  trips: Trips;
  /** Returns UI for updating the current user's TSA information */
  tsaForm: ProfileComponent;
  /** testing localization message */
  unescoLocalizationTest: Scalars["String"];
  /** Top level universal profile query */
  universalProfile: UniversalProfileResponse;
  upcomingInteractions: SupplyReservationsInteractionsUpcomingView;
  /** Query to get a wizard based on page location and line of business */
  userProfileNextWizard: ProfileWizardComponent;
  /** Retrieve vacChatContent component */
  vacChatContent?: Maybe<VirtualAgentControlChatContent>;
  /** Retrieve VAC Orchestrator configuration */
  vacOrchestrator: VacOrchestrator;
  versions: Array<Maybe<Spinner>>;
  /** Retrieve VAC lite components */
  virtualAgentControl?: Maybe<VirtualAgentControl>;
  /** Top level Voice of the Customer query */
  voiceOfTheCustomer: VoiceOfTheCustomer;
  /** Top level Voice of the Customer Optional query */
  voiceOfTheCustomerOptional?: Maybe<VoiceOfTheCustomer>;
  /** Check integration with vr personalization service by retrieving some signal values */
  vrIntentSignals: VrIntentSignalsResult;
  worker: WorkerInfo;
};

/**
 * TODO:  Will remove these previous operations when Shared-UI uses the new ones with correct names
 * Duplicate of operations for correcting names based on comments in: https://github.expedia.biz/weaver/weaver-schema-stitcher/pull/899#issuecomment-1646168
 */
export type QueryActiveSessionsFormArgs = {
  context: ContextInput;
};

/**
 * TODO:  Will remove these previous operations when Shared-UI uses the new ones with correct names
 * Duplicate of operations for correcting names based on comments in: https://github.expedia.biz/weaver/weaver-schema-stitcher/pull/899#issuecomment-1646168
 */
export type QueryActivityCrossSellSearchArgs = {
  context: ContextInput;
  dateRange?: InputMaybe<ActivityDateRangeInput>;
  destination?: InputMaybe<ActivityDestinationInput>;
  filters?: InputMaybe<ActivitySearchFiltersInput>;
  pinnedActivityIds?: InputMaybe<Array<Scalars["String"]>>;
  selectedOffers?: InputMaybe<Array<ActivityOfferNaturalKeyInput>>;
  shoppingPath?: InputMaybe<ShoppingPathType>;
};

/**
 * TODO:  Will remove these previous operations when Shared-UI uses the new ones with correct names
 * Duplicate of operations for correcting names based on comments in: https://github.expedia.biz/weaver/weaver-schema-stitcher/pull/899#issuecomment-1646168
 */
export type QueryActivityInfoArgs = {
  activityId: Scalars["String"];
  context: ContextInput;
  dateRange?: InputMaybe<ActivityDateRangeInput>;
  destination?: InputMaybe<ActivityDestinationInput>;
  detailsViewOptions?: InputMaybe<Array<ActivityDetailViewOptions>>;
  marketing?: InputMaybe<ActivityMarketingInfoInput>;
  offerFilters?: InputMaybe<ActivityOfferFilterInput>;
  priceOptions?: InputMaybe<Array<ActivitySearchOptions>>;
  selectedOffers?: InputMaybe<Array<ActivityOfferNaturalKeyInput>>;
  shoppingPath?: InputMaybe<ShoppingPathType>;
  travelerDetails?: InputMaybe<Array<ActivityTravelerDetailsInput>>;
  viewOptions?: InputMaybe<Array<ActivitySearchOptions>>;
};

/**
 * TODO:  Will remove these previous operations when Shared-UI uses the new ones with correct names
 * Duplicate of operations for correcting names based on comments in: https://github.expedia.biz/weaver/weaver-schema-stitcher/pull/899#issuecomment-1646168
 */
export type QueryActivityModulesArgs = {
  context: ContextInput;
  dateRange?: InputMaybe<ActivityDateRangeInput>;
  destination?: InputMaybe<ActivityDestinationInput>;
};

/**
 * TODO:  Will remove these previous operations when Shared-UI uses the new ones with correct names
 * Duplicate of operations for correcting names based on comments in: https://github.expedia.biz/weaver/weaver-schema-stitcher/pull/899#issuecomment-1646168
 */
export type QueryActivityReviewsArgs = {
  activityId: Scalars["String"];
  context: ContextInput;
  pagination?: InputMaybe<PaginationInput>;
  selections?: InputMaybe<Array<ActivitySelectedValueInput>>;
  shoppingPath?: InputMaybe<ShoppingPathType>;
};

/**
 * TODO:  Will remove these previous operations when Shared-UI uses the new ones with correct names
 * Duplicate of operations for correcting names based on comments in: https://github.expedia.biz/weaver/weaver-schema-stitcher/pull/899#issuecomment-1646168
 */
export type QueryActivitySearchArgs = {
  context: ContextInput;
  dateRange?: InputMaybe<ActivityDateRangeInput>;
  destination?: InputMaybe<ActivityDestinationInput>;
  filters?: InputMaybe<ActivitySearchFiltersInput>;
  groupType?: InputMaybe<Array<ActivityGroupType>>;
  marketing?: InputMaybe<ActivityMarketingInfoInput>;
  pagination?: InputMaybe<PaginationInput>;
  searchOptions?: InputMaybe<Array<ActivitySearchOptions>>;
  searchViewOptions?: InputMaybe<Array<ActivitySearchViewOptions>>;
  sort?: InputMaybe<ActivitySort>;
  travelerInfo?: InputMaybe<ActivityTravelerInfoInput>;
};

/**
 * TODO:  Will remove these previous operations when Shared-UI uses the new ones with correct names
 * Duplicate of operations for correcting names based on comments in: https://github.expedia.biz/weaver/weaver-schema-stitcher/pull/899#issuecomment-1646168
 */
export type QueryActivitySeoContentArgs = {
  activityId?: InputMaybe<Scalars["String"]>;
  context: ContextInput;
  pageType: ActivityPageType;
};

/**
 * TODO:  Will remove these previous operations when Shared-UI uses the new ones with correct names
 * Duplicate of operations for correcting names based on comments in: https://github.expedia.biz/weaver/weaver-schema-stitcher/pull/899#issuecomment-1646168
 */
export type QueryAgencyPropertyInfoArgs = {
  propertyId: Scalars["String"];
  shoppingContext: AgencyShoppingContextInput;
  userContext: UserContextInput;
};

/**
 * TODO:  Will remove these previous operations when Shared-UI uses the new ones with correct names
 * Duplicate of operations for correcting names based on comments in: https://github.expedia.biz/weaver/weaver-schema-stitcher/pull/899#issuecomment-1646168
 */
export type QueryAgencyPropertySearchArgs = {
  destination: AgencyDestinationInput;
  filterInputs?: InputMaybe<AgencyPropertySearchFiltersInput>;
  shoppingContext: AgencyShoppingContextInput;
  userContext: UserContextInput;
};

/**
 * TODO:  Will remove these previous operations when Shared-UI uses the new ones with correct names
 * Duplicate of operations for correcting names based on comments in: https://github.expedia.biz/weaver/weaver-schema-stitcher/pull/899#issuecomment-1646168
 */
export type QueryAgencyQuoteBuilderArgs = {
  context: ContextInput;
};

/**
 * TODO:  Will remove these previous operations when Shared-UI uses the new ones with correct names
 * Duplicate of operations for correcting names based on comments in: https://github.expedia.biz/weaver/weaver-schema-stitcher/pull/899#issuecomment-1646168
 */
export type QueryAgencyQuoteInfoArgs = {
  cacheId?: InputMaybe<Scalars["String"]>;
  context: ContextInput;
  naturalKey?: InputMaybe<AgencyQuoteNaturalKeyInput>;
  quoteId?: InputMaybe<Scalars["String"]>;
};

/**
 * TODO:  Will remove these previous operations when Shared-UI uses the new ones with correct names
 * Duplicate of operations for correcting names based on comments in: https://github.expedia.biz/weaver/weaver-schema-stitcher/pull/899#issuecomment-1646168
 */
export type QueryAgencyQuoteListArgs = {
  context: ContextInput;
  retrieveInput: AgencyQuoteListInput;
};

/**
 * TODO:  Will remove these previous operations when Shared-UI uses the new ones with correct names
 * Duplicate of operations for correcting names based on comments in: https://github.expedia.biz/weaver/weaver-schema-stitcher/pull/899#issuecomment-1646168
 */
export type QueryAgentQuoteInfoArgs = {
  context: ContextInput;
  naturalKey: AgentQuoteNaturalKeyInput;
};

/**
 * TODO:  Will remove these previous operations when Shared-UI uses the new ones with correct names
 * Duplicate of operations for correcting names based on comments in: https://github.expedia.biz/weaver/weaver-schema-stitcher/pull/899#issuecomment-1646168
 */
export type QueryAssociatedPropertySearchArgs = {
  context: ContextInput;
  currentPageContext?: InputMaybe<SupplyCurrentPageContext>;
  keyword: Scalars["String"];
};

/**
 * TODO:  Will remove these previous operations when Shared-UI uses the new ones with correct names
 * Duplicate of operations for correcting names based on comments in: https://github.expedia.biz/weaver/weaver-schema-stitcher/pull/899#issuecomment-1646168
 */
export type QueryBestTimeToGoArgs = {
  context: ContextInput;
  placeId: Scalars["String"];
};

/**
 * TODO:  Will remove these previous operations when Shared-UI uses the new ones with correct names
 * Duplicate of operations for correcting names based on comments in: https://github.expedia.biz/weaver/weaver-schema-stitcher/pull/899#issuecomment-1646168
 */
export type QueryBookingServicingCancellationArgs = {
  context: ContextInput;
  queryState?: InputMaybe<BookingServicingQueryState>;
  tripId: Scalars["String"];
};

/**
 * TODO:  Will remove these previous operations when Shared-UI uses the new ones with correct names
 * Duplicate of operations for correcting names based on comments in: https://github.expedia.biz/weaver/weaver-schema-stitcher/pull/899#issuecomment-1646168
 */
export type QueryBookingServicingChangeArgs = {
  context: ContextInput;
  tripId: Scalars["String"];
};

/**
 * TODO:  Will remove these previous operations when Shared-UI uses the new ones with correct names
 * Duplicate of operations for correcting names based on comments in: https://github.expedia.biz/weaver/weaver-schema-stitcher/pull/899#issuecomment-1646168
 */
export type QueryBreadcrumbsArgs = {
  context: ContextInput;
  uriContext: UriContextInput;
};

/**
 * TODO:  Will remove these previous operations when Shared-UI uses the new ones with correct names
 * Duplicate of operations for correcting names based on comments in: https://github.expedia.biz/weaver/weaver-schema-stitcher/pull/899#issuecomment-1646168
 */
export type QueryBusinessPartnerInformationArgs = {
  context: ContextInput;
  propertyContext: PropertyContext;
};

/**
 * TODO:  Will remove these previous operations when Shared-UI uses the new ones with correct names
 * Duplicate of operations for correcting names based on comments in: https://github.expedia.biz/weaver/weaver-schema-stitcher/pull/899#issuecomment-1646168
 */
export type QueryCampaignConfigPropertyGroupFormArgs = {
  accountId: Scalars["Int"];
  context: ContextInput;
};

/**
 * TODO:  Will remove these previous operations when Shared-UI uses the new ones with correct names
 * Duplicate of operations for correcting names based on comments in: https://github.expedia.biz/weaver/weaver-schema-stitcher/pull/899#issuecomment-1646168
 */
export type QueryCampaignRecommendationsArgs = {
  campaignIds?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
  campaignParameters?: InputMaybe<CampaignParametersInput>;
  context: ContextInput;
  destinationId?: InputMaybe<Scalars["String"]>;
  destinationImageDimensions?: InputMaybe<DestinationImageDimensionsInput>;
  displayPropertyCount?: InputMaybe<Scalars["Boolean"]>;
  enableLivePricing?: InputMaybe<Scalars["Boolean"]>;
  enableTripAttach?: InputMaybe<Scalars["Boolean"]>;
  includeDeals?: InputMaybe<Scalars["Boolean"]>;
  maxNumberOfCampaigns?: InputMaybe<Scalars["Int"]>;
  modulePlacement?: InputMaybe<Scalars["String"]>;
  numberOfCampaigns?: InputMaybe<Scalars["Int"]>;
  pageNumber?: InputMaybe<Scalars["Int"]>;
  productType?: InputMaybe<Array<InputMaybe<CampaignProductType>>>;
  recommendationType?: InputMaybe<Array<InputMaybe<RecommendedType>>>;
  referrer?: InputMaybe<Scalars["String"]>;
  userLocation?: InputMaybe<UserLocationInput>;
  userTripState?: InputMaybe<Scalars["String"]>;
};

/**
 * TODO:  Will remove these previous operations when Shared-UI uses the new ones with correct names
 * Duplicate of operations for correcting names based on comments in: https://github.expedia.biz/weaver/weaver-schema-stitcher/pull/899#issuecomment-1646168
 */
export type QueryCancellationWaiverApprovalArgs = {
  context: ContextInput;
  propertyContext: PropertyContext;
  reservationContext: SupplyCancellationWaiverReservationContext;
};

/**
 * TODO:  Will remove these previous operations when Shared-UI uses the new ones with correct names
 * Duplicate of operations for correcting names based on comments in: https://github.expedia.biz/weaver/weaver-schema-stitcher/pull/899#issuecomment-1646168
 */
export type QueryCancellationWaiverDetailsArgs = {
  context: ContextInput;
  propertyContext: PropertyContext;
  reservationContext: SupplyCancellationWaiverReservationContext;
};

/**
 * TODO:  Will remove these previous operations when Shared-UI uses the new ones with correct names
 * Duplicate of operations for correcting names based on comments in: https://github.expedia.biz/weaver/weaver-schema-stitcher/pull/899#issuecomment-1646168
 */
export type QueryCarDetailArgs = {
  carDetailContext: CarDetailContextInput;
  carsDomainRequestContext?: InputMaybe<CarsDomainRequestContextInput>;
  context: ContextInput;
};

/**
 * TODO:  Will remove these previous operations when Shared-UI uses the new ones with correct names
 * Duplicate of operations for correcting names based on comments in: https://github.expedia.biz/weaver/weaver-schema-stitcher/pull/899#issuecomment-1646168
 */
export type QueryCarDropOffSearchArgs = {
  context: ContextInput;
  primaryCarSearchCriteria: PrimaryCarCriteriaInput;
  secondaryCriteria: ShoppingSearchCriteriaInput;
};

/**
 * TODO:  Will remove these previous operations when Shared-UI uses the new ones with correct names
 * Duplicate of operations for correcting names based on comments in: https://github.expedia.biz/weaver/weaver-schema-stitcher/pull/899#issuecomment-1646168
 */
export type QueryCarRulesAndRestrictionsArgs = {
  carRulesAndRestrictionsCriteria: CarRulesAndRestrictionsCriteriaInput;
  context: ContextInput;
};

/**
 * TODO:  Will remove these previous operations when Shared-UI uses the new ones with correct names
 * Duplicate of operations for correcting names based on comments in: https://github.expedia.biz/weaver/weaver-schema-stitcher/pull/899#issuecomment-1646168
 */
export type QueryCarSearchOrRecommendationsArgs = {
  context: ContextInput;
  primaryCarSearchCriteria: PrimaryCarCriteriaInput;
  secondaryCriteria: ShoppingSearchCriteriaInput;
  shoppingContext?: InputMaybe<ShoppingContextInput>;
};

/**
 * TODO:  Will remove these previous operations when Shared-UI uses the new ones with correct names
 * Duplicate of operations for correcting names based on comments in: https://github.expedia.biz/weaver/weaver-schema-stitcher/pull/899#issuecomment-1646168
 */
export type QueryCartArgs = {
  context: ContextInput;
  id?: InputMaybe<Scalars["UUID"]>;
};

/**
 * TODO:  Will remove these previous operations when Shared-UI uses the new ones with correct names
 * Duplicate of operations for correcting names based on comments in: https://github.expedia.biz/weaver/weaver-schema-stitcher/pull/899#issuecomment-1646168
 */
export type QueryCdfPromptByIdArgs = {
  context: ContextInput;
  id: Scalars["ID"];
};

/**
 * TODO:  Will remove these previous operations when Shared-UI uses the new ones with correct names
 * Duplicate of operations for correcting names based on comments in: https://github.expedia.biz/weaver/weaver-schema-stitcher/pull/899#issuecomment-1646168
 */
export type QueryChatbotConfigArgs = {
  applicationName: Scalars["String"];
  context: ContextInput;
  intentMessage?: InputMaybe<Array<ChatbotIntentValueInput>>;
};

/**
 * TODO:  Will remove these previous operations when Shared-UI uses the new ones with correct names
 * Duplicate of operations for correcting names based on comments in: https://github.expedia.biz/weaver/weaver-schema-stitcher/pull/899#issuecomment-1646168
 */
export type QueryCheckoutArgs = {
  context: ContextInput;
};

/**
 * TODO:  Will remove these previous operations when Shared-UI uses the new ones with correct names
 * Duplicate of operations for correcting names based on comments in: https://github.expedia.biz/weaver/weaver-schema-stitcher/pull/899#issuecomment-1646168
 */
export type QueryCheckoutAccountCreationArgs = {
  context: ContextInput;
  identityClientInfo?: InputMaybe<IdentityClientInfoInput>;
};

/**
 * TODO:  Will remove these previous operations when Shared-UI uses the new ones with correct names
 * Duplicate of operations for correcting names based on comments in: https://github.expedia.biz/weaver/weaver-schema-stitcher/pull/899#issuecomment-1646168
 */
export type QueryCoBrandBannerArgs = {
  context: ContextInput;
};

/**
 * TODO:  Will remove these previous operations when Shared-UI uses the new ones with correct names
 * Duplicate of operations for correcting names based on comments in: https://github.expedia.biz/weaver/weaver-schema-stitcher/pull/899#issuecomment-1646168
 */
export type QueryCompetitiveSetEditorArgs = {
  context: ContextInput;
  productId: Scalars["String"];
  productType: CompetitiveSetProductType;
};

/**
 * TODO:  Will remove these previous operations when Shared-UI uses the new ones with correct names
 * Duplicate of operations for correcting names based on comments in: https://github.expedia.biz/weaver/weaver-schema-stitcher/pull/899#issuecomment-1646168
 */
export type QueryCompetitorCardArgs = {
  competitorProductId: Scalars["String"];
  context: ContextInput;
  productId: Scalars["String"];
  productType: CompetitiveSetProductType;
};

/**
 * TODO:  Will remove these previous operations when Shared-UI uses the new ones with correct names
 * Duplicate of operations for correcting names based on comments in: https://github.expedia.biz/weaver/weaver-schema-stitcher/pull/899#issuecomment-1646168
 */
export type QueryConfirmationSummaryArgs = {
  context: ContextInput;
  orderId: Scalars["String"];
};

/**
 * TODO:  Will remove these previous operations when Shared-UI uses the new ones with correct names
 * Duplicate of operations for correcting names based on comments in: https://github.expedia.biz/weaver/weaver-schema-stitcher/pull/899#issuecomment-1646168
 */
export type QueryContactHostArgs = {
  context: ContextInput;
  inquiryFormInput?: InputMaybe<InquiryFormInput>;
  prominence?: InputMaybe<InquiryProminence>;
};

/**
 * TODO:  Will remove these previous operations when Shared-UI uses the new ones with correct names
 * Duplicate of operations for correcting names based on comments in: https://github.expedia.biz/weaver/weaver-schema-stitcher/pull/899#issuecomment-1646168
 */
export type QueryContactUsOptionsArgs = {
  context: ContextInput;
};

/**
 * TODO:  Will remove these previous operations when Shared-UI uses the new ones with correct names
 * Duplicate of operations for correcting names based on comments in: https://github.expedia.biz/weaver/weaver-schema-stitcher/pull/899#issuecomment-1646168
 */
export type QueryContractTermsArgs = {
  context: ContextInput;
  propertyContext: PropertyContext;
};

/**
 * TODO:  Will remove these previous operations when Shared-UI uses the new ones with correct names
 * Duplicate of operations for correcting names based on comments in: https://github.expedia.biz/weaver/weaver-schema-stitcher/pull/899#issuecomment-1646168
 */
export type QueryCouponRedemptionArgs = {
  context: ContextInput;
  moduleInstanceId: Scalars["String"];
};

/**
 * TODO:  Will remove these previous operations when Shared-UI uses the new ones with correct names
 * Duplicate of operations for correcting names based on comments in: https://github.expedia.biz/weaver/weaver-schema-stitcher/pull/899#issuecomment-1646168
 */
export type QueryCouponsAndCreditsArgs = {
  context: ContextInput;
  sourceReferrer?: InputMaybe<Scalars["String"]>;
};

/**
 * TODO:  Will remove these previous operations when Shared-UI uses the new ones with correct names
 * Duplicate of operations for correcting names based on comments in: https://github.expedia.biz/weaver/weaver-schema-stitcher/pull/899#issuecomment-1646168
 */
export type QueryCreditCardApplicationFormArgs = {
  context: ContextInput;
};

/**
 * TODO:  Will remove these previous operations when Shared-UI uses the new ones with correct names
 * Duplicate of operations for correcting names based on comments in: https://github.expedia.biz/weaver/weaver-schema-stitcher/pull/899#issuecomment-1646168
 */
export type QueryCreditCardPromotionArgs = {
  actionType: CreditCardApplyButtonActionType;
  context: ContextInput;
};

/**
 * TODO:  Will remove these previous operations when Shared-UI uses the new ones with correct names
 * Duplicate of operations for correcting names based on comments in: https://github.expedia.biz/weaver/weaver-schema-stitcher/pull/899#issuecomment-1646168
 */
export type QueryCreditRedemptionInsurtechOffersArgs = {
  clientId: InsurtechClientId;
  context: ContextInput;
  residencyInformation: ResidencyDetailsInput;
  tripId: Scalars["String"];
};

/**
 * TODO:  Will remove these previous operations when Shared-UI uses the new ones with correct names
 * Duplicate of operations for correcting names based on comments in: https://github.expedia.biz/weaver/weaver-schema-stitcher/pull/899#issuecomment-1646168
 */
export type QueryCrossSellArgs = {
  context: ContextInput;
  searchContext: MultiItemSearchContextInput;
  selectedProducts?: InputMaybe<MultiItemProductsInput>;
};

/**
 * TODO:  Will remove these previous operations when Shared-UI uses the new ones with correct names
 * Duplicate of operations for correcting names based on comments in: https://github.expedia.biz/weaver/weaver-schema-stitcher/pull/899#issuecomment-1646168
 */
export type QueryCrosslinksArgs = {
  context: ContextInput;
  limit: Scalars["Int"];
  parameters?: InputMaybe<Array<CrossLinksParameterInput>>;
  strategyName: Scalars["String"];
  uriContext: UriContextInput;
};

/**
 * TODO:  Will remove these previous operations when Shared-UI uses the new ones with correct names
 * Duplicate of operations for correcting names based on comments in: https://github.expedia.biz/weaver/weaver-schema-stitcher/pull/899#issuecomment-1646168
 */
export type QueryCruiseSearchArgs = {
  context?: InputMaybe<ContextInput>;
  searchInput: CruiseSearchCriteriaInput;
  sortBy?: InputMaybe<Scalars["String"]>;
  sortOrder?: InputMaybe<Scalars["String"]>;
};

/**
 * TODO:  Will remove these previous operations when Shared-UI uses the new ones with correct names
 * Duplicate of operations for correcting names based on comments in: https://github.expedia.biz/weaver/weaver-schema-stitcher/pull/899#issuecomment-1646168
 */
export type QueryCustomerArgs = {
  context: ContextInput;
  semdtl?: InputMaybe<Scalars["String"]>;
};

/**
 * TODO:  Will remove these previous operations when Shared-UI uses the new ones with correct names
 * Duplicate of operations for correcting names based on comments in: https://github.expedia.biz/weaver/weaver-schema-stitcher/pull/899#issuecomment-1646168
 */
export type QueryCustomerProfileArgs = {
  context: ContextInput;
};

/**
 * TODO:  Will remove these previous operations when Shared-UI uses the new ones with correct names
 * Duplicate of operations for correcting names based on comments in: https://github.expedia.biz/weaver/weaver-schema-stitcher/pull/899#issuecomment-1646168
 */
export type QueryDailyWeatherForecastArgs = {
  context: ContextInput;
  dateRange?: InputMaybe<DateRangeInput>;
  regionId: Scalars["String"];
  unit?: InputMaybe<Scalars["String"]>;
};

/**
 * TODO:  Will remove these previous operations when Shared-UI uses the new ones with correct names
 * Duplicate of operations for correcting names based on comments in: https://github.expedia.biz/weaver/weaver-schema-stitcher/pull/899#issuecomment-1646168
 */
export type QueryDeferredPaymentReportArgs = {
  context: ContextInput;
};

/**
 * TODO:  Will remove these previous operations when Shared-UI uses the new ones with correct names
 * Duplicate of operations for correcting names based on comments in: https://github.expedia.biz/weaver/weaver-schema-stitcher/pull/899#issuecomment-1646168
 */
export type QueryDeleteAccountFormArgs = {
  context: ContextInput;
};

/**
 * TODO:  Will remove these previous operations when Shared-UI uses the new ones with correct names
 * Duplicate of operations for correcting names based on comments in: https://github.expedia.biz/weaver/weaver-schema-stitcher/pull/899#issuecomment-1646168
 */
export type QueryDestinationExpertTipsArgs = {
  context: ContextInput;
  placeId: Scalars["String"];
};

/**
 * TODO:  Will remove these previous operations when Shared-UI uses the new ones with correct names
 * Duplicate of operations for correcting names based on comments in: https://github.expedia.biz/weaver/weaver-schema-stitcher/pull/899#issuecomment-1646168
 */
export type QueryDestinationHeadingArgs = {
  context: ContextInput;
  headingCriteria: DestinationHeadingCriteriaInput;
};

/**
 * TODO:  Will remove these previous operations when Shared-UI uses the new ones with correct names
 * Duplicate of operations for correcting names based on comments in: https://github.expedia.biz/weaver/weaver-schema-stitcher/pull/899#issuecomment-1646168
 */
export type QueryDestinationHeroArgs = {
  context: ContextInput;
  travelContentAttributes?: InputMaybe<TravelContentAttributesInput>;
  uriContext: UriContextInput;
};

/**
 * TODO:  Will remove these previous operations when Shared-UI uses the new ones with correct names
 * Duplicate of operations for correcting names based on comments in: https://github.expedia.biz/weaver/weaver-schema-stitcher/pull/899#issuecomment-1646168
 */
export type QueryDestinationInsightsArgs = {
  context: ContextInput;
  regionId: Scalars["String"];
};

/**
 * TODO:  Will remove these previous operations when Shared-UI uses the new ones with correct names
 * Duplicate of operations for correcting names based on comments in: https://github.expedia.biz/weaver/weaver-schema-stitcher/pull/899#issuecomment-1646168
 */
export type QueryDestinationPropertiesCarouselArgs = {
  context: ContextInput;
  criteria?: InputMaybe<PropertySearchCriteriaInput>;
};

/**
 * TODO:  Will remove these previous operations when Shared-UI uses the new ones with correct names
 * Duplicate of operations for correcting names based on comments in: https://github.expedia.biz/weaver/weaver-schema-stitcher/pull/899#issuecomment-1646168
 */
export type QueryDestinationRecommendationArgs = {
  context: ContextInput;
  recommendationCriteria: DestinationRecommendationCriteriaInput;
};

/**
 * TODO:  Will remove these previous operations when Shared-UI uses the new ones with correct names
 * Duplicate of operations for correcting names based on comments in: https://github.expedia.biz/weaver/weaver-schema-stitcher/pull/899#issuecomment-1646168
 */
export type QueryDirectFeedbackPromptByIdArgs = {
  context: ContextInput;
  id: Scalars["ID"];
};

/**
 * TODO:  Will remove these previous operations when Shared-UI uses the new ones with correct names
 * Duplicate of operations for correcting names based on comments in: https://github.expedia.biz/weaver/weaver-schema-stitcher/pull/899#issuecomment-1646168
 */
export type QueryDrivableDestinationsArgs = {
  context: ContextInput;
  egaid: Scalars["String"];
  latitude: Scalars["Float"];
  longitude: Scalars["Float"];
  traceId: Scalars["String"];
};

/**
 * TODO:  Will remove these previous operations when Shared-UI uses the new ones with correct names
 * Duplicate of operations for correcting names based on comments in: https://github.expedia.biz/weaver/weaver-schema-stitcher/pull/899#issuecomment-1646168
 */
export type QueryFareCalendarArgs = {
  context: ContextInput;
};

/**
 * TODO:  Will remove these previous operations when Shared-UI uses the new ones with correct names
 * Duplicate of operations for correcting names based on comments in: https://github.expedia.biz/weaver/weaver-schema-stitcher/pull/899#issuecomment-1646168
 */
export type QueryFetchItineraryArgs = {
  dateInput: DateInput;
  lineOfBusiness: LineOfBusiness;
};

/**
 * TODO:  Will remove these previous operations when Shared-UI uses the new ones with correct names
 * Duplicate of operations for correcting names based on comments in: https://github.expedia.biz/weaver/weaver-schema-stitcher/pull/899#issuecomment-1646168
 */
export type QueryFetchItineraryWithSpeechArgs = {
  speechText: Scalars["String"];
};

/**
 * TODO:  Will remove these previous operations when Shared-UI uses the new ones with correct names
 * Duplicate of operations for correcting names based on comments in: https://github.expedia.biz/weaver/weaver-schema-stitcher/pull/899#issuecomment-1646168
 */
export type QueryFetchLodgingUnescoPledgeArgs = {
  context: ContextInput;
  pledgeId: Scalars["ID"];
};

/**
 * TODO:  Will remove these previous operations when Shared-UI uses the new ones with correct names
 * Duplicate of operations for correcting names based on comments in: https://github.expedia.biz/weaver/weaver-schema-stitcher/pull/899#issuecomment-1646168
 */
export type QueryFetchLodgingUnescoPledgesArgs = {
  context: ContextInput;
  criteria?: InputMaybe<ShoppingSearchCriteriaInput>;
  filter?: InputMaybe<UnescoPledgeFilterInput>;
};

/**
 * TODO:  Will remove these previous operations when Shared-UI uses the new ones with correct names
 * Duplicate of operations for correcting names based on comments in: https://github.expedia.biz/weaver/weaver-schema-stitcher/pull/899#issuecomment-1646168
 */
export type QueryFetchLodgingUnescoSearchSortAndFilterArgs = {
  context: ContextInput;
};

/**
 * TODO:  Will remove these previous operations when Shared-UI uses the new ones with correct names
 * Duplicate of operations for correcting names based on comments in: https://github.expedia.biz/weaver/weaver-schema-stitcher/pull/899#issuecomment-1646168
 */
export type QueryFlexibleSearchArgs = {
  context: ContextInput;
};

/**
 * TODO:  Will remove these previous operations when Shared-UI uses the new ones with correct names
 * Duplicate of operations for correcting names based on comments in: https://github.expedia.biz/weaver/weaver-schema-stitcher/pull/899#issuecomment-1646168
 */
export type QueryFlightDestinationInsightsArgs = {
  context: ContextInput;
  origin: InsightsLocationInput;
};

/**
 * TODO:  Will remove these previous operations when Shared-UI uses the new ones with correct names
 * Duplicate of operations for correcting names based on comments in: https://github.expedia.biz/weaver/weaver-schema-stitcher/pull/899#issuecomment-1646168
 */
export type QueryFlightInsightsArgs = {
  context: ContextInput;
  destination: InsightsLocationInput;
  origin: InsightsLocationInput;
};

/**
 * TODO:  Will remove these previous operations when Shared-UI uses the new ones with correct names
 * Duplicate of operations for correcting names based on comments in: https://github.expedia.biz/weaver/weaver-schema-stitcher/pull/899#issuecomment-1646168
 */
export type QueryFlightPreferencesFormArgs = {
  context: ContextInput;
};

/**
 * TODO:  Will remove these previous operations when Shared-UI uses the new ones with correct names
 * Duplicate of operations for correcting names based on comments in: https://github.expedia.biz/weaver/weaver-schema-stitcher/pull/899#issuecomment-1646168
 */
export type QueryFlightsAirlineCreditsArgs = {
  context: ContextInput;
  flightsSearchContext?: InputMaybe<FlightsSearchContextInput>;
  journeyCriteria?: InputMaybe<Array<FlightsJourneyCriteriaInput>>;
  originalBookingId?: InputMaybe<Scalars["String"]>;
  queryState?: InputMaybe<FlightsQueryState>;
  searchPreferences?: InputMaybe<FlightsSearchPreferencesInput>;
  shoppingContext?: InputMaybe<ShoppingContextInput>;
  travelerDetails?: InputMaybe<Array<FlightsTravelerDetailsInput>>;
};

/**
 * TODO:  Will remove these previous operations when Shared-UI uses the new ones with correct names
 * Duplicate of operations for correcting names based on comments in: https://github.expedia.biz/weaver/weaver-schema-stitcher/pull/899#issuecomment-1646168
 */
export type QueryFlightsAncillaryArgs = {
  ancillaryCriteria: FlightsAncillaryCriteriaInput;
  context: ContextInput;
  queryState?: InputMaybe<FlightsQueryState>;
  shoppingContext?: InputMaybe<ShoppingContextInput>;
};

/**
 * TODO:  Will remove these previous operations when Shared-UI uses the new ones with correct names
 * Duplicate of operations for correcting names based on comments in: https://github.expedia.biz/weaver/weaver-schema-stitcher/pull/899#issuecomment-1646168
 */
export type QueryFlightsBaggagePriceCalculationsArgs = {
  arithmeticOperationsCriteria: ArithmeticOperationsCriteriaInput;
  context: ContextInput;
  shoppingContext?: InputMaybe<ShoppingContextInput>;
};

/**
 * TODO:  Will remove these previous operations when Shared-UI uses the new ones with correct names
 * Duplicate of operations for correcting names based on comments in: https://github.expedia.biz/weaver/weaver-schema-stitcher/pull/899#issuecomment-1646168
 */
export type QueryFlightsDetailArgs = {
  context: ContextInput;
  flightsDetailComponentsCriteria?: InputMaybe<FlightsDetailComponentsCriteriaInput>;
  flightsDetailCriteria?: InputMaybe<FlightsDetailCriteriaInput>;
  insuranceCriteria?: InputMaybe<InsuranceCriteriaInput>;
  queryState?: InputMaybe<FlightsQueryState>;
  shoppingContext?: InputMaybe<ShoppingContextInput>;
  virtualAgentContext?: InputMaybe<VirtualAgentContextInput>;
};

/**
 * TODO:  Will remove these previous operations when Shared-UI uses the new ones with correct names
 * Duplicate of operations for correcting names based on comments in: https://github.expedia.biz/weaver/weaver-schema-stitcher/pull/899#issuecomment-1646168
 */
export type QueryFlightsFareCalendarArgs = {
  context: ContextInput;
  flightsSearchContext: FlightsSearchContextInput;
  journeyCriteria: Array<FlightsJourneyCriteriaInput>;
  queryState?: InputMaybe<FlightsQueryState>;
  shoppingContext?: InputMaybe<ShoppingContextInput>;
};

/**
 * TODO:  Will remove these previous operations when Shared-UI uses the new ones with correct names
 * Duplicate of operations for correcting names based on comments in: https://github.expedia.biz/weaver/weaver-schema-stitcher/pull/899#issuecomment-1646168
 */
export type QueryFlightsListingsArgs = {
  context: ContextInput;
  journeyCriteria: Array<FlightsJourneyCriteriaInput>;
  searchPreferences?: InputMaybe<FlightsSearchPreferencesInput>;
  shoppingContext?: InputMaybe<ShoppingContextInput>;
  shoppingSearchCriteria?: InputMaybe<ShoppingSearchCriteriaInput>;
};

/**
 * TODO:  Will remove these previous operations when Shared-UI uses the new ones with correct names
 * Duplicate of operations for correcting names based on comments in: https://github.expedia.biz/weaver/weaver-schema-stitcher/pull/899#issuecomment-1646168
 */
export type QueryFlightsPlacardArgs = {
  context: ContextInput;
  flightsDetailComponentsCriteria?: InputMaybe<FlightsDetailComponentsCriteriaInput>;
  flightsDetailCriteria?: InputMaybe<FlightsDetailCriteriaInput>;
  flightsPlacardsTypeList: Array<FlightsPlacardType>;
  shoppingContext?: InputMaybe<ShoppingContextInput>;
};

/**
 * TODO:  Will remove these previous operations when Shared-UI uses the new ones with correct names
 * Duplicate of operations for correcting names based on comments in: https://github.expedia.biz/weaver/weaver-schema-stitcher/pull/899#issuecomment-1646168
 */
export type QueryFlightsSearchArgs = {
  context: ContextInput;
  fareCalendarPrice?: InputMaybe<Scalars["String"]>;
  faresSeparationType?: InputMaybe<FlightsFaresSeparationType>;
  flightsDevicePermissionsInput?: InputMaybe<FlightsDevicePermissionsInput>;
  flightsDisplayComponentValues?: InputMaybe<FlightsDisplayComponentValuesInput>;
  flightsSearchComponentCriteria?: InputMaybe<FlightsSearchComponentCriteriaInput>;
  flightsSearchContext?: InputMaybe<FlightsSearchContextInput>;
  insuranceCriteria?: InputMaybe<InsuranceCriteriaInput>;
  journeyCriteria: Array<FlightsJourneyCriteriaInput>;
  queryState?: InputMaybe<FlightsQueryState>;
  rewardsOption?: InputMaybe<RewardsOption>;
  searchFilterValuesList?: InputMaybe<Array<FlightsSearchFilterValuesInput>>;
  searchPagination?: InputMaybe<PaginationInput>;
  searchPreferences?: InputMaybe<FlightsSearchPreferencesInput>;
  shoppingContext?: InputMaybe<ShoppingContextInput>;
  shoppingSearchCriteria?: InputMaybe<ShoppingSearchCriteriaInput>;
  sortOption?: InputMaybe<FlightsSortOptionTypeInput>;
  travelerDetails?: InputMaybe<Array<FlightsTravelerDetailsInput>>;
  virtualAgentContext?: InputMaybe<VirtualAgentContextInput>;
};

/**
 * TODO:  Will remove these previous operations when Shared-UI uses the new ones with correct names
 * Duplicate of operations for correcting names based on comments in: https://github.expedia.biz/weaver/weaver-schema-stitcher/pull/899#issuecomment-1646168
 */
export type QueryFlightsSeatMapArgs = {
  context: ContextInput;
  queryState?: InputMaybe<FlightsQueryState>;
  seatMapCriteria: FlightsSeatMapCriteriaInput;
  shoppingContext?: InputMaybe<ShoppingContextInput>;
};

/**
 * TODO:  Will remove these previous operations when Shared-UI uses the new ones with correct names
 * Duplicate of operations for correcting names based on comments in: https://github.expedia.biz/weaver/weaver-schema-stitcher/pull/899#issuecomment-1646168
 */
export type QueryFlightsServicingArgs = {
  context: ContextInput;
  flightsServicingCriteria: FlightsServicingCriteriaInput;
  insuranceCriteria?: InputMaybe<InsuranceCriteriaInput>;
  queryState?: InputMaybe<FlightsQueryState>;
  shoppingContext?: InputMaybe<ShoppingContextInput>;
  virtualAgentContext?: InputMaybe<VirtualAgentContextInput>;
};

/**
 * TODO:  Will remove these previous operations when Shared-UI uses the new ones with correct names
 * Duplicate of operations for correcting names based on comments in: https://github.expedia.biz/weaver/weaver-schema-stitcher/pull/899#issuecomment-1646168
 */
export type QueryFlightsServicingConfirmationArgs = {
  context: ContextInput;
  flightsServicingConfirmationCriteria: FlightsServicingConfirmationCriteriaInput;
  queryState?: InputMaybe<FlightsQueryState>;
};

/**
 * TODO:  Will remove these previous operations when Shared-UI uses the new ones with correct names
 * Duplicate of operations for correcting names based on comments in: https://github.expedia.biz/weaver/weaver-schema-stitcher/pull/899#issuecomment-1646168
 */
export type QueryFrequentlyAskedQuestionsArgs = {
  context: ContextInput;
  limit: Scalars["Int"];
  uriContext?: InputMaybe<TravelContentUriContextInput>;
  uriContextV1: UriContextInput;
};

/**
 * TODO:  Will remove these previous operations when Shared-UI uses the new ones with correct names
 * Duplicate of operations for correcting names based on comments in: https://github.expedia.biz/weaver/weaver-schema-stitcher/pull/899#issuecomment-1646168
 */
export type QueryGetAgentPresenceArgs = {
  context: ContextInput;
  flavor: FlavorType;
  partnerId: Scalars["String"];
  roleId: Scalars["String"];
  userId: Scalars["String"];
};

/**
 * TODO:  Will remove these previous operations when Shared-UI uses the new ones with correct names
 * Duplicate of operations for correcting names based on comments in: https://github.expedia.biz/weaver/weaver-schema-stitcher/pull/899#issuecomment-1646168
 */
export type QueryGetMultiFactorAuthenticationViewArgs = {
  context: ContextInput;
};

/**
 * TODO:  Will remove these previous operations when Shared-UI uses the new ones with correct names
 * Duplicate of operations for correcting names based on comments in: https://github.expedia.biz/weaver/weaver-schema-stitcher/pull/899#issuecomment-1646168
 */
export type QueryGetSupplyOnboardingPageTitleArgs = {
  context: ContextInput;
  propertyContext: PropertyContext;
};

/**
 * TODO:  Will remove these previous operations when Shared-UI uses the new ones with correct names
 * Duplicate of operations for correcting names based on comments in: https://github.expedia.biz/weaver/weaver-schema-stitcher/pull/899#issuecomment-1646168
 */
export type QueryGetUserInformationArgs = {
  eapid: Scalars["Int"];
  egaid: Scalars["String"];
  tpid: Scalars["Int"];
  traceId: Scalars["String"];
};

/**
 * TODO:  Will remove these previous operations when Shared-UI uses the new ones with correct names
 * Duplicate of operations for correcting names based on comments in: https://github.expedia.biz/weaver/weaver-schema-stitcher/pull/899#issuecomment-1646168
 */
export type QueryGlobalFooterArgs = {
  context: ContextInput;
  minimal?: InputMaybe<Scalars["Boolean"]>;
};

/**
 * TODO:  Will remove these previous operations when Shared-UI uses the new ones with correct names
 * Duplicate of operations for correcting names based on comments in: https://github.expedia.biz/weaver/weaver-schema-stitcher/pull/899#issuecomment-1646168
 */
export type QueryGlobalHeaderArgs = {
  context: ContextInput;
  layout?: InputMaybe<HeaderLayout>;
  lineOfBusiness?: InputMaybe<GlobalNavigationLineOfBusiness>;
  marketing?: InputMaybe<HeaderMarketingInput>;
  viewSize?: InputMaybe<HeaderViewSize>;
};

/**
 * TODO:  Will remove these previous operations when Shared-UI uses the new ones with correct names
 * Duplicate of operations for correcting names based on comments in: https://github.expedia.biz/weaver/weaver-schema-stitcher/pull/899#issuecomment-1646168
 */
export type QueryGlobalInspirationArgs = {
  locale: Scalars["String"];
  siteId: Scalars["Int"];
};

/**
 * TODO:  Will remove these previous operations when Shared-UI uses the new ones with correct names
 * Duplicate of operations for correcting names based on comments in: https://github.expedia.biz/weaver/weaver-schema-stitcher/pull/899#issuecomment-1646168
 */
export type QueryGlobalInsuranceSearchArgs = {
  context: ContextInput;
  insuranceShoppingRequest: InsuranceShoppingRequestInput;
};

/**
 * TODO:  Will remove these previous operations when Shared-UI uses the new ones with correct names
 * Duplicate of operations for correcting names based on comments in: https://github.expedia.biz/weaver/weaver-schema-stitcher/pull/899#issuecomment-1646168
 */
export type QueryGroundTransfersSearchArgs = {
  context: ContextInput;
  searchCriteria: GroundTransfersSearchCriteriaInput;
};

/**
 * TODO:  Will remove these previous operations when Shared-UI uses the new ones with correct names
 * Duplicate of operations for correcting names based on comments in: https://github.expedia.biz/weaver/weaver-schema-stitcher/pull/899#issuecomment-1646168
 */
export type QueryGuestInfoArgs = {
  bookingId: Scalars["String"];
  context: ContextInput;
  propertyContext: PropertyContext;
};

/**
 * TODO:  Will remove these previous operations when Shared-UI uses the new ones with correct names
 * Duplicate of operations for correcting names based on comments in: https://github.expedia.biz/weaver/weaver-schema-stitcher/pull/899#issuecomment-1646168
 */
export type QueryHelloCollectionApiWgcArgs = {
  context: ContextInput;
};

/**
 * TODO:  Will remove these previous operations when Shared-UI uses the new ones with correct names
 * Duplicate of operations for correcting names based on comments in: https://github.expedia.biz/weaver/weaver-schema-stitcher/pull/899#issuecomment-1646168
 */
export type QueryHelloEssSampleArgs = {
  context: ContextInput;
};

/**
 * TODO:  Will remove these previous operations when Shared-UI uses the new ones with correct names
 * Duplicate of operations for correcting names based on comments in: https://github.expedia.biz/weaver/weaver-schema-stitcher/pull/899#issuecomment-1646168
 */
export type QueryHelloGraphQlContextSampleGaiaArgs = {
  context: ContextInput;
};

/**
 * TODO:  Will remove these previous operations when Shared-UI uses the new ones with correct names
 * Duplicate of operations for correcting names based on comments in: https://github.expedia.biz/weaver/weaver-schema-stitcher/pull/899#issuecomment-1646168
 */
export type QueryHelloWithGraphQlContextArgs = {
  context: ContextInput;
};

/**
 * TODO:  Will remove these previous operations when Shared-UI uses the new ones with correct names
 * Duplicate of operations for correcting names based on comments in: https://github.expedia.biz/weaver/weaver-schema-stitcher/pull/899#issuecomment-1646168
 */
export type QueryHelloWithGraphQlContextDummyArgs = {
  context: ContextInput;
};

/**
 * TODO:  Will remove these previous operations when Shared-UI uses the new ones with correct names
 * Duplicate of operations for correcting names based on comments in: https://github.expedia.biz/weaver/weaver-schema-stitcher/pull/899#issuecomment-1646168
 */
export type QueryHelloWithGraphQlContextSampleArgs = {
  context: ContextInput;
};

/**
 * TODO:  Will remove these previous operations when Shared-UI uses the new ones with correct names
 * Duplicate of operations for correcting names based on comments in: https://github.expedia.biz/weaver/weaver-schema-stitcher/pull/899#issuecomment-1646168
 */
export type QueryHelpArticlesArgs = {
  browseKnowledgeBase: BrowseKnowledgeBaseInput;
};

/**
 * TODO:  Will remove these previous operations when Shared-UI uses the new ones with correct names
 * Duplicate of operations for correcting names based on comments in: https://github.expedia.biz/weaver/weaver-schema-stitcher/pull/899#issuecomment-1646168
 */
export type QueryIdentityLayoutArgs = {
  context: ContextInput;
  identityClientInfo?: InputMaybe<IdentityClientInfoInput>;
  layout: IdentityLayout;
};

/**
 * TODO:  Will remove these previous operations when Shared-UI uses the new ones with correct names
 * Duplicate of operations for correcting names based on comments in: https://github.expedia.biz/weaver/weaver-schema-stitcher/pull/899#issuecomment-1646168
 */
export type QueryImportantInfoArgs = {
  cartId: Scalars["String"];
  context: ContextInput;
};

/**
 * TODO:  Will remove these previous operations when Shared-UI uses the new ones with correct names
 * Duplicate of operations for correcting names based on comments in: https://github.expedia.biz/weaver/weaver-schema-stitcher/pull/899#issuecomment-1646168
 */
export type QueryIncentivesCollectionArgs = {
  collectionId: Scalars["String"];
  context: ContextInput;
  expectedCollectionType?: InputMaybe<CollectionType>;
  pageContext?: InputMaybe<PageContextInput>;
  paginationContext?: InputMaybe<PaginationContextInput>;
};

/**
 * TODO:  Will remove these previous operations when Shared-UI uses the new ones with correct names
 * Duplicate of operations for correcting names based on comments in: https://github.expedia.biz/weaver/weaver-schema-stitcher/pull/899#issuecomment-1646168
 */
export type QueryIncentivesCollectionViewArgs = {
  collectionId: Scalars["String"];
  context: ContextInput;
  pageContext?: InputMaybe<PageContextInput>;
};

/**
 * TODO:  Will remove these previous operations when Shared-UI uses the new ones with correct names
 * Duplicate of operations for correcting names based on comments in: https://github.expedia.biz/weaver/weaver-schema-stitcher/pull/899#issuecomment-1646168
 */
export type QueryIncentivesJourneyArgs = {
  context: ContextInput;
  maxItems?: InputMaybe<Scalars["Int"]>;
  placementId: Scalars["String"];
  selectedIds?: InputMaybe<Array<Scalars["String"]>>;
};

/**
 * TODO:  Will remove these previous operations when Shared-UI uses the new ones with correct names
 * Duplicate of operations for correcting names based on comments in: https://github.expedia.biz/weaver/weaver-schema-stitcher/pull/899#issuecomment-1646168
 */
export type QueryInsuranceBenefitDetailsArgs = {
  context: ContextInput;
  insuranceBenefitDetailsRequest: InsuranceBenefitDetailsQueryRequestInput;
};

/**
 * TODO:  Will remove these previous operations when Shared-UI uses the new ones with correct names
 * Duplicate of operations for correcting names based on comments in: https://github.expedia.biz/weaver/weaver-schema-stitcher/pull/899#issuecomment-1646168
 */
export type QueryInsuranceBookingOverviewArgs = {
  context: ContextInput;
  insuranceBookingOverviewRequest: InsuranceBookingOverviewRequestInput;
};

/**
 * TODO:  Will remove these previous operations when Shared-UI uses the new ones with correct names
 * Duplicate of operations for correcting names based on comments in: https://github.expedia.biz/weaver/weaver-schema-stitcher/pull/899#issuecomment-1646168
 */
export type QueryInsuranceBookingOverviewErrorArgs = {
  context: ContextInput;
};

/**
 * TODO:  Will remove these previous operations when Shared-UI uses the new ones with correct names
 * Duplicate of operations for correcting names based on comments in: https://github.expedia.biz/weaver/weaver-schema-stitcher/pull/899#issuecomment-1646168
 */
export type QueryInsuranceClaimDetailsArgs = {
  context: ContextInput;
  insuranceClaimDetailsRequest: InsuranceClaimDetailsRequestInput;
};

/**
 * TODO:  Will remove these previous operations when Shared-UI uses the new ones with correct names
 * Duplicate of operations for correcting names based on comments in: https://github.expedia.biz/weaver/weaver-schema-stitcher/pull/899#issuecomment-1646168
 */
export type QueryInsuranceDetailPrimingArgs = {
  context: ContextInput;
  insuranceDetailPrimingRequest: InsuranceDetailPrimingRequestInput;
};

/**
 * TODO:  Will remove these previous operations when Shared-UI uses the new ones with correct names
 * Duplicate of operations for correcting names based on comments in: https://github.expedia.biz/weaver/weaver-schema-stitcher/pull/899#issuecomment-1646168
 */
export type QueryInsuranceFileAClaimArgs = {
  context: ContextInput;
  insuranceFileAClaimRequest: InsuranceFileAClaimRequestInput;
};

/**
 * TODO:  Will remove these previous operations when Shared-UI uses the new ones with correct names
 * Duplicate of operations for correcting names based on comments in: https://github.expedia.biz/weaver/weaver-schema-stitcher/pull/899#issuecomment-1646168
 */
export type QueryInsuranceSearchArgs = {
  context: ContextInput;
  insuranceShoppingRequest: InsuranceShoppingRequestInput;
};

/**
 * TODO:  Will remove these previous operations when Shared-UI uses the new ones with correct names
 * Duplicate of operations for correcting names based on comments in: https://github.expedia.biz/weaver/weaver-schema-stitcher/pull/899#issuecomment-1646168
 */
export type QueryInteractionListArgs = {
  context: ContextInput;
  filterInput?: InputMaybe<SupplyReservationsInteractionsFilterInput>;
  paginationInput?: InputMaybe<SupplyReservationInteractionPageInput>;
  propertyContext?: InputMaybe<PropertyContext>;
  searchInput?: InputMaybe<Scalars["String"]>;
};

/**
 * TODO:  Will remove these previous operations when Shared-UI uses the new ones with correct names
 * Duplicate of operations for correcting names based on comments in: https://github.expedia.biz/weaver/weaver-schema-stitcher/pull/899#issuecomment-1646168
 */
export type QueryLegacyWidgetArgs = {
  context: ContextInput;
};

/**
 * TODO:  Will remove these previous operations when Shared-UI uses the new ones with correct names
 * Duplicate of operations for correcting names based on comments in: https://github.expedia.biz/weaver/weaver-schema-stitcher/pull/899#issuecomment-1646168
 */
export type QueryLegalArgs = {
  cartId?: InputMaybe<Scalars["String"]>;
  context: ContextInput;
  dialogId?: InputMaybe<Scalars["String"]>;
  entityId?: InputMaybe<Scalars["String"]>;
  messageId?: InputMaybe<Scalars["String"]>;
  tripId?: InputMaybe<Scalars["String"]>;
};

/**
 * TODO:  Will remove these previous operations when Shared-UI uses the new ones with correct names
 * Duplicate of operations for correcting names based on comments in: https://github.expedia.biz/weaver/weaver-schema-stitcher/pull/899#issuecomment-1646168
 */
export type QueryLocalePreferencesArgs = {
  context: ContextInput;
  lineOfBusiness?: InputMaybe<GlobalNavigationLineOfBusiness>;
  pickerTriggerPlacementType?: InputMaybe<PickerTriggerPlacementType>;
  selectedSiteId?: InputMaybe<Scalars["Int"]>;
};

/**
 * TODO:  Will remove these previous operations when Shared-UI uses the new ones with correct names
 * Duplicate of operations for correcting names based on comments in: https://github.expedia.biz/weaver/weaver-schema-stitcher/pull/899#issuecomment-1646168
 */
export type QueryLodgingDestinationArgs = {
  context: ContextInput;
  destination: DestinationInput;
  filters: PropertySearchFiltersInput;
};

/**
 * TODO:  Will remove these previous operations when Shared-UI uses the new ones with correct names
 * Duplicate of operations for correcting names based on comments in: https://github.expedia.biz/weaver/weaver-schema-stitcher/pull/899#issuecomment-1646168
 */
export type QueryLodgingTravelPledgeSearchSortAndFilterArgs = {
  context: ContextInput;
};

/**
 * TODO:  Will remove these previous operations when Shared-UI uses the new ones with correct names
 * Duplicate of operations for correcting names based on comments in: https://github.expedia.biz/weaver/weaver-schema-stitcher/pull/899#issuecomment-1646168
 */
export type QueryLodgingTravelPledgesArgs = {
  context: ContextInput;
  criteria?: InputMaybe<ShoppingSearchCriteriaInput>;
  filter?: InputMaybe<LodgingTravelPledgeFilterInput>;
};

/**
 * TODO:  Will remove these previous operations when Shared-UI uses the new ones with correct names
 * Duplicate of operations for correcting names based on comments in: https://github.expedia.biz/weaver/weaver-schema-stitcher/pull/899#issuecomment-1646168
 */
export type QueryLoyaltyArgs = {
  context: ContextInput;
};

/**
 * TODO:  Will remove these previous operations when Shared-UI uses the new ones with correct names
 * Duplicate of operations for correcting names based on comments in: https://github.expedia.biz/weaver/weaver-schema-stitcher/pull/899#issuecomment-1646168
 */
export type QueryLoyaltyAccountStatusDetailsArgs = {
  context: ContextInput;
};

/**
 * TODO:  Will remove these previous operations when Shared-UI uses the new ones with correct names
 * Duplicate of operations for correcting names based on comments in: https://github.expedia.biz/weaver/weaver-schema-stitcher/pull/899#issuecomment-1646168
 */
export type QueryLoyaltyEarnCalculationDetailsArgs = {
  context: ContextInput;
  loyaltyDomainId: Scalars["String"];
};

/**
 * TODO:  Will remove these previous operations when Shared-UI uses the new ones with correct names
 * Duplicate of operations for correcting names based on comments in: https://github.expedia.biz/weaver/weaver-schema-stitcher/pull/899#issuecomment-1646168
 */
export type QueryMemberWalletArgs = {
  context: ContextInput;
};

/**
 * TODO:  Will remove these previous operations when Shared-UI uses the new ones with correct names
 * Duplicate of operations for correcting names based on comments in: https://github.expedia.biz/weaver/weaver-schema-stitcher/pull/899#issuecomment-1646168
 */
export type QueryMembersOnlyDealsTiersArgs = {
  propertyContext: PropertyContext;
};

/**
 * TODO:  Will remove these previous operations when Shared-UI uses the new ones with correct names
 * Duplicate of operations for correcting names based on comments in: https://github.expedia.biz/weaver/weaver-schema-stitcher/pull/899#issuecomment-1646168
 */
export type QueryMerchCouponsArgs = {
  context: ContextInput;
  couponIds: Array<Scalars["String"]>;
};

/**
 * TODO:  Will remove these previous operations when Shared-UI uses the new ones with correct names
 * Duplicate of operations for correcting names based on comments in: https://github.expedia.biz/weaver/weaver-schema-stitcher/pull/899#issuecomment-1646168
 */
export type QueryMobilityProductReviewArgs = {
  pageState: PageState;
};

/**
 * TODO:  Will remove these previous operations when Shared-UI uses the new ones with correct names
 * Duplicate of operations for correcting names based on comments in: https://github.expedia.biz/weaver/weaver-schema-stitcher/pull/899#issuecomment-1646168
 */
export type QueryMobilityProductSearchArgs = {
  searchState: PageState;
};

/**
 * TODO:  Will remove these previous operations when Shared-UI uses the new ones with correct names
 * Duplicate of operations for correcting names based on comments in: https://github.expedia.biz/weaver/weaver-schema-stitcher/pull/899#issuecomment-1646168
 */
export type QueryMultiItemStepIndicatorArgs = {
  context: ContextInput;
  journeyContinuationId?: InputMaybe<Scalars["String"]>;
  lockupPrice?: InputMaybe<MoneyInput>;
  multiItemPriceToken?: InputMaybe<Scalars["String"]>;
  multiItemSessionId?: InputMaybe<Scalars["String"]>;
  originalBookingId?: InputMaybe<Scalars["String"]>;
  savingsPrice?: InputMaybe<MoneyInput>;
};

/**
 * TODO:  Will remove these previous operations when Shared-UI uses the new ones with correct names
 * Duplicate of operations for correcting names based on comments in: https://github.expedia.biz/weaver/weaver-schema-stitcher/pull/899#issuecomment-1646168
 */
export type QueryNearbyAirportsSuggestionArgs = {
  context: ContextInput;
  sessionId: Scalars["String"];
};

/**
 * TODO:  Will remove these previous operations when Shared-UI uses the new ones with correct names
 * Duplicate of operations for correcting names based on comments in: https://github.expedia.biz/weaver/weaver-schema-stitcher/pull/899#issuecomment-1646168
 */
export type QueryNotificationArgs = {
  context: ContextInput;
};

/**
 * TODO:  Will remove these previous operations when Shared-UI uses the new ones with correct names
 * Duplicate of operations for correcting names based on comments in: https://github.expedia.biz/weaver/weaver-schema-stitcher/pull/899#issuecomment-1646168
 */
export type QueryOffersListingArgs = {
  context: ContextInput;
  offerToken: Scalars["String"];
};

/**
 * TODO:  Will remove these previous operations when Shared-UI uses the new ones with correct names
 * Duplicate of operations for correcting names based on comments in: https://github.expedia.biz/weaver/weaver-schema-stitcher/pull/899#issuecomment-1646168
 */
export type QueryOffersRecommendationByProductArgs = {
  containerType?: InputMaybe<OffersRecommendationContainerType>;
  context: ContextInput;
  productId: Scalars["String"];
  productLine: LineOfBusinessDomain;
  strategy?: InputMaybe<OffersRecommendationStrategy>;
};

/**
 * TODO:  Will remove these previous operations when Shared-UI uses the new ones with correct names
 * Duplicate of operations for correcting names based on comments in: https://github.expedia.biz/weaver/weaver-schema-stitcher/pull/899#issuecomment-1646168
 */
export type QueryOnboardingPropertyRatesExperienceArgs = {
  context: ContextInput;
  propertyContext: PropertyContext;
};

/**
 * TODO:  Will remove these previous operations when Shared-UI uses the new ones with correct names
 * Duplicate of operations for correcting names based on comments in: https://github.expedia.biz/weaver/weaver-schema-stitcher/pull/899#issuecomment-1646168
 */
export type QueryOneKeyLoyaltyBannerArgs = {
  context: ContextInput;
  lineOfBusiness: LineOfBusinessDomain;
  pageLocation: PageLocation;
  useLoyaltyCurrency?: InputMaybe<Scalars["Boolean"]>;
};

/**
 * TODO:  Will remove these previous operations when Shared-UI uses the new ones with correct names
 * Duplicate of operations for correcting names based on comments in: https://github.expedia.biz/weaver/weaver-schema-stitcher/pull/899#issuecomment-1646168
 */
export type QueryPackageDestinationArgs = {
  context: ContextInput;
  regionId: Scalars["String"];
};

/**
 * TODO:  Will remove these previous operations when Shared-UI uses the new ones with correct names
 * Duplicate of operations for correcting names based on comments in: https://github.expedia.biz/weaver/weaver-schema-stitcher/pull/899#issuecomment-1646168
 */
export type QueryPackageDetailsArgs = {
  context: ContextInput;
};

/**
 * TODO:  Will remove these previous operations when Shared-UI uses the new ones with correct names
 * Duplicate of operations for correcting names based on comments in: https://github.expedia.biz/weaver/weaver-schema-stitcher/pull/899#issuecomment-1646168
 */
export type QueryPackagePrimersArgs = {
  context: ContextInput;
};

/**
 * TODO:  Will remove these previous operations when Shared-UI uses the new ones with correct names
 * Duplicate of operations for correcting names based on comments in: https://github.expedia.biz/weaver/weaver-schema-stitcher/pull/899#issuecomment-1646168
 */
export type QueryPassportsFormArgs = {
  context: ContextInput;
  formContext?: InputMaybe<Scalars["String"]>;
};

/**
 * TODO:  Will remove these previous operations when Shared-UI uses the new ones with correct names
 * Duplicate of operations for correcting names based on comments in: https://github.expedia.biz/weaver/weaver-schema-stitcher/pull/899#issuecomment-1646168
 */
export type QueryPasswordResetArgs = {
  context: ContextInput;
  eapid: Scalars["Int"];
  egaid: Scalars["String"];
  tpid: Scalars["Int"];
  traceId: Scalars["String"];
};

/**
 * TODO:  Will remove these previous operations when Shared-UI uses the new ones with correct names
 * Duplicate of operations for correcting names based on comments in: https://github.expedia.biz/weaver/weaver-schema-stitcher/pull/899#issuecomment-1646168
 */
export type QueryPasswordStrengthMeterArgs = {
  context: ContextInput;
};

/**
 * TODO:  Will remove these previous operations when Shared-UI uses the new ones with correct names
 * Duplicate of operations for correcting names based on comments in: https://github.expedia.biz/weaver/weaver-schema-stitcher/pull/899#issuecomment-1646168
 */
export type QueryPasswordUpdatedArgs = {
  brand: Scalars["String"];
  context: ContextInput;
  egaid: Scalars["String"];
  traceId: Scalars["String"];
};

/**
 * TODO:  Will remove these previous operations when Shared-UI uses the new ones with correct names
 * Duplicate of operations for correcting names based on comments in: https://github.expedia.biz/weaver/weaver-schema-stitcher/pull/899#issuecomment-1646168
 */
export type QueryPaymentDetailsArgs = {
  bookingId: Scalars["String"];
  context: ContextInput;
  propertyContext: PropertyContext;
};

/**
 * TODO:  Will remove these previous operations when Shared-UI uses the new ones with correct names
 * Duplicate of operations for correcting names based on comments in: https://github.expedia.biz/weaver/weaver-schema-stitcher/pull/899#issuecomment-1646168
 */
export type QueryPaymentModuleArgs = {
  paymentSessionId: Scalars["String"];
};

/**
 * TODO:  Will remove these previous operations when Shared-UI uses the new ones with correct names
 * Duplicate of operations for correcting names based on comments in: https://github.expedia.biz/weaver/weaver-schema-stitcher/pull/899#issuecomment-1646168
 */
export type QueryPaymentModuleCardInfoArgs = {
  cardIssueBankNumber: Scalars["String"];
};

/**
 * TODO:  Will remove these previous operations when Shared-UI uses the new ones with correct names
 * Duplicate of operations for correcting names based on comments in: https://github.expedia.biz/weaver/weaver-schema-stitcher/pull/899#issuecomment-1646168
 */
export type QueryPersonalInfoFormArgs = {
  context: ContextInput;
};

/**
 * TODO:  Will remove these previous operations when Shared-UI uses the new ones with correct names
 * Duplicate of operations for correcting names based on comments in: https://github.expedia.biz/weaver/weaver-schema-stitcher/pull/899#issuecomment-1646168
 */
export type QueryPersonalizedOffersRecommendationArgs = {
  context: ContextInput;
};

/**
 * TODO:  Will remove these previous operations when Shared-UI uses the new ones with correct names
 * Duplicate of operations for correcting names based on comments in: https://github.expedia.biz/weaver/weaver-schema-stitcher/pull/899#issuecomment-1646168
 */
export type QueryPreBundledPackageSearchArgs = {
  context: ContextInput;
  searchCriteria: PackageSearchCriteriaInput;
  sort?: InputMaybe<PackageSort>;
};

/**
 * TODO:  Will remove these previous operations when Shared-UI uses the new ones with correct names
 * Duplicate of operations for correcting names based on comments in: https://github.expedia.biz/weaver/weaver-schema-stitcher/pull/899#issuecomment-1646168
 */
export type QueryPreBundledPackageSearchEntryArgs = {
  context: ContextInput;
  sessionId: Scalars["String"];
};

/**
 * TODO:  Will remove these previous operations when Shared-UI uses the new ones with correct names
 * Duplicate of operations for correcting names based on comments in: https://github.expedia.biz/weaver/weaver-schema-stitcher/pull/899#issuecomment-1646168
 */
export type QueryPreBundledPackageSearchFormArgs = {
  context: ContextInput;
  searchCriteria: PackageSearchCriteriaInput;
};

/**
 * TODO:  Will remove these previous operations when Shared-UI uses the new ones with correct names
 * Duplicate of operations for correcting names based on comments in: https://github.expedia.biz/weaver/weaver-schema-stitcher/pull/899#issuecomment-1646168
 */
export type QueryPriceDetailsArgs = {
  cartId?: InputMaybe<Scalars["String"]>;
  context: ContextInput;
  entityToken?: InputMaybe<Scalars["String"]>;
  orderId?: InputMaybe<Scalars["String"]>;
};

/**
 * TODO:  Will remove these previous operations when Shared-UI uses the new ones with correct names
 * Duplicate of operations for correcting names based on comments in: https://github.expedia.biz/weaver/weaver-schema-stitcher/pull/899#issuecomment-1646168
 */
export type QueryPriceInsightsArgs = {
  context: ContextInput;
};

/**
 * TODO:  Will remove these previous operations when Shared-UI uses the new ones with correct names
 * Duplicate of operations for correcting names based on comments in: https://github.expedia.biz/weaver/weaver-schema-stitcher/pull/899#issuecomment-1646168
 */
export type QueryPriceMatchPromiseArgs = {
  context: ContextInput;
  tripNumber: Scalars["String"];
};

/**
 * TODO:  Will remove these previous operations when Shared-UI uses the new ones with correct names
 * Duplicate of operations for correcting names based on comments in: https://github.expedia.biz/weaver/weaver-schema-stitcher/pull/899#issuecomment-1646168
 */
export type QueryProductDetailsArgs = {
  context: ContextInput;
  entityToken: Scalars["String"];
  productLine?: InputMaybe<Scalars["String"]>;
};

/**
 * TODO:  Will remove these previous operations when Shared-UI uses the new ones with correct names
 * Duplicate of operations for correcting names based on comments in: https://github.expedia.biz/weaver/weaver-schema-stitcher/pull/899#issuecomment-1646168
 */
export type QueryProductDetailsTempArgs = {
  context: ContextInput;
  productIds: Array<Scalars["String"]>;
};

/**
 * TODO:  Will remove these previous operations when Shared-UI uses the new ones with correct names
 * Duplicate of operations for correcting names based on comments in: https://github.expedia.biz/weaver/weaver-schema-stitcher/pull/899#issuecomment-1646168
 */
export type QueryProductListingCarouselsArgs = {
  context: ContextInput;
  criteria: PropertySearchCriteriaInput;
};

/**
 * TODO:  Will remove these previous operations when Shared-UI uses the new ones with correct names
 * Duplicate of operations for correcting names based on comments in: https://github.expedia.biz/weaver/weaver-schema-stitcher/pull/899#issuecomment-1646168
 */
export type QueryProductQuestionsArgs = {
  context: ContextInput;
  filters?: InputMaybe<ProductQuestionFiltersInput>;
  productId: Scalars["String"];
  productQuestionTopic: ProductQuestionTopic;
  questionPagination?: InputMaybe<PaginationInput>;
  sort?: InputMaybe<QuestionSortType>;
};

/**
 * TODO:  Will remove these previous operations when Shared-UI uses the new ones with correct names
 * Duplicate of operations for correcting names based on comments in: https://github.expedia.biz/weaver/weaver-schema-stitcher/pull/899#issuecomment-1646168
 */
export type QueryProductSummaryArgs = {
  context: ContextInput;
  productSummaryInput: ProductSummaryInput;
};

/**
 * TODO:  Will remove these previous operations when Shared-UI uses the new ones with correct names
 * Duplicate of operations for correcting names based on comments in: https://github.expedia.biz/weaver/weaver-schema-stitcher/pull/899#issuecomment-1646168
 */
export type QueryProfileChangedArgs = {
  brand: Scalars["String"];
  context: ContextInput;
  egaid: Scalars["String"];
  traceId: Scalars["String"];
};

/**
 * TODO:  Will remove these previous operations when Shared-UI uses the new ones with correct names
 * Duplicate of operations for correcting names based on comments in: https://github.expedia.biz/weaver/weaver-schema-stitcher/pull/899#issuecomment-1646168
 */
export type QueryPropertyAlternateDateSearchArgs = {
  context: ContextInput;
  dateRange?: InputMaybe<PropertyDateRangeInput>;
  destination: DestinationInput;
  filters?: InputMaybe<PropertySearchFiltersInput>;
  marketing?: InputMaybe<PropertyMarketingInfoInput>;
  rooms?: InputMaybe<Array<RoomInput>>;
  searchOptions?: InputMaybe<Array<PropertySearchOptions>>;
  sort?: InputMaybe<PropertySort>;
};

/**
 * TODO:  Will remove these previous operations when Shared-UI uses the new ones with correct names
 * Duplicate of operations for correcting names based on comments in: https://github.expedia.biz/weaver/weaver-schema-stitcher/pull/899#issuecomment-1646168
 */
export type QueryPropertyAvailabilityCalendarsArgs = {
  context?: InputMaybe<ContextInput>;
  dateRange?: InputMaybe<DateRangeInput>;
  eid: Scalars["ID"];
};

/**
 * TODO:  Will remove these previous operations when Shared-UI uses the new ones with correct names
 * Duplicate of operations for correcting names based on comments in: https://github.expedia.biz/weaver/weaver-schema-stitcher/pull/899#issuecomment-1646168
 */
export type QueryPropertyFilterArgs = {
  context: ContextInput;
  currentPageContext?: InputMaybe<SupplyCurrentPageContext>;
  propertyContext?: InputMaybe<PropertyContext>;
};

/**
 * TODO:  Will remove these previous operations when Shared-UI uses the new ones with correct names
 * Duplicate of operations for correcting names based on comments in: https://github.expedia.biz/weaver/weaver-schema-stitcher/pull/899#issuecomment-1646168
 */
export type QueryPropertyInfoArgs = {
  context: ContextInput;
  offerOptions?: InputMaybe<Array<PropertyInfoOptions>>;
  propertyId: Scalars["String"];
  referrer?: InputMaybe<Scalars["String"]>;
  shoppingContext?: InputMaybe<ShoppingContextInput>;
};

/**
 * TODO:  Will remove these previous operations when Shared-UI uses the new ones with correct names
 * Duplicate of operations for correcting names based on comments in: https://github.expedia.biz/weaver/weaver-schema-stitcher/pull/899#issuecomment-1646168
 */
export type QueryPropertyOffersArgs = {
  context: ContextInput;
  marketing?: InputMaybe<PropertyMarketingInfoInput>;
  propertyId: Scalars["String"];
  referrer?: InputMaybe<Scalars["String"]>;
  searchCriteria?: InputMaybe<PropertySearchCriteriaInput>;
  searchOffer?: InputMaybe<SearchOfferInput>;
  shoppingContext?: InputMaybe<ShoppingContextInput>;
  travelAdTrackingInfo?: InputMaybe<PropertyTravelAdTrackingInfoInput>;
};

/**
 * TODO:  Will remove these previous operations when Shared-UI uses the new ones with correct names
 * Duplicate of operations for correcting names based on comments in: https://github.expedia.biz/weaver/weaver-schema-stitcher/pull/899#issuecomment-1646168
 */
export type QueryPropertyPoiContentArgs = {
  context: ContextInput;
  poiIDs: Scalars["String"];
};

/**
 * TODO:  Will remove these previous operations when Shared-UI uses the new ones with correct names
 * Duplicate of operations for correcting names based on comments in: https://github.expedia.biz/weaver/weaver-schema-stitcher/pull/899#issuecomment-1646168
 */
export type QueryPropertyReviewArgs = {
  context: ContextInput;
  id: Scalars["String"];
  locale?: InputMaybe<Scalars["Locale"]>;
};

/**
 * TODO:  Will remove these previous operations when Shared-UI uses the new ones with correct names
 * Duplicate of operations for correcting names based on comments in: https://github.expedia.biz/weaver/weaver-schema-stitcher/pull/899#issuecomment-1646168
 */
export type QueryPropertyReviewAggregatesArgs = {
  context: ContextInput;
  propertyIds: Array<Scalars["String"]>;
};

/**
 * TODO:  Will remove these previous operations when Shared-UI uses the new ones with correct names
 * Duplicate of operations for correcting names based on comments in: https://github.expedia.biz/weaver/weaver-schema-stitcher/pull/899#issuecomment-1646168
 */
export type QueryPropertyReviewInfoArgs = {
  context: ContextInput;
  propertyId: Scalars["String"];
  propertyName?: InputMaybe<Scalars["String"]>;
  searchCriteria?: InputMaybe<PropertySearchCriteriaInput>;
};

/**
 * TODO:  Will remove these previous operations when Shared-UI uses the new ones with correct names
 * Duplicate of operations for correcting names based on comments in: https://github.expedia.biz/weaver/weaver-schema-stitcher/pull/899#issuecomment-1646168
 */
export type QueryPropertyReviewSummariesArgs = {
  context: ContextInput;
  propertyIds: Array<Scalars["String"]>;
  searchCriteria?: InputMaybe<PropertySearchCriteriaInput>;
};

/**
 * TODO:  Will remove these previous operations when Shared-UI uses the new ones with correct names
 * Duplicate of operations for correcting names based on comments in: https://github.expedia.biz/weaver/weaver-schema-stitcher/pull/899#issuecomment-1646168
 */
export type QueryPropertySearchArgs = {
  context: ContextInput;
  criteria?: InputMaybe<PropertySearchCriteriaInput>;
  dateRange?: InputMaybe<PropertyDateRangeInput>;
  destination: DestinationInput;
  filters?: InputMaybe<PropertySearchFiltersInput>;
  legacyCriteria?: InputMaybe<LegacyPropertySearchCriteriaInput>;
  marketing?: InputMaybe<PropertyMarketingInfoInput>;
  propertyShopOptions?: InputMaybe<PropertyShopOptionsInput>;
  pwaLegacySort?: InputMaybe<Scalars["String"]>;
  returnPropertyType?: InputMaybe<Scalars["Boolean"]>;
  rooms?: InputMaybe<Array<RoomInput>>;
  searchIntent?: InputMaybe<SearchIntentInput>;
  searchOptions?: InputMaybe<Array<PropertySearchOptions>>;
  searchPagination?: InputMaybe<PaginationInput>;
  shoppingContext?: InputMaybe<ShoppingContextInput>;
  sort?: InputMaybe<PropertySort>;
};

/**
 * TODO:  Will remove these previous operations when Shared-UI uses the new ones with correct names
 * Duplicate of operations for correcting names based on comments in: https://github.expedia.biz/weaver/weaver-schema-stitcher/pull/899#issuecomment-1646168
 */
export type QueryPropertyTopReviewsArgs = {
  context: ContextInput;
  propertyId: Scalars["String"];
  searchCriteria?: InputMaybe<PropertySearchCriteriaInput>;
};

/**
 * TODO:  Will remove these previous operations when Shared-UI uses the new ones with correct names
 * Duplicate of operations for correcting names based on comments in: https://github.expedia.biz/weaver/weaver-schema-stitcher/pull/899#issuecomment-1646168
 */
export type QueryPropertyUnitReviewSummariesArgs = {
  context: ContextInput;
  propertyIds: Array<Scalars["String"]>;
};

/**
 * TODO:  Will remove these previous operations when Shared-UI uses the new ones with correct names
 * Duplicate of operations for correcting names based on comments in: https://github.expedia.biz/weaver/weaver-schema-stitcher/pull/899#issuecomment-1646168
 */
export type QueryQualtricsConfigArgs = {
  context: ContextInput;
};

/**
 * TODO:  Will remove these previous operations when Shared-UI uses the new ones with correct names
 * Duplicate of operations for correcting names based on comments in: https://github.expedia.biz/weaver/weaver-schema-stitcher/pull/899#issuecomment-1646168
 */
export type QueryReasonsToBelieveArgs = {
  locale: Scalars["String"];
  siteId: Scalars["Int"];
};

/**
 * TODO:  Will remove these previous operations when Shared-UI uses the new ones with correct names
 * Duplicate of operations for correcting names based on comments in: https://github.expedia.biz/weaver/weaver-schema-stitcher/pull/899#issuecomment-1646168
 */
export type QueryRecentlyViewedPropertiesCarouselArgs = {
  context: ContextInput;
  criteria?: InputMaybe<PropertySearchCriteriaInput>;
};

/**
 * TODO:  Will remove these previous operations when Shared-UI uses the new ones with correct names
 * Duplicate of operations for correcting names based on comments in: https://github.expedia.biz/weaver/weaver-schema-stitcher/pull/899#issuecomment-1646168
 */
export type QueryRentalAgreementArgs = {
  bookingId: Scalars["String"];
  context: ContextInput;
  propertyContext: PropertyContext;
};

/**
 * TODO:  Will remove these previous operations when Shared-UI uses the new ones with correct names
 * Duplicate of operations for correcting names based on comments in: https://github.expedia.biz/weaver/weaver-schema-stitcher/pull/899#issuecomment-1646168
 */
export type QueryRequestContextArgs = {
  clientRequest: ClientRequestInput;
};

/**
 * TODO:  Will remove these previous operations when Shared-UI uses the new ones with correct names
 * Duplicate of operations for correcting names based on comments in: https://github.expedia.biz/weaver/weaver-schema-stitcher/pull/899#issuecomment-1646168
 */
export type QueryRetailTravelAgentNotificationCenterArgs = {
  context: ContextInput;
};

/**
 * TODO:  Will remove these previous operations when Shared-UI uses the new ones with correct names
 * Duplicate of operations for correcting names based on comments in: https://github.expedia.biz/weaver/weaver-schema-stitcher/pull/899#issuecomment-1646168
 */
export type QueryReviewQuestionsArgs = {
  context: ContextInput;
  orderId: Scalars["String"];
  orderLineId: Scalars["String"];
};

/**
 * TODO:  Will remove these previous operations when Shared-UI uses the new ones with correct names
 * Duplicate of operations for correcting names based on comments in: https://github.expedia.biz/weaver/weaver-schema-stitcher/pull/899#issuecomment-1646168
 */
export type QueryRewardProgramsFormArgs = {
  context: ContextInput;
  formContext?: InputMaybe<Scalars["String"]>;
};

/**
 * TODO:  Will remove these previous operations when Shared-UI uses the new ones with correct names
 * Duplicate of operations for correcting names based on comments in: https://github.expedia.biz/weaver/weaver-schema-stitcher/pull/899#issuecomment-1646168
 */
export type QueryRulesAndRestrictionsArgs = {
  context: ContextInput;
  policySearchCriteria: PolicySearchCriteriaInput;
};

/**
 * TODO:  Will remove these previous operations when Shared-UI uses the new ones with correct names
 * Duplicate of operations for correcting names based on comments in: https://github.expedia.biz/weaver/weaver-schema-stitcher/pull/899#issuecomment-1646168
 */
export type QuerySailingDealsArgs = {
  context?: InputMaybe<ContextInput>;
  cruiseRequestContextInput?: InputMaybe<CruiseRequestContextInput>;
  cruiseSearchFiltersInput?: InputMaybe<CruiseSearchFiltersInput>;
  cruiseSearchOptionsInput: CruiseSearchOptionsInput;
};

/**
 * TODO:  Will remove these previous operations when Shared-UI uses the new ones with correct names
 * Duplicate of operations for correcting names based on comments in: https://github.expedia.biz/weaver/weaver-schema-stitcher/pull/899#issuecomment-1646168
 */
export type QuerySailingDetailsArgs = {
  adults: Scalars["Int"];
  children: Scalars["Int"];
  context: ContextInput;
  cruiseRequestContextInput: CruiseRequestContextInput;
  sailingToken: Scalars["String"];
};

/**
 * TODO:  Will remove these previous operations when Shared-UI uses the new ones with correct names
 * Duplicate of operations for correcting names based on comments in: https://github.expedia.biz/weaver/weaver-schema-stitcher/pull/899#issuecomment-1646168
 */
export type QuerySailingOffersArgs = {
  adultCount: Scalars["Int"];
  cabinExperience?: InputMaybe<Scalars["String"]>;
  childAges?: InputMaybe<Array<CruiseChildInput>>;
  childCount: Scalars["Int"];
  context: ContextInput;
  cruiseRequestContextInput: CruiseRequestContextInput;
  sailingToken: Scalars["String"];
};

/**
 * TODO:  Will remove these previous operations when Shared-UI uses the new ones with correct names
 * Duplicate of operations for correcting names based on comments in: https://github.expedia.biz/weaver/weaver-schema-stitcher/pull/899#issuecomment-1646168
 */
export type QuerySearchAirlineCreditsArgs = {
  searchState: PageState;
};

/**
 * TODO:  Will remove these previous operations when Shared-UI uses the new ones with correct names
 * Duplicate of operations for correcting names based on comments in: https://github.expedia.biz/weaver/weaver-schema-stitcher/pull/899#issuecomment-1646168
 */
export type QuerySearchFormArgs = {
  context: ContextInput;
};

/**
 * TODO:  Will remove these previous operations when Shared-UI uses the new ones with correct names
 * Duplicate of operations for correcting names based on comments in: https://github.expedia.biz/weaver/weaver-schema-stitcher/pull/899#issuecomment-1646168
 */
export type QuerySearchHelpArticlesArgs = {
  context: ContextInput;
};

/**
 * TODO:  Will remove these previous operations when Shared-UI uses the new ones with correct names
 * Duplicate of operations for correcting names based on comments in: https://github.expedia.biz/weaver/weaver-schema-stitcher/pull/899#issuecomment-1646168
 */
export type QueryShopInsurtechOffersArgs = {
  context: ContextInput;
  shopInsurtechOffersRequest: ShopInsurtechOffersRequestInput;
};

/**
 * TODO:  Will remove these previous operations when Shared-UI uses the new ones with correct names
 * Duplicate of operations for correcting names based on comments in: https://github.expedia.biz/weaver/weaver-schema-stitcher/pull/899#issuecomment-1646168
 */
export type QueryShoppingPathPrimersArgs = {
  context: ContextInput;
  multiItemPriceToken?: InputMaybe<Scalars["String"]>;
  multiItemSessionId: Scalars["String"];
  recoveryNaturalKeys?: InputMaybe<MishopRecoveryNaturalKeysInput>;
};

/**
 * TODO:  Will remove these previous operations when Shared-UI uses the new ones with correct names
 * Duplicate of operations for correcting names based on comments in: https://github.expedia.biz/weaver/weaver-schema-stitcher/pull/899#issuecomment-1646168
 */
export type QueryShortlistArgs = {
  context: ContextInput;
};

/**
 * TODO:  Will remove these previous operations when Shared-UI uses the new ones with correct names
 * Duplicate of operations for correcting names based on comments in: https://github.expedia.biz/weaver/weaver-schema-stitcher/pull/899#issuecomment-1646168
 */
export type QuerySimilarPropertiesDealsArgs = {
  campaignParameters: CampaignParametersInput;
  context: ContextInput;
};

/**
 * TODO:  Will remove these previous operations when Shared-UI uses the new ones with correct names
 * Duplicate of operations for correcting names based on comments in: https://github.expedia.biz/weaver/weaver-schema-stitcher/pull/899#issuecomment-1646168
 */
export type QuerySiteConfigurationsArgs = {
  request: SiteConfigurationsRequestInput;
};

/**
 * TODO:  Will remove these previous operations when Shared-UI uses the new ones with correct names
 * Duplicate of operations for correcting names based on comments in: https://github.expedia.biz/weaver/weaver-schema-stitcher/pull/899#issuecomment-1646168
 */
export type QuerySmartFormArgs = {
  context: ContextInput;
  sessionId: Scalars["String"];
};

/**
 * TODO:  Will remove these previous operations when Shared-UI uses the new ones with correct names
 * Duplicate of operations for correcting names based on comments in: https://github.expedia.biz/weaver/weaver-schema-stitcher/pull/899#issuecomment-1646168
 */
export type QuerySoftAccountCreationArgs = {
  brand: Scalars["String"];
  context: ContextInput;
  egaid: Scalars["String"];
  traceId: Scalars["String"];
};

/**
 * TODO:  Will remove these previous operations when Shared-UI uses the new ones with correct names
 * Duplicate of operations for correcting names based on comments in: https://github.expedia.biz/weaver/weaver-schema-stitcher/pull/899#issuecomment-1646168
 */
export type QuerySoftAccountCreationCheckListArgs = {
  brand: Scalars["String"];
  context: ContextInput;
  egaid: Scalars["String"];
  traceId: Scalars["String"];
};

/**
 * TODO:  Will remove these previous operations when Shared-UI uses the new ones with correct names
 * Duplicate of operations for correcting names based on comments in: https://github.expedia.biz/weaver/weaver-schema-stitcher/pull/899#issuecomment-1646168
 */
export type QuerySponsoredPropertiesCarouselArgs = {
  context: ContextInput;
  criteria?: InputMaybe<PropertySearchCriteriaInput>;
};

/**
 * TODO:  Will remove these previous operations when Shared-UI uses the new ones with correct names
 * Duplicate of operations for correcting names based on comments in: https://github.expedia.biz/weaver/weaver-schema-stitcher/pull/899#issuecomment-1646168
 */
export type QueryStaticMultiItemCrossSellArgs = {
  context: ContextInput;
  crossSellProduct: CrossSellProductType;
  searchContext: MultiItemSearchContextInput;
};

/**
 * TODO:  Will remove these previous operations when Shared-UI uses the new ones with correct names
 * Duplicate of operations for correcting names based on comments in: https://github.expedia.biz/weaver/weaver-schema-stitcher/pull/899#issuecomment-1646168
 */
export type QueryStepReviewInlineEditingSheetArgs = {
  context: ContextInput;
  propertyContext: PropertyContext;
};

/**
 * TODO:  Will remove these previous operations when Shared-UI uses the new ones with correct names
 * Duplicate of operations for correcting names based on comments in: https://github.expedia.biz/weaver/weaver-schema-stitcher/pull/899#issuecomment-1646168
 */
export type QuerySupplyAmenitiesGroupArgs = {
  context: ContextInput;
  input: SupplyAmenitiesGroupInput;
  propertyContext: PropertyContext;
};

/**
 * TODO:  Will remove these previous operations when Shared-UI uses the new ones with correct names
 * Duplicate of operations for correcting names based on comments in: https://github.expedia.biz/weaver/weaver-schema-stitcher/pull/899#issuecomment-1646168
 */
export type QuerySupplyBusinessPartnerInformationArgs = {
  context: ContextInput;
  propertyContext: PropertyContext;
  requestedBillingCountryCode?: InputMaybe<Scalars["String"]>;
};

/**
 * TODO:  Will remove these previous operations when Shared-UI uses the new ones with correct names
 * Duplicate of operations for correcting names based on comments in: https://github.expedia.biz/weaver/weaver-schema-stitcher/pull/899#issuecomment-1646168
 */
export type QuerySupplyCancellationWaiverDeclineArgs = {
  context: ContextInput;
  propertyContext: PropertyContext;
  reservationContext: SupplyCancellationWaiverReservationContext;
};

/**
 * TODO:  Will remove these previous operations when Shared-UI uses the new ones with correct names
 * Duplicate of operations for correcting names based on comments in: https://github.expedia.biz/weaver/weaver-schema-stitcher/pull/899#issuecomment-1646168
 */
export type QuerySupplyCoachingTipsBlockArgs = {
  context: ContextInput;
  propertyContext: PropertyContext;
};

/**
 * TODO:  Will remove these previous operations when Shared-UI uses the new ones with correct names
 * Duplicate of operations for correcting names based on comments in: https://github.expedia.biz/weaver/weaver-schema-stitcher/pull/899#issuecomment-1646168
 */
export type QuerySupplyContentHeadlineDescriptionArgs = {
  context: ContextInput;
  propertyContext: PropertyContext;
};

/**
 * TODO:  Will remove these previous operations when Shared-UI uses the new ones with correct names
 * Duplicate of operations for correcting names based on comments in: https://github.expedia.biz/weaver/weaver-schema-stitcher/pull/899#issuecomment-1646168
 */
export type QuerySupplyContentHubArgs = {
  context: ContextInput;
  navigationLevel: Scalars["String"];
  propertyContext: PropertyContext;
};

/**
 * TODO:  Will remove these previous operations when Shared-UI uses the new ones with correct names
 * Duplicate of operations for correcting names based on comments in: https://github.expedia.biz/weaver/weaver-schema-stitcher/pull/899#issuecomment-1646168
 */
export type QuerySupplyContentHubNavigationArgs = {
  context: ContextInput;
  navigationLevel: Scalars["String"];
  propertyContext: PropertyContext;
};

/**
 * TODO:  Will remove these previous operations when Shared-UI uses the new ones with correct names
 * Duplicate of operations for correcting names based on comments in: https://github.expedia.biz/weaver/weaver-schema-stitcher/pull/899#issuecomment-1646168
 */
export type QuerySupplyContentLocationSharingArgs = {
  context: ContextInput;
  propertyContext: PropertyContext;
};

/**
 * TODO:  Will remove these previous operations when Shared-UI uses the new ones with correct names
 * Duplicate of operations for correcting names based on comments in: https://github.expedia.biz/weaver/weaver-schema-stitcher/pull/899#issuecomment-1646168
 */
export type QuerySupplyContentManualTranslationSettingArgs = {
  context: ContextInput;
  locale?: InputMaybe<Scalars["String"]>;
  propertyContext: PropertyContext;
};

/**
 * TODO:  Will remove these previous operations when Shared-UI uses the new ones with correct names
 * Duplicate of operations for correcting names based on comments in: https://github.expedia.biz/weaver/weaver-schema-stitcher/pull/899#issuecomment-1646168
 */
export type QuerySupplyContentSaveButtonArgs = {
  context: ContextInput;
  navigationLevel: Scalars["String"];
  propertyContext: PropertyContext;
};

/**
 * TODO:  Will remove these previous operations when Shared-UI uses the new ones with correct names
 * Duplicate of operations for correcting names based on comments in: https://github.expedia.biz/weaver/weaver-schema-stitcher/pull/899#issuecomment-1646168
 */
export type QuerySupplyContentYourStoryArgs = {
  context: ContextInput;
  propertyContext: PropertyContext;
};

/**
 * TODO:  Will remove these previous operations when Shared-UI uses the new ones with correct names
 * Duplicate of operations for correcting names based on comments in: https://github.expedia.biz/weaver/weaver-schema-stitcher/pull/899#issuecomment-1646168
 */
export type QuerySupplyFeesArgs = {
  context: ContextInput;
  feeFilter?: InputMaybe<SupplyFeeFilterInput>;
  propertyContext: PropertyContext;
};

/**
 * TODO:  Will remove these previous operations when Shared-UI uses the new ones with correct names
 * Duplicate of operations for correcting names based on comments in: https://github.expedia.biz/weaver/weaver-schema-stitcher/pull/899#issuecomment-1646168
 */
export type QuerySupplyMarketMakerGridArgs = {
  context: ContextInput;
  propertyContext: PropertyContext;
};

/**
 * TODO:  Will remove these previous operations when Shared-UI uses the new ones with correct names
 * Duplicate of operations for correcting names based on comments in: https://github.expedia.biz/weaver/weaver-schema-stitcher/pull/899#issuecomment-1646168
 */
export type QuerySupplyMultiFactorAuthenticationViewArgs = {
  context: ContextInput;
};

/**
 * TODO:  Will remove these previous operations when Shared-UI uses the new ones with correct names
 * Duplicate of operations for correcting names based on comments in: https://github.expedia.biz/weaver/weaver-schema-stitcher/pull/899#issuecomment-1646168
 */
export type QuerySupplyNavigationArgs = {
  context: ContextInput;
  currentPageContext?: InputMaybe<SupplyCurrentPageContext>;
  navigationContext?: InputMaybe<SupplyNavigationContext>;
  propertyContext?: InputMaybe<PropertyContext>;
};

/**
 * TODO:  Will remove these previous operations when Shared-UI uses the new ones with correct names
 * Duplicate of operations for correcting names based on comments in: https://github.expedia.biz/weaver/weaver-schema-stitcher/pull/899#issuecomment-1646168
 */
export type QuerySupplyNavigationNotificationArgs = {
  context: ContextInput;
  propertyContext?: InputMaybe<PropertyContext>;
};

/**
 * TODO:  Will remove these previous operations when Shared-UI uses the new ones with correct names
 * Duplicate of operations for correcting names based on comments in: https://github.expedia.biz/weaver/weaver-schema-stitcher/pull/899#issuecomment-1646168
 */
export type QuerySupplyNavigationPropertyDetailsArgs = {
  context: ContextInput;
  propertyContext: PropertyContext;
};

/**
 * TODO:  Will remove these previous operations when Shared-UI uses the new ones with correct names
 * Duplicate of operations for correcting names based on comments in: https://github.expedia.biz/weaver/weaver-schema-stitcher/pull/899#issuecomment-1646168
 */
export type QuerySupplyNavigationUserImpersonationBannerArgs = {
  context: ContextInput;
};

/**
 * TODO:  Will remove these previous operations when Shared-UI uses the new ones with correct names
 * Duplicate of operations for correcting names based on comments in: https://github.expedia.biz/weaver/weaver-schema-stitcher/pull/899#issuecomment-1646168
 */
export type QuerySupplyOnboardingAvailabilityArgs = {
  context: ContextInput;
  propertyContext: PropertyContext;
};

/**
 * TODO:  Will remove these previous operations when Shared-UI uses the new ones with correct names
 * Duplicate of operations for correcting names based on comments in: https://github.expedia.biz/weaver/weaver-schema-stitcher/pull/899#issuecomment-1646168
 */
export type QuerySupplyOnboardingNavigationHeaderArgs = {
  context: ContextInput;
  propertyContext: PropertyContext;
};

/**
 * TODO:  Will remove these previous operations when Shared-UI uses the new ones with correct names
 * Duplicate of operations for correcting names based on comments in: https://github.expedia.biz/weaver/weaver-schema-stitcher/pull/899#issuecomment-1646168
 */
export type QuerySupplyOnboardingPaymentTermsAndConditionsArgs = {
  context: ContextInput;
};

/**
 * TODO:  Will remove these previous operations when Shared-UI uses the new ones with correct names
 * Duplicate of operations for correcting names based on comments in: https://github.expedia.biz/weaver/weaver-schema-stitcher/pull/899#issuecomment-1646168
 */
export type QuerySupplyOnboardingPropertyRatesExperienceArgs = {
  context: ContextInput;
  propertyContext: PropertyContext;
};

/**
 * TODO:  Will remove these previous operations when Shared-UI uses the new ones with correct names
 * Duplicate of operations for correcting names based on comments in: https://github.expedia.biz/weaver/weaver-schema-stitcher/pull/899#issuecomment-1646168
 */
export type QuerySupplyOnboardingPublishListingArgs = {
  context: ContextInput;
  isPublished?: InputMaybe<Scalars["Boolean"]>;
  onboardingContext?: InputMaybe<OnboardingContext>;
  propertyContext: PropertyContext;
};

/**
 * TODO:  Will remove these previous operations when Shared-UI uses the new ones with correct names
 * Duplicate of operations for correcting names based on comments in: https://github.expedia.biz/weaver/weaver-schema-stitcher/pull/899#issuecomment-1646168
 */
export type QuerySupplyOnboardingReadinessArgs = {
  context: ContextInput;
  onboardingContext?: InputMaybe<OnboardingContext>;
  propertyContext: PropertyContext;
};

/**
 * TODO:  Will remove these previous operations when Shared-UI uses the new ones with correct names
 * Duplicate of operations for correcting names based on comments in: https://github.expedia.biz/weaver/weaver-schema-stitcher/pull/899#issuecomment-1646168
 */
export type QuerySupplyOnboardingReviewArgs = {
  context: ContextInput;
  propertyContext: PropertyContext;
};

/**
 * TODO:  Will remove these previous operations when Shared-UI uses the new ones with correct names
 * Duplicate of operations for correcting names based on comments in: https://github.expedia.biz/weaver/weaver-schema-stitcher/pull/899#issuecomment-1646168
 */
export type QuerySupplyOnboardingTipCardArgs = {
  context: ContextInput;
  tipCardId?: InputMaybe<SupplyOnboardingTipCardId>;
};

/**
 * TODO:  Will remove these previous operations when Shared-UI uses the new ones with correct names
 * Duplicate of operations for correcting names based on comments in: https://github.expedia.biz/weaver/weaver-schema-stitcher/pull/899#issuecomment-1646168
 */
export type QuerySupplyOnboardingUnfinishedStepsArgs = {
  context: ContextInput;
  propertyContext: PropertyContext;
};

/**
 * TODO:  Will remove these previous operations when Shared-UI uses the new ones with correct names
 * Duplicate of operations for correcting names based on comments in: https://github.expedia.biz/weaver/weaver-schema-stitcher/pull/899#issuecomment-1646168
 */
export type QuerySupplyOnboardingWelcomeArgs = {
  context: ContextInput;
  propertyContext: PropertyContext;
};

/**
 * TODO:  Will remove these previous operations when Shared-UI uses the new ones with correct names
 * Duplicate of operations for correcting names based on comments in: https://github.expedia.biz/weaver/weaver-schema-stitcher/pull/899#issuecomment-1646168
 */
export type QuerySupplyOnboardingWorkFlowNavigationArgs = {
  context: ContextInput;
  propertyContext: PropertyContext;
};

/**
 * TODO:  Will remove these previous operations when Shared-UI uses the new ones with correct names
 * Duplicate of operations for correcting names based on comments in: https://github.expedia.biz/weaver/weaver-schema-stitcher/pull/899#issuecomment-1646168
 */
export type QuerySupplyPartnerGlanceCobrowseArgs = {
  context: ContextInput;
};

/**
 * TODO:  Will remove these previous operations when Shared-UI uses the new ones with correct names
 * Duplicate of operations for correcting names based on comments in: https://github.expedia.biz/weaver/weaver-schema-stitcher/pull/899#issuecomment-1646168
 */
export type QuerySupplyPropertyEditorPageTitleArgs = {
  context: ContextInput;
  pageName: Scalars["String"];
};

/**
 * TODO:  Will remove these previous operations when Shared-UI uses the new ones with correct names
 * Duplicate of operations for correcting names based on comments in: https://github.expedia.biz/weaver/weaver-schema-stitcher/pull/899#issuecomment-1646168
 */
export type QuerySupplyRegulatoryFlowArgs = {
  context: ContextInput;
  propertyContext: PropertyContext;
};

/**
 * TODO:  Will remove these previous operations when Shared-UI uses the new ones with correct names
 * Duplicate of operations for correcting names based on comments in: https://github.expedia.biz/weaver/weaver-schema-stitcher/pull/899#issuecomment-1646168
 */
export type QuerySupplyRegulatoryFlowTitleArgs = {
  context: ContextInput;
  propertyContext: PropertyContext;
};

/**
 * TODO:  Will remove these previous operations when Shared-UI uses the new ones with correct names
 * Duplicate of operations for correcting names based on comments in: https://github.expedia.biz/weaver/weaver-schema-stitcher/pull/899#issuecomment-1646168
 */
export type QuerySupplyScoreDetailsArgs = {
  context: ContextInput;
  propertyContext: PropertyContext;
};

/**
 * TODO:  Will remove these previous operations when Shared-UI uses the new ones with correct names
 * Duplicate of operations for correcting names based on comments in: https://github.expedia.biz/weaver/weaver-schema-stitcher/pull/899#issuecomment-1646168
 */
export type QuerySupplyScoreFactorAuditTrailArgs = {
  context: ContextInput;
  factorType: Scalars["String"];
  propertyContext: PropertyContext;
};

/**
 * TODO:  Will remove these previous operations when Shared-UI uses the new ones with correct names
 * Duplicate of operations for correcting names based on comments in: https://github.expedia.biz/weaver/weaver-schema-stitcher/pull/899#issuecomment-1646168
 */
export type QuerySupplyTaxesArgs = {
  context: ContextInput;
  propertyContext: PropertyContext;
};

/**
 * TODO:  Will remove these previous operations when Shared-UI uses the new ones with correct names
 * Duplicate of operations for correcting names based on comments in: https://github.expedia.biz/weaver/weaver-schema-stitcher/pull/899#issuecomment-1646168
 */
export type QueryTestingQueryOffersArgs = {
  context: ContextInput;
  marketing?: InputMaybe<PropertyMarketingInfoInput>;
  offerOptions?: InputMaybe<Array<PropertyInfoOptions>>;
  propertyId: Scalars["String"];
  referrer?: InputMaybe<Scalars["String"]>;
  searchCriteria?: InputMaybe<PropertySearchCriteriaInput>;
  searchOffer?: InputMaybe<SearchOfferInput>;
  shoppingContext?: InputMaybe<ShoppingContextInput>;
  travelAdTrackingInfo?: InputMaybe<PropertyTravelAdTrackingInfoInput>;
};

/**
 * TODO:  Will remove these previous operations when Shared-UI uses the new ones with correct names
 * Duplicate of operations for correcting names based on comments in: https://github.expedia.biz/weaver/weaver-schema-stitcher/pull/899#issuecomment-1646168
 */
export type QueryThingsToDoArgs = {
  context: ContextInput;
  placeId: Scalars["String"];
};

/**
 * TODO:  Will remove these previous operations when Shared-UI uses the new ones with correct names
 * Duplicate of operations for correcting names based on comments in: https://github.expedia.biz/weaver/weaver-schema-stitcher/pull/899#issuecomment-1646168
 */
export type QueryTravelAgentAuthenticationOptionsArgs = {
  context: ContextInput;
};

/**
 * TODO:  Will remove these previous operations when Shared-UI uses the new ones with correct names
 * Duplicate of operations for correcting names based on comments in: https://github.expedia.biz/weaver/weaver-schema-stitcher/pull/899#issuecomment-1646168
 */
export type QueryTravelAgentDashboardArgs = {
  context: ContextInput;
  dashboardType?: InputMaybe<DashboardType>;
};

/**
 * TODO:  Will remove these previous operations when Shared-UI uses the new ones with correct names
 * Duplicate of operations for correcting names based on comments in: https://github.expedia.biz/weaver/weaver-schema-stitcher/pull/899#issuecomment-1646168
 */
export type QueryTravelAgentSearchWizardConfigArgs = {
  context: ContextInput;
};

/**
 * TODO:  Will remove these previous operations when Shared-UI uses the new ones with correct names
 * Duplicate of operations for correcting names based on comments in: https://github.expedia.biz/weaver/weaver-schema-stitcher/pull/899#issuecomment-1646168
 */
export type QueryTravelContentArgs = {
  context: ContextInput;
};

/**
 * TODO:  Will remove these previous operations when Shared-UI uses the new ones with correct names
 * Duplicate of operations for correcting names based on comments in: https://github.expedia.biz/weaver/weaver-schema-stitcher/pull/899#issuecomment-1646168
 */
export type QueryTravelContentEditorialArgs = {
  contentIds?: InputMaybe<Array<Scalars["String"]>>;
  contentPurpose?: InputMaybe<Scalars["String"]>;
  context: ContextInput;
  pageType?: InputMaybe<Scalars["String"]>;
  uriContext?: InputMaybe<UriContextInput>;
};

/**
 * TODO:  Will remove these previous operations when Shared-UI uses the new ones with correct names
 * Duplicate of operations for correcting names based on comments in: https://github.expedia.biz/weaver/weaver-schema-stitcher/pull/899#issuecomment-1646168
 */
export type QueryTravelContentSeoArgs = {
  context: ContextInput;
  uriContext: UriContextInput;
};

/**
 * TODO:  Will remove these previous operations when Shared-UI uses the new ones with correct names
 * Duplicate of operations for correcting names based on comments in: https://github.expedia.biz/weaver/weaver-schema-stitcher/pull/899#issuecomment-1646168
 */
export type QueryTravelExperienceContentArgs = {
  context: ContextInput;
  ids: Array<Scalars["String"]>;
  pageType: Scalars["String"];
};

/**
 * TODO:  Will remove these previous operations when Shared-UI uses the new ones with correct names
 * Duplicate of operations for correcting names based on comments in: https://github.expedia.biz/weaver/weaver-schema-stitcher/pull/899#issuecomment-1646168
 */
export type QueryTravelExperienceManagerContentArgs = {
  contentPurpose?: InputMaybe<Scalars["String"]>;
  contentTopic?: InputMaybe<Scalars["String"]>;
  context: ContextInput;
  experienceType?: InputMaybe<Scalars["String"]>;
  preview?: InputMaybe<Scalars["Boolean"]>;
  requestDate?: InputMaybe<Scalars["String"]>;
  uriContext: UriContextInput;
};

/**
 * TODO:  Will remove these previous operations when Shared-UI uses the new ones with correct names
 * Duplicate of operations for correcting names based on comments in: https://github.expedia.biz/weaver/weaver-schema-stitcher/pull/899#issuecomment-1646168
 */
export type QueryTripArgs = {
  context: ContextInput;
};

/**
 * TODO:  Will remove these previous operations when Shared-UI uses the new ones with correct names
 * Duplicate of operations for correcting names based on comments in: https://github.expedia.biz/weaver/weaver-schema-stitcher/pull/899#issuecomment-1646168
 */
export type QueryTripsArgs = {
  context: ContextInput;
};

/**
 * TODO:  Will remove these previous operations when Shared-UI uses the new ones with correct names
 * Duplicate of operations for correcting names based on comments in: https://github.expedia.biz/weaver/weaver-schema-stitcher/pull/899#issuecomment-1646168
 */
export type QueryTsaFormArgs = {
  context: ContextInput;
};

/**
 * TODO:  Will remove these previous operations when Shared-UI uses the new ones with correct names
 * Duplicate of operations for correcting names based on comments in: https://github.expedia.biz/weaver/weaver-schema-stitcher/pull/899#issuecomment-1646168
 */
export type QueryUnescoLocalizationTestArgs = {
  key: Scalars["String"];
  langId: Scalars["Int"];
};

/**
 * TODO:  Will remove these previous operations when Shared-UI uses the new ones with correct names
 * Duplicate of operations for correcting names based on comments in: https://github.expedia.biz/weaver/weaver-schema-stitcher/pull/899#issuecomment-1646168
 */
export type QueryUniversalProfileArgs = {
  context: ContextInput;
};

/**
 * TODO:  Will remove these previous operations when Shared-UI uses the new ones with correct names
 * Duplicate of operations for correcting names based on comments in: https://github.expedia.biz/weaver/weaver-schema-stitcher/pull/899#issuecomment-1646168
 */
export type QueryUpcomingInteractionsArgs = {
  context: ContextInput;
  propertyContext?: InputMaybe<PropertyContext>;
};

/**
 * TODO:  Will remove these previous operations when Shared-UI uses the new ones with correct names
 * Duplicate of operations for correcting names based on comments in: https://github.expedia.biz/weaver/weaver-schema-stitcher/pull/899#issuecomment-1646168
 */
export type QueryUserProfileNextWizardArgs = {
  context: ContextInput;
  wizardContext: ProfileWizardContextInput;
};

/**
 * TODO:  Will remove these previous operations when Shared-UI uses the new ones with correct names
 * Duplicate of operations for correcting names based on comments in: https://github.expedia.biz/weaver/weaver-schema-stitcher/pull/899#issuecomment-1646168
 */
export type QueryVacChatContentArgs = {
  context: ContextInput;
};

/**
 * TODO:  Will remove these previous operations when Shared-UI uses the new ones with correct names
 * Duplicate of operations for correcting names based on comments in: https://github.expedia.biz/weaver/weaver-schema-stitcher/pull/899#issuecomment-1646168
 */
export type QueryVacOrchestratorArgs = {
  clientId: Scalars["String"];
  context: ContextInput;
};

/**
 * TODO:  Will remove these previous operations when Shared-UI uses the new ones with correct names
 * Duplicate of operations for correcting names based on comments in: https://github.expedia.biz/weaver/weaver-schema-stitcher/pull/899#issuecomment-1646168
 */
export type QueryVirtualAgentControlArgs = {
  context: ContextInput;
  conversationContext?: InputMaybe<ConversationContextInput>;
};

/**
 * TODO:  Will remove these previous operations when Shared-UI uses the new ones with correct names
 * Duplicate of operations for correcting names based on comments in: https://github.expedia.biz/weaver/weaver-schema-stitcher/pull/899#issuecomment-1646168
 */
export type QueryVoiceOfTheCustomerArgs = {
  context: ContextInput;
};

/**
 * TODO:  Will remove these previous operations when Shared-UI uses the new ones with correct names
 * Duplicate of operations for correcting names based on comments in: https://github.expedia.biz/weaver/weaver-schema-stitcher/pull/899#issuecomment-1646168
 */
export type QueryVoiceOfTheCustomerOptionalArgs = {
  context: ContextInput;
  surveyContext?: InputMaybe<Scalars["String"]>;
};

/**
 * TODO:  Will remove these previous operations when Shared-UI uses the new ones with correct names
 * Duplicate of operations for correcting names based on comments in: https://github.expedia.biz/weaver/weaver-schema-stitcher/pull/899#issuecomment-1646168
 */
export type QueryVrIntentSignalsArgs = {
  ids: Array<Scalars["String"]>;
  strategy: Scalars["String"];
};

/** Question and answers with analytics. */
export type QuestionAndAnswer = {
  __typename?: "QuestionAndAnswer";
  /** Client side analytics information to track on the interaction with clicks */
  analytics: ClientSideAnalytics;
  /**
   * Answer content as Markdown
   * @deprecated contains raw html
   */
  answer: Scalars["String"];
  /** Question content as plain text */
  question: Scalars["String"];
};

export type QuestionSortType = "NEWEST_TO_OLDEST" | "OLDEST_TO_NEWEST";

export type QuoteAction = UiAction & {
  __typename?: "QuoteAction";
  accessibility?: Maybe<Scalars["String"]>;
  actionIdentifier: Scalars["String"];
  analytics: ClientSideAnalytics;
};

export type RtbIcon = {
  __typename?: "RTBIcon";
  imgAlt: Scalars["String"];
  imgLink: Scalars["String"];
  imgSrc: Scalars["String"];
};

export type RtbLink = {
  __typename?: "RTBLink";
  linkText: Scalars["String"];
  linkUrl: Scalars["String"];
};

/** Type used during a product search to specify a given numeric range like the price of a hotel should be between 100 and 200 (USD). */
export type RangeValue = {
  __typename?: "RangeValue";
  id: Scalars["String"];
  max: Scalars["Int"];
  min: Scalars["Int"];
};

/** Type used during a product search to specify a given numeric range like the price of a hotel should be between 100 and 200 (USD). */
export interface RangeValueInput {
  id: Scalars["String"];
  max: Scalars["Int"];
  min: Scalars["Int"];
}

export type RateDiscount = {
  __typename?: "RateDiscount";
  description?: Maybe<Scalars["String"]>;
  descriptionId: Scalars["String"];
  expiration: Duration;
  sameDay: Scalars["Boolean"];
};

export type RateDiscountType = "MEMBER_DEAL" | "MOBILE_EXCLUSIVE" | "REGULAR" | "TONIGHT_ONLY";

export type RatePlan = {
  __typename?: "RatePlan";
  amenities: Array<RatePlanAmenity>;
  badge?: Maybe<Badge>;
  /** Confidence message displayed below the 'Reserve' button in each rate plan. */
  confidenceMessage?: Maybe<Scalars["String"]>;
  description?: Maybe<Scalars["String"]>;
  /** @deprecated Feature will be moved. */
  etpDialogTopMessage?: Maybe<MessageResult>;
  headerMessage?: Maybe<LodgingEnrichedMessage>;
  highlightedMessages?: Maybe<Array<Maybe<RatePlanMessage>>>;
  id: Scalars["String"];
  loyaltyMessage?: Maybe<LodgingEnrichedMessage>;
  marketingChannelMessage?: Maybe<LodgingEnrichedMessage>;
  marketingSection?: Maybe<MarketingSection>;
  name?: Maybe<Scalars["String"]>;
  /** Rate Plan Level Notifications */
  offerNotifications?: Maybe<LodgingNotificationsCard>;
  paymentPolicy: Array<PropertyPaymentPolicyInfo>;
  priceDetails: Array<Offer>;
  reserveCallToAction?: Maybe<RatePlanCallToAction>;
  /** Generate Quote */
  shareUrl?: Maybe<LodgingLinkMessage>;
  showRecommendedRateMessage: Scalars["Boolean"];
};

export type RatePlanAmenity = {
  __typename?: "RatePlanAmenity";
  additionalInformation?: Maybe<Scalars["String"]>;
  category?: Maybe<AmenityCategory>;
  description?: Maybe<Scalars["String"]>;
  icon?: Maybe<Icon>;
  id?: Maybe<Scalars["Int"]>;
};

/** Common interface to describe a room offer button (e.g. Reserve vs Pay now vs Pay at property) */
export type RatePlanCallToAction = EtpDialog | LodgingForm | LodgingMemberSignInDialog;

export type RatePlanMessage = LodgingEnrichedMessage | LodgingPlainDialog | LodgingPlainMessage;

export type RatePlanViewModel = {
  __typename?: "RatePlanViewModel";
  commissionSection?: Maybe<CommissionSection>;
  price: PriceViewModel;
  priceBreakDown: PriceBreakDownModel;
  ratePlanCode?: Maybe<Scalars["String"]>;
  ratePlanType?: Maybe<Scalars["String"]>;
};

export type RatePlansExpando = LodgingExpando & {
  __typename?: "RatePlansExpando";
  collapseButton: LodgingButton;
  content: RatePlansExpandoContent;
  expandButton: LodgingButton;
};

export type RatePlansExpandoContent = {
  __typename?: "RatePlansExpandoContent";
  ratePlans: Array<RatePlan>;
};

export type Rating = {
  __typename?: "Rating";
  boolRating?: Maybe<BoolRating>;
  numberRating?: Maybe<NumberRating>;
  stringRating?: Maybe<StringRating>;
  tagRating?: Maybe<TagRating>;
};

export type RatingValueDetails = {
  __typename?: "RatingValueDetails";
  description?: Maybe<Scalars["String"]>;
  label?: Maybe<Scalars["String"]>;
  name?: Maybe<Scalars["String"]>;
};

export type Reason = {
  __typename?: "Reason";
  heading: Scalars["String"];
  icon: RtbIcon;
  link: RtbLink;
  paragraph: Scalars["String"];
};

export type ReasonsToBelieve = {
  __typename?: "ReasonsToBelieve";
  heading: Scalars["String"];
  reasons: Array<Reason>;
  terms: Scalars["String"];
};

export type RecommendationAnalytics = {
  __typename?: "RecommendationAnalytics";
  event: EgClickstreamEvent;
  recommendationModule: RecommendationModule;
};

export type RecommendationModule = {
  __typename?: "RecommendationModule";
  recommendationResponseId: Scalars["String"];
  recommendationTitle?: Maybe<Scalars["String"]>;
  recommendations: Array<Recommendations>;
};

export type Recommendations = {
  __typename?: "Recommendations";
  presentationDetailsCurrencyCode?: Maybe<Scalars["String"]>;
  presentationDetailsPriceDisplayed?: Maybe<Scalars["String"]>;
  presentationDetailsRecommendationName?: Maybe<Scalars["String"]>;
  recommendationId: Scalars["String"];
  recommendationPosition?: Maybe<Scalars["String"]>;
};

/** Object holding list of recommended campaigns */
export type RecommendedCampaigns = {
  __typename?: "RecommendedCampaigns";
  /** List of recommended campaigns */
  campaigns: Array<CampaignDetail>;
  /** Campaign pagination information */
  paginationInfo: CampaignPagination;
  /** UUID that identifies the response and allows tracking of impressions */
  responseId: Scalars["UUID"];
};

export type RecommendedOffer = AccessibilityField & {
  __typename?: "RecommendedOffer";
  /** Label where a11y behavior is needed. */
  accessibilityLabel?: Maybe<Scalars["String"]>;
  header?: Maybe<LodgingHeader>;
  /**
   * Recommended offer label.
   * @deprecated Use accessibilityLabel, replace with accessibilityLabel
   */
  label?: Maybe<Scalars["String"]>;
  priceDetails: Offer;
  units: Array<PropertyUnit>;
};

export type RecommendedType = "BESPOKE" | "DESTINATIONS" | "OFFERS";

/** Move me to BEX SDK API */
export type Region = {
  __typename?: "Region";
  id: Scalars["String"];
  name: Scalars["String"];
  shortName: Scalars["String"];
  type?: Maybe<RegionType>;
};

/** Region information of properties that are sold out in the destination region as calculated by the Urgency Service. */
export type RegionCompression = {
  __typename?: "RegionCompression";
  level: CompressionLevel;
  regionId: Scalars["String"];
  regionName: Scalars["String"];
  score: Scalars["Int"];
};

/** Enumerated Gaia geographic region types */
export type RegionType =
  | "ADDRESS"
  | "AIRPORT"
  | "CITY"
  | "CONTINENT"
  | "COUNTRY"
  | "HIGH_LEVEL_REGION"
  | "METRO_STATION"
  | "MULTI_CITY_VICINITY"
  | "NEIGHBORHOOD"
  | "POINT_OF_INTEREST"
  | "PROVINCE_STATE"
  | "TRAIN_STATION"
  | "UNKNOWN";

export type Relation = {
  __typename?: "Relation";
  /** List of related amenities */
  attribute: Array<TravelContentAttribute>;
  /** List of related groceries */
  grocery: Array<TravelContentPlace>;
  /** List of medical centers */
  medicalCenter: Array<TravelContentPoi>;
  /** List of related point of interest */
  poi: Array<TravelContentPoi>;
  /** List of related property */
  property: Array<TravelContentProperty>;
  /** List of related restaurants */
  restaurant: Array<TravelContentRestaurant>;
};

export type RelationAttributeArgs = {
  limit?: InputMaybe<Scalars["Int"]>;
};

export type RelationGroceryArgs = {
  limit?: InputMaybe<Scalars["Int"]>;
};

export type RelationMedicalCenterArgs = {
  limit?: InputMaybe<Scalars["Int"]>;
};

export type RelationPoiArgs = {
  limit?: InputMaybe<Scalars["Int"]>;
};

export type RelationPropertyArgs = {
  limit?: InputMaybe<Scalars["Int"]>;
};

export type RelationRestaurantArgs = {
  limit?: InputMaybe<Scalars["Int"]>;
};

export interface RemoveInsuranceRequestInput {
  /** The user selection for the Insurance product(s) */
  insuranceProductIds: Array<Scalars["String"]>;
  /** The source id of the persistence store.For example Trip for BEX or Record locator for other systems */
  sourceId: Scalars["String"];
  /** The identifier to get the decoded value of params received in shopping response */
  updateRequestId: Scalars["String"];
}

export interface RemoveInsuranceRequestOldInput {
  insuranceSearchId: Scalars["String"];
  offerTypeId?: InputMaybe<Scalars["Int"]>;
}

export type RemoveInsuranceResponse = {
  __typename?: "RemoveInsuranceResponse";
  status: InsuranceMutationStatus;
};

export type RemoveInsuranceResponseOld = {
  __typename?: "RemoveInsuranceResponseOld";
  message: InsurancePhrase;
  status: InsuranceMutationStatus;
};

/** Results from a shortlist fetch call */
export type RemoveItemResults = {
  __typename?: "RemoveItemResults";
  /** Result of removing the saved item */
  result: Result;
};

export type RentalProtectionCard = {
  __typename?: "RentalProtectionCard";
  clickAction: CarActionableItem;
  dialog: RentalProtectionDialog;
  infos: Array<RentalProtectionInfoLineItem>;
  offerBadge?: Maybe<CarOfferBadge>;
  pricePeriod?: Maybe<Scalars["String"]>;
  priceSummary?: Maybe<Scalars["String"]>;
  seeDetailsAction: CarActionableItem;
  selected: Scalars["Boolean"];
  title: Scalars["String"];
};

export type RentalProtectionDialog = {
  __typename?: "RentalProtectionDialog";
  content: Array<RentalProtectionDialogContent>;
  description: Array<Scalars["String"]>;
  title: Scalars["String"];
};

export type RentalProtectionDialogContent = {
  __typename?: "RentalProtectionDialogContent";
  description: Array<RentalProtectionInfoLineItem>;
  title: Scalars["String"];
};

export type RentalProtectionInfo = {
  __typename?: "RentalProtectionInfo";
  rentalProtectionCard: Array<RentalProtectionCard>;
  title: Scalars["String"];
};

export type RentalProtectionInfoLineItem = {
  __typename?: "RentalProtectionInfoLineItem";
  icon?: Maybe<Icon>;
  text: Scalars["String"];
};

export type ResidencyDetails = {
  __typename?: "ResidencyDetails";
  /** Country code Selection */
  countryCode?: Maybe<Scalars["String"]>;
  /** Region code Selection */
  regionCode?: Maybe<Scalars["String"]>;
};

export interface ResidencyDetailsInput {
  /** Country code Selection */
  countryCode?: InputMaybe<Scalars["String"]>;
  /** Region code Selection */
  regionCode?: InputMaybe<Scalars["String"]>;
}

/** Represents an identifier to be used to access downstream data. */
export type ResourceIdentifier = {
  __typename?: "ResourceIdentifier";
  /**
   * The access identifier to be used. This relates to the id provided by the Data Source.
   * Example: 0572acb8-5717-499b-b3d3-b02c499a515d
   */
  id: Scalars["String"];
  /** The type of data source to be accessed. */
  type: DataSourceType;
};

/** Tags Associated with the response */
export type ResponseTagType =
  | "CACHE_SOURCE_AIRBLAZE"
  | "CACHE_SOURCE_BYOT_AIRBLAZE"
  | "LISTINGS_PAGINATED_SLICED"
  | "LISTING_CACHE_SOURCE"
  | "LISTING_DOWNLEVEL_SOURCE"
  | "RESPONSE_SUMMARY_CACHED_CONFIG"
  | "RESPONSE_SUMMARY_CACHED_ML"
  | "RESPONSE_SUMMARY_HYBRID"
  | "RESPONSE_SUMMARY_LIVE"
  | "UNRECOGNIZED";

export type Result = "ERROR" | "SUCCESS";

export type ResultSectionHeading = {
  __typename?: "ResultSectionHeading";
  /** Text content */
  heading: Scalars["String"];
  /** Position in results */
  index: Scalars["Int"];
};

export type ResultTitleModel = {
  __typename?: "ResultTitleModel";
  /** Main header for the title */
  header?: Maybe<Scalars["String"]>;
  /** Subheader info icon */
  icon?: Maybe<Icon>;
  /** Link to info page for subheader info icon */
  link?: Maybe<Scalars["URL"]>;
  /** Subheader for the title */
  subHeader?: Maybe<Scalars["String"]>;
};

export type ResultsHeaderMessage = {
  __typename?: "ResultsHeaderMessage";
  /** Sub messaging models for each header message. */
  subMessages?: Maybe<Array<ResultsHeaderSubMessage>>;
};

export type ResultsHeaderSubMessage = {
  __typename?: "ResultsHeaderSubMessage";
  /** Icon to display next to message. */
  icon?: Maybe<Icon>;
  /** Link to more information about this message. */
  link?: Maybe<Scalars["URL"]>;
  /** Message to display. */
  message?: Maybe<Scalars["String"]>;
  /** Referrer ID to submit on interaction. */
  referrerId?: Maybe<Scalars["String"]>;
};

/** Type to result after mutating a travel agent notification */
export type RetailTravelAgentMutateNotificationResult = {
  __typename?: "RetailTravelAgentMutateNotificationResult";
  message?: Maybe<Scalars["String"]>;
  success: Scalars["Boolean"];
};

/** Type to individual notification of a travel agent */
export type RetailTravelAgentNotification = {
  __typename?: "RetailTravelAgentNotification";
  content: EgdsStylizedText;
  date: Scalars["String"];
  dismissButton: RetailTravelAgentNotificationDismissButton;
  heading: EgdsStylizedText;
  icon?: Maybe<Icon>;
  id: Scalars["ID"];
  link: EgdsStandardLink;
  readIndicator?: Maybe<Icon>;
};

/** Type for a travel agent notification dismiss button */
export type RetailTravelAgentNotificationDismissButton = {
  __typename?: "RetailTravelAgentNotificationDismissButton";
  analytics: ClientSideAnalytics;
  icon: Icon;
};

/** Type to retrieving a travel agent's notifications */
export type RetailTravelAgentNotificationResult = {
  __typename?: "RetailTravelAgentNotificationResult";
  footerText: Scalars["String"];
  notifications: Array<RetailTravelAgentNotification>;
  title: Scalars["String"];
};

export type RetryMultiItemShoppingAction = MultiItemShoppingAction & {
  __typename?: "RetryMultiItemShoppingAction";
  shoppingContext: ShoppingContext;
};

export type ReviewBreakdown = {
  __typename?: "ReviewBreakdown";
  description: Scalars["String"];
  heading: Scalars["String"];
  percentage: Scalars["Int"];
  score?: Maybe<Scalars["String"]>;
};

export type ReviewFlag = {
  __typename?: "ReviewFlag";
  reviewFlagDialog?: Maybe<PropertyReviewFlagDialog>;
  /** field to indicate successful flagged message as a toast to user  */
  reviewFlagToast?: Maybe<LodgingToastMessage>;
};

/** Enum of types of review interactions */
export type ReviewInteractionType = "HELPFUL_REVIEW" | "REVIEW_REPORT_FLAG";

export type ReviewQuestion = {
  __typename?: "ReviewQuestion";
  dependentQuestions?: Maybe<Array<DependentQuestion>>;
  description?: Maybe<Scalars["String"]>;
  isRequired?: Maybe<Scalars["Boolean"]>;
  name?: Maybe<Scalars["String"]>;
  rating?: Maybe<Rating>;
  urn?: Maybe<Scalars["String"]>;
};

/** Represents a range of review scores for filtering properties */
export type ReviewScoreRange = CriteriaRange & {
  __typename?: "ReviewScoreRange";
  /** The maximum review score, e.g. 5.0 */
  max?: Maybe<Scalars["Float"]>;
  /** The minimum review score, e.g. 1.0 */
  min?: Maybe<Scalars["Float"]>;
};

/** Represents a range of review scores for filtering properties */
export interface ReviewScoreRangeInput {
  /** The maximum review score, e.g. 5.0 */
  max?: InputMaybe<Scalars["Float"]>;
  /** The minimum review score, e.g. 1.0 */
  min?: InputMaybe<Scalars["Float"]>;
}

export type ReviewSection = {
  __typename?: "ReviewSection";
  description?: Maybe<Scalars["String"]>;
  questions?: Maybe<Array<ReviewQuestion>>;
};

export type ReviewSectionGroup = {
  __typename?: "ReviewSectionGroup";
  description?: Maybe<Scalars["String"]>;
  sections?: Maybe<Array<ReviewSection>>;
};

/** Section that contains all the benefits related to product */
export type ReviewSummary = OfferCardUnit & {
  __typename?: "ReviewSummary";
  elementID: Scalars["String"];
  /** List that contains attribute Icon along with its title and description */
  reviewCount: EgdsStylizedText;
  /** List that contains attribute Icon along with its title and description */
  reviewDescription: EgdsStylizedText;
  /** List that contains attribute Icon along with its title and description */
  score: EgdsStylizedText;
};

export type ReviewSummaryDetail = {
  __typename?: "ReviewSummaryDetail";
  /**
   * Overall formatted rating over maximum rating
   * @deprecated Overall formatted rating over maximum rating, instead use formattedRatingOutOfMaxA11y , replace with formattedRatingOutOfMaxA11y
   */
  formattedRatingOutOfMax: Scalars["String"];
  /** Overall formatted rating over maximum rating with a11y label */
  formattedRatingOutOfMaxA11y: LodgingEnrichedMessage;
  /** Category label, i.e Cleanliness or Room Comfort */
  label: Scalars["String"];
  /** Percentage used to build the progress bar */
  ratingPercentage: Scalars["Int"];
};

export type ReviewThemes = {
  __typename?: "ReviewThemes";
  /** icon for theme */
  icon?: Maybe<Icon>;
  /** Localized label */
  label?: Maybe<Scalars["String"]>;
};

export type RewardsOption = "ALTAIR" | "AVION" | "NONAVION";

export type RewardsPointSelectionEnum = "APPLY_REWARD_POINTS" | "DO_NOT_APPLY_REWARD_POINTS";

/** Response object for toolbar title and a collection of product policies. */
export type RnRContent = {
  __typename?: "RnRContent";
  productPolicies: Array<ProductPolicy>;
  toolbarTitle: Scalars["String"];
};

export type RnRDetails = {
  __typename?: "RnRDetails";
  rnrInfo: RnRContent;
};

/** A single hotel room configuration */
export type Room = {
  __typename?: "Room";
  /** The number of adult in the room */
  adults: Scalars["Int"];
  /** The number of children in the room */
  children?: Maybe<Array<Child>>;
};

/** Information of the room */
export type RoomInfo = {
  __typename?: "RoomInfo";
  /** Easy readable string for accessibility */
  accessibilityLabel?: Maybe<Scalars["String"]>;
  /** Number of bath rooms */
  bathRoom?: Maybe<Scalars["Int"]>;
  /** Bed description */
  bedConfig?: Maybe<Scalars["String"]>;
  /** Number of bed rooms */
  bedRoom?: Maybe<Scalars["Int"]>;
  /** Maximum occupancy */
  maxPersons?: Maybe<Scalars["Int"]>;
  /** Room size in square footage */
  squareFootage?: Maybe<Scalars["Int"]>;
  /** Text to display on the page */
  text: Array<Maybe<Scalars["String"]>>;
};

/** A single hotel room configuration */
export interface RoomInput {
  /** The number of adult in the room */
  adults: Scalars["Int"];
  /** The number of children in the room */
  children?: InputMaybe<Array<ChildInput>>;
}

export type RoomOccupants = {
  __typename?: "RoomOccupants";
  adults?: Maybe<Scalars["Int"]>;
  agesOfChildren?: Maybe<Array<Scalars["Int"]>>;
  totalOccupants?: Maybe<Scalars["Int"]>;
};

export type RoomSize = {
  __typename?: "RoomSize";
  squareFeet?: Maybe<Scalars["Float"]>;
  squareMeters?: Maybe<Scalars["Float"]>;
};

/** Summary of a room */
export type RoomSummary = {
  __typename?: "RoomSummary";
  /** Room type id */
  id: Scalars["String"];
  /** Guest like it for text */
  roomRatingListTitle?: Maybe<Scalars["String"]>;
  /** Score out of 5 */
  score?: Maybe<Scalars["String"]>;
  /** Score out of 5 with a label */
  scoreLabel?: Maybe<Scalars["String"]>;
  /** List of tags */
  tags: Array<Tag>;
};

export type RoomViewModel = {
  __typename?: "RoomViewModel";
  amenities?: Maybe<Array<Amenity>>;
  beddingOptions?: Maybe<Array<BedOptionViewModel>>;
  description?: Maybe<Scalars["String"]>;
  maxOccupancy?: Maybe<MaxOccupancyViewModel>;
  name?: Maybe<Scalars["String"]>;
  photos?: Maybe<ImageGallery>;
  ratePlans?: Maybe<Array<RatePlanViewModel>>;
  roomId?: Maybe<Scalars["String"]>;
  roomSize?: Maybe<RoomSize>;
  views?: Maybe<Array<ViewModel>>;
};

export type Rooms = {
  __typename?: "Rooms";
  childrenAges?: Maybe<Array<Scalars["Int"]>>;
  numAdults: Scalars["Int"];
  numChildren?: Maybe<Scalars["Int"]>;
};

export type RouteType = "MULTI_DESTINATION" | "ONE_WAY" | "ROUND_TRIP";

export type SeoStructuredData = {
  __typename?: "SEOStructuredData";
  content?: Maybe<Scalars["String"]>;
  itemprop: Scalars["String"];
  itemscope: Scalars["Boolean"];
  itemtype?: Maybe<Scalars["URL"]>;
};

export type Sorting_Direction = "ASC" | "DESC";

/** Displays relevant image, pricing, itin, of the Sailing Item */
export type Sailing = {
  __typename?: "Sailing";
  /** Primary call to action button */
  action: UiLinkAction;
  /** Cruise product gallery details */
  cruiseProductGallery?: Maybe<CruiseProductGallery>;
  /**
   * [Cruise line name] - [Ship Name]
   * @deprecated Use subtitle inside offer instead
   */
  description?: Maybe<Scalars["String"]>;
  /**
   * cruise line icon
   * @deprecated Use iconMedia which used EGDS MediaItem instead
   */
  icon?: Maybe<CruiseMedia>;
  /** Image of given cruise and alt details */
  iconMedia?: Maybe<CruiseMediaItem>;
  /**
   * Image of given cruise and alt details
   * @deprecated Use imageMedia which used EGDS MediaItem instead
   */
  image?: Maybe<CruiseMedia>;
  /** Image of given cruise and alt details */
  imageMedia?: Maybe<CruiseMediaItem>;
  /** Images of given cruise and alt details */
  images?: Maybe<Array<CruiseMediaItem>>;
  /**
   * cruise line logo
   * @deprecated Use logoMedia which used EGDS MediaItem instead
   */
  logo?: Maybe<CruiseMedia>;
  /** Image of given cruise and alt details */
  logoMedia?: Maybe<CruiseMediaItem>;
  /** origin and destination, cruise line name, dates, locations... */
  offer?: Maybe<SailingOffer>;
  /** Localized text for pinned sailings */
  pinnedSailingText?: Maybe<Scalars["String"]>;
  /** basePrice */
  price?: Maybe<CruisePrice>;
  /** Localized text for sponsored sailing Ad icon */
  sponsoredSailingAdText?: Maybe<Scalars["String"]>;
  /**
   * [#] Night [Destination]
   * @deprecated Use title inside offer instead
   */
  title?: Maybe<Scalars["String"]>;
};

/** Dialog with descriptive information */
export type SailingAction = {
  __typename?: "SailingAction";
  /** Primary call to action */
  action: UiAction;
  /** Content of the dialog */
  content: Scalars["String"];
  /** Text for accessibility */
  descriptionText?: Maybe<Scalars["String"]>;
};

/** List of sailings */
export type SailingDeals = {
  __typename?: "SailingDeals";
  /** description about the deals response */
  description?: Maybe<Scalars["String"]>;
  /** Individual items in the Sailings result */
  list?: Maybe<Array<Sailing>>;
  /** Primary call to action button */
  navigation: SailingDealsNavigation;
  /** Secondary UI - eg. See all sailings button */
  searchNavigation?: Maybe<CruiseSearchNavigation>;
  /** title related to the deals request */
  title?: Maybe<Scalars["String"]>;
};

/** List of sailings */
export type SailingDealsNavigation = {
  __typename?: "SailingDealsNavigation";
  /** Navigiation analytics action next/prev */
  analytics: ClientSideAnalytics;
  /** navigate next */
  nextText?: Maybe<Scalars["String"]>;
  /** navigate previous */
  previousText?: Maybe<Scalars["String"]>;
};

export type SailingDetailsResults = {
  __typename?: "SailingDetailsResults";
  /** Itinerary information for the sailing - static map */
  itinerary: ItineraryDetails;
  /** Itinerary information for the sailing - dynamic map */
  itineraryDynamicMap: ItineraryDynamicMapDetails;
  /** Itinerary information for the sailing - static map */
  itineraryMap: ItineraryStaticMapDetails;
  /** Itinerary information for the sailing - static map */
  itineraryStaticMap: ItineraryStaticMapDetails;
};

/** Itinerary dialog */
export type SailingDialog = {
  __typename?: "SailingDialog";
  /** close dialog */
  close?: Maybe<SailingAction>;
  /** description */
  description?: Maybe<Scalars["String"]>;
  /**
   * cruise line icon
   * @deprecated Use iconMediaItem instead
   */
  icon?: Maybe<CruiseMedia>;
  /** cruise line icon */
  iconMediaItem?: Maybe<CruiseMediaItem>;
  /** Itinerary */
  itinerary: SailingItinerary;
  /** open dialog */
  open?: Maybe<SailingAction>;
  /** Token for the sailing item */
  sailingToken?: Maybe<Scalars["String"]>;
  /** Select this sailing */
  select?: Maybe<CruiseDialog>;
  /** subtitle */
  subtitle?: Maybe<Scalars["String"]>;
  /** title */
  title?: Maybe<Scalars["String"]>;
};

/** Sailing Itinerary */
export type SailingItinerary = CruiseCommonItinerary & {
  __typename?: "SailingItinerary";
  /** Call to action to see full itinerary */
  callToAction?: Maybe<UiPrimaryButton>;
  /** First part of the individual itinerary items (till maxDaysToShow) */
  itineraryItems?: Maybe<Array<CruiseItineraryItem>>;
  /** Rest of the individual itinerary items (from maxDaysToShow onward) */
  secondaryItineraryItems?: Maybe<Array<CruiseItineraryItem>>;
};

/** Navigation bar tab with label and section name */
export type SailingNavigationBarTab = {
  __typename?: "SailingNavigationBarTab";
  /** Analytics data for tracking */
  clientSideAnalytics: ClientSideAnalytics;
  /** Label that should be displayed */
  label: Scalars["String"];
  /** Represents the location on the page the tab will jump to */
  sectionName: Scalars["String"];
};

/** Information about the itinerary */
export type SailingOffer = {
  __typename?: "SailingOffer";
  /** Accessibility: Departing from [Origin Port], visiting [Number of ports] ports, select Itinerary details to review day by day itinerary */
  a11yText?: Maybe<Scalars["String"]>;
  /** [Deparure Port Name] - [Next Port Name] - .... */
  description: Scalars["String"];
  /** dialog for card */
  dialog?: Maybe<SailingDialog>;
  /** Departing from [Origin Port], visiting [Number of ports] ports, select Itinerary details to review day by day itinerary */
  heading: Scalars["String"];
  /** Mmm OO YYYY - Mmm OO YYYY */
  subtitle?: Maybe<Scalars["String"]>;
  /**
   * Accessibility: Departing from [Origin Port], visiting [Number of ports] ports, select Itinerary details to review day by day itinerary
   * @deprecated Use a11yText instead
   */
  text?: Maybe<Scalars["String"]>;
  /** [#] Night [Destination] */
  title: Scalars["String"];
};

/** Show more sailings button displayed at the bottom of the sailing cards */
export type SailingPagination = {
  __typename?: "SailingPagination";
  /** Limit of how many results will be returned. - Default is 20 */
  limit?: Maybe<Scalars["Int"]>;
  /** Limit of how many results will be skipped. - Default is 0 */
  offset?: Maybe<Scalars["Int"]>;
  /** Show more button in the bottom of the sailing search result */
  showMoreButton?: Maybe<UiSecondaryButton>;
};

/** List of sailings */
export type SailingSearch = {
  __typename?: "SailingSearch";
  /** description about the sailing search response */
  description?: Maybe<Scalars["String"]>;
  /** Individual items in the Sailing search result */
  list?: Maybe<Array<Sailing>>;
  /** Messaging card for no matching results */
  noResultsMessagingCard?: Maybe<EgdsStandardMessagingCard>;
  /** Show more button in the bottom of the sailing search result */
  pagination: SailingPagination;
  /** Messaging for relaxed search */
  relaxedSearchHeader?: Maybe<Scalars["String"]>;
};

export type SailingSearchResults = {
  __typename?: "SailingSearchResults";
  /** Get sailing search errors message */
  genericErrorsMessage?: Maybe<NoResultsMessage>;
  /** Ask us anything messaging card */
  messagingCard: CruiseMessagingCard;
  /** Title to be used on search results page */
  pageTitle: Scalars["String"];
  /** Sailing cards and related data */
  sailings: SailingSearch;
  /** Get Terms and Conditions */
  termsAndConditions: CruiseSubsection;
};

/** Response container when saving new item */
export type SavedItem = {
  __typename?: "SavedItem";
  /** The unique identifier for the newly saved item */
  id?: Maybe<Scalars["String"]>;
  /** The product id for the saved item */
  productId: Scalars["String"];
  /** The product type of the newly saved item */
  productType?: Maybe<ProductType>;
};

/** Search Carousel used in search card, with title */
export type SearchCarousel = {
  __typename?: "SearchCarousel";
  /** Carousel card model */
  options?: Maybe<Array<SearchCarouselModel>>;
  /** Title that displays outside of carousel card */
  title?: Maybe<Scalars["String"]>;
};

/** Carousel Model used in search card */
export type SearchCarouselModel = {
  __typename?: "SearchCarouselModel";
  /** description displayed on the card */
  description?: Maybe<Scalars["String"]>;
  /** url that links to the card, if any */
  href?: Maybe<Scalars["String"]>;
  /** image associate with the card */
  image?: Maybe<Image>;
  /** Name that indicates what this card is for */
  name?: Maybe<Scalars["String"]>;
  /** Primary header for this carousel card */
  primaryHeading?: Maybe<Scalars["String"]>;
};

export type SearchClickstreamEvents = {
  __typename?: "SearchClickstreamEvents";
  searchResultsViewed?: Maybe<SearchResultsViewed>;
};

export type SearchCriteria = {
  __typename?: "SearchCriteria";
  dateRange: PropertyDateRange;
  destination: Destination;
  filters?: Maybe<PropertySearchFilters>;
  marketing?: Maybe<PropertyMarketingInfo>;
  originalDateRange?: Maybe<PropertyDateRange>;
  privacyTrackingState?: Maybe<PrivacyTrackingState>;
  propertyShopOptions?: Maybe<PropertyShopOptions>;
  resolvedDateRange?: Maybe<PropertyDateRange>;
  rooms: Array<Room>;
  searchIntent?: Maybe<SearchIntent>;
  searchOptions?: Maybe<Array<PropertySearchOptions>>;
  searchPagination?: Maybe<Pagination>;
  shopWithPoints: Scalars["Boolean"];
  sort?: Maybe<PropertySort>;
};

/**
 * Range field on search form or search form widget for entering an event duration.
 *
 * Figma: https://www.figma.com/file/eiXu9ARV67TsK58GPfKdku/Cruise-search-(CSR)?node-id=2486%3A154892
 */
export type SearchFormDurationSpanField = EgdsElement &
  EgdsInputField &
  EgdsSearchFormField & {
    __typename?: "SearchFormDurationSpanField";
    /**
     * Used for screen readers to inform about the current value.
     * Example: based on a display value "3 - 9 nights", read "3 to 9 nights".
     */
    accessibilityTemplate?: Maybe<EgdsLocalizedText>;
    /** Informs behavior in response to user click. */
    action?: Maybe<EgdsSearchFormAction>;
    /**
     * Element unique identifier. Uses include handling diffs for UI updates
     * and identifying the source of data for user input fields.
     */
    egdsElementId: Scalars["String"];
    /** Text to be displayed as error text when the input field is in an invalid state. */
    errorMessage?: Maybe<Scalars["String"]>;
    /** Provides detailed instructions to the user on how to use the input element. */
    instructions?: Maybe<Scalars["String"]>;
    /** Tag description for the input element. */
    label?: Maybe<Scalars["String"]>;
    /** Used to dynamically update the label text in the client, based on user interaction with the input. */
    labelTemplate?: Maybe<EgdsLocalizedText>;
    /** Icon positioned to the left side of the input element. */
    leftIcon?: Maybe<Icon>;
    /** Description of the expected value for the input element. */
    placeholder?: Maybe<Scalars["String"]>;
    /** Field is in a read-only state displaying only text when readOnly is true. */
    readOnly: Scalars["Boolean"];
    /** Informs the user if the field is mandatory. */
    required?: Maybe<Scalars["Boolean"]>;
    /** Icon positioned to the right side of the input element. */
    rightIcon?: Maybe<Icon>;
    /**
     * Validations with corresponding error messages to display if the input is invalid.
     * The order in which the validations appears indicates the order of priority of which error message to display.
     */
    validations?: Maybe<Array<EgdsInputValidation>>;
    /** Default value for the input element. */
    value?: Maybe<Scalars["String"]>;
  };

/** Represents a product that is related to a specific search form experience ie. Lodging, Flights, Cruises, etc. */
export type SearchFormProduct = {
  __typename?: "SearchFormProduct";
  clickAnalytics?: Maybe<ClientSideAnalytics>;
  icon?: Maybe<Icon>;
  id?: Maybe<Scalars["String"]>;
  /** Display label that describe the option */
  label: Scalars["String"];
  /** Indicate if the current product is selected */
  selected: Scalars["Boolean"];
  /** Product type for the current option */
  type: SearchFormProductType;
};

/**
 * Allow a user to select from a list of products a search form experience,
 * mostly used in the entry shopping path (Home and Landing pages)
 */
export type SearchFormProductSelector = {
  __typename?: "SearchFormProductSelector";
  /** List of products available for selection */
  products: Array<SearchFormProduct>;
};

/** Search form product types */
export type SearchFormProductType = "ACTIVITIES" | "CARS" | "CRUISES" | "FLIGHTS" | "LODGING" | "PACKAGES";

export type SearchFormResults = {
  __typename?: "SearchFormResults";
  /** Activity search form */
  activity: EgdsSearchForm;
  /** Car search form */
  car: EgdsSearchForm;
  /** Cruise search form */
  cruise: EgdsSearchForm;
  /** Flight search form */
  flight: EgdsSearchForm;
  /** Lodging search form */
  lodging: EgdsSearchForm;
  /** Packages search form */
  packages: EgdsSearchForm;
  productSelector: SearchFormProductSelector;
};

export type SearchFormResultsCarArgs = {
  carSearchCriteria?: InputMaybe<CarSearchCriteriaInput>;
};

export type SearchFormResultsCruiseArgs = {
  cruiseSearchCriteria?: InputMaybe<CruiseSearchCriteriaInput>;
};

export type SearchFormResultsFlightArgs = {
  flightSearchCriteria?: InputMaybe<FlightSearchCriteriaInput>;
};

export type SearchFormResultsLodgingArgs = {
  propertySearchCriteria?: InputMaybe<PropertySearchCriteriaInput>;
};

export type SearchFormResultsPackagesArgs = {
  packageSearchCriteria?: InputMaybe<PackageSearchCriteriaInput>;
  packageType?: InputMaybe<PackageType>;
};

/** Search history grouping day range. */
export type SearchHistoryDayRange =
  /** Grouping using searches made 7 days from most recent search in same region */
  | "SEVEN_DAYS"
  /** Grouping using searches made 3 days from most recent search in same region */
  | "THREE_DAYS";

/** Search history grouping destination type. */
export type SearchHistoryDestinationType =
  /** Grouping using multi_city_vicinity destination type for searches. */
  "METRO_CITY";

/** Data groups details to display. */
export type SearchHistoryDisplayData = {
  __typename?: "SearchHistoryDisplayData";
  /** Image to display. */
  image?: Maybe<Image>;
  /** Localized date range. */
  localizedDateRange?: Maybe<Scalars["String"]>;
  /** Localized trip name. */
  localizedTripName: Scalars["String"];
};

/** Filter criteria details for the searchHistory query. */
export type SearchHistoryFilterCriteria = {
  __typename?: "SearchHistoryFilterCriteria";
  /** Search item end date in yyyy-MM-dd format. */
  endDate: Scalars["String"];
  /** Search item regionId. */
  regionId: Scalars["String"];
  /** Search item region type. */
  regionType?: Maybe<Scalars["String"]>;
  /** Search item start date in yyyy-MM-dd format. */
  startDate: Scalars["String"];
};

/** Filter criteria details for the searchHistory query. */
export interface SearchHistoryFilterCriteriaInput {
  /** Search item end date in yyyy-MM-dd format. */
  endDate: Scalars["String"];
  /** Search item regionId. */
  regionId: Scalars["String"];
  /** Search item region type. */
  regionType?: InputMaybe<Scalars["String"]>;
  /** Search item start date in yyyy-MM-dd format. */
  startDate: Scalars["String"];
}

/** Criteria based on search history groups are created. */
export interface SearchHistoryGroupingCriteriaInput {
  /** Search history grouping based on specified day range. */
  dayRange?: InputMaybe<SearchHistoryDayRange>;
  /** Search history grouping based on specified destination type. */
  destinationType?: InputMaybe<SearchHistoryDestinationType>;
}

/** User Intent corresponding to this Search */
export type SearchIntent = {
  __typename?: "SearchIntent";
  /** DEPRECATED: Customer spinner call no longer made before property search. List of interests coming from Customer Spinner */
  interests?: Maybe<Array<Interest>>;
  /** DEPRECATED. Use semdtl. SEM param, fetch from URL */
  semDtl?: Maybe<Scalars["String"]>;
  /** SEM param, fetch from URL */
  semdtl?: Maybe<Scalars["String"]>;
  /** TEMP Theme param, fetch from URL. Remove after SEM migration is complete */
  theme?: Maybe<Scalars["String"]>;
  /** TEMP intent param, fetch from URL. Support BFF while migration to BEX API */
  userIntent?: Maybe<Scalars["String"]>;
};

/** User Intent corresponding to this Search */
export interface SearchIntentInput {
  /** DEPRECATED: Customer spinner call no longer made before property search. List of interests coming from Customer Spinner */
  interests?: InputMaybe<Array<InterestInput>>;
  /** DEPRECATED. Use semdtl. SEM param, fetch from URL */
  semDtl?: InputMaybe<Scalars["String"]>;
  /** SEM param, fetch from URL */
  semdtl?: InputMaybe<Scalars["String"]>;
  /** TEMP Theme param, fetch from URL. Remove after SEM migration is complete */
  theme?: InputMaybe<Scalars["String"]>;
  /** TEMP intent param, fetch from URL. Support BFF while migration to BEX API */
  userIntent?: InputMaybe<Scalars["String"]>;
}

/** The offer details from the search results page */
export interface SearchOfferInput {
  /** The price of the search results offer */
  offerPrice?: InputMaybe<SearchOfferPriceInput>;
  ratePlanId?: InputMaybe<Scalars["String"]>;
  roomTypeId?: InputMaybe<Scalars["String"]>;
}

/** The offer price from the search results page */
export interface SearchOfferPriceInput {
  /** The encoded multi-item price token */
  multiItemPriceToken?: InputMaybe<Scalars["String"]>;
  /** The timestamp of when the SRP offer price was generated */
  offerTimestamp?: InputMaybe<Scalars["String"]>;
  /** The total price of the search offer */
  price?: InputMaybe<MoneyInput>;
}

export type SearchResultsViewed = {
  __typename?: "SearchResultsViewed";
  event: EgClickstreamEvent;
  search_request: LodgingSearchRequest;
};

/** Enum class to represent the type of seat choice */
export type SeatChoiceType = "SEAT_CHOICE";

/** Cabin dimension details for cabin width calculation */
export type SeatMapCabinDimensionDetails = {
  __typename?: "SeatMapCabinDimensionDetails";
  /** Maximum number of aisles in seat map. */
  aislesCount: Scalars["Int"];
  /** Maximum number of columns in seat map. */
  columnsCount: Scalars["Int"];
  /** Maximum number of exits in seat map. */
  exitsCount: Scalars["Int"];
  /** Number of rows in seat map. */
  rowsCount: Scalars["Int"];
  /** Wing Information */
  wingDetails?: Maybe<SeatMapCabinWingDetails>;
};

/** Wing Information of plane */
export type SeatMapCabinWingDetails = {
  __typename?: "SeatMapCabinWingDetails";
  /** Ending row index for wing to be shown in seat map */
  endRow: Scalars["Int"];
  /** Starting row index for wing to be shown in seat map */
  startRow: Scalars["Int"];
};

/** Represents seat segment for which seat map is to be shown. */
export type SeatSegment = {
  __typename?: "SeatSegment";
  /** Fare Basis Code required for traveler */
  fareBasisCode: Scalars["String"];
  /** This will be used for unique identification of segment */
  identifier: Scalars["String"];
  /** Operating Carrier Code for each segment */
  operatingCarrierCode: Scalars["String"];
};

/** Represents seat segment for which seat map is to be shown. */
export interface SeatSegmentInput {
  /** Fare Basis Code required for traveler */
  fareBasisCode: Scalars["String"];
  /** This will be used for unique identification of segment */
  identifier: Scalars["String"];
  /** Operating Carrier Code for each segment */
  operatingCarrierCode: Scalars["String"];
}

/** Enum class to represent the seat type variant. */
export type SeatVariant =
  | "ACCESSIBLE"
  | "AISLE"
  | "AVAILABLE"
  | "COLUMN"
  | "EXIT"
  | "GALLEY"
  | "PREFERRED"
  | "RESTROOM"
  | "ROW"
  | "SELECTED"
  | "UNAVAILABLE";

export type SecondaryDestination = {
  __typename?: "SecondaryDestination";
  cityName: Scalars["String"];
  ctaLink: Scalars["String"];
};

export type SecondaryReviewLoadingComponent = PriceSummarySkeletons;

export type SecondaryReviewSection = SecondaryReviewSectionLoading | SecondaryReviewSectionSuccess;

/** This represents the components for Secondary section when page is loading */
export type SecondaryReviewSectionLoading = {
  __typename?: "SecondaryReviewSectionLoading";
  /** This has the list of components to render */
  components: Array<SecondaryReviewLoadingComponent>;
};

/** This represents the components for Secondary section when page is success */
export type SecondaryReviewSectionSuccess = {
  __typename?: "SecondaryReviewSectionSuccess";
  /** This has the list of components to render */
  components: Array<SecondaryReviewSuccessComponent>;
};

export type SecondaryReviewSuccessComponent = BannerPlacard | MessagePlacard | PriceSummaryDetails;

export type SecondarySearchFailureComponent = FiltersFailure;

export type SecondarySearchLoadingComponent = FiltersSkeletons;

export type SecondarySearchSection =
  | SecondarySearchSectionFailure
  | SecondarySearchSectionLoading
  | SecondarySearchSectionSuccess;

/** This represents the components for ASIDE section when search failed */
export type SecondarySearchSectionFailure = {
  __typename?: "SecondarySearchSectionFailure";
  /** This has the list of components to render */
  components: Array<SecondarySearchFailureComponent>;
};

/** This represents the components for ASIDE section when search is loading */
export type SecondarySearchSectionLoading = {
  __typename?: "SecondarySearchSectionLoading";
  /** This has the list of components to render */
  components: Array<SecondarySearchLoadingComponent>;
};

/** This represents the components for ASIDE section when search is success */
export type SecondarySearchSectionSuccess = {
  __typename?: "SecondarySearchSectionSuccess";
  /** This has the list of components to render */
  components: Array<SecondarySearchSuccessComponent>;
};

export type SecondarySearchSuccessComponent = Filters;

/** Tabular section in long form text component */
export type SectionRow = {
  __typename?: "SectionRow";
  rowContent?: Maybe<Array<Maybe<PortableTextWithLink>>>;
};

export type SeeMoreAction = AmenitiesDialog | CleanlinessDialog;

export type SelectPackageActionInput = {
  __typename?: "SelectPackageActionInput";
  packageOfferId: Scalars["String"];
};

export type SelectPackageMultiItemShoppingAction = MultiItemShoppingAction & {
  __typename?: "SelectPackageMultiItemShoppingAction";
  packageOfferId: Scalars["String"];
  shoppingContext: ShoppingContext;
};

/** Selected ancillary message template */
export type SelectedAncillaryTemplate = {
  __typename?: "SelectedAncillaryTemplate";
  /** Selected ancillary message localized template */
  template: EgdsLocalizedText;
  /** Selected ancillary message template type */
  type: SelectedAncillaryTemplateType;
};

/** Type for Selected Baggage template */
export type SelectedAncillaryTemplateType = "MULTIPLE" | "NONE" | "ONE";

/** Type used during a product search to specify a given selection like the airline the customer would like to fly with. */
export type SelectedValue = {
  __typename?: "SelectedValue";
  id: Scalars["String"];
  value: Scalars["String"];
};

/** Type used during a product search to specify a given selection like the airline the customer would like to fly with. */
export interface SelectedValueInput {
  id: Scalars["String"];
  value: Scalars["String"];
}

/** SEO Meta Content Wrapper */
export type SeoMetaContent = {
  __typename?: "SeoMetaContent";
  /** SEO canonical Tags */
  canonical?: Maybe<Scalars["String"]>;
  /** SEO meta description */
  description?: Maybe<Scalars["String"]>;
  /** list of open graph protocol properties */
  openGraphList?: Maybe<Array<OpenGraph>>;
  /** SEO Title */
  title?: Maybe<Scalars["String"]>;
};

/** metadata to be used on SERP */
export type SerpMetadata = {
  __typename?: "SerpMetadata";
  /** price range message */
  priceRange?: Maybe<LodgingPlainMessage>;
  /** price rating message */
  priceRating?: Maybe<LodgingPlainMessage>;
};

export type ServiceAutomationAction = ServiceAutomationCancelItemAction | ServiceAutomationOpenDialogAction;

export type ServiceAutomationButton = {
  __typename?: "ServiceAutomationButton";
  action?: Maybe<ServiceAutomationAction>;
  button: EgdsButton;
};

export type ServiceAutomationCancelItem = {
  __typename?: "ServiceAutomationCancelItem";
  dialogButton?: Maybe<ServiceAutomationButton>;
  view?: Maybe<ServiceAutomationView>;
};

export type ServiceAutomationCancelItemAction = {
  __typename?: "ServiceAutomationCancelItemAction";
  conversationId?: Maybe<Scalars["String"]>;
  payload?: Maybe<Scalars["String"]>;
};

export interface ServiceAutomationCancelItemInitInput {
  orderLineId: Scalars["UUID"];
  orderNumber: Scalars["String"];
}

export type ServiceAutomationCancelMutation = {
  __typename?: "ServiceAutomationCancelMutation";
  /**
   * Currently only support lodging cancellations
   * First time calling this service, pass in the orderLineId and orderNumber. This creates a conversation and starts the lodging cancellation process.
   * Every subsequent time calling this service, pass in the conversationId and the payload from the previous response."
   */
  item?: Maybe<ServiceAutomationCancelItem>;
};

export type ServiceAutomationCancelMutationItemArgs = {
  initInput?: InputMaybe<ServiceAutomationCancelItemInitInput>;
  payload?: InputMaybe<Scalars["String"]>;
};

export type ServiceAutomationDialog = EgdsDialog & {
  __typename?: "ServiceAutomationDialog";
  closeAnalytics?: Maybe<ClientSideAnalytics>;
  content?: Maybe<Scalars["String"]>;
  footer?: Maybe<ServiceAutomationDialogFooter>;
  title?: Maybe<Scalars["String"]>;
};

export type ServiceAutomationDialogFooter = {
  __typename?: "ServiceAutomationDialogFooter";
  buttons: Array<ServiceAutomationButton>;
};

export type ServiceAutomationOpenDialogAction = {
  __typename?: "ServiceAutomationOpenDialogAction";
  dialog: ServiceAutomationDialog;
};

export type ServiceAutomationTopLevelMutation = {
  __typename?: "ServiceAutomationTopLevelMutation";
  /** Cancel Mutations */
  cancel: ServiceAutomationCancelMutation;
};

export type ServiceAutomationView = {
  __typename?: "ServiceAutomationView";
  buttons?: Maybe<Array<ServiceAutomationButton>>;
  content?: Maybe<Array<Scalars["String"]>>;
  title?: Maybe<Scalars["String"]>;
};

export type Servicing = {
  __typename?: "Servicing";
  /** Cancel Queries */
  cancel: ServicingCancelQuery;
};

export type ServicingButton = EgdsButton & {
  __typename?: "ServicingButton";
  accessibility?: Maybe<Scalars["String"]>;
  /**
   * @deprecated
   *         UIAction should not be used as a field because it allows for too many possible types.
   *         If need to specify action have the implementation of EGDSButton add a field for action with interface type of less number of possible subtypes
   *         or a union type with a manageable number of members
   *
   */
  action?: Maybe<UiAction>;
  /** Used to capture client side analytics on button click. */
  analytics?: Maybe<ClientSideAnalytics>;
  disabled: Scalars["Boolean"];
  icon?: Maybe<Icon>;
  primary?: Maybe<Scalars["String"]>;
};

export type ServicingCancelQuery = {
  __typename?: "ServicingCancelQuery";
  /** Basic car cancel POC query happy path */
  item: ServicingItemCancel;
};

export type ServicingDialog = EgdsDialog & {
  __typename?: "ServicingDialog";
  closeAnalytics?: Maybe<ClientSideAnalytics>;
  content?: Maybe<Scalars["String"]>;
  footer?: Maybe<EgdsInlineDialogFooter>;
  title?: Maybe<Scalars["String"]>;
};

export type ServicingItemCancel = {
  __typename?: "ServicingItemCancel";
  canCancel: Scalars["Boolean"];
  cancelButton?: Maybe<ServicingButton>;
  dialog?: Maybe<ServicingDialog>;
};

/** Property Share information */
export type ShareInfo = {
  __typename?: "ShareInfo";
  facebookAppId: Scalars["String"];
  linkCopiedMessage: Scalars["String"];
  linkList: Array<LodgingLinkMessage>;
  menuName: Scalars["String"];
  sharedText: Scalars["String"];
};

export interface ShopInsurtechOffersRequestInput {
  /** The cart ID */
  cartId: Scalars["String"];
  /** Client id that refer to the page the user reach out to the module from, e.g.: eg_checkout, car_info_site. */
  insurtechClientId: InsurtechClientId;
  /** list of offer identities to be removed from the main offer (in case of re-shopping) */
  offersToRemove: Array<OfferIdentityInput>;
  /** Residency details to get details according to country and region */
  residencyDetails?: InputMaybe<ResidencyDetailsInput>;
}

export type ShopInsurtechOffersResponse = {
  __typename?: "ShopInsurtechOffersResponse";
  /** The content of the module. */
  insurtechModule: InsurtechModule;
};

export type ShoppedProduct = {
  __typename?: "ShoppedProduct";
  products: MultiItemProducts;
  shoppingPath: ShoppingPathType;
};

export interface ShoppedProductInput {
  products: MultiItemProductsInput;
  shoppingPath: ShoppingPathType;
}

/** Used to display a removable pill for an applied filter. */
export interface ShoppingAppliedFilter {
  /** Used to display a removable pill for an applied filter. */
  filter?: Maybe<EgdsPill>;
  /** Sort and filter criteria that should be used when pill is triggered */
  nextSearchCriteria?: Maybe<ShoppingSearchCriteria>;
}

/** The shopping context used for all search paths, contains the search contexts for the different shopping paths */
export type ShoppingContext = {
  __typename?: "ShoppingContext";
  multiItem?: Maybe<MultiItemContext>;
};

/** The shopping context used for all search paths, contains the search contexts for the different shopping paths */
export interface ShoppingContextInput {
  multiItem?: InputMaybe<MultiItemContextInput>;
}

/** Represents a date selection */
export type ShoppingDateField = ShoppingSortAndFilterField & {
  __typename?: "ShoppingDateField";
  analytics: ClientSideAnalytics;
  end?: Maybe<DateValue>;
  icon?: Maybe<Icon>;
  primary?: Maybe<Scalars["String"]>;
  secondary?: Maybe<Scalars["String"]>;
  start?: Maybe<DateValue>;
};

/**
 * Represents a dropdown selection
 * Example: selecting the sort from a dropdown
 */
export type ShoppingDropdownField = ShoppingSortAndFilterField & {
  __typename?: "ShoppingDropdownField";
  /** Unique identifier */
  id?: Maybe<Scalars["String"]>;
  options: Array<ShoppingSelectableFilterOption>;
  /**
   * Text associated with the field
   * Example: `Sort by`
   */
  primary?: Maybe<Scalars["String"]>;
  secondary?: Maybe<Scalars["String"]>;
};

export type ShoppingGlobal = {
  __typename?: "ShoppingGlobal";
  classType?: Maybe<Scalars["String"]>;
  destinationCode: Scalars["String"];
  destinationName?: Maybe<Scalars["String"]>;
  gaia?: Maybe<Gaia>;
  loyaltyMembership?: Maybe<Scalars["String"]>;
  numAdults?: Maybe<Scalars["Int"]>;
  numChildren?: Maybe<Scalars["Int"]>;
  numInfants?: Maybe<Scalars["Int"]>;
  numSeniors?: Maybe<Scalars["Int"]>;
  numYouth?: Maybe<Scalars["Int"]>;
  originCode?: Maybe<Scalars["String"]>;
  originName?: Maybe<Scalars["String"]>;
  shoppingHotel: ShoppingHotel;
  travelers?: Maybe<Array<Traveler>>;
  tripEndDate?: Maybe<Scalars["String"]>;
  tripEndTime?: Maybe<Scalars["String"]>;
  tripStartDate?: Maybe<Scalars["String"]>;
  tripStartTime?: Maybe<Scalars["String"]>;
};

export type ShoppingGlobalData = {
  __typename?: "ShoppingGlobalData";
  messageContent: ShoppingGlobal;
  schemaName: Scalars["String"];
};

export type ShoppingHotel = {
  __typename?: "ShoppingHotel";
  numRooms: Scalars["Int"];
  rooms: Array<Rooms>;
};

/** Represents a list where several elements can be selected. */
export type ShoppingMultiSelectionField = ShoppingSortAndFilterField & {
  __typename?: "ShoppingMultiSelectionField";
  expando?: Maybe<ShoppingSelectionExpando>;
  /** Unique identifier */
  id?: Maybe<Scalars["String"]>;
  options?: Maybe<Array<ShoppingSelectableFilterOption>>;
  /**
   * Text associated with the field
   * Example: \`Sort By\`
   */
  primary?: Maybe<Scalars["String"]>;
  secondary?: Maybe<Scalars["String"]>;
};

/** Represents a list of tiles where several elements can be selected. Icon and text are horizontally stacked */
export type ShoppingMultiSelectionStackedTileField = ShoppingSortAndFilterField & {
  __typename?: "ShoppingMultiSelectionStackedTileField";
  expando?: Maybe<ShoppingSelectionExpando>;
  options: Array<ShoppingSelectableFilterOption>;
  /**
   * Text associated with the field
   * Example: \`Filter By\`
   */
  primary?: Maybe<Scalars["String"]>;
  secondary?: Maybe<Scalars["String"]>;
};

/** Represents a list of tiles where several elements can be selected. */
export type ShoppingMultiSelectionTileField = ShoppingSortAndFilterField & {
  __typename?: "ShoppingMultiSelectionTileField";
  expando?: Maybe<ShoppingSelectionExpando>;
  options: Array<ShoppingSelectableFilterOption>;
  /**
   * Text associated with the field
   * Example: \`Filter By\`
   */
  primary?: Maybe<Scalars["String"]>;
  secondary?: Maybe<Scalars["String"]>;
};

/**
 *     Represents a grouping of selectable filter options that when selected, present a filter option mutually exclusive of the remaining options
 * Example: radio buttons for mutually exclusive nightly and total price range sliders
 */
export type ShoppingMutexField = ShoppingSortAndFilterField & {
  __typename?: "ShoppingMutexField";
  /** Unique identifier */
  id?: Maybe<Scalars["String"]>;
  /** List of associated mutually exclusive field options */
  options?: Maybe<Array<ShoppingMutexFieldOption>>;
  /**
   * Text associated with the field
   * Example: `Price`
   */
  primary?: Maybe<Scalars["String"]>;
  secondary?: Maybe<Scalars["String"]>;
};

/**
 *     Represents a filter option of which the exposition is dependent on the selection of filter option
 * Example: radio buttons for mutually exclusive nightly and total price range sliders
 */
export type ShoppingMutexFieldOption = {
  __typename?: "ShoppingMutexFieldOption";
  /** A filter field to be presented upon selection */
  option: ShoppingSortAndFilterField;
  /** A selectable filter option that, when selected, will display the filter field */
  value: ShoppingSelectableFilterOption;
};

export type ShoppingPathPrimersQuery = MultiItemDetailsPrimersQuery & {
  __typename?: "ShoppingPathPrimersQuery";
  primers: MishopDetailsUiPrimer;
};

/** Indicate the shopping path of a given offer */
export type ShoppingPathType = "ATTACH" | "PACKAGE" | "STANDALONE";

/**
 * https://www.figma.com/file/SmX3PPNN3Yb0cFWvrfTdTH/Web-Hand-off-%2F-Air-Smart-Shopping?node-id=50%3A7916
 * Represents a list of filters in pill view where several elements can be selected.
 */
export type ShoppingPillSelectionField = ShoppingSortAndFilterField & {
  __typename?: "ShoppingPillSelectionField";
  /** Unique identifier */
  id?: Maybe<Scalars["String"]>;
  options?: Maybe<Array<ShoppingSelectableFilterOption>>;
  primary?: Maybe<Scalars["String"]>;
  secondary?: Maybe<Scalars["String"]>;
};

/** Represents a quick filter group or a toggleable filter. */
export interface ShoppingQuickAccessFilter {
  /** Pill used to represent the quick filter. */
  filterPill?: Maybe<EgdsPill>;
}

/** Representative values for a range / slider. */
export type ShoppingRangeCharacteristics = {
  __typename?: "ShoppingRangeCharacteristics";
  labels?: Maybe<Array<ShoppingRangeLabel>>;
  max: Scalars["Int"];
  maxLabel: Scalars["String"];
  min: Scalars["Int"];
  minLabel: Scalars["String"];
  step: Scalars["Int"];
};

/**
 * Represents the selection of a range of values.
 * Example: selecting the price of a flight within 2 values
 */
export type ShoppingRangeField = ShoppingSortAndFilterField & {
  __typename?: "ShoppingRangeField";
  /** Unique identifier */
  id?: Maybe<Scalars["String"]>;
  /**
   * Text associated with the field
   * Example: `Your budget`
   */
  primary?: Maybe<Scalars["String"]>;
  /** Configuration for the visual representation including boundaries and primarys */
  range?: Maybe<ShoppingRangeFilterOption>;
  secondary?: Maybe<Scalars["String"]>;
};

export type ShoppingRangeFilterOption = ShoppingSortAndFilterOption & {
  __typename?: "ShoppingRangeFilterOption";
  analytics?: Maybe<ClientSideAnalytics>;
  /**
   * Informs about the outter value for the range.
   * Example: min value could be \`100\` and max value \`1000\` with a spacing out of \`10\`
   */
  characteristics: ShoppingRangeCharacteristics;
  /** List of signals emitted by this option */
  emitters?: Maybe<Array<SortAndFilterSignalEmitter>>;
  graphic?: Maybe<UiGraphic>;
  /** @deprecated Replaced with UIGraphic */
  icon?: Maybe<Icon>;
  id: Scalars["String"];
  primary: Scalars["String"];
  /** List of signals this option listens to */
  receivers?: Maybe<Array<SortAndFilterSignalReceiver>>;
  secondary?: Maybe<Scalars["String"]>;
  /** Informs about the preselected values */
  selected: RangeValue;
};

/**
 * Provides formatted value to be displayed when user selects a value
 * Example: selected value could be \`10\` then formatted value will be \`US $10\`
 */
export type ShoppingRangeLabel = {
  __typename?: "ShoppingRangeLabel";
  label: Scalars["String"];
  value: Scalars["Int"];
};

/** Key/Value elements that describes the search criteria often displayed to the customer as filters */
export type ShoppingSearchCriteria = {
  __typename?: "ShoppingSearchCriteria";
  booleans?: Maybe<Array<BooleanValue>>;
  counts?: Maybe<Array<NumberValue>>;
  dates?: Maybe<Array<DateValue>>;
  ranges?: Maybe<Array<RangeValue>>;
  selections?: Maybe<Array<SelectedValue>>;
};

/** Key/Value elements that describes the search criteria often displayed to the customer as filters */
export interface ShoppingSearchCriteriaInput {
  booleans?: InputMaybe<Array<BooleanValueInput>>;
  counts?: InputMaybe<Array<NumberValueInput>>;
  dates?: InputMaybe<Array<DateValueInput>>;
  ranges?: InputMaybe<Array<RangeValueInput>>;
  selections?: InputMaybe<Array<SelectedValueInput>>;
}

export type ShoppingSelectableFilterOption = ShoppingSortAndFilterOption & {
  __typename?: "ShoppingSelectableFilterOption";
  /**
   * Accessibility string for screenreader users to know what this filter does
   * Example: screenreaders would read \`15 Economy cars from $50\` for a filter that only shows Economy cars, and there are 15 of them starting from $50
   */
  accessibility?: Maybe<Scalars["String"]>;
  /** @deprecated Use selectAnalytics and deselectAnalytics instead */
  analytics: ClientSideAnalytics;
  /**
   * Would be true if this option is to be selected when user taps on clear action from toolbar.
   * Example: using \`Recommended\` as the default sorting option.
   */
  default: Scalars["Boolean"];
  /**
   * Describe/Add more information to the field.
   * Example: for primary text \`Business friendly\`, the decription could be \`See properties with amenities to help you work comfortably, like WiFi and breakfast.\`
   */
  description?: Maybe<Scalars["String"]>;
  deselectAnalytics: ClientSideAnalytics;
  /** Indicates whether the option should be display as disabled and therefore cannot be selected by the customer */
  disabled: Scalars["Boolean"];
  /** List of signals emitted by this option */
  emitters?: Maybe<Array<SortAndFilterSignalEmitter>>;
  graphic?: Maybe<UiGraphic>;
  /** @deprecated Replaced with UIGraphic */
  icon?: Maybe<Icon>;
  /**
   * Identifier used for any selectable sort or filter option.
   * Example: \`amenity\` or \`location\`
   */
  id: Scalars["String"];
  /**
   * To support more than 1 level of filtering within a particular filter option.
   * Allow to add nested options for category/subcategory combo.
   */
  nestedOptions: Array<ShoppingSelectableFilterOption>;
  primary: Scalars["String"];
  /** List of signals this option listens to */
  receivers?: Maybe<Array<SortAndFilterSignalReceiver>>;
  secondary?: Maybe<Scalars["String"]>;
  selectAnalytics: ClientSideAnalytics;
  /**
   * Would be true if this option has to be selected on load of screen.
   * Example: using \`Price\` as the selected sorting option.
   */
  selected: Scalars["Boolean"];
  /**
   * Technical representation of the selectable option.
   * Example: \`downtown\` for a \'location\` or \`free_parking\` for an \`amenity\`
   */
  value: Scalars["String"];
};

/** Represents an individual selected filter. */
export type ShoppingSelectedFilter = ShoppingAppliedFilter & {
  __typename?: "ShoppingSelectedFilter";
  /** List of signals emitted by this option */
  emitters?: Maybe<Array<SortAndFilterSignalEmitter>>;
  filter?: Maybe<EgdsPill>;
  nextSearchCriteria?: Maybe<ShoppingSearchCriteria>;
};

/** Represents a field that will hold selected filter pills. */
export type ShoppingSelectedFiltersField = ShoppingSortAndFilterField & {
  __typename?: "ShoppingSelectedFiltersField";
  /**
   * Text associated with the field
   * Example: \`Your selections\`
   */
  primary?: Maybe<Scalars["String"]>;
  /** List of signals this field listens to */
  receivers?: Maybe<Array<SortAndFilterSignalReceiver>>;
  secondary?: Maybe<Scalars["String"]>;
  shoppingSelectedFilters?: Maybe<Array<ShoppingSelectedFilter>>;
};

/** Controls how a expanded link should appear. */
export type ShoppingSelectionExpando = {
  __typename?: "ShoppingSelectionExpando";
  /** @deprecated Use expandAnalytics and collapseAnalytics instead */
  analytics: ClientSideAnalytics;
  collapseAnalytics: ClientSideAnalytics;
  /** Text appearing when expanded eg: 'See less' */
  collapseLabel: Scalars["String"];
  expandAnalytics: ClientSideAnalytics;
  /** Text appearing when collapsed eg: 'See more' */
  expandLabel: Scalars["String"];
  /**
   * The minimal height of the expando in its collapsed state.
   * For web platforms the associated unit would be in pixels as per the [UTIK-React doc](http://uitk-react.tools.expedia.com/expedia/en_US/components/expando).
   * While for mobile native app platforms the unit would be a number of elements (see the respective documentations).
   */
  minimalHeight?: Maybe<Scalars["Int"]>;
  /**
   * Controls under which condition the expando should appear. It's the minimum value required for the expando to be active.
   * For web platforms the associated unit would be in pixels as per the [UTIK-React doc](http://uitk-react.tools.expedia.com/expedia/en_US/components/expando).
   * While for mobile native app platforms the unit would be a number of elements (see the respective documentations).
   */
  threshold?: Maybe<Scalars["Int"]>;
  /** Should the expando be visible by default */
  visible?: Maybe<Scalars["Boolean"]>;
};

/** Represents a list where only a single element can be selected. */
export type ShoppingSelectionField = ShoppingSortAndFilterField & {
  __typename?: "ShoppingSelectionField";
  expando?: Maybe<ShoppingSelectionExpando>;
  /** Unique identifier */
  id?: Maybe<Scalars["String"]>;
  options?: Maybe<Array<ShoppingSelectableFilterOption>>;
  /**
   * Text associated with the field
   * Example: \`Sort By\`
   */
  primary?: Maybe<Scalars["String"]>;
  secondary?: Maybe<Scalars["String"]>;
};

/** Used to describe an action on Sort and Filter Modal. */
export type ShoppingSortAndFilterAction = UiAction & {
  __typename?: "ShoppingSortAndFilterAction";
  accessibility?: Maybe<Scalars["String"]>;
  actionType: ShoppingSortAndFilterActionType;
  analytics: ClientSideAnalytics;
};

/** Valid actions on Sort and Filter Modal */
export type ShoppingSortAndFilterActionType =
  /** Stay on the Sort & Filter Modal but set to default state. Eg used for clear button */
  | "CLEAR_DATA"
  /** Close Sort & Filter Modal and apply user selected filters. Eg used for Apply/Done buttons */
  | "CLOSE_AND_APPLY"
  /** Close Sort & Filter Modal. Eg used for Back/Cross buttons */
  | "CLOSE_AND_DO_NOT_APPLY"
  /**
   * Open the modal window associated with the component on which action has been performed.
   * Example: on click of Sort & Filter reveal button it should open Sort & Filter Modal and
   *        on click of Input Field it should open Typeahead Modal
   */
  | "OPEN_MODAL";

/** Used to display a removable pill for an applied filter. */
export interface ShoppingSortAndFilterAppliedFilter {
  /** sort and filter criteria that should be used when pill is triggered */
  nextSearchCriteria: ShoppingSearchCriteria;
  /** Used to display a removable pill for an applied filter. */
  pill: UiRemovablePill;
}

/** A container specific to a particular view. */
export interface ShoppingSortAndFilterContainer {
  /** Used to identify the view of the Sort and Filter. */
  view: SortAndFiltersViewType;
}

/** Represents a dialog container for a specific Sort and Filter view. */
export type ShoppingSortAndFilterDialogContainer = ShoppingSortAndFilterContainer & {
  __typename?: "ShoppingSortAndFilterDialogContainer";
  /**
   * Defines a button on tap of which Sort and Filter selections will be applied and modal will be closed.
   * Usually displays the action name. Example "Done"
   */
  applyAction?: Maybe<UiFloatingActionButton>;
  /**
   * Defines a button on tap of which Sort and Filter modal window is displayed.
   * Usually displays the count of filters applied and action name. Example "(2) Filter"
   */
  revealAction?: Maybe<UiFloatingActionButton>;
  /**
   * The toolbar is shown on the top of the sort and filter modal window.
   * Usually consisting of close action, title and clear action.
   */
  toolbar?: Maybe<UiToolbar>;
  view: SortAndFiltersViewType;
};

/**
 * A field is a representation of a given sort, search or filter.
 * It indicates the UI treatment to apply and the possible values.
 * Possible values are explicitly defined in each implementation of the interface.
 */
export interface ShoppingSortAndFilterField {
  /** Example: Property class, Stops, Your budget, Departure time */
  primary?: Maybe<Scalars["String"]>;
  /** Example: From */
  secondary?: Maybe<Scalars["String"]>;
}

/** An option represents what can be selected by the user to filter some results */
export interface ShoppingSortAndFilterOption {
  /** The presence of this field indicates that client side interactions such as \`click\` should be tracked. */
  analytics?: Maybe<ClientSideAnalytics>;
  /** Icon or Mark that provides a visual description of the filter. e.g. a Mark that displays a VIP token next to the VIP filter label */
  graphic?: Maybe<UiGraphic>;
  /** @deprecated we are replacing icon with UIGraphic, which is a union type of Icon, Illustration and Mark */
  icon?: Maybe<Icon>;
  /**
   * Ties back the option to the effective sort or filter it belong to. Example: 'prices' or 'departure_time'
   * The \`id\`is repeated in each option so a \`SortAndFilterField\` can mix multiple elements.
   * For example, \`Popular filters\` contains amenities, location etc.
   * It's then easier to reuse the same option accros multiple filter and being sure they are applied identically.
   */
  id: Scalars["String"];
  /**
   * Primary textual representation.
   * Examples: \`Price\`, \`Nonstop\`, \`Tour & sightseeing\`
   */
  primary: Scalars["String"];
  /**
   * Used to inform the customer about extra information for this option.
   * For instance the minimum price of a type of car or for flights with 1 stop.
   */
  secondary?: Maybe<Scalars["String"]>;
}

/**
 * Represents a filter group and it's associated UI.
 * Interacting with a group will show a version of the sort and filter panel with a subset of
 * filter options for the particular group. This may be presented in different containers eg.
 * a popup (desktop) or dialog on mobile breakpoints.
 */
export type ShoppingSortAndFilterQuickFilter = ShoppingQuickAccessFilter & {
  __typename?: "ShoppingSortAndFilterQuickFilter";
  /**
   * Defines a button on tap of which Sort and Filter selections will be applied and quick filter will be closed.
   * Usually displays the action name. Example "Done"
   */
  applyAction?: Maybe<EgdsButton>;
  /**
   * This property would be used by clients when displaying on screens with larger width.
   * It will contain a longer text to be displayed beside applied filter pills.
   * Example "Clear all filters"
   */
  clearAll?: Maybe<EgdsButton>;
  /** Filter content to be displayed when this quick filter pill is interacted with. */
  fields: Array<ShoppingSortAndFilterField>;
  filterPill?: Maybe<EgdsPill>;
  /** Number of hits a search with the currently active filters would result in. */
  resultCountLabel?: Maybe<Scalars["String"]>;
  /**
   * The toolbar is shown on the top of the sort and filter quick filter.
   * Usually consisting of close action, title and clear action.
   */
  toolbar?: Maybe<UiToolbar>;
};

export type ShoppingSortAndFilterSection = {
  __typename?: "ShoppingSortAndFilterSection";
  fields: Array<ShoppingSortAndFilterField>;
  /** Can be used for identify the sort or filter section. */
  id?: Maybe<Scalars["String"]>;
  /**
   * Can be used for displaying a seconday message if needed
   * Example "No filter options available"
   */
  subTitle?: Maybe<Scalars["String"]>;
  title?: Maybe<Scalars["String"]>;
};

/** Represents an option which may be presented to the user as a toggleable quick filter */
export type ShoppingSortAndFilterToggleFilter = ShoppingQuickAccessFilter & {
  __typename?: "ShoppingSortAndFilterToggleFilter";
  filterPill?: Maybe<EgdsPill>;
  /** Filter option to be toggled on interaction */
  option: ShoppingSortAndFilterOption;
};

/**
 * Page level elements describing which sort & filters can be applied
 * and what are the key elements to use if they are displayed in a modal.
 */
export type ShoppingSortAndFilters = {
  __typename?: "ShoppingSortAndFilters";
  /** @deprecated Use revealAction.badge */
  appliedFilterCount: Scalars["Int"];
  /**
   * Used to display removable pills for all filters applied.
   * @deprecated Use `filtersApplied` instead for displaying removable pills for filters applied.
   */
  appliedFilters?: Maybe<Array<ShoppingSortAndFilterAppliedFilter>>;
  /**
   * Defines a button on tap of which Sort and Filter selections will be applied and modal will be closed.
   * Usually displays the action name. Example "Done"
   * @deprecated Use `containers` instead.
   */
  applyAction?: Maybe<UiFloatingActionButton>;
  /**
   * This property would be used by clients when displaying on screens with larger width.
   * It will contain a longer text to be displayed beside applied filter pills.
   * Example "Clear all filters"
   */
  clearAll?: Maybe<UiTertiaryButton>;
  /** @deprecated Use toolbar.actions.secondaries */
  clearButtonTitle: Scalars["String"];
  /** @deprecated Use toolbar.actions.primary */
  close: Icon;
  /** A list of containers holding Sort and Filter sections. */
  containers?: Maybe<Array<ShoppingSortAndFilterContainer>>;
  /**
   * The section is the list of filters used to refine a primary search.
   * Often displayed on the left side of the page or in a modal window for small breakpoints.
   */
  filterSections?: Maybe<Array<ShoppingSortAndFilterSection>>;
  /** List of removable pills to display all the applied filters */
  filtersApplied?: Maybe<Array<ShoppingAppliedFilter>>;
  /**
   * The footerLabel (results count) displays the number of available properties
   * that will be shown when the filters are applied.
   */
  footerLabel?: Maybe<Scalars["String"]>;
  /** List of quick access filters to be displayed outside of a modal. */
  quickAccessFilters?: Maybe<Array<ShoppingQuickAccessFilter>>;
  /**
   * Defines a button on tap of which Sort and Filter modal window is displayed.
   * Usually displays the count of filters applied and action name. Example "(2) Filter"
   * @deprecated Use `containers` instead.
   */
  revealAction?: Maybe<UiFloatingActionButton>;
  /** @deprecated Use sortSections and filterSections separately */
  sections: Array<ShoppingSortAndFilterSection>;
  /**
   * The section is the list of sort options used to sort a primary search.
   * Often displayed on the page or in a modal window along with filters for small breakpoints.
   */
  sortSections?: Maybe<Array<ShoppingSortAndFilterSection>>;
  /** @deprecated Use toolbar.primary */
  title: Scalars["String"];
  /**
   * The toolbar is shown on the top of the sort and filter modal window.
   * Usually consisting of close action, title and clear action.
   * @deprecated Use `containers` instead.
   */
  toolbar?: Maybe<UiToolbar>;
};

/**
 * Represents a selection using increase and decrease button
 * Figma Step input: https://www.figma.com/file/L4BMgfIGUiqx0zM5yBVBxv/Step-input?node-id=1%3A2
 * Example: selecting the minimum number of bathrooms required
 * Figma rooms & spaces: https://www.figma.com/file/KXdsxyrx5mrCzkr5CnXwkH/Vrbex-Filters?node-id=541%3A69748
 */
export type ShoppingStepInputField = ShoppingSortAndFilterField & {
  __typename?: "ShoppingStepInputField";
  /** Accessibility string that describes this field */
  accessibility?: Maybe<Scalars["String"]>;
  /** List of signals emitted by this field */
  emitters?: Maybe<Array<SortAndFilterSignalEmitter>>;
  /** Unique identifier */
  id?: Maybe<Scalars["String"]>;
  primary?: Maybe<Scalars["String"]>;
  /** List of signals this field listens to */
  receivers?: Maybe<Array<SortAndFilterSignalReceiver>>;
  secondary?: Maybe<Scalars["String"]>;
  /** Input used to select desired value for this filter */
  stepInput: EgdsBasicStepInput;
};

/**
 * https://www.figma.com/file/SmX3PPNN3Yb0cFWvrfTdTH/Web-Hand-off-%2F-Air-Smart-Shopping?node-id=50%3A7916
 * Represents a tab view of options where only a single element can be selected.
 */
export type ShoppingTabSelectionField = ShoppingSortAndFilterField & {
  __typename?: "ShoppingTabSelectionField";
  /** Unique identifier */
  id?: Maybe<Scalars["String"]>;
  options?: Maybe<Array<ShoppingSelectableFilterOption>>;
  primary?: Maybe<Scalars["String"]>;
  secondary?: Maybe<Scalars["String"]>;
};

/**
 * Represent a field expecting the user to enter some text.
 * Example: the \`search by activity name\` field used for Activities.
 */
export type ShoppingTextInputField = ShoppingSortAndFilterField & {
  __typename?: "ShoppingTextInputField";
  action?: Maybe<ShoppingSortAndFilterAction>;
  analytics: ClientSideAnalytics;
  /** Eventual icon to apply at the end of input value. */
  clearIcon?: Maybe<Icon>;
  /** Eventual icon to apply alongside the placeholder. */
  icon?: Maybe<Icon>;
  /**
   * Logical identifier associated with what has been typed by the user.
   * The identifier is used when applying the filter.
   */
  id: Scalars["String"];
  /**
   * Describe the input field.
   * Example: \`Activity name\`
   */
  label?: Maybe<Scalars["String"]>;
  /**
   * Informs about the preselected values
   * Example: \`Hilton\`, \`Hyatt\`, \`Ramada\`
   * @deprecated Use multiSelections
   */
  multiSelected?: Maybe<Array<Scalars["String"]>>;
  /** Describes the preselected multi-select locations */
  multiSelections?: Maybe<Array<ShoppingTextMultiSelection>>;
  /**
   * Default text to display in the input field to guide the user on what information is expected.
   * Example: \`Enter activity name\`
   */
  placeholder?: Maybe<Scalars["String"]>;
  /** Example: `Search for activities` */
  primary?: Maybe<Scalars["String"]>;
  secondary?: Maybe<Scalars["String"]>;
  /**
   * Informs about the preselected values
   * Example: \`Hilton\`
   */
  selected?: Maybe<Scalars["String"]>;
  /** Typeahead setup */
  typeaheadInfo?: Maybe<TypeaheadInfo>;
};

/** Provides information about the multi select locations */
export type ShoppingTextMultiSelection = {
  __typename?: "ShoppingTextMultiSelection";
  /**
   * Informs about the preselected values
   * Example: \`Hilton\`, \`Hyatt\`, \`Ramada\`
   */
  text: Scalars["String"];
  /**
   * Optional value or a code associated with the text which can be used to uniquely identify the selection
   * Example: miami-florida, seattle-washington
   */
  value?: Maybe<Scalars["String"]>;
};

/** Short list model */
export type ShortList = {
  __typename?: "ShortList";
  /** UI representation of the Favorite Button */
  button: LodgingToggle;
  /** @deprecated DO NOT USE! - ShortList clickTracking will be moved to UCS */
  clickTracking: Array<ShortListDataMap>;
  /** Indicates if the property was saved/favorited */
  favorited: Scalars["Boolean"];
  /** @deprecated Don't use this, it's no longer necessary. */
  metaData: ShortListMetaData;
  /** Url to post the remove action */
  removeUrl: Scalars["String"];
  /** Url to post the save action */
  saveUrl: Scalars["String"];
  /** UI representation of the Item Saved notification */
  toast?: Maybe<LodgingToastMessage>;
};

export type ShortListDataMap = AllHotelProductsData | ShoppingGlobalData;

/** Metadata about the short list product and search dates */
export type ShortListMetaData = {
  __typename?: "ShortListMetaData";
  /** Searched check-in dates */
  chkIn: Scalars["String"];
  /** Searched check-out dates */
  chkOut: Scalars["String"];
  /** Property Id of the product shortlisted */
  hotelId: Scalars["String"];
  /** Searched room configuration */
  roomConfiguration: Scalars["String"];
};

export type Shortlist = {
  __typename?: "Shortlist";
  /** Fetch detailed list of shortlisted items */
  details?: Maybe<Array<ShortlistItem>>;
  /** Fetch summary list of shortlisted items */
  summaries?: Maybe<Array<ShortlistSummaryItem>>;
};

export type ShortlistDetailsArgs = {
  destinationFilter?: InputMaybe<ShortlistDestinationFilterInput>;
  productType?: InputMaybe<ProductType>;
};

export type ShortlistSummariesArgs = {
  productType?: InputMaybe<ProductType>;
};

export interface ShortlistDestinationFilterInput {
  /** Region type that will ultimately determined filtered results. Default is MULTI_CITY_VICINITY */
  destinationType: RegionType;
  /** Gaia region ID for which we want to filter shortlisted results. Does not have to match region type, but will be used to find the relevant destination type based on region type provided */
  regionId: Scalars["String"];
}

/** Flight-specific shortlist info */
export type ShortlistFlight = ProductInfo & {
  __typename?: "ShortlistFlight";
  /** Date Display String for the searched flight (e.g. Mar 8, 2019 - Mar 12, 2019) */
  dateDisplayString?: Maybe<Scalars["String"]>;
  /** Origin/Destination string (e.g. 'Seattle (SEA) to New York (NYC)') */
  originDestination?: Maybe<Scalars["String"]>;
  /** The type of route searched */
  routeType?: Maybe<RouteType>;
  type?: Maybe<ProductType>;
};

/** Shortlist info for generic product types */
export type ShortlistGeneric = ProductInfo & {
  __typename?: "ShortlistGeneric";
  type?: Maybe<ProductType>;
};

/** Response container for detail fetches */
export type ShortlistItem = {
  __typename?: "ShortlistItem";
  /** Description of the shortlisted item */
  description?: Maybe<Scalars["String"]>;
  /** Unique identifier of the shortlisted item */
  id?: Maybe<Scalars["String"]>;
  /** Link to the image for the shortlisted item */
  imageURL?: Maybe<Scalars["URL"]>;
  /** Last modified date of the shortlisted item */
  lastModifiedDate?: Maybe<DateTime>;
  /** URL link to the info page for the shortlisted item */
  link?: Maybe<Scalars["URL"]>;
  /** Optional key/value pairs provided by the client for playback */
  metadata?: Maybe<Array<ShortlistMetadata>>;
  /** Product Id of the shortlisted item */
  productId: Scalars["String"];
  /** Product specific information related to the shortlisted item (e.g. Property Information) */
  productInfo?: Maybe<ProductInfo>;
  /** Product Type of the shortlisted item */
  productType?: Maybe<ProductType>;
  /** Title of the shortlisted item (e.g. property name or activity title) */
  title?: Maybe<Scalars["String"]>;
};

/** Key/Value pairs of data required by the client for playback. (Optional) */
export type ShortlistMetadata = {
  __typename?: "ShortlistMetadata";
  key: Scalars["String"];
  value: Scalars["String"];
};

/** Key/Value pairs of data required by the client for playback. (Optional) */
export interface ShortlistMetadataInput {
  key: Scalars["String"];
  value: Scalars["String"];
}

/** Property-specific shortlist info */
export type ShortlistProperty = ProductInfo & {
  __typename?: "ShortlistProperty";
  /** The rating for a property submitted by guests */
  guestRating?: Maybe<ShortlistRating>;
  /** Number of reviews submitted */
  numReviews?: Maybe<ShortlistReviews>;
  /** Price for the shortlisted property */
  price?: Maybe<Money>;
  /** Region Id that the property is located in */
  regionId?: Maybe<Scalars["String"]>;
  /** Name of the region that the property is located in */
  regionName?: Maybe<Scalars["String"]>;
  /** Star rating of the shortlisted property */
  star?: Maybe<Scalars["Float"]>;
  type?: Maybe<ProductType>;
};

/** Rating information provided by guests. */
export type ShortlistRating = {
  __typename?: "ShortlistRating";
  /** Overall rating provided by guests (out of 5). */
  ratingOverall?: Maybe<Scalars["Float"]>;
};

/** Review information provided by guests. */
export type ShortlistReviews = {
  __typename?: "ShortlistReviews";
  /** Total number of reviews submitted. */
  total?: Maybe<Scalars["Int"]>;
};

/** A single shortlisted summary item */
export type ShortlistSummaryItem = {
  __typename?: "ShortlistSummaryItem";
  /** The product's unique identifier */
  productId: Scalars["String"];
  /** The product type of the item */
  productType?: Maybe<ProductType>;
};

/** For expanding and collapsing dropdown by default */
export type ShowDropdownOptions = {
  __typename?: "ShowDropdownOptions";
  isDropDownVisible?: Maybe<ActionDetailsType>;
};

/** Similar properties */
export type SimilarProperties = {
  __typename?: "SimilarProperties";
  /** Text to describe the module */
  footer?: Maybe<Scalars["String"]>;
  /** Accessibility Button Texts */
  galleryCarousel?: Maybe<EgdsGalleryCarousel>;
  /** Similar properties module header */
  header?: Maybe<Scalars["String"]>;
  /** AdaptEx client side tracking */
  lodgingClientSideAnalyticsSuccess?: Maybe<LodgingClientSideAnalyticsSuccess>;
  /** Clickstream recommendations analytics tracking */
  lodgingRecommendationClickstreamEvent?: Maybe<LodgingRecommendationClickstreamEvent>;
  /** list of similar properties */
  properties: Array<SimilarProperty>;
  /**
   * Response ID of the recommendations response
   * @deprecated Will be replaced by lodgingRecommendationClickstreamEvent
   */
  recommendationsResponseId?: Maybe<Scalars["String"]>;
  /** Message consisting of plain text. */
  selectionOptions?: Maybe<LodgingSimilarSelectionOptions>;
};

export type SimilarPropertiesDeals = {
  __typename?: "SimilarPropertiesDeals";
  /** Tracking analytics */
  analytics?: Maybe<ClientSideAnalytics>;
  /** Carousel UI component action */
  carouselActions?: Maybe<CarouselActions>;
  /** Module's header */
  header?: Maybe<Scalars["String"]>;
  /** List of property offers */
  propertyOffers?: Maybe<Array<PropertyOfferItem>>;
};

/** Similar property */
export type SimilarProperty = {
  __typename?: "SimilarProperty";
  /** Action */
  action: MessagingAction;
  /**
   * Feature message
   * @deprecated Deprecated in favour of featuredMessages
   */
  featuredMessage?: Maybe<LodgingEnrichedMessage>;
  /** Feature messages */
  featuredMessages: Array<EgdsGraphicText>;
  /** Property's image */
  image?: Maybe<PropertyImage>;
  /** List of the amenities */
  items: Array<LodgingEnrichedMessage>;
  /** Price information */
  price?: Maybe<SimilarPropertyPriceInfo>;
  /**
   * Property's ID
   * @deprecated Used only for tracking, and will be removed in the future.
   */
  propertyId?: Maybe<Scalars["String"]>;
  /** Reviews */
  reviews?: Maybe<PropertyReviewsSummary>;
  /** Title */
  title: LodgingHeader;
};

/** Similar property's price information */
export type SimilarPropertyPriceInfo = {
  __typename?: "SimilarPropertyPriceInfo";
  /** Property's price information */
  price: PropertyPrice;
  /** This field shows the qualifier of the price */
  qualifier?: Maybe<LodgingEnrichedMessage>;
  /** This field shows the estimated date */
  subText?: Maybe<LodgingHeader>;
};

export type SimpleItem = Item & {
  __typename?: "SimpleItem";
  text: Scalars["String"];
};

/** Property change selection with action, label, and accessibility */
export type SimpleStepIndicatorChangeSelection = StepIndicatorChangeSelection & {
  __typename?: "SimpleStepIndicatorChangeSelection";
  a11yLabel: Scalars["String"];
  action: UiLinkAction;
  label: Scalars["String"];
  multiItemShoppingAction?: Maybe<MultiItemShoppingAction>;
};

/** Simplest form of a label that has optional detail text */
export type SimpleStepIndicatorLabel = StepIndicatorLabel & {
  __typename?: "SimpleStepIndicatorLabel";
  detailText?: Maybe<Scalars["String"]>;
  text: Scalars["String"];
};

/** An input validation that tests if an input has a valid email address */
export type SingleEmailValidation = EgdsInputValidation & {
  __typename?: "SingleEmailValidation";
  errorMessage: Scalars["String"];
};

/** Single Unit VR Offer */
export type SingleUnitOfferDetails = AccessibilityField & {
  __typename?: "SingleUnitOfferDetails";
  accessibilityLabel?: Maybe<Scalars["String"]>;
  availabilityCallToAction?: Maybe<AvailabilityCallToAction>;
  displayPrice?: Maybe<DisplayPriceSummaryItem>;
  id: Scalars["String"];
  /** @deprecated Use accessibilityLabel, replace with accessibilityLabel */
  label?: Maybe<Scalars["String"]>;
  ratePlans?: Maybe<Array<Maybe<RatePlan>>>;
  totalPrice?: Maybe<TotalPriceSummary>;
  view?: Maybe<Scalars["String"]>;
};

/** Single Unit VR Offer Dialog box */
export type SingleUnitOfferDialog = LodgingDialog & {
  __typename?: "SingleUnitOfferDialog";
  content: SingleUnitOfferDetails;
  toolbar: LodgingDialogToolbar;
  trigger: LodgingDialogTriggerMessage;
};

export type SiteConfiguration = {
  __typename?: "SiteConfiguration";
  /** Domain of the site, e.g www.expedia.com for Expedia US */
  domain: Scalars["String"];
  /** The Expedia Affiliate Partner ID */
  eapid: Scalars["Int"];
  /** The context Site ID, e.g. (70201 for Orbitz) */
  siteId: Scalars["Int"];
  /** Travel Product ID. For the most part, a TPID represents a country/currency combination, and in many cases, are separated by Brand (Expedia, Travelocity, Orbitz, etc). */
  tpid: Scalars["Int"];
};

/** Input argument for Sites configurations request */
export interface SiteConfigurationsRequestInput {
  /** List of Site IDs to retrieve site information for */
  siteIds: Array<Scalars["Int"]>;
}

/** Set of site identifiers used by front end applications */
export type SiteContext = {
  __typename?: "SiteContext";
  /** The site's brand identifier. e.g. expedia, orbitz, hotels */
  brandId: Scalars["String"];
  /** The domain in the context request (e.g. www.expedia.com) */
  domain: Scalars["String"];
  /** Resolved LangId from SiteContext, LangId should be considered deprecated and you should try and replace with the usage of locale instead of using the LangId. */
  langId: Scalars["Int"];
  /** Human readable site identifier used throughout EG Platform stack for observability and data. e.g. EXPEDIA_US */
  pointOfSaleId: Scalars["String"];
  /** User preference for data sharing with third parties which users may update */
  privacySellState: PrivacySellState;
  /** Short date format for a given request context */
  shortDateFormat: Scalars["String"];
  /** Travel Product ID. For the most part, a TPID represents a country/currency combination, and in many cases, are separated by Brand (Expedia, Travelocity, Orbitz, etc). */
  tpid: Scalars["Int"];
  /** The site's ui brand identifier used for ui theming whitelabels. e.g. for EPS, [brandId = 'gps', uiBrandId = 'marriott']  */
  uiBrandId: Scalars["String"];
};

export type SleepingArrangement = {
  __typename?: "SleepingArrangement";
  spaces?: Maybe<Array<SleepingArrangementSpace>>;
  title: Scalars["String"];
};

export type SleepingArrangementLayout = {
  __typename?: "SleepingArrangementLayout";
  description: Scalars["String"];
  icons?: Maybe<Array<Icon>>;
};

export type SleepingArrangementSpace = {
  __typename?: "SleepingArrangementSpace";
  layouts?: Maybe<Array<SleepingArrangementLayout>>;
  name: Scalars["String"];
};

/** Interface to mark all possible actions that can be performed by the client */
export interface SmartFormAction {
  clientSideAnalytics: ClientSideAnalytics;
}

/** Represents the smart form button integrated with smart form actions */
export type SmartFormButton = {
  __typename?: "SmartFormButton";
  actions?: Maybe<Array<SmartFormAction>>;
  button: EgdsButton;
};

/** Type to represent card, composed of visual characteristics of EGDSStandardMessagingSheet and union of all required types */
export type SmartFormCard = {
  __typename?: "SmartFormCard";
  card: EgdsStandardMessagingCard;
  clickAction: SmartFormOpenSheetAction;
};

/** Represents a checkbox group as one input component */
export type SmartFormCheckboxGroupInputComponent = {
  __typename?: "SmartFormCheckboxGroupInputComponent";
  checkboxGroup: EgdsCheckBoxGroup;
  inputId: Scalars["String"];
  label: Scalars["String"];
};

export type SmartFormClickTrackingAction = SmartFormAction & {
  __typename?: "SmartFormClickTrackingAction";
  clientSideAnalytics: ClientSideAnalytics;
};

/** High level container to contain a smart form (sub-form) */
export type SmartFormContainer = {
  __typename?: "SmartFormContainer";
  elements: Array<SmartFormContainerElement>;
};

/** Union marking all the elements that can be present inside a container. */
export type SmartFormContainerElement = SmartFormSection;

export interface SmartFormDataInput {
  /** Timestamp at which this mutation was sent by the client. */
  timestamp: Scalars["String"];
  userInput: SmartFormUserInput;
}

/** A type to represent a group of logically related fields marked by a label */
export type SmartFormFieldSet = {
  __typename?: "SmartFormFieldSet";
  description?: Maybe<Scalars["String"]>;
  elements: Array<SmartFormFieldSetElement>;
  label: Scalars["String"];
  required: Scalars["Boolean"];
};

/** Union marking all the elements that can be present inside a field set. */
export type SmartFormFieldSetElement = SmartFormFlexibleInputGroup | SmartFormInput | SmartFormText;

/** Type to represent generic group of input fields that can be wrapped to multiple rows. */
export type SmartFormFlexibleInputGroup = {
  __typename?: "SmartFormFlexibleInputGroup";
  elements: Array<SmartFormInput>;
};

/** Type to encapsulate the visual characteristics and behaviour characteristics of input types. */
export type SmartFormInput = {
  __typename?: "SmartFormInput";
  actions?: Maybe<Array<SmartFormAction>>;
  inputComponent: SmartFormInputComponent;
  /** @deprecated inputId are moved inside each inputComponent. Try to use that one */
  inputId: Scalars["String"];
  validations?: Maybe<Array<EgdsInputValidation>>;
};

/** Interface to mark all possible elements which can be used for data input */
export type SmartFormInputComponent =
  | SmartFormCheckboxGroupInputComponent
  | SmartFormPhoneNumberInputComponent
  | SmartFormPhoneNumberInputComponentV2
  | SmartFormRadioGroupInputComponent
  | SmartFormSelectInputComponent
  | SmartFormTextInputComponent
  | SmartFormTypeaheadInputComponent;

export type SmartFormMutation = {
  __typename?: "SmartFormMutation";
  updateFormData: SmartFormMutationBaseResponse;
};

export type SmartFormMutationUpdateFormDataArgs = {
  data: SmartFormDataInput;
};

export type SmartFormMutationBaseResponse = {
  __typename?: "SmartFormMutationBaseResponse";
  success: Scalars["Boolean"];
};

/** Represents an action to open SmartFormSheet */
export type SmartFormOpenSheetAction = SmartFormAction & {
  __typename?: "SmartFormOpenSheetAction";
  clientSideAnalytics: ClientSideAnalytics;
  sheet: SmartFormSheet;
};

/** Type to represent a phone number input which is composed of a country code drop down and numeric text input */
export type SmartFormPhoneNumberInputComponent = {
  __typename?: "SmartFormPhoneNumberInputComponent";
  countryCode: SmartFormSelectInputComponent;
  phoneNumber: SmartFormTextInputComponent;
};

/** This is V2 for SmartFormPhoneNumberInputComponent Type to represent a phone number input which is composed of a country code drop down and numeric text input */
export type SmartFormPhoneNumberInputComponentV2 = {
  __typename?: "SmartFormPhoneNumberInputComponentV2";
  countryCode: SmartFormSelectInputComponent;
  phoneNumber: SmartFormTextInputComponent;
};

/** Represents a prefill selection data entry */
export type SmartFormPrefillData = {
  __typename?: "SmartFormPrefillData";
  inputId: Scalars["String"];
  value: Scalars["String"];
};

/** Represents a prefill selection option */
export type SmartFormPrefillOption = {
  __typename?: "SmartFormPrefillOption";
  label: Scalars["String"];
  leftIcon?: Maybe<Icon>;
  prefillDataList: Array<SmartFormPrefillData>;
  selected?: Maybe<Scalars["Boolean"]>;
};

/** Represents a prefill selection component */
export type SmartFormPrefillSelection = {
  __typename?: "SmartFormPrefillSelection";
  label: Scalars["String"];
  leftIcon?: Maybe<Icon>;
  /** Represents the option where pre-fill is cleared. */
  noPrefillOption?: Maybe<SmartFormPrefillOption>;
  options: Array<SmartFormPrefillOption>;
  required: Scalars["Boolean"];
  rightIcon?: Maybe<Icon>;
};

export type SmartFormQuery = {
  __typename?: "SmartFormQuery";
  view: SmartFormViewResponse;
};

/** Represents a radio group as one input component */
export type SmartFormRadioGroupInputComponent = {
  __typename?: "SmartFormRadioGroupInputComponent";
  inputId: Scalars["String"];
  label: Scalars["String"];
  radioGroup: EgdsBasicRadioGroup;
};

/** A simple section that can contain headings, sub-headings, input fields etc */
export type SmartFormSection = {
  __typename?: "SmartFormSection";
  elements: Array<SmartFormSectionElement>;
  heading?: Maybe<EgdsHeading>;
};

/** Union marking all the elements that can be present inside a section. */
export type SmartFormSectionElement =
  | SmartFormCard
  | SmartFormFieldSet
  | SmartFormInput
  | SmartFormPrefillSelection
  | SmartFormText;

/** Represents a select (drop-down) input */
export type SmartFormSelectInputComponent = EgdsSelect & {
  __typename?: "SmartFormSelectInputComponent";
  disabled: Scalars["Boolean"];
  errorMessage?: Maybe<Scalars["String"]>;
  icon?: Maybe<Icon>;
  inputId: Scalars["String"];
  label: Scalars["String"];
  options: Array<EgdsOption>;
  readOnly: Scalars["Boolean"];
  required: Scalars["Boolean"];
};

/** Type to represent an option in select input. */
export type SmartFormSelectInputOption = EgdsOption & {
  __typename?: "SmartFormSelectInputOption";
  label: Scalars["String"];
  selected?: Maybe<Scalars["Boolean"]>;
  shortLabel: Scalars["String"];
  value: Scalars["String"];
};

/** Contain an input fields internal and external id */
export type SmartFormShareableInputId = {
  __typename?: "SmartFormShareableInputId";
  externalKey: Scalars["String"];
  internalInputId: Scalars["String"];
};

/** Type to represent sheet, composed of visual characteristics of EGDSSheet and union of all required types */
export type SmartFormSheet = SmartFormSubForm & {
  __typename?: "SmartFormSheet";
  description: Scalars["String"];
  elements: Array<SmartFormSheetElement>;
  heading: Scalars["String"];
  saveButton?: Maybe<SmartFormButton>;
  sheet: EgdsSheet;
  subFormId: Scalars["String"];
};

/** Union marking all the elements that can be present inside a sheet. */
export type SmartFormSheetElement = SmartFormFieldSet;

/** Smart for action to execute after receiving a signal. */
export type SmartFormSignalAction = {
  __typename?: "SmartFormSignalAction";
  csrfData: IdentityCsrfAto;
  mutationToCall: Scalars["String"];
  requiredFields: Array<SmartFormSignalRequiredFields>;
};

/** Smart form signal required fields. */
export type SmartFormSignalRequiredFields = {
  __typename?: "SmartFormSignalRequiredFields";
  externalKey: Scalars["String"];
  internalInputId: Scalars["String"];
};

/** Sub level form inside the primary form. */
export interface SmartFormSubForm {
  subFormId: Scalars["String"];
}

/** Type to represent for all text elements. */
export type SmartFormText = {
  __typename?: "SmartFormText";
  textComponent: EgdsComposableTextElement;
};

/** Represents a text input field. */
export type SmartFormTextInputComponent = EgdsInputField & {
  __typename?: "SmartFormTextInputComponent";
  errorMessage?: Maybe<Scalars["String"]>;
  inputId: Scalars["String"];
  instructions?: Maybe<Scalars["String"]>;
  label: Scalars["String"];
  labelTemplate?: Maybe<EgdsLocalizedText>;
  leftIcon?: Maybe<Icon>;
  placeholder?: Maybe<Scalars["String"]>;
  readOnly: Scalars["Boolean"];
  required: Scalars["Boolean"];
  rightIcon?: Maybe<Icon>;
  validations?: Maybe<Array<EgdsInputValidation>>;
  value?: Maybe<Scalars["String"]>;
  variant: SmartFormTextInputVariant;
};

/** To define which type of keystrokes will be considered by this input. */
export type SmartFormTextInputVariant = "EMAIL" | "NUMERIC" | "TEL" | "TEXT" | "TEXTAREA";

/** Represents the action to trigger a toast message */
export type SmartFormToastAction = SmartFormAction & {
  __typename?: "SmartFormToastAction";
  clientSideAnalytics: ClientSideAnalytics;
  toast?: Maybe<EgdsToast>;
};

/** Represents a typeahead input field. */
export type SmartFormTypeaheadInputComponent = {
  __typename?: "SmartFormTypeaheadInputComponent";
  domainId?: Maybe<Scalars["String"]>;
  inputId: Scalars["String"];
  typeahead: EgdsTypeaheadInputField;
};

/** Value collected corresponding to a field represented by inputId */
export interface SmartFormUserFieldInput {
  inputId: Scalars["String"];
  value: Array<Scalars["String"]>;
}

/** Collection of the values collected corresponding to fields */
export interface SmartFormUserInput {
  userFieldInputs: Array<SmartFormUserFieldInput>;
}

/** Represents the smart form view response. */
export type SmartFormViewResponse = {
  __typename?: "SmartFormViewResponse";
  containers: Array<SmartFormContainer>;
  shareableInputIds: Array<SmartFormShareableInputId>;
};

export type SoftAccountCreation = {
  __typename?: "SoftAccountCreation";
  /** BodyCopy */
  bodyCopy: Scalars["String"];
  /** ButtonText */
  buttonText: Scalars["String"];
  /** Header */
  header?: Maybe<Scalars["String"]>;
  /** PreHeader */
  preHeader: Scalars["String"];
  /** SubjectLine */
  subjectLine: Scalars["String"];
};

export type SoftAccountCreationCheckList = {
  __typename?: "SoftAccountCreationCheckList";
  /** Header */
  header: Scalars["String"];
  /** List Items */
  listItems: Array<Item>;
};

export type SortAndFilter = {
  __typename?: "SortAndFilter";
  defaults?: Maybe<SortAndFilterDefaults>;
  options?: Maybe<SortAndFilterViewModel>;
  /**
   * PWA ONLY: Used for updating the client store
   * @deprecated This is redundant information that can be found elsewhere and pwa specific, replace with SortAndFilterOptions isSelected boolean or the SearchCriteria.Filters
   */
  selected?: Maybe<SortAndFilterSelected>;
};

/**
 * "
 *     Payload emitted when a filter is removed.
 *     Example: When a checkbox gets unselected
 */
export type SortAndFilterBasicFilterPayload = {
  __typename?: "SortAndFilterBasicFilterPayload";
  /** Identifies which filter the receiver should update */
  filterId: Scalars["String"];
  /** Defines what type of payload this is */
  type: SortAndFilterBasicFilterPayloadType;
};

/**
 * "
 *     Type of operation to perform.
 */
export type SortAndFilterBasicFilterPayloadType =
  /** Check selected filter option */
  | "OPTION"
  /** Remove selected filter */
  | "REMOVE";

export type SortAndFilterDefaults = {
  __typename?: "SortAndFilterDefaults";
  regionId?: Maybe<Scalars["String"]>;
  sort: PropertySort;
};

/** This is the replica of the SearchCriteriaStore on the PWA. We take this and directly apply it to the store to update the values. */
export type SortAndFilterSelected = {
  __typename?: "SortAndFilterSelected";
  /** List of accessibility filters like ROLL_IN_SHOWER */
  accessibility?: Maybe<Array<Scalars["String"]>>;
  /** List of TAAP business models with values from AgencyBusinessModel enum */
  agencyBusinessModels?: Maybe<Array<Scalars["String"]>>;
  /** List of legacy values from PropertyAmenity enum */
  amenities?: Maybe<Array<Scalars["String"]>>;
  /** List of property cleaning and safety enum filter */
  cleaningAndSafetyType?: Maybe<Array<Scalars["String"]>>;
  /** List of TAAP commission tiers with values from CommissionTier enum */
  commissionTiers?: Maybe<Array<Scalars["String"]>>;
  /** List of Deals with values from DealsFilter enum */
  deals?: Maybe<Array<Scalars["String"]>>;
  destination?: Maybe<Scalars["String"]>;
  /** Legacy guest rating string */
  guestRating?: Maybe<Scalars["String"]>;
  hotelName?: Maybe<Scalars["String"]>;
  /** List of legacy values from StructureType enum */
  lodging?: Maybe<Array<Scalars["String"]>>;
  /** List of legacy value from PaymentType enum filter */
  paymentType?: Maybe<Array<Scalars["String"]>>;
  /** Popular location filter */
  poi?: Maybe<Scalars["String"]>;
  /**
   * List of price buckets from the biz config i.e. [1,2]
   * @deprecated More information is needed so moving list into an object , replace with priceFilterPills
   */
  priceFilterBuckets?: Maybe<Array<Scalars["Int"]>>;
  /** Price pills information */
  priceFilterPills?: Maybe<PriceFilterPills>;
  /** List of Property Styles values from enum */
  propertyStyles?: Maybe<Array<Scalars["String"]>>;
  regionId?: Maybe<Scalars["String"]>;
  /** Maps to the values in PropertySort */
  sort?: Maybe<Scalars["String"]>;
  /** The legacy star rating string */
  star?: Maybe<Scalars["String"]>;
  /** List of Stay Type filter */
  stayTypes?: Maybe<Array<Scalars["String"]>>;
  travelerType?: Maybe<Array<TravelerType>>;
};

/**
 * "
 *     Payload emitted when a filter is selected.
 *     Example: When a checkbox gets selected.
 */
export type SortAndFilterSelectedFilterPillPayload = {
  __typename?: "SortAndFilterSelectedFilterPillPayload";
  /** Id of the signal that gets fired when the pill is clicked and removed */
  deselectionSignalId?: Maybe<Scalars["String"]>;
  /** Remaining information needed to construct the pill */
  filter: EgdsPill;
  /** Used to construct the primary label for the pill */
  filterName: SortAndFilterSignalDataSource;
};

/** Specifies when a signal should be emitted */
export type SortAndFilterSignalCondition =
  /** When a filter value changes from the default value to a non default value */
  | "DEFAULT_TO_NON_DEFAULT"
  /** When a filter value changes from a non default value to the default value */
  | "NON_DEFAULT_TO_DEFAULT"
  /** When a filter value changes from a non default value to a different non default value */
  | "NON_DEFAULT_TO_NON_DEFAULT"
  /** When a filter state changes from unselected to selected */
  | "SELECTED"
  /** When a filter state changes from selected to unselected */
  | "UNSELECTED";

/** Specifies where to source a value from for a signal payload. */
export type SortAndFilterSignalDataSource = EgdsBasicLocalizedText | EgdsCardinalLocalizedText | EgdsPlainText;

/** Specifies what gets emitted and when. */
export type SortAndFilterSignalEmitter = {
  __typename?: "SortAndFilterSignalEmitter";
  /** Specifies when a signal should be broadcast */
  condition: SortAndFilterSignalCondition;
  /** Specifies what gets broadcast */
  payload: SortAndFilterSignalPayload;
  /** Id used for linking emitters and receivers */
  signalId: Scalars["String"];
};

/** Specifies what information gets emitted with a signal. */
export type SortAndFilterSignalPayload = SortAndFilterBasicFilterPayload | SortAndFilterSelectedFilterPillPayload;

/** Specifies which signal to listen to. */
export type SortAndFilterSignalReceiver = {
  __typename?: "SortAndFilterSignalReceiver";
  /** Id used for linking emitters and receivers */
  signalId: Scalars["String"];
};

export type SortAndFilterViewModel = AccessibilityField & {
  __typename?: "SortAndFilterViewModel";
  accessibilityLabel?: Maybe<Scalars["String"]>;
  appliedFilterCount: Scalars["Int"];
  label?: Maybe<Scalars["String"]>;
  sortAndFilter: Array<FilterViewModel>;
};

/** Contains the different views for Sort and Filters, where each of them is meant to be on a specific page section or viewport. */
export type SortAndFiltersViewType =
  /**
   * Represent a view where it's displayed applied filters as removable pills.
   * Used for `SMALL` and `MEDIUM` viewport sizes, above the results in a Search Results Page.
   */
  | "APPLIED_FILTERS"
  /**
   * Represent a view where it's only displayed a list of filters.
   * Used for `LARGE` and `EXTRA_LARGE` viewport sizes, in the left side of the results on a Search Results Page.
   */
  | "FILTERS"
  /**
   * Represent a view where it displays a filter bar with an All Filters button.
   * Used for all viewport sizes, above the results in the Vrbex SRP split view template.
   */
  | "FILTER_BAR"
  /**
   * Represent a view where it displays a dialog with only `filters` sections, which are hidden and will be displayed (within a Dialog) once a trigger is clicked by the user.
   * Used for all viewport sizes, inside toolbars.
   */
  | "FILTER_DIALOG"
  /**
   * Represent a view where it's only displayed a list of sort fields, it usually contains a single section with a sort field.
   * Used for `LARGE` and `EXTRA_LARGE` viewport sizes, above the results in a Search Results Page.
   */
  | "SORT"
  /**
   * Represent a view of a combined list of the `sort` and `filters` sections, which are hidden and will be displayed (within a Dialog) once a trigger is clicked by the user.
   * Used for `SMALL` and `MEDIUM` viewport sizes, above the results in a Search Results Page.
   */
  | "SORT_AND_FILTERS";

/** This represents the basic Listings Heading, with legal text and a sort dropdown */
export type SortAndLegalHeading = {
  __typename?: "SortAndLegalHeading";
  /** This represents the legal text displayed within the Listings Heading */
  legalText: EgdsStylizedText;
  /** This represents the sort dropdown component */
  universalSortAndFilters: ShoppingSortAndFilters;
};

export type SourceType = "ESR" | "GDS";

/** Space Details for different lodging type */
export type SpaceDetails = {
  __typename?: "SpaceDetails";
  floorPlan?: Maybe<FloorPlanDialog>;
  header: LodgingHeader;
  spaces?: Maybe<Array<Spaces>>;
  summary?: Maybe<Array<Scalars["String"]>>;
  virtualTourPrompt?: Maybe<VirtualTourPrompt>;
};

export type Spaces = {
  __typename?: "Spaces";
  description?: Maybe<Array<Scalars["String"]>>;
  icons?: Maybe<Array<Icon>>;
  name: Scalars["String"];
};

/** Grouping of server driven dialog */
export type SpannableTextDialog = {
  __typename?: "SpannableTextDialog";
  /** Dialog content: A subset of inline EGDSText implementations that comprise the dialog content. */
  contents: Array<EgdsSpannableText>;
  /** EGDSDialogs are containers that content can be rendered in. Clients should orchestrate how content will render within the dialog. */
  dialog: EgdsDialog;
  /** Trigger message, accessibility tied to the dialog */
  trigger: EgdsText;
};

/** Represents Speak next available agent sheet */
export type SpeakNextAvailableAgentSheet = {
  __typename?: "SpeakNextAvailableAgentSheet";
  /** Label to go back from Speak to next available sheet */
  back: Scalars["String"];
  /** Heading of Speak to next available sheet */
  heading: Scalars["String"];
  /** List of Phone Numbers for customer to dial */
  phoneNumberList: Array<PhoneNumberData>;
  /** SubHeading of Speak to next available sheet */
  subheading: Scalars["String"];
  /** Toolbar of Speak to next available sheet */
  toolBar: ContactUsToolBar;
};

/** Union of Speak next available agent Sheet and Error View for Next available agent view */
export type SpeakNextAvailableAgentView = ContactUsErrorView | SpeakNextAvailableAgentSheet;

/** Possible equipment requested by the customer */
export type SpecialEquipment =
  | "ADDITIONAL_DRIVER"
  | "BICYCLE_RACK"
  | "BOOSTER_SEAT"
  | "INFANT_SEAT"
  | "LEFT_HAND_CONTROL"
  | "LUGGAGE_RACK"
  | "NAV_SYSTEM"
  | "RIGHT_HAND_CONTROL"
  | "ROAD_CONGESTION_PAYMENT_SCHEME"
  | "SATELLITE_RADIO"
  | "SKI_RACK"
  | "SNOW_CHAINS"
  | "SNOW_TIRES"
  | "TODDLER_SEAT"
  | "TOLL_PAYMENT_TAG_PASS"
  | "TRAILER_HITCH"
  | "WIFI_ACCESS"
  | "WINTER_PACKAGE";

export type Spinner = {
  __typename?: "Spinner";
  name: Scalars["String"];
  sdk?: Maybe<Scalars["String"]>;
  sdl?: Maybe<Scalars["String"]>;
  success: Scalars["Boolean"];
  version?: Maybe<Scalars["String"]>;
};

export type SponsoredContentBeacons = {
  __typename?: "SponsoredContentBeacons";
  /** Impression/render beacon URL for sponsored content product */
  renderBeacon: Scalars["URL"];
  /** List of third-party impression URL for sponsored content product. Default to empty list when no third-party impressions are provided. */
  thirdPartyImpressions: Array<Scalars["URL"]>;
  /** Viewability beacon URL for a sponsored content product. Default to null when viewablity beacon is not provided. */
  viewabilityBeacon?: Maybe<Scalars["URL"]>;
};

/** brand result listing data model. Documentation: https://github.expedia.biz/Brand-Expedia/sponsored-content-experience-api-schema-review/pull/4/files */
export type SponsoredContentBrandResultListingCars = {
  __typename?: "SponsoredContentBrandResultListingCars";
  /** Sponsored content label to display on the badge. Eg. Sponsored, Ad etc. */
  badge: EgdsStandardBadge;
  /** Sponsored content beacons and impressions */
  beacons?: Maybe<SponsoredContentBeacons>;
  /** Navigate to this link when the tile is clicked */
  callToAction?: Maybe<EgdsInlineLink>;
  /** brand result listing tile heading */
  heading: Scalars["String"];
  /** Click Beacon for brand result listing ad */
  link: UiLinkAction;
  /** Logo image for the brand result listing */
  logo?: Maybe<SponsoredContentLogo>;
  /** Detail about the offering */
  paragraph: Scalars["String"];
  /**
   * Impression/render beacon url for the ad
   * @deprecated Please retrieve this from the beacons field
   */
  renderBeacon: Scalars["URL"];
  /**
   * Viewability beacon url for brand result listing ad
   * @deprecated Please retrieve this from the beacons field
   */
  viewabilityBeacon?: Maybe<Scalars["URL"]>;
};

/** brand result listing data model. Documentation: https://github.expedia.biz/Brand-Expedia/sponsored-content-experience-api-schema-review/pull/4/files */
export type SponsoredContentBrandResultListingFlights = {
  __typename?: "SponsoredContentBrandResultListingFlights";
  /** Advertiser name for this product */
  advertiserName: Scalars["String"];
  /** Sponsored content label to display on the badge. Eg. Sponsored, Ad etc. */
  badge: EgdsStandardBadge;
  /** Sponsored content beacons and impressions */
  beacons?: Maybe<SponsoredContentBeacons>;
  /** Navigate to this link when the tile is clicked */
  callToAction?: Maybe<EgdsInlineLink>;
  /** brand result listing tile heading */
  heading: Scalars["String"];
  /** Analytics data for brand result listing impression. */
  impressionAnalytics: ClientSideAnalytics;
  /** Click Beacon for brand result listing ad */
  link: UiLinkAction;
  /** Logo image for the brand result listing */
  logo?: Maybe<SponsoredContentLogo>;
  /** Detail about the offering */
  paragraph: Scalars["String"];
  /**
   * Impression/render beacon url for the ad
   * @deprecated Please retrieve this from the beacons field
   */
  renderBeacon: Scalars["URL"];
  /**
   * Viewability beacon url for brand result listing ad
   * @deprecated Please retrieve this from the beacons field
   */
  viewabilityBeacon?: Maybe<Scalars["URL"]>;
};

/** Brand result listing data model. Documentation: https://confluence.expedia.biz/display/med/BRL+Ad+Schema */
export type SponsoredContentBrandResultListingLodging = {
  __typename?: "SponsoredContentBrandResultListingLodging";
  /** Sponsored content label to display on the badge. Eg. Sponsored, Ad etc. */
  badge?: Maybe<EgdsStandardBadge>;
  /** Sponsored content beacons and impressions */
  beacons?: Maybe<SponsoredContentBeacons>;
  /** Feature image */
  feature: Image;
  /** Brand result listing tile heading */
  heading: Scalars["String"];
  /** Analytics data for impression tracking */
  impressionAnalytics: ClientSideAnalytics;
  /** Navigate to this link when the marquee tile is clicked */
  link: UiLinkAction;
  /** Logo for an ad product */
  logo?: Maybe<SponsoredContentLogo>;
  /** Detail about the offering */
  paragraph: Scalars["String"];
  /**
   * Impression/render beacon url for lodging brand result listing
   * @deprecated Please retrieve this from the beacons field
   */
  renderBeacon: Scalars["URL"];
  /**
   * Viewability beacon url for lodging brand result listing
   * @deprecated Please retrieve this from the beacons field
   */
  viewabilityBeacon?: Maybe<Scalars["URL"]>;
};

/** Context needed to request sponsored content */
export type SponsoredContentContext = {
  __typename?: "SponsoredContentContext";
  /** Page name Eg. page.Hotels.Infosite.Information */
  pageName: Scalars["String"];
  /** Unique identifier for sponsored content placements */
  sponsoredContentId: Scalars["String"];
  /** Model for ad targeting input */
  targeting?: Maybe<SponsoredContentTargeting>;
  /** Target variant. Eg. pwa */
  variant?: Maybe<Scalars["String"]>;
};

/** Context needed to request sponsored content */
export interface SponsoredContentContextInput {
  /** Page name Eg. page.Hotels.Infosite.Information */
  pageName: Scalars["String"];
  /** Unique identifier for sponsored content placements */
  sponsoredContentId: Scalars["String"];
  /** Model for ad targeting input */
  targeting?: InputMaybe<SponsoredContentTargetingInput>;
  /** Target variant. Eg. pwa */
  variant?: InputMaybe<Scalars["String"]>;
}

/** Image Gallery data model. Documentation: https://github.expedia.biz/Brand-Expedia/sponsored-content-experience-api-schema-review/pull/7/files */
export type SponsoredContentImageGallery = {
  __typename?: "SponsoredContentImageGallery";
  /** Sponsored content label to display on the badge. Eg. Sponsored, Ad etc. */
  badge?: Maybe<EgdsStandardBadge>;
  /** Sponsored content beacons and impressions */
  beacons?: Maybe<SponsoredContentBeacons>;
  /** Image gallery component heading */
  heading: Scalars["String"];
  /** Navigate to this link when heading area is clicked */
  link?: Maybe<UiLinkAction>;
  /** Logo for an ad product */
  logo?: Maybe<SponsoredContentLogo>;
  /** Detail about the offering */
  paragraph: Scalars["String"];
  /** Tile cards for Image Gallery */
  tiles: Array<Maybe<EgdsImageLinkCard>>;
};

/** Location resolution by type */
export type SponsoredContentLocationResolver =
  /** Gaia regionId. Ex. 178248 (Chicago (and vicinity)) */
  | "GAIA"
  /** Airport code. Ex. ORD (TLA code for Chicago O'Hare Airport) */
  | "TLA";

/** Location resolution by type */
export type SponsoredContentLocationResolverInput =
  /** Gaia regionId. Ex. 178248 (Chicago (and vicinity)) */
  | "GAIA"
  /** Airport code. Ex. ORD (TLA code for Chicago O'Hare Airport) */
  | "TLA";

export type SponsoredContentLogo = {
  __typename?: "SponsoredContentLogo";
  /** White logo for dark mode */
  darkMode?: Maybe<Mark>;
  /** Standard logo for an ad product */
  standard?: Maybe<Mark>;
};

/** Marquee data model. Documentation: https://confluence.expedia.biz/display/med/Marquee+UI+model+definition */
export type SponsoredContentMarquee = {
  __typename?: "SponsoredContentMarquee";
  /** Sponsored content label to display on the badge. Eg. Sponsored, Ad etc. */
  badge?: Maybe<EgdsStandardBadge>;
  /** Sponsored content beacons and impressions */
  beacons?: Maybe<SponsoredContentBeacons>;
  /** Marquee tile heading */
  heading: Scalars["String"];
  /** Images for the marquee product */
  image: Image;
  /** Navigate to this link when the marquee tile is clicked */
  link: UiLinkAction;
  /** Logo for an ad product */
  logo?: Maybe<SponsoredContentLogo>;
  /** Detail about the offering */
  paragraph: Scalars["String"];
  /**
   * Impression/render beacon url for the marquee product
   * @deprecated Please retrieve this from the beacons field
   */
  renderBeacon: Scalars["URL"];
  /**
   * Viewability beacon url for marquee ad
   * @deprecated Please retrieve this from the beacons field
   */
  viewabilityBeacon?: Maybe<Scalars["URL"]>;
};

/** Marquee data model. Documentation: https://confluence.expedia.biz/display/med/Marquee+UI+model+definition */
export type SponsoredContentMarquees = {
  __typename?: "SponsoredContentMarquees";
  /** Primary content */
  primary: Array<SponsoredContentMarquee>;
  /** Secondary content */
  secondary: Array<SponsoredContentMarquee>;
};

/** Multi listing ad data model. Documentation: https://github.expedia.biz/Brand-Expedia/sponsored-content-experience-api-schema-review/pull/5/files */
export type SponsoredContentMultiListingAd = {
  __typename?: "SponsoredContentMultiListingAd";
  /** List of brand ids for specific chain  */
  advertisedIds: Array<Scalars["Int"]>;
  /** Name of chain */
  advertiserName: Scalars["String"];
  /** Sponsored content label to display on the badge. Eg. Sponsored, Ad etc. */
  badge?: Maybe<EgdsStandardBadge>;
  /** Federation: Extends the type with brand properties */
  brandProperties?: Maybe<Array<LodgingCard>>;
  /** Federation: Extends the type with call to action link */
  callToAction: EgdsInlineLink;
  /** Analytics data for carousel tracking (impression/ next/ back). */
  carouselAnalytics?: Maybe<ClientSideAnalytics>;
  /** Ad product heading */
  heading?: Maybe<Scalars["String"]>;
  /** Logo for an ad product */
  logo?: Maybe<SponsoredContentLogo>;
  /** Details about the offering */
  paragraph?: Maybe<Scalars["String"]>;
};

/** Multi listing ad data model. Documentation: https://github.expedia.biz/Brand-Expedia/sponsored-content-experience-api-schema-review/pull/5/files */
export type SponsoredContentMultiListingAdBrandPropertiesArgs = {
  context: ContextInput;
  searchCriteriaInput: MultiItemSearchContextInput;
  shoppingContext?: InputMaybe<ShoppingContextInput>;
};

/** Multi listing ad data model. Documentation: https://github.expedia.biz/Brand-Expedia/sponsored-content-experience-api-schema-review/pull/5/files */
export type SponsoredContentMultiListingAdCallToActionArgs = {
  context: ContextInput;
  searchCriteriaInput: MultiItemSearchContextInput;
  shoppingContext?: InputMaybe<ShoppingContextInput>;
};

/** Used to indicate a sponsored content placement */
export type SponsoredContentPlacement = {
  __typename?: "SponsoredContentPlacement";
  /** The type of the ad placement */
  productType: SponsoredContentProductType;
  /** Context needed to request sponsored content */
  sponsoredContentContext: SponsoredContentContext;
};

/** The type of the ad placement */
export type SponsoredContentProductType =
  | "BRAND_RESULT_LISTING_FLIGHTS"
  | "BRAND_RESULT_LISTING_LODGING"
  | "DESTINATION_EXPERIENCE"
  | "MULTI_LISTING_AD";

export type SponsoredContentQuery = {
  __typename?: "SponsoredContentQuery";
  /**
   * Query for a Brand Result Listing Cars ad placement
   * @deprecated Schema evolving. Use at your own risk
   */
  brandResultListingCars?: Maybe<SponsoredContentBrandResultListingCars>;
  /**
   * Query for a Brand Result Listing Flights ad placement
   * @deprecated Schema evolving. Use at your own risk
   */
  brandResultListingFlights?: Maybe<SponsoredContentBrandResultListingFlights>;
  /**
   * Query for a Brand Result Listing Lodging ad placement
   * @deprecated Schema evolving. Use at your own risk
   */
  brandResultListingLodging?: Maybe<SponsoredContentBrandResultListingLodging>;
  /** Query to fetch sponsored content destination experience product */
  imageGallery?: Maybe<SponsoredContentImageGallery>;
  /**
   * Query to fetch sponsored content marquee product
   * @deprecated Please use marquees instead
   */
  marquee?: Maybe<SponsoredContentMarquee>;
  /** Query to fetch sponsored content marquee product */
  marquees?: Maybe<SponsoredContentMarquees>;
  /** Query to fetch sponsored content multi listing ad product */
  multiListingAd?: Maybe<SponsoredContentMultiListingAd>;
};

export type SponsoredContentQueryBrandResultListingCarsArgs = {
  context: ContextInput;
  sponsoredContentContext: SponsoredContentContextInput;
};

export type SponsoredContentQueryBrandResultListingFlightsArgs = {
  context: ContextInput;
  sponsoredContentContext: SponsoredContentContextInput;
};

export type SponsoredContentQueryBrandResultListingLodgingArgs = {
  context: ContextInput;
  sponsoredContentContext: SponsoredContentContextInput;
};

export type SponsoredContentQueryImageGalleryArgs = {
  context: ContextInput;
  sponsoredContentContext: SponsoredContentContextInput;
};

export type SponsoredContentQueryMarqueeArgs = {
  context: ContextInput;
  sponsoredContentContext: SponsoredContentContextInput;
};

export type SponsoredContentQueryMarqueesArgs = {
  context: ContextInput;
  sponsoredContentContext: SponsoredContentContextInput;
};

export type SponsoredContentQueryMultiListingAdArgs = {
  context: ContextInput;
  searchCriteriaInput: MultiItemSearchContextInput;
  sponsoredContentContextInput: SponsoredContentContextInput;
};

/** Input model to hold targeting params for queries. */
export type SponsoredContentTargeting = {
  __typename?: "SponsoredContentTargeting";
  /** number of adults included in the search */
  adults?: Maybe<Scalars["Int"]>;
  /** End date of trip. Optional for dateless searches */
  dateEnd?: Maybe<Date>;
  /** Start date of trip. Optional for dateless searches */
  dateStart?: Maybe<Date>;
  /** Destination for the trip. */
  destination?: Maybe<Scalars["String"]>;
  /** number of kids included in the search */
  kids?: Maybe<Scalars["Int"]>;
  /** Type of location for origin and dest. */
  locationResolver?: Maybe<SponsoredContentLocationResolver>;
  /** Origin for the trip. */
  origin?: Maybe<Scalars["String"]>;
};

/** Input model to hold targeting params for queries. */
export interface SponsoredContentTargetingInput {
  /** number of adults included in the search */
  adults?: InputMaybe<Scalars["Int"]>;
  /** End date of trip. Optional for dateless searches */
  dateEnd?: InputMaybe<DateInput>;
  /** Start date of trip. Optional for dateless searches */
  dateStart?: InputMaybe<DateInput>;
  /** Destination for the trip. */
  destination?: InputMaybe<Scalars["String"]>;
  /** number of kids included in the search */
  kids?: InputMaybe<Scalars["Int"]>;
  /** Type of location for origin and dest. */
  locationResolver?: InputMaybe<SponsoredContentLocationResolverInput>;
  /** Origin for the trip. */
  origin?: InputMaybe<Scalars["String"]>;
}

/** Sponsored Listing for this property */
export type SponsoredListing = {
  __typename?: "SponsoredListing";
  brand?: Maybe<Scalars["String"]>;
  clickRedirectLinkoffTrackingUrl?: Maybe<Scalars["URL"]>;
  clickRedirectTrackingUrl?: Maybe<Scalars["URL"]>;
  /** @deprecated click tracking should no longer be done by the client. Please pass PropertyTravelAdTrackingInfo in propertyInfo Offers subquery for click tracking */
  clickTrackingUrl?: Maybe<Scalars["URL"]>;
  details?: Maybe<Scalars["String"]>;
  detailsHeadline?: Maybe<Scalars["String"]>;
  hotelImage?: Maybe<Scalars["String"]>;
  id?: Maybe<Scalars["String"]>;
  impressionTrackingUrl?: Maybe<Scalars["URL"]>;
  logo?: Maybe<Scalars["String"]>;
  lotagline?: Maybe<Scalars["String"]>;
  /** @deprecated Use position in PropertyTravelAdTrackingInfo */
  position?: Maybe<Scalars["String"]>;
  /** @deprecated Use rank in PropertyTravelAdTrackingInfo */
  rank?: Maybe<Scalars["String"]>;
  rating?: Maybe<Scalars["String"]>;
  /** @deprecated Use slots in PropertyTravelAdTrackingInfo */
  slots?: Maybe<Scalars["String"]>;
  /** @deprecated Use trackingData in PropertyTravelAdTrackingInfo */
  trackingData?: Maybe<Scalars["String"]>;
  trackingInfo: PropertyTravelAdTrackingInfo;
  vanityUrl?: Maybe<Scalars["URL"]>;
};

export type StarRange = {
  __typename?: "StarRange";
  max?: Maybe<Scalars["Float"]>;
  min?: Maybe<Scalars["Float"]>;
};

export interface StarRangeInput {
  max?: InputMaybe<Scalars["Float"]>;
  min?: InputMaybe<Scalars["Float"]>;
}

export type StaticCrossSellQueries = {
  __typename?: "StaticCrossSellQueries";
  /** Static xsell intended to be displayed between search result listings on any LOB's SRP page */
  brandedDealListing: BrandedDealCrossSellUiResponse;
  /** Static xsell intended to be displayed between search result listings on any LOB's SRP page */
  searchResultListing: StaticSearchResultListingCrossSellResponse;
};

export type StaticCrossSellQueriesBrandedDealListingArgs = {
  price: BrandedDealProductPriceInput;
  userLocation?: InputMaybe<CrossSellUserLocationInput>;
};

export type StaticCrossSellQueriesSearchResultListingArgs = {
  crossSellProductType?: InputMaybe<CrossSellProductType>;
  userLocation?: InputMaybe<CrossSellUserLocationInput>;
};

export type StaticLicensePlate = {
  __typename?: "StaticLicensePlate";
  description: Scalars["String"];
  feedbackLink: EgdsStandardLink;
  links: Array<EgdsStandardLink>;
  title: Scalars["String"];
};

export type StaticLodgingMultiItemCrossSell = {
  __typename?: "StaticLodgingMultiItemCrossSell";
  crossSellProductType: LodgingCrossSellProductType;
  fallbackListing?: Maybe<StaticLodgingMultiItemCrossSellFallbackListing>;
  multiItemSearchContext: MultiItemSearchContext;
};

export type StaticLodgingMultiItemCrossSellFallbackListing = MessageResult;

/** Static map image that contains the map url and accessibility */
export type StaticMapImage = {
  __typename?: "StaticMapImage";
  /** accessibility text for static map */
  accessibility?: Maybe<Scalars["String"]>;
  /** google static map url that shows the map image */
  url?: Maybe<Scalars["String"]>;
};

/** DEPRECATED: Use StaticSearchResultListingCrossSellResponse instead */
export type StaticMultiItemCrossSellResponse = {
  __typename?: "StaticMultiItemCrossSellResponse";
  crossSellOptions: Array<CrossSellOption>;
  impressionAnalytics: ClientSideAnalytics;
};

/** The top level response object for rendering the static xsell search result listing */
export type StaticSearchResultListingCrossSellResponse = {
  __typename?: "StaticSearchResultListingCrossSellResponse";
  /** Wrapper around all the fields required to render the cross sell card UI */
  crossSell: CrossSellOption;
  /** The analytics data used for impression logging when the cross sell is shown */
  impressionAnalytics: ClientSideAnalytics;
};

export type StayConstraints = {
  __typename?: "StayConstraints";
  maximumStayInDays: Scalars["Int"];
  minimumStayInDays: Scalars["Int"];
  stayIncrementInDays: Scalars["Int"];
};

/** Property search filtering options */
export type StayType = "CONVENTIONAL" | "VACATION_RENTALS";

/** Step indicator with steps and prices */
export type StepIndicator = {
  __typename?: "StepIndicator";
  priceLockup?: Maybe<StepIndicatorPrice>;
  steps: Array<IndicatorStep>;
};

/** Interface for change selections */
export interface StepIndicatorChangeSelection {
  a11yLabel: Scalars["String"];
  action: UiLinkAction;
  label: Scalars["String"];
  multiItemShoppingAction?: Maybe<MultiItemShoppingAction>;
}

/** Interface for step labels */
export interface StepIndicatorLabel {
  text: Scalars["String"];
}

/** Price info displayed on the far right */
export type StepIndicatorPrice = {
  __typename?: "StepIndicatorPrice";
  a11yPrice: Scalars["String"];
  lockupPrice: Scalars["String"];
  priceSubtextStandard?: Maybe<Array<Scalars["String"]>>;
  strikeThroughDialogText?: Maybe<Scalars["String"]>;
  strikeThroughPrice?: Maybe<Scalars["String"]>;
};

export type StepReviewCard = {
  __typename?: "StepReviewCard";
  analytics: StepReviewClickstreamData;
  cardLink: StepReviewCardAction;
  description?: Maybe<Scalars["String"]>;
  editIcon?: Maybe<Icon>;
  editLink?: Maybe<StepReviewEditLink>;
  heading: Scalars["String"];
  statusIcon: Icon;
};

export type StepReviewCardAction = StepReviewLinkAction | StepReviewReturnAction;

export type StepReviewClickstreamData = IEgClickstreamData & {
  __typename?: "StepReviewClickstreamData";
  event?: Maybe<EgClickstreamEvent>;
  experience?: Maybe<EgClickstreamExperience>;
  partner_common?: Maybe<EgClickstreamPartnerCommonData>;
  product_list?: Maybe<Array<EgClickstreamProductListData>>;
  virtual_market_coach?: Maybe<EgClickstreamVirtualMarketCoachData>;
};

export type StepReviewEditLink = {
  __typename?: "StepReviewEditLink";
  action: StepReviewCardAction;
  icon?: Maybe<Icon>;
  iconPosition?: Maybe<EgdsIconPosition>;
  size: EgdsLinkSize;
  text: Scalars["String"];
};

export type StepReviewHeader = {
  __typename?: "StepReviewHeader";
  description: Scalars["String"];
  heading: Scalars["String"];
};

export type StepReviewInlineEditingSheet = {
  __typename?: "StepReviewInlineEditingSheet";
  closeAnalytics?: Maybe<ClientSideAnalytics>;
  closeText?: Maybe<Scalars["String"]>;
  content: StepReviewInlineEditingSheetContent;
  footer: StepReviewInlineEditingSheetFooter;
  heading: Scalars["String"];
  showAction: SupplySubscribeSignalAction;
};

export type StepReviewInlineEditingSheetButtonAction =
  | StepReviewInlineEditingSheetButtonActionCancel
  | StepReviewInlineEditingSheetButtonActionSave;

export type StepReviewInlineEditingSheetButtonActionCancel = {
  __typename?: "StepReviewInlineEditingSheetButtonActionCancel";
  accessibility?: Maybe<Scalars["String"]>;
  analytics?: Maybe<ClientSideAnalytics>;
};

export type StepReviewInlineEditingSheetButtonActionSave = {
  __typename?: "StepReviewInlineEditingSheetButtonActionSave";
  accessibility?: Maybe<Scalars["String"]>;
  analytics?: Maybe<ClientSideAnalytics>;
};

export type StepReviewInlineEditingSheetButtonType = "PRIMARY" | "SECONDARY";

export type StepReviewInlineEditingSheetContent = {
  __typename?: "StepReviewInlineEditingSheetContent";
  description: Scalars["String"];
  sections: Array<StepReviewInlineEditingSheetSection>;
};

export type StepReviewInlineEditingSheetFooter = {
  __typename?: "StepReviewInlineEditingSheetFooter";
  buttons: Array<StepReviewInlineEditingSheetFooterButton>;
};

export type StepReviewInlineEditingSheetFooterButton = {
  __typename?: "StepReviewInlineEditingSheetFooterButton";
  action: StepReviewInlineEditingSheetButtonAction;
  text: Scalars["String"];
  type: StepReviewInlineEditingSheetButtonType;
};

export type StepReviewInlineEditingSheetSection = MinNightStayInputField;

export type StepReviewLinkAction = {
  __typename?: "StepReviewLinkAction";
  accessibility?: Maybe<Scalars["String"]>;
  analytics: StepReviewClickstreamData;
  resource: Uri;
  target: UiLinkTarget;
  viewed?: Maybe<Scalars["String"]>;
};

export type StepReviewList = {
  __typename?: "StepReviewList";
  accessibilityLabel: Scalars["String"];
  announcement: Scalars["String"];
  cards: Array<StepReviewCard>;
  header?: Maybe<StepReviewHeader>;
};

export type StepReviewReturnAction = {
  __typename?: "StepReviewReturnAction";
  accessibility?: Maybe<Scalars["String"]>;
  analytics: StepReviewClickstreamData;
  stepName?: Maybe<Scalars["String"]>;
};

export type StrikeOutType = "ATTACH" | "INVALID" | "LOYALTY" | "PACKAGE" | "PRICE_SURVEY" | "STANDALONE";

export type StringRating = {
  __typename?: "StringRating";
  default?: Maybe<Scalars["String"]>;
  maxLength?: Maybe<Scalars["Int"]>;
  minLength?: Maybe<Scalars["Int"]>;
  regex?: Maybe<Scalars["String"]>;
  stringValue?: Maybe<Scalars["String"]>;
};

export type StructureType =
  | "AGRITOURISM"
  | "ALL_INCLUSIVE"
  | "APARTMENT"
  | "APART_HOTEL"
  | "BED_AND_BREAKFAST"
  | "CABIN"
  | "CAPSULE_HOTEL"
  | "CARAVAN_PARK"
  | "CASTLE"
  | "CHALET"
  | "CONDO"
  | "CONDO_RESORT"
  | "COTTAGE"
  | "COUNTRY_HOUSE"
  | "CRUISE"
  | "ECO_HOTEL"
  | "GUEST_HOUSE"
  | "HOLIDAY_PARK"
  | "HOSTAL"
  | "HOSTEL"
  | "HOTEL"
  | "HOTEL_RESORT"
  | "HOUSE_BOAT"
  | "INN"
  | "LODGE"
  | "LONGHOUSE"
  | "MOTEL"
  | "OVERWATER"
  | "PALACE"
  | "PENSION"
  | "POUSADA_BRAZIL"
  | "POUSADA_PORTUGAL"
  | "RANCH"
  | "RESIDENCE"
  | "RIAD"
  | "RYOKAN"
  | "SAFARI"
  | "SERVICED_APARTMENT"
  | "TOWNHOUSE"
  | "TRADITIONAL_BUILDING"
  | "TREE_HOUSE"
  | "UNKNOWN"
  | "VACATION_HOME"
  | "VILLA"
  | "VIP";

export type StructureTypeValue = {
  __typename?: "StructureTypeValue";
  id: Scalars["Int"];
  name: Scalars["String"];
};

/** Structured Content Media Gallery Carousel */
export type StructuredContentMediaGalleryCarousel = EgdsGalleryCarousel & {
  __typename?: "StructuredContentMediaGalleryCarousel";
  accessibilityHeadingText: Scalars["String"];
  media: Array<MediaItem>;
  nextButtonText: Scalars["String"];
  previousButtonText: Scalars["String"];
};

/** Summary unit containing Score and Tags summary */
export type SummaryUnit = {
  __typename?: "SummaryUnit";
  /** Score out of 5 */
  score?: Maybe<Scalars["String"]>;
  /** List of tags */
  tags: Array<Tag>;
};

export type SuperlativeText = {
  __typename?: "SuperlativeText";
  /** Text to be read by the screen reader. */
  accessibilityMessage?: Maybe<Scalars["String"]>;
  /** Superlative text */
  text: EgdsStylizedText;
};

export type SupplierInformation = {
  __typename?: "SupplierInformation";
  /** Description is the information dislpayed about the supplier */
  description: EgdsPlainText;
  /** Logo is the image of the supplier */
  logo: Image;
};

export type SupplyActionTipResponse = {
  __typename?: "SupplyActionTipResponse";
  error?: Maybe<EgdsErrorSummary>;
  success?: Maybe<SupplyActionTipSuccessResponse>;
};

export type SupplyActionTipSuccessResponse = {
  __typename?: "SupplyActionTipSuccessResponse";
  button?: Maybe<EgdsButton>;
  description: SupplyQuickActionText;
  icon: Icon;
  title: SupplyQuickActionText;
};

export type SupplyAmenitiesGroup = {
  __typename?: "SupplyAmenitiesGroup";
  contents: Array<SupplyAmenitiesGroupContent>;
  description?: Maybe<Scalars["String"]>;
  header?: Maybe<Scalars["String"]>;
};

export type SupplyAmenitiesGroupContent = SupplyAmenitiesList | SupplyAmenitiesSection | SupplyAmenitiesSubSection;

export interface SupplyAmenitiesGroupInput {
  groupId: Scalars["String"];
  roomTypeId?: InputMaybe<Scalars["String"]>;
  spaceId?: InputMaybe<Scalars["String"]>;
}

export type SupplyAmenitiesList = {
  __typename?: "SupplyAmenitiesList";
  amenities: Array<SupplyAmenityElement>;
  column: Scalars["Int"];
};

export type SupplyAmenitiesSection = {
  __typename?: "SupplyAmenitiesSection";
  subSections: Array<SupplyAmenitiesSubSection>;
  title: Scalars["String"];
};

export type SupplyAmenitiesSubSection = {
  __typename?: "SupplyAmenitiesSubSection";
  amenitiesLists: Array<SupplyAmenitiesList>;
  divider: Scalars["Boolean"];
  title: Scalars["String"];
};

export interface SupplyAmenitiesUpdateInput {
  amenities: Array<SupplyAmenityInput>;
  groupId: Scalars["String"];
  roomTypeId?: InputMaybe<Scalars["String"]>;
}

export type SupplyAmenityElement = {
  __typename?: "SupplyAmenityElement";
  element: SupplyAmenityUiElement;
  elementId: Scalars["String"];
  title?: Maybe<Scalars["String"]>;
};

export interface SupplyAmenityInput {
  elementId: Scalars["String"];
  value?: InputMaybe<Scalars["String"]>;
}

export type SupplyAmenityUiElement = EgdsBasicCheckBox | EgdsBasicRadioGroup | EgdsBasicSelect | EgdsTextInputField;

export type SupplyAssociatedPropertiesSummary = {
  __typename?: "SupplyAssociatedPropertiesSummary";
  associatedPropertiesSummary: Array<SupplyPropertyListItemActionContent>;
};

export type SupplyCancelWaiverActionButton = EgdsButton & {
  __typename?: "SupplyCancelWaiverActionButton";
  accessibility?: Maybe<Scalars["String"]>;
  action?: Maybe<UiLinkAction>;
  analytics?: Maybe<ClientSideAnalytics>;
  disabled: Scalars["Boolean"];
  egdsElementId?: Maybe<Scalars["String"]>;
  icon?: Maybe<Icon>;
  primary: Scalars["String"];
};

export type SupplyCancellationPolicyDetailsExpandoLink = EgdsExpando & {
  __typename?: "SupplyCancellationPolicyDetailsExpandoLink";
  collapseAnalytics?: Maybe<ClientSideAnalytics>;
  collapsedLabel: Scalars["String"];
  expandAnalytics?: Maybe<ClientSideAnalytics>;
  expanded: Scalars["Boolean"];
  expandedContent?: Maybe<SupplyCancellationPolicyDetailsSection>;
  expandedLabel: Scalars["String"];
};

export type SupplyCancellationPolicyDetailsSection = {
  __typename?: "SupplyCancellationPolicyDetailsSection";
  policyName: EgdsStandardLink;
  policyRules: Array<SupplyGuestItemContent>;
  policyTip?: Maybe<EgdsIconText>;
};

export type SupplyCancellationWaiverApprovalContent = {
  __typename?: "SupplyCancellationWaiverApprovalContent";
  cancellationReason: SupplyGuestItemContent;
  expando: SupplyCancellationPolicyDetailsExpandoLink;
  refundInformation: SupplyGuestItemContent;
  subTitle: Scalars["String"];
  title: Scalars["String"];
};

export interface SupplyCancellationWaiverApprovalRequestContext {
  bookingItemId: Scalars["String"];
  message?: InputMaybe<Scalars["String"]>;
}

export type SupplyCancellationWaiverApprovalResponseContent = SupplyRefundDecision & {
  __typename?: "SupplyCancellationWaiverApprovalResponseContent";
  content: Scalars["String"];
  disclaimerLink: EgdsStandardLink;
  disclaimerText: Scalars["String"];
  icon: Icon;
  /** @deprecated Replaced by disclaimerLink */
  link: SupplyRefundDisclaimerInlineLink;
  primaryButton: EgdsButton;
  subtitle: Scalars["String"];
  title: Scalars["String"];
};

export type SupplyCancellationWaiverApprovalSection = {
  __typename?: "SupplyCancellationWaiverApprovalSection";
  approvalContent: SupplyCancellationWaiverApprovalContent;
  guestMessage: EgdsTextInputField;
  header: EgdsIconText;
  messageCard: EgdsStandardMessagingCard;
  primaryButton: SupplyCancelWaiverActionButton;
  secondaryButton: EgdsButton;
};

export type SupplyCancellationWaiverCardDetails = {
  __typename?: "SupplyCancellationWaiverCardDetails";
  cancellationReason: SupplyGuestItemContent;
  expando: SupplyCancellationPolicyDetailsExpandoLink;
  primaryButton: EgdsButton;
  refundInformation: EgdsStylizedText;
  secondaryButton: EgdsButton;
  title: Scalars["String"];
};

export type SupplyCancellationWaiverDeclineFlowContent = {
  __typename?: "SupplyCancellationWaiverDeclineFlowContent";
  declineReasonInput: SupplyCancellationWaiverDeclineReasonInput;
  header: EgdsIconText;
  messageCard: EgdsStandardMessagingCard;
  primaryButton: SupplyCancelWaiverActionButton;
  secondaryButton: EgdsButton;
};

export type SupplyCancellationWaiverDeclineReasonInput = {
  __typename?: "SupplyCancellationWaiverDeclineReasonInput";
  guestMessage: EgdsTextInputField;
  selector: EgdsBasicSelect;
  subtitle: Scalars["String"];
  title: Scalars["String"];
};

export type SupplyCancellationWaiverDeclineSuccessContent = SupplyRefundDecision & {
  __typename?: "SupplyCancellationWaiverDeclineSuccessContent";
  content: Scalars["String"];
  expando: SupplyCancellationPolicyDetailsExpandoLink;
  icon: Icon;
  primaryButton: EgdsButton;
  subtitle: Scalars["String"];
  title: Scalars["String"];
};

export interface SupplyCancellationWaiverReservationContext {
  bookingItemId: Scalars["String"];
}

export type SupplyCoachingTipCard = {
  __typename?: "SupplyCoachingTipCard";
  cardAction?: Maybe<SupplyQuickActionOpenSheetAction>;
  cardInfo: SupplyCoachingTipCardInfo;
  clickStreamData?: Maybe<SupplyCoachingTipCardClickStreamData>;
  clickStreamEventData?: Maybe<SupplyVirtualMarketCoachEgClickStreamData>;
};

export type SupplyCoachingTipCardClickStreamData = {
  __typename?: "SupplyCoachingTipCardClickStreamData";
  cardPresented?: Maybe<SupplyVirtualMarketCoachEgClickStreamData>;
  cardSelected?: Maybe<SupplyVirtualMarketCoachEgClickStreamData>;
};

export type SupplyCoachingTipCardInfo = {
  __typename?: "SupplyCoachingTipCardInfo";
  description: EgdsSpannableText;
  icon: Icon;
  primaryButton?: Maybe<EgdsButton>;
  secondaryButton?: Maybe<EgdsButton>;
  title: Scalars["String"];
};

export type SupplyCoachingTipProofPointEgClickstreamCustomAttribute = {
  __typename?: "SupplyCoachingTipProofPointEGClickstreamCustomAttribute";
  comparative_set?: Maybe<Scalars["String"]>;
  metric?: Maybe<Scalars["String"]>;
  type_id?: Maybe<Scalars["Int"]>;
  uplift_percentage?: Maybe<Scalars["String"]>;
};

export type SupplyCoachingTipsBlock = {
  __typename?: "SupplyCoachingTipsBlock";
  coachingTipCards: Array<SupplyCoachingTipCard>;
};

export type SupplyContentButton = {
  __typename?: "SupplyContentButton";
  button: EgdsButton;
  buttonSelected?: Maybe<SupplyContentEgClickstreamData>;
};

export type SupplyContentCarousel = {
  __typename?: "SupplyContentCarousel";
  cards: Array<SupplyContentCarouselCard>;
  nextButtonText: Scalars["String"];
  previousButtonText: Scalars["String"];
};

export type SupplyContentCarouselCard = {
  __typename?: "SupplyContentCarouselCard";
  heading?: Maybe<Scalars["String"]>;
  icon?: Maybe<Icon>;
  id?: Maybe<Scalars["String"]>;
  image?: Maybe<Scalars["URL"]>;
  text: Scalars["String"];
};

export type SupplyContentDescriptionInputSection = {
  __typename?: "SupplyContentDescriptionInputSection";
  description: Scalars["String"];
  heading?: Maybe<Scalars["String"]>;
  textArea: SupplyContentTextArea;
  tips?: Maybe<SupplyContentTips>;
};

export type SupplyContentDescriptionSection = SupplyContentDescriptionInputSection | SupplyContentErrorSection;

export type SupplyContentDescriptionSectionName =
  | "ABOUT_YOU"
  | "DESCRIPTION"
  | "HEADLINE"
  | "MANUAL_TRANSLATION"
  | "PROPERTY_NAME"
  | "UNIQUE_BENEFITS"
  | "WHY_THIS_PROPERTY";

export type SupplyContentDescriptionUpdate = {
  __typename?: "SupplyContentDescriptionUpdate";
  failures?: Maybe<Array<SupplyContentDescriptionUpdateFailure>>;
};

export type SupplyContentDescriptionUpdateFailure = {
  __typename?: "SupplyContentDescriptionUpdateFailure";
  error: SupplyContentErrorMessage;
  sectionName: SupplyContentDescriptionSectionName;
};

export type SupplyContentEgClickstreamData = IEgClickstreamData & {
  __typename?: "SupplyContentEgClickstreamData";
  customizedAttributes?: Maybe<Scalars["String"]>;
  event: EgClickstreamEvent;
  experience: EgClickstreamExperience;
};

export type SupplyContentErrorMessage = {
  __typename?: "SupplyContentErrorMessage";
  icon: Icon;
  message: Scalars["String"];
};

export type SupplyContentErrorSection = {
  __typename?: "SupplyContentErrorSection";
  error: SupplyContentErrorMessage;
  heading: Scalars["String"];
};

export type SupplyContentExistingManualTranslation = {
  __typename?: "SupplyContentExistingManualTranslation";
  deleteButton: SupplyContentButton;
  locale: Scalars["String"];
  text: Scalars["String"];
  viewButton: SupplyContentButton;
};

export type SupplyContentHeadlineDescription = {
  __typename?: "SupplyContentHeadlineDescription";
  contentViewed?: Maybe<SupplyContentEgClickstreamData>;
  description?: Maybe<SupplyContentDescriptionSection>;
  header?: Maybe<SupplyContentHubHeader>;
  headline?: Maybe<SupplyContentDescriptionSection>;
  manualTranslation?: Maybe<SupplyContentManualTranslationSection>;
  propertyName?: Maybe<SupplyContentDescriptionSection>;
};

export interface SupplyContentHeadlineDescriptionUpdateInput {
  description?: InputMaybe<Scalars["String"]>;
  headline?: InputMaybe<Scalars["String"]>;
  propertyName?: InputMaybe<Scalars["String"]>;
}

export type SupplyContentHub = {
  __typename?: "SupplyContentHub";
  contentViewed?: Maybe<SupplyContentEgClickstreamData>;
  header: SupplyContentHubHeader;
  items: Array<SupplyContentHubItem>;
};

export type SupplyContentHubCrumbItem = {
  __typename?: "SupplyContentHubCrumbItem";
  crumbSelected?: Maybe<SupplyContentEgClickstreamData>;
  link?: Maybe<Scalars["String"]>;
  text: Scalars["String"];
};

export type SupplyContentHubHeader = {
  __typename?: "SupplyContentHubHeader";
  heading: Scalars["String"];
  subHeading?: Maybe<Scalars["String"]>;
};

export type SupplyContentHubItem = {
  __typename?: "SupplyContentHubItem";
  contentSelected?: Maybe<SupplyContentEgClickstreamData>;
  heading: Scalars["String"];
  icon: Icon;
  link: Scalars["String"];
  text: Scalars["String"];
};

export type SupplyContentHubNavigation = {
  __typename?: "SupplyContentHubNavigation";
  backButton: SupplyContentButton;
  breadCrumbs: Array<SupplyContentHubCrumbItem>;
};

export interface SupplyContentInputValidation {
  errorMessage: EgdsLocalizedText;
}

export type SupplyContentLeaveWithoutSavingDialog = {
  __typename?: "SupplyContentLeaveWithoutSavingDialog";
  description: Scalars["String"];
  heading: Scalars["String"];
  leaveButton: SupplyContentButton;
  stayButton: SupplyContentButton;
};

export type SupplyContentLinkStyleButton = EgdsButton & {
  __typename?: "SupplyContentLinkStyleButton";
  accessibility?: Maybe<Scalars["String"]>;
  action?: Maybe<UiLinkAction>;
  analytics?: Maybe<ClientSideAnalytics>;
  disabled: Scalars["Boolean"];
  icon?: Maybe<Icon>;
  primary?: Maybe<Scalars["String"]>;
};

export type SupplyContentLocationSharing = {
  __typename?: "SupplyContentLocationSharing";
  contentViewed: Array<Maybe<SupplyContentEgClickstreamData>>;
  header: SupplyContentHubHeader;
  mapSetting?: Maybe<SupplyContentMapSettingsSection>;
  propertyAddress: SupplyContentPropertyAddressSection;
};

export type SupplyContentManualTranslation = {
  __typename?: "SupplyContentManualTranslation";
  addButton: SupplyContentButton;
  deleteDialog: SupplyContentManualTranslationDeleteDialog;
  description: Scalars["String"];
  existingManualTranslations?: Maybe<Array<SupplyContentExistingManualTranslation>>;
  heading: Scalars["String"];
};

export type SupplyContentManualTranslationDeleteDialog = {
  __typename?: "SupplyContentManualTranslationDeleteDialog";
  cancelButton: SupplyContentButton;
  deleteButton: SupplyContentButton;
  heading: Scalars["String"];
};

export type SupplyContentManualTranslationOperation = "ADD" | "DELETE" | "UPDATE";

export type SupplyContentManualTranslationSection = SupplyContentErrorSection | SupplyContentManualTranslation;

export type SupplyContentManualTranslationSetting = {
  __typename?: "SupplyContentManualTranslationSetting";
  description: SupplyContentTextArea;
  headline: SupplyContentTextArea;
  instruction?: Maybe<Scalars["String"]>;
  language: EgdsBasicSelect;
  saveButton: SupplyContentButton;
};

export type SupplyContentManualTranslationSettingDialog = {
  __typename?: "SupplyContentManualTranslationSettingDialog";
  contentViewed?: Maybe<SupplyContentEgClickstreamData>;
  manualTranslation: SupplyContentManualTranslationSetting;
  toolbar: EgdsDialogToolbar;
};

export type SupplyContentManualTranslationUpdate = {
  __typename?: "SupplyContentManualTranslationUpdate";
  failures?: Maybe<Array<SupplyContentDescriptionUpdateFailure>>;
  successToast?: Maybe<EgdsToast>;
};

export interface SupplyContentManualTranslationUpdateInput {
  description?: InputMaybe<Scalars["String"]>;
  headline?: InputMaybe<Scalars["String"]>;
  locale: Scalars["String"];
  operation: SupplyContentManualTranslationOperation;
  optOutAutoTranslation: Scalars["Boolean"];
}

export type SupplyContentMapSettings = {
  __typename?: "SupplyContentMapSettings";
  description?: Maybe<Scalars["String"]>;
  displayOptions?: Maybe<EgdsRadioGroup>;
  exactLatitude?: Maybe<Scalars["String"]>;
  exactLongitude?: Maybe<Scalars["String"]>;
  heading: Scalars["String"];
  instruction?: Maybe<SupplyContentSpannableText>;
  mapSettingSelected?: Maybe<SupplyContentEgClickstreamData>;
  obfuscatedLatitude?: Maybe<Scalars["String"]>;
  obfuscatedLongitude?: Maybe<Scalars["String"]>;
};

export type SupplyContentMapSettingsSection = SupplyContentErrorSection | SupplyContentMapSettings;

export type SupplyContentMaxLengthInputValidation = SupplyContentInputValidation & {
  __typename?: "SupplyContentMaxLengthInputValidation";
  errorMessage: EgdsLocalizedText;
  maxLength: Scalars["Int"];
};

export type SupplyContentMinLengthInputValidation = SupplyContentInputValidation & {
  __typename?: "SupplyContentMinLengthInputValidation";
  errorMessage: EgdsLocalizedText;
  minLength: Scalars["Int"];
};

export type SupplyContentModeration = {
  __typename?: "SupplyContentModeration";
  errorMessage: SupplyContentErrorMessage;
  id: Scalars["String"];
  rule: Moderation_Rule;
  type: Moderation_Type;
  value: Array<Scalars["String"]>;
};

export type SupplyContentPropertyAddress = {
  __typename?: "SupplyContentPropertyAddress";
  address?: Maybe<SupplyContentPropertyAddressDetail>;
  description?: Maybe<Scalars["String"]>;
  heading: Scalars["String"];
  instruction?: Maybe<SupplyContentSpannableText>;
};

export type SupplyContentPropertyAddressDetail = {
  __typename?: "SupplyContentPropertyAddressDetail";
  address1: Scalars["String"];
  address2?: Maybe<Scalars["String"]>;
  cityWithPostalCode: Scalars["String"];
  countryCode: Scalars["String"];
};

export type SupplyContentPropertyAddressSection = SupplyContentErrorSection | SupplyContentPropertyAddress;

export type SupplyContentSaveButton = {
  __typename?: "SupplyContentSaveButton";
  button: SupplyContentButton;
  leaveWithoutSavingDialog: SupplyContentLeaveWithoutSavingDialog;
};

export type SupplyContentSpannableText = {
  __typename?: "SupplyContentSpannableText";
  contents: Array<SupplyContentText>;
  text: Scalars["String"];
};

export type SupplyContentText = {
  __typename?: "SupplyContentText";
  action?: Maybe<SupplyContextTextAction>;
  text: EgdsText;
};

export type SupplyContentTextArea = {
  __typename?: "SupplyContentTextArea";
  contentChanged?: Maybe<SupplyContentEgClickstreamData>;
  errorMessage?: Maybe<Scalars["String"]>;
  instructions?: Maybe<Scalars["String"]>;
  label?: Maybe<Scalars["String"]>;
  labelTemplate?: Maybe<EgdsLocalizedText>;
  leftIcon?: Maybe<Icon>;
  maxRows?: Maybe<Scalars["Int"]>;
  minRows?: Maybe<Scalars["Int"]>;
  moderation?: Maybe<Array<SupplyContentModeration>>;
  placeholder?: Maybe<Scalars["String"]>;
  readOnly: Scalars["Boolean"];
  required?: Maybe<Scalars["Boolean"]>;
  rightIcon?: Maybe<Icon>;
  validations?: Maybe<Array<SupplyContentInputValidation>>;
  value?: Maybe<Scalars["String"]>;
};

export type SupplyContentTips = {
  __typename?: "SupplyContentTips";
  carousel: SupplyContentCarousel;
  contentSelected?: Maybe<SupplyContentEgClickstreamData>;
  description?: Maybe<Scalars["String"]>;
  heading?: Maybe<Scalars["String"]>;
  link?: Maybe<EgdsExpandoLink>;
};

export interface SupplyContentUpdateLocationInput {
  showExactLocation: Scalars["Boolean"];
}

export type SupplyContentUpdateLocationResult = {
  __typename?: "SupplyContentUpdateLocationResult";
  error?: Maybe<SupplyContentErrorMessage>;
  mapSettingSaved?: Maybe<SupplyContentEgClickstreamData>;
};

export type SupplyContentYourStory = {
  __typename?: "SupplyContentYourStory";
  aboutYou: SupplyContentDescriptionSection;
  contentViewed?: Maybe<SupplyContentEgClickstreamData>;
  header: SupplyContentHubHeader;
  uniqueBenefits: SupplyContentDescriptionSection;
  whyThisProperty: SupplyContentDescriptionSection;
};

export interface SupplyContentYourStoryUpdateInput {
  aboutYou?: InputMaybe<Scalars["String"]>;
  uniqueBenefits?: InputMaybe<Scalars["String"]>;
  whyThisProperty?: InputMaybe<Scalars["String"]>;
}

export type SupplyContextTextAction = {
  __typename?: "SupplyContextTextAction";
  selectedAnalytics?: Maybe<SupplyContentEgClickstreamData>;
};

export type SupplyContractExpando = {
  __typename?: "SupplyContractExpando";
  expando: SupplyContractExpandoCard;
  icon?: Maybe<Icon>;
  text: Array<Scalars["String"]>;
};

export type SupplyContractExpandoCard = EgdsExpandoCard | EgdsSpannableText;

export type SupplyContractTerms = {
  __typename?: "SupplyContractTerms";
  banners?: Maybe<Array<UiBanner>>;
  elements: Array<SupplyContractTermsElement>;
  primary: Scalars["String"];
  primaryLink?: Maybe<EgdsStandardLink>;
};

export type SupplyContractTermsElement =
  | EgdsParagraph
  | EgdsPlainText
  | EgdsSpannableText
  | EgdsStylizedText
  | EgdsTextSection
  | SupplyContractExpando
  | SupplyGeneralTermsLink;

export type SupplyCountryCodeOption = {
  __typename?: "SupplyCountryCodeOption";
  label: Scalars["String"];
  /** Masks to be used for phone number based on country code selection */
  masks: Array<Scalars["String"]>;
  selected?: Maybe<Scalars["Boolean"]>;
  value: Scalars["String"];
};

export type SupplyCountryCodeSelection = {
  __typename?: "SupplyCountryCodeSelection";
  egdsElementId?: Maybe<Scalars["String"]>;
  label: Scalars["String"];
  /** Options for country code selection */
  options: Array<SupplyCountryCodeOption>;
};

export interface SupplyCurrentPageContext {
  /** The current relative path for the page */
  path?: InputMaybe<Scalars["String"]>;
  /** specifies any query params the current page has like htid */
  search?: InputMaybe<Scalars["String"]>;
  /** field for native , defining the current native view- like reservations/inbox */
  view?: InputMaybe<Scalars["String"]>;
}

export type SupplyCustomPhoneNumberField = {
  __typename?: "SupplyCustomPhoneNumberField";
  countryCode: SupplyCountryCodeSelection;
  phoneNumber: EgdsTextInputField;
};

export type SupplyEmptyPropertiesSearchResult = {
  __typename?: "SupplyEmptyPropertiesSearchResult";
  primary: EgdsIconText;
  secondary?: Maybe<Scalars["String"]>;
};

export interface SupplyFeeFilterInput {
  includedFees?: InputMaybe<Array<Scalars["String"]>>;
}

export type SupplyFeeInputField = {
  __typename?: "SupplyFeeInputField";
  amount: EgdsNumberInputField;
  amountAnalytics?: Maybe<SupplyContentEgClickstreamData>;
  currencySymbol?: Maybe<Scalars["String"]>;
  name: Scalars["String"];
  productCode: Scalars["String"];
  ratesAvailable: Scalars["Boolean"];
  type: EgdsSelect;
  typeAnalytics?: Maybe<SupplyContentEgClickstreamData>;
};

export type SupplyFeeSignals = {
  __typename?: "SupplyFeeSignals";
  currency: SupplySubscribeSignalAction;
  feeLoad: SupplyPublishSignalAction;
  feeUpdate: SupplyPublishSignalAction;
  rateLoad: SupplySubscribeSignalAction;
  rateReady: SupplySubscribeSignalAction;
};

export type SupplyFees = {
  __typename?: "SupplyFees";
  fields: Array<SupplyFeeInputField>;
  signals?: Maybe<SupplyFeeSignals>;
  title?: Maybe<SupplyFeesTitle>;
};

export interface SupplyFeesInput {
  amount: Scalars["Float"];
  productCode: Scalars["String"];
  type: Scalars["String"];
}

export type SupplyFeesTitle = {
  __typename?: "SupplyFeesTitle";
  heading: Scalars["String"];
  subHeading?: Maybe<Scalars["String"]>;
};

export type SupplyGeneralTermsLink = {
  __typename?: "SupplyGeneralTermsLink";
  lastUpdated?: Maybe<Scalars["String"]>;
  linkText: Scalars["String"];
  sheet: SupplyGeneralTermsSheet;
};

export type SupplyGeneralTermsSheet = {
  __typename?: "SupplyGeneralTermsSheet";
  content: SupplyLegalTemplate;
  select?: Maybe<EgdsBasicSelect>;
  sheet: EgdsSheet;
  title?: Maybe<Scalars["String"]>;
  toolTip?: Maybe<SupplyGeneralTermsToolTip>;
};

export type SupplyGeneralTermsToolTip = {
  __typename?: "SupplyGeneralTermsToolTip";
  content: Array<Scalars["String"]>;
  trigger: EgdsIconText;
};

export type SupplyGuestItemContent = {
  __typename?: "SupplyGuestItemContent";
  primary: Scalars["String"];
  secondary: Scalars["String"];
};

export type SupplyInformationPanel = {
  __typename?: "SupplyInformationPanel";
  expando?: Maybe<EgdsExpandoPeek>;
  icon: Icon;
  sections: Array<SupplyInformationPanelSection>;
};

export type SupplyInformationPanelSection = {
  __typename?: "SupplyInformationPanelSection";
  content: EgdsParagraph;
  heading: EgdsHeading;
};

export type SupplyLegalTemplate = {
  __typename?: "SupplyLegalTemplate";
  html: Scalars["String"];
};

/** Representation of legal view */
export type SupplyLegalView = {
  __typename?: "SupplyLegalView";
  legalCards: Array<EgdsStandardMessagingCard>;
};

export type SupplyMarketMakerGrid = {
  __typename?: "SupplyMarketMakerGrid";
  competitorAverageRatesSection?: Maybe<SupplyMarketMakerGridCompetitorAverageRatesSection>;
  competitorRates?: Maybe<SupplyMarketMakerGridCompetitorRatesSection>;
  dates: Array<SupplyMarketMakerGridDate>;
  legend?: Maybe<SupplyMarketMakerGridLegend>;
  navigation?: Maybe<SupplyMarketMakerGridNavigation>;
  rates: SupplyMarketMakerGridRates;
};

export type SupplyMarketMakerGridCompetitorAverageRatesSection = {
  __typename?: "SupplyMarketMakerGridCompetitorAverageRatesSection";
  averageBookedRates?: Maybe<SupplyMarketMakerGridRates>;
  averageUnbookedRates?: Maybe<SupplyMarketMakerGridRates>;
  link?: Maybe<EgdsStandardLink>;
  title?: Maybe<Scalars["String"]>;
};

export type SupplyMarketMakerGridCompetitorRatesSection = {
  __typename?: "SupplyMarketMakerGridCompetitorRatesSection";
  collapse?: Maybe<SupplyMarketMakerIconButton>;
  competitors: Array<SupplyMarketMakerGridRates>;
  expand?: Maybe<SupplyMarketMakerIconButton>;
  title?: Maybe<Scalars["String"]>;
};

export type SupplyMarketMakerGridDate = {
  __typename?: "SupplyMarketMakerGridDate";
  monthDay?: Maybe<Scalars["String"]>;
  weekDay?: Maybe<Scalars["String"]>;
};

export type SupplyMarketMakerGridLegend = {
  __typename?: "SupplyMarketMakerGridLegend";
  items: Array<SupplyMarketMakerGridLegendItem>;
  title?: Maybe<Scalars["String"]>;
};

export type SupplyMarketMakerGridLegendItem = {
  __typename?: "SupplyMarketMakerGridLegendItem";
  icon: Icon;
  label: Scalars["String"];
};

export type SupplyMarketMakerGridNavigation = {
  __typename?: "SupplyMarketMakerGridNavigation";
  dateLabel?: Maybe<Scalars["String"]>;
  next?: Maybe<SupplyMarketMakerIconButton>;
  previous?: Maybe<SupplyMarketMakerIconButton>;
};

export type SupplyMarketMakerGridRate = {
  __typename?: "SupplyMarketMakerGridRate";
  icon?: Maybe<Icon>;
  rate?: Maybe<Scalars["String"]>;
};

export type SupplyMarketMakerGridRates = {
  __typename?: "SupplyMarketMakerGridRates";
  heading: EgdsStylizedText;
  subheading?: Maybe<EgdsStylizedText>;
  values: Array<SupplyMarketMakerGridRate>;
};

export type SupplyMarketMakerIconButton = {
  __typename?: "SupplyMarketMakerIconButton";
  analytics: ClientSideAnalytics;
  icon: Icon;
};

export type SupplyMembersOnlyDealsTiers = {
  __typename?: "SupplyMembersOnlyDealsTiers";
  clickStreamPageView?: Maybe<SupplyPromotionClickStreamData>;
  create: SupplyPromotionMemberTiersCreateButton;
  learnMore: SupplyPromotionCoachingMessage;
  licensePlate: SupplyPromotionLicensePlate;
  sections: Array<SupplyPromotionMemberTiersSection>;
};

export type SupplyMoreInfoFactor = {
  __typename?: "SupplyMoreInfoFactor";
  content: SupplyMoreInfoFactorContent;
  description: Scalars["String"];
  trigger: SupplyMoreInfoFactorTrigger;
};

export type SupplyMoreInfoFactorContent = {
  __typename?: "SupplyMoreInfoFactorContent";
  text: Scalars["String"];
};

export type SupplyMoreInfoFactorTrigger = {
  __typename?: "SupplyMoreInfoFactorTrigger";
  text: EgdsIconText;
};

/**
 * Representation of Phone number selection view
 * Figma: https://www.figma.com/file/9ISAhyQCup6xwaFlCNyK08/TPGMR-190---2FA?node-id=3786%3A26588
 */
export type SupplyMultiFactorAuthSelectionView = {
  __typename?: "SupplyMultiFactorAuthSelectionView";
  generateCode: EgdsButton;
  phoneNumberSelection: SupplyPhoneNumberSelectionView;
  verificationTypeView: SupplyPhoneNumberVerifyTypeView;
};

/** Possible responses for MFA landing view */
export type SupplyMultiFactorAuthenticationExperience =
  | SupplyMultiFactorLoadErrorView
  | SupplyMultiFactorResultView
  | SupplyMultiFactorSelectionView
  | SupplyMultiFactorVerificationView;

/** Input for generating mfa code */
export interface SupplyMultiFactorCodeGenerationInput {
  /** Optional challenge ticket in case use tries to request for a new code via `send me a new code` operation */
  challengeTicket?: InputMaybe<Scalars["String"]>;
  /** Country code for the phone number */
  countryCode: Scalars["String"];
  /** Phone number of the user */
  phoneNumber: Scalars["String"];
  /** MFA Verification type */
  verifyMethod: MfaVerificationMethod;
}

/** Input for verifying mfa code */
export interface SupplyMultiFactorCodeVerificationInput {
  /** Challenge ticket associated with the mfa flow */
  challengeTicket: Scalars["String"];
  /** 6 digit Code sent to user */
  code: Scalars["String"];
  /** Country code for the phone number */
  countryCode: Scalars["String"];
  /** Phone number of the user */
  phoneNumber: Scalars["String"];
  /** MFA verification method */
  verifyMethod: MfaVerificationMethod;
}

/** Representation of view when there is an error while loading 2fa landing page */
export type SupplyMultiFactorLoadErrorView = {
  __typename?: "SupplyMultiFactorLoadErrorView";
  heading: Scalars["String"];
  serviceError: Scalars["String"];
};

export type SupplyMultiFactorResult = EgdsStandardMessagingCard | UiBanner;

/**
 * Representation of view for successful or unsuccessful completion of 2fa flow. This view is also
 * used for cases when user exhausts code generation and code verification attempts
 */
export type SupplyMultiFactorResultView = {
  __typename?: "SupplyMultiFactorResultView";
  /** MFA event for code verification succeeded */
  clickstreamSucceeded?: Maybe<TwoFactorAuthEgClickstreamData>;
  heading: Scalars["String"];
  resultView: SupplyMultiFactorResult;
};

/** Representation of view for successful landing on 2fa experience */
export type SupplyMultiFactorSelectionView = {
  __typename?: "SupplyMultiFactorSelectionView";
  /**
   * Success loading event for landing experience. The first time use lands into MFA experience
   * this fill will be populated, subsequent times it will not be.
   */
  clickstreamPresented?: Maybe<TwoFactorAuthEgClickstreamData>;
  heading: Scalars["String"];
  legal: SupplyLegalView;
  selectionView: SupplyMultiFactorAuthSelectionView;
  serviceError?: Maybe<Scalars["String"]>;
};

/** Representation of view for landing on code verification page after a code was generated successfully */
export type SupplyMultiFactorVerificationView = {
  __typename?: "SupplyMultiFactorVerificationView";
  /** Failure event after code verification. Populated alongside 'serviceError' */
  clickstreamFailure?: Maybe<TwoFactorAuthEgClickstreamData>;
  heading: Scalars["String"];
  legal: SupplyLegalView;
  serviceError?: Maybe<Scalars["String"]>;
  verificationView: SupplyPhoneNumberVerificationView;
};

export type SupplyNavigation = {
  __typename?: "SupplyNavigation";
  header: SupplyNavigationHeader;
  sidebar: SupplyNavigationSidebar;
};

export type SupplyNavigationAction = SupplyNavigationActionOpenMenu | SupplyPublishSignalAction;

export type SupplyNavigationActionOpenMenu = {
  __typename?: "SupplyNavigationActionOpenMenu";
  menu: SupplyNavigationHeaderMenu;
};

export interface SupplyNavigationContext {
  showSidebarTrigger: Scalars["Boolean"];
}

export type SupplyNavigationEgClickstream = IEgClickstreamData & {
  __typename?: "SupplyNavigationEgClickstream";
  additionalContext?: Maybe<EgAdditionalContext>;
  event: EgClickstreamEvent;
  experience: EgClickstreamExperience;
  mapProductDetail: EgPropertyCount;
  notification?: Maybe<EgNotificationAttributes>;
  typeahead?: Maybe<EgTypeAHead>;
};

export type SupplyNavigationHeader = {
  __typename?: "SupplyNavigationHeader";
  /** Describes the content necessary for an account dropdown menu */
  accountTrigger: SupplyNavigationHeaderButton;
  /** The brand specific logo for the supply navigation */
  logo: SupplyNavigationHeaderLogo;
  /** Describes the content necessary for an account nav presented clickstream event */
  navigationPresented: SupplyNavigationEgClickstream;
  /** Describes the content necessary for a notification dropdown menu */
  notificationsTrigger?: Maybe<SupplyNavigationHeaderButton>;
  /** Describes the content necessary for a property detail dropdown menu */
  propertyDetailsTrigger?: Maybe<SupplyNavigationHeaderButton>;
  /** Describes the content necessary for a property detail dropdown menu */
  propertyFilterTrigger?: Maybe<SupplyNavigationHeaderButton>;
  /** A button which toggles the visibility of the navigation sidebar sheet dialog */
  sidebarTrigger?: Maybe<SupplyNavigationHeaderButton>;
};

export type SupplyNavigationHeaderButton = {
  __typename?: "SupplyNavigationHeaderButton";
  accessibility: Scalars["String"];
  action: SupplyNavigationAction;
  buttonIcon: SupplyNavigationHeaderButtonIcon;
  headerMenuClosedEvent?: Maybe<SupplyNavigationEgClickstream>;
  text?: Maybe<Scalars["String"]>;
};

export type SupplyNavigationHeaderButtonIcon = {
  __typename?: "SupplyNavigationHeaderButtonIcon";
  badge?: Maybe<EgdsBadgeNotification>;
  icon: Icon;
  inverse: Scalars["Boolean"];
};

export type SupplyNavigationHeaderLogo = {
  __typename?: "SupplyNavigationHeaderLogo";
  action: UiLinkAction;
  graphic: UiGraphic;
  headerLogoSelected: SupplyNavigationEgClickstream;
};

export type SupplyNavigationHeaderMenu = {
  __typename?: "SupplyNavigationHeaderMenu";
  content: SupplyNavigationMenuContentDetails;
  header?: Maybe<SupplyNavigationMenuContentHeader>;
};

export type SupplyNavigationHeaderMenuType = "NOTIFICATIONS" | "PROPERTY_DETAILS" | "PROPERTY_FILTER";

export type SupplyNavigationHeaderSearchTrigger = UiAction & {
  __typename?: "SupplyNavigationHeaderSearchTrigger";
  /** Localized accessible string for input */
  accessibility: Scalars["String"];
  /** Analytics for the search input */
  analytics: ClientSideAnalytics;
  /** Icon for the search */
  icon?: Maybe<Icon>;
  /** Localized placeholder string for search input */
  placeholder?: Maybe<Scalars["String"]>;
};

export type SupplyNavigationItem = SupplyNavigationItemLink | SupplyNavigationItemMenu;

export type SupplyNavigationItemLink = {
  __typename?: "SupplyNavigationItemLink";
  active: Scalars["Boolean"];
  badge?: Maybe<EgdsStandardBadge>;
  icon?: Maybe<Icon>;
  link: UiLinkAction;
  menuSelected: SupplyNavigationEgClickstream;
  text: Scalars["String"];
};

export type SupplyNavigationItemMenu = {
  __typename?: "SupplyNavigationItemMenu";
  active: Scalars["Boolean"];
  badge?: Maybe<EgdsStandardBadge>;
  children: Array<SupplyNavigationItemLink>;
  icon?: Maybe<Icon>;
  menuPresented: SupplyNavigationEgClickstream;
  menuSelected: SupplyNavigationEgClickstream;
  text: Scalars["String"];
};

export type SupplyNavigationLazyMenuContent = {
  __typename?: "SupplyNavigationLazyMenuContent";
  menuType: SupplyNavigationHeaderMenuType;
};

export type SupplyNavigationMenuContent = {
  __typename?: "SupplyNavigationMenuContent";
  menuContentPresented?: Maybe<SupplyNavigationEgClickstream>;
  sections: Array<SupplyNavigationMenuContentSection>;
};

export type SupplyNavigationMenuContentDetails = SupplyNavigationLazyMenuContent | SupplyNavigationMenuContent;

export type SupplyNavigationMenuContentHeader = {
  __typename?: "SupplyNavigationMenuContentHeader";
  borderSeparator: Scalars["Boolean"];
  primary: Scalars["String"];
  secondaries: Array<Scalars["String"]>;
};

export type SupplyNavigationMenuContentListItemAction = {
  __typename?: "SupplyNavigationMenuContentListItemAction";
  action: UiLinkAction;
  borderSeparator: Scalars["Boolean"];
  menuContentSectionItemSelected: SupplyNavigationEgClickstream;
  primary: SupplyNavigationMenuContentListItemActionPrimary;
  secondary?: Maybe<SupplyNavigationMenuContentListItemActionSecondary>;
};

export type SupplyNavigationMenuContentListItemActionPrimary = EgdsPlainText | EgdsStylizedText;

export type SupplyNavigationMenuContentListItemActionSecondary = EgdsPlainText | EgdsStylizedText | Icon;

export type SupplyNavigationMenuContentSection =
  | SupplyNavigationMenuContentSectionWithListItemActions
  | SupplyNavigationMenuContentSectionWithSubSections
  | SupplyNavigationNotificationMenuContentSection;

export type SupplyNavigationMenuContentSectionWithListItemActions = {
  __typename?: "SupplyNavigationMenuContentSectionWithListItemActions";
  actions: Array<SupplyNavigationMenuContentListItemAction>;
  /** @deprecated No longer supported */
  menuContentSectionPresented: SupplyNavigationEgClickstream;
  primary?: Maybe<Scalars["String"]>;
};

export type SupplyNavigationMenuContentSectionWithSubSections = {
  __typename?: "SupplyNavigationMenuContentSectionWithSubSections";
  subSections: Array<SupplyNavigationMenuContentSubSection>;
};

export type SupplyNavigationMenuContentSubSection = {
  __typename?: "SupplyNavigationMenuContentSubSection";
  actions: Array<SupplyNavigationMenuContentListItemAction>;
  primary?: Maybe<Scalars["String"]>;
};

export type SupplyNavigationNotificationContent = EgdsIconText | SupplyNavigationMenuContent;

export type SupplyNavigationNotificationMenuContentSection = {
  __typename?: "SupplyNavigationNotificationMenuContentSection";
  expando?: Maybe<EgdsExpandoPeek>;
  notificationItems: Array<SupplyNavigationNotificationMenuListItem>;
  /** @deprecated No longer supported */
  notificationPresented: SupplyNavigationEgClickstream;
};

export type SupplyNavigationNotificationMenuListItem = {
  __typename?: "SupplyNavigationNotificationMenuListItem";
  action?: Maybe<UiLinkAction>;
  badge: EgdsBadgeNotification;
  notificationId: Scalars["String"];
  notificationSelected: SupplyNavigationEgClickstream;
  primary: SupplyNavigationMenuContentListItemActionPrimary;
  secondary: SupplyNavigationMenuContentListItemActionSecondary;
};

export type SupplyNavigationSidebar = {
  __typename?: "SupplyNavigationSidebar";
  footer: SupplyNavigationSidebarFooter;
  items: Array<SupplyNavigationItem>;
  navigationSidePresented: SupplyNavigationEgClickstream;
};

export type SupplyNavigationSidebarFooter = {
  __typename?: "SupplyNavigationSidebarFooter";
  copyright: Scalars["String"];
  legalLinks: Array<SupplyNavigationSidebarFooterLink>;
};

export type SupplyNavigationSidebarFooterLink = {
  __typename?: "SupplyNavigationSidebarFooterLink";
  icon?: Maybe<Icon>;
  link: UiLinkAction;
  text: Scalars["String"];
};

export type SupplyNavigationUserImpersonationBanner = {
  __typename?: "SupplyNavigationUserImpersonationBanner";
  icon: Icon;
  link: EgdsStandardLink;
  primary: Scalars["String"];
  secondary: Scalars["String"];
};

export interface SupplyNewListingOfferEnrollmentInput {
  enrolled: Scalars["Boolean"];
}

export type SupplyNightlyPaymentDetailsSection = {
  __typename?: "SupplyNightlyPaymentDetailsSection";
  label: EgdsStylizedText;
  nightlyPaymentLineItems: Array<SupplyPaymentDetailsLineItem>;
};

export type SupplyOnboardingAction = {
  __typename?: "SupplyOnboardingAction";
  buttonType: SupplyOnboardingButtonType;
  currentStep: Scalars["String"];
};

export type SupplyOnboardingActionResource = {
  __typename?: "SupplyOnboardingActionResource";
  relativePath: Scalars["String"];
};

/** Representation of Availability Selection page. */
export type SupplyOnboardingAvailability = {
  __typename?: "SupplyOnboardingAvailability";
  /** Availability card radio selections */
  availabilityCards: Array<SupplyOnboardingAvailabilityCard>;
  /** Confirmation popup modal, if the Calendar is not originally setup it would return null */
  dialog?: Maybe<SupplyOnboardingAvailabilityConfirmation>;
  /** Signal that this block publish saveForm function to Next button */
  saveAction?: Maybe<SupplyPublishSignalAction>;
  /** Selected availability type */
  selected?: Maybe<SupplyOnboardingAvailabilityType>;
  /** Signal that this block publish when the card is selected */
  validAction?: Maybe<SupplyPublishSignalAction>;
};

export type SupplyOnboardingAvailabilityButton = {
  __typename?: "SupplyOnboardingAvailabilityButton";
  button: EgdsButton;
  selectedAnalytics: SupplyOnboardingAvailabilityClickstreamData;
};

export type SupplyOnboardingAvailabilityCard = {
  __typename?: "SupplyOnboardingAvailabilityCard";
  accessibilityLabel: Scalars["String"];
  availabilityType: SupplyOnboardingAvailabilityType;
  description: Scalars["String"];
  illustration: Illustration;
  selectedAnalytics: SupplyOnboardingAvailabilityClickstreamData;
  title: Scalars["String"];
};

export type SupplyOnboardingAvailabilityClickstreamData = {
  __typename?: "SupplyOnboardingAvailabilityClickstreamData";
  event: EgClickstreamEvent;
  experience: EgClickstreamExperience;
  partner_common?: Maybe<EgClickstreamPartnerCommonData>;
};

export type SupplyOnboardingAvailabilityConfirmation = {
  __typename?: "SupplyOnboardingAvailabilityConfirmation";
  accessibilityLabel: Scalars["String"];
  cancelButton: SupplyOnboardingAvailabilityButton;
  confirmButton: SupplyOnboardingAvailabilityButton;
  description: Scalars["String"];
  title: Scalars["String"];
};

export type SupplyOnboardingAvailabilityType = "BLOCK" | "OPEN";

export type SupplyOnboardingAvailabilityUpdate = {
  __typename?: "SupplyOnboardingAvailabilityUpdate";
  success: SupplyOnboardingAvailabilityType;
};

export type SupplyOnboardingBackButton = {
  __typename?: "SupplyOnboardingBackButton";
  action?: Maybe<UiLinkAction>;
  icon?: Maybe<Icon>;
  primary?: Maybe<Scalars["String"]>;
};

export type SupplyOnboardingButton = {
  __typename?: "SupplyOnboardingButton";
  action: SupplyOnboardingAction;
  analytics: SupplyOnboardingNavigationClickstreamData;
  button: EgdsButton;
  disabledAction?: Maybe<SupplySubscribeSignalAction>;
  hideAction?: Maybe<SupplySubscribeSignalAction>;
  saveAction?: Maybe<SupplySubscribeSignalAction>;
};

export type SupplyOnboardingButtonType = "BACK" | "DONE" | "LINK" | "NEXT" | "SKIP";

export type SupplyOnboardingHostTypeResult = {
  __typename?: "SupplyOnboardingHostTypeResult";
  hostType: Scalars["String"];
};

export type SupplyOnboardingNavigationClickstreamData = {
  __typename?: "SupplyOnboardingNavigationClickstreamData";
  event: EgClickstreamEvent;
  experience: EgClickstreamExperience;
  partner_common?: Maybe<EgClickstreamPartnerCommonData>;
};

export type SupplyOnboardingNavigationHeader = {
  __typename?: "SupplyOnboardingNavigationHeader";
  logo: SupplyOnboardingNavigationHeaderLogo;
  saveIndicator?: Maybe<SupplyOnboardingSaveIndicator>;
};

export type SupplyOnboardingNavigationHeaderLogo = {
  __typename?: "SupplyOnboardingNavigationHeaderLogo";
  action: UiLinkAction;
  imgSrc: Image;
};

export type SupplyOnboardingPageTitle = {
  __typename?: "SupplyOnboardingPageTitle";
  description?: Maybe<Scalars["String"]>;
  title: Scalars["String"];
};

export type SupplyOnboardingPartnerBillingAddress = {
  __typename?: "SupplyOnboardingPartnerBillingAddress";
  city: Scalars["String"];
  country: Scalars["String"];
  isAddingAddress: Scalars["Boolean"];
  postalCode: Scalars["String"];
  stateProvince: Scalars["String"];
  streetAddress: Scalars["String"];
  unit?: Maybe<Scalars["String"]>;
};

/** Input for Billing Address */
export interface SupplyOnboardingPartnerBillingAddressInput {
  /** City */
  city: Scalars["String"];
  /** Country */
  country: Scalars["String"];
  /** Flag for removing or adding address */
  isAddingAddress: Scalars["Boolean"];
  /** Postal Code */
  postalCode: Scalars["String"];
  /** State or Province */
  stateProvince: Scalars["String"];
  /** Address */
  streetAddress: Scalars["String"];
  /** Unit, apt, etc */
  unit?: InputMaybe<Scalars["String"]>;
}

/** View that represents Billing Address section */
export type SupplyOnboardingPartnerBillingAddressSection = {
  __typename?: "SupplyOnboardingPartnerBillingAddressSection";
  address: SupplyPartnerBillingAddress;
  country: EgdsBasicSelect;
  description: Scalars["String"];
  heading: Scalars["String"];
  isSameAsPropertyAddress?: Maybe<EgdsCheckBox>;
};

export interface SupplyOnboardingPartnerBusinessNameInput {
  businessName: Scalars["String"];
}

export type SupplyOnboardingPartnerBusinessNameResult = {
  __typename?: "SupplyOnboardingPartnerBusinessNameResult";
  businessName: Scalars["String"];
};

/** View that represents Business name section */
export type SupplyOnboardingPartnerBusinessNameSection = {
  __typename?: "SupplyOnboardingPartnerBusinessNameSection";
  businessName: EgdsTextInputField;
  heading: Scalars["String"];
};

/** View that represents error section */
export type SupplyOnboardingPartnerError = {
  __typename?: "SupplyOnboardingPartnerError";
  heading: Scalars["String"];
  icon: Icon;
  message: Scalars["String"];
};

/** View that represents HostType section */
export type SupplyOnboardingPartnerHostTypeSection = {
  __typename?: "SupplyOnboardingPartnerHostTypeSection";
  heading: Scalars["String"];
  hostTypes: EgdsBasicRadioGroup;
};

export type SupplyOnboardingPaymentTermsAndConditionsView = {
  __typename?: "SupplyOnboardingPaymentTermsAndConditionsView";
  acceptanceCheckbox: EgdsBasicCheckBox;
  heading: Scalars["String"];
};

export type SupplyOnboardingPropertyRatesExperience = {
  __typename?: "SupplyOnboardingPropertyRatesExperience";
  currencyView: SupplyPropertyRatesBankingCountryCurrencyView;
  errorView?: Maybe<SupplyPropertyRatesErrorView>;
  heading: Scalars["String"];
  offerView: SupplyPropertyRatesOfferView;
  rateView: SupplyPropertyRatesNightlyBaseRateView;
};

export type SupplyOnboardingPublishListing = {
  __typename?: "SupplyOnboardingPublishListing";
  accessibilityLabel: Scalars["String"];
  contentList?: Maybe<Array<EgdsSpannableText>>;
  description: Scalars["String"];
  heading: Scalars["String"];
  illustration?: Maybe<Illustration>;
  publishButton?: Maybe<SupplyOnboardingPublishListingButton>;
  supplyOnboardingBackButton?: Maybe<SupplyOnboardingBackButton>;
};

export type SupplyOnboardingPublishListingAction = {
  __typename?: "SupplyOnboardingPublishListingAction";
  accessibility?: Maybe<Scalars["String"]>;
  analytics: SupplyOnboardingPublishListingClickstreamData;
  event?: Maybe<SupplyOnboardingPublishListingSubmissionEvent>;
  signal?: Maybe<SupplyPublishSignalAction>;
};

export type SupplyOnboardingPublishListingButton = {
  __typename?: "SupplyOnboardingPublishListingButton";
  action: SupplyOnboardingPublishListingButtonAction;
  primary: Scalars["String"];
};

export type SupplyOnboardingPublishListingButtonAction = SupplyOnboardingPublishListingAction | UiLinkAction;

export type SupplyOnboardingPublishListingClickstreamData = IEgClickstreamData & {
  __typename?: "SupplyOnboardingPublishListingClickstreamData";
  event?: Maybe<EgClickstreamEvent>;
  experience?: Maybe<EgClickstreamExperience>;
  partner_common?: Maybe<EgClickstreamPartnerCommonData>;
  product_list?: Maybe<Array<EgClickstreamProductListData>>;
  virtual_market_coach?: Maybe<EgClickstreamVirtualMarketCoachData>;
};

export type SupplyOnboardingPublishListingResult = {
  __typename?: "SupplyOnboardingPublishListingResult";
  success: Scalars["Boolean"];
};

export type SupplyOnboardingPublishListingSubmissionEvent = {
  __typename?: "SupplyOnboardingPublishListingSubmissionEvent";
  bidTarget: Scalars["String"];
  bidTargetUuid: Scalars["String"];
  eventName: Scalars["String"];
  newSupplier: Scalars["Boolean"];
};

export type SupplyOnboardingReadiness = {
  __typename?: "SupplyOnboardingReadiness";
  hideAction?: Maybe<SupplySubscribeSignalAction>;
  stepReviewList: StepReviewList;
};

export type SupplyOnboardingReviewExperience = {
  __typename?: "SupplyOnboardingReviewExperience";
  clickstreamPageView?: Maybe<EgClickstreamData>;
  informationPanel: SupplyInformationPanel;
  sections: Array<SupplyOnboardingReviewSection>;
  signal?: Maybe<SupplyPublishSignalAction>;
};

export type SupplyOnboardingReviewPhotoList = {
  __typename?: "SupplyOnboardingReviewPhotoList";
  imageList: Array<Image>;
  scrimEdit?: Maybe<SupplyReviewEditLink>;
  scrimIcon: Icon;
};

export type SupplyOnboardingReviewSection = SupplyPlaybackSection | SupplyPlaybackSectionList;

export type SupplyOnboardingSaveIndicator = {
  __typename?: "SupplyOnboardingSaveIndicator";
  popoverText?: Maybe<Scalars["String"]>;
  savedText: Scalars["String"];
  savingText: Scalars["String"];
};

export type SupplyOnboardingTipCard = {
  __typename?: "SupplyOnboardingTipCard";
  icon: Icon;
  sections: Array<SupplyTipCardSection>;
};

export type SupplyOnboardingTipCardId = "AMENITIES" | "PHOTOS" | "REGULATORY";

export type SupplyOnboardingTipContent = EgdsParagraph;

export type SupplyOnboardingWelcome = {
  __typename?: "SupplyOnboardingWelcome";
  content: SupplyOnboardingWelcomeSectionContent;
  informationPanel: SupplyOnboardingWelcomeInformationPanel;
  primaryButton: SupplyOnboardingWelcomeButton;
  subTitle: Scalars["String"];
  title: Scalars["String"];
};

export type SupplyOnboardingWelcomeButton = {
  __typename?: "SupplyOnboardingWelcomeButton";
  action: SupplyOnboardingWelcomeButtonAction;
  button: EgdsButton;
};

export type SupplyOnboardingWelcomeButtonAction = {
  __typename?: "SupplyOnboardingWelcomeButtonAction";
  analytics: SupplyOnboardingWelcomeClickstreamData;
};

export type SupplyOnboardingWelcomeClickstreamData = {
  __typename?: "SupplyOnboardingWelcomeClickstreamData";
  event: EgClickstreamEvent;
  experience: EgClickstreamExperience;
  partner_common?: Maybe<EgClickstreamPartnerCommonData>;
};

export type SupplyOnboardingWelcomeInformationPanel = {
  __typename?: "SupplyOnboardingWelcomeInformationPanel";
  content: Scalars["String"];
  icon: Icon;
};

export type SupplyOnboardingWelcomeNavigationUpdate = {
  __typename?: "SupplyOnboardingWelcomeNavigationUpdate";
  relativePath: Scalars["String"];
};

export type SupplyOnboardingWelcomeSectionContent = {
  __typename?: "SupplyOnboardingWelcomeSectionContent";
  content: EgdsBulletedList;
  title: Scalars["String"];
};

export type SupplyOnboardingWorkFlowNavigation = {
  __typename?: "SupplyOnboardingWorkFlowNavigation";
  backButton?: Maybe<SupplyOnboardingButton>;
  currentStep: Scalars["String"];
  groups: Array<SupplyOnboardingWorkFlowNavigationGroup>;
  nextButton?: Maybe<SupplyOnboardingButton>;
  skipButton?: Maybe<SupplyOnboardingButton>;
};

export type SupplyOnboardingWorkFlowNavigationGroup = {
  __typename?: "SupplyOnboardingWorkFlowNavigationGroup";
  identifier: Scalars["String"];
  label: EgdsStylizedText;
  smallLabel?: Maybe<EgdsStylizedText>;
  steps: Array<EgdsProgressBar>;
};

export type SupplyOnboardingWorkFlowNavigationUpdate = {
  __typename?: "SupplyOnboardingWorkFlowNavigationUpdate";
  resource: SupplyOnboardingActionResource;
};

export type SupplyPartnerAddressProvince = EgdsBasicSelect | EgdsTextInputField;

export type SupplyPartnerBillingAddress = {
  __typename?: "SupplyPartnerBillingAddress";
  city: EgdsTextInputField;
  postalCode: EgdsTextInputField;
  state: SupplyPartnerAddressProvince;
  streetAddress: EgdsTextInputField;
  unit: EgdsTextInputField;
};

/** Representation of view for the business partner info page */
export type SupplyPartnerInformation = {
  __typename?: "SupplyPartnerInformation";
  billingAddress: SupplyOnboardingPartnerBillingAddressSection;
  businessName?: Maybe<SupplyOnboardingPartnerBusinessNameSection>;
  error?: Maybe<SupplyOnboardingPartnerError>;
  heading: Scalars["String"];
  hostType: SupplyOnboardingPartnerHostTypeSection;
  propertyAddressForBilling: SupplyOnboardingPartnerBillingAddress;
};

export interface SupplyPartnerPayoutDeferredAccountInput {
  bankingCountry: Scalars["String"];
  currency: Scalars["String"];
}

export type SupplyPaymentDetails = {
  __typename?: "SupplyPaymentDetails";
  detailedPaymentLineItems: SupplyPaymentDisplayDetailed;
  summaryPaymentLineItems: Array<SupplyPaymentDetailsLineItem>;
};

export type SupplyPaymentDetailsAmountLineItem = {
  __typename?: "SupplyPaymentDetailsAmountLineItem";
  amount: EgdsStylizedText;
  icon?: Maybe<Icon>;
};

export type SupplyPaymentDetailsExpandoComponentLineItems = {
  __typename?: "SupplyPaymentDetailsExpandoComponentLineItems";
  expando: SupplyPaymentDetailsExpandoLink;
  nightlyPaymentList: Array<SupplyNightlyPaymentDetailsSection>;
  nightlyPaymentTitle?: Maybe<SupplyPaymentDetailsTitleLineItem>;
};

export type SupplyPaymentDetailsExpandoLineItem = ISupplyPaymentLineItem &
  ISupplyPaymentMoreInfo & {
    __typename?: "SupplyPaymentDetailsExpandoLineItem";
    amount: SupplyPaymentDetailsAmountLineItem;
    expando: SupplyPaymentDetailsExpandoLink;
    footerNoteText?: Maybe<EgdsStylizedText>;
    lineItemText: EgdsStylizedText;
    originalAmount?: Maybe<SupplyPaymentDetailsAmountLineItem>;
    sideNoteText?: Maybe<EgdsStylizedText>;
    subLineItems: Array<SupplyPaymentDetailsSubLineItem>;
    tooltip?: Maybe<SupplyPaymentTooltip>;
  };

export type SupplyPaymentDetailsExpandoLink = EgdsExpando & {
  __typename?: "SupplyPaymentDetailsExpandoLink";
  alignment?: Maybe<SupplyPaymentDetailsExpandoPositioning>;
  collapseAnalytics?: Maybe<ClientSideAnalytics>;
  collapsedLabel: Scalars["String"];
  expandAnalytics?: Maybe<ClientSideAnalytics>;
  expanded: Scalars["Boolean"];
  expandedLabel: Scalars["String"];
};

export type SupplyPaymentDetailsExpandoPositioning = "LEADING" | "TRAILING";

export type SupplyPaymentDetailsLineItem =
  | SupplyPaymentDetailsExpandoLineItem
  | SupplyPaymentDetailsSubLineItem
  | SupplyPaymentDetailsTitleLineItem
  | SupplyPaymentDetailsTotalLineItem;

export type SupplyPaymentDetailsSheetComponentLineItems = {
  __typename?: "SupplyPaymentDetailsSheetComponentLineItems";
  childLineItems: Array<SupplyPaymentDetailsLineItem>;
  sheet: SupplyPaymentDisplaySidePanelProps;
};

export type SupplyPaymentDetailsSubLineItem = ISupplyPaymentLineItem &
  ISupplyPaymentMoreInfo & {
    __typename?: "SupplyPaymentDetailsSubLineItem";
    amount: SupplyPaymentDetailsAmountLineItem;
    footerNoteText?: Maybe<EgdsStylizedText>;
    lineItemText: EgdsStylizedText;
    originalAmount?: Maybe<SupplyPaymentDetailsAmountLineItem>;
    sideNoteText?: Maybe<EgdsStylizedText>;
    tooltip?: Maybe<SupplyPaymentTooltip>;
  };

export type SupplyPaymentDetailsTitleLineItem = ISupplyPaymentMoreInfo & {
  __typename?: "SupplyPaymentDetailsTitleLineItem";
  badge?: Maybe<EgdsStandardBadge>;
  footerNoteText?: Maybe<EgdsStylizedText>;
  title: EgdsStylizedText;
  tooltip?: Maybe<SupplyPaymentTooltip>;
};

export type SupplyPaymentDetailsTotalLineItem = ISupplyPaymentLineItem &
  ISupplyPaymentMoreInfo & {
    __typename?: "SupplyPaymentDetailsTotalLineItem";
    amount: SupplyPaymentDetailsAmountLineItem;
    badge?: Maybe<EgdsStandardBadge>;
    borderSeparator: Scalars["Boolean"];
    currencyCode?: Maybe<EgdsStylizedText>;
    footerNoteText?: Maybe<EgdsStylizedText>;
    lineItemText: EgdsStylizedText;
    originalAmount?: Maybe<SupplyPaymentDetailsAmountLineItem>;
    sideNoteText?: Maybe<EgdsStylizedText>;
    tooltip?: Maybe<SupplyPaymentTooltip>;
  };

export type SupplyPaymentDisplayDetailed =
  | SupplyPaymentDetailsExpandoComponentLineItems
  | SupplyPaymentDetailsSheetComponentLineItems;

export type SupplyPaymentDisplaySidePanelProps = {
  __typename?: "SupplyPaymentDisplaySidePanelProps";
  navType?: Maybe<SupplyPaymentDisplayToolbarIcon>;
  toolbarTitle?: Maybe<Scalars["String"]>;
};

export type SupplyPaymentDisplayToolbarIcon = "BACK" | "CLOSE";

export type SupplyPaymentTooltip = {
  __typename?: "SupplyPaymentTooltip";
  contents?: Maybe<Array<SupplyPaymentTooltipContent>>;
  icon: Icon;
};

export type SupplyPaymentTooltipContent = {
  __typename?: "SupplyPaymentTooltipContent";
  tooltipHeader?: Maybe<EgdsStylizedText>;
  tooltipLink?: Maybe<EgdsStandardLink>;
  tooltipText: EgdsStylizedText;
};

export type SupplyPhoneNumberSelectionView = {
  __typename?: "SupplyPhoneNumberSelectionView";
  addNewPhoneView?: Maybe<SupplyCustomPhoneNumberField>;
  heading: Scalars["String"];
  options: EgdsBasicRadioGroup;
};

/**
 * Representation of Verification view
 * Figma: https://www.figma.com/file/9ISAhyQCup6xwaFlCNyK08/TPGMR-190---2FA?node-id=3786%3A26502
 */
export type SupplyPhoneNumberVerificationView = {
  __typename?: "SupplyPhoneNumberVerificationView";
  challengeTicket: Scalars["String"];
  changeVerifyMethod: EgdsButton;
  codeInput: EgdsTextInputField;
  generateNewCode: EgdsButton;
  heading: Scalars["String"];
  invalidCodeMessage?: Maybe<Scalars["String"]>;
  message: Scalars["String"];
  newCodeMessage?: Maybe<EgdsToast>;
  verifyCode: EgdsButton;
};

export type SupplyPhoneNumberVerifyTypeView = {
  __typename?: "SupplyPhoneNumberVerifyTypeView";
  heading: Scalars["String"];
  options: EgdsBasicRadioGroup;
};

export type SupplyPlaybackSection = {
  __typename?: "SupplyPlaybackSection";
  clickstreamInformation?: Maybe<EgClickstreamData>;
  content: SupplyReviewSectionListItemContent;
  contentListColumns?: Maybe<Scalars["Int"]>;
  editLink?: Maybe<SupplyReviewEditLink>;
  icon: Icon;
  subtitle?: Maybe<Scalars["String"]>;
  title: Scalars["String"];
};

export type SupplyPlaybackSectionList = {
  __typename?: "SupplyPlaybackSectionList";
  content: Array<SupplyReviewSectionListItem>;
  icon: Icon;
  subtitle?: Maybe<Scalars["String"]>;
  title: Scalars["String"];
};

export type SupplyPromotionActionMenu = {
  __typename?: "SupplyPromotionActionMenu";
  actions: Array<EgdsStandardLink>;
};

export type SupplyPromotionBreadcrumbMenu = {
  __typename?: "SupplyPromotionBreadcrumbMenu";
  menus: Array<EgdsStandardLink>;
};

export type SupplyPromotionClickStreamData = IEgClickstreamData & {
  __typename?: "SupplyPromotionClickStreamData";
  event?: Maybe<EgClickstreamEvent>;
  experience?: Maybe<EgClickstreamExperience>;
  partner_common?: Maybe<EgClickStreamPartnerCommon>;
};

export type SupplyPromotionCoachingMessage = {
  __typename?: "SupplyPromotionCoachingMessage";
  content?: Maybe<Array<SupplyPromotionCoachingMessageText>>;
  icon: Icon;
  link?: Maybe<EgdsStandardLink>;
  title: Scalars["String"];
};

export type SupplyPromotionCoachingMessageText = EgdsBulletedList | EgdsPlainText;

export type SupplyPromotionLicensePlate = {
  __typename?: "SupplyPromotionLicensePlate";
  actionMenu: SupplyPromotionActionMenu;
  breadcrumbMenu: SupplyPromotionBreadcrumbMenu;
  description?: Maybe<Scalars["String"]>;
  title: Scalars["String"];
};

export type SupplyPromotionMemberTiersBlockoutDateRange = {
  __typename?: "SupplyPromotionMemberTiersBlockoutDateRange";
  deleteButton: EgdsButton;
  endDate: EgdsSingleDatePicker;
  startDate: EgdsSingleDatePicker;
};

export type SupplyPromotionMemberTiersBlockoutDates = {
  __typename?: "SupplyPromotionMemberTiersBlockoutDates";
  addBlockoutLink?: Maybe<EgdsStandardLink>;
  blockoutStatus?: Maybe<EgdsPlainText>;
  dates?: Maybe<Array<Maybe<SupplyPromotionMemberTiersBlockoutDateRange>>>;
  description?: Maybe<Scalars["String"]>;
  errorMessage: Scalars["String"];
  title: Scalars["String"];
};

export type SupplyPromotionMemberTiersCombinePromotions = {
  __typename?: "SupplyPromotionMemberTiersCombinePromotions";
  description?: Maybe<Scalars["String"]>;
  status: SupplyPromotionMemberTiersSwitchToggle;
  title: Scalars["String"];
};

export type SupplyPromotionMemberTiersCreateButton = {
  __typename?: "SupplyPromotionMemberTiersCreateButton";
  accessibility: Scalars["String"];
  analytics: SupplyPromotionClickStreamData;
  button: EgdsButton;
};

export type SupplyPromotionMemberTiersDiscounts = {
  __typename?: "SupplyPromotionMemberTiersDiscounts";
  baseMemberDiscount: SupplyPromotionMemberTiersInputField;
  description?: Maybe<Scalars["String"]>;
  middleMemberDiscount: SupplyPromotionMemberTiersInputField;
  moreInfo?: Maybe<SupplyPromotionCoachingMessage>;
  title: Scalars["String"];
  topMemberDiscount: SupplyPromotionMemberTiersInputField;
};

export type SupplyPromotionMemberTiersInputField = EgdsNumberInputField | EgdsTextInputField;

export type SupplyPromotionMemberTiersName = {
  __typename?: "SupplyPromotionMemberTiersName";
  description?: Maybe<Scalars["String"]>;
  name: SupplyPromotionMemberTiersInputField;
  title: Scalars["String"];
};

export type SupplyPromotionMemberTiersRunDates = {
  __typename?: "SupplyPromotionMemberTiersRunDates";
  blockoutDates: SupplyPromotionMemberTiersBlockoutDates;
  description?: Maybe<Scalars["String"]>;
  endDate: EgdsPlainText;
  startDate: EgdsSingleDatePicker;
  title: Scalars["String"];
};

export type SupplyPromotionMemberTiersSection =
  | SupplyPromotionMemberTiersCombinePromotions
  | SupplyPromotionMemberTiersDiscounts
  | SupplyPromotionMemberTiersName
  | SupplyPromotionMemberTiersRunDates;

export type SupplyPromotionMemberTiersSwitchToggle = {
  __typename?: "SupplyPromotionMemberTiersSwitchToggle";
  checkedEGClickStream?: Maybe<SupplyPromotionClickStreamData>;
  toggle: UiToggle;
  unCheckedEGClickStream?: Maybe<SupplyPromotionClickStreamData>;
};

export type SupplyPropertiesSummaryContent = EgdsIconText | SupplyAssociatedPropertiesSummary;

export type SupplyPropertyEditorPageTitle = {
  __typename?: "SupplyPropertyEditorPageTitle";
  description?: Maybe<Scalars["String"]>;
  title: Scalars["String"];
};

export type SupplyPropertyFilterHeader = {
  __typename?: "SupplyPropertyFilterHeader";
  icon?: Maybe<Icon>;
  text?: Maybe<Scalars["String"]>;
};

export type SupplyPropertyFilterSection = {
  __typename?: "SupplyPropertyFilterSection";
  header?: Maybe<SupplyPropertyFilterHeader>;
  propertiesSummaryContent: SupplyPropertiesSummaryContent;
  propertyFilterPresented: SupplyNavigationEgClickstream;
  propertySearch?: Maybe<EgdsTextInputField>;
  propertySearchCleared?: Maybe<SupplyNavigationEgClickstream>;
  propertySearchInputted?: Maybe<SupplyNavigationEgClickstream>;
  propertySearchPresented?: Maybe<SupplyNavigationEgClickstream>;
  propertySearchSelected?: Maybe<SupplyNavigationEgClickstream>;
  secondaryButton?: Maybe<SupplySeeAllPropertiesButton>;
  seeAllPropertiesSelected: SupplyNavigationEgClickstream;
};

export type SupplyPropertyListItemActionContent = {
  __typename?: "SupplyPropertyListItemActionContent";
  description: EgdsStylizedText;
  icon?: Maybe<Icon>;
  link?: Maybe<UiLinkAction>;
  /** Field type required for native */
  propertyId?: Maybe<Scalars["String"]>;
  propertySearchItemSelected: SupplyNavigationEgClickstream;
  thumbnail: SupplyPropertyThumbnailImage;
  title: EgdsStylizedText;
};

export interface SupplyPropertyRateInput {
  baseRate: Scalars["Float"];
  currencyCode: Scalars["String"];
  language: Scalars["String"];
}

export type SupplyPropertyRatesBankingCountryCurrencyView = {
  __typename?: "SupplyPropertyRatesBankingCountryCurrencyView";
  bankingCountrySelect: EgdsBasicSelect;
  bankingCurrencySelect: SupplyPropertyRatesBankingCurrencySelect;
  /** @deprecated Replaced by bankingCurrencySelect */
  currencySelect: EgdsBasicSelect;
  heading: Scalars["String"];
  ratesReadySignal: Scalars["String"];
  saveErrorSignal: Scalars["String"];
  signal: Scalars["String"];
  subHeading: Scalars["String"];
};

export type SupplyPropertyRatesBankingCurrencySelect = {
  __typename?: "SupplyPropertyRatesBankingCurrencySelect";
  disabled: Scalars["Boolean"];
  label: Scalars["String"];
  options: Array<SupplyPropertyRatesCurrencyOptionV2>;
};

export type SupplyPropertyRatesCurrencyOption = EgdsOption & {
  __typename?: "SupplyPropertyRatesCurrencyOption";
  acceptedCountries: Array<Scalars["String"]>;
  currencySymbol: Scalars["String"];
  label: Scalars["String"];
  selected?: Maybe<Scalars["Boolean"]>;
  value: Scalars["String"];
};

export type SupplyPropertyRatesCurrencyOptionV2 = {
  __typename?: "SupplyPropertyRatesCurrencyOptionV2";
  acceptedCountries: Array<Scalars["String"]>;
  currencySymbol: Scalars["String"];
  label: Scalars["String"];
  selected?: Maybe<Scalars["Boolean"]>;
  value: Scalars["String"];
};

export type SupplyPropertyRatesErrorView = {
  __typename?: "SupplyPropertyRatesErrorView";
  description: Scalars["String"];
  heading: Scalars["String"];
};

export type SupplyPropertyRatesNightlyBaseRateView = {
  __typename?: "SupplyPropertyRatesNightlyBaseRateView";
  heading: Scalars["String"];
  iconText: EgdsIconText;
  rateInput: EgdsNumberInputField;
  saveErrorSignal: Scalars["String"];
  signal: Scalars["String"];
  subHeading: Scalars["String"];
};

export type SupplyPropertyRatesOfferView = {
  __typename?: "SupplyPropertyRatesOfferView";
  discountInfo: EgdsStandardLink;
  heading: Scalars["String"];
  options: EgdsBasicRadioGroup;
  saveErrorSignal: Scalars["String"];
  subHeading: Scalars["String"];
};

export type SupplyPropertySearchResultContent = SupplyAssociatedPropertiesSummary | SupplyEmptyPropertiesSearchResult;

export type SupplyPropertyThumbnailImage = Icon | Image;

export type SupplyPublishSignalAction = {
  __typename?: "SupplyPublishSignalAction";
  signal: Scalars["String"];
};

/** Interface to mark all possible actions that can be performed by the client */
export interface SupplyQuickActionAction {
  analytics: EgClickstreamEvent;
}

/** A type to represent expando element inside quick action panel */
export type SupplyQuickActionExpando = {
  __typename?: "SupplyQuickActionExpando";
  collapsedLabel: Scalars["String"];
  expandedContent: Scalars["String"];
  expandedLabel: Scalars["String"];
};

/** A type to represent a group of logically related fields marked by a label */
export type SupplyQuickActionFieldSet = {
  __typename?: "SupplyQuickActionFieldSet";
  description?: Maybe<Scalars["String"]>;
  elements: Array<SupplyQuickActionFieldSetElement>;
  label?: Maybe<Scalars["String"]>;
};

/** Union marking all the elements that can be present inside a field set. */
export type SupplyQuickActionFieldSetElement =
  | SupplyQuickActionExpando
  | SupplyQuickActionTable
  | SupplyQuickActionText;

/** Sub level form inside the primary form. */
export interface SupplyQuickActionForm {
  formId: Scalars["String"];
}

export type SupplyQuickActionFormContext = {
  __typename?: "SupplyQuickActionFormContext";
  key: Scalars["String"];
  values: Array<Scalars["String"]>;
};

export interface SupplyQuickActionFormContextInput {
  key: Scalars["String"];
  values: Array<Scalars["String"]>;
}

/** Represents an action to open SupplyQuickActionSheet */
export type SupplyQuickActionOpenSheetAction = SupplyQuickActionAction & {
  __typename?: "SupplyQuickActionOpenSheetAction";
  analytics: EgClickstreamEvent;
  sheet: SupplyQuickActionSheet;
};

/** Type to represent sheet, composed of visual characteristics of EGDSSheet and union of all required types */
export type SupplyQuickActionSheet = SupplyQuickActionForm & {
  __typename?: "SupplyQuickActionSheet";
  clickStreamData?: Maybe<SupplyQuickActionSidePanelAnalytics>;
  elements: Array<SupplyQuickActionSheetElement>;
  formId: Scalars["String"];
  heading: Scalars["String"];
  sheet: EgdsSheet;
  submit: Array<SupplyQuickActionSubmitElements>;
};

/** Union marking all the elements that can be present inside a sheet. */
export type SupplyQuickActionSheetElement =
  | SupplyQuickActionExpando
  | SupplyQuickActionFieldSet
  | SupplyQuickActionTable
  | SupplyQuickActionText;

export type SupplyQuickActionSidePanelAnalytics = {
  __typename?: "SupplyQuickActionSidePanelAnalytics";
  sidePanelClosed?: Maybe<SupplyQuickActionSidePanelEgClickStreamData>;
  sidePanelConfirmSelected?: Maybe<SupplyQuickActionSidePanelEgClickStreamData>;
  sidePanelPresented?: Maybe<SupplyQuickActionSidePanelEgClickStreamData>;
};

export type SupplyQuickActionSidePanelEgClickStreamData = IEgClickstreamData & {
  __typename?: "SupplyQuickActionSidePanelEgClickStreamData";
  event?: Maybe<EgClickstreamEvent>;
  experience?: Maybe<EgClickstreamExperience>;
  virtual_market_coach?: Maybe<SupplyVmcEgClickstreamCustomAttribute>;
};

/** Type to represent for submit button or link */
export type SupplyQuickActionSubmitButton = {
  __typename?: "SupplyQuickActionSubmitButton";
  actionContext: Array<SupplyQuickActionFormContext>;
  button: EgdsButton;
  clickStreamData?: Maybe<SupplyQuickActionSidePanelAnalytics>;
};

export type SupplyQuickActionSubmitElements = SupplyQuickActionSubmitButton | SupplyQuickActionSubmitPostpone;

export type SupplyQuickActionSubmitPostpone = {
  __typename?: "SupplyQuickActionSubmitPostpone";
  link?: Maybe<EgdsStandardLink>;
};

/** A type to represent a table element inside quick action panel */
export type SupplyQuickActionTable = {
  __typename?: "SupplyQuickActionTable";
  columnHeaders?: Maybe<Array<Scalars["String"]>>;
  rows: Array<SupplyQuickActionTableItemRows>;
  title: Scalars["String"];
};

export type SupplyQuickActionTableItemCell = {
  __typename?: "SupplyQuickActionTableItemCell";
  text: Scalars["String"];
  type?: Maybe<SupplyQuickActionTableItemCellType>;
};

export type SupplyQuickActionTableItemCellType = "NORMAL" | "STRIKETHROUGH";

export type SupplyQuickActionTableItemRows = {
  __typename?: "SupplyQuickActionTableItemRows";
  cells: Array<SupplyQuickActionTableItemCell>;
};

/** Type to represent for all text elements. */
export type SupplyQuickActionText = {
  __typename?: "SupplyQuickActionText";
  textComponent: SupplyQuickActionTextContent;
};

/** Union marking all the text components that can be present inside SupplyQuickActionText. */
export type SupplyQuickActionTextContent =
  | EgdsHeading
  | EgdsIconText
  | EgdsParagraph
  | EgdsPlainText
  | EgdsSpannableText
  | EgdsStandardLink
  | EgdsStylizedText
  | EgdsTextIconList
  | EgdsTextListSection
  | EgdsTextSection
  | EgdsUnorderedList;

export interface SupplyRefundDecision {
  content: Scalars["String"];
  icon: Icon;
  primaryButton: EgdsButton;
  subtitle: Scalars["String"];
  title: Scalars["String"];
}

export type SupplyRefundDisclaimerInlineLink = {
  __typename?: "SupplyRefundDisclaimerInlineLink";
  formatText: Scalars["String"];
  fullText: Scalars["String"];
  inlineLink: Array<EgdsInlineLink>;
  placeholderText: Scalars["String"];
};

export type SupplyRegulatoryFlow = {
  __typename?: "SupplyRegulatoryFlow";
  sections: Array<SupplyRegulatoryFlowSection>;
};

export type SupplyRegulatoryFlowSection = {
  __typename?: "SupplyRegulatoryFlowSection";
  id: Scalars["String"];
  /** The section will show as long as ANY preconditions is satisfied in the preconditions list (Logical OR) */
  preconditions?: Maybe<Array<SupplyRegulatoryFlowSectionPrecondition>>;
  settings: Array<SupplyRegulatorySetting>;
};

/**
 * For checking if a Section is in completed condition.
 * A Section is completed only if all required fields inside a section are filled with values,
 * Otherwise it is incomplete
 */
export type SupplyRegulatoryFlowSectionCompletenessCondition = {
  __typename?: "SupplyRegulatoryFlowSectionCompletenessCondition";
  completed: Scalars["Boolean"];
  sectionId: Scalars["String"];
};

/**
 * For checking if a Section is in compliant condition.
 * A Section is non-compliant only if any of the required registration number field is set to Option No (radio button value = non-compliant).
 * Otherwise it is compliant
 */
export type SupplyRegulatoryFlowSectionComplianceCondition = {
  __typename?: "SupplyRegulatoryFlowSectionComplianceCondition";
  compliant: Scalars["Boolean"];
  sectionId: Scalars["String"];
};

export type SupplyRegulatoryFlowSectionCondition =
  | SupplyRegulatoryFlowSectionCompletenessCondition
  | SupplyRegulatoryFlowSectionComplianceCondition
  | SupplyRegulatoryFlowSectionValidityCondition
  | SupplyRegulatoryFlowSectionValueCondition
  | SupplyRegulatoryFlowSectionVisibilityCondition;

export type SupplyRegulatoryFlowSectionPrecondition = {
  __typename?: "SupplyRegulatoryFlowSectionPrecondition";
  /** The preconditions can be true only if ALL the conditions are matched (Logical AND) */
  conditions: Array<SupplyRegulatoryFlowSectionCondition>;
};

/**
 * For checking if a Section is in valid condition.
 * A Section is valid only if all fields inside a section are filled with valid values,
 * Otherwise it is invalid
 */
export type SupplyRegulatoryFlowSectionValidityCondition = {
  __typename?: "SupplyRegulatoryFlowSectionValidityCondition";
  sectionId: Scalars["String"];
  valid: Scalars["Boolean"];
};

/** For checking if a Section's value matches any target value in a list. */
export type SupplyRegulatoryFlowSectionValueCondition = {
  __typename?: "SupplyRegulatoryFlowSectionValueCondition";
  sectionId: Scalars["String"];
  /**
   * The array holds all possible values for the section value,
   * As long as the section value equals to any value string in the array, then the condition is satisfied
   */
  value: Array<Scalars["String"]>;
};

/**
 * For checking if a Section is in visible condition.
 * A Section is visible only if its setting view (SupplyRegulatorySetting) is shown up in the UI.
 * Otherwise it is invisible
 */
export type SupplyRegulatoryFlowSectionVisibilityCondition = {
  __typename?: "SupplyRegulatoryFlowSectionVisibilityCondition";
  sectionId: Scalars["String"];
  visible: Scalars["Boolean"];
};

export type SupplyRegulatoryFlowTitle = {
  __typename?: "SupplyRegulatoryFlowTitle";
  title: Scalars["String"];
};

export type SupplyRegulatoryRadioButton = {
  __typename?: "SupplyRegulatoryRadioButton";
  button: EgdsRadioButton;
  /** Add this field to support nested contents like form fields/texts for each radio button */
  contents?: Maybe<Array<SupplyRegulatoryRadioButtonContent>>;
};

export type SupplyRegulatoryRadioButtonContent = EgdsPlainText | SupplyRegulatoryRegistrationNumber;

export type SupplyRegulatoryRadioGroup = {
  __typename?: "SupplyRegulatoryRadioGroup";
  errorMessage?: Maybe<Scalars["String"]>;
  groupName: Scalars["String"];
  /** Implement the Regulatory Radio Button */
  options: Array<SupplyRegulatoryRadioButton>;
  selected?: Maybe<Scalars["String"]>;
};

export type SupplyRegulatoryRegistrationNumber = {
  __typename?: "SupplyRegulatoryRegistrationNumber";
  description: Scalars["String"];
  formatDescription?: Maybe<Scalars["String"]>;
  numberField: EgdsTextInputField;
};

export type SupplyRegulatorySetting = {
  __typename?: "SupplyRegulatorySetting";
  descriptions?: Maybe<Array<SupplyRegulatorySettingDescription>>;
  fieldSet?: Maybe<SupplyRegulatorySettingFieldSet>;
  title: Scalars["String"];
};

export type SupplyRegulatorySettingDescription = EgdsPlainText | EgdsStandardLink;

export type SupplyRegulatorySettingFieldSet =
  | EgdsBasicCheckBox
  | SupplyRegulatoryRadioGroup
  | SupplyRegulatoryRegistrationNumber;

export interface SupplyRegulatorySettingInput {
  name: Scalars["String"];
  value?: InputMaybe<Scalars["String"]>;
}

export interface SupplyReservationInteractionPageInput {
  pageNumber?: InputMaybe<Scalars["Int"]>;
  pageSize?: InputMaybe<Scalars["Int"]>;
}

export type SupplyReservationInteractionsPaginationTriggerPageDetails = {
  __typename?: "SupplyReservationInteractionsPaginationTriggerPageDetails";
  pageNumber?: Maybe<Scalars["Int"]>;
  pageSize: Scalars["Int"];
};

export type SupplyReservationsGuestInfo = {
  __typename?: "SupplyReservationsGuestInfo";
  bottomButtons: Array<SupplyReservationsGuestInfoBottomButton>;
  defaultExpanded: Scalars["Boolean"];
  heading: Scalars["String"];
  listItems: Array<SupplyReservationsGuestInfoListItem>;
};

export type SupplyReservationsGuestInfoBottomButton = {
  __typename?: "SupplyReservationsGuestInfoBottomButton";
  button: EgdsButton;
  linkAction?: Maybe<UiLinkAction>;
};

export type SupplyReservationsGuestInfoListItem = EgdsTextIconLinkListItem | EgdsTextIconListItem;

export type SupplyReservationsInteractionAvatar = {
  __typename?: "SupplyReservationsInteractionAvatar";
  icon?: Maybe<Icon>;
  text?: Maybe<Scalars["String"]>;
};

export type SupplyReservationsInteractionEmptyState = {
  __typename?: "SupplyReservationsInteractionEmptyState";
  action?: Maybe<SupplyReservationsInteractionEmptyStateAction>;
  columnHeaders?: Maybe<Array<SupplyReservationsInteractionListColumn>>;
  description: EgdsStylizedText;
  icon?: Maybe<Icon>;
  image?: Maybe<Scalars["URL"]>;
  title: EgdsStylizedText;
};

export type SupplyReservationsInteractionEmptyStateAction = EgdsStandardLink | UiTertiaryButton;

export type SupplyReservationsInteractionList = {
  __typename?: "SupplyReservationsInteractionList";
  columnHeaders: Array<SupplyReservationsInteractionListColumn>;
  interactionList: Array<SupplyReservationsInteractionListItemType>;
  pagination: SupplyReservationsInteractionsPagination;
};

export type SupplyReservationsInteractionListColumn = {
  __typename?: "SupplyReservationsInteractionListColumn";
  checkbox?: Maybe<EgdsBasicCheckBox>;
  label: Scalars["String"];
  sortingDirection?: Maybe<Sorting_Direction>;
  sortingIcon?: Maybe<Icon>;
};

export type SupplyReservationsInteractionListItemHobbyist = SupplyReservationsInteractionListItemShared & {
  __typename?: "SupplyReservationsInteractionListItemHobbyist";
  arriving?: Maybe<SupplyReservationsInteractionListItemStyledString>;
  avatar?: Maybe<SupplyReservationsInteractionAvatar>;
  countdownTime?: Maybe<SupplyReservationsInteractionListItemStyledCountdown>;
  detailLink?: Maybe<HttpUri>;
  firstName: SupplyReservationsInteractionListItemStyledString;
  /**
   * String representation of the total guest count of the interaction
   * Part of the Message column
   */
  guestCount?: Maybe<SupplyReservationsInteractionListItemStyledString>;
  headline?: Maybe<SupplyReservationsInteractionListItemStyledString>;
  interactionId: Scalars["String"];
  lastName: SupplyReservationsInteractionListItemStyledString;
  message?: Maybe<SupplyReservationsInteractionListItemStyledString>;
  receivedTime?: Maybe<SupplyReservationsInteractionListItemStyledString>;
  reservationReferenceNumber?: Maybe<SupplyReservationsInteractionListItemStyledString>;
  status?: Maybe<SupplyReservationsInteractionListItemStyledString>;
  stayDates: SupplyReservationsInteractionListItemStyledString;
  unread?: Maybe<EgdsBadgeNotification>;
};

export type SupplyReservationsInteractionListItemOptimizer = SupplyReservationsInteractionListItemShared & {
  __typename?: "SupplyReservationsInteractionListItemOptimizer";
  arriving?: Maybe<SupplyReservationsInteractionListItemStyledString>;
  avatar?: Maybe<SupplyReservationsInteractionAvatar>;
  confirmationNumber?: Maybe<SupplyReservationsInteractionListItemStyledString>;
  detailLink?: Maybe<HttpUri>;
  firstName: SupplyReservationsInteractionListItemStyledString;
  interactionId: Scalars["String"];
  lastName: SupplyReservationsInteractionListItemStyledString;
  paymentAmount?: Maybe<SupplyReservationsInteractionListItemStyledString>;
  receivedTime?: Maybe<SupplyReservationsInteractionListItemStyledString>;
  reservationReferenceNumber?: Maybe<SupplyReservationsInteractionListItemStyledString>;
  roomType?: Maybe<SupplyReservationsInteractionListItemStyledString>;
  stayDates: SupplyReservationsInteractionListItemStyledString;
  unread?: Maybe<EgdsBadgeNotification>;
};

export interface SupplyReservationsInteractionListItemShared {
  arriving?: Maybe<SupplyReservationsInteractionListItemStyledString>;
  avatar?: Maybe<SupplyReservationsInteractionAvatar>;
  detailLink?: Maybe<HttpUri>;
  /**
   * The traveler's first name.
   * This can be bolded or normal weight depending on whether or not
   * the interaction has been "marked as read" or not.
   */
  firstName: SupplyReservationsInteractionListItemStyledString;
  /**
   * The interaction identifier.
   * Not shown in the UI to the partner, but will be used to retrieve
   * reservation / conversation data when the partner selects an item.
   */
  interactionId: Scalars["String"];
  /**
   * The traveler's last name.
   * This can be bolded or normal weight depending on whether or not
   * the interaction has been "marked as read" or not.
   */
  lastName: SupplyReservationsInteractionListItemStyledString;
  receivedTime?: Maybe<SupplyReservationsInteractionListItemStyledString>;
  /**
   * Reservation ID
   * This will be highlighted if the user does a search for the reservation id
   */
  reservationReferenceNumber?: Maybe<SupplyReservationsInteractionListItemStyledString>;
  /**
   * String representation of the stay dates
   * Part of the Message column
   */
  stayDates: SupplyReservationsInteractionListItemStyledString;
  /**
   * Indicates if the message has been read by the supplier
   * If this field is populated then it is unread
   */
  unread?: Maybe<EgdsBadgeNotification>;
}

export interface SupplyReservationsInteractionListItemStyledBase {
  /**
   * The hint informs the developer about the reason this
   * string has this specific styling
   * The behavior should reduce confusion for new developers
   */
  hint: Scalars["String"];
  /**
   * As part of the design there are icons
   * This value is optional since the icon may not be present
   */
  icon?: Maybe<Icon>;
  text: EgdsStylizedText;
}

export type SupplyReservationsInteractionListItemStyledCountdown = SupplyReservationsInteractionListItemStyledBase & {
  __typename?: "SupplyReservationsInteractionListItemStyledCountdown";
  expiresOn: Scalars["String"];
  hint: Scalars["String"];
  icon?: Maybe<Icon>;
  /**
   * The string that represents the countdown
   * Example: HH:MM:SS
   * Displays "Expired" if the count down hits 00:00:00
   */
  text: EgdsStylizedText;
};

export type SupplyReservationsInteractionListItemStyledString = SupplyReservationsInteractionListItemStyledBase & {
  __typename?: "SupplyReservationsInteractionListItemStyledString";
  backgroundColor?: Maybe<Scalars["String"]>;
  hint: Scalars["String"];
  icon?: Maybe<Icon>;
  label?: Maybe<EgdsStylizedText>;
  text: EgdsStylizedText;
};

/**
 * Each one of these represents one interaction in our system.
 * These will be used to populate the interactions list for both the hobbyist view and hotel view
 */
export type SupplyReservationsInteractionListItemType =
  | SupplyReservationsInteractionListItemHobbyist
  | SupplyReservationsInteractionListItemOptimizer;

export type SupplyReservationsInteractionView = {
  __typename?: "SupplyReservationsInteractionView";
  content: SupplyReservationsInteractionViewContent;
  filters: SupplyReservationsInteractionsQuickFilters;
  searchHistory: SupplyReservationsInteractionsSearchHistory;
  searchInput: EgdsTextInputField;
  sideSheet: SupplyReservationsInteractionsFilterSideSheet;
};

export type SupplyReservationsInteractionViewContent =
  | SupplyReservationsInteractionEmptyState
  | SupplyReservationsInteractionList;

export type SupplyReservationsInteractionsExpandoContent = EgdsCheckBoxGroup | EgdsDateRangePicker;

export type SupplyReservationsInteractionsFilterExpandos = {
  __typename?: "SupplyReservationsInteractionsFilterExpandos";
  /**
   * Each group within the expando
   * eg. "Reservation", "Guest", "Payment", etc.
   * each group will have a list of filter items with checkboxes or a daterange picker
   */
  content: SupplyReservationsInteractionsExpandoContent;
  display: EgdsExpandoListItem;
  title: Scalars["String"];
};

export interface SupplyReservationsInteractionsFilterInput {
  endDate?: InputMaybe<Scalars["String"]>;
  /**
   * List of selected filters
   * Should be the value of "options.name"
   * Examples:
   *     "message.unread"
   *     "guest.requests.inquiry"
   */
  filters?: InputMaybe<Array<Scalars["String"]>>;
  startDate?: InputMaybe<Scalars["String"]>;
}

export type SupplyReservationsInteractionsFilterSideSheet = {
  __typename?: "SupplyReservationsInteractionsFilterSideSheet";
  applyFilters: UiPrimaryFloatingActionButton;
  display: EgdsSheet;
  expandos: Array<SupplyReservationsInteractionsFilterExpandos>;
  toolbar: UiToolbar;
};

export type SupplyReservationsInteractionsPagination = {
  __typename?: "SupplyReservationsInteractionsPagination";
  paginationIndexDetails: SupplyReservationsInteractionsPaginationIndexDetails;
  paginationTrigger: SupplyReservationsInteractionsPaginationTrigger;
};

export type SupplyReservationsInteractionsPaginationIndexDetails = {
  __typename?: "SupplyReservationsInteractionsPaginationIndexDetails";
  itemsPerPage: EgdsBasicSelect;
  startPageIndex: EgdsNumberInputField;
};

export type SupplyReservationsInteractionsPaginationTrigger = {
  __typename?: "SupplyReservationsInteractionsPaginationTrigger";
  nextRecords: SupplyReservationsInteractionsPaginationTriggerButton;
  previousRecords: SupplyReservationsInteractionsPaginationTriggerButton;
  /**
   * Result count with localized string, for mobile native
   * ex: 25 results
   */
  recordCount: Scalars["String"];
  /**
   * Localized page and result count information
   * ex: 1-1 of 25 results
   */
  recordSummary: Scalars["String"];
};

export type SupplyReservationsInteractionsPaginationTriggerButton = {
  __typename?: "SupplyReservationsInteractionsPaginationTriggerButton";
  button: UiSecondaryButton;
  triggerDetails?: Maybe<SupplyReservationInteractionsPaginationTriggerPageDetails>;
};

export type SupplyReservationsInteractionsQuickFilters = {
  __typename?: "SupplyReservationsInteractionsQuickFilters";
  /**
   * Button for clearing selected/enabled filters
   * Only shows if the partner has selected/enabled a filter(s)
   */
  clearFilters?: Maybe<UiTertiaryButton>;
  /**
   * Pills for quick filtering the inbox
   * These are always displayed
   */
  defaultPills: Array<EgdsBasicPill>;
  filterAccess: UiTertiaryButton;
  /**
   * Pills showing selected/enabled filters
   * Only shows if the filters are selected/enabled
   */
  filterPills?: Maybe<Array<EgdsBasicRemovablePill>>;
};

export type SupplyReservationsInteractionsSearchHistory = {
  __typename?: "SupplyReservationsInteractionsSearchHistory";
  action: Scalars["String"];
  header: Scalars["String"];
};

export type SupplyReservationsInteractionsUpcomingHeader = {
  __typename?: "SupplyReservationsInteractionsUpcomingHeader";
  action?: Maybe<EgdsStandardLink>;
  title: Scalars["String"];
};

export type SupplyReservationsInteractionsUpcomingView = {
  __typename?: "SupplyReservationsInteractionsUpcomingView";
  empty?: Maybe<SupplyReservationsInteractionEmptyState>;
  header: SupplyReservationsInteractionsUpcomingHeader;
  interactionList: Array<SupplyReservationsInteractionListItemType>;
};

export type SupplyReservationsRentalAgreement = {
  __typename?: "SupplyReservationsRentalAgreement";
  content: SupplyReservationsRentalAgreementContent;
  heading: Scalars["String"];
  viewAgreementButton: SupplyReservationsRentalAgreementButton;
};

export type SupplyReservationsRentalAgreementButton = {
  __typename?: "SupplyReservationsRentalAgreementButton";
  action: SupplyReservationsRentalAgreementButtonAction;
  button: EgdsButton;
};

export type SupplyReservationsRentalAgreementButtonAction = {
  __typename?: "SupplyReservationsRentalAgreementButtonAction";
  filePath: Scalars["String"];
};

export type SupplyReservationsRentalAgreementContent = {
  __typename?: "SupplyReservationsRentalAgreementContent";
  content: Scalars["String"];
  heading: Scalars["String"];
};

export type SupplyReviewEditLink = EgdsStandardLink | StepReviewReturnAction;

export type SupplyReviewRoomsAndSpacesCard = SupplyRoomsAndSpacesCard & {
  __typename?: "SupplyReviewRoomsAndSpacesCard";
  heading: Scalars["String"];
  list: EgdsBulletedList;
};

export type SupplyReviewSectionListItem = {
  __typename?: "SupplyReviewSectionListItem";
  clickstreamInformation?: Maybe<EgClickstreamData>;
  content: SupplyReviewSectionListItemContent;
  contentListColumns?: Maybe<Scalars["Int"]>;
  editLink?: Maybe<SupplyReviewEditLink>;
  expando?: Maybe<EgdsExpandoPeek>;
  heading: Scalars["String"];
};

export type SupplyReviewSectionListItemContent =
  | EgdsParagraph
  | EgdsPlainText
  | EgdsTextIconList
  | EgdsUnorderedList
  | SupplyOnboardingReviewPhotoList
  | SupplyRoomsAndSpacesCarousel;

export interface SupplyRoomsAndSpacesCard {
  heading: Scalars["String"];
}

export type SupplyRoomsAndSpacesCardCarouselItem = {
  __typename?: "SupplyRoomsAndSpacesCardCarouselItem";
  card: SupplyRoomsAndSpacesCard;
  id?: Maybe<Scalars["String"]>;
};

export type SupplyRoomsAndSpacesCarousel = {
  __typename?: "SupplyRoomsAndSpacesCarousel";
  carouselId?: Maybe<Scalars["String"]>;
  items?: Maybe<Array<Maybe<SupplyRoomsAndSpacesCardCarouselItem>>>;
  nextButton?: Maybe<EgdsButton>;
  previousButton?: Maybe<EgdsButton>;
};

export type SupplyScoreCategory = {
  __typename?: "SupplyScoreCategory";
  clickstreamFactorsPresented?: Maybe<SupplyScoreEgClickstreamData>;
  clickstreamPresented?: Maybe<SupplyScoreEgClickstreamData>;
  clickstreamSelected?: Maybe<SupplyScoreEgClickstreamData>;
  compsetRank: EgdsStylizedText;
  content: SupplyScoreCategoryContent;
  description: Scalars["String"];
  moreInfo: SupplyScoreToolTip;
  needsAttentionFactors: Array<SupplyScoreValueFactor>;
  originalSubscore?: Maybe<Scalars["Int"]>;
  progressAccessibility?: Maybe<Scalars["String"]>;
  subScore: EgdsStylizedText;
  title: Scalars["String"];
  travelerInformativeError?: Maybe<SupplyScoreTravelerInformativeError>;
  warningMessage?: Maybe<Scalars["String"]>;
};

export type SupplyScoreCategoryContent = SupplyScoreCategoryFactorContent | SupplyScoreEmptyErrorState;

export type SupplyScoreCategoryFactorContent = {
  __typename?: "SupplyScoreCategoryFactorContent";
  factors: Array<SupplyScoreFactor>;
};

export type SupplyScoreCategoryOverview = {
  __typename?: "SupplyScoreCategoryOverview";
  attentionCount?: Maybe<Scalars["Int"]>;
  description: Scalars["String"];
  score?: Maybe<Scalars["Int"]>;
  title: Scalars["String"];
  warning?: Maybe<Scalars["String"]>;
};

export type SupplyScoreCompsetRank = {
  __typename?: "SupplyScoreCompsetRank";
  icon?: Maybe<Icon>;
  text: Scalars["String"];
};

export type SupplyScoreCompsetRankAudit =
  | SupplyScoreCompsetRankAuditContent
  | SupplyScoreCompsetRankAuditGeneralError
  | SupplyScoreCompsetRankAuditNonCompliantCompset;

export type SupplyScoreCompsetRankAuditContent = {
  __typename?: "SupplyScoreCompsetRankAuditContent";
  buttonLink: SupplyScoreLinkButton;
  clickstreamSelected?: Maybe<SupplyScoreEgClickstreamData>;
  link: EgdsStandardLink;
  text: Scalars["String"];
  title: Scalars["String"];
};

export type SupplyScoreCompsetRankAuditGeneralError = {
  __typename?: "SupplyScoreCompsetRankAuditGeneralError";
  error: UiBanner;
  title: Scalars["String"];
};

export type SupplyScoreCompsetRankAuditNonCompliantCompset = {
  __typename?: "SupplyScoreCompsetRankAuditNonCompliantCompset";
  content: SupplyScoreCompsetRankAuditNonCompliantContent;
  title: Scalars["String"];
};

export type SupplyScoreCompsetRankAuditNonCompliantContent = {
  __typename?: "SupplyScoreCompsetRankAuditNonCompliantContent";
  buttonLink: SupplyScoreLinkButton;
  clickstreamSelected?: Maybe<SupplyScoreEgClickstreamData>;
  description: Scalars["String"];
  link: EgdsStandardLink;
  title: Scalars["String"];
};

export type SupplyScoreDetails = {
  __typename?: "SupplyScoreDetails";
  clickstreamViewed?: Maybe<SupplyScoreEgClickstreamData>;
  externalModuleOverview: SupplyScoreExternalModuleOverview;
  licensePlate: StaticLicensePlate;
  sections: Array<SupplyScoreSection>;
};

export type SupplyScoreEgClickstreamCustomAttribute = {
  __typename?: "SupplyScoreEgClickstreamCustomAttribute";
  category_attention_count?: Maybe<Scalars["Int"]>;
  category_name?: Maybe<Scalars["String"]>;
  category_name_value?: Maybe<Scalars["Int"]>;
  factor_list?: Maybe<Array<Maybe<SupplyScoreFactorsEgClickstreamCustomAttribute>>>;
};

export type SupplyScoreEgClickstreamData = IEgClickstreamData & {
  __typename?: "SupplyScoreEgClickstreamData";
  event?: Maybe<EgClickstreamEvent>;
  experience?: Maybe<EgClickstreamExperience>;
  search_request?: Maybe<SupplyScoreEgClickstreamSearchRequest>;
  supply_score_list?: Maybe<Array<Maybe<SupplyScoreEgClickstreamCustomAttribute>>>;
};

export type SupplyScoreEgClickstreamSearchRequest = {
  __typename?: "SupplyScoreEgClickstreamSearchRequest";
  filters?: Maybe<Array<Maybe<SupplyScoreEgClickstreamSearchRequestFilterItem>>>;
};

export type SupplyScoreEgClickstreamSearchRequestFilterItem = {
  __typename?: "SupplyScoreEgClickstreamSearchRequestFilterItem";
  category?: Maybe<Scalars["String"]>;
  value?: Maybe<Scalars["String"]>;
};

export type SupplyScoreEmptyErrorState = {
  __typename?: "SupplyScoreEmptyErrorState";
  action: UiLinkAction;
  description: Scalars["String"];
  icon: Icon;
  linkText: Scalars["String"];
  title: Scalars["String"];
};

export type SupplyScoreExternalModuleOverview = {
  __typename?: "SupplyScoreExternalModuleOverview";
  description: Scalars["String"];
  guestExperience: SupplyScoreCategoryOverview;
  productAttractiveness: SupplyScoreCategoryOverview;
  title: Scalars["String"];
};

export type SupplyScoreFactor = SupplyMoreInfoFactor | SupplyScoreValueFactor;

export type SupplyScoreFactorAuditAction = SupplyScoreFactorAuditDirectLink | SupplyScoreFactorAuditLinkAction;

export type SupplyScoreFactorAuditContentTip = {
  __typename?: "SupplyScoreFactorAuditContentTip";
  description: Scalars["String"];
  subItems: Array<SupplyScoreFactorAuditSubItems>;
  title: Scalars["String"];
};

export type SupplyScoreFactorAuditContentToolbar = {
  __typename?: "SupplyScoreFactorAuditContentToolbar";
  closeLabel: Scalars["String"];
  title: Scalars["String"];
};

export type SupplyScoreFactorAuditContentWrapper = {
  __typename?: "SupplyScoreFactorAuditContentWrapper";
  clickstreamCloseSelected?: Maybe<SupplyScoreEgClickstreamData>;
  compsetRankAudit?: Maybe<SupplyScoreCompsetRankAudit>;
  factorType: Scalars["String"];
  panelContent: SupplyScoreFactorPanelContent;
  scoreDisplay: SupplyScoreFactorScoreDisplay;
  toolbar: SupplyScoreFactorAuditContentToolbar;
};

export type SupplyScoreFactorAuditDirectLink = {
  __typename?: "SupplyScoreFactorAuditDirectLink";
  action: UiLinkAction;
  clickstreamSelected?: Maybe<SupplyScoreEgClickstreamData>;
};

export type SupplyScoreFactorAuditLinkAction = {
  __typename?: "SupplyScoreFactorAuditLinkAction";
  contentWrapper: SupplyScoreFactorAuditContentWrapper;
  trigger: SupplyScoreFactorAuditTrigger;
};

export type SupplyScoreFactorAuditSubItemLink = {
  __typename?: "SupplyScoreFactorAuditSubItemLink";
  clickstreamSelected?: Maybe<SupplyScoreEgClickstreamData>;
  link: EgdsStandardLink;
};

export type SupplyScoreFactorAuditSubItems = {
  __typename?: "SupplyScoreFactorAuditSubItems";
  links: Array<SupplyScoreFactorAuditSubItemLink>;
  text: Scalars["String"];
};

export type SupplyScoreFactorAuditTrail =
  | SupplyScoreFactorAuditTrailError
  | SupplyScoreFactorNoNegativeReviewAuditTrail
  | SupplyScoreFactorNoReviewAuditTrail
  | SupplyScoreFactorReservationAuditTrail
  | SupplyScoreFactorReviewAuditTrail;

export type SupplyScoreFactorAuditTrailError = {
  __typename?: "SupplyScoreFactorAuditTrailError";
  clickstreamPresented?: Maybe<SupplyScoreEgClickstreamData>;
  description: Scalars["String"];
  title: Scalars["String"];
};

export type SupplyScoreFactorAuditTrigger = {
  __typename?: "SupplyScoreFactorAuditTrigger";
  accessibility: Scalars["String"];
  clickstreamSelected?: Maybe<SupplyScoreEgClickstreamData>;
};

export type SupplyScoreFactorNoNegativeReviewAuditTrail = {
  __typename?: "SupplyScoreFactorNoNegativeReviewAuditTrail";
  clickstreamPresented?: Maybe<SupplyScoreEgClickstreamData>;
  content: SupplyScoreFactorNoNegativeReviewAuditTrailContent;
  description: Scalars["String"];
  /** the title & description & link when no negative review */
  title: Scalars["String"];
};

export type SupplyScoreFactorNoNegativeReviewAuditTrailContent = {
  __typename?: "SupplyScoreFactorNoNegativeReviewAuditTrailContent";
  showAllReviewsClickstreamClicked?: Maybe<SupplyScoreEgClickstreamData>;
  showAllReviewsLink: EgdsStandardLink;
  title: Scalars["String"];
};

export type SupplyScoreFactorNoReviewAuditTrail = {
  __typename?: "SupplyScoreFactorNoReviewAuditTrail";
  clickstreamPresented?: Maybe<SupplyScoreEgClickstreamData>;
  description: Scalars["String"];
  requestReviewClickstreamClicked?: Maybe<SupplyScoreEgClickstreamData>;
  requestReviewLink: EgdsStandardLink;
  /** the title & description & link when no review */
  title: Scalars["String"];
};

export type SupplyScoreFactorNotification = {
  __typename?: "SupplyScoreFactorNotification";
  icon: Icon;
  stylizedText: EgdsStylizedText;
};

export type SupplyScoreFactorPanelContent = ISupplyScoreFactorPanelContent & {
  __typename?: "SupplyScoreFactorPanelContent";
  clickstreamPresented?: Maybe<SupplyScoreEgClickstreamData>;
  elements: Array<SupplyScoreFactorPanelContentElement>;
};

export type SupplyScoreFactorPanelContentBasic = {
  __typename?: "SupplyScoreFactorPanelContentBasic";
  descriptionItems: Array<SupplyScoreFactorPanelContentDescription>;
  /** @deprecated Replaced by descriptionItems */
  descriptions: Array<Scalars["String"]>;
  title?: Maybe<Scalars["String"]>;
};

export type SupplyScoreFactorPanelContentDescription = {
  __typename?: "SupplyScoreFactorPanelContentDescription";
  icon?: Maybe<Icon>;
  text: Scalars["String"];
};

export type SupplyScoreFactorPanelContentElement =
  | SupplyScoreFactorPanelContentBasic
  | SupplyScoreFactorPanelContentImprovement;

export type SupplyScoreFactorPanelContentImprovement = {
  __typename?: "SupplyScoreFactorPanelContentImprovement";
  tip: SupplyScoreFactorAuditContentTip;
};

export type SupplyScoreFactorReservationAuditTrail = {
  __typename?: "SupplyScoreFactorReservationAuditTrail";
  clickstreamPresented?: Maybe<SupplyScoreEgClickstreamData>;
  contactUsClickstreamClicked?: Maybe<SupplyScoreEgClickstreamData>;
  /** the link to contact us to fix incorrect reservation data */
  contactUsLink?: Maybe<EgdsStandardLink>;
  emptyDataDescription?: Maybe<Scalars["String"]>;
  /** the title & description when no data */
  emptyDataTitle?: Maybe<Scalars["String"]>;
  items?: Maybe<Array<SupplyScoreFactorReservationAuditTrailItem>>;
  /** @deprecated not being used anymore in the latest UX */
  showLessLink?: Maybe<EgdsStandardLink>;
  showMoreClickstreamClicked?: Maybe<SupplyScoreEgClickstreamData>;
  showMoreLink?: Maybe<EgdsStandardLink>;
  title: Scalars["String"];
};

export type SupplyScoreFactorReservationAuditTrailItem = {
  __typename?: "SupplyScoreFactorReservationAuditTrailItem";
  date: Scalars["String"];
  travelerNameClickstreamClicked?: Maybe<SupplyScoreEgClickstreamData>;
  travelerNameLink: EgdsStandardLink;
  /** @deprecated use travelerNameLink instead */
  travellerNameLink: EgdsStandardLink;
};

export type SupplyScoreFactorReviewAuditTrail = {
  __typename?: "SupplyScoreFactorReviewAuditTrail";
  clickstreamPresented?: Maybe<SupplyScoreEgClickstreamData>;
  description: Scalars["String"];
  items: Array<SupplyScoreFactorReviewAuditTrailItem>;
  reportReviewClickstreamClicked?: Maybe<SupplyScoreEgClickstreamData>;
  reportReviewLink: EgdsStandardLink;
  respondReviewClickstreamClicked?: Maybe<SupplyScoreEgClickstreamData>;
  respondReviewLink: EgdsStandardLink;
  showMoreClickstreamClicked?: Maybe<SupplyScoreEgClickstreamData>;
  showMoreLink?: Maybe<EgdsStandardLink>;
  title: Scalars["String"];
};

export type SupplyScoreFactorReviewAuditTrailItem = {
  __typename?: "SupplyScoreFactorReviewAuditTrailItem";
  icon: Icon;
  reviewDetail: Scalars["String"];
  reviewFromOtherSite?: Maybe<Scalars["String"]>;
  travelerNameClickstreamClicked?: Maybe<SupplyScoreEgClickstreamData>;
  travelerNameLink: EgdsSpannableText;
  value: Scalars["String"];
};

export type SupplyScoreFactorScoreDisplay = {
  __typename?: "SupplyScoreFactorScoreDisplay";
  notificationHeader?: Maybe<SupplyScoreFactorNotification>;
  stylizedValue: EgdsStylizedText;
};

export type SupplyScoreFactorsEgClickstreamCustomAttribute = {
  __typename?: "SupplyScoreFactorsEgClickstreamCustomAttribute";
  factor_audit_trail_count?: Maybe<Scalars["Int"]>;
  factor_audit_trail_ids?: Maybe<Array<Scalars["String"]>>;
  /** Valid states: success ｜ no item | no item matching filter | failed to fetch */
  factor_audit_trail_state?: Maybe<Scalars["String"]>;
  factor_badge_type?: Maybe<Scalars["String"]>;
  factor_card_position?: Maybe<Scalars["Int"]>;
  factor_card_target_link?: Maybe<Scalars["String"]>;
  /** Valid types: compset | audit_trail_item |  audit_trail_other | audit_trail_dispute |  audit_trail_more | tip */
  factor_card_target_link_type?: Maybe<Scalars["String"]>;
  factor_competitive_set_rank?: Maybe<Scalars["Int"]>;
  factor_competitive_set_size?: Maybe<Scalars["Int"]>;
  factor_type?: Maybe<Scalars["String"]>;
  factor_value?: Maybe<Scalars["String"]>;
};

/** Filter menu  */
export type SupplyScoreFilterMenu = {
  __typename?: "SupplyScoreFilterMenu";
  title: Scalars["String"];
  trigger: SupplyScoreFilterMenuTrigger;
};

export type SupplyScoreFilterMenuItem = {
  __typename?: "SupplyScoreFilterMenuItem";
  action: SupplyScoreFilterMenuItemAction;
  text: Scalars["String"];
  value: Scalars["String"];
};

/** Filter menu action */
export type SupplyScoreFilterMenuItemAction = {
  __typename?: "SupplyScoreFilterMenuItemAction";
  selectedAnalytics?: Maybe<SupplyScoreEgClickstreamData>;
};

export type SupplyScoreFilterMenuTrigger = {
  __typename?: "SupplyScoreFilterMenuTrigger";
  accessibility: Scalars["String"];
  contentItems: Array<SupplyScoreFilterMenuItem>;
  text: Scalars["String"];
};

export type SupplyScoreLinkButton = {
  __typename?: "SupplyScoreLinkButton";
  action: UiLinkAction;
  button: EgdsButton;
};

/** Generic messaging card */
export type SupplyScoreMessaging = {
  __typename?: "SupplyScoreMessaging";
  icon?: Maybe<Icon>;
  links: Array<EgdsStandardLink>;
  messages: Array<Scalars["String"]>;
  /** Description of the card's UI */
  theme: SupplyScoreMessagingTheme;
};

/** Description of a SupplyScoreMessaging's card */
export type SupplyScoreMessagingTheme = "INFO" | "MESSAGE" | "WARNING";

/** Card of the performance overview's item */
export type SupplyScorePerformanceOverview = {
  __typename?: "SupplyScorePerformanceOverview";
  /** Presentation event */
  clickstreamPresented?: Maybe<SupplyScoreEgClickstreamData>;
  /** Filter value */
  filterValue?: Maybe<Scalars["String"]>;
  items: Array<SupplyScorePerformanceOverviewItem>;
};

/** Metric card inside performance overview */
export type SupplyScorePerformanceOverviewItem = {
  __typename?: "SupplyScorePerformanceOverviewItem";
  /** Compset rank for the value */
  compsetRank?: Maybe<EgdsStylizedText>;
  /**
   * Filter value
   * @deprecated Use filterValue at SupplyScorePerformanceOverview level
   */
  filterValue?: Maybe<Scalars["String"]>;
  /** Title's tool-tip */
  moreInfo: SupplyScoreToolTip;
  title: Scalars["String"];
  /** Metric value */
  value: EgdsStylizedText;
};

/** Page's section */
export type SupplyScoreSection = {
  __typename?: "SupplyScoreSection";
  filterMenu?: Maybe<SupplyScoreFilterMenu>;
  items: Array<SupplyScoreSectionItem>;
  subtitle?: Maybe<Scalars["String"]>;
  title: Scalars["String"];
};

export type SupplyScoreSectionItem = SupplyScoreCategory | SupplyScoreMessaging | SupplyScorePerformanceOverview;

/** Tool-tip of Performance overview's item */
export type SupplyScoreToolTip = {
  __typename?: "SupplyScoreToolTip";
  /** Content inside the tool-tip's pop-up */
  content: Array<Scalars["String"]>;
  trigger: EgdsIconText;
};

export type SupplyScoreTravelerInformativeError = {
  __typename?: "SupplyScoreTravelerInformativeError";
  description: Scalars["String"];
  icon: Icon;
  title?: Maybe<EgdsStylizedText>;
};

export type SupplyScoreValueFactor = {
  __typename?: "SupplyScoreValueFactor";
  action?: Maybe<SupplyScoreFactorAuditAction>;
  compsetRank?: Maybe<SupplyScoreCompsetRank>;
  notificationHeader?: Maybe<SupplyScoreFactorNotification>;
  stylizedTitle: EgdsStylizedText;
  stylizedValue: EgdsStylizedText;
};

export type SupplySeeAllPropertiesButton = {
  __typename?: "SupplySeeAllPropertiesButton";
  action: UiLinkAction;
  disabled: Scalars["Boolean"];
  primary: Scalars["String"];
};

export type SupplySubscribeSignalAction = {
  __typename?: "SupplySubscribeSignalAction";
  signal: Scalars["String"];
};

export type SupplyTaxes = SupplyTaxesEditor | SupplyTaxesMessage;

export type SupplyTaxesAmountDetails = {
  __typename?: "SupplyTaxesAmountDetails";
  age: EgdsNumberInputField;
  ageBoxEnteredAnalytics?: Maybe<SupplyContentEgClickstreamData>;
  ageBoxSelectedAnalytics?: Maybe<SupplyContentEgClickstreamData>;
  ageTitle: Scalars["String"];
  amount: EgdsNumberInputField;
  amountBoxEnteredAnalytics?: Maybe<SupplyContentEgClickstreamData>;
  amountBoxSelectedAnalytics?: Maybe<SupplyContentEgClickstreamData>;
  collectAtCheckinRadioButtonSelectedAnalytics?: Maybe<SupplyContentEgClickstreamData>;
};

export interface SupplyTaxesAmountInput {
  age: Scalars["Int"];
  amount: Scalars["Float"];
}

export type SupplyTaxesEditor = {
  __typename?: "SupplyTaxesEditor";
  errorMessagePresentedAnalytics?: Maybe<SupplyContentEgClickstreamData>;
  heading: Scalars["String"];
  nextButtonInitiatedAnalytics?: Maybe<SupplyContentEgClickstreamData>;
  optionDetails: Array<SupplyTaxesOption>;
  options: EgdsBasicRadioGroup;
  taxPageViewedAnalytics?: Maybe<SupplyContentEgClickstreamData>;
};

export interface SupplyTaxesInput {
  taxesAmount?: InputMaybe<SupplyTaxesAmountInput>;
  taxesPercent?: InputMaybe<SupplyTaxesPercentInput>;
  type: SupplyTaxesType;
}

export type SupplyTaxesLink = {
  __typename?: "SupplyTaxesLink";
  href: Scalars["String"];
  text: Scalars["String"];
};

export type SupplyTaxesMessage = {
  __typename?: "SupplyTaxesMessage";
  errorMessagePresentedAnalytics?: Maybe<SupplyContentEgClickstreamData>;
  message: Scalars["String"];
  nextButtonInitiatedAnalytics?: Maybe<SupplyContentEgClickstreamData>;
  taxMessagePageViewedAnalytics?: Maybe<SupplyContentEgClickstreamData>;
};

export type SupplyTaxesNotInclude = {
  __typename?: "SupplyTaxesNotInclude";
  collectAsRequiredRadioButtonSelectedAnalytics?: Maybe<SupplyContentEgClickstreamData>;
  message: Scalars["String"];
};

export type SupplyTaxesOption = {
  __typename?: "SupplyTaxesOption";
  optionDetails: SupplyTaxesOptionDetails;
  parent: SupplyTaxesType;
};

export type SupplyTaxesOptionDetails = SupplyTaxesAmountDetails | SupplyTaxesNotInclude | SupplyTaxesPercentDetails;

export type SupplyTaxesPercentDetails = {
  __typename?: "SupplyTaxesPercentDetails";
  collectDuringBookingRadioButtonSelectedAnalytics?: Maybe<SupplyContentEgClickstreamData>;
  link?: Maybe<SupplyTaxesLink>;
  percent: EgdsNumberInputField;
  percentBoxEnteredAnalytics?: Maybe<SupplyContentEgClickstreamData>;
  percentBoxSelectedAnalytics?: Maybe<SupplyContentEgClickstreamData>;
};

export interface SupplyTaxesPercentInput {
  percent: Scalars["Float"];
}

export type SupplyTaxesType = "AMOUNT" | "NOT_INCLUDED" | "PERCENT";

export type SupplyTipCardSection = {
  __typename?: "SupplyTipCardSection";
  content: SupplyOnboardingTipContent;
  heading: Scalars["String"];
};

export type SupplyUpdateNewListingOfferEnrollment = {
  __typename?: "SupplyUpdateNewListingOfferEnrollment";
  enrolled: Scalars["Boolean"];
};

export type SupplyUpdatePartnerPayoutDeferredAccount = {
  __typename?: "SupplyUpdatePartnerPayoutDeferredAccount";
  bankingCountry: Scalars["String"];
  currency: Scalars["String"];
  merchantAccountUrl: Scalars["String"];
  payoutConfigUrl: Scalars["String"];
};

export type SupplyUpdatePropertyRates = {
  __typename?: "SupplyUpdatePropertyRates";
  baseRate: Scalars["Float"];
};

export type SupplyVirtualMarketCoachEgClickStreamData = IEgClickstreamData & {
  __typename?: "SupplyVirtualMarketCoachEgClickStreamData";
  event?: Maybe<EgClickstreamEvent>;
  experience?: Maybe<EgClickstreamExperience>;
  virtual_market_coach?: Maybe<SupplyVmcEgClickstreamCustomAttribute>;
};

export type SupplyVmcEgClickstreamCustomAttribute = {
  __typename?: "SupplyVmcEGClickstreamCustomAttribute";
  coaching_tip_id?: Maybe<Scalars["Int"]>;
  coaching_tip_proofpoint?: Maybe<SupplyCoachingTipProofPointEgClickstreamCustomAttribute>;
  coaching_tip_source_id?: Maybe<Scalars["String"]>;
  sort_position?: Maybe<Scalars["String"]>;
};

export type TaapAgencyImage = {
  __typename?: "TaapAgencyImage";
  /** Identifies the contents shown in the image */
  caption?: Maybe<Scalars["String"]>;
  /** 70px version of the image */
  seventyPixels?: Maybe<Scalars["String"]>;
  /** 1000px version of the image */
  thousandPixels?: Maybe<Scalars["String"]>;
  /** 350px version of the image */
  threeHundredFiftyPixels?: Maybe<Scalars["String"]>;
  /** 200px version of the image */
  twoHundredPixels?: Maybe<Scalars["String"]>;
};

/** Summary of a Tag */
export type Tag = {
  __typename?: "Tag";
  /** Tag Label */
  label: Scalars["String"];
};

export type TagRating = {
  __typename?: "TagRating";
  customTagValue?: Maybe<CustomTagRating>;
  isMultiValue?: Maybe<Scalars["Boolean"]>;
  tagValues?: Maybe<Array<RatingValueDetails>>;
};

/** Support for `tel` based URI constructed based on the phone number. */
export type TelUri = Uri & {
  __typename?: "TelURI";
  phoneNumber: Scalars["String"];
  value: Scalars["String"];
};

/** Describes Telesales phone number details for a property */
export type Telesales = {
  __typename?: "Telesales";
  /** Description for phone number to book over the phone */
  description: LodgingPlainMessage;
  /** The phone number that can be used to book over the phone */
  telesalesNumber: TelUri;
  /** Client analytic data */
  tracking: ClientSideAnalytics;
};

export type TemperatureRange = {
  __typename?: "TemperatureRange";
  /** max temp of the day with degree symbol : 40 */
  maximum?: Maybe<Scalars["String"]>;
  /** min temp of the day with degree symbol : 40 */
  minimum?: Maybe<Scalars["String"]>;
  /** unit of temp */
  unit?: Maybe<Scalars["String"]>;
};

/** Represents the key value pair between analytics and its identifier */
export interface TemplateAnalytics {
  /** Represents analytics */
  analytics: ClientSideAnalytics;
  /** Represents the analytics identifier */
  analyticsIdentifier: AnalyticsKey;
}

/**
 * Represents the dynamic part of the localized text.  The `key` value indicates where to insert the variable data.
 * The `source` is an ID for locating the actual data that will be inserted.
 */
export type TemplateModel = {
  __typename?: "TemplateModel";
  key: Scalars["String"];
  source: Scalars["String"];
};

export type TermsAndConditions = {
  __typename?: "TermsAndConditions";
  /** Incentives collection terms and conditions dialog body text */
  body: Scalars["String"];
  /** Incentives collection terms and conditions link text */
  linkText: Scalars["String"];
  /** Incentives collection terms and conditions dialog title */
  title: Scalars["String"];
};

export type TextBanner = {
  __typename?: "TextBanner";
  heading: Scalars["String"];
};

export type TextBreadcrumb = BreadcrumbItem & {
  __typename?: "TextBreadcrumb";
  text: Scalars["String"];
  uiLinkAction?: Maybe<UiLinkAction>;
};

/** The text direction of the locale e.g. ltr or rtl */
export type TextDirection = "LTR" | "RTL";

/** Used to highlight or convey information. For example, positive messaging like free cancellation may be green. */
export type TextTheme = "LOYALTY" | "NEGATIVE" | "POSITIVE" | "PRIMARY" | "SECONDARY";

/** Used to highlight or convey information. For example, Payable amount in the price summary module of the checkout page. */
export type TextWeight = "BOLD" | "MEDIUM" | "REGULAR";

/** Wrapping for text with file */
export type TextWithFile = TravelExperienceContent & {
  __typename?: "TextWithFile";
  content: Array<Maybe<EgdsElement>>;
  file?: Maybe<EgdsStandardLink>;
  id: Scalars["ID"];
};

export type TextWrapper = {
  __typename?: "TextWrapper";
  /** Text to be read by the screen reader. */
  accessibilityMessage?: Maybe<Scalars["String"]>;
  /** EGDSText element */
  text: EgdsText;
};

export type Theme =
  | "BRAND"
  | "BRANDED_DEAL"
  | "DEAL_ADD_ON"
  | "DEAL_BUNDLED"
  | "DEAL_GENERIC"
  | "DEAL_MEMBER"
  | "FAMILY_FRIENDLY"
  | "INFO"
  | "LINK"
  | "LOYALTY"
  | "LOYALTY_HIGH_TIER"
  | "LOYALTY_LOW_TIER"
  | "LOYALTY_MIDDLE_TIER"
  | "NOTIFICATION"
  | "PROMOTED"
  | "SAVED"
  | "SPONSORED"
  | "SUCCESS"
  | "SUCCESS_MEDIUM"
  | "SUPPLIER_PROMO"
  | "URGENT"
  | "VIEWED"
  | "VIP"
  | "VIP_ACCESS";

export type Timezone = {
  __typename?: "Timezone";
  name: Scalars["String"];
  offset: Scalars["String"];
};

export type TogglePhase = {
  __typename?: "TogglePhase";
  /** Accessibility for the name of the toggle or denoting the state of the toggle */
  accessibilityMessage?: Maybe<Scalars["String"]>;
  /** Name of the toggle link, ex: Show Details */
  action: Scalars["String"];
  /** Represents the analytics to track on interaction with trigger. */
  analytics: FlightsAnalytics;
  /** Icon next to toggle label, ex: chevron */
  icon?: Maybe<Icon>;
};

/** Represents toggleable card content section */
export type ToggleableCardContentSection = {
  __typename?: "ToggleableCardContentSection";
  /** Represents the trigger for the pmp info dialog */
  infoTrigger: FlightsDialogTrigger;
  /** Represents the price for selecting pmp */
  price?: Maybe<Scalars["String"]>;
  /** Represents the subheading of the pmp card */
  subHeading: Scalars["String"];
  /** Represent the switch for toggling pmp */
  switchToggle: FlightsSwitchToggle;
};

/** Represents toggleable card heading section */
export type ToggleableCardHeadingSection = {
  __typename?: "ToggleableCardHeadingSection";
  /** Represents the header of the pmp card */
  header: EgdsGraphicText;
  /** Represents the price for selecting pmp */
  price?: Maybe<Scalars["String"]>;
};

export type TotalPriceSummary = {
  __typename?: "TotalPriceSummary";
  amount?: Maybe<LodgingEnrichedMessage>;
  label?: Maybe<LodgingEnrichedMessage>;
};

export type TrackingData = {
  __typename?: "TrackingData";
  totalPriceAmount: Scalars["Float"];
  totalPriceCurrencyCode: Scalars["String"];
};

export type TravelAgentAuthenticationOptionsResponse = {
  __typename?: "TravelAgentAuthenticationOptionsResponse";
  /** The join now button */
  joinNow: UiSecondaryButton;
  /** The mark shown. */
  logo: Mark;
  /** The sign in button */
  signIn: UiPrimaryButton;
  /** Optional subtitle. */
  subtitle?: Maybe<Scalars["String"]>;
  /** The text to display for the title. */
  title: Scalars["String"];
};

export type TravelAgentDashboard = {
  __typename?: "TravelAgentDashboard";
  heading?: Maybe<Scalars["String"]>;
  sections: Array<TravelAgentDashboardSection>;
};

/** Represents a value that may have an associated label */
export type TravelAgentDashboardLabelValue = {
  __typename?: "TravelAgentDashboardLabelValue";
  label?: Maybe<Scalars["String"]>;
  value?: Maybe<Scalars["String"]>;
};

export type TravelAgentDashboardProgress = {
  __typename?: "TravelAgentDashboardProgress";
  progressBar?: Maybe<EgdsProgressBar>;
  progressBarNote?: Maybe<Scalars["String"]>;
};

export type TravelAgentDashboardSection = {
  __typename?: "TravelAgentDashboardSection";
  /** Perform this action on click of card */
  cardActionLink?: Maybe<ActionLink>;
  /** Http url associated with the card */
  cardLink?: Maybe<UiLinkAction>;
  /** Action associated with hyperlink on card */
  clickableActionLink?: Maybe<ActionLink>;
  /** Http url associated with hyperlink on card */
  clickableLink?: Maybe<EgdsStandardLink>;
  content?: Maybe<TravelAgentDashboardSectionContent>;
  heading?: Maybe<Scalars["String"]>;
  image?: Maybe<Image>;
  subheading?: Maybe<Scalars["String"]>;
};

export type TravelAgentDashboardSectionContent = TravelAgentDashboardProgress | TravelAgentDashboardSubheadingList;

export type TravelAgentDashboardSubheadingList = {
  __typename?: "TravelAgentDashboardSubheadingList";
  labelValues?: Maybe<Array<TravelAgentDashboardLabelValue>>;
  subheadings: Array<Maybe<Scalars["String"]>>;
};

export type TravelAgentPackageRatesDetail = {
  __typename?: "TravelAgentPackageRatesDetail";
  /** A heading for the package rates section */
  heading?: Maybe<Scalars["String"]>;
  /** Brief summary of terms and conditions for package rates */
  termsAndConditions: Scalars["String"];
};

export type TravelAgentSearchWizardConfig = {
  __typename?: "TravelAgentSearchWizardConfig";
  /** Enabled Lobs */
  enabledLobs: Array<Scalars["String"]>;
  /** If package rates should be available, more detail describing them */
  packageRatesDetail?: Maybe<TravelAgentPackageRatesDetail>;
  /** Whether package rates should be made available */
  packageRatesEnabled: Scalars["Boolean"];
};

export type TravelContent = {
  __typename?: "TravelContent";
  /** List of related point of interest */
  poi: Array<BasePoi>;
  /** List of related property */
  property: Array<BaseProperty>;
};

export type TravelContentPoiArgs = {
  ids: Array<Scalars["String"]>;
  limit?: InputMaybe<Scalars["Int"]>;
};

export type TravelContentPropertyArgs = {
  ids: Array<Scalars["String"]>;
  limit?: InputMaybe<Scalars["Int"]>;
};

export type TravelContentAttribute = {
  __typename?: "TravelContentAttribute";
  name: Scalars["String"];
};

/** Optional inputs for custom flex content */
export interface TravelContentAttributesInput {
  /** content Id */
  contentId: Scalars["String"];
  /** preview */
  preview: Scalars["Boolean"];
}

export type TravelContentDistance = {
  __typename?: "TravelContentDistance";
  /** Direct distance in kilometer, to the parent. */
  directKm?: Maybe<Scalars["Float"]>;
  /** Driving distance in kilometer, to the parent. */
  drivingKm?: Maybe<Scalars["Float"]>;
  /** Driving distance in minutes, to the parent. */
  drivingMinutes?: Maybe<Scalars["Float"]>;
  /** Walking distance in kilometer, to the parent. */
  walkingKm?: Maybe<Scalars["Float"]>;
  /** Walking distance in minutes, to the parent. */
  walkingMinutes?: Maybe<Scalars["Float"]>;
};

export type TravelContentImage = {
  __typename?: "TravelContentImage";
  /** The alt text of the image */
  alt?: Maybe<Scalars["String"]>;
  /** The id of the image */
  id?: Maybe<Scalars["String"]>;
  /** The source of the image */
  source?: Maybe<Scalars["String"]>;
  /** The url of the image */
  url?: Maybe<Scalars["String"]>;
};

export type TravelContentImages = {
  __typename?: "TravelContentImages";
  info?: Maybe<Array<TravelContentImage>>;
};

export type TravelContentPlace = {
  __typename?: "TravelContentPlace";
  /** Entity coordinates */
  coordinates?: Maybe<Scalars["String"]>;
  /** Entity distance to parent */
  distance?: Maybe<TravelContentDistance>;
  /** Entity id */
  id?: Maybe<Scalars["String"]>;
  /** Entity name */
  name?: Maybe<Scalars["String"]>;
  /** Entity nearby relationship. By default, excludes the items that are inside the parent geo polygon. */
  nearby?: Maybe<Relation>;
  /** Entity related relationship. Includes exclusively items that are within the parent geo polygon. */
  related?: Maybe<Relation>;
  /** Entity score */
  score?: Maybe<Scalars["Float"]>;
};

export type TravelContentPoi = {
  __typename?: "TravelContentPoi";
  /** the point of interest content, example: images or descriptions. */
  content?: Maybe<Content>;
  /** Entity coordinates */
  coordinates?: Maybe<Scalars["String"]>;
  /** Entity distance to parent */
  distance?: Maybe<TravelContentDistance>;
  /** Entity id */
  id?: Maybe<Scalars["String"]>;
  /** Entity name */
  name?: Maybe<Scalars["String"]>;
  /** Entity nearby relationship. By default, excludes the items that are inside the parent geo polygon. */
  nearby?: Maybe<Relation>;
  /** Poi popularity score */
  popularity?: Maybe<Scalars["Float"]>;
  /** Entity related relationship. Includes exclusively items that are within the parent geo polygon. */
  related?: Maybe<Relation>;
  /** Entity type. Example: park */
  type?: Maybe<Scalars["String"]>;
};

export type TravelContentProperty = {
  __typename?: "TravelContentProperty";
  /** Entity coordinates */
  coordinates?: Maybe<Scalars["String"]>;
  /** Entity distance to parent */
  distance?: Maybe<TravelContentDistance>;
  /** Entity Gaia id */
  gaiaId?: Maybe<Scalars["String"]>;
  /** Entity id */
  id?: Maybe<Scalars["String"]>;
  /** Entity name */
  name?: Maybe<Scalars["String"]>;
  /** Entity nearby relationship. By default, excludes the items that are inside the parent geo polygon. */
  nearby?: Maybe<Relation>;
  /** Entity related relationship. Includes exclusively items that are within the parent geo polygon. */
  related?: Maybe<Relation>;
  /** Property star rating */
  starRating?: Maybe<Scalars["Float"]>;
  /** Entity structure name. example: hotel, vacation rental. */
  structureName?: Maybe<Scalars["String"]>;
};

export type TravelContentRestaurant = {
  __typename?: "TravelContentRestaurant";
  /** Entity coordinates */
  coordinates?: Maybe<Scalars["String"]>;
  /** Entity distance to parent */
  distance?: Maybe<TravelContentDistance>;
  /** Entity id */
  id?: Maybe<Scalars["String"]>;
  /** Entity name */
  name?: Maybe<Scalars["String"]>;
  /** Entity nearby relationship. By default, excludes the items that are inside the parent geo polygon. */
  nearby?: Maybe<Relation>;
  /** Entity related relationship. Includes exclusively items that are within the parent geo polygon. */
  related?: Maybe<Relation>;
  /** Entity score */
  score?: Maybe<Scalars["Float"]>;
  /** Entity type. Example: grocery, restaurant, hotel */
  type?: Maybe<Scalars["String"]>;
};

export type TravelContentText = {
  __typename?: "TravelContentText";
  /** The body of the text */
  body?: Maybe<Scalars["String"]>;
  /** The name of the text */
  name?: Maybe<Scalars["String"]>;
  /** The section of the text */
  section?: Maybe<Scalars["String"]>;
  /** The section of the text */
  source: Scalars["String"];
  /** The tag of the text */
  tag?: Maybe<Scalars["String"]>;
};

export type TravelContentTexts = {
  __typename?: "TravelContentTexts";
  info?: Maybe<Array<TravelContentText>>;
};

/** URI context to get flex content. */
export interface TravelContentUriContextInput {
  /** The attribute categorises groups of similar URIs */
  attributes: UriContextAttributesInput;
  /** Identifiers are the subcomponents that uniquely identify a URI */
  identifiers: UriContextIdentifiersInput;
}

/** Wrapping type for traveler content */
export interface TravelExperienceContent {
  /** Content Unique Identifier */
  id: Scalars["ID"];
}

export type TravelExperienceContentResults = {
  __typename?: "TravelExperienceContentResults";
  /** Experience Manager - Text With Media Component -  Title Text With Media Assets Content Type */
  editorialComponent?: Maybe<EditorialComponent>;
  /** Experience Manager - Text With File Content Type */
  portableTextDocumentWithLink?: Maybe<PortableTextWithLink>;
};

/** Hero image wrapper. */
export type TravelExperienceHero = TravelExperienceContent & {
  __typename?: "TravelExperienceHero";
  /** Hero image alt */
  alt?: Maybe<Scalars["String"]>;
  /** Hero image author */
  author?: Maybe<Scalars["String"]>;
  id: Scalars["ID"];
  /** Hero image */
  image: Image;
  /** Level 1 heading */
  primary?: Maybe<Scalars["String"]>;
  /** List of subheadings */
  secondaries?: Maybe<Array<EgdsText>>;
};

/** Destination travel guide info */
export type TravelGuide = {
  __typename?: "TravelGuide";
  /** Url that links to travel guide page from blacksmith response */
  url?: Maybe<Scalars["URL"]>;
};

export type TravelScheduleLeg = {
  __typename?: "TravelScheduleLeg";
  /** message contains informtaion about the travel locations, timings and shuttle information */
  message: Array<EgdsStylizedText>;
};

export interface TravelStoreV1CarDetailsInput {
  cleaningSafetyInformation: Scalars["Boolean"];
  periodPricing: Scalars["Boolean"];
  showAds: Scalars["Boolean"];
}

export interface TravelStoreV1CarSearchInput {
  cleaningSafetyInformation: Scalars["Boolean"];
  defaultSortOption: Scalars["String"];
  filterOptions: Array<Scalars["String"]>;
  messagingOptions: Array<Scalars["String"]>;
  periodPricing: Scalars["Boolean"];
  showAds: Scalars["Boolean"];
  sortOptions: Array<Scalars["String"]>;
}

export type Traveler = {
  __typename?: "Traveler";
  age?: Maybe<Scalars["Int"]>;
  ageCategory?: Maybe<Scalars["Int"]>;
  primary?: Maybe<Scalars["Boolean"]>;
};

/** Represents the traveler details */
export type TravelerDetails = {
  __typename?: "TravelerDetails";
  age?: Maybe<Scalars["Int"]>;
  type: TravelerDetailsType;
};

/** Details corresponding to traveler */
export type TravelerDetailsForItinerary = {
  __typename?: "TravelerDetailsForItinerary";
  age: Scalars["Int"];
  name: Scalars["String"];
  qrCode?: Maybe<Scalars["String"]>;
};

/** Represents the traveler details */
export interface TravelerDetailsInput {
  age?: InputMaybe<Scalars["Int"]>;
  type: TravelerDetailsType;
}

/** Possible traveler details types */
export type TravelerDetailsType = "ADULT" | "CHILD" | "INFANT_IN_LAP" | "INFANT_IN_SEAT";

/** Package traveler occupancy group */
export type TravelerOccupancyGroup = {
  __typename?: "TravelerOccupancyGroup";
  travelers: Array<TravelerDetails>;
};

/** Package traveler occupancy group */
export interface TravelerOccupancyGroupInput {
  travelers: Array<TravelerDetailsInput>;
}

export type TravelerType = "BUSINESS" | "FAMILY" | "LGBT" | "ROMANTIC";

/** Represents per traveller ancillary selection */
export interface TravellerAncillarySelectionInput {
  /** Represents the list of encoded AncillaryToken for each selection made */
  ancillaryTokens: Array<Scalars["String"]>;
  /** Represents the traveler index for which the selection is applicable */
  travelerIndex: Scalars["Int"];
}

export type Trip = {
  __typename?: "Trip";
  /** The creation query returns a `TripsComposableDrawer` providing the customer with the ability to create a new trip. */
  creation: TripsViewResponse;
  /** The edit query returns a `TripsComposableDrawer` providing a customer the ability to edit an existing trip. */
  edit: TripsViewResponse;
  /** The invite query returns a `TripsComposableDrawer` providing a customer the ability to invite other users via email into the trip. */
  invite: TripsViewResponse;
  /**
   * The itemDetails query returns a `TripsView` providing all the details about a single trip item
   * (property, flight, car, etc.) needed by the customer. This query is typically called when a customer interacts with a trip item
   * card containing a `TripsNavigateToItemDetailsAction` action.
   */
  itemDetails: TripsViewResponse;
  /**
   * The itemEmailItinerary query returns a `TripsComposableDrawer` providing the customer with the ability to email their itinerary
   * to a list of email addresses.
   */
  itemEmailItinerary: TripsViewResponse;
  /**
   * The itemEssentialInfo query returns a TripsView providing essential information details about a single trip item as requested.
   *         It provides details for Property Access, check-in and check-out, Using the amenities, Driving and Parking instruction views.
   *         This query is typically called when a customer interacts with a trip item details card containing a `TripsLinkAction`.
   */
  itemEssentialInfo: TripsViewResponse;
  /**
   * The itemItinerary query returns a `TripsView` providing an itinerary for a single trip item
   * (property, flight, car, etc.) needed by the customer.
   */
  itemItinerary: TripsViewResponse;
  /**
   * The itemManageBooking query returns a `TripsView` providing manage booking options for a single trip item
   * (property, flight, car, etc.) needed by the customer. This query is typically called when a customer interacts with a trip item details
   * card containing a `TripsNavigateToItemManageBookingAction` action.
   */
  itemManageBooking: TripsViewResponse;
  /**
   * The itemPricingAndRewards query returns a `TripsView` providing pricing and rewards details about a single trip item
   * (property, flight, car, etc.) needed by the customer. This query is typically called when a customer interacts with a trip item details
   * card containing a `TripsNavigateToItemPricingAndRewardsAction` action.
   */
  itemPricingAndRewards: TripsViewResponse;
  /**
   * The itemReceipt query returns a `TripsView` providing a receipt for a single trip item
   * (property, flight, car, etc.) needed by the customer.
   */
  itemReceipt: TripsViewResponse;
  /**
   * The itemVoucher query returns a `TripsView` providing voucher details about a single trip activity item
   * needed by the customer.
   */
  itemVoucher: TripsViewResponse;
  /**
   * The itemVoucherPrint query returns a `TripsView` providing voucher details about a single trip activity item
   * to be converted into a printable PDF.
   */
  itemVoucherPrint: TripsViewResponse;
  /** The manage guests query returns a `TripsView` providing a customer the ability to see list of guests in accepted and pending state with avatar and name or email address. */
  manageGuests: TripsViewResponse;
  /**
   * The move trip item query returns a `TripsComposableDrawer` providing the customer with the ability
   * to move a trip item to another trip.
   */
  moveTripItem: TripsViewResponse;
  /**
   * The overview query returns a TripsView providing an overview of an entire trip.
   * In addition to the trip cards representing the trip's booked or unbooked trip items, such as a flight or activity,
   * it will also return cards that offer other related information such as weather, recommendations, maps and the like.
   * This query is typically called when a customer interacts with trip card containing a `TripsNavigateToTripOverviewAction action`.
   */
  overview: TripsViewResponse;
  /** The overviewItinerary query returns a `TripsView` providing an itinerary for the entire trip. */
  overviewItinerary: TripsViewResponse;
  /** Invite query to show invite landing screen to join the trip or go back to trips overview screen */
  pendingInvite: TripsViewResponse;
  /** Query returns a `TripsSavedItemPrice` providing customers a price information (including live price) for any saved to a trip item. */
  savedItemPrice?: Maybe<TripsSavedItemPrice>;
};

export type TripCreationArgs = {
  metadata?: InputMaybe<TripCreationMetadataInput>;
  source?: InputMaybe<TripCreationEntryPoint>;
};

export type TripEditArgs = {
  overview: TripOverviewInput;
};

export type TripInviteArgs = {
  overview: TripOverviewInput;
};

export type TripItemDetailsArgs = {
  item: TripItemInput;
  userToken?: InputMaybe<Scalars["String"]>;
};

export type TripItemEmailItineraryArgs = {
  item: TripItemInput;
};

export type TripItemEssentialInfoArgs = {
  essentialItemInput: EssentialInfoItemInput;
  item: TripItemInput;
};

export type TripItemItineraryArgs = {
  item: TripItemInput;
};

export type TripItemManageBookingArgs = {
  item: TripItemInput;
};

export type TripItemPricingAndRewardsArgs = {
  item: TripItemInput;
};

export type TripItemReceiptArgs = {
  item: TripItemInput;
};

export type TripItemVoucherArgs = {
  item: TripItemInput;
};

export type TripItemVoucherPrintArgs = {
  item: TripItemInput;
};

export type TripManageGuestsArgs = {
  overview: TripOverviewInput;
};

export type TripMoveTripItemArgs = {
  item: TripItemInput;
};

export type TripOverviewArgs = {
  overview: TripOverviewInput;
  userToken?: InputMaybe<Scalars["String"]>;
};

export type TripOverviewItineraryArgs = {
  overview: TripOverviewInput;
};

export type TripPendingInviteArgs = {
  tripInvite: TripInviteInput;
};

export type TripSavedItemPriceArgs = {
  item: TripItemInput;
};

/** Trip Care Attributes */
export type TripCareAttributes = {
  __typename?: "TripCareAttributes";
  /** Insurance order attribute */
  orderLineNumbers?: Maybe<Scalars["String"]>;
  /** Insurance vendor attribute */
  vendor?: Maybe<Scalars["String"]>;
};

/** Trip Care Banner UI Component */
export type TripCareBanner = {
  __typename?: "TripCareBanner";
  /** The heading of the banner */
  heading?: Maybe<Scalars["String"]>;
  /** The icon of the banner */
  icon?: Maybe<Icon>;
  /** The main message of the banner body */
  message: Scalars["String"];
};

export type TripCareButton = {
  __typename?: "TripCareButton";
  action: TripCareButtonAction;
  icon: Icon;
  state?: Maybe<TripCareButtonState>;
  tag: Scalars["String"];
};

export type TripCareButtonAction = "BACK" | "CANCEL_POLICY" | "DISMISS_POPUP" | "POPUP" | "RELOAD";

export type TripCareButtonState = "DISABLED" | "ENABLED";

export type TripCareCountryPhoneComponent = {
  __typename?: "TripCareCountryPhoneComponent";
  countryName: TripCareTextPhrase;
  phoneNumber: TripCarePhoneNumberComponent;
};

export type TripCareCountryPhoneListComponent = {
  __typename?: "TripCareCountryPhoneListComponent";
  countryPhoneComponents: Array<TripCareCountryPhoneComponent>;
};

export type TripCareDialog = {
  __typename?: "TripCareDialog";
  footer: TripCareDialogFooter;
  header: TripCareHeader;
  section: TripCareSection;
  tag?: Maybe<TripCareTextPhrase>;
  uniqueDialogId: Scalars["String"];
};

export type TripCareDialogFooter = {
  __typename?: "TripCareDialogFooter";
  buttonOne: TripCareButton;
  buttonThree?: Maybe<TripCareButton>;
  buttonTwo?: Maybe<TripCareButton>;
  stacked: Scalars["Boolean"];
};

/** Trip Care Email Component */
export type TripCareEmailComponent = {
  __typename?: "TripCareEmailComponent";
  /** Email address */
  emailId: Scalars["String"];
  /** Icon for email */
  icon: Icon;
  /** Message with email Text */
  message: TripCareTextPhrase;
};

/** Error response for TripCare UI */
export type TripCareError = {
  __typename?: "TripCareError";
  /** Body for error message containing any additional content attributes if required. This is the UI section we  will be showing on error page */
  errorBody?: Maybe<TripCareSection>;
  /** Error code corresponding to the exception */
  errorCode: Scalars["String"];
  /** Error message for the exception if any. In some case only popup message will be there */
  errorMessage: Scalars["String"];
  /** HTTP status code */
  httpStatus: HttpStatus;
};

/** Trip Care Expendo UI Component */
export type TripCareExpando = {
  __typename?: "TripCareExpando";
  /** Click expando analytics events to be published  */
  analytics?: Maybe<ClientSideAnalytics>;
  /** Details Section of Expando */
  details: TripCareSection;
  /** Title of Expando */
  heading: TripCareTextPhrase;
  /** Expando section visibility flag */
  isVisible: Scalars["Boolean"];
};

/** Trip Care Expendo Peek UI Component */
export type TripCareExpandoPeek = {
  __typename?: "TripCareExpandoPeek";
  /** Click expando analytics events to be published  */
  analytics?: Maybe<ClientSideAnalytics>;
  /** Expando collapse label */
  collapseLabel: Scalars["String"];
  /** Details Section component of Expando */
  details: TripCareSectionComponent;
  /** Expando expand label */
  expandLabel: Scalars["String"];
};

export type TripCareFullScreenDialog = {
  __typename?: "TripCareFullScreenDialog";
  header: TripCareHeader;
  section: TripCareSection;
  tag: Scalars["String"];
  uniqueDialogId: Scalars["String"];
};

/** Trip Care Header Component */
export type TripCareHeader = {
  __typename?: "TripCareHeader";
  /** Additional Sub Headers */
  additionalHeaders: Array<TripCarePhrase>;
  heading: TripCareTextPhrase;
  subHeading?: Maybe<TripCareTextPhrase>;
};

/** Trip Care Section Layout Card */
export type TripCareLayoutCard = {
  __typename?: "TripCareLayoutCard";
  columnNumber: Scalars["Int"];
  section: TripCareSectionComponent;
};

/** Parent interface for all cards components */
export type TripCareLayoutComponent = TripCareLayoutCard | TripCareLayoutSection;

/** Trip Care Section Layout Wrapper */
export type TripCareLayoutSection = {
  __typename?: "TripCareLayoutSection";
  columnNumber: Scalars["Int"];
  section: TripCareSectionComponent;
};

export type TripCareLayoutStyle = "CARD_BORDER_TOP";

export type TripCareLinkPhrase = {
  __typename?: "TripCareLinkPhrase";
  /** Label for specially-abled users */
  accessibilityLabel?: Maybe<Scalars["String"]>;
  /** Details for analytics events to be published  */
  analytics?: Maybe<ClientSideAnalytics>;
  /** Text displayed to user for link */
  label: Scalars["String"];
  /** Whether its plaintext, link or button */
  phraseType?: Maybe<TripCarePhraseType>;
  /** Styling on the phrase */
  styles?: Maybe<Array<TripCarePhraseStyle>>;
  /** Url of link */
  url: HttpUri;
};

/** Trip Care List UI Component */
export type TripCareListComponent = {
  __typename?: "TripCareListComponent";
  contentList: Array<TripCarePhrase>;
  heading?: Maybe<TripCareTextPhrase>;
  listType: TripCareListType;
  subHeading?: Maybe<TripCareTextPhrase>;
};

export type TripCareListType = "BULLET" | "NO_BULLET" | "NUMBERED";

export type TripCareOverviewSection = {
  __typename?: "TripCareOverviewSection";
  description: Scalars["String"];
  heading: Scalars["String"];
  /** Url to Detail Page */
  link: TripCareLinkPhrase;
};

export type TripCarePhoneNumberComponent = {
  __typename?: "TripCarePhoneNumberComponent";
  /** Icon for phone */
  icon?: Maybe<Icon>;
  identifier: Scalars["String"];
  message?: Maybe<TripCareSentence>;
  phone: Scalars["String"];
  regionDetails?: Maybe<TripCareTextPhrase>;
};

/** Markup Interface for Trip Care Phrase */
export type TripCarePhrase =
  | TripCareDialog
  | TripCareFullScreenDialog
  | TripCareLinkPhrase
  | TripCareSentence
  | TripCareTextPhrase;

export type TripCarePhraseStyle =
  | "BOLD"
  | "HR_DIVIDER_BOTTOM"
  | "HR_DIVIDER_TOP"
  | "SIZE_100"
  | "SIZE_200"
  | "SIZE_300"
  | "SIZE_400"
  | "SIZE_500"
  | "SIZE_600"
  | "SIZE_700"
  | "SIZE_800"
  | "SIZE_900"
  | "SMALL"
  | "SPACING_FOUR"
  | "SPACING_HALF"
  | "SPACING_ONE"
  | "SPACING_SIX"
  | "SPACING_THREE"
  | "SPACING_TWO"
  | "THEME_EMPHASIS"
  | "THEME_NEGATIVE"
  | "THEME_POSITIVE"
  | "WEIGHT_BOLD"
  | "WEIGHT_MEDIUM"
  | "WEIGHT_REGULAR";

export type TripCarePhraseType = "BUTTON" | "LINK" | "TEXT";

/** Trip Care Section UI Component */
export type TripCareSection = {
  __typename?: "TripCareSection";
  footer?: Maybe<Array<TripCarePhrase>>;
  heading?: Maybe<TripCareTextPhrase>;
  /** Subsections in UI Component */
  sections?: Maybe<Array<TripCareSectionComponent>>;
  /** Styling on the phrase */
  styles?: Maybe<Array<TripCareLayoutStyle>>;
  subHeading?: Maybe<TripCareTextPhrase>;
};

/** Parent interface for all section components */
export type TripCareSectionComponent =
  | TripCareBanner
  | TripCareButton
  | TripCareCountryPhoneComponent
  | TripCareCountryPhoneListComponent
  | TripCareDialog
  | TripCareDialogFooter
  | TripCareEmailComponent
  | TripCareExpando
  | TripCareExpandoPeek
  | TripCareFullScreenDialog
  | TripCareLinkPhrase
  | TripCareListComponent
  | TripCareOverviewSection
  | TripCarePhoneNumberComponent
  | TripCareSection
  | TripCareSentence
  | TripCareTextPhrase;

/** Sentences having multiple phrases */
export type TripCareSentence = {
  __typename?: "TripCareSentence";
  phrases: Array<TripCarePhrase>;
  /** Styling on the sentence */
  styles?: Maybe<Array<TripCarePhraseStyle>>;
};

/** Text Phrase */
export type TripCareTextPhrase = {
  __typename?: "TripCareTextPhrase";
  /** Text content in phrase */
  content: Scalars["String"];
  /** Icon in the phrase */
  icon?: Maybe<Icon>;
  /** Whether its text or button, default being text */
  phraseType?: Maybe<TripCarePhraseType>;
  /** Styling on the phrase */
  styles?: Maybe<Array<TripCarePhraseStyle>>;
};

export type TripCreationEntryPoint = "HOTEL_SEARCH_RESULTS" | "TRIPS_LIST" | "TRIP_OVERVIEW";

/** Metadata which can be provided when creating a new trip. */
export type TripCreationMetadata = {
  __typename?: "TripCreationMetadata";
  /** @deprecated TripCreationEntryPoint has been deprecated and will be removed in future */
  entryPoint: TripCreationEntryPoint;
  /** @deprecated itemId has been deprecated., replace with saveItemInput.itemId */
  itemId?: Maybe<Scalars["String"]>;
  /** An item provided when creating a new trip as part of moving an item to a trip */
  moveItem?: Maybe<TripItem>;
  /** Trip planning inputs provided when creating a new trip as part of saving an item to a trip */
  saveItemInput?: Maybe<TripsPlan>;
};

/** Metadata which can be provided when creating a new trip. */
export interface TripCreationMetadataInput {
  entryPoint?: InputMaybe<TripCreationEntryPoint>;
  itemId?: InputMaybe<Scalars["String"]>;
  /** An input provided when creating a new trip as part of moving an item to a trip */
  moveItemInput?: InputMaybe<TripItemInput>;
  /** Trip planning inputs provided when creating a new trip as part of saving an item to a trip */
  saveItemInput?: InputMaybe<TripsPlanInput>;
}

/** The TripEntity defines a list of supported items which can be can be saved to a trip. */
export type TripEntity = "ACTIVITY_PRODUCT" | "FLIGHT_SEARCH" | "LODGING_PRODUCT";

/** Origin info of the Customer */
export type TripIntentAirport = {
  __typename?: "TripIntentAirport";
  /** The Region Id of the city the airport is in */
  cityRegionId?: Maybe<Scalars["String"]>;
  /** The IATA airport code of the airport */
  code?: Maybe<Scalars["String"]>;
};

export type TripIntentDestination = {
  __typename?: "TripIntentDestination";
  /** Airport for most recent search */
  airport?: Maybe<TripIntentAirport>;
  /** Latitude of destination */
  coordinates?: Maybe<Coordinates>;
  /** RegionId of destination */
  id?: Maybe<Scalars["String"]>;
  /** Name of destination */
  name?: Maybe<Scalars["String"]>;
};

export type TripIntentOrigin = {
  __typename?: "TripIntentOrigin";
  /** Preferred airport info of the customer */
  airport?: Maybe<TripIntentAirport>;
  /** Latitude of origin */
  coordinates?: Maybe<Coordinates>;
  /** RegionId of  origin */
  id?: Maybe<Scalars["String"]>;
  /** Name of origin */
  name?: Maybe<Scalars["String"]>;
};

export type TripIntentPerson = {
  __typename?: "TripIntentPerson";
  age?: Maybe<Scalars["Int"]>;
  type: TripIntentPersonType;
};

export type TripIntentPersonType = "ADULT" | "CHILD";

export type TripIntentRoom = {
  __typename?: "TripIntentRoom";
  childAges: Array<Scalars["Int"]>;
  numberOfAdults: Scalars["Int"];
  numberOfChildren: Scalars["Int"];
};

export type TripIntentWhen = {
  __typename?: "TripIntentWhen";
  fromDate: ZonedDateTime;
  toDate: ZonedDateTime;
};

export type TripIntentWhere = {
  __typename?: "TripIntentWhere";
  /** Retrieve the Destination info of the current trip */
  destination?: Maybe<TripIntentDestination>;
  /** Retrieve the Origin info of the current trip */
  origin?: Maybe<TripIntentOrigin>;
};

export type TripIntentWho = {
  __typename?: "TripIntentWho";
  people: Array<TripIntentPerson>;
  rooms: Array<TripIntentRoom>;
};

export type TripIntentWhy = {
  __typename?: "TripIntentWhy";
  /** Retrieve the customer interests */
  interests: Array<Interest>;
};

/**
 * The `TripInviteInput` complex type contains a `inviteId` known by the Trip Domain.
 * The inviteId is invitation identifier to be opened from trips overview screen or redirected to by invite deep link.
 * The server will construct all the necessary information based on invite that has back reference to trip with all needed information to populate view
 * It also provides context to the Trip Overview view for functions such as back navigation.
 */
export interface TripInviteInput {
  inviteId: Scalars["String"];
}

/**
 * "The `TripItemInput` contains a tripViewId and tripItemId known by the Trip Domain, plus an optional filter known to the Trips Graph.
 * The set of supported filters is the same as defined in `TripsFilterInput` and provides context to the Trip Item Details view for functions such as back navigation.
 */
export type TripItem = {
  __typename?: "TripItem";
  filter?: Maybe<Scalars["String"]>;
  tripEntity?: Maybe<TripEntity>;
  tripItemId: Scalars["String"];
  tripViewId: Scalars["String"];
};

/**
 * "The `TripItemInput` contains a tripViewId and tripItemId known by the Trip Domain, plus an optional filter known to the Trips Graph.
 * The set of supported filters is the same as defined in `TripsFilterInput` and provides context to the Trip Item Details view for functions such as back navigation.
 */
export interface TripItemInput {
  filter?: InputMaybe<Scalars["String"]>;
  tripEntity?: InputMaybe<TripEntity>;
  tripItemId: Scalars["String"];
  tripViewId: Scalars["String"];
}

export type TripMutation = {
  __typename?: "TripMutation";
  /** Accept invite take TripInvite as input and invokes corresponding operation on backend. Upon successful response Trip Overview is displayed for the user */
  acceptInvite: TripsViewResponse;
  /** The cancel mutation requests to cancel products from a trip, and returns a `TripsView` to be displayed to the user. */
  cancel: TripsViewResponse;
  /** The cancel activity mutation requests to cancel the activity trip item, and returns a `TripsView` to be displayed to the user. */
  cancelActivity: TripsViewResponse;
  /** The cancel car mutation requests to cancel the car trip item (and associated insurance, if relevant), and returns a `TripsView` to be displayed to the user. */
  cancelCar: TripsViewResponse;
  /** The cancel insurance mutation requests to cancel the trip item's insurance, and returns a `TripsView` to be displayed to the user. */
  cancelInsurance: TripsViewResponse;
  /** The create trip mutation requests to create a new empty trip, and returns a `TripsView` with a toast to be displayed to the user. */
  createTrip: TripsViewResponse;
  /** The delete trip mutation requests to delete a trip, and returns a `TripsView` with a toast to be displayed to the user. */
  deleteTrip: TripsViewResponse;
  /** The edit trip mutation requests to edit an existing trip, and returns a `TripsView` with a toast to be displayed to the user. */
  editTrip: TripsViewResponse;
  /** The move trip item mutation requests to move a trip item when toTripId, toTripName are provided. Creates a trip and move the item when the name and description are provided in the inputs and returns a `TripsView` with a toast to be displayed to the user. */
  moveTripItem: TripsViewResponse;
  /** The `saveItemToTrip`  to trip mutation requests to add an item to a new or an existing trip, and returns a `TripsView` with a toast to be displayed to the user. */
  saveItemToTrip: TripsViewResponse;
  /**
   * The `saveStayToTrip` mutation requests to add a stay to a new or an existing trip, and returns a `TripsView` with a toast to be displayed to the user.
   * @deprecated saveStayToTrip mutation has been deprecated, replace with saveItemToTrip mutation
   */
  saveStayToTrip: TripsViewResponse;
  /** The send invite mutation takes in a list of emails from the client and an optional message and returns a `TripsView` with a toast if the invite was successful or not */
  sendInvite: TripsViewResponse;
  /** The send Itinerary email mutation requests to send an email of the trip to the requested email ids, and returns a `TripsView` to be displayed to the user. */
  sendItineraryEmail: TripsViewResponse;
  /** The `unsaveItemFromTrip` mutation requests to remove an item from a trip, and returns a `TripsView` with a toast to be displayed to the user. */
  unsaveItemFromTrip: TripsViewResponse;
  /**
   * The un-save stay to trip mutation requests to remove a stay from an existing trip, and returns a `TripsView` with a toast to be displayed to the user.
   * @deprecated unsaveStayFromTrip mutation has been deprecated, replace with unsaveItemFromTrip mutation
   */
  unsaveStayFromTrip: TripsViewResponse;
  /** The update item dates mutation requests to update the dates for item within a Trip, and returns a `TripsView` with a toast to be displayed to the user. */
  updateItemDates: TripsViewResponse;
  /** The `updateItemPriceAlertStatus` mutation updates the given saved search `tripItem`'s price alerting status to the given `alertStatus` value. */
  updateItemPriceAlertStatus: TripsMutationResponse;
};

export type TripMutationAcceptInviteArgs = {
  tripInvite: TripInviteInput;
};

export type TripMutationCancelArgs = {
  cancellationAttributes?: InputMaybe<TripsCancellationAttributesInput>;
  cancellationType: TripsCancellationType;
  item: TripItemInput;
};

export type TripMutationCancelActivityArgs = {
  item: TripItemInput;
  orderLineNumbers?: InputMaybe<Array<Scalars["String"]>>;
  orderNumber: Scalars["String"];
};

export type TripMutationCancelCarArgs = {
  item: TripItemInput;
  orderLineNumbers: Array<Scalars["String"]>;
};

export type TripMutationCancelInsuranceArgs = {
  item: TripItemInput;
  orderLineNumber: Scalars["String"];
};

export type TripMutationCreateTripArgs = {
  inputs: Array<GraphQlPairInput>;
};

export type TripMutationDeleteTripArgs = {
  tripId: Scalars["String"];
};

export type TripMutationEditTripArgs = {
  inputs: Array<GraphQlPairInput>;
  overview: TripOverviewInput;
};

export type TripMutationMoveTripItemArgs = {
  inputs?: InputMaybe<Array<GraphQlPairInput>>;
  item: TripItemInput;
  toTripId?: InputMaybe<Scalars["String"]>;
  toTripName?: InputMaybe<Scalars["String"]>;
};

export type TripMutationSaveItemToTripArgs = {
  itemInput: TripsPlanInput;
  newTripInputs?: InputMaybe<Array<GraphQlPairInput>>;
  tripId?: InputMaybe<Scalars["String"]>;
};

export type TripMutationSaveStayToTripArgs = {
  inputs?: InputMaybe<Array<GraphQlPairInput>>;
  stayInput: TripsSaveStayInput;
  tripId?: InputMaybe<Scalars["String"]>;
};

export type TripMutationSendInviteArgs = {
  inputs: Array<GraphQlPairInput>;
  overview: TripOverviewInput;
};

export type TripMutationSendItineraryEmailArgs = {
  inputs: Array<GraphQlPairInput>;
  item: TripItemInput;
};

export type TripMutationUnsaveItemFromTripArgs = {
  tripEntity: TripEntity;
  tripItem: TripItemInput;
};

export type TripMutationUnsaveStayFromTripArgs = {
  tripItem: TripItemInput;
};

export type TripMutationUpdateItemDatesArgs = {
  dateRange: DateRangeInput;
  tripEntity: TripEntity;
  tripItem: TripItemInput;
};

export type TripMutationUpdateItemPriceAlertStatusArgs = {
  alertStatus: TripsToggleStatus;
  tripItem: TripItemInput;
};

/**
 * The `TripOverviewInput` complex type contains a `tripViewId` known by the Trip Domain and an optional `filter` known by the Trips Graph Service.
 * The tripViewId identifier is opaque to the client, it may be an EG Trip Identifier or an identifier used for Trip Sharing.
 * The server will determine how much of the trip and which actions to return based on the sharing rules associated with the TripViewId.
 * The set of supported filters is the same as defined in `TripsFilterInput` and provides context to the Trip Overview view for functions such as back navigation.
 */
export type TripOverview = {
  __typename?: "TripOverview";
  filter?: Maybe<Scalars["String"]>;
  inviteId?: Maybe<Scalars["String"]>;
  segments?: Maybe<Array<Scalars["String"]>>;
  tripViewId: Scalars["String"];
};

/**
 * The `TripOverviewInput` complex type contains a `tripViewId` known by the Trip Domain and an optional `filter` known by the Trips Graph Service.
 * The tripViewId identifier is opaque to the client, it may be an EG Trip Identifier or an identifier used for Trip Sharing.
 * The server will determine how much of the trip and which actions to return based on the sharing rules associated with the TripViewId.
 * The set of supported filters is the same as defined in `TripsFilterInput` and provides context to the Trip Overview view for functions such as back navigation.
 */
export interface TripOverviewInput {
  filter?: InputMaybe<Scalars["String"]>;
  inviteId?: InputMaybe<Scalars["String"]>;
  segments?: InputMaybe<Array<Scalars["String"]>>;
  tripViewId: Scalars["String"];
}

/** EG Clickstream schema for individual recommendation impressions and interactions */
export type TripRecommendation = {
  __typename?: "TripRecommendation";
  currencyCode?: Maybe<Scalars["String"]>;
  id: Scalars["String"];
  name?: Maybe<Scalars["String"]>;
  position?: Maybe<Scalars["String"]>;
  priceDisplayed: Scalars["String"];
};

/** EG Clickstream schema for recommendation module impressions and interactions */
export type TripRecommendationModule = {
  __typename?: "TripRecommendationModule";
  recommendations: Array<TripRecommendation>;
  responseId: Scalars["String"];
  title: Scalars["String"];
};

export type TripScheduleChangeStatus = "FLIGHT_SCHEDULE_CHANGE" | "NO_CHANGE";

/** Content for the trip summary card */
export type TripSummaryContent = {
  __typename?: "TripSummaryContent";
  /** Trip details title */
  header: LodgingHeader;
  /** Prices and price messages on right side of card */
  price: PropertyPrice;
  /** Summary messages on left side of card */
  summary: Array<LodgingEnrichedMessage>;
};

export type TripSummaryHeading = EgdsSectionHeading & {
  __typename?: "TripSummaryHeading";
  heading: EgdsHeading;
  subheading?: Maybe<Scalars["String"]>;
};

export type Trips = {
  __typename?: "Trips";
  /**
   * The customer query returns a TripsView providing organized access to all a customer's trips. This query is typically called when
   * the customer navigates via the Trips tab or Trips menu.
   */
  customer: TripsViewResponse;
  /**
   * The filtered query returns a `TripsView` providing all the trips that match the filter specified in the filterId input argument.
   * This query is typically called when a customer interacts with a trip card ("See all upcoming trips") or navigation element ("Upcoming" tab) that has an associated
   * `TripsNavigateToFilteredViewAction` action.
   */
  filtered: TripsViewResponse;
  /** The find itinerary number query provides a view that allows sending an email with a list of Itineraries to the user's email (replacing user/forgotitin flow). It provides the Find your itinerary number view where user can enter their email address in a form and submit. It also handles form submition and generate success/failure view. */
  findItineraryNumber: TripsViewResponse;
  /** The hero query returns a component that will takeover part of the page with trip and other related content. */
  hero: HomeResponse;
  /**
   * The important query returns a `TripsView` summarizing the trips which are most important to a customer in the current context.
   * This query is typically called from the home screens and homepages of clients.
   */
  important: TripsViewResponse;
  /** The navigation query returns a `TripsView` to be shown as a dropdown from the navigation header, summarizing the trips which are most important to a customer in the current context. */
  navigation: TripsViewResponse;
  /** The plan query returns a trips drawer response providing a list of trips a customer can save an item to. */
  plan: TripsViewResponse;
  /** The recentSearches query returns an action list with all the recent searches done by the user. */
  recentSearches: TripsRecentSearchesResponse;
  /** The screenshot query returns a screenshot option drawer response providing the options to save or share the stay. */
  screenshot: TripsViewResponse;
  /** The searchBooking query is responsible for powering search your booking flow(replacing old finditin flow). It is responsible for generating Find your booking view where user can enter their itinerary number/email address in a form.It is also responsible to generating view when the user submits the form, there can be two cases success or failure case */
  searchBooking: TripsViewResponse;
};

export type TripsFilteredArgs = {
  filter: TripsFilterInput;
};

export type TripsFindItineraryNumberArgs = {
  inputs?: InputMaybe<Array<GraphQlPairInput>>;
  viewType: TripsFindItineraryNumberView;
};

export type TripsHeroArgs = {
  heroViewType?: InputMaybe<HeroViewType>;
};

export type TripsPlanArgs = {
  input: TripsPlanInput;
};

export type TripsScreenshotArgs = {
  input: TripsScreenshotInput;
};

export type TripsSearchBookingArgs = {
  searchInput?: InputMaybe<Array<GraphQlPairInput>>;
  viewType: TripsSearchBookingView;
};

/** Action describing the user interaction on an element that should allow the traveler to accept an invite to join a trip and see the 'Trip Overview' page. */
export type TripsAcceptInviteAndNavigateToOverviewAction = TripsAction & {
  __typename?: "TripsAcceptInviteAndNavigateToOverviewAction";
  analytics: ClientSideAnalytics;
  overview: TripOverview;
  overviewUrl?: Maybe<Scalars["URL"]>;
};

/** Standard or default Trips Accessibility Data. */
export type TripsAccessibilityData = AccessibilityData & {
  __typename?: "TripsAccessibilityData";
  hint?: Maybe<Scalars["String"]>;
  label?: Maybe<Scalars["String"]>;
};

/**
 * An action is a generic container to information the client side application what can be done with a given card.
 * Sometimes the action will be could be associated with a deep link, opening a specific view or leveraging some protocols like e-mails or phones.
 * Every action must be trackable for analytics purpose based on the `analytics` information.
 */
export interface TripsAction {
  analytics: ClientSideAnalytics;
}

/** Represent an Action List for Trips */
export type TripsActionList = {
  __typename?: "TripsActionList";
  accessibility?: Maybe<Scalars["String"]>;
  actionList: Array<TripsActionListItem>;
  primary?: Maybe<Scalars["String"]>;
};

/** Represents an Action List Item for Trips */
export type TripsActionListItem = {
  __typename?: "TripsActionListItem";
  action: TripsNavigateToViewAction;
  icon?: Maybe<Icon>;
  primary: Scalars["String"];
  secondaries?: Maybe<Array<Scalars["String"]>>;
};

/** Basic representation of an avatar. */
export type TripsAvatar = {
  __typename?: "TripsAvatar";
  name: Scalars["String"];
  url?: Maybe<Scalars["URL"]>;
};

/** Used to represent a list of Avatars. */
export type TripsAvatarGroup = TripsFlexContainerItem & {
  __typename?: "TripsAvatarGroup";
  accessibility?: Maybe<AccessibilityData>;
  /** action can be optional for a group. */
  action?: Maybe<TripsNavigateToViewAction>;
  avatarSize: TripsAvatarSize;
  /** Returns a list of Avatars that UI needs to render. For instance if design requires to show 3 avatars followed by count text as the last avatar, then the list will return a total of 4 avatars. */
  avatars: Array<TripsAvatar>;
  grow?: Maybe<Scalars["Float"]>;
  /** Avatar in a group can be with or without a border. */
  showBorder: Scalars["Boolean"];
};

/** Represents different avatar sizes. */
export type TripsAvatarSize = "EXTRA_LARGE" | "LARGE" | "MEDIUM" | "SMALL";

/** Represents a Trips badge */
export type TripsBadge = {
  __typename?: "TripsBadge";
  accessibility?: Maybe<Scalars["String"]>;
  graphic?: Maybe<UiGraphic>;
  text?: Maybe<Scalars["String"]>;
  theme?: Maybe<TripsBadgeTheme>;
};

/** Supported Trips badge themes */
export type TripsBadgeTheme =
  | "LOYALTY_HIGH_TIER"
  | "LOYALTY_LOW_TIER"
  | "LOYALTY_MIDDLE_TIER"
  | "SAVED"
  | "STATUS_NEGATIVE"
  | "STATUS_POSITIVE"
  | "UTILITY_STANDARD"
  | "VIP";

/** A menu shows a list of items which perform an action on interaction, this one is anchored to the bottom of the screen */
export type TripsBottomMenu = TripsMenu & {
  __typename?: "TripsBottomMenu";
  impressionTracking?: Maybe<ClientSideImpressionAnalytics>;
  items: Array<TripsMenuItem>;
  menuItems: Array<TripsMenuItem>;
  menuTitle?: Maybe<Scalars["String"]>;
};

/** DEPRECATED */
export type TripsBottomSheet = {
  __typename?: "TripsBottomSheet";
  elements: Array<TripsTertiaryButton>;
  primary?: Maybe<Scalars["String"]>;
  secondaries?: Maybe<Array<Scalars["String"]>>;
};

/** Base class for Buttons */
export interface TripsButton {
  accessibility?: Maybe<AccessibilityData>;
  action?: Maybe<TripsAction>;
  disabled: Scalars["Boolean"];
  icon?: Maybe<Icon>;
  primary?: Maybe<Scalars["String"]>;
  width: TripsButtonWidth;
}

export type TripsButtonWidth = "MATCH_PARENT_CONTAINER" | "WRAP_CONTENT";

export type TripsCalendarSelectionType = "SINGLE" | "START_AND_END" | "START_AND_END_WITH_SAME_DATE";

/** DEPRECATED - will be removed */
export type TripsCancelActivityAction = TripsAction & {
  __typename?: "TripsCancelActivityAction";
  analytics: ClientSideAnalytics;
  item: TripItem;
  orderLineNumbers?: Maybe<Array<Scalars["String"]>>;
  orderNumber: Scalars["String"];
};

/** DEPRECATED - will be removed */
export type TripsCancelAssuranceAction = TripsAction & {
  __typename?: "TripsCancelAssuranceAction";
  analytics: ClientSideAnalytics;
  item: TripItem;
  orderLineNumber: Scalars["String"];
};

/** DEPRECATED - will be removed */
export type TripsCancelCarAction = TripsAction & {
  __typename?: "TripsCancelCarAction";
  analytics: ClientSideAnalytics;
  item: TripItem;
  orderLineNumbers: Array<Scalars["String"]>;
};

/** DEPRECATED - will be removed soon */
export type TripsCancelFlightAction = TripsAction & {
  __typename?: "TripsCancelFlightAction";
  airRecordLocator: Scalars["String"];
  airlineConfirmationCode: Scalars["String"];
  analytics: ClientSideAnalytics;
  item: TripItem;
  tripNumber: Scalars["String"];
  userToken: Scalars["String"];
};

/** DEPRECATED - will be removed */
export type TripsCancelInsuranceAction = TripsAction & {
  __typename?: "TripsCancelInsuranceAction";
  analytics: ClientSideAnalytics;
  item: TripItem;
  orderLineNumber: Scalars["String"];
};

/** Action describing the user interaction on an element should cancel the associated trip item */
export type TripsCancellationAction = TripsAction & {
  __typename?: "TripsCancellationAction";
  analytics: ClientSideAnalytics;
  cancellationAttributes?: Maybe<TripsCancellationAttributes>;
  cancellationType: TripsCancellationType;
  item?: Maybe<TripItem>;
  /** @deprecated Deprecated, please use `cancellationAttributes` instead */
  orderLineNumbers?: Maybe<Array<Scalars["String"]>>;
  /** @deprecated Deprecated, please use `cancellationAttributes` instead */
  orderNumber?: Maybe<Scalars["String"]>;
};

/** Contains attributes for trip cancellation */
export type TripsCancellationAttributes = {
  __typename?: "TripsCancellationAttributes";
  orderLineNumbers?: Maybe<Array<Scalars["String"]>>;
  orderNumber?: Maybe<Scalars["String"]>;
  /** Formatted string. This is optional attribute. In case of partial refund, we are passing this value to the backend. */
  penaltyAmount?: Maybe<Scalars["String"]>;
  /** Formatted string. This is optional attribute for displayed refund amount to user. If this value set then compare between displayed amount and actual amount from backend. */
  refundAmount?: Maybe<Scalars["String"]>;
};

/** Contains attributes for trip cancellation */
export interface TripsCancellationAttributesInput {
  orderLineNumbers?: InputMaybe<Array<Scalars["String"]>>;
  orderNumber?: InputMaybe<Scalars["String"]>;
  /** Formatted string. This is optional attribute. In case of partial refund, we are passing this value to the backend. */
  penaltyAmount?: InputMaybe<Scalars["String"]>;
  /** Formatted string. This is optional attribute for displayed refund amount to user. If this value set then compare between displayed amount and actual amount from backend. */
  refundAmount?: InputMaybe<Scalars["String"]>;
}

export type TripsCancellationType = "ACTIVITY" | "CAR" | "CRUISE" | "HOTEL" | "INSURANCE";

/**
 * A card can contain others to provide a logical grouping or carry some information.
 * Each card implementation will be responsible for displaying each part appropriately.
 * For example, in a web experience, a `primary` could sometimes be used in a `h1` where somewhere else the `primary` would be an `h4`.
 */
export interface TripsCard {
  impressionTracking?: Maybe<ClientSideImpressionAnalytics>;
  primary?: Maybe<Scalars["String"]>;
}

/** Represents a TripsCard's selection/active state */
export type TripsCardState = "SELECTED" | "UNSELECTED";

/** Trips Carousel Accessibility Data when you have next and back buttons. */
export type TripsCarouselAccessibilityData = AccessibilityData & {
  __typename?: "TripsCarouselAccessibilityData";
  hint?: Maybe<Scalars["String"]>;
  label?: Maybe<Scalars["String"]>;
  nextButton?: Maybe<Scalars["String"]>;
  prevButton?: Maybe<Scalars["String"]>;
};

/** Used to align a set of cards horizontally with a scrolling effect. The recommended card to use is `TripImageTopCard` */
export type TripsCarouselContainer = TripsContainer & {
  __typename?: "TripsCarouselContainer";
  /** Used for accessibility. */
  accessibility?: Maybe<AccessibilityData>;
  elements: Array<TripsComposableElement>;
  heading?: Maybe<Scalars["String"]>;
};

/** Action describing the user interaction on an element should lead the customer to submitting updated item dates from the date picker */
export type TripsChangeItemDatesAction = TripsAction & {
  __typename?: "TripsChangeItemDatesAction";
  analytics: ClientSideAnalytics;
  item: TripItem;
  tripEntity: TripEntity;
};

/** Action describing the user interaction on an element should lead the customer to closing a dialog */
export type TripsCloseDialogAction = TripsAction & {
  __typename?: "TripsCloseDialogAction";
  analytics: ClientSideAnalytics;
};

/** Represents a button used for closing a dialog. */
export type TripsCloseDialogButton = {
  __typename?: "TripsCloseDialogButton";
  accessibility?: Maybe<AccessibilityData>;
  action?: Maybe<TripsCloseDialogAction>;
  icon?: Maybe<Icon>;
  primary?: Maybe<Scalars["String"]>;
};

/** Basic Drawer implementation */
export type TripsComposableDrawer = TripsDrawer & {
  __typename?: "TripsComposableDrawer";
  elements: Array<TripsComposableElement>;
  /** @deprecated header has been deprecated in favour of tripsViewHeader */
  header?: Maybe<TripsDrawerHeader>;
  impressionTracking?: Maybe<ClientSideImpressionAnalytics>;
  tripsViewHeader?: Maybe<TripsViewHeader>;
};

/** A trips composable element is a markup union type used to mark that an element (card or container) can be grouped in the same list. For example a `TripsSectionContainer` can contain both cards and other containers. */
export type TripsComposableElement =
  | TripsAvatarGroup
  | TripsCarouselContainer
  | TripsContentCard
  | TripsEmbeddedContentCard
  | TripsFittedImageCard
  | TripsFlexContainer
  | TripsFlightPathMapCard
  | TripsForm
  | TripsFormContainer
  | TripsFullBleedImageCard
  | TripsIllustrationCard
  | TripsImageSlimCard
  | TripsImageTopCard
  | TripsMapCard
  | TripsMediaGallery
  | TripsPageBreak
  | TripsPricePresentation
  | TripsPrimaryButton
  | TripsSecondaryButton
  | TripsSectionContainer
  | TripsSlimCard
  | TripsTertiaryButton
  | TripsValidatedInput;

/** Simple interface marking that all containers can group other containers and simple element such as cards. */
export interface TripsContainer {
  elements: Array<TripsComposableElement>;
}

/** Represents a generic base of any type of content. */
export interface TripsContent {
  /** A primary is mapped to a content sub-section heading */
  primary?: Maybe<Scalars["String"]>;
  /** Secondaries are mapped to content sub-sub-section headings */
  secondaries?: Maybe<Array<Scalars["String"]>>;
}

/** Used to represent textual content. Content can be formed combining with elements like paragraphs, lists etc. */
export type TripsContentCard = TripsCard & {
  __typename?: "TripsContentCard";
  impressionTracking?: Maybe<ClientSideImpressionAnalytics>;
  primary?: Maybe<Scalars["String"]>;
  rows: Array<TripsContent>;
  /** @deprecated Do not request, will always be null. */
  secondaries?: Maybe<Array<Scalars["String"]>>;
};

/** Used when content needs to be aligned horizontally */
export type TripsContentColumns = TripsContent & {
  __typename?: "TripsContentColumns";
  columns: Array<TripsContent>;
  primary?: Maybe<Scalars["String"]>;
  secondaries?: Maybe<Array<Scalars["String"]>>;
};

export type TripsContentInlineLinkItem = {
  __typename?: "TripsContentInlineLinkItem";
  items: Array<TripsContentItem>;
};

export type TripsContentItem = TripsContentInlineLinkItem | TripsContentLinkItem | TripsContentTextItem;

export type TripsContentLinkItem = {
  __typename?: "TripsContentLinkItem";
  /**
   * @deprecated `action` of type TripsLinkAction has been deprecated. Use `linkAction` instead.
   *          TripContentLinkItem now supports any action conforming to TripsAction.
   */
  action: TripsLinkAction;
  icon?: Maybe<Icon>;
  linkAction: TripsAction;
  linkText: Scalars["String"];
};

/** Represents a list of textual content. Content can be paragraphs, ordered lists, or unordered lists. */
export type TripsContentList = TripsContent & {
  __typename?: "TripsContentList";
  items?: Maybe<Array<TripsViewContentLineItem>>;
  primary?: Maybe<Scalars["String"]>;
  secondaries?: Maybe<Array<Scalars["String"]>>;
  theme: TripsContentTheme;
};

export type TripsContentOrderedList = TripsContent & {
  __typename?: "TripsContentOrderedList";
  items?: Maybe<Array<TripsContentItem>>;
  primary?: Maybe<Scalars["String"]>;
  secondaries?: Maybe<Array<Scalars["String"]>>;
};

export type TripsContentParagraph = TripsContent & {
  __typename?: "TripsContentParagraph";
  items?: Maybe<Array<TripsContentItem>>;
  primary?: Maybe<Scalars["String"]>;
  secondaries?: Maybe<Array<Scalars["String"]>>;
};

export type TripsContentTextItem = {
  __typename?: "TripsContentTextItem";
  action?: Maybe<TripsAction>;
  icon?: Maybe<Icon>;
  primary?: Maybe<Scalars["String"]>;
};

/** Display theme for trips content */
export type TripsContentTheme =
  /** The Unordered List should be displayed with bullets */
  | "BULLETS"
  /** The Unordered List should be displayed with no bullets */
  | "NO_BULLETS"
  /** The ordered list should always be displayed with numbers */
  | "ORDERED"
  /** Paragraph type list */
  | "PARAGRAPH";

export type TripsContentType = "PDF";

export type TripsContentUnorderedList = TripsContent & {
  __typename?: "TripsContentUnorderedList";
  items?: Maybe<Array<TripsContentItem>>;
  primary?: Maybe<Scalars["String"]>;
  secondaries?: Maybe<Array<Scalars["String"]>>;
  theme?: Maybe<TripsContentUnorderedListTheme>;
};

export type TripsContentUnorderedListTheme =
  /** The Unordered List should be displayed with bullets */
  | "BULLETS"
  /** The Unordered List should be displayed with no bullets */
  | "NO_BULLETS";

export type TripsCreateEmptyTrip = {
  __typename?: "TripsCreateEmptyTrip";
  metadata?: Maybe<TripCreationMetadata>;
};

/** Action describing the user interaction on an element should lead the customer to a trips drawer for creating a trip. */
export type TripsCreateNewTripAction = TripsAction & {
  __typename?: "TripsCreateNewTripAction";
  analytics: ClientSideAnalytics;
  itemId: Scalars["String"];
};

export type TripsCreateTripFromItem = {
  __typename?: "TripsCreateTripFromItem";
  input: TripsPlan;
};

/** DEPRECATED - will be removed soon */
export type TripsCreateTripFromItemAction = TripsAction &
  TripsFormSubmitAction & {
    __typename?: "TripsCreateTripFromItemAction";
    analytics: ClientSideAnalytics;
    inputIds: Array<Scalars["String"]>;
    /** @deprecated itemId has been deprecated., replace with saveItemInput.itemId */
    itemId: Scalars["String"];
    saveItemInput?: Maybe<TripsPlan>;
  };

export type TripsCreateTripFromMovedItem = {
  __typename?: "TripsCreateTripFromMovedItem";
  item: TripItem;
};

/**
 * Optional context to be passed to the `customer.notifications` query.
 * This object should be mapped to `CustomerNotificationOptionalContextInput` in the client.
 */
export type TripsCustomerNotificationOptionalContext = {
  __typename?: "TripsCustomerNotificationOptionalContext";
  itineraryNumber?: Maybe<Scalars["String"]>;
  journeyCriterias?: Maybe<Array<TripsCustomerNotificationOptionalContextJourneyCriteria>>;
  regionId?: Maybe<Scalars["String"]>;
  regionIds?: Maybe<Array<Scalars["String"]>>;
  tripId?: Maybe<Scalars["String"]>;
  tripItemId?: Maybe<Scalars["String"]>;
};

/** JourneyCriteria for customer notification optional context to be passed to the `customer.notifications` query. */
export type TripsCustomerNotificationOptionalContextJourneyCriteria = {
  __typename?: "TripsCustomerNotificationOptionalContextJourneyCriteria";
  dateRange?: Maybe<DateRange>;
  destination?: Maybe<TripsCustomerNotificationOptionalContextJourneyCriteriaLocation>;
  origin?: Maybe<TripsCustomerNotificationOptionalContextJourneyCriteriaLocation>;
  tripScheduleChangeStatus?: Maybe<TripsCustomerNotificationTripScheduleChangeStatus>;
};

/** Location for JourneyCriteria of customer notification optional context to be passed to the `customer.notifications` query. */
export type TripsCustomerNotificationOptionalContextJourneyCriteriaLocation = {
  __typename?: "TripsCustomerNotificationOptionalContextJourneyCriteriaLocation";
  airportTLA?: Maybe<Scalars["String"]>;
  propertyId?: Maybe<Scalars["String"]>;
  regionId?: Maybe<Scalars["String"]>;
};

/** Parameters to be passed to the `customer.notifications` query */
export type TripsCustomerNotificationQueryParameters = {
  __typename?: "TripsCustomerNotificationQueryParameters";
  /** The funnelLocation String will map to one of the `FunnelLocation` enum types in the customer.notifications input. */
  funnelLocation?: Maybe<Scalars["String"]>;
  /** The lineOfBusiness String will map to one of the `ExpLineOfBusiness` enum types in customer.notifications input */
  lineOfBusiness?: Maybe<Scalars["String"]>;
  /** The notificationLocation String will map to one of the `NotificationLocation` enum types in customer.notifications input */
  notificationLocation?: Maybe<Scalars["String"]>;
  optionalContext?: Maybe<TripsCustomerNotificationOptionalContext>;
  xPageID?: Maybe<Scalars["String"]>;
};

export type TripsCustomerNotificationTripScheduleChangeStatus = "FLIGHT_SCHEDULE_CHANGE" | "NO_CHANGE";

/** Analytics for interactions on the date picker */
export type TripsDatePickerAnalytics = {
  __typename?: "TripsDatePickerAnalytics";
  closeAnalytics: ClientSideAnalytics;
  nextPageAnalytics: ClientSideAnalytics;
  previousPageAnalytics: ClientSideAnalytics;
};

/** Attributes required to display a date picker */
export type TripsDatePickerAttributes = {
  __typename?: "TripsDatePickerAttributes";
  analytics: TripsDatePickerAnalytics;
  buttonText: Scalars["String"];
  calendarSelectionType: TripsCalendarSelectionType;
  changeDatesAction: TripsChangeItemDatesAction;
  daysBookableInAdvance: Scalars["Int"];
  itemDates: DateRange;
  maxDateRange: Scalars["Int"];
  midnightBookingOffset?: Maybe<Scalars["Int"]>;
  minDateRange: Scalars["Int"];
  tripEntity: TripEntity;
};

export type TripsDeleteTripAction = TripsAction & {
  __typename?: "TripsDeleteTripAction";
  analytics: ClientSideAnalytics;
  overview: TripOverview;
};

export interface TripsDialog {
  body: Array<TripsContent>;
  heading?: Maybe<Scalars["String"]>;
}

/** Represents layout of buttons on a modal dialog */
export type TripsDialogButtonLayout =
  /** Dialog with horizontally stacked buttons */
  | "INLINE"
  /** Dialog with vertically stacked buttons */
  | "STACKED";

/** Action describing the user interaction on an element should lead the customer to dismiss a component */
export type TripsDismissAction = TripsAction & {
  __typename?: "TripsDismissAction";
  analytics: ClientSideAnalytics;
};

/** Action describing the user interaction on an element should lead the customer to closing a drawer. */
export type TripsDismissDrawerAction = TripsAction & {
  __typename?: "TripsDismissDrawerAction";
  analytics: ClientSideAnalytics;
};

export type TripsDisplayMode = "DEFAULT" | "MODAL";

/** Wrapping type for drawers */
export interface TripsDrawer {
  elements: Array<TripsComposableElement>;
  header?: Maybe<TripsDrawerHeader>;
  impressionTracking?: Maybe<ClientSideImpressionAnalytics>;
}

/** Heading for a trips drawer */
export type TripsDrawerHeader = {
  __typename?: "TripsDrawerHeader";
  action?: Maybe<TripsTertiaryButton>;
  primary?: Maybe<Scalars["String"]>;
  secondaries?: Maybe<Array<Scalars["String"]>>;
};

/** Used to represent textual content to be used in dialogs. Content can be formed combining with elements like paragraphs, lists etc. */
export type TripsEmbeddedContentCard = TripsCard &
  TripsFlexContainerItem & {
    __typename?: "TripsEmbeddedContentCard";
    grow?: Maybe<Scalars["Float"]>;
    impressionTracking?: Maybe<ClientSideImpressionAnalytics>;
    items: Array<TripsEmbeddedContentList>;
    primary?: Maybe<Scalars["String"]>;
  };

/** An element which can be a simple text, link or combine both alongside the icon. */
export type TripsEmbeddedContentItem = TripsSignalListener & {
  __typename?: "TripsEmbeddedContentItem";
  action?: Maybe<TripsLinkAction>;
  icon?: Maybe<Icon>;
  primary?: Maybe<Scalars["String"]>;
  signal?: Maybe<TripsSignal>;
};

/** An element which houses the content items that allows for item positioning by list order. */
export type TripsEmbeddedContentLineItem = {
  __typename?: "TripsEmbeddedContentLineItem";
  items: Array<TripsEmbeddedContentItem>;
};

/** Represents a list of textual content. Content can be paragraphs, ordered lists, or unordered lists. */
export type TripsEmbeddedContentList = TripsContent & {
  __typename?: "TripsEmbeddedContentList";
  items?: Maybe<Array<TripsEmbeddedContentLineItem>>;
  primary?: Maybe<Scalars["String"]>;
  secondaries?: Maybe<Array<Scalars["String"]>>;
  theme: TripsContentTheme;
};

/** Trips Emblems that consists either of a Mark or Badge */
export type TripsEmblem =
  | EgdsBadgeNotification
  | EgdsLoyaltyBadge
  | EgdsProgramBadge
  | EgdsStandardBadge
  | Mark
  | TripsBadge;

/** Trips Emblems to be displayed inline in order */
export type TripsEmblemsInlineContent = TripsContent & {
  __typename?: "TripsEmblemsInlineContent";
  emblems: Array<TripsEmblem>;
  primary?: Maybe<Scalars["String"]>;
  secondaries?: Maybe<Array<Scalars["String"]>>;
};

/** Emitting signals are action events that will send a value to all registered signals that match. */
export type TripsEmitSignal = {
  __typename?: "TripsEmitSignal";
  signal: TripsSignal;
  values: Array<TripsSignalPair>;
};

/**
 * The `TripsFilterInput` contains a filter identifier.
 * The set of supported filter identifiers is defined by the Trips Graph Service and may represent a simple filter like Upcoming or Past or an arbitrarily complex filter defined by an ML algorithm.
 * See the Trips Graph team for a list of reserved values.
 */
export type TripsFilter = {
  __typename?: "TripsFilter";
  filter: Scalars["String"];
};

/**
 * The `TripsFilterInput` contains a filter identifier.
 * The set of supported filter identifiers is defined by the Trips Graph Service and may represent a simple filter like Upcoming or Past or an arbitrarily complex filter defined by an ML algorithm.
 * See the Trips Graph team for a list of reserved values.
 */
export interface TripsFilterInput {
  filter: Scalars["String"];
}

export type TripsFindItineraryNumberView = "FIND_ITINERARY_OTHER_EMAIL" | "FIND_ITINERARY_USER_EMAIL" | "RESULT";

/** Card used to display a fitted EGDS Image. */
export type TripsFittedImageCard = TripsCard & {
  __typename?: "TripsFittedImageCard";
  accessibility?: Maybe<AccessibilityData>;
  image: Image;
  imageType?: Maybe<TripsFittedImageType>;
  impressionTracking?: Maybe<ClientSideImpressionAnalytics>;
  primary?: Maybe<Scalars["String"]>;
  secondaries?: Maybe<Array<Scalars["String"]>>;
};

/** This enum is to indicate what type of image is being placed into TripsFittedImageCard. UitkLayoutGrid would apply onto BARCODE */
export type TripsFittedImageType = "BARCODE" | "E_FRANKING_STAMP" | "QR_CODE";

/**
 * A subset of the CSS Flexbox spec encapsulated within a component.
 * Flex container will layout all flex items along a line (the flex axis) which can wrap across multiple lines if needed.
 * Items on multiple lines are laid out independently of one another. Use when there is no need to align items both horizontally and vertically.
 */
export type TripsFlexContainer = {
  __typename?: "TripsFlexContainer";
  alignItems: FlexAlignItems;
  direction: FlexDirection;
  elements: Array<TripsFlexContainerItem>;
  justifyContent: FlexJustifyContent;
  wrap: FlexWrap;
};

/** An element that has a common behavior as a flex item contained in a flex container. */
export interface TripsFlexContainerItem {
  /** The attribute determines how much this child will grow if positive free space is distributed relative to the rest of other flex items included in the same flex line. */
  grow?: Maybe<Scalars["Float"]>;
}

export type TripsFlightPath = {
  __typename?: "TripsFlightPath";
  coordinates: Array<Coordinates>;
};

/**
 * Used to display a static map image with a pinned airport locations at co-ordinates provided in the `data` field.
 *     Usually, the `action` for this card will be null.
 */
export type TripsFlightPathMapCard = TripsCard & {
  __typename?: "TripsFlightPathMapCard";
  /** Used for accessibility. */
  accessibility?: Maybe<AccessibilityData>;
  action?: Maybe<TripsAction>;
  data: TripsFlightPathMapData;
  image?: Maybe<Image>;
  impressionTracking?: Maybe<ClientSideImpressionAnalytics>;
  primary?: Maybe<Scalars["String"]>;
  secondaries?: Maybe<Array<Scalars["String"]>>;
};

export type TripsFlightPathMapData = {
  __typename?: "TripsFlightPathMapData";
  paths: Array<TripsFlightPath>;
};

/** Use this button for a floating icon style. */
export type TripsFloatingActionButton = {
  __typename?: "TripsFloatingActionButton";
  action?: Maybe<TripsAction>;
  disabled: Scalars["Boolean"];
  icon?: Maybe<Icon>;
  primary?: Maybe<Scalars["String"]>;
};

/** Drawer with a floating button */
export type TripsFloatingActionDrawer = TripsDrawer & {
  __typename?: "TripsFloatingActionDrawer";
  elements: Array<TripsComposableElement>;
  floatingButton?: Maybe<TripsFloatingButton>;
  header?: Maybe<TripsDrawerHeader>;
  impressionTracking?: Maybe<ClientSideImpressionAnalytics>;
};

/** Use this button for a floating button with a scrim. */
export type TripsFloatingButton = {
  __typename?: "TripsFloatingButton";
  accessibility?: Maybe<AccessibilityData>;
  action?: Maybe<TripsAction>;
  disabled: Scalars["Boolean"];
  icon?: Maybe<Icon>;
  primary?: Maybe<Scalars["String"]>;
};

/** A menu shows a list of items which perform an action on interaction, this one is appears floating near the component that opened it */
export type TripsFloatingMenu = TripsMenu & {
  __typename?: "TripsFloatingMenu";
  impressionTracking?: Maybe<ClientSideImpressionAnalytics>;
  items: Array<TripsMenuItem>;
  menuItems: Array<TripsMenuItem>;
  menuTitle?: Maybe<Scalars["String"]>;
};

export type TripsForm = {
  __typename?: "TripsForm";
  elements: Array<TripsFormElement>;
};

/** An action that is used to submit form */
export type TripsFormAction = TripsAction & {
  __typename?: "TripsFormAction";
  analytics: ClientSideAnalytics;
  formData?: Maybe<TripsFormData>;
  type: TripsFormType;
  validatedInputIds: Array<Scalars["String"]>;
};

/** Base object for forms, will most likely be replaced by EGDSForms when/if it has been implemented */
export type TripsFormContainer = TripsContainer & {
  __typename?: "TripsFormContainer";
  elements: Array<TripsComposableElement>;
  formTheme?: Maybe<TripsFormContainerTheme>;
};

/** This enum is to indicate whether the form container should have padding or it should fit right inside the parent component */
export type TripsFormContainerTheme = "MATCH_PARENT" | "WRAP_CONTENT";

export type TripsFormData =
  | TripsCreateEmptyTrip
  | TripsCreateTripFromItem
  | TripsCreateTripFromMovedItem
  | TripsInvite
  | TripsSendItineraryEmail
  | TripsUpdateTrip;

export type TripsFormElement = TripsContentTextItem | TripsPrimaryButton | TripsSecondaryButton | TripsValidatedInput;

/** DEPRECATED - will be removed */
export interface TripsFormSubmitAction {
  inputIds: Array<Scalars["String"]>;
}

export type TripsFormType =
  | "CREATE_NEW_TRIP_FROM_ITEM"
  | "FIND_ITINERARY_NUMBER"
  | "INVITE"
  | "SAVE_NEW_TRIP"
  | "SEARCH_BOOKING"
  | "SEND_ITINERARY_EMAIL"
  | "UPDATE_TRIP";

/** Used to display a large image with a few pieces of text information like when listing upcoming trips */
export type TripsFullBleedImageCard = TripsCard & {
  __typename?: "TripsFullBleedImageCard";
  /** Used for accessibility. */
  accessibility?: Maybe<AccessibilityData>;
  action?: Maybe<TripsAction>;
  background?: Maybe<Image>;
  badgeList?: Maybe<Array<EgdsBadge>>;
  /** @deprecated TripsBadge field has been deprecated. Rather use new EGDS Badges., replace with badgeList */
  badges?: Maybe<Array<TripsBadge>>;
  icons?: Maybe<Array<Icon>>;
  impressionTracking?: Maybe<ClientSideImpressionAnalytics>;
  primary?: Maybe<Scalars["String"]>;
  secondaries?: Maybe<Array<Scalars["String"]>>;
};

/** Represents a full screen dialog */
export type TripsFullScreenDialog = {
  __typename?: "TripsFullScreenDialog";
  closeButton?: Maybe<TripsCloseDialogButton>;
  content?: Maybe<Array<TripsEmbeddedContentCard>>;
  heading?: Maybe<Scalars["String"]>;
};

/** Represents an icon which can have an associated label and/or action */
export type TripsIcon = {
  __typename?: "TripsIcon";
  action?: Maybe<TripsAction>;
  icon?: Maybe<Icon>;
  label?: Maybe<Scalars["String"]>;
};

/** Represents a TripsIcon that can be used as a toggle, to display various TripsIcon depending on its state */
export type TripsIconToggle = TripsSignalListener & {
  __typename?: "TripsIconToggle";
  disabledIcon?: Maybe<TripsIcon>;
  enabledIcon?: Maybe<TripsIcon>;
  initialStatus: TripsToggleStatus;
  signal?: Maybe<TripsSignal>;
};

/** Card often used on empty or error state views to show an Illustration Image with a message for the Customer. */
export type TripsIllustrationCard = TripsCard & {
  __typename?: "TripsIllustrationCard";
  illustration?: Maybe<Illustration>;
  impressionTracking?: Maybe<ClientSideImpressionAnalytics>;
  primary?: Maybe<Scalars["String"]>;
  secondaries?: Maybe<Array<Scalars["String"]>>;
};

/**
 * An image slim card contains an image for the product is mostly used to highlight some information like a saved or booked product.
 * The card can be associated with actions to open a subsequent view such as a menu.
 */
export type TripsImageSlimCard = TripsCard &
  TripsSignalListener & {
    __typename?: "TripsImageSlimCard";
    accessibility?: Maybe<AccessibilityData>;
    badgeList?: Maybe<Array<EgdsBadge>>;
    /** @deprecated TripsBadge field has been deprecated. Rather use new EGDS Badges., replace with badgeList */
    badges?: Maybe<Array<TripsBadge>>;
    cardIcon?: Maybe<TripsIcon>;
    /** @deprecated TripsImageSlimCard icon field has been deprecated. Rather use action associated with cardIcon., replace with cardIcon */
    icon?: Maybe<Icon>;
    impressionTracking?: Maybe<ClientSideImpressionAnalytics>;
    /** Contains the necessary data to fetch price information (including live price) for a trip item. */
    itemPricePrimer?: Maybe<TripsItemPricePrimer>;
    /** Actionable TripsIcon toggle used to display price insight alerting status */
    priceAlertToggle?: Maybe<TripsIconToggle>;
    primary?: Maybe<Scalars["String"]>;
    /** Action associated with card click/tap */
    primaryAction?: Maybe<TripsAction>;
    secondaries?: Maybe<Array<Scalars["String"]>>;
    /** Action which can be associated with thumbnail(image), and primary + secondaries text click/tap */
    secondaryAction?: Maybe<TripsAction>;
    signal?: Maybe<TripsSignal>;
    state?: Maybe<TripsCardState>;
    thumbnail?: Maybe<Image>;
  };

/** Card often used in combination with `TripCarousel` to bring a concise view for a product like a hotel. */
export type TripsImageTopCard = TripsCard & {
  __typename?: "TripsImageTopCard";
  /** Used for accessibility. */
  accessibility?: Maybe<AccessibilityData>;
  action?: Maybe<TripsAction>;
  background?: Maybe<Image>;
  impressionTracking?: Maybe<ClientSideImpressionAnalytics>;
  primary?: Maybe<Scalars["String"]>;
  secondaries?: Maybe<Array<Scalars["String"]>>;
};

/** Trips Toast when you have only have text to display */
export type TripsInfoToast = TripsToast & {
  __typename?: "TripsInfoToast";
  impressionTracking?: Maybe<ClientSideImpressionAnalytics>;
  primary: Scalars["String"];
};

/**
 * Trips Toast when you have text and button inline.
 * Actionable toast is behind a feature gate: https://egtnl.prod.expedia.com/experiment/43510
 */
export type TripsInlineActionToast = TripsToast & {
  __typename?: "TripsInlineActionToast";
  button: TripsButton;
  impressionTracking?: Maybe<ClientSideImpressionAnalytics>;
  primary: Scalars["String"];
};

export type TripsInlinedActionsDialog = TripsDialog & {
  __typename?: "TripsInlinedActionsDialog";
  body: Array<TripsContent>;
  buttons: Array<TripsButton>;
  heading?: Maybe<Scalars["String"]>;
};

/** Drawer with horizontally stacked buttons */
export type TripsInlinedActionsDrawer = TripsDrawer & {
  __typename?: "TripsInlinedActionsDrawer";
  buttons: Array<TripsButton>;
  elements: Array<TripsComposableElement>;
  header?: Maybe<TripsDrawerHeader>;
  impressionTracking?: Maybe<ClientSideImpressionAnalytics>;
};

/** Enum to represent the number of lines that the text field supports. Defaulted to one line (single) if no changes are made. */
export type TripsInputType = "MULTIPLE" | "SINGLE";

export type TripsInvite = {
  __typename?: "TripsInvite";
  overview: TripOverview;
};

/** Action describing the user interaction on an element that should allow the traveler to accept an invite to join a trip. */
export type TripsInviteAcceptAction = TripsAction & {
  __typename?: "TripsInviteAcceptAction";
  analytics: ClientSideAnalytics;
  inviteId: Scalars["String"];
};

/** DEPRECATED - will be removed soon */
export type TripsInviteAction = TripsAction &
  TripsFormSubmitAction & {
    __typename?: "TripsInviteAction";
    analytics: ClientSideAnalytics;
    inputIds: Array<Scalars["String"]>;
    overview: TripOverview;
  };

/** Contains the necessary data for calling all of the queries to get pricing information for a trip item. */
export type TripsItemPricePrimer = TripsSavedItemPricePrimer;

/** Used to describe a URI based link. The `target` specifies whether to open the link in the same user interface context or in a different context. */
export type TripsLinkAction = TripsAction & {
  __typename?: "TripsLinkAction";
  analytics: ClientSideAnalytics;
  clickstreamAnalytics?: Maybe<ClickstreamAnalytics>;
  resource: Uri;
  target: TripsLinkTarget;
};

export type TripsLinkTarget = "EXTERNAL" | "INTERNAL";

export type TripsLoaderDialog = TripsDialog & {
  __typename?: "TripsLoaderDialog";
  body: Array<TripsContent>;
  heading?: Maybe<Scalars["String"]>;
};

/** Contains enough data to render a map and markers with information, */
export type TripsMap = {
  __typename?: "TripsMap";
  bounds?: Maybe<TripsMapBounds>;
  locale: Scalars["String"];
  /** The mapData contains center co-ordinates, bounds and zoom data as info for rendering a map. */
  mapCenter: TripsMapCenter;
  markers: Array<TripsMapMarker>;
  paths: Array<TripsFlightPathMapData>;
};

/** Action describing the user interaction on an element should open a map at the co-ordinates provided in `data` field. */
export type TripsMapAction = TripsAction & {
  __typename?: "TripsMapAction";
  analytics: ClientSideAnalytics;
  data: TripsMapData;
};

/** The nw and se corners of the map */
export type TripsMapBounds = {
  __typename?: "TripsMapBounds";
  ne: Coordinates;
  sw: Coordinates;
};

/**
 * Used to display a static map image with a pinned center location at co-ordinates provided in the `data` field.
 *     Usually, the `action` for this card will be a `TripsMapAction` which will open a map at the same co-ordinates.
 */
export type TripsMapCard = TripsCard & {
  __typename?: "TripsMapCard";
  /** Used for accessibility. */
  accessibility?: Maybe<AccessibilityData>;
  action?: Maybe<TripsAction>;
  data: TripsMapData;
  image?: Maybe<Image>;
  impressionTracking?: Maybe<ClientSideImpressionAnalytics>;
  primary?: Maybe<Scalars["String"]>;
  secondaries?: Maybe<Array<Scalars["String"]>>;
};

/** The center point and zoom of the map */
export type TripsMapCenter = {
  __typename?: "TripsMapCenter";
  center: Coordinates;
  zoom?: Maybe<Scalars["Int"]>;
};

/** The `TripsMapData` contains center co-ordinates and zoom data as info for rendering a map. */
export type TripsMapData = {
  __typename?: "TripsMapData";
  center: Coordinates;
  zoom: Scalars["Int"];
};

/** Action describing the user interaction on an element should open a map to get directions to the co-ordinates provided in `data` field. */
export type TripsMapDirectionsAction = TripsAction & {
  __typename?: "TripsMapDirectionsAction";
  analytics: ClientSideAnalytics;
  data: TripsMapData;
  url: Scalars["URL"];
};

/** Information about a location that needs to be rendered on the map */
export type TripsMapMarker = {
  __typename?: "TripsMapMarker";
  /** Analytics information for the trips map marker */
  analytics?: Maybe<ClientSideAnalytics>;
  /** Summary information for the marker */
  content?: Maybe<TripsMarkerContent>;
  /** The coordinates used to determine the marker placement */
  coordinates: Coordinates;
  /** The localized label to display on the marker */
  label: Scalars["String"];
  /** The type of map marker, Airport, Hotel, Place etc */
  type?: Maybe<TripsMarkerType>;
};

/** Information to show on the map or in a component when marker is in view or selected */
export type TripsMarkerContent = {
  __typename?: "TripsMarkerContent";
  /** Description of the place or point at the marker */
  description?: Maybe<Scalars["String"]>;
  /** Image of or near the marker */
  image?: Maybe<Image>;
  /** Localised primary text for the marker */
  primary: Scalars["String"];
};

/** The type of map marker */
export type TripsMarkerType =
  | "ActivityEventMarker"
  | "ActivityGuestPickupMarker"
  | "ActivityLocationMarker"
  | "ActivityRedemptionMarker"
  | "AirportMarker"
  | "CarMarker"
  | "CruiseMarker"
  | "HotelMarker"
  | "PlaceMarker";

/** TripsMedia provide media item and associated accessiblity data id available */
export type TripsMedia = MediaItem & {
  __typename?: "TripsMedia";
  accessibilityData?: Maybe<AccessibilityData>;
  media: Media;
};

/** A Gallery returns a list of TripsMedia */
export type TripsMediaGallery = EgdsElement &
  EgdsGalleryCarousel & {
    __typename?: "TripsMediaGallery";
    /** Accessibility text for the carousel */
    accessibilityHeadingText: Scalars["String"];
    /** Analytics data which can be used on click of any image of carousel to open full screen gallery dialog */
    analytics?: Maybe<ClientSideAnalytics>;
    /** Unique identifier for the carousel */
    egdsElementId?: Maybe<Scalars["String"]>;
    /** List of media including images or videos in the carousel */
    media: Array<TripsMedia>;
    /** Toolbar for the fullscreen images of a property */
    mediaGalleryDialogToolbar: TripsToolbar;
    /** Accessibility text for next button on a carousel */
    nextButtonText?: Maybe<Scalars["String"]>;
    /** Accessibility text for previous button on a carousel */
    previousButtonText?: Maybe<Scalars["String"]>;
  };

/** A menu shows a list of items which perform an action on interaction */
export interface TripsMenu {
  impressionTracking?: Maybe<ClientSideImpressionAnalytics>;
  items: Array<TripsMenuItem>;
  /** @deprecated TripsMenu menuItems field has been deprecated. Rather use items., replace with items */
  menuItems: Array<TripsMenuItem>;
  /**
   * Optional title which summarizes the contents of the menu
   * @deprecated TripsMenu menuTitle field has been deprecated. See TripsMenuTitle as a menu item., replace with TripsMenuTitle
   */
  menuTitle?: Maybe<Scalars["String"]>;
}

export interface TripsMenuItem {
  primary: Scalars["String"];
  /** @deprecated TripsMenuItem text field has been deprecated., replace with primary */
  text: Scalars["String"];
}

/** A menu item that can be used as a toggle, to display various content depending on its state */
export type TripsMenuItemToggle = TripsMenuItem &
  TripsSignalListener & {
    __typename?: "TripsMenuItemToggle";
    disabledMenuItem?: Maybe<TripsMenuListItem>;
    enabledMenuItem?: Maybe<TripsMenuListItem>;
    initialStatus: TripsToggleStatus;
    /** Use `enabledMenuItem` or `disabledMenuItem`'s primary field instead. */
    primary: Scalars["String"];
    signal?: Maybe<TripsSignal>;
    text: Scalars["String"];
  };

/** An item in the menu */
export type TripsMenuListItem = TripsMenuItem & {
  __typename?: "TripsMenuListItem";
  accessibility: AccessibilityData;
  action: TripsAction;
  icon?: Maybe<Icon>;
  paymentType?: Maybe<Mark>;
  primary: Scalars["String"];
  text: Scalars["String"];
};

/** Use MenuListTitle to organize sections within the menu if there are multiple unique groups */
export type TripsMenuListTitle = TripsMenuItem & {
  __typename?: "TripsMenuListTitle";
  primary: Scalars["String"];
  text: Scalars["String"];
};

/** Optional title which summarizes the contents of the menu */
export type TripsMenuTitle = TripsMenuItem & {
  __typename?: "TripsMenuTitle";
  primary: Scalars["String"];
  text: Scalars["String"];
};

/** Represents a modal dialog */
export type TripsModalDialog = {
  __typename?: "TripsModalDialog";
  buttonLayout: TripsDialogButtonLayout;
  buttons?: Maybe<Array<TripsButton>>;
  content?: Maybe<Array<TripsEmbeddedContentList>>;
  heading?: Maybe<Scalars["String"]>;
};

/** Action describing the user interaction on an element triggering a trip item to move to another trip. */
export type TripsMoveItemToTripAction = TripsAction & {
  __typename?: "TripsMoveItemToTripAction";
  analytics: ClientSideAnalytics;
  data: TripsMoveTripItemData;
};

/** Describes the data required to move a trip item to another trip */
export type TripsMoveTripItemData = {
  __typename?: "TripsMoveTripItemData";
  item: TripItem;
  toTripId?: Maybe<Scalars["String"]>;
  toTripName?: Maybe<Scalars["String"]>;
};

/** Represents a response to a failed trips mutation with an action */
export type TripsMutationActionFailureResponse = TripsMutationActionResponse & {
  __typename?: "TripsMutationActionFailureResponse";
  action: TripsAction;
};

/** Represents a response to a trips mutation with an action */
export interface TripsMutationActionResponse {
  action: TripsAction;
}

/** Represents a response to a successful trips mutation with an action */
export type TripsMutationActionSuccessResponse = TripsMutationActionResponse & {
  __typename?: "TripsMutationActionSuccessResponse";
  action: TripsAction;
};

/** Wrapping type for trips mutation responses */
export type TripsMutationResponse =
  | TripsMutationActionFailureResponse
  | TripsMutationActionSuccessResponse
  | TripsMutationToastFailureResponse
  | TripsMutationToastSuccessResponse;

/** Represents a response to a failed trips mutation with a toast */
export type TripsMutationToastFailureResponse = TripsMutationToastResponse & {
  __typename?: "TripsMutationToastFailureResponse";
  toast: TripsToast;
};

/** Represents a response to a trips mutation with a toast */
export interface TripsMutationToastResponse {
  toast: TripsToast;
}

/** Represents a response to a successful trips mutation with a toast */
export type TripsMutationToastSuccessResponse = TripsMutationToastResponse & {
  __typename?: "TripsMutationToastSuccessResponse";
  toast: TripsToast;
};

/** DEPRECATED - will be removed */
export type TripsNavigateToFilteredViewAction = TripsAction & {
  __typename?: "TripsNavigateToFilteredViewAction";
  analytics: ClientSideAnalytics;
  filter: TripsFilter;
  url: Scalars["URL"];
};

/** DEPRECATED - will be removed */
export type TripsNavigateToItemDetailsAction = TripsAction & {
  __typename?: "TripsNavigateToItemDetailsAction";
  analytics: ClientSideAnalytics;
  item: TripItem;
  url: Scalars["URL"];
};

/** Deprecated in favour of `TripsNavigateToViewAction` */
export type TripsNavigateToItemPricingAndRewardsAction = TripsAction & {
  __typename?: "TripsNavigateToItemPricingAndRewardsAction";
  analytics: ClientSideAnalytics;
  item: TripItem;
  url: Scalars["URL"];
};

/** DEPRECATED - this action will be removed soon */
export type TripsNavigateToItemReceiptAction = TripsAction & {
  __typename?: "TripsNavigateToItemReceiptAction";
  analytics: ClientSideAnalytics;
  item: TripItem;
  url: Scalars["URL"];
};

/** Deprecated in favour of `TripsNavigateToViewAction` */
export type TripsNavigateToItemVoucherAction = TripsAction & {
  __typename?: "TripsNavigateToItemVoucherAction";
  analytics: ClientSideAnalytics;
  item: TripItem;
  url: Scalars["URL"];
};

/** DEPRECATED - will be removed */
export type TripsNavigateToListViewAction = TripsAction & {
  __typename?: "TripsNavigateToListViewAction";
  analytics: ClientSideAnalytics;
  listViewId: Scalars["String"];
  url: Scalars["URL"];
};

/** DEPRECATED - will be removed soon */
export type TripsNavigateToManageBookingAction = TripsAction & {
  __typename?: "TripsNavigateToManageBookingAction";
  analytics: ClientSideAnalytics;
  item: TripItem;
  url: Scalars["URL"];
};

/** DEPRECATED - will be removed */
export type TripsNavigateToManageTripAction = TripsAction & {
  __typename?: "TripsNavigateToManageTripAction";
  analytics: ClientSideAnalytics;
  tripViewId: Scalars["String"];
  url: Scalars["String"];
};

/** DEPRECATED - will be removed */
export type TripsNavigateToTripOverviewAction = TripsAction & {
  __typename?: "TripsNavigateToTripOverviewAction";
  analytics: ClientSideAnalytics;
  overview: TripOverview;
  url: Scalars["URL"];
};

/** Action describing the user interaction on an element should lead the customer to the view specified by the `viewType` field. */
export type TripsNavigateToViewAction = TripsAction & {
  __typename?: "TripsNavigateToViewAction";
  analytics: ClientSideAnalytics;
  displayMode: TripsDisplayMode;
  essentialInfoItem?: Maybe<EssentialInfoItem>;
  inviteId?: Maybe<Scalars["String"]>;
  tripItemId?: Maybe<Scalars["String"]>;
  tripViewId?: Maybe<Scalars["String"]>;
  updateHistory?: Maybe<UpdateHistory>;
  viewFilter?: Maybe<TripsFilter>;
  viewType: TripsViewType;
  viewUrl?: Maybe<Scalars["URL"]>;
};

/** Shared UI Component for trips.  Displays the customer's upcoming trips. */
export type TripsNavigation = HeaderSharedUi & {
  __typename?: "TripsNavigation";
  skipSsr: Scalars["Boolean"];
};

/** DEPRECATED - this action will be removed soon */
export type TripsOpenBottomSheetAction = TripsAction & {
  __typename?: "TripsOpenBottomSheetAction";
  analytics: ClientSideAnalytics;
  bottomSheet: TripsBottomSheet;
};

/** Action describing the user interaction on an element should lead the customer to opening a date picker to change item dates */
export type TripsOpenChangeDatesDatePickerAction = TripsAction & {
  __typename?: "TripsOpenChangeDatesDatePickerAction";
  analytics: ClientSideAnalytics;
  attributes: TripsDatePickerAttributes;
};

/** Action describing the user interaction on an element should lead the customer to a trips drawer for creating a trip. */
export type TripsOpenCreateNewTripDrawerAction = TripsAction & {
  __typename?: "TripsOpenCreateNewTripDrawerAction";
  analytics: ClientSideAnalytics;
  /** @deprecated Use TripsOpenCreateNewTripDrawerForItemAction instead if you need passing an itemId */
  itemId: Scalars["String"];
};

/** Action describing the user interaction on an element should lead the customer to a trips drawer for creating a trip when saving an item. */
export type TripsOpenCreateNewTripDrawerForItemAction = TripsAction & {
  __typename?: "TripsOpenCreateNewTripDrawerForItemAction";
  analytics: ClientSideAnalytics;
  createTripMetadata?: Maybe<TripCreationMetadata>;
  /** @deprecated itemId has been deprecated., replace with createTripMetadata.saveItemInput.itemId */
  itemId: Scalars["String"];
  /** @deprecated TripCreationEntryPoint has been deprecated and will be removed in future */
  source: TripCreationEntryPoint;
};

/** Action describing the user interaction on an element should lead the customer to a TripsDialog */
export type TripsOpenDialogAction = TripsAction & {
  __typename?: "TripsOpenDialogAction";
  analytics: ClientSideAnalytics;
  /** @deprecated Deprecated in favour of 'modalDialog' */
  dialog: TripsDialog;
  modalDialog?: Maybe<TripsModalDialog>;
};

/** Action describing the user interaction on an element should lead the customer to a view where the trip can be updated */
export type TripsOpenEditTripDrawerAction = TripsAction & {
  __typename?: "TripsOpenEditTripDrawerAction";
  analytics: ClientSideAnalytics;
  overview: TripOverview;
};

/** Action describing the user interaction on an element should lead the customer to a view where the itinerary can be emailed of a trip item */
export type TripsOpenEmailDrawerAction = TripsAction & {
  __typename?: "TripsOpenEmailDrawerAction";
  analytics: ClientSideAnalytics;
  item: TripItem;
};

/** Action describing the user interaction on an element should lead the customer to a full screen dialog containing TripsViewResponse */
export type TripsOpenFullScreenDialogAction = TripsAction & {
  __typename?: "TripsOpenFullScreenDialogAction";
  analytics: ClientSideAnalytics;
  dialog?: Maybe<TripsFullScreenDialog>;
  /** @deprecated Deprecated in favour of 'dialog' */
  view: TripsViewResponse;
};

/** Action describing the user interaction on an element should lead the traveler to a view the form where the user can invite people to a trip. */
export type TripsOpenInviteDrawerAction = TripsAction & {
  __typename?: "TripsOpenInviteDrawerAction";
  analytics: ClientSideAnalytics;
  overview: TripOverview;
};

/**
 * Action when on interaction opens a TripsMenu - either a bottom menu or floating menu.
 * Responsive clients can decide when to show which based on breakpoint
 */
export type TripsOpenMenuAction = TripsAction & {
  __typename?: "TripsOpenMenuAction";
  analytics: ClientSideAnalytics;
  bottomMenu?: Maybe<TripsBottomMenu>;
  floatingMenu?: Maybe<TripsFloatingMenu>;
};

/**
 * Action describing the user interaction on an element leads the customer to a view
 * where the trip item can be moved to another trip.
 */
export type TripsOpenMoveTripItemDrawerAction = TripsAction & {
  __typename?: "TripsOpenMoveTripItemDrawerAction";
  analytics: ClientSideAnalytics;
  item: TripItem;
};

/** Action describing the user interaction on an element should lead the customer to a trips drawer for creating a trip when saving an item. */
export type TripsOpenSaveToTripDrawerAction = TripsAction & {
  __typename?: "TripsOpenSaveToTripDrawerAction";
  analytics: ClientSideAnalytics;
  input: TripsPlan;
};

/** Insert page-break after styling as needed for printable views. */
export type TripsPageBreak = {
  __typename?: "TripsPageBreak";
  /** noop field */
  _empty?: Maybe<Scalars["Boolean"]>;
};

/** Input to the trips.plan query. */
export type TripsPlan = {
  __typename?: "TripsPlan";
  /** Provides LOB specific search context */
  attributes?: Maybe<TripsSaveItemAttributes>;
  /** The id of the item being saved, e.g property id */
  itemId: Scalars["String"];
  /** Provides an entrypoint location from which an item can be saved to a trip */
  pageLocation?: Maybe<PageLocation>;
  /** @deprecated `source` has been deprecated in favour of `pageLocation`. */
  source: TripsPlanSourceType;
};

/** Input to the trips.plan query. */
export interface TripsPlanInput {
  /** Provides LOB specific search context */
  attributes?: InputMaybe<TripsSaveItemAttributesInput>;
  /** The id of the item being saved, e.g property id */
  itemId: Scalars["String"];
  /** Provides an entrypoint location from which an item can be saved to a trip */
  pageLocation?: InputMaybe<PageLocation>;
  source?: InputMaybe<TripsPlanSourceType>;
}

/** The `TripsPlanSourceType` defines a list of supported pages or views from which an item can be saved to a trip. */
export type TripsPlanSourceType =
  | "ACTIVITY_DETAILS"
  | "ACTIVITY_SEARCH"
  | "HOTEL_SEARCH"
  | "LODGING_DETAILS"
  | "LODGING_SEARCH"
  | "TRIP_OVERVIEW";

export type TripsPrefetchOperation = TripsPrefetchTripItemDetails | TripsPrefetchTripOverview;

/** Trips Prefetch Operation to retrieve a trip item's details data. */
export type TripsPrefetchTripItemDetails = {
  __typename?: "TripsPrefetchTripItemDetails";
  item: TripItem;
};

/** Trips Prefetch Operation to retrieve a trip's overview data. */
export type TripsPrefetchTripOverview = {
  __typename?: "TripsPrefetchTripOverview";
  overview: TripOverview;
};

/** Action describing the user interaction on an element that updates price alert status, such as the bell icon or menu item */
export type TripsPriceAlertAction = TripsAction & {
  __typename?: "TripsPriceAlertAction";
  alertStatus: TripsToggleStatus;
  analytics: ClientSideAnalytics;
  emitSignals?: Maybe<Array<TripsEmitSignal>>;
  tripItem: TripItem;
};

/** Used to represent pricing and rewards details` */
export type TripsPricePresentation = {
  __typename?: "TripsPricePresentation";
  pricePresentation?: Maybe<PricePresentation>;
};

/** Use this button to make the primary call to action. Do not use it for different calls to action in the same view. */
export type TripsPrimaryButton = TripsButton &
  TripsFlexContainerItem & {
    __typename?: "TripsPrimaryButton";
    accessibility?: Maybe<AccessibilityData>;
    action?: Maybe<TripsAction>;
    disabled: Scalars["Boolean"];
    grow?: Maybe<Scalars["Float"]>;
    icon?: Maybe<Icon>;
    primary?: Maybe<Scalars["String"]>;
    width: TripsButtonWidth;
  };

/** Wrapping type for recent searches responses */
export type TripsRecentSearchesResponse = TripsRecentSearchesResponseError | TripsRecentSearchesResponseSuccess;

/** Represent an empty response or an unexpected error when fetching user recent searches */
export type TripsRecentSearchesResponseError = {
  __typename?: "TripsRecentSearchesResponseError";
  message: UiEmptyState;
  title?: Maybe<Scalars["String"]>;
};

/** Represents a success response for trips recent searches */
export type TripsRecentSearchesResponseSuccess = {
  __typename?: "TripsRecentSearchesResponseSuccess";
  elements: Array<TripsActionList>;
  heading: Scalars["String"];
};

export type TripsResponseStatus = "FAIL" | "SUCCESS";

/** Action describing the user interaction with an element to try again some operation. */
export type TripsRetryOperationAction = UiAction & {
  __typename?: "TripsRetryOperationAction";
  accessibility?: Maybe<Scalars["String"]>;
  analytics: ClientSideAnalytics;
};

/** Save activity input details */
export type TripsSaveActivityAttributes = {
  __typename?: "TripsSaveActivityAttributes";
  /** Date range representing activity search, if absent the default [today, today+14d] is used */
  dateRange?: Maybe<DateRange>;
  /** The Gaia region ID of the search */
  regionId?: Maybe<Scalars["String"]>;
};

/** Save activity input details */
export interface TripsSaveActivityAttributesInput {
  /** Date range representing activity search, if absent the default [today, today+14d] is used */
  dateRange?: InputMaybe<DateRangeInput>;
  /** The Gaia region ID of the search */
  regionId?: InputMaybe<Scalars["String"]>;
}

/** Provide required values to be able to trigger Trip planning view. */
export type TripsSaveItem = {
  __typename?: "TripsSaveItem";
  /** LOB specific data that will be used when saving an item. */
  attributes?: Maybe<TripsSaveItemAttributes>;
  /** Toggle between a save and remove state on the item. */
  initialChecked: Scalars["Boolean"];
  /** Product item id to be saved. */
  itemId: Scalars["String"];
  /** Data for removing an item from a trip. */
  remove: TripsSaveItemProperties;
  /** Data for saving an item to a trip. */
  save: TripsSaveItemProperties;
  /** Provides an entrypoint location when opening the Trips Drawer via saving an item. */
  source: PageLocation;
};

/** Type grouping all the optional additional information that's required when saving an item. */
export type TripsSaveItemAttributes = TripsSaveActivityAttributes | TripsSaveStayAttributes;

/** Type grouping all the optional additional information that's required when saving an item. */
export interface TripsSaveItemAttributesInput {
  /** Activity input details */
  activityAttributes?: InputMaybe<TripsSaveActivityAttributesInput>;
  /** Stay input details */
  stayAttributes?: InputMaybe<TripsSaveStayAttributesInput>;
}

/** Accessibility and analytics data to be used in the heart icon/action. */
export type TripsSaveItemProperties = {
  __typename?: "TripsSaveItemProperties";
  accessibility?: Maybe<Scalars["String"]>;
  analytics?: Maybe<ClientSideAnalytics>;
  /** A text label to be displayed alongside the favorite component */
  label?: Maybe<Scalars["String"]>;
};

/** Action describing the user interaction on an element should lead the customer to saving an item to the selected trip. */
export type TripsSaveItemToTripAction = TripsAction & {
  __typename?: "TripsSaveItemToTripAction";
  analytics: ClientSideAnalytics;
  /** @deprecated itemId has been deprecated in favour of saveItemInput.itemId */
  itemId: Scalars["String"];
  saveItemInput?: Maybe<TripsPlan>;
  tripId: Scalars["String"];
};

/** DEPRECATED - will be removed soon */
export type TripsSaveNewTripAction = TripsAction &
  TripsFormSubmitAction & {
    __typename?: "TripsSaveNewTripAction";
    analytics: ClientSideAnalytics;
    inputIds: Array<Scalars["String"]>;
    metadata?: Maybe<TripCreationMetadata>;
  };

/** Save stay input details */
export type TripsSaveStayAttributes = {
  __typename?: "TripsSaveStayAttributes";
  /** The check-in date for the property */
  checkInDate?: Maybe<Date>;
  /** The check-out date for the property */
  checkoutDate?: Maybe<Date>;
  /** The Gaia region ID of the search */
  regionId?: Maybe<Scalars["String"]>;
  /** Provides Stay traveler information */
  roomConfiguration?: Maybe<Array<PropertyRoom>>;
};

/** Save stay input details */
export interface TripsSaveStayAttributesInput {
  /** The check-in date for the property */
  checkInDate?: InputMaybe<DateInput>;
  /** The check-out date for the property */
  checkoutDate?: InputMaybe<DateInput>;
  /** The Gaia region ID of the search */
  regionId?: InputMaybe<Scalars["String"]>;
  /** Provides Stay traveler information */
  roomConfiguration?: InputMaybe<Array<PropertyRoomInput>>;
}

/** Stay input details */
export interface TripsSaveStayInput {
  checkInDate?: InputMaybe<DateTimeInput>;
  checkoutDate?: InputMaybe<DateTimeInput>;
  propertyId: Scalars["String"];
  regionId?: InputMaybe<Scalars["String"]>;
  roomConfiguration?: InputMaybe<Array<TripsStayRoomTravelerInfoInput>>;
  sourceType?: InputMaybe<TripsPlanSourceType>;
}

/** Represents a response representing a price section for trip's saved item. */
export type TripsSavedItemPrice = {
  __typename?: "TripsSavedItemPrice";
  impressionAnalytics: ClientSideImpressionAnalytics;
  leadingGraphic?: Maybe<UiGraphic>;
  primary?: Maybe<Scalars["String"]>;
  secondary?: Maybe<Scalars["String"]>;
};

/** Contains the necessary data for calling the savedItemPrice query. */
export type TripsSavedItemPricePrimer = {
  __typename?: "TripsSavedItemPricePrimer";
  tripItem: TripItem;
};

/** Input to the trips.screenshot query. */
export interface TripsScreenshotInput {
  /** The id of the item being saved, e.g property id */
  itemId: Scalars["String"];
  /** Provides an entrypoint location from which an item can be saved to a trip */
  pageLocation?: InputMaybe<PageLocation>;
  /** Provides LOB specific search context */
  saveItemAttributes: TripsSaveItemAttributesInput;
}

export type TripsSearchBookingView =
  | "SEARCH_BY_ITINERARY_NUMBER"
  | "SEARCH_BY_ITINERARY_NUMBER_AND_EMAIL"
  | "SEARCH_RESULT";

/** Use this button to let users take an alternative, supplemental, or less important action. */
export type TripsSecondaryButton = TripsButton &
  TripsFlexContainerItem & {
    __typename?: "TripsSecondaryButton";
    accessibility?: Maybe<AccessibilityData>;
    action?: Maybe<TripsAction>;
    disabled: Scalars["Boolean"];
    grow?: Maybe<Scalars["Float"]>;
    icon?: Maybe<Icon>;
    primary?: Maybe<Scalars["String"]>;
    width: TripsButtonWidth;
  };

/**
 * A section is a logical grouping of several cards.
 * For example: listing all the upcoming trips and then past trips can be achieved with 2 sections.
 */
export type TripsSectionContainer = TripsContainer & {
  __typename?: "TripsSectionContainer";
  elements: Array<TripsComposableElement>;
  heading?: Maybe<Scalars["String"]>;
  theme?: Maybe<ContainerTheme>;
};

export type TripsSendItineraryEmail = {
  __typename?: "TripsSendItineraryEmail";
  item: TripItem;
};

/** DEPRECATED - will be removed soon */
export type TripsSendItineraryEmailAction = TripsAction &
  TripsFormSubmitAction & {
    __typename?: "TripsSendItineraryEmailAction";
    analytics: ClientSideAnalytics;
    inputIds: Array<Scalars["String"]>;
    item: TripItem;
  };

/** Interface for a side-effect which may occur on initial TripsView or as a result of some mutation result, etc. */
export type TripsSideEffects =
  | CopyToClipboardAction
  | TripsAcceptInviteAndNavigateToOverviewAction
  | TripsCancelActivityAction
  | TripsCancelAssuranceAction
  | TripsCancelCarAction
  | TripsCancelFlightAction
  | TripsCancelInsuranceAction
  | TripsCancellationAction
  | TripsChangeItemDatesAction
  | TripsCloseDialogAction
  | TripsCreateNewTripAction
  | TripsCreateTripFromItemAction
  | TripsDeleteTripAction
  | TripsDismissAction
  | TripsDismissDrawerAction
  | TripsFormAction
  | TripsInfoToast
  | TripsInlineActionToast
  | TripsInviteAcceptAction
  | TripsInviteAction
  | TripsLinkAction
  | TripsMapAction
  | TripsMapDirectionsAction
  | TripsMoveItemToTripAction
  | TripsNavigateToFilteredViewAction
  | TripsNavigateToItemDetailsAction
  | TripsNavigateToItemPricingAndRewardsAction
  | TripsNavigateToItemReceiptAction
  | TripsNavigateToItemVoucherAction
  | TripsNavigateToListViewAction
  | TripsNavigateToManageBookingAction
  | TripsNavigateToManageTripAction
  | TripsNavigateToTripOverviewAction
  | TripsNavigateToViewAction
  | TripsOpenBottomSheetAction
  | TripsOpenChangeDatesDatePickerAction
  | TripsOpenCreateNewTripDrawerAction
  | TripsOpenCreateNewTripDrawerForItemAction
  | TripsOpenDialogAction
  | TripsOpenEditTripDrawerAction
  | TripsOpenEmailDrawerAction
  | TripsOpenFullScreenDialogAction
  | TripsOpenInviteDrawerAction
  | TripsOpenMenuAction
  | TripsOpenMoveTripItemDrawerAction
  | TripsOpenSaveToTripDrawerAction
  | TripsPriceAlertAction
  | TripsSaveItemToTripAction
  | TripsSaveNewTripAction
  | TripsSendItineraryEmailAction
  | TripsStackedActionToast
  | TripsUnsaveItemFromTripAction
  | TripsUpdateTripAction
  | TripsVirtualAgentInitAction;

/** Trips Signal are attached to elements that are wanting to have emitted values returned to it. */
export type TripsSignal = {
  __typename?: "TripsSignal";
  reference?: Maybe<Scalars["String"]>;
  type: TripsSignalType;
};

/** This type is used for getting a client's field input value by fetching it via the field's ID as well as a list of other static values. */
export type TripsSignalFieldIdExistingValues = {
  __typename?: "TripsSignalFieldIdExistingValues";
  ids: Array<Scalars["String"]>;
  prefixes?: Maybe<Array<Scalars["String"]>>;
};

/** This type is used for getting a client's field input value by fetching it via the field's ID. */
export type TripsSignalFieldIdValue = {
  __typename?: "TripsSignalFieldIdValue";
  id: Scalars["String"];
};

export interface TripsSignalListener {
  signal?: Maybe<TripsSignal>;
}

/** A Pair that contains a key, of which field the value relates to, and a value. */
export type TripsSignalPair = {
  __typename?: "TripsSignalPair";
  key: TripsSignalPairKey;
  value: TripsSignalPairValue;
};

/** This enum represents the different fields that a TripsSignalPair relates to. */
export type TripsSignalPairKey = "PRIMARY" | "SECONDARY" | "STATUS";

/** A generic type that will house various different types of signal values that can be emitted. */
export type TripsSignalPairValue = TripsSignalFieldIdExistingValues | TripsSignalFieldIdValue | TripsSignalValue;

/** This enum represents the different category types of signals registered within the platform. */
export type TripsSignalType = "REMOVE" | "UPDATE";

/** This type is used to pass a string value, like a dialog content, as an emitted signal value. */
export type TripsSignalValue = {
  __typename?: "TripsSignalValue";
  value: Scalars["String"];
};

/**
 * A slim card is mostly used to highlight some information like a booked product.
 * Often the card will be associated to an action to open a subsequent view such as the details about a flight booking or a car reservation.
 */
export type TripsSlimCard = TripsCard & {
  __typename?: "TripsSlimCard";
  /** Used for accessibility. */
  accessibility?: Maybe<AccessibilityData>;
  action?: Maybe<TripsAction>;
  graphic?: Maybe<UiGraphic>;
  /** @deprecated Use graphic */
  icon?: Maybe<Icon>;
  impressionTracking?: Maybe<ClientSideImpressionAnalytics>;
  primary?: Maybe<Scalars["String"]>;
  secondaries?: Maybe<Array<Scalars["String"]>>;
};

/**
 * Trips Toast when you have text and button stacked.
 * Actionable toast is behind a feature gate: https://egtnl.prod.expedia.com/experiment/43510
 */
export type TripsStackedActionToast = TripsToast & {
  __typename?: "TripsStackedActionToast";
  button: TripsButton;
  impressionTracking?: Maybe<ClientSideImpressionAnalytics>;
  primary: Scalars["String"];
};

export type TripsStackedActionsDialog = TripsDialog & {
  __typename?: "TripsStackedActionsDialog";
  body: Array<TripsContent>;
  buttons: Array<TripsButton>;
  heading?: Maybe<Scalars["String"]>;
};

/** Stay room traveler information */
export interface TripsStayRoomTravelerInfoInput {
  childrenAges: Array<Scalars["Int"]>;
  numberOfAdults: Scalars["Int"];
}

/** Use this button for the least amount of prominence. */
export type TripsTertiaryButton = TripsButton &
  TripsFlexContainerItem & {
    __typename?: "TripsTertiaryButton";
    accessibility?: Maybe<AccessibilityData>;
    action?: Maybe<TripsAction>;
    disabled: Scalars["Boolean"];
    grow?: Maybe<Scalars["Float"]>;
    icon?: Maybe<Icon>;
    primary?: Maybe<Scalars["String"]>;
    width: TripsButtonWidth;
  };

/** Base class for Trips Toast */
export interface TripsToast {
  impressionTracking?: Maybe<ClientSideImpressionAnalytics>;
  primary: Scalars["String"];
}

/** Represents a toggle's state. */
export type TripsToggleStatus = "DISABLED" | "ENABLED";

/** Toolbars provide navigation, context and access to view level actions. */
export type TripsToolbar = {
  __typename?: "TripsToolbar";
  actions: TripsToolbarActions;
  primary?: Maybe<Scalars["String"]>;
  secondaries?: Maybe<Array<Scalars["String"]>>;
};

/**
 * Back toolbars are ideal path progression views. Examples: Infosite, Checkout.
 * Close toolbars are ideal for full-screen dialogs or any new view that isn't part of user path progression. Examples: date pickers, additonal information views.
 */
export type TripsToolbarActions = {
  __typename?: "TripsToolbarActions";
  primary: TripsTertiaryButton;
  secondaries?: Maybe<Array<TripsTertiaryButton>>;
};

/** Action describing the user interaction on an element should lead the customer to un-saving an item from the selected trip. */
export type TripsUnsaveItemFromTripAction = TripsAction & {
  __typename?: "TripsUnsaveItemFromTripAction";
  analytics: ClientSideAnalytics;
  emitSignals?: Maybe<Array<TripsEmitSignal>>;
  itemId: Scalars["String"];
  /** @deprecated lineOfBusiness has been deprecated in favour of tripEntity */
  lineOfBusiness: LineOfBusinessDomain;
  tripEntity: TripEntity;
  tripItem: TripItem;
};

export type TripsUpdateTrip = {
  __typename?: "TripsUpdateTrip";
  emitSignals?: Maybe<Array<TripsEmitSignal>>;
  overview: TripOverview;
};

/** DEPRECATED - will be removed soon */
export type TripsUpdateTripAction = TripsAction &
  TripsFormSubmitAction & {
    __typename?: "TripsUpdateTripAction";
    analytics: ClientSideAnalytics;
    emitSignals?: Maybe<Array<TripsEmitSignal>>;
    inputIds: Array<Scalars["String"]>;
    overview: TripOverview;
  };

/** A text input field for user's data */
export type TripsValidatedInput = EgdsElement &
  EgdsInputField & {
    __typename?: "TripsValidatedInput";
    egdsElementId: Scalars["String"];
    errorMessage?: Maybe<Scalars["String"]>;
    inputType?: Maybe<TripsInputType>;
    instructions?: Maybe<Scalars["String"]>;
    label?: Maybe<Scalars["String"]>;
    labelTemplate?: Maybe<EgdsLocalizedText>;
    leftIcon?: Maybe<Icon>;
    placeholder?: Maybe<Scalars["String"]>;
    readOnly: Scalars["Boolean"];
    required?: Maybe<Scalars["Boolean"]>;
    rightIcon?: Maybe<Icon>;
    validations?: Maybe<Array<EgdsInputValidation>>;
    value?: Maybe<Scalars["String"]>;
  };

/**
 * A trips view used for either list customer's upcoming trips or even looking at the details of a product within a trip has been broken down into a list of Cards.
 * Composing a trips view, effectively means assembling a set of Cards.
 */
export type TripsView = {
  __typename?: "TripsView";
  contentType?: Maybe<TripsContentType>;
  customerNotifications?: Maybe<TripsCustomerNotificationQueryParameters>;
  egTripsCards: Array<EgdsImageCard>;
  egTripsMap?: Maybe<EgdsBasicMap>;
  elements: Array<TripsComposableElement>;
  floatingActionButton?: Maybe<TripsFloatingActionButton>;
  header?: Maybe<TripsViewHeader>;
  pageTitle?: Maybe<Scalars["String"]>;
  prefetchOperations?: Maybe<Array<TripsPrefetchOperation>>;
  status?: Maybe<TripsResponseStatus>;
  /** @deprecated toast attribute is deprecated., replace with tripsSideEffects */
  toast?: Maybe<TripsToast>;
  tripsMap?: Maybe<TripsMap>;
  tripsSideEffects?: Maybe<Array<TripsSideEffects>>;
};

/** An element which can be a simple text, link or combine both alongside the icon. */
export type TripsViewContentItem = {
  __typename?: "TripsViewContentItem";
  action?: Maybe<TripsAction>;
  icon?: Maybe<Icon>;
  primary?: Maybe<Scalars["String"]>;
};

/** An element which houses the text items that allows for text item positioning by list order. */
export type TripsViewContentLineItem = {
  __typename?: "TripsViewContentLineItem";
  items: Array<TripsViewContentItem>;
};

/** Header for a trips view. Contains a primary heading text, a list of secondary texts, and a toolbar with actions (such as a back button) */
export type TripsViewHeader = TripsSignalListener & {
  __typename?: "TripsViewHeader";
  primary?: Maybe<Scalars["String"]>;
  secondaries?: Maybe<Array<Scalars["String"]>>;
  signal?: Maybe<TripsSignal>;
  toolbar?: Maybe<TripsToolbar>;
};

/** Wrapping type for trips views */
export type TripsViewResponse =
  | TripsComposableDrawer
  | TripsFloatingActionDrawer
  | TripsInlinedActionsDrawer
  | TripsView;

export type TripsViewType =
  | "ACTIVITIES_SEARCH_RESULTS"
  | "CAMPAIGNS"
  | "CARS_SEARCH_RESULTS"
  | "FILTERED"
  | "FIND_ITINERARY_BY_OTHER_EMAIL"
  | "FIND_ITINERARY_BY_USER_EMAIL"
  | "FLIGHTS_SEARCH_RESULTS"
  | "ITEM_DETAILS"
  | "ITEM_ESSENTIAL_INFO"
  | "ITEM_PRICING_AND_REWARDS"
  | "ITEM_VOUCHER"
  | "LOB_SELECTION_VIEW"
  | "LODGING_SEARCH_RESULTS"
  | "MANAGE_BOOKING"
  | "MANAGE_GUESTS"
  | "OVERVIEW"
  | "PACKAGES_FC_SEARCH_RESULTS"
  | "PACKAGES_FHC_SEARCH_RESULTS"
  | "PACKAGES_HC_SEARCH_RESULTS"
  | "PACKAGES_HF_SEARCH_RESULTS"
  | "PENDING_INVITE"
  | "SEARCH_BY_ITINERARY_NUMBER"
  | "SEARCH_BY_ITINERARY_NUMBER_AND_EMAIL"
  | "TRIPS_LIST";

/** Action describing the user interaction on an element should initialize the Virtual Agent */
export type TripsVirtualAgentInitAction = TripsAction & {
  __typename?: "TripsVirtualAgentInitAction";
  analytics: ClientSideAnalytics;
  applicationName?: Maybe<Scalars["String"]>;
  clientOverrides?: Maybe<TripsVirtualAgentOverrideData>;
  pageName?: Maybe<Scalars["String"]>;
  /** @deprecated Request this value from the chatBotConfig query going forward. */
  resource?: Maybe<Uri>;
  title?: Maybe<Scalars["String"]>;
};

/** The `TripsVirtualAgentOverrideData` contains client override data to be forwarded on to the Virtual Agent Platform */
export type TripsVirtualAgentOverrideData = {
  __typename?: "TripsVirtualAgentOverrideData";
  conversationProperties?: Maybe<VirtualAgentConversationProperties>;
  enableAutoOpenChatWidget?: Maybe<Scalars["Boolean"]>;
  enableProactiveConversation?: Maybe<Scalars["Boolean"]>;
  intentArguments?: Maybe<Array<VirtualAgentIntentValue>>;
  /** @deprecated Please use intentArguments instead */
  intentMessage?: Maybe<VirtualAgentIntentMessage>;
  subscribedEvents?: Maybe<Array<Scalars["String"]>>;
};

/** The legacy model for Icons with text */
export type TripsWidgetTextWithIconViewModel = {
  __typename?: "TripsWidgetTextWithIconViewModel";
  icon: Scalars["String"];
  text: Scalars["String"];
};

/** The legacy model for Trip Item Detail score to show or hide widget. */
export type TripsWidgetTripDetailItemRelevance = {
  __typename?: "TripsWidgetTripDetailItemRelevance";
  duration: Scalars["Int"];
  score: Scalars["Int"];
};

/** The legacy model for Trip Product Detailsto power widget. */
export type TripsWidgetTripProductDetailViewModel = {
  __typename?: "TripsWidgetTripProductDetailViewModel";
  deeplinkUrl: Scalars["URL"];
  icon: Scalars["String"];
  subtitleText: Scalars["String"];
  titleText: Scalars["String"];
};

export type TwoFactorAuthEgClickstreamData = {
  __typename?: "TwoFactorAuthEGClickstreamData";
  event: EgClickstreamEvent;
  experience: EgClickstreamExperience;
};

/** Additional information to initialise cruise typeahead adapter */
export type TypeaheadAdapterDetails = {
  __typename?: "TypeaheadAdapterDetails";
  /** Request body for the typeahead search */
  adapterRequest?: Maybe<TypeaheadAdapterRequest>;
  /** Typeahead category information to categorize the typeahead search results */
  categoryDetails?: Maybe<Array<TypeaheadCategoryDetails>>;
  /** Domain of the information to be requested from the Typeahead API */
  domainId: Scalars["String"];
};

/** Specifies request body for typeahead search */
export type TypeaheadAdapterRequest = {
  __typename?: "TypeaheadAdapterRequest";
  /** Specifies which metadata fields to include in the typeahead results */
  includeMetadata?: Maybe<Array<Scalars["String"]>>;
};

/** Typeahead category information to categorize the typeahead search results */
export type TypeaheadCategoryDetails = {
  __typename?: "TypeaheadCategoryDetails";
  /** Key of the category detail */
  key: Scalars["String"];
  /** Value to be used for display on the component */
  value: Scalars["String"];
};

/**
 * Used to setup UITK Typeahead component (which internally uses Expedia Suggest Service API)
 * enables search resolution functionalities
 *
 * More details on UITK Typeahead:
 * https://uitk.expedia.biz/expedia/en_US/components/typeahead
 */
export type TypeaheadInfo = {
  __typename?: "TypeaheadInfo";
  /** Enables exact search term matching */
  allowExactMatch: Scalars["Boolean"];
  /** Flag used to categorize the typeahead results */
  categorize: Scalars["Boolean"];
  /** An agreed upon name between Expedia Suggest Service and its partners */
  client?: Maybe<Scalars["String"]>;
  /** Text for dismiss button text */
  dismissButtonText?: Maybe<Scalars["String"]>;
  /** Specify the domain to use for the requests, ex `www.expedia.com` */
  domain?: Maybe<Scalars["String"]>;
  /** When set to true, nearby results will be presented when the user focuses the destination input without typing anything */
  drivable: Scalars["Boolean"];
  /** Placeholder for using when no results have been gather, commonly displayed when user hasn't performed a search before */
  emptyResultsPlaceholder?: Maybe<Scalars["String"]>;
  /**
   * Specifies whether query term is a destination (as opposed to an origin).
   * ESS needs this information for Flights/Packages/Cars.
   */
  isDestination: Scalars["Boolean"];
  /**
   * Specifies is multiple locations selection feature is enable
   * @deprecated Use typeaheadMultiSelect.isMultiLocation
   */
  isMultiLocation?: Maybe<Scalars["Boolean"]>;
  /** One of the Expedia Group line of business: Hotels, Flights, Cars, Packages... */
  lineOfBusiness?: Maybe<Scalars["String"]>;
  /** When this flag is set, the heading for the categorized results is shown */
  listTitle: Scalars["Boolean"];
  /** Specifies the maximum number of results to be returned in ESS response */
  maxNumberOfResults?: Maybe<Scalars["Int"]>;
  /** Package type, this parameter accompanies Packages line of business */
  packageType?: Maybe<Scalars["String"]>;
  /** When set to true, user history is considered while compiling results */
  personalize: Scalars["Boolean"];
  /** Used to fetch results from within the specified region id */
  regionId?: Maybe<Scalars["String"]>;
  /** Region category, eg: Airport, City, Multi-city... */
  regionType?: Maybe<Scalars["Int"]>;
  /** When set to true, trending results will be presented when the user focuses the destination input without typing anything */
  trending: Scalars["Boolean"];
  /** Features enabled, such as ta_hierarchy enables that typeahead shows the hierarchy */
  typeaheadFeatures?: Maybe<Scalars["String"]>;
  /** Property to use for multi select option */
  typeaheadMultiSelect?: Maybe<EgdsTypeaheadMultiSelect>;
};

/**
 * An action is a generic container to information the client side application what can be done with a given card.
 * Sometimes the action will be could be associated with a deep link, opening a specific view or leveraging some protocols like e-mails or phones.
 * Every action must be trackable for analytics purpose based on the `analytics` information.
 */
export interface UiAction {
  /** Used to provide accessibility that has to be read on completion of action. */
  accessibility?: Maybe<Scalars["String"]>;
  analytics: ClientSideAnalytics;
}

/** Banners are used to notify users of an urgent or important condition that may affect their trip or booking experience. */
export type UiBanner = EgdsElement & {
  __typename?: "UIBanner";
  actions: Array<UiLinkAction>;
  egdsElementId?: Maybe<Scalars["String"]>;
  fullWidth?: Maybe<Scalars["Boolean"]>;
  heading?: Maybe<Scalars["String"]>;
  icon?: Maybe<Icon>;
  message: Scalars["String"];
};

/** Represent the subscription mutation which client will call */
export type UiCreatePriceInsightsTrackingAction = ClientSideErrorRepresentation &
  PriceInsightsTrackingToggleAction & {
    __typename?: "UICreatePriceInsightsTrackingAction";
    accessibility?: Maybe<Scalars["String"]>;
    analytics: ClientSideAnalytics;
    clientSideErrorRepresentationAction?: Maybe<PriceInsightsTrackingRetryDialogAction>;
    clientSideErrorRepresentationDialog?: Maybe<ClientSideErrorRepresentationDialog>;
    /** Represent the dialog when user tries to update existing alert */
    existingTrackingDialog?: Maybe<PriceInsightsExistingTrackingDialogAction>;
    /** Represents the price on which subscription needs to be created */
    priceShown: Scalars["String"];
    /** Action client needs to take when traveller does not have notifications enabled in general for device */
    systemNotificationPermissionsDisabledAction: UiDisableSystemNotificationsAction;
  };

/** Represent the action to enable system notifications */
export type UiDisableSystemNotificationsAction = PriceInsightsTrackingToggleAction & {
  __typename?: "UIDisableSystemNotificationsAction";
  accessibility?: Maybe<Scalars["String"]>;
  analytics: ClientSideAnalytics;
  /** Native platform's dialog's cancellation button text */
  cancelButtonText: Scalars["String"];
  /** Native platform's dialog's confirmation button text */
  confirmationButtonText: Scalars["String"];
  /** Native platform's dialog heading for turning on notification */
  dialogMessageHeading: Scalars["String"];
  /** Native platform's dialog details for turning on notification */
  dialogMessageSubHeading: Scalars["String"];
  /** Represents the analytics to track on display of the component */
  displayAnalytics?: Maybe<ClientSideImpressionEventAnalytics>;
  /** Represents the EGCS analytics to track on display of the component */
  egcsDisplayAnalytics?: Maybe<EgClickstreamEvent>;
};

/**
 * Empty state elements are provided as separate pieces that combine to form different variations and can be assembled in a variety of different ways depending on need.
 * Empty states can be used between modules on a page or be placed alone in a full screen view.
 * Figma: https://www.figma.com/file/0OuX8BMSFmFdWYXfdCEjrj/Empty-state
 */
export type UiEmptyState = EgdsElement & {
  __typename?: "UIEmptyState";
  body: Scalars["String"];
  egdsElementId?: Maybe<Scalars["String"]>;
  heading?: Maybe<Scalars["String"]>;
  icon?: Maybe<Icon>;
  primaryButton?: Maybe<UiPrimaryButton>;
  tertiaryButton?: Maybe<UiTertiaryButton>;
};

export type UiFlightAction = UiAction & {
  __typename?: "UIFlightAction";
  accessibility?: Maybe<Scalars["String"]>;
  analytics: ClientSideAnalytics;
};

export type UiFlightFloatingActionButton = UiFloatingActionButton & {
  __typename?: "UIFlightFloatingActionButton";
  accessibility?: Maybe<Scalars["String"]>;
  action?: Maybe<UiAction>;
  analytics?: Maybe<ClientSideAnalytics>;
  badge?: Maybe<Scalars["Int"]>;
  disabled: Scalars["Boolean"];
  icon?: Maybe<Icon>;
  primary?: Maybe<Scalars["String"]>;
};

/** Use this button for a floating icon style. */
export interface UiFloatingActionButton {
  accessibility?: Maybe<Scalars["String"]>;
  /**
   * @deprecated
   *         UIAction should not be used as a field because it allows for too many possible types.
   *         If need to specify action have the implementation of EGDSButton add a field for action with interface type of less number of possible subtypes
   *         or a union type with a manageable number of members
   *
   */
  action?: Maybe<UiAction>;
  /** Used to capture client side analytics on button click. */
  analytics?: Maybe<ClientSideAnalytics>;
  /** Use badge to notify a count on button. */
  badge?: Maybe<Scalars["Int"]>;
  disabled: Scalars["Boolean"];
  icon?: Maybe<Icon>;
  /** Use primary to show text beside icon or badge. */
  primary?: Maybe<Scalars["String"]>;
}

/**
 * In many cases, UX designs support Icons, Illustrations, and Marks interchangeably.
 * Their fields are slightly different and their UI implementations are also different.
 * Graphic is intended to help group those possible types together without having to add nullable fields for them individually.
 */
export type UiGraphic = Icon | Illustration | Mark;

/** Used to describe a URI based link. A URI can expose several protocols like `geo` for geographical information, `tel` to let the customer's phone application taking over or even `mailto`. */
export type UiLinkAction = UiAction & {
  __typename?: "UILinkAction";
  accessibility?: Maybe<Scalars["String"]>;
  analytics: ClientSideAnalytics;
  resource: Uri;
  target: UiLinkTarget;
  /** Flag to identify if relative path to be rendered or whole url */
  useRelativePath: Scalars["Boolean"];
};

/** Specifies whether to open the link in the same user interface context or in a different context */
export type UiLinkTarget = "EXTERNAL" | "INTERNAL";

/**
 * A specific type of card used for product messaging or other contextual information highlighted to the user.
 * This is often used for things like product availability, user sign-in status, earning brand points, or other promotional/informative messages.
 * Figma: https://www.figma.com/file/V9juOKAE4bgugBqxRiPBjJ/Messaging-cards
 */
export type UiMessagingCard = EgdsElement & {
  __typename?: "UIMessagingCard";
  actions?: Maybe<UiMessagingCardActions>;
  egdsElementId?: Maybe<Scalars["String"]>;
  graphic?: Maybe<UiGraphic>;
  primary?: Maybe<Scalars["String"]>;
  secondaries?: Maybe<Array<Scalars["String"]>>;
};

/**
 * There are times when a Messaging Card can provide some actionable options to the user.
 * For visual consistency, the targets/triggers for those actions should be limited to Button types.
 * Common examples of Messaging Card Actions could be "Sign-in", "Show me FooBar properties", "Learn more".
 */
export type UiMessagingCardActions = {
  __typename?: "UIMessagingCardActions";
  primary?: Maybe<UiTertiaryButton>;
  secondaries?: Maybe<Array<UiTertiaryButton>>;
};

/**
 * Use to toggle on one or more categories (e.g. Beach, Family),
 * quick-select an option (e.g. quick response in Chat virtual assistant),
 * or trigger a selection feature (e.g. Datepicker).
 */
export interface UiPill {
  accessibility?: Maybe<Scalars["String"]>;
  /**
   * @deprecated
   *         UIAction should not be used as a field because it allows for too many possible types.
   *         If need to specify action have the implementation of UIPill add a field for action with interface type of less number of possible subtypes
   *         or a union type with a manageable number of members
   *
   */
  action?: Maybe<UiAction>;
  /** Denotes whether pill is in disabled state */
  disabled: Scalars["Boolean"];
  /** Used to denote informative icon */
  icon?: Maybe<Icon>;
  /** Used to display text on pill */
  primary: Scalars["String"];
  /** Denotes whether pill is in selected state */
  selected: Scalars["Boolean"];
}

/** Use this button to make the primary call to action. Do not use it for different calls to action in the same view. */
export type UiPrimaryButton = EgdsButton &
  EgdsElement & {
    __typename?: "UIPrimaryButton";
    accessibility?: Maybe<Scalars["String"]>;
    action?: Maybe<UiAction>;
    analytics?: Maybe<ClientSideAnalytics>;
    disabled: Scalars["Boolean"];
    egdsElementId?: Maybe<Scalars["String"]>;
    icon?: Maybe<Icon>;
    primary?: Maybe<Scalars["String"]>;
  };

/** Use this button to make the primary call to action and for a floating button style. */
export type UiPrimaryFloatingActionButton = EgdsElement &
  UiFloatingActionButton & {
    __typename?: "UIPrimaryFloatingActionButton";
    accessibility?: Maybe<Scalars["String"]>;
    action?: Maybe<UiAction>;
    analytics?: Maybe<ClientSideAnalytics>;
    badge?: Maybe<Scalars["Int"]>;
    disabled: Scalars["Boolean"];
    egdsElementId?: Maybe<Scalars["String"]>;
    icon?: Maybe<Icon>;
    primary?: Maybe<Scalars["String"]>;
  };

/**
 * Used to help remember what you selected (e.g. applied filters) and easily deselect.
 * Clicking or tapping any part of the pill will trigger its removal.
 */
export interface UiRemovablePill {
  accessibility?: Maybe<Scalars["String"]>;
  /**
   * @deprecated
   *         UIAction should not be used as a field because it allows for too many possible types.
   *         If need to specify action have the implementation of UIRemovablePill add a field for action with interface type of less number of possible subtypes
   *         or a union type with a manageable number of members
   *
   */
  action?: Maybe<UiAction>;
  /** Denotes whether pill is in disabled state */
  disabled: Scalars["Boolean"];
  /** Used to denote informative icon */
  icon?: Maybe<Icon>;
  /** Used to display text on pill. Example "Delta", "Nonstop" */
  primary: Scalars["String"];
  /** denotes removal trigger of pill */
  remove?: Maybe<Icon>;
  /** Denotes whether pill is in selected state */
  selected: Scalars["Boolean"];
}

export type UisPrimeRecommendationsDisplayPrice = {
  __typename?: "UISPrimeRecommendationsDisplayPrice";
  currency: Scalars["String"];
  displayPrice: Scalars["Float"];
};

export type UisPrimeRecommendationsEvent = {
  __typename?: "UISPrimeRecommendationsEvent";
  component: Scalars["String"];
  componentElement?: Maybe<Scalars["String"]>;
  egRecommendationResponseId: Scalars["String"];
  eventName: Scalars["String"];
  eventType: Scalars["String"];
  recommendationTitle: Scalars["String"];
  recommendations: Array<UisPrimeRecommendationsItem>;
  scroll?: Maybe<Scalars["String"]>;
};

export type UisPrimeRecommendationsItem = {
  __typename?: "UISPrimeRecommendationsItem";
  presentationDetails: UisPrimeRecommendationsItemPresentationDetails;
  rank: Scalars["Int"];
  recommendationId: Scalars["String"];
};

export type UisPrimeRecommendationsItemPresentationDetails = {
  __typename?: "UISPrimeRecommendationsItemPresentationDetails";
  badges?: Maybe<Scalars["String"]>;
  imageUrl: Scalars["String"];
  name: Scalars["String"];
  price?: Maybe<UisPrimeRecommendationsDisplayPrice>;
};

/** Use this button to let users take an alternative, supplemental, or less important action. */
export type UiSecondaryButton = EgdsButton &
  EgdsElement & {
    __typename?: "UISecondaryButton";
    accessibility?: Maybe<Scalars["String"]>;
    action?: Maybe<UiAction>;
    analytics?: Maybe<ClientSideAnalytics>;
    disabled: Scalars["Boolean"];
    egdsElementId?: Maybe<Scalars["String"]>;
    icon?: Maybe<Icon>;
    primary?: Maybe<Scalars["String"]>;
  };

/** Use this button to let users take an alternative, supplemental, or less important action and for a floating icon style. */
export type UiSecondaryFloatingActionButton = EgdsElement &
  UiFloatingActionButton & {
    __typename?: "UISecondaryFloatingActionButton";
    accessibility?: Maybe<Scalars["String"]>;
    action?: Maybe<UiAction>;
    analytics?: Maybe<ClientSideAnalytics>;
    badge?: Maybe<Scalars["Int"]>;
    disabled: Scalars["Boolean"];
    egdsElementId?: Maybe<Scalars["String"]>;
    icon?: Maybe<Icon>;
    primary?: Maybe<Scalars["String"]>;
  };

export type UiSignal =
  | "BOOKING_SUCCESS"
  | "DUPLICATE_REQUEST"
  | "GENERIC_DOWNSTREAM_ERROR"
  | "PAYMENT_ERROR"
  | "PRICE_ADJUSTED"
  | "PRICE_CHANGED"
  | "UNKNOWN"
  | "UNRECOVERABLE_FAILURE";

/** Represents an individual text */
export type UiSimpleText = {
  __typename?: "UISimpleText";
  /** Represents the text */
  text: Scalars["String"];
};

/** Use this button for the least amount of prominence. */
export type UiTertiaryButton = EgdsButton &
  EgdsElement & {
    __typename?: "UITertiaryButton";
    accessibility?: Maybe<Scalars["String"]>;
    action?: Maybe<UiAction>;
    analytics?: Maybe<ClientSideAnalytics>;
    disabled: Scalars["Boolean"];
    egdsElementId?: Maybe<Scalars["String"]>;
    icon?: Maybe<Icon>;
    primary?: Maybe<Scalars["String"]>;
  };

/** Represents a bullet list */
export type UiTextList = {
  __typename?: "UITextList";
  /** Represents the header of the list */
  heading?: Maybe<Scalars["String"]>;
  /** Represents a list of text */
  texts?: Maybe<Array<Scalars["String"]>>;
};

/**
 * Use this component to let users switch/toggle between states
 * Figma: https://www.figma.com/file/69SEMRa1KCBXU6T8uRcdzM/Switches?node-id=20%3A83
 */
export interface UiToggle {
  checked: Scalars["Boolean"];
  checkedAccessibilityLabel?: Maybe<Scalars["String"]>;
  checkedAnalytics?: Maybe<ClientSideAnalytics>;
  checkedDescription?: Maybe<Scalars["String"]>;
  checkedLabel: Scalars["String"];
  enabled: Scalars["Boolean"];
  /** @deprecated Use checked or unchecked label */
  label: Scalars["String"];
  uncheckedAccessibilityLabel?: Maybe<Scalars["String"]>;
  uncheckedAnalytics?: Maybe<ClientSideAnalytics>;
  uncheckedDescription?: Maybe<Scalars["String"]>;
  uncheckedLabel: Scalars["String"];
}

/** Toolbars provide navigation, context and access to view level actions. */
export type UiToolbar = {
  __typename?: "UIToolbar";
  actions: UiToolbarActions;
  primary?: Maybe<Scalars["String"]>;
  secondaries?: Maybe<Array<Scalars["String"]>>;
};

/**
 * Back toolbars are ideal path progression views. Examples: Infosite, Checkout.
 * Close toolbars are ideal for full-screen dialogs or any new view that isn't part of user path progression. Examples: date pickers, additonal information views.
 */
export type UiToolbarActions = {
  __typename?: "UIToolbarActions";
  primary: UiTertiaryButton;
  secondaries?: Maybe<Array<UiTertiaryButton>>;
};

export type UiValidateTravelerLoggedInAction = ClientSideErrorRepresentation &
  PriceInsightsTrackingToggleAction & {
    __typename?: "UIValidateTravelerLoggedInAction";
    accessibility?: Maybe<Scalars["String"]>;
    analytics: ClientSideAnalytics;
    clientSideErrorRepresentationAction?: Maybe<PriceInsightsTrackingRetryDialogAction>;
    clientSideErrorRepresentationDialog?: Maybe<ClientSideErrorRepresentationDialog>;
    /** Represents the EGCS analytics to track on display of the component */
    egcsDisplayAnalytics?: Maybe<EgClickstreamEvent>;
  };

/**
 * Generic representation of a Uniform Resource Indicator see [RFC](https://tools.ietf.org/html/rfc3986) for more information.
 * Example of use case:
 * - non http protocol: being able to expose a link like `tel` to let the mobile native integration taking over to call the hotelier.
 * - http protocol: being able to retrieve relative URL (path + query + fragment)
 */
export interface Uri {
  value: Scalars["String"];
}

/** Type which define an UnescoPledge data structure */
export type UnescoPledge = {
  __typename?: "UnescoPledge";
  /** Sustainability actions on the UnescoPledge */
  commitmentDetails: PropertyContentSectionGroup;
  /** ID of an UnescoPledge */
  pledgeId: Scalars["ID"];
  /** Name and city of the property signed on the UnescoPledge */
  propertyName: EgdsStylizedText;
};

/** Card used to render an UnescoPledge */
export type UnescoPledgeCard = {
  __typename?: "UnescoPledgeCard";
  /** Section related the categories */
  categories?: Maybe<Array<Maybe<EgdsIconText>>>;
  /** Style of the categories section */
  categoriesLabel: EgdsStylizedText;
  /** Creation date of the UnescoPledge */
  creationDate: Scalars["String"];
  /** ID of an UnescoPledge */
  pledgeId: Scalars["ID"];
  /** Title of the card, it's the name of the property */
  propertyName: EgdsStylizedText;
};

/** Type to select a category of action for an UnescoPledge */
export type UnescoPledgeCategory =
  /** Category to support local communities */
  | "COMMUNITY_ENGAGEMENT"
  /** Category to save energy consumption */
  | "CONSERVE_ENERGY"
  /** Category to save water consumption */
  | "CONSERVE_WATER"
  /** Category to add additional information about sustainability */
  | "OTHER"
  /** Category to reduce plastic usage */
  | "REDUCE_PLASTIC"
  /** Category to reduce waste */
  | "REDUCE_WASTE";

/** Type to specify a filter related UnescoPledges */
export interface UnescoPledgeFilterInput {
  /** Categories to filter */
  category?: InputMaybe<Array<InputMaybe<UnescoPledgeCategory>>>;
  /** Number of UnescoPledge to visualize */
  pledgesNumber?: InputMaybe<Scalars["Int"]>;
  /** Number of the starting index of UnescoPledge list */
  startingIndex?: InputMaybe<Scalars["Int"]>;
}

/** Return type for a list of UnescoPledgeCard */
export type UnescoPledges = {
  __typename?: "UnescoPledges";
  /** Boolean to know if there are other UnescoPledgeCard to retrieve */
  hasNext: EgdsButton;
  /** Starting index to retrieve UnescoPledgeCard */
  lastIndex: Scalars["Int"];
  /** Total number of UnescoPledgeCard stored */
  total: Scalars["Int"];
  /** UnescoPledgeCard to render */
  unescoPledgeCards: Array<UnescoPledgeCard>;
};

export type UnitOccupancy = {
  __typename?: "UnitOccupancy";
  adults: Scalars["Int"];
  children: Scalars["Int"];
  description?: Maybe<Scalars["String"]>;
  people: Scalars["Int"];
};

export type UniversalProfileAboutYouField = {
  __typename?: "UniversalProfileAboutYouField";
  aboutYou: UniversalProfileTextInputField;
  heading: UniversalProfileContentHeading;
};

export type UniversalProfileAccessibilityNeedsField = {
  __typename?: "UniversalProfileAccessibilityNeedsField";
  accessibilityNeeds: UniversalProfileBasicSelect;
  heading: UniversalProfileContentHeading;
};

export type UniversalProfileAccountTakeOverCaptchaWidget = {
  __typename?: "UniversalProfileAccountTakeOverCaptchaWidget";
  links?: Maybe<Array<UniversalProfileAccountTakeOverLink>>;
  placementContext?: Maybe<Array<UniversalProfileAccountTakeOverPlacementContext>>;
};

export type UniversalProfileAccountTakeOverCsrfWidget = {
  __typename?: "UniversalProfileAccountTakeOverCsrfWidget";
  content: Scalars["String"];
};

export type UniversalProfileAccountTakeOverLink = {
  __typename?: "UniversalProfileAccountTakeOverLink";
  loadBeforeWidget?: Maybe<Scalars["Boolean"]>;
  mimeType: Scalars["String"];
  section?: Maybe<Scalars["String"]>;
  uri: Scalars["String"];
};

export type UniversalProfileAccountTakeOverPlacementContext = {
  __typename?: "UniversalProfileAccountTakeOverPlacementContext";
  key: Scalars["String"];
  value: Scalars["String"];
};

export type UniversalProfileAccountTakeOverWidget =
  | UniversalProfileAccountTakeOverCaptchaWidget
  | UniversalProfileAccountTakeOverCsrfWidget;

export interface UniversalProfileAccountTakeOverWidgetRequestInput {
  content?: InputMaybe<Scalars["String"]>;
  type: UniversalProfileAccountTakeOverWidgetTypeRequest;
}

export type UniversalProfileAccountTakeOverWidgetTypeRequest = "CAPTCHA" | "CSRF";

export interface UniversalProfileAction {
  analytics: Array<EgClickstreamEvent>;
}

export type UniversalProfileActionResponse = UniversalProfileErrorResponse | UniversalProfileSuccessResponse;

export type UniversalProfileAdditionalTravelerContent = {
  __typename?: "UniversalProfileAdditionalTravelerContent";
  addTravelerButton: UniversalProfileButton;
  travelers: Array<UniversalProfileStandardLink>;
};

export type UniversalProfileAdditionalTravelerCreateAction = UniversalProfileAction & {
  __typename?: "UniversalProfileAdditionalTravelerCreateAction";
  analytics: Array<EgClickstreamEvent>;
};

export type UniversalProfileAdditionalTravelerViewAction = UniversalProfileAction & {
  __typename?: "UniversalProfileAdditionalTravelerViewAction";
  analytics: Array<EgClickstreamEvent>;
};

export type UniversalProfileAdditionalTravelers = {
  __typename?: "UniversalProfileAdditionalTravelers";
  container: EgdsExpandoCard;
  content: UniversalProfileExpandoContent;
};

export type UniversalProfileAddressField = {
  __typename?: "UniversalProfileAddressField";
  addressLine1: UniversalProfileTextInputField;
  addressLine2: UniversalProfileTextInputField;
  city: UniversalProfileTextInputField;
  country: UniversalProfileBasicSelect;
  heading: UniversalProfileContentHeading;
  state: UniversalProfileBasicSelect;
  zipCode: UniversalProfileTextInputField;
};

export interface UniversalProfileAddressInput {
  addressLine1?: InputMaybe<Scalars["String"]>;
  addressLine2?: InputMaybe<Scalars["String"]>;
  city?: InputMaybe<Scalars["String"]>;
  countryCode?: InputMaybe<Scalars["String"]>;
  stateCode?: InputMaybe<Scalars["String"]>;
  zipCode?: InputMaybe<Scalars["String"]>;
}

export type UniversalProfileAppearanceField = {
  __typename?: "UniversalProfileAppearanceField";
  appearance: UniversalProfileBasicRadioGroup;
  heading: UniversalProfileHeading;
};

export type UniversalProfileAttribute = UniversalProfileDefaultAttribute;

export type UniversalProfileBasicCheckBox = UniversalProfileInput & {
  __typename?: "UniversalProfileBasicCheckBox";
  analytics?: Maybe<Array<EgClickstreamEvent>>;
  input: EgdsBasicCheckBox;
  validation?: Maybe<Array<UniversalProfileValidationRule>>;
};

export interface UniversalProfileBasicInformationDateOfBirthInput {
  day?: InputMaybe<Scalars["Int"]>;
  month?: InputMaybe<Scalars["Int"]>;
  year?: InputMaybe<Scalars["Int"]>;
}

export type UniversalProfileBasicInformationForm = {
  __typename?: "UniversalProfileBasicInformationForm";
  basicInformation: UniversalProfileInformationBasicForm;
};

export type UniversalProfileBasicInformationFormAction = UniversalProfileAction & {
  __typename?: "UniversalProfileBasicInformationFormAction";
  analytics: Array<EgClickstreamEvent>;
};

export interface UniversalProfileBasicInformationNameInput {
  firstName: Scalars["String"];
  lastName: Scalars["String"];
  middleName?: InputMaybe<Scalars["String"]>;
}

export interface UniversalProfileBasicInformationRequestInput {
  accessibilityNeeds?: InputMaybe<Scalars["String"]>;
  bio?: InputMaybe<Scalars["String"]>;
  dateOfBirth: UniversalProfileBasicInformationDateOfBirthInput;
  gender?: InputMaybe<Scalars["String"]>;
  name: UniversalProfileBasicInformationNameInput;
}

export type UniversalProfileBasicInformationSaveAction = UniversalProfileAction & {
  __typename?: "UniversalProfileBasicInformationSaveAction";
  accountTakeOverWidgets: Array<UniversalProfileAccountTakeOverWidget>;
  analytics: Array<EgClickstreamEvent>;
};

export type UniversalProfileBasicRadioGroup = UniversalProfileInput & {
  __typename?: "UniversalProfileBasicRadioGroup";
  analytics?: Maybe<Array<EgClickstreamEvent>>;
  input: EgdsBasicRadioGroup;
  validation?: Maybe<Array<UniversalProfileValidationRule>>;
};

export type UniversalProfileBasicSelect = UniversalProfileInput & {
  __typename?: "UniversalProfileBasicSelect";
  analytics?: Maybe<Array<EgClickstreamEvent>>;
  input: EgdsBasicSelect;
  validation?: Maybe<Array<UniversalProfileValidationRule>>;
};

export type UniversalProfileBrandPreferences = {
  __typename?: "UniversalProfileBrandPreferences";
  appearance: UniversalProfileAppearanceField;
  copyInformation?: Maybe<UniversalProfileButton>;
  heading: UniversalProfileHeading;
  locationAndLanguage: UniversalProfileLocationAndLanguage;
  type: UniversalProfilePreferencesOptionType;
};

export type UniversalProfileBrowsingHistory = {
  __typename?: "UniversalProfileBrowsingHistory";
  clearHistory: UniversalProfileButton;
  heading: UniversalProfileHeading;
};

export type UniversalProfileBulletedList = UniversalProfileInput & {
  __typename?: "UniversalProfileBulletedList";
  analytics?: Maybe<Array<EgClickstreamEvent>>;
  input: EgdsBulletedList;
  validation?: Maybe<Array<UniversalProfileValidationRule>>;
};

export type UniversalProfileButton = {
  __typename?: "UniversalProfileButton";
  action: UniversalProfileAction;
  button: EgdsButton;
};

export type UniversalProfileCancelAction = UniversalProfileAction & {
  __typename?: "UniversalProfileCancelAction";
  analytics: Array<EgClickstreamEvent>;
};

export type UniversalProfileCheckBoxGroup = UniversalProfileInput & {
  __typename?: "UniversalProfileCheckBoxGroup";
  analytics?: Maybe<Array<EgClickstreamEvent>>;
  input: EgdsCheckBoxGroup;
  validation?: Maybe<Array<UniversalProfileValidationRule>>;
};

export type UniversalProfileClearHistoryAction = UniversalProfileAction & {
  __typename?: "UniversalProfileClearHistoryAction";
  analytics: Array<EgClickstreamEvent>;
};

export type UniversalProfileConfirmationLeavingView = {
  __typename?: "UniversalProfileConfirmationLeavingView";
  confirmationLeaving: UniversalProfileBulletedList;
  heading: UniversalProfileContentHeading;
};

export type UniversalProfileContactInformationForm = {
  __typename?: "UniversalProfileContactInformationForm";
  contactInformation: UniversalProfileInformationBasicForm;
};

export type UniversalProfileContactInformationFormAction = UniversalProfileAction & {
  __typename?: "UniversalProfileContactInformationFormAction";
  additionalTravelerIdentifier?: Maybe<Scalars["String"]>;
  analytics: Array<EgClickstreamEvent>;
};

export interface UniversalProfileContactInformationRequestInput {
  address: UniversalProfileAddressInput;
  emergencyContact: UniversalProfileEmergencyContactInput;
  phone: UniversalProfilePhoneInput;
}

export type UniversalProfileContactInformationSaveAction = UniversalProfileAction & {
  __typename?: "UniversalProfileContactInformationSaveAction";
  additionalTravelerIdentifier?: Maybe<Scalars["String"]>;
  analytics: Array<EgClickstreamEvent>;
};

export type UniversalProfileContentHeading = {
  __typename?: "UniversalProfileContentHeading";
  description?: Maybe<Scalars["String"]>;
  subtitle?: Maybe<Scalars["String"]>;
  title?: Maybe<Scalars["String"]>;
};

export interface UniversalProfileContextInput {
  accountTakeOverWidgets?: InputMaybe<Array<UniversalProfileAccountTakeOverWidgetRequestInput>>;
  additionalTravelerIdentifier?: InputMaybe<Scalars["String"]>;
  experienceType?: InputMaybe<UniversalProfileExperienceType>;
  informationFormType?: InputMaybe<UniversalProfileInformationFormType>;
  settingsFormType?: InputMaybe<UniversalProfileSettingsFormType>;
}

export type UniversalProfileContinueAction = UniversalProfileAction & {
  __typename?: "UniversalProfileContinueAction";
  analytics: Array<EgClickstreamEvent>;
};

export type UniversalProfileCopySupportInfoAction = UniversalProfileAction & {
  __typename?: "UniversalProfileCopySupportInfoAction";
  analytics: Array<EgClickstreamEvent>;
};

export type UniversalProfileCountryField = {
  __typename?: "UniversalProfileCountryField";
  country: UniversalProfileBasicRadioGroup;
  heading: UniversalProfileContentHeading;
};

export type UniversalProfileCountryForm = {
  __typename?: "UniversalProfileCountryForm";
  confirmation: UniversalProfileSettingsBasicForm;
  country: UniversalProfileSettingsBasicForm;
};

export type UniversalProfileCountrySaveAction = UniversalProfileAction & {
  __typename?: "UniversalProfileCountrySaveAction";
  analytics: Array<EgClickstreamEvent>;
};

export type UniversalProfileDashboard = {
  __typename?: "UniversalProfileDashboard";
  heading: UniversalProfileHeading;
  options: Array<UniversalProfileDashboardMessagingCard>;
  signOutButton: UniversalProfileButton;
};

export type UniversalProfileDashboardMessagingCard = {
  __typename?: "UniversalProfileDashboardMessagingCard";
  action?: Maybe<UniversalProfileAction>;
  analytics?: Maybe<Array<EgClickstreamEvent>>;
  card: EgdsStandardMessagingCard;
  type: UniversalProfileDashboardOptionType;
};

export type UniversalProfileDashboardOptionType =
  | "COMMUNICATIONS"
  | "COUPONS_AND_CREDITS"
  | "HELP"
  | "PAYMENTS"
  | "PROFILE"
  | "REVIEWS"
  | "SETTINGS";

export type UniversalProfileDateOfBirthField = {
  __typename?: "UniversalProfileDateOfBirthField";
  day: UniversalProfileNumberInputField;
  heading: UniversalProfileContentHeading;
  month: UniversalProfileNumberInputField;
  validation?: Maybe<Array<UniversalProfileValidationRule>>;
  year: UniversalProfileNumberInputField;
};

export type UniversalProfileDefaultAttribute = {
  __typename?: "UniversalProfileDefaultAttribute";
  attribute: Scalars["String"];
  value: Scalars["String"];
};

export type UniversalProfileDeleteAccountAction = UniversalProfileAction & {
  __typename?: "UniversalProfileDeleteAccountAction";
  analytics: Array<EgClickstreamEvent>;
};

export type UniversalProfileDeleteAccountForm = {
  __typename?: "UniversalProfileDeleteAccountForm";
  accountVerification: UniversalProfileSettingsBasicForm;
  confirmation?: Maybe<UniversalProfileSettingsBasicForm>;
  reason: UniversalProfileSettingsBasicForm;
  unableDelete?: Maybe<UniversalProfileSettingsBasicForm>;
};

export type UniversalProfileDeleteAccountViewAction = UniversalProfileAction & {
  __typename?: "UniversalProfileDeleteAccountViewAction";
  analytics: Array<EgClickstreamEvent>;
};

export type UniversalProfileEmailEditAction = UniversalProfileAction & {
  __typename?: "UniversalProfileEmailEditAction";
  analytics: Array<EgClickstreamEvent>;
};

export type UniversalProfileEmailField = {
  __typename?: "UniversalProfileEmailField";
  email: UniversalProfileEmailInputField;
  heading: UniversalProfileContentHeading;
};

export type UniversalProfileEmailForm = {
  __typename?: "UniversalProfileEmailForm";
  email: UniversalProfileSettingsBasicForm;
};

export type UniversalProfileEmailFormAction = UniversalProfileAction & {
  __typename?: "UniversalProfileEmailFormAction";
  analytics: Array<EgClickstreamEvent>;
};

export type UniversalProfileEmailInputField = UniversalProfileInput & {
  __typename?: "UniversalProfileEmailInputField";
  analytics?: Maybe<Array<EgClickstreamEvent>>;
  input: EgdsEmailInputField;
  validation?: Maybe<Array<UniversalProfileValidationRule>>;
};

export type UniversalProfileEmailView = {
  __typename?: "UniversalProfileEmailView";
  changeLink?: Maybe<UniversalProfileStandardLink>;
  email: UniversalProfileAttribute;
};

export type UniversalProfileEmergencyContactField = {
  __typename?: "UniversalProfileEmergencyContactField";
  heading: UniversalProfileContentHeading;
  name: UniversalProfileTextInputField;
  phone: UniversalProfilePhoneField;
};

export interface UniversalProfileEmergencyContactInput {
  name?: InputMaybe<Scalars["String"]>;
  phone: UniversalProfilePhoneInput;
}

export type UniversalProfileErrorResponse = {
  __typename?: "UniversalProfileErrorResponse";
  accountTakeOverWidgets?: Maybe<Array<UniversalProfileAccountTakeOverWidget>>;
  analytics?: Maybe<Array<EgClickstreamEvent>>;
  errorSummary?: Maybe<UniversalProfileErrorSummary>;
};

export type UniversalProfileErrorSummary = {
  __typename?: "UniversalProfileErrorSummary";
  summary: EgdsErrorSummary;
};

export type UniversalProfileExpandoContent = UniversalProfileAdditionalTravelerContent;

export type UniversalProfileExperience = UniversalProfileTravelerInformation | UniversalProfileTravelerSettings;

export type UniversalProfileExperienceType = "HELP" | "PROFILE" | "SETTINGS";

export type UniversalProfileExternalRedirectAction = UniversalProfileAction & {
  __typename?: "UniversalProfileExternalRedirectAction";
  analytics: Array<EgClickstreamEvent>;
  redirectUrl: Scalars["String"];
};

export type UniversalProfileForgotPasswordAction = UniversalProfileAction & {
  __typename?: "UniversalProfileForgotPasswordAction";
  analytics: Array<EgClickstreamEvent>;
};

export type UniversalProfileGenderField = {
  __typename?: "UniversalProfileGenderField";
  gender: UniversalProfileBasicRadioGroup;
  heading: UniversalProfileContentHeading;
};

export type UniversalProfileHeading = {
  __typename?: "UniversalProfileHeading";
  description?: Maybe<Scalars["String"]>;
  subtitle?: Maybe<Scalars["String"]>;
  title?: Maybe<Scalars["String"]>;
};

export type UniversalProfileInformation = {
  __typename?: "UniversalProfileInformation";
  edit: UniversalProfileButton;
  heading: UniversalProfileHeading;
  information: Array<UniversalProfileAttribute>;
};

export type UniversalProfileInformationBasicForm = {
  __typename?: "UniversalProfileInformationBasicForm";
  cancelButton?: Maybe<UniversalProfileButton>;
  content: Array<UniversalProfileInformationFormContent>;
  errorSummary?: Maybe<UniversalProfileErrorSummary>;
  heading: UniversalProfileHeading;
  saveButton?: Maybe<UniversalProfileButton>;
  title: Scalars["String"];
};

export type UniversalProfileInformationForm =
  | UniversalProfileBasicInformationForm
  | UniversalProfileContactInformationForm;

export type UniversalProfileInformationFormContent =
  | UniversalProfileAboutYouField
  | UniversalProfileAccessibilityNeedsField
  | UniversalProfileAddressField
  | UniversalProfileDateOfBirthField
  | UniversalProfileEmailView
  | UniversalProfileEmergencyContactField
  | UniversalProfileGenderField
  | UniversalProfileNameField
  | UniversalProfilePhoneField;

export type UniversalProfileInformationFormType = "UPDATE_BASIC_INFORMATION" | "UPDATE_CONTACT_INFORMATION";

export interface UniversalProfileInput {
  analytics?: Maybe<Array<EgClickstreamEvent>>;
  validation?: Maybe<Array<UniversalProfileValidationRule>>;
}

export type UniversalProfileIntegerRangeValidationRule = UniversalProfileValidationRule & {
  __typename?: "UniversalProfileIntegerRangeValidationRule";
  errorMessage: Scalars["String"];
  max: Scalars["Int"];
  min: Scalars["Int"];
};

export type UniversalProfileLanguageField = {
  __typename?: "UniversalProfileLanguageField";
  heading: UniversalProfileContentHeading;
  language: UniversalProfileBasicRadioGroup;
};

export type UniversalProfileLanguageForm = {
  __typename?: "UniversalProfileLanguageForm";
  language: UniversalProfileSettingsBasicForm;
};

export type UniversalProfileLocationAndLanguage = {
  __typename?: "UniversalProfileLocationAndLanguage";
  heading: UniversalProfileHeading;
  options: Array<UniversalProfileLocationAndLanguageMessagingCard>;
};

export type UniversalProfileLocationAndLanguageMessagingCard = {
  __typename?: "UniversalProfileLocationAndLanguageMessagingCard";
  action?: Maybe<UniversalProfileAction>;
  card: EgdsStandardMessagingCard;
  enabled: Scalars["Boolean"];
  type: UniversalProfileLocationAndLanguageOptionType;
};

export type UniversalProfileLocationAndLanguageOptionType = "COUNTY" | "CURRENCY" | "LANGUAGE";

export type UniversalProfileLoginAndSecurity = {
  __typename?: "UniversalProfileLoginAndSecurity";
  heading: UniversalProfileHeading;
  options: Array<UniversalProfileLoginAndSecurityMessagingCard>;
};

export type UniversalProfileLoginAndSecurityMessagingCard = {
  __typename?: "UniversalProfileLoginAndSecurityMessagingCard";
  action?: Maybe<UniversalProfileAction>;
  card: EgdsStandardMessagingCard;
  type: UniversalProfileLoginAndSecurityOptionType;
};

export type UniversalProfileLoginAndSecurityOptionType = "CONNECTED_DEVICES" | "EMAIL" | "PASSWORD" | "SOCIAL_ACCOUNTS";

export type UniversalProfileMoreDetails = {
  __typename?: "UniversalProfileMoreDetails";
  heading: UniversalProfileHeading;
  options: Array<UniversalProfileMoreDetailsMessagingCard>;
};

export type UniversalProfileMoreDetailsMessagingCard = {
  __typename?: "UniversalProfileMoreDetailsMessagingCard";
  action?: Maybe<UniversalProfileAction>;
  card: EgdsStandardMessagingCard;
  type: UniversalProfileMoreDetailsOptionType;
};

export type UniversalProfileMoreDetailsOptionType =
  | "AIRPORT_SECURITY"
  | "FLIGHT_PREFERENCES"
  | "REWARD_PROGRAM"
  | "TRAVELER_DOCUMENTS";

export type UniversalProfileNameField = {
  __typename?: "UniversalProfileNameField";
  firstName: UniversalProfileTextInputField;
  heading: UniversalProfileContentHeading;
  lastName: UniversalProfileTextInputField;
  middleName?: Maybe<UniversalProfileTextInputField>;
};

export type UniversalProfileNumberInputField = UniversalProfileInput & {
  __typename?: "UniversalProfileNumberInputField";
  analytics?: Maybe<Array<EgClickstreamEvent>>;
  input: EgdsNumberInputField;
  validation?: Maybe<Array<UniversalProfileValidationRule>>;
};

export type UniversalProfilePasswordCheckAction = UniversalProfileAction & {
  __typename?: "UniversalProfilePasswordCheckAction";
  analytics: Array<EgClickstreamEvent>;
};

export type UniversalProfilePasswordEditAction = UniversalProfileAction & {
  __typename?: "UniversalProfilePasswordEditAction";
  analytics: Array<EgClickstreamEvent>;
};

export type UniversalProfilePasswordField = {
  __typename?: "UniversalProfilePasswordField";
  heading: UniversalProfileContentHeading;
  password: UniversalProfilePasswordInputField;
};

export type UniversalProfilePasswordForm = {
  __typename?: "UniversalProfilePasswordForm";
  newPassword: UniversalProfileSettingsBasicForm;
  validateAccount: UniversalProfileSettingsBasicForm;
};

export type UniversalProfilePasswordInputField = UniversalProfileInput & {
  __typename?: "UniversalProfilePasswordInputField";
  analytics?: Maybe<Array<EgClickstreamEvent>>;
  input: EgdsPasswordInputField;
  validation?: Maybe<Array<UniversalProfileValidationRule>>;
};

export type UniversalProfilePhoneField = {
  __typename?: "UniversalProfilePhoneField";
  countryCode: UniversalProfileBasicSelect;
  heading: UniversalProfileContentHeading;
  number: UniversalProfileNumberInputField;
  smsInfo?: Maybe<UniversalProfileBasicCheckBox>;
};

export interface UniversalProfilePhoneInput {
  countryCode?: InputMaybe<Scalars["String"]>;
  number?: InputMaybe<Scalars["String"]>;
  smsInfo?: InputMaybe<Scalars["Boolean"]>;
}

export type UniversalProfilePreferences = {
  __typename?: "UniversalProfilePreferences";
  heading: UniversalProfileHeading;
  options: Array<UniversalProfilePreferencesMessagingCard>;
  subOptions: Array<UniversalProfileBrandPreferences>;
};

export type UniversalProfilePreferencesMessagingCard = {
  __typename?: "UniversalProfilePreferencesMessagingCard";
  action?: Maybe<UniversalProfileAction>;
  card: EgdsStandardMessagingCard;
  type: UniversalProfilePreferencesOptionType;
};

export type UniversalProfilePreferencesOptionType = "EXPEDIA" | "HOTELS" | "VRBO";

export type UniversalProfilePrivacy = {
  __typename?: "UniversalProfilePrivacy";
  browsingHistory: UniversalProfileBrowsingHistory;
  heading: UniversalProfileHeading;
  options: Array<UniversalProfileButton>;
};

export type UniversalProfilePrivacyAction = UniversalProfileAction & {
  __typename?: "UniversalProfilePrivacyAction";
  analytics: Array<EgClickstreamEvent>;
};

export type UniversalProfileReasonLeavingField = {
  __typename?: "UniversalProfileReasonLeavingField";
  checkboxGroup: UniversalProfileCheckBoxGroup;
  heading: UniversalProfileContentHeading;
};

export type UniversalProfileRedirectAction = UniversalProfileAction & {
  __typename?: "UniversalProfileRedirectAction";
  analytics: Array<EgClickstreamEvent>;
  redirectUrl: Scalars["String"];
};

export type UniversalProfileRegexValidationRule = UniversalProfileValidationRule & {
  __typename?: "UniversalProfileRegexValidationRule";
  errorMessage: Scalars["String"];
  regex: Scalars["String"];
};

export type UniversalProfileResponse = {
  __typename?: "UniversalProfileResponse";
  /** Universal Profile Dashboard */
  dashboard: UniversalProfileDashboard;
  /** Profile Information Section */
  travelerInformation: UniversalProfileExperience;
  /** Profile Information Section */
  travelerInformationForm: UniversalProfileInformationForm;
  /** Profile Information Section */
  travelerSettingsForm: UniversalProfileSettingsForm;
};

export type UniversalProfileResponseDashboardArgs = {
  universalProfileContext: UniversalProfileContextInput;
};

export type UniversalProfileResponseTravelerInformationArgs = {
  universalProfileContext: UniversalProfileContextInput;
};

export type UniversalProfileResponseTravelerInformationFormArgs = {
  universalProfileContext: UniversalProfileContextInput;
};

export type UniversalProfileResponseTravelerSettingsFormArgs = {
  universalProfileContext: UniversalProfileContextInput;
};

export type UniversalProfileSettingsBasicForm = {
  __typename?: "UniversalProfileSettingsBasicForm";
  cancelButton?: Maybe<UniversalProfileButton>;
  content: Array<UniversalProfileSettingsFormContent>;
  errorSummary?: Maybe<UniversalProfileErrorSummary>;
  heading: UniversalProfileHeading;
  saveButton?: Maybe<UniversalProfileButton>;
};

export type UniversalProfileSettingsForm =
  | UniversalProfileCountryForm
  | UniversalProfileDeleteAccountForm
  | UniversalProfileEmailForm
  | UniversalProfileLanguageForm
  | UniversalProfilePasswordForm;

export type UniversalProfileSettingsFormContent =
  | UniversalProfileButton
  | UniversalProfileConfirmationLeavingView
  | UniversalProfileCountryField
  | UniversalProfileEmailField
  | UniversalProfileEmailView
  | UniversalProfileLanguageField
  | UniversalProfilePasswordField
  | UniversalProfileReasonLeavingField
  | UniversalProfileStrengthMeter;

export type UniversalProfileSettingsFormType =
  | "DELETE_ACCOUNT"
  | "UPDATE_COUNTRY"
  | "UPDATE_EMAIL"
  | "UPDATE_LANGUAGE"
  | "UPDATE_PASSWORD";

export type UniversalProfileSignOutAction = UniversalProfileAction & {
  __typename?: "UniversalProfileSignOutAction";
  analytics: Array<EgClickstreamEvent>;
};

export type UniversalProfileStandardLink = {
  __typename?: "UniversalProfileStandardLink";
  action: UniversalProfileAction;
  disabled: Scalars["Boolean"];
  text: Scalars["String"];
};

export type UniversalProfileStrengthMeter = {
  __typename?: "UniversalProfileStrengthMeter";
  heading: UniversalProfileContentHeading;
};

export type UniversalProfileSuccessResponse = {
  __typename?: "UniversalProfileSuccessResponse";
  analytics?: Maybe<Array<EgClickstreamEvent>>;
  message: UniversalProfileToast;
};

export type UniversalProfileTextInputField = UniversalProfileInput & {
  __typename?: "UniversalProfileTextInputField";
  analytics?: Maybe<Array<EgClickstreamEvent>>;
  input: EgdsTextInputField;
  validation?: Maybe<Array<UniversalProfileValidationRule>>;
};

export type UniversalProfileToast = {
  __typename?: "UniversalProfileToast";
  toast: EgdsToast;
};

/** Universal Profile, Profile Page Experience */
export type UniversalProfileTravelerInformation = {
  __typename?: "UniversalProfileTravelerInformation";
  additionalTravelers?: Maybe<UniversalProfileAdditionalTravelers>;
  basicInformation: UniversalProfileInformation;
  contactInformation: UniversalProfileInformation;
  heading: UniversalProfileHeading;
  moreDetails?: Maybe<UniversalProfileMoreDetails>;
};

/** Universal Profile, Settings Page Experience */
export type UniversalProfileTravelerSettings = {
  __typename?: "UniversalProfileTravelerSettings";
  heading: UniversalProfileHeading;
  loginAndSecurity: UniversalProfileLoginAndSecurity;
  preferences: UniversalProfilePreferences;
  privacy: UniversalProfilePrivacy;
  userAccount: UniversalProfileUserAccountSettings;
};

export type UniversalProfileUserAccountSettings = {
  __typename?: "UniversalProfileUserAccountSettings";
  deleteAccount: UniversalProfileButton;
  heading: UniversalProfileHeading;
};

export interface UniversalProfileValidationRule {
  errorMessage: Scalars["String"];
}

/** Enum for holding values with reference to page stack history */
export type UpdateHistory = "REMOVE";

export interface UpdateInsurtechOfferRequestInput {
  /** The cart ID */
  cartId: Scalars["String"];
  /** list of offer tokens to be added to the main offer */
  offersToAdd: Array<OfferIdentityInput>;
  /** list of offer ids to be removed from the main offer */
  offersToRemove: Array<OfferIdentityInput>;
  /** The identity of the target offer to be updated, e.g.: Hotel, Flight, Car, etc. */
  targetOfferIdentity: OfferIdentityInput;
}

export type UpdateInsurtechOfferResponse = {
  __typename?: "UpdateInsurtechOfferResponse";
  /** message that will be shown according to the action status. */
  message?: Maybe<Scalars["String"]>;
  /** The selected offer identities in the cart that will be needed in case of deletion. */
  selectedOffers: Array<OfferIdentity>;
  /** Status of the update action */
  status: InsurtechMutationStatus;
};

export type UpdatePresence = {
  __typename?: "UpdatePresence";
  currentState: AgentState;
  message: Scalars["String"];
};

export type UpdateTripType = "ADD" | "REMOVE";

export type UpvotePropertyReviewWithAccessibility = AccessibilityField & {
  __typename?: "UpvotePropertyReviewWithAccessibility";
  /** Label where a11y behavior is needed. */
  accessibilityLabel?: Maybe<Scalars["String"]>;
  /**
   * Message for a11y label.
   * @deprecated Use accessibilityLabel, replace with accessibilityLabel
   */
  label?: Maybe<Scalars["String"]>;
  /** String to be displayed after mutation is performed */
  primaryDisplayString?: Maybe<Scalars["String"]>;
};

export type Uri = Uri & {
  __typename?: "Uri";
  value: Scalars["String"];
};

export interface UriAttributesInput {
  /**
   * Used to specify the GAIA feature TYPE
   * Example Value: Multi-City
   */
  gaiaType?: InputMaybe<Scalars["String"]>;
  lodgingUrlCode?: InputMaybe<Scalars["String"]>;
}

export interface UriContextAttributesInput {
  affinity?: InputMaybe<Scalars["String"]>;
  airCarrierCode?: InputMaybe<Scalars["String"]>;
  carClass?: InputMaybe<Scalars["String"]>;
  carSupplier?: InputMaybe<Scalars["String"]>;
  gaiaType?: InputMaybe<Scalars["String"]>;
  lodgingUrlCode?: InputMaybe<Scalars["String"]>;
  starRating?: InputMaybe<Scalars["String"]>;
}

export interface UriContextIdentifiersInput {
  destination: Scalars["String"];
  /** Only for PDP pages */
  hotelId?: InputMaybe<Scalars["Int"]>;
  origin?: InputMaybe<Scalars["String"]>;
}

/**
 * A context that can be used to retrieve targeted flex content
 * with combination of attributes and identifiers that uniquely identify a URI.
 */
export interface UriContextInput {
  /** The attribute categorises groups of similar URIs */
  attributes?: InputMaybe<UriAttributesInput>;
  /** Identifiers are the subcomponents that uniquely identify a URI */
  identifiers?: InputMaybe<UriIdentifiersInput>;
}

/** A identifiers list that can be used to uniquely identify a URI. */
export interface UriIdentifiersInput {
  /**
   * Used to specify the accommodation type.
   * Example Value: Apartments
   */
  accommodationType?: InputMaybe<Scalars["String"]>;
  /**
   * Used to specify airports city GAIA feature ID
   * Example Value: 178279
   */
  airport?: InputMaybe<Scalars["String"]>;
  /**
   * Used to specify the brand.
   * Example Value: Travelodge UK
   */
  brand?: InputMaybe<Scalars["String"]>;
  /**
   * Used to specify the car class.
   * Example Value: Economy
   */
  carClass?: InputMaybe<Scalars["String"]>;
  /**
   * Used to specify the car supplier location ID (aka CVL ID).
   * Example Value: 12245
   */
  carSupplierLocation?: InputMaybe<Scalars["String"]>;
  /**
   * Used to specify the carrier code.
   * Example Value: BA
   */
  carrierCode?: InputMaybe<Scalars["String"]>;
  /**
   * Used to specify vendor ID
   * Example Value: ET
   */
  company?: InputMaybe<Scalars["String"]>;
  /**
   * Used to specify the cruise line ID
   * Example Value: CV
   */
  cruiseLine?: InputMaybe<Scalars["String"]>;
  /**
   * Used to specify the GAIA feature ID of destination
   * Example Value:
   */
  destination?: InputMaybe<Scalars["String"]>;
  /**
   * Used to specify the discriminator for hotel landing pages
   * Example Value: ho
   */
  discriminator?: InputMaybe<Scalars["String"]>;
  /**
   * Used to specify current screen feature displayed to user
   * Example Value: reviews, lodgingDiscovery, destinationDiscovery
   */
  feature?: InputMaybe<Scalars["String"]>;
  /**
   * Used to specify the flight route type
   * Example Value: open / fixed
   */
  flightRoute?: InputMaybe<Scalars["String"]>;
  /**
   * Used to specify current location of user in the conversion funnel
   * Example Value: entry
   */
  funnelLocation?: InputMaybe<Scalars["String"]>;
  /**
   * Used to specify the hotel ID
   * Example Value: 1
   */
  hotel?: InputMaybe<Scalars["String"]>;
  /**
   * Used to specify hotel PCS ID for HCOM pages
   * Example Value: 456469
   */
  id?: InputMaybe<Scalars["String"]>;
  /**
   * Used to specify the line of business
   * Example Value: flight
   */
  lineOfBusiness?: InputMaybe<Scalars["String"]>;
  /**
   * Used to specify the type of lodging
   * Example Value: alternative
   */
  lodgingType?: InputMaybe<Scalars["String"]>;
  /**
   * Used to specify the GAIA feature ID of origin
   * Example Value: 178286
   */
  origin?: InputMaybe<Scalars["String"]>;
  /**
   * Used to specify the ship code of the ship
   * Example Value: AVW
   */
  ship?: InputMaybe<Scalars["String"]>;
  /**
   * Used to specify the hotel's star rating
   * Source of truth is flex-hotels-service
   * Example Value: 5
   */
  starRating?: InputMaybe<Scalars["String"]>;
  /**
   * Used to specify the hotel's theme
   * Source of truth is affinity prime
   * Example Value: romantic
   */
  theme?: InputMaybe<Scalars["String"]>;
  /**
   * Used to specify the url mapping path, without leading '/'
   * Example Value: lp/deals
   */
  url?: InputMaybe<Scalars["String"]>;
}

export type User = {
  __typename?: "User";
  /** Email address */
  email?: Maybe<Scalars["String"]>;
  /** User's roles */
  roles?: Maybe<Array<Maybe<Scalars["String"]>>>;
  /** Travel User ID */
  tuid?: Maybe<Scalars["Int"]>;
  /** Identifies a user */
  userId?: Maybe<Scalars["String"]>;
};

/** Question asked by any user */
export type UserAnswer = {
  __typename?: "UserAnswer";
  /** Answer Text */
  answer: Scalars["String"];
  /** Answer submitted time */
  answerTime: DateTime;
  /** Localised string to show the reviewer name on PWA, This is combination of name from replierType */
  displayName?: Maybe<Scalars["String"]>;
  /** Unique identifier of a answer */
  id: Scalars["String"];
  /** Upvote counts for this answer */
  upVotes: FormattedNumber;
};

export type UserContext = {
  __typename?: "UserContext";
  /** Details about the agency */
  agency?: Maybe<Agency>;
  /** Details about the user */
  user?: Maybe<User>;
};

export interface UserContextInput {
  siteId: Scalars["Int"];
  tuid: Scalars["Int"];
}

export type UserFeedback = {
  __typename?: "UserFeedback";
  options: Array<UserFeedbackOption>;
  submit: CarActionableItem;
  submitConfirmation: Scalars["String"];
  userSurveyTitle: Scalars["String"];
};

export type UserFeedbackOption = {
  __typename?: "UserFeedbackOption";
  inputHeading: Scalars["String"];
  inputTextPlaceholder: Scalars["String"];
  option: CarActionableItem;
};

export type UserInformationQueryResult = {
  __typename?: "UserInformationQueryResult";
  /** egaid for user */
  egaid: Scalars["String"];
  /** Email for user */
  emailAddress: Scalars["String"];
  /** expuId for user */
  expuId: Scalars["String"];
  /** User last name */
  familyName: Scalars["String"];
  /** User first name */
  firstName: Scalars["String"];
  /** User token for a given user */
  userToken: Scalars["String"];
};

export interface UserLocationInput {
  userCountryCode?: InputMaybe<Scalars["String"]>;
  userLatitude?: InputMaybe<Scalars["BigDecimal"]>;
  userLongitude?: InputMaybe<Scalars["BigDecimal"]>;
  userSelectedOrigin?: InputMaybe<Scalars["String"]>;
}

/** List of user generated QuestionsAnswers resposes */
export type UserQuestion = {
  __typename?: "UserQuestion";
  /** Answers provided by different users */
  answers?: Maybe<Array<UserAnswer>>;
  /** Question posted time */
  createDate?: Maybe<DateTime>;
  /** Unique identifier for a Question */
  id: Scalars["String"];
  /** Question asked by user */
  question: Scalars["String"];
  /** Name of the questioner */
  questioner?: Maybe<Scalars["String"]>;
  /** Total Answer count for the question */
  totalAnswers: FormattedNumber;
};

export type VaConversationProperties = {
  __typename?: "VAConversationProperties";
  /** Value to pass as the indicator where the VA was launched from. */
  launchPoint?: Maybe<Scalars["String"]>;
};

/** VacOrchestrator configuration used to initialize instance(s) of VacLite. */
export type VacOrchestrator = {
  __typename?: "VacOrchestrator";
  /** Authentication object used to initialize Web Socket connection. */
  auth: VacOrchestratorAuthentication;
};

/** Represents the information required for establishing websocket connection */
export type VacOrchestratorAuthentication = {
  __typename?: "VacOrchestratorAuthentication";
  /** Represents the channel to which the UI should listen for messages */
  subscriptionId: Scalars["String"];
  /** Represents the token required to connect to ably server */
  token: Scalars["String"];
};

/** Vehicle details returned in details api response */
export type VehicleDetails = {
  __typename?: "VehicleDetails";
  attributes: Array<VehicleFeature>;
  category: Scalars["String"];
  description?: Maybe<Scalars["String"]>;
  features: Array<VehicleFeature>;
  fuelInfo: Array<VehicleFeature>;
  image?: Maybe<Image>;
};

export type VehicleFeature = {
  __typename?: "VehicleFeature";
  icon?: Maybe<Icon>;
  info?: Maybe<VehicleFeatureInfo>;
  text: Scalars["String"];
};

export type VehicleFeatureInfo = {
  __typename?: "VehicleFeatureInfo";
  carActionableItem: CarActionableItem;
  vehicleFeatureDialog: CarsDialog;
};

export type Video = {
  __typename?: "Video";
  /** The localized text describing the video */
  description: Scalars["String"];
  /** Play or Pause analytics */
  playPauseAnalytics?: Maybe<ClientSideAnalytics>;
  /** Thumbnail of the video */
  thumbnail?: Maybe<Uri>;
  /** thumbnail video click analytics */
  thumbnailClickAnalytics?: Maybe<ClientSideAnalytics>;
  url: Uri;
};

export type ViewModel = {
  __typename?: "ViewModel";
  id?: Maybe<Scalars["String"]>;
  name?: Maybe<Scalars["String"]>;
};

export type ViewState = {
  __typename?: "ViewState";
  /** The latitude in which to focus */
  latitude?: Maybe<Scalars["Float"]>;
  /** The longitude in which to focus */
  longitude?: Maybe<Scalars["Float"]>;
  /** The amount in which to zoom in */
  zoom?: Maybe<Scalars["Int"]>;
};

export type VirtualAgentCancelIntentMessage = VirtualAgentIntentMessage & {
  __typename?: "VirtualAgentCancelIntentMessage";
  action: Scalars["String"];
  emailAddress?: Maybe<Scalars["String"]>;
  intent: Scalars["String"];
  orderLineId: Scalars["String"];
  orderNumber: Scalars["String"];
  product: Scalars["String"];
};

/** Represents the virtual agent checkout response */
export type VirtualAgentCheckoutResponse = {
  __typename?: "VirtualAgentCheckoutResponse";
  /** Represents the status of response */
  status: VirtualAgentCheckoutStatus;
};

/** Represents the status of response */
export type VirtualAgentCheckoutStatus = "FAILED" | "SUCCESS";

/** Represents the virtual agent context */
export interface VirtualAgentContextInput {
  /** Represents the intended itinerary number to change */
  itineraryNumber: Scalars["String"];
  /** Represents the token which is used in exchange of information */
  opaqueToken: Scalars["String"];
}

/** Represents VAC lite */
export type VirtualAgentControl = {
  __typename?: "VirtualAgentControl";
  /** VAC chat */
  chat: VirtualAgentControlChat;
  conversationIdentifiers: ConversationIdentifiers;
  /** VAC Trigger */
  trigger?: Maybe<VirtualAgentControlTrigger>;
};

/** Union of AvatarGroup */
export type VirtualAgentControlAvatar = AvatarGroup;

/** Represents VAC Chat */
export type VirtualAgentControlChat = {
  __typename?: "VirtualAgentControlChat";
  /** footer on VAC */
  footer: VirtualAgentControlChatFooter;
  /** header on VAC */
  header?: Maybe<VirtualAgentControlChatHeader>;
};

/** Represents the Chat content to be rendered between the Header and Footer */
export type VirtualAgentControlChatContent = {
  __typename?: "VirtualAgentControlChatContent";
  /** Represents the list Chat elements to display within this Chat */
  elements: Array<VirtualAgentControlChatElement>;
};

/** Union of VirtualAgentControlInboundMessageGroup, VirtualAgentControlOutboundMessageGroup and VirtualAgentControlMessageSeparator */
export type VirtualAgentControlChatElement =
  | VirtualAgentControlInboundMessageGroup
  | VirtualAgentControlMessageSeparator
  | VirtualAgentControlOutboundMessageGroup;

/** Represents VAC lite footer */
export type VirtualAgentControlChatFooter = {
  __typename?: "VirtualAgentControlChatFooter";
  /** EGDS button to upload attachment on VAC */
  attach?: Maybe<EgdsButton>;
  /** input to type message for sending */
  input: VirtualAgentControlInput;
  /** EGDSbutton to send message on VAC */
  send: EgdsButton;
};

/** Represents VAC lite header */
export type VirtualAgentControlChatHeader = {
  __typename?: "VirtualAgentControlChatHeader";
  /** VAC Avatar */
  avatar: VirtualAgentControlAvatar;
  /** EGDS button to minimize VAC widget */
  minimize?: Maybe<EgdsButton>;
  /** title on the header */
  text: Scalars["String"];
};

/** Represents VAC Inbound Card Message */
export type VirtualAgentControlInboundCardMessage = VirtualAgentControlInboundMessage & {
  __typename?: "VirtualAgentControlInboundCardMessage";
  /** Represents a header level text displayed at the top of the card */
  header?: Maybe<Scalars["String"]>;
  metadata: VirtualAgentControlMessageMetadata;
  /** Represents the primary messaging for this card */
  primary: Scalars["String"];
};

/** Represents fields common in all Inbound message types */
export interface VirtualAgentControlInboundMessage {
  /** Represents metadata associated with this message */
  metadata: VirtualAgentControlMessageMetadata;
}

/** Represents a group of Inbound messages */
export type VirtualAgentControlInboundMessageGroup = {
  __typename?: "VirtualAgentControlInboundMessageGroup";
  /** Represents small text displayed above the message */
  eyebrow?: Maybe<Scalars["String"]>;
  /** Represents Inbound messages contained within the group */
  messages: Array<VirtualAgentControlInboundMessage>;
  /** Represents a group level time stamp */
  timeStamp?: Maybe<Scalars["String"]>;
};

/** Represents VAC Inbound Text Message */
export type VirtualAgentControlInboundTextMessage = VirtualAgentControlInboundMessage & {
  __typename?: "VirtualAgentControlInboundTextMessage";
  metadata: VirtualAgentControlMessageMetadata;
  /** Represents the primary messaging for this card */
  primary: Scalars["String"];
};

/** Union of EGDSTypeaheadInputField, EGDSTextInputField in the text input */
export type VirtualAgentControlInput = EgdsTextInputField | EgdsTypeaheadInputField;

/** Represents VAC input message data */
export interface VirtualAgentControlMessageInput {
  /** Represents the text of message input */
  text: Scalars["String"];
  /** Represents a unique identifier on the UI */
  umid: Scalars["String"];
}

/** Represents VAC message metadata */
export type VirtualAgentControlMessageMetadata = {
  __typename?: "VirtualAgentControlMessageMetadata";
  /** Represents the ID persisted in the Conversation Platform */
  messageId: Scalars["String"];
  /** Represents the time the message was sent */
  timeStamp?: Maybe<Scalars["String"]>;
};

/** Represents VAC message separator */
export type VirtualAgentControlMessageSeparator = {
  __typename?: "VirtualAgentControlMessageSeparator";
  /** Represents the text displaying the time associated with that conversation */
  primary: Scalars["String"];
};

/** Represents VAC Outbound Message */
export type VirtualAgentControlOutboundMessage = {
  __typename?: "VirtualAgentControlOutboundMessage";
  metadata: VirtualAgentControlMessageMetadata;
  /** Represents the user submitted text */
  primary: Scalars["String"];
  /** Represents the status of the message */
  status?: Maybe<Scalars["String"]>;
};

/** Represents VAC Outbound Message Group */
export type VirtualAgentControlOutboundMessageGroup = {
  __typename?: "VirtualAgentControlOutboundMessageGroup";
  /** Represents the Outbound messages contained with this group */
  messages: Array<VirtualAgentControlOutboundMessage>;
  /** Represents a group level status */
  status?: Maybe<Scalars["String"]>;
};

/** Represents the result of send message mutation */
export type VirtualAgentControlSendMessageResult = {
  __typename?: "VirtualAgentControlSendMessageResult";
  /** Represents the delivery status of the input message */
  deliveryStatus: Scalars["String"];
  /** Represents the persisted ID from the conversation platform */
  messageId?: Maybe<Scalars["String"]>;
  /** Represents a unique identifier on the UI */
  umid: Scalars["String"];
};

/** Represents VAC Trigger */
export type VirtualAgentControlTrigger = {
  __typename?: "VirtualAgentControlTrigger";
  /** boolean to decide whether VAC will be autoOpen */
  autoOpen: Scalars["Boolean"];
  /** button to trigger VAC open/close */
  button?: Maybe<VirtualAgentControlTriggerButton>;
};

/** Union of EGDSButton (Primary, Secondary, or Tertiary) and UIFloatingActionButton (Primary or Secondary) */
export type VirtualAgentControlTriggerButton =
  | UiPrimaryButton
  | UiPrimaryFloatingActionButton
  | UiSecondaryButton
  | UiSecondaryFloatingActionButton
  | UiTertiaryButton;

/** The `VirtualAgentConversationProperties` contains properties to be forwarded on to the Virtual Agent Platform */
export type VirtualAgentConversationProperties = {
  __typename?: "VirtualAgentConversationProperties";
  launchPoint?: Maybe<Scalars["String"]>;
  pageName?: Maybe<Scalars["String"]>;
  skipWelcome?: Maybe<Scalars["String"]>;
};

export interface VirtualAgentIntentMessage {
  intent: Scalars["String"];
}

/** The `VirtualAgentIntentValues` contains intent data for VA skills, to be forwarded on to the Virtual Agent Platform */
export type VirtualAgentIntentValue = {
  __typename?: "VirtualAgentIntentValue";
  id: Scalars["String"];
  value: Scalars["String"];
};

/** Representation of a virtual tour prompt */
export type VirtualTourPrompt = {
  __typename?: "VirtualTourPrompt";
  /** Representation of a overlay button */
  button?: Maybe<EgdsOverlayButton>;
  /** Simple text without additional attributes */
  caption?: Maybe<EgdsPlainText>;
  /** Representation of a heading text with different EGDS typography styles */
  heading?: Maybe<EgdsHeading>;
  /** Representation of a photosphere image (360 image) */
  heroImage?: Maybe<EgdsPhotosphereImage>;
  /** URL to locate the virtual tour */
  url?: Maybe<Scalars["URL"]>;
};

export type VoiceOfTheCustomer = {
  __typename?: "VoiceOfTheCustomer";
  /** Represents the accessibility message associated with this trigger */
  accessibilityMessage: Scalars["String"];
  /** Represents the analytics to track on interaction with trigger */
  analytics: ClientSideAnalytics;
  /** Text shown in the actionable area. Example: 'Search for Hotels', 'No Thanks' */
  displayAction: Scalars["String"];
  /** Represents label associated with the action */
  label: Scalars["String"];
  /** Represents the relative destination URL */
  relativeURI: HttpUri;
};

export type VrIntentSignalItem = {
  __typename?: "VrIntentSignalItem";
  /** decision flag to identify card should be shown */
  decision?: Maybe<Scalars["Boolean"]>;
  /** vr card id */
  id?: Maybe<Scalars["String"]>;
  /** prediction value */
  prediction?: Maybe<Scalars["Float"]>;
  /** threshold value */
  threshold?: Maybe<Scalars["Float"]>;
};

export type VrIntentSignalsResult = {
  __typename?: "VrIntentSignalsResult";
  /** list of vr intent signal values  */
  intents: Array<VrIntentSignalItem>;
};

/** Wrapping type for widget components and views */
export type WidgetResponse = LegacyWidgetComponent;

/** Action which instructs clients to retrieve additional inputs via the `inputSource` and call the mutation with the result.This may also be returned as the result of the `userProfileWizardSubmit` mutation if the spinner determines additional information is needed. */
export type WizardAdditionalUserInputRequiredAction = UiAction & {
  __typename?: "WizardAdditionalUserInputRequiredAction";
  accessibility?: Maybe<Scalars["String"]>;
  actionContext: Scalars["String"];
  analytics: ClientSideAnalytics;
  inputSource: WizardAdditionalUserInputSource;
};

/** Represents required inputs needed for a mutation as well as the resource which should be used to retrieve them */
export type WizardAdditionalUserInputSource = {
  __typename?: "WizardAdditionalUserInputSource";
  requestedInputs: Array<Scalars["String"]>;
  resource: Uri;
};

/** Generic action which contains client side analytics along with payload to encapsulate action details */
export type WizardSubmitAction = UiAction & {
  __typename?: "WizardSubmitAction";
  accessibility?: Maybe<Scalars["String"]>;
  /** Opaque property which encapsulates action details. Clients should pass this back in mutation when action is performed. */
  actionContext: Scalars["String"];
  analytics: ClientSideAnalytics;
};

export type WorkFlowItem = {
  __typename?: "WorkFlowItem";
  automationStatus: Scalars["String"];
  channel: Scalars["String"];
  intent: Scalars["String"];
  orderLineId: Scalars["String"];
  product: Scalars["String"];
};

export type WorkerInfo = {
  __typename?: "WorkerInfo";
  instanceId: Scalars["String"];
  workerId: Scalars["String"];
};

/** A common zoned date time */
export type ZonedDateTime = {
  __typename?: "ZonedDateTime";
  /** The day of the month of the date */
  day: Scalars["Int"];
  /**
   * Converts this date-time to the number of seconds from the epoch of 1970-01-01T00:00:00Z
   * @deprecated Use platform formatters and return localized strings instead
   */
  epochSeconds: Scalars["String"];
  /**
   * Format a with a pattern. 'd MMM uuuu' will format 2011-12-03 as '3 Dec 2011'
   * @deprecated Use platform formatters and return localized strings instead
   */
  formatted: Scalars["String"];
  /**
   * Localized full date string e.g. en='Wed, Feb 26' de='Mi., 26. Feb.'
   * @deprecated Use platform formatters and return localized strings instead
   */
  fullDateFormat?: Maybe<Scalars["String"]>;
  /**
   * Localized full time string e.g. en='11:15:14 AM GMT-08:00' de='11:15:12 Uhr'
   * @deprecated Use platform formatters and return localized strings instead
   */
  fullTimeFormat?: Maybe<Scalars["String"]>;
  /** The hour of the datetime */
  hour: Scalars["Int"];
  /**
   * Localized long date string e.g. en='Feb 26, 2020' de='26. Feb. 2020'
   * @deprecated Use platform formatters and return localized strings instead
   */
  longDateFormat?: Maybe<Scalars["String"]>;
  /**
   * Localized long time string e.g. en='11:15AM GMT-8' de='11:15 Uhr GMT-8'
   * @deprecated Use platform formatters and return localized strings instead
   */
  longTimeFormat?: Maybe<Scalars["String"]>;
  /**
   * Localized medium date string e.g. en='Feb 26' de='26. Feb.'
   * @deprecated Use platform formatters and return localized strings instead
   */
  mediumDateFormat?: Maybe<Scalars["String"]>;
  /**
   * Localized medium time string e.g. en='11:06:15AM' de='11:06:20 Uhr'
   * @deprecated Use platform formatters and return localized strings instead
   */
  mediumTimeFormat?: Maybe<Scalars["String"]>;
  /** The minute of the hour */
  minute: Scalars["Int"];
  /** The numeric month of the date */
  month: Scalars["Int"];
  /**
   * Returns the posix format
   * @deprecated Use platform formatters and return localized strings instead
   */
  raw: Scalars["String"];
  /** The second of the minute */
  second: Scalars["Int"];
  /**
   * Localized short date string e.g. en='2/26/2020' de='26.02.2020'
   * @deprecated Use platform formatters and return localized strings instead
   */
  shortDateFormat?: Maybe<Scalars["String"]>;
  /**
   * Localized short time string e.g. en='11:06am' de='11:06 Uhr'
   * @deprecated Use platform formatters and return localized strings instead
   */
  shortTimeFormat?: Maybe<Scalars["String"]>;
  /**
   * Get the timezone offset from UTC in seconds
   * @deprecated Use platform formatters and return localized strings instead
   */
  timeZoneOffsetSeconds: Scalars["Int"];
  /** The four-digit year of the date */
  year: Scalars["Int"];
};

/** A common zoned date time */
export type ZonedDateTimeFormattedArgs = {
  format: Scalars["String"];
};

/** Represent types of click actions */
export type ClickActionType = EgdsStandardLink | UiPrimaryButton | UiSecondaryButton | UiTertiaryButton;

/** Content may contain list of combination of any of these. */
export type Content = EgdsBulletedList | EgdsPlainText | PolicyHtmlContent;

/** Return one of the elements for quote list content */
export type Element = EgdsBasicCheckBox | EgdsPlainText | EgdsStandardLink;

/** Return one or the other model for Legal full Content Header */
export type Header = LegalFullContentHeader;

/** Represent types of list */
export type List = EgdsOrderedList | EgdsTextIconList | EgdsUnorderedList;

/** PolicySection may contain expando list, bulleted list or a link */
export type PolicySection = EgdsBulletedList | EgdsStandardLink | PolicyExpandoList;

/**
 * Represent elements of Long Form text that can be of several types
 *                    to bring a cohesive editorial like experience
 */
export type PortableTextContent =
  | EgdsHeading
  | EgdsInlineLink
  | EgdsLevelList
  | EgdsOrderedList
  | EgdsPlainText
  | EgdsSpannableText
  | EgdsStylizedText
  | EgdsUnorderedList
  | PortableTextHtmlTableSection;

/** Return one or the other model for Legal RnR section */
export type RnrSection = LegalExpandoSection;

export type BlossomNotificationQueryVariables = Exact<{
  context: ContextInput;
  notificationLocation: NotificationLocationOnPage;
  lineOfBusiness: LineOfBusinessDomain;
  funnelLocation: PageLocation;
}>;

export type BlossomNotificationQuery = {
  __typename?: "Query";
  notification: {
    __typename?: "NotificationQuery";
    inlineNotification: {
      __typename?: "InlineNotification";
      type: NotificationType;
      title?: {
        __typename?: "NotificationPhrase";
        items: Array<
          | {
              __typename: "NotificationPhraseLinkNode";
              target?: NotificationLinkTarget | null;
              text: string;
              styles: Array<NotificationPhrasePartStyle>;
              uri?:
                | { __typename: "GeoURI"; value: string }
                | { __typename: "HttpURI"; value: string }
                | { __typename: "MailToURI"; value: string }
                | { __typename: "MobileAppURI"; value: string }
                | { __typename: "TelURI"; value: string }
                | { __typename: "Uri"; value: string }
                | null;
              actions?: Array<
                | { __typename: "NotificationAnalytics"; description?: string | null; referrerId: string }
                | { __typename: "NotificationAnalyticsEgClickstream" }
                | { __typename: "NotificationCookie"; name: string; value: string; expires: string }
                | { __typename: "NotificationMarketing" }
                | { __typename: "NotificationSchema" }
                | { __typename: "NotificationSpecifications" }
              > | null;
            }
          | { __typename: "NotificationPhraseTextNode"; text: string; styles: Array<NotificationPhrasePartStyle> }
        >;
      } | null;
      body?: Array<{
        __typename?: "NotificationPhrase";
        items: Array<
          | {
              __typename: "NotificationPhraseLinkNode";
              target?: NotificationLinkTarget | null;
              id?: string | null;
              text: string;
              styles: Array<NotificationPhrasePartStyle>;
              uri?:
                | { __typename: "GeoURI"; value: string }
                | { __typename: "HttpURI"; value: string }
                | { __typename: "MailToURI"; value: string }
                | { __typename: "MobileAppURI"; value: string }
                | { __typename: "TelURI"; value: string }
                | { __typename: "Uri"; value: string }
                | null;
              actions?: Array<
                | { __typename: "NotificationAnalytics"; description?: string | null; referrerId: string }
                | { __typename: "NotificationAnalyticsEgClickstream" }
                | { __typename: "NotificationCookie"; name: string; value: string; expires: string }
                | { __typename: "NotificationMarketing" }
                | { __typename: "NotificationSchema" }
                | { __typename: "NotificationSpecifications" }
              > | null;
              icon?: { __typename?: "Icon"; id: string; description: string } | null;
            }
          | { __typename: "NotificationPhraseTextNode"; text: string; styles: Array<NotificationPhrasePartStyle> }
        >;
      }> | null;
      containerLink?: {
        __typename?: "NotificationContainerLink";
        target?: NotificationLinkTarget | null;
        uri?:
          | { __typename: "GeoURI"; value: string }
          | { __typename: "HttpURI"; value: string }
          | { __typename: "MailToURI"; value: string }
          | { __typename: "MobileAppURI"; value: string }
          | { __typename: "TelURI"; value: string }
          | { __typename: "Uri"; value: string }
          | null;
        actions?: Array<
          | { __typename: "NotificationAnalytics"; description?: string | null; referrerId: string }
          | { __typename: "NotificationAnalyticsEgClickstream" }
          | { __typename: "NotificationCookie"; name: string; value: string; expires: string }
          | { __typename: "NotificationMarketing" }
          | { __typename: "NotificationSchema" }
          | { __typename: "NotificationSpecifications" }
        > | null;
      } | null;
      logo?: { __typename?: "Image"; description: string; url: any } | null;
      links?: Array<{
        __typename?: "NotificationPhraseLinkNode";
        id?: string | null;
        text: string;
        uri?:
          | { __typename: "GeoURI"; value: string }
          | { __typename: "HttpURI"; value: string }
          | { __typename: "MailToURI"; value: string }
          | { __typename: "MobileAppURI"; value: string }
          | { __typename: "TelURI"; value: string }
          | { __typename: "Uri"; value: string }
          | null;
        icon?: { __typename?: "Icon"; id: string; description: string } | null;
        actions?: Array<
          | { __typename: "NotificationAnalytics"; description?: string | null; referrerId: string }
          | { __typename: "NotificationAnalyticsEgClickstream" }
          | { __typename: "NotificationCookie"; name: string; value: string; expires: string }
          | { __typename: "NotificationMarketing" }
          | { __typename: "NotificationSchema" }
          | { __typename: "NotificationSpecifications" }
        > | null;
      }> | null;
      dismiss?: {
        __typename?: "NotificationDismiss";
        icon: { __typename?: "Icon"; id: string; description: string };
        actions?: Array<
          | { __typename: "NotificationAnalytics"; description?: string | null; referrerId: string }
          | { __typename: "NotificationAnalyticsEgClickstream" }
          | { __typename: "NotificationCookie"; name: string; value: string; expires: string }
          | { __typename: "NotificationMarketing" }
          | { __typename: "NotificationSchema" }
          | { __typename: "NotificationSpecifications" }
        > | null;
      } | null;
      revealActions?: Array<
        | { __typename: "NotificationAnalytics"; description?: string | null; referrerId: string }
        | { __typename: "NotificationAnalyticsEgClickstream" }
        | { __typename: "NotificationCookie"; name: string; value: string; expires: string }
        | { __typename: "NotificationMarketing" }
        | { __typename: "NotificationSchema" }
        | { __typename: "NotificationSpecifications" }
      > | null;
      backgroundImage?: { __typename?: "Image"; url: any } | null;
    };
  };
};

export type CampaignByIdQueryQueryVariables = Exact<{
  productType?: InputMaybe<Array<CampaignProductType> | CampaignProductType>;
  context: ContextInput;
  userLocation?: InputMaybe<UserLocationInput>;
  referrer?: InputMaybe<Scalars["String"]>;
  enableTripAttach?: InputMaybe<Scalars["Boolean"]>;
  displayPropertyCount?: InputMaybe<Scalars["Boolean"]>;
  campaignId: Scalars["String"];
  pageSize?: InputMaybe<Scalars["Int"]>;
  pageNumber: Scalars["Int"];
  enableLivePricing?: InputMaybe<Scalars["Boolean"]>;
  returnPath?: InputMaybe<Scalars["String"]>;
  destinationId?: InputMaybe<Scalars["String"]>;
}>;

export type CampaignByIdQueryQuery = {
  __typename?: "Query";
  campaignRecommendations?: {
    __typename?: "RecommendedCampaigns";
    responseId: any;
    campaigns: Array<{
      __typename?: "CampaignDetail";
      headline: string;
      fromOriginHeaderText?: string | null;
      termsAndConditions: string;
      productTypes: Array<string>;
      recommendedType: RecommendedType;
      campaignId: string;
      campaignContentPaginationInfo?: {
        __typename?: "CampaignContentPaginationInfo";
        hasMoreContentPages: boolean;
      } | null;
      description: { __typename?: "CampaignDescriptions"; short?: string | null; long?: string | null };
      offers?: Array<
        | {
            __typename: "ActivityOfferItem";
            title?: string | null;
            description?: string | null;
            duration?: string | null;
            durationLabel?: string | null;
            city: string;
            province?: string | null;
            dates?: string | null;
            freeCancellationMessage?: string | null;
            name: string;
            secondaryContent?: string | null;
            badge?: { __typename?: "CampaignOfferBadge"; text?: string | null; type: CampaignOfferBadgeType } | null;
            image: { __typename?: "Image"; description: string; url: any };
            activityOffer?: {
              __typename?: "OfferData";
              price: {
                __typename?: "OfferPrice";
                value: string;
                qualifierText: string;
                disclaimerText: string;
                allyText?: string | null;
              };
              strikeThroughPrice?: { __typename?: "OfferPrice"; value: string; qualifierText: string } | null;
              actionLink: { __typename?: "OfferActionLink"; href: string; text: string };
            } | null;
          }
        | {
            __typename: "DestinationOfferItem";
            affinities?: Array<string> | null;
            propertyCount?: string | null;
            dates?: string | null;
            name: string;
            description?: string | null;
            secondaryContent?: string | null;
            lodgingOffer?: {
              __typename?: "OfferData";
              price: { __typename?: "OfferPrice"; value: string; qualifierText: string; disclaimerText: string };
              actionLink: { __typename?: "OfferActionLink"; href: string; text: string };
            } | null;
            flightOffer?: {
              __typename?: "OfferData";
              price: {
                __typename?: "OfferPrice";
                value: string;
                qualifierText: string;
                disclaimerText: string;
                prefixText?: string | null;
              };
              actionLink: { __typename?: "OfferActionLink"; href: string; text: string };
            } | null;
            packageOffer?: {
              __typename?: "OfferData";
              price: {
                __typename?: "OfferPrice";
                value: string;
                qualifierText: string;
                disclaimerText: string;
                prefixText?: string | null;
                checkPriceText?: string | null;
              };
              strikeThroughPrice?: { __typename?: "OfferPrice"; value: string } | null;
              actionLink: { __typename?: "OfferActionLink"; href: string; text: string };
            } | null;
            image: { __typename?: "Image"; description: string; url: any };
          }
        | {
            __typename: "FlightOfferItem";
            airlineName?: string | null;
            originCity?: string | null;
            originAirportCode?: string | null;
            destinationCity?: string | null;
            destinationAirportCode?: string | null;
            tripType?: string | null;
            flightClass?: string | null;
            dates?: string | null;
            name: string;
            description?: string | null;
            secondaryContent?: string | null;
            airlineImage?: { __typename?: "Image"; description: string; url: any } | null;
            flightOffer?: {
              __typename?: "OfferData";
              price: { __typename?: "OfferPrice"; value: string; qualifierText: string; prefixText?: string | null };
              actionLink: { __typename?: "OfferActionLink"; href: string; text: string };
            } | null;
            image: { __typename?: "Image"; description: string; url: any };
          }
        | {
            __typename: "HotelOfferItem";
            location?: string | null;
            starRating?: number | null;
            guestReviewRating?: string | null;
            guestReviewRatingQualifierText?: string | null;
            guestReviewCount?: string | null;
            vipMessage?: string | null;
            freeCancellationMessage?: string | null;
            dates?: string | null;
            name: string;
            description?: string | null;
            secondaryContent?: string | null;
            badge?: { __typename?: "CampaignOfferBadge"; text?: string | null; type: CampaignOfferBadgeType } | null;
            discountBadge?: {
              __typename?: "CampaignOfferBadge";
              text?: string | null;
              type: CampaignOfferBadgeType;
            } | null;
            mod?: {
              __typename?: "MODItem";
              modTagText?: string | null;
              modAvailabilityText?: string | null;
              modSignInText?: string | null;
              signInUrl?: { __typename?: "HttpURI"; value: string; relativePath: string } | null;
            } | null;
            lodgingOffer?: {
              __typename?: "OfferData";
              price: {
                __typename?: "OfferPrice";
                value: string;
                qualifierText: string;
                disclaimerText: string;
                allyText?: string | null;
              };
              strikeThroughPrice?: { __typename?: "OfferPrice"; value: string } | null;
              actionLink: { __typename?: "OfferActionLink"; href: string; text: string };
            } | null;
            image: { __typename?: "Image"; description: string; url: any };
          }
        | {
            __typename: "PackageOfferItem";
            dates?: string | null;
            name: string;
            description?: string | null;
            secondaryContent?: string | null;
            flightOfferItem?: {
              __typename?: "FlightOfferItem";
              airlineName?: string | null;
              originCity?: string | null;
              originAirportCode?: string | null;
              destinationCity?: string | null;
              destinationAirportCode?: string | null;
              airlineImage?: { __typename?: "Image"; description: string; url: any } | null;
            } | null;
            hotelOfferItem?: {
              __typename?: "HotelOfferItem";
              name: string;
              location?: string | null;
              vipMessage?: string | null;
            } | null;
            packageOffer?: {
              __typename?: "OfferData";
              price: {
                __typename?: "OfferPrice";
                value: string;
                qualifierText: string;
                prefixText?: string | null;
                checkPriceText?: string | null;
              };
              actionLink: { __typename?: "OfferActionLink"; href: string; text: string };
            } | null;
            image: { __typename?: "Image"; description: string; url: any };
          }
        | {
            __typename: "PropertyOfferItem";
            name: string;
            description?: string | null;
            secondaryContent?: string | null;
            image: { __typename?: "Image"; description: string; url: any };
          }
      > | null;
    }>;
    paginationInfo: { __typename?: "CampaignPagination"; referrer: string };
  } | null;
};

export type CampaignRecommendationsWithOffersQueryQueryVariables = Exact<{
  numCampaigns: Scalars["Int"];
  pageNumberOfCampaigns: Scalars["Int"];
  maxNumberOfCampaigns?: InputMaybe<Scalars["Int"]>;
  productType?: InputMaybe<Array<CampaignProductType> | CampaignProductType>;
  recommendationType?: InputMaybe<Array<InputMaybe<RecommendedType>> | InputMaybe<RecommendedType>>;
  context: ContextInput;
  userLocation?: InputMaybe<UserLocationInput>;
  referrer?: InputMaybe<Scalars["String"]>;
  userTripState?: InputMaybe<Scalars["String"]>;
  enableLivePricing?: InputMaybe<Scalars["Boolean"]>;
  returnPath?: InputMaybe<Scalars["String"]>;
}>;

export type CampaignRecommendationsWithOffersQueryQuery = {
  __typename?: "Query";
  campaignRecommendations?: {
    __typename?: "RecommendedCampaigns";
    responseId: any;
    campaigns: Array<{
      __typename?: "CampaignDetail";
      headline: string;
      fromOriginHeaderText?: string | null;
      termsAndConditions: string;
      productTypes: Array<string>;
      recommendedType: RecommendedType;
      campaignId: string;
      description: { __typename?: "CampaignDescriptions"; short?: string | null; long?: string | null };
      offers?: Array<
        | {
            __typename: "ActivityOfferItem";
            title?: string | null;
            description?: string | null;
            duration?: string | null;
            durationLabel?: string | null;
            city: string;
            province?: string | null;
            dates?: string | null;
            freeCancellationMessage?: string | null;
            name: string;
            secondaryContent?: string | null;
            badge?: { __typename?: "CampaignOfferBadge"; text?: string | null; type: CampaignOfferBadgeType } | null;
            image: { __typename?: "Image"; description: string; url: any };
            activityOffer?: {
              __typename?: "OfferData";
              price: {
                __typename?: "OfferPrice";
                value: string;
                qualifierText: string;
                disclaimerText: string;
                allyText?: string | null;
              };
              strikeThroughPrice?: { __typename?: "OfferPrice"; value: string; qualifierText: string } | null;
              actionLink: { __typename?: "OfferActionLink"; href: string; text: string };
            } | null;
          }
        | {
            __typename: "DestinationOfferItem";
            affinities?: Array<string> | null;
            dates?: string | null;
            name: string;
            description?: string | null;
            secondaryContent?: string | null;
            lodgingOffer?: {
              __typename?: "OfferData";
              price: {
                __typename?: "OfferPrice";
                value: string;
                qualifierText: string;
                disclaimerText: string;
                prefixText?: string | null;
                checkPriceText?: string | null;
              };
              actionLink: { __typename?: "OfferActionLink"; href: string; text: string };
            } | null;
            flightOffer?: {
              __typename?: "OfferData";
              price: {
                __typename?: "OfferPrice";
                value: string;
                qualifierText: string;
                disclaimerText: string;
                prefixText?: string | null;
                checkPriceText?: string | null;
              };
              actionLink: { __typename?: "OfferActionLink"; href: string; text: string };
            } | null;
            packageOffer?: {
              __typename?: "OfferData";
              price: {
                __typename?: "OfferPrice";
                value: string;
                qualifierText: string;
                disclaimerText: string;
                prefixText?: string | null;
                checkPriceText?: string | null;
              };
              strikeThroughPrice?: { __typename?: "OfferPrice"; value: string } | null;
              actionLink: { __typename?: "OfferActionLink"; href: string; text: string };
            } | null;
            image: { __typename?: "Image"; description: string; url: any };
          }
        | {
            __typename: "FlightOfferItem";
            airlineName?: string | null;
            originCity?: string | null;
            originAirportCode?: string | null;
            destinationCity?: string | null;
            destinationAirportCode?: string | null;
            tripType?: string | null;
            flightClass?: string | null;
            dates?: string | null;
            name: string;
            description?: string | null;
            secondaryContent?: string | null;
            airlineImage?: { __typename?: "Image"; description: string; url: any } | null;
            flightOffer?: {
              __typename?: "OfferData";
              price: { __typename?: "OfferPrice"; value: string; qualifierText: string; prefixText?: string | null };
              actionLink: { __typename?: "OfferActionLink"; href: string; text: string };
            } | null;
            image: { __typename?: "Image"; description: string; url: any };
          }
        | {
            __typename: "HotelOfferItem";
            location?: string | null;
            starRating?: number | null;
            guestReviewRating?: string | null;
            guestReviewRatingQualifierText?: string | null;
            guestReviewCount?: string | null;
            vipMessage?: string | null;
            freeCancellationMessage?: string | null;
            dates?: string | null;
            name: string;
            description?: string | null;
            secondaryContent?: string | null;
            badge?: { __typename?: "CampaignOfferBadge"; text?: string | null; type: CampaignOfferBadgeType } | null;
            discountBadge?: {
              __typename?: "CampaignOfferBadge";
              text?: string | null;
              type: CampaignOfferBadgeType;
            } | null;
            mod?: {
              __typename?: "MODItem";
              modTagText?: string | null;
              modAvailabilityText?: string | null;
              modSignInText?: string | null;
              signInUrl?: { __typename?: "HttpURI"; value: string; relativePath: string } | null;
            } | null;
            lodgingOffer?: {
              __typename?: "OfferData";
              price: {
                __typename?: "OfferPrice";
                value: string;
                qualifierText: string;
                disclaimerText: string;
                allyText?: string | null;
              };
              strikeThroughPrice?: { __typename?: "OfferPrice"; value: string } | null;
              actionLink: { __typename?: "OfferActionLink"; href: string; text: string };
            } | null;
            image: { __typename?: "Image"; description: string; url: any };
          }
        | {
            __typename: "PackageOfferItem";
            dates?: string | null;
            name: string;
            description?: string | null;
            secondaryContent?: string | null;
            flightOfferItem?: {
              __typename?: "FlightOfferItem";
              airlineName?: string | null;
              originCity?: string | null;
              originAirportCode?: string | null;
              destinationCity?: string | null;
              destinationAirportCode?: string | null;
              airlineImage?: { __typename?: "Image"; description: string; url: any } | null;
            } | null;
            hotelOfferItem?: {
              __typename?: "HotelOfferItem";
              name: string;
              location?: string | null;
              vipMessage?: string | null;
            } | null;
            packageOffer?: {
              __typename?: "OfferData";
              price: {
                __typename?: "OfferPrice";
                value: string;
                qualifierText: string;
                prefixText?: string | null;
                checkPriceText?: string | null;
              };
              actionLink: { __typename?: "OfferActionLink"; href: string; text: string };
            } | null;
            image: { __typename?: "Image"; description: string; url: any };
          }
        | {
            __typename: "PropertyOfferItem";
            name: string;
            description?: string | null;
            secondaryContent?: string | null;
            image: { __typename?: "Image"; description: string; url: any };
          }
      > | null;
    }>;
    paginationInfo: { __typename?: "CampaignPagination"; referrer: string; hasNextPage: boolean };
  } | null;
};

export type CustomerPropertySearchByIdQueryQueryVariables = Exact<{
  context: ContextInput;
  destination: DestinationInput;
  criteria?: InputMaybe<PropertySearchCriteriaInput>;
}>;

export type CustomerPropertySearchByIdQueryQuery = {
  __typename?: "Query";
  propertySearch: {
    __typename?: "PropertySearchResults";
    properties: Array<{
      __typename?: "Property";
      name: string;
      id: string;
      infositeURL: string;
      price?: {
        __typename?: "PropertyPrice";
        options?: Array<{
          __typename?: "PropertyPriceOption";
          displayPrice?: {
            __typename?: "Money";
            formatted: string;
            amount: number;
            currencyInfo?: { __typename?: "Currency"; symbol: string; code: string; name: string } | null;
          } | null;
        }> | null;
      } | null;
      image?: { __typename?: "Image"; url: any } | null;
    }>;
    searchCriteria: {
      __typename?: "SearchCriteria";
      dateRange: {
        __typename?: "PropertyDateRange";
        checkInDate: { __typename?: "Date"; isoFormat: string; day: number; month: number; year: number };
        checkOutDate: { __typename?: "Date"; isoFormat: string; day: number; month: number; year: number };
      };
    };
  };
};

export type CustomerSearchHistoryAllQueryQueryVariables = Exact<{
  context: ContextInput;
  lobs?: InputMaybe<Array<HistoryType> | HistoryType>;
  numberOfResults?: InputMaybe<Scalars["Int"]>;
}>;

export type CustomerSearchHistoryAllQueryQuery = {
  __typename?: "Query";
  customer: {
    __typename?: "Customer";
    searchHistory?: Array<{
      __typename?: "History";
      type?: HistoryType | null;
      items?: Array<{
        __typename?: "HistoryItem";
        id?: string | null;
        localizedDateRange?: string | null;
        localizedAsOfDateTime?: string | null;
        lastViewedDate: {
          __typename?: "ZonedDateTime";
          day: number;
          hour: number;
          minute: number;
          second: number;
          month: number;
          year: number;
        };
        startDate: { __typename?: "ZonedDateTime"; raw: string; year: number; month: number; day: number };
        endDate: { __typename?: "ZonedDateTime"; raw: string; year: number; month: number; day: number };
        originalSearchPrice?: {
          __typename?: "Money";
          amount: number;
          formatted: string;
          currencyInfo?: { __typename?: "Currency"; code: string; name: string; symbol: string } | null;
        } | null;
        productInfo?:
          | {
              __typename?: "HistoryActivityDetail";
              name?: string | null;
              duration?: string | null;
              leadTicketType?: string | null;
              searchUrl?: string | null;
              imageUrl?: { __typename?: "Image"; description: string; url: any } | null;
            }
          | {
              __typename?: "HistoryActivitySearch";
              searchUrl?: string | null;
              regionDetail?: { __typename?: "GeographicFeature"; name: string } | null;
            }
          | { __typename?: "HistoryCarDetail" }
          | { __typename?: "HistoryCarSearch" }
          | { __typename?: "HistoryCruiseSearch" }
          | {
              __typename?: "HistoryFlightDetail";
              localizedFlightName?: string | null;
              searchUrl?: string | null;
              routeType?: string | null;
              flightPassengers?: {
                __typename?: "FlightPassengers";
                adults?: number | null;
                agesOfChildren?: Array<number> | null;
              } | null;
            }
          | {
              __typename?: "HistoryFlightSearch";
              localizedFlightName?: string | null;
              searchUrl?: string | null;
              routeType?: string | null;
              flightPassengers?: {
                __typename?: "FlightPassengers";
                adults?: number | null;
                agesOfChildren?: Array<number> | null;
              } | null;
            }
          | {
              __typename?: "HistoryPackageSearch";
              localizedPackageName?: string | null;
              localizedRegionName?: string | null;
              localizedPackagesTemplate?: string | null;
              searchUrl?: string | null;
            }
          | {
              __typename?: "HistoryPropertyDetail";
              regionId?: string | null;
              formattedRating: string;
              formattedReviewCount: string;
              propertyId?: string | null;
              searchUrl?: string | null;
              summary?: { __typename?: "PropertySummary"; id: string; name: string } | null;
              regionDetail?: { __typename?: "GeographicFeature"; name: string } | null;
              reviewInfo?: {
                __typename?: "PropertyReviews";
                summary: {
                  __typename?: "PropertyReviewSummary";
                  averageOverallRating: { __typename?: "FormattedNumber"; formatted: string };
                  totalCount: { __typename?: "FormattedNumber"; formatted: string };
                };
              } | null;
              gallery?: {
                __typename?: "PropertyGallery";
                featured?: { __typename?: "Image"; description: string; url: any } | null;
              } | null;
            }
          | {
              __typename?: "HistoryPropertySearch";
              localizedRoomsTemplate?: string | null;
              searchUrl?: string | null;
              regionDetail?: { __typename?: "GeographicFeature"; name: string } | null;
            }
          | null;
      } | null> | null;
    }> | null;
  };
};

export type CustomerSearchHistoryQueryQueryVariables = Exact<{
  context: ContextInput;
  lobs?: InputMaybe<Array<HistoryType> | HistoryType>;
  numberOfResults?: InputMaybe<Scalars["Int"]>;
}>;

export type CustomerSearchHistoryQueryQuery = {
  __typename?: "Query";
  customer: {
    __typename?: "Customer";
    searchHistory?: Array<{
      __typename?: "History";
      type?: HistoryType | null;
      items?: Array<{
        __typename?: "HistoryItem";
        startDate: { __typename?: "ZonedDateTime"; raw: string; year: number; month: number; day: number };
        endDate: { __typename?: "ZonedDateTime"; raw: string; year: number; month: number; day: number };
        originalSearchPrice?: {
          __typename?: "Money";
          amount: number;
          formatted: string;
          currencyInfo?: { __typename?: "Currency"; code: string; name: string; symbol: string } | null;
        } | null;
        productInfo?:
          | { __typename?: "HistoryActivityDetail" }
          | { __typename?: "HistoryActivitySearch" }
          | { __typename?: "HistoryCarDetail" }
          | { __typename?: "HistoryCarSearch" }
          | { __typename?: "HistoryCruiseSearch" }
          | { __typename?: "HistoryFlightDetail" }
          | { __typename?: "HistoryFlightSearch" }
          | { __typename?: "HistoryPackageSearch" }
          | {
              __typename?: "HistoryPropertyDetail";
              regionId?: string | null;
              propertyId?: string | null;
              propertySummary?: { __typename?: "PropertySummary"; id: string; name: string } | null;
              propertyImageGallery?: {
                __typename?: "PropertyImageGallery";
                featured?: { __typename?: "PropertyImage"; image: { __typename?: "Image"; url: any } } | null;
              } | null;
            }
          | { __typename?: "HistoryPropertySearch" }
          | null;
      } | null> | null;
    }> | null;
  };
};

export type DxPropertySearchQueryQueryVariables = Exact<{
  context: ContextInput;
  hotelIds: Array<Scalars["String"]> | Scalars["String"];
}>;

export type DxPropertySearchQueryQuery = {
  __typename?: "Query";
  propertySearch: {
    __typename?: "PropertySearchResults";
    properties: Array<{
      __typename?: "Property";
      id: string;
      name: string;
      infositeURL: string;
      price?: {
        __typename?: "PropertyPrice";
        lead?: { __typename?: "Money"; formatted: string; amount: number } | null;
      } | null;
      reviews: { __typename?: "PropertyReviewsSummary"; score?: number | null; total?: number | null };
      gallery?: Array<{ __typename?: "Image"; url: any; description: string }> | null;
    }>;
  };
};

export type MapPropertySearchByIdQueryVariables = Exact<{
  context: ContextInput;
  destination: DestinationInput;
  criteria?: InputMaybe<PropertySearchCriteriaInput>;
}>;

export type MapPropertySearchByIdQuery = {
  __typename?: "Query";
  propertySearch: {
    __typename?: "PropertySearchResults";
    sortAndFilter: {
      __typename?: "SortAndFilter";
      options?: {
        __typename?: "SortAndFilterViewModel";
        sortAndFilter: Array<{
          __typename?: "FilterViewModel";
          name: string;
          options: Array<{
            __typename?: "OptionViewModel";
            label?: string | null;
            value?: string | null;
            enumValue?: string | null;
            range?: { __typename?: "FilterOptionRange"; min?: number | null; max?: number | null } | null;
          }>;
        }>;
      } | null;
    };
    properties: Array<{
      __typename?: "Property";
      name: string;
      id: string;
      infositeURL: string;
      star?: number | null;
      price?: {
        __typename?: "PropertyPrice";
        lead?: {
          __typename?: "Money";
          formatted: string;
          amount: number;
          currencyInfo?: { __typename?: "Currency"; symbol: string; code: string; name: string } | null;
        } | null;
      } | null;
      reviews: {
        __typename?: "PropertyReviewsSummary";
        score?: number | null;
        total?: number | null;
        localizedSubtitle?: string | null;
      };
      image?: { __typename?: "Image"; url: any } | null;
      mapMarker?: {
        __typename?: "MapMarker";
        latLong: { __typename?: "Coordinates"; latitude: number; longitude: number };
      } | null;
    }>;
  };
};

export type MapPropertySearchByLatLongQueryVariables = Exact<{
  context: ContextInput;
  destination: DestinationInput;
  criteria?: InputMaybe<PropertySearchCriteriaInput>;
}>;

export type MapPropertySearchByLatLongQuery = {
  __typename?: "Query";
  propertySearch: {
    __typename?: "PropertySearchResults";
    properties: Array<{
      __typename?: "Property";
      name: string;
      id: string;
      infositeURL: string;
      star?: number | null;
      price?: {
        __typename?: "PropertyPrice";
        lead?: { __typename?: "Money"; formatted: string; amount: number } | null;
      } | null;
      reviews: {
        __typename?: "PropertyReviewsSummary";
        score?: number | null;
        total?: number | null;
        localizedSubtitle?: string | null;
      };
      image?: { __typename?: "Image"; url: any } | null;
      mapMarker?: {
        __typename?: "MapMarker";
        latLong: { __typename?: "Coordinates"; latitude: number; longitude: number };
      } | null;
    }>;
    summary: {
      __typename?: "PropertyResultsSummary";
      messages?: Array<{
        __typename?: "MessageResult";
        type?: MessageType | null;
        title?: { __typename?: "MessagingResultTitle"; text?: string | null } | null;
        subtitle?: { __typename?: "MessagingResultTitle"; text?: string | null } | null;
      }> | null;
    };
  };
};

export type MerchCouponsQueryQueryVariables = Exact<{
  context: ContextInput;
  couponIds: Array<Scalars["String"]> | Scalars["String"];
}>;

export type MerchCouponsQueryQuery = {
  __typename?: "Query";
  merchCoupons?: {
    __typename?: "MerchCoupons";
    coupons: Array<{
      __typename?: "CouponDetail";
      id: string;
      name: string;
      statusMessage: string;
      termsAndConditions: {
        __typename?: "CouponTermsAndConditions";
        text: string;
        informationUrl: { __typename?: "HttpURI"; value: string };
      };
    }>;
  } | null;
};

export type CouponDetailFragmentFragment = {
  __typename?: "CouponDetail";
  id: string;
  name: string;
  statusMessage: string;
  termsAndConditions: {
    __typename?: "CouponTermsAndConditions";
    text: string;
    informationUrl: { __typename?: "HttpURI"; value: string };
  };
};

export type PropertyFilterSearchQueryQueryVariables = Exact<{
  context: ContextInput;
  destination: DestinationInput;
  criteria?: InputMaybe<PropertySearchCriteriaInput>;
}>;

export type PropertyFilterSearchQueryQuery = {
  __typename?: "Query";
  propertySearch: {
    __typename?: "PropertySearchResults";
    sortAndFilter: {
      __typename?: "SortAndFilter";
      selected?: {
        __typename?: "SortAndFilterSelected";
        priceFilterPills?: {
          __typename?: "PriceFilterPills";
          aggregate?: { __typename?: "PriceFilterPillsAggregate"; label?: string | null } | null;
        } | null;
      } | null;
    };
    propertySearchListings: Array<
      | { __typename?: "EGDSStandardMessagingCard" }
      | { __typename?: "LodgingCard" }
      | { __typename?: "LodgingHeading" }
      | { __typename?: "LodgingIntentCard" }
      | { __typename?: "LodgingListingDivider" }
      | { __typename?: "LodgingSurveyTrigger" }
      | {
          __typename: "MessageResult";
          index?: number | null;
          type?: MessageType | null;
          title?: {
            __typename?: "MessagingResultTitle";
            text?: string | null;
            icon?: { __typename?: "Icon"; description: string; id: string } | null;
          } | null;
          subtitle?: { __typename?: "MessagingResultTitle"; text?: string | null } | null;
        }
      | {
          __typename: "Property";
          id: string;
          name: string;
          addressMessaging?: string | null;
          star?: number | null;
          structureType: StructureType;
          offerSummary: {
            __typename?: "OfferSummary";
            messages?: Array<{ __typename?: "OfferSummaryMessage"; type?: string | null }> | null;
          };
          propertyImage?: { __typename?: "PropertyImage"; image: { __typename?: "Image"; url: any } } | null;
          destinationInfo: {
            __typename?: "PropertyDestinationInfo";
            distanceFromMessaging?: string | null;
            distanceFromDestination?: { __typename?: "Distance"; unit: DistanceUnit; value: number } | null;
          };
          mapMarker?: {
            __typename?: "MapMarker";
            latLong: { __typename?: "Coordinates"; latitude: number; longitude: number };
          } | null;
          reviews: { __typename?: "PropertyReviewsSummary"; score?: number | null; total?: number | null };
          price?: {
            __typename?: "PropertyPrice";
            priceMessages?: Array<{ __typename?: "LodgingPlainMessage"; value: string }> | null;
            options?: Array<{
              __typename?: "PropertyPriceOption";
              displayPrice?: {
                __typename?: "Money";
                amount: number;
                formatted: string;
                currencyInfo?: { __typename?: "Currency"; code: string } | null;
              } | null;
            }> | null;
          } | null;
          propertyDetailsLink?: {
            __typename?: "LodgingLink";
            uri: { __typename?: "HttpURI"; relativePath: string; value: string };
          } | null;
        }
      | { __typename?: "PropertyListingsIconTextExpando" }
      | { __typename?: "PropertySearchListingsOverfilteredCard" }
      | { __typename?: "PropertySearchListingsSoldOutCard" }
      | { __typename?: "SponsoredContentPlacement" }
      | { __typename?: "StaticLodgingMultiItemCrossSell" }
    >;
  };
};

export type PropertyFiltersQueryQueryVariables = Exact<{
  context: ContextInput;
  destination: DestinationInput;
  criteria?: InputMaybe<PropertySearchCriteriaInput>;
}>;

export type PropertyFiltersQueryQuery = {
  __typename?: "Query";
  propertySearch: {
    __typename?: "PropertySearchResults";
    sortAndFilter: {
      __typename?: "SortAndFilter";
      options?: {
        __typename?: "SortAndFilterViewModel";
        sortAndFilter: Array<{
          __typename?: "FilterViewModel";
          label?: string | null;
          name: string;
          options: Array<{
            __typename?: "OptionViewModel";
            label?: string | null;
            optionValue?: string | null;
            filterCategory?: string | null;
            description?: string | null;
            selectedLabel?: string | null;
            isSelected: boolean;
            range?: { __typename?: "FilterOptionRange"; max?: number | null; min?: number | null } | null;
          }>;
        }>;
      } | null;
    };
  };
};

export type QueryPropertyHeroImageQueryVariables = Exact<{
  context: ContextInput;
  propertyId: Scalars["String"];
}>;

export type QueryPropertyHeroImageQuery = {
  __typename?: "Query";
  propertyInfo: {
    __typename?: "PropertyInfo";
    id: string;
    gallery?: {
      __typename?: "PropertyGallery";
      featured?: { __typename?: "Image"; description: string; url: any } | null;
    } | null;
  };
};

export type QueryPropertyReviewsHeadlineQueryVariables = Exact<{
  context: ContextInput;
  propertyId: Scalars["String"];
}>;

export type QueryPropertyReviewsHeadlineQuery = {
  __typename?: "Query";
  propertyInfo: {
    __typename?: "PropertyInfo";
    id: string;
    infositeUrl?: any | null;
    summary?: {
      __typename?: "PropertySummary";
      id: string;
      name: string;
      overview?: { __typename?: "PropertyOverview"; starRating?: number | null } | null;
      location?: {
        __typename?: "PropertyLocation";
        address?: {
          __typename?: "PropertyAddress";
          city?: string | null;
          countryCode?: string | null;
          firstAddressLine?: string | null;
          secondAddressLine?: string | null;
          postalCode?: string | null;
          province?: string | null;
        } | null;
      } | null;
    } | null;
  };
};

export type PropertySearchQueryQueryVariables = Exact<{
  context: ContextInput;
  hotelIds: Array<Scalars["String"]> | Scalars["String"];
}>;

export type PropertySearchQueryQuery = {
  __typename?: "Query";
  propertySearch: {
    __typename?: "PropertySearchResults";
    properties: Array<{
      __typename?: "Property";
      id: string;
      name: string;
      gallery?: Array<{ __typename?: "Image"; url: any; description: string }> | null;
    }>;
  };
};

export type TravelAgentSearchWizardConfigQueryQueryVariables = Exact<{
  context: ContextInput;
}>;

export type TravelAgentSearchWizardConfigQueryQuery = {
  __typename?: "Query";
  travelAgentSearchWizardConfig?: {
    __typename?: "TravelAgentSearchWizardConfig";
    packageRatesEnabled: boolean;
    enabledLobs: Array<string>;
    packageRatesDetail?: {
      __typename?: "TravelAgentPackageRatesDetail";
      heading?: string | null;
      termsAndConditions: string;
    } | null;
  } | null;
};

export const CouponDetailFragmentFragmentDoc = ({
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "CouponDetailFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "CouponDetail" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "statusMessage" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "termsAndConditions" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "text" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "informationUrl" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [{ kind: "Field", name: { kind: "Name", value: "value" } }],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown) as DocumentNode<CouponDetailFragmentFragment, unknown>;
export const BlossomNotificationDocument = ({
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "BlossomNotification" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "context" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "ContextInput" } } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "notificationLocation" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "NotificationLocationOnPage" } },
          },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "lineOfBusiness" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "LineOfBusinessDomain" } },
          },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "funnelLocation" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "PageLocation" } } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "notification" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "context" },
                value: { kind: "Variable", name: { kind: "Name", value: "context" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "inlineNotification" },
                  arguments: [
                    {
                      kind: "Argument",
                      name: { kind: "Name", value: "lineOfBusiness" },
                      value: { kind: "Variable", name: { kind: "Name", value: "lineOfBusiness" } },
                    },
                    {
                      kind: "Argument",
                      name: { kind: "Name", value: "notificationLocation" },
                      value: { kind: "Variable", name: { kind: "Name", value: "notificationLocation" } },
                    },
                    {
                      kind: "Argument",
                      name: { kind: "Name", value: "pageLocation" },
                      value: { kind: "Variable", name: { kind: "Name", value: "funnelLocation" } },
                    },
                  ],
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "type" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "title" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "items" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  { kind: "Field", name: { kind: "Name", value: "__typename" } },
                                  { kind: "Field", name: { kind: "Name", value: "text" } },
                                  { kind: "Field", name: { kind: "Name", value: "styles" } },
                                  {
                                    kind: "InlineFragment",
                                    typeCondition: {
                                      kind: "NamedType",
                                      name: { kind: "Name", value: "NotificationPhraseLinkNode" },
                                    },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "uri" },
                                          selectionSet: {
                                            kind: "SelectionSet",
                                            selections: [
                                              { kind: "Field", name: { kind: "Name", value: "__typename" } },
                                              { kind: "Field", name: { kind: "Name", value: "value" } },
                                            ],
                                          },
                                        },
                                        { kind: "Field", name: { kind: "Name", value: "target" } },
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "actions" },
                                          selectionSet: {
                                            kind: "SelectionSet",
                                            selections: [
                                              { kind: "Field", name: { kind: "Name", value: "__typename" } },
                                              {
                                                kind: "InlineFragment",
                                                typeCondition: {
                                                  kind: "NamedType",
                                                  name: { kind: "Name", value: "NotificationAnalytics" },
                                                },
                                                selectionSet: {
                                                  kind: "SelectionSet",
                                                  selections: [
                                                    { kind: "Field", name: { kind: "Name", value: "description" } },
                                                    { kind: "Field", name: { kind: "Name", value: "referrerId" } },
                                                  ],
                                                },
                                              },
                                              {
                                                kind: "InlineFragment",
                                                typeCondition: {
                                                  kind: "NamedType",
                                                  name: { kind: "Name", value: "NotificationCookie" },
                                                },
                                                selectionSet: {
                                                  kind: "SelectionSet",
                                                  selections: [
                                                    { kind: "Field", name: { kind: "Name", value: "name" } },
                                                    { kind: "Field", name: { kind: "Name", value: "value" } },
                                                    { kind: "Field", name: { kind: "Name", value: "expires" } },
                                                  ],
                                                },
                                              },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "body" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "items" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  { kind: "Field", name: { kind: "Name", value: "__typename" } },
                                  { kind: "Field", name: { kind: "Name", value: "text" } },
                                  { kind: "Field", name: { kind: "Name", value: "styles" } },
                                  {
                                    kind: "InlineFragment",
                                    typeCondition: {
                                      kind: "NamedType",
                                      name: { kind: "Name", value: "NotificationPhraseLinkNode" },
                                    },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        { kind: "Field", name: { kind: "Name", value: "target" } },
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "uri" },
                                          selectionSet: {
                                            kind: "SelectionSet",
                                            selections: [
                                              { kind: "Field", name: { kind: "Name", value: "__typename" } },
                                              { kind: "Field", name: { kind: "Name", value: "value" } },
                                            ],
                                          },
                                        },
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "actions" },
                                          selectionSet: {
                                            kind: "SelectionSet",
                                            selections: [
                                              { kind: "Field", name: { kind: "Name", value: "__typename" } },
                                              {
                                                kind: "InlineFragment",
                                                typeCondition: {
                                                  kind: "NamedType",
                                                  name: { kind: "Name", value: "NotificationAnalytics" },
                                                },
                                                selectionSet: {
                                                  kind: "SelectionSet",
                                                  selections: [
                                                    { kind: "Field", name: { kind: "Name", value: "description" } },
                                                    { kind: "Field", name: { kind: "Name", value: "referrerId" } },
                                                  ],
                                                },
                                              },
                                              {
                                                kind: "InlineFragment",
                                                typeCondition: {
                                                  kind: "NamedType",
                                                  name: { kind: "Name", value: "NotificationCookie" },
                                                },
                                                selectionSet: {
                                                  kind: "SelectionSet",
                                                  selections: [
                                                    { kind: "Field", name: { kind: "Name", value: "name" } },
                                                    { kind: "Field", name: { kind: "Name", value: "value" } },
                                                    { kind: "Field", name: { kind: "Name", value: "expires" } },
                                                  ],
                                                },
                                              },
                                            ],
                                          },
                                        },
                                        { kind: "Field", name: { kind: "Name", value: "id" } },
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "icon" },
                                          selectionSet: {
                                            kind: "SelectionSet",
                                            selections: [
                                              { kind: "Field", name: { kind: "Name", value: "id" } },
                                              { kind: "Field", name: { kind: "Name", value: "description" } },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "containerLink" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "uri" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  { kind: "Field", name: { kind: "Name", value: "__typename" } },
                                  { kind: "Field", name: { kind: "Name", value: "value" } },
                                ],
                              },
                            },
                            { kind: "Field", name: { kind: "Name", value: "target" } },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "actions" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  { kind: "Field", name: { kind: "Name", value: "__typename" } },
                                  {
                                    kind: "InlineFragment",
                                    typeCondition: {
                                      kind: "NamedType",
                                      name: { kind: "Name", value: "NotificationAnalytics" },
                                    },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        { kind: "Field", name: { kind: "Name", value: "description" } },
                                        { kind: "Field", name: { kind: "Name", value: "referrerId" } },
                                      ],
                                    },
                                  },
                                  {
                                    kind: "InlineFragment",
                                    typeCondition: {
                                      kind: "NamedType",
                                      name: { kind: "Name", value: "NotificationCookie" },
                                    },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        { kind: "Field", name: { kind: "Name", value: "name" } },
                                        { kind: "Field", name: { kind: "Name", value: "value" } },
                                        { kind: "Field", name: { kind: "Name", value: "expires" } },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "logo" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "description" } },
                            { kind: "Field", name: { kind: "Name", value: "url" } },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "links" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "id" } },
                            { kind: "Field", name: { kind: "Name", value: "text" } },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "uri" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  { kind: "Field", name: { kind: "Name", value: "__typename" } },
                                  { kind: "Field", name: { kind: "Name", value: "value" } },
                                ],
                              },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "icon" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  { kind: "Field", name: { kind: "Name", value: "id" } },
                                  { kind: "Field", name: { kind: "Name", value: "description" } },
                                ],
                              },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "actions" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  { kind: "Field", name: { kind: "Name", value: "__typename" } },
                                  {
                                    kind: "InlineFragment",
                                    typeCondition: {
                                      kind: "NamedType",
                                      name: { kind: "Name", value: "NotificationAnalytics" },
                                    },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        { kind: "Field", name: { kind: "Name", value: "description" } },
                                        { kind: "Field", name: { kind: "Name", value: "referrerId" } },
                                      ],
                                    },
                                  },
                                  {
                                    kind: "InlineFragment",
                                    typeCondition: {
                                      kind: "NamedType",
                                      name: { kind: "Name", value: "NotificationCookie" },
                                    },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        { kind: "Field", name: { kind: "Name", value: "name" } },
                                        { kind: "Field", name: { kind: "Name", value: "value" } },
                                        { kind: "Field", name: { kind: "Name", value: "expires" } },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "dismiss" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "icon" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  { kind: "Field", name: { kind: "Name", value: "id" } },
                                  { kind: "Field", name: { kind: "Name", value: "description" } },
                                ],
                              },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "actions" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  { kind: "Field", name: { kind: "Name", value: "__typename" } },
                                  {
                                    kind: "InlineFragment",
                                    typeCondition: {
                                      kind: "NamedType",
                                      name: { kind: "Name", value: "NotificationAnalytics" },
                                    },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        { kind: "Field", name: { kind: "Name", value: "description" } },
                                        { kind: "Field", name: { kind: "Name", value: "referrerId" } },
                                      ],
                                    },
                                  },
                                  {
                                    kind: "InlineFragment",
                                    typeCondition: {
                                      kind: "NamedType",
                                      name: { kind: "Name", value: "NotificationCookie" },
                                    },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        { kind: "Field", name: { kind: "Name", value: "name" } },
                                        { kind: "Field", name: { kind: "Name", value: "value" } },
                                        { kind: "Field", name: { kind: "Name", value: "expires" } },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "revealActions" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "__typename" } },
                            {
                              kind: "InlineFragment",
                              typeCondition: {
                                kind: "NamedType",
                                name: { kind: "Name", value: "NotificationAnalytics" },
                              },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  { kind: "Field", name: { kind: "Name", value: "description" } },
                                  { kind: "Field", name: { kind: "Name", value: "referrerId" } },
                                ],
                              },
                            },
                            {
                              kind: "InlineFragment",
                              typeCondition: { kind: "NamedType", name: { kind: "Name", value: "NotificationCookie" } },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  { kind: "Field", name: { kind: "Name", value: "name" } },
                                  { kind: "Field", name: { kind: "Name", value: "value" } },
                                  { kind: "Field", name: { kind: "Name", value: "expires" } },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "backgroundImage" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [{ kind: "Field", name: { kind: "Name", value: "url" } }],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown) as DocumentNode<BlossomNotificationQuery, BlossomNotificationQueryVariables>;
export const CampaignByIdQueryDocument = ({
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "CampaignByIdQuery" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "productType" } },
          type: {
            kind: "ListType",
            type: {
              kind: "NonNullType",
              type: { kind: "NamedType", name: { kind: "Name", value: "CampaignProductType" } },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "context" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "ContextInput" } } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "userLocation" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "UserLocationInput" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "referrer" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "enableTripAttach" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "Boolean" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "displayPropertyCount" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "Boolean" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "campaignId" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "pageSize" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "Int" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "pageNumber" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Int" } } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "enableLivePricing" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "Boolean" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "returnPath" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "destinationId" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "campaignRecommendations" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "productType" },
                value: { kind: "Variable", name: { kind: "Name", value: "productType" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "userLocation" },
                value: { kind: "Variable", name: { kind: "Name", value: "userLocation" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "context" },
                value: { kind: "Variable", name: { kind: "Name", value: "context" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "referrer" },
                value: { kind: "Variable", name: { kind: "Name", value: "referrer" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "enableTripAttach" },
                value: { kind: "Variable", name: { kind: "Name", value: "enableTripAttach" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "campaignParameters" },
                value: {
                  kind: "ObjectValue",
                  fields: [
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "campaignId" },
                      value: { kind: "Variable", name: { kind: "Name", value: "campaignId" } },
                    },
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "contentPagination" },
                      value: {
                        kind: "ObjectValue",
                        fields: [
                          {
                            kind: "ObjectField",
                            name: { kind: "Name", value: "pageSize" },
                            value: { kind: "Variable", name: { kind: "Name", value: "pageSize" } },
                          },
                          {
                            kind: "ObjectField",
                            name: { kind: "Name", value: "pageNumber" },
                            value: { kind: "Variable", name: { kind: "Name", value: "pageNumber" } },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "displayPropertyCount" },
                value: { kind: "Variable", name: { kind: "Name", value: "displayPropertyCount" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "includeDeals" },
                value: { kind: "BooleanValue", value: true },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "enableLivePricing" },
                value: { kind: "Variable", name: { kind: "Name", value: "enableLivePricing" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "destinationId" },
                value: { kind: "Variable", name: { kind: "Name", value: "destinationId" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "campaigns" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        alias: { kind: "Name", value: "campaignId" },
                        name: { kind: "Name", value: "id" },
                      },
                      { kind: "Field", name: { kind: "Name", value: "headline" } },
                      { kind: "Field", name: { kind: "Name", value: "fromOriginHeaderText" } },
                      { kind: "Field", name: { kind: "Name", value: "termsAndConditions" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "campaignContentPaginationInfo" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [{ kind: "Field", name: { kind: "Name", value: "hasMoreContentPages" } }],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "description" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "short" } },
                            { kind: "Field", name: { kind: "Name", value: "long" } },
                          ],
                        },
                      },
                      { kind: "Field", name: { kind: "Name", value: "productTypes" } },
                      { kind: "Field", name: { kind: "Name", value: "recommendedType" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "offers" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "__typename" } },
                            { kind: "Field", name: { kind: "Name", value: "name" } },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "image" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  { kind: "Field", name: { kind: "Name", value: "description" } },
                                  { kind: "Field", name: { kind: "Name", value: "url" } },
                                ],
                              },
                            },
                            { kind: "Field", name: { kind: "Name", value: "description" } },
                            { kind: "Field", name: { kind: "Name", value: "secondaryContent" } },
                            {
                              kind: "InlineFragment",
                              typeCondition: {
                                kind: "NamedType",
                                name: { kind: "Name", value: "DestinationOfferItem" },
                              },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  { kind: "Field", name: { kind: "Name", value: "affinities" } },
                                  { kind: "Field", name: { kind: "Name", value: "propertyCount" } },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "lodgingOffer" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "price" },
                                          selectionSet: {
                                            kind: "SelectionSet",
                                            selections: [
                                              { kind: "Field", name: { kind: "Name", value: "value" } },
                                              { kind: "Field", name: { kind: "Name", value: "qualifierText" } },
                                              { kind: "Field", name: { kind: "Name", value: "disclaimerText" } },
                                            ],
                                          },
                                        },
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "actionLink" },
                                          selectionSet: {
                                            kind: "SelectionSet",
                                            selections: [
                                              { kind: "Field", name: { kind: "Name", value: "href" } },
                                              { kind: "Field", name: { kind: "Name", value: "text" } },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "flightOffer" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "price" },
                                          selectionSet: {
                                            kind: "SelectionSet",
                                            selections: [
                                              { kind: "Field", name: { kind: "Name", value: "value" } },
                                              { kind: "Field", name: { kind: "Name", value: "qualifierText" } },
                                              { kind: "Field", name: { kind: "Name", value: "disclaimerText" } },
                                              { kind: "Field", name: { kind: "Name", value: "prefixText" } },
                                            ],
                                          },
                                        },
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "actionLink" },
                                          selectionSet: {
                                            kind: "SelectionSet",
                                            selections: [
                                              { kind: "Field", name: { kind: "Name", value: "href" } },
                                              { kind: "Field", name: { kind: "Name", value: "text" } },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "packageOffer" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "price" },
                                          selectionSet: {
                                            kind: "SelectionSet",
                                            selections: [
                                              { kind: "Field", name: { kind: "Name", value: "value" } },
                                              { kind: "Field", name: { kind: "Name", value: "qualifierText" } },
                                              { kind: "Field", name: { kind: "Name", value: "disclaimerText" } },
                                              { kind: "Field", name: { kind: "Name", value: "prefixText" } },
                                              { kind: "Field", name: { kind: "Name", value: "checkPriceText" } },
                                            ],
                                          },
                                        },
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "strikeThroughPrice" },
                                          selectionSet: {
                                            kind: "SelectionSet",
                                            selections: [{ kind: "Field", name: { kind: "Name", value: "value" } }],
                                          },
                                        },
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "actionLink" },
                                          selectionSet: {
                                            kind: "SelectionSet",
                                            selections: [
                                              { kind: "Field", name: { kind: "Name", value: "href" } },
                                              { kind: "Field", name: { kind: "Name", value: "text" } },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                  { kind: "Field", name: { kind: "Name", value: "dates" } },
                                ],
                              },
                            },
                            {
                              kind: "InlineFragment",
                              typeCondition: { kind: "NamedType", name: { kind: "Name", value: "HotelOfferItem" } },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  { kind: "Field", name: { kind: "Name", value: "location" } },
                                  { kind: "Field", name: { kind: "Name", value: "starRating" } },
                                  { kind: "Field", name: { kind: "Name", value: "guestReviewRating" } },
                                  { kind: "Field", name: { kind: "Name", value: "guestReviewRatingQualifierText" } },
                                  { kind: "Field", name: { kind: "Name", value: "guestReviewCount" } },
                                  { kind: "Field", name: { kind: "Name", value: "vipMessage" } },
                                  { kind: "Field", name: { kind: "Name", value: "freeCancellationMessage" } },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "badge" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        { kind: "Field", name: { kind: "Name", value: "text" } },
                                        { kind: "Field", name: { kind: "Name", value: "type" } },
                                      ],
                                    },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "discountBadge" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        { kind: "Field", name: { kind: "Name", value: "text" } },
                                        { kind: "Field", name: { kind: "Name", value: "type" } },
                                      ],
                                    },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "mod" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        { kind: "Field", name: { kind: "Name", value: "modTagText" } },
                                        { kind: "Field", name: { kind: "Name", value: "modAvailabilityText" } },
                                        { kind: "Field", name: { kind: "Name", value: "modSignInText" } },
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "signInUrl" },
                                          arguments: [
                                            {
                                              kind: "Argument",
                                              name: { kind: "Name", value: "returnPath" },
                                              value: { kind: "Variable", name: { kind: "Name", value: "returnPath" } },
                                            },
                                          ],
                                          selectionSet: {
                                            kind: "SelectionSet",
                                            selections: [
                                              { kind: "Field", name: { kind: "Name", value: "value" } },
                                              { kind: "Field", name: { kind: "Name", value: "relativePath" } },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "lodgingOffer" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "price" },
                                          selectionSet: {
                                            kind: "SelectionSet",
                                            selections: [
                                              { kind: "Field", name: { kind: "Name", value: "value" } },
                                              { kind: "Field", name: { kind: "Name", value: "qualifierText" } },
                                              { kind: "Field", name: { kind: "Name", value: "disclaimerText" } },
                                              { kind: "Field", name: { kind: "Name", value: "allyText" } },
                                            ],
                                          },
                                        },
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "strikeThroughPrice" },
                                          selectionSet: {
                                            kind: "SelectionSet",
                                            selections: [{ kind: "Field", name: { kind: "Name", value: "value" } }],
                                          },
                                        },
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "actionLink" },
                                          selectionSet: {
                                            kind: "SelectionSet",
                                            selections: [
                                              { kind: "Field", name: { kind: "Name", value: "href" } },
                                              { kind: "Field", name: { kind: "Name", value: "text" } },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                  { kind: "Field", name: { kind: "Name", value: "dates" } },
                                ],
                              },
                            },
                            {
                              kind: "InlineFragment",
                              typeCondition: { kind: "NamedType", name: { kind: "Name", value: "FlightOfferItem" } },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  { kind: "Field", name: { kind: "Name", value: "airlineName" } },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "airlineImage" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        { kind: "Field", name: { kind: "Name", value: "description" } },
                                        { kind: "Field", name: { kind: "Name", value: "url" } },
                                      ],
                                    },
                                  },
                                  { kind: "Field", name: { kind: "Name", value: "originCity" } },
                                  { kind: "Field", name: { kind: "Name", value: "originAirportCode" } },
                                  { kind: "Field", name: { kind: "Name", value: "destinationCity" } },
                                  { kind: "Field", name: { kind: "Name", value: "destinationAirportCode" } },
                                  { kind: "Field", name: { kind: "Name", value: "tripType" } },
                                  { kind: "Field", name: { kind: "Name", value: "flightClass" } },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "flightOffer" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "price" },
                                          selectionSet: {
                                            kind: "SelectionSet",
                                            selections: [
                                              { kind: "Field", name: { kind: "Name", value: "value" } },
                                              { kind: "Field", name: { kind: "Name", value: "qualifierText" } },
                                              { kind: "Field", name: { kind: "Name", value: "prefixText" } },
                                            ],
                                          },
                                        },
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "actionLink" },
                                          selectionSet: {
                                            kind: "SelectionSet",
                                            selections: [
                                              { kind: "Field", name: { kind: "Name", value: "href" } },
                                              { kind: "Field", name: { kind: "Name", value: "text" } },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                  { kind: "Field", name: { kind: "Name", value: "dates" } },
                                ],
                              },
                            },
                            {
                              kind: "InlineFragment",
                              typeCondition: { kind: "NamedType", name: { kind: "Name", value: "PackageOfferItem" } },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "flightOfferItem" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        { kind: "Field", name: { kind: "Name", value: "airlineName" } },
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "airlineImage" },
                                          selectionSet: {
                                            kind: "SelectionSet",
                                            selections: [
                                              { kind: "Field", name: { kind: "Name", value: "description" } },
                                              { kind: "Field", name: { kind: "Name", value: "url" } },
                                            ],
                                          },
                                        },
                                        { kind: "Field", name: { kind: "Name", value: "originCity" } },
                                        { kind: "Field", name: { kind: "Name", value: "originAirportCode" } },
                                        { kind: "Field", name: { kind: "Name", value: "destinationCity" } },
                                        { kind: "Field", name: { kind: "Name", value: "destinationAirportCode" } },
                                      ],
                                    },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "hotelOfferItem" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        { kind: "Field", name: { kind: "Name", value: "name" } },
                                        { kind: "Field", name: { kind: "Name", value: "location" } },
                                        { kind: "Field", name: { kind: "Name", value: "vipMessage" } },
                                      ],
                                    },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "packageOffer" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "price" },
                                          selectionSet: {
                                            kind: "SelectionSet",
                                            selections: [
                                              { kind: "Field", name: { kind: "Name", value: "value" } },
                                              { kind: "Field", name: { kind: "Name", value: "qualifierText" } },
                                              { kind: "Field", name: { kind: "Name", value: "prefixText" } },
                                              { kind: "Field", name: { kind: "Name", value: "checkPriceText" } },
                                            ],
                                          },
                                        },
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "actionLink" },
                                          selectionSet: {
                                            kind: "SelectionSet",
                                            selections: [
                                              { kind: "Field", name: { kind: "Name", value: "href" } },
                                              { kind: "Field", name: { kind: "Name", value: "text" } },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                  { kind: "Field", name: { kind: "Name", value: "dates" } },
                                ],
                              },
                            },
                            {
                              kind: "InlineFragment",
                              typeCondition: { kind: "NamedType", name: { kind: "Name", value: "ActivityOfferItem" } },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "badge" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        { kind: "Field", name: { kind: "Name", value: "text" } },
                                        { kind: "Field", name: { kind: "Name", value: "type" } },
                                      ],
                                    },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "image" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        { kind: "Field", name: { kind: "Name", value: "description" } },
                                        { kind: "Field", name: { kind: "Name", value: "url" } },
                                      ],
                                    },
                                  },
                                  { kind: "Field", name: { kind: "Name", value: "title" } },
                                  { kind: "Field", name: { kind: "Name", value: "description" } },
                                  { kind: "Field", name: { kind: "Name", value: "duration" } },
                                  { kind: "Field", name: { kind: "Name", value: "durationLabel" } },
                                  { kind: "Field", name: { kind: "Name", value: "city" } },
                                  { kind: "Field", name: { kind: "Name", value: "province" } },
                                  { kind: "Field", name: { kind: "Name", value: "dates" } },
                                  { kind: "Field", name: { kind: "Name", value: "freeCancellationMessage" } },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "activityOffer" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "price" },
                                          selectionSet: {
                                            kind: "SelectionSet",
                                            selections: [
                                              { kind: "Field", name: { kind: "Name", value: "value" } },
                                              { kind: "Field", name: { kind: "Name", value: "qualifierText" } },
                                              { kind: "Field", name: { kind: "Name", value: "disclaimerText" } },
                                              { kind: "Field", name: { kind: "Name", value: "allyText" } },
                                            ],
                                          },
                                        },
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "strikeThroughPrice" },
                                          selectionSet: {
                                            kind: "SelectionSet",
                                            selections: [
                                              { kind: "Field", name: { kind: "Name", value: "value" } },
                                              { kind: "Field", name: { kind: "Name", value: "qualifierText" } },
                                            ],
                                          },
                                        },
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "actionLink" },
                                          selectionSet: {
                                            kind: "SelectionSet",
                                            selections: [
                                              { kind: "Field", name: { kind: "Name", value: "href" } },
                                              { kind: "Field", name: { kind: "Name", value: "text" } },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                { kind: "Field", name: { kind: "Name", value: "responseId" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "paginationInfo" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [{ kind: "Field", name: { kind: "Name", value: "referrer" } }],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown) as DocumentNode<CampaignByIdQueryQuery, CampaignByIdQueryQueryVariables>;
export const CampaignRecommendationsWithOffersQueryDocument = ({
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "CampaignRecommendationsWithOffersQuery" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "numCampaigns" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Int" } } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "pageNumberOfCampaigns" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Int" } } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "maxNumberOfCampaigns" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "Int" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "productType" } },
          type: {
            kind: "ListType",
            type: {
              kind: "NonNullType",
              type: { kind: "NamedType", name: { kind: "Name", value: "CampaignProductType" } },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "recommendationType" } },
          type: { kind: "ListType", type: { kind: "NamedType", name: { kind: "Name", value: "RecommendedType" } } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "context" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "ContextInput" } } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "userLocation" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "UserLocationInput" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "referrer" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "userTripState" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "enableLivePricing" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "Boolean" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "returnPath" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "campaignRecommendations" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "numberOfCampaigns" },
                value: { kind: "Variable", name: { kind: "Name", value: "numCampaigns" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "pageNumber" },
                value: { kind: "Variable", name: { kind: "Name", value: "pageNumberOfCampaigns" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "maxNumberOfCampaigns" },
                value: { kind: "Variable", name: { kind: "Name", value: "maxNumberOfCampaigns" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "productType" },
                value: { kind: "Variable", name: { kind: "Name", value: "productType" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "recommendationType" },
                value: { kind: "Variable", name: { kind: "Name", value: "recommendationType" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "userLocation" },
                value: { kind: "Variable", name: { kind: "Name", value: "userLocation" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "context" },
                value: { kind: "Variable", name: { kind: "Name", value: "context" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "referrer" },
                value: { kind: "Variable", name: { kind: "Name", value: "referrer" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "includeDeals" },
                value: { kind: "BooleanValue", value: true },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "userTripState" },
                value: { kind: "Variable", name: { kind: "Name", value: "userTripState" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "enableLivePricing" },
                value: { kind: "Variable", name: { kind: "Name", value: "enableLivePricing" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "campaigns" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        alias: { kind: "Name", value: "campaignId" },
                        name: { kind: "Name", value: "id" },
                      },
                      { kind: "Field", name: { kind: "Name", value: "headline" } },
                      { kind: "Field", name: { kind: "Name", value: "fromOriginHeaderText" } },
                      { kind: "Field", name: { kind: "Name", value: "termsAndConditions" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "description" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "short" } },
                            { kind: "Field", name: { kind: "Name", value: "long" } },
                          ],
                        },
                      },
                      { kind: "Field", name: { kind: "Name", value: "productTypes" } },
                      { kind: "Field", name: { kind: "Name", value: "recommendedType" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "offers" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "__typename" } },
                            { kind: "Field", name: { kind: "Name", value: "name" } },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "image" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  { kind: "Field", name: { kind: "Name", value: "description" } },
                                  { kind: "Field", name: { kind: "Name", value: "url" } },
                                ],
                              },
                            },
                            { kind: "Field", name: { kind: "Name", value: "description" } },
                            { kind: "Field", name: { kind: "Name", value: "secondaryContent" } },
                            {
                              kind: "InlineFragment",
                              typeCondition: {
                                kind: "NamedType",
                                name: { kind: "Name", value: "DestinationOfferItem" },
                              },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  { kind: "Field", name: { kind: "Name", value: "affinities" } },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "lodgingOffer" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "price" },
                                          selectionSet: {
                                            kind: "SelectionSet",
                                            selections: [
                                              { kind: "Field", name: { kind: "Name", value: "value" } },
                                              { kind: "Field", name: { kind: "Name", value: "qualifierText" } },
                                              { kind: "Field", name: { kind: "Name", value: "disclaimerText" } },
                                              { kind: "Field", name: { kind: "Name", value: "prefixText" } },
                                              { kind: "Field", name: { kind: "Name", value: "checkPriceText" } },
                                            ],
                                          },
                                        },
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "actionLink" },
                                          selectionSet: {
                                            kind: "SelectionSet",
                                            selections: [
                                              { kind: "Field", name: { kind: "Name", value: "href" } },
                                              { kind: "Field", name: { kind: "Name", value: "text" } },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "flightOffer" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "price" },
                                          selectionSet: {
                                            kind: "SelectionSet",
                                            selections: [
                                              { kind: "Field", name: { kind: "Name", value: "value" } },
                                              { kind: "Field", name: { kind: "Name", value: "qualifierText" } },
                                              { kind: "Field", name: { kind: "Name", value: "disclaimerText" } },
                                              { kind: "Field", name: { kind: "Name", value: "prefixText" } },
                                              { kind: "Field", name: { kind: "Name", value: "checkPriceText" } },
                                            ],
                                          },
                                        },
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "actionLink" },
                                          selectionSet: {
                                            kind: "SelectionSet",
                                            selections: [
                                              { kind: "Field", name: { kind: "Name", value: "href" } },
                                              { kind: "Field", name: { kind: "Name", value: "text" } },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "packageOffer" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "price" },
                                          selectionSet: {
                                            kind: "SelectionSet",
                                            selections: [
                                              { kind: "Field", name: { kind: "Name", value: "value" } },
                                              { kind: "Field", name: { kind: "Name", value: "qualifierText" } },
                                              { kind: "Field", name: { kind: "Name", value: "disclaimerText" } },
                                              { kind: "Field", name: { kind: "Name", value: "prefixText" } },
                                              { kind: "Field", name: { kind: "Name", value: "checkPriceText" } },
                                            ],
                                          },
                                        },
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "strikeThroughPrice" },
                                          selectionSet: {
                                            kind: "SelectionSet",
                                            selections: [{ kind: "Field", name: { kind: "Name", value: "value" } }],
                                          },
                                        },
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "actionLink" },
                                          selectionSet: {
                                            kind: "SelectionSet",
                                            selections: [
                                              { kind: "Field", name: { kind: "Name", value: "href" } },
                                              { kind: "Field", name: { kind: "Name", value: "text" } },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                  { kind: "Field", name: { kind: "Name", value: "dates" } },
                                ],
                              },
                            },
                            {
                              kind: "InlineFragment",
                              typeCondition: { kind: "NamedType", name: { kind: "Name", value: "HotelOfferItem" } },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  { kind: "Field", name: { kind: "Name", value: "location" } },
                                  { kind: "Field", name: { kind: "Name", value: "starRating" } },
                                  { kind: "Field", name: { kind: "Name", value: "guestReviewRating" } },
                                  { kind: "Field", name: { kind: "Name", value: "guestReviewRatingQualifierText" } },
                                  { kind: "Field", name: { kind: "Name", value: "guestReviewCount" } },
                                  { kind: "Field", name: { kind: "Name", value: "vipMessage" } },
                                  { kind: "Field", name: { kind: "Name", value: "freeCancellationMessage" } },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "badge" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        { kind: "Field", name: { kind: "Name", value: "text" } },
                                        { kind: "Field", name: { kind: "Name", value: "type" } },
                                      ],
                                    },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "discountBadge" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        { kind: "Field", name: { kind: "Name", value: "text" } },
                                        { kind: "Field", name: { kind: "Name", value: "type" } },
                                      ],
                                    },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "mod" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        { kind: "Field", name: { kind: "Name", value: "modTagText" } },
                                        { kind: "Field", name: { kind: "Name", value: "modAvailabilityText" } },
                                        { kind: "Field", name: { kind: "Name", value: "modSignInText" } },
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "signInUrl" },
                                          arguments: [
                                            {
                                              kind: "Argument",
                                              name: { kind: "Name", value: "returnPath" },
                                              value: { kind: "Variable", name: { kind: "Name", value: "returnPath" } },
                                            },
                                          ],
                                          selectionSet: {
                                            kind: "SelectionSet",
                                            selections: [
                                              { kind: "Field", name: { kind: "Name", value: "value" } },
                                              { kind: "Field", name: { kind: "Name", value: "relativePath" } },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "lodgingOffer" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "price" },
                                          selectionSet: {
                                            kind: "SelectionSet",
                                            selections: [
                                              { kind: "Field", name: { kind: "Name", value: "value" } },
                                              { kind: "Field", name: { kind: "Name", value: "qualifierText" } },
                                              { kind: "Field", name: { kind: "Name", value: "disclaimerText" } },
                                              { kind: "Field", name: { kind: "Name", value: "allyText" } },
                                            ],
                                          },
                                        },
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "strikeThroughPrice" },
                                          selectionSet: {
                                            kind: "SelectionSet",
                                            selections: [{ kind: "Field", name: { kind: "Name", value: "value" } }],
                                          },
                                        },
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "actionLink" },
                                          selectionSet: {
                                            kind: "SelectionSet",
                                            selections: [
                                              { kind: "Field", name: { kind: "Name", value: "href" } },
                                              { kind: "Field", name: { kind: "Name", value: "text" } },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                  { kind: "Field", name: { kind: "Name", value: "dates" } },
                                ],
                              },
                            },
                            {
                              kind: "InlineFragment",
                              typeCondition: { kind: "NamedType", name: { kind: "Name", value: "FlightOfferItem" } },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  { kind: "Field", name: { kind: "Name", value: "airlineName" } },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "airlineImage" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        { kind: "Field", name: { kind: "Name", value: "description" } },
                                        { kind: "Field", name: { kind: "Name", value: "url" } },
                                      ],
                                    },
                                  },
                                  { kind: "Field", name: { kind: "Name", value: "originCity" } },
                                  { kind: "Field", name: { kind: "Name", value: "originAirportCode" } },
                                  { kind: "Field", name: { kind: "Name", value: "destinationCity" } },
                                  { kind: "Field", name: { kind: "Name", value: "destinationAirportCode" } },
                                  { kind: "Field", name: { kind: "Name", value: "tripType" } },
                                  { kind: "Field", name: { kind: "Name", value: "flightClass" } },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "flightOffer" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "price" },
                                          selectionSet: {
                                            kind: "SelectionSet",
                                            selections: [
                                              { kind: "Field", name: { kind: "Name", value: "value" } },
                                              { kind: "Field", name: { kind: "Name", value: "qualifierText" } },
                                              { kind: "Field", name: { kind: "Name", value: "prefixText" } },
                                            ],
                                          },
                                        },
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "actionLink" },
                                          selectionSet: {
                                            kind: "SelectionSet",
                                            selections: [
                                              { kind: "Field", name: { kind: "Name", value: "href" } },
                                              { kind: "Field", name: { kind: "Name", value: "text" } },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                  { kind: "Field", name: { kind: "Name", value: "dates" } },
                                ],
                              },
                            },
                            {
                              kind: "InlineFragment",
                              typeCondition: { kind: "NamedType", name: { kind: "Name", value: "PackageOfferItem" } },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "flightOfferItem" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        { kind: "Field", name: { kind: "Name", value: "airlineName" } },
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "airlineImage" },
                                          selectionSet: {
                                            kind: "SelectionSet",
                                            selections: [
                                              { kind: "Field", name: { kind: "Name", value: "description" } },
                                              { kind: "Field", name: { kind: "Name", value: "url" } },
                                            ],
                                          },
                                        },
                                        { kind: "Field", name: { kind: "Name", value: "originCity" } },
                                        { kind: "Field", name: { kind: "Name", value: "originAirportCode" } },
                                        { kind: "Field", name: { kind: "Name", value: "destinationCity" } },
                                        { kind: "Field", name: { kind: "Name", value: "destinationAirportCode" } },
                                      ],
                                    },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "hotelOfferItem" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        { kind: "Field", name: { kind: "Name", value: "name" } },
                                        { kind: "Field", name: { kind: "Name", value: "location" } },
                                        { kind: "Field", name: { kind: "Name", value: "vipMessage" } },
                                      ],
                                    },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "packageOffer" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "price" },
                                          selectionSet: {
                                            kind: "SelectionSet",
                                            selections: [
                                              { kind: "Field", name: { kind: "Name", value: "value" } },
                                              { kind: "Field", name: { kind: "Name", value: "qualifierText" } },
                                              { kind: "Field", name: { kind: "Name", value: "prefixText" } },
                                              { kind: "Field", name: { kind: "Name", value: "checkPriceText" } },
                                            ],
                                          },
                                        },
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "actionLink" },
                                          selectionSet: {
                                            kind: "SelectionSet",
                                            selections: [
                                              { kind: "Field", name: { kind: "Name", value: "href" } },
                                              { kind: "Field", name: { kind: "Name", value: "text" } },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                  { kind: "Field", name: { kind: "Name", value: "dates" } },
                                ],
                              },
                            },
                            {
                              kind: "InlineFragment",
                              typeCondition: { kind: "NamedType", name: { kind: "Name", value: "ActivityOfferItem" } },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "badge" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        { kind: "Field", name: { kind: "Name", value: "text" } },
                                        { kind: "Field", name: { kind: "Name", value: "type" } },
                                      ],
                                    },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "image" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        { kind: "Field", name: { kind: "Name", value: "description" } },
                                        { kind: "Field", name: { kind: "Name", value: "url" } },
                                      ],
                                    },
                                  },
                                  { kind: "Field", name: { kind: "Name", value: "title" } },
                                  { kind: "Field", name: { kind: "Name", value: "description" } },
                                  { kind: "Field", name: { kind: "Name", value: "duration" } },
                                  { kind: "Field", name: { kind: "Name", value: "durationLabel" } },
                                  { kind: "Field", name: { kind: "Name", value: "city" } },
                                  { kind: "Field", name: { kind: "Name", value: "province" } },
                                  { kind: "Field", name: { kind: "Name", value: "dates" } },
                                  { kind: "Field", name: { kind: "Name", value: "freeCancellationMessage" } },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "activityOffer" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "price" },
                                          selectionSet: {
                                            kind: "SelectionSet",
                                            selections: [
                                              { kind: "Field", name: { kind: "Name", value: "value" } },
                                              { kind: "Field", name: { kind: "Name", value: "qualifierText" } },
                                              { kind: "Field", name: { kind: "Name", value: "disclaimerText" } },
                                              { kind: "Field", name: { kind: "Name", value: "allyText" } },
                                            ],
                                          },
                                        },
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "strikeThroughPrice" },
                                          selectionSet: {
                                            kind: "SelectionSet",
                                            selections: [
                                              { kind: "Field", name: { kind: "Name", value: "value" } },
                                              { kind: "Field", name: { kind: "Name", value: "qualifierText" } },
                                            ],
                                          },
                                        },
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "actionLink" },
                                          selectionSet: {
                                            kind: "SelectionSet",
                                            selections: [
                                              { kind: "Field", name: { kind: "Name", value: "href" } },
                                              { kind: "Field", name: { kind: "Name", value: "text" } },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                { kind: "Field", name: { kind: "Name", value: "responseId" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "paginationInfo" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "referrer" } },
                      { kind: "Field", name: { kind: "Name", value: "hasNextPage" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown) as DocumentNode<
  CampaignRecommendationsWithOffersQueryQuery,
  CampaignRecommendationsWithOffersQueryQueryVariables
>;
export const CustomerPropertySearchByIdQueryDocument = ({
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "CustomerPropertySearchByIdQuery" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "context" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "ContextInput" } } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "destination" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "DestinationInput" } } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "criteria" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "PropertySearchCriteriaInput" } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "propertySearch" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "context" },
                value: { kind: "Variable", name: { kind: "Name", value: "context" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "destination" },
                value: { kind: "Variable", name: { kind: "Name", value: "destination" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "criteria" },
                value: { kind: "Variable", name: { kind: "Name", value: "criteria" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "properties" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "infositeURL" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "price" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "options" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "displayPrice" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        { kind: "Field", name: { kind: "Name", value: "formatted" } },
                                        { kind: "Field", name: { kind: "Name", value: "amount" } },
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "currencyInfo" },
                                          selectionSet: {
                                            kind: "SelectionSet",
                                            selections: [
                                              { kind: "Field", name: { kind: "Name", value: "symbol" } },
                                              { kind: "Field", name: { kind: "Name", value: "code" } },
                                              { kind: "Field", name: { kind: "Name", value: "name" } },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "image" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [{ kind: "Field", name: { kind: "Name", value: "url" } }],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "searchCriteria" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "dateRange" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "checkInDate" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  { kind: "Field", name: { kind: "Name", value: "isoFormat" } },
                                  { kind: "Field", name: { kind: "Name", value: "day" } },
                                  { kind: "Field", name: { kind: "Name", value: "month" } },
                                  { kind: "Field", name: { kind: "Name", value: "year" } },
                                ],
                              },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "checkOutDate" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  { kind: "Field", name: { kind: "Name", value: "isoFormat" } },
                                  { kind: "Field", name: { kind: "Name", value: "day" } },
                                  { kind: "Field", name: { kind: "Name", value: "month" } },
                                  { kind: "Field", name: { kind: "Name", value: "year" } },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown) as DocumentNode<CustomerPropertySearchByIdQueryQuery, CustomerPropertySearchByIdQueryQueryVariables>;
export const CustomerSearchHistoryAllQueryDocument = ({
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "CustomerSearchHistoryAllQuery" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "context" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "ContextInput" } } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "lobs" } },
          type: {
            kind: "ListType",
            type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "HistoryType" } } },
          },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "numberOfResults" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "Int" } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "customer" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "context" },
                value: { kind: "Variable", name: { kind: "Name", value: "context" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "searchHistory" },
                  arguments: [
                    {
                      kind: "Argument",
                      name: { kind: "Name", value: "types" },
                      value: { kind: "Variable", name: { kind: "Name", value: "lobs" } },
                    },
                    {
                      kind: "Argument",
                      name: { kind: "Name", value: "numberOfResults" },
                      value: { kind: "Variable", name: { kind: "Name", value: "numberOfResults" } },
                    },
                  ],
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "type" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "items" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "id" } },
                            { kind: "Field", name: { kind: "Name", value: "localizedDateRange" } },
                            { kind: "Field", name: { kind: "Name", value: "localizedAsOfDateTime" } },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "lastViewedDate" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  { kind: "Field", name: { kind: "Name", value: "day" } },
                                  { kind: "Field", name: { kind: "Name", value: "hour" } },
                                  { kind: "Field", name: { kind: "Name", value: "minute" } },
                                  { kind: "Field", name: { kind: "Name", value: "second" } },
                                  { kind: "Field", name: { kind: "Name", value: "month" } },
                                  { kind: "Field", name: { kind: "Name", value: "year" } },
                                ],
                              },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "startDate" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  { kind: "Field", name: { kind: "Name", value: "raw" } },
                                  { kind: "Field", name: { kind: "Name", value: "year" } },
                                  { kind: "Field", name: { kind: "Name", value: "month" } },
                                  { kind: "Field", name: { kind: "Name", value: "day" } },
                                ],
                              },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "endDate" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  { kind: "Field", name: { kind: "Name", value: "raw" } },
                                  { kind: "Field", name: { kind: "Name", value: "year" } },
                                  { kind: "Field", name: { kind: "Name", value: "month" } },
                                  { kind: "Field", name: { kind: "Name", value: "day" } },
                                ],
                              },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "originalSearchPrice" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "currencyInfo" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        { kind: "Field", name: { kind: "Name", value: "code" } },
                                        { kind: "Field", name: { kind: "Name", value: "name" } },
                                        { kind: "Field", name: { kind: "Name", value: "symbol" } },
                                      ],
                                    },
                                  },
                                  { kind: "Field", name: { kind: "Name", value: "amount" } },
                                  { kind: "Field", name: { kind: "Name", value: "formatted" } },
                                ],
                              },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "productInfo" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "InlineFragment",
                                    typeCondition: {
                                      kind: "NamedType",
                                      name: { kind: "Name", value: "HistoryActivitySearch" },
                                    },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "regionDetail" },
                                          selectionSet: {
                                            kind: "SelectionSet",
                                            selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }],
                                          },
                                        },
                                        { kind: "Field", name: { kind: "Name", value: "searchUrl" } },
                                      ],
                                    },
                                  },
                                  {
                                    kind: "InlineFragment",
                                    typeCondition: {
                                      kind: "NamedType",
                                      name: { kind: "Name", value: "HistoryActivityDetail" },
                                    },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        { kind: "Field", name: { kind: "Name", value: "name" } },
                                        { kind: "Field", name: { kind: "Name", value: "duration" } },
                                        { kind: "Field", name: { kind: "Name", value: "leadTicketType" } },
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "imageUrl" },
                                          selectionSet: {
                                            kind: "SelectionSet",
                                            selections: [
                                              { kind: "Field", name: { kind: "Name", value: "description" } },
                                              { kind: "Field", name: { kind: "Name", value: "url" } },
                                            ],
                                          },
                                        },
                                        { kind: "Field", name: { kind: "Name", value: "searchUrl" } },
                                      ],
                                    },
                                  },
                                  {
                                    kind: "InlineFragment",
                                    typeCondition: {
                                      kind: "NamedType",
                                      name: { kind: "Name", value: "HistoryFlightSearch" },
                                    },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        { kind: "Field", name: { kind: "Name", value: "localizedFlightName" } },
                                        { kind: "Field", name: { kind: "Name", value: "searchUrl" } },
                                        { kind: "Field", name: { kind: "Name", value: "routeType" } },
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "flightPassengers" },
                                          selectionSet: {
                                            kind: "SelectionSet",
                                            selections: [
                                              { kind: "Field", name: { kind: "Name", value: "adults" } },
                                              { kind: "Field", name: { kind: "Name", value: "agesOfChildren" } },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                  {
                                    kind: "InlineFragment",
                                    typeCondition: {
                                      kind: "NamedType",
                                      name: { kind: "Name", value: "HistoryFlightDetail" },
                                    },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        { kind: "Field", name: { kind: "Name", value: "localizedFlightName" } },
                                        { kind: "Field", name: { kind: "Name", value: "searchUrl" } },
                                        { kind: "Field", name: { kind: "Name", value: "routeType" } },
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "flightPassengers" },
                                          selectionSet: {
                                            kind: "SelectionSet",
                                            selections: [
                                              { kind: "Field", name: { kind: "Name", value: "adults" } },
                                              { kind: "Field", name: { kind: "Name", value: "agesOfChildren" } },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                  {
                                    kind: "InlineFragment",
                                    typeCondition: {
                                      kind: "NamedType",
                                      name: { kind: "Name", value: "HistoryPackageSearch" },
                                    },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        { kind: "Field", name: { kind: "Name", value: "localizedPackageName" } },
                                        { kind: "Field", name: { kind: "Name", value: "localizedRegionName" } },
                                        { kind: "Field", name: { kind: "Name", value: "localizedPackagesTemplate" } },
                                        { kind: "Field", name: { kind: "Name", value: "searchUrl" } },
                                      ],
                                    },
                                  },
                                  {
                                    kind: "InlineFragment",
                                    typeCondition: {
                                      kind: "NamedType",
                                      name: { kind: "Name", value: "HistoryPropertySearch" },
                                    },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "regionDetail" },
                                          selectionSet: {
                                            kind: "SelectionSet",
                                            selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }],
                                          },
                                        },
                                        { kind: "Field", name: { kind: "Name", value: "localizedRoomsTemplate" } },
                                        { kind: "Field", name: { kind: "Name", value: "searchUrl" } },
                                      ],
                                    },
                                  },
                                  {
                                    kind: "InlineFragment",
                                    typeCondition: {
                                      kind: "NamedType",
                                      name: { kind: "Name", value: "HistoryPropertyDetail" },
                                    },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        { kind: "Field", name: { kind: "Name", value: "regionId" } },
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "summary" },
                                          selectionSet: {
                                            kind: "SelectionSet",
                                            selections: [
                                              { kind: "Field", name: { kind: "Name", value: "id" } },
                                              { kind: "Field", name: { kind: "Name", value: "name" } },
                                            ],
                                          },
                                        },
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "regionDetail" },
                                          selectionSet: {
                                            kind: "SelectionSet",
                                            selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }],
                                          },
                                        },
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "reviewInfo" },
                                          selectionSet: {
                                            kind: "SelectionSet",
                                            selections: [
                                              {
                                                kind: "Field",
                                                name: { kind: "Name", value: "summary" },
                                                selectionSet: {
                                                  kind: "SelectionSet",
                                                  selections: [
                                                    {
                                                      kind: "Field",
                                                      name: { kind: "Name", value: "averageOverallRating" },
                                                      selectionSet: {
                                                        kind: "SelectionSet",
                                                        selections: [
                                                          { kind: "Field", name: { kind: "Name", value: "formatted" } },
                                                        ],
                                                      },
                                                    },
                                                    {
                                                      kind: "Field",
                                                      name: { kind: "Name", value: "totalCount" },
                                                      selectionSet: {
                                                        kind: "SelectionSet",
                                                        selections: [
                                                          { kind: "Field", name: { kind: "Name", value: "formatted" } },
                                                        ],
                                                      },
                                                    },
                                                  ],
                                                },
                                              },
                                            ],
                                          },
                                        },
                                        { kind: "Field", name: { kind: "Name", value: "formattedRating" } },
                                        { kind: "Field", name: { kind: "Name", value: "formattedReviewCount" } },
                                        { kind: "Field", name: { kind: "Name", value: "propertyId" } },
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "gallery" },
                                          selectionSet: {
                                            kind: "SelectionSet",
                                            selections: [
                                              {
                                                kind: "Field",
                                                name: { kind: "Name", value: "featured" },
                                                selectionSet: {
                                                  kind: "SelectionSet",
                                                  selections: [
                                                    { kind: "Field", name: { kind: "Name", value: "description" } },
                                                    { kind: "Field", name: { kind: "Name", value: "url" } },
                                                  ],
                                                },
                                              },
                                            ],
                                          },
                                        },
                                        { kind: "Field", name: { kind: "Name", value: "searchUrl" } },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown) as DocumentNode<CustomerSearchHistoryAllQueryQuery, CustomerSearchHistoryAllQueryQueryVariables>;
export const CustomerSearchHistoryQueryDocument = ({
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "CustomerSearchHistoryQuery" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "context" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "ContextInput" } } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "lobs" } },
          type: {
            kind: "ListType",
            type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "HistoryType" } } },
          },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "numberOfResults" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "Int" } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "customer" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "context" },
                value: { kind: "Variable", name: { kind: "Name", value: "context" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "searchHistory" },
                  arguments: [
                    {
                      kind: "Argument",
                      name: { kind: "Name", value: "types" },
                      value: { kind: "Variable", name: { kind: "Name", value: "lobs" } },
                    },
                    {
                      kind: "Argument",
                      name: { kind: "Name", value: "numberOfResults" },
                      value: { kind: "Variable", name: { kind: "Name", value: "numberOfResults" } },
                    },
                  ],
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "type" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "items" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "startDate" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  { kind: "Field", name: { kind: "Name", value: "raw" } },
                                  { kind: "Field", name: { kind: "Name", value: "year" } },
                                  { kind: "Field", name: { kind: "Name", value: "month" } },
                                  { kind: "Field", name: { kind: "Name", value: "day" } },
                                ],
                              },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "endDate" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  { kind: "Field", name: { kind: "Name", value: "raw" } },
                                  { kind: "Field", name: { kind: "Name", value: "year" } },
                                  { kind: "Field", name: { kind: "Name", value: "month" } },
                                  { kind: "Field", name: { kind: "Name", value: "day" } },
                                ],
                              },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "originalSearchPrice" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "currencyInfo" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        { kind: "Field", name: { kind: "Name", value: "code" } },
                                        { kind: "Field", name: { kind: "Name", value: "name" } },
                                        { kind: "Field", name: { kind: "Name", value: "symbol" } },
                                      ],
                                    },
                                  },
                                  { kind: "Field", name: { kind: "Name", value: "amount" } },
                                  { kind: "Field", name: { kind: "Name", value: "formatted" } },
                                ],
                              },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "productInfo" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "InlineFragment",
                                    typeCondition: {
                                      kind: "NamedType",
                                      name: { kind: "Name", value: "HistoryPropertyDetail" },
                                    },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        { kind: "Field", name: { kind: "Name", value: "regionId" } },
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "propertySummary" },
                                          arguments: [
                                            {
                                              kind: "Argument",
                                              name: { kind: "Name", value: "context" },
                                              value: { kind: "Variable", name: { kind: "Name", value: "context" } },
                                            },
                                          ],
                                          selectionSet: {
                                            kind: "SelectionSet",
                                            selections: [
                                              { kind: "Field", name: { kind: "Name", value: "id" } },
                                              { kind: "Field", name: { kind: "Name", value: "name" } },
                                            ],
                                          },
                                        },
                                        { kind: "Field", name: { kind: "Name", value: "propertyId" } },
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "propertyImageGallery" },
                                          arguments: [
                                            {
                                              kind: "Argument",
                                              name: { kind: "Name", value: "context" },
                                              value: { kind: "Variable", name: { kind: "Name", value: "context" } },
                                            },
                                          ],
                                          selectionSet: {
                                            kind: "SelectionSet",
                                            selections: [
                                              {
                                                kind: "Field",
                                                name: { kind: "Name", value: "featured" },
                                                selectionSet: {
                                                  kind: "SelectionSet",
                                                  selections: [
                                                    {
                                                      kind: "Field",
                                                      name: { kind: "Name", value: "image" },
                                                      selectionSet: {
                                                        kind: "SelectionSet",
                                                        selections: [
                                                          { kind: "Field", name: { kind: "Name", value: "url" } },
                                                        ],
                                                      },
                                                    },
                                                  ],
                                                },
                                              },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown) as DocumentNode<CustomerSearchHistoryQueryQuery, CustomerSearchHistoryQueryQueryVariables>;
export const DxPropertySearchQueryDocument = ({
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "DxPropertySearchQuery" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "context" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "ContextInput" } } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "hotelIds" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "ListType",
              type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "propertySearch" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "context" },
                value: { kind: "Variable", name: { kind: "Name", value: "context" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "destination" },
                value: {
                  kind: "ObjectValue",
                  fields: [
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "propertyIds" },
                      value: { kind: "Variable", name: { kind: "Name", value: "hotelIds" } },
                    },
                  ],
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "sort" },
                value: { kind: "EnumValue", value: "REVIEW" },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "properties" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                      { kind: "Field", name: { kind: "Name", value: "infositeURL" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "price" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "lead" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  { kind: "Field", name: { kind: "Name", value: "formatted" } },
                                  { kind: "Field", name: { kind: "Name", value: "amount" } },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "reviews" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "score" } },
                            { kind: "Field", name: { kind: "Name", value: "total" } },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "gallery" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "url" } },
                            { kind: "Field", name: { kind: "Name", value: "description" } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown) as DocumentNode<DxPropertySearchQueryQuery, DxPropertySearchQueryQueryVariables>;
export const MapPropertySearchByIdDocument = ({
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "MapPropertySearchById" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "context" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "ContextInput" } } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "destination" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "DestinationInput" } } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "criteria" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "PropertySearchCriteriaInput" } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "propertySearch" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "context" },
                value: { kind: "Variable", name: { kind: "Name", value: "context" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "destination" },
                value: { kind: "Variable", name: { kind: "Name", value: "destination" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "criteria" },
                value: { kind: "Variable", name: { kind: "Name", value: "criteria" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "sortAndFilter" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "options" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "sortAndFilter" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  { kind: "Field", name: { kind: "Name", value: "name" } },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "options" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        { kind: "Field", name: { kind: "Name", value: "label" } },
                                        { kind: "Field", name: { kind: "Name", value: "value" } },
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "range" },
                                          selectionSet: {
                                            kind: "SelectionSet",
                                            selections: [
                                              { kind: "Field", name: { kind: "Name", value: "min" } },
                                              { kind: "Field", name: { kind: "Name", value: "max" } },
                                            ],
                                          },
                                        },
                                        { kind: "Field", name: { kind: "Name", value: "enumValue" } },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "properties" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "infositeURL" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "price" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "lead" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  { kind: "Field", name: { kind: "Name", value: "formatted" } },
                                  { kind: "Field", name: { kind: "Name", value: "amount" } },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "currencyInfo" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        { kind: "Field", name: { kind: "Name", value: "symbol" } },
                                        { kind: "Field", name: { kind: "Name", value: "code" } },
                                        { kind: "Field", name: { kind: "Name", value: "name" } },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "reviews" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "score" } },
                            { kind: "Field", name: { kind: "Name", value: "total" } },
                            { kind: "Field", name: { kind: "Name", value: "localizedSubtitle" } },
                          ],
                        },
                      },
                      { kind: "Field", name: { kind: "Name", value: "star" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "image" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [{ kind: "Field", name: { kind: "Name", value: "url" } }],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "mapMarker" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "latLong" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  { kind: "Field", name: { kind: "Name", value: "latitude" } },
                                  { kind: "Field", name: { kind: "Name", value: "longitude" } },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown) as DocumentNode<MapPropertySearchByIdQuery, MapPropertySearchByIdQueryVariables>;
export const MapPropertySearchByLatLongDocument = ({
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "MapPropertySearchByLatLong" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "context" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "ContextInput" } } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "destination" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "DestinationInput" } } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "criteria" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "PropertySearchCriteriaInput" } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "propertySearch" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "context" },
                value: { kind: "Variable", name: { kind: "Name", value: "context" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "destination" },
                value: { kind: "Variable", name: { kind: "Name", value: "destination" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "sort" },
                value: { kind: "EnumValue", value: "DISTANCE" },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "criteria" },
                value: { kind: "Variable", name: { kind: "Name", value: "criteria" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "properties" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "infositeURL" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "price" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "lead" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  { kind: "Field", name: { kind: "Name", value: "formatted" } },
                                  { kind: "Field", name: { kind: "Name", value: "amount" } },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "reviews" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "score" } },
                            { kind: "Field", name: { kind: "Name", value: "total" } },
                            { kind: "Field", name: { kind: "Name", value: "localizedSubtitle" } },
                          ],
                        },
                      },
                      { kind: "Field", name: { kind: "Name", value: "star" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "image" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [{ kind: "Field", name: { kind: "Name", value: "url" } }],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "mapMarker" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "latLong" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  { kind: "Field", name: { kind: "Name", value: "latitude" } },
                                  { kind: "Field", name: { kind: "Name", value: "longitude" } },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "summary" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "messages" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "type" } },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "title" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [{ kind: "Field", name: { kind: "Name", value: "text" } }],
                              },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "subtitle" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [{ kind: "Field", name: { kind: "Name", value: "text" } }],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown) as DocumentNode<MapPropertySearchByLatLongQuery, MapPropertySearchByLatLongQueryVariables>;
export const MerchCouponsQueryDocument = ({
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "MerchCouponsQuery" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "context" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "ContextInput" } } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "couponIds" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "ListType",
              type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "merchCoupons" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "context" },
                value: { kind: "Variable", name: { kind: "Name", value: "context" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "couponIds" },
                value: { kind: "Variable", name: { kind: "Name", value: "couponIds" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "coupons" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "CouponDetailFragment" } }],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    ...CouponDetailFragmentFragmentDoc.definitions,
  ],
} as unknown) as DocumentNode<MerchCouponsQueryQuery, MerchCouponsQueryQueryVariables>;
export const PropertyFilterSearchQueryDocument = ({
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "PropertyFilterSearchQuery" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "context" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "ContextInput" } } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "destination" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "DestinationInput" } } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "criteria" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "PropertySearchCriteriaInput" } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "propertySearch" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "context" },
                value: { kind: "Variable", name: { kind: "Name", value: "context" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "destination" },
                value: { kind: "Variable", name: { kind: "Name", value: "destination" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "criteria" },
                value: { kind: "Variable", name: { kind: "Name", value: "criteria" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "sortAndFilter" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "selected" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "priceFilterPills" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "aggregate" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [{ kind: "Field", name: { kind: "Name", value: "label" } }],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "propertySearchListings" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "InlineFragment",
                        typeCondition: { kind: "NamedType", name: { kind: "Name", value: "MessageResult" } },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "title" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "icon" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        { kind: "Field", name: { kind: "Name", value: "description" } },
                                        { kind: "Field", name: { kind: "Name", value: "id" } },
                                      ],
                                    },
                                  },
                                  { kind: "Field", name: { kind: "Name", value: "text" } },
                                ],
                              },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "subtitle" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [{ kind: "Field", name: { kind: "Name", value: "text" } }],
                              },
                            },
                            { kind: "Field", name: { kind: "Name", value: "index" } },
                            { kind: "Field", name: { kind: "Name", value: "type" } },
                            { kind: "Field", name: { kind: "Name", value: "__typename" } },
                          ],
                        },
                      },
                      {
                        kind: "InlineFragment",
                        typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Property" } },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "__typename" } },
                            { kind: "Field", name: { kind: "Name", value: "id" } },
                            { kind: "Field", name: { kind: "Name", value: "name" } },
                            { kind: "Field", name: { kind: "Name", value: "addressMessaging" } },
                            { kind: "Field", name: { kind: "Name", value: "star" } },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "offerSummary" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "messages" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [{ kind: "Field", name: { kind: "Name", value: "type" } }],
                                    },
                                  },
                                ],
                              },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "propertyImage" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "image" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [{ kind: "Field", name: { kind: "Name", value: "url" } }],
                                    },
                                  },
                                ],
                              },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "destinationInfo" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  { kind: "Field", name: { kind: "Name", value: "distanceFromMessaging" } },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "distanceFromDestination" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        { kind: "Field", name: { kind: "Name", value: "unit" } },
                                        { kind: "Field", name: { kind: "Name", value: "value" } },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "mapMarker" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "latLong" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        { kind: "Field", name: { kind: "Name", value: "latitude" } },
                                        { kind: "Field", name: { kind: "Name", value: "longitude" } },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "reviews" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  { kind: "Field", name: { kind: "Name", value: "score" } },
                                  { kind: "Field", name: { kind: "Name", value: "total" } },
                                ],
                              },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "price" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "priceMessages" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [{ kind: "Field", name: { kind: "Name", value: "value" } }],
                                    },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "options" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "displayPrice" },
                                          selectionSet: {
                                            kind: "SelectionSet",
                                            selections: [
                                              { kind: "Field", name: { kind: "Name", value: "amount" } },
                                              { kind: "Field", name: { kind: "Name", value: "formatted" } },
                                              {
                                                kind: "Field",
                                                name: { kind: "Name", value: "currencyInfo" },
                                                selectionSet: {
                                                  kind: "SelectionSet",
                                                  selections: [
                                                    { kind: "Field", name: { kind: "Name", value: "code" } },
                                                  ],
                                                },
                                              },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "propertyDetailsLink" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "uri" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        { kind: "Field", name: { kind: "Name", value: "relativePath" } },
                                        { kind: "Field", name: { kind: "Name", value: "value" } },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                            { kind: "Field", name: { kind: "Name", value: "structureType" } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown) as DocumentNode<PropertyFilterSearchQueryQuery, PropertyFilterSearchQueryQueryVariables>;
export const PropertyFiltersQueryDocument = ({
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "PropertyFiltersQuery" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "context" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "ContextInput" } } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "destination" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "DestinationInput" } } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "criteria" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "PropertySearchCriteriaInput" } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "propertySearch" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "context" },
                value: { kind: "Variable", name: { kind: "Name", value: "context" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "destination" },
                value: { kind: "Variable", name: { kind: "Name", value: "destination" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "criteria" },
                value: { kind: "Variable", name: { kind: "Name", value: "criteria" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "sortAndFilter" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "options" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "sortAndFilter" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  { kind: "Field", name: { kind: "Name", value: "label" } },
                                  { kind: "Field", name: { kind: "Name", value: "name" } },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "options" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        { kind: "Field", name: { kind: "Name", value: "label" } },
                                        { kind: "Field", name: { kind: "Name", value: "optionValue" } },
                                        { kind: "Field", name: { kind: "Name", value: "filterCategory" } },
                                        { kind: "Field", name: { kind: "Name", value: "description" } },
                                        { kind: "Field", name: { kind: "Name", value: "selectedLabel" } },
                                        { kind: "Field", name: { kind: "Name", value: "isSelected" } },
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "range" },
                                          selectionSet: {
                                            kind: "SelectionSet",
                                            selections: [
                                              { kind: "Field", name: { kind: "Name", value: "max" } },
                                              { kind: "Field", name: { kind: "Name", value: "min" } },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown) as DocumentNode<PropertyFiltersQueryQuery, PropertyFiltersQueryQueryVariables>;
export const QueryPropertyHeroImageDocument = ({
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "QueryPropertyHeroImage" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "context" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "ContextInput" } } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "propertyId" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "propertyInfo" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "context" },
                value: { kind: "Variable", name: { kind: "Name", value: "context" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "propertyId" },
                value: { kind: "Variable", name: { kind: "Name", value: "propertyId" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "gallery" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "featured" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "description" } },
                            { kind: "Field", name: { kind: "Name", value: "url" } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown) as DocumentNode<QueryPropertyHeroImageQuery, QueryPropertyHeroImageQueryVariables>;
export const QueryPropertyReviewsHeadlineDocument = ({
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "QueryPropertyReviewsHeadline" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "context" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "ContextInput" } } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "propertyId" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "propertyInfo" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "context" },
                value: { kind: "Variable", name: { kind: "Name", value: "context" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "propertyId" },
                value: { kind: "Variable", name: { kind: "Name", value: "propertyId" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "infositeUrl" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "summary" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "overview" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [{ kind: "Field", name: { kind: "Name", value: "starRating" } }],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "location" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "address" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  { kind: "Field", name: { kind: "Name", value: "city" } },
                                  { kind: "Field", name: { kind: "Name", value: "countryCode" } },
                                  { kind: "Field", name: { kind: "Name", value: "firstAddressLine" } },
                                  { kind: "Field", name: { kind: "Name", value: "secondAddressLine" } },
                                  { kind: "Field", name: { kind: "Name", value: "postalCode" } },
                                  { kind: "Field", name: { kind: "Name", value: "province" } },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown) as DocumentNode<QueryPropertyReviewsHeadlineQuery, QueryPropertyReviewsHeadlineQueryVariables>;
export const PropertySearchQueryDocument = ({
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "PropertySearchQuery" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "context" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "ContextInput" } } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "hotelIds" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "ListType",
              type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "propertySearch" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "context" },
                value: { kind: "Variable", name: { kind: "Name", value: "context" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "destination" },
                value: {
                  kind: "ObjectValue",
                  fields: [
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "propertyIds" },
                      value: { kind: "Variable", name: { kind: "Name", value: "hotelIds" } },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "properties" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "gallery" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "url" } },
                            { kind: "Field", name: { kind: "Name", value: "description" } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown) as DocumentNode<PropertySearchQueryQuery, PropertySearchQueryQueryVariables>;
export const TravelAgentSearchWizardConfigQueryDocument = ({
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "TravelAgentSearchWizardConfigQuery" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "context" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "ContextInput" } } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "travelAgentSearchWizardConfig" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "context" },
                value: { kind: "Variable", name: { kind: "Name", value: "context" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "packageRatesEnabled" } },
                { kind: "Field", name: { kind: "Name", value: "enabledLobs" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "packageRatesDetail" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "heading" } },
                      { kind: "Field", name: { kind: "Name", value: "termsAndConditions" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown) as DocumentNode<
  TravelAgentSearchWizardConfigQueryQuery,
  TravelAgentSearchWizardConfigQueryQueryVariables
>;
